
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5bbd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5bbd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fLfPA", function(module, exports) {

$parcel$export(module.exports, "render", () => $b797868843cfbef7$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $b797868843cfbef7$var$_hoisted_1 = {
    id: "app"
};
function $b797868843cfbef7$export$b3890eb0ae9dca99(_ctx, _cache) {
    const _component_router_view = (0, $TusQn.resolveComponent)("router-view");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b797868843cfbef7$var$_hoisted_1, [
        (0, $TusQn.createVNode)(_component_router_view)
    ]);
}

});
parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "setBlockTracking", () => (parcelRequire("TusQn")).setBlockTracking);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "Text", () => (parcelRequire("TusQn")).Text);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "render", () => (parcelRequire("eeJ70")).render);
$parcel$export(module.exports, "Transition", () => (parcelRequire("eeJ70")).Transition);
$parcel$export(module.exports, "vModelCheckbox", () => (parcelRequire("eeJ70")).vModelCheckbox);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("eeJ70")).vModelSelect);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "vShow", () => (parcelRequire("eeJ70")).vShow);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("eeJ70")).withKeys);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
/**
* vue v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");parcelRequire("eeJ70");parcelRequire("01W3b");parcelRequire("8POXm");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $0a6cc4ba868319ae$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "setBlockTracking", () => $0a6cc4ba868319ae$export$c20bee82f26f1e27);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "watchPostEffect", () => $0a6cc4ba868319ae$export$b7f27ea67102d543);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $0a6cc4ba868319ae$export$23b7aeb0d671f804);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "mergeProps", () => $0a6cc4ba868319ae$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
/**
* @vue/runtime-core v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core ."
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8POXm.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $0a6cc4ba868319ae$var$isFlushing = false;
let $0a6cc4ba868319ae$var$isFlushPending = false;
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = 0;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!$0a6cc4ba868319ae$var$queue.length || !$0a6cc4ba868319ae$var$queue.includes(job, $0a6cc4ba868319ae$var$isFlushing && job.allowRecurse ? $0a6cc4ba868319ae$var$flushIndex + 1 : $0a6cc4ba868319ae$var$flushIndex)) {
        if (job.id == null) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(job.id), 0, job);
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$isFlushing && !$0a6cc4ba868319ae$var$isFlushPending) {
        $0a6cc4ba868319ae$var$isFlushPending = true;
        $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
    }
}
function $0a6cc4ba868319ae$var$invalidateJob(job) {
    const i = $0a6cc4ba868319ae$var$queue.indexOf(job);
    if (i > $0a6cc4ba868319ae$var$flushIndex) $0a6cc4ba868319ae$var$queue.splice(i, 1);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if (!$0a6cc4ba868319ae$var$activePostFlushCbs || !$0a6cc4ba868319ae$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $0a6cc4ba868319ae$var$postFlushIndex + 1 : $0a6cc4ba868319ae$var$postFlushIndex)) $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$isFlushing ? $0a6cc4ba868319ae$var$flushIndex + 1 : 0) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++)$0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex]();
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $0a6cc4ba868319ae$var$comparator = (a, b)=>{
    const diff = $0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    $0a6cc4ba868319ae$var$isFlushPending = false;
    $0a6cc4ba868319ae$var$isFlushing = true;
    $0a6cc4ba868319ae$var$queue.sort($0a6cc4ba868319ae$var$comparator);
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && job.active !== false) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $0a6cc4ba868319ae$var$flushIndex = 0;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$isFlushing = false;
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        if (!$0a6cc4ba868319ae$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            instance.parent.effect.dirty = true;
            $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
        } else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        for (const instance of instances)$0a6cc4ba868319ae$var$hmrDirtyComponents.delete($0a6cc4ba868319ae$var$normalizeClassComponent(instance.type));
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $8POXm.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    create: $0a6cc4ba868319ae$var$createSuspenseBoundary,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE = {};
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, once: once, onTrack: onTrack, onTrigger: onTrigger } = (0, $8POXm.EMPTY_OBJ)) {
    if (cb && once) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            unwatch();
        };
    }
    const warnInvalidSource = (s)=>{
        $0a6cc4ba868319ae$var$warn$1(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    const reactiveGetter = (source2)=>deep === true ? source2 : // for deep: false, only traverse root-level properties
        $0a6cc4ba868319ae$var$traverse(source2, deep === false ? 1 : void 0);
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $01W3b.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $01W3b.isShallow)(source);
    } else if ((0, $01W3b.isReactive)(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $01W3b.isReactive)(s) || (0, $01W3b.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $01W3b.isRef)(s)) return s.value;
                else if ((0, $01W3b.isReactive)(s)) return reactiveGetter(s);
                else if ((0, $8POXm.isFunction)(s)) return $0a6cc4ba868319ae$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = ()=>$0a6cc4ba868319ae$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (cleanup) cleanup();
            return $0a6cc4ba868319ae$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$0a6cc4ba868319ae$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        onCleanup = (0, $8POXm.NOOP);
        if (!cb) getter();
        else if (immediate) $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $8POXm.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE) : $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active || !effect.dirty) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $8POXm.hasChanged)(v1, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
    }
    const effect = new (0, $01W3b.ReactiveEffect)(getter, (0, $8POXm.NOOP), scheduler);
    const scope = (0, $01W3b.getCurrentScope)();
    const unwatch = ()=>{
        effect.stop();
        if (scope) (0, $8POXm.remove)(scope.effects, effect);
    };
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $0a6cc4ba868319ae$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$var$traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8POXm.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ((0, $01W3b.isRef)(value)) $0a6cc4ba868319ae$var$traverse(value.value, depth, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$0a6cc4ba868319ae$var$traverse(value[i], depth, seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v1)=>{
        $0a6cc4ba868319ae$var$traverse(v1, depth, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) for(const key in value)$0a6cc4ba868319ae$var$traverse(value[key], depth, seen);
    return value;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getExposeProxy($0a6cc4ba868319ae$var$currentRenderingInstance) || $0a6cc4ba868319ae$var$currentRenderingInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $0a6cc4ba868319ae$var$traverse(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
const $0a6cc4ba868319ae$var$leaveCbKey = Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getKeepAliveChild(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $0a6cc4ba868319ae$var$getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild)) {
                const leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getKeepAliveChild(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) return vnode;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8POXm.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
                }
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") && $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $8POXm.isArray)(source) || (0, $8POXm.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.isCE || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getExposeProxy(i) || i.proxy;
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            i.effect.dirty = true;
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext().slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext().attrs;
}
function $0a6cc4ba868319ae$var$getContext() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if (!$0a6cc4ba868319ae$var$currentInstance) ;
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $0a6cc4ba868319ae$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : (0, $8POXm.extend)({}, opt);
            if (prop) {
                const booleanIndex = $0a6cc4ba868319ae$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $0a6cc4ba868319ae$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8POXm.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$isSameType(a, b) {
    return $0a6cc4ba868319ae$var$getType(a) === $0a6cc4ba868319ae$var$getType(b);
}
function $0a6cc4ba868319ae$var$getTypeIndex(type, expectedTypes) {
    if ((0, $8POXm.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$0a6cc4ba868319ae$var$isSameType(t, type));
    else if ((0, $8POXm.isFunction)(expectedTypes)) return $0a6cc4ba868319ae$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !(0, $8POXm.hasOwn)(rawProps, key) && !(0, $8POXm.hasOwn)(rawProps, (0, $8POXm.hyphenate)(key)));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            (0, $8POXm.extend)(slots, children);
            (0, $8POXm.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $8POXm.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $8POXm.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $8POXm.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $0a6cc4ba868319ae$var$hasMismatch = false;
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $0a6cc4ba868319ae$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($0a6cc4ba868319ae$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            if (!("__vnode" in node)) Object.defineProperty(node, "__vnode", {
                value: vnode,
                enumerable: false
            });
            if (!("__vueParentComponent" in node)) Object.defineProperty(node, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $0a6cc4ba868319ae$var$hasMismatch = true;
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) for(const key in props){
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$hasMismatch = true;
                    if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                    key[0] === ".") patchProp(el, key, null, props[key], void 0, void 0, parentComponent);
                }
                else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $0a6cc4ba868319ae$var$hasMismatch = true;
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                    $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                    hasWarned = true;
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $0a6cc4ba868319ae$var$hasMismatch = true;
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 /* TEXT */  ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var _a;
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $8POXm.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) mismatchType = mismatchKey = `class`;
    } else if (key === "style") {
        actual = el.getAttribute("style");
        expected = (0, $8POXm.isString)(clientValue) ? clientValue : (0, $8POXm.stringifyStyle)((0, $8POXm.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        const root = instance == null ? void 0 : instance.subTree;
        if (vnode === root || (root == null ? void 0 : root.type) === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode)) {
            const cssVars = (_a = instance == null ? void 0 : instance.getCssVars) == null ? void 0 : _a.call(instance);
            for(const key2 in cssVars)expectedMap.set(`--${key2}`, String(cssVars[key2]));
        }
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) mismatchType = mismatchKey = "style";
    } else if (el instanceof SVGElement && (0, $8POXm.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8POXm.isBooleanAttr)(key) || (0, $8POXm.isKnownHtmlAttr)(key))) {
        if ((0, $8POXm.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8POXm.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8POXm.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = `attribute`;
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${mismatchType} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key == null ? void 0 : key.trim();
        value = value == null ? void 0 : value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $0a6cc4ba868319ae$var$invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn, (0, $8POXm.NOOP), ()=>$0a6cc4ba868319ae$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>{
            if (effect.dirty) effect.run();
        };
        update.id = instance.uid;
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs();
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) cloned.transition = transition.clone(cloned);
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8POXm.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $01W3b.resetTracking)();
        reset();
        if ((0, $8POXm.isPromise)(setupResult)) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8POXm.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8POXm.camelize)(name);
    const hyphenatedName = (0, $8POXm.hyphenate)(name);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[name];
            if ((0, $8POXm.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps)) && (0, $8POXm.hasChanged)(value, localValue)) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, options.set ? options.set(value) : value);
            }
        };
    });
    const modifierKey = name === "modelValue" ? "modelModifiers" : `${name}Modifiers`;
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? props[modifierKey] || {} : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.4.26";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8POXm.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $005d1fb7704e278c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
/**
* @vue/reactivity v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $005d1fb7704e278c$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $005d1fb7704e278c$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$var$recordEffectScope(effect, scope = $005d1fb7704e278c$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeEffect;
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn, trigger, scheduler, scope){
        this.fn = fn;
        this.trigger = trigger;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        /**
     * @internal
     */ this._dirtyLevel = 4;
        /**
     * @internal
     */ this._trackId = 0;
        /**
     * @internal
     */ this._runnings = 0;
        /**
     * @internal
     */ this._shouldSchedule = false;
        /**
     * @internal
     */ this._depsLength = 0;
        $005d1fb7704e278c$var$recordEffectScope(this, scope);
    }
    get dirty() {
        if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
            this._dirtyLevel = 1;
            $005d1fb7704e278c$export$938a971395fef855();
            for(let i = 0; i < this._depsLength; i++){
                const dep = this.deps[i];
                if (dep.computed) {
                    $005d1fb7704e278c$var$triggerComputed(dep.computed);
                    if (this._dirtyLevel >= 4) break;
                }
            }
            if (this._dirtyLevel === 1) this._dirtyLevel = 0;
            $005d1fb7704e278c$export$c39176b1babaa8b8();
        }
        return this._dirtyLevel >= 4;
    }
    set dirty(v) {
        this._dirtyLevel = v ? 4 : 0;
    }
    run() {
        this._dirtyLevel = 0;
        if (!this.active) return this.fn();
        let lastShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        let lastEffect = $005d1fb7704e278c$var$activeEffect;
        try {
            $005d1fb7704e278c$var$shouldTrack = true;
            $005d1fb7704e278c$var$activeEffect = this;
            this._runnings++;
            $005d1fb7704e278c$var$preCleanupEffect(this);
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$postCleanupEffect(this);
            this._runnings--;
            $005d1fb7704e278c$var$activeEffect = lastEffect;
            $005d1fb7704e278c$var$shouldTrack = lastShouldTrack;
        }
    }
    stop() {
        if (this.active) {
            $005d1fb7704e278c$var$preCleanupEffect(this);
            $005d1fb7704e278c$var$postCleanupEffect(this);
            this.onStop && this.onStop();
            this.active = false;
        }
    }
}
function $005d1fb7704e278c$var$triggerComputed(computed) {
    return computed.value;
}
function $005d1fb7704e278c$var$preCleanupEffect(effect2) {
    effect2._trackId++;
    effect2._depsLength = 0;
}
function $005d1fb7704e278c$var$postCleanupEffect(effect2) {
    if (effect2.deps.length > effect2._depsLength) {
        for(let i = effect2._depsLength; i < effect2.deps.length; i++)$005d1fb7704e278c$var$cleanupDepEffect(effect2.deps[i], effect2);
        effect2.deps.length = effect2._depsLength;
    }
}
function $005d1fb7704e278c$var$cleanupDepEffect(dep, effect2) {
    const trackId = dep.get(effect2);
    if (trackId !== void 0 && effect2._trackId !== trackId) {
        dep.delete(effect2);
        if (dep.size === 0) dep.cleanup();
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const _effect = new $005d1fb7704e278c$export$28352bb4dd362521(fn, (0, $8POXm.NOOP), ()=>{
        if (_effect.dirty) _effect.run();
    });
    if (options) {
        (0, $8POXm.extend)(_effect, options);
        if (options.scope) $005d1fb7704e278c$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
let $005d1fb7704e278c$var$pauseScheduleStack = 0;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$262a949f95482a17() {
    $005d1fb7704e278c$var$pauseScheduleStack++;
}
function $005d1fb7704e278c$export$3539fa10306ef581() {
    $005d1fb7704e278c$var$pauseScheduleStack--;
    while(!$005d1fb7704e278c$var$pauseScheduleStack && $005d1fb7704e278c$var$queueEffectSchedulers.length)$005d1fb7704e278c$var$queueEffectSchedulers.shift()();
}
function $005d1fb7704e278c$var$trackEffect(effect2, dep, debuggerEventExtraInfo) {
    var _a;
    if (dep.get(effect2) !== effect2._trackId) {
        dep.set(effect2, effect2._trackId);
        const oldDep = effect2.deps[effect2._depsLength];
        if (oldDep !== dep) {
            if (oldDep) $005d1fb7704e278c$var$cleanupDepEffect(oldDep, effect2);
            effect2.deps[effect2._depsLength++] = dep;
        } else effect2._depsLength++;
    }
}
const $005d1fb7704e278c$var$queueEffectSchedulers = [];
function $005d1fb7704e278c$var$triggerEffects(dep, dirtyLevel, debuggerEventExtraInfo) {
    var _a;
    $005d1fb7704e278c$export$262a949f95482a17();
    for (const effect2 of dep.keys()){
        let tracking;
        if (effect2._dirtyLevel < dirtyLevel && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2._shouldSchedule || (effect2._shouldSchedule = effect2._dirtyLevel === 0);
            effect2._dirtyLevel = dirtyLevel;
        }
        if (effect2._shouldSchedule && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2.trigger();
            if ((!effect2._runnings || effect2.allowRecurse) && effect2._dirtyLevel !== 2) {
                effect2._shouldSchedule = false;
                if (effect2.scheduler) $005d1fb7704e278c$var$queueEffectSchedulers.push(effect2.scheduler);
            }
        }
    }
    $005d1fb7704e278c$export$3539fa10306ef581();
}
const $005d1fb7704e278c$var$createDep = (cleanup, computed)=>{
    const dep = /* @__PURE__ */ new Map();
    dep.cleanup = cleanup;
    dep.computed = computed;
    return dep;
};
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol("");
const $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY = Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $005d1fb7704e278c$var$createDep(()=>depsMap.delete(key)));
        $005d1fb7704e278c$var$trackEffect($005d1fb7704e278c$var$activeEffect, dep, void 0);
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $8POXm.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $8POXm.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                break;
        }
    }
    $005d1fb7704e278c$export$262a949f95482a17();
    for (const dep of deps)if (dep) $005d1fb7704e278c$var$triggerEffects(dep, 4, void 0);
    $005d1fb7704e278c$export$3539fa10306ef581();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depsMap && depsMap.get(key);
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
const $005d1fb7704e278c$var$arrayInstrumentations = /* @__PURE__ */ $005d1fb7704e278c$var$createArrayInstrumentations();
function $005d1fb7704e278c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$005d1fb7704e278c$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($005d1fb7704e278c$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $005d1fb7704e278c$export$938a971395fef855();
            $005d1fb7704e278c$export$262a949f95482a17();
            const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $005d1fb7704e278c$export$3539fa10306ef581();
            $005d1fb7704e278c$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $8POXm.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the reciever is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $8POXm.hasOwn)($005d1fb7704e278c$var$arrayInstrumentations, key)) return Reflect.get($005d1fb7704e278c$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $8POXm.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key) ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $005d1fb7704e278c$var$getProto(rawTarget);
    const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $005d1fb7704e278c$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $005d1fb7704e278c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $005d1fb7704e278c$var$add(value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const proto = $005d1fb7704e278c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $005d1fb7704e278c$var$set(key, value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $005d1fb7704e278c$var$deleteEntry(key) {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $005d1fb7704e278c$var$clear() {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $005d1fb7704e278c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, false, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$005d1fb7704e278c$var$mutableInstrumentations, $005d1fb7704e278c$var$readonlyInstrumentations, $005d1fb7704e278c$var$shallowInstrumentations, $005d1fb7704e278c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentations();
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $005d1fb7704e278c$var$shallowReadonlyInstrumentations : $005d1fb7704e278c$var$shallowInstrumentations : isReadonly ? $005d1fb7704e278c$var$readonlyInstrumentations : $005d1fb7704e278c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (Object.isExtensible(value)) (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$var$toReactive = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$var$toReadonly = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
const $005d1fb7704e278c$var$COMPUTED_SIDE_EFFECT_WARN = `Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free`;
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this.getter = getter;
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this.effect = new $005d1fb7704e278c$export$28352bb4dd362521(()=>getter(this._value), ()=>$005d1fb7704e278c$var$triggerRefValue(this, this.effect._dirtyLevel === 2 ? 2 : 3));
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
        if ((!self._cacheable || self.effect.dirty) && (0, $8POXm.hasChanged)(self._value, self._value = self.effect.run())) $005d1fb7704e278c$var$triggerRefValue(self, 4);
        $005d1fb7704e278c$var$trackRefValue(self);
        if (self.effect._dirtyLevel >= 2) $005d1fb7704e278c$var$triggerRefValue(self, 2);
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(v) {
        this.effect.dirty = v;
    }
}
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $8POXm.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $8POXm.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
function $005d1fb7704e278c$var$trackRefValue(ref2) {
    var _a;
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
        $005d1fb7704e278c$var$trackEffect($005d1fb7704e278c$var$activeEffect, (_a = ref2.dep) != null ? _a : ref2.dep = $005d1fb7704e278c$var$createDep(()=>ref2.dep = void 0, ref2 instanceof $005d1fb7704e278c$var$ComputedRefImpl ? ref2 : void 0), void 0);
    }
}
function $005d1fb7704e278c$var$triggerRefValue(ref2, dirtyLevel = 4, newVal) {
    ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $005d1fb7704e278c$var$triggerEffects(dep, dirtyLevel, void 0);
}
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $005d1fb7704e278c$var$toReactive(value);
    }
    get value() {
        $005d1fb7704e278c$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $005d1fb7704e278c$export$7f3fe6025abfa26e(newVal) || $005d1fb7704e278c$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $005d1fb7704e278c$export$ab18938b9fc5f28e(newVal);
        if ((0, $8POXm.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $005d1fb7704e278c$var$toReactive(newVal);
            $005d1fb7704e278c$var$triggerRefValue(this, 4, newVal);
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    $005d1fb7704e278c$var$triggerRefValue(ref2, 4, void 0);
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$005d1fb7704e278c$var$trackRefValue(this), ()=>$005d1fb7704e278c$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive($005d1fb7704e278c$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
const $005d1fb7704e278c$export$483264c4ec4c46ce = $005d1fb7704e278c$export$2983e091f1a1e8e2;
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw"
};

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $66ea9d0aaa418c4d$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $66ea9d0aaa418c4d$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $66ea9d0aaa418c4d$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $66ea9d0aaa418c4d$export$921dd2acf0d386a3);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
/**
* @vue/shared v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-(\w)/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setBlockTracking", () => (parcelRequire("TusQn")).setBlockTracking);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "Text", () => (parcelRequire("TusQn")).Text);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "watchPostEffect", () => (parcelRequire("TusQn")).watchPostEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "render", () => $a5d55dc64ccb07cf$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $a5d55dc64ccb07cf$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelSelect", () => $a5d55dc64ccb07cf$export$87d227567b51ca39);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
/**
* @vue/runtime-dom v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");parcelRequire("01W3b");parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : $a5d55dc64ccb07cf$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content;
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = Symbol("_vtc");
const $a5d55dc64ccb07cf$export$be58926105124dd4 = (props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots);
$a5d55dc64ccb07cf$export$be58926105124dd4.displayName = "Transition";
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = $a5d55dc64ccb07cf$export$be58926105124dd4.props = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            $a5d55dc64ccb07cf$var$forceReflow();
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watchPostEffect)(setVars);
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $8POXm.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $8POXm.isFunction)(value) || (0, $8POXm.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $8POXm.NOOP;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8POXm.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, namespace, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $TusQn.defineComponent)(options);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
        }
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.hasAttribute(key) ? this.getAttribute(key) : void 0;
        const camelKey = (0, $8POXm.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
            }
        }
    }
    _update() {
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
};
const $a5d55dc64ccb07cf$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $a5d55dc64ccb07cf$var$removeMode($a5d55dc64ccb07cf$var$TransitionGroupImpl.props);
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = Symbol("_assign");
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $8POXm.looseToNumber)(domValue);
            el[$a5d55dc64ccb07cf$var$assignKey](domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $8POXm.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $8POXm.isArray)(value)) el.checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8POXm.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value, modifiers: { number: number } }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value, modifiers: { number: number } }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value, number) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $8POXm.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});



parcelRegister("fP2DP", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f8fea0d4d656ec$export$2e2bcd8739ae039);
let $02f8fea0d4d656ec$var$NOOP = ()=>{};
var $02f8fea0d4d656ec$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("4q2En", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $337ba569cc6704c0$export$2e2bcd8739ae039);

var $72Xwp = parcelRequire("72Xwp");

var $gOjKo = parcelRequire("gOjKo");
var $337ba569cc6704c0$export$2e2bcd8739ae039 = {
    name: "Login",
    mounted () {
        this.getLogin();
    },
    data () {
        return {
            input: {
                userName: "",
                password: ""
            }
        };
    },
    computed: {
        redirectTarget () {
            const query = this.$route.query.returnUrl;
            if (query && query.length > 0) return query;
            return "/modelings";
        }
    },
    methods: {
        async getLogin () {
            try {
                (0, $gOjKo.ResetAuthCache)();
                let login = await (0, $72Xwp.default).auth();
                if (login.isAuthenticated) this.$router.replace(this.redirectTarget);
            } catch (error) {
            // TODO
            }
        },
        async login () {
            let { userName: userName, password: password } = this.input;
            let login = await (0, $72Xwp.default).login(userName, password);
            (0, $gOjKo.ResetAuthCache)();
            if (login.succeeded) this.$router.replace(this.redirectTarget);
            else {
                let doc = document.getElementById("alert");
                doc.classList.remove("hidden");
            }
        }
    }
};

});
parcelRegister("72Xwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5216e41ad21d8bf7$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $5216e41ad21d8bf7$var$AuthorizationApi = {
    auth: async ()=>{
        const req = (0, $f5Koy.default).get(`/api/auth/signin`);
        const res = await req;
        return res.body;
    },
    login: async (userName, password)=>{
        const req = (0, $f5Koy.default).post(`/api/auth/signin`).send({
            userName: userName,
            password: password
        });
        const res = await req;
        return res.body;
    },
    logout: async ()=>{
        const req = (0, $f5Koy.default).get(`/api/auth/signout`);
        const res = await req;
        return res.body;
    }
};
var $5216e41ad21d8bf7$export$2e2bcd8739ae039 = $5216e41ad21d8bf7$var$AuthorizationApi;

});
parcelRegister("f5Koy", function(module, exports) {

$parcel$export(module.exports, "default", () => $afcb4fbbdd5d721a$export$2e2bcd8739ae039);

var $6gZo1 = parcelRequire("6gZo1");
let $afcb4fbbdd5d721a$var$serverBase = "";
const $afcb4fbbdd5d721a$var$request = {
    get: (url)=>{
        return $6gZo1.get($afcb4fbbdd5d721a$var$serverBase + url).withCredentials().set("Accept", "application/json").set("Content-Type", "application/json");
    },
    post: (url)=>{
        return $6gZo1.post($afcb4fbbdd5d721a$var$serverBase + url).withCredentials().set("Accept", "application/json").set("Content-Type", "application/json");
    },
    postMultipart: (url)=>{
        return $6gZo1.post($afcb4fbbdd5d721a$var$serverBase + url).withCredentials().set("Accept", "application/json");
    },
    put: (url)=>{
        return $6gZo1.put($afcb4fbbdd5d721a$var$serverBase + url).withCredentials().set("Accept", "application/json").set("Content-Type", "application/json");
    },
    patch: (url)=>{
        return $6gZo1.patch($afcb4fbbdd5d721a$var$serverBase + url).withCredentials().set("Accept", "application/json").set("Content-Type", "application/json");
    },
    delete: (url)=>{
        return $6gZo1.delete($afcb4fbbdd5d721a$var$serverBase + url).withCredentials().set("Accept", "application/json").set("Content-Type", "application/json");
    }
};
var $afcb4fbbdd5d721a$export$2e2bcd8739ae039 = $afcb4fbbdd5d721a$var$request;

});
parcelRegister("6gZo1", function(module, exports) {
"use strict";
/**
 * Root reference for iframes.
 */ let root;
if (typeof window !== "undefined") // Browser window
root = window;
else if (typeof self === "undefined") {
    // Other environments
    console.warn("Using browser-only version of superagent in non-browser environment");
    root = void 0;
} else // Web Worker
root = self;

var $9yRAu = parcelRequire("9yRAu");

var $hgGe6 = parcelRequire("hgGe6");

var $2rasJ = parcelRequire("2rasJ");

var $hli7k = parcelRequire("hli7k");

var $ess0W = parcelRequire("ess0W");
var $4913dac236115adc$require$isObject = $ess0W.isObject;
var $4913dac236115adc$require$mixin = $ess0W.mixin;
var $4913dac236115adc$require$hasOwn = $ess0W.hasOwn;

var $8GXcX = parcelRequire("8GXcX");

var $7fj1N = parcelRequire("7fj1N");
/**
 * Noop.
 */ function noop() {}
/**
 * Expose `request`.
 */ module.exports = function(method, url) {
    // callback
    if (typeof url === "function") return new exports.Request("GET", method).end(url);
    // url first
    if (arguments.length === 1) return new exports.Request("GET", method);
    return new exports.Request(method, url);
};
exports = module.exports;
const request = exports;
exports.Request = Request;
/**
 * Determine XHR.
 */ request.getXHR = ()=>{
    if (root.XMLHttpRequest) return new root.XMLHttpRequest();
    throw new Error("Browser-only version of superagent could not find XHR");
};
/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */ const trim = "".trim ? (s)=>s.trim() : (s)=>s.replace(/(^\s*|\s*$)/g, "");
/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */ function serialize(object) {
    if (!$4913dac236115adc$require$isObject(object)) return object;
    const pairs = [];
    for(const key in object)if ($4913dac236115adc$require$hasOwn(object, key)) pushEncodedKeyValuePair(pairs, key, object[key]);
    return pairs.join("&");
}
/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */ function pushEncodedKeyValuePair(pairs, key, value) {
    if (value === undefined) return;
    if (value === null) {
        pairs.push(encodeURI(key));
        return;
    }
    if (Array.isArray(value)) for (const v of value)pushEncodedKeyValuePair(pairs, key, v);
    else if ($4913dac236115adc$require$isObject(value)) {
        for(const subkey in value)if ($4913dac236115adc$require$hasOwn(value, subkey)) pushEncodedKeyValuePair(pairs, `${key}[${subkey}]`, value[subkey]);
    } else pairs.push(encodeURI(key) + "=" + encodeURIComponent(value));
}
/**
 * Expose serialization method.
 */ request.serializeObject = serialize;
/**
 * Parse the given x-www-form-urlencoded `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseString(string_) {
    const object = {};
    const pairs = string_.split("&");
    let pair;
    let pos;
    for(let i = 0, length_ = pairs.length; i < length_; ++i){
        pair = pairs[i];
        pos = pair.indexOf("=");
        if (pos === -1) object[decodeURIComponent(pair)] = "";
        else object[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
    return object;
}
/**
 * Expose parser.
 */ request.parseString = parseString;
/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */ request.types = {
    html: "text/html",
    json: "application/json",
    xml: "text/xml",
    urlencoded: "application/x-www-form-urlencoded",
    form: "application/x-www-form-urlencoded",
    "form-data": "application/x-www-form-urlencoded"
};
/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */ request.serialize = {
    "application/x-www-form-urlencoded": $2rasJ.stringify,
    "application/json": $hgGe6
};
/**
 * Default parsers.
 *
 *     superagent.parse['application/xml'] = function(str){
 *       return { object parsed from str };
 *     };
 *
 */ request.parse = {
    "application/x-www-form-urlencoded": parseString,
    "application/json": JSON.parse
};
/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseHeader(string_) {
    const lines = string_.split(/\r?\n/);
    const fields = {};
    let index;
    let line;
    let field;
    let value;
    for(let i = 0, length_ = lines.length; i < length_; ++i){
        line = lines[i];
        index = line.indexOf(":");
        if (index === -1) continue;
        field = line.slice(0, index).toLowerCase();
        value = trim(line.slice(index + 1));
        fields[field] = value;
    }
    return fields;
}
/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */ function isJSON(mime) {
    // should match /json or +json
    // but not /json-seq
    return /[/+]json($|[^-\w])/i.test(mime);
}
/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */ function Response(request_) {
    this.req = request_;
    this.xhr = this.req.xhr;
    // responseText is accessible only if responseType is '' or 'text' and on older browsers
    this.text = this.req.method !== "HEAD" && (this.xhr.responseType === "" || this.xhr.responseType === "text") || typeof this.xhr.responseType === "undefined" ? this.xhr.responseText : null;
    this.statusText = this.req.xhr.statusText;
    let { status } = this.xhr;
    // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    if (status === 1223) status = 204;
    this._setStatusProperties(status);
    this.headers = parseHeader(this.xhr.getAllResponseHeaders());
    this.header = this.headers;
    // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
    // getResponseHeader still works. so we get content-type even if getting
    // other headers fails.
    this.header["content-type"] = this.xhr.getResponseHeader("content-type");
    this._setHeaderProperties(this.header);
    if (this.text === null && request_._responseType) this.body = this.xhr.response;
    else this.body = this.req.method === "HEAD" ? null : this._parseBody(this.text ? this.text : this.xhr.response);
}
$4913dac236115adc$require$mixin(Response.prototype, $8GXcX.prototype);
/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */ Response.prototype._parseBody = function(string_) {
    let parse = request.parse[this.type];
    if (this.req._parser) return this.req._parser(this, string_);
    if (!parse && isJSON(this.type)) parse = request.parse["application/json"];
    return parse && string_ && (string_.length > 0 || string_ instanceof Object) ? parse(string_) : null;
};
/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */ Response.prototype.toError = function() {
    const { req } = this;
    const { method } = req;
    const { url } = req;
    const message = `cannot ${method} ${url} (${this.status})`;
    const error = new Error(message);
    error.status = this.status;
    error.method = method;
    error.url = url;
    return error;
};
/**
 * Expose `Response`.
 */ request.Response = Response;
/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */ function Request(method, url) {
    const self1 = this;
    this._query = this._query || [];
    this.method = method;
    this.url = url;
    this.header = {}; // preserves header name case
    this._header = {}; // coerces header names to lowercase
    this.on("end", ()=>{
        let error = null;
        let res = null;
        try {
            res = new Response(self1);
        } catch (err) {
            error = new Error("Parser is unable to parse the response");
            error.parse = true;
            error.original = err;
            // issue #675: return the raw response if the response parsing fails
            if (self1.xhr) {
                // ie9 doesn't have 'response' property
                error.rawResponse = typeof self1.xhr.responseType === "undefined" ? self1.xhr.responseText : self1.xhr.response;
                // issue #876: return the http status code if the response parsing fails
                error.status = self1.xhr.status ? self1.xhr.status : null;
                error.statusCode = error.status; // backwards-compat only
            } else {
                error.rawResponse = null;
                error.status = null;
            }
            return self1.callback(error);
        }
        self1.emit("response", res);
        let new_error;
        try {
            if (!self1._isResponseOK(res)) new_error = new Error(res.statusText || res.text || "Unsuccessful HTTP response");
        } catch (err) {
            new_error = err; // ok() callback can throw
        }
        // #1000 don't catch errors from the callback to avoid double calling it
        if (new_error) {
            new_error.original = error;
            new_error.response = res;
            new_error.status = new_error.status || res.status;
            self1.callback(new_error, res);
        } else self1.callback(null, res);
    });
}
/**
 * Mixin `Emitter` and `RequestBase`.
 */ // eslint-disable-next-line new-cap
$9yRAu(Request.prototype);
$4913dac236115adc$require$mixin(Request.prototype, $hli7k.prototype);
/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.type = function(type) {
    this.set("Content-Type", request.types[type] || type);
    return this;
};
/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.accept = function(type) {
    this.set("Accept", request.types[type] || type);
    return this;
};
/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.auth = function(user, pass, options) {
    if (arguments.length === 1) pass = "";
    if (typeof pass === "object" && pass !== null) {
        // pass is optional and can be replaced with options
        options = pass;
        pass = "";
    }
    if (!options) options = {
        type: typeof btoa === "function" ? "basic" : "auto"
    };
    const encoder = options.encoder ? options.encoder : (string)=>{
        if (typeof btoa === "function") return btoa(string);
        throw new Error("Cannot use basic auth, btoa is not a function");
    };
    return this._auth(user, pass, options, encoder);
};
/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.query = function(value) {
    if (typeof value !== "string") value = serialize(value);
    if (value) this._query.push(value);
    return this;
};
/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.attach = function(field, file, options) {
    if (file) {
        if (this._data) throw new Error("superagent can't mix .send() and .attach()");
        this._getFormData().append(field, file, options || file.name);
    }
    return this;
};
Request.prototype._getFormData = function() {
    if (!this._formData) this._formData = new root.FormData();
    return this._formData;
};
/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */ Request.prototype.callback = function(error, res) {
    if (this._shouldRetry(error, res)) return this._retry();
    const fn = this._callback;
    this.clearTimeout();
    if (error) {
        if (this._maxRetries) error.retries = this._retries - 1;
        this.emit("error", error);
    }
    fn(error, res);
};
/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */ Request.prototype.crossDomainError = function() {
    const error = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");
    error.crossDomain = true;
    error.status = this.status;
    error.method = this.method;
    error.url = this.url;
    this.callback(error);
};
// This only warns, because the request is still likely to work
Request.prototype.agent = function() {
    console.warn("This is not supported in browser version of superagent");
    return this;
};
Request.prototype.ca = Request.prototype.agent;
Request.prototype.buffer = Request.prototype.ca;
// This throws, because it can't send/receive data as expected
Request.prototype.write = ()=>{
    throw new Error("Streaming is not supported in browser version of superagent");
};
Request.prototype.pipe = Request.prototype.write;
/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj host object
 * @return {Boolean} is a host object
 * @api private
 */ Request.prototype._isHost = function(object) {
    // Native objects stringify to [object File], [object Blob], [object FormData], etc.
    return object && typeof object === "object" && !Array.isArray(object) && Object.prototype.toString.call(object) !== "[object Object]";
};
/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.end = function(fn) {
    if (this._endCalled) console.warn("Warning: .end() was called twice. This is not supported in superagent");
    this._endCalled = true;
    // store callback
    this._callback = fn || noop;
    // querystring
    this._finalizeQueryString();
    this._end();
};
Request.prototype._setUploadTimeout = function() {
    const self1 = this;
    // upload timeout it's wokrs only if deadline timeout is off
    if (this._uploadTimeout && !this._uploadTimeoutTimer) this._uploadTimeoutTimer = setTimeout(()=>{
        self1._timeoutError("Upload timeout of ", self1._uploadTimeout, "ETIMEDOUT");
    }, this._uploadTimeout);
};
// eslint-disable-next-line complexity
Request.prototype._end = function() {
    if (this._aborted) return this.callback(new Error("The request has been aborted even before .end() was called"));
    const self1 = this;
    this.xhr = request.getXHR();
    const { xhr } = this;
    let data = this._formData || this._data;
    this._setTimeouts();
    // state change
    xhr.addEventListener("readystatechange", ()=>{
        const { readyState } = xhr;
        if (readyState >= 2 && self1._responseTimeoutTimer) clearTimeout(self1._responseTimeoutTimer);
        if (readyState !== 4) return;
        // In IE9, reads to any property (e.g. status) off of an aborted XHR will
        // result in the error "Could not complete the operation due to error c00c023f"
        let status;
        try {
            status = xhr.status;
        } catch (err) {
            status = 0;
        }
        if (!status) {
            if (self1.timedout || self1._aborted) return;
            return self1.crossDomainError();
        }
        self1.emit("end");
    });
    // progress
    const handleProgress = (direction, e)=>{
        if (e.total > 0) {
            e.percent = e.loaded / e.total * 100;
            if (e.percent === 100) clearTimeout(self1._uploadTimeoutTimer);
        }
        e.direction = direction;
        self1.emit("progress", e);
    };
    if (this.hasListeners("progress")) try {
        xhr.addEventListener("progress", handleProgress.bind(null, "download"));
        if (xhr.upload) xhr.upload.addEventListener("progress", handleProgress.bind(null, "upload"));
    } catch (err) {
    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
    // Reported here:
    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
    if (xhr.upload) this._setUploadTimeout();
    // initiate request
    try {
        if (this.username && this.password) xhr.open(this.method, this.url, true, this.username, this.password);
        else xhr.open(this.method, this.url, true);
    } catch (err) {
        // see #1149
        return this.callback(err);
    }
    // CORS
    if (this._withCredentials) xhr.withCredentials = true;
    // body
    if (!this._formData && this.method !== "GET" && this.method !== "HEAD" && typeof data !== "string" && !this._isHost(data)) {
        // serialize stuff
        const contentType = this._header["content-type"];
        let serialize = this._serializer || request.serialize[contentType ? contentType.split(";")[0] : ""];
        if (!serialize && isJSON(contentType)) serialize = request.serialize["application/json"];
        if (serialize) data = serialize(data);
    }
    // set header fields
    for(const field in this.header){
        if (this.header[field] === null) continue;
        if ($4913dac236115adc$require$hasOwn(this.header, field)) xhr.setRequestHeader(field, this.header[field]);
    }
    if (this._responseType) xhr.responseType = this._responseType;
    // send stuff
    this.emit("request", this);
    // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
    // We need null here if data is undefined
    xhr.send(typeof data === "undefined" ? null : data);
};
request.agent = ()=>new $7fj1N();
for (const method of [
    "GET",
    "POST",
    "OPTIONS",
    "PATCH",
    "PUT",
    "DELETE"
])$7fj1N.prototype[method.toLowerCase()] = function(url, fn) {
    const request_ = new request.Request(method, url);
    this._setDefaults(request_);
    if (fn) request_.end(fn);
    return request_;
};
$7fj1N.prototype.del = $7fj1N.prototype.delete;
/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.get = (url, data, fn)=>{
    const request_ = request("GET", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.query(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.head = (url, data, fn)=>{
    const request_ = request("HEAD", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.query(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.options = (url, data, fn)=>{
    const request_ = request("OPTIONS", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ function del(url, data, fn) {
    const request_ = request("DELETE", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
}
request.del = del;
request.delete = del;
/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.patch = (url, data, fn)=>{
    const request_ = request("PATCH", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.post = (url, data, fn)=>{
    const request_ = request("POST", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.put = (url, data, fn)=>{
    const request_ = request("PUT", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};

});
parcelRegister("9yRAu", function(module, exports) {
/**
 * Expose `Emitter`.
 */ module.exports = $6f60db6a5819cdac$var$Emitter;
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $6f60db6a5819cdac$var$Emitter(obj) {
    if (obj) return $6f60db6a5819cdac$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $6f60db6a5819cdac$var$mixin(obj) {
    for(var key in $6f60db6a5819cdac$var$Emitter.prototype)obj[key] = $6f60db6a5819cdac$var$Emitter.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $6f60db6a5819cdac$var$Emitter.prototype.on = $6f60db6a5819cdac$var$Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $6f60db6a5819cdac$var$Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $6f60db6a5819cdac$var$Emitter.prototype.off = $6f60db6a5819cdac$var$Emitter.prototype.removeListener = $6f60db6a5819cdac$var$Emitter.prototype.removeAllListeners = $6f60db6a5819cdac$var$Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $6f60db6a5819cdac$var$Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $6f60db6a5819cdac$var$Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $6f60db6a5819cdac$var$Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("hgGe6", function(module, exports) {
module.exports = $c924af90aa582a4d$var$stringify;
$c924af90aa582a4d$var$stringify.default = $c924af90aa582a4d$var$stringify;
$c924af90aa582a4d$var$stringify.stable = $c924af90aa582a4d$var$deterministicStringify;
$c924af90aa582a4d$var$stringify.stableStringify = $c924af90aa582a4d$var$deterministicStringify;
var $c924af90aa582a4d$var$LIMIT_REPLACE_NODE = "[...]";
var $c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE = "[Circular]";
var $c924af90aa582a4d$var$arr = [];
var $c924af90aa582a4d$var$replacerStack = [];
function $c924af90aa582a4d$var$defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function $c924af90aa582a4d$var$stringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $c924af90aa582a4d$var$defaultOptions();
    $c924af90aa582a4d$var$decirc(obj, "", 0, [], undefined, 0, options);
    var res;
    try {
        if ($c924af90aa582a4d$var$replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, $c924af90aa582a4d$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        while($c924af90aa582a4d$var$arr.length !== 0){
            var part = $c924af90aa582a4d$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $c924af90aa582a4d$var$setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            $c924af90aa582a4d$var$arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else $c924af90aa582a4d$var$replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        $c924af90aa582a4d$var$arr.push([
            parent,
            k,
            val
        ]);
    }
}
function $c924af90aa582a4d$var$decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$c924af90aa582a4d$var$decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $c924af90aa582a4d$var$decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function $c924af90aa582a4d$var$compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $c924af90aa582a4d$var$deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $c924af90aa582a4d$var$defaultOptions();
    var tmp = $c924af90aa582a4d$var$deterministicDecirc(obj, "", 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if ($c924af90aa582a4d$var$replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, $c924af90aa582a4d$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        // Ensure that we restore the object as it was.
        while($c924af90aa582a4d$var$arr.length !== 0){
            var part = $c924af90aa582a4d$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $c924af90aa582a4d$var$deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === "function") return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$c924af90aa582a4d$var$deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort($c924af90aa582a4d$var$compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $c924af90aa582a4d$var$deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== "undefined") {
                $c924af90aa582a4d$var$arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function $c924af90aa582a4d$var$replaceGetterValues(replacer) {
    replacer = typeof replacer !== "undefined" ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if ($c924af90aa582a4d$var$replacerStack.length > 0) for(var i = 0; i < $c924af90aa582a4d$var$replacerStack.length; i++){
            var part = $c924af90aa582a4d$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                $c924af90aa582a4d$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}

});

parcelRegister("2rasJ", function(module, exports) {
"use strict";

var $jJyEy = parcelRequire("jJyEy");

var $cfYIz = parcelRequire("cfYIz");

var $i1Gbt = parcelRequire("i1Gbt");
module.exports = {
    formats: $i1Gbt,
    parse: $cfYIz,
    stringify: $jJyEy
};

});
parcelRegister("jJyEy", function(module, exports) {
"use strict";

var $LlIML = parcelRequire("LlIML");

var $iBfJ5 = parcelRequire("iBfJ5");

var $i1Gbt = parcelRequire("i1Gbt");
var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $i1Gbt.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $iBfJ5.encode,
    encodeValuesOnly: false,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $i1Gbt.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) obj = $iBfJ5.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $iBfJ5.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $iBfJ5.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $LlIML();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $e5dd19a945a45bbb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $i1Gbt.default;
    if (typeof opts.format !== "undefined") {
        if (!$e5dd19a945a45bbb$var$has.call($i1Gbt.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $i1Gbt.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === "function" || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $e5dd19a945a45bbb$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $e5dd19a945a45bbb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $e5dd19a945a45bbb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $LlIML();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("LlIML", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $hXu6F = parcelRequire("hXu6F");

var $e7DLx = parcelRequire("e7DLx");

var $eEkyn = parcelRequire("eEkyn");
var $08e53d4ef2e1f8ef$var$$WeakMap = $1zENl("%WeakMap%", true);
var $08e53d4ef2e1f8ef$var$$Map = $1zENl("%Map%", true);
var $08e53d4ef2e1f8ef$var$$weakMapGet = $hXu6F("WeakMap.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$weakMapSet = $hXu6F("WeakMap.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$weakMapHas = $hXu6F("WeakMap.prototype.has", true);
var $08e53d4ef2e1f8ef$var$$mapGet = $hXu6F("Map.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$mapSet = $hXu6F("Map.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$mapHas = $hXu6F("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $08e53d4ef2e1f8ef$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $08e53d4ef2e1f8ef$var$listGet = function(objects, key) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $08e53d4ef2e1f8ef$var$listSet = function(objects, key, value) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $08e53d4ef2e1f8ef$var$listHas = function(objects, key) {
    return !!$08e53d4ef2e1f8ef$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eEkyn("Side channel does not contain " + $e7DLx(key));
        },
        get: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapGet($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapGet($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapHas($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapHas($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $08e53d4ef2e1f8ef$var$$WeakMap();
                $08e53d4ef2e1f8ef$var$$weakMapSet($wm, key, value);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if (!$m) $m = new $08e53d4ef2e1f8ef$var$$Map();
                $08e53d4ef2e1f8ef$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $08e53d4ef2e1f8ef$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $5A49f,
    "%eval%": eval,
    "%EvalError%": $hDtVy,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $9RC8m,
    "%ReferenceError%": $2BaZq,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $5Ox6r,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $eEkyn,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $hFSMY,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $eEkyn("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $eEkyn("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $5Ox6r("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5A49f", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    __proto__: null,
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !($a1b9a4c94d7d9147$var$test instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");

var $eEkyn = parcelRequire("eEkyn");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);

var $jAy3M = parcelRequire("jAy3M");
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $eEkyn("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($jAy3M) $jAy3M(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $eEkyn("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $eEkyn("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $eEkyn("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $eEkyn("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $eEkyn("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $eEkyn("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $eEkyn("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("jAy3M", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = $1zENl("%Object.defineProperty%", true) || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});


parcelRegister("i16wS", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});




parcelRegister("e7DLx", function(module, exports) {
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === "function" && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === "function" && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, "$&_") + "." + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, "$&_");
}

var $kjyEk = parcelRequire("kjyEk");
var $a48090c7c3dfd2b6$var$inspectCustom = $kjyEk.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($a48090c7c3dfd2b6$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $a48090c7c3dfd2b6$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $a48090c7c3dfd2b6$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === "object" && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = "<" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return "[" + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + "]";
        return "[ " + $a48090c7c3dfd2b6$var$$join.call(xs, ", ") + " ]";
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === "function" && $kjyEk) return $kjyEk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Map", $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Set", $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakMap");
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakSet");
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakRef");
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $a48090c7c3dfd2b6$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, "&quot;");
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Array]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Date]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object RegExp]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Error]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object String]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Number]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Boolean]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, "single", opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === "function" ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("iBfJ5", function(module, exports) {
"use strict";

var $i1Gbt = parcelRequire("i1Gbt");
var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $d8a7e190fdc9c6e7$var$limit){
        var segment = string.length >= $d8a7e190fdc9c6e7$var$limit ? string.slice(j, j + $d8a7e190fdc9c6e7$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $i1Gbt.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};

});
parcelRegister("i1Gbt", function(module, exports) {
"use strict";
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};

});



parcelRegister("cfYIz", function(module, exports) {
"use strict";

var $iBfJ5 = parcelRequire("iBfJ5");
var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $iBfJ5.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = $iBfJ5.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        var existing = $8ec5fc0fdc198ba4$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $iBfJ5.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && leaf === "" ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $8ec5fc0fdc198ba4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $8ec5fc0fdc198ba4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $iBfJ5.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $iBfJ5.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $iBfJ5.compact(obj);
};

});


parcelRegister("hli7k", function(module, exports) {
"use strict";

var $ess0W = parcelRequire("ess0W");
var $ca02738322db5140$require$isObject = $ess0W.isObject;
var $ca02738322db5140$require$hasOwn = $ess0W.hasOwn;
/**
 * Expose `RequestBase`.
 */ module.exports = $ca02738322db5140$var$RequestBase;
/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */ function $ca02738322db5140$var$RequestBase() {}
/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.clearTimeout = function() {
    clearTimeout(this._timer);
    clearTimeout(this._responseTimeoutTimer);
    clearTimeout(this._uploadTimeoutTimer);
    delete this._timer;
    delete this._responseTimeoutTimer;
    delete this._uploadTimeoutTimer;
    return this;
};
/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.parse = function(fn) {
    this._parser = fn;
    return this;
};
/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.responseType = function(value) {
    this._responseType = value;
    return this;
};
/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.serialize = function(fn) {
    this._serializer = fn;
    return this;
};
/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 * - upload is the time  since last bit of data was sent or received. This timeout works only if deadline timeout is off
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.timeout = function(options) {
    if (!options || typeof options !== "object") {
        this._timeout = options;
        this._responseTimeout = 0;
        this._uploadTimeout = 0;
        return this;
    }
    for(const option in options)if ($ca02738322db5140$require$hasOwn(options, option)) switch(option){
        case "deadline":
            this._timeout = options.deadline;
            break;
        case "response":
            this._responseTimeout = options.response;
            break;
        case "upload":
            this._uploadTimeout = options.upload;
            break;
        default:
            console.warn("Unknown timeout option", option);
    }
    return this;
};
/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.retry = function(count, fn) {
    // Default to 1 if no count passed or true
    if (arguments.length === 0 || count === true) count = 1;
    if (count <= 0) count = 0;
    this._maxRetries = count;
    this._retries = 0;
    this._retryCallback = fn;
    return this;
};
//
// NOTE: we do not include ESOCKETTIMEDOUT because that is from `request` package
//       <https://github.com/sindresorhus/got/pull/537>
//
// NOTE: we do not include EADDRINFO because it was removed from libuv in 2014
//       <https://github.com/libuv/libuv/commit/02e1ebd40b807be5af46343ea873331b2ee4e9c1>
//       <https://github.com/request/request/search?q=ESOCKETTIMEDOUT&unscoped_q=ESOCKETTIMEDOUT>
//
//
// TODO: expose these as configurable defaults
//
const $ca02738322db5140$var$ERROR_CODES = new Set([
    "ETIMEDOUT",
    "ECONNRESET",
    "EADDRINUSE",
    "ECONNREFUSED",
    "EPIPE",
    "ENOTFOUND",
    "ENETUNREACH",
    "EAI_AGAIN"
]);
const $ca02738322db5140$var$STATUS_CODES = new Set([
    408,
    413,
    429,
    500,
    502,
    503,
    504,
    521,
    522,
    524
]);
// TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
// const METHODS = new Set(['GET', 'PUT', 'HEAD', 'DELETE', 'OPTIONS', 'TRACE']);
/**
 * Determine if a request should be retried.
 * (Inspired by https://github.com/sindresorhus/got#retry)
 *
 * @param {Error} err an error
 * @param {Response} [res] response
 * @returns {Boolean} if segment should be retried
 */ $ca02738322db5140$var$RequestBase.prototype._shouldRetry = function(error, res) {
    if (!this._maxRetries || this._retries++ >= this._maxRetries) return false;
    if (this._retryCallback) try {
        const override = this._retryCallback(error, res);
        if (override === true) return true;
        if (override === false) return false;
    // undefined falls back to defaults
    } catch (err) {
        console.error(err);
    }
    // TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
    /*
  if (
    this.req &&
    this.req.method &&
    !METHODS.has(this.req.method.toUpperCase())
  )
    return false;
  */ if (res && res.status && $ca02738322db5140$var$STATUS_CODES.has(res.status)) return true;
    if (error) {
        if (error.code && $ca02738322db5140$var$ERROR_CODES.has(error.code)) return true;
        // Superagent timeout
        if (error.timeout && error.code === "ECONNABORTED") return true;
        if (error.crossDomain) return true;
    }
    return false;
};
/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */ $ca02738322db5140$var$RequestBase.prototype._retry = function() {
    this.clearTimeout();
    // node
    if (this.req) {
        this.req = null;
        this.req = this.request();
    }
    this._aborted = false;
    this.timedout = false;
    this.timedoutError = null;
    return this._end();
};
/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */ $ca02738322db5140$var$RequestBase.prototype.then = function(resolve, reject) {
    if (!this._fullfilledPromise) {
        const self = this;
        if (this._endCalled) console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
        this._fullfilledPromise = new Promise((resolve, reject)=>{
            self.on("abort", ()=>{
                if (this._maxRetries && this._maxRetries > this._retries) return;
                if (this.timedout && this.timedoutError) {
                    reject(this.timedoutError);
                    return;
                }
                const error = new Error("Aborted");
                error.code = "ABORTED";
                error.status = this.status;
                error.method = this.method;
                error.url = this.url;
                reject(error);
            });
            self.end((error, res)=>{
                if (error) reject(error);
                else resolve(res);
            });
        });
    }
    return this._fullfilledPromise.then(resolve, reject);
};
$ca02738322db5140$var$RequestBase.prototype.catch = function(callback) {
    return this.then(undefined, callback);
};
/**
 * Allow for extension
 */ $ca02738322db5140$var$RequestBase.prototype.use = function(fn) {
    fn(this);
    return this;
};
$ca02738322db5140$var$RequestBase.prototype.ok = function(callback) {
    if (typeof callback !== "function") throw new Error("Callback required");
    this._okCallback = callback;
    return this;
};
$ca02738322db5140$var$RequestBase.prototype._isResponseOK = function(res) {
    if (!res) return false;
    if (this._okCallback) return this._okCallback(res);
    return res.status >= 200 && res.status < 300;
};
/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.get = function(field) {
    return this._header[field.toLowerCase()];
};
/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */ $ca02738322db5140$var$RequestBase.prototype.getHeader = $ca02738322db5140$var$RequestBase.prototype.get;
/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.set = function(field, value) {
    if ($ca02738322db5140$require$isObject(field)) {
        for(const key in field)if ($ca02738322db5140$require$hasOwn(field, key)) this.set(key, field[key]);
        return this;
    }
    this._header[field.toLowerCase()] = value;
    this.header[field] = value;
    return this;
};
/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field field name
 */ $ca02738322db5140$var$RequestBase.prototype.unset = function(field) {
    delete this._header[field.toLowerCase()];
    delete this.header[field];
    return this;
};
/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name name of field
 * @param {String|Blob|File|Buffer|fs.ReadStream} val value of field
 * @param {String} options extra options, e.g. 'blob'
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.field = function(name, value, options) {
    // name should be either a string or an object.
    if (name === null || undefined === name) throw new Error(".field(name, val) name can not be empty");
    if (this._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
    if ($ca02738322db5140$require$isObject(name)) {
        for(const key in name)if ($ca02738322db5140$require$hasOwn(name, key)) this.field(key, name[key]);
        return this;
    }
    if (Array.isArray(value)) {
        for(const i in value)if ($ca02738322db5140$require$hasOwn(value, i)) this.field(name, value[i]);
        return this;
    }
    // val should be defined now
    if (value === null || undefined === value) throw new Error(".field(name, val) val can not be empty");
    if (typeof value === "boolean") value = String(value);
    // fix https://github.com/ladjs/superagent/issues/1680
    if (options) this._getFormData().append(name, value, options);
    else this._getFormData().append(name, value);
    return this;
};
/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request} request
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.abort = function() {
    if (this._aborted) return this;
    this._aborted = true;
    if (this.xhr) this.xhr.abort(); // browser
    if (this.req) this.req.abort(); // node
    this.clearTimeout();
    this.emit("abort");
    return this;
};
$ca02738322db5140$var$RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
    switch(options.type){
        case "basic":
            this.set("Authorization", `Basic ${base64Encoder(`${user}:${pass}`)}`);
            break;
        case "auto":
            this.username = user;
            this.password = pass;
            break;
        case "bearer":
            // usage would be .auth(accessToken, { type: 'bearer' })
            this.set("Authorization", `Bearer ${user}`);
            break;
        default:
            break;
    }
    return this;
};
/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 * @param {Boolean} [on=true] - Set 'withCredentials' state
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.withCredentials = function(on) {
    // This is browser-only functionality. Node side is no-op.
    if (on === undefined) on = true;
    this._withCredentials = on;
    return this;
};
/**
 * Set the max redirects to `n`. Does nothing in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.redirects = function(n) {
    this._maxRedirects = n;
    return this;
};
/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n number of bytes
 * @return {Request} for chaining
 */ $ca02738322db5140$var$RequestBase.prototype.maxResponseSize = function(n) {
    if (typeof n !== "number") throw new TypeError("Invalid argument");
    this._maxResponseSize = n;
    return this;
};
/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.toJSON = function() {
    return {
        method: this.method,
        url: this.url,
        data: this._data,
        headers: this._header
    };
};
/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */ // eslint-disable-next-line complexity
$ca02738322db5140$var$RequestBase.prototype.send = function(data) {
    const isObject_ = $ca02738322db5140$require$isObject(data);
    let type = this._header["content-type"];
    if (this._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
    if (isObject_ && !this._data) {
        if (Array.isArray(data)) this._data = [];
        else if (!this._isHost(data)) this._data = {};
    } else if (data && this._data && this._isHost(this._data)) throw new Error("Can't merge these send calls");
    // merge
    if (isObject_ && $ca02738322db5140$require$isObject(this._data)) for(const key in data){
        if (typeof data[key] == "bigint" && !data[key].toJSON) throw new Error("Cannot serialize BigInt value to json");
        if ($ca02738322db5140$require$hasOwn(data, key)) this._data[key] = data[key];
    }
    else if (typeof data === "bigint") throw new Error("Cannot send value of type BigInt");
    else if (typeof data === "string") {
        // default to x-www-form-urlencoded
        if (!type) this.type("form");
        type = this._header["content-type"];
        if (type) type = type.toLowerCase().trim();
        if (type === "application/x-www-form-urlencoded") this._data = this._data ? `${this._data}&${data}` : data;
        else this._data = (this._data || "") + data;
    } else this._data = data;
    if (!isObject_ || this._isHost(data)) return this;
    // default to json
    if (!type) this.type("json");
    return this;
};
/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.sortQuery = function(sort) {
    // _sort default to true but otherwise can be a function or boolean
    this._sort = typeof sort === "undefined" ? true : sort;
    return this;
};
/**
 * Compose querystring to append to req.url
 *
 * @api private
 */ $ca02738322db5140$var$RequestBase.prototype._finalizeQueryString = function() {
    const query = this._query.join("&");
    if (query) this.url += (this.url.includes("?") ? "&" : "?") + query;
    this._query.length = 0; // Makes the call idempotent
    if (this._sort) {
        const index = this.url.indexOf("?");
        if (index >= 0) {
            const queryArray = this.url.slice(index + 1).split("&");
            if (typeof this._sort === "function") queryArray.sort(this._sort);
            else queryArray.sort();
            this.url = this.url.slice(0, index) + "?" + queryArray.join("&");
        }
    }
};
// For backwards compat only
$ca02738322db5140$var$RequestBase.prototype._appendQueryString = ()=>{
    console.warn("Unsupported");
};
/**
 * Invoke callback with timeout error.
 *
 * @api private
 */ $ca02738322db5140$var$RequestBase.prototype._timeoutError = function(reason, timeout, errno) {
    if (this._aborted) return;
    const error = new Error(`${reason + timeout}ms exceeded`);
    error.timeout = timeout;
    error.code = "ECONNABORTED";
    error.errno = errno;
    this.timedout = true;
    this.timedoutError = error;
    this.abort();
    this.callback(error);
};
$ca02738322db5140$var$RequestBase.prototype._setTimeouts = function() {
    const self = this;
    // deadline
    if (this._timeout && !this._timer) this._timer = setTimeout(()=>{
        self._timeoutError("Timeout of ", self._timeout, "ETIME");
    }, this._timeout);
    // response timeout
    if (this._responseTimeout && !this._responseTimeoutTimer) this._responseTimeoutTimer = setTimeout(()=>{
        self._timeoutError("Response timeout of ", self._responseTimeout, "ETIMEDOUT");
    }, this._responseTimeout);
};

});
parcelRegister("ess0W", function(module, exports) {

$parcel$export(module.exports, "type", () => $a869694114aee2b5$export$bf9fb029d174d554, (v) => $a869694114aee2b5$export$bf9fb029d174d554 = v);
$parcel$export(module.exports, "params", () => $a869694114aee2b5$export$281ad3752a540efe, (v) => $a869694114aee2b5$export$281ad3752a540efe = v);
$parcel$export(module.exports, "parseLinks", () => $a869694114aee2b5$export$255722312ba7ba74, (v) => $a869694114aee2b5$export$255722312ba7ba74 = v);
$parcel$export(module.exports, "isObject", () => $a869694114aee2b5$export$a6cdc56e425d0d0a, (v) => $a869694114aee2b5$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "hasOwn", () => $a869694114aee2b5$export$b5a638e9b3fff9f3, (v) => $a869694114aee2b5$export$b5a638e9b3fff9f3 = v);
$parcel$export(module.exports, "mixin", () => $a869694114aee2b5$export$e36fc9d62a853069, (v) => $a869694114aee2b5$export$e36fc9d62a853069 = v);
/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ var $a869694114aee2b5$export$bf9fb029d174d554;
/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ var $a869694114aee2b5$export$281ad3752a540efe;
/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ var $a869694114aee2b5$export$255722312ba7ba74;
/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */ var $a869694114aee2b5$export$bbc652556e2dc9ed;
/**
 * Check if `obj` is an object.
 *
 * @param {Object} object
 * @return {Boolean}
 * @api private
 */ var $a869694114aee2b5$export$a6cdc56e425d0d0a;
/**
 * Object.hasOwn fallback/polyfill.
 *
 * @type {(object: object, property: string) => boolean} object
 * @api private
 */ var $a869694114aee2b5$export$b5a638e9b3fff9f3;
var $a869694114aee2b5$export$e36fc9d62a853069;
"use strict";
$a869694114aee2b5$export$bf9fb029d174d554 = (string_)=>string_.split(/ *; */).shift();
$a869694114aee2b5$export$281ad3752a540efe = (value)=>{
    const object = {};
    for (const string_ of value.split(/ *; */)){
        const parts = string_.split(/ *= */);
        const key = parts.shift();
        const value = parts.shift();
        if (key && value) object[key] = value;
    }
    return object;
};
$a869694114aee2b5$export$255722312ba7ba74 = (value)=>{
    const object = {};
    for (const string_ of value.split(/ *, */)){
        const parts = string_.split(/ *; */);
        const url = parts[0].slice(1, -1);
        const rel = parts[1].split(/ *= */)[1].slice(1, -1);
        object[rel] = url;
    }
    return object;
};
$a869694114aee2b5$export$bbc652556e2dc9ed = (header, changesOrigin)=>{
    delete header["content-type"];
    delete header["content-length"];
    delete header["transfer-encoding"];
    delete header.host;
    // secuirty
    if (changesOrigin) {
        delete header.authorization;
        delete header.cookie;
    }
    return header;
};
$a869694114aee2b5$export$a6cdc56e425d0d0a = (object)=>{
    return object !== null && typeof object === "object";
};
$a869694114aee2b5$export$b5a638e9b3fff9f3 = Object.hasOwn || function(object, property) {
    if (object == null) throw new TypeError("Cannot convert undefined or null to object");
    return Object.prototype.hasOwnProperty.call(new Object(object), property);
};
$a869694114aee2b5$export$e36fc9d62a853069 = (target, source)=>{
    for(const key in source)if ($a869694114aee2b5$export$b5a638e9b3fff9f3(source, key)) target[key] = source[key];
};

});


parcelRegister("8GXcX", function(module, exports) {
"use strict";

var $ess0W = parcelRequire("ess0W");
/**
 * Expose `ResponseBase`.
 */ module.exports = $65402c774823aef2$var$ResponseBase;
/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */ function $65402c774823aef2$var$ResponseBase() {}
/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ $65402c774823aef2$var$ResponseBase.prototype.get = function(field) {
    return this.header[field.toLowerCase()];
};
/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */ $65402c774823aef2$var$ResponseBase.prototype._setHeaderProperties = function(header) {
    // TODO: moar!
    // TODO: make this a util
    // content-type
    const ct = header["content-type"] || "";
    this.type = $ess0W.type(ct);
    // params
    const parameters = $ess0W.params(ct);
    for(const key in parameters)if (Object.prototype.hasOwnProperty.call(parameters, key)) this[key] = parameters[key];
    this.links = {};
    // links
    try {
        if (header.link) this.links = $ess0W.parseLinks(header.link);
    } catch (err) {
    // ignore
    }
};
/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */ $65402c774823aef2$var$ResponseBase.prototype._setStatusProperties = function(status) {
    const type = Math.trunc(status / 100);
    // status / class
    this.statusCode = status;
    this.status = this.statusCode;
    this.statusType = type;
    // basics
    this.info = type === 1;
    this.ok = type === 2;
    this.redirect = type === 3;
    this.clientError = type === 4;
    this.serverError = type === 5;
    this.error = type === 4 || type === 5 ? this.toError() : false;
    // sugar
    this.created = status === 201;
    this.accepted = status === 202;
    this.noContent = status === 204;
    this.badRequest = status === 400;
    this.unauthorized = status === 401;
    this.notAcceptable = status === 406;
    this.forbidden = status === 403;
    this.notFound = status === 404;
    this.unprocessableEntity = status === 422;
};

});

parcelRegister("7fj1N", function(module, exports) {
"use strict";
const $5468b1add91df428$var$defaults = [
    "use",
    "on",
    "once",
    "set",
    "query",
    "type",
    "accept",
    "auth",
    "withCredentials",
    "sortQuery",
    "retry",
    "ok",
    "redirects",
    "timeout",
    "buffer",
    "serialize",
    "parse",
    "ca",
    "key",
    "pfx",
    "cert",
    "disableTLSCerts"
];
class $5468b1add91df428$var$Agent {
    constructor(){
        this._defaults = [];
    }
    _setDefaults(request) {
        for (const def of this._defaults)request[def.fn](...def.args);
    }
}
for (const fn of $5468b1add91df428$var$defaults)// Default setting for all requests from this agent
$5468b1add91df428$var$Agent.prototype[fn] = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    this._defaults.push({
        fn: fn,
        args: args
    });
    return this;
};
module.exports = $5468b1add91df428$var$Agent;

});




parcelRegister("gOjKo", function(module, exports) {

$parcel$export(module.exports, "ResetAuthCache", () => $c3d0a2401760e38e$export$8cecbc515898cb3f);
$parcel$export(module.exports, "CheckIfUserIsEditor", () => $c3d0a2401760e38e$export$b9a732e5b403b682);

var $72Xwp = parcelRequire("72Xwp");
let $c3d0a2401760e38e$var$authCache = null;
var $c3d0a2401760e38e$var$fetchUserInfo = async function() {
    if (!$c3d0a2401760e38e$var$authCache) $c3d0a2401760e38e$var$authCache = await (0, $72Xwp.default).auth();
    return $c3d0a2401760e38e$var$authCache || {};
};
function $c3d0a2401760e38e$export$8cecbc515898cb3f() {
    $c3d0a2401760e38e$var$authCache = null;
}
async function $c3d0a2401760e38e$export$5eac103c3c4b4319() {
    let auth = await $c3d0a2401760e38e$var$fetchUserInfo();
    auth.userrole;
}
$c3d0a2401760e38e$export$5eac103c3c4b4319;
async function $c3d0a2401760e38e$export$b9a732e5b403b682() {
    let auth = await $c3d0a2401760e38e$var$fetchUserInfo();
    return auth.userrole == "LyzarEditor" || auth.userrole == "Admin";
}

});


parcelRegister("gMOUR", function(module, exports) {

$parcel$export(module.exports, "render", () => $c3889fee55681489$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");

var $fAKGc = parcelRequire("fAKGc");

var $6gKts = parcelRequire("6gKts");
const $c3889fee55681489$var$_hoisted_1 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "header"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("a", {
        href: "/"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fAKGc))),
            alt: "Logo",
            class: "logo"
        })
    ])
], -1);
const $c3889fee55681489$var$_hoisted_2 = {
    class: "form-signin"
};
const $c3889fee55681489$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("img", {
    style: {
        "width": "50%"
    },
    class: "loginLogo",
    src: (0, (/*@__PURE__*/$parcel$interopDefault($6gKts)))
}, null, -1);
const $c3889fee55681489$var$_hoisted_4 = {
    class: "h3 mb-3 font-weight-normal",
    style: {
        "text-align": "center",
        "padding-top": "30px"
    }
};
const $c3889fee55681489$var$_hoisted_5 = {
    id: "alert",
    class: "text-align: center alert alert-danger alert-dismissible hidden"
};
const $c3889fee55681489$var$_hoisted_6 = {
    for: "inputUserName",
    class: "sr-only"
};
const $c3889fee55681489$var$_hoisted_7 = [
    "placeholder"
];
const $c3889fee55681489$var$_hoisted_8 = {
    for: "inputPassword",
    class: "sr-only"
};
const $c3889fee55681489$var$_hoisted_9 = [
    "placeholder"
];
function $c3889fee55681489$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        $c3889fee55681489$var$_hoisted_1,
        (0, $TusQn.createElementVNode)("div", $c3889fee55681489$var$_hoisted_2, [
            $c3889fee55681489$var$_hoisted_3,
            (0, $TusQn.createElementVNode)("h1", $c3889fee55681489$var$_hoisted_4, (0, $8POXm.toDisplayString)(_ctx.$t("pleaseSignIn")), 1),
            (0, $TusQn.createElementVNode)("div", $c3889fee55681489$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("incorrectUserOrPassword")), 1),
            (0, $TusQn.createElementVNode)("label", $c3889fee55681489$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("email")), 1),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                onKeyup: _cache[0] || (_cache[0] = (0, $eeJ70.withKeys)((...args)=>$options.login && $options.login(...args), [
                    "enter"
                ])),
                type: "userName",
                id: "inputUserName",
                class: "form-control",
                placeholder: _ctx.$t("enterLogin"),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.input.userName = $event),
                required: "",
                autofocus: ""
            }, null, 40, $c3889fee55681489$var$_hoisted_7), [
                [
                    (0, $eeJ70.vModelText),
                    $data.input.userName
                ]
            ]),
            (0, $TusQn.createElementVNode)("label", $c3889fee55681489$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("password")), 1),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                onKeyup: _cache[2] || (_cache[2] = (0, $eeJ70.withKeys)((...args)=>$options.login && $options.login(...args), [
                    "enter"
                ])),
                type: "password",
                id: "inputPassword",
                class: "form-control",
                placeholder: _ctx.$t("enterPassword"),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.input.password = $event),
                required: ""
            }, null, 40, $c3889fee55681489$var$_hoisted_9), [
                [
                    (0, $eeJ70.vModelText),
                    $data.input.password
                ]
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-lg btn-primary btn-block",
                onClick: _cache[4] || (_cache[4] = (...args)=>$options.login && $options.login(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("signIn")), 1)
        ])
    ]);
}

});
parcelRegister("fAKGc", function(module, exports) {
module.exports = new URL("header-logo.dccf98dc.png", import.meta.url).toString();

});

parcelRegister("6gKts", function(module, exports) {
module.exports = new URL("login_logo.d02bed8d.png", import.meta.url).toString();

});


parcelRegister("fhwaF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2016609ec44ab33$export$2e2bcd8739ae039);
let $b2016609ec44ab33$var$NOOP = ()=>{};
var $b2016609ec44ab33$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("utY1T", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $05ba0c527d83812c$export$2e2bcd8739ae039);

var $l6otV = parcelRequire("l6otV");

var $72Xwp = parcelRequire("72Xwp");
var $05ba0c527d83812c$export$2e2bcd8739ae039 = {
    name: "ModelingList",
    mounted () {
        this.requestData();
    },
    computed: {
        listOfModelings () {
            var modelingList = this.modelingList;
            if (this.filterInput) {
                const lowerCaseFilter = this.filterInput.toLowerCase();
                modelingList = modelingList.filter((viz)=>{
                    if (viz.name.toLowerCase().includes(lowerCaseFilter)) return viz;
                });
            }
            return modelingList.sort((a, b)=>a.name.localeCompare(b.name));
        }
    },
    methods: {
        async requestData () {
            try {
                this.loginInfo = await (0, $72Xwp.default).auth();
                var groupId = this.loginInfo.usergroup;
                var allModelings = await (0, $l6otV.default).modelingList();
                if (this.loginInfo.userrole == "Admin") this.modelingList = allModelings;
                else for(var i in allModelings){
                    var modeling = allModelings[i];
                    var parsedContent = JSON.parse(modeling.content);
                    if (parsedContent["groups"]) {
                        let findIndex = parsedContent["groups"].findIndex((g)=>g.groupId == groupId);
                        if (findIndex > -1) this.modelingList.push(modeling);
                    }
                }
            } catch (error) {
            // TODO: error
            }
        },
        showAlert () {
            this.hidden = "showAlertBlock";
        },
        async changeUser () {
            await (0, $72Xwp.default).logout();
            this.$router.push("/");
        }
    },
    data () {
        return {
            loginInfo: {
                isAuthenticated: false,
                usergroup: null,
                userrole: ""
            },
            hidden: "hidden",
            userrole: "",
            modelingList: [],
            filterInput: "",
            params: "",
            name: ""
        };
    }
};

});
parcelRegister("l6otV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5cd261364fad9bb$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $f5cd261364fad9bb$var$modelingApi = {
    modelingList: async ()=>{
        const req = (0, $f5Koy.default).get(`/api/modeling`);
        const res = await req;
        return res.body;
    },
    modelingDetail: async (modeling)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modeling}`);
        const res = await req;
        return res.body;
    },
    modelingUpdate: async (modeling)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modeling.id}`).send(modeling);
        const res = await req;
        return res.body;
    },
    modelingCreate: async (modeling)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling`).send(modeling);
        const res = await req;
        return res.body;
    },
    modelingDelete: async (modelingId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}`);
        await req;
    },
    modelingExport: (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/json`);
        return req;
    },
    modelingInfo: async (modeling)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/info/${modeling}`);
        const res = await req;
        return res.body;
    },
    importJson: async (modelingId, data)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/json`).send(data);
        const res = await req;
        return res.body;
    }
};
var $f5cd261364fad9bb$export$2e2bcd8739ae039 = $f5cd261364fad9bb$var$modelingApi;

});


parcelRegister("3FNfL", function(module, exports) {

$parcel$export(module.exports, "render", () => $2acb681a56451e2c$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");

var $fAKGc = parcelRequire("fAKGc");
const $2acb681a56451e2c$var$_hoisted_1 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "header"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("a", {
        href: "/"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fAKGc))),
            alt: "Logo",
            class: "logo"
        })
    ])
], -1);
const $2acb681a56451e2c$var$_hoisted_2 = {
    class: "modelings container py-5"
};
const $2acb681a56451e2c$var$_hoisted_3 = {
    class: "table-responsive"
};
const $2acb681a56451e2c$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("b", null, "here", -1);
const $2acb681a56451e2c$var$_hoisted_5 = {
    class: "table table-bordered table-responsive-md"
};
const $2acb681a56451e2c$var$_hoisted_6 = {
    class: "text-center"
};
const $2acb681a56451e2c$var$_hoisted_7 = {
    style: {
        "padding": "0"
    }
};
const $2acb681a56451e2c$var$_hoisted_8 = [
    "placeholder"
];
const $2acb681a56451e2c$var$_hoisted_9 = {
    key: 0
};
const $2acb681a56451e2c$var$_hoisted_10 = {
    key: 1
};
const $2acb681a56451e2c$var$_hoisted_11 = {
    class: "under-buttons"
};
const $2acb681a56451e2c$var$_hoisted_12 = {
    key: 0,
    style: {
        "float": "left"
    }
};
const $2acb681a56451e2c$var$_hoisted_13 = {
    class: "logout"
};
function $2acb681a56451e2c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        $2acb681a56451e2c$var$_hoisted_1,
        (0, $TusQn.createElementVNode)("div", $2acb681a56451e2c$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $2acb681a56451e2c$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", {
                    class: (0, $8POXm.normalizeClass)([
                        "alert alert-info",
                        $data.hidden
                    ]),
                    role: "alert"
                }, [
                    (0, $TusQn.createTextVNode)(" Please enter your credentials "),
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $2acb681a56451e2c$var$_hoisted_4
                            ]),
                        _: 1
                    }),
                    (0, $TusQn.createTextVNode)(". ")
                ], 2),
                (0, $TusQn.createElementVNode)("table", $2acb681a56451e2c$var$_hoisted_5, [
                    (0, $TusQn.createElementVNode)("thead", null, [
                        (0, $TusQn.createElementVNode)("tr", null, [
                            (0, $TusQn.createElementVNode)("th", $2acb681a56451e2c$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("modelings")), 1)
                        ]),
                        (0, $TusQn.createElementVNode)("tr", null, [
                            (0, $TusQn.createElementVNode)("td", $2acb681a56451e2c$var$_hoisted_7, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    class: "form-control",
                                    style: {
                                        "border": "none"
                                    },
                                    placeholder: _ctx.$t("filterByName"),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.filterInput = $event),
                                    type: "search"
                                }, null, 8, $2acb681a56451e2c$var$_hoisted_8), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        $data.filterInput
                                    ]
                                ])
                            ])
                        ])
                    ]),
                    $options.listOfModelings.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $2acb681a56451e2c$var$_hoisted_9, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.listOfModelings, (item, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                key: i
                            }, [
                                (0, $TusQn.createElementVNode)("td", null, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: {
                                            name: "modeling",
                                            params: {
                                                id: item.id
                                            }
                                        }
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "to"
                                    ])
                                ])
                            ]);
                        }), 128))
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $2acb681a56451e2c$var$_hoisted_10, [
                        (0, $TusQn.createElementVNode)("tr", null, (0, $8POXm.toDisplayString)(_ctx.$t("noAssignedModeling")), 1)
                    ]))
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $2acb681a56451e2c$var$_hoisted_11, [
                $data.loginInfo.userrole == "Admin" && $data.loginInfo.isAuthenticated ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2acb681a56451e2c$var$_hoisted_12, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "settings/modelings",
                        class: "btn btn-secondary"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("settings")), 1)
                            ]),
                        _: 1
                    })
                ])) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.createElementVNode)("div", $2acb681a56451e2c$var$_hoisted_13, [
                    (0, $TusQn.createElementVNode)("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[1] || (_cache[1] = ($event)=>$options.changeUser()),
                        style: {
                            "float": "right",
                            "margin-right": "20px"
                        }
                    }, (0, $8POXm.toDisplayString)(_ctx.$t("logout")), 1)
                ])
            ])
        ])
    ]);
}

});

parcelRegister("79szO", function(module, exports) {

$parcel$export(module.exports, "default", () => $534f8a62329cc7b1$export$2e2bcd8739ae039);
let $534f8a62329cc7b1$var$NOOP = ()=>{};
var $534f8a62329cc7b1$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("bOqrG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8998e0c5172ec273$export$2e2bcd8739ae039);

var $926P8 = parcelRequire("926P8");
var $8998e0c5172ec273$export$2e2bcd8739ae039 = {
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.list = await (0, $926P8.default).list();
        },
        checkIfActive (name) {
            var self = this;
            if (self.$route.name == name) return "active";
        }
    },
    data () {
        return {
            list: []
        };
    }
};

});
parcelRegister("926P8", function(module, exports) {

$parcel$export(module.exports, "default", () => $69399804cb140698$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $69399804cb140698$var$UserApi = {
    list: async ()=>{
        const req = (0, $f5Koy.default).get(`/api/user`);
        const res = await req;
        return res.body;
    },
    detail: async (user)=>{
        const req = (0, $f5Koy.default).get(`/api/user/${user}`);
        const res = await req;
        return res.body;
    },
    setPassword: async (id, password)=>{
        const req = (0, $f5Koy.default).put(`/api/user/${id}/resetpassword`).send(password);
        const res = await req;
        return res.body;
    },
    update: async (user)=>{
        const req = (0, $f5Koy.default).put(`/api/user/${user.id}`).send(user);
        const res = await req;
        return res.body;
    },
    create: async (user)=>{
        const req = (0, $f5Koy.default).post(`/api/user`).send(user);
        const res = await req;
        return res.body;
    },
    delete: async (userId)=>{
        const req = (0, $f5Koy.default).delete(`/api/user/${userId}`);
        await req;
    },
    createLog: async (audit)=>{
        const req = (0, $f5Koy.default).post(`/api/user/log`).send(audit);
        const res = await req;
        return res.body;
    }
};
var $69399804cb140698$export$2e2bcd8739ae039 = $69399804cb140698$var$UserApi;

});


parcelRegister("TuEYg", function(module, exports) {

$parcel$export(module.exports, "render", () => $0a6ceb921a8d6ef0$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $0a6ceb921a8d6ef0$var$_hoisted_1 = {
    class: "container py-5"
};
const $0a6ceb921a8d6ef0$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $0a6ceb921a8d6ef0$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $0a6ceb921a8d6ef0$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $0a6ceb921a8d6ef0$var$_hoisted_5 = {
    key: 0,
    class: "breadcrumb-item"
};
const $0a6ceb921a8d6ef0$var$_hoisted_6 = {
    key: 1,
    class: "breadcrumb-item"
};
const $0a6ceb921a8d6ef0$var$_hoisted_7 = {
    key: 2,
    class: "breadcrumb-item"
};
const $0a6ceb921a8d6ef0$var$_hoisted_8 = {
    class: "row"
};
const $0a6ceb921a8d6ef0$var$_hoisted_9 = {
    class: "col-3"
};
const $0a6ceb921a8d6ef0$var$_hoisted_10 = {
    class: "nav flex-column nav-pills",
    id: "v-pills-tab",
    role: "tablist",
    "aria-orientation": "vertical"
};
const $0a6ceb921a8d6ef0$var$_hoisted_11 = {
    class: "col-9"
};
const $0a6ceb921a8d6ef0$var$_hoisted_12 = {
    class: "tab-content",
    id: "v-pills-tabContent"
};
function $0a6ceb921a8d6ef0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_router_view = (0, $TusQn.resolveComponent)("router-view");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0a6ceb921a8d6ef0$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("settings")), 1),
        (0, $TusQn.createElementVNode)("nav", $0a6ceb921a8d6ef0$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $0a6ceb921a8d6ef0$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $0a6ceb921a8d6ef0$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                this.$route.name === "modelings" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $0a6ceb921a8d6ef0$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("modelings")), 1)) : this.$route.name === "users" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $0a6ceb921a8d6ef0$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("users")), 1)) : this.$route.name === "groups" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $0a6ceb921a8d6ef0$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1)) : (0, $TusQn.createCommentVNode)("", true)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $0a6ceb921a8d6ef0$var$_hoisted_8, [
            (0, $TusQn.createElementVNode)("div", $0a6ceb921a8d6ef0$var$_hoisted_9, [
                (0, $TusQn.createElementVNode)("div", $0a6ceb921a8d6ef0$var$_hoisted_10, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/modelings",
                        class: (0, $8POXm.normalizeClass)([
                            "nav-link",
                            this.checkIfActive("modelings")
                        ]),
                        id: "modelings",
                        "data-toggle": "pill",
                        role: "tab",
                        href: "#modelings",
                        "aria-controls": "modelings",
                        "aria-selected": "false"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "class"
                    ]),
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/users",
                        id: "users",
                        "data-toggle": "pill",
                        role: "tab",
                        "aria-selected": "true",
                        href: "#users",
                        class: (0, $8POXm.normalizeClass)([
                            "nav-link",
                            this.checkIfActive("users")
                        ])
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("users")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "class"
                    ]),
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/groups",
                        class: (0, $8POXm.normalizeClass)([
                            "nav-link",
                            this.checkIfActive("groups")
                        ]),
                        id: "groups",
                        "data-toggle": "pill",
                        role: "tab",
                        "aria-controls": "groups",
                        "aria-selected": "false"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "class"
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $0a6ceb921a8d6ef0$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("div", $0a6ceb921a8d6ef0$var$_hoisted_12, [
                    (0, $TusQn.createVNode)(_component_router_view)
                ])
            ])
        ])
    ]);
}

});

parcelRegister("4SCIc", function(module, exports) {

$parcel$export(module.exports, "default", () => $38da3bec98346d9f$export$2e2bcd8739ae039);
let $38da3bec98346d9f$var$NOOP = ()=>{};
var $38da3bec98346d9f$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("hPYqr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cfc61254b46b7d22$export$2e2bcd8739ae039);

var $45fvw = parcelRequire("45fvw");

var $l6otV = parcelRequire("l6otV");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $8i3Lm = parcelRequire("8i3Lm");

var $fmQKt = parcelRequire("fmQKt");

var $gxt0C = parcelRequire("gxt0C");

var $gOjKo = parcelRequire("gOjKo");
var $cfc61254b46b7d22$export$2e2bcd8739ae039 = {
    name: "modelingdetail",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        exportJson () {
            var request = (0, $l6otV.default).modelingExport(this.$route.params.id);
            window.open(request.url);
        },
        confirm () {
            this.requestData();
            this.showSuccessUpload();
            this.showImportModal = false;
        },
        async exportResults (item) {
            var request = (0, $gxt0C.default).exportXlsx(this.$route.params.id, item.id);
            window.open(request.url);
        },
        getCreatedDate (date) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format("DD.MM.YYYY HH:mm");
        },
        async deleteDataset (dataset) {
            await (0, $ch9iu.default).datasetDelete(this.$route.params.id, dataset.id);
        },
        filteredAssetTypes (assetTypeList, datasetId) {
            return assetTypeList.filter((a)=>a.datasetId == datasetId);
        },
        filteredSelectionList (selectionList, forecastId) {
            return selectionList.filter((a)=>a.forecastId == forecastId);
        },
        async requestData () {
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            this.data = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.datasetList = await (0, $ch9iu.default).datasetList(this.$route.params.id);
            this.assetTypeList = await (0, $eHCxc.default).assetTypeList(this.$route.params.id);
            this.forecastList = await (0, $8i3Lm.default).forecastList(this.$route.params.id);
            this.selectionList = await (0, $fmQKt.default).selectionList(this.$route.params.id);
            await this.loadAnalysisList();
            const hasRunning = this.analysisList.some((x)=>x.state === 0 || x.state === 201);
            if (hasRunning) this.startPollingAnalysis();
            this.pending = false;
        },
        async loadAnalysisList () {
            this.analysisList = await (0, $gxt0C.default).analysisList(this.$route.params.id, "");
            const hasRunning = this.analysisList.some((x)=>x.state === 0 || x.state === 201);
            if (!hasRunning && this.pollingHandle) {
                clearInterval(this.pollingHandle);
                this.pollingHandle = null;
            }
        },
        startPollingAnalysis () {
            if (this.pollingHandle) return;
            this.pollingHandle = setInterval(()=>{
                this.loadAnalysisList();
            }, 3000);
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "modelingUpdated",
            type: "success"
        },
        showSuccessUpload: {
            title: "success",
            message: "importSuccess",
            type: "success"
        }
    },
    beforeUnmount () {
        if (this.pollingHandle) clearInterval(this.pollingHandle);
    },
    data () {
        return {
            data: {
                name: "",
                id: 0
            },
            datasetList: [],
            assetTypeList: [],
            forecastList: [],
            selectionList: [],
            analysisList: [],
            showImportModal: false,
            pending: true,
            isUserAdmin: false,
            pollingHandle: null
        };
    }
};

});
parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("ch9iu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8efe48d10bc91bde$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $8efe48d10bc91bde$var$datasetApi = {
    datasetList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/dataset`);
        const res = await req;
        return res.body;
    },
    datasetDetail: async (modelingId, dataset)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/dataset/${dataset}`);
        const res = await req;
        return res.body;
    },
    datasetSections: async (modelingId, dataset)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/dataset/${dataset}/sections`);
        const res = await req;
        return res.body;
    },
    datasetUpdate: async (modelingId, dataset)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/dataset/${dataset.id}`).send(dataset);
        const res = await req;
        return res.body;
    },
    datasetUpload: async (modelingId, datasetId, files)=>{
        const req = (0, $f5Koy.default).postMultipart(`/api/modeling/${modelingId}/dataset/upload/${datasetId}`);
        for (const file of files)req.attach("files", file);
        const res = await req;
        return res.body;
    },
    datasetXlsxUpload: async (modelingId, datasetId, files)=>{
        const req = (0, $f5Koy.default).postMultipart(`/api/modeling/${modelingId}/dataset/upload/${datasetId}/xlsx`);
        for (const file of files)req.attach("files", file);
        const res = await req;
        return res.body;
    },
    datasetZipDownload: (modelingId, datasetId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/dataset/download/${datasetId}/datasetzip`);
        return req;
    },
    datasetCreate: async (modelingId, dataset)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/dataset`).send(dataset);
        const res = await req;
        return res.body;
    },
    datasetDelete: async (modelingId, datasetId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/dataset/${datasetId}`);
        await req;
    }
};
var $8efe48d10bc91bde$export$2e2bcd8739ae039 = $8efe48d10bc91bde$var$datasetApi;

});

parcelRegister("eHCxc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab42f8ff0ba2e995$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $ab42f8ff0ba2e995$var$assetTypeApi = {
    assetTypeList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/assetType`);
        const res = await req;
        return res.body;
    },
    assetTypeDetail: async (modelingId, assetType)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/assetType/${assetType}`);
        const res = await req;
        return res.body;
    },
    assetTypeUpdate: async (modelingId, assetType)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/assetType/${assetType.id}`).send(assetType);
        const res = await req;
        return res.body;
    },
    assetTypeCreate: async (modelingId, assetType)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/assetType`).send(assetType);
        const res = await req;
        return res.body;
    },
    assetTypeDelete: async (modelingId, assetTypeId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/assetType/${assetTypeId}`);
        await req;
    }
};
var $ab42f8ff0ba2e995$export$2e2bcd8739ae039 = $ab42f8ff0ba2e995$var$assetTypeApi;

});

parcelRegister("8i3Lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6092ec617c9ba6aa$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $6092ec617c9ba6aa$var$forecastApi = {
    forecastList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/forecast`);
        const res = await req;
        return res.body;
    },
    forecastDetail: async (modelingId, forecast)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/forecast/${forecast}`);
        const res = await req;
        return res.body;
    },
    forecastUpdate: async (modelingId, forecast)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/forecast/${forecast.id}`).send(forecast);
        const res = await req;
        return res.body;
    },
    forecastCreate: async (modelingId, forecast)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/forecast`).send(forecast);
        const res = await req;
        return res.body;
    },
    forecastDelete: async (modelingId, forecastId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/forecast/${forecastId}`);
        await req;
    },
    forecastCopy: async (modelingId, forecastId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/forecast/${forecastId}/copy`);
        const res = await req;
        return res.body;
    }
};
var $6092ec617c9ba6aa$export$2e2bcd8739ae039 = $6092ec617c9ba6aa$var$forecastApi;

});

parcelRegister("fmQKt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b301d3df1b8d3e6d$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $b301d3df1b8d3e6d$var$selectionApi = {
    selectionList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/selection`);
        const res = await req;
        return res.body;
    },
    selectionDetail: async (modelingId, selection)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/selection/${selection}`);
        const res = await req;
        return res.body;
    },
    selectionUpdate: async (modelingId, selection)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/selection/${selection.id}`).send(selection);
        const res = await req;
        return res.body;
    },
    selectionCreate: async (modelingId, selection)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/selection`).send(selection);
        const res = await req;
        return res.body;
    },
    selectionDelete: async (modelingId, selectionId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/selection/${selectionId}`);
        await req;
    }
};
var $b301d3df1b8d3e6d$export$2e2bcd8739ae039 = $b301d3df1b8d3e6d$var$selectionApi;

});

parcelRegister("gxt0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a63b0271d00342$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $c0a63b0271d00342$var$analysisApi = {
    analysisList: async (modelingId, query = "")=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/modeling-result/${modelingId}${query}`);
        const res = await req;
        return res.body;
    },
    analysisDetail: async (modelingId, resultId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/modeling-result/${modelingId}/${resultId}`);
        const res = await req;
        return res.body;
    },
    analysisDelete: async (modelingId, resultId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/modeling-result/${modelingId}/${resultId}`);
        await req;
    },
    analyseSelection: async (modelingId, selectionId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results-run/${modelingId}/${selectionId}`);
        const res = await req;
        return res.body;
    },
    validateSelection: async (modelingId, selectionId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/validate-selection/${modelingId}/${selectionId}`);
        const res = await req;
        return res.body;
    },
    exportXlsx: (modelingId, resultId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/xlsx`);
        return req;
    },
    exportLimitXlsx: (modelingId, resultId, limitId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/${limitId}/xlsx`);
        return req;
    },
    exportResultsCsv: (modelingId, resultId, limitId, query)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/${limitId}/results/csv${query}`);
        return req;
    },
    exportConditionsCsv: (modelingId, resultId, limitId, query)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/${limitId}/conditions/csv${query}`);
        return req;
    },
    exportSpendingCsv: (modelingId, resultId, limitId, query)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/${limitId}/spending/csv${query}`);
        return req;
    },
    exportParameterAndKpiCsv: (modelingId, resultId, limitId, query)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/${limitId}/parameterkpi/csv${query}`);
        return req;
    },
    exportActivityPlanCsv: (modelingId, resultId, query)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/activity-plan/csv${query}`);
        return req;
    },
    exportActivityPlanShp: (modelingId, resultId, query)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/activity-plan/shp${query}`);
        return req;
    },
    weightedGraphCharts: async (modelingId, resultId, limitId, query)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/weighted-graph${query}`);
        const res = await req;
        return res.body;
    },
    activityGraphCharts: async (modelingId, resultId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/activity-graph`);
        const res = await req;
        return res.body;
    },
    activityPlanData: async (modelingId, resultId, query)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/activity-plan${query}`);
        const res = await req;
        return res.body;
    },
    activityPlanSections: async (modelingId, resultId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/activity-plan/sections`);
        const res = await req;
        return res.body;
    },
    distributionCharts: async (modelingId, resultId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/distribution-graph`);
        const res = await req;
        return res.body;
    },
    sumarizedCostGraph: async (modelingId, resultId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/analysis-results/${modelingId}/${resultId}/sumarized-cost-graph`);
        const res = await req;
        return res.body;
    }
};
var $c0a63b0271d00342$export$2e2bcd8739ae039 = $c0a63b0271d00342$var$analysisApi;

});


parcelRegister("2f3ob", function(module, exports) {

$parcel$export(module.exports, "render", () => $1a1f9c766df3cda7$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $1a1f9c766df3cda7$var$_hoisted_1 = {
    class: "container py-5"
};
const $1a1f9c766df3cda7$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $1a1f9c766df3cda7$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $1a1f9c766df3cda7$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $1a1f9c766df3cda7$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $1a1f9c766df3cda7$var$_hoisted_6 = {
    key: 0
};
const $1a1f9c766df3cda7$var$_hoisted_7 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $1a1f9c766df3cda7$var$_hoisted_8 = [
    $1a1f9c766df3cda7$var$_hoisted_7
];
const $1a1f9c766df3cda7$var$_hoisted_9 = {
    key: 1
};
const $1a1f9c766df3cda7$var$_hoisted_10 = {
    class: "text-center mb-4"
};
const $1a1f9c766df3cda7$var$_hoisted_11 = {
    key: 0,
    class: "dropdown float-end"
};
const $1a1f9c766df3cda7$var$_hoisted_12 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("button", {
    class: "btn btn-secondary",
    type: "button",
    id: "dropdownMenu2",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
        class: "fa-solid fa-gear"
    })
], -1);
const $1a1f9c766df3cda7$var$_hoisted_13 = {
    class: "dropdown-menu",
    "aria-labelledby": "dropdownMenu2"
};
const $1a1f9c766df3cda7$var$_hoisted_14 = {
    class: "dropdown-item",
    type: "button"
};
const $1a1f9c766df3cda7$var$_hoisted_15 = {
    class: "row mb-4"
};
const $1a1f9c766df3cda7$var$_hoisted_16 = {
    class: "card text-center"
};
const $1a1f9c766df3cda7$var$_hoisted_17 = {
    class: "card-body"
};
const $1a1f9c766df3cda7$var$_hoisted_18 = {
    class: "card-title"
};
const $1a1f9c766df3cda7$var$_hoisted_19 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $1a1f9c766df3cda7$var$_hoisted_20 = {
    key: 1,
    class: "card-body"
};
const $1a1f9c766df3cda7$var$_hoisted_21 = {
    class: "btn btn-sm btn-light"
};
const $1a1f9c766df3cda7$var$_hoisted_22 = {
    key: 0,
    class: "col-sm-3"
};
const $1a1f9c766df3cda7$var$_hoisted_23 = {
    class: "card text-center"
};
const $1a1f9c766df3cda7$var$_hoisted_24 = {
    class: "card-body"
};
const $1a1f9c766df3cda7$var$_hoisted_25 = {
    class: "list-group list-group-flush"
};
const $1a1f9c766df3cda7$var$_hoisted_26 = {
    class: "list-group-item"
};
const $1a1f9c766df3cda7$var$_hoisted_27 = {
    class: "btn btn-sm btn-light"
};
const $1a1f9c766df3cda7$var$_hoisted_28 = {
    class: "text-center mb-4"
};
const $1a1f9c766df3cda7$var$_hoisted_29 = {
    class: "row mb-4"
};
const $1a1f9c766df3cda7$var$_hoisted_30 = {
    class: "card text-center"
};
const $1a1f9c766df3cda7$var$_hoisted_31 = {
    class: "card-body"
};
const $1a1f9c766df3cda7$var$_hoisted_32 = {
    class: "card-title"
};
const $1a1f9c766df3cda7$var$_hoisted_33 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $1a1f9c766df3cda7$var$_hoisted_34 = {
    key: 1,
    class: "card-body"
};
const $1a1f9c766df3cda7$var$_hoisted_35 = {
    class: "btn btn-sm btn-light"
};
const $1a1f9c766df3cda7$var$_hoisted_36 = {
    key: 0,
    class: "col-sm-3"
};
const $1a1f9c766df3cda7$var$_hoisted_37 = {
    class: "card text-center"
};
const $1a1f9c766df3cda7$var$_hoisted_38 = {
    class: "card-body"
};
const $1a1f9c766df3cda7$var$_hoisted_39 = {
    class: "list-group list-group-flush"
};
const $1a1f9c766df3cda7$var$_hoisted_40 = {
    class: "list-group-item"
};
const $1a1f9c766df3cda7$var$_hoisted_41 = {
    class: "btn btn-sm btn-light"
};
const $1a1f9c766df3cda7$var$_hoisted_42 = {
    class: "text-center mb-4"
};
const $1a1f9c766df3cda7$var$_hoisted_43 = {
    class: "table table-bordered",
    style: {
        "border-radius": "5px"
    }
};
const $1a1f9c766df3cda7$var$_hoisted_44 = {
    scope: "col"
};
const $1a1f9c766df3cda7$var$_hoisted_45 = {
    scope: "col"
};
const $1a1f9c766df3cda7$var$_hoisted_46 = {
    scope: "col"
};
const $1a1f9c766df3cda7$var$_hoisted_47 = {
    scope: "col"
};
const $1a1f9c766df3cda7$var$_hoisted_48 = {
    scope: "col"
};
const $1a1f9c766df3cda7$var$_hoisted_49 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $1a1f9c766df3cda7$var$_hoisted_50 = {
    class: "text-center"
};
const $1a1f9c766df3cda7$var$_hoisted_51 = {
    key: 0,
    class: "spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
};
const $1a1f9c766df3cda7$var$_hoisted_52 = {
    key: 1,
    class: "text-danger"
};
const $1a1f9c766df3cda7$var$_hoisted_53 = {
    class: "btn btn-sm btn-light"
};
function $1a1f9c766df3cda7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1a1f9c766df3cda7$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("modelingDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $1a1f9c766df3cda7$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $1a1f9c766df3cda7$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $1a1f9c766df3cda7$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $1a1f9c766df3cda7$var$_hoisted_5, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1a1f9c766df3cda7$var$_hoisted_6, $1a1f9c766df3cda7$var$_hoisted_8)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1a1f9c766df3cda7$var$_hoisted_9, [
            (0, $TusQn.createElementVNode)("h3", $1a1f9c766df3cda7$var$_hoisted_10, [
                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("inputModel")) + " ", 1),
                $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1a1f9c766df3cda7$var$_hoisted_11, [
                    $1a1f9c766df3cda7$var$_hoisted_12,
                    (0, $TusQn.createElementVNode)("ul", $1a1f9c766df3cda7$var$_hoisted_13, [
                        (0, $TusQn.createElementVNode)("li", null, [
                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                style: {
                                    "color": "black",
                                    "text-decoration": "unset"
                                },
                                to: "/modeling/" + this.$route.params.id + "/import"
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createElementVNode)("button", $1a1f9c766df3cda7$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("import")), 1)
                                    ]),
                                _: 1
                            }, 8, [
                                "to"
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("li", null, [
                            (0, $TusQn.createElementVNode)("button", {
                                class: "dropdown-item",
                                type: "button",
                                onClick: _cache[0] || (_cache[0] = ($event)=>$options.exportJson())
                            }, (0, $8POXm.toDisplayString)(_ctx.$t("export")), 1)
                        ])
                    ])
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ]),
            (0, $TusQn.createElementVNode)("div", $1a1f9c766df3cda7$var$_hoisted_15, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.datasetList, (item, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        class: "col-sm-3 mb-4",
                        key: i
                    }, [
                        (0, $TusQn.createElementVNode)("div", $1a1f9c766df3cda7$var$_hoisted_16, [
                            (0, $TusQn.createElementVNode)("div", $1a1f9c766df3cda7$var$_hoisted_17, [
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    style: {
                                        "color": "black"
                                    },
                                    to: "/modeling/" + this.$route.params.id + "/dataset/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createElementVNode)("h5", $1a1f9c766df3cda7$var$_hoisted_18, (0, $8POXm.toDisplayString)(item.name), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ])
                            ]),
                            $data.assetTypeList.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $1a1f9c766df3cda7$var$_hoisted_19, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.filteredAssetTypes($data.assetTypeList, item.id), (item, i)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                        class: "list-group-item",
                                        key: i
                                    }, [
                                        (0, $TusQn.createVNode)(_component_RouterLink, {
                                            to: "/modeling/" + $data.data.id + "/assettype/" + item.id
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "to"
                                        ])
                                    ]);
                                }), 128))
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1a1f9c766df3cda7$var$_hoisted_20, [
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    to: "/modeling/" + $data.data.id + "/assettypecreate/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createElementVNode)("button", $1a1f9c766df3cda7$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("addAssetType")), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ])
                            ])) : (0, $TusQn.createCommentVNode)("", true)
                        ])
                    ]);
                }), 128)),
                $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1a1f9c766df3cda7$var$_hoisted_22, [
                    (0, $TusQn.createElementVNode)("div", $1a1f9c766df3cda7$var$_hoisted_23, [
                        (0, $TusQn.createElementVNode)("div", $1a1f9c766df3cda7$var$_hoisted_24, [
                            (0, $TusQn.createElementVNode)("ul", $1a1f9c766df3cda7$var$_hoisted_25, [
                                (0, $TusQn.createElementVNode)("li", $1a1f9c766df3cda7$var$_hoisted_26, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: "/modeling/" + $data.data.id + "/datasetcreate"
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createElementVNode)("button", $1a1f9c766df3cda7$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("addDataset")), 1)
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "to"
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ]),
            (0, $TusQn.createElementVNode)("h3", $1a1f9c766df3cda7$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("analysisSelection")), 1),
            (0, $TusQn.createElementVNode)("div", $1a1f9c766df3cda7$var$_hoisted_29, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.forecastList, (item, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        class: "col-sm-3 mb-4",
                        key: i
                    }, [
                        (0, $TusQn.createElementVNode)("div", $1a1f9c766df3cda7$var$_hoisted_30, [
                            (0, $TusQn.createElementVNode)("div", $1a1f9c766df3cda7$var$_hoisted_31, [
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    style: {
                                        "color": "black"
                                    },
                                    to: "/modeling/" + this.$route.params.id + "/forecast/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createElementVNode)("h5", $1a1f9c766df3cda7$var$_hoisted_32, (0, $8POXm.toDisplayString)(item.name), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ])
                            ]),
                            $data.selectionList.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $1a1f9c766df3cda7$var$_hoisted_33, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.filteredSelectionList($data.selectionList, item.id), (item, i)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                        class: "list-group-item",
                                        key: i
                                    }, [
                                        (0, $TusQn.createVNode)(_component_RouterLink, {
                                            to: "/modeling/" + $data.data.id + "/selection/" + item.id
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "to"
                                        ])
                                    ]);
                                }), 128))
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1a1f9c766df3cda7$var$_hoisted_34, [
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    to: "/modeling/" + $data.data.id + "/selectioncreate/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createElementVNode)("button", $1a1f9c766df3cda7$var$_hoisted_35, (0, $8POXm.toDisplayString)(_ctx.$t("addSelection")), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ])
                            ])) : (0, $TusQn.createCommentVNode)("", true)
                        ])
                    ]);
                }), 128)),
                $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1a1f9c766df3cda7$var$_hoisted_36, [
                    (0, $TusQn.createElementVNode)("div", $1a1f9c766df3cda7$var$_hoisted_37, [
                        (0, $TusQn.createElementVNode)("div", $1a1f9c766df3cda7$var$_hoisted_38, [
                            (0, $TusQn.createElementVNode)("ul", $1a1f9c766df3cda7$var$_hoisted_39, [
                                (0, $TusQn.createElementVNode)("li", $1a1f9c766df3cda7$var$_hoisted_40, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: "/modeling/" + $data.data.id + "/forecastcreate"
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createElementVNode)("button", $1a1f9c766df3cda7$var$_hoisted_41, (0, $8POXm.toDisplayString)(_ctx.$t("addForecast")), 1)
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "to"
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ]),
            (0, $TusQn.createElementVNode)("h3", $1a1f9c766df3cda7$var$_hoisted_42, (0, $8POXm.toDisplayString)(_ctx.$t("results")), 1),
            (0, $TusQn.createElementVNode)("table", $1a1f9c766df3cda7$var$_hoisted_43, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        (0, $TusQn.createElementVNode)("th", $1a1f9c766df3cda7$var$_hoisted_44, (0, $8POXm.toDisplayString)(_ctx.$t("forecastName")), 1),
                        (0, $TusQn.createElementVNode)("th", $1a1f9c766df3cda7$var$_hoisted_45, (0, $8POXm.toDisplayString)(_ctx.$t("selectionName")), 1),
                        (0, $TusQn.createElementVNode)("th", $1a1f9c766df3cda7$var$_hoisted_46, (0, $8POXm.toDisplayString)(_ctx.$t("selectionStartYear")), 1),
                        (0, $TusQn.createElementVNode)("th", $1a1f9c766df3cda7$var$_hoisted_47, (0, $8POXm.toDisplayString)(_ctx.$t("selectionEndYear")), 1),
                        (0, $TusQn.createElementVNode)("th", $1a1f9c766df3cda7$var$_hoisted_48, (0, $8POXm.toDisplayString)(_ctx.$t("createdDate")), 1),
                        $1a1f9c766df3cda7$var$_hoisted_49
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.analysisList, (item, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            key: i,
                            class: "align-middle"
                        }, [
                            (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(item.forecastName), 1),
                            (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(item.selectionName), 1),
                            (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(item.selectionStartYear), 1),
                            (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(item.selectionEndYear), 1),
                            (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(this.getCreatedDate(item.createdDate)), 1),
                            (0, $TusQn.createElementVNode)("td", $1a1f9c766df3cda7$var$_hoisted_50, [
                                item.state === 0 || item.state === 201 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $1a1f9c766df3cda7$var$_hoisted_51)) : item.state === 500 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $1a1f9c766df3cda7$var$_hoisted_52, (0, $8POXm.toDisplayString)(_ctx.$t("resultFailed")), 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_RouterLink, {
                                    key: 2,
                                    to: "/modeling/" + _ctx.$route.params.id + "/modelingresult/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createElementVNode)("button", $1a1f9c766df3cda7$var$_hoisted_53, (0, $8POXm.toDisplayString)(_ctx.$t("detail")), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ]))
                            ])
                        ]);
                    }), 128))
                ])
            ])
        ]))
    ]);
}

});

parcelRegister("6gWsL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4911963ad2f04710$export$2e2bcd8739ae039);
let $4911963ad2f04710$var$NOOP = ()=>{};
var $4911963ad2f04710$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("1xUz0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1204bfe162e9089a$export$2e2bcd8739ae039);

var $l6otV = parcelRequire("l6otV");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $8i3Lm = parcelRequire("8i3Lm");

var $fmQKt = parcelRequire("fmQKt");

var $gxt0C = parcelRequire("gxt0C");
var $1204bfe162e9089a$export$2e2bcd8739ae039 = {
    name: "modelingimport",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        isSelectionDisabled (selection) {
            var foundForecast = this.importForecastList.find((f)=>f.checked && "-" + f.number == selection.forecast);
            return foundForecast != null;
        },
        async requestData () {
            this.data = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.datasetList = await (0, $ch9iu.default).datasetList(this.$route.params.id);
            this.assetTypeList = await (0, $eHCxc.default).assetTypeList(this.$route.params.id);
            this.forecastList = await (0, $8i3Lm.default).forecastList(this.$route.params.id);
            this.selectionList = await (0, $fmQKt.default).selectionList(this.$route.params.id);
            this.analysisList = await (0, $gxt0C.default).analysisList(this.$route.params.id);
            this.pending = false;
        },
        onFileChanged (event) {
            const file = event.target.files[0];
            if (file && file.type === "application/json") {
                const reader = new FileReader();
                reader.onload = (e)=>{
                    try {
                        var fileContent = JSON.parse(e.target.result);
                        if (fileContent.assetTypes) for(var i in fileContent.assetTypes){
                            var assetType = fileContent.assetTypes[i];
                            assetType.checked = false;
                            this.importAssetTypes.push(assetType);
                        }
                        if (fileContent.datasets) this.importDatasetList = fileContent.datasets;
                        if (fileContent.selections) for(var i in fileContent.selections){
                            var selection = fileContent.selections[i];
                            selection.checked = false;
                            this.importSelections.push(selection);
                        }
                        if (fileContent.forecasts) for(var i in fileContent.forecasts){
                            var forecast = fileContent.forecasts[i];
                            forecast.checked = false;
                            this.importForecastList.push(forecast);
                        }
                    } catch (error) {
                        console.error("Error parsing JSON:", error);
                    }
                };
                reader.readAsText(file);
            } else console.error("Please select a valid JSON file.");
        },
        async confirm () {
            var canUpload = true;
            var data = {
                datasets: this.importDatasetList,
                assetTypes: this.importAssetTypes.filter((c)=>c.checked),
                forecasts: this.importForecastList.filter((c)=>c.checked),
                selections: this.importSelections.filter((c)=>c.checked)
            };
            for(var i in data.forecasts){
                var forecast = data.forecasts[i];
                for(var o in forecast.forecastLifeCycles){
                    var lifeCycle = forecast.forecastLifeCycles[o];
                    if (data.assetTypes.find((a)=>a.number == lifeCycle.assetType) == null) canUpload = false;
                }
            }
            if (canUpload) {
                await (0, $l6otV.default).importJson(this.$route.params.id, data);
                this.$router.go(-1);
            } else this.showError();
        }
    },
    notifications: {
        showError: {
            title: "error",
            message: "importError",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0
            },
            datasetList: [],
            assetTypeList: [],
            forecastList: [],
            selectionList: [],
            analysisList: [],
            importAssetTypes: [],
            importDatasetList: [],
            importSelections: [],
            importForecastList: [],
            showImportModal: false,
            pending: true
        };
    }
};

});

parcelRegister("iWfCP", function(module, exports) {

$parcel$export(module.exports, "render", () => $dc99c3a2c3d0a400$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $dc99c3a2c3d0a400$var$_hoisted_1 = {
    class: "container py-5"
};
const $dc99c3a2c3d0a400$var$_hoisted_2 = {
    key: 0,
    class: "container mt-4"
};
const $dc99c3a2c3d0a400$var$_hoisted_3 = {
    class: "row"
};
const $dc99c3a2c3d0a400$var$_hoisted_4 = {
    class: "col-md-6"
};
const $dc99c3a2c3d0a400$var$_hoisted_5 = {
    class: "form-label"
};
const $dc99c3a2c3d0a400$var$_hoisted_6 = {
    class: "col-md-6"
};
const $dc99c3a2c3d0a400$var$_hoisted_7 = {
    class: "form-label"
};
const $dc99c3a2c3d0a400$var$_hoisted_8 = {
    class: "col-md-6"
};
const $dc99c3a2c3d0a400$var$_hoisted_9 = {
    class: "input-group mb-3"
};
const $dc99c3a2c3d0a400$var$_hoisted_10 = {
    class: "input-group-text"
};
const $dc99c3a2c3d0a400$var$_hoisted_11 = [
    "onUpdate:modelValue"
];
const $dc99c3a2c3d0a400$var$_hoisted_12 = [
    "onUpdate:modelValue"
];
const $dc99c3a2c3d0a400$var$_hoisted_13 = {
    class: "col-md-6"
};
const $dc99c3a2c3d0a400$var$_hoisted_14 = {
    class: "input-group mb-3"
};
const $dc99c3a2c3d0a400$var$_hoisted_15 = [
    "onUpdate:modelValue"
];
const $dc99c3a2c3d0a400$var$_hoisted_16 = [
    "value"
];
const $dc99c3a2c3d0a400$var$_hoisted_17 = [
    "value"
];
const $dc99c3a2c3d0a400$var$_hoisted_18 = {
    class: "form-label"
};
const $dc99c3a2c3d0a400$var$_hoisted_19 = {
    class: "col-md-6"
};
const $dc99c3a2c3d0a400$var$_hoisted_20 = {
    class: "input-group mb-3"
};
const $dc99c3a2c3d0a400$var$_hoisted_21 = {
    class: "input-group-text"
};
const $dc99c3a2c3d0a400$var$_hoisted_22 = [
    "onUpdate:modelValue"
];
const $dc99c3a2c3d0a400$var$_hoisted_23 = [
    "onUpdate:modelValue"
];
const $dc99c3a2c3d0a400$var$_hoisted_24 = {
    class: "form-label"
};
const $dc99c3a2c3d0a400$var$_hoisted_25 = {
    class: "col-md-6"
};
const $dc99c3a2c3d0a400$var$_hoisted_26 = {
    class: "input-group mb-3"
};
const $dc99c3a2c3d0a400$var$_hoisted_27 = {
    class: "input-group-text"
};
const $dc99c3a2c3d0a400$var$_hoisted_28 = [
    "onUpdate:modelValue",
    "disabled"
];
const $dc99c3a2c3d0a400$var$_hoisted_29 = [
    "onUpdate:modelValue"
];
const $dc99c3a2c3d0a400$var$_hoisted_30 = {
    class: "d-grid gap-2 d-md-flex mt-4"
};
function $dc99c3a2c3d0a400$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $dc99c3a2c3d0a400$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("modelingImport")), 1),
        (0, $TusQn.createElementVNode)("input", {
            type: "file",
            class: "form-control",
            multiple: "true",
            onChange: _cache[0] || (_cache[0] = ($event)=>$options.onFileChanged($event))
        }, null, 32),
        $data.importAssetTypes.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $dc99c3a2c3d0a400$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("label", $dc99c3a2c3d0a400$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("assetTypes")), 1)
                ]),
                (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("label", $dc99c3a2c3d0a400$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("datasets")), 1)
                ])
            ]),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.importAssetTypes, (assetType, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "row",
                    key: i
                }, [
                    (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_8, [
                        (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_9, [
                            (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_10, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    class: "form-check-input mt-0",
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event)=>assetType.checked = $event
                                }, null, 8, $dc99c3a2c3d0a400$var$_hoisted_11), [
                                    [
                                        (0, $eeJ70.vModelCheckbox),
                                        assetType.checked
                                    ]
                                ])
                            ]),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": ($event)=>assetType.name = $event,
                                disabled: ""
                            }, null, 8, $dc99c3a2c3d0a400$var$_hoisted_12), [
                                [
                                    (0, $eeJ70.vModelText),
                                    assetType.name
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_13, [
                        (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_14, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                class: "form-select",
                                "onUpdate:modelValue": ($event)=>assetType.dataset = $event
                            }, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.importDatasetList, (dataset, o)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        value: "-" + dataset.number,
                                        key: o
                                    }, "*" + (0, $8POXm.toDisplayString)(dataset.name), 9, $dc99c3a2c3d0a400$var$_hoisted_16);
                                }), 128)),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.datasetList, (dataset, u)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        value: dataset.id,
                                        key: u
                                    }, "Attach to " + (0, $8POXm.toDisplayString)(dataset.name), 9, $dc99c3a2c3d0a400$var$_hoisted_17);
                                }), 128))
                            ], 8, $dc99c3a2c3d0a400$var$_hoisted_15), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    assetType.dataset
                                ]
                            ])
                        ])
                    ])
                ]);
            }), 128)),
            (0, $TusQn.createElementVNode)("label", $dc99c3a2c3d0a400$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("forecasts")), 1),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.importForecastList, (forecast, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "row",
                    key: i
                }, [
                    (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_19, [
                        (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_20, [
                            (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_21, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    class: "form-check-input mt-0",
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event)=>forecast.checked = $event
                                }, null, 8, $dc99c3a2c3d0a400$var$_hoisted_22), [
                                    [
                                        (0, $eeJ70.vModelCheckbox),
                                        forecast.checked
                                    ]
                                ])
                            ]),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": ($event)=>forecast.name = $event,
                                disabled: ""
                            }, null, 8, $dc99c3a2c3d0a400$var$_hoisted_23), [
                                [
                                    (0, $eeJ70.vModelText),
                                    forecast.name
                                ]
                            ])
                        ])
                    ])
                ]);
            }), 128)),
            (0, $TusQn.createElementVNode)("label", $dc99c3a2c3d0a400$var$_hoisted_24, (0, $8POXm.toDisplayString)(_ctx.$t("selections")), 1),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.importSelections, (selection, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "row",
                    key: i
                }, [
                    (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_25, [
                        (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_26, [
                            (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_27, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    class: "form-check-input mt-0",
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event)=>selection.checked = $event,
                                    disabled: !$options.isSelectionDisabled(selection)
                                }, null, 8, $dc99c3a2c3d0a400$var$_hoisted_28), [
                                    [
                                        (0, $eeJ70.vModelCheckbox),
                                        selection.checked
                                    ]
                                ])
                            ]),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": ($event)=>selection.name = $event,
                                disabled: ""
                            }, null, 8, $dc99c3a2c3d0a400$var$_hoisted_29), [
                                [
                                    (0, $eeJ70.vModelText),
                                    selection.name
                                ]
                            ])
                        ])
                    ])
                ]);
            }), 128))
        ])) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createElementVNode)("div", $dc99c3a2c3d0a400$var$_hoisted_30, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = (...args)=>$options.confirm && $options.confirm(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("upload")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]);
}

});

parcelRegister("hTo1j", function(module, exports) {

$parcel$export(module.exports, "default", () => $d06a34a6beffb71e$export$2e2bcd8739ae039);
let $d06a34a6beffb71e$var$NOOP = ()=>{};
var $d06a34a6beffb71e$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("69ZUf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $47c39a9d47d77fc0$export$2e2bcd8739ae039);

var $moZaO = parcelRequire("moZaO");

var $gxt0C = parcelRequire("gxt0C");

var $gOjKo = parcelRequire("gOjKo");
var $47c39a9d47d77fc0$export$2e2bcd8739ae039 = {
    name: "modelingresultdetail",
    watch: {
        $route: "requestData"
    },
    components: {
        ModelingResultDeleteModal: $moZaO.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        exportResults (limitId, language) {
            var query = "?";
            if (language) query += "ci=" + language;
            var request = (0, $gxt0C.default).exportResultsCsv(this.$route.params.id, this.$route.params.modelingResultId, limitId, query);
            window.open(request.url);
        },
        exportConditions (limitId, language) {
            var query = "?";
            if (language) query += "ci=" + language;
            var request = (0, $gxt0C.default).exportConditionsCsv(this.$route.params.id, this.$route.params.modelingResultId, limitId, query);
            window.open(request.url);
        },
        exportSpending (limitId, language) {
            var query = "?";
            if (language) query += "ci=" + language;
            var request = (0, $gxt0C.default).exportSpendingCsv(this.$route.params.id, this.$route.params.modelingResultId, limitId, query);
            window.open(request.url);
        },
        exportParameterAndKpi (limitId, language) {
            var query = "?";
            if (language) query += "ci=" + language;
            var request = (0, $gxt0C.default).exportParameterAndKpiCsv(this.$route.params.id, this.$route.params.modelingResultId, limitId, query);
            window.open(request.url);
        },
        async requestData () {
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var analysisDetail = await (0, $gxt0C.default).analysisDetail(this.$route.params.id, this.$route.params.modelingResultId);
            if (analysisDetail.modelingInfo && analysisDetail.modelingInfo.selections) {
                this.modelingName = analysisDetail.modelingInfo.name;
                this.selection = analysisDetail.modelingInfo.selections.find((s)=>s.id == analysisDetail.selectionId);
            }
            this.pending = false;
        }
    },
    data () {
        return {
            data: {
                name: ""
            },
            selection: {
                Limits: []
            },
            pending: true,
            showResultDeleteModal: false,
            isUserAdmin: false,
            modelingName: ""
        };
    }
};

});
parcelRegister("moZaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $04356fd24ea46556$export$2e2bcd8739ae039);
let $04356fd24ea46556$var$script;



let $04356fd24ea46556$var$initialize = ()=>{
    $04356fd24ea46556$var$script = (parcelRequire("jLx7R"));
    if ($04356fd24ea46556$var$script.__esModule) $04356fd24ea46556$var$script = $04356fd24ea46556$var$script.default;
    $04356fd24ea46556$var$script.render = (parcelRequire("gyr45")).render;
    (parcelRequire("bzmL4")).default($04356fd24ea46556$var$script);
    $04356fd24ea46556$var$script.__scopeId = "data-v-2a9516";
    $04356fd24ea46556$var$script.__file = "ModelingResultDeleteModal.vue";
};
$04356fd24ea46556$var$initialize();
var $04356fd24ea46556$export$2e2bcd8739ae039 = $04356fd24ea46556$var$script;

});
parcelRegister("jLx7R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e63c1a330f9254e5$export$2e2bcd8739ae039);

var $gxt0C = parcelRequire("gxt0C");
var $e63c1a330f9254e5$export$2e2bcd8739ae039 = {
    name: "ModelingResultDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteResult () {
            await (0, $gxt0C.default).analysisDelete(this.$parent.$route.params.id, this.$parent.$route.params.modelingResultId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("gyr45", function(module, exports) {

$parcel$export(module.exports, "render", () => $c0d4d0d3fb56df02$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $c0d4d0d3fb56df02$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $c0d4d0d3fb56df02$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $c0d4d0d3fb56df02$var$_hoisted_3 = {
    class: "modal-content"
};
const $c0d4d0d3fb56df02$var$_hoisted_4 = {
    class: "modal-header"
};
const $c0d4d0d3fb56df02$var$_hoisted_5 = {
    class: "modal-title"
};
const $c0d4d0d3fb56df02$var$_hoisted_6 = {
    class: "modal-body"
};
const $c0d4d0d3fb56df02$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0"
    }
};
const $c0d4d0d3fb56df02$var$_hoisted_8 = {
    class: "modal-footer"
};
function $c0d4d0d3fb56df02$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $c0d4d0d3fb56df02$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $c0d4d0d3fb56df02$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $c0d4d0d3fb56df02$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $c0d4d0d3fb56df02$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $c0d4d0d3fb56df02$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("resultDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $c0d4d0d3fb56df02$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", $c0d4d0d3fb56df02$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisResult")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $c0d4d0d3fb56df02$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteResult && $options.deleteResult(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("bzmL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $86c49de7fae023aa$export$2e2bcd8739ae039);
let $86c49de7fae023aa$var$NOOP = ()=>{};
var $86c49de7fae023aa$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("alXN7", function(module, exports) {

$parcel$export(module.exports, "render", () => $789a3edcf71ff0c0$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $789a3edcf71ff0c0$var$_hoisted_1 = {
    class: "container py-5"
};
const $789a3edcf71ff0c0$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $789a3edcf71ff0c0$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $789a3edcf71ff0c0$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $789a3edcf71ff0c0$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $789a3edcf71ff0c0$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $789a3edcf71ff0c0$var$_hoisted_7 = {
    key: 0
};
const $789a3edcf71ff0c0$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $789a3edcf71ff0c0$var$_hoisted_9 = [
    $789a3edcf71ff0c0$var$_hoisted_8
];
const $789a3edcf71ff0c0$var$_hoisted_10 = {
    key: 1
};
const $789a3edcf71ff0c0$var$_hoisted_11 = {
    class: "text-center mb-4"
};
const $789a3edcf71ff0c0$var$_hoisted_12 = {
    class: "table table-bordered",
    style: {
        "border-radius": "5px"
    }
};
const $789a3edcf71ff0c0$var$_hoisted_13 = {
    scope: "col"
};
const $789a3edcf71ff0c0$var$_hoisted_14 = {
    scope: "col"
};
const $789a3edcf71ff0c0$var$_hoisted_15 = {
    scope: "col"
};
const $789a3edcf71ff0c0$var$_hoisted_16 = {
    scope: "col"
};
const $789a3edcf71ff0c0$var$_hoisted_17 = {
    scope: "col"
};
const $789a3edcf71ff0c0$var$_hoisted_18 = {
    style: {
        "text-align": "center"
    }
};
const $789a3edcf71ff0c0$var$_hoisted_19 = {
    class: "btn-group",
    role: "group",
    "aria-label": "Button group with nested dropdown"
};
const $789a3edcf71ff0c0$var$_hoisted_20 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_21 = {
    class: "btn-group",
    role: "group"
};
const $789a3edcf71ff0c0$var$_hoisted_22 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("button", {
    id: "btnGroupDrop1",
    type: "button",
    class: "btn btn-primary dropdown-toggle",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
}, null, -1);
const $789a3edcf71ff0c0$var$_hoisted_23 = {
    class: "dropdown-menu",
    "aria-labelledby": "btnGroupDrop1"
};
const $789a3edcf71ff0c0$var$_hoisted_24 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_25 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_26 = {
    style: {
        "text-align": "center"
    }
};
const $789a3edcf71ff0c0$var$_hoisted_27 = {
    class: "btn-group",
    role: "group",
    "aria-label": "Button group with nested dropdown"
};
const $789a3edcf71ff0c0$var$_hoisted_28 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_29 = {
    class: "btn-group",
    role: "group"
};
const $789a3edcf71ff0c0$var$_hoisted_30 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("button", {
    id: "btnGroupDrop1",
    type: "button",
    class: "btn btn-primary dropdown-toggle",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
}, null, -1);
const $789a3edcf71ff0c0$var$_hoisted_31 = {
    class: "dropdown-menu",
    "aria-labelledby": "btnGroupDrop1"
};
const $789a3edcf71ff0c0$var$_hoisted_32 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_33 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_34 = {
    style: {
        "text-align": "center"
    }
};
const $789a3edcf71ff0c0$var$_hoisted_35 = {
    class: "btn-group",
    role: "group",
    "aria-label": "Button group with nested dropdown"
};
const $789a3edcf71ff0c0$var$_hoisted_36 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_37 = {
    class: "btn-group",
    role: "group"
};
const $789a3edcf71ff0c0$var$_hoisted_38 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("button", {
    id: "btnGroupDrop1",
    type: "button",
    class: "btn btn-primary dropdown-toggle",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
}, null, -1);
const $789a3edcf71ff0c0$var$_hoisted_39 = {
    class: "dropdown-menu",
    "aria-labelledby": "btnGroupDrop1"
};
const $789a3edcf71ff0c0$var$_hoisted_40 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_41 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_42 = {
    style: {
        "text-align": "center"
    }
};
const $789a3edcf71ff0c0$var$_hoisted_43 = {
    class: "btn-group",
    role: "group",
    "aria-label": "Button group with nested dropdown"
};
const $789a3edcf71ff0c0$var$_hoisted_44 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_45 = {
    class: "btn-group",
    role: "group"
};
const $789a3edcf71ff0c0$var$_hoisted_46 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("button", {
    id: "btnGroupDrop1",
    type: "button",
    class: "btn btn-primary dropdown-toggle",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
}, null, -1);
const $789a3edcf71ff0c0$var$_hoisted_47 = {
    class: "dropdown-menu",
    "aria-labelledby": "btnGroupDrop1"
};
const $789a3edcf71ff0c0$var$_hoisted_48 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_49 = [
    "onClick"
];
const $789a3edcf71ff0c0$var$_hoisted_50 = {
    key: 0,
    class: "d-grid gap-2 d-md-flex mb-4"
};
const $789a3edcf71ff0c0$var$_hoisted_51 = {
    class: "row"
};
const $789a3edcf71ff0c0$var$_hoisted_52 = {
    class: "text-center mb-4"
};
const $789a3edcf71ff0c0$var$_hoisted_53 = {
    class: "d-grid gap-2 d-md-flex"
};
const $789a3edcf71ff0c0$var$_hoisted_54 = {
    class: "btn btn-sm btn-primary"
};
const $789a3edcf71ff0c0$var$_hoisted_55 = {
    class: "btn btn-sm btn-primary"
};
const $789a3edcf71ff0c0$var$_hoisted_56 = {
    class: "btn btn-sm btn-primary"
};
const $789a3edcf71ff0c0$var$_hoisted_57 = {
    class: "btn btn-sm btn-primary"
};
const $789a3edcf71ff0c0$var$_hoisted_58 = {
    class: "btn btn-sm btn-primary"
};
function $789a3edcf71ff0c0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_ModelingResultDeleteModal = (0, $TusQn.resolveComponent)("ModelingResultDeleteModal");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $789a3edcf71ff0c0$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("modelingResultDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $789a3edcf71ff0c0$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $789a3edcf71ff0c0$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $789a3edcf71ff0c0$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $789a3edcf71ff0c0$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $789a3edcf71ff0c0$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("modelingResult")), 1)
            ])
        ]),
        $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $789a3edcf71ff0c0$var$_hoisted_7, $789a3edcf71ff0c0$var$_hoisted_9)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $789a3edcf71ff0c0$var$_hoisted_10, [
            (0, $TusQn.createElementVNode)("h3", $789a3edcf71ff0c0$var$_hoisted_11, (0, $8POXm.toDisplayString)(_ctx.$t("limits")), 1),
            (0, $TusQn.createElementVNode)("table", $789a3edcf71ff0c0$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        (0, $TusQn.createElementVNode)("th", $789a3edcf71ff0c0$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("limitName")), 1),
                        (0, $TusQn.createElementVNode)("th", $789a3edcf71ff0c0$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("results")), 1),
                        (0, $TusQn.createElementVNode)("th", $789a3edcf71ff0c0$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("conditions")), 1),
                        (0, $TusQn.createElementVNode)("th", $789a3edcf71ff0c0$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("spending")), 1),
                        (0, $TusQn.createElementVNode)("th", $789a3edcf71ff0c0$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("parameterandkpi")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.selection.limits, (item, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            key: i,
                            class: "align-middle"
                        }, [
                            (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(item.name), 1),
                            (0, $TusQn.createElementVNode)("td", $789a3edcf71ff0c0$var$_hoisted_18, [
                                (0, $TusQn.createElementVNode)("div", $789a3edcf71ff0c0$var$_hoisted_19, [
                                    (0, $TusQn.createElementVNode)("button", {
                                        onClick: ($event)=>$options.exportResults(item.id),
                                        class: "btn btn-sm btn-primary"
                                    }, "csv", 8, $789a3edcf71ff0c0$var$_hoisted_20),
                                    (0, $TusQn.createElementVNode)("div", $789a3edcf71ff0c0$var$_hoisted_21, [
                                        $789a3edcf71ff0c0$var$_hoisted_22,
                                        (0, $TusQn.createElementVNode)("ul", $789a3edcf71ff0c0$var$_hoisted_23, [
                                            (0, $TusQn.createElementVNode)("li", null, [
                                                (0, $TusQn.createElementVNode)("a", {
                                                    class: "dropdown-item",
                                                    onClick: ($event)=>$options.exportResults(item.id, "de-AT")
                                                }, "csv - AT", 8, $789a3edcf71ff0c0$var$_hoisted_24)
                                            ]),
                                            (0, $TusQn.createElementVNode)("li", null, [
                                                (0, $TusQn.createElementVNode)("a", {
                                                    class: "dropdown-item",
                                                    onClick: ($event)=>$options.exportResults(item.id, "cs-CZ")
                                                }, "csv - CZ", 8, $789a3edcf71ff0c0$var$_hoisted_25)
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", $789a3edcf71ff0c0$var$_hoisted_26, [
                                (0, $TusQn.createElementVNode)("div", $789a3edcf71ff0c0$var$_hoisted_27, [
                                    (0, $TusQn.createElementVNode)("button", {
                                        onClick: ($event)=>$options.exportConditions(item.id),
                                        class: "btn btn-sm btn-primary"
                                    }, "csv", 8, $789a3edcf71ff0c0$var$_hoisted_28),
                                    (0, $TusQn.createElementVNode)("div", $789a3edcf71ff0c0$var$_hoisted_29, [
                                        $789a3edcf71ff0c0$var$_hoisted_30,
                                        (0, $TusQn.createElementVNode)("ul", $789a3edcf71ff0c0$var$_hoisted_31, [
                                            (0, $TusQn.createElementVNode)("li", null, [
                                                (0, $TusQn.createElementVNode)("a", {
                                                    class: "dropdown-item",
                                                    onClick: ($event)=>$options.exportConditions(item.id, "de-AT")
                                                }, "csv - AT", 8, $789a3edcf71ff0c0$var$_hoisted_32)
                                            ]),
                                            (0, $TusQn.createElementVNode)("li", null, [
                                                (0, $TusQn.createElementVNode)("a", {
                                                    class: "dropdown-item",
                                                    onClick: ($event)=>$options.exportConditions(item.id, "cs-CZ")
                                                }, "csv - CZ", 8, $789a3edcf71ff0c0$var$_hoisted_33)
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", $789a3edcf71ff0c0$var$_hoisted_34, [
                                (0, $TusQn.createElementVNode)("div", $789a3edcf71ff0c0$var$_hoisted_35, [
                                    (0, $TusQn.createElementVNode)("button", {
                                        onClick: ($event)=>$options.exportSpending(item.id),
                                        class: "btn btn-sm btn-primary"
                                    }, "csv", 8, $789a3edcf71ff0c0$var$_hoisted_36),
                                    (0, $TusQn.createElementVNode)("div", $789a3edcf71ff0c0$var$_hoisted_37, [
                                        $789a3edcf71ff0c0$var$_hoisted_38,
                                        (0, $TusQn.createElementVNode)("ul", $789a3edcf71ff0c0$var$_hoisted_39, [
                                            (0, $TusQn.createElementVNode)("li", null, [
                                                (0, $TusQn.createElementVNode)("a", {
                                                    class: "dropdown-item",
                                                    onClick: ($event)=>$options.exportSpending(item.id, "de-AT")
                                                }, "csv - AT", 8, $789a3edcf71ff0c0$var$_hoisted_40)
                                            ]),
                                            (0, $TusQn.createElementVNode)("li", null, [
                                                (0, $TusQn.createElementVNode)("a", {
                                                    class: "dropdown-item",
                                                    onClick: ($event)=>$options.exportSpending(item.id, "cs-CZ")
                                                }, "csv - CZ", 8, $789a3edcf71ff0c0$var$_hoisted_41)
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", $789a3edcf71ff0c0$var$_hoisted_42, [
                                (0, $TusQn.createElementVNode)("div", $789a3edcf71ff0c0$var$_hoisted_43, [
                                    (0, $TusQn.createElementVNode)("button", {
                                        onClick: ($event)=>$options.exportParameterAndKpi(item.id),
                                        class: "btn btn-sm btn-primary"
                                    }, "csv", 8, $789a3edcf71ff0c0$var$_hoisted_44),
                                    (0, $TusQn.createElementVNode)("div", $789a3edcf71ff0c0$var$_hoisted_45, [
                                        $789a3edcf71ff0c0$var$_hoisted_46,
                                        (0, $TusQn.createElementVNode)("ul", $789a3edcf71ff0c0$var$_hoisted_47, [
                                            (0, $TusQn.createElementVNode)("li", null, [
                                                (0, $TusQn.createElementVNode)("a", {
                                                    class: "dropdown-item",
                                                    onClick: ($event)=>$options.exportParameterAndKpi(item.id, "de-AT")
                                                }, "csv - AT", 8, $789a3edcf71ff0c0$var$_hoisted_48)
                                            ]),
                                            (0, $TusQn.createElementVNode)("li", null, [
                                                (0, $TusQn.createElementVNode)("a", {
                                                    class: "dropdown-item",
                                                    onClick: ($event)=>$options.exportParameterAndKpi(item.id, "cs-CZ")
                                                }, "csv - CZ", 8, $789a3edcf71ff0c0$var$_hoisted_49)
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $789a3edcf71ff0c0$var$_hoisted_50, [
                (0, $TusQn.createElementVNode)("button", {
                    class: "btn btn-sm btn-danger",
                    onClick: _cache[0] || (_cache[0] = ($event)=>$data.showResultDeleteModal = true)
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ])) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("div", $789a3edcf71ff0c0$var$_hoisted_51, [
                (0, $TusQn.createElementVNode)("h3", $789a3edcf71ff0c0$var$_hoisted_52, (0, $8POXm.toDisplayString)(_ctx.$t("resultVisualization")), 1),
                (0, $TusQn.createElementVNode)("div", $789a3edcf71ff0c0$var$_hoisted_53, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/modelingresult/" + this.$route.params.modelingResultId + "/weightedaverage"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createElementVNode)("button", $789a3edcf71ff0c0$var$_hoisted_54, (0, $8POXm.toDisplayString)(_ctx.$t("weightedAverageCharts")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ]),
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/modelingresult/" + this.$route.params.modelingResultId + "/distribution"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createElementVNode)("button", $789a3edcf71ff0c0$var$_hoisted_55, (0, $8POXm.toDisplayString)(_ctx.$t("distributionCharts")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ]),
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/modelingresult/" + this.$route.params.modelingResultId + "/activity"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createElementVNode)("button", $789a3edcf71ff0c0$var$_hoisted_56, (0, $8POXm.toDisplayString)(_ctx.$t("activityCharts")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ]),
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/modelingresult/" + this.$route.params.modelingResultId + "/sumarizedcost"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createElementVNode)("button", $789a3edcf71ff0c0$var$_hoisted_57, (0, $8POXm.toDisplayString)(_ctx.$t("sumarizedCostCharts")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ]),
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/modelingresult/" + this.$route.params.modelingResultId + "/activityplan"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createElementVNode)("button", $789a3edcf71ff0c0$var$_hoisted_58, (0, $8POXm.toDisplayString)(_ctx.$t("activityPlan")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ])
            ])
        ])),
        $data.showResultDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ModelingResultDeleteModal, {
            key: 2,
            onReload: _cache[1] || (_cache[1] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}`
                })),
            onCloseDeleteDialog: _cache[2] || (_cache[2] = ($event)=>$data.showResultDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("bzWxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $86e05e712c4719cb$export$2e2bcd8739ae039);
let $86e05e712c4719cb$var$NOOP = ()=>{};
var $86e05e712c4719cb$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("gcV6I", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bcca10abaa99c29d$export$2e2bcd8739ae039);

var $gxt0C = parcelRequire("gxt0C");

var $l6otV = parcelRequire("l6otV");

var $gOjKo = parcelRequire("gOjKo");
var $bcca10abaa99c29d$export$2e2bcd8739ae039 = {
    name: "resultCharts",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var result = await (0, $gxt0C.default).weightedGraphCharts(this.$route.params.id, this.$route.params.modelingResultId, null, "");
            this.assetTypeList = result.assetTypes;
            this.dataValues = result.dataValues;
            this.groups = result.groups;
            this.packages = result.packages;
            this.chartConfigs = result.assetTypes.map((assetType)=>{
                return {
                    assetTypeId: assetType.assetTypeId,
                    assetTypeName: assetType.assetTypeName,
                    selectedDataValue: this.getSelectedDataValue(assetType.assetTypeId, result.dataValues),
                    selectedGroupId: null,
                    selectedPackageId: null,
                    charts: assetType.charts
                };
            });
            this.pending = false;
        },
        getSelectedChartTotalWeight (cfg) {
            const chart = this.getSelectedChart(cfg);
            if (!chart || !chart.totalWeight || !chart.weightAttributeName) return null;
            return {
                totalWeight: chart.totalWeight.toFixed(2),
                weightAttributeName: chart.weightAttributeName
            };
        },
        getSelectedDataValue (assetTypeId, dataValues) {
            return dataValues.find((v)=>v.selected && v.assetTypeId === assetTypeId)?.value || "performance";
        },
        formatAmount (value) {
            return value?.toFixed(2);
        },
        getSelectedChart (cfg) {
            const filteredCharts = cfg.charts.filter((c)=>c.dataValue === cfg.selectedDataValue);
            if (!filteredCharts.length) return null;
            // package chart
            if (cfg.selectedPackageId != null) return filteredCharts.find((c)=>c.packageId === cfg.selectedPackageId) || null;
            // group chart
            if (cfg.selectedGroupId != null) return filteredCharts.find((c)=>c.groupId === cfg.selectedGroupId) || null;
            // jinak All
            return filteredCharts.find((c)=>c.groupId == null && c.packageId == null) || null;
        },
        getChartOptions (chart) {
            return {
                chart: {
                    type: "line",
                    height: 500
                },
                title: {
                    text: this.$t("weightedAveragePerformanceOverTime")
                },
                xaxis: {
                    categories: chart.years,
                    title: {
                        text: this.$t("year")
                    }
                },
                yaxis: {
                    title: {
                        text: this.$t("weightedAveragePerformance")
                    },
                    labels: {
                        formatter: (v)=>this.formatAmount(v)
                    }
                },
                tooltip: {
                    y: {
                        formatter: (v)=>this.formatAmount(v)
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    position: "top"
                }
            };
        }
    },
    data () {
        return {
            chartConfigs: [],
            dataValues: [],
            assetTypeList: [],
            groups: [],
            packages: [],
            pending: true,
            isUserAdmin: false,
            modelingName: ""
        };
    }
};

});

parcelRegister("kQFDA", function(module, exports) {

$parcel$export(module.exports, "render", () => $f2d8f653c55dd0fc$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $f2d8f653c55dd0fc$var$_hoisted_1 = {
    class: "container py-5"
};
const $f2d8f653c55dd0fc$var$_hoisted_2 = {
    "aria-label": "breadcrumb",
    class: "mb-4"
};
const $f2d8f653c55dd0fc$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $f2d8f653c55dd0fc$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $f2d8f653c55dd0fc$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $f2d8f653c55dd0fc$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $f2d8f653c55dd0fc$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $f2d8f653c55dd0fc$var$_hoisted_8 = {
    key: 0
};
const $f2d8f653c55dd0fc$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $f2d8f653c55dd0fc$var$_hoisted_10 = [
    $f2d8f653c55dd0fc$var$_hoisted_9
];
const $f2d8f653c55dd0fc$var$_hoisted_11 = {
    key: 1
};
const $f2d8f653c55dd0fc$var$_hoisted_12 = {
    class: "mb-3"
};
const $f2d8f653c55dd0fc$var$_hoisted_13 = {
    class: "col-md-8"
};
const $f2d8f653c55dd0fc$var$_hoisted_14 = {
    key: 0,
    class: "mb-1"
};
const $f2d8f653c55dd0fc$var$_hoisted_15 = {
    class: "col-md-4"
};
const $f2d8f653c55dd0fc$var$_hoisted_16 = [
    "onUpdate:modelValue"
];
const $f2d8f653c55dd0fc$var$_hoisted_17 = [
    "value"
];
const $f2d8f653c55dd0fc$var$_hoisted_18 = [
    "onUpdate:modelValue",
    "onChange"
];
const $f2d8f653c55dd0fc$var$_hoisted_19 = {
    value: null
};
const $f2d8f653c55dd0fc$var$_hoisted_20 = [
    "value"
];
const $f2d8f653c55dd0fc$var$_hoisted_21 = [
    "onUpdate:modelValue",
    "onChange"
];
const $f2d8f653c55dd0fc$var$_hoisted_22 = {
    value: null
};
const $f2d8f653c55dd0fc$var$_hoisted_23 = [
    "value"
];
const $f2d8f653c55dd0fc$var$_hoisted_24 = {
    class: "d-grid gap-2 d-md-flex mb-4"
};
function $f2d8f653c55dd0fc$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_apexchart = (0, $TusQn.resolveComponent)("apexchart");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $f2d8f653c55dd0fc$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("weightAverageCharts")), 1),
        (0, $TusQn.createElementVNode)("nav", $f2d8f653c55dd0fc$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $f2d8f653c55dd0fc$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $f2d8f653c55dd0fc$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $f2d8f653c55dd0fc$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $f2d8f653c55dd0fc$var$_hoisted_6, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: `/modeling/${this.$route.params.id}/modelingresult/${this.$route.params.modelingResultId}`
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("modelingResult")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $f2d8f653c55dd0fc$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("weightAverageCharts")), 1)
            ])
        ]),
        $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $f2d8f653c55dd0fc$var$_hoisted_8, $f2d8f653c55dd0fc$var$_hoisted_10)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $f2d8f653c55dd0fc$var$_hoisted_11, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.chartConfigs, (cfg)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "row mb-5",
                    key: cfg.assetTypeId
                }, [
                    (0, $TusQn.createElementVNode)("h5", $f2d8f653c55dd0fc$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("assetType")) + ": " + (0, $8POXm.toDisplayString)(cfg.assetTypeName), 1),
                    (0, $TusQn.createElementVNode)("div", $f2d8f653c55dd0fc$var$_hoisted_13, [
                        $options.getSelectedChartTotalWeight(cfg) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $f2d8f653c55dd0fc$var$_hoisted_14, " Total " + (0, $8POXm.toDisplayString)($options.getSelectedChartTotalWeight(cfg).weightAttributeName) + ": " + (0, $8POXm.toDisplayString)($options.getSelectedChartTotalWeight(cfg).totalWeight), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        $options.getSelectedChart(cfg) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_apexchart, {
                            key: 1,
                            type: "line",
                            width: "800",
                            height: 500,
                            options: $options.getChartOptions($options.getSelectedChart(cfg)),
                            series: $options.getSelectedChart(cfg).series,
                            class: "d-flex justify-content-center"
                        }, null, 8, [
                            "options",
                            "series"
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $f2d8f653c55dd0fc$var$_hoisted_15, [
                        (0, $TusQn.createElementVNode)("label", null, (0, $8POXm.toDisplayString)(_ctx.$t("dataValues")), 1),
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                            class: "form-select",
                            "onUpdate:modelValue": ($event)=>cfg.selectedDataValue = $event
                        }, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.dataValues.filter((p)=>p.assetTypeId === cfg.assetTypeId), (v)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                    key: v.value,
                                    value: v.value
                                }, (0, $8POXm.toDisplayString)(v.name), 9, $f2d8f653c55dd0fc$var$_hoisted_17);
                            }), 128))
                        ], 8, $f2d8f653c55dd0fc$var$_hoisted_16), [
                            [
                                (0, $eeJ70.vModelSelect),
                                cfg.selectedDataValue
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("label", null, (0, $8POXm.toDisplayString)(_ctx.$t("area")), 1),
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                            class: "form-select",
                            "onUpdate:modelValue": ($event)=>cfg.selectedGroupId = $event,
                            onChange: ($event)=>cfg.selectedPackageId = null
                        }, [
                            (0, $TusQn.createElementVNode)("option", $f2d8f653c55dd0fc$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("allAreas")), 1),
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.groups.filter((p)=>p.assetTypeId === cfg.assetTypeId), (g)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                    key: g.value,
                                    value: Number(g.value)
                                }, (0, $8POXm.toDisplayString)(g.name), 9, $f2d8f653c55dd0fc$var$_hoisted_20);
                            }), 128))
                        ], 40, $f2d8f653c55dd0fc$var$_hoisted_18), [
                            [
                                (0, $eeJ70.vModelSelect),
                                cfg.selectedGroupId
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("label", null, (0, $8POXm.toDisplayString)(_ctx.$t("package")), 1),
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                            class: "form-select",
                            "onUpdate:modelValue": ($event)=>cfg.selectedPackageId = $event,
                            onChange: ($event)=>cfg.selectedGroupId = null
                        }, [
                            (0, $TusQn.createElementVNode)("option", $f2d8f653c55dd0fc$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("allPackages")), 1),
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.packages.filter((x)=>x.assetTypeId === cfg.assetTypeId), (p)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                    key: p.value,
                                    value: Number(p.value)
                                }, (0, $8POXm.toDisplayString)(p.name), 9, $f2d8f653c55dd0fc$var$_hoisted_23);
                            }), 128))
                        ], 40, $f2d8f653c55dd0fc$var$_hoisted_21), [
                            [
                                (0, $eeJ70.vModelSelect),
                                cfg.selectedPackageId
                            ]
                        ])
                    ])
                ]);
            }), 128)),
            (0, $TusQn.createElementVNode)("div", $f2d8f653c55dd0fc$var$_hoisted_24, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$router.push({
                            path: `/modeling/${this.$route.params.id}/modelingresult/${this.$route.params.modelingResultId}`
                        }))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
            ])
        ]))
    ]);
}

});

parcelRegister("leArl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7572c00010c3dbe$export$2e2bcd8739ae039);
let $f7572c00010c3dbe$var$NOOP = ()=>{};
var $f7572c00010c3dbe$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("g3X4a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bb1abe7a5ae678e9$export$2e2bcd8739ae039);

var $gxt0C = parcelRequire("gxt0C");

var $gOjKo = parcelRequire("gOjKo");

var $1M4Zs = parcelRequire("1M4Zs");
var $bb1abe7a5ae678e9$export$2e2bcd8739ae039 = {
    name: "resultCharts",
    watch: {
        $route: "requestData"
    },
    async mounted () {
        await this.requestData();
    },
    data () {
        return {
            pending: true,
            isUserAdmin: false,
            limits: [],
            groups: [],
            packages: [],
            assetTypeList: [],
            visualizationList: [],
            chartConfigs: [],
            modelingName: ""
        };
    },
    methods: {
        getSelectedChartTotalWeight (cfg) {
            if (cfg.selectedVisualization === "cost") return null;
            const chart = this.getSelectedChart(cfg);
            if (!chart || !chart.totalWeight || !chart.weightAttributeName) return null;
            return {
                totalWeight: chart.totalWeight,
                weightAttributeName: chart.weightAttributeName
            };
        },
        onAssetTypeChanged (cfg) {
            const firstVisForAt = this.visualizationList.find((v)=>v.assetTypeId === cfg.selectedAssetType)?.value || "cost";
            cfg.selectedVisualization = firstVisForAt;
            cfg.selectedGroupId = null;
            cfg.selectedPackageId = null;
        },
        getSelectedChart (cfg) {
            const filteredCharts = cfg.charts.filter((c)=>c.assetTypeId === cfg.selectedAssetType && c.visualization === cfg.selectedVisualization);
            if (!filteredCharts.length) return null;
            // package chart
            if (cfg.selectedPackageId != null) return filteredCharts.find((c)=>c.packageId === cfg.selectedPackageId) || null;
            // group chart
            if (cfg.selectedGroupId != null) return filteredCharts.find((c)=>c.groupId === cfg.selectedGroupId) || null;
            // all chart (bez group i package)
            return filteredCharts.find((c)=>c.groupId == null && c.packageId == null) || null;
        },
        getChartOptions (chart, cfg) {
            return {
                chart: {
                    type: "bar",
                    height: 500
                },
                title: {
                    text: `Activity ${chart.visualizationName} for Limit: ${cfg.limitName}`
                },
                xaxis: {
                    categories: chart.years,
                    title: {
                        text: "Year"
                    }
                },
                yaxis: {
                    title: {
                        text: chart.visualizationName
                    },
                    labels: {
                        formatter: (v)=>(0, $1M4Zs.formatAmount)(v, chart.currency)
                    }
                },
                tooltip: {
                    y: {
                        formatter: (v)=>(0, $1M4Zs.formatAmount)(v, chart.currency)
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "50%",
                        endingShape: "rounded"
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    position: "top"
                },
                colors: chart.series?.map((s)=>s.color)
            };
        },
        async requestData () {
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var analysisDetail = await (0, $gxt0C.default).analysisDetail(this.$route.params.id, this.$route.params.modelingResultId);
            if (analysisDetail.modelingInfo && analysisDetail.modelingInfo.selections) this.modelingName = analysisDetail.modelingInfo.name;
            var result = await (0, $gxt0C.default).activityGraphCharts(this.$route.params.id, this.$route.params.modelingResultId);
            this.assetTypeList = result.assetTypes;
            this.visualizationList = result.visualizationOptions;
            this.groups = result.groups || [];
            this.packages = result.packages || [];
            this.chartConfigs = result.limits.map((limitGroup)=>({
                    limitId: limitGroup.limitId,
                    limitName: limitGroup.limitName,
                    charts: limitGroup.charts,
                    selectedAssetType: result.assetTypes[0]?.id ?? null,
                    selectedVisualization: result.visualizationOptions[0]?.value ?? null,
                    selectedGroupId: null,
                    selectedPackageId: null
                }));
            this.pending = false;
        }
    }
};

});
parcelRegister("1M4Zs", function(module, exports) {

$parcel$export(module.exports, "formatAmount", () => $14ae251337ac7f82$export$e251d23bea783311);
function $14ae251337ac7f82$export$b91dea8e61ccd7ef(currency) {
    switch(currency){
        case "K\u010D":
            return "CZK";
        case "\u20AC":
            return "EUR";
        case "$":
            return "USD";
        default:
            return currency.toUpperCase();
    }
}
function $14ae251337ac7f82$export$e251d23bea783311(value, currency) {
    if (!currency) return value?.toFixed(2);
    return currency + " " + value?.toFixed(2);
}

});


parcelRegister("XAxNH", function(module, exports) {

$parcel$export(module.exports, "render", () => $0b31dbb6bcef9f3e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $0b31dbb6bcef9f3e$var$_hoisted_1 = {
    class: "container py-5"
};
const $0b31dbb6bcef9f3e$var$_hoisted_2 = {
    "aria-label": "breadcrumb",
    class: "mb-4"
};
const $0b31dbb6bcef9f3e$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $0b31dbb6bcef9f3e$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $0b31dbb6bcef9f3e$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $0b31dbb6bcef9f3e$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $0b31dbb6bcef9f3e$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $0b31dbb6bcef9f3e$var$_hoisted_8 = {
    key: 0
};
const $0b31dbb6bcef9f3e$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $0b31dbb6bcef9f3e$var$_hoisted_10 = [
    $0b31dbb6bcef9f3e$var$_hoisted_9
];
const $0b31dbb6bcef9f3e$var$_hoisted_11 = {
    key: 1
};
const $0b31dbb6bcef9f3e$var$_hoisted_12 = {
    class: "mb-3"
};
const $0b31dbb6bcef9f3e$var$_hoisted_13 = {
    class: "col-md-8"
};
const $0b31dbb6bcef9f3e$var$_hoisted_14 = {
    key: 0,
    class: "mb-1"
};
const $0b31dbb6bcef9f3e$var$_hoisted_15 = {
    class: "col-md-4"
};
const $0b31dbb6bcef9f3e$var$_hoisted_16 = {
    class: "row mb-3"
};
const $0b31dbb6bcef9f3e$var$_hoisted_17 = {
    class: "col-md-4"
};
const $0b31dbb6bcef9f3e$var$_hoisted_18 = [
    "onUpdate:modelValue",
    "onChange"
];
const $0b31dbb6bcef9f3e$var$_hoisted_19 = [
    "value"
];
const $0b31dbb6bcef9f3e$var$_hoisted_20 = {
    class: "row mb-3"
};
const $0b31dbb6bcef9f3e$var$_hoisted_21 = {
    class: "col-md-4"
};
const $0b31dbb6bcef9f3e$var$_hoisted_22 = [
    "onUpdate:modelValue",
    "onChange"
];
const $0b31dbb6bcef9f3e$var$_hoisted_23 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: "",
    disabled: "",
    selected: ""
}, "Select", -1);
const $0b31dbb6bcef9f3e$var$_hoisted_24 = [
    "value"
];
const $0b31dbb6bcef9f3e$var$_hoisted_25 = {
    class: "row mb-3"
};
const $0b31dbb6bcef9f3e$var$_hoisted_26 = {
    class: "col-md-4"
};
const $0b31dbb6bcef9f3e$var$_hoisted_27 = [
    "onUpdate:modelValue",
    "onChange"
];
const $0b31dbb6bcef9f3e$var$_hoisted_28 = {
    value: null
};
const $0b31dbb6bcef9f3e$var$_hoisted_29 = [
    "value"
];
const $0b31dbb6bcef9f3e$var$_hoisted_30 = {
    class: "row mb-3"
};
const $0b31dbb6bcef9f3e$var$_hoisted_31 = {
    class: "col-md-4"
};
const $0b31dbb6bcef9f3e$var$_hoisted_32 = [
    "onUpdate:modelValue",
    "onChange"
];
const $0b31dbb6bcef9f3e$var$_hoisted_33 = {
    value: null
};
const $0b31dbb6bcef9f3e$var$_hoisted_34 = [
    "value"
];
const $0b31dbb6bcef9f3e$var$_hoisted_35 = {
    class: "d-grid gap-2 d-md-flex mb-4"
};
function $0b31dbb6bcef9f3e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_apexchart = (0, $TusQn.resolveComponent)("apexchart");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0b31dbb6bcef9f3e$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("activityCharts")), 1),
        (0, $TusQn.createElementVNode)("nav", $0b31dbb6bcef9f3e$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $0b31dbb6bcef9f3e$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $0b31dbb6bcef9f3e$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $0b31dbb6bcef9f3e$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $0b31dbb6bcef9f3e$var$_hoisted_6, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: `/modeling/${this.$route.params.id}/modelingresult/${this.$route.params.modelingResultId}`
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("modelingResult")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $0b31dbb6bcef9f3e$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("activityCharts")), 1)
            ])
        ]),
        $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0b31dbb6bcef9f3e$var$_hoisted_8, $0b31dbb6bcef9f3e$var$_hoisted_10)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0b31dbb6bcef9f3e$var$_hoisted_11, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.chartConfigs, (cfg)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "row mb-5",
                    key: cfg.limitId
                }, [
                    (0, $TusQn.createElementVNode)("h5", $0b31dbb6bcef9f3e$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("limit")) + ": " + (0, $8POXm.toDisplayString)(cfg.limitName), 1),
                    (0, $TusQn.createElementVNode)("div", $0b31dbb6bcef9f3e$var$_hoisted_13, [
                        $options.getSelectedChartTotalWeight(cfg) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0b31dbb6bcef9f3e$var$_hoisted_14, " Total " + (0, $8POXm.toDisplayString)($options.getSelectedChartTotalWeight(cfg).weightAttributeName) + ": " + (0, $8POXm.toDisplayString)($options.getSelectedChartTotalWeight(cfg).totalWeight), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        $options.getSelectedChart(cfg) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_apexchart, {
                            key: 1,
                            type: "bar",
                            width: "800",
                            height: "500",
                            options: $options.getChartOptions($options.getSelectedChart(cfg), cfg),
                            series: $options.getSelectedChart(cfg).series,
                            class: "d-flex justify-content-center"
                        }, null, 8, [
                            "options",
                            "series"
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $0b31dbb6bcef9f3e$var$_hoisted_15, [
                        (0, $TusQn.createElementVNode)("div", $0b31dbb6bcef9f3e$var$_hoisted_16, [
                            (0, $TusQn.createElementVNode)("label", $0b31dbb6bcef9f3e$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("assetType")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                class: "col-md-8 form-select",
                                "onUpdate:modelValue": ($event)=>cfg.selectedAssetType = $event,
                                onChange: ($event)=>$options.onAssetTypeChanged(cfg)
                            }, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.assetTypeList, (at)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: at.id,
                                        value: at.id
                                    }, (0, $8POXm.toDisplayString)(at.name), 9, $0b31dbb6bcef9f3e$var$_hoisted_19);
                                }), 128))
                            ], 40, $0b31dbb6bcef9f3e$var$_hoisted_18), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    cfg.selectedAssetType,
                                    void 0,
                                    {
                                        number: true
                                    }
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $0b31dbb6bcef9f3e$var$_hoisted_20, [
                            (0, $TusQn.createElementVNode)("label", $0b31dbb6bcef9f3e$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("visualization")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                class: "col-md-8 form-select",
                                "onUpdate:modelValue": ($event)=>cfg.selectedVisualization = $event,
                                onChange: ($event)=>$options.getSelectedChart(cfg)
                            }, [
                                $0b31dbb6bcef9f3e$var$_hoisted_23,
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.visualizationList?.filter((p)=>p.assetTypeId == cfg.selectedAssetType), (visualization)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: visualization.value,
                                        value: visualization.value
                                    }, (0, $8POXm.toDisplayString)(visualization.name), 9, $0b31dbb6bcef9f3e$var$_hoisted_24);
                                }), 128))
                            ], 40, $0b31dbb6bcef9f3e$var$_hoisted_22), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    cfg.selectedVisualization
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $0b31dbb6bcef9f3e$var$_hoisted_25, [
                            (0, $TusQn.createElementVNode)("label", $0b31dbb6bcef9f3e$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("areas")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                class: "col-md-8 form-select",
                                "onUpdate:modelValue": ($event)=>cfg.selectedGroupId = $event,
                                onChange: ($event)=>cfg.selectedPackageId = null
                            }, [
                                (0, $TusQn.createElementVNode)("option", $0b31dbb6bcef9f3e$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("allAreas")), 1),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.groups.filter((p)=>p.assetTypeId === cfg.selectedAssetType), (g)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: g.value,
                                        value: Number(g.value)
                                    }, (0, $8POXm.toDisplayString)(g.name), 9, $0b31dbb6bcef9f3e$var$_hoisted_29);
                                }), 128))
                            ], 40, $0b31dbb6bcef9f3e$var$_hoisted_27), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    cfg.selectedGroupId
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $0b31dbb6bcef9f3e$var$_hoisted_30, [
                            (0, $TusQn.createElementVNode)("label", $0b31dbb6bcef9f3e$var$_hoisted_31, (0, $8POXm.toDisplayString)(_ctx.$t("packages")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                class: "col-md-8 form-select",
                                "onUpdate:modelValue": ($event)=>cfg.selectedPackageId = $event,
                                onChange: ($event)=>cfg.selectedGroupId = null
                            }, [
                                (0, $TusQn.createElementVNode)("option", $0b31dbb6bcef9f3e$var$_hoisted_33, (0, $8POXm.toDisplayString)(_ctx.$t("allPackages")), 1),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.packages.filter((x)=>x.assetTypeId === cfg.selectedAssetType), (p)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: p.value,
                                        value: Number(p.value)
                                    }, (0, $8POXm.toDisplayString)(p.name), 9, $0b31dbb6bcef9f3e$var$_hoisted_34);
                                }), 128))
                            ], 40, $0b31dbb6bcef9f3e$var$_hoisted_32), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    cfg.selectedPackageId
                                ]
                            ])
                        ])
                    ])
                ]);
            }), 128)),
            (0, $TusQn.createElementVNode)("div", $0b31dbb6bcef9f3e$var$_hoisted_35, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$router.push({
                            path: `/modeling/${_ctx.$route.params.id}/modelingresult/${_ctx.$route.params.modelingResultId}`
                        }))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
            ])
        ]))
    ]);
}

});

parcelRegister("ifxsT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d493962e678b713a$export$2e2bcd8739ae039);
let $d493962e678b713a$var$NOOP = ()=>{};
var $d493962e678b713a$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("8JMqw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $65c81740eea179d4$export$2e2bcd8739ae039);

var $gxt0C = parcelRequire("gxt0C");

var $gOjKo = parcelRequire("gOjKo");
var $65c81740eea179d4$export$2e2bcd8739ae039 = {
    name: "distributionCharts",
    watch: {
        $route: "requestData"
    },
    async mounted () {
        await this.requestData();
    },
    data () {
        return {
            data: {},
            pending: true,
            isUserAdmin: false,
            // raw payload
            limits: [],
            assetTypeList: [],
            dataValuesList: [],
            chartConfigs: [],
            groupsList: [],
            packagesList: [],
            modelingName: ""
        };
    },
    methods: {
        getSelectedChartTotalWeight (cfg) {
            const chart = this.getSelectedChart(cfg);
            if (!chart || chart.dataValue !== "performance") return null;
            if (!chart.totalWeight && !chart.weightAttributeName) return null;
            return {
                totalWeight: chart.totalWeight,
                weightAttributeName: chart.weightAttributeName
            };
        },
        async getGraphData (cfg) {},
        chartKey (cfg) {
            return `${cfg.limitId}-${cfg.selectedAssetType}-${cfg.selectedDataValue}-${cfg.selectedGroupId ?? "all"}-${cfg.selectedPackageId ?? "all"}`;
        },
        assetTypeChanged (cfg) {
            cfg.selectedDataValue = this.getSelectedDataValue(cfg.assetTypes?.[0]?.id, cfg.dataValues);
            cfg.selectedGroupId = null;
            cfg.selectedPackageId = null;
        },
        formatAmount (value) {
            return `${value}%`;
        },
        getSelectedChart (cfg) {
            const filteredCharts = cfg.charts.filter((c)=>c.assetTypeId == cfg.selectedAssetType && c.dataValue == cfg.selectedDataValue);
            if (!filteredCharts.length) return null;
            const gid = cfg.selectedGroupId;
            const pid = cfg.selectedPackageId;
            // ALL
            if (gid == null && pid == null) return filteredCharts.find((c)=>c.groupId == null && c.packageId == null) || null;
            // only group
            if (gid != null && pid == null) return filteredCharts.find((c)=>c.groupId === gid && c.packageId == null) || null;
            // only package
            if (gid == null && pid != null) return filteredCharts.find((c)=>c.groupId == null && c.packageId === pid) || null;
            // group + package
            return filteredCharts.find((c)=>c.groupId === gid && c.packageId === pid) || null;
        },
        getChartOptions (chart, cfg) {
            return {
                chart: {
                    type: "bar",
                    stacked: true,
                    stackType: "100%",
                    height: 500,
                    animations: {
                        enabled: false
                    }
                },
                title: {
                },
                xaxis: {
                    categories: chart.categories || chart.years,
                    title: {
                        text: this.$t("year")
                    }
                },
                yaxis: {
                    title: {
                        text: this.$t("percentage")
                    },
                    labels: {
                        formatter: (v)=>this.formatAmount(v)
                    }
                },
                tooltip: {
                    y: {
                        formatter: (v)=>this.formatAmount(v)
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "50%",
                        endingShape: "rounded"
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    position: "top"
                },
                colors: chart.series?.map((s)=>s.color)
            };
        },
        getSelectedDataValue (assetTypeId, dataValues) {
            return dataValues.find((v)=>v.selected && v.assetTypeId == assetTypeId)?.value || "performance";
        },
        async requestData () {
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            const analysisDetail = await (0, $gxt0C.default).analysisDetail(this.$route.params.id, this.$route.params.modelingResultId);
            this.modelingName = analysisDetail.modelingInfo?.name || "";
            const result = await (0, $gxt0C.default).distributionCharts(this.$route.params.id, this.$route.params.modelingResultId);
            this.assetTypeList = result.assetTypes;
            this.dataValuesList = result.dataValues;
            this.groupsList = result.groups;
            this.packagesList = result.packages;
            this.chartConfigs = result.limits.map((limitGroup)=>({
                    limitId: limitGroup.limitId,
                    limitName: limitGroup.limitName,
                    charts: limitGroup.charts,
                    selectedAssetType: result.assetTypes?.[0]?.id || null,
                    selectedDataValue: this.getSelectedDataValue(result.assetTypes?.[0]?.id, result.dataValues),
                    selectedGroupId: null,
                    selectedPackageId: null
                }));
            this.pending = false;
        }
    }
};

});

parcelRegister("iBWWz", function(module, exports) {

$parcel$export(module.exports, "render", () => $d8c967ab769d209b$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $d8c967ab769d209b$var$_hoisted_1 = {
    class: "container py-5"
};
const $d8c967ab769d209b$var$_hoisted_2 = {
    "aria-label": "breadcrumb",
    class: "mb-4"
};
const $d8c967ab769d209b$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $d8c967ab769d209b$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $d8c967ab769d209b$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $d8c967ab769d209b$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $d8c967ab769d209b$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $d8c967ab769d209b$var$_hoisted_8 = {
    key: 0,
    class: "d-flex justify-content-center loading-center"
};
const $d8c967ab769d209b$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "spinner-border",
    role: "status"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
        class: "sr-only"
    }, "Loading...")
], -1);
const $d8c967ab769d209b$var$_hoisted_10 = [
    $d8c967ab769d209b$var$_hoisted_9
];
const $d8c967ab769d209b$var$_hoisted_11 = {
    key: 1
};
const $d8c967ab769d209b$var$_hoisted_12 = {
    class: "mb-3"
};
const $d8c967ab769d209b$var$_hoisted_13 = {
    class: "col-md-8"
};
const $d8c967ab769d209b$var$_hoisted_14 = {
    key: 0,
    class: "mb-1"
};
const $d8c967ab769d209b$var$_hoisted_15 = {
    class: "col-md-4"
};
const $d8c967ab769d209b$var$_hoisted_16 = {
    class: "row mb-3"
};
const $d8c967ab769d209b$var$_hoisted_17 = {
    class: "col-md-4"
};
const $d8c967ab769d209b$var$_hoisted_18 = [
    "onUpdate:modelValue",
    "onChange"
];
const $d8c967ab769d209b$var$_hoisted_19 = [
    "value"
];
const $d8c967ab769d209b$var$_hoisted_20 = {
    class: "row mb-3"
};
const $d8c967ab769d209b$var$_hoisted_21 = {
    class: "col-md-4"
};
const $d8c967ab769d209b$var$_hoisted_22 = [
    "onUpdate:modelValue",
    "onChange"
];
const $d8c967ab769d209b$var$_hoisted_23 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: "",
    disabled: "",
    selected: ""
}, "Select", -1);
const $d8c967ab769d209b$var$_hoisted_24 = [
    "value"
];
const $d8c967ab769d209b$var$_hoisted_25 = {
    class: "row mb-3"
};
const $d8c967ab769d209b$var$_hoisted_26 = {
    class: "col-md-4"
};
const $d8c967ab769d209b$var$_hoisted_27 = [
    "onUpdate:modelValue"
];
const $d8c967ab769d209b$var$_hoisted_28 = {
    value: null
};
const $d8c967ab769d209b$var$_hoisted_29 = [
    "value"
];
const $d8c967ab769d209b$var$_hoisted_30 = {
    class: "row mb-3"
};
const $d8c967ab769d209b$var$_hoisted_31 = {
    class: "col-md-4"
};
const $d8c967ab769d209b$var$_hoisted_32 = [
    "onUpdate:modelValue"
];
const $d8c967ab769d209b$var$_hoisted_33 = {
    value: null
};
const $d8c967ab769d209b$var$_hoisted_34 = [
    "value"
];
const $d8c967ab769d209b$var$_hoisted_35 = {
    class: "d-grid gap-2 d-md-flex mb-4"
};
function $d8c967ab769d209b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_apexchart = (0, $TusQn.resolveComponent)("apexchart");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d8c967ab769d209b$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("distributionCharts")), 1),
        (0, $TusQn.createElementVNode)("nav", $d8c967ab769d209b$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $d8c967ab769d209b$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $d8c967ab769d209b$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $d8c967ab769d209b$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: _ctx.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $d8c967ab769d209b$var$_hoisted_6, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: `/modeling/${_ctx.$route.params.id}/modelingresult/${_ctx.$route.params.modelingResultId}`
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("modelingResult")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $d8c967ab769d209b$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("distributionCharts")), 1)
            ])
        ]),
        $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d8c967ab769d209b$var$_hoisted_8, $d8c967ab769d209b$var$_hoisted_10)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d8c967ab769d209b$var$_hoisted_11, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.chartConfigs, (cfg)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "row mb-5",
                    key: cfg.limitId
                }, [
                    (0, $TusQn.createElementVNode)("h5", $d8c967ab769d209b$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("limit")) + ": " + (0, $8POXm.toDisplayString)(cfg.limitName), 1),
                    (0, $TusQn.createElementVNode)("div", $d8c967ab769d209b$var$_hoisted_13, [
                        $options.getSelectedChartTotalWeight(cfg) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d8c967ab769d209b$var$_hoisted_14, " Total " + (0, $8POXm.toDisplayString)($options.getSelectedChartTotalWeight(cfg).weightAttributeName) + ": " + (0, $8POXm.toDisplayString)($options.getSelectedChartTotalWeight(cfg).totalWeight), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        $options.getSelectedChart(cfg) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_apexchart, {
                            key: $options.chartKey(cfg),
                            type: "bar",
                            width: "800",
                            height: 500,
                            options: $options.getChartOptions($options.getSelectedChart(cfg), cfg),
                            series: $options.getSelectedChart(cfg).series,
                            class: "d-flex justify-content-center"
                        }, null, 8, [
                            "options",
                            "series"
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $d8c967ab769d209b$var$_hoisted_15, [
                        (0, $TusQn.createElementVNode)("div", $d8c967ab769d209b$var$_hoisted_16, [
                            (0, $TusQn.createElementVNode)("label", $d8c967ab769d209b$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("assetType")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                class: "col-md-8 form-select",
                                "onUpdate:modelValue": ($event)=>cfg.selectedAssetType = $event,
                                onChange: ($event)=>$options.assetTypeChanged(cfg)
                            }, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.assetTypeList, (at)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: at.id,
                                        value: at.id
                                    }, (0, $8POXm.toDisplayString)(at.name), 9, $d8c967ab769d209b$var$_hoisted_19);
                                }), 128))
                            ], 40, $d8c967ab769d209b$var$_hoisted_18), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    cfg.selectedAssetType,
                                    void 0,
                                    {
                                        number: true
                                    }
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $d8c967ab769d209b$var$_hoisted_20, [
                            (0, $TusQn.createElementVNode)("label", $d8c967ab769d209b$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("dataValues")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                class: "col-md-8 form-select",
                                "onUpdate:modelValue": ($event)=>cfg.selectedDataValue = $event,
                                onChange: ($event)=>$options.getGraphData(cfg)
                            }, [
                                $d8c967ab769d209b$var$_hoisted_23,
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.dataValuesList?.filter((p)=>p.assetTypeId == cfg.selectedAssetType), (dataValue)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: dataValue.value,
                                        value: dataValue.value
                                    }, (0, $8POXm.toDisplayString)(dataValue.name), 9, $d8c967ab769d209b$var$_hoisted_24);
                                }), 128))
                            ], 40, $d8c967ab769d209b$var$_hoisted_22), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    cfg.selectedDataValue
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $d8c967ab769d209b$var$_hoisted_25, [
                            (0, $TusQn.createElementVNode)("label", $d8c967ab769d209b$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("area")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                class: "col-md-8 form-select",
                                "onUpdate:modelValue": ($event)=>cfg.selectedGroupId = $event
                            }, [
                                (0, $TusQn.createElementVNode)("option", $d8c967ab769d209b$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("allAreas")), 1),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.groupsList.filter((p)=>p.assetTypeId === cfg.selectedAssetType), (g)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: g.value,
                                        value: Number(g.value)
                                    }, (0, $8POXm.toDisplayString)(g.name), 9, $d8c967ab769d209b$var$_hoisted_29);
                                }), 128))
                            ], 8, $d8c967ab769d209b$var$_hoisted_27), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    cfg.selectedGroupId
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $d8c967ab769d209b$var$_hoisted_30, [
                            (0, $TusQn.createElementVNode)("label", $d8c967ab769d209b$var$_hoisted_31, (0, $8POXm.toDisplayString)(_ctx.$t("package")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                class: "col-md-8 form-select",
                                "onUpdate:modelValue": ($event)=>cfg.selectedPackageId = $event
                            }, [
                                (0, $TusQn.createElementVNode)("option", $d8c967ab769d209b$var$_hoisted_33, (0, $8POXm.toDisplayString)(_ctx.$t("allPackages")), 1),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.packagesList.filter((x)=>x.assetTypeId === cfg.selectedAssetType), (p)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: p.value,
                                        value: Number(p.value)
                                    }, (0, $8POXm.toDisplayString)(p.name), 9, $d8c967ab769d209b$var$_hoisted_34);
                                }), 128))
                            ], 8, $d8c967ab769d209b$var$_hoisted_32), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    cfg.selectedPackageId
                                ]
                            ])
                        ])
                    ])
                ]);
            }), 128)),
            (0, $TusQn.createElementVNode)("div", $d8c967ab769d209b$var$_hoisted_35, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$router.push({
                            path: `/modeling/${_ctx.$route.params.id}/modelingresult/${_ctx.$route.params.modelingResultId}`
                        }))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
            ])
        ]))
    ]);
}

});

parcelRegister("eGNRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab1bab594cffe91e$export$2e2bcd8739ae039);
let $ab1bab594cffe91e$var$NOOP = ()=>{};
var $ab1bab594cffe91e$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("a1Unm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $74d5ba6ea75ddc20$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $gxt0C = parcelRequire("gxt0C");
parcelRequire("l6otV");

var $gOjKo = parcelRequire("gOjKo");

var $fihz0 = parcelRequire("fihz0");

var $bfIrw = parcelRequire("bfIrw");

var $4mWlF = parcelRequire("4mWlF");

var $9jDAx = parcelRequire("9jDAx");

var $5DwXE = parcelRequire("5DwXE");

var $9DiKA = parcelRequire("9DiKA");

var $haRZ2 = parcelRequire("haRZ2");

var $bdrRp = parcelRequire("bdrRp");

var $bnthu = parcelRequire("bnthu");

var $ndRlY = parcelRequire("ndRlY");

var $4Z60n = parcelRequire("4Z60n");

var $1SJ4B = parcelRequire("1SJ4B");



var $lwfqC = parcelRequire("lwfqC");

var $fVglf = parcelRequire("fVglf");
(0, $fihz0.default).use((0, $bfIrw.default));
var $74d5ba6ea75ddc20$export$2e2bcd8739ae039 = {
    name: "resultCharts",
    components: {
        DataTable: $fihz0.default
    },
    watch: {
        $route: "requestData",
        data: {
            handler () {
                this.debouncedUpdateFeatures();
            },
            deep: true
        },
        assetTypeList: {
            handler () {
                this.debouncedUpdateFeatures();
            },
            deep: true
        }
    },
    mounted () {
        this.requestData();
    },
    created () {
        this.debouncedUpdateFeatures = (0, (/*@__PURE__*/$parcel$interopDefault($lwfqC)))(this.updateFeatures.bind(this), 200);
    },
    computed: {
        filteredSections () {
            const from = this.data.selectionStartYear;
            const to = this.data.selectionEndYear;
            // vybrané assetTypes
            const selectedAssetTypeIds = this.assetTypeList.filter((at)=>at.checked).map((at)=>at.id);
            // vybrané activity
            const selectedActivityIds = this.assetTypeList.flatMap((at)=>{
                if (!at.checked) return [];
                const subs = at.activities.filter((a)=>a.checked).map((a)=>a.id);
                // Když nejsou vybrané žádné aktivity, vrátí se všechny aktivity daného assetType
                return subs.length ? subs : at.activities.map((a)=>a.id);
            });
            return this.activityPlanProperties.filter((sec)=>{
                if (this.data.limit != null && sec.limitId != this.data.limit) return false;
                if (selectedAssetTypeIds.length && !selectedAssetTypeIds.includes(sec.assetTypeId)) return false;
                if (from && to) {
                    const inYears = sec.activities.some((a)=>{
                        const y = a.year;
                        return y >= from && y <= to;
                    });
                    if (!inYears) return false;
                }
                if (selectedActivityIds.length) {
                    const anySelectedActivities = sec.activities.some((a)=>selectedActivityIds.includes(a.id));
                    if (!anySelectedActivities) return false;
                }
                return true;
            }).map((sec)=>({
                    ...sec,
                    activities: (sec.activities || []).filter((a)=>{
                        const passActivity = !selectedActivityIds.length || selectedActivityIds.includes(a.id);
                        const passYear = !(from && to) || a.year >= from && a.year <= to;
                        return passActivity && passYear;
                    })
                }));
        }
    },
    methods: {
        async requestData () {
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var analysis = await (0, $gxt0C.default).analysisDetail(this.$route.params.id, this.$route.params.modelingResultId);
            var selection = analysis.modelingInfo.selections.find((s)=>s.id == analysis.selectionId);
            this.modelingName = analysis.modelingInfo.name;
            this.data.selectionStartYear = analysis.selectionStartYear;
            this.data.selectionEndYear = analysis.selectionEndYear;
            var sections = await (0, $gxt0C.default).activityPlanSections(this.$route.params.id, this.$route.params.modelingResultId);
            for(var i in sections.data){
                var dataset = sections.data[i];
                this.recById[i] = Object.fromEntries(dataset.map((r)=>[
                        String(r.properties.OBJECTID),
                        r
                    ]));
            }
            var activityPlan = await (0, $gxt0C.default).activityPlanData(this.$route.params.id, this.$route.params.modelingResultId, "");
            // ZLO/!!!!
            // var usedAssetTypes = {};
            // for (var i in activityPlan.properties) {
            //     usedAssetTypes[activityPlan.properties[i].assetTypeId] = true;
            // }
            const usedActivityIds = new Set(activityPlan.usedActivityIds);
            const usedAssetTypeIds = new Set(activityPlan.usedAssetTypeIds);
            this.assetTypeList = analysis.modelingInfo.assetTypes.filter((a)=>usedAssetTypeIds.has(a.id)).map((assetType)=>({
                    ...assetType,
                    activities: assetType.activities.filter((a)=>usedActivityIds.has(a.id))
                }));
            this.mapCenter = activityPlan?.center;
            this.activityPlanProperties = activityPlan.properties;
            this.limitList = selection.limits;
            this.pending = false;
            if (this.renderMap && this.mapCenter) {
                await (0, $TusQn.nextTick)();
                this.adjustDt();
                this.initMap();
            }
        },
        async initMap () {
            var self = this;
            self.mapLoading = true;
            if (!self.$refs.map) return;
            // Release previous map
            if (self.map) self.map.setTarget(undefined);
            if (self.popUpDataTable) self.popUpDataTable.destroy(true);
            const overlay = new (0, $haRZ2.default)({
                element: self.$refs.popup,
                autoPan: {
                    animation: {
                        duration: 250
                    }
                }
            });
            if (self.$refs["popupCloser"]) self.$refs["popupCloser"].onclick = ()=>{
                overlay.setPosition(undefined);
                self.$refs["popupCloser"].blur();
                return false;
            };
            this.vectorLayer = new (0, $bdrRp.default)({
                source: new (0, $bnthu.default)(),
                style: (feature, res)=>(0, $ndRlY.defaultLineStyleFunction)(feature, res, feature.get("color") || "#000000", 4)
            });
            const layers = [
                new (0, $4mWlF.default)({
                    source: new (0, $9jDAx.default)()
                }),
                this.vectorLayer
            ];
            // const features = getFeaturesFromSectionGeoJSON(self.filteredSections, projection);
            // if (features.length > 0) {
            //     const vector = new VectorLayer({ 
            //         source: new VectorSource({ features: features }),
            //         style: (feature, resolution) => defaultLineStyleFunction(feature, resolution, feature.get("color") ? feature.get("color") : "#000000", 4)
            //     });
            //     layers.push(vector);
            // }
            // this.content.center misto pevneho center
            const view = new (0, $9DiKA.default)({
                center: (0, $1SJ4B.parseCoords)(this.mapCenter),
                zoom: 12
            });
            self.map = new (0, $5DwXE.default)({
                target: self.$refs.map,
                layers: layers,
                overlays: [
                    overlay
                ],
                view: view
            });
            const select = new (0, $4Z60n.default)({
                style: function(feature, resolution) {
                    return (0, $ndRlY.defaultLineStyleFunction)(feature, resolution, "#A020F0", 4);
                }
            });
            select.on("select", (evt)=>{
                if (evt.selected && evt.selected.length > 0) {
                    self.selectedFeatures = evt.target.getFeatures().getArray();
                    self.selectedFeatureIndex = self.selectedFeatures.length;
                    self.setPopupTableData();
                    overlay.setPosition(evt.mapBrowserEvent.coordinate);
                } else {
                    self.selectedFeatures = [];
                    self.selectedFeatureIndex = 0;
                    overlay.setPosition(undefined);
                    self.$refs.popupCloser.blur();
                }
            });
            self.map.addInteraction(select);
            this.updateFeatures();
            this.buildLegendItems();
            this.renderLegendControl();
            self.mapLoading = false;
        },
        buildLegendItems () {
            var activityColors = [];
            this.filteredSections.forEach((sec)=>{
                (sec.activities || []).forEach((act)=>{
                    const label = act.name ?? "\u2014";
                    const color = act.color || "#000000";
                    if (activityColors.some((ac)=>ac.label === label && ac.color === color)) return;
                    activityColors.push({
                        label: label,
                        color: color
                    });
                });
            });
            this.legendItems = activityColors;
        },
        renderLegendControl () {
            if (this.legendItems.length == 0) return;
            const el = document.createElement("div");
            el.className = "ol-unselectable ol-control activity-legend";
            el.style = "top:.5em; right:.5em;"; // pravý horní roh
            el.innerHTML = `
                <div class="legend-card">
                <div class="legend-title">${this.$t("legend")}</div>
                <ul class="legend-list">
                    ${this.legendItems.map((it)=>`
                    <li class="legend-row">
                        <span class="legend-dot" style="background:${it.color}"></span>
                        <span class="legend-label" title="${it.label}">${it.label}</span>
                    </li>
                    `).join("")}
                </ul>
                </div>
            `;
            this.legendControl = new (0, $fVglf.default)({
                element: el
            });
            this.map.addControl(this.legendControl);
        },
        exportActivityPlan () {
            var query = "?";
            if (this.data.limit) query += `limitId=${this.data.limit}&`;
            if (this.data.selectionStartYear) query += `startYear=${this.data.selectionStartYear}&`;
            if (this.data.selectionEndYear) query += `endYear=${this.data.selectionEndYear}&`;
            const assetTypeIds = this.assetTypeList.filter((at)=>at.checked).map((at)=>at.id);
            if (assetTypeIds.length) query += `assetTypeIds=${assetTypeIds.join(",")}&`;
            const activityIds = this.assetTypeList.flatMap((at)=>{
                if (!at.checked) return [];
                const sel = at.activities.filter((a)=>a.checked).map((a)=>a.id);
                return sel.length ? sel : at.activities.map((a)=>a.id);
            });
            if (activityIds.length) query += `activityIds=${activityIds.join(",")}&`;
            var request = (0, $gxt0C.default).exportActivityPlanCsv(this.$route.params.id, this.$route.params.modelingResultId, query);
            window.open(request.url);
        },
        exportShp () {
            var query = "?";
            if (this.data.limit) query += `limitId=${this.data.limit}&`;
            if (this.data.selectionStartYear) query += `startYear=${this.data.selectionStartYear}&`;
            if (this.data.selectionEndYear) query += `endYear=${this.data.selectionEndYear}&`;
            const assetTypeIds = this.assetTypeList.filter((at)=>at.checked).map((at)=>at.id);
            if (assetTypeIds.length) query += `assetTypeIds=${assetTypeIds.join(",")}&`;
            const activityIds = this.assetTypeList.flatMap((at)=>{
                if (!at.checked) return [];
                const sel = at.activities.filter((a)=>a.checked).map((a)=>a.id);
                return sel.length ? sel : at.activities.map((a)=>a.id);
            });
            if (activityIds.length) query += `activityIds=${activityIds.join(",")}&`;
            var request = (0, $gxt0C.default).exportActivityPlanShp(this.$route.params.id, this.$route.params.modelingResultId, query);
            window.open(request.url);
        },
        async updateFeatures () {
            if (this.vectorLayer) this.vectorLayer.getSource().clear();
            if (!this.data.limit) {
                this.formLoading = false;
                return;
            }
            // vyfiltruj sekce
            const secs = this.filteredSections;
            var tableColumns = this.tableColumns;
            var tableData = [];
            var result = [];
            secs.forEach((section)=>{
                var record = this.recById["ds" + section.datasetId][section.objectid];
                //FIX: pokud nejsou vstupni data
                if (!record) return;
                result.push({
                    ...record,
                    ...section
                });
                const baseObject = {
                    objectid: section.objectid,
                    assetType: section.assetType,
                    assetValue: section.assetValue?.toFixed(2),
                    lifeCycle: section.lifeCycle,
                    ageValue: section.ageValue,
                    weightValue: section.weightValue?.toFixed(2),
                    coreBenefit: section.coreBenefit?.toFixed(2),
                    costFactor: section.costFactor?.toFixed(2),
                    annuity: section.annuity?.toFixed(2),
                    limit: section.limit,
                    group: section.group
                };
                section.infosets.forEach((prop)=>{
                    baseObject[prop.name] = prop.value;
                    if (!tableColumns.some((col)=>col.data == prop.name)) tableColumns.push({
                        title: prop.alias,
                        data: prop.name,
                        width: 100
                    });
                });
                if (section.activities.length > 1) section.activities.forEach((act)=>{
                    tableData.push({
                        ...baseObject,
                        name: act.name,
                        year: act.year,
                        age: act.age,
                        cost: act.cost,
                        package: act.package,
                        color: act.color,
                        assetPerformanceBefore: act.assetPerformanceBefore,
                        assetPerformanceAfter: act.assetPerformanceAfter
                    });
                });
                else {
                    const a = section.activities[0] || {};
                    tableData.push({
                        ...baseObject,
                        name: a.name || "",
                        year: a.year || "",
                        age: a.age || "",
                        cost: a.cost || "",
                        package: a.package || "",
                        color: a.color || "",
                        assetPerformanceBefore: a.assetPerformanceBefore,
                        assetPerformanceAfter: a.assetPerformanceAfter
                    });
                }
            });
            this.tableData = tableData;
            this.tableColumns = tableColumns;
            // vyčisti staré
            if (this.vectorLayer != null) {
                const src = this.vectorLayer.getSource();
                src.clear();
                // vytvoř nové
                const feats = (0, $ndRlY.getFeaturesFromSectionGeoJSON)(result, this.projection);
                src.addFeatures(feats);
            }
        },
        setPopupTableData () {
            var self = this;
            new (0, $bfIrw.default)(self.$refs["popUpDataTable"]).destroy();
            var currentSelectedFeature = self.selectedFeatures[self.selectedFeatureIndex - 1];
            var currentSelectedFeatureProperties = currentSelectedFeature.get("properties");
            var tmpDataTable = [];
            for(var property in currentSelectedFeatureProperties)tmpDataTable.push({
                name: property,
                value: currentSelectedFeatureProperties[property]
            });
            self.popUpDataTable = new (0, $bfIrw.default)(self.$refs["popUpDataTable"], {
                scrollY: "300px",
                scrollCollapse: true,
                paging: false,
                searching: false,
                info: false,
                columns: [
                    {
                        "data": "name",
                        "title": this.$t("attribute")
                    },
                    {
                        "data": "value",
                        "title": this.$t("value")
                    }
                ]
            }).clear().rows.add(tmpDataTable).draw();
        },
        adjustDt () {
            const api = this.$refs.dt?.dt;
            console.log(api, this);
            if (!api) return;
            api.columns.adjust();
        }
    },
    data () {
        return {
            renderMap: true,
            selectedFeatures: [],
            selectedFeatureIndex: 0,
            sections: [],
            select: null,
            map: null,
            data: {
                limit: null,
                evaluationMethod: null,
                selectionStartYear: null,
                selectionEndYear: null
            },
            tableColumns: [
                {
                    title: this.$t("group"),
                    data: "group",
                    width: 100
                },
                {
                    title: this.$t("limit"),
                    data: "limit",
                    width: 100
                },
                {
                    title: this.$t("at"),
                    data: "assetType",
                    width: 100
                },
                {
                    title: this.$t("recordId"),
                    data: "objectid",
                    width: 100
                },
                {
                    title: this.$t("assetType"),
                    data: "assetType",
                    width: 100
                },
                {
                    title: this.$t("lc"),
                    data: "lifeCycle",
                    width: 100
                },
                {
                    title: this.$t("assetPerformance"),
                    data: "assetValue",
                    width: 100
                },
                {
                    title: this.$t("ageValue"),
                    data: "ageValue",
                    width: 100
                },
                {
                    title: this.$t("assetWeight"),
                    data: "weightValue",
                    width: 100
                },
                {
                    title: this.$t("coreBenefit"),
                    data: "coreBenefit",
                    width: 100
                },
                {
                    title: this.$t("costFactor"),
                    data: "costFactor",
                    width: 100
                },
                {
                    title: this.$t("annuity"),
                    data: "annuity",
                    width: 100
                },
                {
                    title: this.$t("year"),
                    data: "year",
                    width: 100
                },
                {
                    title: this.$t("cost"),
                    data: "cost",
                    width: 100
                },
                {
                    title: this.$t("age"),
                    data: "age",
                    width: 100
                },
                {
                    title: this.$t("activity"),
                    data: "name",
                    width: 100
                },
                {
                    title: this.$t("package"),
                    data: "package",
                    width: 100
                },
                {
                    title: this.$t("performanceBefore"),
                    data: "assetPerformanceBefore",
                    width: 100
                },
                {
                    title: this.$t("performanceAfter"),
                    data: "assetPerformanceAfter",
                    width: 100
                }
            ],
            tableData: [],
            recById: {},
            tableOptions: {
                fixedHeader: {
                    header: false,
                    footer: true
                },
                scrollX: true,
                scrollY: 350,
                order: [
                    0,
                    "desc"
                ]
            },
            chartConfigs: [],
            limitList: [],
            assetTypeList: [],
            activityList: [],
            activityPlanProperties: [],
            mapCenter: "",
            pending: true,
            vectorLayer: null,
            projection: 'GEOGCS["WGS 84", DATUM["World Geodetic System 1984", SPHEROID["WGS 84", 6378137.0, 298.257223563, AUTHORITY["EPSG","7030"]], AUTHORITY["EPSG","6326"]], PRIMEM["Greenwich", 0.0, AUTHORITY["EPSG","8901"]], UNIT["degree", 0.017453292519943295], AXIS["Geodetic longitude", EAST], AXIS["Geodetic latitude", NORTH], AUTHORITY["EPSG","4326"]]',
            isUserAdmin: false,
            modelingName: "",
            legendControl: null,
            legendItems: []
        };
    }
};

});
parcelRegister("fihz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9931269ce75cf917$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
var $eeJ70 = parcelRequire("eeJ70");
const $9931269ce75cf917$var$w = [
    "childRow",
    "column-sizing",
    "column-visibility",
    "destroy",
    "draw",
    "error",
    "init",
    "length",
    "order",
    "page",
    "preDraw",
    "preInit",
    "preXhr",
    "processing",
    "requestChild",
    "search",
    "stateLoadParams",
    "stateLoaded",
    "stateSaveParams",
    "xhr",
    "autoFill",
    "preAutoFill",
    "buttons-action",
    "buttons-processing",
    "column-reorder",
    "key",
    "key-blur",
    "key-focus",
    "key-refocus",
    "key-return-submit",
    "responsive-display",
    "responsive-resize",
    "rowgroup-datasrc",
    "pre-row-reorder",
    "row-reorder",
    "row-reordered",
    "dtsb-inserted",
    "deselect",
    "select",
    "select-blur",
    "selectItems",
    "selectStyle",
    "user-select",
    "stateRestore-change"
];
let $9931269ce75cf917$var$m;
const $9931269ce75cf917$var$C = {
    name: "Datatables.netVue",
    inheritAttrs: !1,
    use (u) {
        $9931269ce75cf917$var$m = u;
    }
}, $9931269ce75cf917$export$df30df7ec97b32b5 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    ...$9931269ce75cf917$var$C,
    props: {
        ajax: null,
        columns: null,
        data: null,
        options: null
    },
    emits: $9931269ce75cf917$var$w,
    setup (u, { expose: d }) {
        const o = u, y = (0, $01W3b.ref)(null), i = {}, s = (0, $01W3b.ref)(), k = (0, $01W3b.ref)([]);
        (0, $TusQn.watch)(()=>o.data, (t)=>{
            let e = s.value;
            if (e) {
                for(var n = Object.keys(i), l = 0; l < n.length; l++)delete i[n[l]];
                e.clear(), e.rows.add(t).draw(!1);
            }
        }, {
            deep: !0
        }), (0, $TusQn.onMounted)(()=>{
            var n, l;
            const t = (0, $TusQn.getCurrentInstance)();
            let e = o.options || {};
            if (o.data && (e.data = o.data, D(e.data)), o.columns && (e.columns = o.columns, b(e.columns, t)), o.ajax && (e.ajax = o.ajax), e.columnDefs || (e.columnDefs = []), t) {
                let r = Object.keys(t.slots);
                for(let a = 0; a < r.length; a++){
                    let c = r[a];
                    if (c.match(/^column\-/)) {
                        let f = c.replace("column-", "");
                        e.columnDefs.push({
                            target: f.match(/^\d+$/) ? parseInt(f) : f + ":name",
                            render: "#" + c
                        });
                    }
                }
                b(e.columnDefs, t);
            }
            if (!$9931269ce75cf917$var$m) throw new Error("DataTables library not set. See https://datatables.net/tn/19 for details.");
            s.value = new $9931269ce75cf917$var$m((0, $01W3b.unref)(y), e), (n = s.value) != null && n.page.info().serverSide && ((l = s.value) == null || l.on("preDraw", function() {
                let r = Object.keys(i);
                for(var a = 0; a < r.length; a++)delete i[r[a]];
            }));
            for (let r of $9931269ce75cf917$var$w)s.value && t && s.value.on(r, function() {
                var a = Array.from(arguments), c = a.shift();
                a.unshift({
                    event: c,
                    dt: s
                }), a.unshift(r), t.emit.apply(t, a);
            });
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            var t;
            (t = s.value) == null || t.destroy(!0);
        });
        function D(t) {
            k.value = t.value ? t.value.slice() : t.slice();
        }
        function v(t) {
            return function(e, n, l, r) {
                let a = r.row + "," + r.col;
                if (!i[a]) {
                    let c = (0, $TusQn.h)("div", t({
                        cellData: e,
                        colIndex: r.col,
                        rowData: l,
                        rowIndex: r.row,
                        type: n
                    }));
                    i[a] = document.createElement("div"), (0, $eeJ70.render)(c, i[a]);
                }
                return i[a];
            };
        }
        function b(t, e) {
            if (e) for(let l = 0; l < t.length; l++){
                let r = t[l];
                if (typeof r.render == "string" && r.render.charAt(0) === "#") {
                    var n = r.render.replace("#", "");
                    e.slots[n] && (r.render = v(e.slots[n]));
                } else if (typeof r.render == "object" && typeof r.render.display == "string" && r.render.display.charAt(0) === "#") {
                    var n = r.render.display.replace("#", "");
                    e.slots[n] && (r.render.display = v(e.slots[n]));
                }
            }
        }
        return d({
            dt: s
        }), (t, e)=>e[0] || ((0, $TusQn.setBlockTracking)(-1), e[0] = (0, $TusQn.createElementVNode)("div", {
                class: "datatable"
            }, [
                (0, $TusQn.createElementVNode)("table", (0, $TusQn.mergeProps)({
                    ref_key: "table",
                    ref: y
                }, t.$attrs, {
                    style: {
                        width: "100%"
                    }
                }), [
                    (0, $TusQn.renderSlot)(t.$slots, "default")
                ], 16)
            ]), (0, $TusQn.setBlockTracking)(1), e[0]);
    }
}), $9931269ce75cf917$export$2e2bcd8739ae039 = /* @__PURE__ */ (()=>{
    const u = $9931269ce75cf917$export$df30df7ec97b32b5;
    return u.install = (d)=>{
        d.component("Datatables.netVue", u);
    }, u;
})();

});

parcelRegister("bfIrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $420c57962e03702d$export$2e2bcd8739ae039);
/*! DataTables 2.0.7
 * © SpryMedia Ltd - datatables.net/license
 */ 
var $6KOho = parcelRequire("6KOho");
// DataTables code uses $ internally, but we want to be able to
// reassign $ with the `use` method, so it is a regular var.
var $420c57962e03702d$var$$ = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)));
var $420c57962e03702d$var$DataTable = function(selector, options) {
    // Check if called with a window or jQuery object for DOM less applications
    // This is for backwards compatibility
    if ($420c57962e03702d$var$DataTable.factory(selector, options)) return $420c57962e03702d$var$DataTable;
    // When creating with `new`, create a new DataTable, returning the API instance
    if (this instanceof $420c57962e03702d$var$DataTable) return $420c57962e03702d$var$$(selector).DataTable(options);
    else // Argument switching
    options = selector;
    var _that = this;
    var emptyInit = options === undefined;
    var len = this.length;
    if (emptyInit) options = {};
    // Method to get DT API instance from jQuery object
    this.api = function() {
        return new $420c57962e03702d$var$_Api(this);
    };
    this.each(function() {
        // For each initialisation we want to give it a clean initialisation
        // object that can be bashed around
        var o = {};
        var oInit = len > 1 ? $420c57962e03702d$var$_fnExtend(o, options, true) : options;
        var i = 0, iLen;
        var sId = this.getAttribute("id");
        var bInitHandedOff = false;
        var defaults = $420c57962e03702d$var$DataTable.defaults;
        var $this = $420c57962e03702d$var$$(this);
        /* Sanity check */ if (this.nodeName.toLowerCase() != "table") {
            $420c57962e03702d$var$_fnLog(null, 0, "Non-table node initialisation (" + this.nodeName + ")", 2);
            return;
        }
        $420c57962e03702d$var$$(this).trigger("options.dt", oInit);
        /* Backwards compatibility for the defaults */ $420c57962e03702d$var$_fnCompatOpts(defaults);
        $420c57962e03702d$var$_fnCompatCols(defaults.column);
        /* Convert the camel-case defaults to Hungarian */ $420c57962e03702d$var$_fnCamelToHungarian(defaults, defaults, true);
        $420c57962e03702d$var$_fnCamelToHungarian(defaults.column, defaults.column, true);
        /* Setting up the initialisation object */ $420c57962e03702d$var$_fnCamelToHungarian(defaults, $420c57962e03702d$var$$.extend(oInit, $this.data()), true);
        /* Check to see if we are re-initialising a table */ var allSettings = $420c57962e03702d$var$DataTable.settings;
        for(i = 0, iLen = allSettings.length; i < iLen; i++){
            var s = allSettings[i];
            /* Base check on table node */ if (s.nTable == this || s.nTHead && s.nTHead.parentNode == this || s.nTFoot && s.nTFoot.parentNode == this) {
                var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
                var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
                if (emptyInit || bRetrieve) return s.oInstance;
                else if (bDestroy) {
                    new $420c57962e03702d$var$DataTable.Api(s).destroy();
                    break;
                } else {
                    $420c57962e03702d$var$_fnLog(s, 0, "Cannot reinitialise DataTable", 3);
                    return;
                }
            }
            /* If the element we are initialising has the same ID as a table which was previously
			 * initialised, but the table nodes don't match (from before) then we destroy the old
			 * instance by simply deleting it. This is under the assumption that the table has been
			 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
			 */ if (s.sTableId == this.id) {
                allSettings.splice(i, 1);
                break;
            }
        }
        /* Ensure the table has an ID - required for accessibility */ if (sId === null || sId === "") {
            sId = "DataTables_Table_" + $420c57962e03702d$var$DataTable.ext._unique++;
            this.id = sId;
        }
        /* Create the settings object for this table and set some of the default parameters */ var oSettings = $420c57962e03702d$var$$.extend(true, {}, $420c57962e03702d$var$DataTable.models.oSettings, {
            "sDestroyWidth": $this[0].style.width,
            "sInstance": sId,
            "sTableId": sId,
            colgroup: $420c57962e03702d$var$$("<colgroup>").prependTo(this),
            fastData: function(row, column, type) {
                return $420c57962e03702d$var$_fnGetCellData(oSettings, row, column, type);
            }
        });
        oSettings.nTable = this;
        oSettings.oInit = oInit;
        allSettings.push(oSettings);
        // Make a single API instance available for internal handling
        oSettings.api = new $420c57962e03702d$var$_Api(oSettings);
        // Need to add the instance after the instance after the settings object has been added
        // to the settings array, so we can self reference the table instance if more than one
        oSettings.oInstance = _that.length === 1 ? _that : $this.dataTable();
        // Backwards compatibility, before we apply all the defaults
        $420c57962e03702d$var$_fnCompatOpts(oInit);
        // If the length menu is given, but the init display length is not, use the length menu
        if (oInit.aLengthMenu && !oInit.iDisplayLength) oInit.iDisplayLength = Array.isArray(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0][0] : $420c57962e03702d$var$$.isPlainObject(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0].value : oInit.aLengthMenu[0];
        // Apply the defaults and init options to make a single init object will all
        // options defined from defaults and instance options.
        oInit = $420c57962e03702d$var$_fnExtend($420c57962e03702d$var$$.extend(true, {}, defaults), oInit);
        // Map the initialisation options onto the settings object
        $420c57962e03702d$var$_fnMap(oSettings.oFeatures, oInit, [
            "bPaginate",
            "bLengthChange",
            "bFilter",
            "bSort",
            "bSortMulti",
            "bInfo",
            "bProcessing",
            "bAutoWidth",
            "bSortClasses",
            "bServerSide",
            "bDeferRender"
        ]);
        $420c57962e03702d$var$_fnMap(oSettings, oInit, [
            "ajax",
            "fnFormatNumber",
            "sServerMethod",
            "aaSorting",
            "aaSortingFixed",
            "aLengthMenu",
            "sPaginationType",
            "iStateDuration",
            "bSortCellsTop",
            "iTabIndex",
            "sDom",
            "fnStateLoadCallback",
            "fnStateSaveCallback",
            "renderer",
            "searchDelay",
            "rowId",
            "caption",
            "layout",
            [
                "iCookieDuration",
                "iStateDuration"
            ],
            [
                "oSearch",
                "oPreviousSearch"
            ],
            [
                "aoSearchCols",
                "aoPreSearchCols"
            ],
            [
                "iDisplayLength",
                "_iDisplayLength"
            ]
        ]);
        $420c57962e03702d$var$_fnMap(oSettings.oScroll, oInit, [
            [
                "sScrollX",
                "sX"
            ],
            [
                "sScrollXInner",
                "sXInner"
            ],
            [
                "sScrollY",
                "sY"
            ],
            [
                "bScrollCollapse",
                "bCollapse"
            ]
        ]);
        $420c57962e03702d$var$_fnMap(oSettings.oLanguage, oInit, "fnInfoCallback");
        /* Callback functions which are array driven */ $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoDrawCallback", oInit.fnDrawCallback);
        $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoStateSaveParams", oInit.fnStateSaveParams);
        $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoStateLoadParams", oInit.fnStateLoadParams);
        $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoStateLoaded", oInit.fnStateLoaded);
        $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoRowCallback", oInit.fnRowCallback);
        $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoRowCreatedCallback", oInit.fnCreatedRow);
        $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoHeaderCallback", oInit.fnHeaderCallback);
        $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoFooterCallback", oInit.fnFooterCallback);
        $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoInitComplete", oInit.fnInitComplete);
        $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoPreDrawCallback", oInit.fnPreDrawCallback);
        oSettings.rowIdFn = $420c57962e03702d$var$_fnGetObjectDataFn(oInit.rowId);
        /* Browser support detection */ $420c57962e03702d$var$_fnBrowserDetect(oSettings);
        var oClasses = oSettings.oClasses;
        $420c57962e03702d$var$$.extend(oClasses, $420c57962e03702d$var$DataTable.ext.classes, oInit.oClasses);
        $this.addClass(oClasses.table);
        if (!oSettings.oFeatures.bPaginate) oInit.iDisplayStart = 0;
        if (oSettings.iInitDisplayStart === undefined) {
            /* Display start point, taking into account the save saving */ oSettings.iInitDisplayStart = oInit.iDisplayStart;
            oSettings._iDisplayStart = oInit.iDisplayStart;
        }
        /* Language definitions */ var oLanguage = oSettings.oLanguage;
        $420c57962e03702d$var$$.extend(true, oLanguage, oInit.oLanguage);
        if (oLanguage.sUrl) {
            /* Get the language definitions from a file - because this Ajax call makes the language
			 * get async to the remainder of this function we use bInitHandedOff to indicate that
			 * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
			 */ $420c57962e03702d$var$$.ajax({
                dataType: "json",
                url: oLanguage.sUrl,
                success: function(json) {
                    $420c57962e03702d$var$_fnCamelToHungarian(defaults.oLanguage, json);
                    $420c57962e03702d$var$$.extend(true, oLanguage, json, oSettings.oInit.oLanguage);
                    $420c57962e03702d$var$_fnCallbackFire(oSettings, null, "i18n", [
                        oSettings
                    ], true);
                    $420c57962e03702d$var$_fnInitialise(oSettings);
                },
                error: function() {
                    // Error occurred loading language file
                    $420c57962e03702d$var$_fnLog(oSettings, 0, "i18n file loading error", 21);
                    // continue on as best we can
                    $420c57962e03702d$var$_fnInitialise(oSettings);
                }
            });
            bInitHandedOff = true;
        } else $420c57962e03702d$var$_fnCallbackFire(oSettings, null, "i18n", [
            oSettings
        ]);
        /*
		 * Columns
		 * See if we should load columns automatically or use defined ones
		 */ var columnsInit = [];
        var thead = this.getElementsByTagName("thead");
        var initHeaderLayout = $420c57962e03702d$var$_fnDetectHeader(oSettings, thead[0]);
        // If we don't have a columns array, then generate one with nulls
        if (oInit.aoColumns) columnsInit = oInit.aoColumns;
        else if (initHeaderLayout.length) for(i = 0, iLen = initHeaderLayout[0].length; i < iLen; i++)columnsInit.push(null);
        // Add the columns
        for(i = 0, iLen = columnsInit.length; i < iLen; i++)$420c57962e03702d$var$_fnAddColumn(oSettings);
        // Apply the column definitions
        $420c57962e03702d$var$_fnApplyColumnDefs(oSettings, oInit.aoColumnDefs, columnsInit, initHeaderLayout, function(iCol, oDef) {
            $420c57962e03702d$var$_fnColumnOptions(oSettings, iCol, oDef);
        });
        /* HTML5 attribute detection - build an mData object automatically if the
		 * attributes are found
		 */ var rowOne = $this.children("tbody").find("tr").eq(0);
        if (rowOne.length) {
            var a = function(cell, name) {
                return cell.getAttribute("data-" + name) !== null ? name : null;
            };
            $420c57962e03702d$var$$(rowOne[0]).children("th, td").each(function(i, cell) {
                var col = oSettings.aoColumns[i];
                if (!col) $420c57962e03702d$var$_fnLog(oSettings, 0, "Incorrect column count", 18);
                if (col.mData === i) {
                    var sort = a(cell, "sort") || a(cell, "order");
                    var filter = a(cell, "filter") || a(cell, "search");
                    if (sort !== null || filter !== null) {
                        col.mData = {
                            _: i + ".display",
                            sort: sort !== null ? i + ".@data-" + sort : undefined,
                            type: sort !== null ? i + ".@data-" + sort : undefined,
                            filter: filter !== null ? i + ".@data-" + filter : undefined
                        };
                        col._isArrayHost = true;
                        $420c57962e03702d$var$_fnColumnOptions(oSettings, i);
                    }
                }
            });
        }
        var features = oSettings.oFeatures;
        var loadedInit = function() {
            /*
			 * Sorting
			 * @todo For modularisation (1.11) this needs to do into a sort start up handler
			 */ // If aaSorting is not defined, then we use the first indicator in asSorting
            // in case that has been altered, so the default sort reflects that option
            if (oInit.aaSorting === undefined) {
                var sorting = oSettings.aaSorting;
                for(i = 0, iLen = sorting.length; i < iLen; i++)sorting[i][1] = oSettings.aoColumns[i].asSorting[0];
            }
            /* Do a first pass on the sorting classes (allows any size changes to be taken into
			 * account, and also will apply sorting disabled classes if disabled
			 */ $420c57962e03702d$var$_fnSortingClasses(oSettings);
            $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoDrawCallback", function() {
                if (oSettings.bSorted || $420c57962e03702d$var$_fnDataSource(oSettings) === "ssp" || features.bDeferRender) $420c57962e03702d$var$_fnSortingClasses(oSettings);
            });
            /*
			 * Final init
			 * Cache the header, body and footer as required, creating them if needed
			 */ var caption = $this.children("caption");
            if (oSettings.caption) {
                if (caption.length === 0) caption = $420c57962e03702d$var$$("<caption/>").appendTo($this);
                caption.html(oSettings.caption);
            }
            // Store the caption side, so we can remove the element from the document
            // when creating the element
            if (caption.length) {
                caption[0]._captionSide = caption.css("caption-side");
                oSettings.captionNode = caption[0];
            }
            if (thead.length === 0) thead = $420c57962e03702d$var$$("<thead/>").appendTo($this);
            oSettings.nTHead = thead[0];
            $420c57962e03702d$var$$("tr", thead).addClass(oClasses.thead.row);
            var tbody = $this.children("tbody");
            if (tbody.length === 0) tbody = $420c57962e03702d$var$$("<tbody/>").insertAfter(thead);
            oSettings.nTBody = tbody[0];
            var tfoot = $this.children("tfoot");
            if (tfoot.length === 0) // If we are a scrolling table, and no footer has been given, then we need to create
            // a tfoot element for the caption element to be appended to
            tfoot = $420c57962e03702d$var$$("<tfoot/>").appendTo($this);
            oSettings.nTFoot = tfoot[0];
            $420c57962e03702d$var$$("tr", tfoot).addClass(oClasses.tfoot.row);
            // Check if there is data passing into the constructor
            if (oInit.aaData) for(i = 0; i < oInit.aaData.length; i++)$420c57962e03702d$var$_fnAddData(oSettings, oInit.aaData[i]);
            else if ($420c57962e03702d$var$_fnDataSource(oSettings) == "dom") // Grab the data from the page
            $420c57962e03702d$var$_fnAddTr(oSettings, $420c57962e03702d$var$$(oSettings.nTBody).children("tr"));
            /* Copy the data index array */ oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
            /* Initialisation complete - table can be drawn */ oSettings.bInitialised = true;
            /* Check if we need to initialise the table (it might not have been handed off to the
			 * language processor)
			 */ if (bInitHandedOff === false) $420c57962e03702d$var$_fnInitialise(oSettings);
        };
        /* Must be done after everything which can be overridden by the state saving! */ $420c57962e03702d$var$_fnCallbackReg(oSettings, "aoDrawCallback", $420c57962e03702d$var$_fnSaveState);
        if (oInit.bStateSave) {
            features.bStateSave = true;
            $420c57962e03702d$var$_fnLoadState(oSettings, oInit, loadedInit);
        } else loadedInit();
    });
    _that = null;
    return this;
};
/**
 * DataTables extensions
 * 
 * This namespace acts as a collection area for plug-ins that can be used to
 * extend DataTables capabilities. Indeed many of the build in methods
 * use this method to provide their own capabilities (sorting methods for
 * example).
 *
 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
 * reasons
 *
 *  @namespace
 */ $420c57962e03702d$var$DataTable.ext = $420c57962e03702d$var$_ext = {
    /**
	 * Buttons. For use with the Buttons extension for DataTables. This is
	 * defined here so other extensions can define buttons regardless of load
	 * order. It is _not_ used by DataTables core.
	 *
	 *  @type object
	 *  @default {}
	 */ buttons: {},
    /**
	 * Element class names
	 *
	 *  @type object
	 *  @default {}
	 */ classes: {},
    /**
	 * DataTables build type (expanded by the download builder)
	 *
	 *  @type string
	 */ builder: "-source-",
    /**
	 * Error reporting.
	 * 
	 * How should DataTables report an error. Can take the value 'alert',
	 * 'throw', 'none' or a function.
	 *
	 *  @type string|function
	 *  @default alert
	 */ errMode: "alert",
    /**
	 * Legacy so v1 plug-ins don't throw js errors on load
	 */ feature: [],
    /**
	 * Feature plug-ins.
	 * 
	 * This is an object of callbacks which provide the features for DataTables
	 * to be initialised via the `layout` option.
	 */ features: {},
    /**
	 * Row searching.
	 * 
	 * This method of searching is complimentary to the default type based
	 * searching, and a lot more comprehensive as it allows you complete control
	 * over the searching logic. Each element in this array is a function
	 * (parameters described below) that is called for every row in the table,
	 * and your logic decides if it should be included in the searching data set
	 * or not.
	 *
	 * Searching functions have the following input parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{array|object}` Data for the row to be processed (same as the
	 *    original format that was passed in as the data source, or an array
	 *    from a DOM data source
	 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
	 *    can be useful to retrieve the `TR` element if you need DOM interaction.
	 *
	 * And the following return is expected:
	 *
	 * * {boolean} Include the row in the searched result set (true) or not
	 *   (false)
	 *
	 * Note that as with the main search ability in DataTables, technically this
	 * is "filtering", since it is subtractive. However, for consistency in
	 * naming we call it searching here.
	 *
	 *  @type array
	 *  @default []
	 *
	 *  @example
	 *    // The following example shows custom search being applied to the
	 *    // fourth column (i.e. the data[3] index) based on two input values
	 *    // from the end-user, matching the data in a certain range.
	 *    $.fn.dataTable.ext.search.push(
	 *      function( settings, data, dataIndex ) {
	 *        var min = document.getElementById('min').value * 1;
	 *        var max = document.getElementById('max').value * 1;
	 *        var version = data[3] == "-" ? 0 : data[3]*1;
	 *
	 *        if ( min == "" && max == "" ) {
	 *          return true;
	 *        }
	 *        else if ( min == "" && version < max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && "" == max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && version < max ) {
	 *          return true;
	 *        }
	 *        return false;
	 *      }
	 *    );
	 */ search: [],
    /**
	 * Selector extensions
	 *
	 * The `selector` option can be used to extend the options available for the
	 * selector modifier options (`selector-modifier` object data type) that
	 * each of the three built in selector types offer (row, column and cell +
	 * their plural counterparts). For example the Select extension uses this
	 * mechanism to provide an option to select only rows, columns and cells
	 * that have been marked as selected by the end user (`{selected: true}`),
	 * which can be used in conjunction with the existing built in selector
	 * options.
	 *
	 * Each property is an array to which functions can be pushed. The functions
	 * take three attributes:
	 *
	 * * Settings object for the host table
	 * * Options object (`selector-modifier` object type)
	 * * Array of selected item indexes
	 *
	 * The return is an array of the resulting item indexes after the custom
	 * selector has been applied.
	 *
	 *  @type object
	 */ selector: {
        cell: [],
        column: [],
        row: []
    },
    /**
	 * Legacy configuration options. Enable and disable legacy options that
	 * are available in DataTables.
	 *
	 *  @type object
	 */ legacy: {
        /**
		 * Enable / disable DataTables 1.9 compatible server-side processing
		 * requests
		 *
		 *  @type boolean
		 *  @default null
		 */ ajax: null
    },
    /**
	 * Pagination plug-in methods.
	 * 
	 * Each entry in this object is a function and defines which buttons should
	 * be shown by the pagination rendering method that is used for the table:
	 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
	 * buttons are displayed in the document, while the functions here tell it
	 * what buttons to display. This is done by returning an array of button
	 * descriptions (what each button will do).
	 *
	 * Pagination types (the four built in options and any additional plug-in
	 * options defined here) can be used through the `paginationType`
	 * initialisation parameter.
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{int} page` The current page index
	 * 2. `{int} pages` The number of pages in the table
	 *
	 * Each function is expected to return an array where each element of the
	 * array can be one of:
	 *
	 * * `first` - Jump to first page when activated
	 * * `last` - Jump to last page when activated
	 * * `previous` - Show previous page when activated
	 * * `next` - Show next page when activated
	 * * `{int}` - Show page of the index given
	 * * `{array}` - A nested array containing the above elements to add a
	 *   containing 'DIV' element (might be useful for styling).
	 *
	 * Note that DataTables v1.9- used this object slightly differently whereby
	 * an object with two functions would be defined for each plug-in. That
	 * ability is still supported by DataTables 1.10+ to provide backwards
	 * compatibility, but this option of use is now decremented and no longer
	 * documented in DataTables 1.10+.
	 *
	 *  @type object
	 *  @default {}
	 *
	 *  @example
	 *    // Show previous, next and current page buttons only
	 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
	 *      return [ 'previous', page, 'next' ];
	 *    };
	 */ pager: {},
    renderer: {
        pageButton: {},
        header: {}
    },
    /**
	 * Ordering plug-ins - custom data source
	 * 
	 * The extension options for ordering of data available here is complimentary
	 * to the default type based ordering that DataTables typically uses. It
	 * allows much greater control over the the data that is being used to
	 * order a column, but is necessarily therefore more complex.
	 * 
	 * This type of ordering is useful if you want to do ordering based on data
	 * live from the DOM (for example the contents of an 'input' element) rather
	 * than just the static string that DataTables knows of.
	 * 
	 * The way these plug-ins work is that you create an array of the values you
	 * wish to be ordering for the column in question and then return that
	 * array. The data in the array much be in the index order of the rows in
	 * the table (not the currently ordering order!). Which order data gathering
	 * function is run here depends on the `dt-init columns.orderDataType`
	 * parameter that is used for the column (if any).
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{int}` Target column index
	 *
	 * Each function is expected to return an array:
	 *
	 * * `{array}` Data for the column to be ordering upon
	 *
	 *  @type array
	 *
	 *  @example
	 *    // Ordering using `input` node values
	 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
	 *    {
	 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
	 *        return $('input', td).val();
	 *      } );
	 *    }
	 */ order: {},
    /**
	 * Type based plug-ins.
	 *
	 * Each column in DataTables has a type assigned to it, either by automatic
	 * detection or by direct assignment using the `type` option for the column.
	 * The type of a column will effect how it is ordering and search (plug-ins
	 * can also make use of the column type if required).
	 *
	 * @namespace
	 */ type: {
        /**
		 * Automatic column class assignment
		 */ className: {},
        /**
		 * Type detection functions.
		 *
		 * The functions defined in this object are used to automatically detect
		 * a column's type, making initialisation of DataTables super easy, even
		 * when complex data is in the table.
		 *
		 * The functions defined take two parameters:
		 *
	     *  1. `{*}` Data from the column cell to be analysed
	     *  2. `{settings}` DataTables settings object. This can be used to
	     *     perform context specific type detection - for example detection
	     *     based on language settings such as using a comma for a decimal
	     *     place. Generally speaking the options from the settings will not
	     *     be required
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Data type detected, or null if unknown (and thus
		 *   pass it on to the other type detection functions.
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Currency type detection plug-in:
		 *    $.fn.dataTable.ext.type.detect.push(
		 *      function ( data, settings ) {
		 *        // Check the numeric part
		 *        if ( ! data.substring(1).match(/[0-9]/) ) {
		 *          return null;
		 *        }
		 *
		 *        // Check prefixed by currency
		 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
		 *          return 'currency';
		 *        }
		 *        return null;
		 *      }
		 *    );
		 */ detect: [],
        /**
		 * Automatic renderer assignment
		 */ render: {},
        /**
		 * Type based search formatting.
		 *
		 * The type based searching functions can be used to pre-format the
		 * data to be search on. For example, it can be used to strip HTML
		 * tags or to de-format telephone numbers for numeric only searching.
		 *
		 * Note that is a search is not defined for a column of a given type,
		 * no search formatting will be performed.
		 * 
		 * Pre-processing of searching data plug-ins - When you assign the sType
		 * for a column (or have it automatically detected for you by DataTables
		 * or a type detection plug-in), you will typically be using this for
		 * custom sorting, but it can also be used to provide custom searching
		 * by allowing you to pre-processing the data and returning the data in
		 * the format that should be searched upon. This is done by adding
		 * functions this object with a parameter name which matches the sType
		 * for that target column. This is the corollary of <i>afnSortData</i>
		 * for searching data.
		 *
		 * The functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for searching
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Formatted string that will be used for the searching.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
		 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
		 *    }
		 */ search: {},
        /**
		 * Type based ordering.
		 *
		 * The column type tells DataTables what ordering to apply to the table
		 * when a column is sorted upon. The order for each type that is defined,
		 * is defined by the functions available in this object.
		 *
		 * Each ordering option can be described by three properties added to
		 * this object:
		 *
		 * * `{type}-pre` - Pre-formatting function
		 * * `{type}-asc` - Ascending order function
		 * * `{type}-desc` - Descending order function
		 *
		 * All three can be used together, only `{type}-pre` or only
		 * `{type}-asc` and `{type}-desc` together. It is generally recommended
		 * that only `{type}-pre` is used, as this provides the optimal
		 * implementation in terms of speed, although the others are provided
		 * for compatibility with existing Javascript sort functions.
		 *
		 * `{type}-pre`: Functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for ordering
		 *
		 * And return:
		 *
		 * * `{*}` Data to be sorted upon
		 *
		 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
		 * functions, taking two parameters:
		 *
	     *  1. `{*}` Data to compare to the second parameter
	     *  2. `{*}` Data to compare to the first parameter
		 *
		 * And returning:
		 *
		 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
		 *   than the second parameter, ===0 if the two parameters are equal and
		 *   >0 if the first parameter should be sorted height than the second
		 *   parameter.
		 * 
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Numeric ordering of formatted numbers with a pre-formatter
		 *    $.extend( $.fn.dataTable.ext.type.order, {
		 *      "string-pre": function(x) {
		 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
		 *        return parseFloat( a );
		 *      }
		 *    } );
		 *
		 *  @example
		 *    // Case-sensitive string ordering, with no pre-formatting method
		 *    $.extend( $.fn.dataTable.ext.order, {
		 *      "string-case-asc": function(x,y) {
		 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		 *      },
		 *      "string-case-desc": function(x,y) {
		 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
		 *      }
		 *    } );
		 */ order: {}
    },
    /**
	 * Unique DataTables instance counter
	 *
	 * @type int
	 * @private
	 */ _unique: 0,
    //
    // Depreciated
    // The following properties are retained for backwards compatibility only.
    // The should not be used in new projects and will be removed in a future
    // version
    //
    /**
	 * Version check function.
	 *  @type function
	 *  @depreciated Since 1.10
	 */ fnVersionCheck: $420c57962e03702d$var$DataTable.fnVersionCheck,
    /**
	 * Index for what 'this' index API functions should use
	 *  @type int
	 *  @deprecated Since v1.10
	 */ iApiIndex: 0,
    /**
	 * Software version
	 *  @type string
	 *  @deprecated Since v1.10
	 */ sVersion: $420c57962e03702d$var$DataTable.version
};
//
// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
//
$420c57962e03702d$var$$.extend($420c57962e03702d$var$_ext, {
    afnFiltering: $420c57962e03702d$var$_ext.search,
    aTypes: $420c57962e03702d$var$_ext.type.detect,
    ofnSearch: $420c57962e03702d$var$_ext.type.search,
    oSort: $420c57962e03702d$var$_ext.type.order,
    afnSortData: $420c57962e03702d$var$_ext.order,
    aoFeatures: $420c57962e03702d$var$_ext.feature,
    oStdClasses: $420c57962e03702d$var$_ext.classes,
    oPagination: $420c57962e03702d$var$_ext.pager
});
$420c57962e03702d$var$$.extend($420c57962e03702d$var$DataTable.ext.classes, {
    container: "dt-container",
    empty: {
        row: "dt-empty"
    },
    info: {
        container: "dt-info"
    },
    length: {
        container: "dt-length",
        select: "dt-input"
    },
    order: {
        canAsc: "dt-orderable-asc",
        canDesc: "dt-orderable-desc",
        isAsc: "dt-ordering-asc",
        isDesc: "dt-ordering-desc",
        none: "dt-orderable-none",
        position: "sorting_"
    },
    processing: {
        container: "dt-processing"
    },
    scrolling: {
        body: "dt-scroll-body",
        container: "dt-scroll",
        footer: {
            self: "dt-scroll-foot",
            inner: "dt-scroll-footInner"
        },
        header: {
            self: "dt-scroll-head",
            inner: "dt-scroll-headInner"
        }
    },
    search: {
        container: "dt-search",
        input: "dt-input"
    },
    table: "dataTable",
    tbody: {
        cell: "",
        row: ""
    },
    thead: {
        cell: "",
        row: ""
    },
    tfoot: {
        cell: "",
        row: ""
    },
    paging: {
        active: "current",
        button: "dt-paging-button",
        container: "dt-paging",
        disabled: "disabled"
    }
});
/*
 * It is useful to have variables which are scoped locally so only the
 * DataTables functions can access them and they don't leak into global space.
 * At the same time these functions are often useful over multiple files in the
 * core and API, so we list, or at least document, all variables which are used
 * by DataTables as private variables here. This also ensures that there is no
 * clashing of variable names and that they can easily referenced for reuse.
 */ // Defined else where
//  _selector_run
//  _selector_opts
//  _selector_row_indexes
var $420c57962e03702d$var$_ext; // DataTable.ext
var $420c57962e03702d$var$_Api; // DataTable.Api
var $420c57962e03702d$var$_api_register; // DataTable.Api.register
var $420c57962e03702d$var$_api_registerPlural; // DataTable.Api.registerPlural
var $420c57962e03702d$var$_re_dic = {};
var $420c57962e03702d$var$_re_new_lines = /[\r\n\u2028]/g;
var $420c57962e03702d$var$_re_html = /<([^>]*>)/g;
var $420c57962e03702d$var$_max_str_len = Math.pow(2, 28);
// This is not strict ISO8601 - Date.parse() is quite lax, although
// implementations differ between browsers.
var $420c57962e03702d$var$_re_date = /^\d{2,4}[./-]\d{1,2}[./-]\d{1,2}([T ]{1}\d{1,2}[:.]\d{2}([.:]\d{2})?)?$/;
// Escape regular expression special characters
var $420c57962e03702d$var$_re_escape_regex = new RegExp("(\\" + [
    "/",
    ".",
    "*",
    "+",
    "?",
    "|",
    "(",
    ")",
    "[",
    "]",
    "{",
    "}",
    "\\",
    "$",
    "^",
    "-"
].join("|\\") + ")", "g");
// https://en.wikipedia.org/wiki/Foreign_exchange_market
// - \u20BD - Russian ruble.
// - \u20a9 - South Korean Won
// - \u20BA - Turkish Lira
// - \u20B9 - Indian Rupee
// - R - Brazil (R$) and South Africa
// - fr - Swiss Franc
// - kr - Swedish krona, Norwegian krone and Danish krone
// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
// - Ƀ - Bitcoin
// - Ξ - Ethereum
//   standards as thousands separators.
var $420c57962e03702d$var$_re_formatted_numeric = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;
var $420c57962e03702d$var$_empty = function(d) {
    return !d || d === true || d === "-" ? true : false;
};
var $420c57962e03702d$var$_intVal = function(s) {
    var integer = parseInt(s, 10);
    return !isNaN(integer) && isFinite(s) ? integer : null;
};
// Convert from a formatted number with characters other than `.` as the
// decimal place, to a Javascript number
var $420c57962e03702d$var$_numToDecimal = function(num, decimalPoint) {
    // Cache created regular expressions for speed as this function is called often
    if (!$420c57962e03702d$var$_re_dic[decimalPoint]) $420c57962e03702d$var$_re_dic[decimalPoint] = new RegExp($420c57962e03702d$var$_fnEscapeRegex(decimalPoint), "g");
    return typeof num === "string" && decimalPoint !== "." ? num.replace(/\./g, "").replace($420c57962e03702d$var$_re_dic[decimalPoint], ".") : num;
};
var $420c57962e03702d$var$_isNumber = function(d, decimalPoint, formatted) {
    var type = typeof d;
    var strType = type === "string";
    if (type === "number" || type === "bigint") return true;
    // If empty return immediately so there must be a number if it is a
    // formatted string (this stops the string "k", or "kr", etc being detected
    // as a formatted number for currency
    if ($420c57962e03702d$var$_empty(d)) return true;
    if (decimalPoint && strType) d = $420c57962e03702d$var$_numToDecimal(d, decimalPoint);
    if (formatted && strType) d = d.replace($420c57962e03702d$var$_re_formatted_numeric, "");
    return !isNaN(parseFloat(d)) && isFinite(d);
};
// A string without HTML in it can be considered to be HTML still
var $420c57962e03702d$var$_isHtml = function(d) {
    return $420c57962e03702d$var$_empty(d) || typeof d === "string";
};
// Is a string a number surrounded by HTML?
var $420c57962e03702d$var$_htmlNumeric = function(d, decimalPoint, formatted) {
    if ($420c57962e03702d$var$_empty(d)) return true;
    // input and select strings mean that this isn't just a number
    if (typeof d === "string" && d.match(/<(input|select)/i)) return null;
    var html = $420c57962e03702d$var$_isHtml(d);
    return !html ? null : $420c57962e03702d$var$_isNumber($420c57962e03702d$var$_stripHtml(d), decimalPoint, formatted) ? true : null;
};
var $420c57962e03702d$var$_pluck = function(a, prop, prop2) {
    var out = [];
    var i = 0, ien = a.length;
    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if (prop2 !== undefined) {
        for(; i < ien; i++)if (a[i] && a[i][prop]) out.push(a[i][prop][prop2]);
    } else {
        for(; i < ien; i++)if (a[i]) out.push(a[i][prop]);
    }
    return out;
};
// Basically the same as _pluck, but rather than looping over `a` we use `order`
// as the indexes to pick from `a`
var $420c57962e03702d$var$_pluck_order = function(a, order, prop, prop2) {
    var out = [];
    var i = 0, ien = order.length;
    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if (prop2 !== undefined) {
        for(; i < ien; i++)if (a[order[i]][prop]) out.push(a[order[i]][prop][prop2]);
    } else {
        for(; i < ien; i++)if (a[order[i]]) out.push(a[order[i]][prop]);
    }
    return out;
};
var $420c57962e03702d$var$_range = function(len, start) {
    var out = [];
    var end;
    if (start === undefined) {
        start = 0;
        end = len;
    } else {
        end = start;
        start = len;
    }
    for(var i = start; i < end; i++)out.push(i);
    return out;
};
var $420c57962e03702d$var$_removeEmpty = function(a) {
    var out = [];
    for(var i = 0, ien = a.length; i < ien; i++)if (a[i]) out.push(a[i]);
    return out;
};
// Replaceable function in api.util
var $420c57962e03702d$var$_stripHtml = function(input) {
    // Irrelevant check to workaround CodeQL's false positive on the regex
    if (input.length > $420c57962e03702d$var$_max_str_len) throw new Error("Exceeded max str len");
    var previous;
    input = input.replace($420c57962e03702d$var$_re_html, ""); // Complete tags
    // Safety for incomplete script tag - use do / while to ensure that
    // we get all instances
    do {
        previous = input;
        input = input.replace(/<script/i, "");
    }while (input !== previous);
    return previous;
};
// Replaceable function in api.util
var $420c57962e03702d$var$_escapeHtml = function(d) {
    if (Array.isArray(d)) d = d.join(",");
    return typeof d === "string" ? d.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;") : d;
};
// Remove diacritics from a string by decomposing it and then removing
// non-ascii characters
var $420c57962e03702d$var$_normalize = function(str, both) {
    if (typeof str !== "string") return str;
    // It is faster to just run `normalize` than it is to check if
    // we need to with a regex!
    var res = str.normalize("NFD");
    // Equally, here we check if a regex is needed or not
    return res.length !== str.length ? (both === true ? str + " " : "") + res.replace(/[\u0300-\u036f]/g, "") : res;
};
/**
 * Determine if all values in the array are unique. This means we can short
 * cut the _unique method at the cost of a single loop. A sorted array is used
 * to easily check the values.
 *
 * @param  {array} src Source array
 * @return {boolean} true if all unique, false otherwise
 * @ignore
 */ var $420c57962e03702d$var$_areAllUnique = function(src) {
    if (src.length < 2) return true;
    var sorted = src.slice().sort();
    var last = sorted[0];
    for(var i = 1, ien = sorted.length; i < ien; i++){
        if (sorted[i] === last) return false;
        last = sorted[i];
    }
    return true;
};
/**
 * Find the unique elements in a source array.
 *
 * @param  {array} src Source array
 * @return {array} Array of unique items
 * @ignore
 */ var $420c57962e03702d$var$_unique = function(src) {
    if (Array.from && Set) return Array.from(new Set(src));
    if ($420c57962e03702d$var$_areAllUnique(src)) return src.slice();
    // A faster unique method is to use object keys to identify used values,
    // but this doesn't work with arrays or objects, which we must also
    // consider. See jsperf.app/compare-array-unique-versions/4 for more
    // information.
    var out = [], val, i, ien = src.length, j, k = 0;
    again: for(i = 0; i < ien; i++){
        val = src[i];
        for(j = 0; j < k; j++){
            if (out[j] === val) continue again;
        }
        out.push(val);
        k++;
    }
    return out;
};
// Surprisingly this is faster than [].concat.apply
// https://jsperf.com/flatten-an-array-loop-vs-reduce/2
var $420c57962e03702d$var$_flatten = function(out, val) {
    if (Array.isArray(val)) for(var i = 0; i < val.length; i++)$420c57962e03702d$var$_flatten(out, val[i]);
    else out.push(val);
    return out;
};
// Similar to jQuery's addClass, but use classList.add
function $420c57962e03702d$var$_addClass(el, name) {
    if (name) name.split(" ").forEach(function(n) {
        if (n) // `add` does deduplication, so no need to check `contains`
        el.classList.add(n);
    });
}
/**
 * DataTables utility methods
 * 
 * This namespace provides helper methods that DataTables uses internally to
 * create a DataTable, but which are not exclusively used only for DataTables.
 * These methods can be used by extension authors to save the duplication of
 * code.
 *
 *  @namespace
 */ $420c57962e03702d$var$DataTable.util = {
    /**
	 * Return a string with diacritic characters decomposed
	 * @param {*} mixed Function or string to normalize
	 * @param {*} both Return original string and the normalized string
	 * @returns String or undefined
	 */ diacritics: function(mixed, both) {
        var type = typeof mixed;
        if (type !== "function") return $420c57962e03702d$var$_normalize(mixed, both);
        $420c57962e03702d$var$_normalize = mixed;
    },
    /**
	 * Debounce a function
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */ debounce: function(fn, timeout) {
        var timer;
        return function() {
            var that = this;
            var args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function() {
                fn.apply(that, args);
            }, timeout || 250);
        };
    },
    /**
	 * Throttle the calls to a function. Arguments and context are maintained
	 * for the throttled function.
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */ throttle: function(fn, freq) {
        var frequency = freq !== undefined ? freq : 200, last, timer;
        return function() {
            var that = this, now = +new Date(), args = arguments;
            if (last && now < last + frequency) {
                clearTimeout(timer);
                timer = setTimeout(function() {
                    last = undefined;
                    fn.apply(that, args);
                }, frequency);
            } else {
                last = now;
                fn.apply(that, args);
            }
        };
    },
    /**
	 * Escape a string such that it can be used in a regular expression
	 *
	 *  @param {string} val string to escape
	 *  @returns {string} escaped string
	 */ escapeRegex: function(val) {
        return val.replace($420c57962e03702d$var$_re_escape_regex, "\\$1");
    },
    /**
	 * Create a function that will write to a nested object or array
	 * @param {*} source JSON notation string
	 * @returns Write function
	 */ set: function(source) {
        if ($420c57962e03702d$var$$.isPlainObject(source)) /* Unlike get, only the underscore (global) option is used for for
			 * setting data since we don't know the type here. This is why an object
			 * option is not documented for `mData` (which is read/write), but it is
			 * for `mRender` which is read only.
			 */ return $420c57962e03702d$var$DataTable.util.set(source._);
        else if (source === null) // Nothing to do when the data source is null
        return function() {};
        else if (typeof source === "function") return function(data, val, meta) {
            source(data, "set", val, meta);
        };
        else if (typeof source === "string" && (source.indexOf(".") !== -1 || source.indexOf("[") !== -1 || source.indexOf("(") !== -1)) {
            // Like the get, we need to get data from a nested object
            var setData = function(data, val, src) {
                var a = $420c57962e03702d$var$_fnSplitObjNotation(src), b;
                var aLast = a[a.length - 1];
                var arrayNotation, funcNotation, o, innerSrc;
                for(var i = 0, iLen = a.length - 1; i < iLen; i++){
                    // Protect against prototype pollution
                    if (a[i] === "__proto__" || a[i] === "constructor") throw new Error("Cannot set prototype values");
                    // Check if we are dealing with an array notation request
                    arrayNotation = a[i].match($420c57962e03702d$var$__reArray);
                    funcNotation = a[i].match($420c57962e03702d$var$__reFn);
                    if (arrayNotation) {
                        a[i] = a[i].replace($420c57962e03702d$var$__reArray, "");
                        data[a[i]] = [];
                        // Get the remainder of the nested object to set so we can recurse
                        b = a.slice();
                        b.splice(0, i + 1);
                        innerSrc = b.join(".");
                        // Traverse each entry in the array setting the properties requested
                        if (Array.isArray(val)) for(var j = 0, jLen = val.length; j < jLen; j++){
                            o = {};
                            setData(o, val[j], innerSrc);
                            data[a[i]].push(o);
                        }
                        else // We've been asked to save data to an array, but it
                        // isn't array data to be saved. Best that can be done
                        // is to just save the value.
                        data[a[i]] = val;
                        // The inner call to setData has already traversed through the remainder
                        // of the source and has set the data, thus we can exit here
                        return;
                    } else if (funcNotation) {
                        // Function call
                        a[i] = a[i].replace($420c57962e03702d$var$__reFn, "");
                        data = data[a[i]](val);
                    }
                    // If the nested object doesn't currently exist - since we are
                    // trying to set the value - create it
                    if (data[a[i]] === null || data[a[i]] === undefined) data[a[i]] = {};
                    data = data[a[i]];
                }
                // Last item in the input - i.e, the actual set
                if (aLast.match($420c57962e03702d$var$__reFn)) // Function call
                data = data[aLast.replace($420c57962e03702d$var$__reFn, "")](val);
                else // If array notation is used, we just want to strip it and use the property name
                // and assign the value. If it isn't used, then we get the result we want anyway
                data[aLast.replace($420c57962e03702d$var$__reArray, "")] = val;
            };
            return function(data, val) {
                return setData(data, val, source);
            };
        } else // Array or flat object mapping
        return function(data, val) {
            data[source] = val;
        };
    },
    /**
	 * Create a function that will read nested objects from arrays, based on JSON notation
	 * @param {*} source JSON notation string
	 * @returns Value read
	 */ get: function(source) {
        if ($420c57962e03702d$var$$.isPlainObject(source)) {
            // Build an object of get functions, and wrap them in a single call
            var o = {};
            $420c57962e03702d$var$$.each(source, function(key, val) {
                if (val) o[key] = $420c57962e03702d$var$DataTable.util.get(val);
            });
            return function(data, type, row, meta) {
                var t = o[type] || o._;
                return t !== undefined ? t(data, type, row, meta) : data;
            };
        } else if (source === null) // Give an empty string for rendering / sorting etc
        return function(data) {
            return data;
        };
        else if (typeof source === "function") return function(data, type, row, meta) {
            return source(data, type, row, meta);
        };
        else if (typeof source === "string" && (source.indexOf(".") !== -1 || source.indexOf("[") !== -1 || source.indexOf("(") !== -1)) {
            /* If there is a . in the source string then the data source is in a
			 * nested object so we loop over the data for each level to get the next
			 * level down. On each loop we test for undefined, and if found immediately
			 * return. This allows entire objects to be missing and sDefaultContent to
			 * be used if defined, rather than throwing an error
			 */ var fetchData = function(data, type, src) {
                var arrayNotation, funcNotation, out, innerSrc;
                if (src !== "") {
                    var a = $420c57962e03702d$var$_fnSplitObjNotation(src);
                    for(var i = 0, iLen = a.length; i < iLen; i++){
                        // Check if we are dealing with special notation
                        arrayNotation = a[i].match($420c57962e03702d$var$__reArray);
                        funcNotation = a[i].match($420c57962e03702d$var$__reFn);
                        if (arrayNotation) {
                            // Array notation
                            a[i] = a[i].replace($420c57962e03702d$var$__reArray, "");
                            // Condition allows simply [] to be passed in
                            if (a[i] !== "") data = data[a[i]];
                            out = [];
                            // Get the remainder of the nested object to get
                            a.splice(0, i + 1);
                            innerSrc = a.join(".");
                            // Traverse each entry in the array getting the properties requested
                            if (Array.isArray(data)) for(var j = 0, jLen = data.length; j < jLen; j++)out.push(fetchData(data[j], type, innerSrc));
                            // If a string is given in between the array notation indicators, that
                            // is used to join the strings together, otherwise an array is returned
                            var join = arrayNotation[0].substring(1, arrayNotation[0].length - 1);
                            data = join === "" ? out : out.join(join);
                            break;
                        } else if (funcNotation) {
                            // Function call
                            a[i] = a[i].replace($420c57962e03702d$var$__reFn, "");
                            data = data[a[i]]();
                            continue;
                        }
                        if (data === null || data[a[i]] === null) return null;
                        else if (data === undefined || data[a[i]] === undefined) return undefined;
                        data = data[a[i]];
                    }
                }
                return data;
            };
            return function(data, type) {
                return fetchData(data, type, source);
            };
        } else // Array or flat object mapping
        return function(data) {
            return data[source];
        };
    },
    stripHtml: function(mixed) {
        var type = typeof mixed;
        if (type === "function") {
            $420c57962e03702d$var$_stripHtml = mixed;
            return;
        } else if (type === "string") return $420c57962e03702d$var$_stripHtml(mixed);
        return mixed;
    },
    escapeHtml: function(mixed) {
        var type = typeof mixed;
        if (type === "function") {
            $420c57962e03702d$var$_escapeHtml = mixed;
            return;
        } else if (type === "string" || Array.isArray(mixed)) return $420c57962e03702d$var$_escapeHtml(mixed);
        return mixed;
    },
    unique: $420c57962e03702d$var$_unique
};
/**
 * Create a mapping object that allows camel case parameters to be looked up
 * for their Hungarian counterparts. The mapping is stored in a private
 * parameter called `_hungarianMap` which can be accessed on the source object.
 *  @param {object} o
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnHungarianMap(o) {
    var hungarian = "a aa ai ao as b fn i m o s ", match, newKey, map = {};
    $420c57962e03702d$var$$.each(o, function(key) {
        match = key.match(/^([^A-Z]+?)([A-Z])/);
        if (match && hungarian.indexOf(match[1] + " ") !== -1) {
            newKey = key.replace(match[0], match[2].toLowerCase());
            map[newKey] = key;
            if (match[1] === "o") $420c57962e03702d$var$_fnHungarianMap(o[key]);
        }
    });
    o._hungarianMap = map;
}
/**
 * Convert from camel case parameters to Hungarian, based on a Hungarian map
 * created by _fnHungarianMap.
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnCamelToHungarian(src, user, force) {
    if (!src._hungarianMap) $420c57962e03702d$var$_fnHungarianMap(src);
    var hungarianKey;
    $420c57962e03702d$var$$.each(user, function(key) {
        hungarianKey = src._hungarianMap[key];
        if (hungarianKey !== undefined && (force || user[hungarianKey] === undefined)) {
            // For objects, we need to buzz down into the object to copy parameters
            if (hungarianKey.charAt(0) === "o") {
                // Copy the camelCase options over to the hungarian
                if (!user[hungarianKey]) user[hungarianKey] = {};
                $420c57962e03702d$var$$.extend(true, user[hungarianKey], user[key]);
                $420c57962e03702d$var$_fnCamelToHungarian(src[hungarianKey], user[hungarianKey], force);
            } else user[hungarianKey] = user[key];
        }
    });
}
/**
 * Map one parameter onto another
 *  @param {object} o Object to map
 *  @param {*} knew The new parameter name
 *  @param {*} old The old parameter name
 */ var $420c57962e03702d$var$_fnCompatMap = function(o, knew, old) {
    if (o[knew] !== undefined) o[old] = o[knew];
};
/**
 * Provide backwards compatibility for the main DT options. Note that the new
 * options are mapped onto the old parameters, so this is an external interface
 * change only.
 *  @param {object} init Object to map
 */ function $420c57962e03702d$var$_fnCompatOpts(init) {
    $420c57962e03702d$var$_fnCompatMap(init, "ordering", "bSort");
    $420c57962e03702d$var$_fnCompatMap(init, "orderMulti", "bSortMulti");
    $420c57962e03702d$var$_fnCompatMap(init, "orderClasses", "bSortClasses");
    $420c57962e03702d$var$_fnCompatMap(init, "orderCellsTop", "bSortCellsTop");
    $420c57962e03702d$var$_fnCompatMap(init, "order", "aaSorting");
    $420c57962e03702d$var$_fnCompatMap(init, "orderFixed", "aaSortingFixed");
    $420c57962e03702d$var$_fnCompatMap(init, "paging", "bPaginate");
    $420c57962e03702d$var$_fnCompatMap(init, "pagingType", "sPaginationType");
    $420c57962e03702d$var$_fnCompatMap(init, "pageLength", "iDisplayLength");
    $420c57962e03702d$var$_fnCompatMap(init, "searching", "bFilter");
    // Boolean initialisation of x-scrolling
    if (typeof init.sScrollX === "boolean") init.sScrollX = init.sScrollX ? "100%" : "";
    if (typeof init.scrollX === "boolean") init.scrollX = init.scrollX ? "100%" : "";
    // Column search objects are in an array, so it needs to be converted
    // element by element
    var searchCols = init.aoSearchCols;
    if (searchCols) {
        for(var i = 0, ien = searchCols.length; i < ien; i++)if (searchCols[i]) $420c57962e03702d$var$_fnCamelToHungarian($420c57962e03702d$var$DataTable.models.oSearch, searchCols[i]);
    }
    // Enable search delay if server-side processing is enabled
    if (init.serverSide && !init.searchDelay) init.searchDelay = 400;
}
/**
 * Provide backwards compatibility for column options. Note that the new options
 * are mapped onto the old parameters, so this is an external interface change
 * only.
 *  @param {object} init Object to map
 */ function $420c57962e03702d$var$_fnCompatCols(init) {
    $420c57962e03702d$var$_fnCompatMap(init, "orderable", "bSortable");
    $420c57962e03702d$var$_fnCompatMap(init, "orderData", "aDataSort");
    $420c57962e03702d$var$_fnCompatMap(init, "orderSequence", "asSorting");
    $420c57962e03702d$var$_fnCompatMap(init, "orderDataType", "sortDataType");
    // orderData can be given as an integer
    var dataSort = init.aDataSort;
    if (typeof dataSort === "number" && !Array.isArray(dataSort)) init.aDataSort = [
        dataSort
    ];
}
/**
 * Browser feature detection for capabilities, quirks
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnBrowserDetect(settings) {
    // We don't need to do this every time DataTables is constructed, the values
    // calculated are specific to the browser and OS configuration which we
    // don't expect to change between initialisations
    if (!$420c57962e03702d$var$DataTable.__browser) {
        var browser = {};
        $420c57962e03702d$var$DataTable.__browser = browser;
        // Scrolling feature / quirks detection
        var n = $420c57962e03702d$var$$("<div/>").css({
            position: "fixed",
            top: 0,
            left: -1 * window.pageXOffset,
            height: 1,
            width: 1,
            overflow: "hidden"
        }).append($420c57962e03702d$var$$("<div/>").css({
            position: "absolute",
            top: 1,
            left: 1,
            width: 100,
            overflow: "scroll"
        }).append($420c57962e03702d$var$$("<div/>").css({
            width: "100%",
            height: 10
        }))).appendTo("body");
        var outer = n.children();
        var inner = outer.children();
        // Get scrollbar width
        browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;
        // In rtl text layout, some browsers (most, but not all) will place the
        // scrollbar on the left, rather than the right.
        browser.bScrollbarLeft = Math.round(inner.offset().left) !== 1;
        n.remove();
    }
    $420c57962e03702d$var$$.extend(settings.oBrowser, $420c57962e03702d$var$DataTable.__browser);
    settings.oScroll.iBarWidth = $420c57962e03702d$var$DataTable.__browser.barWidth;
}
/**
 * Add a column to the list used for the table with default values
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnAddColumn(oSettings) {
    // Add column to aoColumns array
    var oDefaults = $420c57962e03702d$var$DataTable.defaults.column;
    var iCol = oSettings.aoColumns.length;
    var oCol = $420c57962e03702d$var$$.extend({}, $420c57962e03702d$var$DataTable.models.oColumn, oDefaults, {
        "aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [
            iCol
        ],
        "mData": oDefaults.mData ? oDefaults.mData : iCol,
        idx: iCol,
        searchFixed: {},
        colEl: $420c57962e03702d$var$$("<col>").attr("data-dt-column", iCol)
    });
    oSettings.aoColumns.push(oCol);
    // Add search object for column specific search. Note that the `searchCols[ iCol ]`
    // passed into extend can be undefined. This allows the user to give a default
    // with only some of the parameters defined, and also not give a default
    var searchCols = oSettings.aoPreSearchCols;
    searchCols[iCol] = $420c57962e03702d$var$$.extend({}, $420c57962e03702d$var$DataTable.models.oSearch, searchCols[iCol]);
}
/**
 * Apply options for a column
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iCol column index to consider
 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnColumnOptions(oSettings, iCol, oOptions) {
    var oCol = oSettings.aoColumns[iCol];
    /* User specified column options */ if (oOptions !== undefined && oOptions !== null) {
        // Backwards compatibility
        $420c57962e03702d$var$_fnCompatCols(oOptions);
        // Map camel case parameters to their Hungarian counterparts
        $420c57962e03702d$var$_fnCamelToHungarian($420c57962e03702d$var$DataTable.defaults.column, oOptions, true);
        /* Backwards compatibility for mDataProp */ if (oOptions.mDataProp !== undefined && !oOptions.mData) oOptions.mData = oOptions.mDataProp;
        if (oOptions.sType) oCol._sManualType = oOptions.sType;
        // `class` is a reserved word in Javascript, so we need to provide
        // the ability to use a valid name for the camel case input
        if (oOptions.className && !oOptions.sClass) oOptions.sClass = oOptions.className;
        var origClass = oCol.sClass;
        $420c57962e03702d$var$$.extend(oCol, oOptions);
        $420c57962e03702d$var$_fnMap(oCol, oOptions, "sWidth", "sWidthOrig");
        // Merge class from previously defined classes with this one, rather than just
        // overwriting it in the extend above
        if (origClass !== oCol.sClass) oCol.sClass = origClass + " " + oCol.sClass;
        /* iDataSort to be applied (backwards compatibility), but aDataSort will take
		 * priority if defined
		 */ if (oOptions.iDataSort !== undefined) oCol.aDataSort = [
            oOptions.iDataSort
        ];
        $420c57962e03702d$var$_fnMap(oCol, oOptions, "aDataSort");
    }
    /* Cache the data get and set functions for speed */ var mDataSrc = oCol.mData;
    var mData = $420c57962e03702d$var$_fnGetObjectDataFn(mDataSrc);
    // The `render` option can be given as an array to access the helper rendering methods.
    // The first element is the rendering method to use, the rest are the parameters to pass
    if (oCol.mRender && Array.isArray(oCol.mRender)) {
        var copy = oCol.mRender.slice();
        var name = copy.shift();
        oCol.mRender = $420c57962e03702d$var$DataTable.render[name].apply(window, copy);
    }
    oCol._render = oCol.mRender ? $420c57962e03702d$var$_fnGetObjectDataFn(oCol.mRender) : null;
    var attrTest = function(src) {
        return typeof src === "string" && src.indexOf("@") !== -1;
    };
    oCol._bAttrSrc = $420c57962e03702d$var$$.isPlainObject(mDataSrc) && (attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter));
    oCol._setter = null;
    oCol.fnGetData = function(rowData, type, meta) {
        var innerData = mData(rowData, type, undefined, meta);
        return oCol._render && type ? oCol._render(innerData, type, rowData, meta) : innerData;
    };
    oCol.fnSetData = function(rowData, val, meta) {
        return $420c57962e03702d$var$_fnSetObjectDataFn(mDataSrc)(rowData, val, meta);
    };
    // Indicate if DataTables should read DOM data as an object or array
    // Used in _fnGetRowElements
    if (typeof mDataSrc !== "number" && !oCol._isArrayHost) oSettings._rowReadObject = true;
    /* Feature sorting overrides column specific when off */ if (!oSettings.oFeatures.bSort) oCol.bSortable = false;
}
/**
 * Adjust the table column widths for new data. Note: you would probably want to
 * do a redraw after calling this function!
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnAdjustColumnSizing(settings) {
    $420c57962e03702d$var$_fnCalculateColumnWidths(settings);
    $420c57962e03702d$var$_fnColumnSizes(settings);
    var scroll = settings.oScroll;
    if (scroll.sY !== "" || scroll.sX !== "") $420c57962e03702d$var$_fnScrollDraw(settings);
    $420c57962e03702d$var$_fnCallbackFire(settings, null, "column-sizing", [
        settings
    ]);
}
/**
 * Apply column sizes
 *
 * @param {*} settings DataTables settings object
 */ function $420c57962e03702d$var$_fnColumnSizes(settings) {
    var cols = settings.aoColumns;
    for(var i = 0; i < cols.length; i++){
        var width = $420c57962e03702d$var$_fnColumnsSumWidth(settings, [
            i
        ], false, false);
        cols[i].colEl.css("width", width);
    }
}
/**
 * Convert the index of a visible column to the index in the data array (take account
 * of hidden columns)
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iMatch Visible column index to lookup
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnVisibleToColumnIndex(oSettings, iMatch) {
    var aiVis = $420c57962e03702d$var$_fnGetColumns(oSettings, "bVisible");
    return typeof aiVis[iMatch] === "number" ? aiVis[iMatch] : null;
}
/**
 * Convert the index of an index in the data array and convert it to the visible
 *   column index (take account of hidden columns)
 *  @param {int} iMatch Column index to lookup
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnColumnIndexToVisible(oSettings, iMatch) {
    var aiVis = $420c57962e03702d$var$_fnGetColumns(oSettings, "bVisible");
    var iPos = aiVis.indexOf(iMatch);
    return iPos !== -1 ? iPos : null;
}
/**
 * Get the number of visible columns
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the number of visible columns
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnVisbleColumns(settings) {
    var layout = settings.aoHeader;
    var columns = settings.aoColumns;
    var vis = 0;
    if (layout.length) {
        for(var i = 0, ien = layout[0].length; i < ien; i++)if (columns[i].bVisible && $420c57962e03702d$var$$(layout[0][i].cell).css("display") !== "none") vis++;
    }
    return vis;
}
/**
 * Get an array of column indexes that match a given property
 *  @param {object} oSettings dataTables settings object
 *  @param {string} sParam Parameter in aoColumns to look for - typically
 *    bVisible or bSearchable
 *  @returns {array} Array of indexes with matched properties
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnGetColumns(oSettings, sParam) {
    var a = [];
    oSettings.aoColumns.map(function(val, i) {
        if (val[sParam]) a.push(i);
    });
    return a;
}
/**
 * Calculate the 'type' of a column
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnColumnTypes(settings) {
    var columns = settings.aoColumns;
    var data = settings.aoData;
    var types = $420c57962e03702d$var$DataTable.ext.type.detect;
    var i, ien, j, jen, k, ken;
    var col, detectedType, cache;
    // For each column, spin over the 
    for(i = 0, ien = columns.length; i < ien; i++){
        col = columns[i];
        cache = [];
        if (!col.sType && col._sManualType) col.sType = col._sManualType;
        else if (!col.sType) {
            for(j = 0, jen = types.length; j < jen; j++){
                for(k = 0, ken = data.length; k < ken; k++){
                    if (!data[k]) continue;
                    // Use a cache array so we only need to get the type data
                    // from the formatter once (when using multiple detectors)
                    if (cache[k] === undefined) cache[k] = $420c57962e03702d$var$_fnGetCellData(settings, k, i, "type");
                    detectedType = types[j](cache[k], settings);
                    // If null, then this type can't apply to this column, so
                    // rather than testing all cells, break out. There is an
                    // exception for the last type which is `html`. We need to
                    // scan all rows since it is possible to mix string and HTML
                    // types
                    if (!detectedType && j !== types.length - 2) break;
                    // Only a single match is needed for html type since it is
                    // bottom of the pile and very similar to string - but it
                    // must not be empty
                    if (detectedType === "html" && !$420c57962e03702d$var$_empty(cache[k])) break;
                }
                // Type is valid for all data points in the column - use this
                // type
                if (detectedType) {
                    col.sType = detectedType;
                    break;
                }
            }
            // Fall back - if no type was detected, always use string
            if (!col.sType) col.sType = "string";
        }
        // Set class names for header / footer for auto type classes
        var autoClass = $420c57962e03702d$var$_ext.type.className[col.sType];
        if (autoClass) {
            $420c57962e03702d$var$_columnAutoClass(settings.aoHeader, i, autoClass);
            $420c57962e03702d$var$_columnAutoClass(settings.aoFooter, i, autoClass);
        }
        var renderer = $420c57962e03702d$var$_ext.type.render[col.sType];
        // This can only happen once! There is no way to remover
        // a renderer. After the first time the renderer has
        // already been set so createTr will run the renderer itself.
        if (renderer && !col._render) {
            col._render = $420c57962e03702d$var$DataTable.util.get(renderer);
            $420c57962e03702d$var$_columnAutoRender(settings, i);
        }
    }
}
/**
 * Apply an auto detected renderer to data which doesn't yet have
 * a renderer
 */ function $420c57962e03702d$var$_columnAutoRender(settings, colIdx) {
    var data = settings.aoData;
    for(var i = 0; i < data.length; i++)if (data[i].nTr) {
        // We have to update the display here since there is no
        // invalidation check for the data
        var display = $420c57962e03702d$var$_fnGetCellData(settings, i, colIdx, "display");
        data[i].displayData[colIdx] = display;
        $420c57962e03702d$var$_fnWriteCell(data[i].anCells[colIdx], display);
    // No need to update sort / filter data since it has
    // been invalidated and will be re-read with the
    // renderer now applied
    }
}
/**
 * Apply a class name to a column's header cells
 */ function $420c57962e03702d$var$_columnAutoClass(container, colIdx, className) {
    container.forEach(function(row) {
        if (row[colIdx] && row[colIdx].unique) $420c57962e03702d$var$_addClass(row[colIdx].cell, className);
    });
}
/**
 * Take the column definitions and static columns arrays and calculate how
 * they relate to column indexes. The callback function will then apply the
 * definition found for a column to a suitable configuration object.
 *  @param {object} oSettings dataTables settings object
 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
 *  @param {array} aoCols The aoColumns array that defines columns individually
 *  @param {array} headerLayout Layout for header as it was loaded
 *  @param {function} fn Callback function - takes two parameters, the calculated
 *    column index and the definition for that column.
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnApplyColumnDefs(oSettings, aoColDefs, aoCols, headerLayout, fn) {
    var i, iLen, j, jLen, k, kLen, def;
    var columns = oSettings.aoColumns;
    if (aoCols) {
        for(i = 0, iLen = aoCols.length; i < iLen; i++)if (aoCols[i] && aoCols[i].name) columns[i].sName = aoCols[i].name;
    }
    // Column definitions with aTargets
    if (aoColDefs) /* Loop over the definitions array - loop in reverse so first instance has priority */ for(i = aoColDefs.length - 1; i >= 0; i--){
        def = aoColDefs[i];
        /* Each definition can target multiple columns, as it is an array */ var aTargets = def.target !== undefined ? def.target : def.targets !== undefined ? def.targets : def.aTargets;
        if (!Array.isArray(aTargets)) aTargets = [
            aTargets
        ];
        for(j = 0, jLen = aTargets.length; j < jLen; j++){
            var target = aTargets[j];
            if (typeof target === "number" && target >= 0) {
                /* Add columns that we don't yet know about */ while(columns.length <= target)$420c57962e03702d$var$_fnAddColumn(oSettings);
                /* Integer, basic index */ fn(target, def);
            } else if (typeof target === "number" && target < 0) /* Negative integer, right to left column counting */ fn(columns.length + target, def);
            else if (typeof target === "string") for(k = 0, kLen = columns.length; k < kLen; k++){
                if (target === "_all") // Apply to all columns
                fn(k, def);
                else if (target.indexOf(":name") !== -1) // Column selector
                {
                    if (columns[k].sName === target.replace(":name", "")) fn(k, def);
                } else // Cell selector
                headerLayout.forEach(function(row) {
                    if (row[k]) {
                        var cell = $420c57962e03702d$var$$(row[k].cell);
                        // Legacy support. Note that it means that we don't support
                        // an element name selector only, since they are treated as
                        // class names for 1.x compat.
                        if (target.match(/^[a-z][\w-]*$/i)) target = "." + target;
                        if (cell.is(target)) fn(k, def);
                    }
                });
            }
        }
    }
    // Statically defined columns array
    if (aoCols) for(i = 0, iLen = aoCols.length; i < iLen; i++)fn(i, aoCols[i]);
}
/**
 * Get the width for a given set of columns
 *
 * @param {*} settings DataTables settings object
 * @param {*} targets Columns - comma separated string or array of numbers
 * @param {*} original Use the original width (true) or calculated (false)
 * @param {*} incVisible Include visible columns (true) or not (false)
 * @returns Combined CSS value
 */ function $420c57962e03702d$var$_fnColumnsSumWidth(settings, targets, original, incVisible) {
    if (!Array.isArray(targets)) targets = $420c57962e03702d$var$_fnColumnsFromHeader(targets);
    var sum = 0;
    var unit;
    var columns = settings.aoColumns;
    for(var i = 0, ien = targets.length; i < ien; i++){
        var column = columns[targets[i]];
        var definedWidth = original ? column.sWidthOrig : column.sWidth;
        if (!incVisible && column.bVisible === false) continue;
        if (definedWidth === null || definedWidth === undefined) return null; // can't determine a defined width - browser defined
        else if (typeof definedWidth === "number") {
            unit = "px";
            sum += definedWidth;
        } else {
            var matched = definedWidth.match(/([\d\.]+)([^\d]*)/);
            if (matched) {
                sum += matched[1] * 1;
                unit = matched.length === 3 ? matched[2] : "px";
            }
        }
    }
    return sum + unit;
}
function $420c57962e03702d$var$_fnColumnsFromHeader(cell) {
    var attr = $420c57962e03702d$var$$(cell).closest("[data-dt-column]").attr("data-dt-column");
    if (!attr) return [];
    return attr.split(",").map(function(val) {
        return val * 1;
    });
}
/**
 * Add a data array to the table, creating DOM node etc. This is the parallel to
 * _fnGatherData, but for adding rows from a Javascript source, rather than a
 * DOM source.
 *  @param {object} settings dataTables settings object
 *  @param {array} data data array to be added
 *  @param {node} [tr] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [tds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnAddData(settings, dataIn, tr, tds) {
    /* Create the object for storing information about this new row */ var rowIdx = settings.aoData.length;
    var rowModel = $420c57962e03702d$var$$.extend(true, {}, $420c57962e03702d$var$DataTable.models.oRow, {
        src: tr ? "dom" : "data",
        idx: rowIdx
    });
    rowModel._aData = dataIn;
    settings.aoData.push(rowModel);
    var columns = settings.aoColumns;
    for(var i = 0, iLen = columns.length; i < iLen; i++)// Invalidate the column types as the new data needs to be revalidated
    columns[i].sType = null;
    /* Add to the display array */ settings.aiDisplayMaster.push(rowIdx);
    var id = settings.rowIdFn(dataIn);
    if (id !== undefined) settings.aIds[id] = rowModel;
    /* Create the DOM information, or register it if already present */ if (tr || !settings.oFeatures.bDeferRender) $420c57962e03702d$var$_fnCreateTr(settings, rowIdx, tr, tds);
    return rowIdx;
}
/**
 * Add one or more TR elements to the table. Generally we'd expect to
 * use this for reading data from a DOM sourced table, but it could be
 * used for an TR element. Note that if a TR is given, it is used (i.e.
 * it is not cloned).
 *  @param {object} settings dataTables settings object
 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
 *  @returns {array} Array of indexes for the added rows
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnAddTr(settings, trs) {
    var row;
    // Allow an individual node to be passed in
    if (!(trs instanceof $420c57962e03702d$var$$)) trs = $420c57962e03702d$var$$(trs);
    return trs.map(function(i, el) {
        row = $420c57962e03702d$var$_fnGetRowElements(settings, el);
        return $420c57962e03702d$var$_fnAddData(settings, row.data, el, row.cells);
    });
}
/**
 * Get the data for a given cell from the internal cache, taking into account data mapping
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {string} type data get type ('display', 'type' 'filter|search' 'sort|order')
 *  @returns {*} Cell data
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnGetCellData(settings, rowIdx, colIdx, type) {
    if (type === "search") type = "filter";
    else if (type === "order") type = "sort";
    var row = settings.aoData[rowIdx];
    if (!row) return undefined;
    var draw = settings.iDraw;
    var col = settings.aoColumns[colIdx];
    var rowData = row._aData;
    var defaultContent = col.sDefaultContent;
    var cellData = col.fnGetData(rowData, type, {
        settings: settings,
        row: rowIdx,
        col: colIdx
    });
    // Allow for a node being returned for non-display types
    if (type !== "display" && cellData && typeof cellData === "object" && cellData.nodeName) cellData = cellData.innerHTML;
    if (cellData === undefined) {
        if (settings.iDrawError != draw && defaultContent === null) {
            $420c57962e03702d$var$_fnLog(settings, 0, "Requested unknown parameter " + (typeof col.mData == "function" ? "{function}" : "'" + col.mData + "'") + " for row " + rowIdx + ", column " + colIdx, 4);
            settings.iDrawError = draw;
        }
        return defaultContent;
    }
    // When the data source is null and a specific data type is requested (i.e.
    // not the original data), we can use default column data
    if ((cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined) cellData = defaultContent;
    else if (typeof cellData === "function") // If the data source is a function, then we run it and use the return,
    // executing in the scope of the data object (for instances)
    return cellData.call(rowData);
    if (cellData === null && type === "display") return "";
    if (type === "filter") {
        var fomatters = $420c57962e03702d$var$DataTable.ext.type.search;
        if (fomatters[col.sType]) cellData = fomatters[col.sType](cellData);
    }
    return cellData;
}
/**
 * Set the value for a specific cell, into the internal data cache
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {*} val Value to set
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnSetCellData(settings, rowIdx, colIdx, val) {
    var col = settings.aoColumns[colIdx];
    var rowData = settings.aoData[rowIdx]._aData;
    col.fnSetData(rowData, val, {
        settings: settings,
        row: rowIdx,
        col: colIdx
    });
}
/**
 * Write a value to a cell
 * @param {*} td Cell
 * @param {*} val Value
 */ function $420c57962e03702d$var$_fnWriteCell(td, val) {
    if (val && typeof val === "object" && val.nodeName) $420c57962e03702d$var$$(td).empty().append(val);
    else td.innerHTML = val;
}
// Private variable that is used to match action syntax in the data property object
var $420c57962e03702d$var$__reArray = /\[.*?\]$/;
var $420c57962e03702d$var$__reFn = /\(\)$/;
/**
 * Split string on periods, taking into account escaped periods
 * @param  {string} str String to split
 * @return {array} Split string
 */ function $420c57962e03702d$var$_fnSplitObjNotation(str) {
    var parts = str.match(/(\\.|[^.])+/g) || [
        ""
    ];
    return parts.map(function(s) {
        return s.replace(/\\\./g, ".");
    });
}
/**
 * Return a function that can be used to get data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data get function
 *  @memberof DataTable#oApi
 */ var $420c57962e03702d$var$_fnGetObjectDataFn = $420c57962e03702d$var$DataTable.util.get;
/**
 * Return a function that can be used to set data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data set function
 *  @memberof DataTable#oApi
 */ var $420c57962e03702d$var$_fnSetObjectDataFn = $420c57962e03702d$var$DataTable.util.set;
/**
 * Return an array with the full table data
 *  @param {object} oSettings dataTables settings object
 *  @returns array {array} aData Master data array
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnGetDataMaster(settings) {
    return $420c57962e03702d$var$_pluck(settings.aoData, "_aData");
}
/**
 * Nuke the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnClearTable(settings) {
    settings.aoData.length = 0;
    settings.aiDisplayMaster.length = 0;
    settings.aiDisplay.length = 0;
    settings.aIds = {};
}
/**
 * Mark cached data as invalid such that a re-read of the data will occur when
 * the cached data is next requested. Also update from the data source object.
 *
 * @param {object} settings DataTables settings object
 * @param {int}    rowIdx   Row index to invalidate
 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
 *     or 'data'
 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
 *     row will be invalidated
 * @memberof DataTable#oApi
 *
 * @todo For the modularisation of v1.11 this will need to become a callback, so
 *   the sort and filter methods can subscribe to it. That will required
 *   initialisation options for sorting, which is why it is not already baked in
 */ function $420c57962e03702d$var$_fnInvalidate(settings, rowIdx, src, colIdx) {
    var row = settings.aoData[rowIdx];
    var i, ien;
    // Remove the cached data for the row
    row._aSortData = null;
    row._aFilterData = null;
    row.displayData = null;
    // Are we reading last data from DOM or the data object?
    if (src === "dom" || (!src || src === "auto") && row.src === "dom") // Read the data from the DOM
    row._aData = $420c57962e03702d$var$_fnGetRowElements(settings, row, colIdx, colIdx === undefined ? undefined : row._aData).data;
    else {
        // Reading from data object, update the DOM
        var cells = row.anCells;
        var display = $420c57962e03702d$var$_fnGetRowDisplay(settings, rowIdx);
        if (cells) {
            if (colIdx !== undefined) $420c57962e03702d$var$_fnWriteCell(cells[colIdx], display[colIdx]);
            else for(i = 0, ien = cells.length; i < ien; i++)$420c57962e03702d$var$_fnWriteCell(cells[i], display[i]);
        }
    }
    // Column specific invalidation
    var cols = settings.aoColumns;
    if (colIdx !== undefined) {
        // Type - the data might have changed
        cols[colIdx].sType = null;
        // Max length string. Its a fairly cheep recalculation, so not worth
        // something more complicated
        cols[colIdx].maxLenString = null;
    } else {
        for(i = 0, ien = cols.length; i < ien; i++){
            cols[i].sType = null;
            cols[i].maxLenString = null;
        }
        // Update DataTables special `DT_*` attributes for the row
        $420c57962e03702d$var$_fnRowAttributes(settings, row);
    }
}
/**
 * Build a data source object from an HTML row, reading the contents of the
 * cells that are in the row.
 *
 * @param {object} settings DataTables settings object
 * @param {node|object} TR element from which to read data or existing row
 *   object from which to re-read the data from the cells
 * @param {int} [colIdx] Optional column index
 * @param {array|object} [d] Data source object. If `colIdx` is given then this
 *   parameter should also be given and will be used to write the data into.
 *   Only the column in question will be written
 * @returns {object} Object with two parameters: `data` the data read, in
 *   document order, and `cells` and array of nodes (they can be useful to the
 *   caller, so rather than needing a second traversal to get them, just return
 *   them from here).
 * @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnGetRowElements(settings, row, colIdx, d) {
    var tds = [], td = row.firstChild, name, col, i = 0, contents, columns = settings.aoColumns, objectRead = settings._rowReadObject;
    // Allow the data object to be passed in, or construct
    d = d !== undefined ? d : objectRead ? {} : [];
    var attr = function(str, td) {
        if (typeof str === "string") {
            var idx = str.indexOf("@");
            if (idx !== -1) {
                var attr = str.substring(idx + 1);
                var setter = $420c57962e03702d$var$_fnSetObjectDataFn(str);
                setter(d, td.getAttribute(attr));
            }
        }
    };
    // Read data from a cell and store into the data object
    var cellProcess = function(cell) {
        if (colIdx === undefined || colIdx === i) {
            col = columns[i];
            contents = cell.innerHTML.trim();
            if (col && col._bAttrSrc) {
                var setter = $420c57962e03702d$var$_fnSetObjectDataFn(col.mData._);
                setter(d, contents);
                attr(col.mData.sort, cell);
                attr(col.mData.type, cell);
                attr(col.mData.filter, cell);
            } else // Depending on the `data` option for the columns the data can
            // be read to either an object or an array.
            if (objectRead) {
                if (!col._setter) // Cache the setter function
                col._setter = $420c57962e03702d$var$_fnSetObjectDataFn(col.mData);
                col._setter(d, contents);
            } else d[i] = contents;
        }
        i++;
    };
    if (td) // `tr` element was passed in
    while(td){
        name = td.nodeName.toUpperCase();
        if (name == "TD" || name == "TH") {
            cellProcess(td);
            tds.push(td);
        }
        td = td.nextSibling;
    }
    else {
        // Existing row object passed in
        tds = row.anCells;
        for(var j = 0, jen = tds.length; j < jen; j++)cellProcess(tds[j]);
    }
    // Read the ID from the DOM if present
    var rowNode = row.firstChild ? row : row.nTr;
    if (rowNode) {
        var id = rowNode.getAttribute("id");
        if (id) $420c57962e03702d$var$_fnSetObjectDataFn(settings.rowId)(d, id);
    }
    return {
        data: d,
        cells: tds
    };
}
/**
 * Render and cache a row's display data for the columns, if required
 * @returns 
 */ function $420c57962e03702d$var$_fnGetRowDisplay(settings, rowIdx) {
    let rowModal = settings.aoData[rowIdx];
    let columns = settings.aoColumns;
    if (!rowModal.displayData) {
        // Need to render and cache
        rowModal.displayData = [];
        for(var colIdx = 0, len = columns.length; colIdx < len; colIdx++)rowModal.displayData.push($420c57962e03702d$var$_fnGetCellData(settings, rowIdx, colIdx, "display"));
    }
    return rowModal.displayData;
}
/**
 * Create a new TR element (and it's TD children) for a row
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iRow Row to consider
 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnCreateTr(oSettings, iRow, nTrIn, anTds) {
    var row = oSettings.aoData[iRow], rowData = row._aData, cells = [], nTr, nTd, oCol, i, iLen, create, trClass = oSettings.oClasses.tbody.row;
    if (row.nTr === null) {
        nTr = nTrIn || document.createElement("tr");
        row.nTr = nTr;
        row.anCells = cells;
        $420c57962e03702d$var$_addClass(nTr, trClass);
        /* Use a private property on the node to allow reserve mapping from the node
		 * to the aoData array for fast look up
		 */ nTr._DT_RowIndex = iRow;
        /* Special parameters can be given by the data source to be used on the row */ $420c57962e03702d$var$_fnRowAttributes(oSettings, row);
        /* Process each column */ for(i = 0, iLen = oSettings.aoColumns.length; i < iLen; i++){
            oCol = oSettings.aoColumns[i];
            create = nTrIn && anTds[i] ? false : true;
            nTd = create ? document.createElement(oCol.sCellType) : anTds[i];
            if (!nTd) $420c57962e03702d$var$_fnLog(oSettings, 0, "Incorrect column count", 18);
            nTd._DT_CellIndex = {
                row: iRow,
                column: i
            };
            cells.push(nTd);
            var display = $420c57962e03702d$var$_fnGetRowDisplay(oSettings, iRow);
            // Need to create the HTML if new, or if a rendering function is defined
            if (create || (oCol.mRender || oCol.mData !== i) && (!$420c57962e03702d$var$$.isPlainObject(oCol.mData) || oCol.mData._ !== i + ".display")) $420c57962e03702d$var$_fnWriteCell(nTd, display[i]);
            // Visibility - add or remove as required
            if (oCol.bVisible && create) nTr.appendChild(nTd);
            else if (!oCol.bVisible && !create) nTd.parentNode.removeChild(nTd);
            if (oCol.fnCreatedCell) oCol.fnCreatedCell.call(oSettings.oInstance, nTd, $420c57962e03702d$var$_fnGetCellData(oSettings, iRow, i), rowData, iRow, i);
        }
        $420c57962e03702d$var$_fnCallbackFire(oSettings, "aoRowCreatedCallback", "row-created", [
            nTr,
            rowData,
            iRow,
            cells
        ]);
    } else $420c57962e03702d$var$_addClass(row.nTr, trClass);
}
/**
 * Add attributes to a row based on the special `DT_*` parameters in a data
 * source object.
 *  @param {object} settings DataTables settings object
 *  @param {object} DataTables row object for the row to be modified
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnRowAttributes(settings, row) {
    var tr = row.nTr;
    var data = row._aData;
    if (tr) {
        var id = settings.rowIdFn(data);
        if (id) tr.id = id;
        if (data.DT_RowClass) {
            // Remove any classes added by DT_RowClass before
            var a = data.DT_RowClass.split(" ");
            row.__rowc = row.__rowc ? $420c57962e03702d$var$_unique(row.__rowc.concat(a)) : a;
            $420c57962e03702d$var$$(tr).removeClass(row.__rowc.join(" ")).addClass(data.DT_RowClass);
        }
        if (data.DT_RowAttr) $420c57962e03702d$var$$(tr).attr(data.DT_RowAttr);
        if (data.DT_RowData) $420c57962e03702d$var$$(tr).data(data.DT_RowData);
    }
}
/**
 * Create the HTML header for the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnBuildHead(settings, side) {
    var classes = settings.oClasses;
    var columns = settings.aoColumns;
    var i, ien, row;
    var target = side === "header" ? settings.nTHead : settings.nTFoot;
    var titleProp = side === "header" ? "sTitle" : side;
    // Footer might be defined
    if (!target) return;
    // If no cells yet and we have content for them, then create
    if (side === "header" || $420c57962e03702d$var$_pluck(settings.aoColumns, titleProp).join("")) {
        row = $420c57962e03702d$var$$("tr", target);
        // Add a row if needed
        if (!row.length) row = $420c57962e03702d$var$$("<tr/>").appendTo(target);
        // Add the number of cells needed to make up to the number of columns
        if (row.length === 1) {
            var cells = $420c57962e03702d$var$$("td, th", row);
            for(i = cells.length, ien = columns.length; i < ien; i++)$420c57962e03702d$var$$("<th/>").html(columns[i][titleProp] || "").appendTo(row);
        }
    }
    var detected = $420c57962e03702d$var$_fnDetectHeader(settings, target, true);
    if (side === "header") settings.aoHeader = detected;
    else settings.aoFooter = detected;
    // ARIA role for the rows
    $420c57962e03702d$var$$(target).children("tr").attr("role", "row");
    // Every cell needs to be passed through the renderer
    $420c57962e03702d$var$$(target).children("tr").children("th, td").each(function() {
        $420c57962e03702d$var$_fnRenderer(settings, side)(settings, $420c57962e03702d$var$$(this), classes);
    });
}
/**
 * Build a layout structure for a header or footer
 *
 * @param {*} settings DataTables settings
 * @param {*} source Source layout array
 * @param {*} incColumns What columns should be included
 * @returns Layout array
 */ function $420c57962e03702d$var$_fnHeaderLayout(settings, source, incColumns) {
    var row, column, cell;
    var local = [];
    var structure = [];
    var columns = settings.aoColumns;
    var columnCount = columns.length;
    var rowspan, colspan;
    if (!source) return;
    // Default is to work on only visible columns
    if (!incColumns) incColumns = $420c57962e03702d$var$_range(columnCount).filter(function(idx) {
        return columns[idx].bVisible;
    });
    // Make a copy of the master layout array, but with only the columns we want
    for(row = 0; row < source.length; row++){
        // Remove any columns we haven't selected
        local[row] = source[row].slice().filter(function(cell, i) {
            return incColumns.includes(i);
        });
        // Prep the structure array - it needs an element for each row
        structure.push([]);
    }
    for(row = 0; row < local.length; row++)for(column = 0; column < local[row].length; column++){
        rowspan = 1;
        colspan = 1;
        // Check to see if there is already a cell (row/colspan) covering our target
        // insert point. If there is, then there is nothing to do.
        if (structure[row][column] === undefined) {
            cell = local[row][column].cell;
            // Expand for rowspan
            while(local[row + rowspan] !== undefined && local[row][column].cell == local[row + rowspan][column].cell){
                structure[row + rowspan][column] = null;
                rowspan++;
            }
            // And for colspan
            while(local[row][column + colspan] !== undefined && local[row][column].cell == local[row][column + colspan].cell){
                // Which also needs to go over rows
                for(var k = 0; k < rowspan; k++)structure[row + k][column + colspan] = null;
                colspan++;
            }
            var titleSpan = $420c57962e03702d$var$$("span.dt-column-title", cell);
            structure[row][column] = {
                cell: cell,
                colspan: colspan,
                rowspan: rowspan,
                title: titleSpan.length ? titleSpan.html() : $420c57962e03702d$var$$(cell).html()
            };
        }
    }
    return structure;
}
/**
 * Draw the header (or footer) element based on the column visibility states.
 *
 *  @param object oSettings dataTables settings object
 *  @param array aoSource Layout array from _fnDetectHeader
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnDrawHead(settings, source) {
    var layout = $420c57962e03702d$var$_fnHeaderLayout(settings, source);
    var tr, n;
    for(var row = 0; row < source.length; row++){
        tr = source[row].row;
        // All cells are going to be replaced, so empty out the row
        // Can't use $().empty() as that kills event handlers
        if (tr) while(n = tr.firstChild)tr.removeChild(n);
        for(var column = 0; column < layout[row].length; column++){
            var point = layout[row][column];
            if (point) $420c57962e03702d$var$$(point.cell).appendTo(tr).attr("rowspan", point.rowspan).attr("colspan", point.colspan);
        }
    }
}
/**
 * Insert the required TR nodes into the table for display
 *  @param {object} oSettings dataTables settings object
 *  @param ajaxComplete true after ajax call to complete rendering
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnDraw(oSettings, ajaxComplete) {
    // Allow for state saving and a custom start position
    $420c57962e03702d$var$_fnStart(oSettings);
    /* Provide a pre-callback function which can be used to cancel the draw is false is returned */ var aPreDraw = $420c57962e03702d$var$_fnCallbackFire(oSettings, "aoPreDrawCallback", "preDraw", [
        oSettings
    ]);
    if (aPreDraw.indexOf(false) !== -1) {
        $420c57962e03702d$var$_fnProcessingDisplay(oSettings, false);
        return;
    }
    var anRows = [];
    var iRowCount = 0;
    var bServerSide = $420c57962e03702d$var$_fnDataSource(oSettings) == "ssp";
    var aiDisplay = oSettings.aiDisplay;
    var iDisplayStart = oSettings._iDisplayStart;
    var iDisplayEnd = oSettings.fnDisplayEnd();
    var columns = oSettings.aoColumns;
    var body = $420c57962e03702d$var$$(oSettings.nTBody);
    oSettings.bDrawing = true;
    /* Server-side processing draw intercept */ if (!bServerSide) oSettings.iDraw++;
    else if (!oSettings.bDestroying && !ajaxComplete) {
        // Show loading message for server-side processing
        if (oSettings.iDraw === 0) body.empty().append($420c57962e03702d$var$_emptyRow(oSettings));
        $420c57962e03702d$var$_fnAjaxUpdate(oSettings);
        return;
    }
    if (aiDisplay.length !== 0) {
        var iStart = bServerSide ? 0 : iDisplayStart;
        var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
        for(var j = iStart; j < iEnd; j++){
            var iDataIndex = aiDisplay[j];
            var aoData = oSettings.aoData[iDataIndex];
            if (aoData.nTr === null) $420c57962e03702d$var$_fnCreateTr(oSettings, iDataIndex);
            var nRow = aoData.nTr;
            // Add various classes as needed
            for(var i = 0; i < columns.length; i++){
                var col = columns[i];
                var td = aoData.anCells[i];
                $420c57962e03702d$var$_addClass(td, $420c57962e03702d$var$_ext.type.className[col.sType]); // auto class
                $420c57962e03702d$var$_addClass(td, col.sClass); // column class
                $420c57962e03702d$var$_addClass(td, oSettings.oClasses.tbody.cell); // all cells
            }
            // Row callback functions - might want to manipulate the row
            // iRowCount and j are not currently documented. Are they at all
            // useful?
            $420c57962e03702d$var$_fnCallbackFire(oSettings, "aoRowCallback", null, [
                nRow,
                aoData._aData,
                iRowCount,
                j,
                iDataIndex
            ]);
            anRows.push(nRow);
            iRowCount++;
        }
    } else anRows[0] = $420c57962e03702d$var$_emptyRow(oSettings);
    /* Header and footer callbacks */ $420c57962e03702d$var$_fnCallbackFire(oSettings, "aoHeaderCallback", "header", [
        $420c57962e03702d$var$$(oSettings.nTHead).children("tr")[0],
        $420c57962e03702d$var$_fnGetDataMaster(oSettings),
        iDisplayStart,
        iDisplayEnd,
        aiDisplay
    ]);
    $420c57962e03702d$var$_fnCallbackFire(oSettings, "aoFooterCallback", "footer", [
        $420c57962e03702d$var$$(oSettings.nTFoot).children("tr")[0],
        $420c57962e03702d$var$_fnGetDataMaster(oSettings),
        iDisplayStart,
        iDisplayEnd,
        aiDisplay
    ]);
    // replaceChildren is faster, but only became widespread in 2020,
    // so a fall back in jQuery is provided for older browsers.
    if (body[0].replaceChildren) body[0].replaceChildren.apply(body[0], anRows);
    else {
        body.children().detach();
        body.append($420c57962e03702d$var$$(anRows));
    }
    // Empty table needs a specific class
    $420c57962e03702d$var$$(oSettings.nTableWrapper).toggleClass("dt-empty-footer", $420c57962e03702d$var$$("tr", oSettings.nTFoot).length === 0);
    /* Call all required callback functions for the end of a draw */ $420c57962e03702d$var$_fnCallbackFire(oSettings, "aoDrawCallback", "draw", [
        oSettings
    ], true);
    /* Draw is complete, sorting and filtering must be as well */ oSettings.bSorted = false;
    oSettings.bFiltered = false;
    oSettings.bDrawing = false;
}
/**
 * Redraw the table - taking account of the various features which are enabled
 *  @param {object} oSettings dataTables settings object
 *  @param {boolean} [holdPosition] Keep the current paging position. By default
 *    the paging is reset to the first page
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnReDraw(settings, holdPosition, recompute) {
    var features = settings.oFeatures, sort = features.bSort, filter = features.bFilter;
    if (recompute === undefined || recompute === true) {
        if (sort) $420c57962e03702d$var$_fnSort(settings);
        if (filter) $420c57962e03702d$var$_fnFilterComplete(settings, settings.oPreviousSearch);
        else // No filtering, so we want to just use the display master
        settings.aiDisplay = settings.aiDisplayMaster.slice();
    }
    if (holdPosition !== true) settings._iDisplayStart = 0;
    // Let any modules know about the draw hold position state (used by
    // scrolling internally)
    settings._drawHold = holdPosition;
    $420c57962e03702d$var$_fnDraw(settings);
    settings._drawHold = false;
}
/*
 * Table is empty - create a row with an empty message in it
 */ function $420c57962e03702d$var$_emptyRow(settings) {
    var oLang = settings.oLanguage;
    var zero = oLang.sZeroRecords;
    var dataSrc = $420c57962e03702d$var$_fnDataSource(settings);
    if (settings.iDraw < 1 && dataSrc === "ssp" || settings.iDraw <= 1 && dataSrc === "ajax") zero = oLang.sLoadingRecords;
    else if (oLang.sEmptyTable && settings.fnRecordsTotal() === 0) zero = oLang.sEmptyTable;
    return $420c57962e03702d$var$$("<tr/>").append($420c57962e03702d$var$$("<td />", {
        "colSpan": $420c57962e03702d$var$_fnVisbleColumns(settings),
        "class": settings.oClasses.empty.row
    }).html(zero))[0];
}
/**
 * Convert a `layout` object given by a user to the object structure needed
 * for the renderer. This is done twice, once for above and once for below
 * the table. Ordering must also be considered.
 *
 * @param {*} settings DataTables settings object
 * @param {*} layout Layout object to convert
 * @param {string} side `top` or `bottom`
 * @returns Converted array structure - one item for each row.
 */ function $420c57962e03702d$var$_layoutArray(settings, layout, side) {
    var groups = {};
    // Combine into like groups (e.g. `top`, `top2`, etc)
    $420c57962e03702d$var$$.each(layout, function(pos, val) {
        if (val === null) return;
        var splitPos = pos.replace(/([A-Z])/g, " $1").split(" ");
        if (!groups[splitPos[0]]) groups[splitPos[0]] = {};
        var align = splitPos.length === 1 ? "full" : splitPos[1].toLowerCase();
        var group = groups[splitPos[0]];
        var groupRun = function(contents, innerVal) {
            // If it is an object, then there can be multiple features contained in it
            if ($420c57962e03702d$var$$.isPlainObject(innerVal)) Object.keys(innerVal).map(function(key) {
                contents.push({
                    feature: key,
                    opts: innerVal[key]
                });
            });
            else contents.push(innerVal);
        };
        // Transform to an object with a contents property
        if (!group[align] || !group[align].contents) group[align] = {
            contents: []
        };
        // Allow for an array or just a single object
        if (Array.isArray(val)) for(var i = 0; i < val.length; i++)groupRun(group[align].contents, val[i]);
        else groupRun(group[align].contents, val);
        // And make contents an array
        if (!Array.isArray(group[align].contents)) group[align].contents = [
            group[align].contents
        ];
    });
    var filtered = Object.keys(groups).map(function(pos) {
        // Filter to only the side we need
        if (pos.indexOf(side) !== 0) return null;
        return {
            name: pos,
            val: groups[pos]
        };
    }).filter(function(item) {
        return item !== null;
    });
    // Order by item identifier
    filtered.sort(function(a, b) {
        var order1 = a.name.replace(/[^0-9]/g, "") * 1;
        var order2 = b.name.replace(/[^0-9]/g, "") * 1;
        return order2 - order1;
    });
    if (side === "bottom") filtered.reverse();
    // Split into rows
    var rows = [];
    for(var i = 0, ien = filtered.length; i < ien; i++){
        if (filtered[i].val.full) {
            rows.push({
                full: filtered[i].val.full
            });
            $420c57962e03702d$var$_layoutResolve(settings, rows[rows.length - 1]);
            delete filtered[i].val.full;
        }
        if (Object.keys(filtered[i].val).length) {
            rows.push(filtered[i].val);
            $420c57962e03702d$var$_layoutResolve(settings, rows[rows.length - 1]);
        }
    }
    return rows;
}
/**
 * Convert the contents of a row's layout object to nodes that can be inserted
 * into the document by a renderer. Execute functions, look up plug-ins, etc.
 *
 * @param {*} settings DataTables settings object
 * @param {*} row Layout object for this row
 */ function $420c57962e03702d$var$_layoutResolve(settings, row) {
    var getFeature = function(feature, opts) {
        if (!$420c57962e03702d$var$_ext.features[feature]) $420c57962e03702d$var$_fnLog(settings, 0, "Unknown feature: " + feature);
        return $420c57962e03702d$var$_ext.features[feature].apply(this, [
            settings,
            opts
        ]);
    };
    var resolve = function(item) {
        var line = row[item].contents;
        for(var i = 0, ien = line.length; i < ien; i++){
            if (!line[i]) continue;
            else if (typeof line[i] === "string") line[i] = getFeature(line[i], null);
            else if ($420c57962e03702d$var$$.isPlainObject(line[i])) // If it's an object, it just has feature and opts properties from
            // the transform in _layoutArray
            line[i] = getFeature(line[i].feature, line[i].opts);
            else if (typeof line[i].node === "function") line[i] = line[i].node(settings);
            else if (typeof line[i] === "function") {
                var inst = line[i](settings);
                line[i] = typeof inst.node === "function" ? inst.node() : inst;
            }
        }
    };
    $420c57962e03702d$var$$.each(row, function(key) {
        resolve(key);
    });
}
/**
 * Add the options to the page HTML for the table
 *  @param {object} settings DataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnAddOptionsHtml(settings) {
    var classes = settings.oClasses;
    var table = $420c57962e03702d$var$$(settings.nTable);
    // Wrapper div around everything DataTables controls
    var insert = $420c57962e03702d$var$$("<div/>").attr({
        id: settings.sTableId + "_wrapper",
        "class": classes.container
    }).insertBefore(table);
    settings.nTableWrapper = insert[0];
    if (settings.sDom) // Legacy
    $420c57962e03702d$var$_fnLayoutDom(settings, settings.sDom, insert);
    else {
        var top = $420c57962e03702d$var$_layoutArray(settings, settings.layout, "top");
        var bottom = $420c57962e03702d$var$_layoutArray(settings, settings.layout, "bottom");
        var renderer = $420c57962e03702d$var$_fnRenderer(settings, "layout");
        // Everything above - the renderer will actually insert the contents into the document
        top.forEach(function(item) {
            renderer(settings, insert, item);
        });
        // The table - always the center of attention
        renderer(settings, insert, {
            full: {
                table: true,
                contents: [
                    $420c57962e03702d$var$_fnFeatureHtmlTable(settings)
                ]
            }
        });
        // Everything below
        bottom.forEach(function(item) {
            renderer(settings, insert, item);
        });
    }
    // Processing floats on top, so it isn't an inserted feature
    $420c57962e03702d$var$_processingHtml(settings);
}
/**
 * Draw the table with the legacy DOM property
 * @param {*} settings DT settings object
 * @param {*} dom DOM string
 * @param {*} insert Insert point
 */ function $420c57962e03702d$var$_fnLayoutDom(settings, dom, insert) {
    var parts = dom.match(/(".*?")|('.*?')|./g);
    var featureNode, option, newNode, next, attr;
    for(var i = 0; i < parts.length; i++){
        featureNode = null;
        option = parts[i];
        if (option == "<") {
            // New container div
            newNode = $420c57962e03702d$var$$("<div/>");
            // Check to see if we should append an id and/or a class name to the container
            next = parts[i + 1];
            if (next[0] == "'" || next[0] == '"') {
                attr = next.replace(/['"]/g, "");
                var id = "", className;
                /* The attribute can be in the format of "#id.class", "#id" or "class" This logic
				 * breaks the string into parts and applies them as needed
				 */ if (attr.indexOf(".") != -1) {
                    var split = attr.split(".");
                    id = split[0];
                    className = split[1];
                } else if (attr[0] == "#") id = attr;
                else className = attr;
                newNode.attr("id", id.substring(1)).addClass(className);
                i++; // Move along the position array
            }
            insert.append(newNode);
            insert = newNode;
        } else if (option == ">") // End container div
        insert = insert.parent();
        else if (option == "t") // Table
        featureNode = $420c57962e03702d$var$_fnFeatureHtmlTable(settings);
        else $420c57962e03702d$var$DataTable.ext.feature.forEach(function(feature) {
            if (option == feature.cFeature) featureNode = feature.fnInit(settings);
        });
        // Add to the display
        if (featureNode) insert.append(featureNode);
    }
}
/**
 * Use the DOM source to create up an array of header cells. The idea here is to
 * create a layout grid (array) of rows x columns, which contains a reference
 * to the cell that that point in the grid (regardless of col/rowspan), such that
 * any column / row could be removed and the new grid constructed
 *  @param {node} thead The header/footer element for the table
 *  @returns {array} Calculated layout array
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnDetectHeader(settings, thead, write) {
    var columns = settings.aoColumns;
    var rows = $420c57962e03702d$var$$(thead).children("tr");
    var row, cell;
    var i, k, l, iLen, shifted, column, colspan, rowspan;
    var isHeader = thead && thead.nodeName.toLowerCase() === "thead";
    var layout = [];
    var unique;
    var shift = function(a, i, j) {
        var k = a[i];
        while(k[j])j++;
        return j;
    };
    // We know how many rows there are in the layout - so prep it
    for(i = 0, iLen = rows.length; i < iLen; i++)layout.push([]);
    for(i = 0, iLen = rows.length; i < iLen; i++){
        row = rows[i];
        column = 0;
        // For every cell in the row..
        cell = row.firstChild;
        while(cell){
            if (cell.nodeName.toUpperCase() == "TD" || cell.nodeName.toUpperCase() == "TH") {
                var cols = [];
                // Get the col and rowspan attributes from the DOM and sanitise them
                colspan = cell.getAttribute("colspan") * 1;
                rowspan = cell.getAttribute("rowspan") * 1;
                colspan = !colspan || colspan === 0 || colspan === 1 ? 1 : colspan;
                rowspan = !rowspan || rowspan === 0 || rowspan === 1 ? 1 : rowspan;
                // There might be colspan cells already in this row, so shift our target
                // accordingly
                shifted = shift(layout, i, column);
                // Cache calculation for unique columns
                unique = colspan === 1 ? true : false;
                // Perform header setup
                if (write) {
                    if (unique) {
                        // Allow column options to be set from HTML attributes
                        $420c57962e03702d$var$_fnColumnOptions(settings, shifted, $420c57962e03702d$var$$(cell).data());
                        // Get the width for the column. This can be defined from the
                        // width attribute, style attribute or `columns.width` option
                        var columnDef = columns[shifted];
                        var width = cell.getAttribute("width") || null;
                        var t = cell.style.width.match(/width:\s*(\d+[pxem%]+)/);
                        if (t) width = t[1];
                        columnDef.sWidthOrig = columnDef.sWidth || width;
                        if (isHeader) {
                            // Column title handling - can be user set, or read from the DOM
                            // This happens before the render, so the original is still in place
                            if (columnDef.sTitle !== null && !columnDef.autoTitle) cell.innerHTML = columnDef.sTitle;
                            if (!columnDef.sTitle && unique) {
                                columnDef.sTitle = $420c57962e03702d$var$_stripHtml(cell.innerHTML);
                                columnDef.autoTitle = true;
                            }
                        } else // Footer specific operations
                        if (columnDef.footer) cell.innerHTML = columnDef.footer;
                        // Fall back to the aria-label attribute on the table header if no ariaTitle is
                        // provided.
                        if (!columnDef.ariaTitle) columnDef.ariaTitle = $420c57962e03702d$var$$(cell).attr("aria-label") || columnDef.sTitle;
                        // Column specific class names
                        if (columnDef.className) $420c57962e03702d$var$$(cell).addClass(columnDef.className);
                    }
                    // Wrap the column title so we can write to it in future
                    if ($420c57962e03702d$var$$("span.dt-column-title", cell).length === 0) $420c57962e03702d$var$$("<span>").addClass("dt-column-title").append(cell.childNodes).appendTo(cell);
                    if (isHeader && $420c57962e03702d$var$$("span.dt-column-order", cell).length === 0) $420c57962e03702d$var$$("<span>").addClass("dt-column-order").appendTo(cell);
                }
                // If there is col / rowspan, copy the information into the layout grid
                for(l = 0; l < colspan; l++){
                    for(k = 0; k < rowspan; k++){
                        layout[i + k][shifted + l] = {
                            cell: cell,
                            unique: unique
                        };
                        layout[i + k].row = row;
                    }
                    cols.push(shifted + l);
                }
                // Assign an attribute so spanning cells can still be identified
                // as belonging to a column
                cell.setAttribute("data-dt-column", $420c57962e03702d$var$_unique(cols).join(","));
            }
            cell = cell.nextSibling;
        }
    }
    return layout;
}
/**
 * Set the start position for draw
 *  @param {object} oSettings dataTables settings object
 */ function $420c57962e03702d$var$_fnStart(oSettings) {
    var bServerSide = $420c57962e03702d$var$_fnDataSource(oSettings) == "ssp";
    var iInitDisplayStart = oSettings.iInitDisplayStart;
    // Check and see if we have an initial draw position from state saving
    if (iInitDisplayStart !== undefined && iInitDisplayStart !== -1) {
        oSettings._iDisplayStart = bServerSide ? iInitDisplayStart : iInitDisplayStart >= oSettings.fnRecordsDisplay() ? 0 : iInitDisplayStart;
        oSettings.iInitDisplayStart = -1;
    }
}
/**
 * Create an Ajax call based on the table's settings, taking into account that
 * parameters can have multiple forms, and backwards compatibility.
 *
 * @param {object} oSettings dataTables settings object
 * @param {array} data Data to send to the server, required by
 *     DataTables - may be augmented by developer callbacks
 * @param {function} fn Callback function to run when data is obtained
 */ function $420c57962e03702d$var$_fnBuildAjax(oSettings, data, fn) {
    var ajaxData;
    var ajax = oSettings.ajax;
    var instance = oSettings.oInstance;
    var callback = function(json) {
        var status = oSettings.jqXHR ? oSettings.jqXHR.status : null;
        if (json === null || typeof status === "number" && status == 204) {
            json = {};
            $420c57962e03702d$var$_fnAjaxDataSrc(oSettings, json, []);
        }
        var error = json.error || json.sError;
        if (error) $420c57962e03702d$var$_fnLog(oSettings, 0, error);
        oSettings.json = json;
        $420c57962e03702d$var$_fnCallbackFire(oSettings, null, "xhr", [
            oSettings,
            json,
            oSettings.jqXHR
        ], true);
        fn(json);
    };
    if ($420c57962e03702d$var$$.isPlainObject(ajax) && ajax.data) {
        ajaxData = ajax.data;
        var newData = typeof ajaxData === "function" ? ajaxData(data, oSettings) : ajaxData; // an object object or array to merge
        // If the function returned something, use that alone
        data = typeof ajaxData === "function" && newData ? newData : $420c57962e03702d$var$$.extend(true, data, newData);
        // Remove the data property as we've resolved it already and don't want
        // jQuery to do it again (it is restored at the end of the function)
        delete ajax.data;
    }
    var baseAjax = {
        "url": typeof ajax === "string" ? ajax : "",
        "data": data,
        "success": callback,
        "dataType": "json",
        "cache": false,
        "type": oSettings.sServerMethod,
        "error": function(xhr, error) {
            var ret = $420c57962e03702d$var$_fnCallbackFire(oSettings, null, "xhr", [
                oSettings,
                null,
                oSettings.jqXHR
            ], true);
            if (ret.indexOf(true) === -1) {
                if (error == "parsererror") $420c57962e03702d$var$_fnLog(oSettings, 0, "Invalid JSON response", 1);
                else if (xhr.readyState === 4) $420c57962e03702d$var$_fnLog(oSettings, 0, "Ajax error", 7);
            }
            $420c57962e03702d$var$_fnProcessingDisplay(oSettings, false);
        }
    };
    // If `ajax` option is an object, extend and override our default base
    if ($420c57962e03702d$var$$.isPlainObject(ajax)) $420c57962e03702d$var$$.extend(baseAjax, ajax);
    // Store the data submitted for the API
    oSettings.oAjaxData = data;
    // Allow plug-ins and external processes to modify the data
    $420c57962e03702d$var$_fnCallbackFire(oSettings, null, "preXhr", [
        oSettings,
        data,
        baseAjax
    ], true);
    if (typeof ajax === "function") // Is a function - let the caller define what needs to be done
    oSettings.jqXHR = ajax.call(instance, data, callback, oSettings);
    else if (ajax.url === "") {
        // No url, so don't load any data. Just apply an empty data array
        // to the object for the callback.
        var empty = {};
        $420c57962e03702d$var$DataTable.util.set(ajax.dataSrc)(empty, []);
        callback(empty);
    } else {
        // Object to extend the base settings
        oSettings.jqXHR = $420c57962e03702d$var$$.ajax(baseAjax);
        // Restore for next time around
        if (ajaxData) ajax.data = ajaxData;
    }
}
/**
 * Update the table using an Ajax call
 *  @param {object} settings dataTables settings object
 *  @returns {boolean} Block the table drawing or not
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnAjaxUpdate(settings) {
    settings.iDraw++;
    $420c57962e03702d$var$_fnProcessingDisplay(settings, true);
    $420c57962e03702d$var$_fnBuildAjax(settings, $420c57962e03702d$var$_fnAjaxParameters(settings), function(json) {
        $420c57962e03702d$var$_fnAjaxUpdateDraw(settings, json);
    });
}
/**
 * Build up the parameters in an object needed for a server-side processing
 * request.
 *  @param {object} oSettings dataTables settings object
 *  @returns {bool} block the table drawing or not
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnAjaxParameters(settings) {
    var columns = settings.aoColumns, features = settings.oFeatures, preSearch = settings.oPreviousSearch, preColSearch = settings.aoPreSearchCols, colData = function(idx, prop) {
        return typeof columns[idx][prop] === "function" ? "function" : columns[idx][prop];
    };
    return {
        draw: settings.iDraw,
        columns: columns.map(function(column, i) {
            return {
                data: colData(i, "mData"),
                name: column.sName,
                searchable: column.bSearchable,
                orderable: column.bSortable,
                search: {
                    value: preColSearch[i].search,
                    regex: preColSearch[i].regex,
                    fixed: Object.keys(column.searchFixed).map(function(name) {
                        return {
                            name: name,
                            term: column.searchFixed[name].toString()
                        };
                    })
                }
            };
        }),
        order: $420c57962e03702d$var$_fnSortFlatten(settings).map(function(val) {
            return {
                column: val.col,
                dir: val.dir,
                name: colData(val.col, "sName")
            };
        }),
        start: settings._iDisplayStart,
        length: features.bPaginate ? settings._iDisplayLength : -1,
        search: {
            value: preSearch.search,
            regex: preSearch.regex,
            fixed: Object.keys(settings.searchFixed).map(function(name) {
                return {
                    name: name,
                    term: settings.searchFixed[name].toString()
                };
            })
        }
    };
}
/**
 * Data the data from the server (nuking the old) and redraw the table
 *  @param {object} oSettings dataTables settings object
 *  @param {object} json json data return from the server.
 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
 *  @param {array} json.aaData The data to display on this page
 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnAjaxUpdateDraw(settings, json) {
    var data = $420c57962e03702d$var$_fnAjaxDataSrc(settings, json);
    var draw = $420c57962e03702d$var$_fnAjaxDataSrcParam(settings, "draw", json);
    var recordsTotal = $420c57962e03702d$var$_fnAjaxDataSrcParam(settings, "recordsTotal", json);
    var recordsFiltered = $420c57962e03702d$var$_fnAjaxDataSrcParam(settings, "recordsFiltered", json);
    if (draw !== undefined) {
        // Protect against out of sequence returns
        if (draw * 1 < settings.iDraw) return;
        settings.iDraw = draw * 1;
    }
    // No data in returned object, so rather than an array, we show an empty table
    if (!data) data = [];
    $420c57962e03702d$var$_fnClearTable(settings);
    settings._iRecordsTotal = parseInt(recordsTotal, 10);
    settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
    for(var i = 0, ien = data.length; i < ien; i++)$420c57962e03702d$var$_fnAddData(settings, data[i]);
    settings.aiDisplay = settings.aiDisplayMaster.slice();
    $420c57962e03702d$var$_fnDraw(settings, true);
    $420c57962e03702d$var$_fnInitComplete(settings);
    $420c57962e03702d$var$_fnProcessingDisplay(settings, false);
}
/**
 * Get the data from the JSON data source to use for drawing a table. Using
 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
 * source object, or from a processing function.
 *  @param {object} settings dataTables settings object
 *  @param  {object} json Data source object / array from the server
 *  @return {array} Array of data to use
 */ function $420c57962e03702d$var$_fnAjaxDataSrc(settings, json, write) {
    var dataProp = "data";
    if ($420c57962e03702d$var$$.isPlainObject(settings.ajax) && settings.ajax.dataSrc !== undefined) {
        // Could in inside a `dataSrc` object, or not!
        var dataSrc = settings.ajax.dataSrc;
        // string, function and object are valid types
        if (typeof dataSrc === "string" || typeof dataSrc === "function") dataProp = dataSrc;
        else if (dataSrc.data !== undefined) dataProp = dataSrc.data;
    }
    if (!write) {
        if (dataProp === "data") // If the default, then we still want to support the old style, and safely ignore
        // it if possible
        return json.aaData || json[dataProp];
        return dataProp !== "" ? $420c57962e03702d$var$_fnGetObjectDataFn(dataProp)(json) : json;
    }
    // set
    $420c57962e03702d$var$_fnSetObjectDataFn(dataProp)(json, write);
}
/**
 * Very similar to _fnAjaxDataSrc, but for the other SSP properties
 * @param {*} settings DataTables settings object
 * @param {*} param Target parameter
 * @param {*} json JSON data
 * @returns Resolved value
 */ function $420c57962e03702d$var$_fnAjaxDataSrcParam(settings, param, json) {
    var dataSrc = $420c57962e03702d$var$$.isPlainObject(settings.ajax) ? settings.ajax.dataSrc : null;
    if (dataSrc && dataSrc[param]) // Get from custom location
    return $420c57962e03702d$var$_fnGetObjectDataFn(dataSrc[param])(json);
    // else - Default behaviour
    var old = "";
    // Legacy support
    if (param === "draw") old = "sEcho";
    else if (param === "recordsTotal") old = "iTotalRecords";
    else if (param === "recordsFiltered") old = "iTotalDisplayRecords";
    return json[old] !== undefined ? json[old] : json[param];
}
/**
 * Filter the table using both the global filter and column based filtering
 *  @param {object} settings dataTables settings object
 *  @param {object} input search information
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnFilterComplete(settings, input) {
    var columnsSearch = settings.aoPreSearchCols;
    // Resolve any column types that are unknown due to addition or invalidation
    // @todo As per sort - can this be moved into an event handler?
    $420c57962e03702d$var$_fnColumnTypes(settings);
    // In server-side processing all filtering is done by the server, so no point hanging around here
    if ($420c57962e03702d$var$_fnDataSource(settings) != "ssp") {
        // Check if any of the rows were invalidated
        $420c57962e03702d$var$_fnFilterData(settings);
        // Start from the full data set
        settings.aiDisplay = settings.aiDisplayMaster.slice();
        // Global filter first
        $420c57962e03702d$var$_fnFilter(settings.aiDisplay, settings, input.search, input);
        $420c57962e03702d$var$$.each(settings.searchFixed, function(name, term) {
            $420c57962e03702d$var$_fnFilter(settings.aiDisplay, settings, term, {});
        });
        // Then individual column filters
        for(var i = 0; i < columnsSearch.length; i++){
            var col = columnsSearch[i];
            $420c57962e03702d$var$_fnFilter(settings.aiDisplay, settings, col.search, col, i);
            $420c57962e03702d$var$$.each(settings.aoColumns[i].searchFixed, function(name, term) {
                $420c57962e03702d$var$_fnFilter(settings.aiDisplay, settings, term, {}, i);
            });
        }
        // And finally global filtering
        $420c57962e03702d$var$_fnFilterCustom(settings);
    }
    // Tell the draw function we have been filtering
    settings.bFiltered = true;
    $420c57962e03702d$var$_fnCallbackFire(settings, null, "search", [
        settings
    ]);
}
/**
 * Apply custom filtering functions
 * 
 * This is legacy now that we have named functions, but it is widely used
 * from 1.x, so it is not yet deprecated.
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnFilterCustom(settings) {
    var filters = $420c57962e03702d$var$DataTable.ext.search;
    var displayRows = settings.aiDisplay;
    var row, rowIdx;
    for(var i = 0, ien = filters.length; i < ien; i++){
        var rows = [];
        // Loop over each row and see if it should be included
        for(var j = 0, jen = displayRows.length; j < jen; j++){
            rowIdx = displayRows[j];
            row = settings.aoData[rowIdx];
            if (filters[i](settings, row._aFilterData, rowIdx, row._aData, j)) rows.push(rowIdx);
        }
        // So the array reference doesn't break set the results into the
        // existing array
        displayRows.length = 0;
        displayRows.push.apply(displayRows, rows);
    }
}
/**
 * Filter the data table based on user input and draw the table
 */ function $420c57962e03702d$var$_fnFilter(searchRows, settings, input, options, column) {
    if (input === "") return;
    var i = 0;
    var matched = [];
    // Search term can be a function, regex or string - if a string we apply our
    // smart filtering regex (assuming the options require that)
    var searchFunc = typeof input === "function" ? input : null;
    var rpSearch = input instanceof RegExp ? input : searchFunc ? null : $420c57962e03702d$var$_fnFilterCreateSearch(input, options);
    // Then for each row, does the test pass. If not, lop the row from the array
    for(i = 0; i < searchRows.length; i++){
        var row = settings.aoData[searchRows[i]];
        var data = column === undefined ? row._sFilterRow : row._aFilterData[column];
        if (searchFunc && searchFunc(data, row._aData, searchRows[i], column) || rpSearch && rpSearch.test(data)) matched.push(searchRows[i]);
    }
    // Mutate the searchRows array
    searchRows.length = matched.length;
    for(i = 0; i < matched.length; i++)searchRows[i] = matched[i];
}
/**
 * Build a regular expression object suitable for searching a table
 *  @param {string} sSearch string to search for
 *  @param {bool} bRegex treat as a regular expression or not
 *  @param {bool} bSmart perform smart filtering or not
 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
 *  @returns {RegExp} constructed object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnFilterCreateSearch(search, inOpts) {
    var not = [];
    var options = $420c57962e03702d$var$$.extend({}, {
        boundary: false,
        caseInsensitive: true,
        exact: false,
        regex: false,
        smart: true
    }, inOpts);
    if (typeof search !== "string") search = search.toString();
    // Remove diacritics if normalize is set up to do so
    search = $420c57962e03702d$var$_normalize(search);
    if (options.exact) return new RegExp("^" + $420c57962e03702d$var$_fnEscapeRegex(search) + "$", options.caseInsensitive ? "i" : "");
    search = options.regex ? search : $420c57962e03702d$var$_fnEscapeRegex(search);
    if (options.smart) {
        /* For smart filtering we want to allow the search to work regardless of
		 * word order. We also want double quoted text to be preserved, so word
		 * order is important - a la google. And a negative look around for
		 * finding rows which don't contain a given string.
		 * 
		 * So this is the sort of thing we want to generate:
		 * 
		 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
		 */ var parts = search.match(/!?["\u201C][^"\u201D]+["\u201D]|[^ ]+/g) || [
            ""
        ];
        var a = parts.map(function(word) {
            var negative = false;
            var m;
            // Determine if it is a "does not include"
            if (word.charAt(0) === "!") {
                negative = true;
                word = word.substring(1);
            }
            // Strip the quotes from around matched phrases
            if (word.charAt(0) === '"') {
                m = word.match(/^"(.*)"$/);
                word = m ? m[1] : word;
            } else if (word.charAt(0) === "\u201C") {
                // Smart quote match (iPhone users)
                m = word.match(/^\u201C(.*)\u201D$/);
                word = m ? m[1] : word;
            }
            // For our "not" case, we need to modify the string that is
            // allowed to match at the end of the expression.
            if (negative) {
                if (word.length > 1) not.push("(?!" + word + ")");
                word = "";
            }
            return word.replace(/"/g, "");
        });
        var match = not.length ? not.join("") : "";
        var boundary = options.boundary ? "\\b" : "";
        search = "^(?=.*?" + boundary + a.join(")(?=.*?" + boundary) + ")(" + match + ".)*$";
    }
    return new RegExp(search, options.caseInsensitive ? "i" : "");
}
/**
 * Escape a string such that it can be used in a regular expression
 *  @param {string} sVal string to escape
 *  @returns {string} escaped string
 *  @memberof DataTable#oApi
 */ var $420c57962e03702d$var$_fnEscapeRegex = $420c57962e03702d$var$DataTable.util.escapeRegex;
var $420c57962e03702d$var$__filter_div = $420c57962e03702d$var$$("<div>")[0];
var $420c57962e03702d$var$__filter_div_textContent = $420c57962e03702d$var$__filter_div.textContent !== undefined;
// Update the filtering data for each row if needed (by invalidation or first run)
function $420c57962e03702d$var$_fnFilterData(settings) {
    var columns = settings.aoColumns;
    var data = settings.aoData;
    var column;
    var j, jen, filterData, cellData, row;
    var wasInvalidated = false;
    for(var rowIdx = 0; rowIdx < data.length; rowIdx++){
        if (!data[rowIdx]) continue;
        row = data[rowIdx];
        if (!row._aFilterData) {
            filterData = [];
            for(j = 0, jen = columns.length; j < jen; j++){
                column = columns[j];
                if (column.bSearchable) {
                    cellData = $420c57962e03702d$var$_fnGetCellData(settings, rowIdx, j, "filter");
                    // Search in DataTables is string based
                    if (cellData === null) cellData = "";
                    if (typeof cellData !== "string" && cellData.toString) cellData = cellData.toString();
                } else cellData = "";
                // If it looks like there is an HTML entity in the string,
                // attempt to decode it so sorting works as expected. Note that
                // we could use a single line of jQuery to do this, but the DOM
                // method used here is much faster https://jsperf.com/html-decode
                if (cellData.indexOf && cellData.indexOf("&") !== -1) {
                    $420c57962e03702d$var$__filter_div.innerHTML = cellData;
                    cellData = $420c57962e03702d$var$__filter_div_textContent ? $420c57962e03702d$var$__filter_div.textContent : $420c57962e03702d$var$__filter_div.innerText;
                }
                if (cellData.replace) cellData = cellData.replace(/[\r\n\u2028]/g, "");
                filterData.push(cellData);
            }
            row._aFilterData = filterData;
            row._sFilterRow = filterData.join("  ");
            wasInvalidated = true;
        }
    }
    return wasInvalidated;
}
/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnInitialise(settings) {
    var i, iAjaxStart = settings.iInitDisplayStart;
    /* Ensure that the table data is fully initialised */ if (!settings.bInitialised) {
        setTimeout(function() {
            $420c57962e03702d$var$_fnInitialise(settings);
        }, 200);
        return;
    }
    /* Build and draw the header / footer for the table */ $420c57962e03702d$var$_fnBuildHead(settings, "header");
    $420c57962e03702d$var$_fnBuildHead(settings, "footer");
    $420c57962e03702d$var$_fnDrawHead(settings, settings.aoHeader);
    $420c57962e03702d$var$_fnDrawHead(settings, settings.aoFooter);
    // Enable features
    $420c57962e03702d$var$_fnAddOptionsHtml(settings);
    $420c57962e03702d$var$_fnSortInit(settings);
    $420c57962e03702d$var$_colGroup(settings);
    /* Okay to show that something is going on now */ $420c57962e03702d$var$_fnProcessingDisplay(settings, true);
    $420c57962e03702d$var$_fnCallbackFire(settings, null, "preInit", [
        settings
    ], true);
    // If there is default sorting required - let's do it. The sort function
    // will do the drawing for us. Otherwise we draw the table regardless of the
    // Ajax source - this allows the table to look initialised for Ajax sourcing
    // data (show 'loading' message possibly)
    $420c57962e03702d$var$_fnReDraw(settings);
    var dataSrc = $420c57962e03702d$var$_fnDataSource(settings);
    // Server-side processing init complete is done by _fnAjaxUpdateDraw
    if (dataSrc != "ssp") {
        // if there is an ajax source load the data
        if (dataSrc == "ajax") $420c57962e03702d$var$_fnBuildAjax(settings, {}, function(json) {
            var aData = $420c57962e03702d$var$_fnAjaxDataSrc(settings, json);
            // Got the data - add it to the table
            for(i = 0; i < aData.length; i++)$420c57962e03702d$var$_fnAddData(settings, aData[i]);
            // Reset the init display for cookie saving. We've already done
            // a filter, and therefore cleared it before. So we need to make
            // it appear 'fresh'
            settings.iInitDisplayStart = iAjaxStart;
            $420c57962e03702d$var$_fnReDraw(settings);
            $420c57962e03702d$var$_fnProcessingDisplay(settings, false);
            $420c57962e03702d$var$_fnInitComplete(settings);
        }, settings);
        else {
            $420c57962e03702d$var$_fnInitComplete(settings);
            $420c57962e03702d$var$_fnProcessingDisplay(settings, false);
        }
    }
}
/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnInitComplete(settings) {
    if (settings._bInitComplete) return;
    var args = [
        settings,
        settings.json
    ];
    settings._bInitComplete = true;
    // Table is fully set up and we have data, so calculate the
    // column widths
    $420c57962e03702d$var$_fnAdjustColumnSizing(settings);
    $420c57962e03702d$var$_fnCallbackFire(settings, null, "plugin-init", args, true);
    $420c57962e03702d$var$_fnCallbackFire(settings, "aoInitComplete", "init", args, true);
}
function $420c57962e03702d$var$_fnLengthChange(settings, val) {
    var len = parseInt(val, 10);
    settings._iDisplayLength = len;
    $420c57962e03702d$var$_fnLengthOverflow(settings);
    // Fire length change event
    $420c57962e03702d$var$_fnCallbackFire(settings, null, "length", [
        settings,
        len
    ]);
}
/**
 * Alter the display settings to change the page
 *  @param {object} settings DataTables settings object
 *  @param {string|int} action Paging action to take: "first", "previous",
 *    "next" or "last" or page number to jump to (integer)
 *  @param [bool] redraw Automatically draw the update or not
 *  @returns {bool} true page has changed, false - no change
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnPageChange(settings, action, redraw) {
    var start = settings._iDisplayStart, len = settings._iDisplayLength, records = settings.fnRecordsDisplay();
    if (records === 0 || len === -1) start = 0;
    else if (typeof action === "number") {
        start = action * len;
        if (start > records) start = 0;
    } else if (action == "first") start = 0;
    else if (action == "previous") {
        start = len >= 0 ? start - len : 0;
        if (start < 0) start = 0;
    } else if (action == "next") {
        if (start + len < records) start += len;
    } else if (action == "last") start = Math.floor((records - 1) / len) * len;
    else if (action === "ellipsis") return;
    else $420c57962e03702d$var$_fnLog(settings, 0, "Unknown paging action: " + action, 5);
    var changed = settings._iDisplayStart !== start;
    settings._iDisplayStart = start;
    $420c57962e03702d$var$_fnCallbackFire(settings, null, changed ? "page" : "page-nc", [
        settings
    ]);
    if (changed && redraw) $420c57962e03702d$var$_fnDraw(settings);
    return changed;
}
/**
 * Generate the node required for the processing node
 *  @param {object} settings DataTables settings object
 */ function $420c57962e03702d$var$_processingHtml(settings) {
    var table = settings.nTable;
    var scrolling = settings.oScroll.sX !== "" || settings.oScroll.sY !== "";
    if (settings.oFeatures.bProcessing) {
        var n = $420c57962e03702d$var$$("<div/>", {
            "id": settings.sTableId + "_processing",
            "class": settings.oClasses.processing.container,
            "role": "status"
        }).html(settings.oLanguage.sProcessing).append("<div><div></div><div></div><div></div><div></div></div>");
        // Different positioning depending on if scrolling is enabled or not
        if (scrolling) n.prependTo($420c57962e03702d$var$$("div.dt-scroll", settings.nTableWrapper));
        else n.insertBefore(table);
        $420c57962e03702d$var$$(table).on("processing.dt.DT", function(e, s, show) {
            n.css("display", show ? "block" : "none");
        });
    }
}
/**
 * Display or hide the processing indicator
 *  @param {object} settings DataTables settings object
 *  @param {bool} show Show the processing indicator (true) or not (false)
 */ function $420c57962e03702d$var$_fnProcessingDisplay(settings, show) {
    $420c57962e03702d$var$_fnCallbackFire(settings, null, "processing", [
        settings,
        show
    ]);
}
/**
 * Add any control elements for the table - specifically scrolling
 *  @param {object} settings dataTables settings object
 *  @returns {node} Node to add to the DOM
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnFeatureHtmlTable(settings) {
    var table = $420c57962e03702d$var$$(settings.nTable);
    // Scrolling from here on in
    var scroll = settings.oScroll;
    if (scroll.sX === "" && scroll.sY === "") return settings.nTable;
    var scrollX = scroll.sX;
    var scrollY = scroll.sY;
    var classes = settings.oClasses.scrolling;
    var caption = settings.captionNode;
    var captionSide = caption ? caption._captionSide : null;
    var headerClone = $420c57962e03702d$var$$(table[0].cloneNode(false));
    var footerClone = $420c57962e03702d$var$$(table[0].cloneNode(false));
    var footer = table.children("tfoot");
    var _div = "<div/>";
    var size = function(s) {
        return !s ? null : $420c57962e03702d$var$_fnStringToCss(s);
    };
    if (!footer.length) footer = null;
    /*
	 * The HTML structure that we want to generate in this function is:
	 *  div - scroller
	 *    div - scroll head
	 *      div - scroll head inner
	 *        table - scroll head table
	 *          thead - thead
	 *    div - scroll body
	 *      table - table (master table)
	 *        thead - thead clone for sizing
	 *        tbody - tbody
	 *    div - scroll foot
	 *      div - scroll foot inner
	 *        table - scroll foot table
	 *          tfoot - tfoot
	 */ var scroller = $420c57962e03702d$var$$(_div, {
        "class": classes.container
    }).append($420c57962e03702d$var$$(_div, {
        "class": classes.header.self
    }).css({
        overflow: "hidden",
        position: "relative",
        border: 0,
        width: scrollX ? size(scrollX) : "100%"
    }).append($420c57962e03702d$var$$(_div, {
        "class": classes.header.inner
    }).css({
        "box-sizing": "content-box",
        width: scroll.sXInner || "100%"
    }).append(headerClone.removeAttr("id").css("margin-left", 0).append(captionSide === "top" ? caption : null).append(table.children("thead"))))).append($420c57962e03702d$var$$(_div, {
        "class": classes.body
    }).css({
        position: "relative",
        overflow: "auto",
        width: size(scrollX)
    }).append(table));
    if (footer) scroller.append($420c57962e03702d$var$$(_div, {
        "class": classes.footer.self
    }).css({
        overflow: "hidden",
        border: 0,
        width: scrollX ? size(scrollX) : "100%"
    }).append($420c57962e03702d$var$$(_div, {
        "class": classes.footer.inner
    }).append(footerClone.removeAttr("id").css("margin-left", 0).append(captionSide === "bottom" ? caption : null).append(table.children("tfoot")))));
    var children = scroller.children();
    var scrollHead = children[0];
    var scrollBody = children[1];
    var scrollFoot = footer ? children[2] : null;
    // When the body is scrolled, then we also want to scroll the headers
    $420c57962e03702d$var$$(scrollBody).on("scroll.DT", function() {
        var scrollLeft = this.scrollLeft;
        scrollHead.scrollLeft = scrollLeft;
        if (footer) scrollFoot.scrollLeft = scrollLeft;
    });
    // When focus is put on the header cells, we might need to scroll the body
    $420c57962e03702d$var$$("th, td", scrollHead).on("focus", function() {
        var scrollLeft = scrollHead.scrollLeft;
        scrollBody.scrollLeft = scrollLeft;
        if (footer) scrollBody.scrollLeft = scrollLeft;
    });
    $420c57962e03702d$var$$(scrollBody).css("max-height", scrollY);
    if (!scroll.bCollapse) $420c57962e03702d$var$$(scrollBody).css("height", scrollY);
    settings.nScrollHead = scrollHead;
    settings.nScrollBody = scrollBody;
    settings.nScrollFoot = scrollFoot;
    // On redraw - align columns
    settings.aoDrawCallback.push($420c57962e03702d$var$_fnScrollDraw);
    return scroller[0];
}
/**
 * Update the header, footer and body tables for resizing - i.e. column
 * alignment.
 *
 * Welcome to the most horrible function DataTables. The process that this
 * function follows is basically:
 *   1. Re-create the table inside the scrolling div
 *   2. Correct colgroup > col values if needed
 *   3. Copy colgroup > col over to header and footer
 *   4. Clean up
 *
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnScrollDraw(settings) {
    // Given that this is such a monster function, a lot of variables are use
    // to try and keep the minimised size as small as possible
    var scroll = settings.oScroll, barWidth = scroll.iBarWidth, divHeader = $420c57962e03702d$var$$(settings.nScrollHead), divHeaderInner = divHeader.children("div"), divHeaderTable = divHeaderInner.children("table"), divBodyEl = settings.nScrollBody, divBody = $420c57962e03702d$var$$(divBodyEl), divFooter = $420c57962e03702d$var$$(settings.nScrollFoot), divFooterInner = divFooter.children("div"), divFooterTable = divFooterInner.children("table"), header = $420c57962e03702d$var$$(settings.nTHead), table = $420c57962e03702d$var$$(settings.nTable), footer = settings.nTFoot && $420c57962e03702d$var$$("th, td", settings.nTFoot).length ? $420c57962e03702d$var$$(settings.nTFoot) : null, browser = settings.oBrowser, headerCopy, footerCopy;
    // If the scrollbar visibility has changed from the last draw, we need to
    // adjust the column sizes as the table width will have changed to account
    // for the scrollbar
    var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
    if (settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined) {
        settings.scrollBarVis = scrollBarVis;
        $420c57962e03702d$var$_fnAdjustColumnSizing(settings);
        return; // adjust column sizing will call this function again
    } else settings.scrollBarVis = scrollBarVis;
    // 1. Re-create the table inside the scrolling div
    // Remove the old minimised thead and tfoot elements in the inner table
    table.children("thead, tfoot").remove();
    // Clone the current header and footer elements and then place it into the inner table
    headerCopy = header.clone().prependTo(table);
    headerCopy.find("th, td").removeAttr("tabindex");
    headerCopy.find("[id]").removeAttr("id");
    if (footer) {
        footerCopy = footer.clone().prependTo(table);
        footerCopy.find("[id]").removeAttr("id");
    }
    // 2. Correct colgroup > col values if needed
    // It is possible that the cell sizes are smaller than the content, so we need to
    // correct colgroup>col for such cases. This can happen if the auto width detection
    // uses a cell which has a longer string, but isn't the widest! For example 
    // "Chief Executive Officer (CEO)" is the longest string in the demo, but
    // "Systems Administrator" is actually the widest string since it doesn't collapse.
    // Note the use of translating into a column index to get the `col` element. This
    // is because of Responsive which might remove `col` elements, knocking the alignment
    // of the indexes out.
    if (settings.aiDisplay.length) {
        // Get the column sizes from the first row in the table
        var colSizes = table.children("tbody").eq(0).children("tr").eq(0).children("th, td").map(function(vis) {
            return {
                idx: $420c57962e03702d$var$_fnVisibleToColumnIndex(settings, vis),
                width: $420c57962e03702d$var$$(this).outerWidth()
            };
        });
        // Check against what the colgroup > col is set to and correct if needed
        for(var i = 0; i < colSizes.length; i++){
            var colEl = settings.aoColumns[colSizes[i].idx].colEl[0];
            var colWidth = colEl.style.width.replace("px", "");
            if (colWidth !== colSizes[i].width) colEl.style.width = colSizes[i].width + "px";
        }
    }
    // 3. Copy the colgroup over to the header and footer
    divHeaderTable.find("colgroup").remove();
    divHeaderTable.append(settings.colgroup.clone());
    if (footer) {
        divFooterTable.find("colgroup").remove();
        divFooterTable.append(settings.colgroup.clone());
    }
    // "Hide" the header and footer that we used for the sizing. We need to keep
    // the content of the cell so that the width applied to the header and body
    // both match, but we want to hide it completely.
    $420c57962e03702d$var$$("th, td", headerCopy).each(function() {
        $420c57962e03702d$var$$(this.childNodes).wrapAll('<div class="dt-scroll-sizing">');
    });
    if (footer) $420c57962e03702d$var$$("th, td", footerCopy).each(function() {
        $420c57962e03702d$var$$(this.childNodes).wrapAll('<div class="dt-scroll-sizing">');
    });
    // 4. Clean up
    // Figure out if there are scrollbar present - if so then we need a the header and footer to
    // provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
    var isScrolling = Math.floor(table.height()) > divBodyEl.clientHeight || divBody.css("overflow-y") == "scroll";
    var paddingSide = "padding" + (browser.bScrollbarLeft ? "Left" : "Right");
    // Set the width's of the header and footer tables
    var outerWidth = table.outerWidth();
    divHeaderTable.css("width", $420c57962e03702d$var$_fnStringToCss(outerWidth));
    divHeaderInner.css("width", $420c57962e03702d$var$_fnStringToCss(outerWidth)).css(paddingSide, isScrolling ? barWidth + "px" : "0px");
    if (footer) {
        divFooterTable.css("width", $420c57962e03702d$var$_fnStringToCss(outerWidth));
        divFooterInner.css("width", $420c57962e03702d$var$_fnStringToCss(outerWidth)).css(paddingSide, isScrolling ? barWidth + "px" : "0px");
    }
    // Correct DOM ordering for colgroup - comes before the thead
    table.children("colgroup").prependTo(table);
    // Adjust the position of the header in case we loose the y-scrollbar
    divBody.trigger("scroll");
    // If sorting or filtering has occurred, jump the scrolling back to the top
    // only if we aren't holding the position
    if ((settings.bSorted || settings.bFiltered) && !settings._drawHold) divBodyEl.scrollTop = 0;
}
/**
 * Calculate the width of columns for the table
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnCalculateColumnWidths(settings) {
    // Not interested in doing column width calculation if auto-width is disabled
    if (!settings.oFeatures.bAutoWidth) return;
    var table = settings.nTable, columns = settings.aoColumns, scroll = settings.oScroll, scrollY = scroll.sY, scrollX = scroll.sX, scrollXInner = scroll.sXInner, visibleColumns = $420c57962e03702d$var$_fnGetColumns(settings, "bVisible"), tableWidthAttr = table.getAttribute("width"), tableContainer = table.parentNode, i, column, columnIdx;
    var styleWidth = table.style.width;
    if (styleWidth && styleWidth.indexOf("%") !== -1) tableWidthAttr = styleWidth;
    // Let plug-ins know that we are doing a recalc, in case they have changed any of the
    // visible columns their own way (e.g. Responsive uses display:none).
    $420c57962e03702d$var$_fnCallbackFire(settings, null, "column-calc", {
        visible: visibleColumns
    }, false);
    // Construct a single row, worst case, table with the widest
    // node in the data, assign any user defined widths, then insert it into
    // the DOM and allow the browser to do all the hard work of calculating
    // table widths
    var tmpTable = $420c57962e03702d$var$$(table.cloneNode()).css("visibility", "hidden").removeAttr("id");
    // Clean up the table body
    tmpTable.append("<tbody>");
    var tr = $420c57962e03702d$var$$("<tr/>").appendTo(tmpTable.find("tbody"));
    // Clone the table header and footer - we can't use the header / footer
    // from the cloned table, since if scrolling is active, the table's
    // real header and footer are contained in different table tags
    tmpTable.append($420c57962e03702d$var$$(settings.nTHead).clone()).append($420c57962e03702d$var$$(settings.nTFoot).clone());
    // Remove any assigned widths from the footer (from scrolling)
    tmpTable.find("tfoot th, tfoot td").css("width", "");
    // Apply custom sizing to the cloned header
    tmpTable.find("thead th, thead td").each(function() {
        // Get the `width` from the header layout
        var width = $420c57962e03702d$var$_fnColumnsSumWidth(settings, this, true, false);
        if (width) {
            this.style.width = width;
            // For scrollX we need to force the column width otherwise the
            // browser will collapse it. If this width is smaller than the
            // width the column requires, then it will have no effect
            if (scrollX) $420c57962e03702d$var$$(this).append($420c57962e03702d$var$$("<div/>").css({
                width: width,
                margin: 0,
                padding: 0,
                border: 0,
                height: 1
            }));
        } else this.style.width = "";
    });
    // Find the widest piece of data for each column and put it into the table
    for(i = 0; i < visibleColumns.length; i++){
        columnIdx = visibleColumns[i];
        column = columns[columnIdx];
        var longest = $420c57962e03702d$var$_fnGetMaxLenString(settings, columnIdx);
        var autoClass = $420c57962e03702d$var$_ext.type.className[column.sType];
        var text = longest + column.sContentPadding;
        var insert = longest.indexOf("<") === -1 ? document.createTextNode(text) : text;
        $420c57962e03702d$var$$("<td/>").addClass(autoClass).addClass(column.sClass).append(insert).appendTo(tr);
    }
    // Tidy the temporary table - remove name attributes so there aren't
    // duplicated in the dom (radio elements for example)
    $420c57962e03702d$var$$("[name]", tmpTable).removeAttr("name");
    // Table has been built, attach to the document so we can work with it.
    // A holding element is used, positioned at the top of the container
    // with minimal height, so it has no effect on if the container scrolls
    // or not. Otherwise it might trigger scrolling when it actually isn't
    // needed
    var holder = $420c57962e03702d$var$$("<div/>").css(scrollX || scrollY ? {
        position: "absolute",
        top: 0,
        left: 0,
        height: 1,
        right: 0,
        overflow: "hidden"
    } : {}).append(tmpTable).appendTo(tableContainer);
    // When scrolling (X or Y) we want to set the width of the table as 
    // appropriate. However, when not scrolling leave the table width as it
    // is. This results in slightly different, but I think correct behaviour
    if (scrollX && scrollXInner) tmpTable.width(scrollXInner);
    else if (scrollX) {
        tmpTable.css("width", "auto");
        tmpTable.removeAttr("width");
        // If there is no width attribute or style, then allow the table to
        // collapse
        if (tmpTable.width() < tableContainer.clientWidth && tableWidthAttr) tmpTable.width(tableContainer.clientWidth);
    } else if (scrollY) tmpTable.width(tableContainer.clientWidth);
    else if (tableWidthAttr) tmpTable.width(tableWidthAttr);
    // Get the width of each column in the constructed table
    var total = 0;
    var bodyCells = tmpTable.find("tbody tr").eq(0).children();
    for(i = 0; i < visibleColumns.length; i++){
        // Use getBounding for sub-pixel accuracy, which we then want to round up!
        var bounding = bodyCells[i].getBoundingClientRect().width;
        // Total is tracked to remove any sub-pixel errors as the outerWidth
        // of the table might not equal the total given here
        total += bounding;
        // Width for each column to use
        columns[visibleColumns[i]].sWidth = $420c57962e03702d$var$_fnStringToCss(bounding);
    }
    table.style.width = $420c57962e03702d$var$_fnStringToCss(total);
    // Finished with the table - ditch it
    holder.remove();
    // If there is a width attr, we want to attach an event listener which
    // allows the table sizing to automatically adjust when the window is
    // resized. Use the width attr rather than CSS, since we can't know if the
    // CSS is a relative value or absolute - DOM read is always px.
    if (tableWidthAttr) table.style.width = $420c57962e03702d$var$_fnStringToCss(tableWidthAttr);
    if ((tableWidthAttr || scrollX) && !settings._reszEvt) {
        var bindResize = function() {
            $420c57962e03702d$var$$(window).on("resize.DT-" + settings.sInstance, $420c57962e03702d$var$DataTable.util.throttle(function() {
                if (!settings.bDestroying) $420c57962e03702d$var$_fnAdjustColumnSizing(settings);
            }));
        };
        bindResize();
        settings._reszEvt = true;
    }
}
/**
 * Get the maximum strlen for each data column
 *  @param {object} settings dataTables settings object
 *  @param {int} colIdx column of interest
 *  @returns {string} string of the max length
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnGetMaxLenString(settings, colIdx) {
    var column = settings.aoColumns[colIdx];
    if (!column.maxLenString) {
        var s, max = "", maxLen = -1;
        for(var i = 0, ien = settings.aiDisplayMaster.length; i < ien; i++){
            var rowIdx = settings.aiDisplayMaster[i];
            var data = $420c57962e03702d$var$_fnGetRowDisplay(settings, rowIdx)[colIdx];
            var cellString = data && typeof data === "object" && data.nodeType ? data.innerHTML : data + "";
            // Remove id / name attributes from elements so they
            // don't interfere with existing elements
            cellString = cellString.replace(/id=".*?"/g, "").replace(/name=".*?"/g, "");
            s = $420c57962e03702d$var$_stripHtml(cellString).replace(/&nbsp;/g, " ");
            if (s.length > maxLen) {
                // We want the HTML in the string, but the length that
                // is important is the stripped string
                max = cellString;
                maxLen = s.length;
            }
        }
        column.maxLenString = max;
    }
    return column.maxLenString;
}
/**
 * Append a CSS unit (only if required) to a string
 *  @param {string} value to css-ify
 *  @returns {string} value with css unit
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnStringToCss(s) {
    if (s === null) return "0px";
    if (typeof s == "number") return s < 0 ? "0px" : s + "px";
    // Check it has a unit character already
    return s.match(/\d$/) ? s + "px" : s;
}
/**
 * Re-insert the `col` elements for current visibility
 *
 * @param {*} settings DT settings
 */ function $420c57962e03702d$var$_colGroup(settings) {
    var cols = settings.aoColumns;
    settings.colgroup.empty();
    for($420c57962e03702d$var$i = 0; $420c57962e03702d$var$i < cols.length; $420c57962e03702d$var$i++)if (cols[$420c57962e03702d$var$i].bVisible) settings.colgroup.append(cols[$420c57962e03702d$var$i].colEl);
}
function $420c57962e03702d$var$_fnSortInit(settings) {
    var target = settings.nTHead;
    var headerRows = target.querySelectorAll("tr");
    var legacyTop = settings.bSortCellsTop;
    var notSelector = ':not([data-dt-order="disable"]):not([data-dt-order="icon-only"])';
    // Legacy support for `orderCellsTop`
    if (legacyTop === true) target = headerRows[0];
    else if (legacyTop === false) target = headerRows[headerRows.length - 1];
    $420c57962e03702d$var$_fnSortAttachListener(settings, target, target === settings.nTHead ? "tr" + notSelector + " th" + notSelector + ", tr" + notSelector + " td" + notSelector : "th" + notSelector + ", td" + notSelector);
    // Need to resolve the user input array into our internal structure
    var order = [];
    $420c57962e03702d$var$_fnSortResolve(settings, order, settings.aaSorting);
    settings.aaSorting = order;
}
function $420c57962e03702d$var$_fnSortAttachListener(settings, node, selector, column, callback) {
    $420c57962e03702d$var$_fnBindAction(node, selector, function(e) {
        var run = false;
        var columns = column === undefined ? $420c57962e03702d$var$_fnColumnsFromHeader(e.target) : [
            column
        ];
        if (columns.length) {
            for(var i = 0, ien = columns.length; i < ien; i++){
                var ret = $420c57962e03702d$var$_fnSortAdd(settings, columns[i], i, e.shiftKey);
                if (ret !== false) run = true;
                // If the first entry is no sort, then subsequent
                // sort columns are ignored
                if (settings.aaSorting.length === 1 && settings.aaSorting[0][1] === "") break;
            }
            if (run) {
                $420c57962e03702d$var$_fnProcessingDisplay(settings, true);
                // Allow the processing display to show
                setTimeout(function() {
                    $420c57962e03702d$var$_fnSort(settings);
                    $420c57962e03702d$var$_fnSortDisplay(settings, settings.aiDisplay);
                    // Sort processing done - redraw has its own processing display
                    $420c57962e03702d$var$_fnProcessingDisplay(settings, false);
                    $420c57962e03702d$var$_fnReDraw(settings, false, false);
                    if (callback) callback();
                }, 0);
            }
        }
    });
}
/**
 * Sort the display array to match the master's order
 * @param {*} settings
 */ function $420c57962e03702d$var$_fnSortDisplay(settings, display) {
    if (display.length < 2) return;
    var master = settings.aiDisplayMaster;
    var masterMap = {};
    var map = {};
    var i;
    // Rather than needing an `indexOf` on master array, we can create a map
    for(i = 0; i < master.length; i++)masterMap[master[i]] = i;
    // And then cache what would be the indexOf fom the display
    for(i = 0; i < display.length; i++)map[display[i]] = masterMap[display[i]];
    display.sort(function(a, b) {
        // Short version of this function is simply `master.indexOf(a) - master.indexOf(b);`
        return map[a] - map[b];
    });
}
function $420c57962e03702d$var$_fnSortResolve(settings, nestedSort, sort) {
    var push = function(a) {
        if ($420c57962e03702d$var$$.isPlainObject(a)) {
            if (a.idx !== undefined) // Index based ordering
            nestedSort.push([
                a.idx,
                a.dir
            ]);
            else if (a.name) {
                // Name based ordering
                var cols = $420c57962e03702d$var$_pluck(settings.aoColumns, "sName");
                var idx = cols.indexOf(a.name);
                if (idx !== -1) nestedSort.push([
                    idx,
                    a.dir
                ]);
            }
        } else // Plain column index and direction pair
        nestedSort.push(a);
    };
    if ($420c57962e03702d$var$$.isPlainObject(sort)) // Object
    push(sort);
    else if (sort.length && typeof sort[0] === "number") // 1D array
    push(sort);
    else if (sort.length) // 2D array
    for(var z = 0; z < sort.length; z++)push(sort[z]); // Object or array
}
function $420c57962e03702d$var$_fnSortFlatten(settings) {
    var i, k, kLen, aSort = [], extSort = $420c57962e03702d$var$DataTable.ext.type.order, aoColumns = settings.aoColumns, aDataSort, iCol, sType, srcCol, fixed = settings.aaSortingFixed, fixedObj = $420c57962e03702d$var$$.isPlainObject(fixed), nestedSort = [];
    if (!settings.oFeatures.bSort) return aSort;
    // Build the sort array, with pre-fix and post-fix options if they have been
    // specified
    if (Array.isArray(fixed)) $420c57962e03702d$var$_fnSortResolve(settings, nestedSort, fixed);
    if (fixedObj && fixed.pre) $420c57962e03702d$var$_fnSortResolve(settings, nestedSort, fixed.pre);
    $420c57962e03702d$var$_fnSortResolve(settings, nestedSort, settings.aaSorting);
    if (fixedObj && fixed.post) $420c57962e03702d$var$_fnSortResolve(settings, nestedSort, fixed.post);
    for(i = 0; i < nestedSort.length; i++){
        srcCol = nestedSort[i][0];
        if (aoColumns[srcCol]) {
            aDataSort = aoColumns[srcCol].aDataSort;
            for(k = 0, kLen = aDataSort.length; k < kLen; k++){
                iCol = aDataSort[k];
                sType = aoColumns[iCol].sType || "string";
                if (nestedSort[i]._idx === undefined) nestedSort[i]._idx = aoColumns[iCol].asSorting.indexOf(nestedSort[i][1]);
                if (nestedSort[i][1]) aSort.push({
                    src: srcCol,
                    col: iCol,
                    dir: nestedSort[i][1],
                    index: nestedSort[i]._idx,
                    type: sType,
                    formatter: extSort[sType + "-pre"],
                    sorter: extSort[sType + "-" + nestedSort[i][1]]
                });
            }
        }
    }
    return aSort;
}
/**
 * Change the order of the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnSort(oSettings, col, dir) {
    var i, ien, iLen, aiOrig = [], extSort = $420c57962e03702d$var$DataTable.ext.type.order, aoData = oSettings.aoData, sortCol, displayMaster = oSettings.aiDisplayMaster, aSort;
    // Resolve any column types that are unknown due to addition or invalidation
    // @todo Can this be moved into a 'data-ready' handler which is called when
    //   data is going to be used in the table?
    $420c57962e03702d$var$_fnColumnTypes(oSettings);
    // Allow a specific column to be sorted, which will _not_ alter the display
    // master
    if (col !== undefined) {
        var srcCol = oSettings.aoColumns[col];
        aSort = [
            {
                src: col,
                col: col,
                dir: dir,
                index: 0,
                type: srcCol.sType,
                formatter: extSort[srcCol.sType + "-pre"],
                sorter: extSort[srcCol.sType + "-" + dir]
            }
        ];
        displayMaster = displayMaster.slice();
    } else aSort = $420c57962e03702d$var$_fnSortFlatten(oSettings);
    for(i = 0, ien = aSort.length; i < ien; i++){
        sortCol = aSort[i];
        // Load the data needed for the sort, for each cell
        $420c57962e03702d$var$_fnSortData(oSettings, sortCol.col);
    }
    /* No sorting required if server-side or no sorting array */ if ($420c57962e03702d$var$_fnDataSource(oSettings) != "ssp" && aSort.length !== 0) {
        // Reset the initial positions on each pass so we get a stable sort
        for(i = 0, iLen = displayMaster.length; i < iLen; i++)aiOrig[i] = i;
        // If the first sort is desc, then reverse the array to preserve original
        // order, just in reverse
        if (aSort.length && aSort[0].dir === "desc") aiOrig.reverse();
        /* Do the sort - here we want multi-column sorting based on a given data source (column)
		 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
		 * follow on it's own, but this is what we want (example two column sorting):
		 *  fnLocalSorting = function(a,b){
		 *    var test;
		 *    test = oSort['string-asc']('data11', 'data12');
		 *      if (test !== 0)
		 *        return test;
		 *    test = oSort['numeric-desc']('data21', 'data22');
		 *    if (test !== 0)
		 *      return test;
		 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
		 *  }
		 * Basically we have a test for each sorting column, if the data in that column is equal,
		 * test the next column. If all columns match, then we use a numeric sort on the row
		 * positions in the original data array to provide a stable sort.
		 */ displayMaster.sort(function(a, b) {
            var x, y, k, test, sort, len = aSort.length, dataA = aoData[a]._aSortData, dataB = aoData[b]._aSortData;
            for(k = 0; k < len; k++){
                sort = aSort[k];
                // Data, which may have already been through a `-pre` function
                x = dataA[sort.col];
                y = dataB[sort.col];
                if (sort.sorter) {
                    // If there is a custom sorter (`-asc` or `-desc`) for this
                    // data type, use it
                    test = sort.sorter(x, y);
                    if (test !== 0) return test;
                } else {
                    // Otherwise, use generic sorting
                    test = x < y ? -1 : x > y ? 1 : 0;
                    if (test !== 0) return sort.dir === "asc" ? test : -test;
                }
            }
            x = aiOrig[a];
            y = aiOrig[b];
            return x < y ? -1 : x > y ? 1 : 0;
        });
    } else if (aSort.length === 0) // Apply index order
    displayMaster.sort(function(x, y) {
        return x < y ? -1 : x > y ? 1 : 0;
    });
    if (col === undefined) {
        // Tell the draw function that we have sorted the data
        oSettings.bSorted = true;
        $420c57962e03702d$var$_fnCallbackFire(oSettings, null, "order", [
            oSettings,
            aSort
        ]);
    }
    return displayMaster;
}
/**
 * Function to run on user sort request
 *  @param {object} settings dataTables settings object
 *  @param {node} attachTo node to attach the handler to
 *  @param {int} colIdx column sorting index
 *  @param {int} addIndex Counter
 *  @param {boolean} [shift=false] Shift click add
 *  @param {function} [callback] callback function
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnSortAdd(settings, colIdx, addIndex, shift) {
    var col = settings.aoColumns[colIdx];
    var sorting = settings.aaSorting;
    var asSorting = col.asSorting;
    var nextSortIdx;
    var next = function(a, overflow) {
        var idx = a._idx;
        if (idx === undefined) idx = asSorting.indexOf(a[1]);
        return idx + 1 < asSorting.length ? idx + 1 : overflow ? null : 0;
    };
    if (!col.bSortable) return false;
    // Convert to 2D array if needed
    if (typeof sorting[0] === "number") sorting = settings.aaSorting = [
        sorting
    ];
    // If appending the sort then we are multi-column sorting
    if ((shift || addIndex) && settings.oFeatures.bSortMulti) {
        // Are we already doing some kind of sort on this column?
        var sortIdx = $420c57962e03702d$var$_pluck(sorting, "0").indexOf(colIdx);
        if (sortIdx !== -1) {
            // Yes, modify the sort
            nextSortIdx = next(sorting[sortIdx], true);
            if (nextSortIdx === null && sorting.length === 1) nextSortIdx = 0; // can't remove sorting completely
            if (nextSortIdx === null) sorting.splice(sortIdx, 1);
            else {
                sorting[sortIdx][1] = asSorting[nextSortIdx];
                sorting[sortIdx]._idx = nextSortIdx;
            }
        } else if (shift) {
            // No sort on this column yet, being added by shift click
            // add it as itself
            sorting.push([
                colIdx,
                asSorting[0],
                0
            ]);
            sorting[sorting.length - 1]._idx = 0;
        } else {
            // No sort on this column yet, being added from a colspan
            // so add with same direction as first column
            sorting.push([
                colIdx,
                sorting[0][1],
                0
            ]);
            sorting[sorting.length - 1]._idx = 0;
        }
    } else if (sorting.length && sorting[0][0] == colIdx) {
        // Single column - already sorting on this column, modify the sort
        nextSortIdx = next(sorting[0]);
        sorting.length = 1;
        sorting[0][1] = asSorting[nextSortIdx];
        sorting[0]._idx = nextSortIdx;
    } else {
        // Single column - sort only on this column
        sorting.length = 0;
        sorting.push([
            colIdx,
            asSorting[0]
        ]);
        sorting[0]._idx = 0;
    }
}
/**
 * Set the sorting classes on table's body, Note: it is safe to call this function
 * when bSort and bSortClasses are false
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnSortingClasses(settings) {
    var oldSort = settings.aLastSort;
    var sortClass = settings.oClasses.order.position;
    var sort = $420c57962e03702d$var$_fnSortFlatten(settings);
    var features = settings.oFeatures;
    var i, ien, colIdx;
    if (features.bSort && features.bSortClasses) {
        // Remove old sorting classes
        for(i = 0, ien = oldSort.length; i < ien; i++){
            colIdx = oldSort[i].src;
            // Remove column sorting
            $420c57962e03702d$var$$($420c57962e03702d$var$_pluck(settings.aoData, "anCells", colIdx)).removeClass(sortClass + (i < 2 ? i + 1 : 3));
        }
        // Add new column sorting
        for(i = 0, ien = sort.length; i < ien; i++){
            colIdx = sort[i].src;
            $420c57962e03702d$var$$($420c57962e03702d$var$_pluck(settings.aoData, "anCells", colIdx)).addClass(sortClass + (i < 2 ? i + 1 : 3));
        }
    }
    settings.aLastSort = sort;
}
// Get the data to sort a column, be it from cache, fresh (populating the
// cache), or from a sort formatter
function $420c57962e03702d$var$_fnSortData(settings, colIdx) {
    // Custom sorting function - provided by the sort data type
    var column = settings.aoColumns[colIdx];
    var customSort = $420c57962e03702d$var$DataTable.ext.order[column.sSortDataType];
    var customData;
    if (customSort) customData = customSort.call(settings.oInstance, settings, colIdx, $420c57962e03702d$var$_fnColumnIndexToVisible(settings, colIdx));
    // Use / populate cache
    var row, cellData;
    var formatter = $420c57962e03702d$var$DataTable.ext.type.order[column.sType + "-pre"];
    var data = settings.aoData;
    for(var rowIdx = 0; rowIdx < data.length; rowIdx++){
        // Sparse array
        if (!data[rowIdx]) continue;
        row = data[rowIdx];
        if (!row._aSortData) row._aSortData = [];
        if (!row._aSortData[colIdx] || customSort) {
            cellData = customSort ? customData[rowIdx] : $420c57962e03702d$var$_fnGetCellData(settings, rowIdx, colIdx, "sort");
            row._aSortData[colIdx] = formatter ? formatter(cellData, settings) : cellData;
        }
    }
}
/**
 * State information for a table
 *
 * @param {*} settings
 * @returns State object
 */ function $420c57962e03702d$var$_fnSaveState(settings) {
    if (settings._bLoadingState) return;
    /* Store the interesting variables */ var state = {
        time: +new Date(),
        start: settings._iDisplayStart,
        length: settings._iDisplayLength,
        order: $420c57962e03702d$var$$.extend(true, [], settings.aaSorting),
        search: $420c57962e03702d$var$$.extend({}, settings.oPreviousSearch),
        columns: settings.aoColumns.map(function(col, i) {
            return {
                visible: col.bVisible,
                search: $420c57962e03702d$var$$.extend({}, settings.aoPreSearchCols[i])
            };
        })
    };
    settings.oSavedState = state;
    $420c57962e03702d$var$_fnCallbackFire(settings, "aoStateSaveParams", "stateSaveParams", [
        settings,
        state
    ]);
    if (settings.oFeatures.bStateSave && !settings.bDestroying) settings.fnStateSaveCallback.call(settings.oInstance, settings, state);
}
/**
 * Attempt to load a saved table state
 *  @param {object} oSettings dataTables settings object
 *  @param {object} oInit DataTables init object so we can override settings
 *  @param {function} callback Callback to execute when the state has been loaded
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnLoadState(settings, init, callback) {
    if (!settings.oFeatures.bStateSave) {
        callback();
        return;
    }
    var loaded = function(state) {
        $420c57962e03702d$var$_fnImplementState(settings, state, callback);
    };
    var state = settings.fnStateLoadCallback.call(settings.oInstance, settings, loaded);
    if (state !== undefined) $420c57962e03702d$var$_fnImplementState(settings, state, callback);
    // otherwise, wait for the loaded callback to be executed
    return true;
}
function $420c57962e03702d$var$_fnImplementState(settings, s, callback) {
    var i, ien;
    var columns = settings.aoColumns;
    settings._bLoadingState = true;
    // When StateRestore was introduced the state could now be implemented at any time
    // Not just initialisation. To do this an api instance is required in some places
    var api = settings._bInitComplete ? new $420c57962e03702d$var$DataTable.Api(settings) : null;
    if (!s || !s.time) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Reject old data
    var duration = settings.iStateDuration;
    if (duration > 0 && s.time < +new Date() - duration * 1000) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Allow custom and plug-in manipulation functions to alter the saved data set and
    // cancelling of loading by returning false
    var abStateLoad = $420c57962e03702d$var$_fnCallbackFire(settings, "aoStateLoadParams", "stateLoadParams", [
        settings,
        s
    ]);
    if (abStateLoad.indexOf(false) !== -1) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Number of columns have changed - all bets are off, no restore of settings
    if (s.columns && columns.length !== s.columns.length) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Store the saved state so it might be accessed at any time
    settings.oLoadedState = $420c57962e03702d$var$$.extend(true, {}, s);
    // This is needed for ColReorder, which has to happen first to allow all
    // the stored indexes to be usable. It is not publicly documented.
    $420c57962e03702d$var$_fnCallbackFire(settings, null, "stateLoadInit", [
        settings,
        s
    ], true);
    // Page Length
    if (s.length !== undefined) {
        // If already initialised just set the value directly so that the select element is also updated
        if (api) api.page.len(s.length);
        else settings._iDisplayLength = s.length;
    }
    // Restore key features - todo - for 1.11 this needs to be done by
    // subscribed events
    if (s.start !== undefined) {
        if (api === null) {
            settings._iDisplayStart = s.start;
            settings.iInitDisplayStart = s.start;
        } else $420c57962e03702d$var$_fnPageChange(settings, s.start / settings._iDisplayLength);
    }
    // Order
    if (s.order !== undefined) {
        settings.aaSorting = [];
        $420c57962e03702d$var$$.each(s.order, function(i, col) {
            settings.aaSorting.push(col[0] >= columns.length ? [
                0,
                col[1]
            ] : col);
        });
    }
    // Search
    if (s.search !== undefined) $420c57962e03702d$var$$.extend(settings.oPreviousSearch, s.search);
    // Columns
    if (s.columns) {
        for(i = 0, ien = s.columns.length; i < ien; i++){
            var col = s.columns[i];
            // Visibility
            if (col.visible !== undefined) {
                // If the api is defined, the table has been initialised so we need to use it rather than internal settings
                if (api) // Don't redraw the columns on every iteration of this loop, we will do this at the end instead
                api.column(i).visible(col.visible, false);
                else columns[i].bVisible = col.visible;
            }
            // Search
            if (col.search !== undefined) $420c57962e03702d$var$$.extend(settings.aoPreSearchCols[i], col.search);
        }
        // If the api is defined then we need to adjust the columns once the visibility has been changed
        if (api) api.columns.adjust();
    }
    settings._bLoadingState = false;
    $420c57962e03702d$var$_fnCallbackFire(settings, "aoStateLoaded", "stateLoaded", [
        settings,
        s
    ]);
    callback();
}
/**
 * Log an error message
 *  @param {object} settings dataTables settings object
 *  @param {int} level log error messages, or display them to the user
 *  @param {string} msg error message
 *  @param {int} tn Technical note id to get more information about the error.
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnLog(settings, level, msg, tn) {
    msg = "DataTables warning: " + (settings ? "table id=" + settings.sTableId + " - " : "") + msg;
    if (tn) msg += ". For more information about this error, please see https://datatables.net/tn/" + tn;
    if (!level) {
        // Backwards compatibility pre 1.10
        var ext = $420c57962e03702d$var$DataTable.ext;
        var type = ext.sErrMode || ext.errMode;
        if (settings) $420c57962e03702d$var$_fnCallbackFire(settings, null, "dt-error", [
            settings,
            tn,
            msg
        ], true);
        if (type == "alert") alert(msg);
        else if (type == "throw") throw new Error(msg);
        else if (typeof type == "function") type(settings, tn, msg);
    } else if (window.console && console.log) console.log(msg);
}
/**
 * See if a property is defined on one object, if so assign it to the other object
 *  @param {object} ret target object
 *  @param {object} src source object
 *  @param {string} name property
 *  @param {string} [mappedName] name to map too - optional, name used if not given
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnMap(ret, src, name, mappedName) {
    if (Array.isArray(name)) {
        $420c57962e03702d$var$$.each(name, function(i, val) {
            if (Array.isArray(val)) $420c57962e03702d$var$_fnMap(ret, src, val[0], val[1]);
            else $420c57962e03702d$var$_fnMap(ret, src, val);
        });
        return;
    }
    if (mappedName === undefined) mappedName = name;
    if (src[name] !== undefined) ret[mappedName] = src[name];
}
/**
 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
 * shallow copy arrays. The reason we need to do this, is that we don't want to
 * deep copy array init values (such as aaSorting) since the dev wouldn't be
 * able to override them, but we do want to deep copy arrays.
 *  @param {object} out Object to extend
 *  @param {object} extender Object from which the properties will be applied to
 *      out
 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
 *      independent copy with the exception of the `data` or `aaData` parameters
 *      if they are present. This is so you can pass in a collection to
 *      DataTables and have that used as your data source without breaking the
 *      references
 *  @returns {object} out Reference, just for convenience - out === the return.
 *  @memberof DataTable#oApi
 *  @todo This doesn't take account of arrays inside the deep copied objects.
 */ function $420c57962e03702d$var$_fnExtend(out, extender, breakRefs) {
    var val;
    for(var prop in extender)if (Object.prototype.hasOwnProperty.call(extender, prop)) {
        val = extender[prop];
        if ($420c57962e03702d$var$$.isPlainObject(val)) {
            if (!$420c57962e03702d$var$$.isPlainObject(out[prop])) out[prop] = {};
            $420c57962e03702d$var$$.extend(true, out[prop], val);
        } else if (breakRefs && prop !== "data" && prop !== "aaData" && Array.isArray(val)) out[prop] = val.slice();
        else out[prop] = val;
    }
    return out;
}
/**
 * Bind an event handers to allow a click or return key to activate the callback.
 * This is good for accessibility since a return on the keyboard will have the
 * same effect as a click, if the element has focus.
 *  @param {element} n Element to bind the action to
 *  @param {object|string} selector Selector (for delegated events) or data object
 *   to pass to the triggered function
 *  @param {function} fn Callback function for when the event is triggered
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnBindAction(n, selector, fn) {
    $420c57962e03702d$var$$(n).on("click.DT", selector, function(e) {
        fn(e);
    }).on("keypress.DT", selector, function(e) {
        if (e.which === 13) {
            e.preventDefault();
            fn(e);
        }
    }).on("selectstart.DT", selector, function() {
        // Don't want a double click resulting in text selection
        return false;
    });
}
/**
 * Register a callback function. Easily allows a callback function to be added to
 * an array store of callback functions that can then all be called together.
 *  @param {object} settings dataTables settings object
 *  @param {string} store Name of the array storage for the callbacks in oSettings
 *  @param {function} fn Function to be called back
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnCallbackReg(settings, store, fn) {
    if (fn) settings[store].push(fn);
}
/**
 * Fire callback functions and trigger events. Note that the loop over the
 * callback array store is done backwards! Further note that you do not want to
 * fire off triggers in time sensitive applications (for example cell creation)
 * as its slow.
 *  @param {object} settings dataTables settings object
 *  @param {string} callbackArr Name of the array storage for the callbacks in
 *      oSettings
 *  @param {string} eventName Name of the jQuery custom event to trigger. If
 *      null no trigger is fired
 *  @param {array} args Array of arguments to pass to the callback function /
 *      trigger
 *  @param {boolean} [bubbles] True if the event should bubble
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnCallbackFire(settings, callbackArr, eventName, args, bubbles) {
    var ret = [];
    if (callbackArr) ret = settings[callbackArr].slice().reverse().map(function(val) {
        return val.apply(settings.oInstance, args);
    });
    if (eventName !== null) {
        var e = $420c57962e03702d$var$$.Event(eventName + ".dt");
        var table = $420c57962e03702d$var$$(settings.nTable);
        // Expose the DataTables API on the event object for easy access
        e.dt = settings.api;
        table[bubbles ? "trigger" : "triggerHandler"](e, args);
        // If not yet attached to the document, trigger the event
        // on the body directly to sort of simulate the bubble
        if (bubbles && table.parents("body").length === 0) $420c57962e03702d$var$$("body").trigger(e, args);
        ret.push(e.result);
    }
    return ret;
}
function $420c57962e03702d$var$_fnLengthOverflow(settings) {
    var start = settings._iDisplayStart, end = settings.fnDisplayEnd(), len = settings._iDisplayLength;
    /* If we have space to show extra rows (backing up from the end point - then do so */ if (start >= end) start = end - len;
    // Keep the start record on the current page
    start -= start % len;
    if (len === -1 || start < 0) start = 0;
    settings._iDisplayStart = start;
}
function $420c57962e03702d$var$_fnRenderer(settings, type) {
    var renderer = settings.renderer;
    var host = $420c57962e03702d$var$DataTable.ext.renderer[type];
    if ($420c57962e03702d$var$$.isPlainObject(renderer) && renderer[type]) // Specific renderer for this type. If available use it, otherwise use
    // the default.
    return host[renderer[type]] || host._;
    else if (typeof renderer === "string") // Common renderer - if there is one available for this type use it,
    // otherwise use the default
    return host[renderer] || host._;
    // Use the default
    return host._;
}
/**
 * Detect the data source being used for the table. Used to simplify the code
 * a little (ajax) and to make it compress a little smaller.
 *
 *  @param {object} settings dataTables settings object
 *  @returns {string} Data source
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnDataSource(settings) {
    if (settings.oFeatures.bServerSide) return "ssp";
    else if (settings.ajax) return "ajax";
    return "dom";
}
/**
 * Common replacement for language strings
 *
 * @param {*} settings DT settings object
 * @param {*} str String with values to replace
 * @param {*} entries Plural number for _ENTRIES_ - can be undefined
 * @returns String
 */ function $420c57962e03702d$var$_fnMacros(settings, str, entries) {
    // When infinite scrolling, we are always starting at 1. _iDisplayStart is
    // used only internally
    var formatter = settings.fnFormatNumber, start = settings._iDisplayStart + 1, len = settings._iDisplayLength, vis = settings.fnRecordsDisplay(), max = settings.fnRecordsTotal(), all = len === -1;
    return str.replace(/_START_/g, formatter.call(settings, start)).replace(/_END_/g, formatter.call(settings, settings.fnDisplayEnd())).replace(/_MAX_/g, formatter.call(settings, max)).replace(/_TOTAL_/g, formatter.call(settings, vis)).replace(/_PAGE_/g, formatter.call(settings, all ? 1 : Math.ceil(start / len))).replace(/_PAGES_/g, formatter.call(settings, all ? 1 : Math.ceil(vis / len))).replace(/_ENTRIES_/g, settings.api.i18n("entries", "", entries)).replace(/_ENTRIES-MAX_/g, settings.api.i18n("entries", "", max)).replace(/_ENTRIES-TOTAL_/g, settings.api.i18n("entries", "", vis));
}
/**
 * Computed structure of the DataTables API, defined by the options passed to
 * `DataTable.Api.register()` when building the API.
 *
 * The structure is built in order to speed creation and extension of the Api
 * objects since the extensions are effectively pre-parsed.
 *
 * The array is an array of objects with the following structure, where this
 * base array represents the Api prototype base:
 *
 *     [
 *       {
 *         name:      'data'                -- string   - Property name
 *         val:       function () {},       -- function - Api method (or undefined if just an object
 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
 *       },
 *       {
 *         name:     'row'
 *         val:       {},
 *         methodExt: [ ... ],
 *         propExt:   [
 *           {
 *             name:      'data'
 *             val:       function () {},
 *             methodExt: [ ... ],
 *             propExt:   [ ... ]
 *           },
 *           ...
 *         ]
 *       }
 *     ]
 *
 * @type {Array}
 * @ignore
 */ var $420c57962e03702d$var$__apiStruct = [];
/**
 * `Array.prototype` reference.
 *
 * @type object
 * @ignore
 */ var $420c57962e03702d$var$__arrayProto = Array.prototype;
/**
 * Abstraction for `context` parameter of the `Api` constructor to allow it to
 * take several different forms for ease of use.
 *
 * Each of the input parameter types will be converted to a DataTables settings
 * object where possible.
 *
 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
 *   of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 *   * `DataTables.Api` - API instance
 * @return {array|null} Matching DataTables settings objects. `null` or
 *   `undefined` is returned if no matching DataTable is found.
 * @ignore
 */ var $420c57962e03702d$var$_toSettings = function(mixed) {
    var idx, jq;
    var settings = $420c57962e03702d$var$DataTable.settings;
    var tables = $420c57962e03702d$var$_pluck(settings, "nTable");
    if (!mixed) return [];
    else if (mixed.nTable && mixed.oFeatures) // DataTables settings object
    return [
        mixed
    ];
    else if (mixed.nodeName && mixed.nodeName.toLowerCase() === "table") {
        // Table node
        idx = tables.indexOf(mixed);
        return idx !== -1 ? [
            settings[idx]
        ] : null;
    } else if (mixed && typeof mixed.settings === "function") return mixed.settings().toArray();
    else if (typeof mixed === "string") // jQuery selector
    jq = $420c57962e03702d$var$$(mixed).get();
    else if (mixed instanceof $420c57962e03702d$var$$) // jQuery object (also DataTables instance)
    jq = mixed.get();
    if (jq) return settings.filter(function(v, idx) {
        return jq.includes(tables[idx]);
    });
};
/**
 * DataTables API class - used to control and interface with  one or more
 * DataTables enhanced tables.
 *
 * The API class is heavily based on jQuery, presenting a chainable interface
 * that you can use to interact with tables. Each instance of the API class has
 * a "context" - i.e. the tables that it will operate on. This could be a single
 * table, all tables on a page or a sub-set thereof.
 *
 * Additionally the API is designed to allow you to easily work with the data in
 * the tables, retrieving and manipulating it as required. This is done by
 * presenting the API class as an array like interface. The contents of the
 * array depend upon the actions requested by each method (for example
 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
 * return an array of objects or arrays depending upon your table's
 * configuration). The API object has a number of array like methods (`push`,
 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
 * `unique` etc) to assist your working with the data held in a table.
 *
 * Most methods (those which return an Api instance) are chainable, which means
 * the return from a method call also has all of the methods available that the
 * top level object had. For example, these two calls are equivalent:
 *
 *     // Not chained
 *     api.row.add( {...} );
 *     api.draw();
 *
 *     // Chained
 *     api.row.add( {...} ).draw();
 *
 * @class DataTable.Api
 * @param {array|object|string|jQuery} context DataTable identifier. This is
 *   used to define which DataTables enhanced tables this API will operate on.
 *   Can be one of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 * @param {array} [data] Data to initialise the Api instance with.
 *
 * @example
 *   // Direct initialisation during DataTables construction
 *   var api = $('#example').DataTable();
 *
 * @example
 *   // Initialisation using a DataTables jQuery object
 *   var api = $('#example').dataTable().api();
 *
 * @example
 *   // Initialisation as a constructor
 *   var api = new DataTable.Api( 'table.dataTable' );
 */ $420c57962e03702d$var$_Api = function(context, data) {
    if (!(this instanceof $420c57962e03702d$var$_Api)) return new $420c57962e03702d$var$_Api(context, data);
    var settings = [];
    var ctxSettings = function(o) {
        var a = $420c57962e03702d$var$_toSettings(o);
        if (a) settings.push.apply(settings, a);
    };
    if (Array.isArray(context)) for(var i = 0, ien = context.length; i < ien; i++)ctxSettings(context[i]);
    else ctxSettings(context);
    // Remove duplicates
    this.context = settings.length > 1 ? $420c57962e03702d$var$_unique(settings) : settings;
    // Initial data
    if (data) this.push.apply(this, data);
    // selector
    this.selector = {
        rows: null,
        cols: null,
        opts: null
    };
    $420c57962e03702d$var$_Api.extend(this, this, $420c57962e03702d$var$__apiStruct);
};
$420c57962e03702d$var$DataTable.Api = $420c57962e03702d$var$_Api;
// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
// isPlainObject.
$420c57962e03702d$var$$.extend($420c57962e03702d$var$_Api.prototype, {
    any: function() {
        return this.count() !== 0;
    },
    context: [],
    count: function() {
        return this.flatten().length;
    },
    each: function(fn) {
        for(var i = 0, ien = this.length; i < ien; i++)fn.call(this, this[i], i, this);
        return this;
    },
    eq: function(idx) {
        var ctx = this.context;
        return ctx.length > idx ? new $420c57962e03702d$var$_Api(ctx[idx], this[idx]) : null;
    },
    filter: function(fn) {
        var a = $420c57962e03702d$var$__arrayProto.filter.call(this, fn, this);
        return new $420c57962e03702d$var$_Api(this.context, a);
    },
    flatten: function() {
        var a = [];
        return new $420c57962e03702d$var$_Api(this.context, a.concat.apply(a, this.toArray()));
    },
    get: function(idx) {
        return this[idx];
    },
    join: $420c57962e03702d$var$__arrayProto.join,
    includes: function(find) {
        return this.indexOf(find) === -1 ? false : true;
    },
    indexOf: $420c57962e03702d$var$__arrayProto.indexOf,
    iterator: function(flatten, type, fn, alwaysNew) {
        var a = [], ret, i, ien, j, jen, context = this.context, rows, items, item, selector = this.selector;
        // Argument shifting
        if (typeof flatten === "string") {
            alwaysNew = fn;
            fn = type;
            type = flatten;
            flatten = false;
        }
        for(i = 0, ien = context.length; i < ien; i++){
            var apiInst = new $420c57962e03702d$var$_Api(context[i]);
            if (type === "table") {
                ret = fn.call(apiInst, context[i], i);
                if (ret !== undefined) a.push(ret);
            } else if (type === "columns" || type === "rows") {
                // this has same length as context - one entry for each table
                ret = fn.call(apiInst, context[i], this[i], i);
                if (ret !== undefined) a.push(ret);
            } else if (type === "every" || type === "column" || type === "column-rows" || type === "row" || type === "cell") {
                // columns and rows share the same structure.
                // 'this' is an array of column indexes for each context
                items = this[i];
                if (type === "column-rows") rows = $420c57962e03702d$var$_selector_row_indexes(context[i], selector.opts);
                for(j = 0, jen = items.length; j < jen; j++){
                    item = items[j];
                    if (type === "cell") ret = fn.call(apiInst, context[i], item.row, item.column, i, j);
                    else ret = fn.call(apiInst, context[i], item, i, j, rows);
                    if (ret !== undefined) a.push(ret);
                }
            }
        }
        if (a.length || alwaysNew) {
            var api = new $420c57962e03702d$var$_Api(context, flatten ? a.concat.apply([], a) : a);
            var apiSelector = api.selector;
            apiSelector.rows = selector.rows;
            apiSelector.cols = selector.cols;
            apiSelector.opts = selector.opts;
            return api;
        }
        return this;
    },
    lastIndexOf: $420c57962e03702d$var$__arrayProto.lastIndexOf,
    length: 0,
    map: function(fn) {
        var a = $420c57962e03702d$var$__arrayProto.map.call(this, fn, this);
        return new $420c57962e03702d$var$_Api(this.context, a);
    },
    pluck: function(prop) {
        var fn = $420c57962e03702d$var$DataTable.util.get(prop);
        return this.map(function(el) {
            return fn(el);
        });
    },
    pop: $420c57962e03702d$var$__arrayProto.pop,
    push: $420c57962e03702d$var$__arrayProto.push,
    reduce: $420c57962e03702d$var$__arrayProto.reduce,
    reduceRight: $420c57962e03702d$var$__arrayProto.reduceRight,
    reverse: $420c57962e03702d$var$__arrayProto.reverse,
    // Object with rows, columns and opts
    selector: null,
    shift: $420c57962e03702d$var$__arrayProto.shift,
    slice: function() {
        return new $420c57962e03702d$var$_Api(this.context, this);
    },
    sort: $420c57962e03702d$var$__arrayProto.sort,
    splice: $420c57962e03702d$var$__arrayProto.splice,
    toArray: function() {
        return $420c57962e03702d$var$__arrayProto.slice.call(this);
    },
    to$: function() {
        return $420c57962e03702d$var$$(this);
    },
    toJQuery: function() {
        return $420c57962e03702d$var$$(this);
    },
    unique: function() {
        return new $420c57962e03702d$var$_Api(this.context, $420c57962e03702d$var$_unique(this.toArray()));
    },
    unshift: $420c57962e03702d$var$__arrayProto.unshift
});
function $420c57962e03702d$var$_api_scope(scope, fn, struc) {
    return function() {
        var ret = fn.apply(scope || this, arguments);
        // Method extension
        $420c57962e03702d$var$_Api.extend(ret, ret, struc.methodExt);
        return ret;
    };
}
function $420c57962e03702d$var$_api_find(src, name) {
    for(var i = 0, ien = src.length; i < ien; i++){
        if (src[i].name === name) return src[i];
    }
    return null;
}
window.__apiStruct = $420c57962e03702d$var$__apiStruct;
$420c57962e03702d$var$_Api.extend = function(scope, obj, ext) {
    // Only extend API instances and static properties of the API
    if (!ext.length || !obj || !(obj instanceof $420c57962e03702d$var$_Api) && !obj.__dt_wrapper) return;
    var i, ien, struct;
    for(i = 0, ien = ext.length; i < ien; i++){
        struct = ext[i];
        if (struct.name === "__proto__") continue;
        // Value
        obj[struct.name] = struct.type === "function" ? $420c57962e03702d$var$_api_scope(scope, struct.val, struct) : struct.type === "object" ? {} : struct.val;
        obj[struct.name].__dt_wrapper = true;
        // Property extension
        $420c57962e03702d$var$_Api.extend(scope, obj[struct.name], struct.propExt);
    }
};
//     [
//       {
//         name:      'data'                -- string   - Property name
//         val:       function () {},       -- function - Api method (or undefined if just an object
//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
//       },
//       {
//         name:     'row'
//         val:       {},
//         methodExt: [ ... ],
//         propExt:   [
//           {
//             name:      'data'
//             val:       function () {},
//             methodExt: [ ... ],
//             propExt:   [ ... ]
//           },
//           ...
//         ]
//       }
//     ]
$420c57962e03702d$var$_Api.register = $420c57962e03702d$var$_api_register = function(name, val) {
    if (Array.isArray(name)) {
        for(var j = 0, jen = name.length; j < jen; j++)$420c57962e03702d$var$_Api.register(name[j], val);
        return;
    }
    var i, ien, heir = name.split("."), struct = $420c57962e03702d$var$__apiStruct, key, method;
    for(i = 0, ien = heir.length; i < ien; i++){
        method = heir[i].indexOf("()") !== -1;
        key = method ? heir[i].replace("()", "") : heir[i];
        var src = $420c57962e03702d$var$_api_find(struct, key);
        if (!src) {
            src = {
                name: key,
                val: {},
                methodExt: [],
                propExt: [],
                type: "object"
            };
            struct.push(src);
        }
        if (i === ien - 1) {
            src.val = val;
            src.type = typeof val === "function" ? "function" : $420c57962e03702d$var$$.isPlainObject(val) ? "object" : "other";
        } else struct = method ? src.methodExt : src.propExt;
    }
};
$420c57962e03702d$var$_Api.registerPlural = $420c57962e03702d$var$_api_registerPlural = function(pluralName, singularName, val) {
    $420c57962e03702d$var$_Api.register(pluralName, val);
    $420c57962e03702d$var$_Api.register(singularName, function() {
        var ret = val.apply(this, arguments);
        if (ret === this) // Returned item is the API instance that was passed in, return it
        return this;
        else if (ret instanceof $420c57962e03702d$var$_Api) // New API instance returned, want the value from the first item
        // in the returned array for the singular result.
        return ret.length ? Array.isArray(ret[0]) ? new $420c57962e03702d$var$_Api(ret.context, ret[0]) : ret[0] : undefined;
        // Non-API return - just fire it back
        return ret;
    });
};
/**
 * Selector for HTML tables. Apply the given selector to the give array of
 * DataTables settings objects.
 *
 * @param {string|integer} [selector] jQuery selector string or integer
 * @param  {array} Array of DataTables settings objects to be filtered
 * @return {array}
 * @ignore
 */ var $420c57962e03702d$var$__table_selector = function(selector, a) {
    if (Array.isArray(selector)) {
        var result = [];
        selector.forEach(function(sel) {
            var inner = $420c57962e03702d$var$__table_selector(sel, a);
            result.push.apply(result, inner);
        });
        return result.filter(function(item) {
            return item;
        });
    }
    // Integer is used to pick out a table by index
    if (typeof selector === "number") return [
        a[selector]
    ];
    // Perform a jQuery selector on the table nodes
    var nodes = a.map(function(el) {
        return el.nTable;
    });
    return $420c57962e03702d$var$$(nodes).filter(selector).map(function() {
        // Need to translate back from the table node to the settings
        var idx = nodes.indexOf(this);
        return a[idx];
    }).toArray();
};
/**
 * Context selector for the API's context (i.e. the tables the API instance
 * refers to.
 *
 * @name    DataTable.Api#tables
 * @param {string|integer} [selector] Selector to pick which tables the iterator
 *   should operate on. If not given, all tables in the current context are
 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
 *   select multiple tables or as an integer to select a single table.
 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
 */ $420c57962e03702d$var$_api_register("tables()", function(selector) {
    // A new instance is created if there was a selector specified
    return selector !== undefined && selector !== null ? new $420c57962e03702d$var$_Api($420c57962e03702d$var$__table_selector(selector, this.context)) : this;
});
$420c57962e03702d$var$_api_register("table()", function(selector) {
    var tables = this.tables(selector);
    var ctx = tables.context;
    // Truncate to the first matched table
    return ctx.length ? new $420c57962e03702d$var$_Api(ctx[0]) : tables;
});
// Common methods, combined to reduce size
[
    [
        "nodes",
        "node",
        "nTable"
    ],
    [
        "body",
        "body",
        "nTBody"
    ],
    [
        "header",
        "header",
        "nTHead"
    ],
    [
        "footer",
        "footer",
        "nTFoot"
    ]
].forEach(function(item) {
    $420c57962e03702d$var$_api_registerPlural("tables()." + item[0] + "()", "table()." + item[1] + "()", function() {
        return this.iterator("table", function(ctx) {
            return ctx[item[2]];
        }, 1);
    });
});
// Structure methods
[
    [
        "header",
        "aoHeader"
    ],
    [
        "footer",
        "aoFooter"
    ]
].forEach(function(item) {
    $420c57962e03702d$var$_api_register("table()." + item[0] + ".structure()", function(selector) {
        var indexes = this.columns(selector).indexes().flatten();
        var ctx = this.context[0];
        return $420c57962e03702d$var$_fnHeaderLayout(ctx, ctx[item[1]], indexes);
    });
});
$420c57962e03702d$var$_api_registerPlural("tables().containers()", "table().container()", function() {
    return this.iterator("table", function(ctx) {
        return ctx.nTableWrapper;
    }, 1);
});
$420c57962e03702d$var$_api_register("tables().every()", function(fn) {
    var that = this;
    return this.iterator("table", function(s, i) {
        fn.call(that.table(i), i);
    });
});
$420c57962e03702d$var$_api_register("caption()", function(value, side) {
    var context = this.context;
    // Getter - return existing node's content
    if (value === undefined) {
        var caption = context[0].captionNode;
        return caption && context.length ? caption.innerHTML : null;
    }
    return this.iterator("table", function(ctx) {
        var table = $420c57962e03702d$var$$(ctx.nTable);
        var caption = $420c57962e03702d$var$$(ctx.captionNode);
        var container = $420c57962e03702d$var$$(ctx.nTableWrapper);
        // Create the node if it doesn't exist yet
        if (!caption.length) {
            caption = $420c57962e03702d$var$$("<caption/>").html(value);
            ctx.captionNode = caption[0];
            // If side isn't set, we need to insert into the document to let the
            // CSS decide so we can read it back, otherwise there is no way to
            // know if the CSS would put it top or bottom for scrolling
            if (!side) {
                table.prepend(caption);
                side = caption.css("caption-side");
            }
        }
        caption.html(value);
        if (side) {
            caption.css("caption-side", side);
            caption[0]._captionSide = side;
        }
        if (container.find("div.dataTables_scroll").length) {
            var selector = side === "top" ? "Head" : "Foot";
            container.find("div.dataTables_scroll" + selector + " table").prepend(caption);
        } else table.prepend(caption);
    }, 1);
});
$420c57962e03702d$var$_api_register("caption.node()", function() {
    var ctx = this.context;
    return ctx.length ? ctx[0].captionNode : null;
});
/**
 * Redraw the tables in the current context.
 */ $420c57962e03702d$var$_api_register("draw()", function(paging) {
    return this.iterator("table", function(settings) {
        if (paging === "page") $420c57962e03702d$var$_fnDraw(settings);
        else {
            if (typeof paging === "string") paging = paging === "full-hold" ? false : true;
            $420c57962e03702d$var$_fnReDraw(settings, paging === false);
        }
    });
});
/**
 * Get the current page index.
 *
 * @return {integer} Current page index (zero based)
 */ /**
 * Set the current page.
 *
 * Note that if you attempt to show a page which does not exist, DataTables will
 * not throw an error, but rather reset the paging.
 *
 * @param {integer|string} action The paging action to take. This can be one of:
 *  * `integer` - The page index to jump to
 *  * `string` - An action to take:
 *    * `first` - Jump to first page.
 *    * `next` - Jump to the next page
 *    * `previous` - Jump to previous page
 *    * `last` - Jump to the last page.
 * @returns {DataTables.Api} this
 */ $420c57962e03702d$var$_api_register("page()", function(action) {
    if (action === undefined) return this.page.info().page; // not an expensive call
    // else, have an action to take on all tables
    return this.iterator("table", function(settings) {
        $420c57962e03702d$var$_fnPageChange(settings, action);
    });
});
/**
 * Paging information for the first table in the current context.
 *
 * If you require paging information for another table, use the `table()` method
 * with a suitable selector.
 *
 * @return {object} Object with the following properties set:
 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
 *  * `pages` - Total number of pages
 *  * `start` - Display index for the first record shown on the current page
 *  * `end` - Display index for the last record shown on the current page
 *  * `length` - Display length (number of records). Note that generally `start
 *    + length = end`, but this is not always true, for example if there are
 *    only 2 records to show on the final page, with a length of 10.
 *  * `recordsTotal` - Full data set length
 *  * `recordsDisplay` - Data set length once the current filtering criterion
 *    are applied.
 */ $420c57962e03702d$var$_api_register("page.info()", function() {
    if (this.context.length === 0) return undefined;
    var settings = this.context[0], start = settings._iDisplayStart, len = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1, visRecords = settings.fnRecordsDisplay(), all = len === -1;
    return {
        "page": all ? 0 : Math.floor(start / len),
        "pages": all ? 1 : Math.ceil(visRecords / len),
        "start": start,
        "end": settings.fnDisplayEnd(),
        "length": len,
        "recordsTotal": settings.fnRecordsTotal(),
        "recordsDisplay": visRecords,
        "serverSide": $420c57962e03702d$var$_fnDataSource(settings) === "ssp"
    };
});
/**
 * Get the current page length.
 *
 * @return {integer} Current page length. Note `-1` indicates that all records
 *   are to be shown.
 */ /**
 * Set the current page length.
 *
 * @param {integer} Page length to set. Use `-1` to show all records.
 * @returns {DataTables.Api} this
 */ $420c57962e03702d$var$_api_register("page.len()", function(len) {
    // Note that we can't call this function 'length()' because `length`
    // is a Javascript property of functions which defines how many arguments
    // the function expects.
    if (len === undefined) return this.context.length !== 0 ? this.context[0]._iDisplayLength : undefined;
    // else, set the page length
    return this.iterator("table", function(settings) {
        $420c57962e03702d$var$_fnLengthChange(settings, len);
    });
});
var $420c57962e03702d$var$__reload = function(settings, holdPosition, callback) {
    // Use the draw event to trigger a callback
    if (callback) {
        var api = new $420c57962e03702d$var$_Api(settings);
        api.one("draw", function() {
            callback(api.ajax.json());
        });
    }
    if ($420c57962e03702d$var$_fnDataSource(settings) == "ssp") $420c57962e03702d$var$_fnReDraw(settings, holdPosition);
    else {
        $420c57962e03702d$var$_fnProcessingDisplay(settings, true);
        // Cancel an existing request
        var xhr = settings.jqXHR;
        if (xhr && xhr.readyState !== 4) xhr.abort();
        // Trigger xhr
        $420c57962e03702d$var$_fnBuildAjax(settings, {}, function(json) {
            $420c57962e03702d$var$_fnClearTable(settings);
            var data = $420c57962e03702d$var$_fnAjaxDataSrc(settings, json);
            for(var i = 0, ien = data.length; i < ien; i++)$420c57962e03702d$var$_fnAddData(settings, data[i]);
            $420c57962e03702d$var$_fnReDraw(settings, holdPosition);
            $420c57962e03702d$var$_fnInitComplete(settings);
            $420c57962e03702d$var$_fnProcessingDisplay(settings, false);
        });
    }
};
/**
 * Get the JSON response from the last Ajax request that DataTables made to the
 * server. Note that this returns the JSON from the first table in the current
 * context.
 *
 * @return {object} JSON received from the server.
 */ $420c57962e03702d$var$_api_register("ajax.json()", function() {
    var ctx = this.context;
    if (ctx.length > 0) return ctx[0].json;
// else return undefined;
});
/**
 * Get the data submitted in the last Ajax request
 */ $420c57962e03702d$var$_api_register("ajax.params()", function() {
    var ctx = this.context;
    if (ctx.length > 0) return ctx[0].oAjaxData;
// else return undefined;
});
/**
 * Reload tables from the Ajax data source. Note that this function will
 * automatically re-draw the table when the remote data has been loaded.
 *
 * @param {boolean} [reset=true] Reset (default) or hold the current paging
 *   position. A full re-sort and re-filter is performed when this method is
 *   called, which is why the pagination reset is the default action.
 * @returns {DataTables.Api} this
 */ $420c57962e03702d$var$_api_register("ajax.reload()", function(callback, resetPaging) {
    return this.iterator("table", function(settings) {
        $420c57962e03702d$var$__reload(settings, resetPaging === false, callback);
    });
});
/**
 * Get the current Ajax URL. Note that this returns the URL from the first
 * table in the current context.
 *
 * @return {string} Current Ajax source URL
 */ /**
 * Set the Ajax URL. Note that this will set the URL for all tables in the
 * current context.
 *
 * @param {string} url URL to set.
 * @returns {DataTables.Api} this
 */ $420c57962e03702d$var$_api_register("ajax.url()", function(url) {
    var ctx = this.context;
    if (url === undefined) {
        // get
        if (ctx.length === 0) return undefined;
        ctx = ctx[0];
        return $420c57962e03702d$var$$.isPlainObject(ctx.ajax) ? ctx.ajax.url : ctx.ajax;
    }
    // set
    return this.iterator("table", function(settings) {
        if ($420c57962e03702d$var$$.isPlainObject(settings.ajax)) settings.ajax.url = url;
        else settings.ajax = url;
    });
});
/**
 * Load data from the newly set Ajax URL. Note that this method is only
 * available when `ajax.url()` is used to set a URL. Additionally, this method
 * has the same effect as calling `ajax.reload()` but is provided for
 * convenience when setting a new URL. Like `ajax.reload()` it will
 * automatically redraw the table once the remote data has been loaded.
 *
 * @returns {DataTables.Api} this
 */ $420c57962e03702d$var$_api_register("ajax.url().load()", function(callback, resetPaging) {
    // Same as a reload, but makes sense to present it for easy access after a
    // url change
    return this.iterator("table", function(ctx) {
        $420c57962e03702d$var$__reload(ctx, resetPaging === false, callback);
    });
});
var $420c57962e03702d$var$_selector_run = function(type, selector, selectFn, settings, opts) {
    var out = [], res, a, i, ien, j, jen, selectorType = typeof selector;
    // Can't just check for isArray here, as an API or jQuery instance might be
    // given with their array like look
    if (!selector || selectorType === "string" || selectorType === "function" || selector.length === undefined) selector = [
        selector
    ];
    for(i = 0, ien = selector.length; i < ien; i++){
        // Only split on simple strings - complex expressions will be jQuery selectors
        a = selector[i] && selector[i].split && !selector[i].match(/[[(:]/) ? selector[i].split(",") : [
            selector[i]
        ];
        for(j = 0, jen = a.length; j < jen; j++){
            res = selectFn(typeof a[j] === "string" ? a[j].trim() : a[j]);
            // Remove empty items
            res = res.filter(function(item) {
                return item !== null && item !== undefined;
            });
            if (res && res.length) out = out.concat(res);
        }
    }
    // selector extensions
    var ext = $420c57962e03702d$var$_ext.selector[type];
    if (ext.length) for(i = 0, ien = ext.length; i < ien; i++)out = ext[i](settings, opts, out);
    return $420c57962e03702d$var$_unique(out);
};
var $420c57962e03702d$var$_selector_opts = function(opts) {
    if (!opts) opts = {};
    // Backwards compatibility for 1.9- which used the terminology filter rather
    // than search
    if (opts.filter && opts.search === undefined) opts.search = opts.filter;
    return $420c57962e03702d$var$$.extend({
        search: "none",
        order: "current",
        page: "all"
    }, opts);
};
// Reduce the API instance to the first item found
var $420c57962e03702d$var$_selector_first = function(old) {
    let inst = new $420c57962e03702d$var$_Api(old.context[0]);
    // Use a push rather than passing to the constructor, since it will
    // merge arrays down automatically, which isn't what is wanted here
    if (old.length) inst.push(old[0]);
    inst.selector = old.selector;
    // Limit to a single row / column / cell
    if (inst.length && inst[0].length > 1) inst[0].splice(1);
    return inst;
};
var $420c57962e03702d$var$_selector_row_indexes = function(settings, opts) {
    var i, ien, tmp, a = [], displayFiltered = settings.aiDisplay, displayMaster = settings.aiDisplayMaster;
    var search = opts.search, order = opts.order, page = opts.page; // all, current
    if (page == "current") // Current page implies that order=current and filter=applied, since it is
    // fairly senseless otherwise, regardless of what order and search actually
    // are
    for(i = settings._iDisplayStart, ien = settings.fnDisplayEnd(); i < ien; i++)a.push(displayFiltered[i]);
    else if (order == "current" || order == "applied") {
        if (search == "none") a = displayMaster.slice();
        else if (search == "applied") a = displayFiltered.slice();
        else if (search == "removed") {
            // O(n+m) solution by creating a hash map
            var displayFilteredMap = {};
            for(i = 0, ien = displayFiltered.length; i < ien; i++)displayFilteredMap[displayFiltered[i]] = null;
            displayMaster.forEach(function(item) {
                if (!Object.prototype.hasOwnProperty.call(displayFilteredMap, item)) a.push(item);
            });
        }
    } else if (order == "index" || order == "original") for(i = 0, ien = settings.aoData.length; i < ien; i++){
        if (!settings.aoData[i]) continue;
        if (search == "none") a.push(i);
        else {
            tmp = displayFiltered.indexOf(i);
            if (tmp === -1 && search == "removed" || tmp >= 0 && search == "applied") a.push(i);
        }
    }
    else if (typeof order === "number") {
        // Order the rows by the given column
        var ordered = $420c57962e03702d$var$_fnSort(settings, order, "asc");
        if (search === "none") a = ordered;
        else for(i = 0; i < ordered.length; i++){
            tmp = displayFiltered.indexOf(ordered[i]);
            if (tmp === -1 && search == "removed" || tmp >= 0 && search == "applied") a.push(ordered[i]);
        }
    }
    return a;
};
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Rows
 *
 * {}          - no selector - use all available rows
 * {integer}   - row aoData index
 * {node}      - TR node
 * {string}    - jQuery selector to apply to the TR elements
 * {array}     - jQuery array of nodes, or simply an array of TR nodes
 *
 */ var $420c57962e03702d$var$__row_selector = function(settings, selector, opts) {
    var rows;
    var run = function(sel) {
        var selInt = $420c57962e03702d$var$_intVal(sel);
        var aoData = settings.aoData;
        // Short cut - selector is a number and no options provided (default is
        // all records, so no need to check if the index is in there, since it
        // must be - dev error if the index doesn't exist).
        if (selInt !== null && !opts) return [
            selInt
        ];
        if (!rows) rows = $420c57962e03702d$var$_selector_row_indexes(settings, opts);
        if (selInt !== null && rows.indexOf(selInt) !== -1) // Selector - integer
        return [
            selInt
        ];
        else if (sel === null || sel === undefined || sel === "") // Selector - none
        return rows;
        // Selector - function
        if (typeof sel === "function") return rows.map(function(idx) {
            var row = aoData[idx];
            return sel(idx, row._aData, row.nTr) ? idx : null;
        });
        // Selector - node
        if (sel.nodeName) {
            var rowIdx = sel._DT_RowIndex; // Property added by DT for fast lookup
            var cellIdx = sel._DT_CellIndex;
            if (rowIdx !== undefined) // Make sure that the row is actually still present in the table
            return aoData[rowIdx] && aoData[rowIdx].nTr === sel ? [
                rowIdx
            ] : [];
            else if (cellIdx) return aoData[cellIdx.row] && aoData[cellIdx.row].nTr === sel.parentNode ? [
                cellIdx.row
            ] : [];
            else {
                var host = $420c57962e03702d$var$$(sel).closest("*[data-dt-row]");
                return host.length ? [
                    host.data("dt-row")
                ] : [];
            }
        }
        // ID selector. Want to always be able to select rows by id, regardless
        // of if the tr element has been created or not, so can't rely upon
        // jQuery here - hence a custom implementation. This does not match
        // Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
        // but to select it using a CSS selector engine (like Sizzle or
        // querySelect) it would need to need to be escaped for some characters.
        // DataTables simplifies this for row selectors since you can select
        // only a row. A # indicates an id any anything that follows is the id -
        // unescaped.
        if (typeof sel === "string" && sel.charAt(0) === "#") {
            // get row index from id
            var rowObj = settings.aIds[sel.replace(/^#/, "")];
            if (rowObj !== undefined) return [
                rowObj.idx
            ];
        // need to fall through to jQuery in case there is DOM id that
        // matches
        }
        // Get nodes in the order from the `rows` array with null values removed
        var nodes = $420c57962e03702d$var$_removeEmpty($420c57962e03702d$var$_pluck_order(settings.aoData, rows, "nTr"));
        // Selector - jQuery selector string, array of nodes or jQuery object/
        // As jQuery's .filter() allows jQuery objects to be passed in filter,
        // it also allows arrays, so this will cope with all three options
        return $420c57962e03702d$var$$(nodes).filter(sel).map(function() {
            return this._DT_RowIndex;
        }).toArray();
    };
    var matched = $420c57962e03702d$var$_selector_run("row", selector, run, settings, opts);
    if (opts.order === "current" || opts.order === "applied") $420c57962e03702d$var$_fnSortDisplay(settings, matched);
    return matched;
};
$420c57962e03702d$var$_api_register("rows()", function(selector, opts) {
    // argument shifting
    if (selector === undefined) selector = "";
    else if ($420c57962e03702d$var$$.isPlainObject(selector)) {
        opts = selector;
        selector = "";
    }
    opts = $420c57962e03702d$var$_selector_opts(opts);
    var inst = this.iterator("table", function(settings) {
        return $420c57962e03702d$var$__row_selector(settings, selector, opts);
    }, 1);
    // Want argument shifting here and in __row_selector?
    inst.selector.rows = selector;
    inst.selector.opts = opts;
    return inst;
});
$420c57962e03702d$var$_api_register("rows().nodes()", function() {
    return this.iterator("row", function(settings, row) {
        return settings.aoData[row].nTr || undefined;
    }, 1);
});
$420c57962e03702d$var$_api_register("rows().data()", function() {
    return this.iterator(true, "rows", function(settings, rows) {
        return $420c57962e03702d$var$_pluck_order(settings.aoData, rows, "_aData");
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("rows().cache()", "row().cache()", function(type) {
    return this.iterator("row", function(settings, row) {
        var r = settings.aoData[row];
        return type === "search" ? r._aFilterData : r._aSortData;
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("rows().invalidate()", "row().invalidate()", function(src) {
    return this.iterator("row", function(settings, row) {
        $420c57962e03702d$var$_fnInvalidate(settings, row, src);
    });
});
$420c57962e03702d$var$_api_registerPlural("rows().indexes()", "row().index()", function() {
    return this.iterator("row", function(settings, row) {
        return row;
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("rows().ids()", "row().id()", function(hash) {
    var a = [];
    var context = this.context;
    // `iterator` will drop undefined values, but in this case we want them
    for(var i = 0, ien = context.length; i < ien; i++)for(var j = 0, jen = this[i].length; j < jen; j++){
        var id = context[i].rowIdFn(context[i].aoData[this[i][j]]._aData);
        a.push((hash === true ? "#" : "") + id);
    }
    return new $420c57962e03702d$var$_Api(context, a);
});
$420c57962e03702d$var$_api_registerPlural("rows().remove()", "row().remove()", function() {
    this.iterator("row", function(settings, row) {
        var data = settings.aoData;
        var rowData = data[row];
        // Delete from the display arrays
        var idx = settings.aiDisplayMaster.indexOf(row);
        if (idx !== -1) settings.aiDisplayMaster.splice(idx, 1);
        // For server-side processing tables - subtract the deleted row from the count
        if (settings._iRecordsDisplay > 0) settings._iRecordsDisplay--;
        // Check for an 'overflow' they case for displaying the table
        $420c57962e03702d$var$_fnLengthOverflow(settings);
        // Remove the row's ID reference if there is one
        var id = settings.rowIdFn(rowData._aData);
        if (id !== undefined) delete settings.aIds[id];
        data[row] = null;
    });
    return this;
});
$420c57962e03702d$var$_api_register("rows.add()", function(rows) {
    var newRows = this.iterator("table", function(settings) {
        var row, i, ien;
        var out = [];
        for(i = 0, ien = rows.length; i < ien; i++){
            row = rows[i];
            if (row.nodeName && row.nodeName.toUpperCase() === "TR") out.push($420c57962e03702d$var$_fnAddTr(settings, row)[0]);
            else out.push($420c57962e03702d$var$_fnAddData(settings, row));
        }
        return out;
    }, 1);
    // Return an Api.rows() extended instance, so rows().nodes() etc can be used
    var modRows = this.rows(-1);
    modRows.pop();
    modRows.push.apply(modRows, newRows);
    return modRows;
});
/**
 *
 */ $420c57962e03702d$var$_api_register("row()", function(selector, opts) {
    return $420c57962e03702d$var$_selector_first(this.rows(selector, opts));
});
$420c57962e03702d$var$_api_register("row().data()", function(data) {
    var ctx = this.context;
    if (data === undefined) // Get
    return ctx.length && this.length && this[0].length ? ctx[0].aoData[this[0]]._aData : undefined;
    // Set
    var row = ctx[0].aoData[this[0]];
    row._aData = data;
    // If the DOM has an id, and the data source is an array
    if (Array.isArray(data) && row.nTr && row.nTr.id) $420c57962e03702d$var$_fnSetObjectDataFn(ctx[0].rowId)(data, row.nTr.id);
    // Automatically invalidate
    $420c57962e03702d$var$_fnInvalidate(ctx[0], this[0], "data");
    return this;
});
$420c57962e03702d$var$_api_register("row().node()", function() {
    var ctx = this.context;
    if (ctx.length && this.length && this[0].length) {
        var row = ctx[0].aoData[this[0]];
        if (row && row.nTr) return row.nTr;
    }
    return null;
});
$420c57962e03702d$var$_api_register("row.add()", function(row) {
    // Allow a jQuery object to be passed in - only a single row is added from
    // it though - the first element in the set
    if (row instanceof $420c57962e03702d$var$$ && row.length) row = row[0];
    var rows = this.iterator("table", function(settings) {
        if (row.nodeName && row.nodeName.toUpperCase() === "TR") return $420c57962e03702d$var$_fnAddTr(settings, row)[0];
        return $420c57962e03702d$var$_fnAddData(settings, row);
    });
    // Return an Api.rows() extended instance, with the newly added row selected
    return this.row(rows[0]);
});
$420c57962e03702d$var$$(document).on("plugin-init.dt", function(e, context) {
    var api = new $420c57962e03702d$var$_Api(context);
    api.on("stateSaveParams.DT", function(e, settings, d) {
        // This could be more compact with the API, but it is a lot faster as a simple
        // internal loop
        var idFn = settings.rowIdFn;
        var rows = settings.aiDisplayMaster;
        var ids = [];
        for(var i = 0; i < rows.length; i++){
            var rowIdx = rows[i];
            var data = settings.aoData[rowIdx];
            if (data._detailsShow) ids.push("#" + idFn(data._aData));
        }
        d.childRows = ids;
    });
    // For future state loads (e.g. with StateRestore)
    api.on("stateLoaded.DT", function(e, settings, state) {
        $420c57962e03702d$var$__details_state_load(api, state);
    });
    // And the initial load state
    $420c57962e03702d$var$__details_state_load(api, api.state.loaded());
});
var $420c57962e03702d$var$__details_state_load = function(api, state) {
    if (state && state.childRows) api.rows(state.childRows.map(function(id) {
        // Escape any `:` characters from the row id. Accounts for
        // already escaped characters.
        return id.replace(/([^:\\]*(?:\\.[^:\\]*)*):/g, "$1\\:");
    })).every(function() {
        $420c57962e03702d$var$_fnCallbackFire(api.settings()[0], null, "requestChild", [
            this
        ]);
    });
};
var $420c57962e03702d$var$__details_add = function(ctx, row, data, klass) {
    // Convert to array of TR elements
    var rows = [];
    var addRow = function(r, k) {
        // Recursion to allow for arrays of jQuery objects
        if (Array.isArray(r) || r instanceof $420c57962e03702d$var$$) {
            for(var i = 0, ien = r.length; i < ien; i++)addRow(r[i], k);
            return;
        }
        // If we get a TR element, then just add it directly - up to the dev
        // to add the correct number of columns etc
        if (r.nodeName && r.nodeName.toLowerCase() === "tr") {
            r.setAttribute("data-dt-row", row.idx);
            rows.push(r);
        } else {
            // Otherwise create a row with a wrapper
            var created = $420c57962e03702d$var$$("<tr><td></td></tr>").attr("data-dt-row", row.idx).addClass(k);
            $420c57962e03702d$var$$("td", created).addClass(k).html(r)[0].colSpan = $420c57962e03702d$var$_fnVisbleColumns(ctx);
            rows.push(created[0]);
        }
    };
    addRow(data, klass);
    if (row._details) row._details.detach();
    row._details = $420c57962e03702d$var$$(rows);
    // If the children were already shown, that state should be retained
    if (row._detailsShow) row._details.insertAfter(row.nTr);
};
// Make state saving of child row details async to allow them to be batch processed
var $420c57962e03702d$var$__details_state = $420c57962e03702d$var$DataTable.util.throttle(function(ctx) {
    $420c57962e03702d$var$_fnSaveState(ctx[0]);
}, 500);
var $420c57962e03702d$var$__details_remove = function(api, idx) {
    var ctx = api.context;
    if (ctx.length) {
        var row = ctx[0].aoData[idx !== undefined ? idx : api[0]];
        if (row && row._details) {
            row._details.remove();
            row._detailsShow = undefined;
            row._details = undefined;
            $420c57962e03702d$var$$(row.nTr).removeClass("dt-hasChild");
            $420c57962e03702d$var$__details_state(ctx);
        }
    }
};
var $420c57962e03702d$var$__details_display = function(api, show) {
    var ctx = api.context;
    if (ctx.length && api.length) {
        var row = ctx[0].aoData[api[0]];
        if (row._details) {
            row._detailsShow = show;
            if (show) {
                row._details.insertAfter(row.nTr);
                $420c57962e03702d$var$$(row.nTr).addClass("dt-hasChild");
            } else {
                row._details.detach();
                $420c57962e03702d$var$$(row.nTr).removeClass("dt-hasChild");
            }
            $420c57962e03702d$var$_fnCallbackFire(ctx[0], null, "childRow", [
                show,
                api.row(api[0])
            ]);
            $420c57962e03702d$var$__details_events(ctx[0]);
            $420c57962e03702d$var$__details_state(ctx);
        }
    }
};
var $420c57962e03702d$var$__details_events = function(settings) {
    var api = new $420c57962e03702d$var$_Api(settings);
    var namespace = ".dt.DT_details";
    var drawEvent = "draw" + namespace;
    var colvisEvent = "column-sizing" + namespace;
    var destroyEvent = "destroy" + namespace;
    var data = settings.aoData;
    api.off(drawEvent + " " + colvisEvent + " " + destroyEvent);
    if ($420c57962e03702d$var$_pluck(data, "_details").length > 0) {
        // On each draw, insert the required elements into the document
        api.on(drawEvent, function(e, ctx) {
            if (settings !== ctx) return;
            api.rows({
                page: "current"
            }).eq(0).each(function(idx) {
                // Internal data grab
                var row = data[idx];
                if (row._detailsShow) row._details.insertAfter(row.nTr);
            });
        });
        // Column visibility change - update the colspan
        api.on(colvisEvent, function(e, ctx) {
            if (settings !== ctx) return;
            // Update the colspan for the details rows (note, only if it already has
            // a colspan)
            var row, visible = $420c57962e03702d$var$_fnVisbleColumns(ctx);
            for(var i = 0, ien = data.length; i < ien; i++){
                row = data[i];
                if (row && row._details) row._details.each(function() {
                    var el = $420c57962e03702d$var$$(this).children("td");
                    if (el.length == 1) el.attr("colspan", visible);
                });
            }
        });
        // Table destroyed - nuke any child rows
        api.on(destroyEvent, function(e, ctx) {
            if (settings !== ctx) return;
            for(var i = 0, ien = data.length; i < ien; i++)if (data[i] && data[i]._details) $420c57962e03702d$var$__details_remove(api, i);
        });
    }
};
// Strings for the method names to help minification
var $420c57962e03702d$var$_emp = "";
var $420c57962e03702d$var$_child_obj = $420c57962e03702d$var$_emp + "row().child";
var $420c57962e03702d$var$_child_mth = $420c57962e03702d$var$_child_obj + "()";
// data can be:
//  tr
//  string
//  jQuery or array of any of the above
$420c57962e03702d$var$_api_register($420c57962e03702d$var$_child_mth, function(data, klass) {
    var ctx = this.context;
    if (data === undefined) // get
    return ctx.length && this.length && ctx[0].aoData[this[0]] ? ctx[0].aoData[this[0]]._details : undefined;
    else if (data === true) // show
    this.child.show();
    else if (data === false) // remove
    $420c57962e03702d$var$__details_remove(this);
    else if (ctx.length && this.length) // set
    $420c57962e03702d$var$__details_add(ctx[0], ctx[0].aoData[this[0]], data, klass);
    return this;
});
$420c57962e03702d$var$_api_register([
    $420c57962e03702d$var$_child_obj + ".show()",
    $420c57962e03702d$var$_child_mth + ".show()" // only when `child()` was called with parameters (without
], function() {
    $420c57962e03702d$var$__details_display(this, true);
    return this;
});
$420c57962e03702d$var$_api_register([
    $420c57962e03702d$var$_child_obj + ".hide()",
    $420c57962e03702d$var$_child_mth + ".hide()" // only when `child()` was called with parameters (without
], function() {
    $420c57962e03702d$var$__details_display(this, false);
    return this;
});
$420c57962e03702d$var$_api_register([
    $420c57962e03702d$var$_child_obj + ".remove()",
    $420c57962e03702d$var$_child_mth + ".remove()" // only when `child()` was called with parameters (without
], function() {
    $420c57962e03702d$var$__details_remove(this);
    return this;
});
$420c57962e03702d$var$_api_register($420c57962e03702d$var$_child_obj + ".isShown()", function() {
    var ctx = this.context;
    if (ctx.length && this.length) // _detailsShown as false or undefined will fall through to return false
    return ctx[0].aoData[this[0]]._detailsShow || false;
    return false;
});
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Columns
 *
 * {integer}           - column index (>=0 count from left, <0 count from right)
 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
 * "{string}:name"     - column name
 * "{string}"          - jQuery selector on column header nodes
 *
 */ // can be an array of these items, comma separated list, or an array of comma
// separated lists
var $420c57962e03702d$var$__re_column_selector = /^([^:]+):(name|title|visIdx|visible)$/;
// r1 and r2 are redundant - but it means that the parameters match for the
// iterator callback in columns().data()
var $420c57962e03702d$var$__columnData = function(settings, column, r1, r2, rows, type) {
    var a = [];
    for(var row = 0, ien = rows.length; row < ien; row++)a.push($420c57962e03702d$var$_fnGetCellData(settings, rows[row], column, type));
    return a;
};
var $420c57962e03702d$var$__column_header = function(settings, column, row) {
    var header = settings.aoHeader;
    var target = row !== undefined ? row : settings.bSortCellsTop // legacy support
     ? 0 : header.length - 1;
    return header[target][column].cell;
};
var $420c57962e03702d$var$__column_selector = function(settings, selector, opts) {
    var columns = settings.aoColumns, names = $420c57962e03702d$var$_pluck(columns, "sName"), titles = $420c57962e03702d$var$_pluck(columns, "sTitle"), cells = $420c57962e03702d$var$DataTable.util.get("[].[].cell")(settings.aoHeader), nodes = $420c57962e03702d$var$_unique($420c57962e03702d$var$_flatten([], cells));
    var run = function(s) {
        var selInt = $420c57962e03702d$var$_intVal(s);
        // Selector - all
        if (s === "") return $420c57962e03702d$var$_range(columns.length);
        // Selector - index
        if (selInt !== null) return [
            selInt >= 0 ? selInt : columns.length + selInt // Count from right (+ because its a negative value)
        ];
        // Selector = function
        if (typeof s === "function") {
            var rows = $420c57962e03702d$var$_selector_row_indexes(settings, opts);
            return columns.map(function(col, idx) {
                return s(idx, $420c57962e03702d$var$__columnData(settings, idx, 0, 0, rows), $420c57962e03702d$var$__column_header(settings, idx)) ? idx : null;
            });
        }
        // jQuery or string selector
        var match = typeof s === "string" ? s.match($420c57962e03702d$var$__re_column_selector) : "";
        if (match) switch(match[2]){
            case "visIdx":
            case "visible":
                var idx = parseInt(match[1], 10);
                // Visible index given, convert to column index
                if (idx < 0) {
                    // Counting from the right
                    var visColumns = columns.map(function(col, i) {
                        return col.bVisible ? i : null;
                    });
                    return [
                        visColumns[visColumns.length + idx]
                    ];
                }
                // Counting from the left
                return [
                    $420c57962e03702d$var$_fnVisibleToColumnIndex(settings, idx)
                ];
            case "name":
                // match by name. `names` is column index complete and in order
                return names.map(function(name, i) {
                    return name === match[1] ? i : null;
                });
            case "title":
                // match by column title
                return titles.map(function(title, i) {
                    return title === match[1] ? i : null;
                });
            default:
                return [];
        }
        // Cell in the table body
        if (s.nodeName && s._DT_CellIndex) return [
            s._DT_CellIndex.column
        ];
        // jQuery selector on the TH elements for the columns
        var jqResult = $420c57962e03702d$var$$(nodes).filter(s).map(function() {
            return $420c57962e03702d$var$_fnColumnsFromHeader(this); // `nodes` is column index complete and in order
        }).toArray();
        if (jqResult.length || !s.nodeName) return jqResult;
        // Otherwise a node which might have a `dt-column` data attribute, or be
        // a child or such an element
        var host = $420c57962e03702d$var$$(s).closest("*[data-dt-column]");
        return host.length ? [
            host.data("dt-column")
        ] : [];
    };
    return $420c57962e03702d$var$_selector_run("column", selector, run, settings, opts);
};
var $420c57962e03702d$var$__setColumnVis = function(settings, column, vis) {
    var cols = settings.aoColumns, col = cols[column], data = settings.aoData, cells, i, ien, tr;
    // Get
    if (vis === undefined) return col.bVisible;
    // Set
    // No change
    if (col.bVisible === vis) return false;
    if (vis) {
        // Insert column
        // Need to decide if we should use appendChild or insertBefore
        var insertBefore = $420c57962e03702d$var$_pluck(cols, "bVisible").indexOf(true, column + 1);
        for(i = 0, ien = data.length; i < ien; i++)if (data[i]) {
            tr = data[i].nTr;
            cells = data[i].anCells;
            if (tr) // insertBefore can act like appendChild if 2nd arg is null
            tr.insertBefore(cells[column], cells[insertBefore] || null);
        }
    } else // Remove column
    $420c57962e03702d$var$$($420c57962e03702d$var$_pluck(settings.aoData, "anCells", column)).detach();
    // Common actions
    col.bVisible = vis;
    $420c57962e03702d$var$_colGroup(settings);
    return true;
};
$420c57962e03702d$var$_api_register("columns()", function(selector, opts) {
    // argument shifting
    if (selector === undefined) selector = "";
    else if ($420c57962e03702d$var$$.isPlainObject(selector)) {
        opts = selector;
        selector = "";
    }
    opts = $420c57962e03702d$var$_selector_opts(opts);
    var inst = this.iterator("table", function(settings) {
        return $420c57962e03702d$var$__column_selector(settings, selector, opts);
    }, 1);
    // Want argument shifting here and in _row_selector?
    inst.selector.cols = selector;
    inst.selector.opts = opts;
    return inst;
});
$420c57962e03702d$var$_api_registerPlural("columns().header()", "column().header()", function(row) {
    return this.iterator("column", function(settings, column) {
        return $420c57962e03702d$var$__column_header(settings, column, row);
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("columns().footer()", "column().footer()", function(row) {
    return this.iterator("column", function(settings, column) {
        var footer = settings.aoFooter;
        if (!footer.length) return null;
        return settings.aoFooter[row !== undefined ? row : 0][column].cell;
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("columns().data()", "column().data()", function() {
    return this.iterator("column-rows", $420c57962e03702d$var$__columnData, 1);
});
$420c57962e03702d$var$_api_registerPlural("columns().render()", "column().render()", function(type) {
    return this.iterator("column-rows", function(settings, column, i, j, rows) {
        return $420c57962e03702d$var$__columnData(settings, column, i, j, rows, type);
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("columns().dataSrc()", "column().dataSrc()", function() {
    return this.iterator("column", function(settings, column) {
        return settings.aoColumns[column].mData;
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("columns().cache()", "column().cache()", function(type) {
    return this.iterator("column-rows", function(settings, column, i, j, rows) {
        return $420c57962e03702d$var$_pluck_order(settings.aoData, rows, type === "search" ? "_aFilterData" : "_aSortData", column);
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("columns().init()", "column().init()", function() {
    return this.iterator("column", function(settings, column) {
        return settings.aoColumns[column];
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("columns().nodes()", "column().nodes()", function() {
    return this.iterator("column-rows", function(settings, column, i, j, rows) {
        return $420c57962e03702d$var$_pluck_order(settings.aoData, rows, "anCells", column);
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("columns().titles()", "column().title()", function(title, row) {
    return this.iterator("column", function(settings, column) {
        // Argument shifting
        if (typeof title === "number") {
            row = title;
            title = undefined;
        }
        var span = $420c57962e03702d$var$$("span.dt-column-title", this.column(column).header(row));
        if (title !== undefined) {
            span.html(title);
            return this;
        }
        return span.html();
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("columns().types()", "column().type()", function() {
    return this.iterator("column", function(settings, column) {
        var type = settings.aoColumns[column].sType;
        // If the type was invalidated, then resolve it. This actually does
        // all columns at the moment. Would only happen once if getting all
        // column's data types.
        if (!type) $420c57962e03702d$var$_fnColumnTypes(settings);
        return type;
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("columns().visible()", "column().visible()", function(vis, calc) {
    var that = this;
    var changed = [];
    var ret = this.iterator("column", function(settings, column) {
        if (vis === undefined) return settings.aoColumns[column].bVisible;
         // else
        if ($420c57962e03702d$var$__setColumnVis(settings, column, vis)) changed.push(column);
    });
    // Group the column visibility changes
    if (vis !== undefined) this.iterator("table", function(settings) {
        // Redraw the header after changes
        $420c57962e03702d$var$_fnDrawHead(settings, settings.aoHeader);
        $420c57962e03702d$var$_fnDrawHead(settings, settings.aoFooter);
        // Update colspan for no records display. Child rows and extensions will use their own
        // listeners to do this - only need to update the empty table item here
        if (!settings.aiDisplay.length) $420c57962e03702d$var$$(settings.nTBody).find("td[colspan]").attr("colspan", $420c57962e03702d$var$_fnVisbleColumns(settings));
        $420c57962e03702d$var$_fnSaveState(settings);
        // Second loop once the first is done for events
        that.iterator("column", function(settings, column) {
            if (changed.includes(column)) $420c57962e03702d$var$_fnCallbackFire(settings, null, "column-visibility", [
                settings,
                column,
                vis,
                calc
            ]);
        });
        if (changed.length && (calc === undefined || calc)) that.columns.adjust();
    });
    return ret;
});
$420c57962e03702d$var$_api_registerPlural("columns().widths()", "column().width()", function() {
    // Injects a fake row into the table for just a moment so the widths can
    // be read, regardless of colspan in the header and rows being present in
    // the body
    var columns = this.columns(":visible").count();
    var row = $420c57962e03702d$var$$("<tr>").html("<td>" + Array(columns).join("</td><td>") + "</td>");
    $420c57962e03702d$var$$(this.table().body()).append(row);
    var widths = row.children().map(function() {
        return $420c57962e03702d$var$$(this).outerWidth();
    });
    row.remove();
    return this.iterator("column", function(settings, column) {
        var visIdx = $420c57962e03702d$var$_fnColumnIndexToVisible(settings, column);
        return visIdx !== null ? widths[visIdx] : 0;
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("columns().indexes()", "column().index()", function(type) {
    return this.iterator("column", function(settings, column) {
        return type === "visible" ? $420c57962e03702d$var$_fnColumnIndexToVisible(settings, column) : column;
    }, 1);
});
$420c57962e03702d$var$_api_register("columns.adjust()", function() {
    return this.iterator("table", function(settings) {
        $420c57962e03702d$var$_fnAdjustColumnSizing(settings);
    }, 1);
});
$420c57962e03702d$var$_api_register("column.index()", function(type, idx) {
    if (this.context.length !== 0) {
        var ctx = this.context[0];
        if (type === "fromVisible" || type === "toData") return $420c57962e03702d$var$_fnVisibleToColumnIndex(ctx, idx);
        else if (type === "fromData" || type === "toVisible") return $420c57962e03702d$var$_fnColumnIndexToVisible(ctx, idx);
    }
});
$420c57962e03702d$var$_api_register("column()", function(selector, opts) {
    return $420c57962e03702d$var$_selector_first(this.columns(selector, opts));
});
var $420c57962e03702d$var$__cell_selector = function(settings, selector, opts) {
    var data = settings.aoData;
    var rows = $420c57962e03702d$var$_selector_row_indexes(settings, opts);
    var cells = $420c57962e03702d$var$_removeEmpty($420c57962e03702d$var$_pluck_order(data, rows, "anCells"));
    var allCells = $420c57962e03702d$var$$($420c57962e03702d$var$_flatten([], cells));
    var row;
    var columns = settings.aoColumns.length;
    var a, i, ien, j, o, host;
    var run = function(s) {
        var fnSelector = typeof s === "function";
        if (s === null || s === undefined || fnSelector) {
            // All cells and function selectors
            a = [];
            for(i = 0, ien = rows.length; i < ien; i++){
                row = rows[i];
                for(j = 0; j < columns; j++){
                    o = {
                        row: row,
                        column: j
                    };
                    if (fnSelector) {
                        // Selector - function
                        host = data[row];
                        if (s(o, $420c57962e03702d$var$_fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null)) a.push(o);
                    } else // Selector - all
                    a.push(o);
                }
            }
            return a;
        }
        // Selector - index
        if ($420c57962e03702d$var$$.isPlainObject(s)) // Valid cell index and its in the array of selectable rows
        return s.column !== undefined && s.row !== undefined && rows.indexOf(s.row) !== -1 ? [
            s
        ] : [];
        // Selector - jQuery filtered cells
        var jqResult = allCells.filter(s).map(function(i, el) {
            return {
                row: el._DT_CellIndex.row,
                column: el._DT_CellIndex.column
            };
        }).toArray();
        if (jqResult.length || !s.nodeName) return jqResult;
        // Otherwise the selector is a node, and there is one last option - the
        // element might be a child of an element which has dt-row and dt-column
        // data attributes
        host = $420c57962e03702d$var$$(s).closest("*[data-dt-row]");
        return host.length ? [
            {
                row: host.data("dt-row"),
                column: host.data("dt-column")
            }
        ] : [];
    };
    return $420c57962e03702d$var$_selector_run("cell", selector, run, settings, opts);
};
$420c57962e03702d$var$_api_register("cells()", function(rowSelector, columnSelector, opts) {
    // Argument shifting
    if ($420c57962e03702d$var$$.isPlainObject(rowSelector)) {
        // Indexes
        if (rowSelector.row === undefined) {
            // Selector options in first parameter
            opts = rowSelector;
            rowSelector = null;
        } else {
            // Cell index objects in first parameter
            opts = columnSelector;
            columnSelector = null;
        }
    }
    if ($420c57962e03702d$var$$.isPlainObject(columnSelector)) {
        opts = columnSelector;
        columnSelector = null;
    }
    // Cell selector
    if (columnSelector === null || columnSelector === undefined) return this.iterator("table", function(settings) {
        return $420c57962e03702d$var$__cell_selector(settings, rowSelector, $420c57962e03702d$var$_selector_opts(opts));
    });
    // The default built in options need to apply to row and columns
    var internalOpts = opts ? {
        page: opts.page,
        order: opts.order,
        search: opts.search
    } : {};
    // Row + column selector
    var columns = this.columns(columnSelector, internalOpts);
    var rows = this.rows(rowSelector, internalOpts);
    var i, ien, j, jen;
    var cellsNoOpts = this.iterator("table", function(settings, idx) {
        var a = [];
        for(i = 0, ien = rows[idx].length; i < ien; i++)for(j = 0, jen = columns[idx].length; j < jen; j++)a.push({
            row: rows[idx][i],
            column: columns[idx][j]
        });
        return a;
    }, 1);
    // There is currently only one extension which uses a cell selector extension
    // It is a _major_ performance drag to run this if it isn't needed, so this is
    // an extension specific check at the moment
    var cells = opts && opts.selected ? this.cells(cellsNoOpts, opts) : cellsNoOpts;
    $420c57962e03702d$var$$.extend(cells.selector, {
        cols: columnSelector,
        rows: rowSelector,
        opts: opts
    });
    return cells;
});
$420c57962e03702d$var$_api_registerPlural("cells().nodes()", "cell().node()", function() {
    return this.iterator("cell", function(settings, row, column) {
        var data = settings.aoData[row];
        return data && data.anCells ? data.anCells[column] : undefined;
    }, 1);
});
$420c57962e03702d$var$_api_register("cells().data()", function() {
    return this.iterator("cell", function(settings, row, column) {
        return $420c57962e03702d$var$_fnGetCellData(settings, row, column);
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("cells().cache()", "cell().cache()", function(type) {
    type = type === "search" ? "_aFilterData" : "_aSortData";
    return this.iterator("cell", function(settings, row, column) {
        return settings.aoData[row][type][column];
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("cells().render()", "cell().render()", function(type) {
    return this.iterator("cell", function(settings, row, column) {
        return $420c57962e03702d$var$_fnGetCellData(settings, row, column, type);
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("cells().indexes()", "cell().index()", function() {
    return this.iterator("cell", function(settings, row, column) {
        return {
            row: row,
            column: column,
            columnVisible: $420c57962e03702d$var$_fnColumnIndexToVisible(settings, column)
        };
    }, 1);
});
$420c57962e03702d$var$_api_registerPlural("cells().invalidate()", "cell().invalidate()", function(src) {
    return this.iterator("cell", function(settings, row, column) {
        $420c57962e03702d$var$_fnInvalidate(settings, row, src, column);
    });
});
$420c57962e03702d$var$_api_register("cell()", function(rowSelector, columnSelector, opts) {
    return $420c57962e03702d$var$_selector_first(this.cells(rowSelector, columnSelector, opts));
});
$420c57962e03702d$var$_api_register("cell().data()", function(data) {
    var ctx = this.context;
    var cell = this[0];
    if (data === undefined) // Get
    return ctx.length && cell.length ? $420c57962e03702d$var$_fnGetCellData(ctx[0], cell[0].row, cell[0].column) : undefined;
    // Set
    $420c57962e03702d$var$_fnSetCellData(ctx[0], cell[0].row, cell[0].column, data);
    $420c57962e03702d$var$_fnInvalidate(ctx[0], cell[0].row, "data", cell[0].column);
    return this;
});
/**
 * Get current ordering (sorting) that has been applied to the table.
 *
 * @returns {array} 2D array containing the sorting information for the first
 *   table in the current context. Each element in the parent array represents
 *   a column being sorted upon (i.e. multi-sorting with two columns would have
 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
 *   the column index that the sorting condition applies to, the second is the
 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
 *   index of the sorting order from the `column.sorting` initialisation array.
 */ /**
 * Set the ordering for the table.
 *
 * @param {integer} order Column index to sort upon.
 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
 * @returns {DataTables.Api} this
 */ /**
 * Set the ordering for the table.
 *
 * @param {array} order 1D array of sorting information to be applied.
 * @param {array} [...] Optional additional sorting conditions
 * @returns {DataTables.Api} this
 */ /**
 * Set the ordering for the table.
 *
 * @param {array} order 2D array of sorting information to be applied.
 * @returns {DataTables.Api} this
 */ $420c57962e03702d$var$_api_register("order()", function(order, dir) {
    var ctx = this.context;
    var args = Array.prototype.slice.call(arguments);
    if (order === undefined) // get
    return ctx.length !== 0 ? ctx[0].aaSorting : undefined;
    // set
    if (typeof order === "number") // Simple column / direction passed in
    order = [
        [
            order,
            dir
        ]
    ];
    else if (args.length > 1) // Arguments passed in (list of 1D arrays)
    order = args;
    // otherwise a 2D array was passed in
    return this.iterator("table", function(settings) {
        settings.aaSorting = Array.isArray(order) ? order.slice() : order;
    });
});
/**
 * Attach a sort listener to an element for a given column
 *
 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
 *   listener to. This can take the form of a single DOM node, a jQuery
 *   collection of nodes or a jQuery selector which will identify the node(s).
 * @param {integer} column the column that a click on this node will sort on
 * @param {function} [callback] callback function when sort is run
 * @returns {DataTables.Api} this
 */ $420c57962e03702d$var$_api_register("order.listener()", function(node, column, callback) {
    return this.iterator("table", function(settings) {
        $420c57962e03702d$var$_fnSortAttachListener(settings, node, {}, column, callback);
    });
});
$420c57962e03702d$var$_api_register("order.fixed()", function(set) {
    if (!set) {
        var ctx = this.context;
        var fixed = ctx.length ? ctx[0].aaSortingFixed : undefined;
        return Array.isArray(fixed) ? {
            pre: fixed
        } : fixed;
    }
    return this.iterator("table", function(settings) {
        settings.aaSortingFixed = $420c57962e03702d$var$$.extend(true, {}, set);
    });
});
// Order by the selected column(s)
$420c57962e03702d$var$_api_register([
    "columns().order()",
    "column().order()"
], function(dir) {
    var that = this;
    if (!dir) return this.iterator("column", function(settings, idx) {
        var sort = $420c57962e03702d$var$_fnSortFlatten(settings);
        for(var i = 0, ien = sort.length; i < ien; i++){
            if (sort[i].col === idx) return sort[i].dir;
        }
        return null;
    }, 1);
    else return this.iterator("table", function(settings, i) {
        settings.aaSorting = that[i].map(function(col) {
            return [
                col,
                dir
            ];
        });
    });
});
$420c57962e03702d$var$_api_registerPlural("columns().orderable()", "column().orderable()", function(directions) {
    return this.iterator("column", function(settings, idx) {
        var col = settings.aoColumns[idx];
        return directions ? col.asSorting : col.bSortable;
    }, 1);
});
$420c57962e03702d$var$_api_register("processing()", function(show) {
    return this.iterator("table", function(ctx) {
        $420c57962e03702d$var$_fnProcessingDisplay(ctx, show);
    });
});
$420c57962e03702d$var$_api_register("search()", function(input, regex, smart, caseInsen) {
    var ctx = this.context;
    if (input === undefined) // get
    return ctx.length !== 0 ? ctx[0].oPreviousSearch.search : undefined;
    // set
    return this.iterator("table", function(settings) {
        if (!settings.oFeatures.bFilter) return;
        if (typeof regex === "object") // New style options to pass to the search builder
        $420c57962e03702d$var$_fnFilterComplete(settings, $420c57962e03702d$var$$.extend(settings.oPreviousSearch, regex, {
            search: input
        }));
        else // Compat for the old options
        $420c57962e03702d$var$_fnFilterComplete(settings, $420c57962e03702d$var$$.extend(settings.oPreviousSearch, {
            search: input,
            regex: regex === null ? false : regex,
            smart: smart === null ? true : smart,
            caseInsensitive: caseInsen === null ? true : caseInsen
        }));
    });
});
$420c57962e03702d$var$_api_register("search.fixed()", function(name, search) {
    var ret = this.iterator(true, "table", function(settings) {
        var fixed = settings.searchFixed;
        if (!name) return Object.keys(fixed);
        else if (search === undefined) return fixed[name];
        else if (search === null) delete fixed[name];
        else fixed[name] = search;
        return this;
    });
    return name !== undefined && search === undefined ? ret[0] : ret;
});
$420c57962e03702d$var$_api_registerPlural("columns().search()", "column().search()", function(input, regex, smart, caseInsen) {
    return this.iterator("column", function(settings, column) {
        var preSearch = settings.aoPreSearchCols;
        if (input === undefined) // get
        return preSearch[column].search;
        // set
        if (!settings.oFeatures.bFilter) return;
        if (typeof regex === "object") // New style options to pass to the search builder
        $420c57962e03702d$var$$.extend(preSearch[column], regex, {
            search: input
        });
        else // Old style (with not all options available)
        $420c57962e03702d$var$$.extend(preSearch[column], {
            search: input,
            regex: regex === null ? false : regex,
            smart: smart === null ? true : smart,
            caseInsensitive: caseInsen === null ? true : caseInsen
        });
        $420c57962e03702d$var$_fnFilterComplete(settings, settings.oPreviousSearch);
    });
});
$420c57962e03702d$var$_api_register([
    "columns().search.fixed()",
    "column().search.fixed()"
], function(name, search) {
    var ret = this.iterator(true, "column", function(settings, colIdx) {
        var fixed = settings.aoColumns[colIdx].searchFixed;
        if (!name) return Object.keys(fixed);
        else if (search === undefined) return fixed[name];
        else if (search === null) delete fixed[name];
        else fixed[name] = search;
        return this;
    });
    return name !== undefined && search === undefined ? ret[0] : ret;
});
/*
 * State API methods
 */ $420c57962e03702d$var$_api_register("state()", function(set, ignoreTime) {
    // getter
    if (!set) return this.context.length ? this.context[0].oSavedState : null;
    var setMutate = $420c57962e03702d$var$$.extend(true, {}, set);
    // setter
    return this.iterator("table", function(settings) {
        if (ignoreTime !== false) setMutate.time = +new Date() + 100;
        $420c57962e03702d$var$_fnImplementState(settings, setMutate, function() {});
    });
});
$420c57962e03702d$var$_api_register("state.clear()", function() {
    return this.iterator("table", function(settings) {
        // Save an empty object
        settings.fnStateSaveCallback.call(settings.oInstance, settings, {});
    });
});
$420c57962e03702d$var$_api_register("state.loaded()", function() {
    return this.context.length ? this.context[0].oLoadedState : null;
});
$420c57962e03702d$var$_api_register("state.save()", function() {
    return this.iterator("table", function(settings) {
        $420c57962e03702d$var$_fnSaveState(settings);
    });
});
/**
 * Set the jQuery or window object to be used by DataTables
 *
 * @param {*} module Library / container object
 * @param {string} [type] Library or container type `lib`, `win` or `datetime`.
 *   If not provided, automatic detection is attempted.
 */ $420c57962e03702d$var$DataTable.use = function(module, type) {
    if (type === "lib" || module.fn) $420c57962e03702d$var$$ = module;
    else if (type == "win" || module.document) {
        window = module;
        document = module.document;
    } else if (type === "datetime" || module.type === "DateTime") $420c57962e03702d$var$DataTable.DateTime = module;
};
/**
 * CommonJS factory function pass through. This will check if the arguments
 * given are a window object or a jQuery object. If so they are set
 * accordingly.
 * @param {*} root Window
 * @param {*} jq jQUery
 * @returns {boolean} Indicator
 */ $420c57962e03702d$var$DataTable.factory = function(root, jq) {
    var is = false;
    // Test if the first parameter is a window object
    if (root && root.document) {
        window = root;
        document = root.document;
    }
    // Test if the second parameter is a jQuery object
    if (jq && jq.fn && jq.fn.jquery) {
        $420c57962e03702d$var$$ = jq;
        is = true;
    }
    return is;
};
/**
 * Provide a common method for plug-ins to check the version of DataTables being
 * used, in order to ensure compatibility.
 *
 *  @param {string} version Version string to check for, in the format "X.Y.Z".
 *    Note that the formats "X" and "X.Y" are also acceptable.
 *  @param {string} [version2=current DataTables version] As above, but optional.
 *   If not given the current DataTables version will be used.
 *  @returns {boolean} true if this version of DataTables is greater or equal to
 *    the required version, or false if this version of DataTales is not
 *    suitable
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
 */ $420c57962e03702d$var$DataTable.versionCheck = function(version, version2) {
    var aThis = version2 ? version2.split(".") : $420c57962e03702d$var$DataTable.version.split(".");
    var aThat = version.split(".");
    var iThis, iThat;
    for(var i = 0, iLen = aThat.length; i < iLen; i++){
        iThis = parseInt(aThis[i], 10) || 0;
        iThat = parseInt(aThat[i], 10) || 0;
        // Parts are the same, keep comparing
        if (iThis === iThat) continue;
        // Parts are different, return immediately
        return iThis > iThat;
    }
    return true;
};
/**
 * Check if a `<table>` node is a DataTable table already or not.
 *
 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
 *      selector for the table to test. Note that if more than more than one
 *      table is passed on, only the first will be checked
 *  @returns {boolean} true the table given is a DataTable, or false otherwise
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
 *      $('#example').dataTable();
 *    }
 */ $420c57962e03702d$var$DataTable.isDataTable = function(table) {
    var t = $420c57962e03702d$var$$(table).get(0);
    var is = false;
    if (table instanceof $420c57962e03702d$var$DataTable.Api) return true;
    $420c57962e03702d$var$$.each($420c57962e03702d$var$DataTable.settings, function(i, o) {
        var head = o.nScrollHead ? $420c57962e03702d$var$$("table", o.nScrollHead)[0] : null;
        var foot = o.nScrollFoot ? $420c57962e03702d$var$$("table", o.nScrollFoot)[0] : null;
        if (o.nTable === t || head === t || foot === t) is = true;
    });
    return is;
};
/**
 * Get all DataTable tables that have been initialised - optionally you can
 * select to get only currently visible tables.
 *
 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
 *    or visible tables only.
 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
 *    DataTables
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    $.each( $.fn.dataTable.tables(true), function () {
 *      $(table).DataTable().columns.adjust();
 *    } );
 */ $420c57962e03702d$var$DataTable.tables = function(visible) {
    var api = false;
    if ($420c57962e03702d$var$$.isPlainObject(visible)) {
        api = visible.api;
        visible = visible.visible;
    }
    var a = $420c57962e03702d$var$DataTable.settings.filter(function(o) {
        return !visible || visible && $420c57962e03702d$var$$(o.nTable).is(":visible") ? true : false;
    }).map(function(o) {
        return o.nTable;
    });
    return api ? new $420c57962e03702d$var$_Api(a) : a;
};
/**
 * Convert from camel case parameters to Hungarian notation. This is made public
 * for the extensions to provide the same ability as DataTables core to accept
 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
 * parameters.
 *
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 */ $420c57962e03702d$var$DataTable.camelToHungarian = $420c57962e03702d$var$_fnCamelToHungarian;
/**
 *
 */ $420c57962e03702d$var$_api_register("$()", function(selector, opts) {
    var rows = this.rows(opts).nodes(), jqRows = $420c57962e03702d$var$$(rows);
    return $420c57962e03702d$var$$([].concat(jqRows.filter(selector).toArray(), jqRows.find(selector).toArray()));
});
// jQuery functions to operate on the tables
$420c57962e03702d$var$$.each([
    "on",
    "one",
    "off"
], function(i, key) {
    $420c57962e03702d$var$_api_register(key + "()", function() {
        var args = Array.prototype.slice.call(arguments);
        // Add the `dt` namespace automatically if it isn't already present
        args[0] = args[0].split(/\s/).map(function(e) {
            return !e.match(/\.dt\b/) ? e + ".dt" : e;
        }).join(" ");
        var inst = $420c57962e03702d$var$$(this.tables().nodes());
        inst[key].apply(inst, args);
        return this;
    });
});
$420c57962e03702d$var$_api_register("clear()", function() {
    return this.iterator("table", function(settings) {
        $420c57962e03702d$var$_fnClearTable(settings);
    });
});
$420c57962e03702d$var$_api_register("error()", function(msg) {
    return this.iterator("table", function(settings) {
        $420c57962e03702d$var$_fnLog(settings, 0, msg);
    });
});
$420c57962e03702d$var$_api_register("settings()", function() {
    return new $420c57962e03702d$var$_Api(this.context, this.context);
});
$420c57962e03702d$var$_api_register("init()", function() {
    var ctx = this.context;
    return ctx.length ? ctx[0].oInit : null;
});
$420c57962e03702d$var$_api_register("data()", function() {
    return this.iterator("table", function(settings) {
        return $420c57962e03702d$var$_pluck(settings.aoData, "_aData");
    }).flatten();
});
$420c57962e03702d$var$_api_register("trigger()", function(name, args, bubbles) {
    return this.iterator("table", function(settings) {
        return $420c57962e03702d$var$_fnCallbackFire(settings, null, name, args, bubbles);
    }).flatten();
});
$420c57962e03702d$var$_api_register("ready()", function(fn) {
    var ctx = this.context;
    // Get status of first table
    if (!fn) return ctx.length ? ctx[0]._bInitComplete || false : null;
    // Function to run either once the table becomes ready or
    // immediately if it is already ready.
    return this.tables().every(function() {
        if (this.context[0]._bInitComplete) fn.call(this);
        else this.on("init", function() {
            fn.call(this);
        });
    });
});
$420c57962e03702d$var$_api_register("destroy()", function(remove) {
    remove = remove || false;
    return this.iterator("table", function(settings) {
        var classes = settings.oClasses;
        var table = settings.nTable;
        var tbody = settings.nTBody;
        var thead = settings.nTHead;
        var tfoot = settings.nTFoot;
        var jqTable = $420c57962e03702d$var$$(table);
        var jqTbody = $420c57962e03702d$var$$(tbody);
        var jqWrapper = $420c57962e03702d$var$$(settings.nTableWrapper);
        var rows = settings.aoData.map(function(r) {
            return r ? r.nTr : null;
        });
        var orderClasses = classes.order;
        // Flag to note that the table is currently being destroyed - no action
        // should be taken
        settings.bDestroying = true;
        // Fire off the destroy callbacks for plug-ins etc
        $420c57962e03702d$var$_fnCallbackFire(settings, "aoDestroyCallback", "destroy", [
            settings
        ], true);
        // If not being removed from the document, make all columns visible
        if (!remove) new $420c57962e03702d$var$_Api(settings).columns().visible(true);
        // Blitz all `DT` namespaced events (these are internal events, the
        // lowercase, `dt` events are user subscribed and they are responsible
        // for removing them
        jqWrapper.off(".DT").find(":not(tbody *)").off(".DT");
        $420c57962e03702d$var$$(window).off(".DT-" + settings.sInstance);
        // When scrolling we had to break the table up - restore it
        if (table != thead.parentNode) {
            jqTable.children("thead").detach();
            jqTable.append(thead);
        }
        if (tfoot && table != tfoot.parentNode) {
            jqTable.children("tfoot").detach();
            jqTable.append(tfoot);
        }
        settings.colgroup.remove();
        settings.aaSorting = [];
        settings.aaSortingFixed = [];
        $420c57962e03702d$var$_fnSortingClasses(settings);
        $420c57962e03702d$var$$("th, td", thead).removeClass(orderClasses.canAsc + " " + orderClasses.canDesc + " " + orderClasses.isAsc + " " + orderClasses.isDesc).css("width", "");
        // Add the TR elements back into the table in their original order
        jqTbody.children().detach();
        jqTbody.append(rows);
        var orig = settings.nTableWrapper.parentNode;
        var insertBefore = settings.nTableWrapper.nextSibling;
        // Remove the DataTables generated nodes, events and classes
        var removedMethod = remove ? "remove" : "detach";
        jqTable[removedMethod]();
        jqWrapper[removedMethod]();
        // If we need to reattach the table to the document
        if (!remove && orig) {
            // insertBefore acts like appendChild if !arg[1]
            orig.insertBefore(table, insertBefore);
            // Restore the width of the original table - was read from the style property,
            // so we can restore directly to that
            jqTable.css("width", settings.sDestroyWidth).removeClass(classes.table);
        }
        /* Remove the settings object from the settings array */ var idx = $420c57962e03702d$var$DataTable.settings.indexOf(settings);
        if (idx !== -1) $420c57962e03702d$var$DataTable.settings.splice(idx, 1);
    });
});
// Add the `every()` method for rows, columns and cells in a compact form
$420c57962e03702d$var$$.each([
    "column",
    "row",
    "cell"
], function(i, type) {
    $420c57962e03702d$var$_api_register(type + "s().every()", function(fn) {
        var opts = this.selector.opts;
        var api = this;
        var inst;
        var counter = 0;
        return this.iterator("every", function(settings, selectedIdx, tableIdx) {
            inst = api[type](selectedIdx, opts);
            if (type === "cell") fn.call(inst, inst[0][0].row, inst[0][0].column, tableIdx, counter);
            else fn.call(inst, selectedIdx, tableIdx, counter);
            counter++;
        });
    });
});
// i18n method for extensions to be able to use the language object from the
// DataTable
$420c57962e03702d$var$_api_register("i18n()", function(token, def, plural) {
    var ctx = this.context[0];
    var resolved = $420c57962e03702d$var$_fnGetObjectDataFn(token)(ctx.oLanguage);
    if (resolved === undefined) resolved = def;
    if ($420c57962e03702d$var$$.isPlainObject(resolved)) resolved = plural !== undefined && resolved[plural] !== undefined ? resolved[plural] : resolved._;
    return typeof resolved === "string" ? resolved.replace("%d", plural) // nb: plural might be undefined,
     : resolved;
});
/**
 * Version string for plug-ins to check compatibility. Allowed format is
 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
 * only for non-release builds. See https://semver.org/ for more information.
 *  @member
 *  @type string
 *  @default Version number
 */ $420c57962e03702d$var$DataTable.version = "2.0.7";
/**
 * Private data store, containing all of the settings objects that are
 * created for the tables on a given page.
 *
 * Note that the `DataTable.settings` object is aliased to
 * `jQuery.fn.dataTableExt` through which it may be accessed and
 * manipulated, or `jQuery.fn.dataTable.settings`.
 *  @member
 *  @type array
 *  @default []
 *  @private
 */ $420c57962e03702d$var$DataTable.settings = [];
/**
 * Object models container, for the various models that DataTables has
 * available to it. These models define the objects that are used to hold
 * the active state and configuration of the table.
 *  @namespace
 */ $420c57962e03702d$var$DataTable.models = {};
/**
 * Template object for the way in which DataTables holds information about
 * search information for the global filter and individual column filters.
 *  @namespace
 */ $420c57962e03702d$var$DataTable.models.oSearch = {
    /**
	 * Flag to indicate if the filtering should be case insensitive or not
	 */ "caseInsensitive": true,
    /**
	 * Applied search term
	 */ "search": "",
    /**
	 * Flag to indicate if the search term should be interpreted as a
	 * regular expression (true) or not (false) and therefore and special
	 * regex characters escaped.
	 */ "regex": false,
    /**
	 * Flag to indicate if DataTables is to use its smart filtering or not.
	 */ "smart": true,
    /**
	 * Flag to indicate if DataTables should only trigger a search when
	 * the return key is pressed.
	 */ "return": false
};
/**
 * Template object for the way in which DataTables holds information about
 * each individual row. This is the object format used for the settings
 * aoData array.
 *  @namespace
 */ $420c57962e03702d$var$DataTable.models.oRow = {
    /**
	 * TR element for the row
	 */ "nTr": null,
    /**
	 * Array of TD elements for each row. This is null until the row has been
	 * created.
	 */ "anCells": null,
    /**
	 * Data object from the original data source for the row. This is either
	 * an array if using the traditional form of DataTables, or an object if
	 * using mData options. The exact type will depend on the passed in
	 * data from the data source, or will be an array if using DOM a data
	 * source.
	 */ "_aData": [],
    /**
	 * Sorting data cache - this array is ostensibly the same length as the
	 * number of columns (although each index is generated only as it is
	 * needed), and holds the data that is used for sorting each column in the
	 * row. We do this cache generation at the start of the sort in order that
	 * the formatting of the sort data need be done only once for each cell
	 * per sort. This array should not be read from or written to by anything
	 * other than the master sorting methods.
	 */ "_aSortData": null,
    /**
	 * Per cell filtering data cache. As per the sort data cache, used to
	 * increase the performance of the filtering in DataTables
	 */ "_aFilterData": null,
    /**
	 * Filtering data cache. This is the same as the cell filtering cache, but
	 * in this case a string rather than an array. This is easily computed with
	 * a join on `_aFilterData`, but is provided as a cache so the join isn't
	 * needed on every search (memory traded for performance)
	 */ "_sFilterRow": null,
    /**
	 * Denote if the original data source was from the DOM, or the data source
	 * object. This is used for invalidating data, so DataTables can
	 * automatically read data from the original source, unless uninstructed
	 * otherwise.
	 */ "src": null,
    /**
	 * Index in the aoData array. This saves an indexOf lookup when we have the
	 * object, but want to know the index
	 */ "idx": -1,
    /**
	 * Cached display value
	 */ displayData: null
};
/**
 * Template object for the column information object in DataTables. This object
 * is held in the settings aoColumns array and contains all the information that
 * DataTables needs about each individual column.
 *
 * Note that this object is related to {@link DataTable.defaults.column}
 * but this one is the internal data store for DataTables's cache of columns.
 * It should NOT be manipulated outside of DataTables. Any configuration should
 * be done through the initialisation options.
 *  @namespace
 */ $420c57962e03702d$var$DataTable.models.oColumn = {
    /**
	 * Column index.
	 */ "idx": null,
    /**
	 * A list of the columns that sorting should occur on when this column
	 * is sorted. That this property is an array allows multi-column sorting
	 * to be defined for a column (for example first name / last name columns
	 * would benefit from this). The values are integers pointing to the
	 * columns to be sorted on (typically it will be a single integer pointing
	 * at itself, but that doesn't need to be the case).
	 */ "aDataSort": null,
    /**
	 * Define the sorting directions that are applied to the column, in sequence
	 * as the column is repeatedly sorted upon - i.e. the first value is used
	 * as the sorting direction when the column if first sorted (clicked on).
	 * Sort it again (click again) and it will move on to the next index.
	 * Repeat until loop.
	 */ "asSorting": null,
    /**
	 * Flag to indicate if the column is searchable, and thus should be included
	 * in the filtering or not.
	 */ "bSearchable": null,
    /**
	 * Flag to indicate if the column is sortable or not.
	 */ "bSortable": null,
    /**
	 * Flag to indicate if the column is currently visible in the table or not
	 */ "bVisible": null,
    /**
	 * Store for manual type assignment using the `column.type` option. This
	 * is held in store so we can manipulate the column's `sType` property.
	 */ "_sManualType": null,
    /**
	 * Flag to indicate if HTML5 data attributes should be used as the data
	 * source for filtering or sorting. True is either are.
	 */ "_bAttrSrc": false,
    /**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 */ "fnCreatedCell": null,
    /**
	 * Function to get data from a cell in a column. You should <b>never</b>
	 * access data directly through _aData internally in DataTables - always use
	 * the method attached to this property. It allows mData to function as
	 * required. This function is automatically assigned by the column
	 * initialisation method
	 */ "fnGetData": null,
    /**
	 * Function to set data for a cell in the column. You should <b>never</b>
	 * set the data directly to _aData internally in DataTables - always use
	 * this method. It allows mData to function as required. This function
	 * is automatically assigned by the column initialisation method
	 */ "fnSetData": null,
    /**
	 * Property to read the value for the cells in the column from the data
	 * source array / object. If null, then the default content is used, if a
	 * function is given then the return from the function is used.
	 */ "mData": null,
    /**
	 * Partner property to mData which is used (only when defined) to get
	 * the data - i.e. it is basically the same as mData, but without the
	 * 'set' option, and also the data fed to it is the result from mData.
	 * This is the rendering method to match the data method of mData.
	 */ "mRender": null,
    /**
	 * The class to apply to all TD elements in the table's TBODY for the column
	 */ "sClass": null,
    /**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 */ "sContentPadding": null,
    /**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because mData
	 * is set to null, or because the data source itself is null).
	 */ "sDefaultContent": null,
    /**
	 * Name for the column, allowing reference to the column by name as well as
	 * by index (needs a lookup to work by name).
	 */ "sName": null,
    /**
	 * Custom sorting data type - defines which of the available plug-ins in
	 * afnSortData the custom sorting will use - if any is defined.
	 */ "sSortDataType": "std",
    /**
	 * Class to be applied to the header element when sorting on this column
	 */ "sSortingClass": null,
    /**
	 * Title of the column - what is seen in the TH element (nTh).
	 */ "sTitle": null,
    /**
	 * Column sorting and filtering type
	 */ "sType": null,
    /**
	 * Width of the column
	 */ "sWidth": null,
    /**
	 * Width of the column when it was first "encountered"
	 */ "sWidthOrig": null,
    /** Cached string which is the longest in the column */ maxLenString: null,
    /**
	 * Store for named searches
	 */ searchFixed: null
};
/*
 * Developer note: The properties of the object below are given in Hungarian
 * notation, that was used as the interface for DataTables prior to v1.10, however
 * from v1.10 onwards the primary interface is camel case. In order to avoid
 * breaking backwards compatibility utterly with this change, the Hungarian
 * version is still, internally the primary interface, but is is not documented
 * - hence the @name tags in each doc comment. This allows a Javascript function
 * to create a map from Hungarian notation to camel case (going the other direction
 * would require each property to be listed, which would add around 3K to the size
 * of DataTables, while this method is about a 0.5K hit).
 *
 * Ultimately this does pave the way for Hungarian notation to be dropped
 * completely, but that is a massive amount of work and will break current
 * installs (therefore is on-hold until v2).
 */ /**
 * Initialisation options that can be given to DataTables at initialisation
 * time.
 *  @namespace
 */ $420c57962e03702d$var$DataTable.defaults = {
    /**
	 * An array of data to use for the table, passed in at initialisation which
	 * will be used in preference to any data which is already in the DOM. This is
	 * particularly useful for constructing tables purely in Javascript, for
	 * example with a custom Ajax call.
	 */ "aaData": null,
    /**
	 * If ordering is enabled, then DataTables will perform a first pass sort on
	 * initialisation. You can define which column(s) the sort is performed
	 * upon, and the sorting direction, with this variable. The `sorting` array
	 * should contain an array for each column to be sorted initially containing
	 * the column's index and a direction string ('asc' or 'desc').
	 */ "aaSorting": [
        [
            0,
            "asc"
        ]
    ],
    /**
	 * This parameter is basically identical to the `sorting` parameter, but
	 * cannot be overridden by user interaction with the table. What this means
	 * is that you could have a column (visible or hidden) which the sorting
	 * will always be forced on first - any sorting after that (from the user)
	 * will then be performed as required. This can be useful for grouping rows
	 * together.
	 */ "aaSortingFixed": [],
    /**
	 * DataTables can be instructed to load data to display in the table from a
	 * Ajax source. This option defines how that Ajax call is made and where to.
	 *
	 * The `ajax` property has three different modes of operation, depending on
	 * how it is defined. These are:
	 *
	 * * `string` - Set the URL from where the data should be loaded from.
	 * * `object` - Define properties for `jQuery.ajax`.
	 * * `function` - Custom data get function
	 *
	 * `string`
	 * --------
	 *
	 * As a string, the `ajax` property simply defines the URL from which
	 * DataTables will load data.
	 *
	 * `object`
	 * --------
	 *
	 * As an object, the parameters in the object are passed to
	 * [jQuery.ajax](https://api.jquery.com/jQuery.ajax/) allowing fine control
	 * of the Ajax request. DataTables has a number of default parameters which
	 * you can override using this option. Please refer to the jQuery
	 * documentation for a full description of the options available, although
	 * the following parameters provide additional options in DataTables or
	 * require special consideration:
	 *
	 * * `data` - As with jQuery, `data` can be provided as an object, but it
	 *   can also be used as a function to manipulate the data DataTables sends
	 *   to the server. The function takes a single parameter, an object of
	 *   parameters with the values that DataTables has readied for sending. An
	 *   object may be returned which will be merged into the DataTables
	 *   defaults, or you can add the items to the object that was passed in and
	 *   not return anything from the function. This supersedes `fnServerParams`
	 *   from DataTables 1.9-.
	 *
	 * * `dataSrc` - By default DataTables will look for the property `data` (or
	 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
	 *   from an Ajax source or for server-side processing - this parameter
	 *   allows that property to be changed. You can use Javascript dotted
	 *   object notation to get a data source for multiple levels of nesting, or
	 *   it my be used as a function. As a function it takes a single parameter,
	 *   the JSON returned from the server, which can be manipulated as
	 *   required, with the returned value being that used by DataTables as the
	 *   data source for the table.
	 *
	 * * `success` - Should not be overridden it is used internally in
	 *   DataTables. To manipulate / transform the data returned by the server
	 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
	 *
	 * `function`
	 * ----------
	 *
	 * As a function, making the Ajax call is left up to yourself allowing
	 * complete control of the Ajax request. Indeed, if desired, a method other
	 * than Ajax could be used to obtain the required data, such as Web storage
	 * or an AIR database.
	 *
	 * The function is given four parameters and no return is required. The
	 * parameters are:
	 *
	 * 1. _object_ - Data to send to the server
	 * 2. _function_ - Callback function that must be executed when the required
	 *    data has been obtained. That data should be passed into the callback
	 *    as the only parameter
	 * 3. _object_ - DataTables settings object for the table
	 */ "ajax": null,
    /**
	 * This parameter allows you to readily specify the entries in the length drop
	 * down menu that DataTables shows when pagination is enabled. It can be
	 * either a 1D array of options which will be used for both the displayed
	 * option and the value, or a 2D array which will use the array in the first
	 * position as the value, and the array in the second position as the
	 * displayed options (useful for language strings such as 'All').
	 *
	 * Note that the `pageLength` property will be automatically set to the
	 * first value given in this array, unless `pageLength` is also provided.
	 */ "aLengthMenu": [
        10,
        25,
        50,
        100
    ],
    /**
	 * The `columns` option in the initialisation parameter allows you to define
	 * details about the way individual columns behave. For a full list of
	 * column options that can be set, please see
	 * {@link DataTable.defaults.column}. Note that if you use `columns` to
	 * define your columns, you must have an entry in the array for every single
	 * column that you have in your table (these can be null if you don't which
	 * to specify any options).
	 */ "aoColumns": null,
    /**
	 * Very similar to `columns`, `columnDefs` allows you to target a specific
	 * column, multiple columns, or all columns, using the `targets` property of
	 * each object in the array. This allows great flexibility when creating
	 * tables, as the `columnDefs` arrays can be of any length, targeting the
	 * columns you specifically want. `columnDefs` may use any of the column
	 * options available: {@link DataTable.defaults.column}, but it _must_
	 * have `targets` defined in each object in the array. Values in the `targets`
	 * array may be:
	 *   <ul>
	 *     <li>a string - class name will be matched on the TH for the column</li>
	 *     <li>0 or a positive integer - column index counting from the left</li>
	 *     <li>a negative integer - column index counting from the right</li>
	 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
	 *   </ul>
	 */ "aoColumnDefs": null,
    /**
	 * Basically the same as `search`, this parameter defines the individual column
	 * filtering state at initialisation time. The array must be of the same size
	 * as the number of columns, and each element be an object with the parameters
	 * `search` and `escapeRegex` (the latter is optional). 'null' is also
	 * accepted and the default will be used.
	 */ "aoSearchCols": [],
    /**
	 * Enable or disable automatic column width calculation. This can be disabled
	 * as an optimisation (it takes some time to calculate the widths) if the
	 * tables widths are passed in using `columns`.
	 */ "bAutoWidth": true,
    /**
	 * Deferred rendering can provide DataTables with a huge speed boost when you
	 * are using an Ajax or JS data source for the table. This option, when set to
	 * true, will cause DataTables to defer the creation of the table elements for
	 * each row until they are needed for a draw - saving a significant amount of
	 * time.
	 */ "bDeferRender": true,
    /**
	 * Replace a DataTable which matches the given selector and replace it with
	 * one which has the properties of the new initialisation object passed. If no
	 * table matches the selector, then the new DataTable will be constructed as
	 * per normal.
	 */ "bDestroy": false,
    /**
	 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
	 * that it allows the end user to input multiple words (space separated) and
	 * will match a row containing those words, even if not in the order that was
	 * specified (this allow matching across multiple columns). Note that if you
	 * wish to use filtering in DataTables this must remain 'true' - to remove the
	 * default filtering input box and retain filtering abilities, please use
	 * {@link DataTable.defaults.dom}.
	 */ "bFilter": true,
    /**
	 * Used only for compatiblity with DT1
	 * @deprecated
	 */ "bInfo": true,
    /**
	 * Used only for compatiblity with DT1
	 * @deprecated
	 */ "bLengthChange": true,
    /**
	 * Enable or disable pagination.
	 */ "bPaginate": true,
    /**
	 * Enable or disable the display of a 'processing' indicator when the table is
	 * being processed (e.g. a sort). This is particularly useful for tables with
	 * large amounts of data where it can take a noticeable amount of time to sort
	 * the entries.
	 */ "bProcessing": false,
    /**
	 * Retrieve the DataTables object for the given selector. Note that if the
	 * table has already been initialised, this parameter will cause DataTables
	 * to simply return the object that has already been set up - it will not take
	 * account of any changes you might have made to the initialisation object
	 * passed to DataTables (setting this parameter to true is an acknowledgement
	 * that you understand this). `destroy` can be used to reinitialise a table if
	 * you need.
	 */ "bRetrieve": false,
    /**
	 * When vertical (y) scrolling is enabled, DataTables will force the height of
	 * the table's viewport to the given height at all times (useful for layout).
	 * However, this can look odd when filtering data down to a small data set,
	 * and the footer is left "floating" further down. This parameter (when
	 * enabled) will cause DataTables to collapse the table's viewport down when
	 * the result set will fit within the given Y height.
	 */ "bScrollCollapse": false,
    /**
	 * Configure DataTables to use server-side processing. Note that the
	 * `ajax` parameter must also be given in order to give DataTables a
	 * source to obtain the required data for each draw.
	 */ "bServerSide": false,
    /**
	 * Enable or disable sorting of columns. Sorting of individual columns can be
	 * disabled by the `sortable` option for each column.
	 */ "bSort": true,
    /**
	 * Enable or display DataTables' ability to sort multiple columns at the
	 * same time (activated by shift-click by the user).
	 */ "bSortMulti": true,
    /**
	 * Allows control over whether DataTables should use the top (true) unique
	 * cell that is found for a single column, or the bottom (false - default).
	 * This is useful when using complex headers.
	 */ "bSortCellsTop": null,
    /**
	 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
	 * `sorting\_3` to the columns which are currently being sorted on. This is
	 * presented as a feature switch as it can increase processing time (while
	 * classes are removed and added) so for large data sets you might want to
	 * turn this off.
	 */ "bSortClasses": true,
    /**
	 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
	 * used to save table display information such as pagination information,
	 * display length, filtering and sorting. As such when the end user reloads
	 * the page the display display will match what thy had previously set up.
	 */ "bStateSave": false,
    /**
	 * This function is called when a TR element is created (and all TD child
	 * elements have been inserted), or registered if using a DOM source, allowing
	 * manipulation of the TR element (adding classes etc).
	 */ "fnCreatedRow": null,
    /**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify any aspect you want about the created DOM.
	 */ "fnDrawCallback": null,
    /**
	 * Identical to fnHeaderCallback() but for the table footer this function
	 * allows you to modify the table footer on every 'draw' event.
	 */ "fnFooterCallback": null,
    /**
	 * When rendering large numbers in the information element for the table
	 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
	 * to have a comma separator for the 'thousands' units (e.g. 1 million is
	 * rendered as "1,000,000") to help readability for the end user. This
	 * function will override the default method DataTables uses.
	 */ "fnFormatNumber": function(toFormat) {
        return toFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.oLanguage.sThousands);
    },
    /**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify the header row. This can be used to calculate and
	 * display useful information about the table.
	 */ "fnHeaderCallback": null,
    /**
	 * The information element can be used to convey information about the current
	 * state of the table. Although the internationalisation options presented by
	 * DataTables are quite capable of dealing with most customisations, there may
	 * be times where you wish to customise the string further. This callback
	 * allows you to do exactly that.
	 */ "fnInfoCallback": null,
    /**
	 * Called when the table has been initialised. Normally DataTables will
	 * initialise sequentially and there will be no need for this function,
	 * however, this does not hold true when using external language information
	 * since that is obtained using an async XHR call.
	 */ "fnInitComplete": null,
    /**
	 * Called at the very start of each table draw and can be used to cancel the
	 * draw by returning false, any other return (including undefined) results in
	 * the full draw occurring).
	 */ "fnPreDrawCallback": null,
    /**
	 * This function allows you to 'post process' each row after it have been
	 * generated for each table draw, but before it is rendered on screen. This
	 * function might be used for setting the row class name etc.
	 */ "fnRowCallback": null,
    /**
	 * Load the table state. With this function you can define from where, and how, the
	 * state of a table is loaded. By default DataTables will load from `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 */ "fnStateLoadCallback": function(settings) {
        try {
            return JSON.parse((settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem("DataTables_" + settings.sInstance + "_" + location.pathname));
        } catch (e) {
            return {};
        }
    },
    /**
	 * Callback which allows modification of the saved state prior to loading that state.
	 * This callback is called when the table is loading state from the stored data, but
	 * prior to the settings object being modified by the saved state. Note that for
	 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
	 * a plug-in.
	 */ "fnStateLoadParams": null,
    /**
	 * Callback that is called when the state has been loaded from the state saving method
	 * and the DataTables settings object has been modified as a result of the loaded state.
	 */ "fnStateLoaded": null,
    /**
	 * Save the table state. This function allows you to define where and how the state
	 * information for the table is stored By default DataTables will use `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 */ "fnStateSaveCallback": function(settings, data) {
        try {
            (settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem("DataTables_" + settings.sInstance + "_" + location.pathname, JSON.stringify(data));
        } catch (e) {
        // noop
        }
    },
    /**
	 * Callback which allows modification of the state to be saved. Called when the table
	 * has changed state a new state save is required. This method allows modification of
	 * the state saving object prior to actually doing the save, including addition or
	 * other state properties or modification. Note that for plug-in authors, you should
	 * use the `stateSaveParams` event to save parameters for a plug-in.
	 */ "fnStateSaveParams": null,
    /**
	 * Duration for which the saved state information is considered valid. After this period
	 * has elapsed the state will be returned to the default.
	 * Value is given in seconds.
	 */ "iStateDuration": 7200,
    /**
	 * Number of rows to display on a single page when using pagination. If
	 * feature enabled (`lengthChange`) then the end user will be able to override
	 * this to a custom setting using a pop-up menu.
	 */ "iDisplayLength": 10,
    /**
	 * Define the starting point for data display when using DataTables with
	 * pagination. Note that this parameter is the number of records, rather than
	 * the page number, so if you have 10 records per page and want to start on
	 * the third page, it should be "20".
	 */ "iDisplayStart": 0,
    /**
	 * By default DataTables allows keyboard navigation of the table (sorting, paging,
	 * and filtering) by adding a `tabindex` attribute to the required elements. This
	 * allows you to tab through the controls and press the enter key to activate them.
	 * The tabindex is default 0, meaning that the tab follows the flow of the document.
	 * You can overrule this using this parameter if you wish. Use a value of -1 to
	 * disable built-in keyboard navigation.
	 */ "iTabIndex": 0,
    /**
	 * Classes that DataTables assigns to the various components and features
	 * that it adds to the HTML table. This allows classes to be configured
	 * during initialisation in addition to through the static
	 * {@link DataTable.ext.oStdClasses} object).
	 */ "oClasses": {},
    /**
	 * All strings that DataTables uses in the user interface that it creates
	 * are defined in this object, allowing you to modified them individually or
	 * completely replace them all as required.
	 */ "oLanguage": {
        /**
		 * Strings that are used for WAI-ARIA labels and controls only (these are not
		 * actually visible on the page, but will be read by screenreaders, and thus
		 * must be internationalised as well).
		 */ "oAria": {
            /**
			 * ARIA label that is added to the table headers when the column may be sorted
			 */ "orderable": ": Activate to sort",
            /**
			 * ARIA label that is added to the table headers when the column is currently being sorted
			 */ "orderableReverse": ": Activate to invert sorting",
            /**
			 * ARIA label that is added to the table headers when the column is currently being 
			 * sorted and next step is to remove sorting
			 */ "orderableRemove": ": Activate to remove sorting",
            paginate: {
                first: "First",
                last: "Last",
                next: "Next",
                previous: "Previous"
            }
        },
        /**
		 * Pagination string used by DataTables for the built-in pagination
		 * control types.
		 */ "oPaginate": {
            /**
			 * Label and character for first page button («)
			 */ "sFirst": "\xab",
            /**
			 * Last page button (»)
			 */ "sLast": "\xbb",
            /**
			 * Next page button (›)
			 */ "sNext": "\u203A",
            /**
			 * Previous page button (‹)
			 */ "sPrevious": "\u2039"
        },
        /**
		 * Plural object for the data type the table is showing
		 */ entries: {
            _: "entries",
            1: "entry"
        },
        /**
		 * This string is shown in preference to `zeroRecords` when the table is
		 * empty of data (regardless of filtering). Note that this is an optional
		 * parameter - if it is not given, the value of `zeroRecords` will be used
		 * instead (either the default or given value).
		 */ "sEmptyTable": "No data available in table",
        /**
		 * This string gives information to the end user about the information
		 * that is current on display on the page. The following tokens can be
		 * used in the string and will be dynamically replaced as the table
		 * display updates. This tokens can be placed anywhere in the string, or
		 * removed as needed by the language requires:
		 *
		 * * `\_START\_` - Display index of the first record on the current page
		 * * `\_END\_` - Display index of the last record on the current page
		 * * `\_TOTAL\_` - Number of records in the table after filtering
		 * * `\_MAX\_` - Number of records in the table without filtering
		 * * `\_PAGE\_` - Current page number
		 * * `\_PAGES\_` - Total number of pages of data in the table
		 */ "sInfo": "Showing _START_ to _END_ of _TOTAL_ _ENTRIES-TOTAL_",
        /**
		 * Display information string for when the table is empty. Typically the
		 * format of this string should match `info`.
		 */ "sInfoEmpty": "Showing 0 to 0 of 0 _ENTRIES-TOTAL_",
        /**
		 * When a user filters the information in a table, this string is appended
		 * to the information (`info`) to give an idea of how strong the filtering
		 * is. The variable _MAX_ is dynamically updated.
		 */ "sInfoFiltered": "(filtered from _MAX_ total _ENTRIES-MAX_)",
        /**
		 * If can be useful to append extra information to the info string at times,
		 * and this variable does exactly that. This information will be appended to
		 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
		 * being used) at all times.
		 */ "sInfoPostFix": "",
        /**
		 * This decimal place operator is a little different from the other
		 * language options since DataTables doesn't output floating point
		 * numbers, so it won't ever use this for display of a number. Rather,
		 * what this parameter does is modify the sort methods of the table so
		 * that numbers which are in a format which has a character other than
		 * a period (`.`) as a decimal place will be sorted numerically.
		 *
		 * Note that numbers with different decimal places cannot be shown in
		 * the same table and still be sortable, the table must be consistent.
		 * However, multiple different tables on the page can use different
		 * decimal place characters.
		 */ "sDecimal": "",
        /**
		 * DataTables has a build in number formatter (`formatNumber`) which is
		 * used to format large numbers that are used in the table information.
		 * By default a comma is used, but this can be trivially changed to any
		 * character you wish with this parameter.
		 */ "sThousands": ",",
        /**
		 * Detail the action that will be taken when the drop down menu for the
		 * pagination length option is changed. The '_MENU_' variable is replaced
		 * with a default select list of 10, 25, 50 and 100, and can be replaced
		 * with a custom select box if required.
		 */ "sLengthMenu": "_MENU_ _ENTRIES_ per page",
        /**
		 * When using Ajax sourced data and during the first draw when DataTables is
		 * gathering the data, this message is shown in an empty row in the table to
		 * indicate to the end user the the data is being loaded. Note that this
		 * parameter is not used when loading data by server-side processing, just
		 * Ajax sourced data with client-side processing.
		 */ "sLoadingRecords": "Loading...",
        /**
		 * Text which is displayed when the table is processing a user action
		 * (usually a sort command or similar).
		 */ "sProcessing": "",
        /**
		 * Details the actions that will be taken when the user types into the
		 * filtering input text box. The variable "_INPUT_", if used in the string,
		 * is replaced with the HTML text box for the filtering input allowing
		 * control over where it appears in the string. If "_INPUT_" is not given
		 * then the input box is appended to the string automatically.
		 */ "sSearch": "Search:",
        /**
		 * Assign a `placeholder` attribute to the search `input` element
		 *  @type string
		 *  @default 
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.searchPlaceholder
		 */ "sSearchPlaceholder": "",
        /**
		 * All of the language information can be stored in a file on the
		 * server-side, which DataTables will look up if this parameter is passed.
		 * It must store the URL of the language file, which is in a JSON format,
		 * and the object has the same properties as the oLanguage object in the
		 * initialiser object (i.e. the above parameters). Please refer to one of
		 * the example language files to see how this works in action.
		 */ "sUrl": "",
        /**
		 * Text shown inside the table records when the is no information to be
		 * displayed after filtering. `emptyTable` is shown when there is simply no
		 * information in the table at all (regardless of filtering).
		 */ "sZeroRecords": "No matching records found"
    },
    /**
	 * This parameter allows you to have define the global filtering state at
	 * initialisation time. As an object the `search` parameter must be
	 * defined, but all other parameters are optional. When `regex` is true,
	 * the search string will be treated as a regular expression, when false
	 * (default) it will be treated as a straight string. When `smart`
	 * DataTables will use it's smart filtering methods (to word match at
	 * any point in the data), when false this will not be done.
	 */ "oSearch": $420c57962e03702d$var$$.extend({}, $420c57962e03702d$var$DataTable.models.oSearch),
    /**
	 * Table and control layout. This replaces the legacy `dom` option.
	 */ layout: {
        topStart: "pageLength",
        topEnd: "search",
        bottomStart: "info",
        bottomEnd: "paging"
    },
    /**
	 * Legacy DOM layout option
	 */ "sDom": null,
    /**
	 * Search delay option. This will throttle full table searches that use the
	 * DataTables provided search input element (it does not effect calls to
	 * `dt-api search()`, providing a delay before the search is made.
	 */ "searchDelay": null,
    /**
	 * DataTables features six different built-in options for the buttons to
	 * display for pagination control:
	 *
	 * * `numbers` - Page number buttons only
	 * * `simple` - 'Previous' and 'Next' buttons only
	 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
	 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
	 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
	 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
	 */ "sPaginationType": "full_numbers",
    /**
	 * Enable horizontal scrolling. When a table is too wide to fit into a
	 * certain layout, or you have a large number of columns in the table, you
	 * can enable x-scrolling to show the table in a viewport, which can be
	 * scrolled. This property can be `true` which will allow the table to
	 * scroll horizontally when needed, or any CSS unit, or a number (in which
	 * case it will be treated as a pixel measurement). Setting as simply `true`
	 * is recommended.
	 */ "sScrollX": "",
    /**
	 * This property can be used to force a DataTable to use more width than it
	 * might otherwise do when x-scrolling is enabled. For example if you have a
	 * table which requires to be well spaced, this parameter is useful for
	 * "over-sizing" the table, and thus forcing scrolling. This property can by
	 * any CSS unit, or a number (in which case it will be treated as a pixel
	 * measurement).
	 */ "sScrollXInner": "",
    /**
	 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
	 * to the given height, and enable scrolling for any data which overflows the
	 * current viewport. This can be used as an alternative to paging to display
	 * a lot of data in a small area (although paging and scrolling can both be
	 * enabled at the same time). This property can be any CSS unit, or a number
	 * (in which case it will be treated as a pixel measurement).
	 */ "sScrollY": "",
    /**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * Set the HTTP method that is used to make the Ajax call for server-side
	 * processing or Ajax sourced data.
	 */ "sServerMethod": "GET",
    /**
	 * DataTables makes use of renderers when displaying HTML elements for
	 * a table. These renderers can be added or modified by plug-ins to
	 * generate suitable mark-up for a site. For example the Bootstrap
	 * integration plug-in for DataTables uses a paging button renderer to
	 * display pagination buttons in the mark-up required by Bootstrap.
	 *
	 * For further information about the renderers available see
	 * DataTable.ext.renderer
	 */ "renderer": null,
    /**
	 * Set the data property name that DataTables should use to get a row's id
	 * to set as the `id` property in the node.
	 */ "rowId": "DT_RowId",
    /**
	 * Caption value
	 */ "caption": null
};
$420c57962e03702d$var$_fnHungarianMap($420c57962e03702d$var$DataTable.defaults);
/*
 * Developer note - See note in model.defaults.js about the use of Hungarian
 * notation and camel case.
 */ /**
 * Column options that can be given to DataTables at initialisation time.
 *  @namespace
 */ $420c57962e03702d$var$DataTable.defaults.column = {
    /**
	 * Define which column(s) an order will occur on for this column. This
	 * allows a column's ordering to take multiple columns into account when
	 * doing a sort or use the data from a different column. For example first
	 * name / last name columns make sense to do a multi-column sort over the
	 * two columns.
	 */ "aDataSort": null,
    "iDataSort": -1,
    ariaTitle: "",
    /**
	 * You can control the default ordering direction, and even alter the
	 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
	 * using this parameter.
	 */ "asSorting": [
        "asc",
        "desc",
        ""
    ],
    /**
	 * Enable or disable filtering on the data in this column.
	 */ "bSearchable": true,
    /**
	 * Enable or disable ordering on this column.
	 */ "bSortable": true,
    /**
	 * Enable or disable the display of this column.
	 */ "bVisible": true,
    /**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 */ "fnCreatedCell": null,
    /**
	 * This property can be used to read data from any data source property,
	 * including deeply nested objects / properties. `data` can be given in a
	 * number of different ways which effect its behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	 *      Javascript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object. Note that
	 *      function notation is recommended for use in `render` rather than
	 *      `data` as it is much simpler to use as a renderer.
	 * * `null` - use the original data source for the row rather than plucking
	 *   data directly from it. This action has effects on two other
	 *   initialisation options:
	 *    * `defaultContent` - When null is given as the `data` option and
	 *      `defaultContent` is specified for the column, the value defined by
	 *      `defaultContent` will be used for the cell.
	 *    * `render` - When null is used for the `data` option and the `render`
	 *      option is specified for the column, the whole data source for the
	 *      row is used for the renderer.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * `{array|object}` The data source for the row
	 *      * `{string}` The type call data requested - this will be 'set' when
	 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
	 *        when gathering data. Note that when `undefined` is given for the
	 *        type DataTables expects to get the raw data for the object back<
	 *      * `{*}` Data to set when the second parameter is 'set'.
	 *    * Return:
	 *      * The return value from the function is not required when 'set' is
	 *        the type of call, but otherwise the return is what will be used
	 *        for the data requested.
	 *
	 * Note that `data` is a getter and setter option. If you just require
	 * formatting of data for output, you will likely want to use `render` which
	 * is simply a getter and thus simpler to use.
	 *
	 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
	 * name change reflects the flexibility of this property and is consistent
	 * with the naming of mRender. If 'mDataProp' is given, then it will still
	 * be used by DataTables, as it automatically maps the old name to the new
	 * if required.
	 */ "mData": null,
    /**
	 * This property is the rendering partner to `data` and it is suggested that
	 * when you want to manipulate data for display (including filtering,
	 * sorting etc) without altering the underlying data for the table, use this
	 * property. `render` can be considered to be the the read only companion to
	 * `data` which is read / write (then as such more complex). Like `data`
	 * this option can be given in a number of different ways to effect its
	 * behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	 *      Javascript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object.
	 * * `object` - use different data for the different data types requested by
	 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
	 *   of the object is the data type the property refers to and the value can
	 *   defined using an integer, string or function using the same rules as
	 *   `render` normally does. Note that an `_` option _must_ be specified.
	 *   This is the default value to use if you haven't specified a value for
	 *   the data type requested by DataTables.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * {array|object} The data source for the row (based on `data`)
	 *      * {string} The type call data requested - this will be 'filter',
	 *        'display', 'type' or 'sort'.
	 *      * {array|object} The full data source for the row (not based on
	 *        `data`)
	 *    * Return:
	 *      * The return value from the function is what will be used for the
	 *        data requested.
	 */ "mRender": null,
    /**
	 * Change the cell type created for the column - either TD cells or TH cells. This
	 * can be useful as TH cells have semantic meaning in the table body, allowing them
	 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
	 */ "sCellType": "td",
    /**
	 * Class to give to each cell in this column.
	 */ "sClass": "",
    /**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 * Generally you shouldn't need this!
	 */ "sContentPadding": "",
    /**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because `data`
	 * is set to null, or because the data source itself is null).
	 */ "sDefaultContent": null,
    /**
	 * This parameter is only used in DataTables' server-side processing. It can
	 * be exceptionally useful to know what columns are being displayed on the
	 * client side, and to map these to database fields. When defined, the names
	 * also allow DataTables to reorder information from the server if it comes
	 * back in an unexpected order (i.e. if you switch your columns around on the
	 * client-side, your server-side code does not also need updating).
	 */ "sName": "",
    /**
	 * Defines a data source type for the ordering which can be used to read
	 * real-time information from the table (updating the internally cached
	 * version) prior to ordering. This allows ordering to occur on user
	 * editable elements such as form inputs.
	 */ "sSortDataType": "std",
    /**
	 * The title of this column.
	 */ "sTitle": null,
    /**
	 * The type allows you to specify how the data for this column will be
	 * ordered. Four types (string, numeric, date and html (which will strip
	 * HTML tags before ordering)) are currently available. Note that only date
	 * formats understood by Javascript's Date() object will be accepted as type
	 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
	 * 'numeric', 'date' or 'html' (by default). Further types can be adding
	 * through plug-ins.
	 */ "sType": null,
    /**
	 * Defining the width of the column, this parameter may take any CSS value
	 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
	 * been given a specific width through this interface ensuring that the table
	 * remains readable.
	 */ "sWidth": null
};
$420c57962e03702d$var$_fnHungarianMap($420c57962e03702d$var$DataTable.defaults.column);
/**
 * DataTables settings object - this holds all the information needed for a
 * given table, including configuration, data and current application of the
 * table options. DataTables does not have a single instance for each DataTable
 * with the settings attached to that instance, but rather instances of the
 * DataTable "class" are created on-the-fly as needed (typically by a
 * $().dataTable() call) and the settings object is then applied to that
 * instance.
 *
 * Note that this object is related to {@link DataTable.defaults} but this
 * one is the internal data store for DataTables's cache of columns. It should
 * NOT be manipulated outside of DataTables. Any configuration should be done
 * through the initialisation options.
 */ $420c57962e03702d$var$DataTable.models.oSettings = {
    /**
	 * Primary features of DataTables and their enablement state.
	 */ "oFeatures": {
        /**
		 * Flag to say if DataTables should automatically try to calculate the
		 * optimum table and columns widths (true) or not (false).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bAutoWidth": null,
        /**
		 * Delay the creation of TR and TD elements until they are actually
		 * needed by a driven page draw. This can give a significant speed
		 * increase for Ajax source and Javascript source data, but makes no
		 * difference at all for DOM and server-side processing tables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bDeferRender": null,
        /**
		 * Enable filtering on the table or not. Note that if this is disabled
		 * then there is no filtering at all on the table, including fnFilter.
		 * To just remove the filtering input use sDom and remove the 'f' option.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bFilter": null,
        /**
		 * Used only for compatiblity with DT1
		 * @deprecated
		 */ "bInfo": true,
        /**
		 * Used only for compatiblity with DT1
		 * @deprecated
		 */ "bLengthChange": true,
        /**
		 * Pagination enabled or not. Note that if this is disabled then length
		 * changing must also be disabled.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bPaginate": null,
        /**
		 * Processing indicator enable flag whenever DataTables is enacting a
		 * user request - typically an Ajax request for server-side processing.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bProcessing": null,
        /**
		 * Server-side processing enabled flag - when enabled DataTables will
		 * get all data from the server for every draw - there is no filtering,
		 * sorting or paging done on the client-side.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bServerSide": null,
        /**
		 * Sorting enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSort": null,
        /**
		 * Multi-column sorting
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSortMulti": null,
        /**
		 * Apply a class to the columns which are being sorted to provide a
		 * visual highlight or not. This can slow things down when enabled since
		 * there is a lot of DOM interaction.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSortClasses": null,
        /**
		 * State saving enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bStateSave": null
    },
    /**
	 * Scrolling settings for a table.
	 */ "oScroll": {
        /**
		 * When the table is shorter in height than sScrollY, collapse the
		 * table container down to the height of the table (when true).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bCollapse": null,
        /**
		 * Width of the scrollbar for the web-browser's platform. Calculated
		 * during table initialisation.
		 */ "iBarWidth": 0,
        /**
		 * Viewport width for horizontal scrolling. Horizontal scrolling is
		 * disabled if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "sX": null,
        /**
		 * Width to expand the table to when using x-scrolling. Typically you
		 * should not need to use this.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @deprecated
		 */ "sXInner": null,
        /**
		 * Viewport height for vertical scrolling. Vertical scrolling is disabled
		 * if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "sY": null
    },
    /**
	 * Language information for the table.
	 */ "oLanguage": {
        /**
		 * Information callback function. See
		 * {@link DataTable.defaults.fnInfoCallback}
		 */ "fnInfoCallback": null
    },
    /**
	 * Browser support parameters
	 */ "oBrowser": {
        /**
		 * Determine if the vertical scrollbar is on the right or left of the
		 * scrolling container - needed for rtl language layout, although not
		 * all browsers move the scrollbar (Safari).
		 */ "bScrollbarLeft": false,
        /**
		 * Browser scrollbar width
		 */ "barWidth": 0
    },
    "ajax": null,
    /**
	 * Array referencing the nodes which are used for the features. The
	 * parameters of this object match what is allowed by sDom - i.e.
	 *   <ul>
	 *     <li>'l' - Length changing</li>
	 *     <li>'f' - Filtering input</li>
	 *     <li>'t' - The table!</li>
	 *     <li>'i' - Information</li>
	 *     <li>'p' - Pagination</li>
	 *     <li>'r' - pRocessing</li>
	 *   </ul>
	 */ "aanFeatures": [],
    /**
	 * Store data information - see {@link DataTable.models.oRow} for detailed
	 * information.
	 */ "aoData": [],
    /**
	 * Array of indexes which are in the current display (after filtering etc)
	 */ "aiDisplay": [],
    /**
	 * Array of indexes for display - no filtering
	 */ "aiDisplayMaster": [],
    /**
	 * Map of row ids to data indexes
	 */ "aIds": {},
    /**
	 * Store information about each column that is in use
	 */ "aoColumns": [],
    /**
	 * Store information about the table's header
	 */ "aoHeader": [],
    /**
	 * Store information about the table's footer
	 */ "aoFooter": [],
    /**
	 * Store the applied global search information in case we want to force a
	 * research or compare the old search to a new one.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "oPreviousSearch": {},
    /**
	 * Store for named searches
	 */ searchFixed: {},
    /**
	 * Store the applied search for each column - see
	 * {@link DataTable.models.oSearch} for the format that is used for the
	 * filtering information for each column.
	 */ "aoPreSearchCols": [],
    /**
	 * Sorting that is applied to the table. Note that the inner arrays are
	 * used in the following manner:
	 * <ul>
	 *   <li>Index 0 - column number</li>
	 *   <li>Index 1 - current sorting direction</li>
	 * </ul>
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aaSorting": null,
    /**
	 * Sorting that is always applied to the table (i.e. prefixed in front of
	 * aaSorting).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aaSortingFixed": [],
    /**
	 * If restoring a table - we should restore its width
	 */ "sDestroyWidth": 0,
    /**
	 * Callback functions array for every time a row is inserted (i.e. on a draw).
	 */ "aoRowCallback": [],
    /**
	 * Callback functions for the header on each draw.
	 */ "aoHeaderCallback": [],
    /**
	 * Callback function for the footer on each draw.
	 */ "aoFooterCallback": [],
    /**
	 * Array of callback functions for draw callback functions
	 */ "aoDrawCallback": [],
    /**
	 * Array of callback functions for row created function
	 */ "aoRowCreatedCallback": [],
    /**
	 * Callback functions for just before the table is redrawn. A return of
	 * false will be used to cancel the draw.
	 */ "aoPreDrawCallback": [],
    /**
	 * Callback functions for when the table has been initialised.
	 */ "aoInitComplete": [],
    /**
	 * Callbacks for modifying the settings to be stored for state saving, prior to
	 * saving state.
	 */ "aoStateSaveParams": [],
    /**
	 * Callbacks for modifying the settings that have been stored for state saving
	 * prior to using the stored values to restore the state.
	 */ "aoStateLoadParams": [],
    /**
	 * Callbacks for operating on the settings object once the saved state has been
	 * loaded
	 */ "aoStateLoaded": [],
    /**
	 * Cache the table ID for quick access
	 */ "sTableId": "",
    /**
	 * The TABLE node for the main table
	 */ "nTable": null,
    /**
	 * Permanent ref to the thead element
	 */ "nTHead": null,
    /**
	 * Permanent ref to the tfoot element - if it exists
	 */ "nTFoot": null,
    /**
	 * Permanent ref to the tbody element
	 */ "nTBody": null,
    /**
	 * Cache the wrapper node (contains all DataTables controlled elements)
	 */ "nTableWrapper": null,
    /**
	 * Indicate if all required information has been read in
	 */ "bInitialised": false,
    /**
	 * Information about open rows. Each object in the array has the parameters
	 * 'nTr' and 'nParent'
	 */ "aoOpenRows": [],
    /**
	 * Dictate the positioning of DataTables' control elements - see
	 * {@link DataTable.model.oInit.sDom}.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sDom": null,
    /**
	 * Search delay (in mS)
	 */ "searchDelay": null,
    /**
	 * Which type of pagination should be used.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sPaginationType": "two_button",
    /**
	 * Number of paging controls on the page. Only used for backwards compatibility
	 */ pagingControls: 0,
    /**
	 * The state duration (for `stateSave`) in seconds.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "iStateDuration": 0,
    /**
	 * Array of callback functions for state saving. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the JSON string to save that has been thus far created. Returns
	 *       a JSON string to be inserted into a json object
	 *       (i.e. '"param": [ 0, 1, 2]')</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 */ "aoStateSave": [],
    /**
	 * Array of callback functions for state loading. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the object stored. May return false to cancel state loading</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 */ "aoStateLoad": [],
    /**
	 * State that was saved. Useful for back reference
	 */ "oSavedState": null,
    /**
	 * State that was loaded. Useful for back reference
	 */ "oLoadedState": null,
    /**
	 * Note if draw should be blocked while getting data
	 */ "bAjaxDataGet": true,
    /**
	 * The last jQuery XHR object that was used for server-side data gathering.
	 * This can be used for working with the XHR information in one of the
	 * callbacks
	 */ "jqXHR": null,
    /**
	 * JSON returned from the server in the last Ajax request
	 */ "json": undefined,
    /**
	 * Data submitted as part of the last Ajax request
	 */ "oAjaxData": undefined,
    /**
	 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
	 * required).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sServerMethod": null,
    /**
	 * Format numbers for display.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "fnFormatNumber": null,
    /**
	 * List of options that can be used for the user selectable length menu.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aLengthMenu": null,
    /**
	 * Counter for the draws that the table does. Also used as a tracker for
	 * server-side processing
	 */ "iDraw": 0,
    /**
	 * Indicate if a redraw is being done - useful for Ajax
	 */ "bDrawing": false,
    /**
	 * Draw index (iDraw) of the last error when parsing the returned data
	 */ "iDrawError": -1,
    /**
	 * Paging display length
	 */ "_iDisplayLength": 10,
    /**
	 * Paging start point - aiDisplay index
	 */ "_iDisplayStart": 0,
    /**
	 * Server-side processing - number of records in the result set
	 * (i.e. before filtering), Use fnRecordsTotal rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 */ "_iRecordsTotal": 0,
    /**
	 * Server-side processing - number of records in the current display set
	 * (i.e. after filtering). Use fnRecordsDisplay rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 */ "_iRecordsDisplay": 0,
    /**
	 * The classes to use for the table
	 */ "oClasses": {},
    /**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if filtering has been done in the draw. Deprecated in favour of
	 * events.
	 *  @deprecated
	 */ "bFiltered": false,
    /**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if sorting has been done in the draw. Deprecated in favour of
	 * events.
	 *  @deprecated
	 */ "bSorted": false,
    /**
	 * Indicate that if multiple rows are in the header and there is more than
	 * one unique cell per column, if the top one (true) or bottom one (false)
	 * should be used for sorting / title by DataTables.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "bSortCellsTop": null,
    /**
	 * Initialisation object that is used for the table
	 */ "oInit": null,
    /**
	 * Destroy callback functions - for plug-ins to attach themselves to the
	 * destroy so they can clean up markup and events.
	 */ "aoDestroyCallback": [],
    /**
	 * Get the number of records in the current record set, before filtering
	 */ "fnRecordsTotal": function() {
        return $420c57962e03702d$var$_fnDataSource(this) == "ssp" ? this._iRecordsTotal * 1 : this.aiDisplayMaster.length;
    },
    /**
	 * Get the number of records in the current record set, after filtering
	 */ "fnRecordsDisplay": function() {
        return $420c57962e03702d$var$_fnDataSource(this) == "ssp" ? this._iRecordsDisplay * 1 : this.aiDisplay.length;
    },
    /**
	 * Get the display end point - aiDisplay index
	 */ "fnDisplayEnd": function() {
        var len = this._iDisplayLength, start = this._iDisplayStart, calc = start + len, records = this.aiDisplay.length, features = this.oFeatures, paginate = features.bPaginate;
        if (features.bServerSide) return paginate === false || len === -1 ? start + records : Math.min(start + len, this._iRecordsDisplay);
        else return !paginate || calc > records || len === -1 ? records : calc;
    },
    /**
	 * The DataTables object for this table
	 */ "oInstance": null,
    /**
	 * Unique identifier for each instance of the DataTables object. If there
	 * is an ID on the table node, then it takes that value, otherwise an
	 * incrementing internal counter is used.
	 */ "sInstance": null,
    /**
	 * tabindex attribute value that is added to DataTables control elements, allowing
	 * keyboard navigation of the table and its controls.
	 */ "iTabIndex": 0,
    /**
	 * DIV container for the footer scrolling table if scrolling
	 */ "nScrollHead": null,
    /**
	 * DIV container for the footer scrolling table if scrolling
	 */ "nScrollFoot": null,
    /**
	 * Last applied sort
	 */ "aLastSort": [],
    /**
	 * Stored plug-in instances
	 */ "oPlugins": {},
    /**
	 * Function used to get a row's id from the row's data
	 */ "rowIdFn": null,
    /**
	 * Data location where to store a row's id
	 */ "rowId": null,
    caption: "",
    captionNode: null,
    colgroup: null
};
/**
 * Extension object for DataTables that is used to provide all extension
 * options.
 *
 * Note that the `DataTable.ext` object is available through
 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
 *  @namespace
 *  @extends DataTable.models.ext
 */ var $420c57962e03702d$var$extPagination = $420c57962e03702d$var$DataTable.ext.pager;
// Paging buttons configuration
$420c57962e03702d$var$$.extend($420c57962e03702d$var$extPagination, {
    simple: function() {
        return [
            "previous",
            "next"
        ];
    },
    full: function() {
        return [
            "first",
            "previous",
            "next",
            "last"
        ];
    },
    numbers: function() {
        return [
            "numbers"
        ];
    },
    simple_numbers: function() {
        return [
            "previous",
            "numbers",
            "next"
        ];
    },
    full_numbers: function() {
        return [
            "first",
            "previous",
            "numbers",
            "next",
            "last"
        ];
    },
    first_last: function() {
        return [
            "first",
            "last"
        ];
    },
    first_last_numbers: function() {
        return [
            "first",
            "numbers",
            "last"
        ];
    },
    // For testing and plug-ins to use
    _numbers: $420c57962e03702d$var$_pagingNumbers,
    // Number of number buttons - legacy, use `numbers` option for paging feature
    numbers_length: 7
});
$420c57962e03702d$var$$.extend(true, $420c57962e03702d$var$DataTable.ext.renderer, {
    pagingButton: {
        _: function(settings, buttonType, content, active, disabled) {
            var classes = settings.oClasses.paging;
            var btnClasses = [
                classes.button
            ];
            var btn;
            if (active) btnClasses.push(classes.active);
            if (disabled) btnClasses.push(classes.disabled);
            if (buttonType === "ellipsis") btn = $420c57962e03702d$var$$('<span class="ellipsis"></span>').html(content)[0];
            else btn = $420c57962e03702d$var$$("<button>", {
                class: btnClasses.join(" "),
                role: "link",
                type: "button"
            }).html(content);
            return {
                display: btn,
                clicker: btn
            };
        }
    },
    pagingContainer: {
        _: function(settings, buttons) {
            // No wrapping element - just append directly to the host
            return buttons;
        }
    }
});
// Common function to remove new lines, strip HTML and diacritic control
var $420c57962e03702d$var$_filterString = function(stripHtml, normalize) {
    return function(str) {
        if ($420c57962e03702d$var$_empty(str) || typeof str !== "string") return str;
        str = str.replace($420c57962e03702d$var$_re_new_lines, " ");
        if (stripHtml) str = $420c57962e03702d$var$_stripHtml(str);
        if (normalize) str = $420c57962e03702d$var$_normalize(str, false);
        return str;
    };
};
/*
 * Public helper functions. These aren't used internally by DataTables, or
 * called by any of the options passed into DataTables, but they can be used
 * externally by developers working with DataTables. They are helper functions
 * to make working with DataTables a little bit easier.
 */ function $420c57962e03702d$var$__mldFnName(name) {
    return name.replace(/[\W]/g, "_");
}
// Common logic for moment, luxon or a date action
function $420c57962e03702d$var$__mld(dt, momentFn, luxonFn, dateFn, arg1) {
    if (window.moment) return dt[momentFn](arg1);
    else if (window.luxon) return dt[luxonFn](arg1);
    return dateFn ? dt[dateFn](arg1) : dt;
}
var $420c57962e03702d$var$__mlWarning = false;
function $420c57962e03702d$var$__mldObj(d, format, locale) {
    var dt;
    if (window.moment) {
        dt = window.moment.utc(d, format, locale, true);
        if (!dt.isValid()) return null;
    } else if (window.luxon) {
        dt = format && typeof d === "string" ? window.luxon.DateTime.fromFormat(d, format) : window.luxon.DateTime.fromISO(d);
        if (!dt.isValid) return null;
        dt.setLocale(locale);
    } else if (!format) // No format given, must be ISO
    dt = new Date(d);
    else {
        if (!$420c57962e03702d$var$__mlWarning) alert("DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17");
        $420c57962e03702d$var$__mlWarning = true;
    }
    return dt;
}
// Wrapper for date, datetime and time which all operate the same way with the exception of
// the output string for auto locale support
function $420c57962e03702d$var$__mlHelper(localeString) {
    return function(from, to, locale, def) {
        // Luxon and Moment support
        // Argument shifting
        if (arguments.length === 0) {
            locale = "en";
            to = null; // means toLocaleString
            from = null; // means iso8601
        } else if (arguments.length === 1) {
            locale = "en";
            to = from;
            from = null;
        } else if (arguments.length === 2) {
            locale = to;
            to = from;
            from = null;
        }
        var typeName = "datetime" + (to ? "-" + $420c57962e03702d$var$__mldFnName(to) : "");
        // Add type detection and sorting specific to this date format - we need to be able to identify
        // date type columns as such, rather than as numbers in extensions. Hence the need for this.
        if (!$420c57962e03702d$var$DataTable.ext.type.order[typeName]) $420c57962e03702d$var$DataTable.type(typeName, {
            detect: function(d) {
                // The renderer will give the value to type detect as the type!
                return d === typeName ? typeName : false;
            },
            order: {
                pre: function(d) {
                    // The renderer gives us Moment, Luxon or Date obects for the sorting, all of which have a
                    // `valueOf` which gives milliseconds epoch
                    return d.valueOf();
                }
            },
            className: "dt-right"
        });
        return function(d, type) {
            // Allow for a default value
            if (d === null || d === undefined) {
                if (def === "--now") {
                    // We treat everything as UTC further down, so no changes are
                    // made, as such need to get the local date / time as if it were
                    // UTC
                    var local = new Date();
                    d = new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds()));
                } else d = "";
            }
            if (type === "type") // Typing uses the type name for fast matching
            return typeName;
            if (d === "") return type !== "sort" ? "" : $420c57962e03702d$var$__mldObj("0000-01-01 00:00:00", null, locale);
            // Shortcut. If `from` and `to` are the same, we are using the renderer to
            // format for ordering, not display - its already in the display format.
            if (to !== null && from === to && type !== "sort" && type !== "type" && !(d instanceof Date)) return d;
            var dt = $420c57962e03702d$var$__mldObj(d, from, locale);
            if (dt === null) return d;
            if (type === "sort") return dt;
            var formatted = to === null ? $420c57962e03702d$var$__mld(dt, "toDate", "toJSDate", "")[localeString]() : $420c57962e03702d$var$__mld(dt, "format", "toFormat", "toISOString", to);
            // XSS protection
            return type === "display" ? $420c57962e03702d$var$_escapeHtml(formatted) : formatted;
        };
    };
}
// Based on locale, determine standard number formatting
// Fallback for legacy browsers is US English
var $420c57962e03702d$var$__thousands = ",";
var $420c57962e03702d$var$__decimal = ".";
if (window.Intl !== undefined) try {
    var $420c57962e03702d$var$num = new Intl.NumberFormat().formatToParts(100000.1);
    for(var $420c57962e03702d$var$i = 0; $420c57962e03702d$var$i < $420c57962e03702d$var$num.length; $420c57962e03702d$var$i++){
        if ($420c57962e03702d$var$num[$420c57962e03702d$var$i].type === "group") $420c57962e03702d$var$__thousands = $420c57962e03702d$var$num[$420c57962e03702d$var$i].value;
        else if ($420c57962e03702d$var$num[$420c57962e03702d$var$i].type === "decimal") $420c57962e03702d$var$__decimal = $420c57962e03702d$var$num[$420c57962e03702d$var$i].value;
    }
} catch (e) {
// noop
}
// Formatted date time detection - use by declaring the formats you are going to use
$420c57962e03702d$var$DataTable.datetime = function(format, locale) {
    var typeName = "datetime-detect-" + $420c57962e03702d$var$__mldFnName(format);
    if (!locale) locale = "en";
    if (!$420c57962e03702d$var$DataTable.ext.type.order[typeName]) $420c57962e03702d$var$DataTable.type(typeName, {
        detect: function(d) {
            var dt = $420c57962e03702d$var$__mldObj(d, format, locale);
            return d === "" || dt ? typeName : false;
        },
        order: {
            pre: function(d) {
                return $420c57962e03702d$var$__mldObj(d, format, locale) || 0;
            }
        },
        className: "dt-right"
    });
};
/**
 * Helpers for `columns.render`.
 *
 * The options defined here can be used with the `columns.render` initialisation
 * option to provide a display renderer. The following functions are defined:
 *
 * * `moment` - Uses the MomentJS library to convert from a given format into another.
 * This renderer has three overloads:
 *   * 1 parameter:
 *     * `string` - Format to convert to (assumes input is ISO8601 and locale is `en`)
 *   * 2 parameters:
 *     * `string` - Format to convert from
 *     * `string` - Format to convert to. Assumes `en` locale
 *   * 3 parameters:
 *     * `string` - Format to convert from
 *     * `string` - Format to convert to
 *     * `string` - Locale
 * * `number` - Will format numeric data (defined by `columns.data`) for
 *   display, retaining the original unformatted data for sorting and filtering.
 *   It takes 5 parameters:
 *   * `string` - Thousands grouping separator
 *   * `string` - Decimal point indicator
 *   * `integer` - Number of decimal points to show
 *   * `string` (optional) - Prefix.
 *   * `string` (optional) - Postfix (/suffix).
 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
 *   parameters.
 *
 * @example
 *   // Column definition using the number renderer
 *   {
 *     data: "salary",
 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
 *   }
 *
 * @namespace
 */ $420c57962e03702d$var$DataTable.render = {
    date: $420c57962e03702d$var$__mlHelper("toLocaleDateString"),
    datetime: $420c57962e03702d$var$__mlHelper("toLocaleString"),
    time: $420c57962e03702d$var$__mlHelper("toLocaleTimeString"),
    number: function(thousands, decimal, precision, prefix, postfix) {
        // Auto locale detection
        if (thousands === null || thousands === undefined) thousands = $420c57962e03702d$var$__thousands;
        if (decimal === null || decimal === undefined) decimal = $420c57962e03702d$var$__decimal;
        return {
            display: function(d) {
                if (typeof d !== "number" && typeof d !== "string") return d;
                if (d === "" || d === null) return d;
                var negative = d < 0 ? "-" : "";
                var flo = parseFloat(d);
                var abs = Math.abs(flo);
                // Scientific notation for large and small numbers
                if (abs >= 100000000000 || abs < 0.0001 && abs !== 0) {
                    var exp = flo.toExponential(precision).split(/e\+?/);
                    return exp[0] + " x 10<sup>" + exp[1] + "</sup>";
                }
                // If NaN then there isn't much formatting that we can do - just
                // return immediately, escaping any HTML (this was supposed to
                // be a number after all)
                if (isNaN(flo)) return $420c57962e03702d$var$_escapeHtml(d);
                flo = flo.toFixed(precision);
                d = Math.abs(flo);
                var intPart = parseInt(d, 10);
                var floatPart = precision ? decimal + (d - intPart).toFixed(precision).substring(2) : "";
                // If zero, then can't have a negative prefix
                if (intPart === 0 && parseFloat(floatPart) === 0) negative = "";
                return negative + (prefix || "") + intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + floatPart + (postfix || "");
            }
        };
    },
    text: function() {
        return {
            display: $420c57962e03702d$var$_escapeHtml,
            filter: $420c57962e03702d$var$_escapeHtml
        };
    }
};
var $420c57962e03702d$var$_extTypes = $420c57962e03702d$var$DataTable.ext.type;
// Get / set type
$420c57962e03702d$var$DataTable.type = function(name, prop, val) {
    if (!prop) return {
        className: $420c57962e03702d$var$_extTypes.className[name],
        detect: $420c57962e03702d$var$_extTypes.detect.find(function(fn) {
            return fn.name === name;
        }),
        order: {
            pre: $420c57962e03702d$var$_extTypes.order[name + "-pre"],
            asc: $420c57962e03702d$var$_extTypes.order[name + "-asc"],
            desc: $420c57962e03702d$var$_extTypes.order[name + "-desc"]
        },
        render: $420c57962e03702d$var$_extTypes.render[name],
        search: $420c57962e03702d$var$_extTypes.search[name]
    };
    var setProp = function(prop, propVal) {
        $420c57962e03702d$var$_extTypes[prop][name] = propVal;
    };
    var setDetect = function(fn) {
        // Wrap to allow the function to return `true` rather than
        // specifying the type name.
        var cb = function(d, s) {
            var ret = fn(d, s);
            return ret === true ? name : ret;
        };
        Object.defineProperty(cb, "name", {
            value: name
        });
        var idx = $420c57962e03702d$var$_extTypes.detect.findIndex(function(fn) {
            return fn.name === name;
        });
        if (idx === -1) $420c57962e03702d$var$_extTypes.detect.unshift(cb);
        else $420c57962e03702d$var$_extTypes.detect.splice(idx, 1, cb);
    };
    var setOrder = function(obj) {
        $420c57962e03702d$var$_extTypes.order[name + "-pre"] = obj.pre; // can be undefined
        $420c57962e03702d$var$_extTypes.order[name + "-asc"] = obj.asc; // can be undefined
        $420c57962e03702d$var$_extTypes.order[name + "-desc"] = obj.desc; // can be undefined
    };
    // prop is optional
    if (val === undefined) {
        val = prop;
        prop = null;
    }
    if (prop === "className") setProp("className", val);
    else if (prop === "detect") setDetect(val);
    else if (prop === "order") setOrder(val);
    else if (prop === "render") setProp("render", val);
    else if (prop === "search") setProp("search", val);
    else if (!prop) {
        if (val.className) setProp("className", val.className);
        if (val.detect !== undefined) setDetect(val.detect);
        if (val.order) setOrder(val.order);
        if (val.render !== undefined) setProp("render", val.render);
        if (val.search !== undefined) setProp("search", val.search);
    }
};
// Get a list of types
$420c57962e03702d$var$DataTable.types = function() {
    return $420c57962e03702d$var$_extTypes.detect.map(function(fn) {
        return fn.name;
    });
};
//
// Built in data types
//
$420c57962e03702d$var$DataTable.type("string", {
    detect: function() {
        return "string";
    },
    order: {
        pre: function(a) {
            // This is a little complex, but faster than always calling toString,
            // http://jsperf.com/tostring-v-check
            return $420c57962e03702d$var$_empty(a) ? "" : typeof a === "string" ? a.toLowerCase() : !a.toString ? "" : a.toString();
        }
    },
    search: $420c57962e03702d$var$_filterString(false, true)
});
$420c57962e03702d$var$DataTable.type("html", {
    detect: function(d) {
        return $420c57962e03702d$var$_empty(d) || typeof d === "string" && d.indexOf("<") !== -1 ? "html" : null;
    },
    order: {
        pre: function(a) {
            return $420c57962e03702d$var$_empty(a) ? "" : a.replace ? $420c57962e03702d$var$_stripHtml(a).trim().toLowerCase() : a + "";
        }
    },
    search: $420c57962e03702d$var$_filterString(true, true)
});
$420c57962e03702d$var$DataTable.type("date", {
    className: "dt-type-date",
    detect: function(d) {
        // V8 tries _very_ hard to make a string passed into `Date.parse()`
        // valid, so we need to use a regex to restrict date formats. Use a
        // plug-in for anything other than ISO8601 style strings
        if (d && !(d instanceof Date) && !$420c57962e03702d$var$_re_date.test(d)) return null;
        var parsed = Date.parse(d);
        return parsed !== null && !isNaN(parsed) || $420c57962e03702d$var$_empty(d) ? "date" : null;
    },
    order: {
        pre: function(d) {
            var ts = Date.parse(d);
            return isNaN(ts) ? -Infinity : ts;
        }
    }
});
$420c57962e03702d$var$DataTable.type("html-num-fmt", {
    className: "dt-type-numeric",
    detect: function(d, settings) {
        var decimal = settings.oLanguage.sDecimal;
        return $420c57962e03702d$var$_htmlNumeric(d, decimal, true) ? "html-num-fmt" : null;
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $420c57962e03702d$var$__numericReplace(d, dp, $420c57962e03702d$var$_re_html, $420c57962e03702d$var$_re_formatted_numeric);
        }
    },
    search: $420c57962e03702d$var$_filterString(true, true)
});
$420c57962e03702d$var$DataTable.type("html-num", {
    className: "dt-type-numeric",
    detect: function(d, settings) {
        var decimal = settings.oLanguage.sDecimal;
        return $420c57962e03702d$var$_htmlNumeric(d, decimal) ? "html-num" : null;
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $420c57962e03702d$var$__numericReplace(d, dp, $420c57962e03702d$var$_re_html);
        }
    },
    search: $420c57962e03702d$var$_filterString(true, true)
});
$420c57962e03702d$var$DataTable.type("num-fmt", {
    className: "dt-type-numeric",
    detect: function(d, settings) {
        var decimal = settings.oLanguage.sDecimal;
        return $420c57962e03702d$var$_isNumber(d, decimal, true) ? "num-fmt" : null;
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $420c57962e03702d$var$__numericReplace(d, dp, $420c57962e03702d$var$_re_formatted_numeric);
        }
    }
});
$420c57962e03702d$var$DataTable.type("num", {
    className: "dt-type-numeric",
    detect: function(d, settings) {
        var decimal = settings.oLanguage.sDecimal;
        return $420c57962e03702d$var$_isNumber(d, decimal) ? "num" : null;
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $420c57962e03702d$var$__numericReplace(d, dp);
        }
    }
});
var $420c57962e03702d$var$__numericReplace = function(d, decimalPlace, re1, re2) {
    if (d !== 0 && (!d || d === "-")) return -Infinity;
    var type = typeof d;
    if (type === "number" || type === "bigint") return d;
    // If a decimal place other than `.` is used, it needs to be given to the
    // function so we can detect it and replace with a `.` which is the only
    // decimal place Javascript recognises - it is not locale aware.
    if (decimalPlace) d = $420c57962e03702d$var$_numToDecimal(d, decimalPlace);
    if (d.replace) {
        if (re1) d = d.replace(re1, "");
        if (re2) d = d.replace(re2, "");
    }
    return d * 1;
};
$420c57962e03702d$var$$.extend(true, $420c57962e03702d$var$DataTable.ext.renderer, {
    footer: {
        _: function(settings, cell, classes) {
            cell.addClass(classes.tfoot.cell);
        }
    },
    header: {
        _: function(settings, cell, classes) {
            cell.addClass(classes.thead.cell);
            if (!settings.oFeatures.bSort) cell.addClass(classes.order.none);
            var legacyTop = settings.bSortCellsTop;
            var headerRows = cell.closest("thead").find("tr");
            var rowIdx = cell.parent().index();
            // Conditions to not apply the ordering icons
            if (// Cells and rows which have the attribute to disable the icons
            cell.attr("data-dt-order") === "disable" || cell.parent().attr("data-dt-order") === "disable" || // Legacy support for `orderCellsTop`. If it is set, then cells
            // which are not in the top or bottom row of the header (depending
            // on the value) do not get the sorting classes applied to them
            legacyTop === true && rowIdx !== 0 || legacyTop === false && rowIdx !== headerRows.length - 1) return;
            // No additional mark-up required
            // Attach a sort listener to update on sort - note that using the
            // `DT` namespace will allow the event to be removed automatically
            // on destroy, while the `dt` namespaced event is the one we are
            // listening for
            $420c57962e03702d$var$$(settings.nTable).on("order.dt.DT", function(e, ctx, sorting) {
                if (settings !== ctx) return; // table, not a nested one
                var orderClasses = classes.order;
                var columns = ctx.api.columns(cell);
                var col = settings.aoColumns[columns.flatten()[0]];
                var orderable = columns.orderable().includes(true);
                var ariaType = "";
                var indexes = columns.indexes();
                var sortDirs = columns.orderable(true).flatten();
                var orderedColumns = "," + sorting.map(function(val) {
                    return val.col;
                }).join(",") + ",";
                cell.removeClass(orderClasses.isAsc + " " + orderClasses.isDesc).toggleClass(orderClasses.none, !orderable).toggleClass(orderClasses.canAsc, orderable && sortDirs.includes("asc")).toggleClass(orderClasses.canDesc, orderable && sortDirs.includes("desc"));
                var sortIdx = orderedColumns.indexOf("," + indexes.toArray().join(",") + ",");
                if (sortIdx !== -1) {
                    // Get the ordering direction for the columns under this cell
                    // Note that it is possible for a cell to be asc and desc sorting
                    // (column spanning cells)
                    var orderDirs = columns.order();
                    cell.addClass(orderDirs.includes("asc") ? orderClasses.isAsc : "" + orderDirs.includes("desc") ? orderClasses.isDesc : "");
                }
                // The ARIA spec says that only one column should be marked with aria-sort
                if (sortIdx === 0) {
                    var firstSort = sorting[0];
                    var sortOrder = col.asSorting;
                    cell.attr("aria-sort", firstSort.dir === "asc" ? "ascending" : "descending");
                    // Determine if the next click will remove sorting or change the sort
                    ariaType = !sortOrder[firstSort.index + 1] ? "Remove" : "Reverse";
                } else cell.removeAttr("aria-sort");
                cell.attr("aria-label", orderable ? col.ariaTitle + ctx.api.i18n("oAria.orderable" + ariaType) : col.ariaTitle);
                if (orderable) {
                    cell.find(".dt-column-title").attr("role", "button");
                    cell.attr("tabindex", 0);
                }
            });
        }
    },
    layout: {
        _: function(settings, container, items) {
            var row = $420c57962e03702d$var$$("<div/>").addClass("dt-layout-row").appendTo(container);
            $420c57962e03702d$var$$.each(items, function(key, val) {
                var klass = !val.table ? "dt-" + key + " " : "";
                if (val.table) row.addClass("dt-layout-table");
                $420c57962e03702d$var$$("<div/>").attr({
                    id: val.id || null,
                    "class": "dt-layout-cell " + klass + (val.className || "")
                }).append(val.contents).appendTo(row);
            });
        }
    }
});
$420c57962e03702d$var$DataTable.feature = {};
// Third parameter is internal only!
$420c57962e03702d$var$DataTable.feature.register = function(name, cb, legacy) {
    $420c57962e03702d$var$DataTable.ext.features[name] = cb;
    if (legacy) $420c57962e03702d$var$_ext.feature.push({
        cFeature: legacy,
        fnInit: cb
    });
};
$420c57962e03702d$var$DataTable.feature.register("info", function(settings, opts) {
    // For compatibility with the legacy `info` top level option
    if (!settings.oFeatures.bInfo) return null;
    var lang = settings.oLanguage, tid = settings.sTableId, n = $420c57962e03702d$var$$("<div/>", {
        "class": settings.oClasses.info.container
    });
    opts = $420c57962e03702d$var$$.extend({
        callback: lang.fnInfoCallback,
        empty: lang.sInfoEmpty,
        postfix: lang.sInfoPostFix,
        search: lang.sInfoFiltered,
        text: lang.sInfo
    }, opts);
    // Update display on each draw
    settings.aoDrawCallback.push(function(s) {
        $420c57962e03702d$var$_fnUpdateInfo(s, opts, n);
    });
    // For the first info display in the table, we add a callback and aria information.
    if (!settings._infoEl) {
        n.attr({
            "aria-live": "polite",
            id: tid + "_info",
            role: "status"
        });
        // Table is described by our info div
        $420c57962e03702d$var$$(settings.nTable).attr("aria-describedby", tid + "_info");
        settings._infoEl = n;
    }
    return n;
}, "i");
/**
 * Update the information elements in the display
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $420c57962e03702d$var$_fnUpdateInfo(settings, opts, node) {
    var start = settings._iDisplayStart + 1, end = settings.fnDisplayEnd(), max = settings.fnRecordsTotal(), total = settings.fnRecordsDisplay(), out = total ? opts.text : opts.empty;
    if (total !== max) // Record set after filtering
    out += " " + opts.search;
    // Convert the macros
    out += opts.postfix;
    out = $420c57962e03702d$var$_fnMacros(settings, out);
    if (opts.callback) out = opts.callback.call(settings.oInstance, settings, start, end, max, total, out);
    node.html(out);
    $420c57962e03702d$var$_fnCallbackFire(settings, null, "info", [
        settings,
        node[0],
        out
    ]);
}
var $420c57962e03702d$var$__searchCounter = 0;
// opts
// - text
// - placeholder
$420c57962e03702d$var$DataTable.feature.register("search", function(settings, opts) {
    // Don't show the input if filtering isn't available on the table
    if (!settings.oFeatures.bFilter) return null;
    var classes = settings.oClasses.search;
    var tableId = settings.sTableId;
    var language = settings.oLanguage;
    var previousSearch = settings.oPreviousSearch;
    var input = '<input type="search" class="' + classes.input + '"/>';
    opts = $420c57962e03702d$var$$.extend({
        placeholder: language.sSearchPlaceholder,
        text: language.sSearch
    }, opts);
    // The _INPUT_ is optional - is appended if not present
    if (opts.text.indexOf("_INPUT_") === -1) opts.text += "_INPUT_";
    opts.text = $420c57962e03702d$var$_fnMacros(settings, opts.text);
    // We can put the <input> outside of the label if it is at the start or end
    // which helps improve accessability (not all screen readers like implicit
    // for elements).
    var end = opts.text.match(/_INPUT_$/);
    var start = opts.text.match(/^_INPUT_/);
    var removed = opts.text.replace(/_INPUT_/, "");
    var str = "<label>" + opts.text + "</label>";
    if (start) str = "_INPUT_<label>" + removed + "</label>";
    else if (end) str = "<label>" + removed + "</label>_INPUT_";
    var filter = $420c57962e03702d$var$$("<div>").addClass(classes.container).append(str.replace(/_INPUT_/, input));
    // add for and id to label and input
    filter.find("label").attr("for", "dt-search-" + $420c57962e03702d$var$__searchCounter);
    filter.find("input").attr("id", "dt-search-" + $420c57962e03702d$var$__searchCounter);
    $420c57962e03702d$var$__searchCounter++;
    var searchFn = function(event) {
        var val = this.value;
        if (previousSearch.return && event.key !== "Enter") return;
        /* Now do the filter */ if (val != previousSearch.search) {
            previousSearch.search = val;
            $420c57962e03702d$var$_fnFilterComplete(settings, previousSearch);
            // Need to redraw, without resorting
            settings._iDisplayStart = 0;
            $420c57962e03702d$var$_fnDraw(settings);
        }
    };
    var searchDelay = settings.searchDelay !== null ? settings.searchDelay : 0;
    var jqFilter = $420c57962e03702d$var$$("input", filter).val(previousSearch.search).attr("placeholder", opts.placeholder).on("keyup.DT search.DT input.DT paste.DT cut.DT", searchDelay ? $420c57962e03702d$var$DataTable.util.debounce(searchFn, searchDelay) : searchFn).on("mouseup.DT", function(e) {
        // Edge fix! Edge 17 does not trigger anything other than mouse events when clicking
        // on the clear icon (Edge bug 17584515). This is safe in other browsers as `searchFn`
        // checks the value to see if it has changed. In other browsers it won't have.
        setTimeout(function() {
            searchFn.call(jqFilter[0], e);
        }, 10);
    }).on("keypress.DT", function(e) {
        /* Prevent form submission */ if (e.keyCode == 13) return false;
    }).attr("aria-controls", tableId);
    // Update the input elements whenever the table is filtered
    $420c57962e03702d$var$$(settings.nTable).on("search.dt.DT", function(ev, s) {
        if (settings === s && jqFilter[0] !== document.activeElement) jqFilter.val(typeof previousSearch.search !== "function" ? previousSearch.search : "");
    });
    return filter;
}, "f");
// opts
// - type - button configuration
// - buttons - number of buttons to show - must be odd
$420c57962e03702d$var$DataTable.feature.register("paging", function(settings, opts) {
    // Don't show the paging input if the table doesn't have paging enabled
    if (!settings.oFeatures.bPaginate) return null;
    opts = $420c57962e03702d$var$$.extend({
        buttons: $420c57962e03702d$var$DataTable.ext.pager.numbers_length,
        type: settings.sPaginationType,
        boundaryNumbers: true
    }, opts);
    // To be removed in 2.1
    if (opts.numbers) opts.buttons = opts.numbers;
    var host = $420c57962e03702d$var$$("<div/>").addClass(settings.oClasses.paging.container + " paging_" + opts.type);
    var draw = function() {
        $420c57962e03702d$var$_pagingDraw(settings, host, opts);
    };
    settings.aoDrawCallback.push(draw);
    // Responsive redraw of paging control
    $420c57962e03702d$var$$(settings.nTable).on("column-sizing.dt.DT", draw);
    return host;
}, "p");
function $420c57962e03702d$var$_pagingDraw(settings, host, opts) {
    if (!settings._bInitComplete) return;
    var plugin = $420c57962e03702d$var$DataTable.ext.pager[opts.type], aria = settings.oLanguage.oAria.paginate || {}, start = settings._iDisplayStart, len = settings._iDisplayLength, visRecords = settings.fnRecordsDisplay(), all = len === -1, page = all ? 0 : Math.ceil(start / len), pages = all ? 1 : Math.ceil(visRecords / len), buttons = plugin().map(function(val) {
        return val === "numbers" ? $420c57962e03702d$var$_pagingNumbers(page, pages, opts.buttons, opts.boundaryNumbers) : val;
    }).flat();
    var buttonEls = [];
    for(var i = 0; i < buttons.length; i++){
        var button = buttons[i];
        var btnInfo = $420c57962e03702d$var$_pagingButtonInfo(settings, button, page, pages);
        var btn = $420c57962e03702d$var$_fnRenderer(settings, "pagingButton")(settings, button, btnInfo.display, btnInfo.active, btnInfo.disabled);
        // Common attributes
        $420c57962e03702d$var$$(btn.clicker).attr({
            "aria-controls": settings.sTableId,
            "aria-disabled": btnInfo.disabled ? "true" : null,
            "aria-current": btnInfo.active ? "page" : null,
            "aria-label": aria[button],
            "data-dt-idx": button,
            "tabIndex": btnInfo.disabled ? -1 : settings.iTabIndex
        });
        if (typeof button !== "number") $420c57962e03702d$var$$(btn.clicker).addClass(button);
        $420c57962e03702d$var$_fnBindAction(btn.clicker, {
            action: button
        }, function(e) {
            e.preventDefault();
            $420c57962e03702d$var$_fnPageChange(settings, e.data.action, true);
        });
        buttonEls.push(btn.display);
    }
    var wrapped = $420c57962e03702d$var$_fnRenderer(settings, "pagingContainer")(settings, buttonEls);
    var activeEl = host.find(document.activeElement).data("dt-idx");
    host.empty().append(wrapped);
    if (activeEl !== undefined) host.find("[data-dt-idx=" + activeEl + "]").trigger("focus");
    // Responsive - check if the buttons are over two lines based on the
    // height of the buttons and the container.
    if (buttonEls.length && // any buttons
    opts.numbers > 1 && // prevent infinite
    $420c57962e03702d$var$$(host).height() >= $420c57962e03702d$var$$(buttonEls[0]).outerHeight() * 2 - 10) $420c57962e03702d$var$_pagingDraw(settings, host, $420c57962e03702d$var$$.extend({}, opts, {
        numbers: opts.numbers - 2
    }));
}
/**
 * Get properties for a button based on the current paging state of the table
 *
 * @param {*} settings DT settings object
 * @param {*} button The button type in question
 * @param {*} page Table's current page
 * @param {*} pages Number of pages
 * @returns Info object
 */ function $420c57962e03702d$var$_pagingButtonInfo(settings, button, page, pages) {
    var lang = settings.oLanguage.oPaginate;
    var o = {
        display: "",
        active: false,
        disabled: false
    };
    switch(button){
        case "ellipsis":
            o.display = "&#x2026;";
            o.disabled = true;
            break;
        case "first":
            o.display = lang.sFirst;
            if (page === 0) o.disabled = true;
            break;
        case "previous":
            o.display = lang.sPrevious;
            if (page === 0) o.disabled = true;
            break;
        case "next":
            o.display = lang.sNext;
            if (pages === 0 || page === pages - 1) o.disabled = true;
            break;
        case "last":
            o.display = lang.sLast;
            if (pages === 0 || page === pages - 1) o.disabled = true;
            break;
        default:
            if (typeof button === "number") {
                o.display = settings.fnFormatNumber(button + 1);
                if (page === button) o.active = true;
            }
            break;
    }
    return o;
}
/**
 * Compute what number buttons to show in the paging control
 *
 * @param {*} page Current page
 * @param {*} pages Total number of pages
 * @param {*} buttons Target number of number buttons
 * @param {boolean} addFirstLast Indicate if page 1 and end should be included
 * @returns Buttons to show
 */ function $420c57962e03702d$var$_pagingNumbers(page, pages, buttons, addFirstLast) {
    var numbers = [], half = Math.floor(buttons / 2), before = addFirstLast ? 2 : 1, after = addFirstLast ? 1 : 0;
    if (pages <= buttons) numbers = $420c57962e03702d$var$_range(0, pages);
    else if (buttons === 1) // Single button - current page only
    numbers = [
        page
    ];
    else if (buttons === 3) {
        // Special logic for just three buttons
        if (page <= 1) numbers = [
            0,
            1,
            "ellipsis"
        ];
        else if (page >= pages - 2) {
            numbers = $420c57962e03702d$var$_range(pages - 2, pages);
            numbers.unshift("ellipsis");
        } else numbers = [
            "ellipsis",
            page,
            "ellipsis"
        ];
    } else if (page <= half) {
        numbers = $420c57962e03702d$var$_range(0, buttons - before);
        numbers.push("ellipsis");
        if (addFirstLast) numbers.push(pages - 1);
    } else if (page >= pages - 1 - half) {
        numbers = $420c57962e03702d$var$_range(pages - (buttons - before), pages);
        numbers.unshift("ellipsis");
        if (addFirstLast) numbers.unshift(0);
    } else {
        numbers = $420c57962e03702d$var$_range(page - half + before, page + half - after);
        numbers.push("ellipsis");
        numbers.unshift("ellipsis");
        if (addFirstLast) {
            numbers.push(pages - 1);
            numbers.unshift(0);
        }
    }
    return numbers;
}
var $420c57962e03702d$var$__lengthCounter = 0;
// opts
// - menu
// - text
$420c57962e03702d$var$DataTable.feature.register("pageLength", function(settings, opts) {
    var features = settings.oFeatures;
    // For compatibility with the legacy `pageLength` top level option
    if (!features.bPaginate || !features.bLengthChange) return null;
    opts = $420c57962e03702d$var$$.extend({
        menu: settings.aLengthMenu,
        text: settings.oLanguage.sLengthMenu
    }, opts);
    var classes = settings.oClasses.length, tableId = settings.sTableId, menu = opts.menu, lengths = [], language = [], i;
    // Options can be given in a number of ways
    if (Array.isArray(menu[0])) {
        // Old 1.x style - 2D array
        lengths = menu[0];
        language = menu[1];
    } else {
        for(i = 0; i < menu.length; i++)// An object with different label and value
        if ($420c57962e03702d$var$$.isPlainObject(menu[i])) {
            lengths.push(menu[i].value);
            language.push(menu[i].label);
        } else {
            // Or just a number to display and use
            lengths.push(menu[i]);
            language.push(menu[i]);
        }
    }
    // We can put the <select> outside of the label if it is at the start or
    // end which helps improve accessability (not all screen readers like
    // implicit for elements).
    var end = opts.text.match(/_MENU_$/);
    var start = opts.text.match(/^_MENU_/);
    var removed = opts.text.replace(/_MENU_/, "");
    var str = "<label>" + opts.text + "</label>";
    if (start) str = "_MENU_<label>" + removed + "</label>";
    else if (end) str = "<label>" + removed + "</label>_MENU_";
    // Wrapper element - use a span as a holder for where the select will go
    var div = $420c57962e03702d$var$$("<div/>").addClass(classes.container).append(str.replace("_MENU_", "<span></span>"));
    // Save text node content for macro updating
    var textNodes = [];
    div.find("label")[0].childNodes.forEach(function(el) {
        if (el.nodeType === Node.TEXT_NODE) textNodes.push({
            el: el,
            text: el.textContent
        });
    });
    // Update the label text in case it has an entries value
    var updateEntries = function(len) {
        textNodes.forEach(function(node) {
            node.el.textContent = $420c57962e03702d$var$_fnMacros(settings, node.text, len);
        });
    };
    // Next, the select itself, along with the options
    var select = $420c57962e03702d$var$$("<select/>", {
        "name": tableId + "_length",
        "aria-controls": tableId,
        "class": classes.select
    });
    for(i = 0; i < lengths.length; i++)select[0][i] = new Option(typeof language[i] === "number" ? settings.fnFormatNumber(language[i]) : language[i], lengths[i]);
    // add for and id to label and input
    div.find("label").attr("for", "dt-length-" + $420c57962e03702d$var$__lengthCounter);
    select.attr("id", "dt-length-" + $420c57962e03702d$var$__lengthCounter);
    $420c57962e03702d$var$__lengthCounter++;
    // Swap in the select list
    div.find("span").replaceWith(select);
    // Can't use `select` variable as user might provide their own and the
    // reference is broken by the use of outerHTML
    $420c57962e03702d$var$$("select", div).val(settings._iDisplayLength).on("change.DT", function() {
        $420c57962e03702d$var$_fnLengthChange(settings, $420c57962e03702d$var$$(this).val());
        $420c57962e03702d$var$_fnDraw(settings);
    });
    // Update node value whenever anything changes the table's length
    $420c57962e03702d$var$$(settings.nTable).on("length.dt.DT", function(e, s, len) {
        if (settings === s) {
            $420c57962e03702d$var$$("select", div).val(len);
            // Resolve plurals in the text for the new length
            updateEntries(len);
        }
    });
    updateEntries(settings._iDisplayLength);
    return div;
}, "l");
// jQuery access
$420c57962e03702d$var$$.fn.dataTable = $420c57962e03702d$var$DataTable;
// Provide access to the host jQuery object (circular reference)
$420c57962e03702d$var$DataTable.$ = $420c57962e03702d$var$$;
// Legacy aliases
$420c57962e03702d$var$$.fn.dataTableSettings = $420c57962e03702d$var$DataTable.settings;
$420c57962e03702d$var$$.fn.dataTableExt = $420c57962e03702d$var$DataTable.ext;
// With a capital `D` we return a DataTables API instance rather than a
// jQuery object
$420c57962e03702d$var$$.fn.DataTable = function(opts) {
    return $420c57962e03702d$var$$(this).dataTable(opts).api();
};
// All properties that are available to $.fn.dataTable should also be
// available on $.fn.DataTable
$420c57962e03702d$var$$.each($420c57962e03702d$var$DataTable, function(prop, val) {
    $420c57962e03702d$var$$.fn.DataTable[prop] = val;
});
var $420c57962e03702d$export$2e2bcd8739ae039 = $420c57962e03702d$var$DataTable;

});
parcelRegister("6KOho", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});


parcelRegister("4mWlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e67a4d3559554a$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Tile
 */ 
var $cGqMj = parcelRequire("cGqMj");

var $fY4eB = parcelRequire("fY4eB");
/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ class $32e67a4d3559554a$var$TileLayer extends (0, $cGqMj.default) {
    /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        super(options);
    }
    createRenderer() {
        return new (0, $fY4eB.default)(this);
    }
}
var $32e67a4d3559554a$export$2e2bcd8739ae039 = $32e67a4d3559554a$var$TileLayer;

});
parcelRegister("cGqMj", function(module, exports) {

$parcel$export(module.exports, "default", () => $93be2de6a052f587$export$2e2bcd8739ae039);
/**
 * @module ol/layer/BaseTile
 */ 
var $79s7T = parcelRequire("79s7T");

var $jDKXi = parcelRequire("jDKXi");
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *   import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {boolean} [useInterimTilesOnError=true] Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ class $93be2de6a052f587$var$BaseTileLayer extends (0, $79s7T.default) {
    /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseTileLayerOnSignature<void>}
     */ this.un;
        this.setPreload(options.preload !== undefined ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, $jDKXi.default).PRELOAD);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, $jDKXi.default).PRELOAD, preload);
    }
    /**
   * Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $jDKXi.default).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $jDKXi.default).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
    /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $93be2de6a052f587$export$2e2bcd8739ae039 = $93be2de6a052f587$var$BaseTileLayer;

});
parcelRegister("79s7T", function(module, exports) {

$parcel$export(module.exports, "inView", () => $534f30fce11effcd$export$acb1e9cb9ce4ca56);
$parcel$export(module.exports, "default", () => $534f30fce11effcd$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Layer
 */ 
var $7xdj9 = parcelRequire("7xdj9");

var $3xzSb = parcelRequire("3xzSb");

var $lbO8S = parcelRequire("lbO8S");

var $l6YBe = parcelRequire("l6YBe");

var $9DiKA = parcelRequire("9DiKA");

var $4Cz58 = parcelRequire("4Cz58");

var $9pD6L = parcelRequire("9pD6L");

var $ilM9F = parcelRequire("ilM9F");
/**
 * @typedef {function(import("../Map.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {'sourceready'|'change:source'} LayerEventType
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     LayerEventType, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|LayerEventType|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../Map.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number | undefined} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * Components like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * [layer.setMap()]{@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 * A `sourceready` event is fired when the layer's source is ready.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @fires import("../events/Event.js").BaseEvent#sourceready
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @api
 */ class $534f30fce11effcd$var$Layer extends (0, $7xdj9.default) {
    /**
   * @param {Options<SourceType>} options Layer options.
   */ constructor(options){
        const baseOptions = Object.assign({}, options);
        delete baseOptions.source;
        super(baseOptions);
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {LayerOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceChangeKey_ = null;
        /**
     * @private
     * @type {RendererType}
     */ this.renderer_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.sourceReady_ = false;
        /**
     * @protected
     * @type {boolean}
     */ this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) this.render = options.render;
        if (options.map) this.setMap(options.map);
        this.addChangeListener((0, $lbO8S.default).SOURCE, this.handleSourcePropertyChange_);
        const source = options.source ? /** @type {SourceType} */ options.source : null;
        this.setSource(source);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        array = array ? array : [];
        array.push(this);
        return array;
    }
    /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        states = states ? states : [];
        states.push(this.getLayerState());
        return states;
    }
    /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ getSource() {
        return /** @type {SourceType} */ this.get((0, $lbO8S.default).SOURCE) || null;
    }
    /**
   * @return {SourceType|null} The source being rendered.
   */ getRenderSource() {
        return this.getSource();
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        const source = this.getSource();
        return !source ? "undefined" : source.getState();
    }
    /**
   * @private
   */ handleSourceChange_() {
        this.changed();
        if (this.sourceReady_ || this.getSource().getState() !== "ready") return;
        this.sourceReady_ = true;
        this.dispatchEvent("sourceready");
    }
    /**
   * @private
   */ handleSourcePropertyChange_() {
        if (this.sourceChangeKey_) {
            (0, $ilM9F.unlistenByKey)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        this.sourceReady_ = false;
        const source = this.getSource();
        if (source) {
            this.sourceChangeKey_ = (0, $ilM9F.listen)(source, (0, $3xzSb.default).CHANGE, this.handleSourceChange_, this);
            if (source.getState() === "ready") {
                this.sourceReady_ = true;
                setTimeout(()=>{
                    this.dispatchEvent("sourceready");
                }, 0);
            }
        }
        this.changed();
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        if (!this.renderer_) return Promise.resolve([]);
        return this.renderer_.getFeatures(pixel);
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        if (!this.renderer_ || !this.rendered) return null;
        return this.renderer_.getData(pixel);
    }
    /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */ isVisible(view) {
        let frameState;
        const map = this.getMapInternal();
        if (!view && map) view = map.getView();
        if (view instanceof (0, $9DiKA.default)) frameState = {
            viewState: view.getState(),
            extent: view.calculateExtent()
        };
        else frameState = view;
        if (!frameState.layerStatesArray && map) frameState.layerStatesArray = map.getLayerGroup().getLayerStatesArray();
        let layerState;
        if (frameState.layerStatesArray) layerState = frameState.layerStatesArray.find((layerState)=>layerState.layer === this);
        else layerState = this.getLayerState();
        const layerExtent = this.getExtent();
        return $534f30fce11effcd$export$acb1e9cb9ce4ca56(layerState, frameState.viewState) && (!layerExtent || (0, $9pD6L.intersects)(layerExtent, frameState.extent));
    }
    /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */ getAttributions(view) {
        if (!this.isVisible(view)) return [];
        let getAttributions;
        const source = this.getSource();
        if (source) getAttributions = source.getAttributions();
        if (!getAttributions) return [];
        const frameState = view instanceof (0, $9DiKA.default) ? view.getViewStateAndExtent() : view;
        let attributions = getAttributions(frameState);
        if (!Array.isArray(attributions)) attributions = [
            attributions
        ];
        return attributions;
    }
    /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */ render(frameState, target) {
        const layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            this.rendered = true;
            return layerRenderer.renderFrame(frameState, target);
        }
        return null;
    }
    /**
   * Called when a layer is not visible during a map render.
   */ unrender() {
        this.rendered = false;
    }
    /** @return {string} Declutter */ getDeclutter() {
        return undefined;
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {}
    /**
   * When the renderer follows a layout -> render approach, do the final rendering here.
   * @param {import('../Map.js').FrameState} frameState Frame state
   */ renderDeferred(frameState) {
        const layerRenderer = this.getRenderer();
        if (!layerRenderer) return;
        layerRenderer.renderDeferred(frameState);
    }
    /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */ setMapInternal(map) {
        if (!map) this.unrender();
        this.set((0, $lbO8S.default).MAP, map);
    }
    /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */ getMapInternal() {
        return this.get((0, $lbO8S.default).MAP);
    }
    /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.mapPrecomposeKey_) {
            (0, $ilM9F.unlistenByKey)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $ilM9F.unlistenByKey)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $ilM9F.listen)(map, (0, $l6YBe.default).PRECOMPOSE, function(evt) {
                const renderEvent = /** @type {import("../render/Event.js").default} */ evt;
                const layerStatesArray = renderEvent.frameState.layerStatesArray;
                const layerState = this.getLayerState(false);
                (0, $4Cz58.assert)(!layerStatesArray.some(function(arrayLayerState) {
                    return arrayLayerState.layer === layerState.layer;
                }), "A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.");
                layerStatesArray.push(layerState);
            }, this);
            this.mapRenderKey_ = (0, $ilM9F.listen)(this, (0, $3xzSb.default).CHANGE, map.render, map);
            this.changed();
        }
    }
    /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */ setSource(source) {
        this.set((0, $lbO8S.default).SOURCE, source);
    }
    /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */ getRenderer() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    }
    /**
   * @return {boolean} The layer has a renderer.
   */ hasRenderer() {
        return !!this.renderer_;
    }
    /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */ createRenderer() {
        return null;
    }
    /**
   * Clean up.
   */ disposeInternal() {
        if (this.renderer_) {
            this.renderer_.dispose();
            delete this.renderer_;
        }
        this.setSource(null);
        super.disposeInternal();
    }
}
function $534f30fce11effcd$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    const resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    const zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $534f30fce11effcd$export$2e2bcd8739ae039 = $534f30fce11effcd$var$Layer;

});
parcelRegister("7xdj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $57c5f0299cb9b82f$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Base
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $lbO8S = parcelRequire("lbO8S");

var $9iPUS = parcelRequire("9iPUS");

var $4Cz58 = parcelRequire("4Cz58");

var $9byFX = parcelRequire("9byFX");
/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number | undefined} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */ class $57c5f0299cb9b82f$var$BaseLayer extends (0, $fFFY7.default) {
    /**
   * @param {Options} options Layer options.
   */ constructor(options){
        super();
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {BackgroundColor|false}
     * @private
     */ this.background_ = options.background;
        /**
     * @type {Object<string, *>}
     */ const properties = Object.assign({}, options);
        if (typeof options.properties === "object") {
            delete properties.properties;
            Object.assign(properties, options.properties);
        }
        properties[(0, $lbO8S.default).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $4Cz58.assert)(typeof properties[(0, $lbO8S.default).OPACITY] === "number", "Layer opacity must be a number");
        properties[(0, $lbO8S.default).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $lbO8S.default).Z_INDEX] = options.zIndex;
        properties[(0, $lbO8S.default).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $lbO8S.default).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $lbO8S.default).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $lbO8S.default).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
     * @type {string}
     * @private
     */ this.className_ = properties.className !== undefined ? properties.className : "ol-layer";
        delete properties.className;
        this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ this.state_ = null;
    }
    /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */ getBackground() {
        return this.background_;
    }
    /**
   * @return {string} CSS class name.
   */ getClassName() {
        return this.className_;
    }
    /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */ getLayerState(managed) {
        /** @type {import("./Layer.js").State} */ const state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: managed === undefined ? true : managed
        };
        const zIndex = this.getZIndex();
        state.opacity = (0, $9byFX.clamp)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ getExtent() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $lbO8S.default).EXTENT);
    }
    /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ getMaxResolution() {
        return /** @type {number} */ this.get((0, $lbO8S.default).MAX_RESOLUTION);
    }
    /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ getMinResolution() {
        return /** @type {number} */ this.get((0, $lbO8S.default).MIN_RESOLUTION);
    }
    /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.get((0, $lbO8S.default).MIN_ZOOM);
    }
    /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.get((0, $lbO8S.default).MAX_ZOOM);
    }
    /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ getOpacity() {
        return /** @type {number} */ this.get((0, $lbO8S.default).OPACITY);
    }
    /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */ getVisible() {
        return /** @type {boolean} */ this.get((0, $lbO8S.default).VISIBLE);
    }
    /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */ getZIndex() {
        return /** @type {number|undefined} */ this.get((0, $lbO8S.default).Z_INDEX);
    }
    /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */ setBackground(background) {
        this.background_ = background;
        this.changed();
    }
    /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ setExtent(extent) {
        this.set((0, $lbO8S.default).EXTENT, extent);
    }
    /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ setMaxResolution(maxResolution) {
        this.set((0, $lbO8S.default).MAX_RESOLUTION, maxResolution);
    }
    /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ setMinResolution(minResolution) {
        this.set((0, $lbO8S.default).MIN_RESOLUTION, minResolution);
    }
    /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */ setMaxZoom(maxZoom) {
        this.set((0, $lbO8S.default).MAX_ZOOM, maxZoom);
    }
    /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */ setMinZoom(minZoom) {
        this.set((0, $lbO8S.default).MIN_ZOOM, minZoom);
    }
    /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ setOpacity(opacity) {
        (0, $4Cz58.assert)(typeof opacity === "number", "Layer opacity must be a number");
        this.set((0, $lbO8S.default).OPACITY, opacity);
    }
    /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ setVisible(visible) {
        this.set((0, $lbO8S.default).VISIBLE, visible);
    }
    /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ setZIndex(zindex) {
        this.set((0, $lbO8S.default).Z_INDEX, zindex);
    }
    /**
   * Clean up.
   */ disposeInternal() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        super.disposeInternal();
    }
}
var $57c5f0299cb9b82f$export$2e2bcd8739ae039 = $57c5f0299cb9b82f$var$BaseLayer;

});
parcelRegister("fFFY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b68b3d6e32e3074a$export$2e2bcd8739ae039);
/**
 * @module ol/Object
 */ 
var $f18Q2 = parcelRequire("f18Q2");

var $jXCUw = parcelRequire("jXCUw");

var $2FcER = parcelRequire("2FcER");

var $9iPUS = parcelRequire("9iPUS");

var $gn0g3 = parcelRequire("gn0g3");
class $b68b3d6e32e3074a$export$cf395d7c4a2d5a17 extends (0, $f18Q2.default) {
    /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */ constructor(type, key, oldValue){
        super(type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ this.oldValue = oldValue;
    }
}
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */ class $b68b3d6e32e3074a$var$BaseObject extends (0, $2FcER.default) {
    /**
   * @param {Object<string, *>} [values] An object with key-value pairs.
   */ constructor(values){
        super();
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ObjectOnSignature<void>}
     */ this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $9iPUS.getUid)(this);
        /**
     * @private
     * @type {Object<string, *>|null}
     */ this.values_ = null;
        if (values !== undefined) this.setProperties(values);
    }
    /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ get(key) {
        let value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    }
    /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ getKeys() {
        return this.values_ && Object.keys(this.values_) || [];
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>} Object.
   * @api
   */ getProperties() {
        return this.values_ && Object.assign({}, this.values_) || {};
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.values_;
    }
    /**
   * @return {boolean} The object has properties.
   */ hasProperties() {
        return !!this.values_;
    }
    /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ notify(key, oldValue) {
        let eventType;
        eventType = `change:${key}`;
        if (this.hasListener(eventType)) this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $jXCUw.default).PROPERTYCHANGE;
        if (this.hasListener(eventType)) this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ addChangeListener(key, listener) {
        this.addEventListener(`change:${key}`, listener);
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ removeChangeListener(key, listener) {
        this.removeEventListener(`change:${key}`, listener);
    }
    /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ set(key, value, silent) {
        const values = this.values_ || (this.values_ = {});
        if (silent) values[key] = value;
        else {
            const oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    }
    /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Object<string, *>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ setProperties(values, silent) {
        for(const key in values)this.set(key, values[key], silent);
    }
    /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */ applyProperties(source) {
        if (!source.values_) return;
        Object.assign(this.values_ || (this.values_ = {}), source.values_);
    }
    /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */ unset(key, silent) {
        if (this.values_ && key in this.values_) {
            const oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, $gn0g3.isEmpty)(this.values_)) this.values_ = null;
            if (!silent) this.notify(key, oldValue);
        }
    }
}
var $b68b3d6e32e3074a$export$2e2bcd8739ae039 = $b68b3d6e32e3074a$var$BaseObject;

});
parcelRegister("f18Q2", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeedce20e9577100$export$2e2bcd8739ae039);
/**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ class $aeedce20e9577100$var$BaseEvent {
    /**
   * @param {string} type Type.
   */ constructor(type){
        /**
     * @type {boolean}
     */ this.propagationStopped;
        /**
     * @type {boolean}
     */ this.defaultPrevented;
        /**
     * The event type.
     * @type {string}
     * @api
     */ this.type = type;
        /**
     * The event target.
     * @type {Object}
     * @api
     */ this.target = null;
    }
    /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */ preventDefault() {
        this.defaultPrevented = true;
    }
    /**
   * Stop event propagation.
   * @api
   */ stopPropagation() {
        this.propagationStopped = true;
    }
}
function $aeedce20e9577100$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $aeedce20e9577100$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $aeedce20e9577100$export$2e2bcd8739ae039 = $aeedce20e9577100$var$BaseEvent;

});

parcelRegister("jXCUw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e881b5dca21eb5d4$export$2e2bcd8739ae039);
/**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $e881b5dca21eb5d4$export$2e2bcd8739ae039 /**
 * @typedef {'propertychange'} Types
 */  = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: "propertychange"
};

});

parcelRegister("2FcER", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f093ab5083c8a1f$export$2e2bcd8739ae039);
/**
 * @module ol/Observable
 */ 
var $KD0eF = parcelRequire("KD0eF");

var $3xzSb = parcelRequire("3xzSb");

var $ilM9F = parcelRequire("ilM9F");
/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ class $1f093ab5083c8a1f$var$Observable extends (0, $KD0eF.default) {
    constructor(){
        super();
        this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onInternal;
        this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onceInternal;
        this.un = /** @type {ObservableOnSignature<void>} */ this.unInternal;
        /**
     * @private
     * @type {number}
     */ this.revision_ = 0;
    }
    /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ changed() {
        ++this.revision_;
        this.dispatchEvent((0, $3xzSb.default).CHANGE);
    }
    /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ getRevision() {
        return this.revision_;
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onInternal(type, listener) {
        if (Array.isArray(type)) {
            const len = type.length;
            const keys = new Array(len);
            for(let i = 0; i < len; ++i)keys[i] = (0, $ilM9F.listen)(this, type[i], listener);
            return keys;
        }
        return (0, $ilM9F.listen)(this, /** @type {string} */ type, listener);
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onceInternal(type, listener) {
        let key;
        if (Array.isArray(type)) {
            const len = type.length;
            key = new Array(len);
            for(let i = 0; i < len; ++i)key[i] = (0, $ilM9F.listenOnce)(this, type[i], listener);
        } else key = (0, $ilM9F.listenOnce)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    }
    /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */ unInternal(type, listener) {
        const key = /** @type {Object} */ listener.ol_key;
        if (key) $1f093ab5083c8a1f$export$b7ef3f8527533384(key);
        else if (Array.isArray(type)) for(let i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    }
}
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.un;
function $1f093ab5083c8a1f$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(let i = 0, ii = key.length; i < ii; ++i)(0, $ilM9F.unlistenByKey)(key[i]);
    else (0, $ilM9F.unlistenByKey)(/** @type {import("./events.js").EventsKey} */ key);
}
var $1f093ab5083c8a1f$export$2e2bcd8739ae039 = $1f093ab5083c8a1f$var$Observable;

});
parcelRegister("KD0eF", function(module, exports) {

$parcel$export(module.exports, "default", () => $08c28d22c0cb5a39$export$2e2bcd8739ae039);
/**
 * @module ol/events/Target
 */ 
var $4kyFN = parcelRequire("4kyFN");

var $f18Q2 = parcelRequire("f18Q2");

var $6wUzV = parcelRequire("6wUzV");

var $gn0g3 = parcelRequire("gn0g3");
/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ class $08c28d22c0cb5a39$var$Target extends (0, $4kyFN.default) {
    /**
   * @param {*} [target] Default event target for dispatched events.
   */ constructor(target){
        super();
        /**
     * @private
     * @type {*}
     */ this.eventTarget_ = target;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.pendingRemovals_ = null;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.dispatching_ = null;
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>|null}
     */ this.listeners_ = null;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ addEventListener(type, listener) {
        if (!type || !listener) return;
        const listeners = this.listeners_ || (this.listeners_ = {});
        const listenersForType = listeners[type] || (listeners[type] = []);
        if (!listenersForType.includes(listener)) listenersForType.push(listener);
    }
    /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ dispatchEvent(event) {
        const isString = typeof event === "string";
        const type = isString ? event : event.type;
        const listeners = this.listeners_ && this.listeners_[type];
        if (!listeners) return;
        const evt = isString ? new (0, $f18Q2.default)(event) : /** @type {Event} */ event;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        const dispatching = this.dispatching_ || (this.dispatching_ = {});
        const pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
        if (!(type in dispatching)) {
            dispatching[type] = 0;
            pendingRemovals[type] = 0;
        }
        ++dispatching[type];
        let propagate;
        for(let i = 0, ii = listeners.length; i < ii; ++i){
            if ("handleEvent" in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
            else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
            if (propagate === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
        }
        if (--dispatching[type] === 0) {
            let pr = pendingRemovals[type];
            delete pendingRemovals[type];
            while(pr--)this.removeEventListener(type, (0, $6wUzV.VOID));
            delete dispatching[type];
        }
        return propagate;
    }
    /**
   * Clean up.
   */ disposeInternal() {
        this.listeners_ && (0, $gn0g3.clear)(this.listeners_);
    }
    /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */ getListeners(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    }
    /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ hasListener(type) {
        if (!this.listeners_) return false;
        return type ? type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ removeEventListener(type, listener) {
        if (!this.listeners_) return;
        const listeners = this.listeners_[type];
        if (!listeners) return;
        const index = listeners.indexOf(listener);
        if (index !== -1) {
            if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                // make listener a no-op, and remove later in #dispatchEvent()
                listeners[index] = (0, $6wUzV.VOID);
                ++this.pendingRemovals_[type];
            } else {
                listeners.splice(index, 1);
                if (listeners.length === 0) delete this.listeners_[type];
            }
        }
    }
}
var $08c28d22c0cb5a39$export$2e2bcd8739ae039 = $08c28d22c0cb5a39$var$Target;

});
parcelRegister("4kyFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3273ed08087da3da$export$2e2bcd8739ae039);
/**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ class $3273ed08087da3da$var$Disposable {
    constructor(){
        /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */ this.disposed = false;
    }
    /**
   * Clean up.
   */ dispose() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    }
    /**
   * Extension point for disposable objects.
   * @protected
   */ disposeInternal() {}
}
var $3273ed08087da3da$export$2e2bcd8739ae039 = $3273ed08087da3da$var$Disposable;

});

parcelRegister("6wUzV", function(module, exports) {

$parcel$export(module.exports, "TRUE", () => $013a1733c226ec50$export$22e23a2304399231);
$parcel$export(module.exports, "FALSE", () => $013a1733c226ec50$export$8f11cee4bdc7e668);
$parcel$export(module.exports, "VOID", () => $013a1733c226ec50$export$1cd1943b3a73bbe8);
$parcel$export(module.exports, "memoizeOne", () => $013a1733c226ec50$export$ff83df6f9971435f);
$parcel$export(module.exports, "toPromise", () => $013a1733c226ec50$export$4dbaaf6c79705e6c);
/**
 * @module ol/functions
 */ 
var $fVVyM = parcelRequire("fVVyM");
function $013a1733c226ec50$export$22e23a2304399231() {
    return true;
}
function $013a1733c226ec50$export$8f11cee4bdc7e668() {
    return false;
}
function $013a1733c226ec50$export$1cd1943b3a73bbe8() {}
function $013a1733c226ec50$export$ff83df6f9971435f(fn) {
    let called = false;
    /** @type {ReturnType} */ let lastResult;
    /** @type {Array<any>} */ let lastArgs;
    let lastThis;
    return function() {
        const nextArgs = Array.prototype.slice.call(arguments);
        if (!called || this !== lastThis || !(0, $fVVyM.equals)(nextArgs, lastArgs)) {
            called = true;
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function $013a1733c226ec50$export$4dbaaf6c79705e6c(getter) {
    function promiseGetter() {
        let value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}

});
parcelRegister("fVVyM", function(module, exports) {

$parcel$export(module.exports, "binarySearch", () => $b998d41b678ed5d1$export$2e0ae67339d5f1ac);
$parcel$export(module.exports, "ascending", () => $b998d41b678ed5d1$export$fcb633242ef15540);
$parcel$export(module.exports, "linearFindNearest", () => $b998d41b678ed5d1$export$8a3786cc03fdb777);
$parcel$export(module.exports, "reverseSubArray", () => $b998d41b678ed5d1$export$292cfa960964f0e0);
$parcel$export(module.exports, "extend", () => $b998d41b678ed5d1$export$8b58be045bf06082);
$parcel$export(module.exports, "equals", () => $b998d41b678ed5d1$export$e9bab7fafb253603);
$parcel$export(module.exports, "isSorted", () => $b998d41b678ed5d1$export$efa610630f9e181);
/**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $b998d41b678ed5d1$export$2e0ae67339d5f1ac(haystack, needle, comparator) {
    let mid, cmp;
    comparator = comparator || $b998d41b678ed5d1$export$fcb633242ef15540;
    let low = 0;
    let high = haystack.length;
    let found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $b998d41b678ed5d1$export$fcb633242ef15540(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $b998d41b678ed5d1$export$4fa3190a997c3d8f(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $b998d41b678ed5d1$export$8a3786cc03fdb777(arr, target, direction) {
    if (arr[0] <= target) return 0;
    const n = arr.length;
    if (target <= arr[n - 1]) return n - 1;
    if (typeof direction === "function") {
        for(let i = 1; i < n; ++i){
            const candidate = arr[i];
            if (candidate === target) return i;
            if (candidate < target) {
                if (direction(target, arr[i - 1], candidate) > 0) return i - 1;
                return i;
            }
        }
        return n - 1;
    }
    if (direction > 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        return n - 1;
    }
    if (direction < 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        return n - 1;
    }
    for(let i = 1; i < n; ++i){
        if (arr[i] == target) return i;
        if (arr[i] < target) {
            if (arr[i - 1] - target < target - arr[i]) return i - 1;
            return i;
        }
    }
    return n - 1;
}
function $b998d41b678ed5d1$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        const tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $b998d41b678ed5d1$export$8b58be045bf06082(arr, data) {
    const extension = Array.isArray(data) ? data : [
        data
    ];
    const length = extension.length;
    for(let i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $b998d41b678ed5d1$export$cd7f480d6b8286c3(arr, obj) {
    const i = arr.indexOf(obj);
    const found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $b998d41b678ed5d1$export$e9bab7fafb253603(arr1, arr2) {
    const len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(let i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $b998d41b678ed5d1$export$c7d3d1f96a700512(arr, compareFnc) {
    const length = arr.length;
    const tmp = Array(arr.length);
    let i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $b998d41b678ed5d1$export$efa610630f9e181(arr, func, strict) {
    const compare = func || $b998d41b678ed5d1$export$fcb633242ef15540;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        const res = compare(arr[index - 1], currentVal);
        return !(res > 0 || strict && res === 0);
    });
}

});


parcelRegister("gn0g3", function(module, exports) {

$parcel$export(module.exports, "clear", () => $beaefe87199bb537$export$42ffd38884aecdac);
$parcel$export(module.exports, "isEmpty", () => $beaefe87199bb537$export$dd1bc94b04021eeb);
/**
 * @module ol/obj
 */ /**
 * Removes all properties from an object.
 * @param {Object<string, unknown>} object The object to clear.
 */ function $beaefe87199bb537$export$42ffd38884aecdac(object) {
    for(const property in object)delete object[property];
}
function $beaefe87199bb537$export$dd1bc94b04021eeb(object) {
    let property;
    for(property in object)return false;
    return !property;
}

});


parcelRegister("3xzSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $294047c5e65f31a3$export$2e2bcd8739ae039);
/**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $294047c5e65f31a3$export$2e2bcd8739ae039 = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */ CHANGE: "change",
    /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */ ERROR: "error",
    BLUR: "blur",
    CLEAR: "clear",
    CONTEXTMENU: "contextmenu",
    CLICK: "click",
    DBLCLICK: "dblclick",
    DRAGENTER: "dragenter",
    DRAGOVER: "dragover",
    DROP: "drop",
    FOCUS: "focus",
    KEYDOWN: "keydown",
    KEYPRESS: "keypress",
    LOAD: "load",
    RESIZE: "resize",
    TOUCHMOVE: "touchmove",
    WHEEL: "wheel"
};

});

parcelRegister("ilM9F", function(module, exports) {

$parcel$export(module.exports, "listen", () => $d5bf8abd656a3cdc$export$63174c828edd6ff8);
$parcel$export(module.exports, "listenOnce", () => $d5bf8abd656a3cdc$export$8d2a95bc11b44725);
$parcel$export(module.exports, "unlistenByKey", () => $d5bf8abd656a3cdc$export$b0a21c8b3c1c921);
/**
 * @module ol/events
 */ 
var $gn0g3 = parcelRequire("gn0g3");
function $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, thisArg, once) {
    if (thisArg && thisArg !== target) listener = listener.bind(thisArg);
    if (once) {
        const originalListener = listener;
        listener = function() {
            target.removeEventListener(type, listener);
            originalListener.apply(this, arguments);
        };
    }
    const eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $d5bf8abd656a3cdc$export$8d2a95bc11b44725(target, type, listener, thisArg) {
    return $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, thisArg, true);
}
function $d5bf8abd656a3cdc$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $gn0g3.clear)(key);
    }
}

});


parcelRegister("9iPUS", function(module, exports) {

$parcel$export(module.exports, "abstract", () => $6c5e11070e371322$export$817eb92a8194bab0);
$parcel$export(module.exports, "getUid", () => $6c5e11070e371322$export$5e82334337e0f204);
/**
 * @module ol/util
 */ /**
 * @return {never} Any return.
 */ function $6c5e11070e371322$export$817eb92a8194bab0() {
    throw new Error("Unimplemented abstract method.");
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ let $6c5e11070e371322$var$uidCounter_ = 0;
function $6c5e11070e371322$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$6c5e11070e371322$var$uidCounter_));
}
const $6c5e11070e371322$export$a4ad2735b021c132 = "9.2.3";

});


parcelRegister("lbO8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d1853b3fcae320$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $f6d1853b3fcae320$export$2e2bcd8739ae039 = {
    OPACITY: "opacity",
    VISIBLE: "visible",
    EXTENT: "extent",
    Z_INDEX: "zIndex",
    MAX_RESOLUTION: "maxResolution",
    MIN_RESOLUTION: "minResolution",
    MAX_ZOOM: "maxZoom",
    MIN_ZOOM: "minZoom",
    SOURCE: "source",
    MAP: "map"
};

});

parcelRegister("4Cz58", function(module, exports) {

$parcel$export(module.exports, "assert", () => $35d5ec884318008e$export$a7a9523472993e97);
/**
 * @module ol/asserts
 */ /**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {string} errorMessage Error message.
 */ function $35d5ec884318008e$export$a7a9523472993e97(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}

});

parcelRegister("9byFX", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $6b000a049d919fe5$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "squaredSegmentDistance", () => $6b000a049d919fe5$export$251bb0a9cef172e6);
$parcel$export(module.exports, "squaredDistance", () => $6b000a049d919fe5$export$88e6ebb4fe54f538);
$parcel$export(module.exports, "solveLinearSystem", () => $6b000a049d919fe5$export$8240f01c446270e6);
$parcel$export(module.exports, "toDegrees", () => $6b000a049d919fe5$export$56cb859c01fa134d);
$parcel$export(module.exports, "toRadians", () => $6b000a049d919fe5$export$cba01ba138429a1d);
$parcel$export(module.exports, "modulo", () => $6b000a049d919fe5$export$ba467bec01d66def);
$parcel$export(module.exports, "lerp", () => $6b000a049d919fe5$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "toFixed", () => $6b000a049d919fe5$export$a81f732198733497);
$parcel$export(module.exports, "floor", () => $6b000a049d919fe5$export$a3fe094919f356fd);
$parcel$export(module.exports, "ceil", () => $6b000a049d919fe5$export$803ce6b71a0a94b2);
/**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $6b000a049d919fe5$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $6b000a049d919fe5$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $6b000a049d919fe5$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $6b000a049d919fe5$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $6b000a049d919fe5$export$8240f01c446270e6(mat) {
    const n = mat.length;
    for(let i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        let maxRow = i;
        let maxEl = Math.abs(mat[i][i]);
        for(let r = i + 1; r < n; r++){
            const absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        const tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(let j = i + 1; j < n; j++){
            const coef = -mat[j][i] / mat[i][i];
            for(let k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    const x = new Array(n);
    for(let l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(let m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $6b000a049d919fe5$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $6b000a049d919fe5$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $6b000a049d919fe5$export$ba467bec01d66def(a, b) {
    const r = a % b;
    return r * b < 0 ? r + b : r;
}
function $6b000a049d919fe5$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}
function $6b000a049d919fe5$export$a81f732198733497(n, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function $6b000a049d919fe5$export$2077e0241d6afd3c(n, decimals) {
    return Math.round($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$a3fe094919f356fd(n, decimals) {
    return Math.floor($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$803ce6b71a0a94b2(n, decimals) {
    return Math.ceil($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}

});


parcelRegister("l6YBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5e92a4d985a2824$export$2e2bcd8739ae039);
/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $f5e92a4d985a2824$export$2e2bcd8739ae039 /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */  = {
    /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */ PRERENDER: "prerender",
    /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */ POSTRENDER: "postrender",
    /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: "precompose",
    /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: "postcompose",
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: "rendercomplete"
};

});

parcelRegister("9DiKA", function(module, exports) {

$parcel$export(module.exports, "default", () => $70364d0195659942$export$2e2bcd8739ae039);
/**
 * @module ol/View
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $aKuSF = parcelRequire("aKuSF");

var $i93na = parcelRequire("i93na");

var $7xn5x = parcelRequire("7xn5x");

var $dpRHA = parcelRequire("dpRHA");
var $kUyy5 = parcelRequire("kUyy5");

var $6wUzV = parcelRequire("6wUzV");

var $2o3CH = parcelRequire("2o3CH");

var $4Cz58 = parcelRequire("4Cz58");

var $fi2rl = parcelRequire("fi2rl");

var $9byFX = parcelRequire("9byFX");

var $g29x3 = parcelRequire("g29x3");

var $ip5LZ = parcelRequire("ip5LZ");

var $h9x7v = parcelRequire("h9x7v");

var $9pD6L = parcelRequire("9pD6L");

var $fVVyM = parcelRequire("fVVyM");

var $5ydre = parcelRequire("5ydre");
/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to
 * fit the extent into. Defaults to the size of the map the view is associated with.
 * If no map or multiple maps are connected to the view, provide the desired box size
 * (e.g. `map.getSize()`).
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center (in view projection coordinates).
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Like {@link import("./Map.js").FrameState}, but just `viewState` and `extent`.
 * @typedef {Object} ViewStateLayerStateExtent
 * @property {State} viewState View state.
 * @property {import("./extent.js").Extent} extent Extent (in user projection coordinates).
 * @property {Array<import("./layer/Layer.js").State>} [layerStatesArray] Layer states.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ const $70364d0195659942$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<ViewObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 */ class $70364d0195659942$var$View extends (0, $fFFY7.default) {
    /**
   * @param {ViewOptions} [options] View options.
   */ constructor(options){
        super();
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ViewOnSignature<void>}
     */ this.un;
        options = Object.assign({}, options);
        /**
     * @private
     * @type {Array<number>}
     */ this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ this.updateAnimationKey_;
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ this.projection_ = (0, $dpRHA.createProjection)(options.projection, "EPSG:3857");
        /**
     * @private
     * @type {import("./size.js").Size}
     */ this.viewportSize_ = [
            100,
            100
        ];
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.targetCenter_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetResolution_;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ this.nextCenter_ = null;
        /**
     * @private
     * @type {number}
     */ this.nextResolution_;
        /**
     * @private
     * @type {number}
     */ this.nextRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.cancelAnchor_ = undefined;
        if (options.projection) (0, $dpRHA.disableCoordinateWarning)();
        if (options.center) options.center = (0, $dpRHA.fromUserCoordinate)(options.center, this.projection_);
        if (options.extent) options.extent = (0, $dpRHA.fromUserExtent)(options.extent, this.projection_);
        this.applyOptions_(options);
    }
    /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ applyOptions_(options) {
        const properties = Object.assign({}, options);
        for(const key in 0, $i93na.default)delete properties[key];
        this.setProperties(properties, true);
        const resolutionConstraintInfo = $70364d0195659942$export$c68d65f9148da196(options);
        /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
        /**
     * @type {Array<number>|undefined}
     * @private
     */ this.padding_ = options.padding;
        /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        const centerConstraint = $70364d0195659942$export$964345001ee9ac52(options);
        const resolutionConstraint = resolutionConstraintInfo.constraint;
        const rotationConstraint = $70364d0195659942$export$4eeaa08dd550e3c0(options);
        /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
    }
    /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */ get padding() {
        return this.padding_;
    }
    set padding(padding) {
        let oldPadding = this.padding_;
        this.padding_ = padding;
        const center = this.getCenterInternal();
        if (center) {
            const newPadding = padding || [
                0,
                0,
                0,
                0
            ];
            oldPadding = oldPadding || [
                0,
                0,
                0,
                0
            ];
            const resolution = this.getResolution();
            const offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
            const offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
            this.setCenterInternal([
                center[0] + offsetX,
                center[1] - offsetY
            ]);
        }
    }
    /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ getUpdatedOptions_(newOptions) {
        const options = this.getProperties();
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return Object.assign({}, options, newOptions);
    }
    /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ animate(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        const args = new Array(arguments.length);
        for(let i = 0; i < args.length; ++i){
            let options = arguments[i];
            if (options.center) {
                options = Object.assign({}, options);
                options.center = (0, $dpRHA.fromUserCoordinate)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = Object.assign({}, options);
                options.anchor = (0, $dpRHA.fromUserCoordinate)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    }
    /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */ animateInternal(var_args) {
        let animationCount = arguments.length;
        let callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === "function") {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        let i = 0;
        for(; i < animationCount && !this.isDef(); ++i){
            // if view properties are not yet set, shortcut to the final state
            const state = arguments[i];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            else if (state.resolution) this.setResolution(state.resolution);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
        }
        if (i === animationCount) {
            if (callback) $70364d0195659942$var$animationCallback(callback, true);
            return;
        }
        let start = Date.now();
        let center = this.targetCenter_.slice();
        let resolution = this.targetResolution_;
        let rotation = this.targetRotation_;
        const series = [];
        for(; i < animationCount; ++i){
            const options = /** @type {AnimationOptions} */ arguments[i];
            const animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $h9x7v.inAndOut),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                const delta = (0, $9byFX.modulo)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if ($70364d0195659942$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $aKuSF.default).ANIMATING, 1);
        this.updateAnimations_();
    }
    /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ getAnimating() {
        return this.hints_[(0, $aKuSF.default).ANIMATING] > 0;
    }
    /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ getInteracting() {
        return this.hints_[(0, $aKuSF.default).INTERACTING] > 0;
    }
    /**
   * Cancel any ongoing animations.
   * @api
   */ cancelAnimations() {
        this.setHint((0, $aKuSF.default).ANIMATING, -this.hints_[(0, $aKuSF.default).ANIMATING]);
        let anchor;
        for(let i = 0, ii = this.animations_.length; i < ii; ++i){
            const series = this.animations_[i];
            if (series[0].callback) $70364d0195659942$var$animationCallback(series[0].callback, false);
            if (!anchor) for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
        this.nextCenter_ = null;
        this.nextResolution_ = NaN;
        this.nextRotation_ = NaN;
    }
    /**
   * Update all animations.
   */ updateAnimations_() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        const now = Date.now();
        let more = false;
        for(let i = this.animations_.length - 1; i >= 0; --i){
            const series = this.animations_[i];
            let seriesComplete = true;
            for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (animation.complete) continue;
                const elapsed = now - animation.start;
                let fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                const progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    const x0 = animation.sourceCenter[0];
                    const y0 = animation.sourceCenter[1];
                    const x1 = animation.targetCenter[0];
                    const y1 = animation.targetCenter[1];
                    this.nextCenter_ = animation.targetCenter;
                    const x = x0 + progress * (x1 - x0);
                    const y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    const resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        const size = this.getViewportSize_(this.getRotation());
                        const constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.nextResolution_ = animation.targetResolution;
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    const rotation = progress === 1 ? (0, $9byFX.modulo)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        const constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.nextRotation_ = animation.targetRotation;
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $aKuSF.default).ANIMATING, -1);
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
                const callback = series[0].callback;
                if (callback) $70364d0195659942$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    }
    /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ calculateCenterRotate(rotation, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $2o3CH.rotate)(center, rotation - this.getRotation());
            (0, $2o3CH.add)(center, anchor);
        }
        return center;
    }
    /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ calculateCenterZoom(resolution, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        const currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            const x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            const y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    }
    /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ getViewportSize_(rotation) {
        const size = this.viewportSize_;
        if (rotation) {
            const w = size[0];
            const h = size[1];
            return [
                Math.abs(w * Math.cos(rotation)) + Math.abs(h * Math.sin(rotation)),
                Math.abs(w * Math.sin(rotation)) + Math.abs(h * Math.cos(rotation))
            ];
        }
        return size;
    }
    /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */ setViewportSize(size) {
        this.viewportSize_ = Array.isArray(size) ? size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    }
    /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ getCenter() {
        const center = this.getCenterInternal();
        if (!center) return center;
        return (0, $dpRHA.toUserCoordinate)(center, this.getProjection());
    }
    /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */ getCenterInternal() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $i93na.default).CENTER);
    }
    /**
   * @return {Constraints} Constraints.
   */ getConstraints() {
        return this.constraints_;
    }
    /**
   * @return {boolean} Resolution constraint is set
   */ getConstrainResolution() {
        return this.get("constrainResolution");
    }
    /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */ getHints(hints) {
        if (hints !== undefined) {
            hints[0] = this.hints_[0];
            hints[1] = this.hints_[1];
            return hints;
        }
        return this.hints_.slice();
    }
    /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ calculateExtent(size) {
        const extent = this.calculateExtentInternal(size);
        return (0, $dpRHA.toUserExtent)(extent, this.getProjection());
    }
    /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */ calculateExtentInternal(size) {
        size = size || this.getViewportSizeMinusPadding_();
        const center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, $4Cz58.assert)(center, "The view center is not defined");
        const resolution = /** @type {!number} */ this.getResolution();
        (0, $4Cz58.assert)(resolution !== undefined, "The view resolution is not defined");
        const rotation = /** @type {!number} */ this.getRotation();
        (0, $4Cz58.assert)(rotation !== undefined, "The view rotation is not defined");
        return (0, $9pD6L.getForViewAndSize)(center, resolution, rotation, size);
    }
    /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ getMaxResolution() {
        return this.maxResolution_;
    }
    /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ getMinResolution() {
        return this.minResolution_;
    }
    /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    }
    /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ setMaxZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    }
    /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    }
    /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ setMinZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    }
    /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */ setConstrainResolution(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    }
    /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ getProjection() {
        return this.projection_;
    }
    /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ getResolution() {
        return /** @type {number|undefined} */ this.get((0, $i93na.default).RESOLUTION);
    }
    /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ getResolutionForExtent(extent, size) {
        return this.getResolutionForExtentInternal((0, $dpRHA.fromUserExtent)(extent, this.getProjection()), size);
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */ getResolutionForExtentInternal(extent, size) {
        size = size || this.getViewportSizeMinusPadding_();
        const xResolution = (0, $9pD6L.getWidth)(extent) / size[0];
        const yResolution = (0, $9pD6L.getHeight)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    }
    /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */ getResolutionForValueFunction(power) {
        power = power || 2;
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
            const resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    }
    /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ getRotation() {
        return /** @type {number} */ this.get((0, $i93na.default).ROTATION);
    }
    /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */ getValueForResolutionFunction(power) {
        const logPower = Math.log(power || 2);
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
            const value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    }
    /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */ getViewportSizeMinusPadding_(rotation) {
        let size = this.getViewportSize_(rotation);
        const padding = this.padding_;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    }
    /**
   * @return {State} View state.
   */ getState() {
        const projection = this.getProjection();
        const resolution = this.getResolution();
        const rotation = this.getRotation();
        let center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        const padding = this.padding_;
        if (padding) {
            const reducedSize = this.getViewportSizeMinusPadding_();
            center = $70364d0195659942$var$calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            nextCenter: this.nextCenter_,
            nextResolution: this.nextResolution_,
            nextRotation: this.nextRotation_,
            rotation: rotation,
            zoom: this.getZoom()
        };
    }
    /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */ getViewStateAndExtent() {
        return {
            viewState: this.getState(),
            extent: this.calculateExtent()
        };
    }
    /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */ getZoom() {
        let zoom;
        const resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    }
    /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ getZoomForResolution(resolution) {
        let offset = this.minZoom_ || 0;
        let max, zoomFactor;
        if (this.resolutions_) {
            const nearest = (0, $fVVyM.linearFindNearest)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    }
    /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ getResolutionForZoom(zoom) {
        if (this.resolutions_) {
            if (this.resolutions_.length <= 1) return 0;
            const baseLevel = (0, $9byFX.clamp)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            const zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $9byFX.clamp)(zoom - baseLevel, 0, 1));
        }
        return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    }
    /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */ fit(geometryOrExtent, options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ let geometry;
        (0, $4Cz58.assert)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === "function", "Invalid extent or geometry provided as `geometry`");
        if (Array.isArray(geometryOrExtent)) {
            (0, $4Cz58.assert)(!(0, $9pD6L.isEmpty)(geometryOrExtent), "Cannot fit empty extent provided as `geometry`");
            const extent = (0, $dpRHA.fromUserExtent)(geometryOrExtent, this.getProjection());
            geometry = (0, $5ydre.fromExtent)(extent);
        } else if (geometryOrExtent.getType() === "Circle") {
            const extent = (0, $dpRHA.fromUserExtent)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, $5ydre.fromExtent)(extent);
            geometry.rotate(this.getRotation(), (0, $9pD6L.getCenter)(extent));
        } else {
            const userProjection = (0, $dpRHA.getUserProjection)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, options);
    }
    /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent").Extent} The rotated extent for the geometry.
   */ rotatedExtentForGeometry(geometry) {
        const rotation = this.getRotation();
        const cosAngle = Math.cos(rotation);
        const sinAngle = Math.sin(-rotation);
        const coords = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        let minRotX = Infinity;
        let minRotY = Infinity;
        let maxRotX = -Infinity;
        let maxRotY = -Infinity;
        for(let i = 0, ii = coords.length; i < ii; i += stride){
            const rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            const rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ];
    }
    /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */ fitInternal(geometry, options) {
        options = options || {};
        let size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        const padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        const nearest = options.nearest !== undefined ? options.nearest : false;
        let minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        const rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        let resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        const rotation = this.getRotation();
        const sinAngle = Math.sin(rotation);
        const cosAngle = Math.cos(rotation);
        const centerRot = (0, $9pD6L.getCenter)(rotatedExtent);
        centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
        centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
        const centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        const centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        const center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        const callback = options.callback ? options.callback : (0, $6wUzV.VOID);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            $70364d0195659942$var$animationCallback(callback, true);
        }
    }
    /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ centerOn(coordinate, size, position) {
        this.centerOnInternal((0, $dpRHA.fromUserCoordinate)(coordinate, this.getProjection()), size, position);
    }
    /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */ centerOnInternal(coordinate, size, position) {
        this.setCenterInternal($70364d0195659942$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    }
    /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */ calculateCenterShift(center, resolution, rotation, size) {
        let centerShift;
        const padding = this.padding_;
        if (padding && center) {
            const reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            const shiftedCenter = $70364d0195659942$var$calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    }
    /**
   * @return {boolean} Is defined.
   */ isDef() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */ adjustCenter(deltaCoordinates) {
        const center = (0, $dpRHA.toUserCoordinate)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */ adjustCenterInternal(deltaCoordinates) {
        const center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustResolution(ratio, anchor) {
        anchor = anchor && (0, $dpRHA.fromUserCoordinate)(anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ adjustResolutionInternal(ratio, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const size = this.getViewportSize_(this.getRotation());
        const newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    }
    /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustZoom(delta, anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), anchor);
    }
    /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */ adjustRotation(delta, anchor) {
        if (anchor) anchor = (0, $dpRHA.fromUserCoordinate)(anchor, this.getProjection());
        this.adjustRotationInternal(delta, anchor);
    }
    /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */ adjustRotationInternal(delta, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    }
    /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ setCenter(center) {
        this.setCenterInternal(center ? (0, $dpRHA.fromUserCoordinate)(center, this.getProjection()) : center);
    }
    /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */ setCenterInternal(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    }
    /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ setHint(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    }
    /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ setResolution(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    }
    /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ setRotation(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    }
    /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */ setZoom(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    }
    /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */ applyTargetState_(doNotCancelAnims, forceMoving) {
        const isMoving = this.getAnimating() || this.getInteracting() || forceMoving;
        // compute rotation
        const newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, $i93na.default).ROTATION) !== newRotation) this.set((0, $i93na.default).ROTATION, newRotation);
        if (this.get((0, $i93na.default).RESOLUTION) !== newResolution) {
            this.set((0, $i93na.default).RESOLUTION, newResolution);
            this.set("zoom", this.getZoom(), true);
        }
        if (!newCenter || !this.get((0, $i93na.default).CENTER) || !(0, $2o3CH.equals)(this.get((0, $i93na.default).CENTER), newCenter)) this.set((0, $i93na.default).CENTER, newCenter);
        if (this.getAnimating() && !doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    }
    /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ resolveConstraints(duration, resolutionDirection, anchor) {
        duration = duration !== undefined ? duration : 200;
        const direction = resolutionDirection || 0;
        const newRotation = this.constraints_.rotation(this.targetRotation_);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        anchor = anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $2o3CH.equals)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, $h9x7v.easeOut),
                anchor: anchor
            });
        }
    }
    /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */ beginInteraction() {
        this.resolveConstraints(0);
        this.setHint((0, $aKuSF.default).INTERACTING, 1);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ endInteraction(duration, resolutionDirection, anchor) {
        anchor = anchor && (0, $dpRHA.fromUserCoordinate)(anchor, this.getProjection());
        this.endInteractionInternal(duration, resolutionDirection, anchor);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ endInteractionInternal(duration, resolutionDirection, anchor) {
        if (!this.getInteracting()) return;
        this.setHint((0, $aKuSF.default).INTERACTING, -1);
        this.resolveConstraints(duration, resolutionDirection, anchor);
    }
    /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */ getConstrainedCenter(targetCenter, targetResolution) {
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, targetResolution || this.getResolution(), size);
    }
    /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */ getConstrainedZoom(targetZoom, direction) {
        const targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, direction));
    }
    /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */ getConstrainedResolution(targetResolution, direction) {
        direction = direction || 0;
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    }
}
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $70364d0195659942$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $70364d0195659942$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        const smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $fi2rl.createExtent)(options.extent, options.constrainOnlyCenter, smooth);
    }
    const projection = (0, $dpRHA.createProjection)(options.projection, "EPSG:3857");
    if (options.multiWorld !== true && projection.isGlobal()) {
        const extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $fi2rl.createExtent)(extent, false, false);
    }
    return 0, $fi2rl.none;
}
function $70364d0195659942$export$c68d65f9148da196(options) {
    let resolutionConstraint;
    let maxResolution;
    let minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    const defaultMaxZoom = 28;
    const defaultZoomFactor = 2;
    let minZoom = options.minZoom !== undefined ? options.minZoom : $70364d0195659942$var$DEFAULT_MIN_ZOOM;
    let maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    const zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    const multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    const smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    const showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    const projection = (0, $dpRHA.createProjection)(options.projection, "EPSG:3857");
    const projExtent = projection.getExtent();
    let constrainOnlyCenter = options.constrainOnlyCenter;
    let extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        const resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $g29x3.createSnapToResolutions)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $g29x3.createMinMaxResolution)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        const size = !projExtent ? 360 * (0, $kUyy5.METERS_PER_UNIT).degrees / projection.getMetersPerUnit() : Math.max((0, $9pD6L.getWidth)(projExtent), (0, $9pD6L.getHeight)(projExtent));
        const defaultMaxResolution = size / (0, $7xn5x.DEFAULT_TILE_SIZE) / Math.pow(defaultZoomFactor, $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        const defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $g29x3.createSnapToPower)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $g29x3.createMinMaxResolution)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $70364d0195659942$export$4eeaa08dd550e3c0(options) {
    const enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        const constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $ip5LZ.createSnapToZero)();
        if (constrainRotation === false) return 0, $ip5LZ.none;
        if (typeof constrainRotation === "number") return (0, $ip5LZ.createSnapToN)(constrainRotation);
        return 0, $ip5LZ.none;
    }
    return 0, $ip5LZ.disable;
}
function $70364d0195659942$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $2o3CH.equals)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $70364d0195659942$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    const cosAngle = Math.cos(-rotation);
    let sinAngle = Math.sin(-rotation);
    let rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    let rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    const centerX = rotX * cosAngle - rotY * sinAngle;
    const centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $70364d0195659942$export$2e2bcd8739ae039 = $70364d0195659942$var$View;

});
parcelRegister("aKuSF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d362782b4ccb93d$export$2e2bcd8739ae039);
/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $7d362782b4ccb93d$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};

});

parcelRegister("i93na", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35baefbe89be4c5$export$2e2bcd8739ae039);
/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $d35baefbe89be4c5$export$2e2bcd8739ae039 = {
    CENTER: "center",
    RESOLUTION: "resolution",
    ROTATION: "rotation"
};

});

parcelRegister("7xn5x", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MAX_ZOOM", () => $57cd8651d88957a0$export$e98a216cdcc847dc);
$parcel$export(module.exports, "DEFAULT_TILE_SIZE", () => $57cd8651d88957a0$export$6b8cb5cd370bd90c);
/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ const $57cd8651d88957a0$export$e98a216cdcc847dc = 42;
const $57cd8651d88957a0$export$6b8cb5cd370bd90c = 256;

});

parcelRegister("dpRHA", function(module, exports) {

$parcel$export(module.exports, "disableCoordinateWarning", () => $9c4744460e43e41b$export$ed949affbc7c4223);
$parcel$export(module.exports, "get", () => $9c4744460e43e41b$export$3988ae62b71be9a3);
$parcel$export(module.exports, "getPointResolution", () => $9c4744460e43e41b$export$2d8f7b4eec383d44);
$parcel$export(module.exports, "getTransformFromProjections", () => $9c4744460e43e41b$export$e3c4995a701c26a3);
$parcel$export(module.exports, "createProjection", () => $9c4744460e43e41b$export$549167224996a0fb);
$parcel$export(module.exports, "fromLonLat", () => $9c4744460e43e41b$export$b15d9668511529b9);
$parcel$export(module.exports, "transform", () => $9c4744460e43e41b$export$51186ad6e864892a);
$parcel$export(module.exports, "equivalent", () => $9c4744460e43e41b$export$fe091d73a555748b);
$parcel$export(module.exports, "getTransform", () => $9c4744460e43e41b$export$fce0c6cfca85ed96);
$parcel$export(module.exports, "getUserProjection", () => $9c4744460e43e41b$export$3973b77d5f6f2790);
$parcel$export(module.exports, "toUserCoordinate", () => $9c4744460e43e41b$export$698f563af1ba02a5);
$parcel$export(module.exports, "fromUserCoordinate", () => $9c4744460e43e41b$export$d4b8ec0b96db1ee2);
$parcel$export(module.exports, "toUserExtent", () => $9c4744460e43e41b$export$96bfd09e2cffb006);
$parcel$export(module.exports, "fromUserExtent", () => $9c4744460e43e41b$export$494be3a3a25689ca);
$parcel$export(module.exports, "toUserResolution", () => $9c4744460e43e41b$export$b56bb8ad8b3a00e9);
$parcel$export(module.exports, "fromUserResolution", () => $9c4744460e43e41b$export$bd1cd3b88140b906);
$parcel$export(module.exports, "METERS_PER_UNIT", () => (parcelRequire("kUyy5")).METERS_PER_UNIT);
/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ 

var $bof21 = parcelRequire("bof21");

var $fAlut = parcelRequire("fAlut");

var $kUyy5 = parcelRequire("kUyy5");

var $l72II = parcelRequire("l72II");

var $1wgRP = parcelRequire("1wgRP");

var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $2o3CH = parcelRequire("2o3CH");

var $lAvh5 = parcelRequire("lAvh5");

var $c3kwQ = parcelRequire("c3kwQ");
let $9c4744460e43e41b$var$showCoordinateWarning = true;
function $9c4744460e43e41b$export$ed949affbc7c4223(disable) {
    const hide = disable === undefined ? true : disable;
    $9c4744460e43e41b$var$showCoordinateWarning = !hide;
}
function $9c4744460e43e41b$export$dd516654c5f598fb(input, output) {
    if (output !== undefined) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        output;
    } else output = input.slice();
    return output;
}
function $9c4744460e43e41b$export$83e8ab53904f8022(input, output) {
    if (output !== undefined && input !== output) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        input = output;
    }
    return input;
}
function $9c4744460e43e41b$export$59ae956cd3e343f7(projection) {
    (0, $l72II.add)(projection.getCode(), projection);
    (0, $1wgRP.add)(projection, projection, $9c4744460e43e41b$export$dd516654c5f598fb);
}
function $9c4744460e43e41b$export$638ad73f7aafb913(projections) {
    projections.forEach($9c4744460e43e41b$export$59ae956cd3e343f7);
}
function $9c4744460e43e41b$export$3988ae62b71be9a3(projectionLike) {
    return typeof projectionLike === "string" ? (0, $l72II.get)(/** @type {string} */ projectionLike) : /** @type {Projection} */ projectionLike || null;
}
function $9c4744460e43e41b$export$2d8f7b4eec383d44(projection, resolution, point, units) {
    projection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    let pointResolution;
    const getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (units && units !== projection.getUnits()) {
            const metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $kUyy5.METERS_PER_UNIT)[units];
        }
    } else {
        const projUnits = projection.getUnits();
        if (projUnits == "degrees" && !units || units == "degrees") pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            const toEPSG4326 = $9c4744460e43e41b$export$e3c4995a701c26a3(projection, $9c4744460e43e41b$export$3988ae62b71be9a3("EPSG:4326"));
            if (toEPSG4326 === $9c4744460e43e41b$export$83e8ab53904f8022 && projUnits !== "degrees") // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                let vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326(vertices, vertices, 2);
                const width = (0, $lAvh5.getDistance)(vertices.slice(0, 2), vertices.slice(2, 4));
                const height = (0, $lAvh5.getDistance)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            const metersPerUnit = units ? (0, $kUyy5.METERS_PER_UNIT)[units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $9c4744460e43e41b$export$eeb8392580a05a37(projections) {
    $9c4744460e43e41b$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $1wgRP.add)(source, destination, $9c4744460e43e41b$export$dd516654c5f598fb);
        });
    });
}
function $9c4744460e43e41b$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $1wgRP.add)(projection1, projection2, forwardTransform);
            (0, $1wgRP.add)(projection2, projection1, inverseTransform);
        });
    });
}
function $9c4744460e43e41b$export$4860237d10380594() {
    (0, $l72II.clear)();
    (0, $1wgRP.clear)();
}
function $9c4744460e43e41b$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $9c4744460e43e41b$export$3988ae62b71be9a3(defaultCode);
    if (typeof projection === "string") return $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    return /** @type {Projection} */ projection;
}
function $9c4744460e43e41b$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimension.
     * @return {Array<number>} Output.
     */ function(input, output, dimension) {
        const length = input.length;
        dimension = dimension !== undefined ? dimension : 2;
        output = output !== undefined ? output : new Array(length);
        for(let i = 0; i < length; i += dimension){
            const point = coordTransform(input.slice(i, i + dimension));
            const pointLength = point.length;
            for(let j = 0, jj = dimension; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function $9c4744460e43e41b$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    const sourceProj = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    const destProj = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    (0, $1wgRP.add)(sourceProj, destProj, $9c4744460e43e41b$export$6b4aafd331159e0d(forward));
    (0, $1wgRP.add)(destProj, sourceProj, $9c4744460e43e41b$export$6b4aafd331159e0d(inverse));
}
function $9c4744460e43e41b$export$b15d9668511529b9(coordinate, projection) {
    $9c4744460e43e41b$export$ed949affbc7c4223();
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, "EPSG:4326", projection !== undefined ? projection : "EPSG:3857");
}
function $9c4744460e43e41b$export$3fb495868742d370(coordinate, projection) {
    const lonLat = $9c4744460e43e41b$export$51186ad6e864892a(coordinate, projection !== undefined ? projection : "EPSG:3857", "EPSG:4326");
    const lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $9byFX.modulo)(lon + 180, 360) - 180;
    return lonLat;
}
function $9c4744460e43e41b$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    const equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    const transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(projection1, projection2);
    return transformFunc === $9c4744460e43e41b$export$dd516654c5f598fb && equalUnits;
}
function $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection) {
    const sourceCode = sourceProjection.getCode();
    const destinationCode = destinationProjection.getCode();
    let transformFunc = (0, $1wgRP.get)(sourceCode, destinationCode);
    if (!transformFunc) transformFunc = $9c4744460e43e41b$export$83e8ab53904f8022;
    return transformFunc;
}
function $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination) {
    const sourceProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    const destinationProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    return $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $9c4744460e43e41b$export$51186ad6e864892a(coordinate, source, destination) {
    const transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $9c4744460e43e41b$export$751c68e0e0efff79(extent, source, destination, stops) {
    const transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    return (0, $9pD6L.applyTransform)(extent, transformFunc, undefined, stops);
}
function $9c4744460e43e41b$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    const transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ let $9c4744460e43e41b$var$userProjection = null;
function $9c4744460e43e41b$export$d0aeadbeac54116e(projection) {
    $9c4744460e43e41b$var$userProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
}
function $9c4744460e43e41b$export$1ae11279759d4e8f() {
    $9c4744460e43e41b$var$userProjection = null;
}
function $9c4744460e43e41b$export$3973b77d5f6f2790() {
    return $9c4744460e43e41b$var$userProjection;
}
function $9c4744460e43e41b$export$aa7494edfbe36197() {
    $9c4744460e43e41b$export$d0aeadbeac54116e("EPSG:4326");
}
function $9c4744460e43e41b$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return coordinate;
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) {
        if ($9c4744460e43e41b$var$showCoordinateWarning && !(0, $2o3CH.equals)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            $9c4744460e43e41b$var$showCoordinateWarning = false;
            (0, $c3kwQ.warn)("Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.");
        }
        return coordinate;
    }
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$494be3a3a25689ca(extent, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$b56bb8ad8b3a00e9(resolution, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return resolution;
    const sourceMetersPerUnit = $9c4744460e43e41b$export$3988ae62b71be9a3(sourceProjection).getMetersPerUnit();
    const userMetersPerUnit = $9c4744460e43e41b$var$userProjection.getMetersPerUnit();
    return sourceMetersPerUnit && userMetersPerUnit ? resolution * sourceMetersPerUnit / userMetersPerUnit : resolution;
}
function $9c4744460e43e41b$export$bd1cd3b88140b906(resolution, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return resolution;
    const destMetersPerUnit = $9c4744460e43e41b$export$3988ae62b71be9a3(destProjection).getMetersPerUnit();
    const userMetersPerUnit = $9c4744460e43e41b$var$userProjection.getMetersPerUnit();
    return destMetersPerUnit && userMetersPerUnit ? resolution * userMetersPerUnit / destMetersPerUnit : resolution;
}
function $9c4744460e43e41b$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        let transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            const sourceExtent = sourceProj.getExtent();
            const sourceExtentWidth = (0, $9pD6L.getWidth)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, $2o3CH.getWorldsAway)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, $9byFX.clamp)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, $9byFX.clamp)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $9pD6L.getWidth)(destProj.getExtent());
        return transformed;
    };
}
function $9c4744460e43e41b$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $bof21.PROJECTIONS));
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $fAlut.PROJECTIONS));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $9c4744460e43e41b$export$4856f21c2f184f24((0, $fAlut.PROJECTIONS), (0, $bof21.PROJECTIONS), (0, $bof21.fromEPSG4326), (0, $bof21.toEPSG4326));
}
$9c4744460e43e41b$export$86eed449eb2dcac4();

});
parcelRegister("bof21", function(module, exports) {

$parcel$export(module.exports, "PROJECTIONS", () => $84ad988f04807ab1$export$b508d7ad9a891c1b);
$parcel$export(module.exports, "fromEPSG4326", () => $84ad988f04807ab1$export$1ff8bb36c0983070);
$parcel$export(module.exports, "toEPSG4326", () => $84ad988f04807ab1$export$8c71322ec28ed6b4);
/**
 * @module ol/proj/epsg3857
 */ 
var $9qhtr = parcelRequire("9qhtr");
const $84ad988f04807ab1$export$2d2c9be8b5b863f = 6378137;
const $84ad988f04807ab1$export$f3928063e5e96d35 = Math.PI * $84ad988f04807ab1$export$2d2c9be8b5b863f;
const $84ad988f04807ab1$export$21e6da8a7375dfe8 = [
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35
];
const $84ad988f04807ab1$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
const $84ad988f04807ab1$export$d26945d1ad52feeb = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ class $84ad988f04807ab1$var$EPSG3857Projection extends (0, $9qhtr.default) {
    /**
   * @param {string} code Code.
   */ constructor(code){
        super({
            code: code,
            units: "m",
            extent: $84ad988f04807ab1$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $84ad988f04807ab1$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / Math.cosh(point[1] / $84ad988f04807ab1$export$2d2c9be8b5b863f);
            }
        });
    }
}
const $84ad988f04807ab1$export$b508d7ad9a891c1b = [
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:3857"),
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:102100"),
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:102113"),
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:900913"),
    new $84ad988f04807ab1$var$EPSG3857Projection("http://www.opengis.net/def/crs/EPSG/0/3857"),
    new $84ad988f04807ab1$var$EPSG3857Projection("http://www.opengis.net/gml/srs/epsg.xml#3857")
];
function $84ad988f04807ab1$export$1ff8bb36c0983070(input, output, dimension) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += dimension){
        output[i] = $84ad988f04807ab1$export$f3928063e5e96d35 * input[i] / 180;
        let y = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $84ad988f04807ab1$export$d26945d1ad52feeb) y = $84ad988f04807ab1$export$d26945d1ad52feeb;
        else if (y < -$84ad988f04807ab1$export$d26945d1ad52feeb) y = -$84ad988f04807ab1$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $84ad988f04807ab1$export$8c71322ec28ed6b4(input, output, dimension) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += dimension){
        output[i] = 180 * input[i] / $84ad988f04807ab1$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $84ad988f04807ab1$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}

});
parcelRegister("9qhtr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dc418afeec7068a$export$2e2bcd8739ae039);
/**
 * @module ol/proj/Projection
 */ 
var $kUyy5 = parcelRequire("kUyy5");
/**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").Units} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {function(number, import("../coordinate.js").Coordinate):number} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution} function will be used.
 */ /**
 * @classdesc
 * Projection definition class. One of these is created for each projection
 * supported in the application and stored in the {@link module:ol/proj} namespace.
 * You can use these in applications, but this is not required, as API params
 * and options use {@link module:ol/proj~ProjectionLike} which means the simple string
 * code will suffice.
 *
 * You can use {@link module:ol/proj.get} to retrieve the object for a particular
 * projection.
 *
 * The library includes definitions for `EPSG:4326` and `EPSG:3857`, together
 * with the following aliases:
 * * `EPSG:4326`: CRS:84, urn:ogc:def:crs:EPSG:6.6:4326,
 *     urn:ogc:def:crs:OGC:1.3:CRS84, urn:ogc:def:crs:OGC:2:84,
 *     http://www.opengis.net/gml/srs/epsg.xml#4326,
 *     urn:x-ogc:def:crs:EPSG:4326
 * * `EPSG:3857`: EPSG:102100, EPSG:102113, EPSG:900913,
 *     urn:ogc:def:crs:EPSG:6.18:3:3857,
 *     http://www.opengis.net/gml/srs/epsg.xml#3857
 *
 * If you use [proj4js](https://github.com/proj4js/proj4js), aliases can
 * be added using `proj4.defs()`. After all required projection definitions are
 * added, call the {@link module:ol/proj/proj4.register} function.
 *
 * @api
 */ class $6dc418afeec7068a$var$Projection {
    /**
   * @param {Options} options Projection options.
   */ constructor(options){
        /**
     * @private
     * @type {string}
     */ this.code_ = options.code;
        /**
     * Units of projected coordinates. When set to `TILE_PIXELS`, a
     * `this.extent_` and `this.worldExtent_` must be configured properly for each
     * tile.
     * @private
     * @type {import("./Units.js").Units}
     */ this.units_ = /** @type {import("./Units.js").Units} */ options.units;
        /**
     * Validity extent of the projection in projected coordinates. For projections
     * with `TILE_PIXELS` units, this is the extent of the tile in
     * tile pixel space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
     * Extent of the world in EPSG:4326. For projections with
     * `TILE_PIXELS` units, this is the extent of the tile in
     * projected coordinate space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
     * @private
     * @type {string}
     */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : "enu";
        /**
     * @private
     * @type {boolean}
     */ this.global_ = options.global !== undefined ? options.global : false;
        /**
     * @private
     * @type {boolean}
     */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
     * @private
     * @type {function(number, import("../coordinate.js").Coordinate):number|undefined}
     */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.defaultTileGrid_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */ canWrapX() {
        return this.canWrapX_;
    }
    /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */ getCode() {
        return this.code_;
    }
    /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */ getUnits() {
        return this.units_;
    }
    /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */ getMetersPerUnit() {
        return this.metersPerUnit_ || (0, $kUyy5.METERS_PER_UNIT)[this.units_];
    }
    /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getWorldExtent() {
        return this.worldExtent_;
    }
    /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */ getAxisOrientation() {
        return this.axisOrientation_;
    }
    /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */ isGlobal() {
        return this.global_;
    }
    /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */ setGlobal(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    }
    /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */ getDefaultTileGrid() {
        return this.defaultTileGrid_;
    }
    /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */ setDefaultTileGrid(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    }
    /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ setExtent(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    }
    /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */ setWorldExtent(worldExtent) {
        this.worldExtent_ = worldExtent;
    }
    /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */ setGetPointResolution(func) {
        this.getPointResolutionFunc_ = func;
    }
    /**
   * Get the custom point resolution function for this projection (if set).
   * @return {function(number, import("../coordinate.js").Coordinate):number|undefined} The custom point
   * resolution function (if set).
   */ getPointResolutionFunc() {
        return this.getPointResolutionFunc_;
    }
}
var $6dc418afeec7068a$export$2e2bcd8739ae039 = $6dc418afeec7068a$var$Projection;

});
parcelRegister("kUyy5", function(module, exports) {

$parcel$export(module.exports, "METERS_PER_UNIT", () => $03edbd434a9e6608$export$1482081eec883108);
/**
 * @module ol/proj/Units
 */ /**
 * @typedef {'radians' | 'degrees' | 'ft' | 'm' | 'pixels' | 'tile-pixels' | 'us-ft'} Units
 * Projection units.
 */ /**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ const $03edbd434a9e6608$var$unitByCode = {
    "9001": "m",
    "9002": "ft",
    "9003": "us-ft",
    "9101": "radians",
    "9102": "degrees"
};
function $03edbd434a9e6608$export$7f58726df3255edc(code) {
    return $03edbd434a9e6608$var$unitByCode[code];
}
const $03edbd434a9e6608$export$1482081eec883108 = {
    // use the radius of the Normal sphere
    "radians": 6370997 / (2 * Math.PI),
    "degrees": 2 * Math.PI * 6370997 / 360,
    "ft": 0.3048,
    "m": 1,
    "us-ft": 1200 / 3937
};

});



parcelRegister("fAlut", function(module, exports) {

$parcel$export(module.exports, "PROJECTIONS", () => $b58ae362632b32c5$export$b508d7ad9a891c1b);
/**
 * @module ol/proj/epsg4326
 */ 
var $9qhtr = parcelRequire("9qhtr");
const $b58ae362632b32c5$export$2d2c9be8b5b863f = 6378137;
const $b58ae362632b32c5$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
const $b58ae362632b32c5$export$1482081eec883108 = Math.PI * $b58ae362632b32c5$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ class $b58ae362632b32c5$var$EPSG4326Projection extends (0, $9qhtr.default) {
    /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */ constructor(code, axisOrientation){
        super({
            code: code,
            units: "degrees",
            extent: $b58ae362632b32c5$export$21e6da8a7375dfe8,
            axisOrientation: axisOrientation,
            global: true,
            metersPerUnit: $b58ae362632b32c5$export$1482081eec883108,
            worldExtent: $b58ae362632b32c5$export$21e6da8a7375dfe8
        });
    }
}
const $b58ae362632b32c5$export$b508d7ad9a891c1b = [
    new $b58ae362632b32c5$var$EPSG4326Projection("CRS:84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("EPSG:4326", "neu"),
    new $b58ae362632b32c5$var$EPSG4326Projection("urn:ogc:def:crs:OGC:1.3:CRS84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("urn:ogc:def:crs:OGC:2:84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("http://www.opengis.net/def/crs/OGC/1.3/CRS84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("http://www.opengis.net/gml/srs/epsg.xml#4326", "neu"),
    new $b58ae362632b32c5$var$EPSG4326Projection("http://www.opengis.net/def/crs/EPSG/0/4326", "neu")
];

});

parcelRegister("l72II", function(module, exports) {

$parcel$export(module.exports, "clear", () => $f5ec5c943d804ecb$export$42ffd38884aecdac);
$parcel$export(module.exports, "get", () => $f5ec5c943d804ecb$export$3988ae62b71be9a3);
$parcel$export(module.exports, "add", () => $f5ec5c943d804ecb$export$e16d8520af44a096);
/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ let $f5ec5c943d804ecb$var$cache = {};
function $f5ec5c943d804ecb$export$42ffd38884aecdac() {
    $f5ec5c943d804ecb$var$cache = {};
}
function $f5ec5c943d804ecb$export$3988ae62b71be9a3(code) {
    return $f5ec5c943d804ecb$var$cache[code] || $f5ec5c943d804ecb$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, "EPSG:$3")] || null;
}
function $f5ec5c943d804ecb$export$e16d8520af44a096(code, projection) {
    $f5ec5c943d804ecb$var$cache[code] = projection;
}

});

parcelRegister("1wgRP", function(module, exports) {

$parcel$export(module.exports, "clear", () => $11b5dd198626e1de$export$42ffd38884aecdac);
$parcel$export(module.exports, "add", () => $11b5dd198626e1de$export$e16d8520af44a096);
$parcel$export(module.exports, "get", () => $11b5dd198626e1de$export$3988ae62b71be9a3);
/**
 * @module ol/proj/transforms
 */ 
var $gn0g3 = parcelRequire("gn0g3");
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ let $11b5dd198626e1de$var$transforms = {};
function $11b5dd198626e1de$export$42ffd38884aecdac() {
    $11b5dd198626e1de$var$transforms = {};
}
function $11b5dd198626e1de$export$e16d8520af44a096(source, destination, transformFn) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    if (!(sourceCode in $11b5dd198626e1de$var$transforms)) $11b5dd198626e1de$var$transforms[sourceCode] = {};
    $11b5dd198626e1de$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $11b5dd198626e1de$export$cd7f480d6b8286c3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    const transform = $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    delete $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    if ((0, $gn0g3.isEmpty)($11b5dd198626e1de$var$transforms[sourceCode])) delete $11b5dd198626e1de$var$transforms[sourceCode];
    return transform;
}
function $11b5dd198626e1de$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    let transform;
    if (sourceCode in $11b5dd198626e1de$var$transforms && destinationCode in $11b5dd198626e1de$var$transforms[sourceCode]) transform = $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    return transform;
}

});

parcelRegister("9pD6L", function(module, exports) {

$parcel$export(module.exports, "boundingExtent", () => $6da4c8ed3074c92b$export$8aceca7c77505534);
$parcel$export(module.exports, "createEmpty", () => $6da4c8ed3074c92b$export$fe201bb3bbe031e9);
$parcel$export(module.exports, "extendCoordinate", () => $6da4c8ed3074c92b$export$1f820e3920fa5715);
$parcel$export(module.exports, "createOrUpdate", () => $6da4c8ed3074c92b$export$958e3e1a02eac4b6);
$parcel$export(module.exports, "buffer", () => $6da4c8ed3074c92b$export$ab1029bcae9ddb4a);
$parcel$export(module.exports, "clone", () => $6da4c8ed3074c92b$export$9cd59f9826255e47);
$parcel$export(module.exports, "closestSquaredDistanceXY", () => $6da4c8ed3074c92b$export$cbe64c389534206f);
$parcel$export(module.exports, "containsCoordinate", () => $6da4c8ed3074c92b$export$ac68c24d37ca240f);
$parcel$export(module.exports, "containsXY", () => $6da4c8ed3074c92b$export$805bdfd6d6690e97);
$parcel$export(module.exports, "containsExtent", () => $6da4c8ed3074c92b$export$be866b1e0809b17e);
$parcel$export(module.exports, "coordinateRelationship", () => $6da4c8ed3074c92b$export$f97905ead28c61a8);
$parcel$export(module.exports, "createOrUpdateEmpty", () => $6da4c8ed3074c92b$export$3e2152b047719fa1);
$parcel$export(module.exports, "createOrUpdateFromCoordinate", () => $6da4c8ed3074c92b$export$4838bf78d04a9440);
$parcel$export(module.exports, "createOrUpdateFromFlatCoordinates", () => $6da4c8ed3074c92b$export$be0ab0bf96ca59ca);
$parcel$export(module.exports, "extendFlatCoordinates", () => $6da4c8ed3074c92b$export$30570204156ffd18);
$parcel$export(module.exports, "equals", () => $6da4c8ed3074c92b$export$e9bab7fafb253603);
$parcel$export(module.exports, "extend", () => $6da4c8ed3074c92b$export$8b58be045bf06082);
$parcel$export(module.exports, "forEachCorner", () => $6da4c8ed3074c92b$export$f9ed8a3d123a08e2);
$parcel$export(module.exports, "getBottomLeft", () => $6da4c8ed3074c92b$export$8d09f5e2e1bf560d);
$parcel$export(module.exports, "getBottomRight", () => $6da4c8ed3074c92b$export$e77c1cf70445e168);
$parcel$export(module.exports, "getTopRight", () => $6da4c8ed3074c92b$export$b84fa077c8b05295);
$parcel$export(module.exports, "getTopLeft", () => $6da4c8ed3074c92b$export$cb1538b07e6964ff);
$parcel$export(module.exports, "getArea", () => $6da4c8ed3074c92b$export$520c40045967cb15);
$parcel$export(module.exports, "isEmpty", () => $6da4c8ed3074c92b$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getWidth", () => $6da4c8ed3074c92b$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getHeight", () => $6da4c8ed3074c92b$export$c08559766941f856);
$parcel$export(module.exports, "getCenter", () => $6da4c8ed3074c92b$export$c91255cadecfe081);
$parcel$export(module.exports, "getCorner", () => $6da4c8ed3074c92b$export$a1cfd206661d0801);
$parcel$export(module.exports, "getForViewAndSize", () => $6da4c8ed3074c92b$export$13ba650faf8308);
$parcel$export(module.exports, "getRotatedViewport", () => $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac);
$parcel$export(module.exports, "getIntersection", () => $6da4c8ed3074c92b$export$72209efa88586d42);
$parcel$export(module.exports, "intersects", () => $6da4c8ed3074c92b$export$7b0a31e10bbff018);
$parcel$export(module.exports, "returnOrUpdate", () => $6da4c8ed3074c92b$export$6a4fe494c558c238);
$parcel$export(module.exports, "intersectsSegment", () => $6da4c8ed3074c92b$export$a6a5a7a461419425);
$parcel$export(module.exports, "applyTransform", () => $6da4c8ed3074c92b$export$9f9dcb98c894b623);
$parcel$export(module.exports, "wrapX", () => $6da4c8ed3074c92b$export$39a9ce3624977b84);
$parcel$export(module.exports, "wrapAndSliceX", () => $6da4c8ed3074c92b$export$9031237f01de0947);
/**
 * @module ol/extent
 */ 
var $iM9A6 = parcelRequire("iM9A6");
function $6da4c8ed3074c92b$export$8aceca7c77505534(coordinates) {
    const extent = $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [dest] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, dest) {
    const minX = Math.min.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxX = Math.max.apply(null, xs);
    const maxY = Math.max.apply(null, ys);
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest);
}
function $6da4c8ed3074c92b$export$ab1029bcae9ddb4a(extent, value, dest) {
    if (dest) {
        dest[0] = extent[0] - value;
        dest[1] = extent[1] - value;
        dest[2] = extent[2] + value;
        dest[3] = extent[3] + value;
        return dest;
    }
    return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $6da4c8ed3074c92b$export$9cd59f9826255e47(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent.slice();
}
function $6da4c8ed3074c92b$export$cbe64c389534206f(extent, x, y) {
    let dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $6da4c8ed3074c92b$export$ac68c24d37ca240f(extent, coordinate) {
    return $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $6da4c8ed3074c92b$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, coordinate) {
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const x = coordinate[0];
    const y = coordinate[1];
    let relationship = (0, $iM9A6.default).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $iM9A6.default).LEFT;
    else if (x > maxX) relationship = relationship | (0, $iM9A6.default).RIGHT;
    if (y < minY) relationship = relationship | (0, $iM9A6.default).BELOW;
    else if (y > maxY) relationship = relationship | (0, $iM9A6.default).ABOVE;
    if (relationship === (0, $iM9A6.default).UNKNOWN) relationship = (0, $iM9A6.default).INTERSECTING;
    return relationship;
}
function $6da4c8ed3074c92b$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest) {
    if (dest) {
        dest[0] = minX;
        dest[1] = minY;
        dest[2] = maxX;
        dest[3] = maxY;
        return dest;
    }
    return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $6da4c8ed3074c92b$export$3e2152b047719fa1(dest) {
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, dest);
}
function $6da4c8ed3074c92b$export$4838bf78d04a9440(coordinate, dest) {
    const x = coordinate[0];
    const y = coordinate[1];
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(x, y, x, y, dest);
}
function $6da4c8ed3074c92b$export$29e3ad4dbd0cb863(coordinates, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates);
}
function $6da4c8ed3074c92b$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $6da4c8ed3074c92b$export$73b4897e93bc5c83(rings, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings);
}
function $6da4c8ed3074c92b$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $6da4c8ed3074c92b$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $6da4c8ed3074c92b$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings) {
    for(let i = 0, ii = rings.length; i < ii; ++i)$6da4c8ed3074c92b$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $6da4c8ed3074c92b$export$f9ed8a3d123a08e2(extent, callback) {
    let val;
    val = callback($6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $6da4c8ed3074c92b$export$520c40045967cb15(extent) {
    let area = 0;
    if (!$6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent)) area = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) * $6da4c8ed3074c92b$export$c08559766941f856(extent);
    return area;
}
function $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $6da4c8ed3074c92b$export$a1cfd206661d0801(extent, corner) {
    let coordinate;
    if (corner === "bottom-left") coordinate = $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent);
    else if (corner === "bottom-right") coordinate = $6da4c8ed3074c92b$export$e77c1cf70445e168(extent);
    else if (corner === "top-left") coordinate = $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent);
    else if (corner === "top-right") coordinate = $6da4c8ed3074c92b$export$b84fa077c8b05295(extent);
    else throw new Error("Invalid corner");
    return coordinate;
}
function $6da4c8ed3074c92b$export$7d6fa884b32a3751(extent1, extent2) {
    const minX = Math.min(extent1[0], extent2[0]);
    const minY = Math.min(extent1[1], extent2[1]);
    const maxX = Math.max(extent1[2], extent2[2]);
    const maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $6da4c8ed3074c92b$export$13ba650faf8308(center, resolution, rotation, size, dest) {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac(center, resolution, rotation, size);
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), dest);
}
function $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac(center, resolution, rotation, size) {
    const dx = resolution * size[0] / 2;
    const dy = resolution * size[1] / 2;
    const cosRotation = Math.cos(rotation);
    const sinRotation = Math.sin(rotation);
    const xCos = dx * cosRotation;
    const xSin = dx * sinRotation;
    const yCos = dy * cosRotation;
    const ySin = dy * sinRotation;
    const x = center[0];
    const y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function $6da4c8ed3074c92b$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $6da4c8ed3074c92b$export$f3fe0e9a60cde324(extent1, extent2) {
    const intersection = $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2);
    return $6da4c8ed3074c92b$export$520c40045967cb15(intersection);
}
function $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2, dest) {
    const intersection = dest ? dest : $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    if ($6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $6da4c8ed3074c92b$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $6da4c8ed3074c92b$export$1bc603050bd777b1(extent) {
    return $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) + $6da4c8ed3074c92b$export$c08559766941f856(extent);
}
function $6da4c8ed3074c92b$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $6da4c8ed3074c92b$export$6a4fe494c558c238(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent;
}
function $6da4c8ed3074c92b$export$80cbab86674143b6(extent, value) {
    const deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    const deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $6da4c8ed3074c92b$export$a6a5a7a461419425(extent, start, end) {
    let intersects = false;
    const startRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, start);
    const endRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $iM9A6.default).INTERSECTING || endRel === (0, $iM9A6.default).INTERSECTING) intersects = true;
    else {
        const minX = extent[0];
        const minY = extent[1];
        const maxX = extent[2];
        const maxY = extent[3];
        const startX = start[0];
        const startY = start[1];
        const endX = end[0];
        const endY = end[1];
        const slope = (endY - startY) / (endX - startX);
        let x, y;
        if (!!(endRel & (0, $iM9A6.default).ABOVE) && !(startRel & (0, $iM9A6.default).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $iM9A6.default).RIGHT) && !(startRel & (0, $iM9A6.default).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $iM9A6.default).BELOW) && !(startRel & (0, $iM9A6.default).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $iM9A6.default).LEFT) && !(startRel & (0, $iM9A6.default).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $6da4c8ed3074c92b$export$9f9dcb98c894b623(extent, transformFn, dest, stops) {
    if ($6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent)) return $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    let coordinates = [];
    if (stops > 1) {
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        for(let i = 0; i < stops; ++i)coordinates.push(extent[0] + width * i / stops, extent[1], extent[2], extent[1] + height * i / stops, extent[2] - width * i / stops, extent[3], extent[0], extent[3] - height * i / stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    const xs = [];
    const ys = [];
    for(let i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, dest);
}
function $6da4c8ed3074c92b$export$39a9ce3624977b84(extent, projection) {
    const projectionExtent = projection.getExtent();
    const center = $6da4c8ed3074c92b$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        const worldWidth = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(projectionExtent);
        const worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        const offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function $6da4c8ed3074c92b$export$9031237f01de0947(extent, projection, multiWorld) {
    if (projection.canWrapX()) {
        const projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        $6da4c8ed3074c92b$export$39a9ce3624977b84(extent, projection);
        const worldWidth = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(projectionExtent);
        if ($6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) > worldWidth && !multiWorld) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}

});
parcelRegister("iM9A6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab4245bc22b806c$export$2e2bcd8739ae039);
/**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $dab4245bc22b806c$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};

});


parcelRegister("2o3CH", function(module, exports) {

$parcel$export(module.exports, "add", () => $1bd0a226f9a16141$export$e16d8520af44a096);
$parcel$export(module.exports, "equals", () => $1bd0a226f9a16141$export$e9bab7fafb253603);
$parcel$export(module.exports, "rotate", () => $1bd0a226f9a16141$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $1bd0a226f9a16141$export$dcdf75081b88279d);
$parcel$export(module.exports, "wrapX", () => $1bd0a226f9a16141$export$39a9ce3624977b84);
$parcel$export(module.exports, "getWorldsAway", () => $1bd0a226f9a16141$export$24e2b27d1ff0c1d5);
/**
 * @module ol/coordinate
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $lVIA6 = parcelRequire("lVIA6");
function $1bd0a226f9a16141$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $1bd0a226f9a16141$export$cbe80a3fcd2b99b7(coordinate, circle) {
    const r = circle.getRadius();
    const center = circle.getCenter();
    const x0 = center[0];
    const y0 = center[1];
    const x1 = coordinate[0];
    const y1 = coordinate[1];
    let dx = x1 - x0;
    const dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    const d = Math.sqrt(dx * dx + dy * dy);
    const x = x0 + r * dx / d;
    const y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment) {
    const x0 = coordinate[0];
    const y0 = coordinate[1];
    const start = segment[0];
    const end = segment[1];
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    let x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$35ad6765fe262b6(fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, fractionDigits);
    });
}
function $1bd0a226f9a16141$export$6eb0ac5f024d8590(hemispheres, degrees, fractionDigits) {
    const normalizedDegrees = (0, $9byFX.modulo)(degrees + 180, 360) - 180;
    const x = Math.abs(3600 * normalizedDegrees);
    const decimals = fractionDigits || 0;
    let deg = Math.floor(x / 3600);
    let min = Math.floor((x - deg * 3600) / 60);
    let sec = (0, $9byFX.toFixed)(x - deg * 3600 - min * 60, decimals);
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    let hdms = deg + "\xb0";
    if (min !== 0 || sec !== 0) hdms += " " + (0, $lVIA6.padNumber)(min, 2) + "\u2032";
    if (sec !== 0) hdms += " " + (0, $lVIA6.padNumber)(sec, 2, decimals) + "\u2033";
    if (normalizedDegrees !== 0) hdms += " " + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
    return hdms;
}
function $1bd0a226f9a16141$export$d9468344d3651243(coordinate, template, fractionDigits) {
    if (coordinate) return template.replace("{x}", coordinate[0].toFixed(fractionDigits)).replace("{y}", coordinate[1].toFixed(fractionDigits));
    return "";
}
function $1bd0a226f9a16141$export$e9bab7fafb253603(coordinate1, coordinate2) {
    let equals = true;
    for(let i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $1bd0a226f9a16141$export$bb628a54ab399bc9(coordinate, angle) {
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    const y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $1bd0a226f9a16141$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2) {
    const dx = coord1[0] - coord2[0];
    const dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $1bd0a226f9a16141$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2));
}
function $1bd0a226f9a16141$export$6985570514055196(coordinate, segment) {
    return $1bd0a226f9a16141$export$88e6ebb4fe54f538(coordinate, $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment));
}
function $1bd0a226f9a16141$export$c883fd238161f841(coordinate, fractionDigits) {
    if (coordinate) return $1bd0a226f9a16141$export$6eb0ac5f024d8590("NS", coordinate[1], fractionDigits) + " " + $1bd0a226f9a16141$export$6eb0ac5f024d8590("EW", coordinate[0], fractionDigits);
    return "";
}
function $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, fractionDigits) {
    return $1bd0a226f9a16141$export$d9468344d3651243(coordinate, "{x}, {y}", fractionDigits);
}
function $1bd0a226f9a16141$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        const worldWidth = (0, $9pD6L.getWidth)(projection.getExtent());
        const worldsAway = $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, sourceExtentWidth) {
    const projectionExtent = projection.getExtent();
    let worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        sourceExtentWidth = sourceExtentWidth || (0, $9pD6L.getWidth)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}

});
parcelRegister("lVIA6", function(module, exports) {

$parcel$export(module.exports, "padNumber", () => $ff7180bdd45ebb19$export$24be126cb0a7bbeb);
/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ function $ff7180bdd45ebb19$export$24be126cb0a7bbeb(number, width, precision) {
    const numberString = precision !== undefined ? number.toFixed(precision) : "" + number;
    let decimal = numberString.indexOf(".");
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join("0") + numberString;
}
function $ff7180bdd45ebb19$export$66e1c0999abad646(v1, v2) {
    const s1 = ("" + v1).split(".");
    const s2 = ("" + v2).split(".");
    for(let i = 0; i < Math.max(s1.length, s2.length); i++){
        const n1 = parseInt(s1[i] || "0", 10);
        const n2 = parseInt(s2[i] || "0", 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}

});


parcelRegister("lAvh5", function(module, exports) {

$parcel$export(module.exports, "getDistance", () => $fb75384508533d8f$export$79376507b09a66f);
$parcel$export(module.exports, "getLength", () => $fb75384508533d8f$export$f0d11c074a923179);
$parcel$export(module.exports, "offset", () => $fb75384508533d8f$export$cc800923e997bb8);
/**
 * @module ol/sphere
 */ 
var $9byFX = parcelRequire("9byFX");
const $fb75384508533d8f$export$63f2df7bd7371262 = 6371008.8;
function $fb75384508533d8f$export$79376507b09a66f(c1, c2, radius) {
    radius = radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const lat1 = (0, $9byFX.toRadians)(c1[1]);
    const lat2 = (0, $9byFX.toRadians)(c2[1]);
    const deltaLatBy2 = (lat2 - lat1) / 2;
    const deltaLonBy2 = (0, $9byFX.toRadians)(c2[0] - c1[0]) / 2;
    const a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $fb75384508533d8f$var$getLengthInternal(coordinates, radius) {
    let length = 0;
    for(let i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $fb75384508533d8f$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $fb75384508533d8f$export$f0d11c074a923179(geometry, options) {
    options = options || {};
    const radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const projection = options.projection || "EPSG:3857";
    const type = geometry.getType();
    if (type !== "GeometryCollection") geometry = geometry.clone().transform(projection, "EPSG:4326");
    let length = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case "Point":
        case "MultiPoint":
            break;
        case "LineString":
        case "LinearRing":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $fb75384508533d8f$var$getLengthInternal(coordinates, radius);
            break;
        case "MultiLineString":
        case "Polygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $fb75384508533d8f$var$getLengthInternal(coordinates[i], radius);
            break;
        case "MultiPolygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $fb75384508533d8f$var$getLengthInternal(coords[j], radius);
            }
            break;
        case "GeometryCollection":
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)length += $fb75384508533d8f$export$f0d11c074a923179(geometries[i], options);
                break;
            }
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $fb75384508533d8f$var$getAreaInternal(coordinates, radius) {
    let area = 0;
    const len = coordinates.length;
    let x1 = coordinates[len - 1][0];
    let y1 = coordinates[len - 1][1];
    for(let i = 0; i < len; i++){
        const x2 = coordinates[i][0];
        const y2 = coordinates[i][1];
        area += (0, $9byFX.toRadians)(x2 - x1) * (2 + Math.sin((0, $9byFX.toRadians)(y1)) + Math.sin((0, $9byFX.toRadians)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $fb75384508533d8f$export$520c40045967cb15(geometry, options) {
    options = options || {};
    const radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const projection = options.projection || "EPSG:3857";
    const type = geometry.getType();
    if (type !== "GeometryCollection") geometry = geometry.clone().transform(projection, "EPSG:4326");
    let area = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case "Point":
        case "MultiPoint":
        case "LineString":
        case "MultiLineString":
        case "LinearRing":
            break;
        case "Polygon":
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[i], radius));
            break;
        case "MultiPolygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($fb75384508533d8f$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coords[j], radius));
            }
            break;
        case "GeometryCollection":
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)area += $fb75384508533d8f$export$520c40045967cb15(geometries[i], options);
                break;
            }
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return area;
}
function $fb75384508533d8f$export$cc800923e997bb8(c1, distance, bearing, radius) {
    radius = radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const lat1 = (0, $9byFX.toRadians)(c1[1]);
    const lon1 = (0, $9byFX.toRadians)(c1[0]);
    const dByR = distance / radius;
    const lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    const lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $9byFX.toDegrees)(lon),
        (0, $9byFX.toDegrees)(lat)
    ];
}

});

parcelRegister("c3kwQ", function(module, exports) {

$parcel$export(module.exports, "warn", () => $8c65b0699f3f3f8e$export$c106dd0671a0fc2d);
/**
 * @module ol/console
 */ /**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */ /**
 * @type {Object<Level, number>}
 */ const $8c65b0699f3f3f8e$var$levels = {
    info: 1,
    warn: 2,
    error: 3,
    none: 4
};
/**
 * @type {number}
 */ let $8c65b0699f3f3f8e$var$level = $8c65b0699f3f3f8e$var$levels.info;
function $8c65b0699f3f3f8e$export$2c97a59140dbf245(l) {
    $8c65b0699f3f3f8e$var$level = $8c65b0699f3f3f8e$var$levels[l];
}
function $8c65b0699f3f3f8e$export$bef1f36f5486a6a3(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.info) return;
    console.log(...args); // eslint-disable-line no-console
}
function $8c65b0699f3f3f8e$export$c106dd0671a0fc2d(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.warn) return;
    console.warn(...args); // eslint-disable-line no-console
}
function $8c65b0699f3f3f8e$export$a3bc9b8ed74fc(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.error) return;
    console.error(...args); // eslint-disable-line no-console
}

});


parcelRegister("fi2rl", function(module, exports) {

$parcel$export(module.exports, "createExtent", () => $b21a6e049949bb31$export$c2f0af2c946f6897);
$parcel$export(module.exports, "none", () => $b21a6e049949bb31$export$f883a24d5edde77c);
/**
 * @module ol/centerconstraint
 */ 
var $9byFX = parcelRequire("9byFX");
function $b21a6e049949bb31$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, isMoving, centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        const viewWidth = onlyCenter ? 0 : size[0] * resolution;
        const viewHeight = onlyCenter ? 0 : size[1] * resolution;
        const shiftX = centerShift ? centerShift[0] : 0;
        const shiftY = centerShift ? centerShift[1] : 0;
        let minX = extent[0] + viewWidth / 2 + shiftX;
        let maxX = extent[2] - viewWidth / 2 + shiftX;
        let minY = extent[1] + viewHeight / 2 + shiftY;
        let maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        let x = (0, $9byFX.clamp)(center[0], minX, maxX);
        let y = (0, $9byFX.clamp)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (isMoving && smooth && resolution) {
            const ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function $b21a6e049949bb31$export$f883a24d5edde77c(center) {
    return center;
}

});

parcelRegister("g29x3", function(module, exports) {

$parcel$export(module.exports, "createSnapToResolutions", () => $bac43a1f4a628548$export$d65a517690fc4385);
$parcel$export(module.exports, "createSnapToPower", () => $bac43a1f4a628548$export$22ac0f6b219de91a);
$parcel$export(module.exports, "createMinMaxResolution", () => $bac43a1f4a628548$export$1c4e6da9b4b066fe);
/**
 * @module ol/resolutionconstraint
 */ 
var $9byFX = parcelRequire("9byFX");

var $9pD6L = parcelRequire("9pD6L");

var $fVVyM = parcelRequire("fVVyM");
/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $bac43a1f4a628548$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    const xResolution = (0, $9pD6L.getWidth)(maxExtent) / viewportSize[0];
    const yResolution = (0, $9pD6L.getHeight)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    let result = Math.min(resolution, maxResolution);
    const ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $9byFX.clamp)(result, minResolution / 2, maxResolution * 2);
}
function $bac43a1f4a628548$export$d65a517690fc4385(resolutions, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const maxResolution = resolutions[0];
            const minResolution = resolutions[resolutions.length - 1];
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $9byFX.clamp)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const capped = Math.min(cappedMaxRes, resolution);
            const z = Math.floor((0, $fVVyM.linearFindNearest)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        }
        return undefined;
    });
}
function $bac43a1f4a628548$export$22ac0f6b219de91a(power, maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    minResolution = minResolution !== undefined ? minResolution : 0;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $9byFX.clamp)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const tolerance = 1e-9;
            const minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            const offset = -direction * (0.5 - tolerance) + 0.5;
            const capped = Math.min(cappedMaxRes, resolution);
            const cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            const zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            const newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $9byFX.clamp)(newResolution, minResolution, cappedMaxRes);
        }
        return undefined;
    });
}
function $bac43a1f4a628548$export$1c4e6da9b4b066fe(maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            if (!smooth || !isMoving) return (0, $9byFX.clamp)(resolution, minResolution, cappedMaxRes);
            return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        return undefined;
    });
}

});

parcelRegister("ip5LZ", function(module, exports) {

$parcel$export(module.exports, "disable", () => $d65f0a322291d127$export$e20fbacbb41798b);
$parcel$export(module.exports, "none", () => $d65f0a322291d127$export$f883a24d5edde77c);
$parcel$export(module.exports, "createSnapToN", () => $d65f0a322291d127$export$9ba78806de831083);
$parcel$export(module.exports, "createSnapToZero", () => $d65f0a322291d127$export$17a6e6f3448b17e8);
/**
 * @module ol/rotationconstraint
 */ 
var $9byFX = parcelRequire("9byFX");
function $d65f0a322291d127$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    return undefined;
}
function $d65f0a322291d127$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    return undefined;
}
function $d65f0a322291d127$export$9ba78806de831083(n) {
    const theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        return undefined;
    });
}
function $d65f0a322291d127$export$17a6e6f3448b17e8(tolerance) {
    const t = tolerance === undefined ? (0, $9byFX.toRadians)(5) : tolerance;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving || rotation === undefined) return rotation;
        if (Math.abs(rotation) <= t) return 0;
        return rotation;
    });
}

});

parcelRegister("h9x7v", function(module, exports) {

$parcel$export(module.exports, "easeIn", () => $c7ccf7e681a9b333$export$929e5a82286172a6);
$parcel$export(module.exports, "easeOut", () => $c7ccf7e681a9b333$export$57636bb43b1ccbb0);
$parcel$export(module.exports, "inAndOut", () => $c7ccf7e681a9b333$export$9b47139b511b56e4);
$parcel$export(module.exports, "linear", () => $c7ccf7e681a9b333$export$45db2fc2f15997e7);
/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $c7ccf7e681a9b333$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $c7ccf7e681a9b333$export$57636bb43b1ccbb0(t) {
    return 1 - $c7ccf7e681a9b333$export$929e5a82286172a6(1 - t);
}
function $c7ccf7e681a9b333$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $c7ccf7e681a9b333$export$45db2fc2f15997e7(t) {
    return t;
}
function $c7ccf7e681a9b333$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * t);
    return 1 - $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * (t - 0.5));
}

});

parcelRegister("5ydre", function(module, exports) {

$parcel$export(module.exports, "default", () => $40aa8d43bbe572bf$export$2e2bcd8739ae039);
$parcel$export(module.exports, "fromExtent", () => $40aa8d43bbe572bf$export$c16b671815801c75);
/**
 * @module ol/geom/Polygon
 */ 
var $7fV57 = parcelRequire("7fV57");

var $9vPkX = parcelRequire("9vPkX");

var $h7zsK = parcelRequire("h7zsK");

var $gqtzW = parcelRequire("gqtzW");

var $9pD6L = parcelRequire("9pD6L");

var $9bJty = parcelRequire("9bJty");

var $fVVyM = parcelRequire("fVVyM");

var $2RNwh = parcelRequire("2RNwh");

var $7eSHW = parcelRequire("7eSHW");

var $eQvue = parcelRequire("eQvue");

var $alOgM = parcelRequire("alOgM");

var $aCXb5 = parcelRequire("aCXb5");

var $33weL = parcelRequire("33weL");

var $9byFX = parcelRequire("9byFX");

var $bDhby = parcelRequire("bDhby");

var $lAvh5 = parcelRequire("lAvh5");
/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ class $40aa8d43bbe572bf$var$Polygon extends (0, $h7zsK.default) {
    /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
    }
    /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ appendLinearRing(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $fVVyM.extend)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   */ clone() {
        const polygon = new $40aa8d43bbe572bf$var$Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $gqtzW.arrayMaxSquaredDelta)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $gqtzW.assignClosestArrayPoint)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        return (0, $33weL.linearRingsContainsXY)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    }
    /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $aCXb5.linearRings)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $alOgM.orientLinearRings)(flatCoordinates, 0, this.ends_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $7eSHW.inflateCoordinatesArray)(flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * @return {Array<number>} Interior point.
   */ getFlatInteriorPoint() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            const flatCenter = (0, $9pD6L.getCenter)(this.getExtent());
            this.flatInteriorPoint_ = (0, $2RNwh.getInteriorPointOfArray)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return /** @type {import("../coordinate.js").Coordinate} */ this.flatInteriorPoint_;
    }
    /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoint() {
        return new (0, $9vPkX.default)(this.getFlatInteriorPoint(), "XYM");
    }
    /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ getLinearRingCount() {
        return this.ends_.length;
    }
    /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */ getLinearRing(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $7fV57.default)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ getLinearRings() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const linearRings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const linearRing = new (0, $7fV57.default)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $alOgM.linearRingsAreOriented)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $alOgM.orientLinearRings)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $bDhby.quantizeArray)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $40aa8d43bbe572bf$var$Polygon(simplifiedFlatCoordinates, "XY", simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "Polygon";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return (0, $eQvue.intersectsLinearRingArray)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $9bJty.deflateCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $40aa8d43bbe572bf$export$2e2bcd8739ae039 = $40aa8d43bbe572bf$var$Polygon;
function $40aa8d43bbe572bf$export$f99d756c6d81ae3f(center, radius, n, sphereRadius) {
    n = n ? n : 32;
    /** @type {Array<number>} */ const flatCoordinates = [];
    for(let i = 0; i < n; ++i)(0, $fVVyM.extend)(flatCoordinates, (0, $lAvh5.offset)(center, radius, 2 * Math.PI * i / n, sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, "XY", [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$c16b671815801c75(extent) {
    if ((0, $9pD6L.isEmpty)(extent)) throw new Error("Cannot create polygon from empty extent");
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, "XY", [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$2451009d645fb8c2(circle, sides, angle) {
    sides = sides ? sides : 32;
    const stride = circle.getStride();
    const layout = circle.getLayout();
    const center = circle.getCenter();
    const arrayLength = stride * (sides + 1);
    const flatCoordinates = new Array(arrayLength);
    for(let i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(let j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    const ends = [
        flatCoordinates.length
    ];
    const polygon = new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, layout, ends);
    $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), angle);
    return polygon;
}
function $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, radius, angle) {
    const flatCoordinates = polygon.getFlatCoordinates();
    const stride = polygon.getStride();
    const sides = flatCoordinates.length / stride - 1;
    const startAngle = angle ? angle : 0;
    for(let i = 0; i <= sides; ++i){
        const offset = i * stride;
        const angle = startAngle + (0, $9byFX.modulo)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}

});
parcelRegister("7fV57", function(module, exports) {

$parcel$export(module.exports, "default", () => $548636579b4087f2$export$2e2bcd8739ae039);
/**
 * @module ol/geom/LinearRing
 */ 
var $h7zsK = parcelRequire("h7zsK");

var $gqtzW = parcelRequire("gqtzW");

var $9pD6L = parcelRequire("9pD6L");

var $9bJty = parcelRequire("9bJty");

var $bDhby = parcelRequire("bDhby");

var $7eSHW = parcelRequire("7eSHW");

var $aCXb5 = parcelRequire("aCXb5");
/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ class $548636579b4087f2$var$LinearRing extends (0, $h7zsK.default) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   */ clone() {
        return new $548636579b4087f2$var$LinearRing(this.flatCoordinates.slice(), this.layout);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $gqtzW.maxSquaredDelta)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $gqtzW.assignClosestPoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $aCXb5.linearRing)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */ getCoordinates() {
        return (0, $7eSHW.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $bDhby.douglasPeucker)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $548636579b4087f2$var$LinearRing(simplifiedFlatCoordinates, "XY");
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "LinearRing";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return false;
    }
    /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $9bJty.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $548636579b4087f2$export$2e2bcd8739ae039 = $548636579b4087f2$var$LinearRing;

});
parcelRegister("h7zsK", function(module, exports) {

$parcel$export(module.exports, "transformGeom2D", () => $c76e993e57efc8c4$export$a3767472617c7861);
$parcel$export(module.exports, "default", () => $c76e993e57efc8c4$export$2e2bcd8739ae039);
/**
 * @module ol/geom/SimpleGeometry
 */ 
var $6WoYU = parcelRequire("6WoYU");

var $9iPUS = parcelRequire("9iPUS");

var $9pD6L = parcelRequire("9pD6L");

var $1MAUi = parcelRequire("1MAUi");
/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ class $c76e993e57efc8c4$var$SimpleGeometry extends (0, $6WoYU.default) {
    constructor(){
        super();
        /**
     * @protected
     * @type {import("./Geometry.js").GeometryLayout}
     */ this.layout = "XY";
        /**
     * @protected
     * @type {number}
     */ this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ this.flatCoordinates;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $9pD6L.createOrUpdateFromFlatCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */ getCoordinates() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ getFirstCoordinate() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getFlatCoordinates() {
        return this.flatCoordinates;
    }
    /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ getLastCoordinate() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    }
    /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */ getLayout() {
        return this.layout;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        const simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        // Simplification did not actually remove any coordinates.  We now know
        // that any calls to getSimplifiedGeometry with a squaredTolerance less
        // than or equal to the current squaredTolerance will also not have any
        // effect.  This allows us to short circuit simplification (saving CPU
        // cycles) and prevents the cache of simplified geometries from filling
        // up with useless identical copies of this geometry (saving memory).
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        return this;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride;
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ setFlatCoordinates(layout, flatCoordinates) {
        this.stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    }
    /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ setCoordinates(coordinates, layout) {
        (0, $9iPUS.abstract)();
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ setLayout(layout, coordinates, nesting) {
        let stride;
        if (layout) stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        else {
            for(let i = 0; i < nesting; ++i){
                if (coordinates.length === 0) {
                    this.layout = "XY";
                    this.stride = 2;
                    return;
                }
                coordinates = /** @type {Array<unknown>} */ coordinates[0];
            }
            stride = coordinates.length;
            layout = $c76e993e57efc8c4$export$61bb6938093db2c8(stride);
        }
        this.layout = layout;
        this.stride = stride;
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   */ applyTransform(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.stride);
            this.changed();
        }
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $1MAUi.rotate)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        if (sy === undefined) sy = sx;
        if (!anchor) anchor = (0, $9pD6L.getCenter)(this.getExtent());
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $1MAUi.scale)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $1MAUi.translate)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    }
}
function $c76e993e57efc8c4$export$61bb6938093db2c8(stride) {
    let layout;
    if (stride == 2) layout = "XY";
    else if (stride == 3) layout = "XYZ";
    else if (stride == 4) layout = "XYZM";
    return /** @type {import("./Geometry.js").GeometryLayout} */ layout;
}
function $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout) {
    let stride;
    if (layout == "XY") stride = 2;
    else if (layout == "XYZ" || layout == "XYM") stride = 3;
    else if (layout == "XYZM") stride = 4;
    return /** @type {number} */ stride;
}
function $c76e993e57efc8c4$export$a3767472617c7861(simpleGeometry, transform, dest) {
    const flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    const stride = simpleGeometry.getStride();
    return (0, $1MAUi.transform2D)(flatCoordinates, 0, flatCoordinates.length, stride, transform, dest);
}
var $c76e993e57efc8c4$export$2e2bcd8739ae039 = $c76e993e57efc8c4$var$SimpleGeometry;

});
parcelRegister("6WoYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $50db89a00eb954f6$export$2e2bcd8739ae039);
/**
 * @module ol/geom/Geometry
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $9iPUS = parcelRequire("9iPUS");

var $jpXrt = parcelRequire("jpXrt");

var $9pD6L = parcelRequire("9pD6L");

var $dpRHA = parcelRequire("dpRHA");

var $6wUzV = parcelRequire("6wUzV");

var $1MAUi = parcelRequire("1MAUi");
/**
 * @typedef {'XY' | 'XYZ' | 'XYM' | 'XYZM'} GeometryLayout
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available.
 */ /**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $50db89a00eb954f6$var$tmpTransform = (0, $jpXrt.create)();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ class $50db89a00eb954f6$var$Geometry extends (0, $fFFY7.default) {
    constructor(){
        super();
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = (0, $9pD6L.createEmpty)();
        /**
     * @private
     * @type {number}
     */ this.extentRevision_ = -1;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryRevision = 0;
        /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ this.simplifyTransformedInternal = (0, $6wUzV.memoizeOne)((revision, squaredTolerance, transform)=>{
            if (!transform) return this.getSimplifiedGeometry(squaredTolerance);
            const clone = this.clone();
            clone.applyTransform(transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, transform);
    }
    /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ clone() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        const coord = this.getClosestPoint([
            x,
            y
        ]);
        return coord[0] === x && coord[1] === y;
    }
    /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ getClosestPoint(point, closestPoint) {
        closestPoint = closestPoint ? closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    }
    /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ intersectsCoordinate(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ getExtent(extent) {
        if (this.extentRevision_ != this.getRevision()) {
            const extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, $9pD6L.createOrUpdateEmpty)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $9pD6L.returnOrUpdate)(this.extent_, extent);
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        (0, $9iPUS.abstract)();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        (0, $9iPUS.abstract)();
    }
    /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ simplify(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */ getType() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */ applyTransform(transformFn) {
        (0, $9iPUS.abstract)();
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ intersectsExtent(extent) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        (0, $9iPUS.abstract)();
    }
    /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {this} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ transform(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ const sourceProj = (0, $dpRHA.get)(source);
        const transformFn = sourceProj.getUnits() == "tile-pixels" ? function(inCoordinates, outCoordinates, stride) {
            const pixelExtent = sourceProj.getExtent();
            const projectedExtent = sourceProj.getWorldExtent();
            const scale = (0, $9pD6L.getHeight)(projectedExtent) / (0, $9pD6L.getHeight)(pixelExtent);
            (0, $jpXrt.compose)($50db89a00eb954f6$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $1MAUi.transform2D)(inCoordinates, 0, inCoordinates.length, stride, $50db89a00eb954f6$var$tmpTransform, outCoordinates);
            return (0, $dpRHA.getTransform)(sourceProj, destination)(inCoordinates, outCoordinates, stride);
        } : (0, $dpRHA.getTransform)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    }
}
var $50db89a00eb954f6$export$2e2bcd8739ae039 = $50db89a00eb954f6$var$Geometry;

});
parcelRegister("jpXrt", function(module, exports) {

$parcel$export(module.exports, "create", () => $e22e7611e69f42a9$export$185802fd694ee1f5);
$parcel$export(module.exports, "setFromArray", () => $e22e7611e69f42a9$export$42b4187a82d80ed0);
$parcel$export(module.exports, "apply", () => $e22e7611e69f42a9$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "compose", () => $e22e7611e69f42a9$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "toString", () => $e22e7611e69f42a9$export$f84e8e69fd4488a5);
$parcel$export(module.exports, "makeInverse", () => $e22e7611e69f42a9$export$bd70ea2a93c0fa4);
/**
 * @module ol/transform
 */ 
var $4Cz58 = parcelRequire("4Cz58");
/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ const $e22e7611e69f42a9$var$tmp_ = new Array(6);
function $e22e7611e69f42a9$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $e22e7611e69f42a9$export$aad8462122ac592b(transform) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $e22e7611e69f42a9$export$2060d2db72cce88f(transform1, transform2) {
    const a1 = transform1[0];
    const b1 = transform1[1];
    const c1 = transform1[2];
    const d1 = transform1[3];
    const e1 = transform1[4];
    const f1 = transform1[5];
    const a2 = transform2[0];
    const b2 = transform2[1];
    const c2 = transform2[2];
    const d2 = transform2[3];
    const e2 = transform2[4];
    const f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $e22e7611e69f42a9$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $e22e7611e69f42a9$export$5635d7ef4b8fee1c(transform, coordinate) {
    const x = coordinate[0];
    const y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $e22e7611e69f42a9$export$bb628a54ab399bc9(transform, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $e22e7611e69f42a9$export$dcdf75081b88279d(transform, x, y) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, x, 0, 0, y, 0, 0));
}
function $e22e7611e69f42a9$export$3e4e33ea14aeb531(target, x, y) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $e22e7611e69f42a9$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $e22e7611e69f42a9$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $e22e7611e69f42a9$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $e22e7611e69f42a9$export$f84e8e69fd4488a5($e22e7611e69f42a9$export$f672e0b6f7222cd7($e22e7611e69f42a9$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $e22e7611e69f42a9$export$6897c284b6f9f4dc(source) {
    return $e22e7611e69f42a9$export$bd70ea2a93c0fa4(source, source);
}
function $e22e7611e69f42a9$export$bd70ea2a93c0fa4(target, source) {
    const det = $e22e7611e69f42a9$export$a04698f914c55ed9(source);
    (0, $4Cz58.assert)(det !== 0, "Transformation matrix cannot be inverted");
    const a = source[0];
    const b = source[1];
    const c = source[2];
    const d = source[3];
    const e = source[4];
    const f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $e22e7611e69f42a9$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {Array}
 */ const $e22e7611e69f42a9$var$matrixPrecision = [
    1e6,
    1e6,
    1e6,
    1e6,
    2,
    2
];
function $e22e7611e69f42a9$export$f84e8e69fd4488a5(mat) {
    const transformString = "matrix(" + mat.map((value, i)=>Math.round(value * $e22e7611e69f42a9$var$matrixPrecision[i]) / $e22e7611e69f42a9$var$matrixPrecision[i]).join(", ") + ")";
    return transformString;
}

});

parcelRegister("1MAUi", function(module, exports) {

$parcel$export(module.exports, "transform2D", () => $14c6e714516e527b$export$b92b2dedcfff79de);
$parcel$export(module.exports, "rotate", () => $14c6e714516e527b$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $14c6e714516e527b$export$dcdf75081b88279d);
$parcel$export(module.exports, "translate", () => $14c6e714516e527b$export$d73ee8ef04f5226a);
/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */ function $14c6e714516e527b$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const x = flatCoordinates[j];
        const y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, dest) {
    dest = dest ? dest : [];
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, dest) {
    dest = dest ? dest : [];
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}

});



parcelRegister("gqtzW", function(module, exports) {

$parcel$export(module.exports, "maxSquaredDelta", () => $bf5604c1b8258b71$export$bc2eb611ddf80103);
$parcel$export(module.exports, "arrayMaxSquaredDelta", () => $bf5604c1b8258b71$export$fbf31c8f2668ed5a);
$parcel$export(module.exports, "multiArrayMaxSquaredDelta", () => $bf5604c1b8258b71$export$37c18e6e7d50501a);
$parcel$export(module.exports, "assignClosestPoint", () => $bf5604c1b8258b71$export$4adc8e5135fb44c);
$parcel$export(module.exports, "assignClosestArrayPoint", () => $bf5604c1b8258b71$export$5a48a0eefcf14992);
$parcel$export(module.exports, "assignClosestMultiArrayPoint", () => $bf5604c1b8258b71$export$60e067685eb8f9c4);
/**
 * @module ol/geom/flat/closest
 */ 
var $9byFX = parcelRequire("9byFX");
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $bf5604c1b8258b71$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    const x1 = flatCoordinates[offset1];
    const y1 = flatCoordinates[offset1 + 1];
    const dx = flatCoordinates[offset2] - x1;
    const dy = flatCoordinates[offset2 + 1] - y1;
    let offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(let i = 0; i < stride; ++i)closestPoint[i] = (0, $9byFX.lerp)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        const squaredDelta = (0, $9byFX.squaredDistance)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        max = $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $bf5604c1b8258b71$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        max = $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    if (offset == end) return minSquaredDistance;
    let i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $9byFX.squaredDistance)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    let index = offset + stride;
    while(index < end){
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $9byFX.squaredDistance)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $9byFX.squaredDistance)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        minSquaredDistance = $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        minSquaredDistance = $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}

});

parcelRegister("9bJty", function(module, exports) {

$parcel$export(module.exports, "deflateCoordinate", () => $6b086aa46281540d$export$60815ead40ec79ab);
$parcel$export(module.exports, "deflateCoordinates", () => $6b086aa46281540d$export$5c4daf67e03c190f);
$parcel$export(module.exports, "deflateCoordinatesArray", () => $6b086aa46281540d$export$47c3746a74384d45);
$parcel$export(module.exports, "deflateMultiCoordinatesArray", () => $6b086aa46281540d$export$f9f2bb59da4accd3);
/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $6b086aa46281540d$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(let i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i){
        const coordinate = coordinates[i];
        for(let j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, ends) {
    ends = ends ? ends : [];
    let i = 0;
    for(let j = 0, jj = coordinatess.length; j < jj; ++j){
        const end = $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $6b086aa46281540d$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, endss) {
    endss = endss ? endss : [];
    let i = 0;
    for(let j = 0, jj = coordinatesss.length; j < jj; ++j){
        const ends = $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        if (ends.length === 0) ends[0] = offset;
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}

});

parcelRegister("bDhby", function(module, exports) {

$parcel$export(module.exports, "douglasPeucker", () => $8780aae6970f5f65$export$ef693d1572e64fb8);
$parcel$export(module.exports, "douglasPeuckerArray", () => $8780aae6970f5f65$export$cedb9900c0b225c2);
$parcel$export(module.exports, "snap", () => $8780aae6970f5f65$export$51a0620f7a28532b);
$parcel$export(module.exports, "quantizeArray", () => $8780aae6970f5f65$export$60a9904b67f8d51b);
$parcel$export(module.exports, "quantizeMultiArray", () => $8780aae6970f5f65$export$b9acf67ef05cd17c);
/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

var $9byFX = parcelRequire("9byFX");
function $8780aae6970f5f65$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, simplifiedFlatCoordinates) {
    simplifiedFlatCoordinates = simplifiedFlatCoordinates !== undefined ? simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    const n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ const markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ const stack = [
        offset,
        end - stride
    ];
    let index = 0;
    while(stack.length > 0){
        const last = stack.pop();
        const first = stack.pop();
        let maxSquaredDistance = 0;
        const x1 = flatCoordinates[first];
        const y1 = flatCoordinates[first + 1];
        const x2 = flatCoordinates[last];
        const y2 = flatCoordinates[last + 1];
        for(let i = first + stride; i < last; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            const squaredDistance = (0, $9byFX.squaredSegmentDistance)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(let i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    let x2 = x1;
    let y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $9byFX.squaredDistance)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    let x1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    let y1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    let x2, y2;
    do {
        x2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        const x3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        const y3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        const dx1 = x2 - x1;
        const dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        const dx2 = x3 - x1;
        const dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}

});

parcelRegister("7eSHW", function(module, exports) {

$parcel$export(module.exports, "inflateCoordinates", () => $5454470599558ddd$export$9c0934e4e9c3f61e);
$parcel$export(module.exports, "inflateCoordinatesArray", () => $5454470599558ddd$export$cbb9596fc0f40db2);
$parcel$export(module.exports, "inflateMultiCoordinatesArray", () => $5454470599558ddd$export$915c7058aeb4dfeb);
/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinates) {
    coordinates = coordinates !== undefined ? coordinates : [];
    let i = 0;
    for(let j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatess) {
    coordinatess = coordinatess !== undefined ? coordinatess : [];
    let i = 0;
    for(let j = 0, jj = ends.length; j < jj; ++j){
        const end = ends[j];
        coordinatess[i++] = $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $5454470599558ddd$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, coordinatesss) {
    coordinatesss = coordinatesss !== undefined ? coordinatesss : [];
    let i = 0;
    for(let j = 0, jj = endss.length; j < jj; ++j){
        const ends = endss[j];
        coordinatesss[i++] = ends.length === 1 && ends[0] === offset ? [] : $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}

});

parcelRegister("aCXb5", function(module, exports) {

$parcel$export(module.exports, "linearRing", () => $01ff26a2f986a1d0$export$3c5e1905f889266e);
$parcel$export(module.exports, "linearRings", () => $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5);
$parcel$export(module.exports, "linearRingss", () => $01ff26a2f986a1d0$export$78e139679ca7205);
/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    let twiceArea = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        twiceArea += y1 * x2 - x1 * y2;
        x1 = x2;
        y1 = y2;
    }
    return twiceArea / 2;
}
function $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    let area = 0;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        area += $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $01ff26a2f986a1d0$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    let area = 0;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        area += $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}

});


parcelRegister("9vPkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eced4c969949f6b$export$2e2bcd8739ae039);
/**
 * @module ol/geom/Point
 */ 
var $h7zsK = parcelRequire("h7zsK");

var $9pD6L = parcelRequire("9pD6L");

var $9bJty = parcelRequire("9bJty");

var $9byFX = parcelRequire("9byFX");
/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ class $6eced4c969949f6b$var$Point extends (0, $h7zsK.default) {
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        this.setCoordinates(coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   */ clone() {
        const point = new $6eced4c969949f6b$var$Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const squaredDistance = (0, $9byFX.squaredDistance)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            const stride = this.stride;
            for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   */ getCoordinates() {
        return this.flatCoordinates.slice();
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $9pD6L.createOrUpdateFromCoordinate)(this.flatCoordinates, extent);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "Point";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return (0, $9pD6L.containsXY)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    }
    /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $9bJty.deflateCoordinate)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $6eced4c969949f6b$export$2e2bcd8739ae039 = $6eced4c969949f6b$var$Point;

});

parcelRegister("2RNwh", function(module, exports) {

$parcel$export(module.exports, "getInteriorPointOfArray", () => $2166f19777f69377$export$50e3b25928a5e892);
$parcel$export(module.exports, "getInteriorPointsOfMultiArray", () => $2166f19777f69377$export$11463803eda8a372);
/**
 * @module ol/geom/flat/interiorpoint
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $33weL = parcelRequire("33weL");
function $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, dest) {
    let i, ii, x, x1, x2, y1, y2;
    const y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ const intersections = [];
    // Calculate intersections with the horizontal line
    for(let r = 0, rr = ends.length; r < rr; ++r){
        const end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    let pointX = NaN;
    let maxSegmentLength = -Infinity;
    intersections.sort((0, $fVVyM.ascending));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        const segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $33weL.linearRingsContainsXY)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (dest) {
        dest.push(pointX, y, maxSegmentLength);
        return dest;
    }
    return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $2166f19777f69377$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    /** @type {Array<number>} */ let interiorPoints = [];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        interiorPoints = $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}

});
parcelRegister("33weL", function(module, exports) {

$parcel$export(module.exports, "linearRingContainsExtent", () => $239aa88e7a573859$export$cedabedc7ac0e138);
$parcel$export(module.exports, "linearRingContainsXY", () => $239aa88e7a573859$export$949a7a3a4b6f34fa);
$parcel$export(module.exports, "linearRingsContainsXY", () => $239aa88e7a573859$export$ae868c0f6acc3355);
$parcel$export(module.exports, "linearRingssContainsXY", () => $239aa88e7a573859$export$c760d9d16cf92043);
/**
 * @module ol/geom/flat/contains
 */ 
var $9pD6L = parcelRequire("9pD6L");
function $239aa88e7a573859$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    const outside = (0, $9pD6L.forEachCorner)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // https://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    let wn = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(let i = 1, ii = ends.length; i < ii; ++i){
        if ($239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $239aa88e7a573859$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}

});


parcelRegister("eQvue", function(module, exports) {

$parcel$export(module.exports, "intersectsLineString", () => $acee589e5b390c5c$export$40d8d71841a3d779);
$parcel$export(module.exports, "intersectsLineStringArray", () => $acee589e5b390c5c$export$fdb1d8e850bf7937);
$parcel$export(module.exports, "intersectsLinearRing", () => $acee589e5b390c5c$export$830a0dafbb2ef1c5);
$parcel$export(module.exports, "intersectsLinearRingArray", () => $acee589e5b390c5c$export$76dcd8f8f83b6ddb);
$parcel$export(module.exports, "intersectsLinearRingMultiArray", () => $acee589e5b390c5c$export$77b72fa3792f5bf0);
/**
 * @module ol/geom/flat/intersectsextent
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $5m6tu = parcelRequire("5m6tu");

var $33weL = parcelRequire("33weL");
function $acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent) {
    const coordinatesExtent = (0, $9pD6L.extendFlatCoordinates)((0, $9pD6L.createEmpty)(), flatCoordinates, offset, end, stride);
    if (!(0, $9pD6L.intersects)(extent, coordinatesExtent)) return false;
    if ((0, $9pD6L.containsExtent)(extent, coordinatesExtent)) return true;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2]) return true;
    if (coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $5m6tu.forEach)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $9pD6L.intersectsSegment)(extent, point1, point2);
    });
}
function $acee589e5b390c5c$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $33weL.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $33weL.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $33weL.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $33weL.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(let i = 1, ii = ends.length; i < ii; ++i)if ((0, $33weL.linearRingContainsExtent)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $acee589e5b390c5c$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}

});
parcelRegister("5m6tu", function(module, exports) {

$parcel$export(module.exports, "forEach", () => $3e64078bffae1cbd$export$4b80e395e36b5a56);
/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $3e64078bffae1cbd$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    let ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}

});


parcelRegister("alOgM", function(module, exports) {

$parcel$export(module.exports, "linearRingsAreOriented", () => $7892dc06ffd23218$export$f27cd06e85f4ba28);
$parcel$export(module.exports, "linearRingssAreOriented", () => $7892dc06ffd23218$export$a1d138f4bd85f4b4);
$parcel$export(module.exports, "orientLinearRings", () => $7892dc06ffd23218$export$b71b604ddfc778c7);
$parcel$export(module.exports, "orientLinearRingsArray", () => $7892dc06ffd23218$export$ea9ed55fc2a85010);
$parcel$export(module.exports, "inflateEnds", () => $7892dc06ffd23218$export$cb72ae403d6e78e6);
/**
 * @module ol/geom/flat/orient
 */ 
var $1PJpx = parcelRequire("1PJpx");
function $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    let edge = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $7892dc06ffd23218$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (!$7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        const reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $1PJpx.coordinates)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $7892dc06ffd23218$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i)offset = $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, right);
    return offset;
}
function $7892dc06ffd23218$export$cb72ae403d6e78e6(flatCoordinates, ends) {
    const endss = [];
    let offset = 0;
    let prevEndIndex = 0;
    let startOrientation;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        const orientation = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, 2);
        if (startOrientation === undefined) startOrientation = orientation;
        if (orientation === startOrientation) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}

});
parcelRegister("1PJpx", function(module, exports) {

$parcel$export(module.exports, "coordinates", () => $155dc783a4ec227e$export$741858880c96b18c);
/**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $155dc783a4ec227e$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(let i = 0; i < stride; ++i){
            const tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}

});





parcelRegister("jDKXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c61536de922b84$export$2e2bcd8739ae039);
/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $e4c61536de922b84$export$2e2bcd8739ae039 = {
    PRELOAD: "preload",
    USE_INTERIM_TILES_ON_ERROR: "useInterimTilesOnError"
};

});


parcelRegister("fY4eB", function(module, exports) {

$parcel$export(module.exports, "default", () => $02fffef185f4339b$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/canvas/TileLayer
 */ 
var $5FKVH = parcelRequire("5FKVH");

var $hCs6p = parcelRequire("hCs6p");

var $4WmJ3 = parcelRequire("4WmJ3");

var $7iKy2 = parcelRequire("7iKy2");

var $fOhwi = parcelRequire("fOhwi");

var $jpXrt = parcelRequire("jpXrt");

var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $dpRHA = parcelRequire("dpRHA");

var $9iPUS = parcelRequire("9iPUS");

var $hxhPO = parcelRequire("hxhPO");
/**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ class $02fffef185f4339b$var$CanvasTileLayerRenderer extends (0, $5FKVH.default) {
    /**
   * @param {LayerType} tileLayer Tile layer.
   */ constructor(tileLayer){
        super(tileLayer);
        /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */ this.extentChanged = true;
        /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */ this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedPixelRatio;
        /**
     * @protected
     * @type {import("../../proj/Projection.js").default}
     */ this.renderedProjection = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedRevision;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ this.renderedTiles = [];
        /**
     * @private
     * @type {boolean}
     */ this.newTiles_ = false;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ this.tmpExtent = (0, $9pD6L.createEmpty)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ this.tmpTileRange_ = new (0, $7iKy2.default)(0, 0, 0, 0);
    }
    /**
   * @protected
   * @param {import("../../Tile.js").default} tile Tile.
   * @return {boolean} Tile is drawable.
   */ isDrawableTile(tile) {
        const tileLayer = this.getLayer();
        const tileState = tile.getState();
        const useInterimTilesOnError = tileLayer.getUseInterimTilesOnError();
        return tileState == (0, $fOhwi.default).LOADED || tileState == (0, $fOhwi.default).EMPTY || tileState == (0, $fOhwi.default).ERROR && !useInterimTilesOnError;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {!import("../../Tile.js").default} Tile.
   */ getTile(z, x, y, frameState) {
        const pixelRatio = frameState.pixelRatio;
        const projection = frameState.viewState.projection;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        let tile = tileSource.getTile(z, x, y, pixelRatio, projection);
        if (tile.getState() == (0, $fOhwi.default).ERROR) {
            if (tileLayer.getUseInterimTilesOnError() && tileLayer.getPreload() > 0) // Preloaded tiles for lower resolutions might have finished loading.
            this.newTiles_ = true;
        }
        if (!this.isDrawableTile(tile)) tile = tile.getInterimTile();
        return tile;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $jpXrt.apply)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $9pD6L.containsCoordinate)(layerExtent, coordinate)) return null;
        }
        const pixelRatio = frameState.pixelRatio;
        const projection = frameState.viewState.projection;
        const viewState = frameState.viewState;
        const source = layer.getRenderSource();
        const tileGrid = source.getTileGridForProjection(viewState.projection);
        const tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
        for(let z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
            const tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            const tile = source.getTile(z, tileCoord[1], tileCoord[2], pixelRatio, projection);
            if (!(tile instanceof (0, $hCs6p.default) || tile instanceof (0, $4WmJ3.default)) || tile instanceof (0, $4WmJ3.default) && tile.getState() === (0, $fOhwi.default).EMPTY) return null;
            if (tile.getState() !== (0, $fOhwi.default).LOADED) continue;
            const tileOrigin = tileGrid.getOrigin(z);
            const tileSize = (0, $hxhPO.toSize)(tileGrid.getTileSize(z));
            const tileResolution = tileGrid.getResolution(z);
            const col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
            const row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
            const gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
            return this.getImageData(tile.getImage(), col + gutter, row + gutter);
        }
        return null;
    }
    /**
   * @param {Object<number, Object<string, import("../../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @param {number} zoom Zoom level.
   * @param {import("../../Tile.js").default} tile Tile.
   * @return {boolean|void} If `false`, the tile will not be considered loaded.
   */ loadedTileCallback(tiles, zoom, tile) {
        if (this.isDrawableTile(tile)) return super.loadedTileCallback(tiles, zoom, tile);
        return false;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return !!this.getLayer().getSource();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const viewResolution = viewState.resolution;
        const viewCenter = viewState.center;
        const rotation = viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const sourceRevision = tileSource.getRevision();
        const tileGrid = tileSource.getTileGridForProjection(projection);
        const z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        let extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const layerExtent = layerState.extent && (0, $dpRHA.fromUserExtent)(layerState.extent, projection);
        if (layerExtent) extent = (0, $9pD6L.getIntersection)(extent, (0, $dpRHA.fromUserExtent)(layerState.extent, projection));
        const dx = tileResolution * width / 2 / tilePixelRatio;
        const dy = tileResolution * height / 2 / tilePixelRatio;
        const canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        const tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
        /**
     * @type {Object<number, Object<string, import("../../Tile.js").default>>}
     */ const tilesToDrawByZ = {};
        tilesToDrawByZ[z] = {};
        const findLoadedTiles = this.createLoadedTileFinder(tileSource, projection, tilesToDrawByZ);
        const tmpExtent = this.tmpExtent;
        const tmpTileRange = this.tmpTileRange_;
        this.newTiles_ = false;
        const viewport = rotation ? (0, $9pD6L.getRotatedViewport)(viewState.center, resolution, rotation, frameState.size) : undefined;
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            if (rotation && !tileGrid.tileCoordIntersectsViewport([
                z,
                x,
                y
            ], viewport)) continue;
            const tile = this.getTile(z, x, y, frameState);
            if (this.isDrawableTile(tile)) {
                const uid = (0, $9iPUS.getUid)(this);
                if (tile.getState() == (0, $fOhwi.default).LOADED) {
                    tilesToDrawByZ[z][tile.tileCoord.toString()] = tile;
                    let inTransition = tile.inTransition(uid);
                    if (inTransition && layerState.opacity !== 1) {
                        // Skipping transition when layer is not fully opaque avoids visual artifacts.
                        tile.endTransition(uid);
                        inTransition = false;
                    }
                    if (!this.newTiles_ && (inTransition || !this.renderedTiles.includes(tile))) this.newTiles_ = true;
                }
                if (tile.getAlpha(uid, frameState.time) === 1) continue;
            }
            const childTileRange = tileGrid.getTileCoordChildTileRange(tile.tileCoord, tmpTileRange, tmpExtent);
            let covered = false;
            if (childTileRange) covered = findLoadedTiles(z + 1, childTileRange);
            if (!covered) tileGrid.forEachTileCoordParentTileRange(tile.tileCoord, findLoadedTiles, tmpTileRange, tmpExtent);
        }
        const canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
        const context = this.getRenderContext(frameState);
        // set scale transform for calculating tile positions on the canvas
        (0, $jpXrt.compose)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (layerExtent) this.clipUnrotated(context, frameState, layerExtent);
        if (!tileSource.getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        this.renderedTiles.length = 0;
        /** @type {Array<number>} */ let zs = Object.keys(tilesToDrawByZ).map(Number);
        zs.sort((0, $fVVyM.ascending));
        let clips, clipZs, currentClip;
        if (layerState.opacity === 1 && (!this.containerReused || tileSource.getOpaque(frameState.viewState.projection))) zs = zs.reverse();
        else {
            clips = [];
            clipZs = [];
        }
        for(let i = zs.length - 1; i >= 0; --i){
            const currentZ = zs[i];
            const currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            const currentResolution = tileGrid.getResolution(currentZ);
            const currentScale = currentResolution / tileResolution;
            const dx = currentTilePixelSize[0] * currentScale * canvasScale;
            const dy = currentTilePixelSize[1] * currentScale * canvasScale;
            const originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $9pD6L.getTopLeft)(canvasExtent), currentZ);
            const originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            const origin = (0, $jpXrt.apply)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            const tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            const tilesToDraw = tilesToDrawByZ[currentZ];
            for(const tileCoordKey in tilesToDraw){
                const tile = /** @type {import("../../ImageTile.js").default} */ tilesToDraw[tileCoordKey];
                const tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                const xIndex = originTileCoord[1] - tileCoord[1];
                const nextX = Math.round(origin[0] - (xIndex - 1) * dx);
                const yIndex = originTileCoord[2] - tileCoord[2];
                const nextY = Math.round(origin[1] - (yIndex - 1) * dy);
                const x = Math.round(origin[0] - xIndex * dx);
                const y = Math.round(origin[1] - yIndex * dy);
                const w = nextX - x;
                const h = nextY - y;
                const transition = z === currentZ;
                const inTransition = transition && tile.getAlpha((0, $9iPUS.getUid)(this), frameState.time) !== 1;
                let contextSaved = false;
                if (!inTransition) {
                    if (clips) {
                        // Clip mask for regions in this tile that already filled by a higher z tile
                        currentClip = [
                            x,
                            y,
                            x + w,
                            y,
                            x + w,
                            y + h,
                            x,
                            y + h
                        ];
                        for(let i = 0, ii = clips.length; i < ii; ++i)if (z !== currentZ && currentZ < clipZs[i]) {
                            const clip = clips[i];
                            if ((0, $9pD6L.intersects)([
                                x,
                                y,
                                x + w,
                                y + h
                            ], [
                                clip[0],
                                clip[3],
                                clip[4],
                                clip[7]
                            ])) {
                                if (!contextSaved) {
                                    context.save();
                                    contextSaved = true;
                                }
                                context.beginPath();
                                // counter-clockwise (outer ring) for current tile
                                context.moveTo(currentClip[0], currentClip[1]);
                                context.lineTo(currentClip[2], currentClip[3]);
                                context.lineTo(currentClip[4], currentClip[5]);
                                context.lineTo(currentClip[6], currentClip[7]);
                                // clockwise (inner ring) for higher z tile
                                context.moveTo(clip[6], clip[7]);
                                context.lineTo(clip[4], clip[5]);
                                context.lineTo(clip[2], clip[3]);
                                context.lineTo(clip[0], clip[1]);
                                context.clip();
                            }
                        }
                        clips.push(currentClip);
                        clipZs.push(currentZ);
                    } else context.clearRect(x, y, w, h);
                }
                this.drawTileImage(tile, frameState, x, y, w, h, tileGutter, transition);
                if (clips && !inTransition) {
                    if (contextSaved) context.restore();
                    this.renderedTiles.unshift(tile);
                } else this.renderedTiles.push(tile);
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedRevision = sourceRevision;
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, $9pD6L.equals)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.renderedProjection = projection;
        this.manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio, projection, extent, z, tileLayer.getPreload());
        this.scheduleExpireCache(frameState, tileSource);
        this.postRender(this.context, frameState);
        if (layerState.extent) context.restore();
        context.imageSmoothingEnabled = true;
        return this.container;
    }
    /**
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   */ drawTileImage(tile, frameState, x, y, w, h, gutter, transition) {
        const image = this.getTileImage(tile);
        if (!image) return;
        const context = this.getRenderContext(frameState);
        const uid = (0, $9iPUS.getUid)(this);
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
        const alphaChanged = alpha !== context.globalAlpha;
        if (alphaChanged) {
            context.save();
            context.globalAlpha = alpha;
        }
        context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) context.restore();
        if (alpha !== layerState.opacity) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    }
    /**
   * @return {HTMLCanvasElement} Image
   */ getImage() {
        const context = this.context;
        return context ? context.canvas : null;
    }
    /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ getTileImage(tile) {
        return tile.getImage();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @protected
   */ scheduleExpireCache(frameState, tileSource) {
        if (tileSource.canExpireCache()) {
            /**
       * @param {import("../../source/Tile.js").default} tileSource Tile source.
       * @param {import("../../Map.js").default} map Map.
       * @param {import("../../Map.js").FrameState} frameState Frame state.
       */ const postRenderFunction = (function(tileSource, map, frameState) {
                const tileSourceKey = (0, $9iPUS.getUid)(tileSource);
                if (tileSourceKey in frameState.usedTiles) tileSource.expireCache(frameState.viewState.projection, frameState.usedTiles[tileSourceKey]);
            }).bind(null, tileSource);
            frameState.postRenderFunctions.push(/** @type {import("../../Map.js").PostRenderFunction} */ postRenderFunction);
        }
    }
    /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */ updateUsedTiles(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        const tileSourceKey = (0, $9iPUS.getUid)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    }
    /**
   * Manage tile pyramid.
   * This function performs a number of functions related to the tiles at the
   * current zoom and lower zoom levels:
   * - registers idle tiles in frameState.wantedTiles so that they are not
   *   discarded by the tile queue
   * - enqueues missing tiles
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid Tile grid.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection.js").default} projection Projection.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {number} currentZ Current Z.
   * @param {number} preload Load low resolution tiles up to `preload` levels.
   * @param {function(import("../../Tile.js").default):void} [tileCallback] Tile callback.
   * @protected
   */ manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio, projection, extent, currentZ, preload, tileCallback) {
        const tileSourceKey = (0, $9iPUS.getUid)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        const wantedTiles = frameState.wantedTiles[tileSourceKey];
        const tileQueue = frameState.tileQueue;
        const minZoom = tileGrid.getMinZoom();
        const rotation = frameState.viewState.rotation;
        const viewport = rotation ? (0, $9pD6L.getRotatedViewport)(frameState.viewState.center, frameState.viewState.resolution, rotation, frameState.size) : undefined;
        let tileCount = 0;
        let tile, tileRange, tileResolution, x, y, z;
        for(z = minZoom; z <= currentZ; ++z){
            tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, tileRange);
            tileResolution = tileGrid.getResolution(z);
            for(x = tileRange.minX; x <= tileRange.maxX; ++x)for(y = tileRange.minY; y <= tileRange.maxY; ++y){
                if (rotation && !tileGrid.tileCoordIntersectsViewport([
                    z,
                    x,
                    y
                ], viewport)) continue;
                if (currentZ - z <= preload) {
                    ++tileCount;
                    tile = tileSource.getTile(z, x, y, pixelRatio, projection);
                    if (tile.getState() == (0, $fOhwi.default).IDLE) {
                        wantedTiles[tile.getKey()] = true;
                        if (!tileQueue.isKeyQueued(tile.getKey())) tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tile.tileCoord),
                            tileResolution
                        ]);
                    }
                    if (tileCallback !== undefined) tileCallback(tile);
                } else tileSource.useTile(z, x, y, projection);
            }
        }
        tileSource.updateCacheSize(tileCount, projection);
    }
}
var $02fffef185f4339b$export$2e2bcd8739ae039 = $02fffef185f4339b$var$CanvasTileLayerRenderer;

});
parcelRegister("5FKVH", function(module, exports) {

$parcel$export(module.exports, "canvasPool", () => $42152f52b26b6ca7$export$a166f0857c555517);
$parcel$export(module.exports, "default", () => $42152f52b26b6ca7$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/canvas/Layer
 */ 
var $hr4Xu = parcelRequire("hr4Xu");

var $fNIok = parcelRequire("fNIok");

var $l6YBe = parcelRequire("l6YBe");

var $gDySU = parcelRequire("gDySU");

var $jpXrt = parcelRequire("jpXrt");

var $4iSHH = parcelRequire("4iSHH");

var $DfnQm = parcelRequire("DfnQm");

var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");
const $42152f52b26b6ca7$export$a166f0857c555517 = [];
/**
 * @type {CanvasRenderingContext2D}
 */ let $42152f52b26b6ca7$var$pixelContext = null;
function $42152f52b26b6ca7$var$createPixelContext() {
    $42152f52b26b6ca7$var$pixelContext = (0, $DfnQm.createCanvasContext2D)(1, 1, undefined, {
        willReadFrequently: true
    });
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ class $42152f52b26b6ca7$var$CanvasLayerRenderer extends (0, $hr4Xu.default) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super(layer);
        /**
     * @protected
     * @type {HTMLElement}
     */ this.container = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedResolution;
        /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.tempTransform = (0, $jpXrt.create)();
        /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.pixelTransform = (0, $jpXrt.create)();
        /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.inversePixelTransform = (0, $jpXrt.create)();
        /**
     * @type {CanvasRenderingContext2D}
     */ this.context = null;
        /**
     * @private
     * @type {ZIndexContext}
     */ this.deferredContext_ = null;
        /**
     * @type {boolean}
     */ this.containerReused = false;
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.pixelContext_ = null;
        /**
     * @protected
     * @type {import("../../Map.js").FrameState|null}
     */ this.frameState = null;
    }
    /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */ getImageData(image, col, row) {
        if (!$42152f52b26b6ca7$var$pixelContext) $42152f52b26b6ca7$var$createPixelContext();
        $42152f52b26b6ca7$var$pixelContext.clearRect(0, 0, 1, 1);
        let data;
        try {
            $42152f52b26b6ca7$var$pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
            data = $42152f52b26b6ca7$var$pixelContext.getImageData(0, 0, 1, 1).data;
        } catch (err) {
            $42152f52b26b6ca7$var$pixelContext = null;
            return null;
        }
        return data;
    }
    /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */ getBackground(frameState) {
        const layer = this.getLayer();
        let background = layer.getBackground();
        if (typeof background === "function") background = background(frameState.viewState.resolution);
        return background || undefined;
    }
    /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS Transform.
   * @param {string} [backgroundColor] Background color.
   */ useContainer(target, transform, backgroundColor) {
        const layerClassName = this.getLayer().getClassName();
        let container, context;
        if (target && target.className === layerClassName && (!backgroundColor || target && target.style.backgroundColor && (0, $fVVyM.equals)((0, $4iSHH.asArray)(target.style.backgroundColor), (0, $4iSHH.asArray)(backgroundColor)))) {
            const canvas = target.firstElementChild;
            if (canvas instanceof HTMLCanvasElement) context = canvas.getContext("2d");
        }
        if (context && context.canvas.style.transform === transform) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        } else if (this.container) this.container.style.backgroundColor = null;
        if (!this.container) {
            container = document.createElement("div");
            container.className = layerClassName;
            let style = container.style;
            style.position = "absolute";
            style.width = "100%";
            style.height = "100%";
            context = (0, $DfnQm.createCanvasContext2D)();
            const canvas = context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = "absolute";
            style.left = "0";
            style.transformOrigin = "top left";
            this.container = container;
            this.context = context;
        }
        if (!this.containerReused && backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = backgroundColor;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ clipUnrotated(context, frameState, extent) {
        const topLeft = (0, $9pD6L.getTopLeft)(extent);
        const topRight = (0, $9pD6L.getTopRight)(extent);
        const bottomRight = (0, $9pD6L.getBottomRight)(extent);
        const bottomLeft = (0, $9pD6L.getBottomLeft)(extent);
        (0, $jpXrt.apply)(frameState.coordinateToPixelTransform, topLeft);
        (0, $jpXrt.apply)(frameState.coordinateToPixelTransform, topRight);
        (0, $jpXrt.apply)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $jpXrt.apply)(frameState.coordinateToPixelTransform, bottomLeft);
        const inverted = this.inversePixelTransform;
        (0, $jpXrt.apply)(inverted, topLeft);
        (0, $jpXrt.apply)(inverted, topRight);
        (0, $jpXrt.apply)(inverted, bottomRight);
        (0, $jpXrt.apply)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @protected
   */ prepareContainer(frameState, target) {
        const extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const width = Math.round((0, $9pD6L.getWidth)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $9pD6L.getHeight)(extent) / resolution * pixelRatio);
        // set forward and inverse pixel transforms
        (0, $jpXrt.compose)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        (0, $jpXrt.makeInverse)(this.inversePixelTransform, this.pixelTransform);
        const canvasTransform = (0, $jpXrt.toString)(this.pixelTransform);
        this.useContainer(target, canvasTransform, this.getBackground(frameState));
        if (!this.containerReused) {
            const canvas = this.context.canvas;
            if (canvas.width != width || canvas.height != height) {
                canvas.width = width;
                canvas.height = height;
            } else this.context.clearRect(0, 0, width, height);
            if (canvasTransform !== canvas.style.transform) canvas.style.transform = canvasTransform;
        }
    }
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ dispatchRenderEvent_(type, context, frameState) {
        const layer = this.getLayer();
        if (layer.hasListener(type)) {
            const event = new (0, $fNIok.default)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event);
        }
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ preRender(context, frameState) {
        this.frameState = frameState;
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $l6YBe.default).PRERENDER, context, frameState);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ postRender(context, frameState) {
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $l6YBe.default).POSTRENDER, context, frameState);
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {}
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import('../../render/canvas/ZIndexContext.js').ZIndexContextProxy} Context.
   */ getRenderContext(frameState) {
        if (frameState.declutter && !this.deferredContext_) this.deferredContext_ = new (0, $gDySU.default)();
        return frameState.declutter ? this.deferredContext_.getContext() : this.context;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferred(frameState) {
        if (!frameState.declutter) return;
        this.dispatchRenderEvent_((0, $l6YBe.default).PRERENDER, this.context, frameState);
        if (frameState.declutter && this.deferredContext_) {
            this.deferredContext_.draw(this.context);
            this.deferredContext_.clear();
        }
        this.renderDeferredInternal(frameState);
        this.dispatchRenderEvent_((0, $l6YBe.default).POSTRENDER, this.context, frameState);
    }
    /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ getRenderTransform(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        const dx1 = width / 2;
        const dy1 = height / 2;
        const sx = pixelRatio / resolution;
        const sy = -sx;
        const dx2 = -center[0] + offsetX;
        const dy2 = -center[1];
        return (0, $jpXrt.compose)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    }
    /**
   * Clean up.
   */ disposeInternal() {
        delete this.frameState;
        super.disposeInternal();
    }
}
var $42152f52b26b6ca7$export$2e2bcd8739ae039 = $42152f52b26b6ca7$var$CanvasLayerRenderer;

});
parcelRegister("hr4Xu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb18cdefd702a327$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/Layer
 */ 
var $3xzSb = parcelRequire("3xzSb");

var $aSvtr = parcelRequire("aSvtr");

var $2FcER = parcelRequire("2FcER");

var $9iPUS = parcelRequire("9iPUS");
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ class $cb18cdefd702a327$var$LayerRenderer extends (0, $2FcER.default) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super();
        /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */ this.ready = true;
        /** @private */ this.boundHandleImageChange_ = this.handleImageChange_.bind(this);
        /**
     * @protected
     * @type {LayerType}
     */ this.layer_ = layer;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        return null;
    }
    /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   */ renderFrame(frameState, target) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @param {number} zoom Zoom level.
   * @param {import("../Tile.js").default} tile Tile.
   * @return {boolean|void} If `false`, the tile will not be considered loaded.
   */ loadedTileCallback(tiles, zoom, tile) {
        if (!tiles[zoom]) tiles[zoom] = {};
        tiles[zoom][tile.tileCoord.toString()] = tile;
        return undefined;
    }
    /**
   * Create a function that adds loaded tiles to the tile lookup.
   * @param {import("../source/Tile.js").default} source Tile source.
   * @param {import("../proj/Projection.js").default} projection Projection of the tiles.
   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @return {function(number, import("../TileRange.js").default):boolean} A function that can be
   *     called with a zoom level and a tile range to add loaded tiles to the lookup.
   * @protected
   */ createLoadedTileFinder(source, projection, tiles) {
        return(/**
       * @param {number} zoom Zoom level.
       * @param {import("../TileRange.js").default} tileRange Tile range.
       * @return {boolean} The tile range is fully loaded.
       */ (zoom, tileRange)=>{
            const callback = this.loadedTileCallback.bind(this, tiles, zoom);
            return source.forEachLoadedTile(projection, zoom, tileRange, callback);
        });
    }
    /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    }
    /**
   * @return {LayerType} Layer.
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */ handleFontsChanged() {}
    /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ handleImageChange_(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $aSvtr.default).LOADED || image.getState() === (0, $aSvtr.default).ERROR) this.renderIfReadyAndVisible();
    }
    /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ loadImage(image) {
        let imageState = image.getState();
        if (imageState != (0, $aSvtr.default).LOADED && imageState != (0, $aSvtr.default).ERROR) image.addEventListener((0, $3xzSb.default).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, $aSvtr.default).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $aSvtr.default).LOADED;
    }
    /**
   * @protected
   */ renderIfReadyAndVisible() {
        const layer = this.getLayer();
        if (layer && layer.getVisible() && layer.getSourceState() === "ready") layer.changed();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ renderDeferred(frameState) {}
    /**
   * Clean up.
   */ disposeInternal() {
        delete this.layer_;
        super.disposeInternal();
    }
}
var $cb18cdefd702a327$export$2e2bcd8739ae039 = $cb18cdefd702a327$var$LayerRenderer;

});
parcelRegister("aSvtr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eb75c96a6b6f2c6$export$2e2bcd8739ae039);
/**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $7eb75c96a6b6f2c6$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};

});


parcelRegister("fNIok", function(module, exports) {

$parcel$export(module.exports, "default", () => $b80dddceb0c42ad4$export$2e2bcd8739ae039);
/**
 * @module ol/render/Event
 */ 
var $f18Q2 = parcelRequire("f18Q2");
class $b80dddceb0c42ad4$var$RenderEvent extends (0, $f18Q2.default) {
    /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */ constructor(type, inversePixelTransform, frameState, context){
        super(type);
        /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */ this.inversePixelTransform = inversePixelTransform;
        /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */ this.frameState = frameState;
        /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */ this.context = context;
    }
}
var $b80dddceb0c42ad4$export$2e2bcd8739ae039 = $b80dddceb0c42ad4$var$RenderEvent;

});

parcelRegister("gDySU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1cb593c98d2cbd0$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/ZIndexContext
 */ 
var $DfnQm = parcelRequire("DfnQm");
/** @typedef {CanvasRenderingContext2D & {globalAlpha: any}} ZIndexContextProxy */ /**
 * @extends {CanvasRenderingContext2D}
 */ class $c1cb593c98d2cbd0$var$ZIndexContext {
    constructor(){
        /**
     * @private
     * @type {Array<Array<*>>}
     */ this.instructions_ = [];
        /**
     * @type {number}
     */ this.zIndex = 0;
        /**
     * @private
     * @type {number}
     */ this.offset_ = 0;
        /**
     * @type {ZIndexContextProxy}
     */ this.context_ = /** @type {ZIndexContextProxy} */ new Proxy((0, $DfnQm.getSharedCanvasContext2D)(), {
            get: (target, property)=>{
                if (typeof /** @type {*} */ (0, $DfnQm.getSharedCanvasContext2D)()[property] !== "function") // we only accept calling functions on the proxy, not accessing properties
                return undefined;
                if (!this.instructions_[this.zIndex + this.offset_]) this.instructions_[this.zIndex + this.offset_] = [];
                this.instructions_[this.zIndex + this.offset_].push(property);
                return this.pushMethodArgs_;
            },
            set: (target, property, value)=>{
                if (!this.instructions_[this.zIndex + this.offset_]) this.instructions_[this.zIndex + this.offset_] = [];
                this.instructions_[this.zIndex + this.offset_].push(property, value);
                return true;
            }
        });
    }
    /**
   * @private
   * @param {...*} args Args.
   * @return {ZIndexContext} This.
   */ pushMethodArgs_ = (...args)=>{
        this.instructions_[this.zIndex + this.offset_].push(args);
        return this;
    };
    /**
   * Push a function that renders to the context directly.
   * @param {function(CanvasRenderingContext2D): void} render Function.
   */ pushFunction(render) {
        this.instructions_[this.zIndex + this.offset_].push(render);
    }
    /**
   * Get a proxy for CanvasRenderingContext2D which does not support getting state
   * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
   * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
   * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
   * @return {ZIndexContextProxy} Context.
   */ getContext() {
        return this.context_;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   */ draw(context) {
        this.instructions_.forEach((instructionsAtIndex)=>{
            for(let i = 0, ii = instructionsAtIndex.length; i < ii; ++i){
                const property = instructionsAtIndex[i];
                if (typeof property === "function") {
                    property(context);
                    continue;
                }
                const instructionAtIndex = instructionsAtIndex[++i];
                if (typeof /** @type {*} */ context[property] === "function") /** @type {*} */ context[property](...instructionAtIndex);
                else {
                    if (typeof instructionAtIndex === "function") {
                        /** @type {*} */ context[property] = instructionAtIndex(context);
                        continue;
                    }
                    /** @type {*} */ context[property] = instructionAtIndex;
                }
            }
        });
    }
    clear() {
        this.instructions_.length = 0;
        this.zIndex = 0;
        this.offset_ = 0;
    }
    /**
   * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
   * avoid conflicting context.clip() or context.save()/restore() calls.
   */ offset() {
        this.offset_ = this.instructions_.length;
        this.zIndex = 0;
    }
}
var $c1cb593c98d2cbd0$export$2e2bcd8739ae039 = $c1cb593c98d2cbd0$var$ZIndexContext;

});
parcelRegister("DfnQm", function(module, exports) {

$parcel$export(module.exports, "createCanvasContext2D", () => $075f937d7366f1a2$export$9e05d10eae75c464);
$parcel$export(module.exports, "getSharedCanvasContext2D", () => $075f937d7366f1a2$export$fcb72ce088a6632c);
$parcel$export(module.exports, "releaseCanvas", () => $075f937d7366f1a2$export$e918ac6a1026a12a);
$parcel$export(module.exports, "outerWidth", () => $075f937d7366f1a2$export$e823f88e4111159a);
$parcel$export(module.exports, "outerHeight", () => $075f937d7366f1a2$export$fc5b8aac72846d1e);
$parcel$export(module.exports, "replaceNode", () => $075f937d7366f1a2$export$5542201de9311ab2);
$parcel$export(module.exports, "removeNode", () => $075f937d7366f1a2$export$1d0aa160432dfea5);
$parcel$export(module.exports, "removeChildren", () => $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1);
$parcel$export(module.exports, "replaceChildren", () => $075f937d7366f1a2$export$caeacfe04f52533a);

var $8UoiJ = parcelRequire("8UoiJ");
function $075f937d7366f1a2$export$9e05d10eae75c464(width, height, canvasPool, settings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ let canvas;
    if (canvasPool && canvasPool.length) canvas = /** @type {HTMLCanvasElement} */ canvasPool.shift();
    else if (0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) canvas = new OffscreenCanvas(width || 300, height || 300);
    else canvas = document.createElement("canvas");
    if (width) canvas.width = width;
    if (height) canvas.height = height;
    //FIXME Allow OffscreenCanvasRenderingContext2D as return type
    return /** @type {CanvasRenderingContext2D} */ canvas.getContext("2d", settings);
}
/** @type {CanvasRenderingContext2D} */ let $075f937d7366f1a2$var$sharedCanvasContext;
function $075f937d7366f1a2$export$fcb72ce088a6632c() {
    if (!$075f937d7366f1a2$var$sharedCanvasContext) $075f937d7366f1a2$var$sharedCanvasContext = $075f937d7366f1a2$export$9e05d10eae75c464(1, 1);
    return $075f937d7366f1a2$var$sharedCanvasContext;
}
function $075f937d7366f1a2$export$e918ac6a1026a12a(context) {
    const canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function $075f937d7366f1a2$export$e823f88e4111159a(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $075f937d7366f1a2$export$fc5b8aac72846d1e(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $075f937d7366f1a2$export$5542201de9311ab2(newNode, oldNode) {
    const parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $075f937d7366f1a2$export$1d0aa160432dfea5(node) {
    return node && node.parentNode ? node.parentNode.removeChild(node) : null;
}
function $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.removeChild(node.lastChild);
}
function $075f937d7366f1a2$export$caeacfe04f52533a(node, children) {
    const oldChildren = node.childNodes;
    for(let i = 0;; ++i){
        const oldChild = oldChildren[i];
        const newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}

});
parcelRegister("8UoiJ", function(module, exports) {

$parcel$export(module.exports, "FIREFOX", () => $67c66761d21428d0$export$8442bdfd18b7b8a6);
$parcel$export(module.exports, "WEBKIT", () => $67c66761d21428d0$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "MAC", () => $67c66761d21428d0$export$76c0a3b101d93136);
$parcel$export(module.exports, "DEVICE_PIXEL_RATIO", () => $67c66761d21428d0$export$6b83a0446fc26f94);
$parcel$export(module.exports, "WORKER_OFFSCREEN_CANVAS", () => $67c66761d21428d0$export$98fcef3dc9973292);
$parcel$export(module.exports, "IMAGE_DECODE", () => $67c66761d21428d0$export$716f8695eedb9bad);
$parcel$export(module.exports, "CREATE_IMAGE_BITMAP", () => $67c66761d21428d0$export$7478563940788376);
$parcel$export(module.exports, "PASSIVE_EVENT_LISTENERS", () => $67c66761d21428d0$export$f751ce96c6c4e4fc);
/**
 * @module ol/has
 */ const $67c66761d21428d0$var$ua = typeof navigator !== "undefined" && typeof navigator.userAgent !== "undefined" ? navigator.userAgent.toLowerCase() : "";
const $67c66761d21428d0$export$8442bdfd18b7b8a6 = $67c66761d21428d0$var$ua.includes("firefox");
const $67c66761d21428d0$export$3227bfbdaa9275de = $67c66761d21428d0$var$ua.includes("safari") && !$67c66761d21428d0$var$ua.includes("chrom");
const $67c66761d21428d0$export$b23eed0e325a206a = $67c66761d21428d0$export$3227bfbdaa9275de && ($67c66761d21428d0$var$ua.includes("version/15.4") || /cpu (os|iphone os) 15_4 like mac os x/.test($67c66761d21428d0$var$ua));
const $67c66761d21428d0$export$39dfd62a25e0fe93 = $67c66761d21428d0$var$ua.includes("webkit") && !$67c66761d21428d0$var$ua.includes("edge");
const $67c66761d21428d0$export$76c0a3b101d93136 = $67c66761d21428d0$var$ua.includes("macintosh");
const $67c66761d21428d0$export$6b83a0446fc26f94 = typeof devicePixelRatio !== "undefined" ? devicePixelRatio : 1;
const $67c66761d21428d0$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== "undefined" && typeof OffscreenCanvas !== "undefined" && self instanceof WorkerGlobalScope; //eslint-disable-line
const $67c66761d21428d0$export$716f8695eedb9bad = typeof Image !== "undefined" && Image.prototype.decode;
const $67c66761d21428d0$export$7478563940788376 = typeof createImageBitmap === "function";
const $67c66761d21428d0$export$f751ce96c6c4e4fc = function() {
    let passive = false;
    try {
        const options = Object.defineProperty({}, "passive", {
            get: function() {
                passive = true;
            }
        });
        // @ts-ignore Ignore invalid event type '_'
        window.addEventListener("_", null, options);
        // @ts-ignore Ignore invalid event type '_'
        window.removeEventListener("_", null, options);
    } catch (error) {
    // passive not supported
    }
    return passive;
}();

});



parcelRegister("4iSHH", function(module, exports) {

$parcel$export(module.exports, "asString", () => $322346e1ff7894ca$export$590567be997858b6);
$parcel$export(module.exports, "toString", () => $322346e1ff7894ca$export$f84e8e69fd4488a5);
$parcel$export(module.exports, "withAlpha", () => $322346e1ff7894ca$export$138c09bdd6bd797c);
$parcel$export(module.exports, "rgbaToLcha", () => $322346e1ff7894ca$export$44fb54fa2e0c0d4);
$parcel$export(module.exports, "lchaToRgba", () => $322346e1ff7894ca$export$27cc94530c050f00);
$parcel$export(module.exports, "fromString", () => $322346e1ff7894ca$export$3004f64547af360e);
$parcel$export(module.exports, "normalize", () => $322346e1ff7894ca$export$a3295358bff77e);
$parcel$export(module.exports, "asArray", () => $322346e1ff7894ca$export$75093a47a9fa838d);
$parcel$export(module.exports, "isStringColor", () => $322346e1ff7894ca$export$40dd713d7775a0b1);
/**
 * @module ol/color
 */ 
var $3FrN6 = parcelRequire("3FrN6");

var $9xJSj = parcelRequire("9xJSj");

var $4KsDk = parcelRequire("4KsDk");

var $5gufb = parcelRequire("5gufb");

var $9byFX = parcelRequire("9byFX");
function $322346e1ff7894ca$export$590567be997858b6(color) {
    if (typeof color === "string") return color;
    return $322346e1ff7894ca$export$f84e8e69fd4488a5(color);
}
/**
 * @type {number}
 */ const $322346e1ff7894ca$var$MAX_CACHE_SIZE = 1024;
/**
 * We maintain a small cache of parsed strings.  Whenever the cache grows too large,
 * we delete an arbitrary set of the entries.
 *
 * @type {Object<string, Color>}
 */ const $322346e1ff7894ca$var$cache = {};
/**
 * @type {number}
 */ let $322346e1ff7894ca$var$cacheSize = 0;
function $322346e1ff7894ca$export$138c09bdd6bd797c(color) {
    if (color.length === 4) return color;
    const output = color.slice();
    output[3] = 1;
    return output;
}
function $322346e1ff7894ca$export$44fb54fa2e0c0d4(color) {
    const output = (0, $5gufb.default).lchuv((0, $4KsDk.default).xyz(color));
    output[3] = color[3];
    return output;
}
function $322346e1ff7894ca$export$27cc94530c050f00(color) {
    const output = (0, $5gufb.default).rgb((0, $3FrN6.default).xyz(color));
    output[3] = color[3];
    return output;
}
function $322346e1ff7894ca$export$3004f64547af360e(s) {
    if ($322346e1ff7894ca$var$cache.hasOwnProperty(s)) return $322346e1ff7894ca$var$cache[s];
    if ($322346e1ff7894ca$var$cacheSize >= $322346e1ff7894ca$var$MAX_CACHE_SIZE) {
        let i = 0;
        for(const key in $322346e1ff7894ca$var$cache)if ((i++ & 3) === 0) {
            delete $322346e1ff7894ca$var$cache[key];
            --$322346e1ff7894ca$var$cacheSize;
        }
    }
    const color = (0, $9xJSj.default)(s);
    if (color.length !== 4) throw new Error('Failed to parse "' + s + '" as color');
    for (const c of color){
        if (isNaN(c)) throw new Error('Failed to parse "' + s + '" as color');
    }
    $322346e1ff7894ca$export$a3295358bff77e(color);
    $322346e1ff7894ca$var$cache[s] = color;
    ++$322346e1ff7894ca$var$cacheSize;
    return color;
}
function $322346e1ff7894ca$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    return $322346e1ff7894ca$export$3004f64547af360e(color);
}
function $322346e1ff7894ca$export$a3295358bff77e(color) {
    color[0] = (0, $9byFX.clamp)(color[0] + 0.5 | 0, 0, 255);
    color[1] = (0, $9byFX.clamp)(color[1] + 0.5 | 0, 0, 255);
    color[2] = (0, $9byFX.clamp)(color[2] + 0.5 | 0, 0, 255);
    color[3] = (0, $9byFX.clamp)(color[3], 0, 1);
    return color;
}
function $322346e1ff7894ca$export$f84e8e69fd4488a5(color) {
    let r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    let g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    let b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    const a = color[3] === undefined ? 1 : Math.round(color[3] * 1000) / 1000;
    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
}
function $322346e1ff7894ca$export$40dd713d7775a0b1(s) {
    try {
        $322346e1ff7894ca$export$3004f64547af360e(s);
        return true;
    } catch (_) {
        return false;
    }
}

});
parcelRegister("3FrN6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2abac224ee1f2820$export$2e2bcd8739ae039);
/**
 * Cylindrical CIE LUV
 *
 * @module color-space/lchuv
 */ 
var $ljULE = parcelRequire("ljULE");

var $5gufb = parcelRequire("5gufb");
//cylindrical luv
var $2abac224ee1f2820$var$lchuv = {
    name: "lchuv",
    channel: [
        "lightness",
        "chroma",
        "hue"
    ],
    alias: [
        "LCHuv",
        "cielchuv"
    ],
    min: [
        0,
        0,
        0
    ],
    max: [
        100,
        100,
        360
    ],
    luv: function(luv) {
        var l = luv[0], c = luv[1], h = luv[2], u, v, hr;
        hr = h / 360 * 2 * Math.PI;
        u = c * Math.cos(hr);
        v = c * Math.sin(hr);
        return [
            l,
            u,
            v
        ];
    },
    xyz: function(arg) {
        return (0, $ljULE.default).xyz($2abac224ee1f2820$var$lchuv.luv(arg));
    }
};
var $2abac224ee1f2820$export$2e2bcd8739ae039 = $2abac224ee1f2820$var$lchuv;
(0, $ljULE.default).lchuv = function(luv) {
    var l = luv[0], u = luv[1], v = luv[2];
    var c = Math.sqrt(u * u + v * v);
    var hr = Math.atan2(v, u);
    var h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    return [
        l,
        c,
        h
    ];
};
(0, $5gufb.default).lchuv = function(arg) {
    return (0, $ljULE.default).lchuv((0, $5gufb.default).luv(arg));
};

});
parcelRegister("ljULE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f857682ac15a36ea$export$2e2bcd8739ae039);
/**
 * CIE LUV (C'est la vie)
 *
 * @module color-space/luv
 */ 
var $5gufb = parcelRequire("5gufb");
var $f857682ac15a36ea$export$2e2bcd8739ae039 = {
    name: "luv",
    //NOTE: luv has no rigidly defined limits
    //easyrgb fails to get proper coords
    //boronine states no rigid limits
    //colorMine refers this ones:
    min: [
        0,
        -134,
        -140
    ],
    max: [
        100,
        224,
        122
    ],
    channel: [
        "lightness",
        "u",
        "v"
    ],
    alias: [
        "LUV",
        "cieluv",
        "cie1976"
    ],
    xyz: function(arg, i, o) {
        var _u, _v, l, u, v, x, y, z, xn, yn, zn, un, vn;
        l = arg[0], u = arg[1], v = arg[2];
        if (l === 0) return [
            0,
            0,
            0
        ];
        //get constants
        //var e = 0.008856451679035631; //(6/29)^3
        var k = 0.0011070564598794539; //(3/29)^3
        //get illuminant/observer
        i = i || "D65";
        o = o || 2;
        xn = (0, $5gufb.default).whitepoint[o][i][0];
        yn = (0, $5gufb.default).whitepoint[o][i][1];
        zn = (0, $5gufb.default).whitepoint[o][i][2];
        un = 4 * xn / (xn + 15 * yn + 3 * zn);
        vn = 9 * yn / (xn + 15 * yn + 3 * zn);
        // un = 0.19783000664283;
        // vn = 0.46831999493879;
        _u = u / (13 * l) + un || 0;
        _v = v / (13 * l) + vn || 0;
        y = l > 8 ? yn * Math.pow((l + 16) / 116, 3) : yn * l * k;
        //wikipedia method
        x = y * 9 * _u / (4 * _v) || 0;
        z = y * (12 - 3 * _u - 20 * _v) / (4 * _v) || 0;
        //boronine method
        //https://github.com/boronine/husl/blob/master/husl.coffee#L201
        // x = 0 - (9 * y * _u) / ((_u - 4) * _v - _u * _v);
        // z = (9 * y - (15 * _v * y) - (_v * x)) / (3 * _v);
        return [
            x,
            y,
            z
        ];
    }
};
// http://www.brucelindbloom.com/index.html?Equations.html
// https://github.com/boronine/husl/blob/master/husl.coffee
//i - illuminant
//o - observer
(0, $5gufb.default).luv = function(arg, i, o) {
    var _u, _v, l, u, v, x, y, z, xn, yn, zn, un, vn;
    //get constants
    var e = 0.008856451679035631; //(6/29)^3
    var k = 903.2962962962961; //(29/3)^3
    //get illuminant/observer coords
    i = i || "D65";
    o = o || 2;
    xn = (0, $5gufb.default).whitepoint[o][i][0];
    yn = (0, $5gufb.default).whitepoint[o][i][1];
    zn = (0, $5gufb.default).whitepoint[o][i][2];
    un = 4 * xn / (xn + 15 * yn + 3 * zn);
    vn = 9 * yn / (xn + 15 * yn + 3 * zn);
    x = arg[0], y = arg[1], z = arg[2];
    _u = 4 * x / (x + 15 * y + 3 * z) || 0;
    _v = 9 * y / (x + 15 * y + 3 * z) || 0;
    var yr = y / yn;
    l = yr <= e ? k * yr : 116 * Math.pow(yr, 1 / 3) - 16;
    u = 13 * l * (_u - un);
    v = 13 * l * (_v - vn);
    return [
        l,
        u,
        v
    ];
};

});
parcelRegister("5gufb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d55e8295660d0b8$export$2e2bcd8739ae039);
/**
 * CIE XYZ
 *
 * @module  color-space/xyz
 */ 
var $4KsDk = parcelRequire("4KsDk");
var $3d55e8295660d0b8$var$xyz = {
    name: "xyz",
    min: [
        0,
        0,
        0
    ],
    channel: [
        "X",
        "Y",
        "Z"
    ],
    alias: [
        "XYZ",
        "ciexyz",
        "cie1931"
    ]
};
/**
 * Whitepoint reference values with observer/illuminant
 *
 * http://en.wikipedia.org/wiki/Standard_illuminant
 */ $3d55e8295660d0b8$var$xyz.whitepoint = {
    //1931 2°
    2: {
        //incadescent
        A: [
            109.85,
            100,
            35.585
        ],
        // B:[],
        C: [
            98.074,
            100,
            118.232
        ],
        D50: [
            96.422,
            100,
            82.521
        ],
        D55: [
            95.682,
            100,
            92.149
        ],
        //daylight
        D65: [
            95.045592705167,
            100,
            108.9057750759878
        ],
        D75: [
            94.972,
            100,
            122.638
        ],
        //flourescent
        // F1: [],
        F2: [
            99.187,
            100,
            67.395
        ],
        // F3: [],
        // F4: [],
        // F5: [],
        // F6:[],
        F7: [
            95.044,
            100,
            108.755
        ],
        // F8: [],
        // F9: [],
        // F10: [],
        F11: [
            100.966,
            100,
            64.370
        ],
        // F12: [],
        E: [
            100,
            100,
            100
        ]
    },
    //1964  10°
    10: {
        //incadescent
        A: [
            111.144,
            100,
            35.200
        ],
        C: [
            97.285,
            100,
            116.145
        ],
        D50: [
            96.720,
            100,
            81.427
        ],
        D55: [
            95.799,
            100,
            90.926
        ],
        //daylight
        D65: [
            94.811,
            100,
            107.304
        ],
        D75: [
            94.416,
            100,
            120.641
        ],
        //flourescent
        F2: [
            103.280,
            100,
            69.026
        ],
        F7: [
            95.792,
            100,
            107.687
        ],
        F11: [
            103.866,
            100,
            65.627
        ],
        E: [
            100,
            100,
            100
        ]
    }
};
/**
 * Top values are the whitepoint’s top values, default are D65
 */ $3d55e8295660d0b8$var$xyz.max = $3d55e8295660d0b8$var$xyz.whitepoint[2].D65;
/**
 * Transform xyz to rgb
 *
 * @param {Array} xyz Array of xyz values
 *
 * @return {Array} RGB values
 */ $3d55e8295660d0b8$var$xyz.rgb = function(_xyz, white) {
    //FIXME: make sure we have to divide like this. Probably we have to replace matrix as well then
    white = white || $3d55e8295660d0b8$var$xyz.whitepoint[2].E;
    var x = _xyz[0] / white[0], y = _xyz[1] / white[1], z = _xyz[2] / white[2], r, g, b;
    // assume sRGB
    // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
    r = x * 3.240969941904521 + y * -1.537383177570093 + z * -0.498610760293;
    g = x * -0.96924363628087 + y * 1.87596750150772 + z * 0.041555057407175;
    b = x * 0.055630079696993 + y * -0.20397695888897 + z * 1.056971514242878;
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r = r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g = g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b = b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
/**
 * RGB to XYZ
 *
 * @param {Array} rgb RGB channels
 *
 * @return {Array} XYZ channels
 */ (0, $4KsDk.default).xyz = function(rgb, white) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.41239079926595 + g * 0.35758433938387 + b * 0.18048078840183;
    var y = r * 0.21263900587151 + g * 0.71516867876775 + b * 0.072192315360733;
    var z = r * 0.019330818715591 + g * 0.11919477979462 + b * 0.95053215224966;
    white = white || $3d55e8295660d0b8$var$xyz.whitepoint[2].E;
    return [
        x * white[0],
        y * white[1],
        z * white[2]
    ];
};
var $3d55e8295660d0b8$export$2e2bcd8739ae039 = $3d55e8295660d0b8$var$xyz;

});
parcelRegister("4KsDk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3751ab4954229b70$export$2e2bcd8739ae039);
/**
 * RGB space.
 *
 * @module  color-space/rgb
 */ var $3751ab4954229b70$export$2e2bcd8739ae039 = {
    name: "rgb",
    min: [
        0,
        0,
        0
    ],
    max: [
        255,
        255,
        255
    ],
    channel: [
        "red",
        "green",
        "blue"
    ],
    alias: [
        "RGB"
    ]
};

});




parcelRegister("9xJSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f2ac7eebd53949d$export$2e2bcd8739ae039);
/** @module  color-rgba */ 
var $7fPnR = parcelRequire("7fPnR");

var $4KsDk = parcelRequire("4KsDk");

var $6rGlo = parcelRequire("6rGlo");
function $6f2ac7eebd53949d$export$2e2bcd8739ae039(color) {
    // template literals
    if (Array.isArray(color) && color.raw) color = String.raw(...arguments);
    if (color instanceof Number) color = +color;
    var values, i, l;
    //attempt to parse non-array arguments
    var parsed = (0, $7fPnR.default)(color);
    if (!parsed.space) return [];
    const min = parsed.space[0] === "h" ? (0, $6rGlo.default).min : (0, $4KsDk.default).min;
    const max = parsed.space[0] === "h" ? (0, $6rGlo.default).max : (0, $4KsDk.default).max;
    values = Array(3);
    values[0] = Math.min(Math.max(parsed.values[0], min[0]), max[0]);
    values[1] = Math.min(Math.max(parsed.values[1], min[1]), max[1]);
    values[2] = Math.min(Math.max(parsed.values[2], min[2]), max[2]);
    if (parsed.space[0] === "h") values = (0, $6rGlo.default).rgb(values);
    values.push(Math.min(Math.max(parsed.alpha, 0), 1));
    return values;
}

});
parcelRegister("7fPnR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5481cadd51b98557$export$2e2bcd8739ae039);
/**
 * @module color-parse
 */ 
var $cXvTj = parcelRequire("cXvTj");
var $5481cadd51b98557$export$2e2bcd8739ae039 = $5481cadd51b98557$var$parse;
/**
 * Base hues
 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
 */ //FIXME: use external hue detector
var $5481cadd51b98557$var$baseHues = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
};
/**
 * Parse color from the string passed
 *
 * @return {Object} A space indicator `space`, an array `values` and `alpha`
 */ function $5481cadd51b98557$var$parse(cstr) {
    var m, parts = [], alpha = 1, space;
    //numeric case
    if (typeof cstr === "number") return {
        space: "rgb",
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    if (typeof cstr === "number") return {
        space: "rgb",
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    cstr = String(cstr).toLowerCase();
    //keyword
    if ((0, $cXvTj.default)[cstr]) {
        parts = (0, $cXvTj.default)[cstr].slice();
        space = "rgb";
    } else if (cstr === "transparent") {
        alpha = 0;
        space = "rgb";
        parts = [
            0,
            0,
            0
        ];
    } else if (cstr[0] === "#") {
        var base = cstr.slice(1);
        var size = base.length;
        var isShort = size <= 4;
        alpha = 1;
        if (isShort) {
            parts = [
                parseInt(base[0] + base[0], 16),
                parseInt(base[1] + base[1], 16),
                parseInt(base[2] + base[2], 16)
            ];
            if (size === 4) alpha = parseInt(base[3] + base[3], 16) / 255;
        } else {
            parts = [
                parseInt(base[0] + base[1], 16),
                parseInt(base[2] + base[3], 16),
                parseInt(base[4] + base[5], 16)
            ];
            if (size === 8) alpha = parseInt(base[6] + base[7], 16) / 255;
        }
        if (!parts[0]) parts[0] = 0;
        if (!parts[1]) parts[1] = 0;
        if (!parts[2]) parts[2] = 0;
        space = "rgb";
    } else if (m = /^((?:rgba?|hs[lvb]a?|hwba?|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms|oklch|oklab|color))\s*\(([^\)]*)\)/.exec(cstr)) {
        var name = m[1];
        space = name.replace(/a$/, "");
        var dims = space === "cmyk" ? 4 : space === "gray" ? 1 : 3;
        parts = m[2].trim().split(/\s*[,\/]\s*|\s+/);
        // color(srgb-linear x x x) -> srgb-linear(x x x)
        if (space === "color") space = parts.shift();
        parts = parts.map(function(x, i) {
            //<percentage>
            if (x[x.length - 1] === "%") {
                x = parseFloat(x) / 100;
                // alpha -> 0..1
                if (i === 3) return x;
                // rgb -> 0..255
                if (space === "rgb") return x * 255;
                // hsl, hwb H -> 0..100
                if (space[0] === "h") return x * 100;
                // lch, lab L -> 0..100
                if (space[0] === "l" && !i) return x * 100;
                // lab A B -> -125..125
                if (space === "lab") return x * 125;
                // lch C -> 0..150, H -> 0..360
                if (space === "lch") return i < 2 ? x * 150 : x * 360;
                // oklch/oklab L -> 0..1
                if (space[0] === "o" && !i) return x;
                // oklab A B -> -0.4..0.4
                if (space === "oklab") return x * 0.4;
                // oklch C -> 0..0.4, H -> 0..360
                if (space === "oklch") return i < 2 ? x * 0.4 : x * 360;
                // color(xxx) -> 0..1
                return x;
            }
            //hue
            if (space[i] === "h" || i === 2 && space[space.length - 1] === "h") {
                //<base-hue>
                if ($5481cadd51b98557$var$baseHues[x] !== undefined) return $5481cadd51b98557$var$baseHues[x];
                //<deg>
                if (x.endsWith("deg")) return parseFloat(x);
                //<turn>
                if (x.endsWith("turn")) return parseFloat(x) * 360;
                if (x.endsWith("grad")) return parseFloat(x) * 360 / 400;
                if (x.endsWith("rad")) return parseFloat(x) * 180 / Math.PI;
            }
            if (x === "none") return 0;
            return parseFloat(x);
        });
        alpha = parts.length > dims ? parts.pop() : 1;
    } else if (/[0-9](?:\s|\/|,)/.test(cstr)) {
        parts = cstr.match(/([0-9]+)/g).map(function(value) {
            return parseFloat(value);
        });
        space = cstr.match(/([a-z])/ig)?.join("")?.toLowerCase() || "rgb";
    }
    return {
        space: space,
        values: parts,
        alpha: alpha
    };
}

});
parcelRegister("cXvTj", function(module, exports) {

$parcel$export(module.exports, "default", () => $96f3bba6e010158e$export$2e2bcd8739ae039);
var $96f3bba6e010158e$export$2e2bcd8739ae039 = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};

});


parcelRegister("6rGlo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b161c5b6bfbd933$export$2e2bcd8739ae039);
/**
 * @module color-space/hsl
 */ 
var $4KsDk = parcelRequire("4KsDk");
var $4b161c5b6bfbd933$export$2e2bcd8739ae039 = {
    name: "hsl",
    min: [
        0,
        0,
        0
    ],
    max: [
        360,
        100,
        100
    ],
    channel: [
        "hue",
        "saturation",
        "lightness"
    ],
    alias: [
        "HSL"
    ],
    rgb: function(hsl) {
        var h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100, t1, t2, t3, rgb, val, i = 0;
        if (s === 0) return val = l * 255, [
            val,
            val,
            val
        ];
        t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        t1 = 2 * l - t2;
        rgb = [
            0,
            0,
            0
        ];
        for(; i < 3;){
            t3 = h + 1 / 3 * -(i - 1);
            t3 < 0 ? t3++ : t3 > 1 && t3--;
            val = 6 * t3 < 1 ? t1 + (t2 - t1) * 6 * t3 : 2 * t3 < 1 ? t2 : 3 * t3 < 2 ? t1 + (t2 - t1) * (2 / 3 - t3) * 6 : t1;
            rgb[i++] = val * 255;
        }
        return rgb;
    }
};
//extend rgb
(0, $4KsDk.default).hsl = function(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min, h, s, l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};

});




parcelRegister("hCs6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd3bc8d185522361$export$2e2bcd8739ae039);
/**
 * @module ol/ImageTile
 */ 
var $1izXo = parcelRequire("1izXo");

var $fOhwi = parcelRequire("fOhwi");

var $DfnQm = parcelRequire("DfnQm");

var $fySoz = parcelRequire("fySoz");
class $cd3bc8d185522361$var$ImageTile extends (0, $1izXo.default) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, crossOrigin, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ this.src_ = src;
        this.key = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */ this.image_ = new Image();
        if (crossOrigin !== null) this.image_.crossOrigin = crossOrigin;
        /**
     * @private
     * @type {?function():void}
     */ this.unlisten_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
    }
    /**
   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|HTMLImageElement} element Element.
   */ setImage(element) {
        this.image_ = element;
        this.state = (0, $fOhwi.default).LOADED;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Tracks loading or read errors.
   *
   * @private
   */ handleImageError_() {
        this.state = (0, $fOhwi.default).ERROR;
        this.unlistenImage_();
        this.image_ = $cd3bc8d185522361$var$getBlankImage();
        this.changed();
    }
    /**
   * Tracks successful image load.
   *
   * @private
   */ handleImageLoad_() {
        const image = /** @type {HTMLImageElement} */ this.image_;
        if (image.naturalWidth && image.naturalHeight) this.state = (0, $fOhwi.default).LOADED;
        else this.state = (0, $fOhwi.default).EMPTY;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   *
   * @api
   */ load() {
        if (this.state == (0, $fOhwi.default).ERROR) {
            this.state = (0, $fOhwi.default).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        }
        if (this.state == (0, $fOhwi.default).IDLE) {
            this.state = (0, $fOhwi.default).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, $fySoz.listenImage)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    }
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ unlistenImage_() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    }
}
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */ function $cd3bc8d185522361$var$getBlankImage() {
    const ctx = (0, $DfnQm.createCanvasContext2D)(1, 1);
    ctx.fillStyle = "rgba(0,0,0,0)";
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $cd3bc8d185522361$export$2e2bcd8739ae039 = $cd3bc8d185522361$var$ImageTile;

});
parcelRegister("1izXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f235d2d04095c6e$export$2e2bcd8739ae039);
/**
 * @module ol/Tile
 */ 
var $KD0eF = parcelRequire("KD0eF");

var $3xzSb = parcelRequire("3xzSb");

var $fOhwi = parcelRequire("fOhwi");

var $9iPUS = parcelRequire("9iPUS");

var $h9x7v = parcelRequire("h9x7v");
/**
 * A function that takes an {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState.js';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   const xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     const data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes an {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ class $0f235d2d04095c6e$var$Tile extends (0, $KD0eF.default) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */ constructor(tileCoord, state, options){
        super();
        options = options ? options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {import("./TileState.js").default}
     */ this.state = state;
        /**
     * An "interim" tile for this tile. The interim tile may be used while this
     * one is loading, for "smooth" transitions when changing params/dimensions
     * on the source.
     * @type {Tile|null}
     */ this.interimTile = null;
        /**
     * A key assigned to the tile. This is used by the tile source to determine
     * if this tile can effectively be used, or if a new tile should be created
     * and this one be used as an interim tile for this new tile.
     * @type {string}
     */ this.key = "";
        /**
     * The duration for the opacity transition.
     * @type {number}
     */ this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @type {Object<string, number>}
     */ this.transitionStarts_ = {};
        /**
     * @type {boolean}
     */ this.interpolate = !!options.interpolate;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $3xzSb.default).CHANGE);
    }
    /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */ release() {
        if (this.state === (0, $fOhwi.default).ERROR) // to remove the `change` listener on this tile in `ol/TileQueue#handleTileChange`
        this.setState((0, $fOhwi.default).EMPTY);
    }
    /**
   * @return {string} Key.
   */ getKey() {
        return this.key + "/" + this.tileCoord;
    }
    /**
   * Get the interim tile most suitable for rendering using the chain of interim
   * tiles. This corresponds to the  most recent tile that has been loaded, if no
   * such tile exists, the original tile is returned.
   * @return {!Tile} Best tile for rendering.
   */ getInterimTile() {
        let tile = this.interimTile;
        if (!tile) //empty chain
        return this;
        // find the first loaded tile and return it. Since the chain is sorted in
        // decreasing order of creation time, there is no need to search the remainder
        // of the list (all those tiles correspond to older requests and will be
        // cleaned up by refreshInterimChain)
        do {
            if (tile.getState() == (0, $fOhwi.default).LOADED) {
                // Show tile immediately instead of fading it in after loading, because
                // the interim tile is in place already
                this.transition_ = 0;
                return tile;
            }
            tile = tile.interimTile;
        }while (tile);
        // we can not find a better tile
        return this;
    }
    /**
   * Goes through the chain of interim tiles and discards sections of the chain
   * that are no longer relevant.
   */ refreshInterimChain() {
        let tile = this.interimTile;
        if (!tile) return;
        /** @type {Tile} */ let prev = this;
        do {
            if (tile.getState() == (0, $fOhwi.default).LOADED) {
                //we have a loaded tile, we can discard the rest of the list
                //we would could abort any LOADING tile request
                //older than this tile (i.e. any LOADING tile following this entry in the chain)
                tile.interimTile = null;
                break;
            }
            if (tile.getState() == (0, $fOhwi.default).LOADING) //keep this LOADING tile any loaded tiles later in the chain are
            //older than this tile, so we're still interested in the request
            prev = tile;
            else if (tile.getState() == (0, $fOhwi.default).IDLE) //the head of the list is the most current tile, we don't need
            //to start any other requests for this chain
            prev.interimTile = tile.interimTile;
            else prev = tile;
            tile = prev.interimTile;
        }while (tile);
    }
    /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ getTileCoord() {
        return this.tileCoord;
    }
    /**
   * @return {import("./TileState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */ setState(state) {
        if (this.state !== (0, $fOhwi.default).ERROR && this.state > state) throw new Error("Tile load sequence violation");
        this.state = state;
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ load() {
        (0, $9iPUS.abstract)();
    }
    /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ getAlpha(id, time) {
        if (!this.transition_) return 1;
        let start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        const delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $h9x7v.easeIn)(delta / this.transition_);
    }
    /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ inTransition(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    }
    /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ endTransition(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    }
}
var $0f235d2d04095c6e$export$2e2bcd8739ae039 = $0f235d2d04095c6e$var$Tile;

});
parcelRegister("fOhwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8291d9739c3c64e$export$2e2bcd8739ae039);
/**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $b8291d9739c3c64e$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4
};

});


parcelRegister("fySoz", function(module, exports) {

$parcel$export(module.exports, "listenImage", () => $b54439be79d4619a$export$bc96ecc7c2a50764);
$parcel$export(module.exports, "decodeFallback", () => $b54439be79d4619a$export$a9e5af241c1bd389);
/**
 * @module ol/Image
 */ 
var $KD0eF = parcelRequire("KD0eF");

var $3xzSb = parcelRequire("3xzSb");

var $aSvtr = parcelRequire("aSvtr");

var $8UoiJ = parcelRequire("8UoiJ");

var $ilM9F = parcelRequire("ilM9F");

var $6wUzV = parcelRequire("6wUzV");
/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(import("./Image.js").default, string): void} LoadFunction
 * @api
 */ /**
 * @typedef {Object} ImageObject
 * @property {import("./extent.js").Extent} [extent] Extent, if different from the requested one.
 * @property {import("./resolution.js").ResolutionLike} [resolution] Resolution, if different from the requested one.
 * When x and y resolution are different, use the array type (`[xResolution, yResolution]`).
 * @property {number} [pixelRatio] Pixel ratio, if different from the requested one.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * For images that cover any extent and resolution (static images), the loader function should not accept
 * any arguments. The function returns an {@link import("./DataTile.js").ImageLike image}, an
 * {@link import("./Image.js").ImageObject image object}, or a promise for the same.
 * For loaders that generate images, the promise should not resolve until the image is loaded.
 * If the returned image does not match the extent, resolution or pixel ratio passed to the loader,
 * it has to return an {@link import("./Image.js").ImageObject image object} with the `image` and the
 * correct `extent`, `resolution` and `pixelRatio`.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} Loader
 * @api
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * The function returns a promise for an  {@link import("./Image.js").ImageObject image object}.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} ImageObjectPromiseLoader
 */ class $b54439be79d4619a$var$ImageWrapper extends (0, $KD0eF.default) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|Array<number>|undefined} resolution Resolution. If provided as array, x and y
   * resolution will be assumed.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default|import("./Image.js").Loader} stateOrLoader State.
   */ constructor(extent, resolution, pixelRatio, stateOrLoader){
        super();
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ this.extent = extent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|Array<number>|undefined}
     */ this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ this.state = typeof stateOrLoader === "function" ? (0, $aSvtr.default).IDLE : stateOrLoader;
        /**
     * @private
     * @type {import('./DataTile.js').ImageLike|null}
     */ this.image_ = null;
        /**
     * @protected
     * @type {import("./Image.js").Loader}
     */ this.loader = typeof stateOrLoader === "function" ? stateOrLoader : null;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $3xzSb.default).CHANGE);
    }
    /**
   * @return {import("./extent.js").Extent} Extent.
   */ getExtent() {
        return this.extent;
    }
    /**
   * @return {import('./DataTile.js').ImageLike} Image.
   */ getImage() {
        return this.image_;
    }
    /**
   * @return {number} PixelRatio.
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * @return {number|Array<number>} Resolution.
   */ getResolution() {
        return /** @type {number} */ this.resolution;
    }
    /**
   * @return {import("./ImageState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $aSvtr.default).IDLE) {
            if (this.loader) {
                this.state = (0, $aSvtr.default).LOADING;
                this.changed();
                const resolution = this.getResolution();
                const requestResolution = Array.isArray(resolution) ? resolution[0] : resolution;
                (0, $6wUzV.toPromise)(()=>this.loader(this.getExtent(), requestResolution, this.getPixelRatio())).then((image)=>{
                    if ("image" in image) this.image_ = image.image;
                    if ("extent" in image) this.extent = image.extent;
                    if ("resolution" in image) this.resolution = image.resolution;
                    if ("pixelRatio" in image) this.pixelRatio_ = image.pixelRatio;
                    if (image instanceof HTMLImageElement || image instanceof ImageBitmap || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement) this.image_ = image;
                    this.state = (0, $aSvtr.default).LOADED;
                }).catch((error)=>{
                    this.state = (0, $aSvtr.default).ERROR;
                    console.error(error); // eslint-disable-line no-console
                }).finally(()=>this.changed());
            }
        }
    }
    /**
   * @param {import('./DataTile.js').ImageLike} image The image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number|Array<number>} resolution Resolution.
   */ setResolution(resolution) {
        this.resolution = resolution;
    }
}
function $b54439be79d4619a$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    const img = /** @type {HTMLImageElement} */ image;
    let listening = true;
    let decoding = false;
    let loaded = false;
    const listenerKeys = [
        (0, $ilM9F.listenOnce)(img, (0, $3xzSb.default).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, $8UoiJ.IMAGE_DECODE)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, $ilM9F.listenOnce)(img, (0, $3xzSb.default).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, $ilM9F.unlistenByKey));
    };
}
function $b54439be79d4619a$export$11e63f7b0f3d9900(image, src) {
    return new Promise((resolve, reject)=>{
        function handleLoad() {
            unlisten();
            resolve(image);
        }
        function handleError() {
            unlisten();
            reject(new Error("Image load error"));
        }
        function unlisten() {
            image.removeEventListener("load", handleLoad);
            image.removeEventListener("error", handleError);
        }
        image.addEventListener("load", handleLoad);
        image.addEventListener("error", handleError);
        if (src) image.src = src;
    });
}
function $b54439be79d4619a$export$a9e5af241c1bd389(image, src) {
    if (src) image.src = src;
    return image.src && (0, $8UoiJ.IMAGE_DECODE) ? new Promise((resolve, reject)=>image.decode().then(()=>resolve(image)).catch((e)=>image.complete && image.width ? resolve(image) : reject(e))) : $b54439be79d4619a$export$11e63f7b0f3d9900(image);
}
function $b54439be79d4619a$export$2f872c0f2117be69(image, src) {
    if (src) image.src = src;
    return image.src && (0, $8UoiJ.IMAGE_DECODE) && (0, $8UoiJ.CREATE_IMAGE_BITMAP) ? image.decode().then(()=>createImageBitmap(image)).catch((e)=>{
        if (image.complete && image.width) return image;
        throw e;
    }) : $b54439be79d4619a$export$a9e5af241c1bd389(image);
}
var $b54439be79d4619a$export$2e2bcd8739ae039 = $b54439be79d4619a$var$ImageWrapper;

});


parcelRegister("4WmJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $398e350e33050c07$export$2e2bcd8739ae039);
/**
 * @module ol/reproj/Tile
 */ 
var $cfilv = parcelRequire("cfilv");

var $3xzSb = parcelRequire("3xzSb");

var $1izXo = parcelRequire("1izXo");

var $fOhwi = parcelRequire("fOhwi");

var $9gka6 = parcelRequire("9gka6");

var $3H62b = parcelRequire("3H62b");

var $9byFX = parcelRequire("9byFX");

var $9pD6L = parcelRequire("9pD6L");

var $ilM9F = parcelRequire("ilM9F");

var $DfnQm = parcelRequire("DfnQm");
/**
 * @typedef {function(number, number, number, number) : (import("../ImageTile.js").default)} FunctionType
 */ /**
 * @typedef {Object} TileOffset
 * @property {import("../ImageTile.js").default} tile Tile.
 * @property {number} offset Offset.
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ class $398e350e33050c07$var$ReprojTile extends (0, $1izXo.default) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {import("../Tile.js").Options} [options] Tile options.
   */ constructor(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, errorThreshold, renderEdges, options){
        super(tileCoord, (0, $fOhwi.default).IDLE, options);
        /**
     * @private
     * @type {boolean}
     */ this.renderEdges_ = renderEdges !== undefined ? renderEdges : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<TileOffset>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.clipExtent_ = sourceProj.canWrapX() ? sourceProj.getExtent() : undefined;
        const targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
        const maxTargetExtent = this.targetTileGrid_.getExtent();
        let maxSourceExtent = this.sourceTileGrid_.getExtent();
        const limitedTargetExtent = maxTargetExtent ? (0, $9pD6L.getIntersection)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $9pD6L.getArea)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, $fOhwi.default).EMPTY;
            return;
        }
        const sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $9pD6L.getIntersection)(maxSourceExtent, sourceProjExtent);
        }
        const targetResolution = targetTileGrid.getResolution(this.wrappedTileCoord_[0]);
        const sourceResolution = (0, $3H62b.calculateSourceExtentResolution)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, $fOhwi.default).EMPTY;
            return;
        }
        const errorThresholdInPixels = errorThreshold !== undefined ? errorThreshold : (0, $cfilv.ERROR_THRESHOLD);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, $9gka6.default)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, $fOhwi.default).EMPTY;
            return;
        }
        this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        let sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $9byFX.clamp)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $9byFX.clamp)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $9pD6L.getIntersection)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $9pD6L.getArea)(sourceExtent)) this.state = (0, $fOhwi.default).EMPTY;
        else {
            let worldWidth = 0;
            let worldsAway = 0;
            if (sourceProj.canWrapX()) {
                worldWidth = (0, $9pD6L.getWidth)(sourceProjExtent);
                worldsAway = Math.floor((sourceExtent[0] - sourceProjExtent[0]) / worldWidth);
            }
            const sourceExtents = (0, $9pD6L.wrapAndSliceX)(sourceExtent.slice(), sourceProj, true);
            sourceExtents.forEach((extent)=>{
                const sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(extent, this.sourceZ_);
                for(let srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(let srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                    const tile = getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio);
                    if (tile) {
                        const offset = worldsAway * worldWidth;
                        this.sourceTiles_.push({
                            tile: tile,
                            offset: offset
                        });
                    }
                }
                ++worldsAway;
            });
            if (this.sourceTiles_.length === 0) this.state = (0, $fOhwi.default).EMPTY;
        }
    }
    /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement} Canvas.
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @private
   */ reproject_() {
        const sources = [];
        this.sourceTiles_.forEach((source)=>{
            const tile = source.tile;
            if (tile && tile.getState() == (0, $fOhwi.default).LOADED) {
                const extent = this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord);
                extent[0] += source.offset;
                extent[2] += source.offset;
                const clipExtent = this.clipExtent_?.slice();
                if (clipExtent) {
                    clipExtent[0] += source.offset;
                    clipExtent[2] += source.offset;
                }
                sources.push({
                    extent: extent,
                    clipExtent: clipExtent,
                    image: tile.getImage()
                });
            }
        });
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $fOhwi.default).ERROR;
        else {
            const z = this.wrappedTileCoord_[0];
            const size = this.targetTileGrid_.getTileSize(z);
            const width = typeof size === "number" ? size : size[0];
            const height = typeof size === "number" ? size : size[1];
            const targetResolution = this.targetTileGrid_.getResolution(z);
            const sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $3H62b.render)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
            this.state = (0, $fOhwi.default).LOADED;
        }
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $fOhwi.default).IDLE) {
            this.state = (0, $fOhwi.default).LOADING;
            this.changed();
            let leftToLoad = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach(({ tile: tile })=>{
                const state = tile.getState();
                if (state == (0, $fOhwi.default).IDLE || state == (0, $fOhwi.default).LOADING) {
                    leftToLoad++;
                    const sourceListenKey = (0, $ilM9F.listen)(tile, (0, $3xzSb.default).CHANGE, function(e) {
                        const state = tile.getState();
                        if (state == (0, $fOhwi.default).LOADED || state == (0, $fOhwi.default).ERROR || state == (0, $fOhwi.default).EMPTY) {
                            (0, $ilM9F.unlistenByKey)(sourceListenKey);
                            leftToLoad--;
                            if (leftToLoad === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    }, this);
                    this.sourcesListenerKeys_.push(sourceListenKey);
                }
            });
            if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
            else this.sourceTiles_.forEach(function({ tile: tile }, i, arr) {
                const state = tile.getState();
                if (state == (0, $fOhwi.default).IDLE) tile.load();
            });
        }
    }
    /**
   * @private
   */ unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, $ilM9F.unlistenByKey));
        this.sourcesListenerKeys_ = null;
    }
    /**
   * Remove from the cache due to expiry
   */ release() {
        if (this.canvas_) {
            (0, $DfnQm.releaseCanvas)(this.canvas_.getContext("2d"));
            (0, $3H62b.canvasPool).push(this.canvas_);
            this.canvas_ = null;
        }
        super.release();
    }
}
var $398e350e33050c07$export$2e2bcd8739ae039 = $398e350e33050c07$var$ReprojTile;

});
parcelRegister("cfilv", function(module, exports) {

$parcel$export(module.exports, "ERROR_THRESHOLD", () => $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855);
/**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ const $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855 = 0.5;

});

parcelRegister("9gka6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be53f6edfbf1854$export$2e2bcd8739ae039);
/**
 * @module ol/reproj/Triangulation
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $dpRHA = parcelRequire("dpRHA");

var $9byFX = parcelRequire("9byFX");
/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ const $6be53f6edfbf1854$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ const $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ class $6be53f6edfbf1854$var$Triangulation {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   */ constructor(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, destinationResolution){
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.sourceProj_ = sourceProj;
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ let transformInvCache = {};
        const transformInv = (0, $dpRHA.getTransform)(this.targetProj_, this.sourceProj_);
        /**
     * @param {import("../coordinate.js").Coordinate} c A coordinate.
     * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
     * @private
     */ this.transformInv_ = function(c) {
            const key = c[0] + "/" + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
     * @type {import("../extent.js").Extent}
     * @private
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @type {number}
     * @private
     */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
     * @type {Array<Triangle>}
     * @private
     */ this.triangles_ = [];
        /**
     * Indicates that the triangulation crosses edge of the source projection.
     * @type {boolean}
     * @private
     */ this.wrapsXInSource_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $9pD6L.getWidth)(maxSourceExtent) >= (0, $9pD6L.getWidth)(this.sourceProj_.getExtent());
        /**
     * @type {?number}
     * @private
     */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $9pD6L.getWidth)(this.sourceProj_.getExtent()) : null;
        /**
     * @type {?number}
     * @private
     */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $9pD6L.getWidth)(this.targetProj_.getExtent()) : null;
        const destinationTopLeft = (0, $9pD6L.getTopLeft)(targetExtent);
        const destinationTopRight = (0, $9pD6L.getTopRight)(targetExtent);
        const destinationBottomRight = (0, $9pD6L.getBottomRight)(targetExtent);
        const destinationBottomLeft = (0, $9pD6L.getBottomLeft)(targetExtent);
        const sourceTopLeft = this.transformInv_(destinationTopLeft);
        const sourceTopRight = this.transformInv_(destinationTopRight);
        const sourceBottomRight = this.transformInv_(destinationBottomRight);
        const sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
     * The maxSubdivision controls how many splittings of the target area can
     * be done. The idea here is to do a linear mapping of the target areas
     * but the actual overall reprojection (can be) extremely non-linear. The
     * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
     * tile size. However this function is also called to remap canvas rendered
     * layers which can be much larger. This calculation increases the maxSubdivision
     * value by the right factor so that each 256x256 pixel area has
     * MAX_SUBDIVISION divisions.
     */ const maxSubdivision = $6be53f6edfbf1854$var$MAX_SUBDIVISION + (destinationResolution ? Math.max(0, Math.ceil(Math.log2((0, $9pD6L.getArea)(targetExtent) / (destinationResolution * destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            let leftBound = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((triangle)=>{
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
                    const newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    const minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    const maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            });
        }
        transformInvCache = {};
    }
    /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */ addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    }
    /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */ addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        const sourceQuadExtent = (0, $9pD6L.boundingExtent)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        const sourceCoverageX = this.sourceWorldWidth_ ? (0, $9pD6L.getWidth)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        const sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        const wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        let needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                const targetQuadExtent = (0, $9pD6L.boundingExtent)([
                    a,
                    b,
                    c,
                    d
                ]);
                const targetCoverageX = (0, $9pD6L.getWidth)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, $9pD6L.intersects)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        let isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                const center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                const centerSrc = this.transformInv_(center);
                let dx;
                if (wrapsX) {
                    const centerSrcEstimX = ((0, $9byFX.modulo)(aSrc[0], sourceWorldWidth) + (0, $9byFX.modulo)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, $9byFX.modulo)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                const dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                const centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    const bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    const bcSrc = this.transformInv_(bc);
                    const da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    const daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    const ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    const abSrc = this.transformInv_(ab);
                    const cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    const cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    }
    /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */ calculateSourceExtent() {
        const extent = (0, $9pD6L.createEmpty)();
        this.triangles_.forEach(function(triangle, i, arr) {
            const src = triangle.source;
            (0, $9pD6L.extendCoordinate)(extent, src[0]);
            (0, $9pD6L.extendCoordinate)(extent, src[1]);
            (0, $9pD6L.extendCoordinate)(extent, src[2]);
        });
        return extent;
    }
    /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */ getTriangles() {
        return this.triangles_;
    }
}
var $6be53f6edfbf1854$export$2e2bcd8739ae039 = $6be53f6edfbf1854$var$Triangulation;

});

parcelRegister("3H62b", function(module, exports) {

$parcel$export(module.exports, "canvasPool", () => $2b0a118af78fb031$export$a166f0857c555517);
$parcel$export(module.exports, "calculateSourceExtentResolution", () => $2b0a118af78fb031$export$16d356211d01f1cc);
$parcel$export(module.exports, "render", () => $2b0a118af78fb031$export$b3890eb0ae9dca99);
/**
 * @module ol/reproj
 */ 
var $9pD6L = parcelRequire("9pD6L");

var $DfnQm = parcelRequire("DfnQm");

var $dpRHA = parcelRequire("dpRHA");

var $9byFX = parcelRequire("9byFX");
let $2b0a118af78fb031$var$brokenDiagonalRendering_;
const $2b0a118af78fb031$export$a166f0857c555517 = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $2b0a118af78fb031$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $2b0a118af78fb031$var$isBrokenDiagonalRendering() {
    if ($2b0a118af78fb031$var$brokenDiagonalRendering_ === undefined) {
        const ctx = (0, $DfnQm.createCanvasContext2D)(6, 6, $2b0a118af78fb031$export$a166f0857c555517);
        ctx.globalCompositeOperation = "lighter";
        ctx.fillStyle = "rgba(210, 0, 0, 0.75)";
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        const data = ctx.getImageData(0, 0, 3, 3).data;
        $2b0a118af78fb031$var$brokenDiagonalRendering_ = $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 0) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 4) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 8);
        (0, $DfnQm.releaseCanvas)(ctx);
        $2b0a118af78fb031$export$a166f0857c555517.push(ctx.canvas);
    }
    return $2b0a118af78fb031$var$brokenDiagonalRendering_;
}
function $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    const sourceCenter = (0, $dpRHA.transform)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    let sourceResolution = (0, $dpRHA.getPointResolution)(targetProj, targetResolution, targetCenter);
    const targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    const sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    const sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $9pD6L.containsCoordinate)(sourceExtent, sourceCenter)) {
        const compensationFactor = (0, $dpRHA.getPointResolution)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $2b0a118af78fb031$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    const targetCenter = (0, $9pD6L.getCenter)(targetExtent);
    let sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $9pD6L.forEachCorner)(targetExtent, function(corner) {
        sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $2b0a118af78fb031$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, renderEdges, interpolate, drawSingle, clipExtent) {
    const context = (0, $DfnQm.createCanvasContext2D)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), $2b0a118af78fb031$export$a166f0857c555517);
    if (!interpolate) context.imageSmoothingEnabled = false;
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = "lighter";
    const sourceDataExtent = (0, $9pD6L.createEmpty)();
    sources.forEach(function(src, i, arr) {
        (0, $9pD6L.extend)(sourceDataExtent, src.extent);
    });
    let stitchContext;
    const stitchScale = pixelRatio / sourceResolution;
    // Round up Float32 scale values to prevent interpolation in Firefox.
    const inverseScale = (interpolate ? 1 : 1 + Math.pow(2, -24)) / stitchScale;
    if (!drawSingle || sources.length !== 1 || gutter !== 0) {
        stitchContext = (0, $DfnQm.createCanvasContext2D)(Math.round((0, $9pD6L.getWidth)(sourceDataExtent) * stitchScale), Math.round((0, $9pD6L.getHeight)(sourceDataExtent) * stitchScale), $2b0a118af78fb031$export$a166f0857c555517);
        if (!interpolate) stitchContext.imageSmoothingEnabled = false;
        if (sourceExtent && clipExtent) {
            const xPos = (sourceExtent[0] - sourceDataExtent[0]) * stitchScale;
            const yPos = -(sourceExtent[3] - sourceDataExtent[3]) * stitchScale;
            const width = (0, $9pD6L.getWidth)(sourceExtent) * stitchScale;
            const height = (0, $9pD6L.getHeight)(sourceExtent) * stitchScale;
            stitchContext.rect(xPos, yPos, width, height);
            stitchContext.clip();
        }
        sources.forEach(function(src, i, arr) {
            // This test should never fail -- but it does. Need to find a fix the upstream condition
            if (src.image.width > 0 && src.image.height > 0) {
                if (src.clipExtent) {
                    stitchContext.save();
                    const xPos = (src.clipExtent[0] - sourceDataExtent[0]) * stitchScale;
                    const yPos = -(src.clipExtent[3] - sourceDataExtent[3]) * stitchScale;
                    const width = (0, $9pD6L.getWidth)(src.clipExtent) * stitchScale;
                    const height = (0, $9pD6L.getHeight)(src.clipExtent) * stitchScale;
                    stitchContext.rect(interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? width : Math.round(xPos + width) - Math.round(xPos), interpolate ? height : Math.round(yPos + height) - Math.round(yPos));
                    stitchContext.clip();
                }
                const xPos = (src.extent[0] - sourceDataExtent[0]) * stitchScale;
                const yPos = -(src.extent[3] - sourceDataExtent[3]) * stitchScale;
                const srcWidth = (0, $9pD6L.getWidth)(src.extent) * stitchScale;
                const srcHeight = (0, $9pD6L.getHeight)(src.extent) * stitchScale;
                stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? srcWidth : Math.round(xPos + srcWidth) - Math.round(xPos), interpolate ? srcHeight : Math.round(yPos + srcHeight) - Math.round(yPos));
                if (src.clipExtent) stitchContext.restore();
            }
        });
    }
    const targetTopLeft = (0, $9pD6L.getTopLeft)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ const source = triangle.source;
        const target = triangle.target;
        let x0 = source[0][0], y0 = source[0][1];
        let x1 = source[1][0], y1 = source[1][1];
        let x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        const u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        const v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        const u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        const v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        const u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        const v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        const sourceNumericalShiftX = x0;
        const sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        const augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        const affineCoefs = (0, $9byFX.solveLinearSystem)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($2b0a118af78fb031$var$isBrokenDiagonalRendering() || !interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            const steps = 4;
            const ud = u0 - u1;
            const vd = v0 - v1;
            for(let step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        let image;
        if (stitchContext) {
            image = stitchContext.canvas;
            context.scale(inverseScale, -inverseScale);
        } else {
            const source = sources[0];
            const extent = source.extent;
            image = source.image;
            context.scale((0, $9pD6L.getWidth)(extent) / image.width, -(0, $9pD6L.getHeight)(extent) / image.height);
        }
        context.drawImage(image, 0, 0);
        context.restore();
    });
    if (stitchContext) {
        (0, $DfnQm.releaseCanvas)(stitchContext);
        $2b0a118af78fb031$export$a166f0857c555517.push(stitchContext.canvas);
    }
    if (renderEdges) {
        context.save();
        context.globalCompositeOperation = "source-over";
        context.strokeStyle = "black";
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            const target = triangle.target;
            const u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            const v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            const u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            const v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            const u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            const v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}

});


parcelRegister("7iKy2", function(module, exports) {

$parcel$export(module.exports, "createOrUpdate", () => $550e524b0d1b61d4$export$958e3e1a02eac4b6);
$parcel$export(module.exports, "default", () => $550e524b0d1b61d4$export$2e2bcd8739ae039);
/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ class $550e524b0d1b61d4$var$TileRange {
    /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */ constructor(minX, maxX, minY, maxY){
        /**
     * @type {number}
     */ this.minX = minX;
        /**
     * @type {number}
     */ this.maxX = maxX;
        /**
     * @type {number}
     */ this.minY = minY;
        /**
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */ contains(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */ containsTileRange(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    }
    /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */ containsXY(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */ equals(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   */ extend(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    }
    /**
   * @return {number} Height.
   */ getHeight() {
        return this.maxY - this.minY + 1;
    }
    /**
   * @return {import("./size.js").Size} Size.
   */ getSize() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    }
    /**
   * @return {number} Width.
   */ getWidth() {
        return this.maxX - this.minX + 1;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */ intersects(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    }
}
function $550e524b0d1b61d4$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    return new $550e524b0d1b61d4$var$TileRange(minX, maxX, minY, maxY);
}
var $550e524b0d1b61d4$export$2e2bcd8739ae039 = $550e524b0d1b61d4$var$TileRange;

});

parcelRegister("hxhPO", function(module, exports) {

$parcel$export(module.exports, "hasArea", () => $cc435a5409103773$export$622c471beb1693c7);
$parcel$export(module.exports, "scale", () => $cc435a5409103773$export$dcdf75081b88279d);
$parcel$export(module.exports, "toSize", () => $cc435a5409103773$export$a71a825ff42fb8e1);
/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $cc435a5409103773$export$ab1029bcae9ddb4a(size, num, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] + 2 * num;
    dest[1] = size[1] + 2 * num;
    return dest;
}
function $cc435a5409103773$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $cc435a5409103773$export$dcdf75081b88279d(size, ratio, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] * ratio + 0.5 | 0;
    dest[1] = size[1] * ratio + 0.5 | 0;
    return dest;
}
function $cc435a5409103773$export$a71a825ff42fb8e1(size, dest) {
    if (Array.isArray(size)) return size;
    if (dest === undefined) dest = [
        size,
        size
    ];
    else {
        dest[0] = size;
        dest[1] = size;
    }
    return dest;
}

});



parcelRegister("9jDAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c8498cc816f2362$export$2e2bcd8739ae039);
/**
 * @module ol/source/OSM
 */ 
var $cTF5I = parcelRequire("cTF5I");
const $6c8498cc816f2362$export$4de8a5e77eb994ad = '&#169; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {boolean} [opaque=true] Whether the layer is opaque.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url='https://tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */ class $6c8498cc816f2362$var$OSM extends (0, $cTF5I.default) {
    /**
   * @param {Options} [options] Open Street Map options.
   */ constructor(options){
        options = options || {};
        let attributions;
        if (options.attributions !== undefined) attributions = options.attributions;
        else attributions = [
            $6c8498cc816f2362$export$4de8a5e77eb994ad
        ];
        const crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : "anonymous";
        const url = options.url !== undefined ? options.url : "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
        super({
            attributions: attributions,
            attributionsCollapsible: false,
            cacheSize: options.cacheSize,
            crossOrigin: crossOrigin,
            interpolate: options.interpolate,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            opaque: options.opaque !== undefined ? options.opaque : true,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX,
            zDirection: options.zDirection
        });
    }
}
var $6c8498cc816f2362$export$2e2bcd8739ae039 = $6c8498cc816f2362$var$OSM;

});
parcelRegister("cTF5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $963a7ef65488964c$export$2e2bcd8739ae039);
/**
 * @module ol/source/XYZ
 */ 
var $71uyY = parcelRequire("71uyY");

var $7vCDj = parcelRequire("7vCDj");
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {number} [gutter=0] The size in pixels of the gutter around image tiles to ignore.
 * This allows artifacts of rendering at tile edges to be ignored.
 * Supported images should be wider and taller than the tile size by a value of `2 x gutter`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get
 * tile URL given a tile coordinate and the projection.
 * Required if `url` or `urls` are not provided.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */ class $963a7ef65488964c$var$XYZ extends (0, $71uyY.default) {
    /**
   * @param {Options} [options] XYZ options.
   */ constructor(options){
        options = options || {};
        const projection = options.projection !== undefined ? options.projection : "EPSG:3857";
        const tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, $7vCDj.createXYZ)({
            extent: (0, $7vCDj.extentFromProjection)(projection),
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            opaque: options.opaque,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return this.gutter_;
    }
}
var $963a7ef65488964c$export$2e2bcd8739ae039 = $963a7ef65488964c$var$XYZ;

});
parcelRegister("71uyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $51d055913ca55b5e$export$2e2bcd8739ae039);
/**
 * @module ol/source/TileImage
 */ 
var $3xzSb = parcelRequire("3xzSb");

var $hCs6p = parcelRequire("hCs6p");

var $4WmJ3 = parcelRequire("4WmJ3");

var $dPXiB = parcelRequire("dPXiB");

var $fOhwi = parcelRequire("fOhwi");

var $jLCO3 = parcelRequire("jLCO3");

var $dpRHA = parcelRequire("dpRHA");

var $gpyQY = parcelRequire("gpyQY");

var $7vCDj = parcelRequire("7vCDj");

var $9iPUS = parcelRequire("9iPUS");
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Base class for sources providing images divided into a tile grid.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ class $51d055913ca55b5e$var$TileImage extends (0, $jLCO3.default) {
    /**
   * @param {!Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $51d055913ca55b5e$var$defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate !== undefined ? options.interpolate : true,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @protected
     * @type {?string}
     */ this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $hCs6p.default);
        /**
     * @protected
     * @type {!Object<string, TileCache>}
     */ this.tileCacheForProjection = {};
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ this.renderReprojectionEdges_ = false;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        if (this.tileCache.canExpireCache()) return true;
        for(const key in this.tileCacheForProjection){
            if (this.tileCacheForProjection[key].canExpireCache()) return true;
        }
        return false;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */ expireCache(projection, usedTiles) {
        const usedTileCache = this.getTileCacheForProjection(projection);
        this.tileCache.expireCache(this.tileCache == usedTileCache ? usedTiles : {});
        for(const id in this.tileCacheForProjection){
            const tileCache = this.tileCacheForProjection[id];
            tileCache.expireCache(tileCache == usedTileCache ? usedTiles : {});
        }
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        if (this.getProjection() && projection && !(0, $dpRHA.equivalent)(this.getProjection(), projection)) return 0;
        return this.getGutter();
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        let key = super.getKey();
        if (!this.getInterpolate()) key += ":disable-interpolation";
        return key;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {boolean} Opaque.
   */ getOpaque(projection) {
        if (this.getProjection() && projection && !(0, $dpRHA.equivalent)(this.getProjection(), projection)) return false;
        return super.getOpaque(projection);
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        const thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $dpRHA.equivalent)(thisProj, projection))) return this.tileGrid;
        const projKey = (0, $9iPUS.getUid)(projection);
        if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $7vCDj.getForProjection)(projection);
        return this.tileGridForProjection[projKey];
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   */ getTileCacheForProjection(projection) {
        const thisProj = this.getProjection();
        if (!thisProj || (0, $dpRHA.equivalent)(thisProj, projection)) return this.tileCache;
        const projKey = (0, $9iPUS.getUid)(projection);
        if (!(projKey in this.tileCacheForProjection)) this.tileCacheForProjection[projKey] = new (0, $dPXiB.default)(this.tileCache.highWaterMark);
        return this.tileCacheForProjection[projKey];
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */ createTile_(z, x, y, pixelRatio, projection, key) {
        const tileCoord = [
            z,
            x,
            y
        ];
        const urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        const tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $fOhwi.default).IDLE : (0, $fOhwi.default).EMPTY, tileUrl !== undefined ? tileUrl : "", this.crossOrigin, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, $3xzSb.default).CHANGE, this.handleTileChange.bind(this));
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!(ImageTile|ReprojTile)} Tile.
   */ getTile(z, x, y, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $dpRHA.equivalent)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        const cache = this.getTileCacheForProjection(projection);
        const tileCoord = [
            z,
            x,
            y
        ];
        let tile;
        const tileCoordKey = (0, $gpyQY.getKey)(tileCoord);
        if (cache.containsKey(tileCoordKey)) tile = cache.get(tileCoordKey);
        const key = this.getKey();
        if (tile && tile.key == key) return tile;
        const sourceTileGrid = this.getTileGridForProjection(sourceProjection);
        const targetTileGrid = this.getTileGridForProjection(projection);
        const wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const newTile = new (0, $4WmJ3.default)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (z, x, y, pixelRatio)=>this.getTileInternal(z, x, y, pixelRatio, sourceProjection), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.tileOptions);
        newTile.key = key;
        if (tile) {
            newTile.interimTile = tile;
            newTile.refreshInterimChain();
            cache.replace(tileCoordKey, newTile);
        } else cache.set(tileCoordKey, newTile);
        return newTile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @return {!ImageTile} Tile.
   * @protected
   */ getTileInternal(z, x, y, pixelRatio, projection) {
        let tile = null;
        const tileCoordKey = (0, $gpyQY.getKeyZXY)(z, x, y);
        const key = this.getKey();
        if (!this.tileCache.containsKey(tileCoordKey)) {
            tile = this.createTile_(z, x, y, pixelRatio, projection, key);
            this.tileCache.set(tileCoordKey, tile);
        } else {
            tile = this.tileCache.get(tileCoordKey);
            if (tile.key != key) {
                // The source's params changed. If the tile has an interim tile and if we
                // can use it then we use it. Otherwise we create a new tile.  In both
                // cases we attempt to assign an interim tile to the new tile.
                const interimTile = tile;
                tile = this.createTile_(z, x, y, pixelRatio, projection, key);
                //make the new tile the head of the list,
                if (interimTile.getState() == (0, $fOhwi.default).IDLE) //the old tile hasn't begun loading yet, and is now outdated, so we can simply discard it
                tile.interimTile = interimTile.interimTile;
                else tile.interimTile = interimTile;
                tile.refreshInterimChain();
                this.tileCache.replace(tileCoordKey, tile);
            }
        }
        return tile;
    }
    /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ setRenderReprojectionEdges(render) {
        if (this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        for(const id in this.tileCacheForProjection)this.tileCacheForProjection[id].clear();
        this.changed();
    }
    /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ setTileGridForProjection(projection, tilegrid) {
        const proj = (0, $dpRHA.get)(projection);
        if (proj) {
            const projKey = (0, $9iPUS.getUid)(proj);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
        }
    }
    clear() {
        super.clear();
        for(const id in this.tileCacheForProjection)this.tileCacheForProjection[id].clear();
    }
}
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */ function $51d055913ca55b5e$var$defaultTileLoadFunction(imageTile, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $51d055913ca55b5e$export$2e2bcd8739ae039 = $51d055913ca55b5e$var$TileImage;

});
parcelRegister("dPXiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12e09565a34db59$export$2e2bcd8739ae039);
/**
 * @module ol/TileCache
 */ 
var $btbc6 = parcelRequire("btbc6");

var $gpyQY = parcelRequire("gpyQY");
class $a12e09565a34db59$var$TileCache extends (0, $btbc6.default) {
    clear() {
        while(this.getCount() > 0)this.pop().release();
        super.clear();
    }
    /**
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */ expireCache(usedTiles) {
        while(this.canExpireCache()){
            const tile = this.peekLast();
            if (tile.getKey() in usedTiles) break;
            else this.pop().release();
        }
    }
    /**
   * Prune all tiles from the cache that don't have the same z as the newest tile.
   */ pruneExceptNewestZ() {
        if (this.getCount() === 0) return;
        const key = this.peekFirstKey();
        const tileCoord = (0, $gpyQY.fromKey)(key);
        const z = tileCoord[0];
        this.forEach((tile)=>{
            if (tile.tileCoord[0] !== z) {
                this.remove((0, $gpyQY.getKey)(tile.tileCoord));
                tile.release();
            }
        });
    }
}
var $a12e09565a34db59$export$2e2bcd8739ae039 = $a12e09565a34db59$var$TileCache;

});
parcelRegister("btbc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $859b1614288c6316$export$2e2bcd8739ae039);
/**
 * @module ol/structs/LRUCache
 */ 
var $4Cz58 = parcelRequire("4Cz58");
/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Entry|null} newer Newer.
 * @property {Entry|null} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ class $859b1614288c6316$var$LRUCache {
    /**
   * @param {number} [highWaterMark] High water mark.
   */ constructor(highWaterMark){
        /**
     * Desired max cache size after expireCache(). If set to 0, no cache entries
     * will be pruned at all.
     * @type {number}
     */ this.highWaterMark = highWaterMark !== undefined ? highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    }
    /**
   * Expire the cache.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */ expireCache(keep) {
        while(this.canExpireCache())this.pop();
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.count_ = 0;
        this.entries_ = {};
        this.oldest_ = null;
        this.newest_ = null;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ containsKey(key) {
        return this.entries_.hasOwnProperty(key);
    }
    /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */ forEach(f) {
        let entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    }
    /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */ get(key, options) {
        const entry = this.entries_[key];
        (0, $4Cz58.assert)(entry !== undefined, "Tried to get a value for a key that does not exist in the cache");
        if (entry === this.newest_) return entry.value_;
        if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    }
    /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ remove(key) {
        const entry = this.entries_[key];
        (0, $4Cz58.assert)(entry !== undefined, "Tried to get a value for a key that does not exist in the cache");
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.count_;
    }
    /**
   * @return {Array<string>} Keys.
   */ getKeys() {
        const keys = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    }
    /**
   * @return {Array<T>} Values.
   */ getValues() {
        const values = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    }
    /**
   * @return {T} Last value.
   */ peekLast() {
        return this.oldest_.value_;
    }
    /**
   * @return {string} Last key.
   */ peekLastKey() {
        return this.oldest_.key_;
    }
    /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ peekFirstKey() {
        return this.newest_.key_;
    }
    /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */ peek(key) {
        return this.entries_[key]?.value_;
    }
    /**
   * @return {T} value Value.
   */ pop() {
        const entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ replace(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ set(key, value) {
        (0, $4Cz58.assert)(!(key in this.entries_), "Tried to set a value for a key that is used already");
        const entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    }
    /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ setSize(size) {
        this.highWaterMark = size;
    }
}
var $859b1614288c6316$export$2e2bcd8739ae039 = $859b1614288c6316$var$LRUCache;

});

parcelRegister("gpyQY", function(module, exports) {

$parcel$export(module.exports, "createOrUpdate", () => $bf2a04496fadabc6$export$958e3e1a02eac4b6);
$parcel$export(module.exports, "getKeyZXY", () => $bf2a04496fadabc6$export$92d0df0f1d25c63c);
$parcel$export(module.exports, "getKey", () => $bf2a04496fadabc6$export$a47fb462a08de82f);
$parcel$export(module.exports, "fromKey", () => $bf2a04496fadabc6$export$a807b7874eb66454);
$parcel$export(module.exports, "hash", () => $bf2a04496fadabc6$export$d6af199866bfb566);
$parcel$export(module.exports, "withinExtentAndZ", () => $bf2a04496fadabc6$export$60bedf8e3e3c3dbe);
/**
 * @module ol/tilecoord
 */ /**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */ /**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord} [tileCoord] Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */ function $bf2a04496fadabc6$export$958e3e1a02eac4b6(z, x, y, tileCoord) {
    if (tileCoord !== undefined) {
        tileCoord[0] = z;
        tileCoord[1] = x;
        tileCoord[2] = y;
        return tileCoord;
    }
    return [
        z,
        x,
        y
    ];
}
function $bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y) {
    return z + "/" + x + "/" + y;
}
function $bf2a04496fadabc6$export$a47fb462a08de82f(tileCoord) {
    return $bf2a04496fadabc6$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $bf2a04496fadabc6$export$7f760414a8e3d2b5(tileKey) {
    const [z, x, y] = tileKey.substring(tileKey.lastIndexOf("/") + 1, tileKey.length).split(",").map(Number);
    return $bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y);
}
function $bf2a04496fadabc6$export$a807b7874eb66454(key) {
    return key.split("/").map(Number);
}
function $bf2a04496fadabc6$export$d6af199866bfb566(tileCoord) {
    return (tileCoord[1] << tileCoord[0]) + tileCoord[2];
}
function $bf2a04496fadabc6$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    const z = tileCoord[0];
    const x = tileCoord[1];
    const y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    const tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    return tileRange.containsXY(x, y);
}

});


parcelRegister("jLCO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6408236331c2614$export$2e2bcd8739ae039);
/**
 * @module ol/source/UrlTile
 */ 
var $aPYls = parcelRequire("aPYls");

var $d5XIU = parcelRequire("d5XIU");

var $fOhwi = parcelRequire("fOhwi");

var $cwqvp = parcelRequire("cwqvp");

var $gpyQY = parcelRequire("gpyQY");

var $9iPUS = parcelRequire("9iPUS");
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Cache size.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] TileUrlFunction.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Base class for sources providing tiles divided into a tile grid over http.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ class $e6408236331c2614$var$UrlTile extends (0, $d5XIU.default) {
    /**
   * @param {Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ this.generateTileUrlFunction_ = this.tileUrlFunction === $e6408236331c2614$var$UrlTile.prototype.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) this.tileUrlFunction = options.tileUrlFunction;
        /**
     * @protected
     * @type {!Array<string>|null}
     */ this.urls = null;
        if (options.urls) this.setUrls(options.urls);
        else if (options.url) this.setUrl(options.url);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ this.tileLoadingKeys_ = {};
    }
    /**
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ getTileLoadFunction() {
        return this.tileLoadFunction;
    }
    /**
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ getTileUrlFunction() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    }
    /**
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ getUrls() {
        return this.urls;
    }
    /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("../Tile.js").default} */ event.target;
        const uid = (0, $9iPUS.getUid)(tile);
        const tileState = tile.getState();
        let type;
        if (tileState == (0, $fOhwi.default).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $aPYls.default).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $fOhwi.default).ERROR ? (0, $aPYls.default).TILELOADERROR : tileState == (0, $fOhwi.default).LOADED ? (0, $aPYls.default).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $d5XIU.TileSourceEvent)(type, tile));
    }
    /**
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ setTileLoadFunction(tileLoadFunction) {
        this.tileCache.clear();
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    }
    /**
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */ setTileUrlFunction(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        this.tileCache.pruneExceptNewestZ();
        if (typeof key !== "undefined") this.setKey(key);
        else this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ setUrl(url) {
        const urls = (0, $cwqvp.expandUrl)(url);
        this.urls = urls;
        this.setUrls(urls);
    }
    /**
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join("\n");
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $cwqvp.createFromTemplates)(urls, this.tileGrid), key);
        else this.setKey(key);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        return undefined;
    }
    /**
   * Marks a tile coord as being used, without triggering a load.
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   */ useTile(z, x, y) {
        const tileCoordKey = (0, $gpyQY.getKeyZXY)(z, x, y);
        if (this.tileCache.containsKey(tileCoordKey)) this.tileCache.get(tileCoordKey);
    }
}
var $e6408236331c2614$export$2e2bcd8739ae039 = $e6408236331c2614$var$UrlTile;

});
parcelRegister("aPYls", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3d7a0f8b272861$export$2e2bcd8739ae039);
/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $7e3d7a0f8b272861$export$2e2bcd8739ae039 /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */  = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: "tileloadstart",
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: "tileloadend",
    /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: "tileloaderror"
};

});

parcelRegister("d5XIU", function(module, exports) {

$parcel$export(module.exports, "TileSourceEvent", () => $988a11d09320f6a8$export$c571855c51e6c4b6);
$parcel$export(module.exports, "default", () => $988a11d09320f6a8$export$2e2bcd8739ae039);
/**
 * @module ol/source/Tile
 */ 
var $f18Q2 = parcelRequire("f18Q2");

var $knPlK = parcelRequire("knPlK");

var $dPXiB = parcelRequire("dPXiB");

var $fOhwi = parcelRequire("fOhwi");

var $9iPUS = parcelRequire("9iPUS");

var $4Cz58 = parcelRequire("4Cz58");

var $dpRHA = parcelRequire("dpRHA");

var $gpyQY = parcelRequire("gpyQY");

var $7vCDj = parcelRequire("7vCDj");

var $hxhPO = parcelRequire("hxhPO");
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./TileEventType").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./TileEventType").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] CacheSize.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 * @abstract
 * @api
 */ class $988a11d09320f6a8$var$TileSource extends (0, $knPlK.default) {
    /**
   * @param {Options} options SourceTile source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        });
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {TileSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {boolean}
     */ this.opaque_ = options.opaque !== undefined ? options.opaque : false;
        /**
     * @private
     * @type {number}
     */ this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @type {import("../tilegrid/TileGrid.js").default|null}
     */ this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        const tileSize = [
            256,
            256
        ];
        if (this.tileGrid) (0, $hxhPO.toSize)(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), tileSize);
        /**
     * @protected
     * @type {import("../TileCache.js").default}
     */ this.tileCache = new (0, $dPXiB.default)(options.cacheSize || 0);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ this.key_ = options.key || "";
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
     * zDirection hint, read by the renderer. Indicates which resolution should be used
     * by a renderer if the views resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @type {number|import("../array.js").NearestDirectionFunction}
     */ this.zDirection = options.zDirection ? options.zDirection : 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.tileCache.canExpireCache();
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */ expireCache(projection, usedTiles) {
        const tileCache = this.getTileCacheForProjection(projection);
        if (tileCache) tileCache.expireCache(usedTiles);
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {number} z Zoom level.
   * @param {import("../TileRange.js").default} tileRange Tile range.
   * @param {function(import("../Tile.js").default):(boolean|void)} callback Called with each
   *     loaded tile.  If the callback returns `false`, the tile will not be
   *     considered loaded.
   * @return {boolean} The tile range is fully covered with loaded tiles.
   */ forEachLoadedTile(projection, z, tileRange, callback) {
        const tileCache = this.getTileCacheForProjection(projection);
        if (!tileCache) return false;
        let covered = true;
        let tile, tileCoordKey, loaded;
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            tileCoordKey = (0, $gpyQY.getKeyZXY)(z, x, y);
            loaded = false;
            if (tileCache.containsKey(tileCoordKey)) {
                tile = /** @type {!import("../Tile.js").default} */ tileCache.get(tileCoordKey);
                loaded = tile.getState() === (0, $fOhwi.default).LOADED;
                if (loaded) loaded = callback(tile) !== false;
            }
            if (!loaded) covered = false;
        }
        return covered;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        return this.key_;
    }
    /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ setKey(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {boolean} Opaque.
   */ getOpaque(projection) {
        return this.opaque_;
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        const tileGrid = projection ? this.getTileGridForProjection(projection) : this.tileGrid;
        if (!tileGrid) return null;
        return tileGrid.getResolutions();
    }
    /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../Tile.js").default} Tile.
   */ getTile(z, x, y, pixelRatio, projection) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */ getTileGrid() {
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        if (!this.tileGrid) return (0, $7vCDj.getForProjection)(projection);
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   * @protected
   */ getTileCacheForProjection(projection) {
        const sourceProjection = this.getProjection();
        (0, $4Cz58.assert)(sourceProjection === null || (0, $dpRHA.equivalent)(sourceProjection, projection), "A VectorTile source can only be rendered if it has a projection compatible with the view projection.");
        return this.tileCache;
    }
    /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ getTilePixelRatio(pixelRatio) {
        return this.tilePixelRatio_;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        const tileSize = (0, $hxhPO.toSize)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        return (0, $hxhPO.scale)(tileSize, tilePixelRatio, this.tmpSize);
    }
    /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ getTileCoordForTileUrlFunction(tileCoord, projection) {
        projection = projection !== undefined ? projection : this.getProjection();
        const tileGrid = this.getTileGridForProjection(projection);
        if (this.getWrapX() && projection.isGlobal()) tileCoord = (0, $7vCDj.wrapX)(tileGrid, tileCoord, projection);
        return (0, $gpyQY.withinExtentAndZ)(tileCoord, tileGrid) ? tileCoord : null;
    }
    /**
   * Remove all cached tiles from the source. The next render cycle will fetch new tiles.
   * @api
   */ clear() {
        this.tileCache.clear();
    }
    refresh() {
        this.clear();
        super.refresh();
    }
    /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ updateCacheSize(tileCount, projection) {
        const tileCache = this.getTileCacheForProjection(projection);
        if (tileCount > tileCache.highWaterMark) tileCache.highWaterMark = tileCount;
    }
    /**
   * Marks a tile coord as being used, without triggering a load.
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ useTile(z, x, y, projection) {}
}
class $988a11d09320f6a8$export$c571855c51e6c4b6 extends (0, $f18Q2.default) {
    /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */ constructor(type, tile){
        super(type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ this.tile = tile;
    }
}
var $988a11d09320f6a8$export$2e2bcd8739ae039 = $988a11d09320f6a8$var$TileSource;

});
parcelRegister("knPlK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed6dc99f268f3882$export$2e2bcd8739ae039);
/**
 * @module ol/source/Source
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $dpRHA = parcelRequire("dpRHA");
/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link import("../View.js").ViewStateLayerStateExtent} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../View.js").ViewStateLayerStateExtent): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * * a simple string (e.g. `'© Acme Inc.'`)
 * * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ class $ed6dc99f268f3882$var$Source extends (0, $fFFY7.default) {
    /**
   * @param {Options} options Source options.
   */ constructor(options){
        super();
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|null}
     */ this.projection = (0, $dpRHA.get)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ this.attributionsCollapsible_ = options.attributionsCollapsible !== undefined ? options.attributionsCollapsible : true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to `true`.
     * @type {boolean}
     */ this.loading = false;
        /**
     * @private
     * @type {import("./Source.js").State}
     */ this.state_ = options.state !== undefined ? options.state : "ready";
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = !!options.interpolate;
        /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */ this.viewResolver = null;
        /**
     * @protected
     * @type {function(Error):void}
     */ this.viewRejector = null;
        const self = this;
        /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */ this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
    }
    /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */ getAttributions() {
        return this.attributions_;
    }
    /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */ getAttributionsCollapsible() {
        return this.attributionsCollapsible_;
    }
    /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */ getProjection() {
        return this.projection;
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        return null;
    }
    /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */ getView() {
        return this.viewPromise_;
    }
    /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */ getState() {
        return this.state_;
    }
    /**
   * @return {boolean|undefined} Wrap X.
   */ getWrapX() {
        return this.wrapX_;
    }
    /**
   * @return {boolean} Use linear interpolation when resampling.
   */ getInterpolate() {
        return this.interpolate_;
    }
    /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */ refresh() {
        this.changed();
    }
    /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */ setAttributions(attributions) {
        this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(attributions);
        this.changed();
    }
    /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */ setState(state) {
        this.state_ = state;
        this.changed();
    }
}
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function $ed6dc99f268f3882$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (Array.isArray(attributionLike)) return function(frameState) {
        return attributionLike;
    };
    if (typeof attributionLike === "function") return attributionLike;
    return function(frameState) {
        return [
            attributionLike
        ];
    };
}
var $ed6dc99f268f3882$export$2e2bcd8739ae039 = $ed6dc99f268f3882$var$Source;

});

parcelRegister("7vCDj", function(module, exports) {

$parcel$export(module.exports, "getForProjection", () => $5779655d81caea04$export$1f4812384df8a9c5);
$parcel$export(module.exports, "wrapX", () => $5779655d81caea04$export$39a9ce3624977b84);
$parcel$export(module.exports, "extentFromProjection", () => $5779655d81caea04$export$7b5b6ef8fd55fac4);
$parcel$export(module.exports, "createXYZ", () => $5779655d81caea04$export$38500bbeccc864ff);
/**
 * @module ol/tilegrid
 */ 
var $g5oyO = parcelRequire("g5oyO");

var $7xn5x = parcelRequire("7xn5x");

var $dpRHA = parcelRequire("dpRHA");
var $kUyy5 = parcelRequire("kUyy5");

var $9pD6L = parcelRequire("9pD6L");

var $hxhPO = parcelRequire("hxhPO");

function $5779655d81caea04$export$1f4812384df8a9c5(projection) {
    let tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $5779655d81caea04$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $5779655d81caea04$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    const z = tileCoord[0];
    const center = tileGrid.getTileCoordCenter(tileCoord);
    const projectionExtent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $9pD6L.containsCoordinate)(projectionExtent, center)) {
        const worldWidth = (0, $9pD6L.getWidth)(projectionExtent);
        const worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    return tileCoord;
}
function $5779655d81caea04$export$ce88871416242df8(extent, maxZoom, tileSize, corner) {
    corner = corner !== undefined ? corner : "top-left";
    const resolutions = $5779655d81caea04$var$resolutionsFromExtent(extent, maxZoom, tileSize);
    return new (0, $g5oyO.default)({
        extent: extent,
        origin: (0, $9pD6L.getCorner)(extent, corner),
        resolutions: resolutions,
        tileSize: tileSize
    });
}
function $5779655d81caea04$export$38500bbeccc864ff(options) {
    const xyzOptions = options || {};
    const extent = xyzOptions.extent || (0, $dpRHA.get)("EPSG:3857").getExtent();
    const gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $5779655d81caea04$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $g5oyO.default)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $5779655d81caea04$var$resolutionsFromExtent(extent, maxZoom, tileSize, maxResolution) {
    maxZoom = maxZoom !== undefined ? maxZoom : (0, $7xn5x.DEFAULT_MAX_ZOOM);
    tileSize = (0, $hxhPO.toSize)(tileSize !== undefined ? tileSize : (0, $7xn5x.DEFAULT_TILE_SIZE));
    const height = (0, $9pD6L.getHeight)(extent);
    const width = (0, $9pD6L.getWidth)(extent);
    maxResolution = maxResolution > 0 ? maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    const length = maxZoom + 1;
    const resolutions = new Array(length);
    for(let z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $5779655d81caea04$export$a251b12f5601c16f(projection, maxZoom, tileSize, corner) {
    const extent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    return $5779655d81caea04$export$ce88871416242df8(extent, maxZoom, tileSize, corner);
}
function $5779655d81caea04$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $dpRHA.get)(projection);
    let extent = projection.getExtent();
    if (!extent) {
        const half = 180 * (0, $kUyy5.METERS_PER_UNIT).degrees / projection.getMetersPerUnit();
        extent = (0, $9pD6L.createOrUpdate)(-half, -half, half, half);
    }
    return extent;
}

});
parcelRegister("g5oyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb602a307ef98bb5$export$2e2bcd8739ae039);
/**
 * @module ol/tilegrid/TileGrid
 */ 
var $7iKy2 = parcelRequire("7iKy2");

var $7xn5x = parcelRequire("7xn5x");

var $4Cz58 = parcelRequire("4Cz58");

var $9byFX = parcelRequire("9byFX");

var $9pD6L = parcelRequire("9pD6L");

var $gpyQY = parcelRequire("gpyQY");

var $eQvue = parcelRequire("eQvue");

var $fVVyM = parcelRequire("fVVyM");

var $hxhPO = parcelRequire("hxhPO");
/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ const $bb602a307ef98bb5$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ const $bb602a307ef98bb5$var$DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ class $bb602a307ef98bb5$var$TileGrid {
    /**
   * @param {Options} options Tile grid options.
   */ constructor(options){
        /**
     * @protected
     * @type {number}
     */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
     * @private
     * @type {!Array<number>}
     */ this.resolutions_ = options.resolutions;
        (0, $4Cz58.assert)((0, $fVVyM.isSorted)(this.resolutions_, /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */ (a, b)=>b - a, true), "`resolutions` must be sorted in descending order");
        // check if we've got a consistent zoom factor and origin
        let zoomFactor;
        if (!options.origins) for(let i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
     * @private
     * @type {number|undefined}
     */ this.zoomFactor_ = zoomFactor;
        /**
     * @protected
     * @type {number}
     */ this.maxZoom = this.resolutions_.length - 1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
     * @private
     * @type {Array<import("../coordinate.js").Coordinate>}
     */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $4Cz58.assert)(this.origins_.length == this.resolutions_.length, "Number of `origins` and `resolutions` must be equal");
        }
        const extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $9pD6L.getTopLeft)(extent);
        (0, $4Cz58.assert)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, "Either `origin` or `origins` must be configured, never both");
        /**
     * @private
     * @type {Array<number|import("../size.js").Size>}
     */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $4Cz58.assert)(this.tileSizes_.length == this.resolutions_.length, "Number of `tileSizes` and `resolutions` must be equal");
        }
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $7xn5x.DEFAULT_TILE_SIZE) : null;
        (0, $4Cz58.assert)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, "Either `tileSize` or `tileSizes` must be configured, never both");
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = extent !== undefined ? extent : null;
        /**
     * @private
     * @type {Array<import("../TileRange.js").default>}
     */ this.fullTileRanges_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.tmpSize_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map((size, z)=>{
            const tileRange = new (0, $7iKy2.default)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                const restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        });
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */ forEachTileCoord(extent, zoom, callback) {
        const tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(let i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(let j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */ forEachTileCoordParentTileRange(tileCoord, callback, tempTileRange, tempExtent) {
        let tileRange, x, y;
        let tileCoordExtent = null;
        let z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent);
        while(z >= this.minZoom){
            if (x !== undefined && y !== undefined) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, $7iKy2.createOrUpdate)(x, x, y, y, tempTileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    }
    /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */ getMaxZoom() {
        return this.maxZoom;
    }
    /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */ getMinZoom() {
        return this.minZoom;
    }
    /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */ getOrigin(z) {
        if (this.origin_) return this.origin_;
        return this.origins_[z];
    }
    /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */ getResolution(z) {
        return this.resolutions_[z];
    }
    /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileCoordChildTileRange(tileCoord, tempTileRange, tempExtent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                const minX = tileCoord[1] * 2;
                const minY = tileCoord[2] * 2;
                return (0, $7iKy2.createOrUpdate)(minX, minX + 1, minY, minY + 1, tempTileRange);
            }
            const tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, tempTileRange);
        }
        return null;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileRangeForTileCoordAndZ(tileCoord, z, tempTileRange) {
        if (z > this.maxZoom || z < this.minZoom) return null;
        const tileCoordZ = tileCoord[0];
        const tileCoordX = tileCoord[1];
        const tileCoordY = tileCoord[2];
        if (z === tileCoordZ) return (0, $7iKy2.createOrUpdate)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, tempTileRange);
        if (this.zoomFactor_) {
            const factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            const minX = Math.floor(tileCoordX * factor);
            const minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) return (0, $7iKy2.createOrUpdate)(minX, minX, minY, minY, tempTileRange);
            const maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            const maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return (0, $7iKy2.createOrUpdate)(minX, maxX, minY, maxY, tempTileRange);
        }
        const tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
    }
    /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */ getTileRangeForExtentAndZ(extent, z, tempTileRange) {
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, $bb602a307ef98bb5$var$tmpTileCoord);
        const minX = $bb602a307ef98bb5$var$tmpTileCoord[1];
        const minY = $bb602a307ef98bb5$var$tmpTileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, $bb602a307ef98bb5$var$tmpTileCoord);
        const maxX = $bb602a307ef98bb5$var$tmpTileCoord[1];
        const maxY = $bb602a307ef98bb5$var$tmpTileCoord[2];
        return (0, $7iKy2.createOrUpdate)(minX, maxX, minY, maxY, tempTileRange);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */ getTileCoordCenter(tileCoord) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $hxhPO.toSize)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    }
    /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getTileCoordExtent(tileCoord, tempExtent) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $hxhPO.toSize)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        const minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        const minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        const maxX = minX + tileSize[0] * resolution;
        const maxY = minY + tileSize[1] * resolution;
        return (0, $9pD6L.createOrUpdate)(minX, minY, maxX, maxY, tempExtent);
    }
    /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    }
    /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        const z = this.getZForResolution(resolution);
        const scale = resolution / this.getResolution(z);
        const origin = this.getOrigin(z);
        const tileSize = (0, $hxhPO.toSize)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $9byFX.ceil)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS) - 1;
            tileCoordY = (0, $9byFX.ceil)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $9byFX.floor)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS);
            tileCoordY = (0, $9byFX.floor)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS);
        }
        return (0, $gpyQY.createOrUpdate)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        const origin = this.getOrigin(z);
        const resolution = this.getResolution(z);
        const tileSize = (0, $hxhPO.toSize)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $9byFX.ceil)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS) - 1;
            tileCoordY = (0, $9byFX.ceil)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $9byFX.floor)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS);
            tileCoordY = (0, $9byFX.floor)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS);
        }
        return (0, $gpyQY.createOrUpdate)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */ getTileCoordResolution(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    }
    /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */ getTileSize(z) {
        if (this.tileSize_) return this.tileSize_;
        return this.tileSizes_[z];
    }
    /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */ getFullTileRange(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        return this.fullTileRanges_[z];
    }
    /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */ getZForResolution(resolution, opt_direction) {
        const z = (0, $fVVyM.linearFindNearest)(this.resolutions_, resolution, opt_direction || 0);
        return (0, $9byFX.clamp)(z, this.minZoom, this.maxZoom);
    }
    /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */ tileCoordIntersectsViewport(tileCoord, viewport) {
        return (0, $eQvue.intersectsLinearRing)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
    }
    /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */ calculateTileRanges_(extent) {
        const length = this.resolutions_.length;
        const fullTileRanges = new Array(length);
        for(let z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    }
}
var $bb602a307ef98bb5$export$2e2bcd8739ae039 = $bb602a307ef98bb5$var$TileGrid;

});



parcelRegister("cwqvp", function(module, exports) {

$parcel$export(module.exports, "createFromTemplates", () => $91dd08a0f5859882$export$436f44dbcc31fea3);
$parcel$export(module.exports, "expandUrl", () => $91dd08a0f5859882$export$2a1fa079bfd73dde);
/**
 * @module ol/tileurlfunction
 */ 
var $9byFX = parcelRequire("9byFX");

var $gpyQY = parcelRequire("gpyQY");
function $91dd08a0f5859882$export$f0ecb46e90798741(template, tileGrid) {
    const zRegEx = /\{z\}/g;
    const xRegEx = /\{x\}/g;
    const yRegEx = /\{y\}/g;
    const dashYRegEx = /\{-y\}/g;
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        return template.replace(zRegEx, tileCoord[0].toString()).replace(xRegEx, tileCoord[1].toString()).replace(yRegEx, tileCoord[2].toString()).replace(dashYRegEx, function() {
            const z = tileCoord[0];
            const range = tileGrid.getFullTileRange(z);
            if (!range) throw new Error("The {-y} placeholder requires a tile grid with extent");
            const y = range.getHeight() - tileCoord[2] - 1;
            return y.toString();
        });
    });
}
function $91dd08a0f5859882$export$436f44dbcc31fea3(templates, tileGrid) {
    const len = templates.length;
    const tileUrlFunctions = new Array(len);
    for(let i = 0; i < len; ++i)tileUrlFunctions[i] = $91dd08a0f5859882$export$f0ecb46e90798741(templates[i], tileGrid);
    return $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        const h = (0, $gpyQY.hash)(tileCoord);
        const index = (0, $9byFX.modulo)(h, tileUrlFunctions.length);
        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
    });
}
function $91dd08a0f5859882$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}
function $91dd08a0f5859882$export$2a1fa079bfd73dde(url) {
    const urls = [];
    let match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        const startCharCode = match[1].charCodeAt(0);
        const stopCharCode = match[2].charCodeAt(0);
        let charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        const stop = parseInt(match[2], 10);
        for(let i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}

});





parcelRegister("5DwXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $41aa29ae0c4b607a$export$2e2bcd8739ae039);
/**
 * @module ol/Map
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $cD8Qe = parcelRequire("cD8Qe");

var $1TIYs = parcelRequire("1TIYs");

var $lvfQG = parcelRequire("lvfQG");

var $3xzSb = parcelRequire("3xzSb");

var $79s7T = parcelRequire("79s7T");

var $YSU3I = parcelRequire("YSU3I");

var $dSQBl = parcelRequire("dSQBl");

var $8hMRr = parcelRequire("8hMRr");

var $1O6bd = parcelRequire("1O6bd");

var $4Zdcs = parcelRequire("4Zdcs");

var $jDfdj = parcelRequire("jDfdj");

var $GsIjZ = parcelRequire("GsIjZ");

var $jXCUw = parcelRequire("jXCUw");

var $ijSzV = parcelRequire("ijSzV");

var $l6YBe = parcelRequire("l6YBe");

var $6yfyT = parcelRequire("6yfyT");

var $9DiKA = parcelRequire("9DiKA");

var $aKuSF = parcelRequire("aKuSF");

var $8UoiJ = parcelRequire("8UoiJ");

var $6wUzV = parcelRequire("6wUzV");

var $jpXrt = parcelRequire("jpXrt");

var $4Cz58 = parcelRequire("4Cz58");

var $9pD6L = parcelRequire("9pD6L");

var $f3WAG = parcelRequire("f3WAG");

var $jzydl = parcelRequire("jzydl");

var $fVVyM = parcelRequire("fVVyM");

var $dpRHA = parcelRequire("dpRHA");

var $9iPUS = parcelRequire("9iPUS");

var $hxhPO = parcelRequire("hxhPO");

var $ilM9F = parcelRequire("ilM9F");

var $DfnQm = parcelRequire("DfnQm");

var $c3kwQ = parcelRequire("c3kwQ");
/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {Object<string, import("rbush").default>|null} declutter Declutter trees by declutter group.
 * When null, no decluttering is needed because no layers have decluttering enabled.
 * @property {null|import("./extent.js").Extent} extent Extent (in view projection coordinates).
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(Map, ?FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} MapEventHandler
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control/defaults.defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction/defaults.defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * **Note:** CSS `transform` support for the target element is limited to `scale`.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function $41aa29ae0c4b607a$var$removeLayerMapProperty(layer) {
    if (layer instanceof (0, $79s7T.default)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, $YSU3I.default)) layer.getLayers().forEach($41aa29ae0c4b607a$var$removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {Map} map Map.
 */ function $41aa29ae0c4b607a$var$setLayerMapProperty(layer, map) {
    if (layer instanceof (0, $79s7T.default)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, $YSU3I.default)) {
        const layers = layer.getLayers().getArray();
        for(let i = 0, ii = layers.length; i < ii; ++i)$41aa29ae0c4b607a$var$setLayerMapProperty(layers[i], map);
    }
}
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map.js';
 *     import View from 'ol/View.js';
 *     import TileLayer from 'ol/layer/Tile.js';
 *     import OSM from 'ol/source/OSM.js';
 *
 *     const map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1,
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM(),
 *         }),
 *       ],
 *       target: 'map',
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ class $41aa29ae0c4b607a$var$Map extends (0, $fFFY7.default) {
    /**
   * @param {MapOptions} [options] Map options.
   */ constructor(options){
        super();
        options = options || {};
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {MapEventHandler<void>}
     */ this.un;
        const optionsInternal = $41aa29ae0c4b607a$var$createOptionsInternal(options);
        /**
     * @private
     * @type {boolean|undefined}
     */ this.renderComplete_;
        /**
     * @private
     * @type {boolean}
     */ this.loaded_ = true;
        /** @private */ this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this);
        /**
     * @type {number}
     * @private
     */ this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $8UoiJ.DEVICE_PIXEL_RATIO);
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.postRenderTimeoutHandle_;
        /**
     * @private
     * @type {number|undefined}
     */ this.animationDelayKey_;
        /**
     * @private
     */ this.animationDelay_ = this.animationDelay_.bind(this);
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.coordinateToPixelTransform_ = (0, $jpXrt.create)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.pixelToCoordinateTransform_ = (0, $jpXrt.create)();
        /**
     * @private
     * @type {number}
     */ this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ this.viewport_ = document.createElement("div");
        this.viewport_.className = "ol-viewport" + ("ontouchstart" in window ? " ol-touch" : "");
        this.viewport_.style.position = "relative";
        this.viewport_.style.overflow = "hidden";
        this.viewport_.style.width = "100%";
        this.viewport_.style.height = "100%";
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainer_ = document.createElement("div");
        this.overlayContainer_.style.position = "absolute";
        this.overlayContainer_.style.zIndex = "0";
        this.overlayContainer_.style.width = "100%";
        this.overlayContainer_.style.height = "100%";
        this.overlayContainer_.style.pointerEvents = "none";
        this.overlayContainer_.className = "ol-overlaycontainer";
        this.viewport_.appendChild(this.overlayContainer_);
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainerStopEvent_ = document.createElement("div");
        this.overlayContainerStopEvent_.style.position = "absolute";
        this.overlayContainerStopEvent_.style.zIndex = "0";
        this.overlayContainerStopEvent_.style.width = "100%";
        this.overlayContainerStopEvent_.style.height = "100%";
        this.overlayContainerStopEvent_.style.pointerEvents = "none";
        this.overlayContainerStopEvent_.className = "ol-overlaycontainer-stopevent";
        this.viewport_.appendChild(this.overlayContainerStopEvent_);
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ this.mapBrowserEventHandler_ = null;
        /**
     * @private
     * @type {number}
     */ this.moveTolerance_ = options.moveTolerance;
        /**
     * @private
     * @type {HTMLElement|Document}
     */ this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.targetChangeHandlerKeys_ = null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ this.targetElement_ = null;
        /**
     * @type {ResizeObserver}
     */ this.resizeObserver_ = new ResizeObserver(()=>this.updateSize());
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ this.controls = optionsInternal.controls || (0, $f3WAG.defaults)();
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ this.interactions = optionsInternal.interactions || (0, $jzydl.defaults)({
            onFocusOnly: true
        });
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */ this.renderer_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ this.tileQueue_ = new (0, $6yfyT.default)(this.getTilePriority.bind(this), this.handleTileChange_.bind(this));
        this.addChangeListener((0, $GsIjZ.default).LAYERGROUP, this.handleLayerGroupChanged_);
        this.addChangeListener((0, $GsIjZ.default).VIEW, this.handleViewChanged_);
        this.addChangeListener((0, $GsIjZ.default).SIZE, this.handleSizeChanged_);
        this.addChangeListener((0, $GsIjZ.default).TARGET, this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        this.setProperties(optionsInternal.values);
        const map = this;
        if (options.view && !(options.view instanceof (0, $9DiKA.default))) options.view.then(function(viewOptions) {
            map.setView(new (0, $9DiKA.default)(viewOptions));
        });
        this.controls.addEventListener((0, $1TIYs.default).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */ (event)=>{
            event.element.setMap(this);
        });
        this.controls.addEventListener((0, $1TIYs.default).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.interactions.addEventListener((0, $1TIYs.default).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(this);
        });
        this.interactions.addEventListener((0, $1TIYs.default).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.overlays_.addEventListener((0, $1TIYs.default).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            this.addOverlayInternal_(event.element);
        });
        this.overlays_.addEventListener((0, $1TIYs.default).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            const id = event.element.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        });
        this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       */ (control)=>{
            control.setMap(this);
        });
        this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */ (interaction)=>{
            interaction.setMap(this);
        });
        this.overlays_.forEach(this.addOverlayInternal_.bind(this));
    }
    /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ addControl(control) {
        this.getControls().push(control);
    }
    /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ addInteraction(interaction) {
        this.getInteractions().push(interaction);
    }
    /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ addLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */ handleLayerAdd_(event) {
        $41aa29ae0c4b607a$var$setLayerMapProperty(event.layer, this);
    }
    /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ addOverlay(overlay) {
        this.getOverlays().push(overlay);
    }
    /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ addOverlayInternal_(overlay) {
        const id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    }
    /**
   *
   * Clean up.
   */ disposeInternal() {
        this.controls.clear();
        this.interactions.clear();
        this.overlays_.clear();
        this.resizeObserver_.disconnect();
        this.setTarget(null);
        super.disposeInternal();
    }
    /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */ forEachFeatureAtPixel(pixel, callback, options) {
        if (!this.frameState_ || !this.renderer_) return;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $6wUzV.TRUE);
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    }
    /**
   * Get all features that intersect a pixel on the viewport.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */ getFeaturesAtPixel(pixel, options) {
        const features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, options);
        return features;
    }
    /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */ getAllLayers() {
        const layers = [];
        function addLayersFrom(layerGroup) {
            layerGroup.forEach(function(layer) {
                if (layer instanceof (0, $YSU3I.default)) addLayersFrom(layer.getLayers());
                else layers.push(layer);
            });
        }
        addLayersFrom(this.getLayers());
        return layers;
    }
    /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */ hasFeatureAtPixel(pixel, options) {
        if (!this.frameState_ || !this.renderer_) return false;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $6wUzV.TRUE);
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    }
    /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ getEventCoordinate(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    }
    /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */ getEventCoordinateInternal(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    }
    /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ getEventPixel(event) {
        const viewport = this.viewport_;
        const viewportPosition = viewport.getBoundingClientRect();
        const viewportSize = this.getSize();
        const scaleX = viewportPosition.width / viewportSize[0];
        const scaleY = viewportPosition.height / viewportSize[1];
        const eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        "changedTouches" in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            (eventPosition.clientX - viewportPosition.left) / scaleX,
            (eventPosition.clientY - viewportPosition.top) / scaleY
        ];
    }
    /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ getTarget() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $GsIjZ.default).TARGET);
    }
    /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ getTargetElement() {
        return this.targetElement_;
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ getCoordinateFromPixel(pixel) {
        return (0, $dpRHA.toUserCoordinate)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */ getCoordinateFromPixelInternal(pixel) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $jpXrt.apply)(frameState.pixelToCoordinateTransform, pixel.slice());
    }
    /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ getControls() {
        return this.controls;
    }
    /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ getOverlays() {
        return this.overlays_;
    }
    /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default|null} Overlay.
   * @api
   */ getOverlayById(id) {
        const overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    }
    /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ getInteractions() {
        return this.interactions;
    }
    /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ getLayerGroup() {
        return /** @type {LayerGroup} */ this.get((0, $GsIjZ.default).LAYERGROUP);
    }
    /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */ setLayers(layers) {
        const group = this.getLayerGroup();
        if (layers instanceof (0, $cD8Qe.default)) {
            group.setLayers(layers);
            return;
        }
        const collection = group.getLayers();
        collection.clear();
        collection.extend(layers);
    }
    /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ getLayers() {
        const layers = this.getLayerGroup().getLayers();
        return layers;
    }
    /**
   * @return {boolean} Layers have sources that are still loading.
   */ getLoadingOrNotReady() {
        const layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const state = layerStatesArray[i];
            if (!state.visible) continue;
            const renderer = state.layer.getRenderer();
            if (renderer && !renderer.ready) return true;
            const source = state.layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ getPixelFromCoordinate(coordinate) {
        const viewCoordinate = (0, $dpRHA.fromUserCoordinate)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */ getPixelFromCoordinateInternal(coordinate) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $jpXrt.apply)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    }
    /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ getSize() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $GsIjZ.default).SIZE);
    }
    /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ getView() {
        return /** @type {View} */ this.get((0, $GsIjZ.default).VIEW);
    }
    /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ getViewport() {
        return this.viewport_;
    }
    /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ getOverlayContainer() {
        return this.overlayContainer_;
    }
    /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ getOverlayContainerStopEvent() {
        return this.overlayContainerStopEvent_;
    }
    /**
   * @return {!Document} The document where the map is displayed.
   */ getOwnerDocument() {
        const targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    }
    /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ getTilePriority(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, $6yfyT.getTilePriority)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    }
    /**
   * @param {UIEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */ handleBrowserEvent(browserEvent, type) {
        type = type || browserEvent.type;
        const mapBrowserEvent = new (0, $dSQBl.default)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    }
    /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ handleMapBrowserEvent(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        const originalEvent = /** @type {PointerEvent} */ mapBrowserEvent.originalEvent;
        const eventType = originalEvent.type;
        if (eventType === (0, $ijSzV.default).POINTERDOWN || eventType === (0, $3xzSb.default).WHEEL || eventType === (0, $3xzSb.default).KEYDOWN) {
            const doc = this.getOwnerDocument();
            const rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            const target = /** @type {Node} */ originalEvent.target;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !(rootNode === doc ? doc.documentElement : rootNode).contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            const interactionsArray = this.getInteractions().getArray().slice();
            for(let i = interactionsArray.length - 1; i >= 0; i--){
                const interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                const cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    }
    /**
   * @protected
   */ handlePostRender() {
        const frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        const tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            let maxTotalLoading = this.maxTilesLoading_;
            let maxNewLoads = maxTotalLoading;
            if (frameState) {
                const hints = frameState.viewHints;
                if (hints[(0, $aKuSF.default).ANIMATING] || hints[(0, $aKuSF.default).INTERACTING]) {
                    const lowOnFrameBudget = Date.now() - frameState.time > 8;
                    maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                    maxNewLoads = lowOnFrameBudget ? 0 : 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.renderer_ && !frameState.animate) {
            if (this.renderComplete_ === true) {
                if (this.hasListener((0, $l6YBe.default).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, $l6YBe.default).RENDERCOMPLETE, frameState);
                if (this.loaded_ === false) {
                    this.loaded_ = true;
                    this.dispatchEvent(new (0, $4Zdcs.default)((0, $jDfdj.default).LOADEND, this, frameState));
                }
            } else if (this.loaded_ === true) {
                this.loaded_ = false;
                this.dispatchEvent(new (0, $4Zdcs.default)((0, $jDfdj.default).LOADSTART, this, frameState));
            }
        }
        const postRenderFunctions = this.postRenderFunctions_;
        for(let i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    }
    /**
   * @private
   */ handleSizeChanged_() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    }
    /**
   * @private
   */ handleTargetChanged_() {
        if (this.mapBrowserEventHandler_) {
            for(let i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, $ilM9F.unlistenByKey)(this.targetChangeHandlerKeys_[i]);
            this.targetChangeHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, $3xzSb.default).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, $3xzSb.default).WHEEL, this.boundHandleBrowserEvent_);
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            (0, $DfnQm.removeNode)(this.viewport_);
        }
        if (this.targetElement_) {
            this.resizeObserver_.unobserve(this.targetElement_);
            const rootNode = this.targetElement_.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.unobserve(rootNode.host);
            this.setSize(undefined);
        }
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        const target = this.getTarget();
        const targetElement = typeof target === "string" ? document.getElementById(target) : target;
        this.targetElement_ = targetElement;
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = new (0, $lvfQG.default)(this);
            this.mapBrowserEventHandler_ = new (0, $8hMRr.default)(this, this.moveTolerance_);
            for(const key in 0, $1O6bd.default)this.mapBrowserEventHandler_.addEventListener((0, $1O6bd.default)[key], this.handleMapBrowserEvent.bind(this));
            this.viewport_.addEventListener((0, $3xzSb.default).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
            this.viewport_.addEventListener((0, $3xzSb.default).WHEEL, this.boundHandleBrowserEvent_, (0, $8UoiJ.PASSIVE_EVENT_LISTENERS) ? {
                passive: false
            } : false);
            const keyboardEventTarget = !this.keyboardEventTarget_ ? targetElement : this.keyboardEventTarget_;
            this.targetChangeHandlerKeys_ = [
                (0, $ilM9F.listen)(keyboardEventTarget, (0, $3xzSb.default).KEYDOWN, this.handleBrowserEvent, this),
                (0, $ilM9F.listen)(keyboardEventTarget, (0, $3xzSb.default).KEYPRESS, this.handleBrowserEvent, this)
            ];
            const rootNode = targetElement.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.observe(rootNode.host);
            this.resizeObserver_.observe(targetElement);
        }
        this.updateSize();
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    }
    /**
   * @private
   */ handleTileChange_() {
        this.render();
    }
    /**
   * @private
   */ handleViewPropertyChanged_() {
        this.render();
    }
    /**
   * @private
   */ handleViewChanged_() {
        if (this.viewPropertyListenerKey_) {
            (0, $ilM9F.unlistenByKey)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $ilM9F.unlistenByKey)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        const view = this.getView();
        if (view) {
            this.updateViewportSize_(this.getSize());
            this.viewPropertyListenerKey_ = (0, $ilM9F.listen)(view, (0, $jXCUw.default).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $ilM9F.listen)(view, (0, $3xzSb.default).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    }
    /**
   * @private
   */ handleLayerGroupChanged_() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $ilM9F.unlistenByKey));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        const layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.handleLayerAdd_(new (0, $YSU3I.GroupEvent)("addlayer", layerGroup));
            this.layerGroupPropertyListenerKeys_ = [
                (0, $ilM9F.listen)(layerGroup, (0, $jXCUw.default).PROPERTYCHANGE, this.render, this),
                (0, $ilM9F.listen)(layerGroup, (0, $3xzSb.default).CHANGE, this.render, this),
                (0, $ilM9F.listen)(layerGroup, "addlayer", this.handleLayerAdd_, this),
                (0, $ilM9F.listen)(layerGroup, "removelayer", this.handleLayerRemove_, this)
            ];
        }
        this.render();
    }
    /**
   * @return {boolean} Is rendered.
   */ isRendered() {
        return !!this.frameState_;
    }
    /**
   * @private
   */ animationDelay_() {
        this.animationDelayKey_ = undefined;
        this.renderFrame_(Date.now());
    }
    /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ renderSync() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    }
    /**
   * Redraws all text after new fonts have loaded
   */ redrawText() {
        const layerStates = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStates.length; i < ii; ++i){
            const layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    }
    /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ render() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    }
    /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ removeControl(control) {
        return this.getControls().remove(control);
    }
    /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ removeInteraction(interaction) {
        return this.getInteractions().remove(interaction);
    }
    /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ removeLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */ handleLayerRemove_(event) {
        $41aa29ae0c4b607a$var$removeLayerMapProperty(event.layer);
    }
    /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ removeOverlay(overlay) {
        return this.getOverlays().remove(overlay);
    }
    /**
   * @param {number} time Time.
   * @private
   */ renderFrame_(time) {
        const size = this.getSize();
        const view = this.getView();
        const previousFrameState = this.frameState_;
        /** @type {?FrameState} */ let frameState = null;
        if (size !== undefined && (0, $hxhPO.hasArea)(size) && view && view.isDef()) {
            const viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            const viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutter: null,
                extent: (0, $9pD6L.getForViewAndSize)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
                mapId: (0, $9iPUS.getUid)(this),
                renderTargets: {}
            };
            if (viewState.nextCenter && viewState.nextResolution) {
                const rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                frameState.nextExtent = (0, $9pD6L.getForViewAndSize)(viewState.nextCenter, viewState.nextResolution, rotation, size);
            }
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                const moveStart = !this.previousExtent_ || !(0, $9pD6L.isEmpty)(this.previousExtent_) && !(0, $9pD6L.equals)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $4Zdcs.default)((0, $jDfdj.default).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $9pD6L.createOrUpdateEmpty)(this.previousExtent_);
                }
            }
            const idle = this.previousExtent_ && !frameState.viewHints[(0, $aKuSF.default).ANIMATING] && !frameState.viewHints[(0, $aKuSF.default).INTERACTING] && !(0, $9pD6L.equals)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $4Zdcs.default)((0, $jDfdj.default).MOVEEND, this, frameState));
                (0, $9pD6L.clone)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $4Zdcs.default)((0, $jDfdj.default).POSTRENDER, this, frameState));
        this.renderComplete_ = this.hasListener((0, $jDfdj.default).LOADSTART) || this.hasListener((0, $jDfdj.default).LOADEND) || this.hasListener((0, $l6YBe.default).RENDERCOMPLETE) ? !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady() : undefined;
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(()=>{
            this.postRenderTimeoutHandle_ = undefined;
            this.handlePostRender();
        }, 0);
    }
    /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ setLayerGroup(layerGroup) {
        const oldLayerGroup = this.getLayerGroup();
        if (oldLayerGroup) this.handleLayerRemove_(new (0, $YSU3I.GroupEvent)("removelayer", oldLayerGroup));
        this.set((0, $GsIjZ.default).LAYERGROUP, layerGroup);
    }
    /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ setSize(size) {
        this.set((0, $GsIjZ.default).SIZE, size);
    }
    /**
   * Set the target element to render this map into.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ setTarget(target) {
        this.set((0, $GsIjZ.default).TARGET, target);
    }
    /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */ setView(view) {
        if (!view || view instanceof (0, $9DiKA.default)) {
            this.set((0, $GsIjZ.default).VIEW, view);
            return;
        }
        this.set((0, $GsIjZ.default).VIEW, new (0, $9DiKA.default)());
        const map = this;
        view.then(function(viewOptions) {
            map.setView(new (0, $9DiKA.default)(viewOptions));
        });
    }
    /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ updateSize() {
        const targetElement = this.getTargetElement();
        let size = undefined;
        if (targetElement) {
            const computedStyle = getComputedStyle(targetElement);
            const width = targetElement.offsetWidth - parseFloat(computedStyle["borderLeftWidth"]) - parseFloat(computedStyle["paddingLeft"]) - parseFloat(computedStyle["paddingRight"]) - parseFloat(computedStyle["borderRightWidth"]);
            const height = targetElement.offsetHeight - parseFloat(computedStyle["borderTopWidth"]) - parseFloat(computedStyle["paddingTop"]) - parseFloat(computedStyle["paddingBottom"]) - parseFloat(computedStyle["borderBottomWidth"]);
            if (!isNaN(width) && !isNaN(height)) {
                size = [
                    width,
                    height
                ];
                if (!(0, $hxhPO.hasArea)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) (0, $c3kwQ.warn)("No map visible because the map container's width or height are 0.");
            }
        }
        const oldSize = this.getSize();
        if (size && (!oldSize || !(0, $fVVyM.equals)(size, oldSize))) {
            this.setSize(size);
            this.updateViewportSize_(size);
        }
    }
    /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */ updateViewportSize_(size) {
        const view = this.getView();
        if (view) view.setViewportSize(size);
    }
}
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $41aa29ae0c4b607a$var$createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ let keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === "string" ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ const values = {};
    const layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === "function" ? /** @type {LayerGroup} */ options.layers : new (0, $YSU3I.default)({
        layers: /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */ options.layers
    });
    values[(0, $GsIjZ.default).LAYERGROUP] = layerGroup;
    values[(0, $GsIjZ.default).TARGET] = options.target;
    values[(0, $GsIjZ.default).VIEW] = options.view instanceof (0, $9DiKA.default) ? options.view : new (0, $9DiKA.default)();
    /** @type {Collection<import("./control/Control.js").default>} */ let controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $cD8Qe.default)(options.controls.slice());
        else {
            (0, $4Cz58.assert)(typeof /** @type {?} */ options.controls.getArray === "function", "Expected `controls` to be an array or an `ol/Collection.js`");
            controls = options.controls;
        }
    }
    /** @type {Collection<import("./interaction/Interaction").default>} */ let interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $cD8Qe.default)(options.interactions.slice());
        else {
            (0, $4Cz58.assert)(typeof /** @type {?} */ options.interactions.getArray === "function", "Expected `interactions` to be an array or an `ol/Collection.js`");
            interactions = options.interactions;
        }
    }
    /** @type {Collection<import("./Overlay.js").default>} */ let overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $cD8Qe.default)(options.overlays.slice());
        else {
            (0, $4Cz58.assert)(typeof /** @type {?} */ options.overlays.getArray === "function", "Expected `overlays` to be an array or an `ol/Collection.js`");
            overlays = options.overlays;
        }
    } else overlays = new (0, $cD8Qe.default)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $41aa29ae0c4b607a$export$2e2bcd8739ae039 = $41aa29ae0c4b607a$var$Map;

});
parcelRegister("cD8Qe", function(module, exports) {

$parcel$export(module.exports, "default", () => $931ffc4e747c14db$export$2e2bcd8739ae039);
/**
 * @module ol/Collection
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $1TIYs = parcelRequire("1TIYs");

var $f18Q2 = parcelRequire("f18Q2");
/**
 * @enum {string}
 * @private
 */ const $931ffc4e747c14db$var$Property = {
    LENGTH: "length"
};
class $931ffc4e747c14db$export$a87ae6eb2761ec6d extends (0, $f18Q2.default) {
    /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */ constructor(type, element, index){
        super(type);
        /**
     * The element that is added to or removed from the collection.
     * @type {T}
     * @api
     */ this.element = element;
        /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */ this.index = index;
    }
}
/***
 * @template T
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent<T>, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ class $931ffc4e747c14db$var$Collection extends (0, $fFFY7.default) {
    /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */ constructor(array, options){
        super();
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {CollectionOnSignature<T, void>}
     */ this.un;
        options = options || {};
        /**
     * @private
     * @type {boolean}
     */ this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ this.array_ = array ? array : [];
        if (this.unique_) for(let i = 0, ii = this.array_.length; i < ii; ++i)this.assertUnique_(this.array_[i], i);
        this.updateLength_();
    }
    /**
   * Remove all elements from the collection.
   * @api
   */ clear() {
        while(this.getLength() > 0)this.pop();
    }
    /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ extend(arr) {
        for(let i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    }
    /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ forEach(f) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    }
    /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ getArray() {
        return this.array_;
    }
    /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ item(index) {
        return this.array_[index];
    }
    /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ getLength() {
        return this.get($931ffc4e747c14db$var$Property.LENGTH);
    }
    /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ insertAt(index, elem) {
        if (index < 0 || index > this.getLength()) throw new Error("Index out of bounds: " + index);
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $1TIYs.default).ADD, elem, index));
    }
    /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ pop() {
        return this.removeAt(this.getLength() - 1);
    }
    /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ push(elem) {
        if (this.unique_) this.assertUnique_(elem);
        const n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    }
    /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ remove(elem) {
        const arr = this.array_;
        for(let i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    }
    /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ removeAt(index) {
        if (index < 0 || index >= this.getLength()) return undefined;
        const prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $1TIYs.default).REMOVE, prev, index));
        return prev;
    }
    /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ setAt(index, elem) {
        const n = this.getLength();
        if (index >= n) {
            this.insertAt(index, elem);
            return;
        }
        if (index < 0) throw new Error("Index out of bounds: " + index);
        if (this.unique_) this.assertUnique_(elem, index);
        const prev = this.array_[index];
        this.array_[index] = elem;
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $1TIYs.default).REMOVE, prev, index));
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $1TIYs.default).ADD, elem, index));
    }
    /**
   * @private
   */ updateLength_() {
        this.set($931ffc4e747c14db$var$Property.LENGTH, this.array_.length);
    }
    /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */ assertUnique_(elem, except) {
        for(let i = 0, ii = this.array_.length; i < ii; ++i){
            if (this.array_[i] === elem && i !== except) throw new Error("Duplicate item added to a unique collection");
        }
    }
}
var $931ffc4e747c14db$export$2e2bcd8739ae039 = $931ffc4e747c14db$var$Collection;

});
parcelRegister("1TIYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $161dd067fe2d672c$export$2e2bcd8739ae039);
/**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $161dd067fe2d672c$export$2e2bcd8739ae039 = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: "add",
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: "remove"
};

});


parcelRegister("lvfQG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa78c97693b12120$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/Composite
 */ 
var $hf3TH = parcelRequire("hf3TH");

var $fp9DL = parcelRequire("fp9DL");

var $jXCUw = parcelRequire("jXCUw");

var $fNIok = parcelRequire("fNIok");

var $l6YBe = parcelRequire("l6YBe");

var $hGHcK = parcelRequire("hGHcK");

var $ig1j9 = parcelRequire("ig1j9");

var $79s7T = parcelRequire("79s7T");

var $ilM9F = parcelRequire("ilM9F");

var $DfnQm = parcelRequire("DfnQm");
/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ class $fa78c97693b12120$var$CompositeMapRenderer extends (0, $fp9DL.default) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super(map);
        /**
     * @type {import("../events.js").EventsKey}
     */ this.fontChangeListenerKey_ = (0, $ilM9F.listen)((0, $ig1j9.checkedFonts), (0, $jXCUw.default).PROPERTYCHANGE, map.redrawText.bind(map));
        /**
     * @private
     * @type {HTMLDivElement}
     */ this.element_ = document.createElement("div");
        const style = this.element_.style;
        style.position = "absolute";
        style.width = "100%";
        style.height = "100%";
        style.zIndex = "0";
        this.element_.className = (0, $hGHcK.CLASS_UNSELECTABLE) + " ol-layers";
        const container = map.getViewport();
        container.insertBefore(this.element_, container.firstChild || null);
        /**
     * @private
     * @type {Array<HTMLElement>}
     */ this.children_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        const map = this.getMap();
        if (map.hasListener(type)) {
            const event = new (0, $fNIok.default)(type, undefined, frameState);
            map.dispatchEvent(event);
        }
    }
    disposeInternal() {
        (0, $ilM9F.unlistenByKey)(this.fontChangeListenerKey_);
        this.element_.parentNode.removeChild(this.element_);
        super.disposeInternal();
    }
    /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = "none";
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $l6YBe.default).PRECOMPOSE, frameState);
        const layerStatesArray = frameState.layerStatesArray.sort(function(a, b) {
            return a.zIndex - b.zIndex;
        });
        const declutter = layerStatesArray.some((layerState)=>layerState.layer instanceof (0, $hf3TH.default) && layerState.layer.getDeclutter());
        if (declutter) // Some layers need decluttering, turn on deferred rendering hint
        frameState.declutter = {};
        const viewState = frameState.viewState;
        this.children_.length = 0;
        const renderedLayerStates = [];
        let previousElement = null;
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            const layer = layerState.layer;
            const sourceState = layer.getSourceState();
            if (!(0, $79s7T.inView)(layerState, viewState) || sourceState != "ready" && sourceState != "undefined") {
                layer.unrender();
                continue;
            }
            const element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            renderedLayerStates.push(layerState);
        }
        this.declutter(frameState, renderedLayerStates);
        (0, $DfnQm.replaceChildren)(this.element_, this.children_);
        this.dispatchRenderEvent((0, $l6YBe.default).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = "";
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {Array<import('../layer/Layer.js').State>} layerStates Layers.
   */ declutter(frameState, layerStates) {
        if (!frameState.declutter) return;
        for(let i = layerStates.length - 1; i >= 0; --i){
            const layerState = layerStates[i];
            const layer = layerState.layer;
            if (layer.getDeclutter()) layer.renderDeclutter(frameState, layerState);
        }
        layerStates.forEach((layerState)=>layerState.layer.renderDeferred(frameState));
    }
}
var $fa78c97693b12120$export$2e2bcd8739ae039 = $fa78c97693b12120$var$CompositeMapRenderer;

});
parcelRegister("hf3TH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d6dc4c09ed9916$export$2e2bcd8739ae039);
/**
 * @module ol/layer/BaseVector
 */ 
var $79s7T = parcelRequire("79s7T");

var $20GDs = parcelRequire("20GDs");

var $c3RIb = parcelRequire("c3RIb");

var $8f0Mc = parcelRequire("8f0Mc");
/**
 * @template {import("../source/Vector.js").default<import('../Feature').FeatureLike>|import("../source/VectorTile.js").default<import('../Feature').FeatureLike>} VectorSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $c8d6dc4c09ed9916$var$Property = {
    RENDER_ORDER: "renderOrder"
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default<import('../Feature').FeatureLike>|import("../source/VectorTile.js").default<import('../Feature').FeatureLike>} VectorSourceType
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @extends {Layer<VectorSourceType, RendererType>}
 * @api
 */ class $c8d6dc4c09ed9916$var$BaseVectorLayer extends (0, $79s7T.default) {
    /**
   * @param {Options<VectorSourceType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        super(baseOptions);
        /**
     * @private
     * @type {string}
     */ this.declutter_ = options.declutter ? String(options.declutter) : undefined;
        /**
     * @type {number}
     * @private
     */ this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
     * User provided style.
     * @type {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike}
     * @private
     */ this.style_ = null;
        /**
     * Style function for use within the library.
     * @type {import("../style/Style.js").StyleFunction|undefined}
     * @private
     */ this.styleFunction_ = undefined;
        this.setStyle(options.style);
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
    }
    /**
   * @return {string} Declutter group.
   */ getDeclutter() {
        return this.declutter_;
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * @return {number|undefined} Render buffer.
   */ getRenderBuffer() {
        return this.renderBuffer_;
    }
    /**
   * @return {function(import("../Feature.js").default, import("../Feature.js").default): number|null|undefined} Render
   *     order.
   */ getRenderOrder() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($c8d6dc4c09ed9916$var$Property.RENDER_ORDER);
    }
    /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null|undefined} Layer style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */ getUpdateWhileAnimating() {
        return this.updateWhileAnimating_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */ getUpdateWhileInteracting() {
        return this.updateWhileInteracting_;
    }
    /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {
        const declutterGroup = this.getDeclutter();
        if (declutterGroup in frameState.declutter === false) frameState.declutter[declutterGroup] = new (0, (/*@__PURE__*/$parcel$interopDefault($20GDs)))(9);
        this.getRenderer().renderDeclutter(frameState, layerState);
    }
    /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */ setRenderOrder(renderOrder) {
        this.set($c8d6dc4c09ed9916$var$Property.RENDER_ORDER, renderOrder);
    }
    /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */ setStyle(style) {
        this.style_ = style === undefined ? (0, $c3RIb.createDefaultStyle) : style;
        const styleLike = $c8d6dc4c09ed9916$var$toStyleLike(style);
        this.styleFunction_ = style === null ? undefined : (0, $c3RIb.toFunction)(styleLike);
        this.changed();
    }
}
/**
 * Coerce the allowed style types into a shorter list of types.  Flat styles, arrays of flat
 * styles, and arrays of rules are converted into style functions.
 *
 * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
 * @return {import("../style/Style.js").StyleLike|null} The style.
 */ function $c8d6dc4c09ed9916$var$toStyleLike(style) {
    if (style === undefined) return 0, $c3RIb.createDefaultStyle;
    if (!style) return null;
    if (typeof style === "function") return style;
    if (style instanceof (0, $c3RIb.default)) return style;
    if (!Array.isArray(style)) return (0, $8f0Mc.flatStylesToStyleFunction)([
        style
    ]);
    if (style.length === 0) return [];
    const length = style.length;
    const first = style[0];
    if (first instanceof (0, $c3RIb.default)) {
        /**
     * @type {Array<Style>}
     */ const styles = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!(candidate instanceof (0, $c3RIb.default))) throw new Error("Expected a list of style instances");
            styles[i] = candidate;
        }
        return styles;
    }
    if ("style" in first) {
        /**
     * @type Array<import("../style/flat.js").Rule>
     */ const rules = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!("style" in candidate)) throw new Error("Expected a list of rules with a style property");
            rules[i] = candidate;
        }
        return (0, $8f0Mc.rulesToStyleFunction)(rules);
    }
    const flatStyles = /** @type {Array<import("../style/flat.js").FlatStyle>} */ style;
    return (0, $8f0Mc.flatStylesToStyleFunction)(flatStyles);
}
var $c8d6dc4c09ed9916$export$2e2bcd8739ae039 = $c8d6dc4c09ed9916$var$BaseVectorLayer;

});
parcelRegister("20GDs", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    function t(t, r, e, a, h) {
        !function t(n, r, e, a, h) {
            for(; a > e;){
                if (a - e > 600) {
                    var o = a - e + 1, s = r - e + 1, l = Math.log(o), f = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * f * (o - f) / o) * (s - o / 2 < 0 ? -1 : 1), m = Math.max(e, Math.floor(r - s * f / o + u)), c = Math.min(a, Math.floor(r + (o - s) * f / o + u));
                    t(n, r, m, c, h);
                }
                var p = n[r], d = e, x = a;
                for(i(n, e, r), h(n[a], p) > 0 && i(n, e, a); d < x;){
                    for(i(n, d, x), d++, x--; h(n[d], p) < 0;)d++;
                    for(; h(n[x], p) > 0;)x--;
                }
                0 === h(n[e], p) ? i(n, e, x) : i(n, ++x, a), x <= r && (e = x + 1), r <= x && (a = x - 1);
            }
        }(t, r, e || 0, a || t.length - 1, h || n);
    }
    function i(t, i, n) {
        var r = t[i];
        t[i] = t[n], t[n] = r;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    var r = function(t) {
        void 0 === t && (t = 9), this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
    };
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(var r = 0; r < i.length; r++)if (n(t, i[r])) return r;
        return -1;
    }
    function a(t, i) {
        h(t, 0, t.children.length, i, t);
    }
    function h(t, i, n, r, e) {
        e || (e = p(null)), e.minX = 1 / 0, e.minY = 1 / 0, e.maxX = -1 / 0, e.maxY = -1 / 0;
        for(var a = i; a < n; a++){
            var h = t.children[a];
            o(e, t.leaf ? r(h) : h);
        }
        return e;
    }
    function o(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function s(t, i) {
        return t.minX - i.minX;
    }
    function l(t, i) {
        return t.minY - i.minY;
    }
    function f(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function u(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function c(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function p(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function d(i, n, r, e, a) {
        for(var h = [
            n,
            r
        ]; h.length;)if (!((r = h.pop()) - (n = h.pop()) <= e)) {
            var o = n + Math.ceil((r - n) / e / 2) * e;
            t(i, o, n, r, a), h.push(n, o, o, r);
        }
    }
    return r.prototype.all = function() {
        return this._all(this.data, []);
    }, r.prototype.search = function(t) {
        var i = this.data, n = [];
        if (!c(t, i)) return n;
        for(var r = this.toBBox, e = []; i;){
            for(var a = 0; a < i.children.length; a++){
                var h = i.children[a], o = i.leaf ? r(h) : h;
                c(t, o) && (i.leaf ? n.push(h) : m(t, o) ? this._all(h, n) : e.push(h));
            }
            i = e.pop();
        }
        return n;
    }, r.prototype.collides = function(t) {
        var i = this.data;
        if (!c(t, i)) return !1;
        for(var n = []; i;){
            for(var r = 0; r < i.children.length; r++){
                var e = i.children[r], a = i.leaf ? this.toBBox(e) : e;
                if (c(t, a)) {
                    if (i.leaf || m(t, a)) return !0;
                    n.push(e);
                }
            }
            i = n.pop();
        }
        return !1;
    }, r.prototype.load = function(t) {
        if (!t || !t.length) return this;
        if (t.length < this._minEntries) {
            for(var i = 0; i < t.length; i++)this.insert(t[i]);
            return this;
        }
        var n = this._build(t.slice(), 0, t.length - 1, 0);
        if (this.data.children.length) {
            if (this.data.height === n.height) this._splitRoot(this.data, n);
            else {
                if (this.data.height < n.height) {
                    var r = this.data;
                    this.data = n, n = r;
                }
                this._insert(n, this.data.height - n.height - 1, !0);
            }
        } else this.data = n;
        return this;
    }, r.prototype.insert = function(t) {
        return t && this._insert(t, this.data.height - 1), this;
    }, r.prototype.clear = function() {
        return this.data = p([]), this;
    }, r.prototype.remove = function(t, i) {
        if (!t) return this;
        for(var n, r, a, h = this.data, o = this.toBBox(t), s = [], l = []; h || s.length;){
            if (h || (h = s.pop(), r = s[s.length - 1], n = l.pop(), a = !0), h.leaf) {
                var f = e(t, h.children, i);
                if (-1 !== f) return h.children.splice(f, 1), s.push(h), this._condense(s), this;
            }
            a || h.leaf || !m(h, o) ? r ? (n++, h = r.children[n], a = !1) : h = null : (s.push(h), l.push(n), n = 0, r = h, h = h.children[0]);
        }
        return this;
    }, r.prototype.toBBox = function(t) {
        return t;
    }, r.prototype.compareMinX = function(t, i) {
        return t.minX - i.minX;
    }, r.prototype.compareMinY = function(t, i) {
        return t.minY - i.minY;
    }, r.prototype.toJSON = function() {
        return this.data;
    }, r.prototype.fromJSON = function(t) {
        return this.data = t, this;
    }, r.prototype._all = function(t, i) {
        for(var n = []; t;)t.leaf ? i.push.apply(i, t.children) : n.push.apply(n, t.children), t = n.pop();
        return i;
    }, r.prototype._build = function(t, i, n, r) {
        var e, h = n - i + 1, o = this._maxEntries;
        if (h <= o) return a(e = p(t.slice(i, n + 1)), this.toBBox), e;
        r || (r = Math.ceil(Math.log(h) / Math.log(o)), o = Math.ceil(h / Math.pow(o, r - 1))), (e = p([])).leaf = !1, e.height = r;
        var s = Math.ceil(h / o), l = s * Math.ceil(Math.sqrt(o));
        d(t, i, n, l, this.compareMinX);
        for(var f = i; f <= n; f += l){
            var u = Math.min(f + l - 1, n);
            d(t, f, u, s, this.compareMinY);
            for(var m = f; m <= u; m += s){
                var c = Math.min(m + s - 1, u);
                e.children.push(this._build(t, m, c, r - 1));
            }
        }
        return a(e, this.toBBox), e;
    }, r.prototype._chooseSubtree = function(t, i, n, r) {
        for(; r.push(i), !i.leaf && r.length - 1 !== n;){
            for(var e = 1 / 0, a = 1 / 0, h = void 0, o = 0; o < i.children.length; o++){
                var s = i.children[o], l = f(s), u = (m = t, c = s, (Math.max(c.maxX, m.maxX) - Math.min(c.minX, m.minX)) * (Math.max(c.maxY, m.maxY) - Math.min(c.minY, m.minY)) - l);
                u < a ? (a = u, e = l < e ? l : e, h = s) : u === a && l < e && (e = l, h = s);
            }
            i = h || i.children[0];
        }
        var m, c;
        return i;
    }, r.prototype._insert = function(t, i, n) {
        var r = n ? t : this.toBBox(t), e = [], a = this._chooseSubtree(r, this.data, i, e);
        for(a.children.push(t), o(a, r); i >= 0 && e[i].children.length > this._maxEntries;)this._split(e, i), i--;
        this._adjustParentBBoxes(r, e, i);
    }, r.prototype._split = function(t, i) {
        var n = t[i], r = n.children.length, e = this._minEntries;
        this._chooseSplitAxis(n, e, r);
        var h = this._chooseSplitIndex(n, e, r), o = p(n.children.splice(h, n.children.length - h));
        o.height = n.height, o.leaf = n.leaf, a(n, this.toBBox), a(o, this.toBBox), i ? t[i - 1].children.push(o) : this._splitRoot(n, o);
    }, r.prototype._splitRoot = function(t, i) {
        this.data = p([
            t,
            i
        ]), this.data.height = t.height + 1, this.data.leaf = !1, a(this.data, this.toBBox);
    }, r.prototype._chooseSplitIndex = function(t, i, n) {
        for(var r, e, a, o, s, l, u, m = 1 / 0, c = 1 / 0, p = i; p <= n - i; p++){
            var d = h(t, 0, p, this.toBBox), x = h(t, p, n, this.toBBox), v = (e = d, a = x, o = void 0, s = void 0, l = void 0, u = void 0, o = Math.max(e.minX, a.minX), s = Math.max(e.minY, a.minY), l = Math.min(e.maxX, a.maxX), u = Math.min(e.maxY, a.maxY), Math.max(0, l - o) * Math.max(0, u - s)), M = f(d) + f(x);
            v < m ? (m = v, r = p, c = M < c ? M : c) : v === m && M < c && (c = M, r = p);
        }
        return r || n - i;
    }, r.prototype._chooseSplitAxis = function(t, i, n) {
        var r = t.leaf ? this.compareMinX : s, e = t.leaf ? this.compareMinY : l;
        this._allDistMargin(t, i, n, r) < this._allDistMargin(t, i, n, e) && t.children.sort(r);
    }, r.prototype._allDistMargin = function(t, i, n, r) {
        t.children.sort(r);
        for(var e = this.toBBox, a = h(t, 0, i, e), s = h(t, n - i, n, e), l = u(a) + u(s), f = i; f < n - i; f++){
            var m = t.children[f];
            o(a, t.leaf ? e(m) : m), l += u(a);
        }
        for(var c = n - i - 1; c >= i; c--){
            var p = t.children[c];
            o(s, t.leaf ? e(p) : p), l += u(s);
        }
        return l;
    }, r.prototype._adjustParentBBoxes = function(t, i, n) {
        for(var r = n; r >= 0; r--)o(i[r], t);
    }, r.prototype._condense = function(t) {
        for(var i = t.length - 1, n = void 0; i >= 0; i--)0 === t[i].children.length ? i > 0 ? (n = t[i - 1].children).splice(n.indexOf(t[i]), 1) : this.clear() : a(t[i], this.toBBox);
    }, r;
});

});

parcelRegister("c3RIb", function(module, exports) {

$parcel$export(module.exports, "toFunction", () => $8c7f6dda98e8cb9c$export$c314ea3f6b164147);
$parcel$export(module.exports, "createDefaultStyle", () => $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6);
$parcel$export(module.exports, "createEditingStyle", () => $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac);
$parcel$export(module.exports, "default", () => $8c7f6dda98e8cb9c$export$2e2bcd8739ae039);
/**
 * @module ol/style/Style
 */ 
var $wnhPR = parcelRequire("wnhPR");

var $inIMS = parcelRequire("inIMS");

var $lrKvI = parcelRequire("lrKvI");

var $4Cz58 = parcelRequire("4Cz58");
/**
 * Defines how symbols and text are decluttered on layers ith `declutter` set to `true`
 * * **declutter**: Overlapping symbols and text are decluttered.
 * * **obstacle**: Symbols and text are rendered, but serve as obstacle for subsequent attempts
 *   to place a symbol or text at the same location.
 * * **none**: No decluttering is done.
 *
 * @typedef {"declutter"|"obstacle"|"none"} DeclutterMode
 */ /**
 * A function that takes an {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes an {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>|Array<Array<Array<import("../coordinate.js").Coordinate>>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ class $8c7f6dda98e8cb9c$var$Style {
    /**
   * @param {Options} [options] Style options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|import("../geom/Geometry.js").default|GeometryFunction|null}
     */ this.geometry_ = null;
        /**
     * @private
     * @type {!GeometryFunction}
     */ this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {import("./Image.js").default|null}
     */ this.image_ = options.image !== undefined ? options.image : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("./Text.js").default|null}
     */ this.text_ = options.text !== undefined ? options.text : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.zIndex_ = options.zIndex;
    }
    /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */ clone() {
        let geometry = this.getGeometry();
        if (geometry && typeof geometry === "object") geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new $8c7f6dda98e8cb9c$var$Style({
            geometry: geometry ?? undefined,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer() ?? undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setRenderer(renderer) {
        this.renderer_ = renderer;
    }
    /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setHitDetectionRenderer(renderer) {
        this.hitDetectionRenderer_ = renderer;
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getHitDetectionRenderer() {
        return this.hitDetectionRenderer_;
    }
    /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */ getGeometry() {
        return this.geometry_;
    }
    /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */ getGeometryFunction() {
        return this.geometryFunction_;
    }
    /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */ getZIndex() {
        return this.zIndex_;
    }
    /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */ setGeometry(geometry) {
        if (typeof geometry === "function") this.geometryFunction_ = geometry;
        else if (typeof geometry === "string") this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    }
    /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */ setZIndex(zIndex) {
        this.zIndex_ = zIndex;
    }
}
function $8c7f6dda98e8cb9c$export$c314ea3f6b164147(obj) {
    let styleFunction;
    if (typeof obj === "function") styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ let styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $4Cz58.assert)(typeof /** @type {?} */ obj.getZIndex === "function", "Expected an `Style` or an array of `Style`");
            const style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ let $8c7f6dda98e8cb9c$var$defaultStyles = null;
function $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$8c7f6dda98e8cb9c$var$defaultStyles) {
        const fill = new (0, $inIMS.default)({
            color: "rgba(255,255,255,0.4)"
        });
        const stroke = new (0, $lrKvI.default)({
            color: "#3399CC",
            width: 1.25
        });
        $8c7f6dda98e8cb9c$var$defaultStyles = [
            new $8c7f6dda98e8cb9c$var$Style({
                image: new (0, $wnhPR.default)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $8c7f6dda98e8cb9c$var$defaultStyles;
}
function $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ const styles = {};
    const white = [
        255,
        255,
        255,
        1
    ];
    const blue = [
        0,
        153,
        255,
        1
    ];
    const width = 3;
    styles["Polygon"] = [
        new $8c7f6dda98e8cb9c$var$Style({
            fill: new (0, $inIMS.default)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles["MultiPolygon"] = styles["Polygon"];
    styles["LineString"] = [
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $lrKvI.default)({
                color: white,
                width: width + 2
            })
        }),
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $lrKvI.default)({
                color: blue,
                width: width
            })
        })
    ];
    styles["MultiLineString"] = styles["LineString"];
    styles["Circle"] = styles["Polygon"].concat(styles["LineString"]);
    styles["Point"] = [
        new $8c7f6dda98e8cb9c$var$Style({
            image: new (0, $wnhPR.default)({
                radius: width * 2,
                fill: new (0, $inIMS.default)({
                    color: blue
                }),
                stroke: new (0, $lrKvI.default)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles["MultiPoint"] = styles["Point"];
    styles["GeometryCollection"] = styles["Polygon"].concat(styles["LineString"], styles["Point"]);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $8c7f6dda98e8cb9c$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $8c7f6dda98e8cb9c$export$2e2bcd8739ae039 = $8c7f6dda98e8cb9c$var$Style;

});
parcelRegister("wnhPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $06150d8570b7481b$export$2e2bcd8739ae039);
/**
 * @module ol/style/Circle
 */ 
var $5ndKB = parcelRequire("5ndKB");
/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ class $06150d8570b7481b$var$CircleStyle extends (0, $5ndKB.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {
            radius: 5
        };
        super({
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
    }
    /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        const style = new $06150d8570b7481b$var$CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Set the circle radius.
   *
   * @param {number} radius Circle radius.
   * @api
   */ setRadius(radius) {
        this.radius_ = radius;
        this.render();
    }
}
var $06150d8570b7481b$export$2e2bcd8739ae039 = $06150d8570b7481b$var$CircleStyle;

});
parcelRegister("5ndKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e99c452138b2224$export$2e2bcd8739ae039);
/**
 * @module ol/style/RegularShape
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $jKhJx = parcelRequire("jKhJx");

var $4iSHH = parcelRequire("4iSHH");

var $jh19n = parcelRequire("jh19n");

var $DfnQm = parcelRequire("DfnQm");

var $ig1j9 = parcelRequire("ig1j9");
/**
 * Specify radius for regular polygons, or both radius and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} radius Radius of a regular polygon.
 * @property {number} [radius2] Second radius to make a star instead of a regular polygon.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's points facing up.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the shape in pixels.
 * Positive values will shift the shape right and up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius` and `radius2`.
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike|undefined} strokeStyle StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>|null} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when both `radius` and
 * `radius2` are provided.
 * @api
 */ class $3e99c452138b2224$var$RegularShape extends (0, $jKhJx.default) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super({
            opacity: 1,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */ this.canvases_;
        /**
     * @private
     * @type {HTMLCanvasElement|null}
     */ this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ this.radius_ = options.radius;
        /**
     * @private
     * @type {number|undefined}
     */ this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_;
        /**
     * @private
     * @type {RenderOptions}
     */ this.renderOptions_;
        this.imageState_ = this.fill_ && this.fill_.loading() ? (0, $aSvtr.default).LOADING : (0, $aSvtr.default).LOADED;
        if (this.imageState_ === (0, $aSvtr.default).LOADING) this.ready().then(()=>this.imageState_ = (0, $aSvtr.default).LOADED);
        this.render();
    }
    /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        const style = new $3e99c452138b2224$var$RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   */ getAnchor() {
        const size = this.size_;
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            size[0] / 2 - displacement[0] / scale[0],
            size[1] / 2 + displacement[1] / scale[1]
        ];
    }
    /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ getAngle() {
        return this.angle_;
    }
    /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
        this.render();
    }
    /**
   * @return {HTMLCanvasElement} Image element.
   */ getHitDetectionImage() {
        if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(this.renderOptions_);
        return this.hitDetectionCanvas_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement} Image or Canvas element.
   * @api
   */ getImage(pixelRatio) {
        let image = this.canvases_[pixelRatio];
        if (!image) {
            const renderOptions = this.renderOptions_;
            const context = (0, $DfnQm.createCanvasContext2D)(renderOptions.size * pixelRatio, renderOptions.size * pixelRatio);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            this.canvases_[pixelRatio] = image;
        }
        return image;
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return this.size_;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   */ getOrigin() {
        return this.origin_;
    }
    /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ getPoints() {
        return this.points_;
    }
    /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return this.radius_;
    }
    /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ getRadius2() {
        return this.radius2_;
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   */ getSize() {
        return this.size_;
    }
    /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
        this.render();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {}
    /**
   * Load not yet loaded URI.
   */ load() {}
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {}
    /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */ calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== "bevel" && lineJoin !== "miter") return strokeWidth;
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        let r1 = this.radius_;
        let r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            const tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        const points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        const alpha = 2 * Math.PI / points;
        const a = r2 * Math.sin(alpha);
        const b = Math.sqrt(r2 * r2 - a * a);
        const d = r1 - b;
        const e = Math.sqrt(a * a + d * d);
        const miterRatio = e / a;
        if (lineJoin === "miter" && miterRatio <= miterLimit) return miterRatio * strokeWidth;
        // Calculate the distance from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        const k = strokeWidth / 2 / miterRatio;
        const l = strokeWidth / 2 * (d / e);
        const maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        const bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === "bevel") return bevelAdd * 2;
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        const aa = r1 * Math.sin(alpha);
        const bb = Math.sqrt(r1 * r1 - aa * aa);
        const dd = r2 - bb;
        const ee = Math.sqrt(aa * aa + dd * dd);
        const innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            const innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    }
    /**
   * @return {RenderOptions}  The render options
   * @protected
   */ createRenderOptions() {
        let lineCap = (0, $ig1j9.defaultLineCap);
        let lineJoin = (0, $ig1j9.defaultLineJoin);
        let miterLimit = 0;
        let lineDash = null;
        let lineDashOffset = 0;
        let strokeStyle;
        let strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = (0, $jh19n.asColorLike)(this.stroke_.getColor() ?? (0, $ig1j9.defaultStrokeStyle));
            strokeWidth = this.stroke_.getWidth() ?? (0, $ig1j9.defaultLineWidth);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset() ?? 0;
            lineJoin = this.stroke_.getLineJoin() ?? (0, $ig1j9.defaultLineJoin);
            lineCap = this.stroke_.getLineCap() ?? (0, $ig1j9.defaultLineCap);
            miterLimit = this.stroke_.getMiterLimit() ?? (0, $ig1j9.defaultMiterLimit);
        }
        const add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        const maxRadius = Math.max(this.radius_, this.radius2_ || 0);
        const size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    }
    /**
   * @protected
   */ render() {
        this.renderOptions_ = this.createRenderOptions();
        const size = this.renderOptions_.size;
        this.canvases_ = {};
        this.hitDetectionCanvas_ = null;
        this.size_ = [
            size,
            size
        ];
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */ draw_(renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            let color = this.fill_.getColor();
            if (color === null) color = (0, $ig1j9.defaultFillStyle);
            context.fillStyle = (0, $jh19n.asColorLike)(color);
            context.fill();
        }
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement} Canvas containing the icon
   */ createHitDetectionCanvas_(renderOptions) {
        let context;
        if (this.fill_) {
            let color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            let opacity = 0;
            if (typeof color === "string") color = (0, $4iSHH.asArray)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                context = (0, $DfnQm.createCanvasContext2D)(renderOptions.size, renderOptions.size);
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        return context ? context.canvas : this.getImage(1);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context The context to draw in.
   */ createPath_(context) {
        let points = this.points_;
        const radius = this.radius_;
        if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
        else {
            const radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) points *= 2;
            const startAngle = this.angle_ - Math.PI / 2;
            const step = 2 * Math.PI / points;
            for(let i = 0; i < points; i++){
                const angle0 = startAngle + i * step;
                const radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The context.
   */ drawHitDetectionCanvas_(renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = (0, $ig1j9.defaultFillStyle);
        context.fill();
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    ready() {
        return this.fill_ ? this.fill_.ready() : Promise.resolve();
    }
}
var $3e99c452138b2224$export$2e2bcd8739ae039 = $3e99c452138b2224$var$RegularShape;

});
parcelRegister("jKhJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e60011aea38e6239$export$2e2bcd8739ae039);
/**
 * @module ol/style/Image
 */ 
var $9iPUS = parcelRequire("9iPUS");

var $hxhPO = parcelRequire("hxhPO");
/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {import('../style/Style.js').DeclutterMode} declutterMode Declutter mode: `declutter`, `obstacle`, `none`.
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ class $e60011aea38e6239$var$ImageStyle {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        /**
     * @private
     * @type {number}
     */ this.opacity_ = options.opacity;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $hxhPO.toSize)(options.scale);
        /**
     * @private
     * @type {Array<number>}
     */ this.displacement_ = options.displacement;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $e60011aea38e6239$var$ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */ getOpacity() {
        return this.opacity_;
    }
    /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */ getDisplacement() {
        return this.displacement_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */ getAnchor() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getImage(pixelRatio) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getHitDetectionImage() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return 1;
    }
    /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */ getOrigin() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */ getSize() {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */ setDisplacement(displacement) {
        this.displacement_ = displacement;
    }
    /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */ setOpacity(opacity) {
        this.opacity_ = opacity;
    }
    /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $hxhPO.toSize)(scale);
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        (0, $9iPUS.abstract)();
    }
    /**
   * Load not yet loaded URI.
   * @abstract
   */ load() {
        (0, $9iPUS.abstract)();
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        (0, $9iPUS.abstract)();
    }
    /**
   * @return {Promise<void>} `false` or Promise that resolves when the style is ready to use.
   */ ready() {
        return Promise.resolve();
    }
}
var $e60011aea38e6239$export$2e2bcd8739ae039 = $e60011aea38e6239$var$ImageStyle;

});

parcelRegister("jh19n", function(module, exports) {

$parcel$export(module.exports, "asColorLike", () => $e0807f400ec9a0a9$export$dc5b1400ac3a10a8);
/**
 * @module ol/colorlike
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $DfnQm = parcelRequire("DfnQm");

var $1epqj = parcelRequire("1epqj");

var $kTbud = parcelRequire("kTbud");

var $4iSHH = parcelRequire("4iSHH");
function $e0807f400ec9a0a9$export$dc5b1400ac3a10a8(color) {
    if (!color) return null;
    if (Array.isArray(color)) return (0, $4iSHH.toString)(color);
    if (typeof color === "object" && "src" in color) return $e0807f400ec9a0a9$var$asCanvasPattern(color);
    return color;
}
/**
 * @param {PatternDescriptor} pattern Pattern descriptor.
 * @return {CanvasPattern|null} Canvas pattern or null if the pattern referenced in the
 * PatternDescriptor was not found in the icon image cache.
 */ function $e0807f400ec9a0a9$var$asCanvasPattern(pattern) {
    if (!pattern.offset || !pattern.size) return (0, $kTbud.shared).getPattern(pattern.src, "anonymous", pattern.color);
    const cacheKey = pattern.src + ":" + pattern.offset;
    const canvasPattern = (0, $kTbud.shared).getPattern(cacheKey, undefined, pattern.color);
    if (canvasPattern) return canvasPattern;
    const iconImage = (0, $kTbud.shared).get(pattern.src, "anonymous", null);
    if (iconImage.getImageState() !== (0, $aSvtr.default).LOADED) return null;
    const patternCanvasContext = (0, $DfnQm.createCanvasContext2D)(pattern.size[0], pattern.size[1]);
    patternCanvasContext.drawImage(iconImage.getImage(1), pattern.offset[0], pattern.offset[1], pattern.size[0], pattern.size[1], 0, 0, pattern.size[0], pattern.size[1]);
    (0, $1epqj.get)(patternCanvasContext.canvas, cacheKey, undefined, (0, $aSvtr.default).LOADED, pattern.color, true);
    return (0, $kTbud.shared).getPattern(cacheKey, undefined, pattern.color);
}

});
parcelRegister("1epqj", function(module, exports) {

$parcel$export(module.exports, "get", () => $0e5ad1d3b638689e$export$3988ae62b71be9a3);
/**
 * @module ol/style/IconImage
 */ 
var $KD0eF = parcelRequire("KD0eF");

var $3xzSb = parcelRequire("3xzSb");

var $aSvtr = parcelRequire("aSvtr");

var $4iSHH = parcelRequire("4iSHH");

var $DfnQm = parcelRequire("DfnQm");

var $fySoz = parcelRequire("fySoz");

var $kTbud = parcelRequire("kTbud");
/**
 * @type {CanvasRenderingContext2D}
 */ let $0e5ad1d3b638689e$var$taintedTestContext = null;
class $0e5ad1d3b638689e$var$IconImage extends (0, $KD0eF.default) {
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null} image Image.
   * @param {string|undefined} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../ImageState.js").default|undefined} imageState Image state.
   * @param {import("../color.js").Color|string|null} color Color.
   */ constructor(image, src, crossOrigin, imageState, color){
        super();
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null}
     */ this.image_ = image;
        /**
     * @private
     * @type {string|null}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */ this.canvas_ = {};
        /**
     * @private
     * @type {import("../color.js").Color|string|null}
     */ this.color_ = color;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ this.imageState_ = imageState === undefined ? (0, $aSvtr.default).IDLE : imageState;
        /**
     * @private
     * @type {import("../size.js").Size|null}
     */ this.size_ = image && image.width && image.height ? [
            image.width,
            image.height
        ] : null;
        /**
     * @private
     * @type {string|undefined}
     */ this.src_ = src;
        /**
     * @private
     */ this.tainted_;
        /**
     * @private
     * @type {Promise<void>|null}
     */ this.ready_ = null;
    }
    /**
   * @private
   */ initializeImage_() {
        this.image_ = new Image();
        if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
    }
    /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ isTainted_() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $aSvtr.default).LOADED) {
            if (!$0e5ad1d3b638689e$var$taintedTestContext) $0e5ad1d3b638689e$var$taintedTestContext = (0, $DfnQm.createCanvasContext2D)(1, 1, undefined, {
                willReadFrequently: true
            });
            $0e5ad1d3b638689e$var$taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                $0e5ad1d3b638689e$var$taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch (e) {
                $0e5ad1d3b638689e$var$taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    }
    /**
   * @private
   */ dispatchChangeEvent_() {
        this.dispatchEvent((0, $3xzSb.default).CHANGE);
    }
    /**
   * @private
   */ handleImageError_() {
        this.imageState_ = (0, $aSvtr.default).ERROR;
        this.dispatchChangeEvent_();
    }
    /**
   * @private
   */ handleImageLoad_() {
        this.imageState_ = (0, $aSvtr.default).LOADED;
        this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.dispatchChangeEvent_();
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element or image bitmap.
   */ getImage(pixelRatio) {
        if (!this.image_) this.initializeImage_();
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */ getPixelRatio(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        if (!this.image_) this.initializeImage_();
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                const width = this.size_[0];
                const height = this.size_[1];
                const context = (0, $DfnQm.createCanvasContext2D)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */ getSize() {
        return this.size_;
    }
    /**
   * @return {string|undefined} Image src.
   */ getSrc() {
        return this.src_;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.imageState_ !== (0, $aSvtr.default).IDLE) return;
        if (!this.image_) this.initializeImage_();
        this.imageState_ = (0, $aSvtr.default).LOADING;
        try {
            if (this.src_ !== undefined) /** @type {HTMLImageElement} */ this.image_.src = this.src_;
        } catch (e) {
            this.handleImageError_();
        }
        if (this.image_ instanceof HTMLImageElement) (0, $fySoz.decodeFallback)(this.image_, this.src_).then((image)=>{
            this.image_ = image;
            this.handleImageLoad_();
        }).catch(this.handleImageError_.bind(this));
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */ replaceColor_(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, $aSvtr.default).LOADED) return;
        const image = this.image_;
        const canvas = document.createElement("canvas");
        canvas.width = Math.ceil(image.width * pixelRatio);
        canvas.height = Math.ceil(image.height * pixelRatio);
        const ctx = canvas.getContext("2d");
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(image, 0, 0);
        ctx.globalCompositeOperation = "multiply";
        ctx.fillStyle = (0, $4iSHH.asString)(this.color_);
        ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
        ctx.globalCompositeOperation = "destination-in";
        ctx.drawImage(image, 0, 0);
        this.canvas_[pixelRatio] = canvas;
    }
    /**
   * @return {Promise<void>} Promise that resolves when the image is loaded.
   */ ready() {
        if (!this.ready_) this.ready_ = new Promise((resolve)=>{
            if (this.imageState_ === (0, $aSvtr.default).LOADED || this.imageState_ === (0, $aSvtr.default).ERROR) resolve();
            else this.addEventListener((0, $3xzSb.default).CHANGE, function onChange() {
                if (this.imageState_ === (0, $aSvtr.default).LOADED || this.imageState_ === (0, $aSvtr.default).ERROR) {
                    this.removeEventListener((0, $3xzSb.default).CHANGE, onChange);
                    resolve();
                }
            });
        });
        return this.ready_;
    }
}
function $0e5ad1d3b638689e$export$3988ae62b71be9a3(image, cacheKey, crossOrigin, imageState, color, pattern) {
    let iconImage = cacheKey === undefined ? undefined : (0, $kTbud.shared).get(cacheKey, crossOrigin, color);
    if (!iconImage) {
        iconImage = new $0e5ad1d3b638689e$var$IconImage(image, image && "src" in image ? image.src || undefined : cacheKey, crossOrigin, imageState, color);
        (0, $kTbud.shared).set(cacheKey, crossOrigin, color, iconImage, pattern);
    }
    if (pattern && iconImage && !(0, $kTbud.shared).getPattern(cacheKey, crossOrigin, color)) (0, $kTbud.shared).set(cacheKey, crossOrigin, color, iconImage, pattern);
    return iconImage;
}
var $0e5ad1d3b638689e$export$2e2bcd8739ae039 = $0e5ad1d3b638689e$var$IconImage;

});
parcelRegister("kTbud", function(module, exports) {

$parcel$export(module.exports, "shared", () => $f351daabfe6e2d22$export$747ccdf771a87ab8);
/**
 * @module ol/style/IconImageCache
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $4iSHH = parcelRequire("4iSHH");

var $DfnQm = parcelRequire("DfnQm");
/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ class $f351daabfe6e2d22$var$IconImageCache {
    constructor(){
        /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */ this.cache_ = {};
        /**
     * @type {!Object<string, CanvasPattern>}
     * @private
     */ this.patternCache_ = {};
        /**
     * @type {number}
     * @private
     */ this.cacheSize_ = 0;
        /**
     * @type {number}
     * @private
     */ this.maxCacheSize_ = 32;
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.cache_ = {};
        this.patternCache_ = {};
        this.cacheSize_ = 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.cacheSize_ > this.maxCacheSize_;
    }
    /**
   * FIXME empty description for jsdoc
   */ expire() {
        if (this.canExpireCache()) {
            let i = 0;
            for(const key in this.cache_){
                const iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    delete this.patternCache_[key];
                    --this.cacheSize_;
                }
            }
        }
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */ get(src, crossOrigin, color) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.cache_ ? this.cache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {CanvasPattern} Icon image.
   */ getPattern(src, crossOrigin, color) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.patternCache_ ? this.patternCache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @param {import("./IconImage.js").default|null} iconImage Icon image.
   * @param {boolean} [pattern] Also cache a `'repeat'` pattern with this `iconImage`.
   */ set(src, crossOrigin, color, iconImage, pattern) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        const update = key in this.cache_;
        this.cache_[key] = iconImage;
        if (pattern) {
            if (iconImage.getImageState() === (0, $aSvtr.default).IDLE) iconImage.load();
            if (iconImage.getImageState() === (0, $aSvtr.default).LOADING) iconImage.ready().then(()=>{
                this.patternCache_[key] = (0, $DfnQm.getSharedCanvasContext2D)().createPattern(iconImage.getImage(1), "repeat");
            });
            else this.patternCache_[key] = (0, $DfnQm.getSharedCanvasContext2D)().createPattern(iconImage.getImage(1), "repeat");
        }
        if (!update) ++this.cacheSize_;
    }
    /**
   * Set the cache size of the icon cache. Default is `32`. Change this value when
   * your map uses more than 32 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */ setSize(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    }
}
function $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color) {
    const colorString = color ? (0, $4iSHH.asArray)(color) : "null";
    return crossOrigin + ":" + src + ":" + colorString;
}
var $f351daabfe6e2d22$export$2e2bcd8739ae039 = $f351daabfe6e2d22$var$IconImageCache;
const $f351daabfe6e2d22$export$747ccdf771a87ab8 = new $f351daabfe6e2d22$var$IconImageCache();

});



parcelRegister("ig1j9", function(module, exports) {

$parcel$export(module.exports, "defaultFont", () => $d4aabc5c971073f1$export$3847dfea4f8d4dfa);
$parcel$export(module.exports, "defaultFillStyle", () => $d4aabc5c971073f1$export$c495d52ee3fd74b2);
$parcel$export(module.exports, "defaultLineCap", () => $d4aabc5c971073f1$export$17bd0c38d6ae694e);
$parcel$export(module.exports, "defaultLineDash", () => $d4aabc5c971073f1$export$e21b4112fdc612fc);
$parcel$export(module.exports, "defaultLineDashOffset", () => $d4aabc5c971073f1$export$e06efc2409049f76);
$parcel$export(module.exports, "defaultLineJoin", () => $d4aabc5c971073f1$export$365eb9648cf19bd0);
$parcel$export(module.exports, "defaultMiterLimit", () => $d4aabc5c971073f1$export$80c1c01844597b7b);
$parcel$export(module.exports, "defaultStrokeStyle", () => $d4aabc5c971073f1$export$1eb2eaecacf2031e);
$parcel$export(module.exports, "defaultTextAlign", () => $d4aabc5c971073f1$export$94d53b95641b5766);
$parcel$export(module.exports, "defaultTextBaseline", () => $d4aabc5c971073f1$export$cf2279a1bff62eb);
$parcel$export(module.exports, "defaultPadding", () => $d4aabc5c971073f1$export$40a9eeef55665a40);
$parcel$export(module.exports, "defaultLineWidth", () => $d4aabc5c971073f1$export$79661f132c62010e);
$parcel$export(module.exports, "checkedFonts", () => $d4aabc5c971073f1$export$1d36981fcadac93b);
$parcel$export(module.exports, "registerFont", () => $d4aabc5c971073f1$export$a534074a28fa87ff);
$parcel$export(module.exports, "measureAndCacheTextWidth", () => $d4aabc5c971073f1$export$915c7ba51467308f);
$parcel$export(module.exports, "getTextDimensions", () => $d4aabc5c971073f1$export$7d7c13020df1e791);
$parcel$export(module.exports, "drawImageOrLabel", () => $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee);
/**
 * @module ol/render/canvas
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $8UoiJ = parcelRequire("8UoiJ");

var $gn0g3 = parcelRequire("gn0g3");

var $DfnQm = parcelRequire("DfnQm");

var $hGHcK = parcelRequire("hGHcK");
const $d4aabc5c971073f1$export$3847dfea4f8d4dfa = "10px sans-serif";
const $d4aabc5c971073f1$export$c495d52ee3fd74b2 = "#000";
const $d4aabc5c971073f1$export$17bd0c38d6ae694e = "round";
const $d4aabc5c971073f1$export$e21b4112fdc612fc = [];
const $d4aabc5c971073f1$export$e06efc2409049f76 = 0;
const $d4aabc5c971073f1$export$365eb9648cf19bd0 = "round";
const $d4aabc5c971073f1$export$80c1c01844597b7b = 10;
const $d4aabc5c971073f1$export$1eb2eaecacf2031e = "#000";
const $d4aabc5c971073f1$export$94d53b95641b5766 = "center";
const $d4aabc5c971073f1$export$cf2279a1bff62eb = "middle";
const $d4aabc5c971073f1$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
const $d4aabc5c971073f1$export$79661f132c62010e = 1;
const $d4aabc5c971073f1$export$1d36981fcadac93b = new (0, $fFFY7.default)();
/**
 * @type {CanvasRenderingContext2D}
 */ let $d4aabc5c971073f1$var$measureContext = null;
/**
 * @type {string}
 */ let $d4aabc5c971073f1$var$measureFont;
const $d4aabc5c971073f1$export$7fdcec604f0b1fa7 = {};
const $d4aabc5c971073f1$export$a534074a28fa87ff = function() {
    const retries = 100;
    const size = "32px ";
    const referenceFonts = [
        "monospace",
        "serif"
    ];
    const len = referenceFonts.length;
    const text = "wmytzilWMYTZIL@#/&?$%10\uF013";
    let interval, referenceWidth;
    /**
   * @param {string} fontStyle Css font-style
   * @param {string} fontWeight Css font-weight
   * @param {*} fontFamily Css font-family
   * @return {boolean} Font with style and weight is available
   */ function isAvailable(fontStyle, fontWeight, fontFamily) {
        let available = true;
        for(let i = 0; i < len; ++i){
            const referenceFont = referenceFonts[i];
            referenceWidth = $d4aabc5c971073f1$export$4ea92329b673abd1(fontStyle + " " + fontWeight + " " + size + referenceFont, text);
            if (fontFamily != referenceFont) {
                const width = $d4aabc5c971073f1$export$4ea92329b673abd1(fontStyle + " " + fontWeight + " " + size + fontFamily + "," + referenceFont, text);
                // If width and referenceWidth are the same, then the fallback was used
                // instead of the font we wanted, so the font is not available.
                available = available && width != referenceWidth;
            }
        }
        if (available) return true;
        return false;
    }
    function check() {
        let done = true;
        const fonts = $d4aabc5c971073f1$export$1d36981fcadac93b.getKeys();
        for(let i = 0, ii = fonts.length; i < ii; ++i){
            const font = fonts[i];
            if ($d4aabc5c971073f1$export$1d36981fcadac93b.get(font) < retries) {
                if (isAvailable.apply(this, font.split("\n"))) {
                    (0, $gn0g3.clear)($d4aabc5c971073f1$export$7fdcec604f0b1fa7);
                    // Make sure that loaded fonts are picked up by Safari
                    $d4aabc5c971073f1$var$measureContext = null;
                    $d4aabc5c971073f1$var$measureFont = undefined;
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, retries);
                } else {
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, $d4aabc5c971073f1$export$1d36981fcadac93b.get(font) + 1, true);
                    done = false;
                }
            }
        }
        if (done) {
            clearInterval(interval);
            interval = undefined;
        }
    }
    return function(fontSpec) {
        const font = (0, $hGHcK.getFontParameters)(fontSpec);
        if (!font) return;
        const families = font.families;
        for(let i = 0, ii = families.length; i < ii; ++i){
            const family = families[i];
            const key = font.style + "\n" + font.weight + "\n" + family;
            if ($d4aabc5c971073f1$export$1d36981fcadac93b.get(key) === undefined) {
                $d4aabc5c971073f1$export$1d36981fcadac93b.set(key, retries, true);
                if (!isAvailable(font.style, font.weight, family)) {
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(key, 0, true);
                    if (interval === undefined) interval = setInterval(check, 32);
                }
            }
        }
    };
}();
const $d4aabc5c971073f1$export$4feaf6852ff92513 = function() {
    /**
   * @type {HTMLDivElement}
   */ let measureElement;
    return function(fontSpec) {
        let height = $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $8UoiJ.WORKER_OFFSCREEN_CANVAS) {
                const font = (0, $hGHcK.getFontParameters)(fontSpec);
                const metrics = $d4aabc5c971073f1$var$measureText(fontSpec, "\u017Dg");
                const lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement("div");
                    measureElement.innerHTML = "M";
                    measureElement.style.minHeight = "0";
                    measureElement.style.maxHeight = "none";
                    measureElement.style.height = "auto";
                    measureElement.style.padding = "0";
                    measureElement.style.border = "none";
                    measureElement.style.position = "absolute";
                    measureElement.style.display = "block";
                    measureElement.style.left = "-99999px";
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $d4aabc5c971073f1$var$measureText(font, text) {
    if (!$d4aabc5c971073f1$var$measureContext) $d4aabc5c971073f1$var$measureContext = (0, $DfnQm.createCanvasContext2D)(1, 1);
    if (font != $d4aabc5c971073f1$var$measureFont) {
        $d4aabc5c971073f1$var$measureContext.font = font;
        $d4aabc5c971073f1$var$measureFont = $d4aabc5c971073f1$var$measureContext.font;
    }
    return $d4aabc5c971073f1$var$measureContext.measureText(text);
}
function $d4aabc5c971073f1$export$4ea92329b673abd1(font, text) {
    return $d4aabc5c971073f1$var$measureText(font, text).width;
}
function $d4aabc5c971073f1$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    const width = text.split("\n").reduce((prev, curr)=>Math.max(prev, $d4aabc5c971073f1$export$4ea92329b673abd1(font, curr)), 0);
    cache[text] = width;
    return width;
}
function $d4aabc5c971073f1$export$7d7c13020df1e791(baseStyle, chunks) {
    const widths = [];
    const heights = [];
    const lineWidths = [];
    let width = 0;
    let lineWidth = 0;
    let height = 0;
    let lineHeight = 0;
    for(let i = 0, ii = chunks.length; i <= ii; i += 2){
        const text = chunks[i];
        if (text === "\n" || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            lineHeight = 0;
            continue;
        }
        const font = chunks[i + 1] || baseStyle.font;
        const currentWidth = $d4aabc5c971073f1$export$4ea92329b673abd1(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        const currentHeight = $d4aabc5c971073f1$export$4feaf6852ff92513(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width: width,
        height: height,
        widths: widths,
        heights: heights,
        lineWidths: lineWidths
    };
}
function $d4aabc5c971073f1$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) {
        if (context.globalAlpha === undefined) context.globalAlpha = (context)=>context.globalAlpha *= opacity;
        else context.globalAlpha *= opacity;
    }
    if (transform) context.transform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $d4aabc5c971073f1$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D} context Context.
 */ function $d4aabc5c971073f1$var$executeLabelInstructions(label, context) {
    const contextInstructions = label.contextInstructions;
    for(let i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}

});
parcelRegister("hGHcK", function(module, exports) {

$parcel$export(module.exports, "CLASS_HIDDEN", () => $ce07df6d5d4656f1$export$981241db82723ce2);
$parcel$export(module.exports, "CLASS_SELECTABLE", () => $ce07df6d5d4656f1$export$99b49471b0394319);
$parcel$export(module.exports, "CLASS_UNSELECTABLE", () => $ce07df6d5d4656f1$export$1afde3d6e16a7b29);
$parcel$export(module.exports, "CLASS_CONTROL", () => $ce07df6d5d4656f1$export$4d4f8be70b656192);
$parcel$export(module.exports, "CLASS_COLLAPSED", () => $ce07df6d5d4656f1$export$e16017ac68d14492);
$parcel$export(module.exports, "getFontParameters", () => $ce07df6d5d4656f1$export$5abde8a6aec4a131);
/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ const $ce07df6d5d4656f1$export$981241db82723ce2 = "ol-hidden";
const $ce07df6d5d4656f1$export$99b49471b0394319 = "ol-selectable";
const $ce07df6d5d4656f1$export$1afde3d6e16a7b29 = "ol-unselectable";
const $ce07df6d5d4656f1$export$68eede0dd8c6c1da = "ol-unsupported";
const $ce07df6d5d4656f1$export$4d4f8be70b656192 = "ol-control";
const $ce07df6d5d4656f1$export$e16017ac68d14492 = "ol-collapsed";
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ const $ce07df6d5d4656f1$var$fontRegEx = new RegExp([
    "^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)",
    "(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?",
    "(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))",
    "(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))",
    "?\\s*([-,\\\"\\'\\sa-z]+?)\\s*$"
].join(""), "i");
/** @type {Array<'style'|'variant'|'weight'|'size'|'lineHeight'|'family'>} */ const $ce07df6d5d4656f1$var$fontRegExMatchIndex = [
    "style",
    "variant",
    "weight",
    "size",
    "lineHeight",
    "family"
];
const $ce07df6d5d4656f1$export$5abde8a6aec4a131 = function(fontSpec) {
    const match = fontSpec.match($ce07df6d5d4656f1$var$fontRegEx);
    if (!match) return null;
    const style = /** @type {FontParameters} */ {
        lineHeight: "normal",
        size: "1.2em",
        style: "normal",
        weight: "normal",
        variant: "normal"
    };
    for(let i = 0, ii = $ce07df6d5d4656f1$var$fontRegExMatchIndex.length; i < ii; ++i){
        const value = match[i + 1];
        if (value !== undefined) style[$ce07df6d5d4656f1$var$fontRegExMatchIndex[i]] = value;
    }
    style.families = style.family.split(/,\s?/);
    return style;
};

});




parcelRegister("inIMS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d61d1dcaf3c44610$export$2e2bcd8739ae039);
/**
 * @module ol/style/Fill
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $1epqj = parcelRequire("1epqj");
/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} [color=null] A color,
 * gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats. For polygon fills (not for {@link import("./RegularShape.js").default} fills),
 * a pattern can also be provided as {@link module:ol/colorlike~PatternDescriptor}.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ class $d61d1dcaf3c44610$var$Fill {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("./IconImage.js").default|null}
     */ this.patternImage_ = null;
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null}
     */ this.color_ = null;
        if (options.color !== undefined) this.setColor(options.color);
    }
    /**
   * Clones the style. The color is not cloned if it is an {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $d61d1dcaf3c44610$var$Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    }
    /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} color Color.
   * @api
   */ setColor(color) {
        if (color !== null && typeof color === "object" && "src" in color) {
            const patternImage = (0, $1epqj.get)(null, color.src, "anonymous", undefined, color.offset ? null : color.color ? color.color : null, !(color.offset && color.size));
            patternImage.ready().then(()=>{
                this.patternImage_ = null;
            });
            if (patternImage.getImageState() === (0, $aSvtr.default).IDLE) patternImage.load();
            if (patternImage.getImageState() === (0, $aSvtr.default).LOADING) this.patternImage_ = patternImage;
        }
        this.color_ = color;
    }
    /**
   * @return {boolean} The fill style is loading an image pattern.
   */ loading() {
        return !!this.patternImage_;
    }
    /**
   * @return {Promise<void>} `false` or a promise that resolves when the style is ready to use.
   */ ready() {
        return this.patternImage_ ? this.patternImage_.ready() : Promise.resolve();
    }
}
var $d61d1dcaf3c44610$export$2e2bcd8739ae039 = $d61d1dcaf3c44610$var$Fill;

});

parcelRegister("lrKvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9d0329c5c745263$export$2e2bcd8739ae039);
/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ class $f9d0329c5c745263$var$Stroke {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
     */ this.color_ = options.color !== undefined ? options.color : null;
        /**
     * @private
     * @type {CanvasLineCap|undefined}
     */ this.lineCap_ = options.lineCap;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lineDashOffset_ = options.lineDashOffset;
        /**
     * @private
     * @type {CanvasLineJoin|undefined}
     */ this.lineJoin_ = options.lineJoin;
        /**
     * @private
     * @type {number|undefined}
     */ this.miterLimit_ = options.miterLimit;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = options.width;
    }
    /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $f9d0329c5c745263$var$Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            width: this.getWidth()
        });
    }
    /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */ getLineCap() {
        return this.lineCap_;
    }
    /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */ getLineDash() {
        return this.lineDash_;
    }
    /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */ getLineDashOffset() {
        return this.lineDashOffset_;
    }
    /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */ getLineJoin() {
        return this.lineJoin_;
    }
    /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */ getMiterLimit() {
        return this.miterLimit_;
    }
    /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */ getWidth() {
        return this.width_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */ setColor(color) {
        this.color_ = color;
    }
    /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */ setLineCap(lineCap) {
        this.lineCap_ = lineCap;
    }
    /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */ setLineDash(lineDash) {
        this.lineDash_ = lineDash;
    }
    /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */ setLineDashOffset(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    }
    /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */ setLineJoin(lineJoin) {
        this.lineJoin_ = lineJoin;
    }
    /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */ setMiterLimit(miterLimit) {
        this.miterLimit_ = miterLimit;
    }
    /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */ setWidth(width) {
        this.width_ = width;
    }
}
var $f9d0329c5c745263$export$2e2bcd8739ae039 = $f9d0329c5c745263$var$Stroke;

});


parcelRegister("8f0Mc", function(module, exports) {

$parcel$export(module.exports, "rulesToStyleFunction", () => $6000539d86fde80c$export$fc6a94152b1b05a8);
$parcel$export(module.exports, "flatStylesToStyleFunction", () => $6000539d86fde80c$export$5a130bc4f0a0420b);
/**
 * @module ol/render/canvas/style
 */ 
var $wnhPR = parcelRequire("wnhPR");

var $inIMS = parcelRequire("inIMS");

var $bmHVE = parcelRequire("bmHVE");

var $5ndKB = parcelRequire("5ndKB");

var $lrKvI = parcelRequire("lrKvI");

var $c3RIb = parcelRequire("c3RIb");

var $cJntk = parcelRequire("cJntk");

var $aghSp = parcelRequire("aghSp");

var $ikW69 = parcelRequire("ikW69");

var $gn0g3 = parcelRequire("gn0g3");

var $hxhPO = parcelRequire("hxhPO");
/**
 * @fileoverview This module includes functions to build styles for the canvas renderer.  Building
 * is composed of two steps: parsing and compiling.  The parsing step takes an encoded expression
 * and returns an instance of one of the expression classes.  The compiling step takes the
 * expression instance and returns a function that can be evaluated to return a literal value.  The
 * evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {import("../../style/flat.js").FlatStyle} FlatStyle
 */ /**
 * @typedef {import("../../expr/expression.js").EncodedExpression} EncodedExpression
 */ /**
 * @typedef {import("../../expr/expression.js").ParsingContext} ParsingContext
 */ /**
 * @typedef {import("../../expr/expression.js").CallExpression} CallExpression
 */ /**
 * @typedef {import("../../expr/cpu.js").EvaluationContext} EvaluationContext
 */ /**
 * @typedef {import("../../expr/cpu.js").ExpressionEvaluator} ExpressionEvaluator
 */ /**
 * @param {EvaluationContext} context The evaluation context.
 * @return {boolean} Always true.
 */ function $6000539d86fde80c$var$always(context) {
    return true;
}
function $6000539d86fde80c$export$fc6a94152b1b05a8(rules) {
    const parsingContext = (0, $aghSp.newParsingContext)();
    const evaluator = $6000539d86fde80c$export$d6ae6a4799989976(rules, parsingContext);
    const evaluationContext = (0, $ikW69.newEvaluationContext)();
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        if (parsingContext.geometryType) evaluationContext.geometryType = (0, $aghSp.computeGeometryType)(feature.getGeometry());
        return evaluator(evaluationContext);
    };
}
function $6000539d86fde80c$export$5a130bc4f0a0420b(flatStyles) {
    const parsingContext = (0, $aghSp.newParsingContext)();
    const length = flatStyles.length;
    /**
   * @type {Array<StyleEvaluator>}
   */ const evaluators = new Array(length);
    for(let i = 0; i < length; ++i)evaluators[i] = $6000539d86fde80c$export$a6e5f510497b7388(flatStyles[i], parsingContext);
    const evaluationContext = (0, $ikW69.newEvaluationContext)();
    /**
   * @type {Array<Style>}
   */ const styles = new Array(length);
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        let nonNullCount = 0;
        for(let i = 0; i < length; ++i){
            const style = evaluators[i](evaluationContext);
            if (style) {
                styles[nonNullCount] = style;
                nonNullCount += 1;
            }
        }
        styles.length = nonNullCount;
        return styles;
    };
}
function $6000539d86fde80c$export$d6ae6a4799989976(rules, context) {
    const length = rules.length;
    /**
   * @type {Array<CompiledRule>}
   */ const compiledRules = new Array(length);
    for(let i = 0; i < length; ++i){
        const rule = rules[i];
        const filter = "filter" in rule ? (0, $ikW69.buildExpression)(rule.filter, (0, $aghSp.BooleanType), context) : $6000539d86fde80c$var$always;
        /**
     * @type {Array<StyleEvaluator>}
     */ let styles;
        if (Array.isArray(rule.style)) {
            const styleLength = rule.style.length;
            styles = new Array(styleLength);
            for(let j = 0; j < styleLength; ++j)styles[j] = $6000539d86fde80c$export$a6e5f510497b7388(rule.style[j], context);
        } else styles = [
            $6000539d86fde80c$export$a6e5f510497b7388(rule.style, context)
        ];
        compiledRules[i] = {
            filter: filter,
            styles: styles
        };
    }
    return function(context) {
        /**
     * @type {Array<Style>}
     */ const styles = [];
        let someMatched = false;
        for(let i = 0; i < length; ++i){
            const filterEvaluator = compiledRules[i].filter;
            if (!filterEvaluator(context)) continue;
            if (rules[i].else && someMatched) continue;
            someMatched = true;
            for (const styleEvaluator of compiledRules[i].styles){
                const style = styleEvaluator(context);
                if (!style) continue;
                styles.push(style);
            }
        }
        return styles;
    };
}
function $6000539d86fde80c$export$a6e5f510497b7388(flatStyle, context) {
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, "", context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, "", context);
    const evaluateText = $6000539d86fde80c$var$buildText(flatStyle, context);
    const evaluateImage = $6000539d86fde80c$var$buildImage(flatStyle, context);
    const evaluateZIndex = $6000539d86fde80c$var$numberEvaluator(flatStyle, "z-index", context);
    if (!evaluateFill && !evaluateStroke && !evaluateText && !evaluateImage && !(0, $gn0g3.isEmpty)(flatStyle)) // assume this is a user error
    // would be nice to check the properties and suggest "did you mean..."
    throw new Error("No fill, stroke, point, or text symbolizer properties in style: " + JSON.stringify(flatStyle));
    const style = new (0, $c3RIb.default)();
    return function(context) {
        let empty = true;
        if (evaluateFill) {
            const fill = evaluateFill(context);
            if (fill) empty = false;
            style.setFill(fill);
        }
        if (evaluateStroke) {
            const stroke = evaluateStroke(context);
            if (stroke) empty = false;
            style.setStroke(stroke);
        }
        if (evaluateText) {
            const text = evaluateText(context);
            if (text) empty = false;
            style.setText(text);
        }
        if (evaluateImage) {
            const image = evaluateImage(context);
            if (image) empty = false;
            style.setImage(image);
        }
        if (evaluateZIndex) style.setZIndex(evaluateZIndex(context));
        if (empty) return null;
        return style;
    };
}
/**
 * @typedef {function(EvaluationContext):Fill|null} FillEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {FillEvaluator?} A function that evaluates to a fill.
 */ function $6000539d86fde80c$var$buildFill(flatStyle, prefix, context) {
    let evaluateColor;
    if (prefix + "fill-pattern-src" in flatStyle) evaluateColor = $6000539d86fde80c$var$patternEvaluator(flatStyle, prefix + "fill-", context);
    else evaluateColor = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + "fill-color", context);
    if (!evaluateColor) return null;
    const fill = new (0, $inIMS.default)();
    return function(context) {
        const color = evaluateColor(context);
        if (color === "none") return null;
        fill.setColor(color);
        return fill;
    };
}
/**
 * @typedef {function(EvaluationContext):Stroke|null} StrokeEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {StrokeEvaluator?} A function the evaluates to a stroke.
 */ function $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context) {
    const evaluateWidth = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "stroke-width", context);
    const evaluateColor = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + "stroke-color", context);
    if (!evaluateWidth && !evaluateColor) return null;
    const evaluateLineCap = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "stroke-line-cap", context);
    const evaluateLineJoin = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "stroke-line-join", context);
    const evaluateLineDash = $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, prefix + "stroke-line-dash", context);
    const evaluateLineDashOffset = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "stroke-line-dash-offset", context);
    const evaluateMiterLimit = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "stroke-miter-limit", context);
    const stroke = new (0, $lrKvI.default)();
    return function(context) {
        if (evaluateColor) {
            const color = evaluateColor(context);
            if (color === "none") return null;
            stroke.setColor(color);
        }
        if (evaluateWidth) stroke.setWidth(evaluateWidth(context));
        if (evaluateLineCap) {
            const lineCap = evaluateLineCap(context);
            if (lineCap !== "butt" && lineCap !== "round" && lineCap !== "square") throw new Error("Expected butt, round, or square line cap");
            stroke.setLineCap(lineCap);
        }
        if (evaluateLineJoin) {
            const lineJoin = evaluateLineJoin(context);
            if (lineJoin !== "bevel" && lineJoin !== "round" && lineJoin !== "miter") throw new Error("Expected bevel, round, or miter line join");
            stroke.setLineJoin(lineJoin);
        }
        if (evaluateLineDash) stroke.setLineDash(evaluateLineDash(context));
        if (evaluateLineDashOffset) stroke.setLineDashOffset(evaluateLineDashOffset(context));
        if (evaluateMiterLimit) stroke.setMiterLimit(evaluateMiterLimit(context));
        return stroke;
    };
}
/**
 * @typedef {function(EvaluationContext):Text} TextEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {TextEvaluator?} A function that evaluates to a text symbolizer.
 */ function $6000539d86fde80c$var$buildText(flatStyle, context) {
    const prefix = "text-";
    // Currently, an Array<string> may be used for rich text support.  This doesn't
    // work with our expression syntax where arrays of strings are interpreted as
    // call expressions.  To support rich text, we could add a 'strings' operator
    // where all the following arguments would be string values.
    const evaluateValue = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "value", context);
    if (!evaluateValue) return null;
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateBackgroundFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix + "background-", context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateBackgroundStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix + "background-", context);
    const evaluateFont = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "font", context);
    const evaluateMaxAngle = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "max-angle", context);
    const evaluateOffsetX = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "offset-x", context);
    const evaluateOffsetY = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "offset-y", context);
    const evaluateOverflow = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "overflow", context);
    const evaluatePlacement = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "placement", context);
    const evaluateRepeat = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "repeat", context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateAlign = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "align", context);
    const evaluateJustify = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "justify", context);
    const evaluateBaseline = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "baseline", context);
    const evaluatePadding = $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, prefix + "padding", context);
    // The following properties are not currently settable
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const text = new (0, $cJntk.default)({
        declutterMode: declutterMode
    });
    return function(context) {
        text.setText(evaluateValue(context));
        if (evaluateFill) text.setFill(evaluateFill(context));
        if (evaluateBackgroundFill) text.setBackgroundFill(evaluateBackgroundFill(context));
        if (evaluateStroke) text.setStroke(evaluateStroke(context));
        if (evaluateBackgroundStroke) text.setBackgroundStroke(evaluateBackgroundStroke(context));
        if (evaluateFont) text.setFont(evaluateFont(context));
        if (evaluateMaxAngle) text.setMaxAngle(evaluateMaxAngle(context));
        if (evaluateOffsetX) text.setOffsetX(evaluateOffsetX(context));
        if (evaluateOffsetY) text.setOffsetY(evaluateOffsetY(context));
        if (evaluateOverflow) text.setOverflow(evaluateOverflow(context));
        if (evaluatePlacement) {
            const placement = evaluatePlacement(context);
            if (placement !== "point" && placement !== "line") throw new Error("Expected point or line for text-placement");
            text.setPlacement(placement);
        }
        if (evaluateRepeat) text.setRepeat(evaluateRepeat(context));
        if (evaluateScale) text.setScale(evaluateScale(context));
        if (evaluateRotateWithView) text.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateRotation) text.setRotation(evaluateRotation(context));
        if (evaluateAlign) {
            const textAlign = evaluateAlign(context);
            if (textAlign !== "left" && textAlign !== "center" && textAlign !== "right" && textAlign !== "end" && textAlign !== "start") throw new Error("Expected left, right, center, start, or end for text-align");
            text.setTextAlign(textAlign);
        }
        if (evaluateJustify) {
            const justify = evaluateJustify(context);
            if (justify !== "left" && justify !== "right" && justify !== "center") throw new Error("Expected left, right, or center for text-justify");
            text.setJustify(justify);
        }
        if (evaluateBaseline) {
            const textBaseline = evaluateBaseline(context);
            if (textBaseline !== "bottom" && textBaseline !== "top" && textBaseline !== "middle" && textBaseline !== "alphabetic" && textBaseline !== "hanging") throw new Error("Expected bottom, top, middle, alphabetic, or hanging for text-baseline");
            text.setTextBaseline(textBaseline);
        }
        if (evaluatePadding) text.setPadding(evaluatePadding(context));
        return text;
    };
}
/**
 * @typedef {function(EvaluationContext):import("../../style/Image.js").default} ImageEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator?} A function that evaluates to an image symbolizer.
 */ function $6000539d86fde80c$var$buildImage(flatStyle, context) {
    if ("icon-src" in flatStyle) return $6000539d86fde80c$var$buildIcon(flatStyle, context);
    if ("shape-points" in flatStyle) return $6000539d86fde80c$var$buildShape(flatStyle, context);
    if ("circle-radius" in flatStyle) return $6000539d86fde80c$var$buildCircle(flatStyle, context);
    return null;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an image symbolizer.
 */ function $6000539d86fde80c$var$buildIcon(flatStyle, context) {
    const prefix = "icon-";
    // required property
    const srcName = prefix + "src";
    const src = $6000539d86fde80c$var$requireString(flatStyle[srcName], srcName);
    // settable properties
    const evaluateAnchor = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "anchor", context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateOpacity = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "opacity", context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining symbolizer properties are not currently settable
    const anchorOrigin = $6000539d86fde80c$var$optionalIconOrigin(flatStyle, prefix + "anchor-origin");
    const anchorXUnits = $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, prefix + "anchor-x-units");
    const anchorYUnits = $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, prefix + "anchor-y-units");
    const color = $6000539d86fde80c$var$optionalColorLike(flatStyle, prefix + "color");
    const crossOrigin = $6000539d86fde80c$var$optionalString(flatStyle, prefix + "cross-origin");
    const offset = $6000539d86fde80c$var$optionalNumberArray(flatStyle, prefix + "offset");
    const offsetOrigin = $6000539d86fde80c$var$optionalIconOrigin(flatStyle, prefix + "offset-origin");
    const width = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "width");
    const height = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "height");
    const size = $6000539d86fde80c$var$optionalSize(flatStyle, prefix + "size");
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const icon = new (0, $bmHVE.default)({
        src: src,
        anchorOrigin: anchorOrigin,
        anchorXUnits: anchorXUnits,
        anchorYUnits: anchorYUnits,
        color: color,
        crossOrigin: crossOrigin,
        offset: offset,
        offsetOrigin: offsetOrigin,
        height: height,
        width: width,
        size: size,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateOpacity) icon.setOpacity(evaluateOpacity(context));
        if (evaluateDisplacement) icon.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) icon.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) icon.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) icon.setScale(evaluateScale(context));
        if (evaluateAnchor) icon.setAnchor(evaluateAnchor(context));
        return icon;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an icon symbolizer.
 */ function $6000539d86fde80c$var$buildShape(flatStyle, context) {
    const prefix = "shape-";
    // required property
    const pointsName = prefix + "points";
    const radiusName = prefix + "radius";
    const points = $6000539d86fde80c$var$requireNumber(flatStyle[pointsName], pointsName);
    const radius = $6000539d86fde80c$var$requireNumber(flatStyle[radiusName], radiusName);
    // settable properties
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining properties are not currently settable
    const radius2 = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "radius2");
    const angle = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "angle");
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const shape = new (0, $5ndKB.default)({
        points: points,
        radius: radius,
        radius2: radius2,
        angle: angle,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateFill) shape.setFill(evaluateFill(context));
        if (evaluateStroke) shape.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) shape.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) shape.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) shape.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) shape.setScale(evaluateScale(context));
        return shape;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to a circle symbolizer.
 */ function $6000539d86fde80c$var$buildCircle(flatStyle, context) {
    const prefix = "circle-";
    // settable properties
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateRadius = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "radius", context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining properties are not currently settable
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const circle = new (0, $wnhPR.default)({
        radius: 5,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) circle.setRadius(evaluateRadius(context));
        if (evaluateFill) circle.setFill(evaluateFill(context));
        if (evaluateStroke) circle.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) circle.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) circle.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) circle.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) circle.setScale(evaluateScale(context));
        return circle;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberEvaluator|undefined} The expression evaluator or undefined.
 */ function $6000539d86fde80c$var$numberEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return undefined;
    const evaluator = (0, $ikW69.buildExpression)(flatStyle[name], (0, $aghSp.NumberType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireNumber(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').StringEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$stringEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $ikW69.buildExpression)(flatStyle[name], (0, $aghSp.StringType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireString(evaluator(context), name);
    };
}
function $6000539d86fde80c$var$patternEvaluator(flatStyle, prefix, context) {
    const srcEvaluator = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "pattern-src", context);
    const offsetEvaluator = $6000539d86fde80c$var$sizeEvaluator(flatStyle, prefix + "pattern-offset", context);
    const patternSizeEvaluator = $6000539d86fde80c$var$sizeEvaluator(flatStyle, prefix + "pattern-size", context);
    const colorEvaluator = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + "color", context);
    return function(context) {
        return {
            src: srcEvaluator(context),
            offset: offsetEvaluator && offsetEvaluator(context),
            size: patternSizeEvaluator && patternSizeEvaluator(context),
            color: colorEvaluator && colorEvaluator(context)
        };
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').BooleanEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$booleanEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $ikW69.buildExpression)(flatStyle[name], (0, $aghSp.BooleanType), context);
    return function(context) {
        const value = evaluator(context);
        if (typeof value !== "boolean") throw new Error(`Expected a boolean for ${name}`);
        return value;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').ColorLikeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $ikW69.buildExpression)(flatStyle[name], (0, $aghSp.ColorType) | (0, $aghSp.StringType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireColorLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberArrayEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $ikW69.buildExpression)(flatStyle[name], (0, $aghSp.NumberArrayType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireNumberArray(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').CoordinateEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$coordinateEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $ikW69.buildExpression)(flatStyle[name], (0, $aghSp.NumberArrayType), context);
    return function(context) {
        const array = $6000539d86fde80c$var$requireNumberArray(evaluator(context), name);
        if (array.length !== 2) throw new Error(`Expected two numbers for ${name}`);
        return array;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$sizeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $ikW69.buildExpression)(flatStyle[name], (0, $aghSp.NumberArrayType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireSize(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeLikeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $ikW69.buildExpression)(flatStyle[name], (0, $aghSp.NumberArrayType) | (0, $aghSp.NumberType), context);
    return function(context) {
        return $6000539d86fde80c$var$requireSizeLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {number|undefined} A number or undefined.
 */ function $6000539d86fde80c$var$optionalNumber(flatStyle, property) {
    const value = flatStyle[property];
    if (value === undefined) return undefined;
    if (typeof value !== "number") throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../size.js").Size|undefined} A size or undefined.
 */ function $6000539d86fde80c$var$optionalSize(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded === "number") return (0, $hxhPO.toSize)(encoded);
    if (!Array.isArray(encoded)) throw new Error(`Expected a number or size array for ${property}`);
    if (encoded.length !== 2 || typeof encoded[0] !== "number" || typeof encoded[1] !== "number") throw new Error(`Expected a number or size array for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|undefined} A string or undefined.
 */ function $6000539d86fde80c$var$optionalString(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== "string") throw new Error(`Expected a string for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconOrigin|undefined} An icon origin or undefined.
 */ function $6000539d86fde80c$var$optionalIconOrigin(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== "bottom-left" && encoded !== "bottom-right" && encoded !== "top-left" && encoded !== "top-right") throw new Error(`Expected bottom-left, bottom-right, top-left, or top-right for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconAnchorUnits|undefined} Icon anchor units or undefined.
 */ function $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== "pixels" && encoded !== "fraction") throw new Error(`Expected pixels or fraction for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {Array<number>|undefined} An array of numbers or undefined.
 */ function $6000539d86fde80c$var$optionalNumberArray(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $6000539d86fde80c$var$requireNumberArray(encoded, property);
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import('../../style/Style.js').DeclutterMode} Icon declutter mode.
 */ function $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== "string") throw new Error(`Expected a string for ${property}`);
    if (encoded !== "declutter" && encoded !== "obstacle" && encoded !== "none") throw new Error(`Expected declutter, obstacle, or none for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|Array<number>|undefined} A string or an array of color values or undefined.
 */ function $6000539d86fde80c$var$optionalColorLike(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $6000539d86fde80c$var$requireColorLike(encoded, property);
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} An array of numbers.
 */ function $6000539d86fde80c$var$requireNumberArray(value, property) {
    if (!Array.isArray(value)) throw new Error(`Expected an array for ${property}`);
    const length = value.length;
    for(let i = 0; i < length; ++i){
        if (typeof value[i] !== "number") throw new Error(`Expected an array of numbers for ${property}`);
    }
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {string} A string.
 */ function $6000539d86fde80c$var$requireString(value, property) {
    if (typeof value !== "string") throw new Error(`Expected a string for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number} A number.
 */ function $6000539d86fde80c$var$requireNumber(value, property) {
    if (typeof value !== "number") throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>|string} A color.
 */ function $6000539d86fde80c$var$requireColorLike(value, property) {
    if (typeof value === "string") return value;
    const array = $6000539d86fde80c$var$requireNumberArray(value, property);
    const length = array.length;
    if (length < 3 || length > 4) throw new Error(`Expected a color with 3 or 4 values for ${property}`);
    return array;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} A number or an array of two numbers.
 */ function $6000539d86fde80c$var$requireSize(value, property) {
    const size = $6000539d86fde80c$var$requireNumberArray(value, property);
    if (size.length !== 2) throw new Error(`Expected an array of two numbers for ${property}`);
    return size;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number|Array<number>} A number or an array of two numbers.
 */ function $6000539d86fde80c$var$requireSizeLike(value, property) {
    if (typeof value === "number") return value;
    return $6000539d86fde80c$var$requireSize(value, property);
}

});
parcelRegister("bmHVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8463d325b53eeb0c$export$2e2bcd8739ae039);
/**
 * @module ol/style/Icon
 */ 
var $3xzSb = parcelRequire("3xzSb");

var $aSvtr = parcelRequire("aSvtr");

var $jKhJx = parcelRequire("jKhJx");

var $4iSHH = parcelRequire("4iSHH");

var $4Cz58 = parcelRequire("4Cz58");

var $1epqj = parcelRequire("1epqj");

var $9iPUS = parcelRequire("9iPUS");
/**
 * @typedef {'fraction' | 'pixels'} IconAnchorUnits
 * Anchor unit can be either a fraction of the icon size or in pixels.
 */ /**
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} IconOrigin
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 */ /**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {IconOrigin} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {IconAnchorUnits} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {IconAnchorUnits} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement|ImageBitmap} [img] Image object for the icon.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the icon in pixels.
 * Positive values will shift the icon right and up.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [width] The width of the icon in pixels. This can't be used together with `scale`.
 * @property {number} [height] The height of the icon in pixels. This can't be used together with `scale`.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {Array<number>} [offset=[0, 0]] Offset which, together with `size` and `offsetOrigin`, defines the
 * sub-rectangle to use from the original (sprite) image.
 * @property {IconOrigin} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("../size.js").Size} [size] Icon size in pixels. Used together with `offset` to define the
 * sub-rectangle to use from the original (sprite) image.
 * @property {string} [src] Image source URI.
 * @property {import("./Style.js").DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @param {number} width The width.
 * @param {number} height The height.
 * @param {number|undefined} wantedWidth The wanted width.
 * @param {number|undefined} wantedHeight The wanted height.
 * @return {number|Array<number>} The scale.
 */ function $8463d325b53eeb0c$var$calculateScale(width, height, wantedWidth, wantedHeight) {
    if (wantedWidth !== undefined && wantedHeight !== undefined) return [
        wantedWidth / width,
        wantedHeight / height
    ];
    if (wantedWidth !== undefined) return wantedWidth / width;
    if (wantedHeight !== undefined) return wantedHeight / height;
    return 1;
}
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ class $8463d325b53eeb0c$var$Icon extends (0, $jKhJx.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @type {number}
     */ const opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ const rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number|import("../size.js").Size}
     */ const scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ const rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        super({
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {IconOrigin}
     */ this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : "top-left";
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : "fraction";
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : "fraction";
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        const image = options.img !== undefined ? options.img : null;
        let cacheKey = options.src;
        (0, $4Cz58.assert)(!(cacheKey !== undefined && image), "`image` and `src` cannot be provided at the same time");
        if ((cacheKey === undefined || cacheKey.length === 0) && image) cacheKey = /** @type {HTMLImageElement} */ image.src || (0, $9iPUS.getUid)(image);
        (0, $4Cz58.assert)(cacheKey !== undefined && cacheKey.length > 0, "A defined and non-empty `src` or `image` must be provided");
        (0, $4Cz58.assert)(!((options.width !== undefined || options.height !== undefined) && options.scale !== undefined), "`width` or `height` cannot be provided together with `scale`");
        let imageState;
        if (options.src !== undefined) imageState = (0, $aSvtr.default).IDLE;
        else if (image !== undefined) {
            if ("complete" in image) {
                if (image.complete) imageState = image.src ? (0, $aSvtr.default).LOADED : (0, $aSvtr.default).IDLE;
                else imageState = (0, $aSvtr.default).LOADING;
            } else imageState = (0, $aSvtr.default).LOADED;
        }
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = options.color !== undefined ? (0, $4iSHH.asArray)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ this.iconImage_ = (0, $1epqj.get)(image, /** @type {string} */ cacheKey, this.crossOrigin_, imageState, this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {IconOrigin}
     */ this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : "top-left";
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = options.size !== undefined ? options.size : null;
        /**
     * Calculate the scale if width or height were given.
     */ if (options.width !== undefined || options.height !== undefined) {
            let width, height;
            if (options.size) [width, height] = options.size;
            else {
                const image = this.getImage(1);
                if (image.width && image.height) {
                    width = image.width;
                    height = image.height;
                } else if (image instanceof HTMLImageElement) {
                    this.initialOptions_ = options;
                    const onload = ()=>{
                        this.unlistenImageChange(onload);
                        if (!this.initialOptions_) return;
                        const imageSize = this.iconImage_.getSize();
                        this.setScale($8463d325b53eeb0c$var$calculateScale(imageSize[0], imageSize[1], options.width, options.height));
                    };
                    this.listenImageChange(onload);
                    return;
                }
            }
            if (width !== undefined) this.setScale($8463d325b53eeb0c$var$calculateScale(width, height, options.width, options.height));
        }
    }
    /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   */ clone() {
        let scale, width, height;
        if (this.initialOptions_) {
            width = this.initialOptions_.width;
            height = this.initialOptions_.height;
        } else {
            scale = this.getScale();
            scale = Array.isArray(scale) ? scale.slice() : scale;
        }
        return new $8463d325b53eeb0c$var$Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            crossOrigin: this.crossOrigin_,
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            opacity: this.getOpacity(),
            rotateWithView: this.getRotateWithView(),
            rotation: this.getRotation(),
            scale: scale,
            width: width,
            height: height,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            src: this.getSrc(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   */ getAnchor() {
        let anchor = this.normalizedAnchor_;
        if (!anchor) {
            anchor = this.anchor_;
            const size = this.getSize();
            if (this.anchorXUnits_ == "fraction" || this.anchorYUnits_ == "fraction") {
                if (!size) return null;
                anchor = this.anchor_.slice();
                if (this.anchorXUnits_ == "fraction") anchor[0] *= size[0];
                if (this.anchorYUnits_ == "fraction") anchor[1] *= size[1];
            }
            if (this.anchorOrigin_ != "top-left") {
                if (!size) return null;
                if (anchor === this.anchor_) anchor = this.anchor_.slice();
                if (this.anchorOrigin_ == "top-right" || this.anchorOrigin_ == "bottom-right") anchor[0] = -anchor[0] + size[0];
                if (this.anchorOrigin_ == "bottom-left" || this.anchorOrigin_ == "bottom-right") anchor[1] = -anchor[1] + size[1];
            }
            this.normalizedAnchor_ = anchor;
        }
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            anchor[0] - displacement[0] / scale[0],
            anchor[1] + displacement[1] / scale[1]
        ];
    }
    /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ setAnchor(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    }
    /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   */ getImage(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    }
    /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   */ getPixelRatio(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    }
    /**
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return this.iconImage_.getSize();
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.iconImage_.getImageState();
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        return this.iconImage_.getHitDetectionImage();
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   */ getOrigin() {
        if (this.origin_) return this.origin_;
        let offset = this.offset_;
        if (this.offsetOrigin_ != "top-left") {
            const size = this.getSize();
            const iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == "top-right" || this.offsetOrigin_ == "bottom-right") offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == "bottom-left" || this.offsetOrigin_ == "bottom-right") offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    }
    /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ getSrc() {
        return this.iconImage_.getSrc();
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   */ getSize() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    }
    /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */ getWidth() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[0] * scale[0];
        if (this.iconImage_.getImageState() == (0, $aSvtr.default).LOADED) return this.iconImage_.getSize()[0] * scale[0];
        return undefined;
    }
    /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */ getHeight() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[1] * scale[1];
        if (this.iconImage_.getImageState() == (0, $aSvtr.default).LOADED) return this.iconImage_.getSize()[1] * scale[1];
        return undefined;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        delete this.initialOptions_;
        super.setScale(scale);
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        this.iconImage_.addEventListener((0, $3xzSb.default).CHANGE, listener);
    }
    /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   */ load() {
        this.iconImage_.load();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        this.iconImage_.removeEventListener((0, $3xzSb.default).CHANGE, listener);
    }
    ready() {
        return this.iconImage_.ready();
    }
}
var $8463d325b53eeb0c$export$2e2bcd8739ae039 = $8463d325b53eeb0c$var$Icon;

});

parcelRegister("cJntk", function(module, exports) {

$parcel$export(module.exports, "default", () => $944be50faeff5321$export$2e2bcd8739ae039);
/**
 * @module ol/style/Text
 */ 
var $inIMS = parcelRequire("inIMS");

var $hxhPO = parcelRequire("hxhPO");
/**
 * @typedef {'point' | 'line'} TextPlacement
 * Default text placement is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 */ /**
 * @typedef {'left' | 'center' | 'right'} TextJustify
 */ /**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ const $944be50faeff5321$var$DEFAULT_FILL_COLOR = "#333";
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS `font` value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is `'10px sans-serif'`
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {TextPlacement} [placement='point'] Text placement.
 * @property {number} [repeat] Repeat interval. When set, the text will be repeated at this interval, which specifies
 * the distance between two text anchors in pixels. Only available when `placement` is set to `'line'`. Overrides 'textAlign'.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for `placement: 'line'` or the immediate rendering API.
 * @property {CanvasTextAlign} [textAlign] Text alignment. Possible values: `'left'`, `'right'`, `'center'`, `'end'` or `'start'`.
 * Default is `'center'` for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {TextJustify} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {CanvasTextBaseline} [textBaseline='middle'] Text base line. Possible values: `'bottom'`, `'top'`, `'middle'`, `'alphabetic'`,
 * `'hanging'`, `'ideographic'`.
 * @property {import("./Fill.js").default|null} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333). Specify `null` for no fill.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 * @property {import('../style/Style.js').DeclutterMode} [declutterMode] Declutter mode: `declutter`, `obstacle`, `none`
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ class $944be50faeff5321$var$Text {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|undefined}
     */ this.font_ = options.font;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number|import("../size.js").Size|undefined}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $hxhPO.toSize)(options.scale !== undefined ? options.scale : 1);
        /**
     * @private
     * @type {string|Array<string>|undefined}
     */ this.text_ = options.text;
        /**
     * @private
     * @type {CanvasTextAlign|undefined}
     */ this.textAlign_ = options.textAlign;
        /**
     * @private
     * @type {TextJustify|undefined}
     */ this.justify_ = options.justify;
        /**
     * @private
     * @type {number|undefined}
     */ this.repeat_ = options.repeat;
        /**
     * @private
     * @type {CanvasTextBaseline|undefined}
     */ this.textBaseline_ = options.textBaseline;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : new (0, $inIMS.default)({
            color: $944be50faeff5321$var$DEFAULT_FILL_COLOR
        });
        /**
     * @private
     * @type {number}
     */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
     * @private
     * @type {TextPlacement}
     */ this.placement_ = options.placement !== undefined ? options.placement : "point";
        /**
     * @private
     * @type {boolean}
     */ this.overflow_ = !!options.overflow;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {number}
     */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
     * @private
     * @type {number}
     */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.padding_ = options.padding === undefined ? null : options.padding;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $944be50faeff5321$var$Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            repeat: this.getRepeat(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            justify: this.getJustify(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
            backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
            padding: this.getPadding() || undefined,
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */ getOverflow() {
        return this.overflow_;
    }
    /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */ getFont() {
        return this.font_;
    }
    /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */ getMaxAngle() {
        return this.maxAngle_;
    }
    /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */ getPlacement() {
        return this.placement_;
    }
    /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */ getRepeat() {
        return this.repeat_;
    }
    /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */ getOffsetX() {
        return this.offsetX_;
    }
    /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */ getOffsetY() {
        return this.offsetY_;
    }
    /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */ getTextAlign() {
        return this.textAlign_;
    }
    /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */ getJustify() {
        return this.justify_;
    }
    /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */ getTextBaseline() {
        return this.textBaseline_;
    }
    /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getBackgroundFill() {
        return this.backgroundFill_;
    }
    /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getBackgroundStroke() {
        return this.backgroundStroke_;
    }
    /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */ getPadding() {
        return this.padding_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */ setOverflow(overflow) {
        this.overflow_ = overflow;
    }
    /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */ setFont(font) {
        this.font_ = font;
    }
    /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */ setMaxAngle(maxAngle) {
        this.maxAngle_ = maxAngle;
    }
    /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */ setOffsetX(offsetX) {
        this.offsetX_ = offsetX;
    }
    /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */ setOffsetY(offsetY) {
        this.offsetY_ = offsetY;
    }
    /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */ setPlacement(placement) {
        this.placement_ = placement;
    }
    /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */ setRepeat(repeat) {
        this.repeat_ = repeat;
    }
    /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $hxhPO.toSize)(scale !== undefined ? scale : 1);
    }
    /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */ setTextAlign(textAlign) {
        this.textAlign_ = textAlign;
    }
    /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */ setJustify(justify) {
        this.justify_ = justify;
    }
    /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */ setTextBaseline(textBaseline) {
        this.textBaseline_ = textBaseline;
    }
    /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setBackgroundFill(fill) {
        this.backgroundFill_ = fill;
    }
    /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setBackgroundStroke(stroke) {
        this.backgroundStroke_ = stroke;
    }
    /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */ setPadding(padding) {
        this.padding_ = padding;
    }
}
var $944be50faeff5321$export$2e2bcd8739ae039 = $944be50faeff5321$var$Text;

});

parcelRegister("aghSp", function(module, exports) {

$parcel$export(module.exports, "BooleanType", () => $778943ec39690f8e$export$240f7fffab1b25a0);
$parcel$export(module.exports, "NumberType", () => $778943ec39690f8e$export$86a7aca748b1e260);
$parcel$export(module.exports, "StringType", () => $778943ec39690f8e$export$2b93044cbf134323);
$parcel$export(module.exports, "ColorType", () => $778943ec39690f8e$export$2cd82751acc0e609);
$parcel$export(module.exports, "NumberArrayType", () => $778943ec39690f8e$export$d701d0e49f4bcb39);
$parcel$export(module.exports, "typeName", () => $778943ec39690f8e$export$b2afc7c96b2b4a45);
$parcel$export(module.exports, "overlapsType", () => $778943ec39690f8e$export$3252d368d784c970);
$parcel$export(module.exports, "LiteralExpression", () => $778943ec39690f8e$export$eb63e96e0913dda4);
$parcel$export(module.exports, "newParsingContext", () => $778943ec39690f8e$export$1c8b4c1584800354);
$parcel$export(module.exports, "parse", () => $778943ec39690f8e$export$98e6a39c04603d36);
$parcel$export(module.exports, "Ops", () => $778943ec39690f8e$export$2655e45458bc48f3);
$parcel$export(module.exports, "computeGeometryType", () => $778943ec39690f8e$export$8da88d86d10c1295);
/**
 * @module ol/expr/expression
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $4iSHH = parcelRequire("4iSHH");
/**
 * @fileoverview This module includes types and functions for parsing array encoded expressions.
 * The result of parsing an encoded expression is one of the specific expression classes.
 * During parsing, information is added to the parsing context about the data accessed by the
 * expression.
 */ /**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link import("./expression.js").ExpressionValue} arguments.
 *
 * See below for details on the available operators (with notes for those that are WebGL or Canvas only).
 *
 * * Reading operators:
 *   * `['band', bandIndex, xOffset, yOffset]` For tile layers only. Fetches pixel values from band
 *     `bandIndex` of the source's data. The first `bandIndex` of the source data is `1`. Fetched values
 *     are in the 0..1 range. {@link import("../source/TileImage.js").default} sources have 4 bands: red,
 *     green, blue and alpha. {@link import("../source/DataTile.js").default} sources can have any number
 *     of bands, depending on the underlying data source and
 *     {@link import("../source/GeoTIFF.js").Options configuration}. `xOffset` and `yOffset` are optional
 *     and allow specifying pixel offsets for x and y. This is used for sampling data from neighboring pixels (WebGL only).
 *   * `['get', 'attributeName', typeHint]` fetches a feature property value, similar to `feature.get('attributeName')`
 *     A type hint can optionally be specified, in case the resulting expression contains a type ambiguity which
 *     will make it invalid. Type hints can be one of: 'string', 'color', 'number', 'boolean', 'number[]'
 *   * `['geometry-type']` returns a feature's geometry type as string, either: 'LineString', 'Point' or 'Polygon'
 *     `Multi*` values are returned as their singular equivalent
 *     `Circle` geometries are returned as 'Polygon'
 *     `GeometryCollection` geometries are returned as the type of the first geometry found in the collection (WebGL only).
 *   * `['resolution']` returns the current resolution
 *   * `['time']` The time in seconds since the creation of the layer (WebGL only).
 *   * `['var', 'varName']` fetches a value from the style variables; will throw an error if that variable is undefined
 *   * `['zoom']` The current zoom level (WebGL only).
 *
 * * Math operators:
 *   * `['*', value1, value2, ...]` multiplies the values (either numbers or colors)
 *   * `['/', value1, value2]` divides `value1` by `value2`
 *   * `['+', value1, value2, ...]` adds the values
 *   * `['-', value1, value2]` subtracts `value2` from `value1`
 *   * `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   * `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   * `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *   * `['abs', value1]` returns the absolute value of `value1`
 *   * `['floor', value1]` returns the nearest integer less than or equal to `value1`
 *   * `['round', value1]` returns the nearest integer to `value1`
 *   * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 *   * `['sin', value1]` returns the sine of `value1`
 *   * `['cos', value1]` returns the cosine of `value1`
 *   * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 *   * `['sqrt', value1]` returns the square root of `value1`
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *   * `['string', value1, value2, ...]` returns the first value in the list that evaluates to a string.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 'default value']]`
 *     (Canvas only).
 *   * `['number', value1, value2, ...]` returns the first value in the list that evaluates to a number.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 42]]`
 *     (Canvas only).
 *   * `['coalesce', value1, value2, ...]` returns the first value in the list which is not null or undefined.
 *     An example would be to provide a default value for get: `['coalesce', ['get','propertyname'], 'default value']]`
 *     (Canvas only).
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *   * `['in', needle, haystack]` returns `true` if `needle` is found in `haystack`, and
 *     `false` otherwise.
 *     This operator has the following limitations:
 *     * `haystack` has to be an array of numbers or strings (searching for a substring in a string is not supported yet)
 *     * Only literal arrays are supported as `haystack` for now; this means that `haystack` cannot be the result of an
 *     expression. If `haystack` is an array of strings, use the `literal` operator to disambiguate from an expression:
 *     `['literal', ['abc', 'def', 'ghi']]`
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4 (WebGL only).
 *   * `['color', red, green, blue, alpha]` or `['color', shade, alpha]` creates a `color` value from `number` values;
 *     the `alpha` parameter is optional; if not specified, it will be set to 1 (WebGL only).
 *     Note: `red`, `green` and `blue` or `shade` components must be values between 0 and 255; `alpha` between 0 and 1.
 *   * `['palette', index, colors]` picks a `color` value from an array of colors using the given index; the `index`
 *     expression must evaluate to a number; the items in the `colors` array must be strings with hex colors
 *     (e.g. `'#86A136'`), colors using the rgba[a] functional notation (e.g. `'rgb(134, 161, 54)'` or `'rgba(134, 161, 54, 1)'`),
 *     named colors (e.g. `'red'`), or array literals with 3 ([r, g, b]) or 4 ([r, g, b, a]) values (with r, g, and b
 *     in the 0-255 range and a in the 0-1 range) (WebGL only).
 *   * `['to-string', value]` converts the input value to a string. If the input is a boolean, the result is "true" or "false".
 *     If the input is a number, it is converted to a string as specified by the "NumberToString" algorithm of the ECMAScript
 *     Language Specification. If the input is a color, it is converted to a string of the form "rgba(r,g,b,a)". (Canvas only)
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `number[]` (number arrays can only have a length of 2, 3 or 4)
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 * @api
 */ let $778943ec39690f8e$var$numTypes = 0;
const $778943ec39690f8e$export$267d7ad6fa96ffaf = 0;
const $778943ec39690f8e$export$240f7fffab1b25a0 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$86a7aca748b1e260 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$2b93044cbf134323 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$2cd82751acc0e609 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$d701d0e49f4bcb39 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$52725c8a6d4c61d1 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$ec4c9a150bae86cd = Math.pow(2, $778943ec39690f8e$var$numTypes) - 1;
const $778943ec39690f8e$var$typeNames = {
    [$778943ec39690f8e$export$240f7fffab1b25a0]: "boolean",
    [$778943ec39690f8e$export$86a7aca748b1e260]: "number",
    [$778943ec39690f8e$export$2b93044cbf134323]: "string",
    [$778943ec39690f8e$export$2cd82751acc0e609]: "color",
    [$778943ec39690f8e$export$d701d0e49f4bcb39]: "number[]",
    [$778943ec39690f8e$export$52725c8a6d4c61d1]: "size"
};
const $778943ec39690f8e$var$namedTypes = Object.keys($778943ec39690f8e$var$typeNames).map(Number).sort((0, $fVVyM.ascending));
function $778943ec39690f8e$export$b2afc7c96b2b4a45(type) {
    const names = [];
    for (const namedType of $778943ec39690f8e$var$namedTypes)if ($778943ec39690f8e$export$9fdcb8b441c4f2b4(type, namedType)) names.push($778943ec39690f8e$var$typeNames[namedType]);
    if (names.length === 0) return "untyped";
    if (names.length < 3) return names.join(" or ");
    return names.slice(0, -1).join(", ") + ", or " + names[names.length - 1];
}
function $778943ec39690f8e$export$9fdcb8b441c4f2b4(broad, specific) {
    return (broad & specific) === specific;
}
function $778943ec39690f8e$export$3252d368d784c970(oneType, otherType) {
    return !!(oneType & otherType);
}
function $778943ec39690f8e$export$26b9f946b448f23e(type, expected) {
    return type === expected;
}
class $778943ec39690f8e$export$eb63e96e0913dda4 {
    /**
   * @param {number} type The value type.
   * @param {LiteralValue} value The literal value.
   */ constructor(type, value){
        this.type = type;
        this.value = value;
    }
}
class $778943ec39690f8e$export$6f3d80189eb72cd4 {
    /**
   * @param {number} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */ constructor(type, operator, ...args){
        this.type = type;
        this.operator = operator;
        this.args = args;
    }
}
function $778943ec39690f8e$export$1c8b4c1584800354() {
    return {
        variables: new Set(),
        properties: new Set(),
        featureId: false,
        geometryType: false,
        style: {}
    };
}
/**
 * @param {string} typeHint Type hint
 * @return {number} Resulting value type (will be a single type)
 */ function $778943ec39690f8e$var$getTypeFromHint(typeHint) {
    switch(typeHint){
        case "string":
            return $778943ec39690f8e$export$2b93044cbf134323;
        case "color":
            return $778943ec39690f8e$export$2cd82751acc0e609;
        case "number":
            return $778943ec39690f8e$export$86a7aca748b1e260;
        case "boolean":
            return $778943ec39690f8e$export$240f7fffab1b25a0;
        case "number[]":
            return $778943ec39690f8e$export$d701d0e49f4bcb39;
        default:
            throw new Error(`Unrecognized type hint: ${typeHint}`);
    }
}
function $778943ec39690f8e$export$98e6a39c04603d36(encoded, context, typeHint) {
    switch(typeof encoded){
        case "boolean":
            return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$240f7fffab1b25a0, encoded);
        case "number":
            return new $778943ec39690f8e$export$eb63e96e0913dda4(typeHint === $778943ec39690f8e$export$52725c8a6d4c61d1 ? $778943ec39690f8e$export$52725c8a6d4c61d1 : $778943ec39690f8e$export$86a7aca748b1e260, encoded);
        case "string":
            {
                let type = $778943ec39690f8e$export$2b93044cbf134323;
                if ((0, $4iSHH.isStringColor)(encoded)) type |= $778943ec39690f8e$export$2cd82751acc0e609;
                // apply the given type hint only if it won't result in an empty type
                if (!$778943ec39690f8e$export$26b9f946b448f23e(type & typeHint, $778943ec39690f8e$export$267d7ad6fa96ffaf)) type &= typeHint;
                return new $778943ec39690f8e$export$eb63e96e0913dda4(type, encoded);
            }
        default:
    }
    if (!Array.isArray(encoded)) throw new Error("Expression must be an array or a primitive value");
    if (encoded.length === 0) throw new Error("Empty expression");
    if (typeof encoded[0] === "string") return $778943ec39690f8e$var$parseCallExpression(encoded, context, typeHint);
    for (const item of encoded){
        if (typeof item !== "number") throw new Error("Expected an array of numbers");
    }
    let type = $778943ec39690f8e$export$d701d0e49f4bcb39;
    if (encoded.length === 2) type |= $778943ec39690f8e$export$52725c8a6d4c61d1;
    else if (encoded.length === 3 || encoded.length === 4) type |= $778943ec39690f8e$export$2cd82751acc0e609;
    if (typeHint) type &= typeHint;
    return new $778943ec39690f8e$export$eb63e96e0913dda4(type, encoded);
}
const $778943ec39690f8e$export$2655e45458bc48f3 = {
    Get: "get",
    Var: "var",
    Concat: "concat",
    GeometryType: "geometry-type",
    Any: "any",
    All: "all",
    Not: "!",
    Resolution: "resolution",
    Zoom: "zoom",
    Time: "time",
    Equal: "==",
    NotEqual: "!=",
    GreaterThan: ">",
    GreaterThanOrEqualTo: ">=",
    LessThan: "<",
    LessThanOrEqualTo: "<=",
    Multiply: "*",
    Divide: "/",
    Add: "+",
    Subtract: "-",
    Clamp: "clamp",
    Mod: "%",
    Pow: "^",
    Abs: "abs",
    Floor: "floor",
    Ceil: "ceil",
    Round: "round",
    Sin: "sin",
    Cos: "cos",
    Atan: "atan",
    Sqrt: "sqrt",
    Match: "match",
    Between: "between",
    Interpolate: "interpolate",
    Coalesce: "coalesce",
    Case: "case",
    In: "in",
    Number: "number",
    String: "string",
    Array: "array",
    Color: "color",
    Id: "id",
    Band: "band",
    Palette: "palette",
    ToString: "to-string"
};
/**
 * @typedef {function(Array, ParsingContext, number):Expression} Parser
 * Third argument is a type hint
 */ /**
 * @type {Object<string, Parser>}
 */ const $778943ec39690f8e$var$parsers = {
    [$778943ec39690f8e$export$2655e45458bc48f3.Get]: $778943ec39690f8e$var$createParser(([_, typeHint])=>{
        if (typeHint !== undefined) return $778943ec39690f8e$var$getTypeFromHint(/** @type {string} */ /** @type {LiteralExpression} */ typeHint.value);
        return $778943ec39690f8e$export$ec4c9a150bae86cd;
    }, $778943ec39690f8e$var$withArgsCount(1, 2), $778943ec39690f8e$var$withGetArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Var]: $778943ec39690f8e$var$createParser(([firstArg])=>firstArg.type, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$withVarArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Id]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2b93044cbf134323, $778943ec39690f8e$var$withNoArgs, $778943ec39690f8e$var$usesFeatureId),
    [$778943ec39690f8e$export$2655e45458bc48f3.Concat]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2b93044cbf134323, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.GeometryType]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2b93044cbf134323, $778943ec39690f8e$var$withNoArgs, $778943ec39690f8e$var$usesGeometryType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Resolution]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Zoom]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Time]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Any]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.All]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Not]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Equal]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.NotEqual]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.GreaterThan]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.GreaterThanOrEqualTo]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.LessThan]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.LessThanOrEqualTo]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Multiply]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        let outputType = $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2cd82751acc0e609;
        for(let i = 0; i < parsedArgs.length; i++)outputType &= parsedArgs[i].type;
        return outputType;
    }, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2cd82751acc0e609), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Coalesce]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        let type = $778943ec39690f8e$export$ec4c9a150bae86cd;
        for(let i = 1; i < parsedArgs.length; i += 2)type &= parsedArgs[i].type;
        type &= parsedArgs[parsedArgs.length - 1].type;
        return type;
    }, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Divide]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Add]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Subtract]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Clamp]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(3, 3), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Mod]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Pow]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Abs]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Floor]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Ceil]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Round]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Sin]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Cos]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Atan]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Sqrt]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Match]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        let type = $778943ec39690f8e$export$ec4c9a150bae86cd;
        for(let i = 2; i < parsedArgs.length; i += 2)type &= parsedArgs[i].type;
        type &= parsedArgs[parsedArgs.length - 1].type;
        return type;
    }, $778943ec39690f8e$var$withArgsCount(4, Infinity), $778943ec39690f8e$var$withEvenArgs, $778943ec39690f8e$var$parseMatchArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Between]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(3, 3), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Interpolate]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        let type = $778943ec39690f8e$export$2cd82751acc0e609 | $778943ec39690f8e$export$86a7aca748b1e260;
        for(let i = 3; i < parsedArgs.length; i += 2)type &= parsedArgs[i].type;
        return type;
    }, $778943ec39690f8e$var$withArgsCount(6, Infinity), $778943ec39690f8e$var$withEvenArgs, $778943ec39690f8e$var$parseInterpolateArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Case]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        let type = $778943ec39690f8e$export$ec4c9a150bae86cd;
        for(let i = 1; i < parsedArgs.length; i += 2)type &= parsedArgs[i].type;
        type &= parsedArgs[parsedArgs.length - 1].type;
        return type;
    }, $778943ec39690f8e$var$withArgsCount(3, Infinity), $778943ec39690f8e$var$withOddArgs, $778943ec39690f8e$var$parseCaseArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.In]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseInArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Number]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.String]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2b93044cbf134323, $778943ec39690f8e$var$withArgsCount(1, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Array]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        return parsedArgs.length === 2 ? $778943ec39690f8e$export$d701d0e49f4bcb39 | $778943ec39690f8e$export$52725c8a6d4c61d1 : parsedArgs.length === 3 || parsedArgs.length === 4 ? $778943ec39690f8e$export$d701d0e49f4bcb39 | $778943ec39690f8e$export$2cd82751acc0e609 : $778943ec39690f8e$export$d701d0e49f4bcb39;
    }, $778943ec39690f8e$var$withArgsCount(1, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Color]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2cd82751acc0e609, $778943ec39690f8e$var$withArgsCount(1, 4), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Band]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 3), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Palette]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2cd82751acc0e609, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parsePaletteArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.ToString]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2b93044cbf134323, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0 | $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$2cd82751acc0e609))
};
/**
 * @typedef {function(Array<EncodedExpression>, ParsingContext, Array<Expression>, number?):Array<Expression>|void} ArgValidator
 * An argument validator applies various checks to an encoded expression arguments
 * Returns the parsed arguments if any.
 * Third argument is the array of parsed arguments from previous validators
 * Fourth argument is an optional type hint
 */ /**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withGetArgs(encoded, context) {
    const arg = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], context);
    if (!(arg instanceof $778943ec39690f8e$export$eb63e96e0913dda4)) throw new Error("Expected a literal argument for get operation");
    if (typeof arg.value !== "string") throw new Error("Expected a string argument for get operation");
    context.properties.add(arg.value);
    if (encoded.length === 3) {
        const hint = $778943ec39690f8e$export$98e6a39c04603d36(encoded[2], context);
        return [
            arg,
            hint
        ];
    }
    return [
        arg
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withVarArgs(encoded, context, parsedArgs, typeHint) {
    const varName = encoded[1];
    if (typeof varName !== "string") throw new Error("Expected a string argument for var operation");
    context.variables.add(varName);
    if (!("variables" in context.style) || context.style.variables[varName] === undefined) return [
        new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$ec4c9a150bae86cd, varName)
    ];
    const initialValue = context.style.variables[varName];
    const arg = /** @type {LiteralExpression} */ $778943ec39690f8e$export$98e6a39c04603d36(initialValue, context);
    arg.value = varName;
    if (typeHint && !$778943ec39690f8e$export$3252d368d784c970(typeHint, arg.type)) throw new Error(`The variable ${varName} has type ${$778943ec39690f8e$export$b2afc7c96b2b4a45(arg.type)} but the following type was expected: ${$778943ec39690f8e$export$b2afc7c96b2b4a45(typeHint)}`);
    return [
        arg
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$usesFeatureId(encoded, context) {
    context.featureId = true;
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$usesGeometryType(encoded, context) {
    context.geometryType = true;
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withNoArgs(encoded, context) {
    const operation = encoded[0];
    if (encoded.length !== 1) throw new Error(`Expected no arguments for ${operation} operation`);
    return [];
}
/**
 * @param {number} minArgs The minimum number of arguments.
 * @param {number} maxArgs The maximum number of arguments.
 * @return {ArgValidator} The argument validator
 */ function $778943ec39690f8e$var$withArgsCount(minArgs, maxArgs) {
    return function(encoded, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        if (minArgs === maxArgs) {
            if (argCount !== minArgs) {
                const plural = minArgs === 1 ? "" : "s";
                throw new Error(`Expected ${minArgs} argument${plural} for ${operation}, got ${argCount}`);
            }
        } else if (argCount < minArgs || argCount > maxArgs) {
            const range = maxArgs === Infinity ? `${minArgs} or more` : `${minArgs} to ${maxArgs}`;
            throw new Error(`Expected ${range} arguments for ${operation}, got ${argCount}`);
        }
    };
}
/**
 * @param {number} argType The argument type.
 * @return {ArgValidator} The argument validator
 */ function $778943ec39690f8e$var$parseArgsOfType(argType) {
    return function(encoded, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ const args = new Array(argCount);
        for(let i = 0; i < argCount; ++i){
            const expression = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], context);
            if (!$778943ec39690f8e$export$3252d368d784c970(argType, expression.type)) {
                const gotType = $778943ec39690f8e$export$b2afc7c96b2b4a45(argType);
                const expectedType = $778943ec39690f8e$export$b2afc7c96b2b4a45(expression.type);
                throw new Error(`Unexpected type for argument ${i} of ${operation} operation` + `, got ${gotType} but expected ${expectedType}`);
            }
            expression.type &= argType;
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$narrowArgsType(encoded, context, parsedArgs) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    // first pass to determine a narrowed down type
    let sameType = $778943ec39690f8e$export$ec4c9a150bae86cd;
    for(let i = 0; i < parsedArgs.length; ++i)sameType &= parsedArgs[i].type;
    if (sameType === $778943ec39690f8e$export$267d7ad6fa96ffaf) throw new Error(`No common type could be found for arguments of ${operation} operation`);
    // re-parse args
    const args = new Array(argCount);
    for(let i = 0; i < argCount; ++i)args[i] = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], context, sameType);
    return args;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withOddArgs(encoded, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 0) throw new Error(`An odd amount of arguments was expected for operation ${operation}, got ${JSON.stringify(argCount)} instead`);
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withEvenArgs(encoded, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 1) throw new Error(`An even amount of arguments was expected for operation ${operation}, got ${JSON.stringify(argCount)} instead`);
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$parseMatchArgs(encoded, context, parsedArgs, typeHint) {
    const argsCount = encoded.length - 1;
    const input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], context);
    let inputType = input.type;
    const fallback = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], context);
    let outputType = typeHint !== undefined ? typeHint & fallback.type : fallback.type;
    // first parse args to figure out possible types
    const args = new Array(argsCount - 2);
    for(let i = 0; i < argsCount - 2; i += 2){
        const match = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], context);
        const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], context);
        inputType &= match.type;
        outputType &= output.type;
        args[i] = match;
        args[i + 1] = output;
    }
    // check input and output types validity
    const expectedInputType = $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$240f7fffab1b25a0;
    if (!$778943ec39690f8e$export$3252d368d784c970(expectedInputType, inputType)) throw new Error(`Expected an input of type ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedInputType)} for the interpolate operation` + `, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(inputType)} instead`);
    inputType &= expectedInputType;
    if ($778943ec39690f8e$export$26b9f946b448f23e(outputType, $778943ec39690f8e$export$267d7ad6fa96ffaf)) throw new Error(`Could not find a common output type for the following match operation: ` + JSON.stringify(encoded));
    // parse again inputs and outputs with common type
    for(let i = 0; i < argsCount - 2; i += 2){
        const match = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], context, inputType);
        const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], context, outputType);
        args[i] = match;
        args[i + 1] = output;
    }
    return [
        $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], context, inputType),
        ...args,
        $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], context, outputType)
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$parseInterpolateArgs(encoded, context, parsedArgs, typeHint) {
    const interpolationType = encoded[1];
    let interpolation;
    switch(interpolationType[0]){
        case "linear":
            interpolation = 1;
            break;
        case "exponential":
            interpolation = interpolationType[1];
            if (typeof interpolation !== "number") throw new Error(`Expected a number base for exponential interpolation` + `, got ${JSON.stringify(interpolation)} instead`);
            break;
        default:
            interpolation = null;
    }
    if (!interpolation) throw new Error(`Invalid interpolation type: ${JSON.stringify(interpolationType)}`);
    interpolation = $778943ec39690f8e$export$98e6a39c04603d36(interpolation, context);
    // check input types
    let input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[2], context);
    if (!$778943ec39690f8e$export$3252d368d784c970($778943ec39690f8e$export$86a7aca748b1e260, input.type)) throw new Error(`Expected an input of type number for the interpolate operation` + `, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(input.type)} instead`);
    input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[2], context, $778943ec39690f8e$export$86a7aca748b1e260); // parse again with narrower output
    const args = new Array(encoded.length - 3);
    for(let i = 0; i < args.length; i += 2){
        let stop = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], context);
        if (!$778943ec39690f8e$export$3252d368d784c970($778943ec39690f8e$export$86a7aca748b1e260, stop.type)) throw new Error(`Expected all stop input values in the interpolate operation to be of type number` + `, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(stop.type)} at position ${i + 2} instead`);
        let output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 4], context);
        if (!$778943ec39690f8e$export$3252d368d784c970($778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2cd82751acc0e609, output.type)) throw new Error(`Expected all stop output values in the interpolate operation to be a number or color` + `, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(output.type)} at position ${i + 3} instead`);
        // parse again with narrower types
        stop = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], context, $778943ec39690f8e$export$86a7aca748b1e260);
        output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 4], context, $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2cd82751acc0e609);
        args[i] = stop;
        args[i + 1] = output;
    }
    return [
        interpolation,
        input,
        ...args
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$parseCaseArgs(encoded, context, parsedArgs, typeHint) {
    const fallback = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], context);
    let outputType = typeHint !== undefined ? typeHint & fallback.type : fallback.type;
    // first parse args to figure out possible types
    const args = new Array(encoded.length - 1);
    for(let i = 0; i < args.length - 1; i += 2){
        const condition = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], context);
        const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], context);
        if (!$778943ec39690f8e$export$3252d368d784c970($778943ec39690f8e$export$240f7fffab1b25a0, condition.type)) throw new Error(`Expected all conditions in the case operation to be of type boolean` + `, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(condition.type)} at position ${i} instead`);
        outputType &= output.type;
        args[i] = condition;
        args[i + 1] = output;
    }
    if ($778943ec39690f8e$export$26b9f946b448f23e(outputType, $778943ec39690f8e$export$267d7ad6fa96ffaf)) throw new Error(`Could not find a common output type for the following case operation: ` + JSON.stringify(encoded));
    // parse again args with common output type
    for(let i = 0; i < args.length - 1; i += 2)args[i + 1] = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], context, outputType);
    args[args.length - 1] = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], context, outputType);
    return args;
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$parseInArgs(encoded, context) {
    /** @type {Array<number|string>} */ let haystack = /** @type {any} */ encoded[2];
    if (!Array.isArray(haystack)) throw new Error(`The "in" operator was provided a literal value which was not an array as second argument.`);
    if (typeof haystack[0] === "string") {
        if (haystack[0] !== "literal") throw new Error(`For the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions.`);
        if (!Array.isArray(haystack[1])) throw new Error(`The "in" operator was provided a literal value which was not an array as second argument.`);
        haystack = haystack[1];
    }
    let needleType = $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$86a7aca748b1e260;
    const args = new Array(haystack.length);
    for(let i = 0; i < args.length; i++){
        const arg = $778943ec39690f8e$export$98e6a39c04603d36(haystack[i], context);
        needleType &= arg.type;
        args[i] = arg;
    }
    if ($778943ec39690f8e$export$26b9f946b448f23e(needleType, $778943ec39690f8e$export$267d7ad6fa96ffaf)) throw new Error(`Could not find a common type for the following in operation: ` + JSON.stringify(encoded));
    const needle = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], context, needleType);
    return [
        needle,
        ...args
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$parsePaletteArgs(encoded, context) {
    const index = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], context, $778943ec39690f8e$export$86a7aca748b1e260);
    if (index.type !== $778943ec39690f8e$export$86a7aca748b1e260) throw new Error(`The first argument of palette must be an number, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(index.type)} instead`);
    const colors = encoded[2];
    if (!Array.isArray(colors)) throw new Error("The second argument of palette must be an array");
    const parsedColors = new Array(colors.length);
    for(let i = 0; i < parsedColors.length; i++){
        const color = $778943ec39690f8e$export$98e6a39c04603d36(colors[i], context, $778943ec39690f8e$export$2cd82751acc0e609);
        if (!(color instanceof $778943ec39690f8e$export$eb63e96e0913dda4)) throw new Error(`The palette color at index ${i} must be a literal value`);
        if (!$778943ec39690f8e$export$3252d368d784c970(color.type, $778943ec39690f8e$export$2cd82751acc0e609)) throw new Error(`The palette color at index ${i} should be of type color, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(color.type)} instead`);
        parsedColors[i] = color;
    }
    return [
        index,
        ...parsedColors
    ];
}
/**
 * @param {number|function(Array<Expression>):number} returnType The return type of the operator; can be a fixed value or a callback taking the parsed
 * arguments
 * @param {Array<ArgValidator>} argValidators A chain of argument validators; the return value of the last validator
 * will be used as parsed arguments
 * @return {Parser} The parser.
 */ function $778943ec39690f8e$var$createParser(returnType, ...argValidators) {
    return function(encoded, context, typeHint) {
        const operator = encoded[0];
        let parsedArgs = [];
        for(let i = 0; i < argValidators.length; i++)parsedArgs = argValidators[i](encoded, context, parsedArgs, typeHint) || parsedArgs;
        let actualType = typeof returnType === "function" ? returnType(parsedArgs) : returnType;
        if (typeHint !== undefined) {
            if (!$778943ec39690f8e$export$3252d368d784c970(actualType, typeHint)) throw new Error(`The following expression was expected to return ${$778943ec39690f8e$export$b2afc7c96b2b4a45(typeHint)}, but returns ${$778943ec39690f8e$export$b2afc7c96b2b4a45(actualType)} instead: ${JSON.stringify(encoded)}`);
            actualType &= typeHint;
        }
        if (actualType === $778943ec39690f8e$export$267d7ad6fa96ffaf) throw new Error(`No matching type was found for the following expression: ${JSON.stringify(encoded)}`);
        return new $778943ec39690f8e$export$6f3d80189eb72cd4(actualType, operator, ...parsedArgs);
    };
}
/**
 * @param {Array} encoded The encoded expression.
 * @param {ParsingContext} context The parsing context.
 * @param {number} [typeHint] Optional type hint
 * @return {Expression} The parsed expression.
 */ function $778943ec39690f8e$var$parseCallExpression(encoded, context, typeHint) {
    const operator = encoded[0];
    const parser = $778943ec39690f8e$var$parsers[operator];
    if (!parser) throw new Error(`Unknown operator: ${operator}`);
    return parser(encoded, context, typeHint);
}
function $778943ec39690f8e$export$8da88d86d10c1295(geometry) {
    if (!geometry) return "";
    const type = geometry.getType();
    switch(type){
        case "Point":
        case "LineString":
        case "Polygon":
            return type;
        case "MultiPoint":
        case "MultiLineString":
        case "MultiPolygon":
            return /** @type {'Point'|'LineString'|'Polygon'} */ type.substring(5);
        case "Circle":
            return "Polygon";
        case "GeometryCollection":
            return $778943ec39690f8e$export$8da88d86d10c1295(/** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries()[0]);
        default:
            return "";
    }
}

});

parcelRegister("ikW69", function(module, exports) {

$parcel$export(module.exports, "newEvaluationContext", () => $d597295b1f166e98$export$c18f39f0e136c26);
$parcel$export(module.exports, "buildExpression", () => $d597295b1f166e98$export$b5f535122a9211f0);
/**
 * @module ol/expr/cpu
 */ 
var $aghSp = parcelRequire("aghSp");

var $4iSHH = parcelRequire("4iSHH");
function $d597295b1f166e98$export$c18f39f0e136c26() {
    return {
        variables: {},
        properties: {},
        resolution: NaN,
        featureId: null,
        geometryType: ""
    };
}
function $d597295b1f166e98$export$b5f535122a9211f0(encoded, type, context) {
    const expression = (0, $aghSp.parse)(encoded, context);
    if (!(0, $aghSp.overlapsType)(type, expression.type)) {
        const expected = (0, $aghSp.typeName)(type);
        const actual = (0, $aghSp.typeName)(expression.type);
        throw new Error(`Expected expression to be of type ${expected}, got ${actual}`);
    }
    return $d597295b1f166e98$var$compileExpression(expression, context);
}
/**
 * @param {import("./expression.js").Expression} expression The expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileExpression(expression, context) {
    if (expression instanceof (0, $aghSp.LiteralExpression)) {
        // convert colors to array if possible
        if (expression.type === (0, $aghSp.ColorType) && typeof expression.value === "string") {
            const colorValue = (0, $4iSHH.fromString)(expression.value);
            return function() {
                return colorValue;
            };
        }
        return function() {
            return expression.value;
        };
    }
    const operator = expression.operator;
    switch(operator){
        case (0, $aghSp.Ops).Number:
        case (0, $aghSp.Ops).String:
        case (0, $aghSp.Ops).Coalesce:
            return $d597295b1f166e98$var$compileAssertionExpression(expression, context);
        case (0, $aghSp.Ops).Get:
        case (0, $aghSp.Ops).Var:
            return $d597295b1f166e98$var$compileAccessorExpression(expression, context);
        case (0, $aghSp.Ops).Id:
            return (context)=>context.featureId;
        case (0, $aghSp.Ops).GeometryType:
            return (context)=>context.geometryType;
        case (0, $aghSp.Ops).Concat:
            {
                const args = expression.args.map((e)=>$d597295b1f166e98$var$compileExpression(e, context));
                return (context)=>"".concat(...args.map((arg)=>arg(context).toString()));
            }
        case (0, $aghSp.Ops).Resolution:
            return (context)=>context.resolution;
        case (0, $aghSp.Ops).Any:
        case (0, $aghSp.Ops).All:
        case (0, $aghSp.Ops).Between:
        case (0, $aghSp.Ops).In:
        case (0, $aghSp.Ops).Not:
            return $d597295b1f166e98$var$compileLogicalExpression(expression, context);
        case (0, $aghSp.Ops).Equal:
        case (0, $aghSp.Ops).NotEqual:
        case (0, $aghSp.Ops).LessThan:
        case (0, $aghSp.Ops).LessThanOrEqualTo:
        case (0, $aghSp.Ops).GreaterThan:
        case (0, $aghSp.Ops).GreaterThanOrEqualTo:
            return $d597295b1f166e98$var$compileComparisonExpression(expression, context);
        case (0, $aghSp.Ops).Multiply:
        case (0, $aghSp.Ops).Divide:
        case (0, $aghSp.Ops).Add:
        case (0, $aghSp.Ops).Subtract:
        case (0, $aghSp.Ops).Clamp:
        case (0, $aghSp.Ops).Mod:
        case (0, $aghSp.Ops).Pow:
        case (0, $aghSp.Ops).Abs:
        case (0, $aghSp.Ops).Floor:
        case (0, $aghSp.Ops).Ceil:
        case (0, $aghSp.Ops).Round:
        case (0, $aghSp.Ops).Sin:
        case (0, $aghSp.Ops).Cos:
        case (0, $aghSp.Ops).Atan:
        case (0, $aghSp.Ops).Sqrt:
            return $d597295b1f166e98$var$compileNumericExpression(expression, context);
        case (0, $aghSp.Ops).Case:
            return $d597295b1f166e98$var$compileCaseExpression(expression, context);
        case (0, $aghSp.Ops).Match:
            return $d597295b1f166e98$var$compileMatchExpression(expression, context);
        case (0, $aghSp.Ops).Interpolate:
            return $d597295b1f166e98$var$compileInterpolateExpression(expression, context);
        case (0, $aghSp.Ops).ToString:
            return $d597295b1f166e98$var$compileConvertExpression(expression, context);
        default:
            throw new Error(`Unsupported operator ${operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileAssertionExpression(expression, context) {
    const type = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(type){
        case (0, $aghSp.Ops).Coalesce:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value !== "undefined" && value !== null) return value;
                }
                throw new Error("Expected one of the values to be non-null");
            };
        case (0, $aghSp.Ops).Number:
        case (0, $aghSp.Ops).String:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value === type) return value;
                }
                throw new Error(`Expected one of the values to be a ${type}`);
            };
        default:
            throw new Error(`Unsupported assertion operator ${type}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileAccessorExpression(expression, context) {
    const nameExpression = /** @type {LiteralExpression} */ expression.args[0];
    const name = /** @type {string} */ nameExpression.value;
    switch(expression.operator){
        case (0, $aghSp.Ops).Get:
            return (context)=>context.properties[name];
        case (0, $aghSp.Ops).Var:
            return (context)=>context.variables[name];
        default:
            throw new Error(`Unsupported accessor operator ${expression.operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileComparisonExpression(expression, context) {
    const op = expression.operator;
    const left = $d597295b1f166e98$var$compileExpression(expression.args[0], context);
    const right = $d597295b1f166e98$var$compileExpression(expression.args[1], context);
    switch(op){
        case (0, $aghSp.Ops).Equal:
            return (context)=>left(context) === right(context);
        case (0, $aghSp.Ops).NotEqual:
            return (context)=>left(context) !== right(context);
        case (0, $aghSp.Ops).LessThan:
            return (context)=>left(context) < right(context);
        case (0, $aghSp.Ops).LessThanOrEqualTo:
            return (context)=>left(context) <= right(context);
        case (0, $aghSp.Ops).GreaterThan:
            return (context)=>left(context) > right(context);
        case (0, $aghSp.Ops).GreaterThanOrEqualTo:
            return (context)=>left(context) >= right(context);
        default:
            throw new Error(`Unsupported comparison operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileLogicalExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $aghSp.Ops).Any:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (args[i](context)) return true;
                }
                return false;
            };
        case (0, $aghSp.Ops).All:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (!args[i](context)) return false;
                }
                return true;
            };
        case (0, $aghSp.Ops).Between:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                const max = args[2](context);
                return value >= min && value <= max;
            };
        case (0, $aghSp.Ops).In:
            return (context)=>{
                const value = args[0](context);
                for(let i = 1; i < length; ++i){
                    if (value === args[i](context)) return true;
                }
                return false;
            };
        case (0, $aghSp.Ops).Not:
            return (context)=>!args[0](context);
        default:
            throw new Error(`Unsupported logical operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {NumberEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileNumericExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $aghSp.Ops).Multiply:
            return (context)=>{
                let value = 1;
                for(let i = 0; i < length; ++i)value *= args[i](context);
                return value;
            };
        case (0, $aghSp.Ops).Divide:
            return (context)=>args[0](context) / args[1](context);
        case (0, $aghSp.Ops).Add:
            return (context)=>{
                let value = 0;
                for(let i = 0; i < length; ++i)value += args[i](context);
                return value;
            };
        case (0, $aghSp.Ops).Subtract:
            return (context)=>args[0](context) - args[1](context);
        case (0, $aghSp.Ops).Clamp:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                if (value < min) return min;
                const max = args[2](context);
                if (value > max) return max;
                return value;
            };
        case (0, $aghSp.Ops).Mod:
            return (context)=>args[0](context) % args[1](context);
        case (0, $aghSp.Ops).Pow:
            return (context)=>Math.pow(args[0](context), args[1](context));
        case (0, $aghSp.Ops).Abs:
            return (context)=>Math.abs(args[0](context));
        case (0, $aghSp.Ops).Floor:
            return (context)=>Math.floor(args[0](context));
        case (0, $aghSp.Ops).Ceil:
            return (context)=>Math.ceil(args[0](context));
        case (0, $aghSp.Ops).Round:
            return (context)=>Math.round(args[0](context));
        case (0, $aghSp.Ops).Sin:
            return (context)=>Math.sin(args[0](context));
        case (0, $aghSp.Ops).Cos:
            return (context)=>Math.cos(args[0](context));
        case (0, $aghSp.Ops).Atan:
            if (length === 2) return (context)=>Math.atan2(args[0](context), args[1](context));
            return (context)=>Math.atan(args[0](context));
        case (0, $aghSp.Ops).Sqrt:
            return (context)=>Math.sqrt(args[0](context));
        default:
            throw new Error(`Unsupported numeric operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileCaseExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        for(let i = 0; i < length - 1; i += 2){
            const condition = args[i](context);
            if (condition) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileMatchExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const value = args[0](context);
        for(let i = 1; i < length; i += 2){
            if (value === args[i](context)) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileInterpolateExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const base = args[0](context);
        const value = args[1](context);
        let previousInput;
        let previousOutput;
        for(let i = 2; i < length; i += 2){
            const input = args[i](context);
            let output = args[i + 1](context);
            const isColor = Array.isArray(output);
            if (isColor) output = (0, $4iSHH.withAlpha)(output);
            if (input >= value) {
                if (i === 2) return output;
                if (isColor) return $d597295b1f166e98$var$interpolateColor(base, value, previousInput, previousOutput, input, output);
                return $d597295b1f166e98$var$interpolateNumber(base, value, previousInput, previousOutput, input, output);
            }
            previousInput = input;
            previousOutput = output;
        }
        return previousOutput;
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileConvertExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $aghSp.Ops).ToString:
            return (context)=>{
                const value = args[0](context);
                if (expression.args[0].type === (0, $aghSp.ColorType)) return (0, $4iSHH.toString)(value);
                return value.toString();
            };
        default:
            throw new Error(`Unsupported convert operator ${op}`);
    }
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {number} output1 The first output value.
 * @param {number} input2 The second input value.
 * @param {number} output2 The second output value.
 * @return {number} The interpolated value.
 */ function $d597295b1f166e98$var$interpolateNumber(base, value, input1, output1, input2, output2) {
    const delta = input2 - input1;
    if (delta === 0) return output1;
    const along = value - input1;
    const factor = base === 1 ? along / delta : (Math.pow(base, along) - 1) / (Math.pow(base, delta) - 1);
    return output1 + factor * (output2 - output1);
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {import('../color.js').Color} rgba1 The first output value.
 * @param {number} input2 The second input value.
 * @param {import('../color.js').Color} rgba2 The second output value.
 * @return {import('../color.js').Color} The interpolated color.
 */ function $d597295b1f166e98$var$interpolateColor(base, value, input1, rgba1, input2, rgba2) {
    const delta = input2 - input1;
    if (delta === 0) return rgba1;
    const lcha1 = (0, $4iSHH.rgbaToLcha)(rgba1);
    const lcha2 = (0, $4iSHH.rgbaToLcha)(rgba2);
    let deltaHue = lcha2[2] - lcha1[2];
    if (deltaHue > 180) deltaHue -= 360;
    else if (deltaHue < -180) deltaHue += 360;
    const lcha = [
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, lcha1[0], input2, lcha2[0]),
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, lcha1[1], input2, lcha2[1]),
        lcha1[2] + $d597295b1f166e98$var$interpolateNumber(base, value, input1, 0, input2, deltaHue),
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, rgba1[3], input2, rgba2[3])
    ];
    return (0, $4iSHH.normalize)((0, $4iSHH.lchaToRgba)(lcha));
}

});



parcelRegister("fp9DL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b370ab32454a96fd$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/Map
 */ 
var $4kyFN = parcelRequire("4kyFN");

var $6wUzV = parcelRequire("6wUzV");

var $9iPUS = parcelRequire("9iPUS");

var $jpXrt = parcelRequire("jpXrt");

var $9pD6L = parcelRequire("9pD6L");

var $kTbud = parcelRequire("kTbud");

var $79s7T = parcelRequire("79s7T");

var $2o3CH = parcelRequire("2o3CH");
/**
 * @template T
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 */ /**
 * @abstract
 */ class $b370ab32454a96fd$var$MapRenderer extends (0, $4kyFN.default) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super();
        /**
     * @private
     * @type {import("../Map.js").default}
     */ this.map_ = map;
    }
    /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        (0, $9iPUS.abstract)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */ calculateMatrices2D(frameState) {
        const viewState = frameState.viewState;
        const coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        const pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $jpXrt.compose)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $jpXrt.makeInverse)(pixelToCoordinateTransform, coordinateToPixelTransform);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        let result;
        const viewState = frameState.viewState;
        /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        const projection = viewState.projection;
        const translatedCoordinate = (0, $2o3CH.wrapX)(coordinate.slice(), projection);
        const offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            const projectionExtent = projection.getExtent();
            const worldWidth = (0, $9pD6L.getWidth)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        const layerStates = frameState.layerStatesArray;
        const numLayers = layerStates.length;
        const matches = /** @type {Array<HitMatch<T>>} */ [];
        const tmpCoord = [];
        for(let i = 0; i < offsets.length; i++)for(let j = numLayers - 1; j >= 0; --j){
            const layerState = layerStates[j];
            const layer = layerState.layer;
            if (layer.hasRenderer() && (0, $79s7T.inView)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                const layerRenderer = layer.getRenderer();
                const source = layer.getSource();
                if (layerRenderer && source) {
                    const coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    const callback = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        const order = 1 / matches.length;
        matches.forEach((m, i)=>m.distanceSq += i * order);
        matches.sort((a, b)=>a.distanceSq - b.distanceSq);
        matches.some((m)=>{
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        const hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $6wUzV.TRUE), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    }
    /**
   * @return {import("../Map.js").default} Map.
   */ getMap() {
        return this.map_;
    }
    /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        (0, $9iPUS.abstract)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */ scheduleExpireIconCache(frameState) {
        if ((0, $kTbud.shared).canExpireCache()) frameState.postRenderFunctions.push($b370ab32454a96fd$var$expireIconCache);
    }
}
/**
 * @param {import("../Map.js").default} map Map.
 * @param {import("../Map.js").FrameState} frameState Frame state.
 */ function $b370ab32454a96fd$var$expireIconCache(map, frameState) {
    (0, $kTbud.shared).expire();
}
var $b370ab32454a96fd$export$2e2bcd8739ae039 = $b370ab32454a96fd$var$MapRenderer;

});


parcelRegister("YSU3I", function(module, exports) {

$parcel$export(module.exports, "GroupEvent", () => $0b703156bb914e6f$export$2f5ff21d758d25a7);
$parcel$export(module.exports, "default", () => $0b703156bb914e6f$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Group
 */ 
var $7xdj9 = parcelRequire("7xdj9");

var $cD8Qe = parcelRequire("cD8Qe");

var $1TIYs = parcelRequire("1TIYs");

var $f18Q2 = parcelRequire("f18Q2");

var $3xzSb = parcelRequire("3xzSb");

var $jXCUw = parcelRequire("jXCUw");

var $4Cz58 = parcelRequire("4Cz58");

var $gn0g3 = parcelRequire("gn0g3");

var $9pD6L = parcelRequire("9pD6L");

var $9iPUS = parcelRequire("9iPUS");

var $ilM9F = parcelRequire("ilM9F");
class $0b703156bb914e6f$export$2f5ff21d758d25a7 extends (0, $f18Q2.default) {
    /**
   * @param {GroupEventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */ constructor(type, layer){
        super(type);
        /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */ this.layer = layer;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|Collection<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $0b703156bb914e6f$var$Property = {
    LAYERS: "layers"
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */ class $0b703156bb914e6f$var$LayerGroup extends (0, $7xdj9.default) {
    /**
   * @param {Options} [options] Layer options.
   */ constructor(options){
        options = options || {};
        const baseOptions = /** @type {Options} */ Object.assign({}, options);
        delete baseOptions.layers;
        let layers = options.layers;
        super(baseOptions);
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {GroupOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.listenerKeys_ = {};
        this.addChangeListener($0b703156bb914e6f$var$Property.LAYERS, this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $cD8Qe.default)(layers.slice(), {
                unique: true
            });
            else (0, $4Cz58.assert)(typeof /** @type {?} */ layers.getArray === "function", "Expected `layers` to be an array or a `Collection`");
        } else layers = new (0, $cD8Qe.default)(undefined, {
            unique: true
        });
        this.setLayers(layers);
    }
    /**
   * @private
   */ handleLayerChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleLayersChanged_() {
        this.layersListenerKeys_.forEach((0, $ilM9F.unlistenByKey));
        this.layersListenerKeys_.length = 0;
        const layers = this.getLayers();
        this.layersListenerKeys_.push((0, $ilM9F.listen)(layers, (0, $1TIYs.default).ADD, this.handleLayersAdd_, this), (0, $ilM9F.listen)(layers, (0, $1TIYs.default).REMOVE, this.handleLayersRemove_, this));
        for(const id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $ilM9F.unlistenByKey));
        (0, $gn0g3.clear)(this.listenerKeys_);
        const layersArray = layers.getArray();
        for(let i = 0, ii = layersArray.length; i < ii; i++){
            const layer = layersArray[i];
            this.registerLayerListeners_(layer);
            this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("addlayer", layer));
        }
        this.changed();
    }
    /**
   * @param {BaseLayer} layer The layer.
   */ registerLayerListeners_(layer) {
        const listenerKeys = [
            (0, $ilM9F.listen)(layer, (0, $jXCUw.default).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $ilM9F.listen)(layer, (0, $3xzSb.default).CHANGE, this.handleLayerChange_, this)
        ];
        if (layer instanceof $0b703156bb914e6f$var$LayerGroup) listenerKeys.push((0, $ilM9F.listen)(layer, "addlayer", this.handleLayerGroupAdd_, this), (0, $ilM9F.listen)(layer, "removelayer", this.handleLayerGroupRemove_, this));
        this.listenerKeys_[(0, $9iPUS.getUid)(layer)] = listenerKeys;
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupAdd_(event) {
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("addlayer", event.layer));
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupRemove_(event) {
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("removelayer", event.layer));
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersAdd_(collectionEvent) {
        const layer = collectionEvent.element;
        this.registerLayerListeners_(layer);
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("addlayer", layer));
        this.changed();
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersRemove_(collectionEvent) {
        const layer = collectionEvent.element;
        const key = (0, $9iPUS.getUid)(layer);
        this.listenerKeys_[key].forEach((0, $ilM9F.unlistenByKey));
        delete this.listenerKeys_[key];
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("removelayer", layer));
        this.changed();
    }
    /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ getLayers() {
        return /** @type {!Collection<import("./Base.js").default>} */ this.get($0b703156bb914e6f$var$Property.LAYERS);
    }
    /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ setLayers(layers) {
        const collection = this.getLayers();
        if (collection) {
            const currentLayers = collection.getArray();
            for(let i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("removelayer", currentLayers[i]));
        }
        this.set($0b703156bb914e6f$var$Property.LAYERS, layers);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        array = array !== undefined ? array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    }
    /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(dest) {
        const states = dest !== undefined ? dest : [];
        const pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        const ownLayerState = this.getLayerState();
        let defaultZIndex = ownLayerState.zIndex;
        if (!dest && ownLayerState.zIndex === undefined) defaultZIndex = 0;
        for(let i = pos, ii = states.length; i < ii; i++){
            const layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $9pD6L.getIntersection)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
            if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
        }
        return states;
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return "ready";
    }
}
var $0b703156bb914e6f$export$2e2bcd8739ae039 = $0b703156bb914e6f$var$LayerGroup;

});

parcelRegister("dSQBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1b91f073c6a6c43$export$2e2bcd8739ae039);
/**
 * @module ol/MapBrowserEvent
 */ 
var $4Zdcs = parcelRequire("4Zdcs");
/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {UIEvent} EVENT
 */ class $a1b91f073c6a6c43$var$MapBrowserEvent extends (0, $4Zdcs.default) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */ constructor(type, map, originalEvent, dragging, frameState, activePointers){
        super(type, map, frameState);
        /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */ this.originalEvent = originalEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     */ this.pixel_ = null;
        /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     */ this.coordinate_ = null;
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ this.dragging = dragging !== undefined ? dragging : false;
        /**
     * @type {Array<PointerEvent>|undefined}
     */ this.activePointers = activePointers;
    }
    /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */ get pixel() {
        if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
        return this.pixel_;
    }
    set pixel(pixel) {
        this.pixel_ = pixel;
    }
    /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */ get coordinate() {
        if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
        return this.coordinate_;
    }
    set coordinate(coordinate) {
        this.coordinate_ = coordinate;
    }
    /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   */ preventDefault() {
        super.preventDefault();
        if ("preventDefault" in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
    }
    /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   */ stopPropagation() {
        super.stopPropagation();
        if ("stopPropagation" in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
    }
}
var $a1b91f073c6a6c43$export$2e2bcd8739ae039 = $a1b91f073c6a6c43$var$MapBrowserEvent;

});
parcelRegister("4Zdcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a171922c3a0c5ed$export$2e2bcd8739ae039);
/**
 * @module ol/MapEvent
 */ 
var $f18Q2 = parcelRequire("f18Q2");
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map event.
 */ class $3a171922c3a0c5ed$var$MapEvent extends (0, $f18Q2.default) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */ constructor(type, map, frameState){
        super(type);
        /**
     * The map where the event occurred.
     * @type {import("./Map.js").default}
     * @api
     */ this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./Map.js").FrameState}
     * @api
     */ this.frameState = frameState !== undefined ? frameState : null;
    }
}
var $3a171922c3a0c5ed$export$2e2bcd8739ae039 = $3a171922c3a0c5ed$var$MapEvent;

});


parcelRegister("8hMRr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6085d006f9d0efe2$export$2e2bcd8739ae039);
/**
 * @module ol/MapBrowserEventHandler
 */ 
var $3xzSb = parcelRequire("3xzSb");

var $dSQBl = parcelRequire("dSQBl");

var $1O6bd = parcelRequire("1O6bd");

var $ijSzV = parcelRequire("ijSzV");

var $KD0eF = parcelRequire("KD0eF");

var $8UoiJ = parcelRequire("8UoiJ");

var $ilM9F = parcelRequire("ilM9F");
class $6085d006f9d0efe2$var$MapBrowserEventHandler extends (0, $KD0eF.default) {
    /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */ constructor(map, moveTolerance){
        super(map);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./Map.js").default}
     * @private
     */ this.map_ = map;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.clickTimeoutId_;
        /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */ this.emulateClicks_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */ this.down_ = null;
        const element = this.map_.getViewport();
        /**
     * @type {Array<PointerEvent>}
     * @private
     */ this.activePointers_ = [];
        /**
     * @type {!Object<number, Event>}
     * @private
     */ this.trackedTouches_ = {};
        this.element_ = element;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.pointerdownListenerKey_ = (0, $ilM9F.listen)(element, (0, $ijSzV.default).POINTERDOWN, this.handlePointerDown_, this);
        /**
     * @type {PointerEvent}
     * @private
     */ this.originalPointerMoveEvent_;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.relayedListenerKey_ = (0, $ilM9F.listen)(element, (0, $ijSzV.default).POINTERMOVE, this.relayMoveEvent_, this);
        /**
     * @private
     */ this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this);
        this.element_.addEventListener((0, $3xzSb.default).TOUCHMOVE, this.boundHandleTouchMove_, (0, $8UoiJ.PASSIVE_EVENT_LISTENERS) ? {
            passive: false
        } : false);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ emulateClick_(pointerEvent) {
        let newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(()=>{
            this.clickTimeoutId_ = undefined;
            const newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }, 250);
    }
    /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ updateActivePointers_(pointerEvent) {
        const event = pointerEvent;
        const id = event.pointerId;
        if (event.type == (0, $1O6bd.default).POINTERUP || event.type == (0, $1O6bd.default).POINTERCANCEL) {
            delete this.trackedTouches_[id];
            for(const pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                // Some platforms assign a new pointerId when the target changes.
                // If this happens, delete one tracked pointer. If there is more
                // than one tracked pointer for the old target, it will be cleared
                // by subsequent POINTERUP events from other pointers.
                delete this.trackedTouches_[pointerId];
                break;
            }
        } else if (event.type == (0, $1O6bd.default).POINTERDOWN || event.type == (0, $1O6bd.default).POINTERMOVE) this.trackedTouches_[id] = event;
        this.activePointers_ = Object.values(this.trackedTouches_);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerUp_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_.length === 0) {
            this.dragListenerKeys_.forEach((0, $ilM9F.unlistenByKey));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ isMouseActionButton_(pointerEvent) {
        return pointerEvent.button === 0;
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerDown_(pointerEvent) {
        this.emulateClicks_ = this.activePointers_.length === 0;
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        this.down_ = new PointerEvent(pointerEvent.type, pointerEvent);
        Object.defineProperty(this.down_, "target", {
            writable: false,
            value: pointerEvent.target
        });
        if (this.dragListenerKeys_.length === 0) {
            const doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, $ilM9F.listen)(doc, (0, $1O6bd.default).POINTERMOVE, this.handlePointerMove_, this), (0, $ilM9F.listen)(doc, (0, $1O6bd.default).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, $ilM9F.listen)(this.element_, (0, $1O6bd.default).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $ilM9F.listen)(this.element_.getRootNode(), (0, $1O6bd.default).POINTERUP, this.handlePointerUp_, this));
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerMove_(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.updateActivePointers_(pointerEvent);
            this.dragging_ = true;
            const newEvent = new (0, $dSQBl.default)((0, $1O6bd.default).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
            this.dispatchEvent(newEvent);
        }
    }
    /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ relayMoveEvent_(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        const dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $dSQBl.default)((0, $1O6bd.default).POINTERMOVE, this.map_, pointerEvent, dragging));
    }
    /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */ handleTouchMove_(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events,
        // when elm-pep is used as pointer events polyfill.
        const originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== "boolean" || event.cancelable === true)) event.preventDefault();
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ isMoving_(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    }
    /**
   * Clean up.
   */ disposeInternal() {
        if (this.relayedListenerKey_) {
            (0, $ilM9F.unlistenByKey)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, $3xzSb.default).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, $ilM9F.unlistenByKey)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $ilM9F.unlistenByKey));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        super.disposeInternal();
    }
}
var $6085d006f9d0efe2$export$2e2bcd8739ae039 = $6085d006f9d0efe2$var$MapBrowserEventHandler;

});
parcelRegister("1O6bd", function(module, exports) {

$parcel$export(module.exports, "default", () => $150f412a4a7fa263$export$2e2bcd8739ae039);
/**
 * @module ol/MapBrowserEventType
 */ 
var $3xzSb = parcelRequire("3xzSb");
var /**
 * Constants for event names.
 * @enum {string}
 */ $150f412a4a7fa263$export$2e2bcd8739ae039 /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */  = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: "singleclick",
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, $3xzSb.default).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, $3xzSb.default).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: "pointerdrag",
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: "pointermove",
    POINTERDOWN: "pointerdown",
    POINTERUP: "pointerup",
    POINTEROVER: "pointerover",
    POINTEROUT: "pointerout",
    POINTERENTER: "pointerenter",
    POINTERLEAVE: "pointerleave",
    POINTERCANCEL: "pointercancel"
};

});

parcelRegister("ijSzV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d564567e31203d44$export$2e2bcd8739ae039);
/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $d564567e31203d44$export$2e2bcd8739ae039 = {
    POINTERMOVE: "pointermove",
    POINTERDOWN: "pointerdown",
    POINTERUP: "pointerup",
    POINTEROVER: "pointerover",
    POINTEROUT: "pointerout",
    POINTERENTER: "pointerenter",
    POINTERLEAVE: "pointerleave",
    POINTERCANCEL: "pointercancel"
};

});


parcelRegister("jDfdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ad75f913b6f7ff$export$2e2bcd8739ae039);
/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $e4ad75f913b6f7ff$export$2e2bcd8739ae039 /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */  = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: "postrender",
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: "movestart",
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: "moveend",
    /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */ LOADSTART: "loadstart",
    /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */ LOADEND: "loadend"
};

});

parcelRegister("GsIjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $07fa325567004bb7$export$2e2bcd8739ae039);
/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $07fa325567004bb7$export$2e2bcd8739ae039 = {
    LAYERGROUP: "layergroup",
    SIZE: "size",
    TARGET: "target",
    VIEW: "view"
};

});

parcelRegister("6yfyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c51fd53052a6bbc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getTilePriority", () => $4c51fd53052a6bbc$export$f08ad5eceeff5d45);
/**
 * @module ol/TileQueue
 */ 
var $3xzSb = parcelRequire("3xzSb");

var $9JKwD = parcelRequire("9JKwD");

var $fOhwi = parcelRequire("fOhwi");
/**
 * @typedef {function(import("./Tile.js").default, string, import("./coordinate.js").Coordinate, number): number} PriorityFunction
 */ class $4c51fd53052a6bbc$var$TileQueue extends (0, $9JKwD.default) {
    /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */ constructor(tilePriorityFunction, tileChangeCallback){
        super(/**
       * @param {Array} element Element.
       * @return {number} Priority.
       */ function(element) {
            return tilePriorityFunction.apply(null, element);
        }, /**
       * @param {Array} element Element.
       * @return {string} Key.
       */ function(element) {
            return /** @type {import("./Tile.js").default} */ element[0].getKey();
        });
        /** @private */ this.boundHandleTileChange_ = this.handleTileChange.bind(this);
        /**
     * @private
     * @type {function(): ?}
     */ this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ this.tilesLoadingKeys_ = {};
    }
    /**
   * @param {Array} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        const added = super.enqueue(element);
        if (added) {
            const tile = element[0];
            tile.addEventListener((0, $3xzSb.default).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    }
    /**
   * @return {number} Number of tiles loading.
   */ getTilesLoading() {
        return this.tilesLoading_;
    }
    /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("./Tile.js").default} */ event.target;
        const state = tile.getState();
        if (state === (0, $fOhwi.default).LOADED || state === (0, $fOhwi.default).ERROR || state === (0, $fOhwi.default).EMPTY) {
            if (state !== (0, $fOhwi.default).ERROR) tile.removeEventListener((0, $3xzSb.default).CHANGE, this.boundHandleTileChange_);
            const tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    }
    /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ loadMoreTiles(maxTotalLoading, maxNewLoads) {
        let newLoads = 0;
        let state, tile, tileKey;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            tile = /** @type {import("./Tile.js").default} */ this.dequeue()[0];
            tileKey = tile.getKey();
            state = tile.getState();
            if (state === (0, $fOhwi.default).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    }
}
var $4c51fd53052a6bbc$export$2e2bcd8739ae039 = $4c51fd53052a6bbc$var$TileQueue;
function $4c51fd53052a6bbc$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $9JKwD.DROP;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $9JKwD.DROP;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    const center = frameState.viewState.center;
    const deltaX = tileCenter[0] - center[0];
    const deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}

});
parcelRegister("9JKwD", function(module, exports) {

$parcel$export(module.exports, "DROP", () => $716c6804ea170b71$export$b4af72c40fd57063);
$parcel$export(module.exports, "default", () => $716c6804ea170b71$export$2e2bcd8739ae039);
/**
 * @module ol/structs/PriorityQueue
 */ 
var $4Cz58 = parcelRequire("4Cz58");

var $gn0g3 = parcelRequire("gn0g3");
const $716c6804ea170b71$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ class $716c6804ea170b71$var$PriorityQueue {
    /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */ constructor(priorityFunction, keyFunction){
        /**
     * @type {function(T): number}
     * @private
     */ this.priorityFunction_ = priorityFunction;
        /**
     * @type {function(T): string}
     * @private
     */ this.keyFunction_ = keyFunction;
        /**
     * @type {Array<T>}
     * @private
     */ this.elements_ = [];
        /**
     * @type {Array<number>}
     * @private
     */ this.priorities_ = [];
        /**
     * @type {!Object<string, boolean>}
     * @private
     */ this.queuedElements_ = {};
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, $gn0g3.clear)(this.queuedElements_);
    }
    /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */ dequeue() {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = /** @type {T} */ elements.pop();
            priorities[0] = /** @type {number} */ priorities.pop();
            this.siftUp_(0);
        }
        const elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    }
    /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        (0, $4Cz58.assert)(!(this.keyFunction_(element) in this.queuedElements_), "Tried to enqueue an `element` that was already added to the queue");
        const priority = this.priorityFunction_(element);
        if (priority != $716c6804ea170b71$export$b4af72c40fd57063) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.elements_.length;
    }
    /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */ getLeftChildIndex_(index) {
        return index * 2 + 1;
    }
    /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */ getRightChildIndex_(index) {
        return index * 2 + 2;
    }
    /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */ getParentIndex_(index) {
        return index - 1 >> 1;
    }
    /**
   * Make this a heap. O(N).
   * @private
   */ heapify_() {
        let i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.elements_.length === 0;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */ isKeyQueued(key) {
        return key in this.queuedElements_;
    }
    /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */ isQueued(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    }
    /**
   * @param {number} index The index of the node to move down.
   * @private
   */ siftUp_(index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const count = elements.length;
        const element = elements[index];
        const priority = priorities[index];
        const startIndex = index;
        while(index < count >> 1){
            const lIndex = this.getLeftChildIndex_(index);
            const rIndex = this.getRightChildIndex_(index);
            const smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    }
    /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */ siftDown_(startIndex, index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[index];
        const priority = priorities[index];
        while(index > startIndex){
            const parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    }
    /**
   * FIXME empty description for jsdoc
   */ reprioritize() {
        const priorityFunction = this.priorityFunction_;
        const elements = this.elements_;
        const priorities = this.priorities_;
        let index = 0;
        const n = elements.length;
        let element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == $716c6804ea170b71$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    }
}
var $716c6804ea170b71$export$2e2bcd8739ae039 = $716c6804ea170b71$var$PriorityQueue;

});


parcelRegister("f3WAG", function(module, exports) {

$parcel$export(module.exports, "defaults", () => $af7495b2f822d5e9$export$ebe90cb607ad99e);
/**
 * @module ol/control/defaults
 */ 
var $972rY = parcelRequire("972rY");

var $cD8Qe = parcelRequire("cD8Qe");

var $dZLuC = parcelRequire("dZLuC");

var $6gCea = parcelRequire("6gCea");
function $af7495b2f822d5e9$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Control.js").default>} */ const controls = new (0, $cD8Qe.default)();
    const zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $6gCea.default)(options.zoomOptions));
    const rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $dZLuC.default)(options.rotateOptions));
    const attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $972rY.default)(options.attributionOptions));
    return controls;
}

});
parcelRegister("972rY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a26ab11104d2c24$export$2e2bcd8739ae039);
/**
 * @module ol/control/Attribution
 */ 
var $fVglf = parcelRequire("fVglf");

var $3xzSb = parcelRequire("3xzSb");

var $hGHcK = parcelRequire("hGHcK");

var $fVVyM = parcelRequire("fVVyM");

var $DfnQm = parcelRequire("DfnQm");

var $6wUzV = parcelRequire("6wUzV");
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ class $6a26ab11104d2c24$var$Attribution extends (0, $fVglf.default) {
    /**
   * @param {Options} [options] Attribution options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement("div"),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ this.ulElement_ = document.createElement("ul");
        /**
     * @private
     * @type {boolean}
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.userCollapsed_ = this.collapsed_;
        /**
     * @private
     * @type {boolean}
     */ this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        const className = options.className !== undefined ? options.className : "ol-attribution";
        const tipLabel = options.tipLabel !== undefined ? options.tipLabel : "Attributions";
        const expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + "-expand";
        const collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : "\u203A";
        const collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + "-collapse";
        if (typeof collapseLabel === "string") {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement("span");
            this.collapseLabel_.textContent = collapseLabel;
            this.collapseLabel_.className = collapseClassName;
        } else this.collapseLabel_ = collapseLabel;
        const label = options.label !== undefined ? options.label : "i";
        if (typeof label === "string") {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement("span");
            this.label_.textContent = label;
            this.label_.className = expandClassName;
        } else this.label_ = label;
        const activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        /**
     * @private
     * @type {HTMLElement}
     */ this.toggleButton_ = document.createElement("button");
        this.toggleButton_.setAttribute("type", "button");
        this.toggleButton_.setAttribute("aria-expanded", String(!this.collapsed_));
        this.toggleButton_.title = tipLabel;
        this.toggleButton_.appendChild(activeLabel);
        this.toggleButton_.addEventListener((0, $3xzSb.default).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + " " + (0, $hGHcK.CLASS_UNSELECTABLE) + " " + (0, $hGHcK.CLASS_CONTROL) + (this.collapsed_ && this.collapsible_ ? " " + (0, $hGHcK.CLASS_COLLAPSED) : "") + (this.collapsible_ ? "" : " ol-uncollapsible");
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(this.toggleButton_);
        element.appendChild(this.ulElement_);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ collectSourceAttributions_(frameState) {
        const visibleAttributions = Array.from(new Set(this.getMap().getAllLayers().flatMap((layer)=>layer.getAttributions(frameState))));
        const collapsible = !this.getMap().getAllLayers().some((layer)=>layer.getSource() && layer.getSource().getAttributionsCollapsible() === false);
        if (!this.overrideCollapsible_) this.setCollapsible(collapsible);
        return visibleAttributions;
    }
    /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ async updateElement_(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = "none";
                this.renderedVisible_ = false;
            }
            return;
        }
        const attributions = await Promise.all(this.collectSourceAttributions_(frameState).map((attribution)=>(0, $6wUzV.toPromise)(()=>attribution)));
        const visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? "" : "none";
            this.renderedVisible_ = visible;
        }
        if ((0, $fVVyM.equals)(attributions, this.renderedAttributions_)) return;
        (0, $DfnQm.removeChildren)(this.ulElement_);
        // append the attributions
        for(let i = 0, ii = attributions.length; i < ii; ++i){
            const element = document.createElement("li");
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    }
    /**
   * @private
   */ handleToggle_() {
        this.element.classList.toggle((0, $hGHcK.CLASS_COLLAPSED));
        if (this.collapsed_) (0, $DfnQm.replaceNode)(this.collapseLabel_, this.label_);
        else (0, $DfnQm.replaceNode)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute("aria-expanded", String(!this.collapsed_));
    }
    /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ getCollapsible() {
        return this.collapsible_;
    }
    /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle("ol-uncollapsible");
        if (this.userCollapsed_) this.handleToggle_();
    }
    /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ setCollapsed(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    }
    /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ getCollapsed() {
        return this.collapsed_;
    }
    /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    }
}
var $6a26ab11104d2c24$export$2e2bcd8739ae039 = $6a26ab11104d2c24$var$Attribution;

});
parcelRegister("fVglf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b978dafe8f7d27ff$export$2e2bcd8739ae039);
/**
 * @module ol/control/Control
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $jDfdj = parcelRequire("jDfdj");

var $6wUzV = parcelRequire("6wUzV");

var $ilM9F = parcelRequire("ilM9F");

var $DfnQm = parcelRequire("DfnQm");
/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * const myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ class $b978dafe8f7d27ff$var$Control extends (0, $fFFY7.default) {
    /**
   * @param {Options} options Control options.
   */ constructor(options){
        super();
        const element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = "auto";
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = element ? element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ this.target_ = null;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ this.listenerKeys = [];
        if (options.render) this.render = options.render;
        if (options.target) this.setTarget(options.target);
    }
    /**
   * Clean up.
   */ disposeInternal() {
        (0, $DfnQm.removeNode)(this.element);
        super.disposeInternal();
    }
    /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.map_) (0, $DfnQm.removeNode)(this.element);
        for(let i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $ilM9F.unlistenByKey)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (map) {
            const target = this.target_ ? this.target_ : map.getOverlayContainerStopEvent();
            target.appendChild(this.element);
            if (this.render !== (0, $6wUzV.VOID)) this.listenerKeys.push((0, $ilM9F.listen)(map, (0, $jDfdj.default).POSTRENDER, this.render, this));
            map.render();
        }
    }
    /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */ render(mapEvent) {}
    /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ setTarget(target) {
        this.target_ = typeof target === "string" ? document.getElementById(target) : target;
    }
}
var $b978dafe8f7d27ff$export$2e2bcd8739ae039 = $b978dafe8f7d27ff$var$Control;

});


parcelRegister("dZLuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a305cff1f91b3b86$export$2e2bcd8739ae039);
/**
 * @module ol/control/Rotate
 */ 
var $fVglf = parcelRequire("fVglf");

var $3xzSb = parcelRequire("3xzSb");

var $hGHcK = parcelRequire("hGHcK");

var $h9x7v = parcelRequire("h9x7v");
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ class $a305cff1f91b3b86$var$Rotate extends (0, $fVglf.default) {
    /**
   * @param {Options} [options] Rotate options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement("div"),
            render: options.render,
            target: options.target
        });
        const className = options.className !== undefined ? options.className : "ol-rotate";
        const label = options.label !== undefined ? options.label : "\u21E7";
        const compassClassName = options.compassClassName !== undefined ? options.compassClassName : "ol-compass";
        /**
     * @type {HTMLElement}
     * @private
     */ this.label_ = null;
        if (typeof label === "string") {
            this.label_ = document.createElement("span");
            this.label_.className = compassClassName;
            this.label_.textContent = label;
        } else {
            this.label_ = label;
            this.label_.classList.add(compassClassName);
        }
        const tipLabel = options.tipLabel ? options.tipLabel : "Reset rotation";
        const button = document.createElement("button");
        button.className = className + "-reset";
        button.setAttribute("type", "button");
        button.title = tipLabel;
        button.appendChild(this.label_);
        button.addEventListener((0, $3xzSb.default).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + " " + (0, $hGHcK.CLASS_UNSELECTABLE) + " " + (0, $hGHcK.CLASS_CONTROL);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(button);
        this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        if (this.autoHide_) this.element.classList.add((0, $hGHcK.CLASS_HIDDEN));
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    }
    /**
   * @private
   */ resetNorth_() {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $h9x7v.easeOut)
            });
            else view.setRotation(0);
        }
    }
    /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) return;
        const rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            const transform = "rotate(" + rotation + "rad)";
            if (this.autoHide_) {
                const contains = this.element.classList.contains((0, $hGHcK.CLASS_HIDDEN));
                if (!contains && rotation === 0) this.element.classList.add((0, $hGHcK.CLASS_HIDDEN));
                else if (contains && rotation !== 0) this.element.classList.remove((0, $hGHcK.CLASS_HIDDEN));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    }
}
var $a305cff1f91b3b86$export$2e2bcd8739ae039 = $a305cff1f91b3b86$var$Rotate;

});

parcelRegister("6gCea", function(module, exports) {

$parcel$export(module.exports, "default", () => $4901e3e27e30416a$export$2e2bcd8739ae039);
/**
 * @module ol/control/Zoom
 */ 
var $fVglf = parcelRequire("fVglf");

var $3xzSb = parcelRequire("3xzSb");

var $hGHcK = parcelRequire("hGHcK");

var $h9x7v = parcelRequire("h9x7v");
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ class $4901e3e27e30416a$var$Zoom extends (0, $fVglf.default) {
    /**
   * @param {Options} [options] Zoom options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement("div"),
            target: options.target
        });
        const className = options.className !== undefined ? options.className : "ol-zoom";
        const delta = options.delta !== undefined ? options.delta : 1;
        const zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + "-in";
        const zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + "-out";
        const zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : "+";
        const zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : "\u2013";
        const zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : "Zoom in";
        const zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : "Zoom out";
        const inElement = document.createElement("button");
        inElement.className = zoomInClassName;
        inElement.setAttribute("type", "button");
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === "string" ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $3xzSb.default).CLICK, this.handleClick_.bind(this, delta), false);
        const outElement = document.createElement("button");
        outElement.className = zoomOutClassName;
        outElement.setAttribute("type", "button");
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === "string" ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $3xzSb.default).CLICK, this.handleClick_.bind(this, -delta), false);
        const cssClasses = className + " " + (0, $hGHcK.CLASS_UNSELECTABLE) + " " + (0, $hGHcK.CLASS_CONTROL);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    }
    /**
   * @param {number} delta Zoom delta.
   * @private
   */ zoomByDelta_(delta) {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, $h9x7v.easeOut)
                });
            } else view.setZoom(newZoom);
        }
    }
}
var $4901e3e27e30416a$export$2e2bcd8739ae039 = $4901e3e27e30416a$var$Zoom;

});


parcelRegister("jzydl", function(module, exports) {

$parcel$export(module.exports, "defaults", () => $e3fbd36d629ecc04$export$ebe90cb607ad99e);
/**
 * @module ol/interaction/defaults
 */ 
var $cD8Qe = parcelRequire("cD8Qe");

var $fxxCd = parcelRequire("fxxCd");

var $gzMtY = parcelRequire("gzMtY");

var $2bF2e = parcelRequire("2bF2e");

var $f5G4s = parcelRequire("f5G4s");

var $21kEk = parcelRequire("21kEk");

var $2W903 = parcelRequire("2W903");

var $dfvfw = parcelRequire("dfvfw");

var $eEiUy = parcelRequire("eEiUy");

var $cYAky = parcelRequire("cYAky");

var $asgrH = parcelRequire("asgrH");
function $e3fbd36d629ecc04$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Interaction.js").default>} */ const interactions = new (0, $cD8Qe.default)();
    const kinetic = new (0, $dfvfw.default)(-0.005, 0.05, 100);
    const altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $2bF2e.default)());
    const doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $fxxCd.default)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    const dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $gzMtY.default)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    const pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $cYAky.default)());
    const pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $asgrH.default)({
        duration: options.zoomDuration
    }));
    const keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $21kEk.default)());
        interactions.push(new (0, $2W903.default)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    const mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $eEiUy.default)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    const shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $f5G4s.default)({
        duration: options.zoomDuration
    }));
    return interactions;
}

});
parcelRegister("fxxCd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50403621294a654$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/DoubleClickZoom
 */ 
var $4U60I = parcelRequire("4U60I");

var $1O6bd = parcelRequire("1O6bd");
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ class $b50403621294a654$var$DoubleClickZoom extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $1O6bd.default).DBLCLICK) {
            const browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            const map = mapBrowserEvent.map;
            const anchor = mapBrowserEvent.coordinate;
            const delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            const view = map.getView();
            (0, $4U60I.zoomByDelta)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    }
}
var $b50403621294a654$export$2e2bcd8739ae039 = $b50403621294a654$var$DoubleClickZoom;

});
parcelRegister("4U60I", function(module, exports) {

$parcel$export(module.exports, "pan", () => $39210df8527e63e5$export$4c486572e961a974);
$parcel$export(module.exports, "zoomByDelta", () => $39210df8527e63e5$export$ace321ff2a8016ef);
$parcel$export(module.exports, "default", () => $39210df8527e63e5$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/Interaction
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $3Pv6i = parcelRequire("3Pv6i");

var $h9x7v = parcelRequire("h9x7v");
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} handleEvent
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ class $39210df8527e63e5$var$Interaction extends (0, $fFFY7.default) {
    /**
   * @param {InteractionOptions} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {InteractionOnSignature<void>}
     */ this.un;
        if (options && options.handleEvent) this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        this.setActive(true);
    }
    /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ getActive() {
        return /** @type {boolean} */ this.get((0, $3Pv6i.default).ACTIVE);
    }
    /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        return true;
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        this.set((0, $3Pv6i.default).ACTIVE, active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        this.map_ = map;
    }
}
function $39210df8527e63e5$export$4c486572e961a974(view, delta, duration) {
    const currentCenter = view.getCenterInternal();
    if (currentCenter) {
        const center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: duration !== undefined ? duration : 250,
            easing: (0, $h9x7v.linear),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $39210df8527e63e5$export$ace321ff2a8016ef(view, delta, anchor, duration) {
    const currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    const newZoom = view.getConstrainedZoom(currentZoom + delta);
    const newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: anchor,
        duration: duration !== undefined ? duration : 250,
        easing: (0, $h9x7v.easeOut)
    });
}
var $39210df8527e63e5$export$2e2bcd8739ae039 = $39210df8527e63e5$var$Interaction;

});
parcelRegister("3Pv6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c9e42723ccf2bfb$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $2c9e42723ccf2bfb$export$2e2bcd8739ae039 = {
    ACTIVE: "active"
};

});



parcelRegister("gzMtY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c11585da26a016db$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/DragPan
 */ 
var $hMuFm = parcelRequire("hMuFm");

var $6wUzV = parcelRequire("6wUzV");

var $kqI9g = parcelRequire("kqI9g");

var $h9x7v = parcelRequire("h9x7v");

var $2o3CH = parcelRequire("2o3CH");
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ class $c11585da26a016db$var$DragPan extends (0, $hMuFm.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super({
            stopDown: (0, $6wUzV.FALSE)
        });
        options = options ? options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ this.lastCentroid = null;
        /**
     * @type {number}
     */ this.lastPointersCount_;
        /**
     * @type {boolean}
     */ this.panning_ = false;
        const condition = options.condition ? options.condition : (0, $kqI9g.all)((0, $kqI9g.noModifierKeys), (0, $kqI9g.primaryAction));
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $kqI9g.all)((0, $kqI9g.focusWithTabindex), condition) : condition;
        /**
     * @private
     * @type {boolean}
     */ this.noKinetic_ = false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ handleDragEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        if (!this.panning_) {
            this.panning_ = true;
            map.getView().beginInteraction();
        }
        const targetPointers = this.targetPointers;
        const centroid = map.getEventPixel((0, $hMuFm.centroid)(targetPointers));
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                const delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                const map = mapBrowserEvent.map;
                const view = map.getView();
                (0, $2o3CH.scale)(delta, view.getResolution());
                (0, $2o3CH.rotate)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                const distance = this.kinetic_.getDistance();
                const angle = this.kinetic_.getAngle();
                const center = view.getCenterInternal();
                const centerpx = map.getPixelFromCoordinateInternal(center);
                const dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, $h9x7v.easeOut)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        }
        if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger up, tiny drag, second finger up
        this.kinetic_.begin();
        this.lastCentroid = null;
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        }
        return false;
    }
}
var $c11585da26a016db$export$2e2bcd8739ae039 = $c11585da26a016db$var$DragPan;

});
parcelRegister("hMuFm", function(module, exports) {

$parcel$export(module.exports, "centroid", () => $cf1eb502962d87a8$export$e2a20c553f6c85ce);
$parcel$export(module.exports, "default", () => $cf1eb502962d87a8$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/Pointer
 */ 
var $4U60I = parcelRequire("4U60I");

var $1O6bd = parcelRequire("1O6bd");
/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ class $cf1eb502962d87a8$var$PointerInteraction extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        if (options.handleDownEvent) this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ this.handlingDownUpSequence = false;
        /**
     * @type {Array<PointerEvent>}
     * @protected
     */ this.targetPointers = [];
    }
    /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */ getPointerCount() {
        return this.targetPointers.length;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleDownEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleDragEvent(mapBrowserEvent) {}
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        let stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $1O6bd.default).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, $1O6bd.default).POINTERUP) {
                const handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $1O6bd.default).POINTERDOWN) {
                const handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $1O6bd.default).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleMoveEvent(mapBrowserEvent) {}
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleUpEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ stopDown(handled) {
        return handled;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */ updateTrackedPointers_(mapBrowserEvent) {
        if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
    }
}
function $cf1eb502962d87a8$export$e2a20c553f6c85ce(pointerEvents) {
    const length = pointerEvents.length;
    let clientX = 0;
    let clientY = 0;
    for(let i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return {
        clientX: clientX / length,
        clientY: clientY / length
    };
}
var $cf1eb502962d87a8$export$2e2bcd8739ae039 = $cf1eb502962d87a8$var$PointerInteraction;

});

parcelRegister("kqI9g", function(module, exports) {

$parcel$export(module.exports, "all", () => $edf87b50170125f7$export$84bf76cd7afc7469);
$parcel$export(module.exports, "altShiftKeysOnly", () => $edf87b50170125f7$export$4e5f01653f9f1f82);
$parcel$export(module.exports, "focusWithTabindex", () => $edf87b50170125f7$export$ae2cdf064e3b0c55);
$parcel$export(module.exports, "always", () => $edf87b50170125f7$export$ba9e5d519bc326ca);
$parcel$export(module.exports, "mouseActionButton", () => $edf87b50170125f7$export$1238ad6b5e7fff70);
$parcel$export(module.exports, "never", () => $edf87b50170125f7$export$b3e22bcfd64c1022);
$parcel$export(module.exports, "singleClick", () => $edf87b50170125f7$export$194df8bad091b401);
$parcel$export(module.exports, "noModifierKeys", () => $edf87b50170125f7$export$fdc892d0d8fe3bfb);
$parcel$export(module.exports, "platformModifierKey", () => $edf87b50170125f7$export$32603ad571dd22b5);
$parcel$export(module.exports, "shiftKeyOnly", () => $edf87b50170125f7$export$5d31fe68a477cfbb);
$parcel$export(module.exports, "targetNotEditable", () => $edf87b50170125f7$export$e5570ca80cd8fd54);
$parcel$export(module.exports, "mouseOnly", () => $edf87b50170125f7$export$abb7acbfa76bf3c4);
$parcel$export(module.exports, "primaryAction", () => $edf87b50170125f7$export$189f0d593022b199);
/**
 * @module ol/events/condition
 */ 
var $1O6bd = parcelRequire("1O6bd");

var $6wUzV = parcelRequire("6wUzV");

var $8UoiJ = parcelRequire("8UoiJ");

var $4Cz58 = parcelRequire("4Cz58");
function $edf87b50170125f7$export$84bf76cd7afc7469(var_args) {
    const conditions = arguments;
    /**
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} All conditions passed.
   */ return function(event) {
        let pass = true;
        for(let i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
const $edf87b50170125f7$export$573409992e89967e = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $edf87b50170125f7$export$d7ddd398f22d79ef = function(event) {
    const targetElement = event.map.getTargetElement();
    const activeElement = event.map.getOwnerDocument().activeElement;
    return targetElement.contains(activeElement);
};
const $edf87b50170125f7$export$ae2cdf064e3b0c55 = function(event) {
    return event.map.getTargetElement().hasAttribute("tabindex") ? $edf87b50170125f7$export$d7ddd398f22d79ef(event) : true;
};
const $edf87b50170125f7$export$ba9e5d519bc326ca = (0, $6wUzV.TRUE);
const $edf87b50170125f7$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1O6bd.default).CLICK;
};
const $edf87b50170125f7$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    const originalEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.button == 0 && !((0, $8UoiJ.WEBKIT) && (0, $8UoiJ.MAC) && originalEvent.ctrlKey);
};
const $edf87b50170125f7$export$b3e22bcfd64c1022 = (0, $6wUzV.FALSE);
const $edf87b50170125f7$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == "pointermove";
};
const $edf87b50170125f7$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1O6bd.default).SINGLECLICK;
};
const $edf87b50170125f7$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1O6bd.default).DBLCLICK;
};
const $edf87b50170125f7$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $8UoiJ.MAC) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$32603ad571dd22b5 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return (0, $8UoiJ.MAC) ? originalEvent.metaKey : originalEvent.ctrlKey;
};
const $edf87b50170125f7$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $edf87b50170125f7$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    const tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== "INPUT" && tagName !== "SELECT" && tagName !== "TEXTAREA" && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
const $edf87b50170125f7$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    const pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $4Cz58.assert)(pointerEvent !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvent.pointerType == "mouse";
};
const $edf87b50170125f7$export$e74de664a571d084 = function(mapBrowserEvent) {
    const pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $4Cz58.assert)(pointerEvt !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === "touch";
};
const $edf87b50170125f7$export$cd1707283a23f059 = function(mapBrowserEvent) {
    const pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $4Cz58.assert)(pointerEvt !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === "pen";
};
const $edf87b50170125f7$export$189f0d593022b199 = function(mapBrowserEvent) {
    const pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $4Cz58.assert)(pointerEvent !== undefined, "mapBrowserEvent must originate from a pointer event");
    return pointerEvent.isPrimary && pointerEvent.button === 0;
};

});


parcelRegister("2bF2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $197c7092261b2aa0$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/DragRotate
 */ 
var $hMuFm = parcelRequire("hMuFm");

var $6wUzV = parcelRequire("6wUzV");

var $kqI9g = parcelRequire("kqI9g");

var $ip5LZ = parcelRequire("ip5LZ");
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ class $197c7092261b2aa0$var$DragRotate extends (0, $hMuFm.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            stopDown: (0, $6wUzV.FALSE)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $kqI9g.altShiftKeysOnly);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ handleDragEvent(mapBrowserEvent) {
        if (!(0, $kqI9g.mouseOnly)(mapBrowserEvent)) return;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $ip5LZ.disable)) return;
        const size = map.getSize();
        const offset = mapBrowserEvent.pixel;
        const theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            const delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(mapBrowserEvent) {
        if (!(0, $kqI9g.mouseOnly)(mapBrowserEvent)) return true;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(mapBrowserEvent) {
        if (!(0, $kqI9g.mouseOnly)(mapBrowserEvent)) return false;
        if ((0, $kqI9g.mouseActionButton)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        }
        return false;
    }
}
var $197c7092261b2aa0$export$2e2bcd8739ae039 = $197c7092261b2aa0$var$DragRotate;

});

parcelRegister("f5G4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $afc7f51010a5b660$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/DragZoom
 */ 
var $jgkip = parcelRequire("jgkip");

var $h9x7v = parcelRequire("h9x7v");

var $kqI9g = parcelRequire("kqI9g");
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ class $afc7f51010a5b660$var$DragZoom extends (0, $jgkip.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const condition = options.condition ? options.condition : (0, $kqI9g.shiftKeyOnly);
        super({
            condition: condition,
            className: options.className || "ol-dragzoom",
            minArea: options.minArea
        });
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ this.out_ = options.out !== undefined ? options.out : false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {
        const map = this.getMap();
        const view = /** @type {!import("../View.js").default} */ map.getView();
        let geometry = this.getGeometry();
        if (this.out_) {
            const rotatedExtent = view.rotatedExtentForGeometry(geometry);
            const resolution = view.getResolutionForExtentInternal(rotatedExtent);
            const factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: (0, $h9x7v.easeOut)
        });
    }
}
var $afc7f51010a5b660$export$2e2bcd8739ae039 = $afc7f51010a5b660$var$DragZoom;

});
parcelRegister("jgkip", function(module, exports) {

$parcel$export(module.exports, "default", () => $e05f414bc3918235$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box

var $f18Q2 = parcelRequire("f18Q2");

var $hMuFm = parcelRequire("hMuFm");

var $gRRde = parcelRequire("gRRde");

var $kqI9g = parcelRequire("kqI9g");
/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ const $e05f414bc3918235$var$DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: "boxstart",
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: "boxdrag",
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: "boxend",
    /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */ BOXCANCEL: "boxcancel"
};
class $e05f414bc3918235$export$7053c33c051365ea extends (0, $f18Q2.default) {
    /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */ constructor(type, coordinate, mapBrowserEvent){
        super(type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ class $e05f414bc3918235$var$DragBox extends (0, $hMuFm.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DragBoxOnSignature<void>}
     */ this.un;
        options = options ? options : {};
        /**
     * @type {import("../render/Box.js").default}
     * @private
     */ this.box_ = new (0, $gRRde.default)(options.className || "ol-dragbox");
        /**
     * @type {number}
     * @private
     */ this.minArea_ = options.minArea !== undefined ? options.minArea : 64;
        if (options.onBoxEnd) this.onBoxEnd = options.onBoxEnd;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $kqI9g.mouseActionButton);
        /**
     * @private
     * @type {EndCondition}
     */ this.boxEndCondition_ = options.boxEndCondition ? options.boxEndCondition : this.defaultBoxEndCondition;
    }
    /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
        const width = endPixel[0] - startPixel[0];
        const height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    }
    /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */ getGeometry() {
        return this.box_.getGeometry();
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ handleDragEvent(mapBrowserEvent) {
        if (!this.startPixel_) return;
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(mapBrowserEvent) {
        if (!this.startPixel_) return false;
        this.box_.setMap(null);
        const completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea(completeBox ? $e05f414bc3918235$var$DragBoxEventType.BOXEND : $e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        }
        return false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {}
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        if (!active) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setActive(active);
    }
}
var $e05f414bc3918235$export$2e2bcd8739ae039 = $e05f414bc3918235$var$DragBox;

});
parcelRegister("gRRde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c47adf75308683a6$export$2e2bcd8739ae039);
/**
 * @module ol/render/Box
 */ 
var $4kyFN = parcelRequire("4kyFN");

var $5ydre = parcelRequire("5ydre");
class $c47adf75308683a6$var$RenderBox extends (0, $4kyFN.default) {
    /**
   * @param {string} className CSS class name.
   */ constructor(className){
        super();
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ this.element_ = document.createElement("div");
        this.element_.style.position = "absolute";
        this.element_.style.pointerEvents = "auto";
        this.element_.className = "ol-box " + className;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.endPixel_ = null;
    }
    /**
   * Clean up.
   */ disposeInternal() {
        this.setMap(null);
    }
    /**
   * @private
   */ render_() {
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const px = "px";
        const style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            const style = this.element_.style;
            style.left = "inherit";
            style.top = "inherit";
            style.width = "inherit";
            style.height = "inherit";
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    }
    /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ setPixels(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    }
    /**
   * Creates or updates the cached geometry.
   */ createOrUpdateGeometry() {
        if (!this.map_) return;
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        const coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $5ydre.default)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    }
    /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ getGeometry() {
        return this.geometry_;
    }
}
var $c47adf75308683a6$export$2e2bcd8739ae039 = $c47adf75308683a6$var$RenderBox;

});



parcelRegister("21kEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $178bb1517d626802$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/KeyboardPan
 */ 
var $3xzSb = parcelRequire("3xzSb");

var $4U60I = parcelRequire("4U60I");

var $4GopZ = parcelRequire("4GopZ");

var $kqI9g = parcelRequire("kqI9g");

var $2o3CH = parcelRequire("2o3CH");
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ class $178bb1517d626802$var$KeyboardPan extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $kqI9g.noModifierKeys)(mapBrowserEvent) && (0, $kqI9g.targetNotEditable)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition !== undefined ? options.condition : this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $3xzSb.default).KEYDOWN) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key == (0, $4GopZ.default).DOWN || key == (0, $4GopZ.default).LEFT || key == (0, $4GopZ.default).RIGHT || key == (0, $4GopZ.default).UP)) {
                const map = mapBrowserEvent.map;
                const view = map.getView();
                const mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                let deltaX = 0, deltaY = 0;
                if (key == (0, $4GopZ.default).DOWN) deltaY = -mapUnitsDelta;
                else if (key == (0, $4GopZ.default).LEFT) deltaX = -mapUnitsDelta;
                else if (key == (0, $4GopZ.default).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                const delta = [
                    deltaX,
                    deltaY
                ];
                (0, $2o3CH.rotate)(delta, view.getRotation());
                (0, $4U60I.pan)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $178bb1517d626802$export$2e2bcd8739ae039 = $178bb1517d626802$var$KeyboardPan;

});
parcelRegister("4GopZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $368e06a3031941b5$export$2e2bcd8739ae039);
/**
 * @module ol/events/Key
 */ /**
 * @enum {string}
 * @const
 */ var $368e06a3031941b5$export$2e2bcd8739ae039 = {
    LEFT: "ArrowLeft",
    UP: "ArrowUp",
    RIGHT: "ArrowRight",
    DOWN: "ArrowDown"
};

});


parcelRegister("2W903", function(module, exports) {

$parcel$export(module.exports, "default", () => $2237fabfa170eefc$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/KeyboardZoom
 */ 
var $3xzSb = parcelRequire("3xzSb");

var $4U60I = parcelRequire("4U60I");

var $kqI9g = parcelRequire("kqI9g");
/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. The default condition is
 * that {@link module:ol/events/condition.targetNotEditable} is fulfilled and that
 * the platform modifier key isn't pressed
 * (!{@link module:ol/events/condition.platformModifierKey}).
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ class $2237fabfa170eefc$var$KeyboardZoom extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : function(mapBrowserEvent) {
            return !(0, $kqI9g.platformModifierKey)(mapBrowserEvent) && (0, $kqI9g.targetNotEditable)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $3xzSb.default).KEYDOWN || mapBrowserEvent.type == (0, $3xzSb.default).KEYPRESS) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key === "+" || key === "-")) {
                const map = mapBrowserEvent.map;
                const delta = key === "+" ? this.delta_ : -this.delta_;
                const view = map.getView();
                (0, $4U60I.zoomByDelta)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $2237fabfa170eefc$export$2e2bcd8739ae039 = $2237fabfa170eefc$var$KeyboardZoom;

});

parcelRegister("dfvfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a54ea8d5f7a49ee$export$2e2bcd8739ae039);
/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ class $9a54ea8d5f7a49ee$var$Kinetic {
    /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */ constructor(decay, minVelocity, delay){
        /**
     * @private
     * @type {number}
     */ this.decay_ = decay;
        /**
     * @private
     * @type {number}
     */ this.minVelocity_ = minVelocity;
        /**
     * @private
     * @type {number}
     */ this.delay_ = delay;
        /**
     * @private
     * @type {Array<number>}
     */ this.points_ = [];
        /**
     * @private
     * @type {number}
     */ this.angle_ = 0;
        /**
     * @private
     * @type {number}
     */ this.initialVelocity_ = 0;
    }
    /**
   * FIXME empty description for jsdoc
   */ begin() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   */ update(x, y) {
        this.points_.push(x, y, Date.now());
    }
    /**
   * @return {boolean} Whether we should do kinetic animation.
   */ end() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        const delay = Date.now() - this.delay_;
        const lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        let firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        const duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        const dx = this.points_[lastIndex] - this.points_[firstIndex];
        const dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    }
    /**
   * @return {number} Total distance travelled (pixels).
   */ getDistance() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    }
    /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */ getAngle() {
        return this.angle_;
    }
}
var $9a54ea8d5f7a49ee$export$2e2bcd8739ae039 = $9a54ea8d5f7a49ee$var$Kinetic;

});

parcelRegister("eEiUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa378764710d71e$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/MouseWheelZoom
 */ 
var $3xzSb = parcelRequire("3xzSb");

var $4U60I = parcelRequire("4U60I");

var $8UoiJ = parcelRequire("8UoiJ");

var $kqI9g = parcelRequire("kqI9g");

var $9byFX = parcelRequire("9byFX");
/**
 * @typedef {'trackpad' | 'wheel'} Mode
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ class $aaa378764710d71e$var$MouseWheelZoom extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        /**
     * @private
     * @type {number}
     */ this.totalDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.lastDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        const condition = options.condition ? options.condition : (0, $kqI9g.always);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $kqI9g.all)((0, $kqI9g.focusWithTabindex), condition) : condition;
        /**
     * @private
     * @type {?import("../coordinate.js").Coordinate}
     */ this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.startTime_ = undefined;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @private
     * @type {number}
     */ this.trackpadEventGap_ = 400;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ this.deltaPerZoom_ = 300;
    }
    /**
   * @private
   */ endInteraction_() {
        this.trackpadTimeoutId_ = undefined;
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_);
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const type = mapBrowserEvent.type;
        if (type !== (0, $3xzSb.default).WHEEL) return true;
        const map = mapBrowserEvent.map;
        const wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.coordinate;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        let delta;
        if (mapBrowserEvent.type == (0, $3xzSb.default).WHEEL) {
            delta = wheelEvent.deltaY;
            if ((0, $8UoiJ.FIREFOX) && wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) delta /= (0, $8UoiJ.DEVICE_PIXEL_RATIO);
            if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 40;
        }
        if (delta === 0) return false;
        this.lastDelta_ = delta;
        const now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? "trackpad" : "wheel";
        const view = map.getView();
        if (this.mode_ === "trackpad" && !(view.getConstrainResolution() || this.constrainResolution_)) {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        const timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    }
    /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */ handleWheelZoom_(map) {
        const view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        let delta = -(0, $9byFX.clamp)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, $4U60I.zoomByDelta)(view, delta, this.lastAnchor_, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    }
    /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ setMouseAnchor(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    }
}
var $aaa378764710d71e$export$2e2bcd8739ae039 = $aaa378764710d71e$var$MouseWheelZoom;

});

parcelRegister("cYAky", function(module, exports) {

$parcel$export(module.exports, "default", () => $9727451f2459496c$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/PinchRotate
 */ 
var $hMuFm = parcelRequire("hMuFm");

var $6wUzV = parcelRequire("6wUzV");

var $ip5LZ = parcelRequire("ip5LZ");
/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ class $9727451f2459496c$var$PinchRotate extends (0, $hMuFm.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $6wUzV.FALSE);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ handleDragEvent(mapBrowserEvent) {
        let rotationDelta = 0.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        // angle between touches
        const angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            const delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $ip5LZ.disable)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $hMuFm.centroid)(this.targetPointers)));
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $9727451f2459496c$export$2e2bcd8739ae039 = $9727451f2459496c$var$PinchRotate;

});

parcelRegister("asgrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c946b60b88d4a6$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/PinchZoom
 */ 
var $hMuFm = parcelRequire("hMuFm");

var $6wUzV = parcelRequire("6wUzV");
/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ class $79c946b60b88d4a6$var$PinchZoom extends (0, $hMuFm.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $6wUzV.FALSE);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 1;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ handleDragEvent(mapBrowserEvent) {
        let scaleDelta = 1.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        const dx = touch0.clientX - touch1.clientX;
        const dy = touch0.clientY - touch1.clientY;
        // distance between touches
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $hMuFm.centroid)(this.targetPointers)));
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            const direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $79c946b60b88d4a6$export$2e2bcd8739ae039 = $79c946b60b88d4a6$var$PinchZoom;

});



parcelRegister("haRZ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c80d3ed2a84f41ed$export$2e2bcd8739ae039);
/**
 * @module ol/Overlay
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $jDfdj = parcelRequire("jDfdj");

var $hGHcK = parcelRequire("hGHcK");

var $9pD6L = parcelRequire("9pD6L");

var $ilM9F = parcelRequire("ilM9F");

var $DfnQm = parcelRequire("DfnQm");
/**
 * @typedef {'bottom-left' | 'bottom-center' | 'bottom-right' | 'center-left' | 'center-center' | 'center-right' | 'top-left' | 'top-center' | 'top-right'} Positioning
 * The overlay position: `'bottom-left'`, `'bottom-center'`,  `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, or `'top-right'`.
 */ /**
 * @typedef {Object} Options
 * @property {number|string} [id] Set the overlay id. The overlay id can be used
 * with the {@link module:ol/Map~Map#getOverlayById} method.
 * @property {HTMLElement} [element] The overlay element.
 * @property {Array<number>} [offset=[0, 0]] Offsets in pixels used when positioning
 * the overlay. The first element in the
 * array is the horizontal offset. A positive value shifts the overlay right.
 * The second element in the array is the vertical offset. A positive value
 * shifts the overlay down.
 * @property {import("./coordinate.js").Coordinate} [position] The overlay position
 * in map projection.
 * @property {Positioning} [positioning='top-left'] Defines how
 * the overlay is actually positioned with respect to its `position` property.
 * Possible values are `'bottom-left'`, `'bottom-center'`, `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, and `'top-right'`.
 * @property {boolean} [stopEvent=true] Whether event propagation to the map
 * viewport should be stopped. If `true` the overlay is placed in the same
 * container as that of the controls (CSS class name
 * `ol-overlaycontainer-stopevent`); if `false` it is placed in the container
 * with CSS class name specified by the `className` property.
 * @property {boolean} [insertFirst=true] Whether the overlay is inserted first
 * in the overlay container, or appended. If the overlay is placed in the same
 * container as that of the controls (see the `stopEvent` option) you will
 * probably set `insertFirst` to `true` so the overlay is displayed below the
 * controls.
 * @property {PanIntoViewOptions|boolean} [autoPan=false] Pan the map when calling
 * `setPosition`, so that the overlay is entirely visible in the current viewport.
 * @property {string} [className='ol-overlay-container ol-selectable'] CSS class
 * name.
 */ /**
 * @typedef {Object} PanOptions
 * @property {number} [duration=1000] The duration of the animation in
 * milliseconds.
 * @property {function(number):number} [easing] The easing function to use. Can
 * be one from {@link module:ol/easing} or a custom function.
 * Default is {@link module:ol/easing.inAndOut}.
 */ /**
 * @typedef {Object} PanIntoViewOptions
 * @property {PanOptions} [animation={}] The animation parameters for the pan
 * @property {number} [margin=20] The margin (in pixels) between the
 * overlay and the borders of the map when panning into view.
 */ /**
 * @enum {string}
 * @protected
 */ const $c80d3ed2a84f41ed$var$Property = {
    ELEMENT: "element",
    MAP: "map",
    OFFSET: "offset",
    POSITION: "position",
    POSITIONING: "positioning"
};
/**
 * @typedef {import("./ObjectEventType").Types|'change:element'|'change:map'|'change:offset'|'change:position'|
 *   'change:positioning'} OverlayObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<OverlayObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|OverlayObjectEventTypes, Return>} OverlayOnSignature
 */ /**
 * @classdesc
 * An element to be displayed over the map and attached to a single map
 * location.  Like {@link module:ol/control/Control~Control}, Overlays are
 * visible widgets. Unlike Controls, they are not in a fixed position on the
 * screen, but are tied to a geographical coordinate, so panning the map will
 * move an Overlay but not a Control.
 *
 * Example:
 *
 *     import Overlay from 'ol/Overlay.js';
 *
 *     // ...
 *     const popup = new Overlay({
 *       element: document.getElementById('popup'),
 *     });
 *     popup.setPosition(coordinate);
 *     map.addOverlay(popup);
 *
 * @api
 */ class $c80d3ed2a84f41ed$var$Overlay extends (0, $fFFY7.default) {
    /**
   * @param {Options} options Overlay options.
   */ constructor(options){
        super();
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {OverlayOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {Options}
     */ this.options = options;
        /**
     * @protected
     * @type {number|string|undefined}
     */ this.id = options.id;
        /**
     * @protected
     * @type {boolean}
     */ this.insertFirst = options.insertFirst !== undefined ? options.insertFirst : true;
        /**
     * @protected
     * @type {boolean}
     */ this.stopEvent = options.stopEvent !== undefined ? options.stopEvent : true;
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = document.createElement("div");
        this.element.className = options.className !== undefined ? options.className : "ol-overlay-container " + (0, $hGHcK.CLASS_SELECTABLE);
        this.element.style.position = "absolute";
        this.element.style.pointerEvents = "auto";
        /**
     * @protected
     * @type {PanIntoViewOptions|undefined}
     */ this.autoPan = options.autoPan === true ? {} : options.autoPan || undefined;
        /**
     * @protected
     * @type {{transform_: string,
     *         visible: boolean}}
     */ this.rendered = {
            transform_: "",
            visible: true
        };
        /**
     * @protected
     * @type {?import("./events.js").EventsKey}
     */ this.mapPostrenderListenerKey = null;
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.ELEMENT, this.handleElementChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.MAP, this.handleMapChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.OFFSET, this.handleOffsetChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.POSITION, this.handlePositionChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.POSITIONING, this.handlePositioningChanged);
        if (options.element !== undefined) this.setElement(options.element);
        this.setOffset(options.offset !== undefined ? options.offset : [
            0,
            0
        ]);
        this.setPositioning(options.positioning || "top-left");
        if (options.position !== undefined) this.setPosition(options.position);
    }
    /**
   * Get the DOM element of this overlay.
   * @return {HTMLElement|undefined} The Element containing the overlay.
   * @observable
   * @api
   */ getElement() {
        return /** @type {HTMLElement|undefined} */ this.get($c80d3ed2a84f41ed$var$Property.ELEMENT);
    }
    /**
   * Get the overlay identifier which is set on constructor.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id;
    }
    /**
   * Get the map associated with this overlay.
   * @return {import("./Map.js").default|null} The map that the
   * overlay is part of.
   * @observable
   * @api
   */ getMap() {
        return /** @type {import("./Map.js").default|null} */ this.get($c80d3ed2a84f41ed$var$Property.MAP) || null;
    }
    /**
   * Get the offset of this overlay.
   * @return {Array<number>} The offset.
   * @observable
   * @api
   */ getOffset() {
        return /** @type {Array<number>} */ this.get($c80d3ed2a84f41ed$var$Property.OFFSET);
    }
    /**
   * Get the current position of this overlay.
   * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
   *     anchored at.
   * @observable
   * @api
   */ getPosition() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get($c80d3ed2a84f41ed$var$Property.POSITION);
    }
    /**
   * Get the current positioning of this overlay.
   * @return {Positioning} How the overlay is positioned
   *     relative to its point on the map.
   * @observable
   * @api
   */ getPositioning() {
        return /** @type {Positioning} */ this.get($c80d3ed2a84f41ed$var$Property.POSITIONING);
    }
    /**
   * @protected
   */ handleElementChanged() {
        (0, $DfnQm.removeChildren)(this.element);
        const element = this.getElement();
        if (element) this.element.appendChild(element);
    }
    /**
   * @protected
   */ handleMapChanged() {
        if (this.mapPostrenderListenerKey) {
            (0, $DfnQm.removeNode)(this.element);
            (0, $ilM9F.unlistenByKey)(this.mapPostrenderListenerKey);
            this.mapPostrenderListenerKey = null;
        }
        const map = this.getMap();
        if (map) {
            this.mapPostrenderListenerKey = (0, $ilM9F.listen)(map, (0, $jDfdj.default).POSTRENDER, this.render, this);
            this.updatePixelPosition();
            const container = this.stopEvent ? map.getOverlayContainerStopEvent() : map.getOverlayContainer();
            if (this.insertFirst) container.insertBefore(this.element, container.childNodes[0] || null);
            else container.appendChild(this.element);
            this.performAutoPan();
        }
    }
    /**
   * @protected
   */ render() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handleOffsetChanged() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handlePositionChanged() {
        this.updatePixelPosition();
        this.performAutoPan();
    }
    /**
   * @protected
   */ handlePositioningChanged() {
        this.updatePixelPosition();
    }
    /**
   * Set the DOM element to be associated with this overlay.
   * @param {HTMLElement|undefined} element The Element containing the overlay.
   * @observable
   * @api
   */ setElement(element) {
        this.set($c80d3ed2a84f41ed$var$Property.ELEMENT, element);
    }
    /**
   * Set the map to be associated with this overlay.
   * @param {import("./Map.js").default|null} map The map that the
   * overlay is part of. Pass `null` to just remove the overlay from the current map.
   * @observable
   * @api
   */ setMap(map) {
        this.set($c80d3ed2a84f41ed$var$Property.MAP, map);
    }
    /**
   * Set the offset for this overlay.
   * @param {Array<number>} offset Offset.
   * @observable
   * @api
   */ setOffset(offset) {
        this.set($c80d3ed2a84f41ed$var$Property.OFFSET, offset);
    }
    /**
   * Set the position for this overlay. If the position is `undefined` the
   * overlay is hidden.
   * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
   *     is anchored at.
   * @observable
   * @api
   */ setPosition(position) {
        this.set($c80d3ed2a84f41ed$var$Property.POSITION, position);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary) using the configured autoPan parameters
   * @protected
   */ performAutoPan() {
        if (this.autoPan) this.panIntoView(this.autoPan);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary).
   * @param {PanIntoViewOptions} [panIntoViewOptions] Options for the pan action
   * @api
   */ panIntoView(panIntoViewOptions) {
        const map = this.getMap();
        if (!map || !map.getTargetElement() || !this.get($c80d3ed2a84f41ed$var$Property.POSITION)) return;
        const mapRect = this.getRect(map.getTargetElement(), map.getSize());
        const element = this.getElement();
        const overlayRect = this.getRect(element, [
            (0, $DfnQm.outerWidth)(element),
            (0, $DfnQm.outerHeight)(element)
        ]);
        panIntoViewOptions = panIntoViewOptions || {};
        const myMargin = panIntoViewOptions.margin === undefined ? 20 : panIntoViewOptions.margin;
        if (!(0, $9pD6L.containsExtent)(mapRect, overlayRect)) {
            // the overlay is not completely inside the viewport, so pan the map
            const offsetLeft = overlayRect[0] - mapRect[0];
            const offsetRight = mapRect[2] - overlayRect[2];
            const offsetTop = overlayRect[1] - mapRect[1];
            const offsetBottom = mapRect[3] - overlayRect[3];
            const delta = [
                0,
                0
            ];
            if (offsetLeft < 0) // move map to the left
            delta[0] = offsetLeft - myMargin;
            else if (offsetRight < 0) // move map to the right
            delta[0] = Math.abs(offsetRight) + myMargin;
            if (offsetTop < 0) // move map up
            delta[1] = offsetTop - myMargin;
            else if (offsetBottom < 0) // move map down
            delta[1] = Math.abs(offsetBottom) + myMargin;
            if (delta[0] !== 0 || delta[1] !== 0) {
                const center = /** @type {import("./coordinate.js").Coordinate} */ map.getView().getCenterInternal();
                const centerPx = map.getPixelFromCoordinateInternal(center);
                if (!centerPx) return;
                const newCenterPx = [
                    centerPx[0] + delta[0],
                    centerPx[1] + delta[1]
                ];
                const panOptions = panIntoViewOptions.animation || {};
                map.getView().animateInternal({
                    center: map.getCoordinateFromPixelInternal(newCenterPx),
                    duration: panOptions.duration,
                    easing: panOptions.easing
                });
            }
        }
    }
    /**
   * Get the extent of an element relative to the document
   * @param {HTMLElement} element The element.
   * @param {import("./size.js").Size} size The size of the element.
   * @return {import("./extent.js").Extent} The extent.
   * @protected
   */ getRect(element, size) {
        const box = element.getBoundingClientRect();
        const offsetX = box.left + window.pageXOffset;
        const offsetY = box.top + window.pageYOffset;
        return [
            offsetX,
            offsetY,
            offsetX + size[0],
            offsetY + size[1]
        ];
    }
    /**
   * Set the positioning for this overlay.
   * @param {Positioning} positioning how the overlay is
   *     positioned relative to its point on the map.
   * @observable
   * @api
   */ setPositioning(positioning) {
        this.set($c80d3ed2a84f41ed$var$Property.POSITIONING, positioning);
    }
    /**
   * Modify the visibility of the element.
   * @param {boolean} visible Element visibility.
   * @protected
   */ setVisible(visible) {
        if (this.rendered.visible !== visible) {
            this.element.style.display = visible ? "" : "none";
            this.rendered.visible = visible;
        }
    }
    /**
   * Update pixel position.
   * @protected
   */ updatePixelPosition() {
        const map = this.getMap();
        const position = this.getPosition();
        if (!map || !map.isRendered() || !position) {
            this.setVisible(false);
            return;
        }
        const pixel = map.getPixelFromCoordinate(position);
        const mapSize = map.getSize();
        this.updateRenderedPosition(pixel, mapSize);
    }
    /**
   * @param {import("./pixel.js").Pixel} pixel The pixel location.
   * @param {import("./size.js").Size|undefined} mapSize The map size.
   * @protected
   */ updateRenderedPosition(pixel, mapSize) {
        const style = this.element.style;
        const offset = this.getOffset();
        const positioning = this.getPositioning();
        this.setVisible(true);
        const x = Math.round(pixel[0] + offset[0]) + "px";
        const y = Math.round(pixel[1] + offset[1]) + "px";
        let posX = "0%";
        let posY = "0%";
        if (positioning == "bottom-right" || positioning == "center-right" || positioning == "top-right") posX = "-100%";
        else if (positioning == "bottom-center" || positioning == "center-center" || positioning == "top-center") posX = "-50%";
        if (positioning == "bottom-left" || positioning == "bottom-center" || positioning == "bottom-right") posY = "-100%";
        else if (positioning == "center-left" || positioning == "center-center" || positioning == "center-right") posY = "-50%";
        const transform = `translate(${posX}, ${posY}) translate(${x}, ${y})`;
        if (this.rendered.transform_ != transform) {
            this.rendered.transform_ = transform;
            style.transform = transform;
        }
    }
    /**
   * returns the options this Overlay has been created with
   * @return {Options} overlay options
   */ getOptions() {
        return this.options;
    }
}
var $c80d3ed2a84f41ed$export$2e2bcd8739ae039 = $c80d3ed2a84f41ed$var$Overlay;

});

parcelRegister("bdrRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $82a68515bd6ef378$export$2e2bcd8739ae039);
/**
 * @module ol/layer/Vector
 */ 
var $hf3TH = parcelRequire("hf3TH");

var $8IUeQ = parcelRequire("8IUeQ");
/**
 * @template {import('../Feature.js').FeatureLike} FeatureType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {import("../source/Vector.js").default<FeatureType>} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import('../Feature.js').FeatureLike} FeatureType
 * @extends {BaseVectorLayer<import("../source/Vector.js").default<FeatureType>, CanvasVectorLayerRenderer>}
 * @api
 */ class $82a68515bd6ef378$var$VectorLayer extends (0, $hf3TH.default) {
    /**
   * @param {Options<FeatureType>} [options] Options.
   */ constructor(options){
        super(options);
    }
    createRenderer() {
        return new (0, $8IUeQ.default)(this);
    }
}
var $82a68515bd6ef378$export$2e2bcd8739ae039 = $82a68515bd6ef378$var$VectorLayer;

});
parcelRegister("8IUeQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $659e0e97392a5f5e$export$2e2bcd8739ae039);
/**
 * @module ol/renderer/canvas/VectorLayer
 */ 
var $jpMYX = parcelRequire("jpMYX");

var $5FKVH = parcelRequire("5FKVH");

var $e1c3o = parcelRequire("e1c3o");

var $l6YBe = parcelRequire("l6YBe");

var $aKuSF = parcelRequire("aKuSF");

var $1HMKO = parcelRequire("1HMKO");

var $9pD6L = parcelRequire("9pD6L");

var $DfnQm = parcelRequire("DfnQm");

var $6urmj = parcelRequire("6urmj");

var $fVVyM = parcelRequire("fVVyM");

var $dpRHA = parcelRequire("dpRHA");

var $9iPUS = parcelRequire("9iPUS");

var $2o3CH = parcelRequire("2o3CH");
/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ class $659e0e97392a5f5e$var$CanvasVectorLayerRenderer extends (0, $5FKVH.default) {
    /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */ constructor(vectorLayer){
        super(vectorLayer);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @type {boolean}
     */ this.animatingOrInteracting_;
        /**
     * @type {ImageData|null}
     */ this.hitDetectionImageData_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.clipped_ = false;
        /**
     * @private
     * @type {Array<import("../../Feature.js").default>}
     */ this.renderedFeatures_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = (0, $9pD6L.createEmpty)();
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.wrappedRenderedExtent_ = (0, $9pD6L.createEmpty)();
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {import("../../coordinate").Coordinate}
     */ this.renderedCenter_ = null;
        /**
     * @private
     * @type {import("../../proj/Projection").default}
     */ this.renderedProjection_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedPixelRatio_ = 1;
        /**
     * @private
     * @type {function(import("../../Feature.js").default, import("../../Feature.js").default): number|null}
     */ this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.renderedFrameDeclutter_;
        /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */ this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ this.replayGroupChanged = true;
        /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */ this.clipping = true;
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.targetContext_ = null;
        /**
     * @private
     * @type {number}
     */ this.opacity_ = 1;
    }
    /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} [declutterable] `true` to only render declutterable items,
   *     `false` to only render non-declutterable items, `undefined` to render all.
   */ renderWorlds(executorGroup, frameState, declutterable) {
        const extent = frameState.extent;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const projection = viewState.projection;
        const rotation = viewState.rotation;
        const projectionExtent = projection.getExtent();
        const vectorSource = this.getLayer().getSource();
        const declutter = this.getLayer().getDeclutter();
        const pixelRatio = frameState.pixelRatio;
        const viewHints = frameState.viewHints;
        const snapToPixel = !(viewHints[(0, $aKuSF.default).ANIMATING] || viewHints[(0, $aKuSF.default).INTERACTING]);
        const context = this.context;
        const width = Math.round((0, $9pD6L.getWidth)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $9pD6L.getHeight)(extent) / resolution * pixelRatio);
        const multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        const worldWidth = multiWorld ? (0, $9pD6L.getWidth)(projectionExtent) : null;
        const endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + 1 : 1;
        let world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) : 0;
        do {
            let transform = this.getRenderTransform(center, resolution, 0, pixelRatio, width, height, world * worldWidth);
            if (frameState.declutter) transform = transform.slice(0);
            executorGroup.execute(context, [
                context.canvas.width,
                context.canvas.height
            ], transform, rotation, snapToPixel, declutterable === undefined ? (0, $e1c3o.ALL) : declutterable ? (0, $e1c3o.DECLUTTER) : (0, $e1c3o.NON_DECLUTTER), declutterable ? declutter && frameState.declutter[declutter] : undefined);
        }while (++world < endWorld);
    }
    /**
   * @private
   */ setDrawContext_() {
        if (this.opacity_ !== 1) {
            this.targetContext_ = this.context;
            this.context = (0, $DfnQm.createCanvasContext2D)(this.context.canvas.width, this.context.canvas.height, (0, $5FKVH.canvasPool));
        }
    }
    /**
   * @private
   */ resetDrawContext_() {
        if (this.opacity_ !== 1) {
            const alpha = this.targetContext_.globalAlpha;
            this.targetContext_.globalAlpha = this.opacity_;
            this.targetContext_.drawImage(this.context.canvas, 0, 0);
            this.targetContext_.globalAlpha = alpha;
            (0, $DfnQm.releaseCanvas)(this.context);
            (0, $5FKVH.canvasPool).push(this.context.canvas);
            this.context = this.targetContext_;
            this.targetContext_ = null;
        }
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeclutter(frameState) {
        if (!this.replayGroup_ || !this.getLayer().getDeclutter()) return;
        this.renderWorlds(this.replayGroup_, frameState, true);
    }
    /**
   * Render deferred instructions.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {
        if (!this.replayGroup_) return;
        this.replayGroup_.renderDeferred();
        if (this.clipped_) this.context.restore();
        this.resetDrawContext_();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        this.opacity_ = layerState.opacity;
        const viewState = frameState.viewState;
        this.prepareContainer(frameState, target);
        const context = this.context;
        const replayGroup = this.replayGroup_;
        let render = replayGroup && !replayGroup.isEmpty();
        if (!render) {
            const hasRenderListeners = this.getLayer().hasListener((0, $l6YBe.default).PRERENDER) || this.getLayer().hasListener((0, $l6YBe.default).POSTRENDER);
            if (!hasRenderListeners) return null;
        }
        this.setDrawContext_();
        this.preRender(context, frameState);
        const projection = viewState.projection;
        // clipped rendering if layer extent is set
        this.clipped_ = false;
        if (render && layerState.extent && this.clipping) {
            const layerExtent = (0, $dpRHA.fromUserExtent)(layerState.extent, projection);
            render = (0, $9pD6L.intersects)(layerExtent, frameState.extent);
            this.clipped_ = render && !(0, $9pD6L.containsExtent)(layerExtent, frameState.extent);
            if (this.clipped_) this.clipUnrotated(context, frameState, layerExtent);
        }
        if (render) this.renderWorlds(replayGroup, frameState, this.getLayer().getDeclutter() ? false : undefined);
        if (!frameState.declutter && this.clipped_) context.restore();
        this.postRender(context, frameState);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        if (!frameState.declutter) this.resetDrawContext_();
        return this.container;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature").default>>} Promise
   * that resolves with an array of features.
   */ getFeatures(pixel) {
        return new Promise((resolve)=>{
            if (this.frameState && !this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                const size = this.frameState.size.slice();
                const center = this.renderedCenter_;
                const resolution = this.renderedResolution_;
                const rotation = this.renderedRotation_;
                const projection = this.renderedProjection_;
                const extent = this.wrappedRenderedExtent_;
                const layer = this.getLayer();
                const transforms = [];
                const width = size[0] * (0, $1HMKO.HIT_DETECT_RESOLUTION);
                const height = size[1] * (0, $1HMKO.HIT_DETECT_RESOLUTION);
                transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $1HMKO.HIT_DETECT_RESOLUTION), width, height, 0).slice());
                const source = layer.getSource();
                const projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, $9pD6L.containsExtent)(projectionExtent, extent)) {
                    let startX = extent[0];
                    const worldWidth = (0, $9pD6L.getWidth)(projectionExtent);
                    let world = 0;
                    let offsetX;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $1HMKO.HIT_DETECT_RESOLUTION), width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $1HMKO.HIT_DETECT_RESOLUTION), width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                const userProjection = (0, $dpRHA.getUserProjection)();
                this.hitDetectionImageData_ = (0, $1HMKO.createHitDetectionImageData)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation, (0, $6urmj.getSquaredTolerance)(resolution, this.renderedPixelRatio_), userProjection ? projection : null);
            }
            resolve((0, $1HMKO.hitDetect)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        });
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        if (!this.replayGroup_) return undefined;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            const key = (0, $9iPUS.getUid)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        let result;
        const executorGroups = [
            this.replayGroup_
        ];
        const declutter = this.getLayer().getDeclutter();
        executorGroups.some((executorGroup)=>{
            return result = executorGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutter && frameState.declutter[declutter] ? frameState.declutter[declutter].all().map((item)=>item.value) : null);
        });
        return result;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        const vectorLayer = this.getLayer();
        const vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        const animating = frameState.viewHints[(0, $aKuSF.default).ANIMATING];
        const interacting = frameState.viewHints[(0, $aKuSF.default).INTERACTING];
        const updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        const updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        const frameStateExtent = frameState.extent;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const resolution = viewState.resolution;
        const pixelRatio = frameState.pixelRatio;
        const vectorLayerRevision = vectorLayer.getRevision();
        const vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        let vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $6urmj.defaultOrder);
        const center = viewState.center.slice();
        const extent = (0, $9pD6L.buffer)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        const renderedExtent = extent.slice();
        const loadExtents = [
            extent.slice()
        ];
        const projectionExtent = projection.getExtent();
        if (vectorSource.getWrapX() && projection.canWrapX() && !(0, $9pD6L.containsExtent)(projectionExtent, frameState.extent)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            const worldWidth = (0, $9pD6L.getWidth)(projectionExtent);
            const gutter = Math.max((0, $9pD6L.getWidth)(extent) / 2, worldWidth);
            extent[0] = projectionExtent[0] - gutter;
            extent[2] = projectionExtent[2] + gutter;
            (0, $2o3CH.wrapX)(center, projection);
            const loadExtent = (0, $9pD6L.wrapX)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (this.ready && this.renderedResolution_ == resolution && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && this.renderedFrameDeclutter_ === !!frameState.declutter && (0, $9pD6L.containsExtent)(this.wrappedRenderedExtent_, extent)) {
            if (!(0, $fVVyM.equals)(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        const replayGroup = new (0, $jpMYX.default)((0, $6urmj.getTolerance)(resolution, pixelRatio), extent, resolution, pixelRatio);
        const userProjection = (0, $dpRHA.getUserProjection)();
        let userTransform;
        if (userProjection) {
            for(let i = 0, ii = loadExtents.length; i < ii; ++i){
                const extent = loadExtents[i];
                const userExtent = (0, $dpRHA.toUserExtent)(extent, projection);
                vectorSource.loadFeatures(userExtent, (0, $dpRHA.toUserResolution)(resolution, projection), userProjection);
            }
            userTransform = (0, $dpRHA.getTransformFromProjections)(userProjection, projection);
        } else for(let i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        const squaredTolerance = (0, $6urmj.getSquaredTolerance)(resolution, pixelRatio);
        let ready = true;
        const render = /**
       * @param {import("../../Feature.js").default} feature Feature.
       * @param {number} index Index.
       */ (feature, index)=>{
            let styles;
            const styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                const dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, this.getLayer().getDeclutter(), index);
                ready = ready && !dirty;
            }
        };
        const userExtent = (0, $dpRHA.toUserExtent)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ const features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(let i = 0, ii = features.length; i < ii; ++i)render(features[i], i);
        this.renderedFeatures_ = features;
        this.ready = ready;
        const replayGroupInstructions = replayGroup.finish();
        const executorGroup = new (0, $e1c3o.default)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer(), !!frameState.declutter);
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedFrameDeclutter_ = !!frameState.declutter;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.renderedPixelRatio_ = pixelRatio;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    }
    /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, transform, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, $6urmj.renderFeature)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index) || loading;
        else loading = (0, $6urmj.renderFeature)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index);
        return loading;
    }
}
var $659e0e97392a5f5e$export$2e2bcd8739ae039 = $659e0e97392a5f5e$var$CanvasVectorLayerRenderer;

});
parcelRegister("jpMYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22658f4b743550b$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/BuilderGroup
 */ 
var $3KABr = parcelRequire("3KABr");

var $fEvr3 = parcelRequire("fEvr3");

var $dUudE = parcelRequire("dUudE");

var $aKl4u = parcelRequire("aKl4u");

var $bboJK = parcelRequire("bboJK");
/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ const $e22658f4b743550b$var$BATCH_CONSTRUCTORS = {
    "Circle": (0, $aKl4u.default),
    "Default": (0, $3KABr.default),
    "Image": (0, $fEvr3.default),
    "LineString": (0, $dUudE.default),
    "Polygon": (0, $aKl4u.default),
    "Text": (0, $bboJK.default)
};
class $e22658f4b743550b$var$BuilderGroup {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
     */ this.buildersByZIndex_ = {};
    }
    /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */ finish() {
        const builderInstructions = {};
        for(const zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            const builders = this.buildersByZIndex_[zKey];
            for(const builderKey in builders){
                const builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    }
    /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */ getBuilder(zIndex, builderType) {
        const zIndexKey = zIndex !== undefined ? zIndex.toString() : "0";
        let replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        let replay = replays[builderType];
        if (replay === undefined) {
            const Constructor = $e22658f4b743550b$var$BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    }
}
var $e22658f4b743550b$export$2e2bcd8739ae039 = $e22658f4b743550b$var$BuilderGroup;

});
parcelRegister("3KABr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bb20f8873deb436$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/Builder
 */ 
var $hNBYx = parcelRequire("hNBYx");

var $iM9A6 = parcelRequire("iM9A6");

var $kbchp = parcelRequire("kbchp");

var $jh19n = parcelRequire("jh19n");

var $9pD6L = parcelRequire("9pD6L");

var $ig1j9 = parcelRequire("ig1j9");

var $fVVyM = parcelRequire("fVVyM");

var $7eSHW = parcelRequire("7eSHW");
class $2bb20f8873deb436$var$CanvasBuilder extends (0, $kbchp.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super();
        /**
     * @protected
     * @type {number}
     */ this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = [];
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.tmpCoordinate_ = [];
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = [];
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
    }
    /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ applyPixelRatio(dashArray) {
        const pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */ appendFlatPointCoordinates(flatCoordinates, stride) {
        const extent = this.getBufferedMaxExtent();
        const tmpCoord = this.tmpCoordinate_;
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, $9pD6L.containsCoordinate)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ appendFlatLineCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        const extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        let lastXCoord = flatCoordinates[offset];
        let lastYCoord = flatCoordinates[offset + 1];
        const nextCoord = this.tmpCoordinate_;
        let skipped = true;
        let i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $9pD6L.coordinateRelationship)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, $iM9A6.default).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */ drawCustomCoordinates_(flatCoordinates, offset, ends, stride, builderEnds) {
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {
        this.beginGeometry(geometry, feature, index);
        const type = geometry.getType();
        const stride = geometry.getStride();
        const builderBegin = this.coordinates.length;
        let flatCoordinates, builderEnd, builderEnds, builderEndss;
        let offset;
        switch(type){
            case "MultiPolygon":
                flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                builderEndss = [];
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                offset = 0;
                for(let i = 0, ii = endss.length; i < ii; ++i){
                    const myEnds = [];
                    offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                    builderEndss.push(myEnds);
                }
                this.instructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    renderer,
                    (0, $7eSHW.inflateMultiCoordinatesArray),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $7eSHW.inflateMultiCoordinatesArray),
                    index
                ]);
                break;
            case "Polygon":
            case "MultiLineString":
                builderEnds = [];
                flatCoordinates = type == "Polygon" ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                this.instructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    renderer,
                    (0, $7eSHW.inflateCoordinatesArray),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $7eSHW.inflateCoordinatesArray),
                    index
                ]);
                break;
            case "LineString":
            case "Circle":
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                this.instructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    (0, $7eSHW.inflateCoordinates),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $7eSHW.inflateCoordinates),
                    index
                ]);
                break;
            case "MultiPoint":
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                if (builderEnd > builderBegin) {
                    this.instructions.push([
                        (0, $hNBYx.default).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        renderer,
                        (0, $7eSHW.inflateCoordinates),
                        index
                    ]);
                    this.hitDetectionInstructions.push([
                        (0, $hNBYx.default).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        hitDetectionRenderer || renderer,
                        (0, $7eSHW.inflateCoordinates),
                        index
                    ]);
                }
                break;
            case "Point":
                flatCoordinates = geometry.getFlatCoordinates();
                this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                builderEnd = this.coordinates.length;
                this.instructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    undefined,
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $hNBYx.default).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    undefined,
                    index
                ]);
                break;
            default:
        }
        this.endGeometry(feature);
    }
    /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} index Render order index
   */ beginGeometry(geometry, feature, index) {
        this.beginGeometryInstruction1_ = [
            (0, $hNBYx.default).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $hNBYx.default).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    }
    /**
   * Reverse the hit detection instructions.
   */ reverseHitDetectionInstructions() {
        const hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        let i;
        const n = hitDetectionInstructions.length;
        let instruction;
        let type;
        let begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, $hNBYx.default).END_GEOMETRY) begin = i;
            else if (type == (0, $hNBYx.default).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $fVVyM.reverseSubArray)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        const state = this.state;
        if (fillStyle) {
            const fillStyleColor = fillStyle.getColor();
            state.fillPatternScale = fillStyleColor && typeof fillStyleColor === "object" && "src" in fillStyleColor ? this.pixelRatio : 1;
            state.fillStyle = (0, $jh19n.asColorLike)(fillStyleColor ? fillStyleColor : (0, $ig1j9.defaultFillStyle));
        } else state.fillStyle = undefined;
        if (strokeStyle) {
            const strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $jh19n.asColorLike)(strokeStyleColor ? strokeStyleColor : (0, $ig1j9.defaultStrokeStyle));
            const strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $ig1j9.defaultLineCap);
            const strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $ig1j9.defaultLineDash);
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $ig1j9.defaultLineDashOffset);
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $ig1j9.defaultLineJoin);
            const strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $ig1j9.defaultLineWidth);
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $ig1j9.defaultMiterLimit);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */ createFill(state) {
        const fillStyle = state.fillStyle;
        /** @type {Array<*>} */ const fillInstruction = [
            (0, $hNBYx.default).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== "string") // Fill is a pattern or gradient - align and scale it!
        fillInstruction.push(state.fillPatternScale);
        return fillInstruction;
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        this.instructions.push(this.createStroke(state));
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ createStroke(state) {
        return [
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            this.applyPixelRatio(state.lineDash),
            state.lineDashOffset * this.pixelRatio
        ];
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */ updateFillStyle(state, createFill) {
        const fillStyle = state.fillStyle;
        if (typeof fillStyle !== "string" || state.currentFillStyle != fillStyle) {
            if (fillStyle !== undefined) this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */ updateStrokeStyle(state, applyStroke) {
        const strokeStyle = state.strokeStyle;
        const lineCap = state.lineCap;
        const lineDash = state.lineDash;
        const lineDashOffset = state.lineDashOffset;
        const lineJoin = state.lineJoin;
        const lineWidth = state.lineWidth;
        const miterLimit = state.miterLimit;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $fVVyM.equals)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit) {
            if (strokeStyle !== undefined) applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
        }
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ endGeometry(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        const endGeometryInstruction = [
            (0, $hNBYx.default).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    }
    /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ getBufferedMaxExtent() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $9pD6L.clone)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                const width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $9pD6L.buffer)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    }
}
var $2bb20f8873deb436$export$2e2bcd8739ae039 = $2bb20f8873deb436$var$CanvasBuilder;

});
parcelRegister("hNBYx", function(module, exports) {

$parcel$export(module.exports, "fillInstruction", () => $cf547866e052f25b$export$f21891651e408226);
$parcel$export(module.exports, "strokeInstruction", () => $cf547866e052f25b$export$7a98aa5364d62ba8);
$parcel$export(module.exports, "beginPathInstruction", () => $cf547866e052f25b$export$9f746cc58a899a00);
$parcel$export(module.exports, "closePathInstruction", () => $cf547866e052f25b$export$89b10f327e413e71);
$parcel$export(module.exports, "default", () => $cf547866e052f25b$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ const $cf547866e052f25b$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
const $cf547866e052f25b$export$f21891651e408226 = [
    $cf547866e052f25b$var$Instruction.FILL
];
const $cf547866e052f25b$export$7a98aa5364d62ba8 = [
    $cf547866e052f25b$var$Instruction.STROKE
];
const $cf547866e052f25b$export$9f746cc58a899a00 = [
    $cf547866e052f25b$var$Instruction.BEGIN_PATH
];
const $cf547866e052f25b$export$89b10f327e413e71 = [
    $cf547866e052f25b$var$Instruction.CLOSE_PATH
];
var $cf547866e052f25b$export$2e2bcd8739ae039 = $cf547866e052f25b$var$Instruction;

});

parcelRegister("kbchp", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb0e5c3938110b4c$export$2e2bcd8739ae039);
/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ class $eb0e5c3938110b4c$var$VectorContext {
    /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {}
    /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */ drawGeometry(geometry) {}
    /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */ setStyle(style) {}
    /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {}
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   * @param {number} [index] Render order index.
   */ drawFeature(feature, style, index) {}
    /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawGeometryCollection(geometryCollectionGeometry, feature, index) {}
    /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {}
    /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {}
    /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {}
    /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */ setImageStyle(imageStyle, declutterImageWithText) {}
    /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */ setTextStyle(textStyle, declutterImageWithText) {}
}
var $eb0e5c3938110b4c$export$2e2bcd8739ae039 = $eb0e5c3938110b4c$var$VectorContext;

});


parcelRegister("fEvr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b652f9dd73b29cfe$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/ImageBuilder
 */ 
var $3KABr = parcelRequire("3KABr");

var $hNBYx = parcelRequire("hNBYx");

var $9pD6L = parcelRequire("9pD6L");
class $b652f9dd73b29cfe$var$CanvasImageBuilder extends (0, $3KABr.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.imagePixelRatio_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */ this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = undefined;
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {
        if (!this.image_ || this.maxExtent && !(0, $9pD6L.containsCoordinate)(this.maxExtent, pointGeometry.getFlatCoordinates())) return;
        this.beginGeometry(pointGeometry, feature, index);
        const flatCoordinates = pointGeometry.getFlatCoordinates();
        const stride = pointGeometry.getStride();
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $hNBYx.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $hNBYx.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature, index);
        const flatCoordinates = multiPointGeometry.getFlatCoordinates();
        const filteredFlatCoordinates = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += multiPointGeometry.getStride())if (!this.maxExtent || (0, $9pD6L.containsCoordinate)(this.maxExtent, flatCoordinates.slice(i, i + 2))) filteredFlatCoordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(filteredFlatCoordinates, 2);
        this.instructions.push([
            (0, $hNBYx.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $hNBYx.default).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return super.finish();
    }
    /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   */ setImageStyle(imageStyle, sharedData) {
        const anchor = imageStyle.getAnchor();
        const size = imageStyle.getSize();
        const origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
        this.image_ = imageStyle.getImage(this.pixelRatio);
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterMode_ = imageStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $b652f9dd73b29cfe$export$2e2bcd8739ae039 = $b652f9dd73b29cfe$var$CanvasImageBuilder;

});

parcelRegister("dUudE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a207f23baa5aa2c5$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/LineStringBuilder
 */ 
var $3KABr = parcelRequire("3KABr");

var $hNBYx = parcelRequire("hNBYx");

var $ig1j9 = parcelRequire("ig1j9");
class $a207f23baa5aa2c5$var$CanvasLineStringBuilder extends (0, $3KABr.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} end.
   */ drawFlatCoordinates_(flatCoordinates, offset, end, stride) {
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        const moveToLineToInstruction = [
            (0, $hNBYx.default).MOVE_TO_LINE_TO,
            myBegin,
            myEnd
        ];
        this.instructions.push(moveToLineToInstruction);
        this.hitDetectionInstructions.push(moveToLineToInstruction);
        return end;
    }
    /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $ig1j9.defaultLineDash),
            (0, $ig1j9.defaultLineDashOffset)
        ], (0, $hNBYx.beginPathInstruction));
        const flatCoordinates = lineStringGeometry.getFlatCoordinates();
        const stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.hitDetectionInstructions.push((0, $hNBYx.strokeInstruction));
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $ig1j9.defaultLineDash),
            (0, $ig1j9.defaultLineDashOffset)
        ], (0, $hNBYx.beginPathInstruction));
        const ends = multiLineStringGeometry.getEnds();
        const flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        const stride = multiLineStringGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride);
        this.hitDetectionInstructions.push((0, $hNBYx.strokeInstruction));
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        const state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $hNBYx.strokeInstruction));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return super.finish();
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $hNBYx.strokeInstruction));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        super.applyStroke(state);
        this.instructions.push((0, $hNBYx.beginPathInstruction));
    }
}
var $a207f23baa5aa2c5$export$2e2bcd8739ae039 = $a207f23baa5aa2c5$var$CanvasLineStringBuilder;

});

parcelRegister("aKl4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2e8ba11a45ae8a$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/PolygonBuilder
 */ 
var $3KABr = parcelRequire("3KABr");

var $hNBYx = parcelRequire("hNBYx");

var $ig1j9 = parcelRequire("ig1j9");

var $bDhby = parcelRequire("bDhby");
class $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder extends (0, $3KABr.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawFlatCoordinatess_(flatCoordinates, offset, ends, stride) {
        const state = this.state;
        const fill = state.fillStyle !== undefined;
        const stroke = state.strokeStyle !== undefined;
        const numEnds = ends.length;
        this.instructions.push((0, $hNBYx.beginPathInstruction));
        this.hitDetectionInstructions.push((0, $hNBYx.beginPathInstruction));
        for(let i = 0; i < numEnds; ++i){
            const end = ends[i];
            const myBegin = this.coordinates.length;
            const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            const moveToLineToInstruction = [
                (0, $hNBYx.default).MOVE_TO_LINE_TO,
                myBegin,
                myEnd
            ];
            this.instructions.push(moveToLineToInstruction);
            this.hitDetectionInstructions.push(moveToLineToInstruction);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, $hNBYx.closePathInstruction));
                this.hitDetectionInstructions.push((0, $hNBYx.closePathInstruction));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $hNBYx.fillInstruction));
            this.hitDetectionInstructions.push((0, $hNBYx.fillInstruction));
        }
        if (stroke) {
            this.instructions.push((0, $hNBYx.strokeInstruction));
            this.hitDetectionInstructions.push((0, $hNBYx.strokeInstruction));
        }
        return offset;
    }
    /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_FILL_STYLE,
            (0, $ig1j9.defaultFillStyle)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $ig1j9.defaultLineDash),
            (0, $ig1j9.defaultLineDashOffset)
        ]);
        const flatCoordinates = circleGeometry.getFlatCoordinates();
        const stride = circleGeometry.getStride();
        const myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        const circleInstruction = [
            (0, $hNBYx.default).CIRCLE,
            myBegin
        ];
        this.instructions.push((0, $hNBYx.beginPathInstruction), circleInstruction);
        this.hitDetectionInstructions.push((0, $hNBYx.beginPathInstruction), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, $hNBYx.fillInstruction));
            this.hitDetectionInstructions.push((0, $hNBYx.fillInstruction));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $hNBYx.strokeInstruction));
            this.hitDetectionInstructions.push((0, $hNBYx.strokeInstruction));
        }
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_FILL_STYLE,
            (0, $ig1j9.defaultFillStyle)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $ig1j9.defaultLineDash),
            (0, $ig1j9.defaultLineDashOffset)
        ]);
        const ends = polygonGeometry.getEnds();
        const flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        const stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_FILL_STYLE,
            (0, $ig1j9.defaultFillStyle)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $hNBYx.default).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $ig1j9.defaultLineDash),
            (0, $ig1j9.defaultLineDashOffset)
        ]);
        const endss = multiPolygonGeometry.getEndss();
        const flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        const stride = multiPolygonGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        const tolerance = this.tolerance;
        if (tolerance !== 0) {
            const coordinates = this.coordinates;
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $bDhby.snap)(coordinates[i], tolerance);
        }
        return super.finish();
    }
    /**
   * @private
   */ setFillStrokeStyles_() {
        const state = this.state;
        const fillStyle = state.fillStyle;
        if (fillStyle !== undefined) this.updateFillStyle(state, this.createFill);
        if (state.strokeStyle !== undefined) this.updateStrokeStyle(state, this.applyStroke);
    }
}
var $7d2e8ba11a45ae8a$export$2e2bcd8739ae039 = $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder;

});

parcelRegister("bboJK", function(module, exports) {

$parcel$export(module.exports, "TEXT_ALIGN", () => $8243e906fae47bbe$export$91a016276e4aee96);
$parcel$export(module.exports, "default", () => $8243e906fae47bbe$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/TextBuilder
 */ 
var $3KABr = parcelRequire("3KABr");

var $hNBYx = parcelRequire("hNBYx");

var $jh19n = parcelRequire("jh19n");

var $ig1j9 = parcelRequire("ig1j9");

var $9iPUS = parcelRequire("9iPUS");

var $9pD6L = parcelRequire("9pD6L");

var $adx6x = parcelRequire("adx6x");

var $apNsw = parcelRequire("apNsw");
const $8243e906fae47bbe$export$91a016276e4aee96 = {
    "left": 0,
    "center": 0.5,
    "right": 1,
    "top": 0,
    "middle": 0.5,
    "hanging": 0.2,
    "alphabetic": 0.8,
    "ideographic": 0.8,
    "bottom": 1
};
class $8243e906fae47bbe$var$CanvasTextBuilder extends (0, $3KABr.default) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ this.labels_ = null;
        /**
     * @private
     * @type {string|Array<string>}
     */ this.text_ = "";
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = {};
        this.fillStates[0, $ig1j9.defaultFillStyle] = {
            fillStyle: (0, $ig1j9.defaultFillStyle)
        };
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = {};
        /**
     * @private
     * @type {string}
     */ this.textKey_ = "";
        /**
     * @private
     * @type {string}
     */ this.fillKey_ = "";
        /**
     * @private
     * @type {string}
     */ this.strokeKey_ = "";
        /**
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        const instructions = super.finish();
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {
        const fillState = this.textFillState_;
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        if (this.text_ === "" || !textState || !fillState && !strokeState) return;
        const coordinates = this.coordinates;
        let begin = coordinates.length;
        const geometryType = geometry.getType();
        let flatCoordinates = null;
        let stride = geometry.getStride();
        if (textState.placement === "line" && (geometryType == "LineString" || geometryType == "MultiLineString" || geometryType == "Polygon" || geometryType == "MultiPolygon")) {
            if (!(0, $9pD6L.intersects)(this.maxExtent, geometry.getExtent())) return;
            let ends;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == "LineString") ends = [
                flatCoordinates.length
            ];
            else if (geometryType == "MultiLineString") ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == "Polygon") ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == "MultiPolygon") {
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(let i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature, index);
            const repeat = textState.repeat;
            const textAlign = repeat ? undefined : textState.textAlign;
            // No `justify` support for line placement.
            let flatOffset = 0;
            for(let o = 0, oo = ends.length; o < oo; ++o){
                let chunks;
                if (repeat) chunks = (0, $adx6x.lineChunk)(repeat * this.resolution, flatCoordinates, flatOffset, ends[o], stride);
                else chunks = [
                    flatCoordinates.slice(flatOffset, ends[o])
                ];
                for(let c = 0, cc = chunks.length; c < cc; ++c){
                    const chunk = chunks[c];
                    let chunkBegin = 0;
                    let chunkEnd = chunk.length;
                    if (textAlign == undefined) {
                        const range = (0, $apNsw.matchingChunk)(textState.maxAngle, chunk, 0, chunk.length, 2);
                        chunkBegin = range[0];
                        chunkEnd = range[1];
                    }
                    for(let i = chunkBegin; i < chunkEnd; i += stride)coordinates.push(chunk[i], chunk[i + 1]);
                    const end = coordinates.length;
                    flatOffset = ends[o];
                    this.drawChars_(begin, end);
                    begin = end;
                }
            }
            this.endGeometry(feature);
        } else {
            let geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case "Point":
                case "MultiPoint":
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case "LineString":
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case "Circle":
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case "MultiLineString":
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case "Polygon":
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case "MultiPolygon":
                    const interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(let i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            const end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
                let beg = begin / 2;
                geometryWidths = geometryWidths.filter((w, i)=>{
                    const keep = coordinates[(beg + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) --beg;
                    return keep;
                });
            }
            this.saveTextStates_();
            if (textState.backgroundFill || textState.backgroundStroke) {
                this.setFillStrokeStyle(textState.backgroundFill, textState.backgroundStroke);
                if (textState.backgroundFill) this.updateFillStyle(this.state, this.createFill);
                if (textState.backgroundStroke) {
                    this.updateStrokeStyle(this.state, this.applyStroke);
                    this.hitDetectionInstructions.push(this.createStroke(this.state));
                }
            }
            this.beginGeometry(geometry, feature, index);
            // adjust padding for negative scale
            let padding = textState.padding;
            if (padding != (0, $ig1j9.defaultPadding) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                let p0 = textState.padding[0];
                let p1 = textState.padding[1];
                let p2 = textState.padding[2];
                let p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            const pixelRatio = this.pixelRatio;
            this.instructions.push([
                (0, $hNBYx.default).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding == (0, $ig1j9.defaultPadding) ? (0, $ig1j9.defaultPadding) : padding.map(function(p) {
                    return p * pixelRatio;
                }),
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            const scale = 1 / pixelRatio;
            // Set default fill for hit detection background
            const currentFillStyle = this.state.fillStyle;
            if (textState.backgroundFill) {
                this.state.fillStyle = (0, $ig1j9.defaultFillStyle);
                this.hitDetectionInstructions.push(this.createFill(this.state));
            }
            this.hitDetectionInstructions.push([
                (0, $hNBYx.default).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding,
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_ ? (0, $ig1j9.defaultFillStyle) : this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            // Reset previous fill
            if (textState.backgroundFill) {
                this.state.fillStyle = currentFillStyle;
                this.hitDetectionInstructions.push(this.createFill(this.state));
            }
            this.endGeometry(feature);
        }
    }
    /**
   * @private
   */ saveTextStates_() {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const fillState = this.textFillState_;
        const strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        const textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, $ig1j9.defaultTextAlign),
            justify: textState.justify,
            textBaseline: textState.textBaseline || (0, $ig1j9.defaultTextBaseline),
            scale: textState.scale
        };
        const fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    }
    /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */ drawChars_(begin, end) {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const strokeKey = this.strokeKey_;
        const textKey = this.textKey_;
        const fillKey = this.fillKey_;
        this.saveTextStates_();
        const pixelRatio = this.pixelRatio;
        const baseline = $8243e906fae47bbe$export$91a016276e4aee96[textState.textBaseline];
        const offsetY = this.textOffsetY_ * pixelRatio;
        const text = this.text_;
        const strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, $hNBYx.default).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1,
            this.declutterMode_
        ]);
        this.hitDetectionInstructions.push([
            (0, $hNBYx.default).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey ? (0, $ig1j9.defaultFillStyle) : fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1 / pixelRatio,
            this.declutterMode_
        ]);
    }
    /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   */ setTextStyle(textStyle, sharedData) {
        let textState, fillState, strokeState;
        if (!textStyle) this.text_ = "";
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, $jh19n.asColorLike)(textFillStyle.getColor() || (0, $ig1j9.defaultFillStyle));
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                const lineDash = textStrokeStyle.getLineDash();
                const lineDashOffset = textStrokeStyle.getLineDashOffset();
                const lineWidth = textStrokeStyle.getWidth();
                const miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $ig1j9.defaultLineCap);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $ig1j9.defaultLineDash);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $ig1j9.defaultLineDashOffset) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $ig1j9.defaultLineJoin);
                strokeState.lineWidth = lineWidth === undefined ? (0, $ig1j9.defaultLineWidth) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $ig1j9.defaultMiterLimit) : miterLimit;
                strokeState.strokeStyle = (0, $jh19n.asColorLike)(textStrokeStyle.getColor() || (0, $ig1j9.defaultStrokeStyle));
            }
            textState = this.textState_;
            const font = textStyle.getFont() || (0, $ig1j9.defaultFont);
            (0, $ig1j9.registerFont)(font);
            const textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.repeat = textStyle.getRepeat();
            textState.justify = textStyle.getJustify();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $ig1j9.defaultTextBaseline);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $ig1j9.defaultPadding);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || "";
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == "string" ? strokeState.strokeStyle : (0, $9iPUS.getUid)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + "|" + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + "[" + strokeState.lineDash.join() + "]" : "";
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || "?") + (textState.repeat || "?") + (textState.justify || "?") + (textState.textBaseline || "?");
            this.fillKey_ = fillState && fillState.fillStyle ? typeof fillState.fillStyle == "string" ? fillState.fillStyle : "|" + (0, $9iPUS.getUid)(fillState.fillStyle) : "";
        }
        this.declutterMode_ = textStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $8243e906fae47bbe$export$2e2bcd8739ae039 = $8243e906fae47bbe$var$CanvasTextBuilder;

});
parcelRegister("adx6x", function(module, exports) {

$parcel$export(module.exports, "lineChunk", () => $7704cc1df2ddb619$export$f08272c6ff321e57);

var $9byFX = parcelRequire("9byFX");
function $7704cc1df2ddb619$export$f08272c6ff321e57(chunkLength, flatCoordinates, offset, end, stride) {
    const chunks = [];
    let cursor = offset;
    let chunkM = 0;
    let currentChunk = flatCoordinates.slice(offset, 2);
    while(chunkM < chunkLength && cursor + stride < end){
        const [x1, y1] = currentChunk.slice(-2);
        const x2 = flatCoordinates[cursor + stride];
        const y2 = flatCoordinates[cursor + stride + 1];
        const segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        chunkM += segmentLength;
        if (chunkM >= chunkLength) {
            const m = (chunkLength - chunkM + segmentLength) / segmentLength;
            const x = (0, $9byFX.lerp)(x1, x2, m);
            const y = (0, $9byFX.lerp)(y1, y2, m);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            if (chunkM == chunkLength) cursor += stride;
            chunkM = 0;
        } else if (chunkM < chunkLength) {
            currentChunk.push(flatCoordinates[cursor + stride], flatCoordinates[cursor + stride + 1]);
            cursor += stride;
        } else {
            const missing = segmentLength - chunkM;
            const x = (0, $9byFX.lerp)(x1, x2, missing / segmentLength);
            const y = (0, $9byFX.lerp)(y1, y2, missing / segmentLength);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            chunkM = 0;
            cursor += stride;
        }
    }
    if (chunkM > 0) chunks.push(currentChunk);
    return chunks;
}

});

parcelRegister("apNsw", function(module, exports) {

$parcel$export(module.exports, "matchingChunk", () => $79529ab61b92f869$export$ed6c897eea07a254);
/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $79529ab61b92f869$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    let chunkStart = offset;
    let chunkEnd = offset;
    let chunkM = 0;
    let m = 0;
    let start = offset;
    let acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}

});



parcelRegister("e1c3o", function(module, exports) {

$parcel$export(module.exports, "ALL", () => $a34a824d875e4ea1$export$61b49a5ae59d663);
$parcel$export(module.exports, "DECLUTTER", () => $a34a824d875e4ea1$export$6195a93a6c97ce02);
$parcel$export(module.exports, "NON_DECLUTTER", () => $a34a824d875e4ea1$export$d0fe61ccfaa1ca87);
$parcel$export(module.exports, "default", () => $a34a824d875e4ea1$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/ExecutorGroup
 */ 
var $8GqJ6 = parcelRequire("8GqJ6");

var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $jpXrt = parcelRequire("jpXrt");

var $DfnQm = parcelRequire("DfnQm");

var $gn0g3 = parcelRequire("gn0g3");

var $1MAUi = parcelRequire("1MAUi");
const $a34a824d875e4ea1$export$61b49a5ae59d663 = [
    "Polygon",
    "Circle",
    "LineString",
    "Image",
    "Text",
    "Default"
];
const $a34a824d875e4ea1$export$6195a93a6c97ce02 = [
    "Image",
    "Text"
];
const $a34a824d875e4ea1$export$d0fe61ccfaa1ca87 = $a34a824d875e4ea1$export$61b49a5ae59d663.filter((builderType)=>!$a34a824d875e4ea1$export$6195a93a6c97ce02.includes(builderType));
class $a34a824d875e4ea1$var$ExecutorGroup {
    /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   * @param {boolean} [deferredRendering] Enable deferred rendering with renderDeferred().
   */ constructor(maxExtent, resolution, pixelRatio, overlaps, allInstructions, renderBuffer, deferredRendering){
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<string, import("./Executor").default>>}
     */ this.executorsByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.hitDetectionContext_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, $jpXrt.create)();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.renderedContext_ = null;
        /**
     * @type {Object<number, Array<import("./ZIndexContext.js").default>>}
     */ this.deferredZIndexContexts_ = {};
        this.createExecutors_(allInstructions, deferredRendering);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ clip(context, transform) {
        const flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    }
    /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<string, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   * @param {boolean} deferredRendering Enable deferred rendering.
   */ createExecutors_(allInstructions, deferredRendering) {
        for(const zIndex in allInstructions){
            let executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            const instructionByZindex = allInstructions[zIndex];
            for(const builderType in instructionByZindex){
                const instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, $8GqJ6.default)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions, deferredRendering);
            }
        }
    }
    /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */ hasExecutors(executors) {
        for(const zIndex in this.executorsByZIndex_){
            const candidates = this.executorsByZIndex_[zIndex];
            for(let i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        hitTolerance = Math.round(hitTolerance);
        const contextSize = hitTolerance * 2 + 1;
        const transform = (0, $jpXrt.compose)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        const newContext = !this.hitDetectionContext_;
        if (newContext) this.hitDetectionContext_ = (0, $DfnQm.createCanvasContext2D)(contextSize, contextSize, undefined, {
            willReadFrequently: true
        });
        const context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /**
     * @type {import("../../extent.js").Extent}
     */ let hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $9pD6L.createEmpty)();
            (0, $9pD6L.extendCoordinate)(hitExtent, coordinate);
            (0, $9pD6L.buffer)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        const indexes = $a34a824d875e4ea1$export$96fc84ea21b8269f(hitTolerance);
        let builderType;
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import('../../style/Style.js').DeclutterMode} declutterMode Declutter mode.
     * @return {T|undefined} Callback result.
     */ function featureCallback(feature, geometry, declutterMode) {
            const imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(let i = 0, ii = indexes.length; i < ii; i++)if (imageData[indexes[i]] > 0) {
                if (!declutteredFeatures || declutterMode === "none" || builderType !== "Image" && builderType !== "Text" || declutteredFeatures.includes(feature)) {
                    const idx = (indexes[i] - 3) / 4;
                    const x = hitTolerance - idx % contextSize;
                    const y = hitTolerance - (idx / contextSize | 0);
                    const result = callback(feature, geometry, x * x + y * y);
                    if (result) return result;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $fVVyM.ascending));
        let i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            const zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = $a34a824d875e4ea1$export$61b49a5ae59d663.length - 1; j >= 0; --j){
                builderType = $a34a824d875e4ea1$export$61b49a5ae59d663[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */ getClipCoords(transform) {
        const maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        const minX = maxExtent[0];
        const minY = maxExtent[1];
        const maxX = maxExtent[2];
        const maxY = maxExtent[3];
        const flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $1MAUi.transform2D)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $gn0g3.isEmpty)(this.executorsByZIndex_);
    }
    /**
   * @param {CanvasRenderingContext2D} targetContext Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ALL}
   * @param {import("rbush").default|null} [declutterTree] Declutter tree.
   *     When set to null, no decluttering is done, even when the executor group has a `ZIndexContext`.
   */ execute(targetContext, scaledCanvasSize, transform, viewRotation, snapToPixel, builderTypes, declutterTree) {
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $fVVyM.ascending));
        builderTypes = builderTypes ? builderTypes : $a34a824d875e4ea1$export$61b49a5ae59d663;
        const maxBuilderTypes = $a34a824d875e4ea1$export$61b49a5ae59d663.length;
        let i, ii, j, jj, replays;
        if (declutterTree) zs.reverse();
        for(i = 0, ii = zs.length; i < ii; ++i){
            const zIndexKey = zs[i].toString();
            replays = this.executorsByZIndex_[zIndexKey];
            for(j = 0, jj = builderTypes.length; j < jj; ++j){
                const builderType = builderTypes[j];
                const replay = replays[builderType];
                if (replay !== undefined) {
                    const zIndexContext = declutterTree === null ? undefined : replay.getZIndexContext();
                    const context = zIndexContext ? zIndexContext.getContext() : targetContext;
                    const requireClip = this.maxExtent_ && builderType !== "Image" && builderType !== "Text";
                    if (requireClip) {
                        context.save();
                        // setup clipping so that the parts of over-simplified geometries are not
                        // visible outside the current extent when panning
                        this.clip(context, transform);
                    }
                    if (!zIndexContext || builderType === "Text" || builderType === "Image") replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree);
                    else zIndexContext.pushFunction((context)=>replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree));
                    if (requireClip) context.restore();
                    if (zIndexContext) {
                        zIndexContext.offset();
                        const index = zs[i] * maxBuilderTypes + j;
                        if (!this.deferredZIndexContexts_[index]) this.deferredZIndexContexts_[index] = [];
                        this.deferredZIndexContexts_[index].push(zIndexContext);
                    }
                }
            }
        }
        this.renderedContext_ = targetContext;
    }
    getDeferredZIndexContexts() {
        return this.deferredZIndexContexts_;
    }
    getRenderedContext() {
        return this.renderedContext_;
    }
    renderDeferred() {
        const deferredZIndexContexts = this.deferredZIndexContexts_;
        const zs = Object.keys(deferredZIndexContexts).map(Number).sort((0, $fVVyM.ascending));
        for(let i = 0, ii = zs.length; i < ii; ++i){
            deferredZIndexContexts[zs[i]].forEach((zIndexContext)=>{
                zIndexContext.draw(this.renderedContext_); // FIXME Pass clip to replay for temporarily enabling clip
                zIndexContext.clear();
            });
            deferredZIndexContexts[zs[i]].length = 0;
        }
    }
}
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ const $a34a824d875e4ea1$var$circlePixelIndexArrayCache = {};
function $a34a824d875e4ea1$export$96fc84ea21b8269f(radius) {
    if ($a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] !== undefined) return $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius];
    const size = radius * 2 + 1;
    const maxDistanceSq = radius * radius;
    const distances = new Array(maxDistanceSq + 1);
    for(let i = 0; i <= radius; ++i)for(let j = 0; j <= radius; ++j){
        const distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        let distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    const pixelIndex = [];
    for(let i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push(...distances[i]);
    $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $a34a824d875e4ea1$export$2e2bcd8739ae039 = $a34a824d875e4ea1$var$ExecutorGroup;

});
parcelRegister("8GqJ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6526fa4ee42dc39d$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/Executor
 */ 
var $hNBYx = parcelRequire("hNBYx");

var $gDySU = parcelRequire("gDySU");

var $bboJK = parcelRequire("bboJK");

var $jpXrt = parcelRequire("jpXrt");

var $9pD6L = parcelRequire("9pD6L");

var $ig1j9 = parcelRequire("ig1j9");

var $l8Phk = parcelRequire("l8Phk");

var $fVVyM = parcelRequire("fVVyM");

var $goM6N = parcelRequire("goM6N");

var $1MAUi = parcelRequire("1MAUi");
/**
 * @typedef {Object} BBox
 * @property {number} minX Minimal x.
 * @property {number} minY Minimal y.
 * @property {number} maxX Maximal x.
 * @property {number} maxY Maximal y
 * @property {*} value Value.
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {BBox} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D, 1: import('../../size.js').Size, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, import("../../style/Style.js").DeclutterMode): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ const $6526fa4ee42dc39d$var$tmpExtent = (0, $9pD6L.createEmpty)();
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {BBox} Declutter bbox.
 */ function $6526fa4ee42dc39d$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
const $6526fa4ee42dc39d$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ "[" + String.fromCharCode(0x00591) + "-" + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + "-" + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + "-" + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + "-" + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + "-" + String.fromCharCode(0x1efff) + "]");
/**
 * @param {string} text Text.
 * @param {CanvasTextAlign} align Alignment.
 * @return {number} Text alignment.
 */ function $6526fa4ee42dc39d$var$horizontalTextAlign(text, align) {
    if (align === "start") align = $6526fa4ee42dc39d$var$rtlRegEx.test(text) ? "right" : "left";
    else if (align === "end") align = $6526fa4ee42dc39d$var$rtlRegEx.test(text) ? "left" : "right";
    return (0, $bboJK.TEXT_ALIGN)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function $6526fa4ee42dc39d$var$createTextChunks(acc, line, i) {
    if (i > 0) acc.push("\n", "");
    acc.push(line, "");
    return acc;
}
class $6526fa4ee42dc39d$var$Executor {
    /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions.
   * @param {boolean} [deferredRendering] Enable deferred rendering.
   */ constructor(resolution, pixelRatio, overlaps, instructions, deferredRendering){
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {number}
     */ this.alignAndScaleFill_;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = instructions.instructions;
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = instructions.coordinates;
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, $jpXrt.create)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = instructions.fillStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = instructions.strokeStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = instructions.textStates || {};
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        /**
     * @private
     * @type {Object<string, import("../canvas.js").Label>}
     */ this.labels_ = {};
        /**
     * @private
     * @type {import("../canvas/ZIndexContext.js").default}
     */ this.zIndexContext_ = deferredRendering ? new (0, $gDySU.default)() : null;
    }
    /**
   * @return {ZIndexContext} ZIndex context.
   */ getZIndexContext() {
        return this.zIndexContext_;
    }
    /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */ createLabel(text, textKey, fillKey, strokeKey) {
        const key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        const strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        const fillState = fillKey ? this.fillStates[fillKey] : null;
        const textState = this.textStates[textKey];
        const pixelRatio = this.pixelRatio;
        const scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        const textIsArray = Array.isArray(text);
        const align = textState.justify ? (0, $bboJK.TEXT_ALIGN)[textState.justify] : $6526fa4ee42dc39d$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $ig1j9.defaultTextAlign));
        const strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        const chunks = textIsArray ? text : text.split("\n").reduce($6526fa4ee42dc39d$var$createTextChunks, []);
        const { width: width, height: height, widths: widths, heights: heights, lineWidths: lineWidths } = (0, $ig1j9.getTextDimensions)(textState, chunks);
        const renderWidth = width + strokeWidth;
        const contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        const w = (renderWidth + 2) * scale[0];
        const h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ const label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push("scale", scale);
        if (strokeKey) {
            contextInstructions.push("strokeStyle", strokeState.strokeStyle);
            contextInstructions.push("lineWidth", strokeWidth);
            contextInstructions.push("lineCap", strokeState.lineCap);
            contextInstructions.push("lineJoin", strokeState.lineJoin);
            contextInstructions.push("miterLimit", strokeState.miterLimit);
            contextInstructions.push("setLineDash", [
                strokeState.lineDash
            ]);
            contextInstructions.push("lineDashOffset", strokeState.lineDashOffset);
        }
        if (fillKey) contextInstructions.push("fillStyle", fillState.fillStyle);
        contextInstructions.push("textBaseline", "middle");
        contextInstructions.push("textAlign", "center");
        const leftRight = 0.5 - align;
        let x = align * renderWidth + leftRight * strokeWidth;
        const strokeInstructions = [];
        const fillInstructions = [];
        let lineHeight = 0;
        let lineOffset = 0;
        let widthHeightIndex = 0;
        let lineWidthIndex = 0;
        let previousFont;
        for(let i = 0, ii = chunks.length; i < ii; i += 2){
            const text = chunks[i];
            if (text === "\n") {
                lineOffset += lineHeight;
                lineHeight = 0;
                x = align * renderWidth + leftRight * strokeWidth;
                ++lineWidthIndex;
                continue;
            }
            const font = chunks[i + 1] || textState.font;
            if (font !== previousFont) {
                if (strokeKey) strokeInstructions.push("font", font);
                if (fillKey) fillInstructions.push("font", font);
                previousFont = font;
            }
            lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
            const fillStrokeArgs = [
                text,
                x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                0.5 * (strokeWidth + lineHeight) + lineOffset
            ];
            x += widths[widthHeightIndex];
            if (strokeKey) strokeInstructions.push("strokeText", fillStrokeArgs);
            if (fillKey) fillInstructions.push("fillText", fillStrokeArgs);
            ++widthHeightIndex;
        }
        Array.prototype.push.apply(contextInstructions, strokeInstructions);
        Array.prototype.push.apply(contextInstructions, fillInstructions);
        this.labels_[key] = label;
        return label;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignAndScaleFill_ = /** @type {number} */ fillInstruction[2];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    }
    /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */ calculateImageOrLabelDimensions_(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        let x = centerX - anchorX;
        let y = centerY - anchorY;
        const w = width + originX > sheetWidth ? sheetWidth - originX : width;
        const h = height + originY > sheetHeight ? sheetHeight - originY : height;
        const boxW = padding[3] + w * scale[0] + padding[1];
        const boxH = padding[0] + h * scale[1] + padding[2];
        const boxX = x - padding[3];
        const boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            $6526fa4ee42dc39d$var$p1[0] = boxX;
            $6526fa4ee42dc39d$var$p4[0] = boxX;
            $6526fa4ee42dc39d$var$p1[1] = boxY;
            $6526fa4ee42dc39d$var$p2[1] = boxY;
            $6526fa4ee42dc39d$var$p2[0] = boxX + boxW;
            $6526fa4ee42dc39d$var$p3[0] = $6526fa4ee42dc39d$var$p2[0];
            $6526fa4ee42dc39d$var$p3[1] = boxY + boxH;
            $6526fa4ee42dc39d$var$p4[1] = $6526fa4ee42dc39d$var$p3[1];
        }
        let transform;
        if (rotation !== 0) {
            transform = (0, $jpXrt.compose)((0, $jpXrt.create)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $jpXrt.apply)(transform, $6526fa4ee42dc39d$var$p1);
            (0, $jpXrt.apply)(transform, $6526fa4ee42dc39d$var$p2);
            (0, $jpXrt.apply)(transform, $6526fa4ee42dc39d$var$p3);
            (0, $jpXrt.apply)(transform, $6526fa4ee42dc39d$var$p4);
            (0, $9pD6L.createOrUpdate)(Math.min($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.min($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), Math.max($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.max($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), $6526fa4ee42dc39d$var$tmpExtent);
        } else (0, $9pD6L.createOrUpdate)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $6526fa4ee42dc39d$var$tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: $6526fa4ee42dc39d$var$tmpExtent[0],
                minY: $6526fa4ee42dc39d$var$tmpExtent[1],
                maxX: $6526fa4ee42dc39d$var$tmpExtent[2],
                maxY: $6526fa4ee42dc39d$var$tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */ replayImageOrLabel_(context, scaledCanvasSize, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        const fillStroke = !!(fillInstruction || strokeInstruction);
        const box = dimensions.declutterBox;
        const strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        const intersects = box.minX - strokePadding <= scaledCanvasSize[0] && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= scaledCanvasSize[1] && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, $6526fa4ee42dc39d$var$p1, $6526fa4ee42dc39d$var$p2, $6526fa4ee42dc39d$var$p3, $6526fa4ee42dc39d$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $ig1j9.drawImageOrLabel)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   */ fill_(context) {
        const alignAndScale = this.alignAndScaleFill_;
        if (alignAndScale) {
            const origin = (0, $jpXrt.apply)(this.renderedTransform_, [
                0,
                0
            ]);
            const repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
            if (alignAndScale !== 1) context.scale(alignAndScale, alignAndScale);
            context.rotate(this.viewRotation_);
        }
        context.fill();
        if (alignAndScale) context.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ setStrokeStyle_(context, instruction) {
        context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        context.lineDashOffset = /** @type {number} */ instruction[7];
        context.setLineDash(/** @type {Array<number>} */ instruction[6]);
    }
    /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */ drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey) {
        const textState = this.textStates[textKey];
        const label = this.createLabel(text, textKey, fillKey, strokeKey);
        const strokeState = this.strokeStates[strokeKey];
        const pixelRatio = this.pixelRatio;
        const align = $6526fa4ee42dc39d$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $ig1j9.defaultTextAlign));
        const baseline = (0, $bboJK.TEXT_ALIGN)[textState.textBaseline || (0, $ig1j9.defaultTextBaseline)];
        const strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        const width = label.width / pixelRatio - 2 * textState.scale[0];
        const anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        const anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */ execute_(context, scaledCanvasSize, transform, instructions, snapToPixel, featureCallback, hitExtent, declutterTree) {
        const zIndexContext = this.zIndexContext_;
        /** @type {Array<number>} */ let pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $fVVyM.equals)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $1MAUi.transform2D)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $jpXrt.setFromArray)(this.renderedTransform_, transform);
        }
        let i = 0; // instruction index
        const ii = instructions.length; // end of instructions
        let d = 0; // data index
        let dd; // end of per-instruction data
        let anchorX, anchorY, /** @type {import('../../style/Style.js').DeclutterMode} */ declutterMode, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        let pendingFill = 0;
        let pendingStroke = 0;
        let lastFillInstruction = null;
        let lastStrokeInstruction = null;
        const coordinateCache = this.coordinateCache_;
        const viewRotation = this.viewRotation_;
        const viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        const state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        const batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        let /** @type {import("../../Feature.js").FeatureLike} */ feature;
        let x, y, currentGeometry;
        while(i < ii){
            const instruction = instructions[i];
            const type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, $hNBYx.default).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (hitExtent !== undefined && !(0, $9pD6L.intersects)(hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    if (zIndexContext) zIndexContext.zIndex = instruction[4];
                    break;
                case (0, $hNBYx.default).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $hNBYx.default).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    const x1 = pixelCoordinates[d];
                    const y1 = pixelCoordinates[d + 1];
                    const x2 = pixelCoordinates[d + 2];
                    const y2 = pixelCoordinates[d + 3];
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $hNBYx.default).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $hNBYx.default).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    const geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    const renderer = instruction[4];
                    const fn = instruction[5];
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    const coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    if (zIndexContext) zIndexContext.zIndex = instruction[6];
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $hNBYx.default).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    let height = /** @type {number} */ instruction[6];
                    const opacity = /** @type {number} */ instruction[7];
                    const originX = /** @type {number} */ instruction[8];
                    const originY = /** @type {number} */ instruction[9];
                    const rotateWithView = /** @type {boolean} */ instruction[10];
                    let rotation = /** @type {number} */ instruction[11];
                    const scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    let width = /** @type {number} */ instruction[13];
                    declutterMode = instruction[14] || "declutter";
                    const declutterImageWithText = /** @type {{args: import("../canvas.js").DeclutterImageWithText, declutterMode: import('../../style/Style.js').DeclutterMode}} */ instruction[15];
                    if (!image && instruction.length >= 20) {
                        // create label images
                        text = /** @type {string} */ instruction[19];
                        textKey = /** @type {string} */ instruction[20];
                        strokeKey = /** @type {string} */ instruction[21];
                        fillKey = /** @type {string} */ instruction[22];
                        const labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        const textOffsetX = /** @type {number} */ instruction[23];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        const textOffsetY = /** @type {number} */ instruction[24];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    let geometryWidths;
                    if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                    let padding, backgroundFill, backgroundStroke;
                    if (instruction.length > 17) {
                        padding = /** @type {Array<number>} */ instruction[16];
                        backgroundFill = /** @type {boolean} */ instruction[17];
                        backgroundStroke = /** @type {boolean} */ instruction[18];
                    } else {
                        padding = (0, $ig1j9.defaultPadding);
                        backgroundFill = false;
                        backgroundStroke = false;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    let widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        const dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, backgroundFill || backgroundStroke, feature);
                        /** @type {ReplayImageOrLabelArgs} */ const args = [
                            context,
                            scaledCanvasSize,
                            image,
                            dimensions,
                            opacity,
                            backgroundFill ? /** @type {Array<*>} */ lastFillInstruction : null,
                            backgroundStroke ? /** @type {Array<*>} */ lastStrokeInstruction : null
                        ];
                        if (declutterTree) {
                            let imageArgs, imageDeclutterMode, imageDeclutterBox;
                            if (declutterImageWithText) {
                                const index = dd - d;
                                if (!declutterImageWithText[index]) {
                                    // We now have the image for an image+text combination.
                                    declutterImageWithText[index] = {
                                        args: args,
                                        declutterMode: declutterMode
                                    };
                                    continue;
                                }
                                const imageDeclutter = declutterImageWithText[index];
                                imageArgs = imageDeclutter.args;
                                imageDeclutterMode = imageDeclutter.declutterMode;
                                delete declutterImageWithText[index];
                                imageDeclutterBox = $6526fa4ee42dc39d$var$getDeclutterBox(imageArgs);
                            }
                            // We now have image and text for an image+text combination.
                            let renderImage, renderText;
                            if (imageArgs && (imageDeclutterMode !== "declutter" || !declutterTree.collides(imageDeclutterBox))) renderImage = true;
                            if (declutterMode !== "declutter" || !declutterTree.collides(dimensions.declutterBox)) renderText = true;
                            if (imageDeclutterMode === "declutter" && declutterMode === "declutter") {
                                const render = renderImage && renderText;
                                renderImage = render;
                                renderText = render;
                            }
                            if (renderImage) {
                                if (imageDeclutterMode !== "none") declutterTree.insert(imageDeclutterBox);
                                this.replayImageOrLabel_.apply(this, imageArgs);
                            }
                            if (renderText) {
                                if (declutterMode !== "none") declutterTree.insert(dimensions.declutterBox);
                                this.replayImageOrLabel_.apply(this, args);
                            }
                        } else this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, $hNBYx.default).DRAW_CHARS:
                    const begin = /** @type {number} */ instruction[1];
                    const end = /** @type {number} */ instruction[2];
                    const baseline = /** @type {number} */ instruction[3];
                    const overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    const maxAngle = /** @type {number} */ instruction[6];
                    const measurePixelRatio = /** @type {number} */ instruction[7];
                    const offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    const strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string} */ instruction[11];
                    textKey = /** @type {string} */ instruction[12];
                    const pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    declutterMode = instruction[14] || "declutter";
                    const textState = this.textStates[textKey];
                    const font = textState.font;
                    const textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    let cachedWidths;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    const pathLength = (0, $goM6N.lineStringLength)(pixelCoordinates, begin, end, 2);
                    const textLength = Math.abs(textScale[0]) * (0, $ig1j9.measureAndCacheTextWidth)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        const textAlign = this.textStates[textKey].textAlign;
                        const startM = (pathLength - textLength) * $6526fa4ee42dc39d$var$horizontalTextAlign(text, textAlign);
                        const parts = (0, $l8Phk.drawTextOnPath)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $ig1j9.measureAndCacheTextWidth), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ const replayImageOrLabelArgs = [];
                            let c, cc, chars, label, part;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, "", strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $ig1j9.defaultPadding), false, feature);
                                if (declutterTree && declutterMode === "declutter" && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, "");
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $ig1j9.defaultPadding), false, feature);
                                if (declutterTree && declutterMode === "declutter" && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (declutterTree && declutterMode !== "none") declutterTree.load(replayImageOrLabelArgs.map($6526fa4ee42dc39d$var$getDeclutterBox));
                            for(let i = 0, ii = replayImageOrLabelArgs.length; i < ii; ++i)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i]);
                        }
                    }
                    ++i;
                    break;
                case (0, $hNBYx.default).END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        const result = featureCallback(feature, currentGeometry, declutterMode);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $hNBYx.default).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $hNBYx.default).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    context.moveTo(x, y);
                    prevX = x + 0.5 | 0;
                    prevY = y + 0.5 | 0;
                    for(d += 2; d < dd; d += 2){
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $hNBYx.default).SET_FILL_STYLE:
                    lastFillInstruction = instruction;
                    this.alignAndScaleFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    /** @type {import("../../colorlike.js").ColorLike} */ context.fillStyle = instruction[1];
                    ++i;
                    break;
                case (0, $hNBYx.default).SET_STROKE_STYLE:
                    lastStrokeInstruction = instruction;
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $hNBYx.default).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default} [declutterTree] Declutter tree.
   */ execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, scaledCanvasSize, transform, this.instructions, snapToPixel, undefined, undefined, declutterTree);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ executeHitDetection(context, transform, viewRotation, featureCallback, hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, [
            context.canvas.width,
            context.canvas.height
        ], transform, this.hitDetectionInstructions, true, featureCallback, hitExtent);
    }
}
var $6526fa4ee42dc39d$export$2e2bcd8739ae039 = $6526fa4ee42dc39d$var$Executor;

});
parcelRegister("l8Phk", function(module, exports) {

$parcel$export(module.exports, "drawTextOnPath", () => $f6421f31729929e6$export$153a9a17ab3e949f);
/**
 * @module ol/geom/flat/textpath
 */ 
var $9byFX = parcelRequire("9byFX");

var $1MAUi = parcelRequire("1MAUi");
function $f6421f31729929e6$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation) {
    let x2 = flatCoordinates[offset];
    let y2 = flatCoordinates[offset + 1];
    let x1 = 0;
    let y1 = 0;
    let segmentLength = 0;
    let segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    let interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    const beginX = (0, $9byFX.lerp)(x1, x2, interpolate);
    const beginY = (0, $9byFX.lerp)(y1, y2, interpolate);
    const startOffset = offset - stride;
    const startLength = segmentM;
    const endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    const endX = (0, $9byFX.lerp)(x1, x2, interpolate);
    const endY = (0, $9byFX.lerp)(y1, y2, interpolate);
    // Keep text upright
    let reverse;
    if (rotation) {
        const flat = [
            beginX,
            beginY,
            endX,
            endY
        ];
        (0, $1MAUi.rotate)(flat, 0, 4, 2, rotation, flat, flat);
        reverse = flat[0] > flat[2];
    } else reverse = beginX > endX;
    const PI = Math.PI;
    const result = [];
    const singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    let previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        const x = (endX + beginX) / 2;
        const y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, " "); // ensure rendering in single-line as all calculations below don't handle multi-lines
    for(let i = 0, ii = text.length; i < ii;){
        advance();
        let angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            let delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        const iStart = i;
        let charLength = 0;
        for(; i < ii; ++i){
            const index = reverse ? ii - i - 1 : i;
            const len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        const chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        const x = (0, $9byFX.lerp)(x1, x2, interpolate);
        const y = (0, $9byFX.lerp)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}

});

parcelRegister("goM6N", function(module, exports) {

$parcel$export(module.exports, "lineStringLength", () => $bf04349d827c1d16$export$153f8c6b4d8caebc);
/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    let length = 0;
    for(let i = offset + stride; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $bf04349d827c1d16$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    let perimeter = $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    const dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    const dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}

});



parcelRegister("1HMKO", function(module, exports) {

$parcel$export(module.exports, "HIT_DETECT_RESOLUTION", () => $13dfa0283bf5c35f$export$ab51038298418f25);
$parcel$export(module.exports, "createHitDetectionImageData", () => $13dfa0283bf5c35f$export$bd05e394339d469);
$parcel$export(module.exports, "hitDetect", () => $13dfa0283bf5c35f$export$6d4d555ddbfffa32);
/**
 * @module ol/render/canvas/hitdetect
 */ 
var $ayYEF = parcelRequire("ayYEF");

var $bmHVE = parcelRequire("bmHVE");

var $fVVyM = parcelRequire("fVVyM");

var $9byFX = parcelRequire("9byFX");

var $DfnQm = parcelRequire("DfnQm");

var $dpRHA = parcelRequire("dpRHA");

var $9pD6L = parcelRequire("9pD6L");
const $13dfa0283bf5c35f$export$ab51038298418f25 = 0.5;
function $13dfa0283bf5c35f$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation, squaredTolerance, projection) {
    const userExtent = projection ? (0, $dpRHA.toUserExtent)(extent, projection) : extent;
    const width = size[0] * $13dfa0283bf5c35f$export$ab51038298418f25;
    const height = size[1] * $13dfa0283bf5c35f$export$ab51038298418f25;
    const context = (0, $DfnQm.createCanvasContext2D)(width, height);
    context.imageSmoothingEnabled = false;
    const canvas = context.canvas;
    const renderer = new (0, $ayYEF.default)(context, $13dfa0283bf5c35f$export$ab51038298418f25, extent, null, rotation, squaredTolerance, projection ? (0, $dpRHA.getTransformFromProjections)((0, $dpRHA.getUserProjection)(), projection) : null);
    const featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    const indexFactor = Math.floor(16777215 / featureCount);
    const featuresByZIndex = {};
    for(let i = 1; i <= featureCount; ++i){
        const feature = features[i - 1];
        const featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!featureStyleFunction) continue;
        let styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        const index = i * indexFactor;
        const color = index.toString(16).padStart(7, "#00000");
        for(let j = 0, jj = styles.length; j < jj; ++j){
            const originalStyle = styles[j];
            const geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, $9pD6L.intersects)(userExtent, geometry.getExtent())) continue;
            const style = originalStyle.clone();
            const fill = style.getFill();
            if (fill) fill.setColor(color);
            const stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            const image = originalStyle.getImage();
            if (image) {
                const imgSize = image.getImageSize();
                if (!imgSize) continue;
                const imgContext = (0, $DfnQm.createCanvasContext2D)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                const img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, $bmHVE.default)({
                    img: img,
                    anchor: image.getAnchor(),
                    anchorXUnits: "pixels",
                    anchorYUnits: "pixels",
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            const zIndex = style.getZIndex() || 0;
            let byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType["Polygon"] = [];
                byGeometryType["Circle"] = [];
                byGeometryType["LineString"] = [];
                byGeometryType["Point"] = [];
            }
            const type = geometry.getType();
            if (type === "GeometryCollection") {
                const geometries = /** @type {import("../../geom/GeometryCollection.js").default} */ geometry.getGeometriesArrayRecursive();
                for(let i = 0, ii = geometries.length; i < ii; ++i){
                    const geometry = geometries[i];
                    byGeometryType[geometry.getType().replace("Multi", "")].push(geometry, style);
                }
            } else byGeometryType[type.replace("Multi", "")].push(geometry, style);
        }
    }
    const zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $fVVyM.ascending));
    for(let i = 0, ii = zIndexKeys.length; i < ii; ++i){
        const byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(const type in byGeometryType){
            const geomAndStyle = byGeometryType[type];
            for(let j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(let k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $13dfa0283bf5c35f$export$6d4d555ddbfffa32(pixel, features, imageData) {
    /** @type {Array<F>} */ const resultFeatures = [];
    if (imageData) {
        const x = Math.floor(Math.round(pixel[0]) * $13dfa0283bf5c35f$export$ab51038298418f25);
        const y = Math.floor(Math.round(pixel[1]) * $13dfa0283bf5c35f$export$ab51038298418f25);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        const index = ((0, $9byFX.clamp)(x, 0, imageData.width - 1) + (0, $9byFX.clamp)(y, 0, imageData.height - 1) * imageData.width) * 4;
        const r = imageData.data[index];
        const g = imageData.data[index + 1];
        const b = imageData.data[index + 2];
        const i = b + 256 * (g + 256 * r);
        const indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}

});
parcelRegister("ayYEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0c2128a27f5020$export$2e2bcd8739ae039);
/**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?

var $kbchp = parcelRequire("kbchp");

var $jh19n = parcelRequire("jh19n");

var $jpXrt = parcelRequire("jpXrt");

var $ig1j9 = parcelRequire("ig1j9");

var $fVVyM = parcelRequire("fVVyM");

var $9pD6L = parcelRequire("9pD6L");

var $9byFX = parcelRequire("9byFX");

var $1MAUi = parcelRequire("1MAUi");

var $h7zsK = parcelRequire("h7zsK");
/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ class $7b0c2128a27f5020$var$CanvasImmediateRenderer extends (0, $kbchp.default) {
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */ constructor(context, pixelRatio, extent, transform, viewRotation, squaredTolerance, userTransform){
        super();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.context_ = context;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ this.transformRotation_ = transform ? (0, $9byFX.toFixed)(Math.atan2(transform[1], transform[0]), 10) : 0;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_ = squaredTolerance;
        /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */ this.userTransform_ = userTransform;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.strokeState_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.imageRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.imageScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ this.text_ = "";
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.textScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpLocalTransform_ = (0, $jpXrt.create)();
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawImages_(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        const pixelCoordinates = (0, $1MAUi.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        const localTransform = this.tmpLocalTransform_;
        const alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        let rotation = this.imageRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(let i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            const x = pixelCoordinates[i] - this.imageAnchorX_;
            const y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                const centerX = x + this.imageAnchorX_;
                const centerY = y + this.imageAnchorY_;
                (0, $jpXrt.compose)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.save();
                context.transform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.restore();
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawText_(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === "") return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        const pixelCoordinates = (0, $1MAUi.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        let rotation = this.textRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            const x = pixelCoordinates[offset] + this.textOffsetX_;
            const y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                context.save();
                context.translate(x - this.textOffsetX_, y - this.textOffsetY_);
                context.rotate(rotation);
                context.translate(this.textOffsetX_, this.textOffsetY_);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.restore();
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @private
   * @return {number} end End.
   */ moveToLineTo_(flatCoordinates, offset, end, stride, close) {
        const context = this.context_;
        const pixelCoordinates = (0, $1MAUi.transform2D)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        let length = pixelCoordinates.length;
        if (close) length -= 2;
        for(let i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawRings_(flatCoordinates, offset, ends, stride) {
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
        return offset;
    }
    /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   */ drawCircle(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Circle.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $9pD6L.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const pixelCoordinates = (0, $h7zsK.transformGeom2D)(geometry, this.transform_, this.pixelCoordinates_);
            const dx = pixelCoordinates[2] - pixelCoordinates[0];
            const dy = pixelCoordinates[3] - pixelCoordinates[1];
            const radius = Math.sqrt(dx * dx + dy * dy);
            const context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") this.drawText_(geometry.getCenter(), 0, 2, 2);
    }
    /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   */ setStyle(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */ setTransform(transform) {
        this.transform_ = transform;
    }
    /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   */ drawGeometry(geometry) {
        const type = geometry.getType();
        switch(type){
            case "Point":
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case "LineString":
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case "Polygon":
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case "MultiPoint":
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case "MultiLineString":
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case "MultiPolygon":
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case "GeometryCollection":
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case "Circle":
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    }
    /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   */ drawFeature(feature, style) {
        const geometry = style.getGeometryFunction()(feature);
        if (!geometry) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    }
    /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   */ drawGeometryCollection(geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    }
    /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   */ drawPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== "") this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   */ drawMultiPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== "") this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   */ drawLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $9pD6L.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
            context.stroke();
        }
        if (this.text_ !== "") {
            const flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    }
    /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   */ drawMultiLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const geometryExtent = geometry.getExtent();
        if (!(0, $9pD6L.intersects)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            let offset = 0;
            const ends = /** @type {Array<number>} */ geometry.getEnds();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
            context.stroke();
        }
        if (this.text_ !== "") {
            const flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    }
    /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   */ drawPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $9pD6L.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride());
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") {
            const flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    }
    /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   */ drawMultiPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $9pD6L.intersects)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getOrientedFlatCoordinates();
            let offset = 0;
            const endss = geometry.getEndss();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = endss.length; i < ii; ++i){
                const ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") {
            const flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    }
    /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ setContextFillState_(fillState) {
        const context = this.context_;
        const contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ setContextStrokeState_(strokeState) {
        const context = this.context_;
        const contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            context.setLineDash(strokeState.lineDash);
            context.lineDashOffset = strokeState.lineDashOffset;
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (!(0, $fVVyM.equals)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
            if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    }
    /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ setContextTextState_(textState) {
        const context = this.context_;
        const contextTextState = this.contextTextState_;
        const textAlign = textState.textAlign ? textState.textAlign : (0, $ig1j9.defaultTextAlign);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = textAlign;
            context.textBaseline = textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = textAlign;
                context.textAlign = textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = textState.textBaseline;
                context.textBaseline = textState.textBaseline;
            }
        }
    }
    /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            const fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $jh19n.asColorLike)(fillStyleColor ? fillStyleColor : (0, $ig1j9.defaultFillStyle))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            const strokeStyleColor = strokeStyle.getColor();
            const strokeStyleLineCap = strokeStyle.getLineCap();
            const strokeStyleLineDash = strokeStyle.getLineDash();
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            const strokeStyleWidth = strokeStyle.getWidth();
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            const lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, $ig1j9.defaultLineDash);
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $ig1j9.defaultLineCap),
                lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map((n)=>n * this.pixelRatio_),
                lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $ig1j9.defaultLineDashOffset)) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $ig1j9.defaultLineJoin),
                lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $ig1j9.defaultLineWidth)) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $ig1j9.defaultMiterLimit),
                strokeStyle: (0, $jh19n.asColorLike)(strokeStyleColor ? strokeStyleColor : (0, $ig1j9.defaultStrokeStyle))
            };
        }
    }
    /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   */ setImageStyle(imageStyle) {
        let imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        const imagePixelRatio = imageStyle.getPixelRatio(this.pixelRatio_);
        const imageAnchor = imageStyle.getAnchor();
        const imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * imagePixelRatio;
        this.imageAnchorY_ = imageAnchor[1] * imagePixelRatio;
        this.imageHeight_ = imageSize[1] * imagePixelRatio;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        const imageScale = imageStyle.getScaleArray();
        this.imageScale_ = [
            imageScale[0] * this.pixelRatio_ / imagePixelRatio,
            imageScale[1] * this.pixelRatio_ / imagePixelRatio
        ];
        this.imageWidth_ = imageSize[0] * imagePixelRatio;
    }
    /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   */ setTextStyle(textStyle) {
        if (!textStyle) this.text_ = "";
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                const textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $jh19n.asColorLike)(textFillStyleColor ? textFillStyleColor : (0, $ig1j9.defaultFillStyle))
                };
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                const textStrokeStyleColor = textStrokeStyle.getColor();
                const textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                const textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                const textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                const textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                const textStrokeStyleWidth = textStrokeStyle.getWidth();
                const textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $ig1j9.defaultLineCap),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $ig1j9.defaultLineDash),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $ig1j9.defaultLineDashOffset),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $ig1j9.defaultLineJoin),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $ig1j9.defaultLineWidth),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $ig1j9.defaultMiterLimit),
                    strokeStyle: (0, $jh19n.asColorLike)(textStrokeStyleColor ? textStrokeStyleColor : (0, $ig1j9.defaultStrokeStyle))
                };
            }
            const textFont = textStyle.getFont();
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            const textScale = textStyle.getScaleArray();
            const textText = textStyle.getText();
            const textTextAlign = textStyle.getTextAlign();
            const textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $ig1j9.defaultFont),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $ig1j9.defaultTextAlign),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $ig1j9.defaultTextBaseline)
            };
            this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce((acc, t, i)=>acc += i % 2 ? " " : t, "") : textText : "";
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    }
}
var $7b0c2128a27f5020$export$2e2bcd8739ae039 = $7b0c2128a27f5020$var$CanvasImmediateRenderer;

});


parcelRegister("6urmj", function(module, exports) {

$parcel$export(module.exports, "defaultOrder", () => $4b9ac454600c05d2$export$531ddd8416d52dfc);
$parcel$export(module.exports, "getSquaredTolerance", () => $4b9ac454600c05d2$export$75084a70d324c1e6);
$parcel$export(module.exports, "getTolerance", () => $4b9ac454600c05d2$export$bdacc5b475012edb);
$parcel$export(module.exports, "renderFeature", () => $4b9ac454600c05d2$export$36f470a33a42f413);
/**
 * @module ol/renderer/vector
 */ 
var $aSvtr = parcelRequire("aSvtr");

var $9iPUS = parcelRequire("9iPUS");
/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ const $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ const $4b9ac454600c05d2$var$GEOMETRY_RENDERERS = {
    "Point": $4b9ac454600c05d2$var$renderPointGeometry,
    "LineString": $4b9ac454600c05d2$var$renderLineStringGeometry,
    "Polygon": $4b9ac454600c05d2$var$renderPolygonGeometry,
    "MultiPoint": $4b9ac454600c05d2$var$renderMultiPointGeometry,
    "MultiLineString": $4b9ac454600c05d2$var$renderMultiLineStringGeometry,
    "MultiPolygon": $4b9ac454600c05d2$var$renderMultiPolygonGeometry,
    "GeometryCollection": $4b9ac454600c05d2$var$renderGeometryCollectionGeometry,
    "Circle": $4b9ac454600c05d2$var$renderCircleGeometry
};
function $4b9ac454600c05d2$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $9iPUS.getUid)(feature1), 10) - parseInt((0, $9iPUS.getUid)(feature2), 10);
}
function $4b9ac454600c05d2$export$75084a70d324c1e6(resolution, pixelRatio) {
    const tolerance = $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderCircleGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const circleReplay = builderGroup.getBuilder(style.getZIndex(), "Circle");
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
function $4b9ac454600c05d2$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, transform, declutter, index) {
    const loadingPromises = [];
    const imageStyle = style.getImage();
    if (imageStyle) {
        let loading = true;
        const imageState = imageStyle.getImageState();
        if (imageState == (0, $aSvtr.default).LOADED || imageState == (0, $aSvtr.default).ERROR) loading = false;
        else if (imageState == (0, $aSvtr.default).IDLE) imageStyle.load();
        if (loading) loadingPromises.push(imageStyle.ready());
    }
    const fillStyle = style.getFill();
    if (fillStyle && fillStyle.loading()) loadingPromises.push(fillStyle.ready());
    const loading = loadingPromises.length > 0;
    if (loading) Promise.all(loadingPromises).then(()=>listener(null));
    $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
 * @param {boolean} [declutter] Enable decluttering.
 * @param {number} [index] Render order index..
 */ function $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index) {
    const geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    const simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, transform);
    const renderer = style.getRenderer();
    if (renderer) $4b9ac454600c05d2$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature, index);
    else {
        const geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, index, declutter);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderGeometry(replayGroup, geometry, style, feature, index) {
    if (geometry.getType() == "GeometryCollection") {
        const geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(let i = 0, ii = geometries.length; i < ii; ++i)$4b9ac454600c05d2$var$renderGeometry(replayGroup, geometries[i], style, feature, index);
        return;
    }
    const replay = replayGroup.getBuilder(style.getZIndex(), "Default");
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer(), index);
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, declutterBuilderGroup, index) {
    const geometries = geometry.getGeometriesArray();
    let i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        const geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, declutterBuilderGroup, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), "LineString");
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), "LineString");
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), "Polygon");
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4b9ac454600c05d2$var$renderPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && imageStyle && hasText ? {} : undefined;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $aSvtr.default).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), "Image");
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4b9ac454600c05d2$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const hasImage = imageStyle && imageStyle.getOpacity() !== 0;
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && hasImage && hasText ? {} : undefined;
    if (hasImage) {
        if (imageStyle.getImageState() != (0, $aSvtr.default).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), "Image");
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), "Polygon");
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}

});



parcelRegister("bnthu", function(module, exports) {

$parcel$export(module.exports, "default", () => $84888e4daf3fdf44$export$2e2bcd8739ae039);
/**
 * @module ol/source/Vector
 */ 
var $cD8Qe = parcelRequire("cD8Qe");

var $1TIYs = parcelRequire("1TIYs");

var $f18Q2 = parcelRequire("f18Q2");

var $3xzSb = parcelRequire("3xzSb");

var $jXCUw = parcelRequire("jXCUw");

var $4wW9x = parcelRequire("4wW9x");

var $4HUbK = parcelRequire("4HUbK");

var $knPlK = parcelRequire("knPlK");

var $hzYQp = parcelRequire("hzYQp");

var $6wUzV = parcelRequire("6wUzV");

var $kcBeU = parcelRequire("kcBeU");

var $4Cz58 = parcelRequire("4Cz58");

var $9pD6L = parcelRequire("9pD6L");

var $fVVyM = parcelRequire("fVVyM");

var $9iPUS = parcelRequire("9iPUS");

var $gn0g3 = parcelRequire("gn0g3");

var $ilM9F = parcelRequire("ilM9F");

var $7BfFg = parcelRequire("7BfFg");
class $84888e4daf3fdf44$export$d402fd02dc2b661c extends (0, $f18Q2.default) {
    /**
   * @param {string} type Type.
   * @param {FeatureClass} [feature] Feature.
   * @param {Array<FeatureClass>} [features] Features.
   */ constructor(type, feature, features){
        super(type);
        /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {FeatureClass|undefined}
     * @api
     */ this.feature = feature;
        /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<FeatureClass>|undefined}
     * @api
     */ this.features = features;
    }
}
/***
 * @template {import("../Feature.js").FeatureLike} [T=import("../Feature.js").default]
 * @typedef {T extends RenderFeature ? T|Array<T> : T} FeatureClassOrArrayOfRenderFeatures
 */ /***
 * @template Return
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent<FeatureType>, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @template {import("../Feature.js").FeatureLike} FeatureType
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<FeatureType>|Collection<FeatureType>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default<import("../format/Feature.js").FeatureToFeatureClass<FeatureType>>} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader<FeatureType>} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import Vector from 'ol/source/Vector.js';
 * import GeoJSON from 'ol/format/GeoJSON.js';
 * import {bbox} from 'ol/loadingstrategy.js';
 *
 * const vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      const proj = projection.getCode();
 *      const url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      const xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      const onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          const features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox,
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 */ class $84888e4daf3fdf44$var$VectorSource extends (0, $knPlK.default) {
    /**
   * @param {Options<FeatureType>} [options] Vector source options.
   */ constructor(options){
        options = options || {};
        super({
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: "ready",
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.on;
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.once;
        /***
     * @type {VectorSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader<FeatureType>}
     */ this.loader_ = (0, $6wUzV.VOID);
        /**
     * @private
     * @type {import("../format/Feature.js").default<import('../format/Feature.js').FeatureToFeatureClass<FeatureType>>|undefined}
     */ this.format_ = options.format;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ this.url_ = options.url;
        if (options.loader !== undefined) this.loader_ = options.loader;
        else if (this.url_ !== undefined) {
            (0, $4Cz58.assert)(this.format_, "`format` must be set when `url` is set");
            // create a XHR feature loader for "url" and "format"
            this.loader_ = (0, $7BfFg.xhr)(this.url_, this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $kcBeU.all);
        const useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<FeatureType>}
     */ this.featuresRtree_ = useSpatialIndex ? new (0, $4wW9x.default)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ this.loadedExtentsRtree_ = new (0, $4wW9x.default)();
        /**
     * @type {number}
     * @private
     */ this.loadingExtentsCount_ = 0;
        /**
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import('../Feature.js').FeatureLike|Array<import('../Feature.js').FeatureLike>>}
     */ this.idIndex_ = {};
        /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.uidIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<FeatureType>|null}
     */ this.featuresCollection_ = null;
        /** @type {Collection<FeatureType>} */ let collection;
        /** @type {Array<FeatureType>} */ let features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $cD8Qe.default)(features);
        if (features !== undefined) this.addFeaturesInternal(features);
        if (collection !== undefined) this.bindFeaturesCollection_(collection);
    }
    /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if an {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureType} feature Feature to add.
   * @api
   */ addFeature(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    }
    /**
   * Add a feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @protected
   */ addFeatureInternal(feature) {
        const featureKey = (0, $9iPUS.getUid)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).ADDFEATURE, feature));
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @private
   */ setupChangeEvents_(featureKey, feature) {
        if (feature instanceof (0, $4HUbK.default)) return;
        this.featureChangeKeys_[featureKey] = [
            (0, $ilM9F.listen)(feature, (0, $3xzSb.default).CHANGE, this.handleFeatureChange_, this),
            (0, $ilM9F.listen)(feature, (0, $jXCUw.default).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ addToIndex_(featureKey, feature) {
        let valid = true;
        if (feature.getId() !== undefined) {
            const id = String(feature.getId());
            if (!(id in this.idIndex_)) this.idIndex_[id] = feature;
            else if (feature instanceof (0, $4HUbK.default)) {
                const indexedFeature = this.idIndex_[id];
                if (!(indexedFeature instanceof (0, $4HUbK.default))) valid = false;
                else if (!Array.isArray(indexedFeature)) this.idIndex_[id] = [
                    indexedFeature,
                    feature
                ];
                else indexedFeature.push(feature);
            } else valid = false;
        }
        if (valid) {
            (0, $4Cz58.assert)(!(featureKey in this.uidIndex_), "The passed `feature` was already added to the source");
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    }
    /**
   * Add a batch of features to the source.
   * @param {Array<FeatureType>} features Features to add.
   * @api
   */ addFeatures(features) {
        this.addFeaturesInternal(features);
        this.changed();
    }
    /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureType>} features Features.
   * @protected
   */ addFeaturesInternal(features) {
        const extents = [];
        /** @type {Array<FeatureType>} */ const newFeatures = [];
        /** @type Array<FeatureType> */ const geometryFeatures = [];
        for(let i = 0, length = features.length; i < length; i++){
            const feature = features[i];
            const featureKey = (0, $9iPUS.getUid)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(let i = 0, length = newFeatures.length; i < length; i++){
            const feature = newFeatures[i];
            const featureKey = (0, $9iPUS.getUid)(feature);
            this.setupChangeEvents_(featureKey, feature);
            const geometry = feature.getGeometry();
            if (geometry) {
                const extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        if (this.hasListener((0, $hzYQp.default).ADDFEATURE)) for(let i = 0, length = newFeatures.length; i < length; i++)this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).ADDFEATURE, newFeatures[i]));
    }
    /**
   * @param {!Collection<FeatureType>} collection Collection.
   * @private
   */ bindFeaturesCollection_(collection) {
        let modifyingCollection = false;
        this.addEventListener((0, $hzYQp.default).ADDFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, $hzYQp.default).REMOVEFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $1TIYs.default).ADD, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(evt.element);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $1TIYs.default).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(evt.element);
                modifyingCollection = false;
            }
        });
        this.featuresCollection_ = collection;
    }
    /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */ clear(fast) {
        if (fast) {
            for(const featureId in this.featureChangeKeys_){
                const keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $ilM9F.unlistenByKey));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            const removeAndIgnoreReturn = (feature)=>{
                this.removeFeatureInternal(feature);
            };
            this.featuresRtree_.forEach(removeAndIgnoreReturn);
            for(const id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        const clearEvent = new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    }
    /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureType): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeature(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ forEachFeatureAtCoordinateDirect(coordinate, callback) {
        const extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $4HUbK.default) || geometry.intersectsCoordinate(coordinate)) return callback(feature);
            return undefined;
        });
    }
    /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureInExtent(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureIntersectingExtent(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $4HUbK.default) || geometry.intersectsExtent(extent)) {
                const result = callback(feature);
                if (result) return result;
            }
        });
    }
    /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with an {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureType>|null} The collection of features.
   * @api
   */ getFeaturesCollection() {
        return this.featuresCollection_;
    }
    /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        let features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $gn0g3.isEmpty)(this.nullGeometryFeatures_)) (0, $fVVyM.extend)(features, Object.values(this.nullGeometryFeatures_));
        }
        return features;
    }
    /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */ getFeaturesAtCoordinate(coordinate) {
        const features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    }
    /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent, projection) {
        if (this.featuresRtree_) {
            const multiWorld = projection && projection.canWrapX() && this.getWrapX();
            if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
            const extents = (0, $9pD6L.wrapAndSliceX)(extent, projection);
            return [].concat(...extents.map((anExtent)=>this.featuresRtree_.getInExtent(anExtent)));
        }
        if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
        return [];
    }
    /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureType} Closest feature.
   * @api
   */ getClosestFeatureToCoordinate(coordinate, filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        const x = coordinate[0];
        const y = coordinate[1];
        let closestFeature = null;
        const closestPoint = [
            NaN,
            NaN
        ];
        let minSquaredDistance = Infinity;
        const extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        filter = filter ? filter : (0, $6wUzV.TRUE);
        this.featuresRtree_.forEachInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       */ function(feature) {
            if (filter(feature)) {
                const geometry = feature.getGeometry();
                const previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry instanceof (0, $4HUbK.default) ? 0 : geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    const minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    }
    /**
   * Get the extent of the features currently in the source.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent(extent) {
        return this.featuresRtree_.getExtent(extent);
    }
    /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClassOrArrayOfRenderFeatures<FeatureType>|null} The feature (or `null` if not found).
   * @api
   */ getFeatureById(id) {
        const feature = this.idIndex_[id.toString()];
        return feature !== undefined ? /** @type {FeatureClassOrArrayOfRenderFeatures<FeatureType>} */ feature : null;
    }
    /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureType|null} The feature (or `null` if not found).
   */ getFeatureByUid(uid) {
        const feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    }
    /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default<import('../format/Feature.js').FeatureToFeatureClass<FeatureType>>|undefined} The feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * @param {Event} event Event.
   * @private
   */ handleFeatureChange_(event) {
        const feature = /** @type {FeatureType} */ event.target;
        const featureKey = (0, $9iPUS.getUid)(feature);
        const geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            const extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        const id = feature.getId();
        if (id !== undefined) {
            const sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).CHANGEFEATURE, feature));
    }
    /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureType} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ hasFeature(feature) {
        const id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        return (0, $9iPUS.getUid)(feature) in this.uidIndex_;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, $gn0g3.isEmpty)(this.nullGeometryFeatures_);
        if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
        return true;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ loadFeatures(extent, resolution, projection) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const extentsToLoad = this.strategy_(extent, resolution, projection);
        for(let i = 0, ii = extentsToLoad.length; i < ii; ++i){
            const extentToLoad = extentsToLoad[i];
            const alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                return (0, $9pD6L.containsExtent)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                ++this.loadingExtentsCount_;
                this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).FEATURESLOADSTART));
                this.loader_.call(this, extentToLoad, resolution, projection, (features)=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).FEATURESLOADEND, undefined, features));
                }, ()=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).FEATURESLOADERROR));
                });
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
            }
        }
        this.loading = this.loader_.length < 4 ? false : this.loadingExtentsCount_ > 0;
    }
    refresh() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        super.refresh();
    }
    /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ removeLoadedExtent(extent) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        let obj;
        loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $9pD6L.equals)(object.extent, extent)) {
                obj = object;
                return true;
            }
        });
        if (obj) loadedExtentsRtree.remove(obj);
    }
    /**
   * Batch remove features from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {Array<FeatureType>} features Features to remove.
   * @api
   */ removeFeatures(features) {
        const removedFeatures = [];
        for(let i = 0, ii = features.length; i < ii; ++i){
            const feature = features[i];
            const removedFeature = this.removeFeatureInternal(feature);
            if (removedFeature) removedFeatures.push(removedFeature);
        }
        if (removedFeatures.length > 0) this.changed();
    }
    /**
   * Remove a single feature from the source. If you want to batch remove
   * features, use the {@link module:ol/source/Vector~VectorSource#removeFeatures #removeFeatures()} method
   * instead.
   * @param {FeatureType} feature Feature to remove.
   * @api
   */ removeFeature(feature) {
        if (!feature) return;
        const result = this.removeFeatureInternal(feature);
        if (result) this.changed();
    }
    /**
   * Remove feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @return {FeatureType|undefined} The removed feature
   *     (or undefined if the feature was not found).
   * @protected
   */ removeFeatureInternal(feature) {
        const featureKey = (0, $9iPUS.getUid)(feature);
        if (!(featureKey in this.uidIndex_)) return;
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        const featureChangeKeys = this.featureChangeKeys_[featureKey];
        featureChangeKeys?.forEach((0, $ilM9F.unlistenByKey));
        delete this.featureChangeKeys_[featureKey];
        const id = feature.getId();
        if (id !== undefined) {
            const idString = id.toString();
            const indexedFeature = this.idIndex_[idString];
            if (indexedFeature === feature) delete this.idIndex_[idString];
            else if (Array.isArray(indexedFeature)) {
                indexedFeature.splice(indexedFeature.indexOf(feature), 1);
                if (indexedFeature.length === 1) this.idIndex_[idString] = indexedFeature[0];
            }
        }
        delete this.uidIndex_[featureKey];
        if (this.hasListener((0, $hzYQp.default).REMOVEFEATURE)) this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $hzYQp.default).REMOVEFEATURE, feature));
        return feature;
    }
    /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureType} feature The feature.
   * @return {boolean} Removed the feature from the index.
   * @private
   */ removeFromIdIndex_(feature) {
        let removed = false;
        for(const id in this.idIndex_){
            const indexedFeature = this.idIndex_[id];
            if (feature instanceof (0, $4HUbK.default) && Array.isArray(indexedFeature) && indexedFeature.includes(feature)) indexedFeature.splice(indexedFeature.indexOf(feature), 1);
            else if (this.idIndex_[id] === feature) {
                delete this.idIndex_[id];
                removed = true;
                break;
            }
        }
        return removed;
    }
    /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader<FeatureType>} loader The loader to set.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
    /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */ setUrl(url) {
        (0, $4Cz58.assert)(this.format_, "`format` must be set when `url` is set");
        this.url_ = url;
        this.setLoader((0, $7BfFg.xhr)(url, this.format_));
    }
}
var $84888e4daf3fdf44$export$2e2bcd8739ae039 = $84888e4daf3fdf44$var$VectorSource;

});
parcelRegister("4wW9x", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c742891733e7a4$export$2e2bcd8739ae039);
/**
 * @module ol/structs/RBush
 */ 
var $20GDs = parcelRequire("20GDs");

var $9pD6L = parcelRequire("9pD6L");

var $9iPUS = parcelRequire("9iPUS");

var $gn0g3 = parcelRequire("gn0g3");
/**
 * @typedef {Object} Entry
 * @property {number} minX MinX.
 * @property {number} minY MinY.
 * @property {number} maxX MaxX.
 * @property {number} maxY MaxY.
 * @property {Object} [value] Value.
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template T
 */ class $34c742891733e7a4$var$RBush {
    /**
   * @param {number} [maxEntries] Max entries.
   */ constructor(maxEntries){
        /**
     * @private
     */ this.rbush_ = new (0, (/*@__PURE__*/$parcel$interopDefault($20GDs)))(maxEntries);
        /**
     * A mapping between the objects added to this rbush wrapper
     * and the objects that are actually added to the internal rbush.
     * @private
     * @type {Object<string, Entry>}
     */ this.items_ = {};
    }
    /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ insert(extent, value) {
        /** @type {Entry} */ const item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, $9iPUS.getUid)(value)] = item;
    }
    /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */ load(extents, values) {
        const items = new Array(values.length);
        for(let i = 0, l = values.length; i < l; i++){
            const extent = extents[i];
            const value = values[i];
            /** @type {Entry} */ const item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, $9iPUS.getUid)(value)] = item;
        }
        this.rbush_.load(items);
    }
    /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */ remove(value) {
        const uid = (0, $9iPUS.getUid)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        const item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    }
    /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ update(extent, value) {
        const item = this.items_[(0, $9iPUS.getUid)(value)];
        const bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, $9pD6L.equals)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    }
    /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */ getAll() {
        const items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */ getInExtent(extent) {
        /** @type {Entry} */ const bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        const items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): *} callback Callback.
   * @return {*} Callback return value.
   */ forEach(callback) {
        return this.forEach_(this.getAll(), callback);
    }
    /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): *} callback Callback.
   * @return {*} Callback return value.
   */ forEachInExtent(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    }
    /**
   * @param {Array<T>} values Values.
   * @param {function(T): *} callback Callback.
   * @private
   * @return {*} Callback return value.
   */ forEach_(values, callback) {
        let result;
        for(let i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $gn0g3.isEmpty)(this.items_);
    }
    /**
   * Remove all values from the RBush.
   */ clear() {
        this.rbush_.clear();
        this.items_ = {};
    }
    /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */ getExtent(extent) {
        const data = this.rbush_.toJSON();
        return (0, $9pD6L.createOrUpdate)(data.minX, data.minY, data.maxX, data.maxY, extent);
    }
    /**
   * @param {RBush} rbush R-Tree.
   */ concat(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(const i in rbush.items_)this.items_[i] = rbush.items_[i];
    }
}
var $34c742891733e7a4$export$2e2bcd8739ae039 = $34c742891733e7a4$var$RBush;

});

parcelRegister("4HUbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $36d6c36c1f9ad5d9$export$2e2bcd8739ae039);
/**
 * @module ol/render/Feature
 */ 
var $dIG9p = parcelRequire("dIG9p");

var $3xcD3 = parcelRequire("3xcD3");
var $fw94T = parcelRequire("fw94T");
var $jKs1i = parcelRequire("jKs1i");
var $le5ya = parcelRequire("le5ya");
var $9vPkX = parcelRequire("9vPkX");
var $5ydre = parcelRequire("5ydre");

var $jpXrt = parcelRequire("jpXrt");

var $9pD6L = parcelRequire("9pD6L");

var $bDhby = parcelRequire("bDhby");

var $fVVyM = parcelRequire("fVVyM");

var $2RNwh = parcelRequire("2RNwh");

var $dpRHA = parcelRequire("dpRHA");

var $alOgM = parcelRequire("alOgM");

var $5PzBf = parcelRequire("5PzBf");

var $d3SGX = parcelRequire("d3SGX");

var $6wUzV = parcelRequire("6wUzV");

var $1MAUi = parcelRequire("1MAUi");
/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'` or 'MultiLineString'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $36d6c36c1f9ad5d9$var$tmpTransform = (0, $jpXrt.create)();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */ class $36d6c36c1f9ad5d9$var$RenderFeature {
    /**
   * @param {Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */ constructor(type, flatCoordinates, ends, stride, properties, id){
        /**
     * @type {import("../style/Style.js").StyleFunction|undefined}
     */ this.styleFunction;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.extent_;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = id;
        /**
     * @private
     * @type {Type}
     */ this.type_ = type;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatCoordinates_ = flatCoordinates;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatMidpoints_ = null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.ends_ = ends || null;
        /**
     * @private
     * @type {Object<string, *>}
     */ this.properties_ = properties;
        /**
     * @type {number}
     */ this.squaredTolerance_;
        /**
     * @type {number}
     */ this.stride_ = stride;
        /**
     * @private
     * @type {RenderFeature}
     */ this.simplifiedGeometry_;
    }
    /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */ get(key) {
        return this.properties_[key];
    }
    /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        if (!this.extent_) this.extent_ = this.type_ === "Point" ? (0, $9pD6L.createOrUpdateFromCoordinate)(this.flatCoordinates_) : (0, $9pD6L.createOrUpdateFromFlatCoordinates)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2);
        return this.extent_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoint() {
        if (!this.flatInteriorPoints_) {
            const flatCenter = (0, $9pD6L.getCenter)(this.getExtent());
            this.flatInteriorPoints_ = (0, $2RNwh.getInteriorPointOfArray)(this.flatCoordinates_, 0, this.ends_, 2, flatCenter, 0);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (!this.flatInteriorPoints_) {
            const ends = (0, $alOgM.inflateEnds)(this.flatCoordinates_, this.ends_);
            const flatCenters = (0, $d3SGX.linearRingss)(this.flatCoordinates_, 0, ends, 2);
            this.flatInteriorPoints_ = (0, $2RNwh.getInteriorPointsOfMultiArray)(this.flatCoordinates_, 0, ends, 2, flatCenters);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (!this.flatMidpoints_) this.flatMidpoints_ = (0, $5PzBf.interpolatePoint)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, 0.5);
        return this.flatMidpoints_;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = [];
            const flatCoordinates = this.flatCoordinates_;
            let offset = 0;
            const ends = /** @type {Array<number>} */ this.ends_;
            for(let i = 0, ii = ends.length; i < ii; ++i){
                const end = ends[i];
                const midpoint = (0, $5PzBf.interpolatePoint)(flatCoordinates, offset, end, 2, 0.5);
                (0, $fVVyM.extend)(this.flatMidpoints_, midpoint);
                offset = end;
            }
        }
        return this.flatMidpoints_;
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getOrientedFlatCoordinates() {
        return this.flatCoordinates_;
    }
    /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */ getGeometry() {
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return this;
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this;
    }
    /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */ getProperties() {
        return this.properties_;
    }
    /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.properties_;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride_;
    }
    /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */ getStyleFunction() {
        return this.styleFunction;
    }
    /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */ getType() {
        return this.type_;
    }
    /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */ transform(projection) {
        projection = (0, $dpRHA.get)(projection);
        const pixelExtent = projection.getExtent();
        const projectedExtent = projection.getWorldExtent();
        if (pixelExtent && projectedExtent) {
            const scale = (0, $9pD6L.getHeight)(projectedExtent) / (0, $9pD6L.getHeight)(pixelExtent);
            (0, $jpXrt.compose)($36d6c36c1f9ad5d9$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $1MAUi.transform2D)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, $36d6c36c1f9ad5d9$var$tmpTransform, this.flatCoordinates_);
        }
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */ applyTransform(transformFn) {
        transformFn(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
    }
    /**
   * @return {RenderFeature} A cloned render feature.
   */ clone() {
        return new $36d6c36c1f9ad5d9$var$RenderFeature(this.type_, this.flatCoordinates_.slice(), this.ends_?.slice(), this.stride_, Object.assign({}, this.properties_), this.id_);
    }
    /**
   * @return {Array<number>|null} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */ enableSimplifyTransformed() {
        this.simplifyTransformed = (0, $6wUzV.memoizeOne)((squaredTolerance, transform)=>{
            if (squaredTolerance === this.squaredTolerance_) return this.simplifiedGeometry_;
            this.simplifiedGeometry_ = this.clone();
            if (transform) this.simplifiedGeometry_.applyTransform(transform);
            const simplifiedFlatCoordinates = this.simplifiedGeometry_.getFlatCoordinates();
            let simplifiedEnds;
            switch(this.type_){
                case "LineString":
                    simplifiedFlatCoordinates.length = (0, $bDhby.douglasPeucker)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.flatCoordinates_.length, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0);
                    simplifiedEnds = [
                        simplifiedFlatCoordinates.length
                    ];
                    break;
                case "MultiLineString":
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $bDhby.douglasPeuckerArray)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                case "Polygon":
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $bDhby.quantizeArray)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                default:
            }
            if (simplifiedEnds) this.simplifiedGeometry_ = new $36d6c36c1f9ad5d9$var$RenderFeature(this.type_, simplifiedFlatCoordinates, simplifiedEnds, 2, this.properties_, this.id_);
            this.squaredTolerance_ = squaredTolerance;
            return this.simplifiedGeometry_;
        });
        return this;
    }
}
/**
 * @return {Array<number>} Flat coordinates.
 */ $36d6c36c1f9ad5d9$var$RenderFeature.prototype.getFlatCoordinates = $36d6c36c1f9ad5d9$var$RenderFeature.prototype.getOrientedFlatCoordinates;
function $36d6c36c1f9ad5d9$export$b89ab3d1d30dec84(renderFeature) {
    const geometryType = renderFeature.getType();
    switch(geometryType){
        case "Point":
            return new (0, $9vPkX.default)(renderFeature.getFlatCoordinates());
        case "MultiPoint":
            return new (0, $jKs1i.default)(renderFeature.getFlatCoordinates(), "XY");
        case "LineString":
            return new (0, $3xcD3.default)(renderFeature.getFlatCoordinates(), "XY");
        case "MultiLineString":
            return new (0, $fw94T.default)(renderFeature.getFlatCoordinates(), "XY", /** @type {Array<number>} */ renderFeature.getEnds());
        case "Polygon":
            const flatCoordinates = renderFeature.getFlatCoordinates();
            const ends = renderFeature.getEnds();
            const endss = (0, $alOgM.inflateEnds)(flatCoordinates, ends);
            return endss.length > 1 ? new (0, $le5ya.default)(flatCoordinates, "XY", endss) : new (0, $5ydre.default)(flatCoordinates, "XY", ends);
        default:
            throw new Error("Invalid geometry type:" + geometryType);
    }
}
function $36d6c36c1f9ad5d9$export$ab19ba60efd1c4b5(renderFeature, geometryName) {
    const id = renderFeature.getId();
    const geometry = $36d6c36c1f9ad5d9$export$b89ab3d1d30dec84(renderFeature);
    const properties = renderFeature.getProperties();
    const feature = new (0, $dIG9p.default)();
    if (geometryName !== undefined) feature.setGeometryName(geometryName);
    feature.setGeometry(geometry);
    if (id !== undefined) feature.setId(id);
    feature.setProperties(properties, true);
    return feature;
}
var $36d6c36c1f9ad5d9$export$2e2bcd8739ae039 = $36d6c36c1f9ad5d9$var$RenderFeature;

});
parcelRegister("dIG9p", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd014ab6df63665$export$2e2bcd8739ae039);
/**
 * @module ol/Feature
 */ 
var $fFFY7 = parcelRequire("fFFY7");

var $3xzSb = parcelRequire("3xzSb");

var $4Cz58 = parcelRequire("4Cz58");

var $ilM9F = parcelRequire("ilM9F");
/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @typedef {Object<string, *> & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature.js';
 * import Polygon from 'ol/geom/Polygon.js';
 * import Point from 'ol/geom/Point.js';
 *
 * const feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon',
 * });
 *
 * // get the polygon geometry
 * const poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * const point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 */ class $9fd014ab6df63665$var$Feature extends (0, $fFFY7.default) {
    /**
   * @param {Geometry|ObjectWithGeometry<Geometry>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */ constructor(geometryOrProperties){
        super();
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {FeatureOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ this.geometryName_ = "geometry";
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.geometryChangeKey_ = null;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        if (geometryOrProperties) {
            if (typeof /** @type {?} */ geometryOrProperties.getSimplifiedGeometry === "function") {
                const geometry = /** @type {Geometry} */ geometryOrProperties;
                this.setGeometry(geometry);
            } else {
                /** @type {Object<string, *>} */ const properties = geometryOrProperties;
                this.setProperties(properties);
            }
        }
    }
    /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */ clone() {
        const clone = /** @type {Feature<Geometry>} */ new $9fd014ab6df63665$var$Feature(this.hasProperties() ? this.getProperties() : null);
        clone.setGeometryName(this.getGeometryName());
        const geometry = this.getGeometry();
        if (geometry) clone.setGeometry(/** @type {Geometry} */ geometry.clone());
        const style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    }
    /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ getGeometry() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ getGeometryName() {
        return this.geometryName_;
    }
    /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @private
   */ handleGeometryChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleGeometryChanged_() {
        if (this.geometryChangeKey_) {
            (0, $ilM9F.unlistenByKey)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        const geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $ilM9F.listen)(geometry, (0, $3xzSb.default).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    }
    /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */ setGeometry(geometry) {
        this.set(this.geometryName_, geometry);
    }
    /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setStyle(style) {
        this.style_ = style;
        this.styleFunction_ = !style ? undefined : $9fd014ab6df63665$export$bb06ddfd5d66e02e(style);
        this.changed();
    }
    /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setId(id) {
        this.id_ = id;
        this.changed();
    }
    /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ setGeometryName(name) {
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    }
}
function $9fd014ab6df63665$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === "function") return obj;
    /**
   * @type {Array<import("./style/Style.js").default>}
   */ let styles;
    if (Array.isArray(obj)) styles = obj;
    else {
        (0, $4Cz58.assert)(typeof /** @type {?} */ obj.getZIndex === "function", "Expected an `ol/style/Style` or an array of `ol/style/Style.js`");
        const style = /** @type {import("./style/Style.js").default} */ obj;
        styles = [
            style
        ];
    }
    return function() {
        return styles;
    };
}
var $9fd014ab6df63665$export$2e2bcd8739ae039 = $9fd014ab6df63665$var$Feature;

});

parcelRegister("3xcD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $292e4002746c8223$export$2e2bcd8739ae039);
/**
 * @module ol/geom/LineString
 */ 
var $h7zsK = parcelRequire("h7zsK");

var $gqtzW = parcelRequire("gqtzW");

var $9pD6L = parcelRequire("9pD6L");

var $9bJty = parcelRequire("9bJty");

var $bDhby = parcelRequire("bDhby");

var $fVVyM = parcelRequire("fVVyM");

var $5m6tu = parcelRequire("5m6tu");

var $7eSHW = parcelRequire("7eSHW");

var $5PzBf = parcelRequire("5PzBf");

var $eQvue = parcelRequire("eQvue");

var $goM6N = parcelRequire("goM6N");
/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ class $292e4002746c8223$var$LineString extends (0, $h7zsK.default) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ appendCoordinate(coordinate) {
        (0, $fVVyM.extend)(this.flatCoordinates, coordinate);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   */ clone() {
        const lineString = new $292e4002746c8223$var$LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $gqtzW.maxSquaredDelta)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $gqtzW.assignClosestPoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ forEachSegment(callback) {
        return (0, $5m6tu.forEach)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate) {
        if (this.layout != "XYM" && this.layout != "XYZM") return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        return (0, $5PzBf.lineStringCoordinateAtM)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    }
    /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */ getCoordinates() {
        return (0, $7eSHW.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ getCoordinateAt(fraction, dest) {
        return (0, $5PzBf.interpolatePoint)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, dest, this.stride);
    }
    /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        return (0, $goM6N.lineStringLength)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_ ?? undefined);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatMidpoint_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $bDhby.douglasPeucker)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $292e4002746c8223$var$LineString(simplifiedFlatCoordinates, "XY");
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "LineString";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return (0, $eQvue.intersectsLineString)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $9bJty.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $292e4002746c8223$export$2e2bcd8739ae039 = $292e4002746c8223$var$LineString;

});
parcelRegister("5PzBf", function(module, exports) {

$parcel$export(module.exports, "interpolatePoint", () => $43ed5485a1d0c509$export$687ff82efd78795b);
$parcel$export(module.exports, "lineStringCoordinateAtM", () => $43ed5485a1d0c509$export$8f44c3c220ef6f09);
$parcel$export(module.exports, "lineStringsCoordinateAtM", () => $43ed5485a1d0c509$export$6a3300857e9ef453);
/**
 * @module ol/geom/flat/interpolate
 */ 
var $fVVyM = parcelRequire("fVVyM");

var $9byFX = parcelRequire("9byFX");
function $43ed5485a1d0c509$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, dest, dimension) {
    let o, t;
    const n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        let x1 = flatCoordinates[offset];
        let y1 = flatCoordinates[offset + 1];
        let length = 0;
        const cumulativeLengths = [
            0
        ];
        for(let i = offset + stride; i < end; i += stride){
            const x2 = flatCoordinates[i];
            const y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        const target = fraction * length;
        const index = (0, $fVVyM.binarySearch)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    dimension = dimension > 1 ? dimension : 2;
    dest = dest ? dest : new Array(dimension);
    for(let i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, $9byFX.lerp)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    let coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    let lo = offset / stride;
    let hi = end / stride;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    const m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    const m1 = flatCoordinates[(lo + 1) * stride - 1];
    const t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(let i = 0; i < stride - 1; ++i)coordinate.push((0, $9byFX.lerp)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $43ed5485a1d0c509$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    let coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        if (m <= flatCoordinates[end - 1]) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}

});


parcelRegister("fw94T", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c0e2e13beea46e$export$2e2bcd8739ae039);
/**
 * @module ol/geom/MultiLineString
 */ 
var $3xcD3 = parcelRequire("3xcD3");

var $h7zsK = parcelRequire("h7zsK");

var $gqtzW = parcelRequire("gqtzW");

var $9pD6L = parcelRequire("9pD6L");

var $9bJty = parcelRequire("9bJty");

var $bDhby = parcelRequire("bDhby");

var $fVVyM = parcelRequire("fVVyM");

var $7eSHW = parcelRequire("7eSHW");

var $5PzBf = parcelRequire("5PzBf");

var $eQvue = parcelRequire("eQvue");
/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ class $b4c0e2e13beea46e$var$MultiLineString extends (0, $h7zsK.default) {
    /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        else if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else {
            const lineStrings = /** @type {Array<LineString>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const ends = [];
            for(let i = 0, ii = lineStrings.length; i < ii; ++i){
                const lineString = lineStrings[i];
                (0, $fVVyM.extend)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            const layout = lineStrings.length === 0 ? this.getLayout() : lineStrings[0].getLayout();
            this.setFlatCoordinates(layout, flatCoordinates);
            this.ends_ = ends;
        }
    }
    /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ appendLineString(lineString) {
        (0, $fVVyM.extend)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   */ clone() {
        const multiLineString = new $b4c0e2e13beea46e$var$MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $gqtzW.arrayMaxSquaredDelta)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $gqtzW.assignClosestArrayPoint)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate, interpolate) {
        if (this.layout != "XYM" && this.layout != "XYZM" || this.flatCoordinates.length === 0) return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        interpolate = interpolate !== undefined ? interpolate : false;
        return (0, $5PzBf.lineStringsCoordinateAtM)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    }
    /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   */ getCoordinates() {
        return (0, $7eSHW.inflateCoordinatesArray)(this.flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ getLineString(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $3xcD3.default)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ getLineStrings() {
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const layout = this.layout;
        /** @type {Array<LineString>} */ const lineStrings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const lineString = new (0, $3xcD3.default)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        /** @type {Array<number>} */ const midpoints = [];
        const flatCoordinates = this.flatCoordinates;
        let offset = 0;
        const ends = this.ends_;
        const stride = this.stride;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const midpoint = (0, $5PzBf.interpolatePoint)(flatCoordinates, offset, end, stride, 0.5);
            (0, $fVVyM.extend)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $bDhby.douglasPeuckerArray)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $b4c0e2e13beea46e$var$MultiLineString(simplifiedFlatCoordinates, "XY", simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "MultiLineString";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return (0, $eQvue.intersectsLineStringArray)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $9bJty.deflateCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $b4c0e2e13beea46e$export$2e2bcd8739ae039 = $b4c0e2e13beea46e$var$MultiLineString;

});

parcelRegister("jKs1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6080c63a9451eda$export$2e2bcd8739ae039);
/**
 * @module ol/geom/MultiPoint
 */ 
var $9vPkX = parcelRequire("9vPkX");

var $h7zsK = parcelRequire("h7zsK");

var $9pD6L = parcelRequire("9pD6L");

var $9bJty = parcelRequire("9bJty");

var $fVVyM = parcelRequire("fVVyM");

var $7eSHW = parcelRequire("7eSHW");

var $9byFX = parcelRequire("9byFX");
/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ class $e6080c63a9451eda$var$MultiPoint extends (0, $h7zsK.default) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        if (layout && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ appendPoint(point) {
        (0, $fVVyM.extend)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   */ clone() {
        const multiPoint = new $e6080c63a9451eda$var$MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const squaredDistance = (0, $9byFX.squaredDistance)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(let j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */ getCoordinates() {
        return (0, $7eSHW.inflateCoordinates)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ getPoint(index) {
        const n = this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, $9vPkX.default)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    }
    /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ getPoints() {
        const flatCoordinates = this.flatCoordinates;
        const layout = this.layout;
        const stride = this.stride;
        /** @type {Array<Point>} */ const points = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const point = new (0, $9vPkX.default)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "MultiPoint";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            if ((0, $9pD6L.containsXY)(extent, x, y)) return true;
        }
        return false;
    }
    /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $9bJty.deflateCoordinates)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $e6080c63a9451eda$export$2e2bcd8739ae039 = $e6080c63a9451eda$var$MultiPoint;

});

parcelRegister("le5ya", function(module, exports) {

$parcel$export(module.exports, "default", () => $f73f35eb6af8b987$export$2e2bcd8739ae039);
/**
 * @module ol/geom/MultiPolygon
 */ 
var $jKs1i = parcelRequire("jKs1i");

var $5ydre = parcelRequire("5ydre");

var $h7zsK = parcelRequire("h7zsK");

var $gqtzW = parcelRequire("gqtzW");

var $9pD6L = parcelRequire("9pD6L");

var $9bJty = parcelRequire("9bJty");

var $fVVyM = parcelRequire("fVVyM");

var $2RNwh = parcelRequire("2RNwh");

var $7eSHW = parcelRequire("7eSHW");

var $eQvue = parcelRequire("eQvue");

var $alOgM = parcelRequire("alOgM");

var $aCXb5 = parcelRequire("aCXb5");

var $d3SGX = parcelRequire("d3SGX");

var $33weL = parcelRequire("33weL");

var $bDhby = parcelRequire("bDhby");
/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ class $f73f35eb6af8b987$var$MultiPolygon extends (0, $h7zsK.default) {
    /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */ constructor(coordinates, layout, endss){
        super();
        /**
     * @type {Array<Array<number>>}
     * @private
     */ this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (!endss && !Array.isArray(coordinates[0])) {
            const polygons = /** @type {Array<Polygon>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const thisEndss = [];
            for(let i = 0, ii = polygons.length; i < ii; ++i){
                const polygon = polygons[i];
                const offset = flatCoordinates.length;
                const ends = polygon.getEnds();
                for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $fVVyM.extend)(flatCoordinates, polygon.getFlatCoordinates());
                thisEndss.push(ends);
            }
            layout = polygons.length === 0 ? this.getLayout() : polygons[0].getLayout();
            coordinates = flatCoordinates;
            endss = thisEndss;
        }
        if (layout !== undefined && endss) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.endss_ = endss;
        } else this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, layout);
    }
    /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ appendPolygon(polygon) {
        /** @type {Array<number>} */ let ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            const offset = this.flatCoordinates.length;
            (0, $fVVyM.extend)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   */ clone() {
        const len = this.endss_.length;
        const newEndss = new Array(len);
        for(let i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        const multiPolygon = new $f73f35eb6af8b987$var$MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $9pD6L.closestSquaredDistanceXY)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $gqtzW.multiArrayMaxSquaredDelta)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $gqtzW.assignClosestMultiArrayPoint)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        return (0, $33weL.linearRingssContainsXY)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    }
    /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $aCXb5.linearRingss)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $alOgM.orientLinearRingsArray)(flatCoordinates, 0, this.endss_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $7eSHW.inflateMultiCoordinatesArray)(flatCoordinates, 0, this.endss_, this.stride);
    }
    /**
   * @return {Array<Array<number>>} Endss.
   */ getEndss() {
        return this.endss_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            const flatCenters = (0, $d3SGX.linearRingss)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, $2RNwh.getInteriorPointsOfMultiArray)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatInteriorPoints_;
    }
    /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoints() {
        return new (0, $jKs1i.default)(this.getFlatInteriorPoints().slice(), "XYM");
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $alOgM.linearRingssAreOriented)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $alOgM.orientLinearRingsArray)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<Array<number>>} */ const simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, $bDhby.quantizeMultiArray)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new $f73f35eb6af8b987$var$MultiPolygon(simplifiedFlatCoordinates, "XY", simplifiedEndss);
    }
    /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ getPolygon(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        let offset;
        if (index === 0) offset = 0;
        else {
            const prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        const ends = this.endss_[index].slice();
        const end = ends[ends.length - 1];
        if (offset !== 0) for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, $5ydre.default)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    }
    /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ getPolygons() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const endss = this.endss_;
        const polygons = [];
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i){
            const ends = endss[i].slice();
            const end = ends[ends.length - 1];
            if (offset !== 0) for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            const polygon = new (0, $5ydre.default)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "MultiPolygon";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return (0, $eQvue.intersectsLinearRingMultiArray)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const endss = (0, $9bJty.deflateMultiCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            const lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    }
}
var $f73f35eb6af8b987$export$2e2bcd8739ae039 = $f73f35eb6af8b987$var$MultiPolygon;

});
parcelRegister("d3SGX", function(module, exports) {

$parcel$export(module.exports, "linearRingss", () => $9825fadaf3b68c4e$export$78e139679ca7205);
/**
 * @module ol/geom/flat/center
 */ 
var $9pD6L = parcelRequire("9pD6L");
function $9825fadaf3b68c4e$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    const flatCenters = [];
    let extent = (0, $9pD6L.createEmpty)();
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        extent = (0, $9pD6L.createOrUpdateFromFlatCoordinates)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}

});



parcelRegister("hzYQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc4e6f11f11978f$export$2e2bcd8739ae039);
/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $ccc4e6f11f11978f$export$2e2bcd8739ae039 /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */  = {
    /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: "addfeature",
    /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: "changefeature",
    /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: "clear",
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: "removefeature",
    /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */ FEATURESLOADSTART: "featuresloadstart",
    /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */ FEATURESLOADEND: "featuresloadend",
    /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */ FEATURESLOADERROR: "featuresloaderror"
};

});

parcelRegister("kcBeU", function(module, exports) {

$parcel$export(module.exports, "all", () => $eb51d0a16123ee90$export$84bf76cd7afc7469);
/**
 * @module ol/loadingstrategy
 */ 
var $dpRHA = parcelRequire("dpRHA");
function $eb51d0a16123ee90$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $eb51d0a16123ee90$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $eb51d0a16123ee90$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        const z = tileGrid.getZForResolution((0, $dpRHA.fromUserResolution)(resolution, projection));
        const tileRange = tileGrid.getTileRangeForExtentAndZ((0, $dpRHA.fromUserExtent)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ const extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ const tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, $dpRHA.toUserExtent)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}

});

parcelRegister("7BfFg", function(module, exports) {

$parcel$export(module.exports, "xhr", () => $588823c001569193$export$14cc81df70b6707e);
/**
 * @module ol/featureloader
 */ 
var $6wUzV = parcelRequire("6wUzV");
/**
 *
 * @type {boolean}
 * @private
 */ let $588823c001569193$var$withCredentials = false;
function $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", typeof url === "function" ? url(extent, resolution, projection) : url, true);
    if (format.getType() == "arraybuffer") xhr.responseType = "arraybuffer";
    xhr.withCredentials = $588823c001569193$var$withCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            const type = format.getType();
            try {
                /** @type {Document|Node|Object|string|undefined} */ let source;
                if (type == "text" || type == "json") source = xhr.responseText;
                else if (type == "xml") source = xhr.responseXML || xhr.responseText;
                else if (type == "arraybuffer") source = /** @type {ArrayBuffer} */ xhr.response;
                if (source) success(/** @type {Array<FeatureType>} */ format.readFeatures(source, {
                    extent: extent,
                    featureProjection: projection
                }), format.readProjection(source));
                else failure();
            } catch  {
                failure();
            }
        } else failure();
    };
    /**
   * @private
   */ xhr.onerror = failure;
    xhr.send();
}
function $588823c001569193$export$14cc81df70b6707e(url, format) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<FeatureType>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   */ return function(extent, resolution, projection, success, failure) {
        const source = /** @type {import("./source/Vector").default<FeatureType>} */ this;
        $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
       * @param {Array<FeatureType>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */ function(features, dataProjection) {
            source.addFeatures(features);
            if (success !== undefined) success(features);
        }, /* FIXME handle error */ failure ? failure : (0, $6wUzV.VOID));
    };
}
function $588823c001569193$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $588823c001569193$var$withCredentials = xhrWithCredentials;
}

});


parcelRegister("ndRlY", function(module, exports) {

$parcel$export(module.exports, "defaultLineStyleFunction", () => $045ce65035c7d962$export$a716399666ccfc3);
$parcel$export(module.exports, "getFeaturesFromSections", () => $045ce65035c7d962$export$bcae7c8893bd3565);
$parcel$export(module.exports, "getFeaturesFromSectionGeoJSON", () => $045ce65035c7d962$export$841df173f33eb3c3);

var $ebcW3 = parcelRequire("ebcW3");

var $lAvh5 = parcelRequire("lAvh5");

var $dIG9p = parcelRequire("dIG9p");

var $3xcD3 = parcelRequire("3xcD3");
var $fw94T = parcelRequire("fw94T");
var $9vPkX = parcelRequire("9vPkX");

var $wnhPR = parcelRequire("wnhPR");
var $inIMS = parcelRequire("inIMS");
var $bmHVE = parcelRequire("bmHVE");
var $lrKvI = parcelRequire("lrKvI");
var $c3RIb = parcelRequire("c3RIb");

var $dpRHA = parcelRequire("dpRHA");

var $i7vbU = parcelRequire("i7vbU");
parcelRequire("bviTd");
function $045ce65035c7d962$export$a716399666ccfc3(feature, resolution, color, width) {
    var styles = [];
    styles.push(new (0, $c3RIb.default)({
        stroke: new (0, $lrKvI.default)({
            color: color,
            width: width
        }),
        zIndex: 2
    }));
    var geometry, end1, end2, dx, dy, rotation;
    return styles;
}
function $045ce65035c7d962$export$bcae7c8893bd3565(sections, projection) {
    var projFunc = (0, $ebcW3.default)(projection || "EPSG:3857", "EPSG:3857");
    let isWGS = projection.indexOf("4326") > 0;
    var features = sections.map((i)=>{
        var olGeometry = null;
        var length = 0;
        if (i.type == "MultiLineString") {
            var coordinates = i.coordinates.map((c)=>c.map((c1)=>projFunc.forward(c1)));
            olGeometry = new (0, $fw94T.default)(coordinates);
            if (!isWGS) for(var ii = 0; ii < i.coordinates.length; ii++){
                var iiCords = i.coordinates[ii];
                for(var iii = 1; iii < iiCords.length; iii++){
                    var dx = iiCords[iii - 1][0] - iiCords[iii][0];
                    var dy = iiCords[iii - 1][1] - iiCords[iii][1];
                    length += Math.sqrt(dx * dx + dy * dy);
                }
            }
            else length = (0, $lAvh5.getLength)(olGeometry);
        } else if (i.type == "Point") olGeometry = new (0, $9vPkX.default)((0, $dpRHA.fromLonLat)(i.coordinates[0]));
        else {
            var coordinates = i.coordinates.map((c)=>projFunc.forward(c));
            olGeometry = new (0, $3xcD3.default)(coordinates);
            if (!isWGS) for(var iii = 1; iii < i.coordinates.length; iii++){
                var dx = i.coordinates[iii - 1][0] - i.coordinates[iii][0];
                var dy = i.coordinates[iii - 1][1] - i.coordinates[iii][1];
                length += Math.sqrt(dx * dx + dy * dy);
            }
            else length = (0, $lAvh5.getLength)(olGeometry);
        }
        var propertyObject = {
            geometry: olGeometry,
            id: i.properties.OBJECTID || i.properties.ID || i.properties.GUID,
            label: "",
            length: length,
            properties: i.properties
        };
        var feature = new (0, $dIG9p.default)(propertyObject);
        if (i.type == "Point") feature.setStyle(new (0, $c3RIb.default)({
            image: new (0, $bmHVE.default)({
                src: (0, (/*@__PURE__*/$parcel$interopDefault($i7vbU))),
                scale: 0.01,
                color: "#FFFF00"
            })
        }));
        return feature;
    });
    return features;
}
function $045ce65035c7d962$export$841df173f33eb3c3(sections, projection) {
    var projFunc = (0, $ebcW3.default)(projection || "EPSG:3857", "EPSG:3857");
    let isWGS = projection.indexOf("4326") > 0;
    var features = sections.map((i)=>{
        var olGeometry = null;
        var length = 0;
        if (i.type == "MultiLineString") {
            var coordinates = i.coordinates.map((c)=>c.map((c1)=>projFunc.forward(c1)));
            olGeometry = new (0, $fw94T.default)(coordinates);
            if (!isWGS) for(var ii = 0; ii < i.coordinates.length; ii++){
                var iiCords = i.coordinates[ii];
                for(var iii = 1; iii < iiCords.length; iii++){
                    var dx = iiCords[iii - 1][0] - iiCords[iii][0];
                    var dy = iiCords[iii - 1][1] - iiCords[iii][1];
                    length += Math.sqrt(dx * dx + dy * dy);
                }
            }
            else length = (0, $lAvh5.getLength)(olGeometry);
        } else if (i.type == "Point") olGeometry = new (0, $9vPkX.default)((0, $dpRHA.fromLonLat)(i.coordinates[0]));
        else {
            var coordinates = i.coordinates.map((c)=>projFunc.forward(c));
            olGeometry = new (0, $3xcD3.default)(coordinates);
            if (!isWGS) for(var iii = 1; iii < i.coordinates.length; iii++){
                var dx = i.coordinates[iii - 1][0] - i.coordinates[iii][0];
                var dy = i.coordinates[iii - 1][1] - i.coordinates[iii][1];
                length += Math.sqrt(dx * dx + dy * dy);
            }
            else length = (0, $lAvh5.getLength)(olGeometry);
        }
        var propertyObject = {
            geometry: olGeometry,
            color: i.activities[0]?.color || "#FF0000",
            id: i.properties.OBJECTID || i.properties.ID || i.properties.GUID,
            label: "",
            length: length,
            properties: i.properties
        };
        var feature = new (0, $dIG9p.default)(propertyObject);
        if (i.type == "Point") {
            var style = new (0, $c3RIb.default)({
                image: new (0, $wnhPR.default)({
                    radius: 6,
                    fill: new (0, $inIMS.default)({
                        color: propertyObject.color
                    })
                })
            });
            feature.setStyle(style);
        }
        return feature;
    });
    return features;
}

});
parcelRegister("ebcW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a52c207aab93bf4f$export$2e2bcd8739ae039);

var $66mQQ = parcelRequire("66mQQ");

var $38qqf = parcelRequire("38qqf");

var $iCFRA = parcelRequire("iCFRA");

var $5vTfu = parcelRequire("5vTfu");

var $ezj1P = parcelRequire("ezj1P");

var $flUkq = parcelRequire("flUkq");

var $ceNev = parcelRequire("ceNev");

var $4hMrQ = parcelRequire("4hMrQ");

var $j48cx = parcelRequire("j48cx");
(0, $66mQQ.default).defaultDatum = "WGS84"; //default datum
(0, $66mQQ.default).Proj = (0, $38qqf.default);
(0, $66mQQ.default).WGS84 = new (0, $66mQQ.default).Proj("WGS84");
(0, $66mQQ.default).Point = (0, $iCFRA.default);
(0, $66mQQ.default).toPoint = (0, $5vTfu.default);
(0, $66mQQ.default).defs = (0, $ezj1P.default);
(0, $66mQQ.default).nadgrid = (0, $flUkq.default);
(0, $66mQQ.default).transform = (0, $ceNev.default);
(0, $66mQQ.default).mgrs = (0, $4hMrQ.default);
(0, $66mQQ.default).version = "__VERSION__";
(0, $j48cx.default)((0, $66mQQ.default));
var $a52c207aab93bf4f$export$2e2bcd8739ae039 = (0, $66mQQ.default);

});
parcelRegister("66mQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $471507637a3ff861$export$2e2bcd8739ae039);

var $38qqf = parcelRequire("38qqf");

var $ceNev = parcelRequire("ceNev");
var $471507637a3ff861$var$wgs84 = (0, $38qqf.default)("WGS84");
function $471507637a3ff861$var$transformer(from, to, coords, enforceAxis) {
    var transformedArray, out, keys;
    if (Array.isArray(coords)) {
        transformedArray = (0, $ceNev.default)(from, to, coords, enforceAxis) || {
            x: NaN,
            y: NaN
        };
        if (coords.length > 2) {
            if (typeof from.name !== "undefined" && from.name === "geocent" || typeof to.name !== "undefined" && to.name === "geocent") {
                if (typeof transformedArray.z === "number") return [
                    transformedArray.x,
                    transformedArray.y,
                    transformedArray.z
                ].concat(coords.splice(3));
                else return [
                    transformedArray.x,
                    transformedArray.y,
                    coords[2]
                ].concat(coords.splice(3));
            } else return [
                transformedArray.x,
                transformedArray.y
            ].concat(coords.splice(2));
        } else return [
            transformedArray.x,
            transformedArray.y
        ];
    } else {
        out = (0, $ceNev.default)(from, to, coords, enforceAxis);
        keys = Object.keys(coords);
        if (keys.length === 2) return out;
        keys.forEach(function(key) {
            if (typeof from.name !== "undefined" && from.name === "geocent" || typeof to.name !== "undefined" && to.name === "geocent") {
                if (key === "x" || key === "y" || key === "z") return;
            } else {
                if (key === "x" || key === "y") return;
            }
            out[key] = coords[key];
        });
        return out;
    }
}
function $471507637a3ff861$var$checkProj(item) {
    if (item instanceof (0, $38qqf.default)) return item;
    if (item.oProj) return item.oProj;
    return (0, $38qqf.default)(item);
}
function $471507637a3ff861$var$proj4(fromProj, toProj, coord) {
    fromProj = $471507637a3ff861$var$checkProj(fromProj);
    var single = false;
    var obj;
    if (typeof toProj === "undefined") {
        toProj = fromProj;
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    } else if (typeof toProj.x !== "undefined" || Array.isArray(toProj)) {
        coord = toProj;
        toProj = fromProj;
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    }
    toProj = $471507637a3ff861$var$checkProj(toProj);
    if (coord) return $471507637a3ff861$var$transformer(fromProj, toProj, coord);
    else {
        obj = {
            forward: function(coords, enforceAxis) {
                return $471507637a3ff861$var$transformer(fromProj, toProj, coords, enforceAxis);
            },
            inverse: function(coords, enforceAxis) {
                return $471507637a3ff861$var$transformer(toProj, fromProj, coords, enforceAxis);
            }
        };
        if (single) obj.oProj = toProj;
        return obj;
    }
}
var $471507637a3ff861$export$2e2bcd8739ae039 = $471507637a3ff861$var$proj4;

});
parcelRegister("38qqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $24869d6338533b3b$export$2e2bcd8739ae039);

var $giDQh = parcelRequire("giDQh");

var $cWauz = parcelRequire("cWauz");

var $1Wo5P = parcelRequire("1Wo5P");

var $d8b9d = parcelRequire("d8b9d");

var $gMdFS = parcelRequire("gMdFS");

var $3MCqb = parcelRequire("3MCqb");

var $hzXAi = parcelRequire("hzXAi");

var $flUkq = parcelRequire("flUkq");
function $24869d6338533b3b$var$Projection(srsCode, callback) {
    if (!(this instanceof $24869d6338533b3b$var$Projection)) return new $24869d6338533b3b$var$Projection(srsCode);
    callback = callback || function(error) {
        if (error) throw error;
    };
    var json = (0, $giDQh.default)(srsCode);
    if (typeof json !== "object") {
        callback(srsCode);
        return;
    }
    var ourProj = $24869d6338533b3b$var$Projection.projections.get(json.projName);
    if (!ourProj) {
        callback(srsCode);
        return;
    }
    if (json.datumCode && json.datumCode !== "none") {
        var datumDef = (0, $hzXAi.default)((0, $gMdFS.default), json.datumCode);
        if (datumDef) {
            json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(",") : null);
            json.ellps = datumDef.ellipse;
            json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
        }
    }
    json.k0 = json.k0 || 1.0;
    json.axis = json.axis || "enu";
    json.ellps = json.ellps || "wgs84";
    json.lat1 = json.lat1 || json.lat0; // Lambert_Conformal_Conic_1SP, for example, needs this
    var sphere_ = (0, $d8b9d.sphere)(json.a, json.b, json.rf, json.ellps, json.sphere);
    var ecc = (0, $d8b9d.eccentricity)(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
    var nadgrids = (0, $flUkq.getNadgrids)(json.nadgrids);
    var datumObj = json.datum || (0, $3MCqb.default)(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2, nadgrids);
    (0, $cWauz.default)(this, json); // transfer everything over from the projection because we don't know what we'll need
    (0, $cWauz.default)(this, ourProj); // transfer all the methods from the projection
    // copy the 4 things over we calculated in deriveConstants.sphere
    this.a = sphere_.a;
    this.b = sphere_.b;
    this.rf = sphere_.rf;
    this.sphere = sphere_.sphere;
    // copy the 3 things we calculated in deriveConstants.eccentricity
    this.es = ecc.es;
    this.e = ecc.e;
    this.ep2 = ecc.ep2;
    // add in the datum object
    this.datum = datumObj;
    // init the projection
    this.init();
    // legecy callback from back in the day when it went to spatialreference.org
    callback(null, this);
}
$24869d6338533b3b$var$Projection.projections = (0, $1Wo5P.default);
$24869d6338533b3b$var$Projection.projections.start();
var $24869d6338533b3b$export$2e2bcd8739ae039 = $24869d6338533b3b$var$Projection;

});
parcelRegister("giDQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bddd3b9c0d2064cd$export$2e2bcd8739ae039);

var $ezj1P = parcelRequire("ezj1P");

var $7UVTv = parcelRequire("7UVTv");

var $7zrM7 = parcelRequire("7zrM7");

var $hzXAi = parcelRequire("hzXAi");
function $bddd3b9c0d2064cd$var$testObj(code) {
    return typeof code === "string";
}
function $bddd3b9c0d2064cd$var$testDef(code) {
    return code in (0, $ezj1P.default);
}
var $bddd3b9c0d2064cd$var$codeWords = [
    "PROJECTEDCRS",
    "PROJCRS",
    "GEOGCS",
    "GEOCCS",
    "PROJCS",
    "LOCAL_CS",
    "GEODCRS",
    "GEODETICCRS",
    "GEODETICDATUM",
    "ENGCRS",
    "ENGINEERINGCRS"
];
function $bddd3b9c0d2064cd$var$testWKT(code) {
    return $bddd3b9c0d2064cd$var$codeWords.some(function(word) {
        return code.indexOf(word) > -1;
    });
}
var $bddd3b9c0d2064cd$var$codes = [
    "3857",
    "900913",
    "3785",
    "102113"
];
function $bddd3b9c0d2064cd$var$checkMercator(item) {
    var auth = (0, $hzXAi.default)(item, "authority");
    if (!auth) return;
    var code = (0, $hzXAi.default)(auth, "epsg");
    return code && $bddd3b9c0d2064cd$var$codes.indexOf(code) > -1;
}
function $bddd3b9c0d2064cd$var$checkProjStr(item) {
    var ext = (0, $hzXAi.default)(item, "extension");
    if (!ext) return;
    return (0, $hzXAi.default)(ext, "proj4");
}
function $bddd3b9c0d2064cd$var$testProj(code) {
    return code[0] === "+";
}
function $bddd3b9c0d2064cd$var$parse(code) {
    if ($bddd3b9c0d2064cd$var$testObj(code)) {
        //check to see if this is a WKT string
        if ($bddd3b9c0d2064cd$var$testDef(code)) return (0, $ezj1P.default)[code];
        if ($bddd3b9c0d2064cd$var$testWKT(code)) {
            var out = (0, $7UVTv.default)(code);
            // test of spetial case, due to this being a very common and often malformed
            if ($bddd3b9c0d2064cd$var$checkMercator(out)) return (0, $ezj1P.default)["EPSG:3857"];
            var maybeProjStr = $bddd3b9c0d2064cd$var$checkProjStr(out);
            if (maybeProjStr) return (0, $7zrM7.default)(maybeProjStr);
            return out;
        }
        if ($bddd3b9c0d2064cd$var$testProj(code)) return (0, $7zrM7.default)(code);
    } else return code;
}
var $bddd3b9c0d2064cd$export$2e2bcd8739ae039 = $bddd3b9c0d2064cd$var$parse;

});
parcelRegister("ezj1P", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9b3183caccb3297$export$2e2bcd8739ae039);

var $cR6T8 = parcelRequire("cR6T8");

var $7zrM7 = parcelRequire("7zrM7");

var $7UVTv = parcelRequire("7UVTv");
function $a9b3183caccb3297$var$defs(name) {
    /*global console*/ var that = this;
    if (arguments.length === 2) {
        var def = arguments[1];
        if (typeof def === "string") {
            if (def.charAt(0) === "+") $a9b3183caccb3297$var$defs[name] = (0, $7zrM7.default)(arguments[1]);
            else $a9b3183caccb3297$var$defs[name] = (0, $7UVTv.default)(arguments[1]);
        } else $a9b3183caccb3297$var$defs[name] = def;
    } else if (arguments.length === 1) {
        if (Array.isArray(name)) return name.map(function(v) {
            if (Array.isArray(v)) $a9b3183caccb3297$var$defs.apply(that, v);
            else $a9b3183caccb3297$var$defs(v);
        });
        else if (typeof name === "string") {
            if (name in $a9b3183caccb3297$var$defs) return $a9b3183caccb3297$var$defs[name];
        } else if ("EPSG" in name) $a9b3183caccb3297$var$defs["EPSG:" + name.EPSG] = name;
        else if ("ESRI" in name) $a9b3183caccb3297$var$defs["ESRI:" + name.ESRI] = name;
        else if ("IAU2000" in name) $a9b3183caccb3297$var$defs["IAU2000:" + name.IAU2000] = name;
        else console.log(name);
        return;
    }
}
(0, $cR6T8.default)($a9b3183caccb3297$var$defs);
var $a9b3183caccb3297$export$2e2bcd8739ae039 = $a9b3183caccb3297$var$defs;

});
parcelRegister("cR6T8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95bfc720255032a6$export$2e2bcd8739ae039);
function $95bfc720255032a6$export$2e2bcd8739ae039(defs) {
    defs("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
    defs("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
    defs("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");
    defs.WGS84 = defs["EPSG:4326"];
    defs["EPSG:3785"] = defs["EPSG:3857"]; // maintain backward compat, official code is 3857
    defs.GOOGLE = defs["EPSG:3857"];
    defs["EPSG:900913"] = defs["EPSG:3857"];
    defs["EPSG:102113"] = defs["EPSG:3857"];
}

});

parcelRegister("7zrM7", function(module, exports) {

$parcel$export(module.exports, "default", () => $583158df16d3522c$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $gyWgF = parcelRequire("gyWgF");

var $6CY0Z = parcelRequire("6CY0Z");

var $hzXAi = parcelRequire("hzXAi");
function $583158df16d3522c$export$2e2bcd8739ae039(defData) {
    var self = {};
    var paramObj = defData.split("+").map(function(v) {
        return v.trim();
    }).filter(function(a) {
        return a;
    }).reduce(function(p, a) {
        var split = a.split("=");
        split.push(true);
        p[split[0].toLowerCase()] = split[1];
        return p;
    }, {});
    var paramName, paramVal, paramOutname;
    var params = {
        proj: "projName",
        datum: "datumCode",
        rf: function(v) {
            self.rf = parseFloat(v);
        },
        lat_0: function(v) {
            self.lat0 = v * (0, $gyVUi.D2R);
        },
        lat_1: function(v) {
            self.lat1 = v * (0, $gyVUi.D2R);
        },
        lat_2: function(v) {
            self.lat2 = v * (0, $gyVUi.D2R);
        },
        lat_ts: function(v) {
            self.lat_ts = v * (0, $gyVUi.D2R);
        },
        lon_0: function(v) {
            self.long0 = v * (0, $gyVUi.D2R);
        },
        lon_1: function(v) {
            self.long1 = v * (0, $gyVUi.D2R);
        },
        lon_2: function(v) {
            self.long2 = v * (0, $gyVUi.D2R);
        },
        alpha: function(v) {
            self.alpha = parseFloat(v) * (0, $gyVUi.D2R);
        },
        gamma: function(v) {
            self.rectified_grid_angle = parseFloat(v);
        },
        lonc: function(v) {
            self.longc = v * (0, $gyVUi.D2R);
        },
        x_0: function(v) {
            self.x0 = parseFloat(v);
        },
        y_0: function(v) {
            self.y0 = parseFloat(v);
        },
        k_0: function(v) {
            self.k0 = parseFloat(v);
        },
        k: function(v) {
            self.k0 = parseFloat(v);
        },
        a: function(v) {
            self.a = parseFloat(v);
        },
        b: function(v) {
            self.b = parseFloat(v);
        },
        r: function(v) {
            self.a = self.b = parseFloat(v);
        },
        r_a: function() {
            self.R_A = true;
        },
        zone: function(v) {
            self.zone = parseInt(v, 10);
        },
        south: function() {
            self.utmSouth = true;
        },
        towgs84: function(v) {
            self.datum_params = v.split(",").map(function(a) {
                return parseFloat(a);
            });
        },
        to_meter: function(v) {
            self.to_meter = parseFloat(v);
        },
        units: function(v) {
            self.units = v;
            var unit = (0, $hzXAi.default)((0, $6CY0Z.default), v);
            if (unit) self.to_meter = unit.to_meter;
        },
        from_greenwich: function(v) {
            self.from_greenwich = v * (0, $gyVUi.D2R);
        },
        pm: function(v) {
            var pm = (0, $hzXAi.default)((0, $gyWgF.default), v);
            self.from_greenwich = (pm ? pm : parseFloat(v)) * (0, $gyVUi.D2R);
        },
        nadgrids: function(v) {
            if (v === "@null") self.datumCode = "none";
            else self.nadgrids = v;
        },
        axis: function(v) {
            var legalAxis = "ewnsud";
            if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) self.axis = v;
        },
        approx: function() {
            self.approx = true;
        }
    };
    for(paramName in paramObj){
        paramVal = paramObj[paramName];
        if (paramName in params) {
            paramOutname = params[paramName];
            if (typeof paramOutname === "function") paramOutname(paramVal);
            else self[paramOutname] = paramVal;
        } else self[paramName] = paramVal;
    }
    if (typeof self.datumCode === "string" && self.datumCode !== "WGS84") self.datumCode = self.datumCode.toLowerCase();
    return self;
}

});
parcelRegister("gyVUi", function(module, exports) {

$parcel$export(module.exports, "PJD_3PARAM", () => $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27);
$parcel$export(module.exports, "PJD_7PARAM", () => $c0ecbd71ed29ee86$export$8cab19b7f383a7a7);
$parcel$export(module.exports, "PJD_GRIDSHIFT", () => $c0ecbd71ed29ee86$export$83d26ae02793dd10);
$parcel$export(module.exports, "PJD_WGS84", () => $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb);
$parcel$export(module.exports, "PJD_NODATUM", () => $c0ecbd71ed29ee86$export$8df4c7729d8ed58d);
$parcel$export(module.exports, "SRS_WGS84_SEMIMAJOR", () => $c0ecbd71ed29ee86$export$d612c03b7390d945);
$parcel$export(module.exports, "SRS_WGS84_SEMIMINOR", () => $c0ecbd71ed29ee86$export$59af086d7527ec46);
$parcel$export(module.exports, "SRS_WGS84_ESQUARED", () => $c0ecbd71ed29ee86$export$9b798f9d78b99fc0);
$parcel$export(module.exports, "SEC_TO_RAD", () => $c0ecbd71ed29ee86$export$e0b9011552f3b2f7);
$parcel$export(module.exports, "HALF_PI", () => $c0ecbd71ed29ee86$export$f504979d7e0a75c7);
$parcel$export(module.exports, "SIXTH", () => $c0ecbd71ed29ee86$export$d7977f56a0faa834);
$parcel$export(module.exports, "RA4", () => $c0ecbd71ed29ee86$export$9e703428410a9c7b);
$parcel$export(module.exports, "RA6", () => $c0ecbd71ed29ee86$export$bb54dde5565ed6e3);
$parcel$export(module.exports, "EPSLN", () => $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb);
$parcel$export(module.exports, "D2R", () => $c0ecbd71ed29ee86$export$ed6012a68c0f4a70);
$parcel$export(module.exports, "R2D", () => $c0ecbd71ed29ee86$export$456934b8be7498c3);
$parcel$export(module.exports, "FORTPI", () => $c0ecbd71ed29ee86$export$10cb69dd603c11b0);
$parcel$export(module.exports, "TWO_PI", () => $c0ecbd71ed29ee86$export$6eec49b1a6289c4e);
$parcel$export(module.exports, "SPI", () => $c0ecbd71ed29ee86$export$703a92fc6506ffb9);
var $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27 = 1;
var $c0ecbd71ed29ee86$export$8cab19b7f383a7a7 = 2;
var $c0ecbd71ed29ee86$export$83d26ae02793dd10 = 3;
var $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb = 4; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$8df4c7729d8ed58d = 5; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$d612c03b7390d945 = 6378137.0; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$59af086d7527ec46 = 6356752.314; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$9b798f9d78b99fc0 = 0.0066943799901413165; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$e0b9011552f3b2f7 = 4.84813681109535993589914102357e-6;
var $c0ecbd71ed29ee86$export$f504979d7e0a75c7 = Math.PI / 2;
var $c0ecbd71ed29ee86$export$d7977f56a0faa834 = 0.1666666666666666667;
var $c0ecbd71ed29ee86$export$9e703428410a9c7b = 0.04722222222222222222;
var $c0ecbd71ed29ee86$export$bb54dde5565ed6e3 = 0.02215608465608465608;
var $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb = 1.0e-10;
var $c0ecbd71ed29ee86$export$ed6012a68c0f4a70 = 0.01745329251994329577;
var $c0ecbd71ed29ee86$export$456934b8be7498c3 = 57.29577951308232088;
var $c0ecbd71ed29ee86$export$10cb69dd603c11b0 = Math.PI / 4;
var $c0ecbd71ed29ee86$export$6eec49b1a6289c4e = Math.PI * 2;
var $c0ecbd71ed29ee86$export$703a92fc6506ffb9 = 3.14159265359;

});

parcelRegister("gyWgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0ed0517e336f22b$export$2e2bcd8739ae039);
var $c0ed0517e336f22b$export$2e2bcd8739ae039 = {};
$c0ed0517e336f22b$export$2e2bcd8739ae039.greenwich = 0.0; //"0dE",
$c0ed0517e336f22b$export$2e2bcd8739ae039.lisbon = -9.131906111111; //"9d07'54.862\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.paris = 2.337229166667; //"2d20'14.025\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.bogota = -74.080916666667; //"74d04'51.3\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.madrid = -3.687938888889; //"3d41'16.58\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.rome = 12.452333333333; //"12d27'8.4\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.bern = 7.439583333333; //"7d26'22.5\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.jakarta = 106.807719444444; //"106d48'27.79\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.ferro = -17.666666666667; //"17d40'W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.brussels = 4.367975; //"4d22'4.71\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.stockholm = 18.058277777778; //"18d3'29.8\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.athens = 23.7163375; //"23d42'58.815\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.oslo = 10.722916666667; //"10d43'22.5\"E"

});

parcelRegister("6CY0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d34d8675ead8d22$export$2e2bcd8739ae039);
var $4d34d8675ead8d22$export$2e2bcd8739ae039 = {
    ft: {
        to_meter: 0.3048
    },
    "us-ft": {
        to_meter: 1200 / 3937
    }
};

});

parcelRegister("hzXAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc3ecc4732a4173$export$2e2bcd8739ae039);
var $ccc3ecc4732a4173$var$ignoredChar = /[\s_\-\/\(\)]/g;
function $ccc3ecc4732a4173$export$2e2bcd8739ae039(obj, key) {
    if (obj[key]) return obj[key];
    var keys = Object.keys(obj);
    var lkey = key.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, "");
    var i = -1;
    var testkey, processedKey;
    while(++i < keys.length){
        testkey = keys[i];
        processedKey = testkey.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, "");
        if (processedKey === lkey) return obj[testkey];
    }
}

});


parcelRegister("7UVTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c3aabf591259c07$export$2e2bcd8739ae039);

var $6Pz8X = parcelRequire("6Pz8X");

var $7SVqc = parcelRequire("7SVqc");
var $5c3aabf591259c07$var$D2R = 0.01745329251994329577;
function $5c3aabf591259c07$var$rename(obj, params) {
    var outName = params[0];
    var inName = params[1];
    if (!(outName in obj) && inName in obj) {
        obj[outName] = obj[inName];
        if (params.length === 3) obj[outName] = params[2](obj[outName]);
    }
}
function $5c3aabf591259c07$var$d2r(input) {
    return input * $5c3aabf591259c07$var$D2R;
}
function $5c3aabf591259c07$var$cleanWKT(wkt) {
    if (wkt.type === "GEOGCS") wkt.projName = "longlat";
    else if (wkt.type === "LOCAL_CS") {
        wkt.projName = "identity";
        wkt.local = true;
    } else if (typeof wkt.PROJECTION === "object") wkt.projName = Object.keys(wkt.PROJECTION)[0];
    else wkt.projName = wkt.PROJECTION;
    if (wkt.AXIS) {
        var axisOrder = "";
        for(var i = 0, ii = wkt.AXIS.length; i < ii; ++i){
            var axis = [
                wkt.AXIS[i][0].toLowerCase(),
                wkt.AXIS[i][1].toLowerCase()
            ];
            if (axis[0].indexOf("north") !== -1 || (axis[0] === "y" || axis[0] === "lat") && axis[1] === "north") axisOrder += "n";
            else if (axis[0].indexOf("south") !== -1 || (axis[0] === "y" || axis[0] === "lat") && axis[1] === "south") axisOrder += "s";
            else if (axis[0].indexOf("east") !== -1 || (axis[0] === "x" || axis[0] === "lon") && axis[1] === "east") axisOrder += "e";
            else if (axis[0].indexOf("west") !== -1 || (axis[0] === "x" || axis[0] === "lon") && axis[1] === "west") axisOrder += "w";
        }
        if (axisOrder.length === 2) axisOrder += "u";
        if (axisOrder.length === 3) wkt.axis = axisOrder;
    }
    if (wkt.UNIT) {
        wkt.units = wkt.UNIT.name.toLowerCase();
        if (wkt.units === "metre") wkt.units = "meter";
        if (wkt.UNIT.convert) {
            if (wkt.type === "GEOGCS") {
                if (wkt.DATUM && wkt.DATUM.SPHEROID) wkt.to_meter = wkt.UNIT.convert * wkt.DATUM.SPHEROID.a;
            } else wkt.to_meter = wkt.UNIT.convert;
        }
    }
    var geogcs = wkt.GEOGCS;
    if (wkt.type === "GEOGCS") geogcs = wkt;
    if (geogcs) {
        //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
        //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
        //}
        if (geogcs.DATUM) wkt.datumCode = geogcs.DATUM.name.toLowerCase();
        else wkt.datumCode = geogcs.name.toLowerCase();
        if (wkt.datumCode.slice(0, 2) === "d_") wkt.datumCode = wkt.datumCode.slice(2);
        if (wkt.datumCode === "new_zealand_geodetic_datum_1949" || wkt.datumCode === "new_zealand_1949") wkt.datumCode = "nzgd49";
        if (wkt.datumCode === "wgs_1984" || wkt.datumCode === "world_geodetic_system_1984") {
            if (wkt.PROJECTION === "Mercator_Auxiliary_Sphere") wkt.sphere = true;
            wkt.datumCode = "wgs84";
        }
        if (wkt.datumCode.slice(-6) === "_ferro") wkt.datumCode = wkt.datumCode.slice(0, -6);
        if (wkt.datumCode.slice(-8) === "_jakarta") wkt.datumCode = wkt.datumCode.slice(0, -8);
        if (~wkt.datumCode.indexOf("belge")) wkt.datumCode = "rnb72";
        if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
            wkt.ellps = geogcs.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk");
            if (wkt.ellps.toLowerCase().slice(0, 13) === "international") wkt.ellps = "intl";
            wkt.a = geogcs.DATUM.SPHEROID.a;
            wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
        }
        if (geogcs.DATUM && geogcs.DATUM.TOWGS84) wkt.datum_params = geogcs.DATUM.TOWGS84;
        if (~wkt.datumCode.indexOf("osgb_1936")) wkt.datumCode = "osgb36";
        if (~wkt.datumCode.indexOf("osni_1952")) wkt.datumCode = "osni52";
        if (~wkt.datumCode.indexOf("tm65") || ~wkt.datumCode.indexOf("geodetic_datum_of_1965")) wkt.datumCode = "ire65";
        if (wkt.datumCode === "ch1903+") wkt.datumCode = "ch1903";
        if (~wkt.datumCode.indexOf("israel")) wkt.datumCode = "isr93";
    }
    if (wkt.b && !isFinite(wkt.b)) wkt.b = wkt.a;
    function toMeter(input) {
        var ratio = wkt.to_meter || 1;
        return input * ratio;
    }
    var renamer = function(a) {
        return $5c3aabf591259c07$var$rename(wkt, a);
    };
    var list = [
        [
            "standard_parallel_1",
            "Standard_Parallel_1"
        ],
        [
            "standard_parallel_1",
            "Latitude of 1st standard parallel"
        ],
        [
            "standard_parallel_2",
            "Standard_Parallel_2"
        ],
        [
            "standard_parallel_2",
            "Latitude of 2nd standard parallel"
        ],
        [
            "false_easting",
            "False_Easting"
        ],
        [
            "false_easting",
            "False easting"
        ],
        [
            "false-easting",
            "Easting at false origin"
        ],
        [
            "false_northing",
            "False_Northing"
        ],
        [
            "false_northing",
            "False northing"
        ],
        [
            "false_northing",
            "Northing at false origin"
        ],
        [
            "central_meridian",
            "Central_Meridian"
        ],
        [
            "central_meridian",
            "Longitude of natural origin"
        ],
        [
            "central_meridian",
            "Longitude of false origin"
        ],
        [
            "latitude_of_origin",
            "Latitude_Of_Origin"
        ],
        [
            "latitude_of_origin",
            "Central_Parallel"
        ],
        [
            "latitude_of_origin",
            "Latitude of natural origin"
        ],
        [
            "latitude_of_origin",
            "Latitude of false origin"
        ],
        [
            "scale_factor",
            "Scale_Factor"
        ],
        [
            "k0",
            "scale_factor"
        ],
        [
            "latitude_of_center",
            "Latitude_Of_Center"
        ],
        [
            "latitude_of_center",
            "Latitude_of_center"
        ],
        [
            "lat0",
            "latitude_of_center",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "longitude_of_center",
            "Longitude_Of_Center"
        ],
        [
            "longitude_of_center",
            "Longitude_of_center"
        ],
        [
            "longc",
            "longitude_of_center",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "x0",
            "false_easting",
            toMeter
        ],
        [
            "y0",
            "false_northing",
            toMeter
        ],
        [
            "long0",
            "central_meridian",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat0",
            "latitude_of_origin",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat0",
            "standard_parallel_1",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat1",
            "standard_parallel_1",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat2",
            "standard_parallel_2",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "azimuth",
            "Azimuth"
        ],
        [
            "alpha",
            "azimuth",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "srsCode",
            "name"
        ]
    ];
    list.forEach(renamer);
    if (!wkt.long0 && wkt.longc && (wkt.projName === "Albers_Conic_Equal_Area" || wkt.projName === "Lambert_Azimuthal_Equal_Area")) wkt.long0 = wkt.longc;
    if (!wkt.lat_ts && wkt.lat1 && (wkt.projName === "Stereographic_South_Pole" || wkt.projName === "Polar Stereographic (variant B)")) {
        wkt.lat0 = $5c3aabf591259c07$var$d2r(wkt.lat1 > 0 ? 90 : -90);
        wkt.lat_ts = wkt.lat1;
    } else if (!wkt.lat_ts && wkt.lat0 && wkt.projName === "Polar_Stereographic") {
        wkt.lat_ts = wkt.lat0;
        wkt.lat0 = $5c3aabf591259c07$var$d2r(wkt.lat0 > 0 ? 90 : -90);
    }
}
function $5c3aabf591259c07$export$2e2bcd8739ae039(wkt) {
    var lisp = (0, $6Pz8X.default)(wkt);
    var type = lisp.shift();
    var name = lisp.shift();
    lisp.unshift([
        "name",
        name
    ]);
    lisp.unshift([
        "type",
        type
    ]);
    var obj = {};
    (0, $7SVqc.sExpr)(lisp, obj);
    $5c3aabf591259c07$var$cleanWKT(obj);
    return obj;
}

});
parcelRegister("6Pz8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f92c43f9960a1f4$export$2e2bcd8739ae039);
var $4f92c43f9960a1f4$export$2e2bcd8739ae039 = $4f92c43f9960a1f4$var$parseString;
var $4f92c43f9960a1f4$var$NEUTRAL = 1;
var $4f92c43f9960a1f4$var$KEYWORD = 2;
var $4f92c43f9960a1f4$var$NUMBER = 3;
var $4f92c43f9960a1f4$var$QUOTED = 4;
var $4f92c43f9960a1f4$var$AFTERQUOTE = 5;
var $4f92c43f9960a1f4$var$ENDED = -1;
var $4f92c43f9960a1f4$var$whitespace = /\s/;
var $4f92c43f9960a1f4$var$latin = /[A-Za-z]/;
var $4f92c43f9960a1f4$var$keyword = /[A-Za-z84_]/;
var $4f92c43f9960a1f4$var$endThings = /[,\]]/;
var $4f92c43f9960a1f4$var$digets = /[\d\.E\-\+]/;
// const ignoredChar = /[\s_\-\/\(\)]/g;
function $4f92c43f9960a1f4$var$Parser(text) {
    if (typeof text !== "string") throw new Error("not a string");
    this.text = text.trim();
    this.level = 0;
    this.place = 0;
    this.root = null;
    this.stack = [];
    this.currentObject = null;
    this.state = $4f92c43f9960a1f4$var$NEUTRAL;
}
$4f92c43f9960a1f4$var$Parser.prototype.readCharicter = function() {
    var char = this.text[this.place++];
    if (this.state !== $4f92c43f9960a1f4$var$QUOTED) while($4f92c43f9960a1f4$var$whitespace.test(char)){
        if (this.place >= this.text.length) return;
        char = this.text[this.place++];
    }
    switch(this.state){
        case $4f92c43f9960a1f4$var$NEUTRAL:
            return this.neutral(char);
        case $4f92c43f9960a1f4$var$KEYWORD:
            return this.keyword(char);
        case $4f92c43f9960a1f4$var$QUOTED:
            return this.quoted(char);
        case $4f92c43f9960a1f4$var$AFTERQUOTE:
            return this.afterquote(char);
        case $4f92c43f9960a1f4$var$NUMBER:
            return this.number(char);
        case $4f92c43f9960a1f4$var$ENDED:
            return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.afterquote = function(char) {
    if (char === '"') {
        this.word += '"';
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = this.word.trim();
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in afterquote yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.afterItem = function(char) {
    if (char === ",") {
        if (this.word !== null) this.currentObject.push(this.word);
        this.word = null;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if (char === "]") {
        this.level--;
        if (this.word !== null) {
            this.currentObject.push(this.word);
            this.word = null;
        }
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        this.currentObject = this.stack.pop();
        if (!this.currentObject) this.state = $4f92c43f9960a1f4$var$ENDED;
        return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.number = function(char) {
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word += char;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = parseFloat(this.word);
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in number yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.quoted = function(char) {
    if (char === '"') {
        this.state = $4f92c43f9960a1f4$var$AFTERQUOTE;
        return;
    }
    this.word += char;
    return;
};
$4f92c43f9960a1f4$var$Parser.prototype.keyword = function(char) {
    if ($4f92c43f9960a1f4$var$keyword.test(char)) {
        this.word += char;
        return;
    }
    if (char === "[") {
        var newObjects = [];
        newObjects.push(this.word);
        this.level++;
        if (this.root === null) this.root = newObjects;
        else this.currentObject.push(newObjects);
        this.stack.push(this.currentObject);
        this.currentObject = newObjects;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in keyword yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.neutral = function(char) {
    if ($4f92c43f9960a1f4$var$latin.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$KEYWORD;
        return;
    }
    if (char === '"') {
        this.word = "";
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$NUMBER;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in neutral yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.output = function() {
    while(this.place < this.text.length)this.readCharicter();
    if (this.state === $4f92c43f9960a1f4$var$ENDED) return this.root;
    throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function $4f92c43f9960a1f4$var$parseString(txt) {
    var parser = new $4f92c43f9960a1f4$var$Parser(txt);
    return parser.output();
}

});

parcelRegister("7SVqc", function(module, exports) {

$parcel$export(module.exports, "sExpr", () => $5bda1e467f1c2649$export$337bc7a3aef1f775);
function $5bda1e467f1c2649$var$mapit(obj, key, value) {
    if (Array.isArray(key)) {
        value.unshift(key);
        key = null;
    }
    var thing = key ? {} : obj;
    var out = value.reduce(function(newObj, item) {
        $5bda1e467f1c2649$export$337bc7a3aef1f775(item, newObj);
        return newObj;
    }, thing);
    if (key) obj[key] = out;
}
function $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj) {
    if (!Array.isArray(v)) {
        obj[v] = true;
        return;
    }
    var key = v.shift();
    if (key === "PARAMETER") key = v.shift();
    if (v.length === 1) {
        if (Array.isArray(v[0])) {
            obj[key] = {};
            $5bda1e467f1c2649$export$337bc7a3aef1f775(v[0], obj[key]);
            return;
        }
        obj[key] = v[0];
        return;
    }
    if (!v.length) {
        obj[key] = true;
        return;
    }
    if (key === "TOWGS84") {
        obj[key] = v;
        return;
    }
    if (key === "AXIS") {
        if (!(key in obj)) obj[key] = [];
        obj[key].push(v);
        return;
    }
    if (!Array.isArray(key)) obj[key] = {};
    var i;
    switch(key){
        case "UNIT":
        case "PRIMEM":
        case "VERT_DATUM":
            obj[key] = {
                name: v[0].toLowerCase(),
                convert: v[1]
            };
            if (v.length === 3) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[2], obj[key]);
            return;
        case "SPHEROID":
        case "ELLIPSOID":
            obj[key] = {
                name: v[0],
                a: v[1],
                rf: v[2]
            };
            if (v.length === 4) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[3], obj[key]);
            return;
        case "PROJECTEDCRS":
        case "PROJCRS":
        case "GEOGCS":
        case "GEOCCS":
        case "PROJCS":
        case "LOCAL_CS":
        case "GEODCRS":
        case "GEODETICCRS":
        case "GEODETICDATUM":
        case "EDATUM":
        case "ENGINEERINGDATUM":
        case "VERT_CS":
        case "VERTCRS":
        case "VERTICALCRS":
        case "COMPD_CS":
        case "COMPOUNDCRS":
        case "ENGINEERINGCRS":
        case "ENGCRS":
        case "FITTED_CS":
        case "LOCAL_DATUM":
        case "DATUM":
            v[0] = [
                "name",
                v[0]
            ];
            $5bda1e467f1c2649$var$mapit(obj, key, v);
            return;
        default:
            i = -1;
            while(++i < v.length){
                if (!Array.isArray(v[i])) return $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj[key]);
            }
            return $5bda1e467f1c2649$var$mapit(obj, key, v);
    }
}

});




parcelRegister("cWauz", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b30a4c80088893$export$2e2bcd8739ae039);
function $96b30a4c80088893$export$2e2bcd8739ae039(destination, source) {
    destination = destination || {};
    var value, property;
    if (!source) return destination;
    for(property in source){
        value = source[property];
        if (value !== undefined) destination[property] = value;
    }
    return destination;
}

});

parcelRegister("1Wo5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $169de593aeaa174c$export$2e2bcd8739ae039);

var $ioIYn = parcelRequire("ioIYn");

var $iMMJV = parcelRequire("iMMJV");
var $169de593aeaa174c$var$projs = [
    (0, $ioIYn.default),
    (0, $iMMJV.default)
];
var $169de593aeaa174c$var$names = {};
var $169de593aeaa174c$var$projStore = [];
function $169de593aeaa174c$export$e16d8520af44a096(proj, i) {
    var len = $169de593aeaa174c$var$projStore.length;
    if (!proj.names) {
        console.log(i);
        return true;
    }
    $169de593aeaa174c$var$projStore[len] = proj;
    proj.names.forEach(function(n) {
        $169de593aeaa174c$var$names[n.toLowerCase()] = len;
    });
    return this;
}
function $169de593aeaa174c$export$3988ae62b71be9a3(name) {
    if (!name) return false;
    var n = name.toLowerCase();
    if (typeof $169de593aeaa174c$var$names[n] !== "undefined" && $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]]) return $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]];
}
function $169de593aeaa174c$export$b3571188c770cc5a() {
    $169de593aeaa174c$var$projs.forEach($169de593aeaa174c$export$e16d8520af44a096);
}
var $169de593aeaa174c$export$2e2bcd8739ae039 = {
    start: $169de593aeaa174c$export$b3571188c770cc5a,
    add: $169de593aeaa174c$export$e16d8520af44a096,
    get: $169de593aeaa174c$export$3988ae62b71be9a3
};

});
parcelRegister("ioIYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64d5a882433f366$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $a9oRf = parcelRequire("a9oRf");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d64d5a882433f366$export$2cd8252107eb640b() {
    var con = this.b / this.a;
    this.es = 1 - con * con;
    if (!("x0" in this)) this.x0 = 0;
    if (!("y0" in this)) this.y0 = 0;
    this.e = Math.sqrt(this.es);
    if (this.lat_ts) {
        if (this.sphere) this.k0 = Math.cos(this.lat_ts);
        else this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    } else if (!this.k0) {
        if (this.k) this.k0 = this.k;
        else this.k0 = 1;
    }
}
function $d64d5a882433f366$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // convert to radians
    if (lat * (0, $gyVUi.R2D) > 90 && lat * (0, $gyVUi.R2D) < -90 && lon * (0, $gyVUi.R2D) > 180 && lon * (0, $gyVUi.R2D) < -180) return null;
    var x, y;
    if (Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) return null;
    else {
        if (this.sphere) {
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0);
            y = this.y0 + this.a * this.k0 * Math.log(Math.tan((0, $gyVUi.FORTPI) + 0.5 * lat));
        } else {
            var sinphi = Math.sin(lat);
            var ts = (0, $3xC66.default)(this.e, lat, sinphi);
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0);
            y = this.y0 - this.a * this.k0 * Math.log(ts);
        }
        p.x = x;
        p.y = y;
        return p;
    }
}
function $d64d5a882433f366$export$70ae2c07e401031b(p) {
    var x = p.x - this.x0;
    var y = p.y - this.y0;
    var lon, lat;
    if (this.sphere) lat = (0, $gyVUi.HALF_PI) - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
    else {
        var ts = Math.exp(-y / (this.a * this.k0));
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    }
    lon = (0, $a9oRf.default)(this.long0 + x / (this.a * this.k0));
    p.x = lon;
    p.y = lat;
    return p;
}
var $d64d5a882433f366$export$e4b2ac9215619f8d = [
    "Mercator",
    "Popular Visualisation Pseudo Mercator",
    "Mercator_1SP",
    "Mercator_Auxiliary_Sphere",
    "merc"
];
var $d64d5a882433f366$export$2e2bcd8739ae039 = {
    init: $d64d5a882433f366$export$2cd8252107eb640b,
    forward: $d64d5a882433f366$export$174bb771924e7eb1,
    inverse: $d64d5a882433f366$export$70ae2c07e401031b,
    names: $d64d5a882433f366$export$e4b2ac9215619f8d
};

});
parcelRegister("bi5ZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8386063044328ea8$export$2e2bcd8739ae039);
function $8386063044328ea8$export$2e2bcd8739ae039(eccent, sinphi, cosphi) {
    var con = eccent * sinphi;
    return cosphi / Math.sqrt(1 - con * con);
}

});

parcelRegister("a9oRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $763e06e438986b6c$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $763e06e438986b6c$export$2e2bcd8739ae039(x) {
    return Math.abs(x) <= (0, $gyVUi.SPI) ? x : x - (0, $boTd3.default)(x) * (0, $gyVUi.TWO_PI);
}

});
parcelRegister("boTd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ccc316da8510bf$export$2e2bcd8739ae039);
function $84ccc316da8510bf$export$2e2bcd8739ae039(x) {
    return x < 0 ? -1 : 1;
}

});


parcelRegister("3xC66", function(module, exports) {

$parcel$export(module.exports, "default", () => $2942018063c2eff1$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $2942018063c2eff1$export$2e2bcd8739ae039(eccent, phi, sinphi) {
    var con = eccent * sinphi;
    var com = 0.5 * eccent;
    con = Math.pow((1 - con) / (1 + con), com);
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) - phi)) / con;
}

});

parcelRegister("2AZR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e3eece278ef2a71$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $1e3eece278ef2a71$export$2e2bcd8739ae039(eccent, ts) {
    var eccnth = 0.5 * eccent;
    var con, dphi;
    var phi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts);
    for(var i = 0; i <= 15; i++){
        con = eccent * Math.sin(phi);
        dphi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts * Math.pow((1 - con) / (1 + con), eccnth)) - phi;
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //console.log("phi2z has NoConvergence");
    return -9999;
}

});


parcelRegister("iMMJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $dad2845bfa7291b9$export$2e2bcd8739ae039);
function $dad2845bfa7291b9$export$2cd8252107eb640b() {
//no-op for longlat
}
function $dad2845bfa7291b9$export$174bb771924e7eb1(pt) {
    return pt;
}
var $dad2845bfa7291b9$export$e4b2ac9215619f8d = [
    "longlat",
    "identity"
];
var $dad2845bfa7291b9$export$2e2bcd8739ae039 = {
    init: $dad2845bfa7291b9$export$2cd8252107eb640b,
    forward: $dad2845bfa7291b9$export$174bb771924e7eb1,
    inverse: $dad2845bfa7291b9$export$174bb771924e7eb1,
    names: $dad2845bfa7291b9$export$e4b2ac9215619f8d
};

});


parcelRegister("d8b9d", function(module, exports) {

$parcel$export(module.exports, "eccentricity", () => $98f4ab684186b766$export$e3d7bf2ed2a7479f);
$parcel$export(module.exports, "sphere", () => $98f4ab684186b766$export$b2690196de52b050);

var $gyVUi = parcelRequire("gyVUi");

var $bO5FE = parcelRequire("bO5FE");

var $hzXAi = parcelRequire("hzXAi");
function $98f4ab684186b766$export$e3d7bf2ed2a7479f(a, b, rf, R_A) {
    var a2 = a * a; // used in geocentric
    var b2 = b * b; // used in geocentric
    var es = (a2 - b2) / a2; // e ^ 2
    var e = 0;
    if (R_A) {
        a *= 1 - es * ((0, $gyVUi.SIXTH) + es * ((0, $gyVUi.RA4) + es * (0, $gyVUi.RA6)));
        a2 = a * a;
        es = 0;
    } else e = Math.sqrt(es); // eccentricity
    var ep2 = (a2 - b2) / b2; // used in geocentric
    return {
        es: es,
        e: e,
        ep2: ep2
    };
}
function $98f4ab684186b766$export$b2690196de52b050(a, b, rf, ellps, sphere) {
    if (!a) {
        var ellipse = (0, $hzXAi.default)((0, $bO5FE.default), ellps);
        if (!ellipse) ellipse = (0, $bO5FE.WGS84);
        a = ellipse.a;
        b = ellipse.b;
        rf = ellipse.rf;
    }
    if (rf && !b) b = (1.0 - 1.0 / rf) * a;
    if (rf === 0 || Math.abs(a - b) < (0, $gyVUi.EPSLN)) {
        sphere = true;
        b = a;
    }
    return {
        a: a,
        b: b,
        rf: rf,
        sphere: sphere
    };
}

});
parcelRegister("bO5FE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8988c354f092c217$export$2e2bcd8739ae039);
$parcel$export(module.exports, "WGS84", () => $8988c354f092c217$export$a1db874f6c0f1ba1);
var $8988c354f092c217$export$2e2bcd8739ae039 = {};
$8988c354f092c217$export$2e2bcd8739ae039.MERIT = {
    a: 6378137.0,
    rf: 298.257,
    ellipseName: "MERIT 1983"
};
$8988c354f092c217$export$2e2bcd8739ae039.SGS85 = {
    a: 6378136.0,
    rf: 298.257,
    ellipseName: "Soviet Geodetic System 85"
};
$8988c354f092c217$export$2e2bcd8739ae039.GRS80 = {
    a: 6378137.0,
    rf: 298.257222101,
    ellipseName: "GRS 1980(IUGG, 1980)"
};
$8988c354f092c217$export$2e2bcd8739ae039.IAU76 = {
    a: 6378140.0,
    rf: 298.257,
    ellipseName: "IAU 1976"
};
$8988c354f092c217$export$2e2bcd8739ae039.airy = {
    a: 6377563.396,
    b: 6356256.910,
    ellipseName: "Airy 1830"
};
$8988c354f092c217$export$2e2bcd8739ae039.APL4 = {
    a: 6378137,
    rf: 298.25,
    ellipseName: "Appl. Physics. 1965"
};
$8988c354f092c217$export$2e2bcd8739ae039.NWL9D = {
    a: 6378145.0,
    rf: 298.25,
    ellipseName: "Naval Weapons Lab., 1965"
};
$8988c354f092c217$export$2e2bcd8739ae039.mod_airy = {
    a: 6377340.189,
    b: 6356034.446,
    ellipseName: "Modified Airy"
};
$8988c354f092c217$export$2e2bcd8739ae039.andrae = {
    a: 6377104.43,
    rf: 300.0,
    ellipseName: "Andrae 1876 (Den., Iclnd.)"
};
$8988c354f092c217$export$2e2bcd8739ae039.aust_SA = {
    a: 6378160.0,
    rf: 298.25,
    ellipseName: "Australian Natl & S. Amer. 1969"
};
$8988c354f092c217$export$2e2bcd8739ae039.GRS67 = {
    a: 6378160.0,
    rf: 298.2471674270,
    ellipseName: "GRS 67(IUGG 1967)"
};
$8988c354f092c217$export$2e2bcd8739ae039.bessel = {
    a: 6377397.155,
    rf: 299.1528128,
    ellipseName: "Bessel 1841"
};
$8988c354f092c217$export$2e2bcd8739ae039.bess_nam = {
    a: 6377483.865,
    rf: 299.1528128,
    ellipseName: "Bessel 1841 (Namibia)"
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk66 = {
    a: 6378206.4,
    b: 6356583.8,
    ellipseName: "Clarke 1866"
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk80 = {
    a: 6378249.145,
    rf: 293.4663,
    ellipseName: "Clarke 1880 mod."
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk80ign = {
    a: 6378249.2,
    b: 6356515,
    rf: 293.4660213,
    ellipseName: "Clarke 1880 (IGN)"
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk58 = {
    a: 6378293.645208759,
    rf: 294.2606763692654,
    ellipseName: "Clarke 1858"
};
$8988c354f092c217$export$2e2bcd8739ae039.CPM = {
    a: 6375738.7,
    rf: 334.29,
    ellipseName: "Comm. des Poids et Mesures 1799"
};
$8988c354f092c217$export$2e2bcd8739ae039.delmbr = {
    a: 6376428.0,
    rf: 311.5,
    ellipseName: "Delambre 1810 (Belgium)"
};
$8988c354f092c217$export$2e2bcd8739ae039.engelis = {
    a: 6378136.05,
    rf: 298.2566,
    ellipseName: "Engelis 1985"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst30 = {
    a: 6377276.345,
    rf: 300.8017,
    ellipseName: "Everest 1830"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst48 = {
    a: 6377304.063,
    rf: 300.8017,
    ellipseName: "Everest 1948"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst56 = {
    a: 6377301.243,
    rf: 300.8017,
    ellipseName: "Everest 1956"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst69 = {
    a: 6377295.664,
    rf: 300.8017,
    ellipseName: "Everest 1969"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrstSS = {
    a: 6377298.556,
    rf: 300.8017,
    ellipseName: "Everest (Sabah & Sarawak)"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr60 = {
    a: 6378166.0,
    rf: 298.3,
    ellipseName: "Fischer (Mercury Datum) 1960"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr60m = {
    a: 6378155.0,
    rf: 298.3,
    ellipseName: "Fischer 1960"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr68 = {
    a: 6378150.0,
    rf: 298.3,
    ellipseName: "Fischer 1968"
};
$8988c354f092c217$export$2e2bcd8739ae039.helmert = {
    a: 6378200.0,
    rf: 298.3,
    ellipseName: "Helmert 1906"
};
$8988c354f092c217$export$2e2bcd8739ae039.hough = {
    a: 6378270.0,
    rf: 297.0,
    ellipseName: "Hough"
};
$8988c354f092c217$export$2e2bcd8739ae039.intl = {
    a: 6378388.0,
    rf: 297.0,
    ellipseName: "International 1909 (Hayford)"
};
$8988c354f092c217$export$2e2bcd8739ae039.kaula = {
    a: 6378163.0,
    rf: 298.24,
    ellipseName: "Kaula 1961"
};
$8988c354f092c217$export$2e2bcd8739ae039.lerch = {
    a: 6378139.0,
    rf: 298.257,
    ellipseName: "Lerch 1979"
};
$8988c354f092c217$export$2e2bcd8739ae039.mprts = {
    a: 6397300.0,
    rf: 191.0,
    ellipseName: "Maupertius 1738"
};
$8988c354f092c217$export$2e2bcd8739ae039.new_intl = {
    a: 6378157.5,
    b: 6356772.2,
    ellipseName: "New International 1967"
};
$8988c354f092c217$export$2e2bcd8739ae039.plessis = {
    a: 6376523.0,
    rf: 6355863.0,
    ellipseName: "Plessis 1817 (France)"
};
$8988c354f092c217$export$2e2bcd8739ae039.krass = {
    a: 6378245.0,
    rf: 298.3,
    ellipseName: "Krassovsky, 1942"
};
$8988c354f092c217$export$2e2bcd8739ae039.SEasia = {
    a: 6378155.0,
    b: 6356773.3205,
    ellipseName: "Southeast Asia"
};
$8988c354f092c217$export$2e2bcd8739ae039.walbeck = {
    a: 6376896.0,
    b: 6355834.8467,
    ellipseName: "Walbeck"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS60 = {
    a: 6378165.0,
    rf: 298.3,
    ellipseName: "WGS 60"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS66 = {
    a: 6378145.0,
    rf: 298.25,
    ellipseName: "WGS 66"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS7 = {
    a: 6378135.0,
    rf: 298.26,
    ellipseName: "WGS 72"
};
var $8988c354f092c217$export$a1db874f6c0f1ba1 = $8988c354f092c217$export$2e2bcd8739ae039.WGS84 = {
    a: 6378137.0,
    rf: 298.257223563,
    ellipseName: "WGS 84"
};
$8988c354f092c217$export$2e2bcd8739ae039.sphere = {
    a: 6370997.0,
    b: 6370997.0,
    ellipseName: "Normal Sphere (r=6370997)"
};

});


parcelRegister("gMdFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36bbc8057de3d00$export$2e2bcd8739ae039);
var $c36bbc8057de3d00$export$2e2bcd8739ae039 = {};
$c36bbc8057de3d00$export$2e2bcd8739ae039.wgs84 = {
    towgs84: "0,0,0",
    ellipse: "WGS84",
    datumName: "WGS84"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.ch1903 = {
    towgs84: "674.374,15.056,405.346",
    ellipse: "bessel",
    datumName: "swiss"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.ggrs87 = {
    towgs84: "-199.87,74.79,246.62",
    ellipse: "GRS80",
    datumName: "Greek_Geodetic_Reference_System_1987"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.nad83 = {
    towgs84: "0,0,0",
    ellipse: "GRS80",
    datumName: "North_American_Datum_1983"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.nad27 = {
    nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
    ellipse: "clrk66",
    datumName: "North_American_Datum_1927"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.potsdam = {
    towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
    ellipse: "bessel",
    datumName: "Potsdam Rauenberg 1950 DHDN"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.carthage = {
    towgs84: "-263.0,6.0,431.0",
    ellipse: "clark80",
    datumName: "Carthage 1934 Tunisia"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.hermannskogel = {
    towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
    ellipse: "bessel",
    datumName: "Hermannskogel"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.militargeographische_institut = {
    towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
    ellipse: "bessel",
    datumName: "Militar-Geographische Institut"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.osni52 = {
    towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
    ellipse: "airy",
    datumName: "Irish National"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.ire65 = {
    towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
    ellipse: "mod_airy",
    datumName: "Ireland 1965"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.rassadiran = {
    towgs84: "-133.63,-157.5,-158.62",
    ellipse: "intl",
    datumName: "Rassadiran"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.nzgd49 = {
    towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
    ellipse: "intl",
    datumName: "New Zealand Geodetic Datum 1949"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.osgb36 = {
    towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
    ellipse: "airy",
    datumName: "Airy 1830"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.s_jtsk = {
    towgs84: "589,76,480",
    ellipse: "bessel",
    datumName: "S-JTSK (Ferro)"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.beduaram = {
    towgs84: "-106,-87,188",
    ellipse: "clrk80",
    datumName: "Beduaram"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.gunung_segara = {
    towgs84: "-403,684,41",
    ellipse: "bessel",
    datumName: "Gunung Segara Jakarta"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.rnb72 = {
    towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
    ellipse: "intl",
    datumName: "Reseau National Belge 1972"
};

});

parcelRegister("3MCqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c13a87cc45f972b$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $2c13a87cc45f972b$var$datum(datumCode, datum_params, a, b, es, ep2, nadgrids) {
    var out = {};
    if (datumCode === undefined || datumCode === "none") out.datum_type = (0, $gyVUi.PJD_NODATUM);
    else out.datum_type = (0, $gyVUi.PJD_WGS84);
    if (datum_params) {
        out.datum_params = datum_params.map(parseFloat);
        if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) out.datum_type = (0, $gyVUi.PJD_3PARAM);
        if (out.datum_params.length > 3) {
            if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
                out.datum_type = (0, $gyVUi.PJD_7PARAM);
                out.datum_params[3] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[4] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[5] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[6] = out.datum_params[6] / 1000000.0 + 1.0;
            }
        }
    }
    if (nadgrids) {
        out.datum_type = (0, $gyVUi.PJD_GRIDSHIFT);
        out.grids = nadgrids;
    }
    out.a = a; //datum object also uses these values
    out.b = b;
    out.es = es;
    out.ep2 = ep2;
    return out;
}
var $2c13a87cc45f972b$export$2e2bcd8739ae039 = $2c13a87cc45f972b$var$datum;

});

parcelRegister("flUkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2d482da445fbb18$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getNadgrids", () => $b2d482da445fbb18$export$31c4d9288d81329a);
/**
 * Resources for details of NTv2 file formats:
 * - https://web.archive.org/web/20140127204822if_/http://www.mgs.gov.on.ca:80/stdprodconsume/groups/content/@mgs/@iandit/documents/resourcelist/stel02_047447.pdf
 * - http://mimaka.com/help/gs/html/004_NTV2%20Data%20Format.htm
 */ var $b2d482da445fbb18$var$loadedNadgrids = {};
function $b2d482da445fbb18$export$2e2bcd8739ae039(key, data) {
    var view = new DataView(data);
    var isLittleEndian = $b2d482da445fbb18$var$detectLittleEndian(view);
    var header = $b2d482da445fbb18$var$readHeader(view, isLittleEndian);
    var subgrids = $b2d482da445fbb18$var$readSubgrids(view, header, isLittleEndian);
    var nadgrid = {
        header: header,
        subgrids: subgrids
    };
    $b2d482da445fbb18$var$loadedNadgrids[key] = nadgrid;
    return nadgrid;
}
function $b2d482da445fbb18$export$31c4d9288d81329a(nadgrids) {
    // Format details: http://proj.maptools.org/gen_parms.html
    if (nadgrids === undefined) return null;
    var grids = nadgrids.split(",");
    return grids.map($b2d482da445fbb18$var$parseNadgridString);
}
function $b2d482da445fbb18$var$parseNadgridString(value) {
    if (value.length === 0) return null;
    var optional = value[0] === "@";
    if (optional) value = value.slice(1);
    if (value === "null") return {
        name: "null",
        mandatory: !optional,
        grid: null,
        isNull: true
    };
    return {
        name: value,
        mandatory: !optional,
        grid: $b2d482da445fbb18$var$loadedNadgrids[value] || null,
        isNull: false
    };
}
function $b2d482da445fbb18$var$secondsToRadians(seconds) {
    return seconds / 3600 * Math.PI / 180;
}
function $b2d482da445fbb18$var$detectLittleEndian(view) {
    var nFields = view.getInt32(8, false);
    if (nFields === 11) return false;
    nFields = view.getInt32(8, true);
    if (nFields !== 11) console.warn("Failed to detect nadgrid endian-ness, defaulting to little-endian");
    return true;
}
function $b2d482da445fbb18$var$readHeader(view, isLittleEndian) {
    return {
        nFields: view.getInt32(8, isLittleEndian),
        nSubgridFields: view.getInt32(24, isLittleEndian),
        nSubgrids: view.getInt32(40, isLittleEndian),
        shiftType: $b2d482da445fbb18$var$decodeString(view, 56, 64).trim(),
        fromSemiMajorAxis: view.getFloat64(120, isLittleEndian),
        fromSemiMinorAxis: view.getFloat64(136, isLittleEndian),
        toSemiMajorAxis: view.getFloat64(152, isLittleEndian),
        toSemiMinorAxis: view.getFloat64(168, isLittleEndian)
    };
}
function $b2d482da445fbb18$var$decodeString(view, start, end) {
    return String.fromCharCode.apply(null, new Uint8Array(view.buffer.slice(start, end)));
}
function $b2d482da445fbb18$var$readSubgrids(view, header, isLittleEndian) {
    var gridOffset = 176;
    var grids = [];
    for(var i = 0; i < header.nSubgrids; i++){
        var subHeader = $b2d482da445fbb18$var$readGridHeader(view, gridOffset, isLittleEndian);
        var nodes = $b2d482da445fbb18$var$readGridNodes(view, gridOffset, subHeader, isLittleEndian);
        var lngColumnCount = Math.round(1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval);
        var latColumnCount = Math.round(1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval);
        // Proj4 operates on radians whereas the coordinates are in seconds in the grid
        grids.push({
            ll: [
                $b2d482da445fbb18$var$secondsToRadians(subHeader.lowerLongitude),
                $b2d482da445fbb18$var$secondsToRadians(subHeader.lowerLatitude)
            ],
            del: [
                $b2d482da445fbb18$var$secondsToRadians(subHeader.longitudeInterval),
                $b2d482da445fbb18$var$secondsToRadians(subHeader.latitudeInterval)
            ],
            lim: [
                lngColumnCount,
                latColumnCount
            ],
            count: subHeader.gridNodeCount,
            cvs: $b2d482da445fbb18$var$mapNodes(nodes)
        });
        gridOffset += 176 + subHeader.gridNodeCount * 16;
    }
    return grids;
}
function $b2d482da445fbb18$var$mapNodes(nodes) {
    return nodes.map(function(r) {
        return [
            $b2d482da445fbb18$var$secondsToRadians(r.longitudeShift),
            $b2d482da445fbb18$var$secondsToRadians(r.latitudeShift)
        ];
    });
}
function $b2d482da445fbb18$var$readGridHeader(view, offset, isLittleEndian) {
    return {
        name: $b2d482da445fbb18$var$decodeString(view, offset + 8, offset + 16).trim(),
        parent: $b2d482da445fbb18$var$decodeString(view, offset + 24, offset + 24 + 8).trim(),
        lowerLatitude: view.getFloat64(offset + 72, isLittleEndian),
        upperLatitude: view.getFloat64(offset + 88, isLittleEndian),
        lowerLongitude: view.getFloat64(offset + 104, isLittleEndian),
        upperLongitude: view.getFloat64(offset + 120, isLittleEndian),
        latitudeInterval: view.getFloat64(offset + 136, isLittleEndian),
        longitudeInterval: view.getFloat64(offset + 152, isLittleEndian),
        gridNodeCount: view.getInt32(offset + 168, isLittleEndian)
    };
}
function $b2d482da445fbb18$var$readGridNodes(view, offset, gridHeader, isLittleEndian) {
    var nodesOffset = offset + 176;
    var gridRecordLength = 16;
    var gridShiftRecords = [];
    for(var i = 0; i < gridHeader.gridNodeCount; i++){
        var record = {
            latitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength, isLittleEndian),
            longitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength + 4, isLittleEndian),
            latitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 8, isLittleEndian),
            longitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 12, isLittleEndian)
        };
        gridShiftRecords.push(record);
    }
    return gridShiftRecords;
}

});


parcelRegister("ceNev", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8cfb7cbefc2113$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $d7qcu = parcelRequire("d7qcu");

var $hL60j = parcelRequire("hL60j");

var $38qqf = parcelRequire("38qqf");

var $5vTfu = parcelRequire("5vTfu");

var $coO2L = parcelRequire("coO2L");
function $8e8cfb7cbefc2113$var$checkNotWGS(source, dest) {
    return (source.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || source.datum.datum_type === (0, $gyVUi.PJD_7PARAM) || source.datum.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) && dest.datumCode !== "WGS84" || (dest.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || dest.datum.datum_type === (0, $gyVUi.PJD_7PARAM) || dest.datum.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) && source.datumCode !== "WGS84";
}
function $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, dest, point, enforceAxis) {
    var wgs84;
    if (Array.isArray(point)) point = (0, $5vTfu.default)(point);
    else // Clone the point object so inputs don't get modified
    point = {
        x: point.x,
        y: point.y,
        z: point.z,
        m: point.m
    };
    var hasZ = point.z !== undefined;
    (0, $coO2L.default)(point);
    // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
    if (source.datum && dest.datum && $8e8cfb7cbefc2113$var$checkNotWGS(source, dest)) {
        wgs84 = new (0, $38qqf.default)("WGS84");
        point = $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, wgs84, point, enforceAxis);
        source = wgs84;
    }
    // DGR, 2010/11/12
    if (enforceAxis && source.axis !== "enu") point = (0, $hL60j.default)(source, false, point);
    // Transform source points to long/lat, if they aren't already.
    if (source.projName === "longlat") point = {
        x: point.x * (0, $gyVUi.D2R),
        y: point.y * (0, $gyVUi.D2R),
        z: point.z || 0
    };
    else {
        if (source.to_meter) point = {
            x: point.x * source.to_meter,
            y: point.y * source.to_meter,
            z: point.z || 0
        };
        point = source.inverse(point); // Convert Cartesian to longlat
        if (!point) return;
    }
    // Adjust for the prime meridian if necessary
    if (source.from_greenwich) point.x += source.from_greenwich;
    // Convert datums if needed, and if possible.
    point = (0, $d7qcu.default)(source.datum, dest.datum, point);
    if (!point) return;
    // Adjust for the prime meridian if necessary
    if (dest.from_greenwich) point = {
        x: point.x - dest.from_greenwich,
        y: point.y,
        z: point.z || 0
    };
    if (dest.projName === "longlat") // convert radians to decimal degrees
    point = {
        x: point.x * (0, $gyVUi.R2D),
        y: point.y * (0, $gyVUi.R2D),
        z: point.z || 0
    };
    else {
        point = dest.forward(point);
        if (dest.to_meter) point = {
            x: point.x / dest.to_meter,
            y: point.y / dest.to_meter,
            z: point.z || 0
        };
    }
    // DGR, 2010/11/12
    if (enforceAxis && dest.axis !== "enu") return (0, $hL60j.default)(dest, true, point);
    if (point && !hasZ) delete point.z;
    return point;
}

});
parcelRegister("d7qcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d040a88dc0214f$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $4YPx7 = parcelRequire("4YPx7");

var $a9oRf = parcelRequire("a9oRf");
function $98d040a88dc0214f$var$checkParams(type) {
    return type === (0, $gyVUi.PJD_3PARAM) || type === (0, $gyVUi.PJD_7PARAM);
}
function $98d040a88dc0214f$export$2e2bcd8739ae039(source, dest, point) {
    // Short cut if the datums are identical.
    if ((0, $4YPx7.compareDatums)(source, dest)) return point; // in this case, zero is sucess,
    // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
    if (source.datum_type === (0, $gyVUi.PJD_NODATUM) || dest.datum_type === (0, $gyVUi.PJD_NODATUM)) return point;
    // If this datum requires grid shifts, then apply it to geodetic coordinates.
    var source_a = source.a;
    var source_es = source.es;
    if (source.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        var gridShiftCode = $98d040a88dc0214f$export$cfa06df23524576a(source, false, point);
        if (gridShiftCode !== 0) return undefined;
        source_a = (0, $gyVUi.SRS_WGS84_SEMIMAJOR);
        source_es = (0, $gyVUi.SRS_WGS84_ESQUARED);
    }
    var dest_a = dest.a;
    var dest_b = dest.b;
    var dest_es = dest.es;
    if (dest.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        dest_a = (0, $gyVUi.SRS_WGS84_SEMIMAJOR);
        dest_b = (0, $gyVUi.SRS_WGS84_SEMIMINOR);
        dest_es = (0, $gyVUi.SRS_WGS84_ESQUARED);
    }
    // Do we need to go through geocentric coordinates?
    if (source_es === dest_es && source_a === dest_a && !$98d040a88dc0214f$var$checkParams(source.datum_type) && !$98d040a88dc0214f$var$checkParams(dest.datum_type)) return point;
    // Convert to geocentric coordinates.
    point = (0, $4YPx7.geodeticToGeocentric)(point, source_es, source_a);
    // Convert between datums
    if ($98d040a88dc0214f$var$checkParams(source.datum_type)) point = (0, $4YPx7.geocentricToWgs84)(point, source.datum_type, source.datum_params);
    if ($98d040a88dc0214f$var$checkParams(dest.datum_type)) point = (0, $4YPx7.geocentricFromWgs84)(point, dest.datum_type, dest.datum_params);
    point = (0, $4YPx7.geocentricToGeodetic)(point, dest_es, dest_a, dest_b);
    if (dest.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        var destGridShiftResult = $98d040a88dc0214f$export$cfa06df23524576a(dest, true, point);
        if (destGridShiftResult !== 0) return undefined;
    }
    return point;
}
function $98d040a88dc0214f$export$cfa06df23524576a(source, inverse, point) {
    if (source.grids === null || source.grids.length === 0) {
        console.log("Grid shift grids not found");
        return -1;
    }
    var input = {
        x: -point.x,
        y: point.y
    };
    var output = {
        x: Number.NaN,
        y: Number.NaN
    };
    var onlyMandatoryGrids = false;
    var attemptedGrids = [];
    outer: for(var i = 0; i < source.grids.length; i++){
        var grid = source.grids[i];
        attemptedGrids.push(grid.name);
        if (grid.isNull) {
            output = input;
            break;
        }
        onlyMandatoryGrids = grid.mandatory;
        if (grid.grid === null) {
            if (grid.mandatory) {
                console.log("Unable to find mandatory grid '" + grid.name + "'");
                return -1;
            }
            continue;
        }
        var subgrids = grid.grid.subgrids;
        for(var j = 0, jj = subgrids.length; j < jj; j++){
            var subgrid = subgrids[j];
            // skip tables that don't match our point at all
            var epsilon = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 10000.0;
            var minX = subgrid.ll[0] - epsilon;
            var minY = subgrid.ll[1] - epsilon;
            var maxX = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon;
            var maxY = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon;
            if (minY > input.y || minX > input.x || maxY < input.y || maxX < input.x) continue;
            output = $98d040a88dc0214f$var$applySubgridShift(input, inverse, subgrid);
            if (!isNaN(output.x)) break outer;
        }
    }
    if (isNaN(output.x)) {
        console.log("Failed to find a grid shift table for location '" + -input.x * (0, $gyVUi.R2D) + " " + input.y * (0, $gyVUi.R2D) + " tried: '" + attemptedGrids + "'");
        return -1;
    }
    point.x = -output.x;
    point.y = output.y;
    return 0;
}
function $98d040a88dc0214f$var$applySubgridShift(pin, inverse, ct) {
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    if (isNaN(pin.x)) return val;
    var tb = {
        x: pin.x,
        y: pin.y
    };
    tb.x -= ct.ll[0];
    tb.y -= ct.ll[1];
    tb.x = (0, $a9oRf.default)(tb.x - Math.PI) + Math.PI;
    var t = $98d040a88dc0214f$var$nadInterpolate(tb, ct);
    if (inverse) {
        if (isNaN(t.x)) return val;
        t.x = tb.x - t.x;
        t.y = tb.y - t.y;
        var i = 9, tol = 1e-12;
        var dif, del;
        do {
            del = $98d040a88dc0214f$var$nadInterpolate(t, ct);
            if (isNaN(del.x)) {
                console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
                break;
            }
            dif = {
                x: tb.x - (del.x + t.x),
                y: tb.y - (del.y + t.y)
            };
            t.x += dif.x;
            t.y += dif.y;
        }while (i-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
        if (i < 0) {
            console.log("Inverse grid shift iterator failed to converge.");
            return val;
        }
        val.x = (0, $a9oRf.default)(t.x + ct.ll[0]);
        val.y = t.y + ct.ll[1];
    } else if (!isNaN(t.x)) {
        val.x = pin.x + t.x;
        val.y = pin.y + t.y;
    }
    return val;
}
function $98d040a88dc0214f$var$nadInterpolate(pin, ct) {
    var t = {
        x: pin.x / ct.del[0],
        y: pin.y / ct.del[1]
    };
    var indx = {
        x: Math.floor(t.x),
        y: Math.floor(t.y)
    };
    var frct = {
        x: t.x - 1.0 * indx.x,
        y: t.y - 1.0 * indx.y
    };
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    var inx;
    if (indx.x < 0 || indx.x >= ct.lim[0]) return val;
    if (indx.y < 0 || indx.y >= ct.lim[1]) return val;
    inx = indx.y * ct.lim[0] + indx.x;
    var f00 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx++;
    var f10 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx += ct.lim[0];
    var f11 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx--;
    var f01 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    var m11 = frct.x * frct.y, m10 = frct.x * (1.0 - frct.y), m00 = (1.0 - frct.x) * (1.0 - frct.y), m01 = (1.0 - frct.x) * frct.y;
    val.x = m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x;
    val.y = m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y;
    return val;
}

});
parcelRegister("4YPx7", function(module, exports) {

$parcel$export(module.exports, "compareDatums", () => $3a04bd721826a648$export$68c8d8590fbb24e4);
$parcel$export(module.exports, "geodeticToGeocentric", () => $3a04bd721826a648$export$4a4ae2976f9a808a);
$parcel$export(module.exports, "geocentricToGeodetic", () => $3a04bd721826a648$export$26210192c8922750);
$parcel$export(module.exports, "geocentricToWgs84", () => $3a04bd721826a648$export$d18952b9ecb47c8f);
$parcel$export(module.exports, "geocentricFromWgs84", () => $3a04bd721826a648$export$2b744ad521e7ac0b);

var $gyVUi = parcelRequire("gyVUi");
"use strict";
function $3a04bd721826a648$export$68c8d8590fbb24e4(source, dest) {
    if (source.datum_type !== dest.datum_type) return false; // false, datums are not equal
    else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) // the tolerance for es is to ensure that GRS80 and WGS84
    // are considered identical
    return false;
    else if (source.datum_type === (0, $gyVUi.PJD_3PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2];
    else if (source.datum_type === (0, $gyVUi.PJD_7PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6];
    else return true; // datums are equal
} // cs_compare_datums()
function $3a04bd721826a648$export$4a4ae2976f9a808a(p, es, a) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; //Z value not always supplied
    var Rn; /*  Earth radius at location  */ 
    var Sin_Lat; /*  Math.sin(Latitude)  */ 
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */ 
    var Cos_Lat; /*  Math.cos(Latitude)  */ 
    /*
   ** Don't blow up if Latitude is just a little out of the value
   ** range as it may just be a rounding issue.  Also removed longitude
   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
   */ if (Latitude < -(0, $gyVUi.HALF_PI) && Latitude > -1.001 * (0, $gyVUi.HALF_PI)) Latitude = -(0, $gyVUi.HALF_PI);
    else if (Latitude > (0, $gyVUi.HALF_PI) && Latitude < 1.001 * (0, $gyVUi.HALF_PI)) Latitude = (0, $gyVUi.HALF_PI);
    else if (Latitude < -(0, $gyVUi.HALF_PI)) /* Latitude out of range */ //..reportError('geocent:lat out of range:' + Latitude);
    return {
        x: -Infinity,
        y: -Infinity,
        z: p.z
    };
    else if (Latitude > (0, $gyVUi.HALF_PI)) /* Latitude out of range */ return {
        x: Infinity,
        y: Infinity,
        z: p.z
    };
    if (Longitude > Math.PI) Longitude -= 2 * Math.PI;
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = a / Math.sqrt(1.0e0 - es * Sin2_Lat);
    return {
        x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
        y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
        z: (Rn * (1 - es) + Height) * Sin_Lat
    };
} // cs_geodetic_to_geocentric()
function $3a04bd721826a648$export$26210192c8922750(p, es, a, b) {
    /* local defintions and variables */ /* end-criterium of loop, accuracy of sin(Latitude) */ var genau = 1e-12;
    var genau2 = genau * genau;
    var maxiter = 30;
    var P; /* distance between semi-minor axis and location */ 
    var RR; /* distance between center and location */ 
    var CT; /* sin of geocentric latitude */ 
    var ST; /* cos of geocentric latitude */ 
    var RX;
    var RK;
    var RN; /* Earth radius at location */ 
    var CPHI0; /* cos of start or old geodetic latitude in iterations */ 
    var SPHI0; /* sin of start or old geodetic latitude in iterations */ 
    var CPHI; /* cos of searched geodetic latitude */ 
    var SPHI; /* sin of searched geodetic latitude */ 
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */ 
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */ 
    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; //Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;
    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);
    /*      special cases for latitude and longitude */ if (P / a < genau) {
        /*  special case, if P=0. (X=0., Y=0.) */ Longitude = 0.0;
        /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */ if (RR / a < genau) {
            Latitude = (0, $gyVUi.HALF_PI);
            Height = -b;
            return {
                x: p.x,
                y: p.y,
                z: p.z
            };
        }
    } else /*  ellipsoidal (geodetic) longitude
     *  interval: -PI < Longitude <= +PI */ Longitude = Math.atan2(Y, X);
    /* --------------------------------------------------------------
   * Following iterative algorithm was developped by
   * "Institut for Erdmessung", University of Hannover, July 1988.
   * Internet: www.ife.uni-hannover.de
   * Iterative computation of CPHI,SPHI and Height.
   * Iteration of CPHI and SPHI to 10**-12 radian resp.
   * 2*10**-7 arcsec.
   * --------------------------------------------------------------
   */ CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
    CPHI0 = ST * (1.0 - es) * RX;
    SPHI0 = CT * RX;
    iter = 0;
    /* loop to find sin(Latitude) resp. Latitude
   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */ do {
        iter++;
        RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);
        /*  ellipsoidal (geodetic) height */ Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);
        RK = es * RN / (RN + Height);
        RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
        CPHI = ST * (1.0 - RK) * RX;
        SPHI = CT * RX;
        SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
        CPHI0 = CPHI;
        SPHI0 = SPHI;
    }while (SDPHI * SDPHI > genau2 && iter < maxiter);
    /*      ellipsoidal (geodetic) latitude */ Latitude = Math.atan(SPHI / Math.abs(CPHI));
    return {
        x: Longitude,
        y: Latitude,
        z: Height
    };
} // cs_geocentric_to_geodetic()
function $3a04bd721826a648$export$d18952b9ecb47c8f(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x + datum_params[0],
        y: p.y + datum_params[1],
        z: p.z + datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
            y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
            z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
        };
    }
} // cs_geocentric_to_wgs84
function $3a04bd721826a648$export$2b744ad521e7ac0b(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) //if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x - datum_params[0],
        y: p.y - datum_params[1],
        z: p.z - datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        var x_tmp = (p.x - Dx_BF) / M_BF;
        var y_tmp = (p.y - Dy_BF) / M_BF;
        var z_tmp = (p.z - Dz_BF) / M_BF;
        //if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
            y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
            z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
        };
    } //cs_geocentric_from_wgs84()
}

});


parcelRegister("hL60j", function(module, exports) {

$parcel$export(module.exports, "default", () => $cedb7bb5617791b0$export$2e2bcd8739ae039);
function $cedb7bb5617791b0$export$2e2bcd8739ae039(crs, denorm, point) {
    var xin = point.x, yin = point.y, zin = point.z || 0.0;
    var v, t, i;
    var out = {};
    for(i = 0; i < 3; i++){
        if (denorm && i === 2 && point.z === undefined) continue;
        if (i === 0) {
            v = xin;
            if ("ew".indexOf(crs.axis[i]) !== -1) t = "x";
            else t = "y";
        } else if (i === 1) {
            v = yin;
            if ("ns".indexOf(crs.axis[i]) !== -1) t = "y";
            else t = "x";
        } else {
            v = zin;
            t = "z";
        }
        switch(crs.axis[i]){
            case "e":
                out[t] = v;
                break;
            case "w":
                out[t] = -v;
                break;
            case "n":
                out[t] = v;
                break;
            case "s":
                out[t] = -v;
                break;
            case "u":
                if (point[t] !== undefined) out.z = v;
                break;
            case "d":
                if (point[t] !== undefined) out.z = -v;
                break;
            default:
                //console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
                return null;
        }
    }
    return out;
}

});

parcelRegister("5vTfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $01093474ae9bd8f6$export$2e2bcd8739ae039);
function $01093474ae9bd8f6$export$2e2bcd8739ae039(array) {
    var out = {
        x: array[0],
        y: array[1]
    };
    if (array.length > 2) out.z = array[2];
    if (array.length > 3) out.m = array[3];
    return out;
}

});

parcelRegister("coO2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $906e8b8bdc80d434$export$2e2bcd8739ae039);
function $906e8b8bdc80d434$export$2e2bcd8739ae039(point) {
    $906e8b8bdc80d434$var$checkCoord(point.x);
    $906e8b8bdc80d434$var$checkCoord(point.y);
}
function $906e8b8bdc80d434$var$checkCoord(num) {
    if (typeof Number.isFinite === "function") {
        if (Number.isFinite(num)) return;
        throw new TypeError("coordinates must be finite numbers");
    }
    if (typeof num !== "number" || num !== num || !isFinite(num)) throw new TypeError("coordinates must be finite numbers");
}

});



parcelRegister("iCFRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8ec3fc1ff061c76$export$2e2bcd8739ae039);

var $4hMrQ = parcelRequire("4hMrQ");
function $d8ec3fc1ff061c76$var$Point(x, y, z) {
    if (!(this instanceof $d8ec3fc1ff061c76$var$Point)) return new $d8ec3fc1ff061c76$var$Point(x, y, z);
    if (Array.isArray(x)) {
        this.x = x[0];
        this.y = x[1];
        this.z = x[2] || 0.0;
    } else if (typeof x === "object") {
        this.x = x.x;
        this.y = x.y;
        this.z = x.z || 0.0;
    } else if (typeof x === "string" && typeof y === "undefined") {
        var coords = x.split(",");
        this.x = parseFloat(coords[0], 10);
        this.y = parseFloat(coords[1], 10);
        this.z = parseFloat(coords[2], 10) || 0.0;
    } else {
        this.x = x;
        this.y = y;
        this.z = z || 0.0;
    }
    console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
}
$d8ec3fc1ff061c76$var$Point.fromMGRS = function(mgrsStr) {
    return new $d8ec3fc1ff061c76$var$Point((0, $4hMrQ.toPoint)(mgrsStr));
};
$d8ec3fc1ff061c76$var$Point.prototype.toMGRS = function(accuracy) {
    return (0, $4hMrQ.forward)([
        this.x,
        this.y
    ], accuracy);
};
var $d8ec3fc1ff061c76$export$2e2bcd8739ae039 = $d8ec3fc1ff061c76$var$Point;

});
parcelRegister("4hMrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ee54b8e1d1cd8f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "forward", () => $31ee54b8e1d1cd8f$export$174bb771924e7eb1);
$parcel$export(module.exports, "toPoint", () => $31ee54b8e1d1cd8f$export$b63cca88ddc558a9);
/**
 * UTM zones are grouped, and assigned to one of a group of 6
 * sets.
 *
 * {int} @private
 */ var $31ee54b8e1d1cd8f$var$NUM_100K_SETS = 6;
/**
 * The column letters (for easting) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS = "AJSAJS";
/**
 * The row letters (for northing) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS = "AFAFAF";
var $31ee54b8e1d1cd8f$var$A = 65; // A
var $31ee54b8e1d1cd8f$var$I = 73; // I
var $31ee54b8e1d1cd8f$var$O = 79; // O
var $31ee54b8e1d1cd8f$var$V = 86; // V
var $31ee54b8e1d1cd8f$var$Z = 90; // Z
var $31ee54b8e1d1cd8f$export$2e2bcd8739ae039 = {
    forward: $31ee54b8e1d1cd8f$export$174bb771924e7eb1,
    inverse: $31ee54b8e1d1cd8f$export$70ae2c07e401031b,
    toPoint: $31ee54b8e1d1cd8f$export$b63cca88ddc558a9
};
function $31ee54b8e1d1cd8f$export$174bb771924e7eb1(ll, accuracy) {
    accuracy = accuracy || 5; // default accuracy 1m
    return $31ee54b8e1d1cd8f$var$encode($31ee54b8e1d1cd8f$var$LLtoUTM({
        lat: ll[1],
        lon: ll[0]
    }), accuracy);
}
function $31ee54b8e1d1cd8f$export$70ae2c07e401031b(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat,
        bbox.lon,
        bbox.lat
    ];
    return [
        bbox.left,
        bbox.bottom,
        bbox.right,
        bbox.top
    ];
}
function $31ee54b8e1d1cd8f$export$b63cca88ddc558a9(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat
    ];
    return [
        (bbox.left + bbox.right) / 2,
        (bbox.top + bbox.bottom) / 2
    ];
}
/**
 * Conversion from degrees to radians.
 *
 * @private
 * @param {number} deg the angle in degrees.
 * @return {number} the angle in radians.
 */ function $31ee54b8e1d1cd8f$var$degToRad(deg) {
    return deg * (Math.PI / 180.0);
}
/**
 * Conversion from radians to degrees.
 *
 * @private
 * @param {number} rad the angle in radians.
 * @return {number} the angle in degrees.
 */ function $31ee54b8e1d1cd8f$var$radToDeg(rad) {
    return 180.0 * (rad / Math.PI);
}
/**
 * Converts a set of Longitude and Latitude co-ordinates to UTM
 * using the WGS84 ellipsoid.
 *
 * @private
 * @param {object} ll Object literal with lat and lon properties
 *     representing the WGS84 coordinate to be converted.
 * @return {object} Object literal containing the UTM value with easting,
 *     northing, zoneNumber and zoneLetter properties, and an optional
 *     accuracy property in digits. Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$LLtoUTM(ll) {
    var Lat = ll.lat;
    var Long = ll.lon;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var k0 = 0.9996;
    var LongOrigin;
    var eccPrimeSquared;
    var N, T, C, A, M;
    var LatRad = $31ee54b8e1d1cd8f$var$degToRad(Lat);
    var LongRad = $31ee54b8e1d1cd8f$var$degToRad(Long);
    var LongOriginRad;
    var ZoneNumber;
    // (int)
    ZoneNumber = Math.floor((Long + 180) / 6) + 1;
    //Make sure the longitude 180.00 is in Zone 60
    if (Long === 180) ZoneNumber = 60;
    // Special zone for Norway
    if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) ZoneNumber = 32;
    // Special zones for Svalbard
    if (Lat >= 72.0 && Lat < 84.0) {
        if (Long >= 0.0 && Long < 9.0) ZoneNumber = 31;
        else if (Long >= 9.0 && Long < 21.0) ZoneNumber = 33;
        else if (Long >= 21.0 && Long < 33.0) ZoneNumber = 35;
        else if (Long >= 33.0 && Long < 42.0) ZoneNumber = 37;
    }
    LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
    // in middle of
    // zone
    LongOriginRad = $31ee54b8e1d1cd8f$var$degToRad(LongOrigin);
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
    T = Math.tan(LatRad) * Math.tan(LatRad);
    C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
    A = Math.cos(LatRad) * (LongRad - LongOriginRad);
    M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - 35 * eccSquared * eccSquared * eccSquared / 3072 * Math.sin(6 * LatRad));
    var UTMEasting = k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0;
    var UTMNorthing = k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0));
    if (Lat < 0.0) UTMNorthing += 10000000.0; //10000000 meter offset for
    return {
        northing: Math.round(UTMNorthing),
        easting: Math.round(UTMEasting),
        zoneNumber: ZoneNumber,
        zoneLetter: $31ee54b8e1d1cd8f$var$getLetterDesignator(Lat)
    };
}
/**
 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
 * class where the Zone can be specified as a single string eg."60N" which
 * is then broken down into the ZoneNumber and ZoneLetter.
 *
 * @private
 * @param {object} utm An object literal with northing, easting, zoneNumber
 *     and zoneLetter properties. If an optional accuracy property is
 *     provided (in meters), a bounding box will be returned instead of
 *     latitude and longitude.
 * @return {object} An object literal containing either lat and lon values
 *     (if no accuracy was provided), or top, right, bottom and left values
 *     for the bounding box calculated according to the provided accuracy.
 *     Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$UTMtoLL(utm) {
    var UTMNorthing = utm.northing;
    var UTMEasting = utm.easting;
    var zoneLetter = utm.zoneLetter;
    var zoneNumber = utm.zoneNumber;
    // check the ZoneNummber is valid
    if (zoneNumber < 0 || zoneNumber > 60) return null;
    var k0 = 0.9996;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var eccPrimeSquared;
    var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
    var N1, T1, C1, R1, D, M;
    var LongOrigin;
    var mu, phi1Rad;
    // remove 500,000 meter offset for longitude
    var x = UTMEasting - 500000.0;
    var y = UTMNorthing;
    // We must know somehow if we are in the Northern or Southern
    // hemisphere, this is the only time we use the letter So even
    // if the Zone letter isn't exactly correct it should indicate
    // the hemisphere correctly
    if (zoneLetter < "N") y -= 10000000.0; // remove 10,000,000 meter offset used
    // There are 60 zones with zone 1 being at West -180 to -174
    LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
    // in middle of
    // zone
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    M = y / k0;
    mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));
    phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + 151 * e1 * e1 * e1 / 96 * Math.sin(6 * mu);
    // double phi1 = ProjMath.radToDeg(phi1Rad);
    N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
    T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
    C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
    R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
    D = x / (N1 * k0);
    var lat = phi1Rad - N1 * Math.tan(phi1Rad) / R1 * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
    lat = $31ee54b8e1d1cd8f$var$radToDeg(lat);
    var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
    lon = LongOrigin + $31ee54b8e1d1cd8f$var$radToDeg(lon);
    var result;
    if (utm.accuracy) {
        var topRight = $31ee54b8e1d1cd8f$var$UTMtoLL({
            northing: utm.northing + utm.accuracy,
            easting: utm.easting + utm.accuracy,
            zoneLetter: utm.zoneLetter,
            zoneNumber: utm.zoneNumber
        });
        result = {
            top: topRight.lat,
            right: topRight.lon,
            bottom: lat,
            left: lon
        };
    } else result = {
        lat: lat,
        lon: lon
    };
    return result;
}
/**
 * Calculates the MGRS letter designator for the given latitude.
 *
 * @private
 * @param {number} lat The latitude in WGS84 to get the letter designator
 *     for.
 * @return {char} The letter designator.
 */ function $31ee54b8e1d1cd8f$var$getLetterDesignator(lat) {
    //This is here as an error flag to show that the Latitude is
    //outside MGRS limits
    var LetterDesignator = "Z";
    if (84 >= lat && lat >= 72) LetterDesignator = "X";
    else if (72 > lat && lat >= 64) LetterDesignator = "W";
    else if (64 > lat && lat >= 56) LetterDesignator = "V";
    else if (56 > lat && lat >= 48) LetterDesignator = "U";
    else if (48 > lat && lat >= 40) LetterDesignator = "T";
    else if (40 > lat && lat >= 32) LetterDesignator = "S";
    else if (32 > lat && lat >= 24) LetterDesignator = "R";
    else if (24 > lat && lat >= 16) LetterDesignator = "Q";
    else if (16 > lat && lat >= 8) LetterDesignator = "P";
    else if (8 > lat && lat >= 0) LetterDesignator = "N";
    else if (0 > lat && lat >= -8) LetterDesignator = "M";
    else if (-8 > lat && lat >= -16) LetterDesignator = "L";
    else if (-16 > lat && lat >= -24) LetterDesignator = "K";
    else if (-24 > lat && lat >= -32) LetterDesignator = "J";
    else if (-32 > lat && lat >= -40) LetterDesignator = "H";
    else if (-40 > lat && lat >= -48) LetterDesignator = "G";
    else if (-48 > lat && lat >= -56) LetterDesignator = "F";
    else if (-56 > lat && lat >= -64) LetterDesignator = "E";
    else if (-64 > lat && lat >= -72) LetterDesignator = "D";
    else if (-72 > lat && lat >= -80) LetterDesignator = "C";
    return LetterDesignator;
}
/**
 * Encodes a UTM location as MGRS string.
 *
 * @private
 * @param {object} utm An object literal with easting, northing,
 *     zoneLetter, zoneNumber
 * @param {number} accuracy Accuracy in digits (1-5).
 * @return {string} MGRS string for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$encode(utm, accuracy) {
    // prepend with leading zeroes
    var seasting = "00000" + utm.easting, snorthing = "00000" + utm.northing;
    return utm.zoneNumber + utm.zoneLetter + $31ee54b8e1d1cd8f$var$get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}
/**
 * Get the two letter 100k designator for a given UTM easting,
 * northing and zone number value.
 *
 * @private
 * @param {number} easting
 * @param {number} northing
 * @param {number} zoneNumber
 * @return the two letter 100k designator for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$get100kID(easting, northing, zoneNumber) {
    var setParm = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var setColumn = Math.floor(easting / 100000);
    var setRow = Math.floor(northing / 100000) % 20;
    return $31ee54b8e1d1cd8f$var$getLetter100kID(setColumn, setRow, setParm);
}
/**
 * Given a UTM zone number, figure out the MGRS 100K set it is in.
 *
 * @private
 * @param {number} i An UTM zone number.
 * @return {number} the 100k set the UTM zone is in.
 */ function $31ee54b8e1d1cd8f$var$get100kSetForZone(i) {
    var setParm = i % $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    if (setParm === 0) setParm = $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    return setParm;
}
/**
 * Get the two-letter MGRS 100k designator given information
 * translated from the UTM northing, easting and zone number.
 *
 * @private
 * @param {number} column the column index as it relates to the MGRS
 *        100k set spreadsheet, created from the UTM easting.
 *        Values are 1-8.
 * @param {number} row the row index as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM northing value. Values
 *        are from 0-19.
 * @param {number} parm the set block, as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM zone. Values are from
 *        1-60.
 * @return two letter MGRS 100k code.
 */ function $31ee54b8e1d1cd8f$var$getLetter100kID(column, row, parm) {
    // colOrigin and rowOrigin are the letters at the origin of the set
    var index = parm - 1;
    var colOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
    var rowOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(index);
    // colInt and rowInt are the letters to build to return
    var colInt = colOrigin + column - 1;
    var rowInt = rowOrigin + row;
    var rollover = false;
    if (colInt > $31ee54b8e1d1cd8f$var$Z) {
        colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    }
    if (colInt === $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I && colInt > $31ee54b8e1d1cd8f$var$I || (colInt > $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) colInt++;
    if (colInt === $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O && colInt > $31ee54b8e1d1cd8f$var$O || (colInt > $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        colInt++;
        if (colInt === $31ee54b8e1d1cd8f$var$I) colInt++;
    }
    if (colInt > $31ee54b8e1d1cd8f$var$Z) colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
    if (rowInt > $31ee54b8e1d1cd8f$var$V) {
        rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    } else rollover = false;
    if (rowInt === $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I && rowInt > $31ee54b8e1d1cd8f$var$I || (rowInt > $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) rowInt++;
    if (rowInt === $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O && rowInt > $31ee54b8e1d1cd8f$var$O || (rowInt > $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        rowInt++;
        if (rowInt === $31ee54b8e1d1cd8f$var$I) rowInt++;
    }
    if (rowInt > $31ee54b8e1d1cd8f$var$V) rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
    var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
    return twoLetter;
}
/**
 * Decode the UTM parameters from a MGRS string.
 *
 * @private
 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
 * @return {object} An object literal with easting, northing, zoneLetter,
 *     zoneNumber and accuracy (in meters) properties.
 */ function $31ee54b8e1d1cd8f$var$decode(mgrsString) {
    if (mgrsString && mgrsString.length === 0) throw "MGRSPoint coverting from nothing";
    var length = mgrsString.length;
    var hunK = null;
    var sb = "";
    var testChar;
    var i = 0;
    // get Zone number
    while(!/[A-Z]/.test(testChar = mgrsString.charAt(i))){
        if (i >= 2) throw "MGRSPoint bad conversion from: " + mgrsString;
        sb += testChar;
        i++;
    }
    var zoneNumber = parseInt(sb, 10);
    if (i === 0 || i + 3 > length) // A good MGRS string has to be 4-5 digits long,
    // ##AAA/#AAA at least.
    throw "MGRSPoint bad conversion from: " + mgrsString;
    var zoneLetter = mgrsString.charAt(i++);
    // Should we check the zone letter here? Why not.
    if (zoneLetter <= "A" || zoneLetter === "B" || zoneLetter === "Y" || zoneLetter >= "Z" || zoneLetter === "I" || zoneLetter === "O") throw "MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString;
    hunK = mgrsString.substring(i, i += 2);
    var set = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var east100k = $31ee54b8e1d1cd8f$var$getEastingFromChar(hunK.charAt(0), set);
    var north100k = $31ee54b8e1d1cd8f$var$getNorthingFromChar(hunK.charAt(1), set);
    // We have a bug where the northing may be 2000000 too low.
    // How
    // do we know when to roll over?
    while(north100k < $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter))north100k += 2000000;
    // calculate the char index for easting/northing separator
    var remainder = length - i;
    if (remainder % 2 !== 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString;
    var sep = remainder / 2;
    var sepEasting = 0.0;
    var sepNorthing = 0.0;
    var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
    if (sep > 0) {
        accuracyBonus = 100000.0 / Math.pow(10, sep);
        sepEastingString = mgrsString.substring(i, i + sep);
        sepEasting = parseFloat(sepEastingString) * accuracyBonus;
        sepNorthingString = mgrsString.substring(i + sep);
        sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
    }
    easting = sepEasting + east100k;
    northing = sepNorthing + north100k;
    return {
        easting: easting,
        northing: northing,
        zoneLetter: zoneLetter,
        zoneNumber: zoneNumber,
        accuracy: accuracyBonus
    };
}
/**
 * Given the first letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the easting value that
 * should be added to the other, secondary easting value.
 *
 * @private
 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
 * @param {number} set The MGRS table set for the zone number.
 * @return {number} The easting value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getEastingFromChar(e, set) {
    // colOrigin is the letter at the origin of the set for the
    // column
    var curCol = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
    var eastingValue = 100000.0;
    var rewindMarker = false;
    while(curCol !== e.charCodeAt(0)){
        curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$I) curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$O) curCol++;
        if (curCol > $31ee54b8e1d1cd8f$var$Z) {
            if (rewindMarker) throw "Bad character: " + e;
            curCol = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        eastingValue += 100000.0;
    }
    return eastingValue;
}
/**
 * Given the second letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the northing value that
 * should be added to the other, secondary northing value. You have to
 * remember that Northings are determined from the equator, and the vertical
 * cycle of letters mean a 2000000 additional northing meters. This happens
 * approx. every 18 degrees of latitude. This method does *NOT* count any
 * additional northings. You have to figure out how many 2000000 meters need
 * to be added for the zone letter of the MGRS coordinate.
 *
 * @private
 * @param {char} n Second letter of the MGRS 100k zone
 * @param {number} set The MGRS table set number, which is dependent on the
 *     UTM zone number.
 * @return {number} The northing value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getNorthingFromChar(n, set) {
    if (n > "V") throw "MGRSPoint given invalid Northing " + n;
    // rowOrigin is the letter at the origin of the set for the
    // column
    var curRow = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
    var northingValue = 0.0;
    var rewindMarker = false;
    while(curRow !== n.charCodeAt(0)){
        curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$I) curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$O) curRow++;
        // fixing a bug making whole application hang in this loop
        // when 'n' is a wrong character
        if (curRow > $31ee54b8e1d1cd8f$var$V) {
            if (rewindMarker) throw "Bad character: " + n;
            curRow = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        northingValue += 100000.0;
    }
    return northingValue;
}
/**
 * The function getMinNorthing returns the minimum northing value of a MGRS
 * zone.
 *
 * Ported from Geotrans' c Lattitude_Band_Value structure table.
 *
 * @private
 * @param {char} zoneLetter The MGRS zone to get the min northing for.
 * @return {number}
 */ function $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter) {
    var northing;
    switch(zoneLetter){
        case "C":
            northing = 1100000.0;
            break;
        case "D":
            northing = 2000000.0;
            break;
        case "E":
            northing = 2800000.0;
            break;
        case "F":
            northing = 3700000.0;
            break;
        case "G":
            northing = 4600000.0;
            break;
        case "H":
            northing = 5500000.0;
            break;
        case "J":
            northing = 6400000.0;
            break;
        case "K":
            northing = 7300000.0;
            break;
        case "L":
            northing = 8200000.0;
            break;
        case "M":
            northing = 9100000.0;
            break;
        case "N":
            northing = 0.0;
            break;
        case "P":
            northing = 800000.0;
            break;
        case "Q":
            northing = 1700000.0;
            break;
        case "R":
            northing = 2600000.0;
            break;
        case "S":
            northing = 3500000.0;
            break;
        case "T":
            northing = 4400000.0;
            break;
        case "U":
            northing = 5300000.0;
            break;
        case "V":
            northing = 6200000.0;
            break;
        case "W":
            northing = 7000000.0;
            break;
        case "X":
            northing = 7900000.0;
            break;
        default:
            northing = -1;
    }
    if (northing >= 0.0) return northing;
    else throw "Invalid zone letter: " + zoneLetter;
}

});


parcelRegister("j48cx", function(module, exports) {

$parcel$export(module.exports, "default", () => $de14c0a63cfa0e0d$export$2e2bcd8739ae039);

var $9t3dO = parcelRequire("9t3dO");

var $9zr9G = parcelRequire("9zr9G");

var $kAWkR = parcelRequire("kAWkR");

var $5HQRm = parcelRequire("5HQRm");

var $llHto = parcelRequire("llHto");

var $4gjYM = parcelRequire("4gjYM");

var $ejQ1Z = parcelRequire("ejQ1Z");

var $iubsy = parcelRequire("iubsy");

var $h7o5G = parcelRequire("h7o5G");

var $0599r = parcelRequire("0599r");

var $deudM = parcelRequire("deudM");

var $8mhgZ = parcelRequire("8mhgZ");

var $iSJfu = parcelRequire("iSJfu");

var $6CTAc = parcelRequire("6CTAc");

var $cEGTl = parcelRequire("cEGTl");

var $2Lrqq = parcelRequire("2Lrqq");

var $6Eu1X = parcelRequire("6Eu1X");

var $fpjAW = parcelRequire("fpjAW");

var $eA4Bc = parcelRequire("eA4Bc");

var $7uCfv = parcelRequire("7uCfv");

var $hp0oy = parcelRequire("hp0oy");

var $1W450 = parcelRequire("1W450");

var $i6dz6 = parcelRequire("i6dz6");

var $37G1n = parcelRequire("37G1n");

var $2XUb4 = parcelRequire("2XUb4");

var $byZja = parcelRequire("byZja");

var $Fj8jS = parcelRequire("Fj8jS");

var $eJp9e = parcelRequire("eJp9e");

var $jJ6PL = parcelRequire("jJ6PL");

var $cbANR = parcelRequire("cbANR");
function $de14c0a63cfa0e0d$export$2e2bcd8739ae039(proj4) {
    proj4.Proj.projections.add((0, $9t3dO.default));
    proj4.Proj.projections.add((0, $9zr9G.default));
    proj4.Proj.projections.add((0, $kAWkR.default));
    proj4.Proj.projections.add((0, $5HQRm.default));
    proj4.Proj.projections.add((0, $llHto.default));
    proj4.Proj.projections.add((0, $4gjYM.default));
    proj4.Proj.projections.add((0, $ejQ1Z.default));
    proj4.Proj.projections.add((0, $iubsy.default));
    proj4.Proj.projections.add((0, $h7o5G.default));
    proj4.Proj.projections.add((0, $0599r.default));
    proj4.Proj.projections.add((0, $deudM.default));
    proj4.Proj.projections.add((0, $8mhgZ.default));
    proj4.Proj.projections.add((0, $iSJfu.default));
    proj4.Proj.projections.add((0, $6CTAc.default));
    proj4.Proj.projections.add((0, $cEGTl.default));
    proj4.Proj.projections.add((0, $2Lrqq.default));
    proj4.Proj.projections.add((0, $6Eu1X.default));
    proj4.Proj.projections.add((0, $fpjAW.default));
    proj4.Proj.projections.add((0, $eA4Bc.default));
    proj4.Proj.projections.add((0, $7uCfv.default));
    proj4.Proj.projections.add((0, $hp0oy.default));
    proj4.Proj.projections.add((0, $1W450.default));
    proj4.Proj.projections.add((0, $i6dz6.default));
    proj4.Proj.projections.add((0, $37G1n.default));
    proj4.Proj.projections.add((0, $2XUb4.default));
    proj4.Proj.projections.add((0, $byZja.default));
    proj4.Proj.projections.add((0, $Fj8jS.default));
    proj4.Proj.projections.add((0, $eJp9e.default));
    proj4.Proj.projections.add((0, $jJ6PL.default));
    proj4.Proj.projections.add((0, $cbANR.default));
}

});
parcelRegister("9t3dO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e495242beb4668f$export$2e2bcd8739ae039);
// Heavily based on this tmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js

var $gqKpL = parcelRequire("gqKpL");

var $hpUQm = parcelRequire("hpUQm");

var $jQUK6 = parcelRequire("jQUK6");

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $6e495242beb4668f$export$2cd8252107eb640b() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    if (this.es) {
        this.en = (0, $gqKpL.default)(this.es);
        this.ml0 = (0, $hpUQm.default)(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
    }
}
function $6e495242beb4668f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    var con;
    var x, y;
    var sin_phi = Math.sin(lat);
    var cos_phi = Math.cos(lat);
    if (!this.es) {
        var b = cos_phi * Math.sin(delta_lon);
        if (Math.abs(Math.abs(b) - 1) < (0, $gyVUi.EPSLN)) return 93;
        else {
            x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
            y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
            b = Math.abs(y);
            if (b >= 1) {
                if (b - 1 > (0, $gyVUi.EPSLN)) return 93;
                else y = 0;
            } else y = Math.acos(y);
            if (lat < 0) y = -y;
            y = this.a * this.k0 * (y - this.lat0) + this.y0;
        }
    } else {
        var al = cos_phi * delta_lon;
        var als = Math.pow(al, 2);
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var tq = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(lat) : 0;
        var t = Math.pow(tq, 2);
        var ts = Math.pow(t, 2);
        con = 1 - this.es * Math.pow(sin_phi, 2);
        al = al / Math.sqrt(con);
        var ml = (0, $hpUQm.default)(lat, sin_phi, cos_phi, this.en);
        x = this.a * (this.k0 * al * (1 + als / 6 * (1 - t + c + als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c + als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) + this.x0;
        y = this.a * (this.k0 * (ml - this.ml0 + sin_phi * delta_lon * al / 2 * (1 + als / 12 * (5 - t + 9 * c + 4 * cs + als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c + als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) + this.y0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $6e495242beb4668f$export$70ae2c07e401031b(p) {
    var con, phi;
    var lat, lon;
    var x = (p.x - this.x0) * (1 / this.a);
    var y = (p.y - this.y0) * (1 / this.a);
    if (!this.es) {
        var f = Math.exp(x / this.k0);
        var g = 0.5 * (f - 1 / f);
        var temp = this.lat0 + y / this.k0;
        var h = Math.cos(temp);
        con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
        lat = Math.asin(con);
        if (y < 0) lat = -lat;
        if (g === 0 && h === 0) lon = 0;
        else lon = (0, $a9oRf.default)(Math.atan2(g, h) + this.long0);
    } else {
        con = this.ml0 + y / this.k0;
        phi = (0, $jQUK6.default)(con, this.es, this.en);
        if (Math.abs(phi) < (0, $gyVUi.HALF_PI)) {
            var sin_phi = Math.sin(phi);
            var cos_phi = Math.cos(phi);
            var tan_phi = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(phi) : 0;
            var c = this.ep2 * Math.pow(cos_phi, 2);
            var cs = Math.pow(c, 2);
            var t = Math.pow(tan_phi, 2);
            var ts = Math.pow(t, 2);
            con = 1 - this.es * Math.pow(sin_phi, 2);
            var d = x * Math.sqrt(con) / this.k0;
            var ds = Math.pow(d, 2);
            con = con * tan_phi;
            lat = phi - con * ds / (1 - this.es) * 0.5 * (1 - ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs - ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c - ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));
            lon = (0, $a9oRf.default)(this.long0 + d * (1 - ds / 6 * (1 + 2 * t + c - ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c - ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi);
        } else {
            lat = (0, $gyVUi.HALF_PI) * (0, $boTd3.default)(y);
            lon = 0;
        }
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $6e495242beb4668f$export$e4b2ac9215619f8d = [
    "Fast_Transverse_Mercator",
    "Fast Transverse Mercator"
];
var $6e495242beb4668f$export$2e2bcd8739ae039 = {
    init: $6e495242beb4668f$export$2cd8252107eb640b,
    forward: $6e495242beb4668f$export$174bb771924e7eb1,
    inverse: $6e495242beb4668f$export$70ae2c07e401031b,
    names: $6e495242beb4668f$export$e4b2ac9215619f8d
};

});
parcelRegister("gqKpL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf6313ff986be9ac$export$2e2bcd8739ae039);
var $bf6313ff986be9ac$var$C00 = 1;
var $bf6313ff986be9ac$var$C02 = 0.25;
var $bf6313ff986be9ac$var$C04 = 0.046875;
var $bf6313ff986be9ac$var$C06 = 0.01953125;
var $bf6313ff986be9ac$var$C08 = 0.01068115234375;
var $bf6313ff986be9ac$var$C22 = 0.75;
var $bf6313ff986be9ac$var$C44 = 0.46875;
var $bf6313ff986be9ac$var$C46 = 0.01302083333333333333;
var $bf6313ff986be9ac$var$C48 = 0.00712076822916666666;
var $bf6313ff986be9ac$var$C66 = 0.36458333333333333333;
var $bf6313ff986be9ac$var$C68 = 0.00569661458333333333;
var $bf6313ff986be9ac$var$C88 = 0.3076171875;
function $bf6313ff986be9ac$export$2e2bcd8739ae039(es) {
    var en = [];
    en[0] = $bf6313ff986be9ac$var$C00 - es * ($bf6313ff986be9ac$var$C02 + es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    en[1] = es * ($bf6313ff986be9ac$var$C22 - es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    var t = es * es;
    en[2] = t * ($bf6313ff986be9ac$var$C44 - es * ($bf6313ff986be9ac$var$C46 + es * $bf6313ff986be9ac$var$C48));
    t *= es;
    en[3] = t * ($bf6313ff986be9ac$var$C66 - es * $bf6313ff986be9ac$var$C68);
    en[4] = t * es * $bf6313ff986be9ac$var$C88;
    return en;
}

});

parcelRegister("hpUQm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae0dd692f473684$export$2e2bcd8739ae039);
function $cae0dd692f473684$export$2e2bcd8739ae039(phi, sphi, cphi, en) {
    cphi *= sphi;
    sphi *= sphi;
    return en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4])));
}

});

parcelRegister("jQUK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e73ee39023f9c198$export$2e2bcd8739ae039);

var $hpUQm = parcelRequire("hpUQm");

var $gyVUi = parcelRequire("gyVUi");
var $e73ee39023f9c198$var$MAX_ITER = 20;
function $e73ee39023f9c198$export$2e2bcd8739ae039(arg, es, en) {
    var k = 1 / (1 - es);
    var phi = arg;
    for(var i = $e73ee39023f9c198$var$MAX_ITER; i; --i){
        var s = Math.sin(phi);
        var t = 1 - es * s * s;
        //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
        //phi -= t * (t * Math.sqrt(t)) * k;
        t = ((0, $hpUQm.default)(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
        phi -= t;
        if (Math.abs(t) < (0, $gyVUi.EPSLN)) return phi;
    }
    //..reportError("cass:pj_inv_mlfn: Convergence error");
    return phi;
}

});


parcelRegister("9zr9G", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $6f7c72613b8aa92a$export$2e2bcd8739ae039);
// Heavily based on this etmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js

var $9t3dO = parcelRequire("9t3dO");

var $zBlxr = parcelRequire("zBlxr");

var $jU5gu = parcelRequire("jU5gu");

var $cVtoA = parcelRequire("cVtoA");

var $klaWo = parcelRequire("klaWo");

var $k0stT = parcelRequire("k0stT");

var $iKZ74 = parcelRequire("iKZ74");

var $a9oRf = parcelRequire("a9oRf");
function init() {
    if (!this.approx && (isNaN(this.es) || this.es <= 0)) throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
    if (this.approx) {
        // When '+approx' is set, use tmerc instead
        (0, $9t3dO.default).init.apply(this);
        this.forward = (0, $9t3dO.default).forward;
        this.inverse = (0, $9t3dO.default).inverse;
    }
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    this.cgb = [];
    this.cbg = [];
    this.utg = [];
    this.gtu = [];
    var f = this.es / (1 + Math.sqrt(1 - this.es));
    var n = f / (2 - f);
    var np = n;
    this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675))))));
    this.cbg[0] = n * (-2 + n * (2 / 3 + n * (4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
    np = np * n;
    this.cgb[1] = np * (7 / 3 + n * (-1.6 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
    this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * (-13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
    np = np * n;
    this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
    this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (1.6 + n * (-12686 / 2835))));
    np = np * n;
    this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
    this.cbg[3] = np * (1237 / 630 + n * (-2.4 + n * (-24832 / 14175)));
    np = np * n;
    this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
    this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
    np = np * n;
    this.cgb[5] = np * (601676 / 22275);
    this.cbg[5] = np * (444337 / 155925);
    np = Math.pow(n, 2);
    this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
    this.utg[0] = n * (-0.5 + n * (2 / 3 + n * (-37 / 96 + n * (1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
    this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
    this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
    this.gtu[1] = np * (13 / 48 + n * (-0.6 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
    np = np * n;
    this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720))));
    this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
    np = np * n;
    this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
    this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
    np = np * n;
    this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
    this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
    np = np * n;
    this.utg[5] = np * (-20648693 / 638668800);
    this.gtu[5] = np * 0.6650675310896665;
    var Z = (0, $klaWo.default)(this.cbg, this.lat0);
    this.Zb = -this.Qn * (Z + (0, $k0stT.default)(this.gtu, 2 * Z));
}
function forward(p) {
    var Ce = (0, $a9oRf.default)(p.x - this.long0);
    var Cn = p.y;
    Cn = (0, $klaWo.default)(this.cbg, Cn);
    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);
    Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
    Ce = Math.atan2(sin_Ce * cos_Cn, (0, $jU5gu.default)(sin_Cn, cos_Cn * cos_Ce));
    Ce = (0, $cVtoA.default)(Math.tan(Ce));
    var tmp = (0, $iKZ74.default)(this.gtu, 2 * Cn, 2 * Ce);
    Cn = Cn + tmp[0];
    Ce = Ce + tmp[1];
    var x;
    var y;
    if (Math.abs(Ce) <= 2.623395162778) {
        x = this.a * (this.Qn * Ce) + this.x0;
        y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
    } else {
        x = Infinity;
        y = Infinity;
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var Ce = (p.x - this.x0) * (1 / this.a);
    var Cn = (p.y - this.y0) * (1 / this.a);
    Cn = (Cn - this.Zb) / this.Qn;
    Ce = Ce / this.Qn;
    var lon;
    var lat;
    if (Math.abs(Ce) <= 2.623395162778) {
        var tmp = (0, $iKZ74.default)(this.utg, 2 * Cn, 2 * Ce);
        Cn = Cn + tmp[0];
        Ce = Ce + tmp[1];
        Ce = Math.atan((0, $zBlxr.default)(Ce));
        var sin_Cn = Math.sin(Cn);
        var cos_Cn = Math.cos(Cn);
        var sin_Ce = Math.sin(Ce);
        var cos_Ce = Math.cos(Ce);
        Cn = Math.atan2(sin_Cn * cos_Ce, (0, $jU5gu.default)(sin_Ce, cos_Ce * cos_Cn));
        Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);
        lon = (0, $a9oRf.default)(Ce + this.long0);
        lat = (0, $klaWo.default)(this.cgb, Cn);
    } else {
        lon = Infinity;
        lat = Infinity;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    "Extended_Transverse_Mercator",
    "Extended Transverse Mercator",
    "etmerc",
    "Transverse_Mercator",
    "Transverse Mercator",
    "Gauss Kruger",
    "Gauss_Kruger",
    "tmerc"
];
var $6f7c72613b8aa92a$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});
parcelRegister("zBlxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b03d370063c40e$export$2e2bcd8739ae039);
function $06b03d370063c40e$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r - 1 / r) / 2;
    return r;
}

});

parcelRegister("jU5gu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d754d244264a37$export$2e2bcd8739ae039);
function $e7d754d244264a37$export$2e2bcd8739ae039(x, y) {
    x = Math.abs(x);
    y = Math.abs(y);
    var a = Math.max(x, y);
    var b = Math.min(x, y) / (a ? a : 1);
    return a * Math.sqrt(1 + Math.pow(b, 2));
}

});

parcelRegister("cVtoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $96919c3c2b0cfee9$export$2e2bcd8739ae039);

var $jU5gu = parcelRequire("jU5gu");

var $g1hBf = parcelRequire("g1hBf");
function $96919c3c2b0cfee9$export$2e2bcd8739ae039(x) {
    var y = Math.abs(x);
    y = (0, $g1hBf.default)(y * (1 + y / ((0, $jU5gu.default)(1, y) + 1)));
    return x < 0 ? -y : y;
}

});
parcelRegister("g1hBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a64430787103e$export$2e2bcd8739ae039);
function $ba9a64430787103e$export$2e2bcd8739ae039(x) {
    var y = 1 + x;
    var z = y - 1;
    return z === 0 ? x : x * Math.log(y) / z;
}

});


parcelRegister("klaWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecee41736c9c0e4b$export$2e2bcd8739ae039);
function $ecee41736c9c0e4b$export$2e2bcd8739ae039(pp, B) {
    var cos_2B = 2 * Math.cos(2 * B);
    var i = pp.length - 1;
    var h1 = pp[i];
    var h2 = 0;
    var h;
    while(--i >= 0){
        h = -h2 + cos_2B * h1 + pp[i];
        h2 = h1;
        h1 = h;
    }
    return B + h * Math.sin(2 * B);
}

});

parcelRegister("k0stT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e909e682fc23c405$export$2e2bcd8739ae039);
function $e909e682fc23c405$export$2e2bcd8739ae039(pp, arg_r) {
    var r = 2 * Math.cos(arg_r);
    var i = pp.length - 1;
    var hr1 = pp[i];
    var hr2 = 0;
    var hr;
    while(--i >= 0){
        hr = -hr2 + r * hr1 + pp[i];
        hr2 = hr1;
        hr1 = hr;
    }
    return Math.sin(arg_r) * hr;
}

});

parcelRegister("iKZ74", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7beda932685c15$export$2e2bcd8739ae039);

var $zBlxr = parcelRequire("zBlxr");

var $cz4ED = parcelRequire("cz4ED");
function $da7beda932685c15$export$2e2bcd8739ae039(pp, arg_r, arg_i) {
    var sin_arg_r = Math.sin(arg_r);
    var cos_arg_r = Math.cos(arg_r);
    var sinh_arg_i = (0, $zBlxr.default)(arg_i);
    var cosh_arg_i = (0, $cz4ED.default)(arg_i);
    var r = 2 * cos_arg_r * cosh_arg_i;
    var i = -2 * sin_arg_r * sinh_arg_i;
    var j = pp.length - 1;
    var hr = pp[j];
    var hi1 = 0;
    var hr1 = 0;
    var hi = 0;
    var hr2;
    var hi2;
    while(--j >= 0){
        hr2 = hr1;
        hi2 = hi1;
        hr1 = hr;
        hi1 = hi;
        hr = -hr2 + r * hr1 - i * hi1 + pp[j];
        hi = -hi2 + i * hr1 + r * hi1;
    }
    r = sin_arg_r * cosh_arg_i;
    i = cos_arg_r * sinh_arg_i;
    return [
        r * hr - i * hi,
        r * hi + i * hr
    ];
}

});
parcelRegister("cz4ED", function(module, exports) {

$parcel$export(module.exports, "default", () => $925c5d35b4e59088$export$2e2bcd8739ae039);
function $925c5d35b4e59088$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r + 1 / r) / 2;
    return r;
}

});



parcelRegister("kAWkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe46ba059d82de2$export$2e2bcd8739ae039);

var $b4YJ1 = parcelRequire("b4YJ1");

var $9zr9G = parcelRequire("9zr9G");

var $gyVUi = parcelRequire("gyVUi");
var $efe46ba059d82de2$export$3f91ef0e0d0d8bf8 = "etmerc";
function $efe46ba059d82de2$export$2cd8252107eb640b() {
    var zone = (0, $b4YJ1.default)(this.zone, this.long0);
    if (zone === undefined) throw new Error("unknown utm zone");
    this.lat0 = 0;
    this.long0 = (6 * Math.abs(zone) - 183) * (0, $gyVUi.D2R);
    this.x0 = 500000;
    this.y0 = this.utmSouth ? 10000000 : 0;
    this.k0 = 0.9996;
    (0, $9zr9G.default).init.apply(this);
    this.forward = (0, $9zr9G.default).forward;
    this.inverse = (0, $9zr9G.default).inverse;
}
var $efe46ba059d82de2$export$e4b2ac9215619f8d = [
    "Universal Transverse Mercator System",
    "utm"
];
var $efe46ba059d82de2$export$2e2bcd8739ae039 = {
    init: $efe46ba059d82de2$export$2cd8252107eb640b,
    names: $efe46ba059d82de2$export$e4b2ac9215619f8d,
    dependsOn: $efe46ba059d82de2$export$3f91ef0e0d0d8bf8
};

});
parcelRegister("b4YJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $810f2c2910fd20b1$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");
function $810f2c2910fd20b1$export$2e2bcd8739ae039(zone, lon) {
    if (zone === undefined) {
        zone = Math.floor(((0, $a9oRf.default)(lon) + Math.PI) * 30 / Math.PI) + 1;
        if (zone < 0) return 0;
        else if (zone > 60) return 60;
    }
    return zone;
}

});


parcelRegister("5HQRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4279f8b9d31284e6$export$2e2bcd8739ae039);

var $zGHAa = parcelRequire("zGHAa");

var $a9oRf = parcelRequire("a9oRf");

var $jU5gu = parcelRequire("jU5gu");
function $4279f8b9d31284e6$export$2cd8252107eb640b() {
    (0, $zGHAa.default).init.apply(this);
    if (!this.rc) return;
    this.sinc0 = Math.sin(this.phic0);
    this.cosc0 = Math.cos(this.phic0);
    this.R2 = 2 * this.rc;
    if (!this.title) this.title = "Oblique Stereographic Alternative";
}
function $4279f8b9d31284e6$export$174bb771924e7eb1(p) {
    var sinc, cosc, cosl, k;
    p.x = (0, $a9oRf.default)(p.x - this.long0);
    (0, $zGHAa.default).forward.apply(this, [
        p
    ]);
    sinc = Math.sin(p.y);
    cosc = Math.cos(p.y);
    cosl = Math.cos(p.x);
    k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
    p.x = k * cosc * Math.sin(p.x);
    p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $4279f8b9d31284e6$export$70ae2c07e401031b(p) {
    var sinc, cosc, lon, lat, rho;
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rho = (0, $jU5gu.default)(p.x, p.y)) {
        var c = 2 * Math.atan2(rho, this.R2);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
        lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    (0, $zGHAa.default).inverse.apply(this, [
        p
    ]);
    p.x = (0, $a9oRf.default)(p.x + this.long0);
    return p;
}
var $4279f8b9d31284e6$export$e4b2ac9215619f8d = [
    "Stereographic_North_Pole",
    "Oblique_Stereographic",
    "sterea",
    "Oblique Stereographic Alternative",
    "Double_Stereographic"
];
var $4279f8b9d31284e6$export$2e2bcd8739ae039 = {
    init: $4279f8b9d31284e6$export$2cd8252107eb640b,
    forward: $4279f8b9d31284e6$export$174bb771924e7eb1,
    inverse: $4279f8b9d31284e6$export$70ae2c07e401031b,
    names: $4279f8b9d31284e6$export$e4b2ac9215619f8d
};

});
parcelRegister("zGHAa", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b464b721451620$export$2e2bcd8739ae039);

var $82Tex = parcelRequire("82Tex");

var $gyVUi = parcelRequire("gyVUi");
var $06b464b721451620$var$MAX_ITER = 20;
function $06b464b721451620$export$2cd8252107eb640b() {
    var sphi = Math.sin(this.lat0);
    var cphi = Math.cos(this.lat0);
    cphi *= cphi;
    this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
    this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
    this.phic0 = Math.asin(sphi / this.C);
    this.ratexp = 0.5 * this.C * this.e;
    this.K = Math.tan(0.5 * this.phic0 + (0, $gyVUi.FORTPI)) / (Math.pow(Math.tan(0.5 * this.lat0 + (0, $gyVUi.FORTPI)), this.C) * (0, $82Tex.default)(this.e * sphi, this.ratexp));
}
function $06b464b721451620$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)), this.C) * (0, $82Tex.default)(this.e * Math.sin(lat), this.ratexp)) - (0, $gyVUi.HALF_PI);
    p.x = this.C * lon;
    return p;
}
function $06b464b721451620$export$70ae2c07e401031b(p) {
    var DEL_TOL = 1e-14;
    var lon = p.x / this.C;
    var lat = p.y;
    var num = Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)) / this.K, 1 / this.C);
    for(var i = $06b464b721451620$var$MAX_ITER; i > 0; --i){
        lat = 2 * Math.atan(num * (0, $82Tex.default)(this.e * Math.sin(p.y), -0.5 * this.e)) - (0, $gyVUi.HALF_PI);
        if (Math.abs(lat - p.y) < DEL_TOL) break;
        p.y = lat;
    }
    /* convergence failed */ if (!i) return null;
    p.x = lon;
    p.y = lat;
    return p;
}
var $06b464b721451620$export$e4b2ac9215619f8d = [
    "gauss"
];
var $06b464b721451620$export$2e2bcd8739ae039 = {
    init: $06b464b721451620$export$2cd8252107eb640b,
    forward: $06b464b721451620$export$174bb771924e7eb1,
    inverse: $06b464b721451620$export$70ae2c07e401031b,
    names: $06b464b721451620$export$e4b2ac9215619f8d
};

});
parcelRegister("82Tex", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db95ad4da70d3a6$export$2e2bcd8739ae039);
function $5db95ad4da70d3a6$export$2e2bcd8739ae039(esinp, exp) {
    return Math.pow((1 - esinp) / (1 + esinp), exp);
}

});



parcelRegister("llHto", function(module, exports) {

$parcel$export(module.exports, "ssfn_", () => ssfn_);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $f8ad4802022ce868$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");

var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $a9oRf = parcelRequire("a9oRf");
function ssfn_(phit, sinphi, eccen) {
    sinphi *= eccen;
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen);
}
function init() {
    // setting default parameters
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.coslat0 = Math.cos(this.lat0);
    this.sinlat0 = Math.sin(this.lat0);
    if (this.sphere) {
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) this.k0 = 0.5 * (1 + (0, $boTd3.default)(this.lat0) * Math.sin(this.lat_ts));
    } else {
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) //North pole
            //trace('stere:north pole');
            this.con = 1;
            else //South pole
            //trace('stere:south pole');
            this.con = -1;
        }
        this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN) && Math.abs(Math.cos(this.lat_ts)) > (0, $gyVUi.EPSLN)) // When k0 is 1 (default value) and lat_ts is a vaild number and lat0 is at a pole and lat_ts is not at a pole
        // Recalculate k0 using formula 21-35 from p161 of Snyder, 1987
        this.k0 = 0.5 * this.cons * (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / (0, $3xC66.default)(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
        this.ms1 = (0, $bi5ZC.default)(this.e, this.sinlat0, this.coslat0);
        this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - (0, $gyVUi.HALF_PI);
        this.cosX0 = Math.cos(this.X0);
        this.sinX0 = Math.sin(this.X0);
    }
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var sinlat = Math.sin(lat);
    var coslat = Math.cos(lat);
    var A, X, sinX, cosX, ts, rh;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= (0, $gyVUi.EPSLN) && Math.abs(lat + this.lat0) <= (0, $gyVUi.EPSLN)) {
        //case of the origine point
        //trace('stere:this is the origin point');
        p.x = NaN;
        p.y = NaN;
        return p;
    }
    if (this.sphere) {
        //trace('stere:sphere case');
        A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
        p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
        p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
        return p;
    } else {
        X = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - (0, $gyVUi.HALF_PI);
        cosX = Math.cos(X);
        sinX = Math.sin(X);
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            ts = (0, $3xC66.default)(this.e, lat * this.con, this.con * sinlat);
            rh = 2 * this.a * this.k0 * ts / this.cons;
            p.x = this.x0 + rh * Math.sin(lon - this.long0);
            p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
            //trace(p.toString());
            return p;
        } else if (Math.abs(this.sinlat0) < (0, $gyVUi.EPSLN)) {
            //Eq
            //trace('stere:equateur');
            A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
            p.y = A * sinX;
        } else {
            //other case
            //trace('stere:normal case');
            A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
            p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
        }
        p.x = A * cosX * Math.sin(dlon) + this.x0;
    }
    //trace(p.toString());
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat, ts, ce, Chi;
    var rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (this.sphere) {
        var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
        lon = this.long0;
        lat = this.lat0;
        if (rh <= (0, $gyVUi.EPSLN)) {
            p.x = lon;
            p.y = lat;
            return p;
        }
        lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
        if (Math.abs(this.coslat0) < (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y));
            else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y));
        } else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
        p.x = lon;
        p.y = lat;
        return p;
    } else if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
        if (rh <= (0, $gyVUi.EPSLN)) {
            lat = this.lat0;
            lon = this.long0;
            p.x = lon;
            p.y = lat;
            //trace(p.toString());
            return p;
        }
        p.x *= this.con;
        p.y *= this.con;
        ts = rh * this.cons / (2 * this.a * this.k0);
        lat = this.con * (0, $2AZR8.default)(this.e, ts);
        lon = this.con * (0, $a9oRf.default)(this.con * this.long0 + Math.atan2(p.x, -1 * p.y));
    } else {
        ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
        lon = this.long0;
        if (rh <= (0, $gyVUi.EPSLN)) Chi = this.X0;
        else {
            Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
        }
        lat = -1 * (0, $2AZR8.default)(this.e, Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + Chi)));
    }
    p.x = lon;
    p.y = lat;
    //trace(p.toString());
    return p;
}
var names = [
    "stere",
    "Stereographic_South_Pole",
    "Polar Stereographic (variant B)",
    "Polar_Stereographic"
];
var $f8ad4802022ce868$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    ssfn_: ssfn_
};

});

parcelRegister("4gjYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a8278a941356d4$export$2e2bcd8739ae039);
/*
  references:
    Formules et constantes pour le Calcul pour la
    projection cylindrique conforme à axe oblique et pour la transformation entre
    des systèmes de référence.
    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
  */ function $31a8278a941356d4$export$2cd8252107eb640b() {
    var phy0 = this.lat0;
    this.lambda0 = this.long0;
    var sinPhy0 = Math.sin(phy0);
    var semiMajorAxis = this.a;
    var invF = this.rf;
    var flattening = 1 / invF;
    var e2 = 2 * flattening - Math.pow(flattening, 2);
    var e = this.e = Math.sqrt(e2);
    this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
    this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
    this.b0 = Math.asin(sinPhy0 / this.alpha);
    var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
    var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
    var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
    this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
}
function $31a8278a941356d4$export$174bb771924e7eb1(p) {
    var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
    var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
    var S = -this.alpha * (Sa1 + Sa2) + this.K;
    // spheric latitude
    var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);
    // spheric longitude
    var I = this.alpha * (p.x - this.lambda0);
    // psoeudo equatorial rotation
    var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));
    var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));
    p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
    p.x = this.R * rotI + this.x0;
    return p;
}
function $31a8278a941356d4$export$70ae2c07e401031b(p) {
    var Y = p.x - this.x0;
    var X = p.y - this.y0;
    var rotI = Y / this.R;
    var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);
    var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
    var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));
    var lambda = this.lambda0 + I / this.alpha;
    var S = 0;
    var phy = b;
    var prevPhy = -1000;
    var iteration = 0;
    while(Math.abs(phy - prevPhy) > 0.0000001){
        if (++iteration > 20) //...reportError("omercFwdInfinity");
        return;
        //S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
        S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
        prevPhy = phy;
        phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
    }
    p.x = lambda;
    p.y = phy;
    return p;
}
var $31a8278a941356d4$export$e4b2ac9215619f8d = [
    "somerc"
];
var $31a8278a941356d4$export$2e2bcd8739ae039 = {
    init: $31a8278a941356d4$export$2cd8252107eb640b,
    forward: $31a8278a941356d4$export$174bb771924e7eb1,
    inverse: $31a8278a941356d4$export$70ae2c07e401031b,
    names: $31a8278a941356d4$export$e4b2ac9215619f8d
};

});

parcelRegister("ejQ1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6cb33582cb5910b$export$2e2bcd8739ae039);

var $3xC66 = parcelRequire("3xC66");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
var $a6cb33582cb5910b$var$TOL = 1e-7;
function $a6cb33582cb5910b$var$isTypeA(P) {
    var typeAProjections = [
        "Hotine_Oblique_Mercator",
        "Hotine_Oblique_Mercator_Azimuth_Natural_Origin"
    ];
    var projectionName = typeof P.PROJECTION === "object" ? Object.keys(P.PROJECTION)[0] : P.PROJECTION;
    return "no_uoff" in P || "no_off" in P || typeAProjections.indexOf(projectionName) !== -1;
}
function $a6cb33582cb5910b$export$2cd8252107eb640b() {
    var con, com, cosph0, D, F, H, L, sinph0, p, J, gamma = 0, gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0, AB;
    // only Type A uses the no_off or no_uoff property
    // https://github.com/OSGeo/proj.4/issues/104
    this.no_off = $a6cb33582cb5910b$var$isTypeA(this);
    this.no_rot = "no_rot" in this;
    var alp = false;
    if ("alpha" in this) alp = true;
    var gam = false;
    if ("rectified_grid_angle" in this) gam = true;
    if (alp) alpha_c = this.alpha;
    if (gam) gamma = this.rectified_grid_angle * (0, $gyVUi.D2R);
    if (alp || gam) lamc = this.longc;
    else {
        lam1 = this.long1;
        phi1 = this.lat1;
        lam2 = this.long2;
        phi2 = this.lat2;
        if (Math.abs(phi1 - phi2) <= $a6cb33582cb5910b$var$TOL || (con = Math.abs(phi1)) <= $a6cb33582cb5910b$var$TOL || Math.abs(con - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL || Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL || Math.abs(Math.abs(phi2) - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL) throw new Error();
    }
    var one_es = 1.0 - this.es;
    com = Math.sqrt(one_es);
    if (Math.abs(this.lat0) > (0, $gyVUi.EPSLN)) {
        sinph0 = Math.sin(this.lat0);
        cosph0 = Math.cos(this.lat0);
        con = 1 - this.es * sinph0 * sinph0;
        this.B = cosph0 * cosph0;
        this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
        this.A = this.B * this.k0 * com / con;
        D = this.B * com / (cosph0 * Math.sqrt(con));
        F = D * D - 1;
        if (F <= 0) F = 0;
        else {
            F = Math.sqrt(F);
            if (this.lat0 < 0) F = -F;
        }
        this.E = F += D;
        this.E *= Math.pow((0, $3xC66.default)(this.e, this.lat0, sinph0), this.B);
    } else {
        this.B = 1 / com;
        this.A = this.k0;
        this.E = D = F = 1;
    }
    if (alp || gam) {
        if (alp) {
            gamma0 = Math.asin(Math.sin(alpha_c) / D);
            if (!gam) gamma = alpha_c;
        } else {
            gamma0 = gamma;
            alpha_c = Math.asin(D * Math.sin(gamma0));
        }
        this.lam0 = lamc - Math.asin(0.5 * (F - 1 / F) * Math.tan(gamma0)) / this.B;
    } else {
        H = Math.pow((0, $3xC66.default)(this.e, phi1, Math.sin(phi1)), this.B);
        L = Math.pow((0, $3xC66.default)(this.e, phi2, Math.sin(phi2)), this.B);
        F = this.E / H;
        p = (L - H) / (L + H);
        J = this.E * this.E;
        J = (J - L * H) / (J + L * H);
        con = lam1 - lam2;
        if (con < -Math.pi) lam2 -= (0, $gyVUi.TWO_PI);
        else if (con > Math.pi) lam2 += (0, $gyVUi.TWO_PI);
        this.lam0 = (0, $a9oRf.default)(0.5 * (lam1 + lam2) - Math.atan(J * Math.tan(0.5 * this.B * (lam1 - lam2)) / p) / this.B);
        gamma0 = Math.atan(2 * Math.sin(this.B * (0, $a9oRf.default)(lam1 - this.lam0)) / (F - 1 / F));
        gamma = alpha_c = Math.asin(D * Math.sin(gamma0));
    }
    this.singam = Math.sin(gamma0);
    this.cosgam = Math.cos(gamma0);
    this.sinrot = Math.sin(gamma);
    this.cosrot = Math.cos(gamma);
    this.rB = 1 / this.B;
    this.ArB = this.A * this.rB;
    this.BrA = 1 / this.ArB;
    AB = this.A * this.B;
    if (this.no_off) this.u_0 = 0;
    else {
        this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D * D - 1) / Math.cos(alpha_c)));
        if (this.lat0 < 0) this.u_0 = -this.u_0;
    }
    F = 0.5 * gamma0;
    this.v_pole_n = this.ArB * Math.log(Math.tan((0, $gyVUi.FORTPI) - F));
    this.v_pole_s = this.ArB * Math.log(Math.tan((0, $gyVUi.FORTPI) + F));
}
function $a6cb33582cb5910b$export$174bb771924e7eb1(p) {
    var coords = {};
    var S, T, U, V, W, temp, u, v;
    p.x = p.x - this.lam0;
    if (Math.abs(Math.abs(p.y) - (0, $gyVUi.HALF_PI)) > (0, $gyVUi.EPSLN)) {
        W = this.E / Math.pow((0, $3xC66.default)(this.e, p.y, Math.sin(p.y)), this.B);
        temp = 1 / W;
        S = 0.5 * (W - temp);
        T = 0.5 * (W + temp);
        V = Math.sin(this.B * p.x);
        U = (S * this.singam - V * this.cosgam) / T;
        if (Math.abs(Math.abs(U) - 1.0) < (0, $gyVUi.EPSLN)) throw new Error();
        v = 0.5 * this.ArB * Math.log((1 - U) / (1 + U));
        temp = Math.cos(this.B * p.x);
        if (Math.abs(temp) < $a6cb33582cb5910b$var$TOL) u = this.A * p.x;
        else u = this.ArB * Math.atan2(S * this.cosgam + V * this.singam, temp);
    } else {
        v = p.y > 0 ? this.v_pole_n : this.v_pole_s;
        u = this.ArB * p.y;
    }
    if (this.no_rot) {
        coords.x = u;
        coords.y = v;
    } else {
        u -= this.u_0;
        coords.x = v * this.cosrot + u * this.sinrot;
        coords.y = u * this.cosrot - v * this.sinrot;
    }
    coords.x = this.a * coords.x + this.x0;
    coords.y = this.a * coords.y + this.y0;
    return coords;
}
function $a6cb33582cb5910b$export$70ae2c07e401031b(p) {
    var u, v, Qp, Sp, Tp, Vp, Up;
    var coords = {};
    p.x = (p.x - this.x0) * (1.0 / this.a);
    p.y = (p.y - this.y0) * (1.0 / this.a);
    if (this.no_rot) {
        v = p.y;
        u = p.x;
    } else {
        v = p.x * this.cosrot - p.y * this.sinrot;
        u = p.y * this.cosrot + p.x * this.sinrot + this.u_0;
    }
    Qp = Math.exp(-this.BrA * v);
    Sp = 0.5 * (Qp - 1 / Qp);
    Tp = 0.5 * (Qp + 1 / Qp);
    Vp = Math.sin(this.BrA * u);
    Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
    if (Math.abs(Math.abs(Up) - 1) < (0, $gyVUi.EPSLN)) {
        coords.x = 0;
        coords.y = Up < 0 ? -(0, $gyVUi.HALF_PI) : (0, $gyVUi.HALF_PI);
    } else {
        coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
        coords.y = (0, $2AZR8.default)(this.e, Math.pow(coords.y, 1 / this.B));
        if (coords.y === Infinity) throw new Error();
        coords.x = -this.rB * Math.atan2(Sp * this.cosgam - Vp * this.singam, Math.cos(this.BrA * u));
    }
    coords.x += this.lam0;
    return coords;
}
var $a6cb33582cb5910b$export$e4b2ac9215619f8d = [
    "Hotine_Oblique_Mercator",
    "Hotine Oblique Mercator",
    "Hotine_Oblique_Mercator_Azimuth_Natural_Origin",
    "Hotine_Oblique_Mercator_Two_Point_Natural_Origin",
    "Hotine_Oblique_Mercator_Azimuth_Center",
    "Oblique_Mercator",
    "omerc"
];
var $a6cb33582cb5910b$export$2e2bcd8739ae039 = {
    init: $a6cb33582cb5910b$export$2cd8252107eb640b,
    forward: $a6cb33582cb5910b$export$174bb771924e7eb1,
    inverse: $a6cb33582cb5910b$export$70ae2c07e401031b,
    names: $a6cb33582cb5910b$export$e4b2ac9215619f8d
};

});

parcelRegister("iubsy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d753eaf12887a276$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $boTd3 = parcelRequire("boTd3");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d753eaf12887a276$export$2cd8252107eb640b() {
    //double lat0;                    /* the reference latitude               */
    //double long0;                   /* the reference longitude              */
    //double lat1;                    /* first standard parallel              */
    //double lat2;                    /* second standard parallel             */
    //double r_maj;                   /* major axis                           */
    //double r_min;                   /* minor axis                           */
    //double false_east;              /* x offset in meters                   */
    //double false_north;             /* y offset in meters                   */
    //the above value can be set with proj4.defs
    //example: proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    if (!this.lat2) this.lat2 = this.lat1;
     //if lat2 is not defined
    if (!this.k0) this.k0 = 1;
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    var temp = this.b / this.a;
    this.e = Math.sqrt(1 - temp * temp);
    var sin1 = Math.sin(this.lat1);
    var cos1 = Math.cos(this.lat1);
    var ms1 = (0, $bi5ZC.default)(this.e, sin1, cos1);
    var ts1 = (0, $3xC66.default)(this.e, this.lat1, sin1);
    var sin2 = Math.sin(this.lat2);
    var cos2 = Math.cos(this.lat2);
    var ms2 = (0, $bi5ZC.default)(this.e, sin2, cos2);
    var ts2 = (0, $3xC66.default)(this.e, this.lat2, sin2);
    var ts0 = (0, $3xC66.default)(this.e, this.lat0, Math.sin(this.lat0));
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
    else this.ns = sin1;
    if (isNaN(this.ns)) this.ns = sin1;
    this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
    this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
    if (!this.title) this.title = "Lambert Conformal Conic";
}
function $d753eaf12887a276$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // singular cases :
    if (Math.abs(2 * Math.abs(lat) - Math.PI) <= (0, $gyVUi.EPSLN)) lat = (0, $boTd3.default)(lat) * ((0, $gyVUi.HALF_PI) - 2 * (0, $gyVUi.EPSLN));
    var con = Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI));
    var ts, rh1;
    if (con > (0, $gyVUi.EPSLN)) {
        ts = (0, $3xC66.default)(this.e, lat, Math.sin(lat));
        rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
    } else {
        con = lat * this.ns;
        if (con <= 0) return null;
        rh1 = 0;
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0);
    p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
    p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;
    return p;
}
function $d753eaf12887a276$export$70ae2c07e401031b(p) {
    var rh1, con, ts;
    var lat, lon;
    var x = (p.x - this.x0) / this.k0;
    var y = this.rh - (p.y - this.y0) / this.k0;
    if (this.ns > 0) {
        rh1 = Math.sqrt(x * x + y * y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(x * x + y * y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * x, con * y);
    if (rh1 !== 0 || this.ns > 0) {
        con = 1 / this.ns;
        ts = Math.pow(rh1 / (this.a * this.f0), con);
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    } else lat = -(0, $gyVUi.HALF_PI);
    lon = (0, $a9oRf.default)(theta / this.ns + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
}
var $d753eaf12887a276$export$e4b2ac9215619f8d = [
    "Lambert Tangential Conformal Conic Projection",
    "Lambert_Conformal_Conic",
    "Lambert_Conformal_Conic_1SP",
    "Lambert_Conformal_Conic_2SP",
    "lcc",
    "Lambert Conic Conformal (1SP)",
    "Lambert Conic Conformal (2SP)"
];
var $d753eaf12887a276$export$2e2bcd8739ae039 = {
    init: $d753eaf12887a276$export$2cd8252107eb640b,
    forward: $d753eaf12887a276$export$174bb771924e7eb1,
    inverse: $d753eaf12887a276$export$70ae2c07e401031b,
    names: $d753eaf12887a276$export$e4b2ac9215619f8d
};

});

parcelRegister("h7o5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $c765c705b741a192$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");
function $c765c705b741a192$export$2cd8252107eb640b() {
    this.a = 6377397.155;
    this.es = 0.006674372230614;
    this.e = Math.sqrt(this.es);
    if (!this.lat0) this.lat0 = 0.863937979737193;
    if (!this.long0) this.long0 = 0.4334234309119251;
    /* if scale not set default to 0.9999 */ if (!this.k0) this.k0 = 0.9999;
    this.s45 = 0.785398163397448; /* 45 */ 
    this.s90 = 2 * this.s45;
    this.fi0 = this.lat0;
    this.e2 = this.es;
    this.e = Math.sqrt(this.e2);
    this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2));
    this.uq = 1.04216856380474;
    this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
    this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
    this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
    this.k1 = this.k0;
    this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
    this.s0 = 1.37008346281555;
    this.n = Math.sin(this.s0);
    this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
    this.ad = this.s90 - this.uq;
}
function $c765c705b741a192$export$174bb771924e7eb1(p) {
    var gfi, u, deltav, s, d, eps, ro;
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    /* Transformation */ gfi = Math.pow((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat)), this.alfa * this.e / 2);
    u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
    deltav = -delta_lon * this.alfa;
    s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
    d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
    eps = this.n * d;
    ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
    p.y = ro * Math.cos(eps) / 1;
    p.x = ro * Math.sin(eps) / 1;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    return p;
}
function $c765c705b741a192$export$70ae2c07e401031b(p) {
    var u, deltav, s, d, eps, ro, fi1;
    var ok;
    /* Transformation */ /* revert y, x*/ var tmp = p.x;
    p.x = p.y;
    p.y = tmp;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    ro = Math.sqrt(p.x * p.x + p.y * p.y);
    eps = Math.atan2(p.y, p.x);
    d = eps / Math.sin(this.s0);
    s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
    u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
    deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
    p.x = this.long0 - deltav / this.alfa;
    fi1 = u;
    ok = 0;
    var iter = 0;
    do {
        p.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
        if (Math.abs(fi1 - p.y) < 0.0000000001) ok = 1;
        fi1 = p.y;
        iter += 1;
    }while (ok === 0 && iter < 15);
    if (iter >= 15) return null;
    return p;
}
var $c765c705b741a192$export$e4b2ac9215619f8d = [
    "Krovak",
    "krovak"
];
var $c765c705b741a192$export$2e2bcd8739ae039 = {
    init: $c765c705b741a192$export$2cd8252107eb640b,
    forward: $c765c705b741a192$export$174bb771924e7eb1,
    inverse: $c765c705b741a192$export$70ae2c07e401031b,
    names: $c765c705b741a192$export$e4b2ac9215619f8d
};

});

parcelRegister("0599r", function(module, exports) {

$parcel$export(module.exports, "default", () => $00f791059e8f61f5$export$2e2bcd8739ae039);

var $f3cKo = parcelRequire("f3cKo");

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $3eeGT = parcelRequire("3eeGT");

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $cfNuL = parcelRequire("cfNuL");

var $gyVUi = parcelRequire("gyVUi");
function $00f791059e8f61f5$export$2cd8252107eb640b() {
    if (!this.sphere) {
        this.e0 = (0, $bWC4D.default)(this.es);
        this.e1 = (0, $hU8aC.default)(this.es);
        this.e2 = (0, $i9r9A.default)(this.es);
        this.e3 = (0, $bM0eI.default)(this.es);
        this.ml0 = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    }
}
function $00f791059e8f61f5$export$174bb771924e7eb1(p) {
    /* Forward equations
      -----------------*/ var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0);
    if (this.sphere) {
        x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
        y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
    } else {
        //ellipsoid
        var sinphi = Math.sin(phi);
        var cosphi = Math.cos(phi);
        var nl = (0, $3eeGT.default)(this.a, this.e, sinphi);
        var tl = Math.tan(phi) * Math.tan(phi);
        var al = lam * Math.cos(phi);
        var asq = al * al;
        var cl = this.es * cosphi * cosphi / (1 - this.es);
        var ml = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, phi);
        x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
        y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $00f791059e8f61f5$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var phi, lam;
    if (this.sphere) {
        var dd = y + this.lat0;
        phi = Math.asin(Math.sin(dd) * Math.cos(x));
        lam = Math.atan2(Math.tan(x), Math.cos(dd));
    } else {
        /* ellipsoid */ var ml1 = this.ml0 / this.a + y;
        var phi1 = (0, $cfNuL.default)(ml1, this.e0, this.e1, this.e2, this.e3);
        if (Math.abs(Math.abs(phi1) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
            p.x = this.long0;
            p.y = (0, $gyVUi.HALF_PI);
            if (y < 0) p.y *= -1;
            return p;
        }
        var nl1 = (0, $3eeGT.default)(this.a, this.e, Math.sin(phi1));
        var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
        var tl1 = Math.pow(Math.tan(phi1), 2);
        var dl = x * this.a / nl1;
        var dsq = dl * dl;
        phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
        lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);
    }
    p.x = (0, $a9oRf.default)(lam + this.long0);
    p.y = (0, $aDUFA.default)(phi);
    return p;
}
var $00f791059e8f61f5$export$e4b2ac9215619f8d = [
    "Cassini",
    "Cassini_Soldner",
    "cass"
];
var $00f791059e8f61f5$export$2e2bcd8739ae039 = {
    init: $00f791059e8f61f5$export$2cd8252107eb640b,
    forward: $00f791059e8f61f5$export$174bb771924e7eb1,
    inverse: $00f791059e8f61f5$export$70ae2c07e401031b,
    names: $00f791059e8f61f5$export$e4b2ac9215619f8d
};

});
parcelRegister("f3cKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $af51062589eeb2ce$export$2e2bcd8739ae039);
function $af51062589eeb2ce$export$2e2bcd8739ae039(e0, e1, e2, e3, phi) {
    return e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi);
}

});

parcelRegister("bWC4D", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b22a51ec249391e$export$2e2bcd8739ae039);
function $8b22a51ec249391e$export$2e2bcd8739ae039(x) {
    return 1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x));
}

});

parcelRegister("hU8aC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d08e0117e308bb87$export$2e2bcd8739ae039);
function $d08e0117e308bb87$export$2e2bcd8739ae039(x) {
    return 0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x));
}

});

parcelRegister("i9r9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $d36e2161accfe0ec$export$2e2bcd8739ae039);
function $d36e2161accfe0ec$export$2e2bcd8739ae039(x) {
    return 0.05859375 * x * x * (1 + 0.75 * x);
}

});

parcelRegister("bM0eI", function(module, exports) {

$parcel$export(module.exports, "default", () => $89245c5bc9a5a616$export$2e2bcd8739ae039);
function $89245c5bc9a5a616$export$2e2bcd8739ae039(x) {
    return x * x * x * (35 / 3072);
}

});

parcelRegister("3eeGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $259e1333723cc7cb$export$2e2bcd8739ae039);
function $259e1333723cc7cb$export$2e2bcd8739ae039(a, e, sinphi) {
    var temp = e * sinphi;
    return a / Math.sqrt(1 - temp * temp);
}

});

parcelRegister("aDUFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf9815baea17aa9$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $7bf9815baea17aa9$export$2e2bcd8739ae039(x) {
    return Math.abs(x) < (0, $gyVUi.HALF_PI) ? x : x - (0, $boTd3.default)(x) * Math.PI;
}

});

parcelRegister("cfNuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ebd4771f70de1ee$export$2e2bcd8739ae039);
function $8ebd4771f70de1ee$export$2e2bcd8739ae039(ml, e0, e1, e2, e3) {
    var phi;
    var dphi;
    phi = ml / e0;
    for(var i = 0; i < 15; i++){
        dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
    return NaN;
}

});


parcelRegister("deudM", function(module, exports) {

$parcel$export(module.exports, "S_POLE", () => S_POLE);
$parcel$export(module.exports, "N_POLE", () => N_POLE);
$parcel$export(module.exports, "EQUIT", () => EQUIT);
$parcel$export(module.exports, "OBLIQ", () => OBLIQ);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $9a24067d8ab69621$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");
var S_POLE = 1;
var N_POLE = 2;
var EQUIT = 3;
var OBLIQ = 4;
function init() {
    var t = Math.abs(this.lat0);
    if (Math.abs(t - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN)) this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
    else if (Math.abs(t) < (0, $gyVUi.EPSLN)) this.mode = this.EQUIT;
    else this.mode = this.OBLIQ;
    if (this.es > 0) {
        var sinphi;
        this.qp = (0, $874JP.default)(this.e, 1);
        this.mmf = 0.5 / (1 - this.es);
        this.apa = authset(this.es);
        switch(this.mode){
            case this.N_POLE:
                this.dd = 1;
                break;
            case this.S_POLE:
                this.dd = 1;
                break;
            case this.EQUIT:
                this.rq = Math.sqrt(0.5 * this.qp);
                this.dd = 1 / this.rq;
                this.xmf = 1;
                this.ymf = 0.5 * this.qp;
                break;
            case this.OBLIQ:
                this.rq = Math.sqrt(0.5 * this.qp);
                sinphi = Math.sin(this.lat0);
                this.sinb1 = (0, $874JP.default)(this.e, sinphi) / this.qp;
                this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
                this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
                this.ymf = (this.xmf = this.rq) / this.dd;
                this.xmf *= this.dd;
                break;
        }
    } else if (this.mode === this.OBLIQ) {
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
}
function forward(p) {
    /* Forward equations
      -----------------*/ var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0);
    if (this.sphere) {
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        coslam = Math.cos(lam);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            y = this.mode === this.EQUIT ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            if (y <= (0, $gyVUi.EPSLN)) return null;
            y = Math.sqrt(2 / y);
            x = y * cosphi * Math.sin(lam);
            y *= this.mode === this.EQUIT ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) coslam = -coslam;
            if (Math.abs(phi + this.lat0) < (0, $gyVUi.EPSLN)) return null;
            y = (0, $gyVUi.FORTPI) - phi * 0.5;
            y = 2 * (this.mode === this.S_POLE ? Math.cos(y) : Math.sin(y));
            x = y * Math.sin(lam);
            y *= coslam;
        }
    } else {
        sinb = 0;
        cosb = 0;
        b = 0;
        coslam = Math.cos(lam);
        sinlam = Math.sin(lam);
        sinphi = Math.sin(phi);
        q = (0, $874JP.default)(this.e, sinphi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinb = q / this.qp;
            cosb = Math.sqrt(1 - sinb * sinb);
        }
        switch(this.mode){
            case this.OBLIQ:
                b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
                break;
            case this.EQUIT:
                b = 1 + cosb * coslam;
                break;
            case this.N_POLE:
                b = (0, $gyVUi.HALF_PI) + phi;
                q = this.qp - q;
                break;
            case this.S_POLE:
                b = phi - (0, $gyVUi.HALF_PI);
                q = this.qp + q;
                break;
        }
        if (Math.abs(b) < (0, $gyVUi.EPSLN)) return null;
        switch(this.mode){
            case this.OBLIQ:
            case this.EQUIT:
                b = Math.sqrt(2 / b);
                if (this.mode === this.OBLIQ) y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
                else y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
                x = this.xmf * b * cosb * sinlam;
                break;
            case this.N_POLE:
            case this.S_POLE:
                if (q >= 0) {
                    x = (b = Math.sqrt(q)) * sinlam;
                    y = coslam * (this.mode === this.S_POLE ? b : -b);
                } else x = y = 0;
                break;
        }
    }
    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var lam, phi, cCe, sCe, q, rho, ab;
    if (this.sphere) {
        var cosz = 0, rh, sinz = 0;
        rh = Math.sqrt(x * x + y * y);
        phi = rh * 0.5;
        if (phi > 1) return null;
        phi = 2 * Math.asin(phi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinz = Math.sin(phi);
            cosz = Math.cos(phi);
        }
        switch(this.mode){
            case this.EQUIT:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? 0 : Math.asin(y * sinz / rh);
                x *= sinz;
                y = cosz * rh;
                break;
            case this.OBLIQ:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
                x *= sinz * this.cosph0;
                y = (cosz - Math.sin(phi) * this.sinph0) * rh;
                break;
            case this.N_POLE:
                y = -y;
                phi = (0, $gyVUi.HALF_PI) - phi;
                break;
            case this.S_POLE:
                phi -= (0, $gyVUi.HALF_PI);
                break;
        }
        lam = y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(x, y);
    } else {
        ab = 0;
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            x /= this.dd;
            y *= this.dd;
            rho = Math.sqrt(x * x + y * y);
            if (rho < (0, $gyVUi.EPSLN)) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            sCe = 2 * Math.asin(0.5 * rho / this.rq);
            cCe = Math.cos(sCe);
            x *= sCe = Math.sin(sCe);
            if (this.mode === this.OBLIQ) {
                ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
                q = this.qp * ab;
                y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
            } else {
                ab = y * sCe / rho;
                q = this.qp * ab;
                y = rho * cCe;
            }
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) y = -y;
            q = x * x + y * y;
            if (!q) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            ab = 1 - q / this.qp;
            if (this.mode === this.S_POLE) ab = -ab;
        }
        lam = Math.atan2(x, y);
        phi = authlat(Math.asin(ab), this.apa);
    }
    p.x = (0, $a9oRf.default)(this.long0 + lam);
    p.y = phi;
    return p;
}
/* determine latitude from authalic latitude */ var P00 = 0.33333333333333333333;
var P01 = 0.17222222222222222222;
var P02 = 0.10257936507936507936;
var P10 = 0.06388888888888888888;
var P11 = 0.06640211640211640211;
var P20 = 0.01641501294219154443;
function authset(es) {
    var t;
    var APA = [];
    APA[0] = es * P00;
    t = es * es;
    APA[0] += t * P01;
    APA[1] = t * P10;
    t *= es;
    APA[0] += t * P02;
    APA[1] += t * P11;
    APA[2] = t * P20;
    return APA;
}
function authlat(beta, APA) {
    var t = beta + beta;
    return beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t);
}
var names = [
    "Lambert Azimuthal Equal Area",
    "Lambert_Azimuthal_Equal_Area",
    "laea"
];
var $9a24067d8ab69621$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    S_POLE: S_POLE,
    N_POLE: N_POLE,
    EQUIT: EQUIT,
    OBLIQ: OBLIQ
};

});
parcelRegister("874JP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e82a7153665d151$export$2e2bcd8739ae039);
function $5e82a7153665d151$export$2e2bcd8739ae039(eccent, sinphi) {
    var con;
    if (eccent > 1.0e-7) {
        con = eccent * sinphi;
        return (1 - eccent * eccent) * (sinphi / (1 - con * con) - 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    } else return 2 * sinphi;
}

});


parcelRegister("8mhgZ", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "phi1z", () => phi1z);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $615dc6dbd83ac6d5$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function init() {
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e3 = Math.sqrt(this.es);
    this.sin_po = Math.sin(this.lat1);
    this.cos_po = Math.cos(this.lat1);
    this.t1 = this.sin_po;
    this.con = this.sin_po;
    this.ms1 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs1 = (0, $874JP.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat2);
    this.cos_po = Math.cos(this.lat2);
    this.t2 = this.sin_po;
    this.ms2 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs2 = (0, $874JP.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat0);
    this.cos_po = Math.cos(this.lat0);
    this.t3 = this.sin_po;
    this.qs0 = (0, $874JP.default)(this.e3, this.sin_po);
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
    else this.ns0 = this.con;
    this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
    this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    this.sin_phi = Math.sin(lat);
    this.cos_phi = Math.cos(lat);
    var qs = (0, $874JP.default)(this.e3, this.sin_phi);
    var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
    var theta = this.ns0 * (0, $a9oRf.default)(lon - this.long0);
    var x = rh1 * Math.sin(theta) + this.x0;
    var y = this.rh - rh1 * Math.cos(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var rh1, qs, con, theta, lon, lat;
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    if (this.ns0 >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    con = rh1 * this.ns0 / this.a;
    if (this.sphere) lat = Math.asin((this.c - con * con) / (2 * this.ns0));
    else {
        qs = (this.c - con * con) / this.ns0;
        lat = this.phi1z(this.e3, qs);
    }
    lon = (0, $a9oRf.default)(theta / this.ns0 + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
}
function phi1z(eccent, qs) {
    var sinphi, cosphi, con, com, dphi;
    var phi = (0, $ljPJJ.default)(0.5 * qs);
    if (eccent < (0, $gyVUi.EPSLN)) return phi;
    var eccnts = eccent * eccent;
    for(var i = 1; i <= 25; i++){
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        con = eccent * sinphi;
        com = 1 - con * con;
        dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi = phi + dphi;
        if (Math.abs(dphi) <= 1e-7) return phi;
    }
    return null;
}
var names = [
    "Albers_Conic_Equal_Area",
    "Albers",
    "aea"
];
var $615dc6dbd83ac6d5$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    phi1z: phi1z
};

});
parcelRegister("ljPJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8538120e633ea57$export$2e2bcd8739ae039);
function $f8538120e633ea57$export$2e2bcd8739ae039(x) {
    if (Math.abs(x) > 1) x = x > 1 ? 1 : -1;
    return Math.asin(x);
}

});


parcelRegister("iSJfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf05e97c9232a2a$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $dbf05e97c9232a2a$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
    // Approximation for projecting points to the horizon (infinity)
    this.infinity_dist = 1000 * this.a;
    this.rc = 1;
}
function $dbf05e97c9232a2a$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g;
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ dlon = (0, $a9oRf.default)(lon - this.long0);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
    } else {
        // Point is in the opposing hemisphere and is unprojectable
        // We still need to return a reasonable point, so we project
        // to infinity, on a bearing
        // equivalent to the northern hemisphere equivalent
        // This is a reasonable approximation for short shapes and lines that
        // straddle the horizon.
        x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
        y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $dbf05e97c9232a2a$export$70ae2c07e401031b(p) {
    var rh; /* Rho */ 
    var sinc, cosc;
    var c;
    var lon, lat;
    /* Inverse equations
      -----------------*/ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rh = Math.sqrt(p.x * p.x + p.y * p.y)) {
        c = Math.atan2(rh, this.rc);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = (0, $ljPJJ.default)(cosc * this.sin_p14 + p.y * sinc * this.cos_p14 / rh);
        lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
        lon = (0, $a9oRf.default)(this.long0 + lon);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $dbf05e97c9232a2a$export$e4b2ac9215619f8d = [
    "gnom"
];
var $dbf05e97c9232a2a$export$2e2bcd8739ae039 = {
    init: $dbf05e97c9232a2a$export$2cd8252107eb640b,
    forward: $dbf05e97c9232a2a$export$174bb771924e7eb1,
    inverse: $dbf05e97c9232a2a$export$70ae2c07e401031b,
    names: $dbf05e97c9232a2a$export$e4b2ac9215619f8d
};

});

parcelRegister("6CTAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d31684dfe594c29$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $874JP = parcelRequire("874JP");

var $bi5ZC = parcelRequire("bi5ZC");

var $b4Ogv = parcelRequire("b4Ogv");
function $4d31684dfe594c29$export$2cd8252107eb640b() {
    //no-op
    if (!this.sphere) this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
}
function $4d31684dfe594c29$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y;
    /* Forward equations
      -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    if (this.sphere) {
        x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
        y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
    } else {
        var qs = (0, $874JP.default)(this.e, Math.sin(lat));
        x = this.x0 + this.a * this.k0 * dlon;
        y = this.y0 + this.a * qs * 0.5 / this.k0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $4d31684dfe594c29$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat;
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + p.x / this.a / Math.cos(this.lat_ts));
        lat = Math.asin(p.y / this.a * Math.cos(this.lat_ts));
    } else {
        lat = (0, $b4Ogv.default)(this.e, 2 * p.y * this.k0 / this.a);
        lon = (0, $a9oRf.default)(this.long0 + p.x / (this.a * this.k0));
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $4d31684dfe594c29$export$e4b2ac9215619f8d = [
    "cea"
];
var $4d31684dfe594c29$export$2e2bcd8739ae039 = {
    init: $4d31684dfe594c29$export$2cd8252107eb640b,
    forward: $4d31684dfe594c29$export$174bb771924e7eb1,
    inverse: $4d31684dfe594c29$export$70ae2c07e401031b,
    names: $4d31684dfe594c29$export$e4b2ac9215619f8d
};

});
parcelRegister("b4Ogv", function(module, exports) {

$parcel$export(module.exports, "default", () => $81070f0f2a61f650$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $81070f0f2a61f650$export$2e2bcd8739ae039(eccent, q) {
    var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
    if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
        if (q < 0) return -1 * (0, $gyVUi.HALF_PI);
        else return 0, $gyVUi.HALF_PI;
    }
    //var phi = 0.5* q/(1-eccent*eccent);
    var phi = Math.asin(0.5 * q);
    var dphi;
    var sin_phi;
    var cos_phi;
    var con;
    for(var i = 0; i < 30; i++){
        sin_phi = Math.sin(phi);
        cos_phi = Math.cos(phi);
        con = eccent * sin_phi;
        dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
    return NaN;
}

});


parcelRegister("cEGTl", function(module, exports) {

$parcel$export(module.exports, "default", () => $936a7dd52884a3fc$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");
function $936a7dd52884a3fc$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Equidistant Cylindrical (Plate Carre)";
    this.rc = Math.cos(this.lat_ts);
}
function $936a7dd52884a3fc$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    var dlat = (0, $aDUFA.default)(lat - this.lat0);
    p.x = this.x0 + this.a * dlon * this.rc;
    p.y = this.y0 + this.a * dlat;
    return p;
}
function $936a7dd52884a3fc$export$70ae2c07e401031b(p) {
    var x = p.x;
    var y = p.y;
    p.x = (0, $a9oRf.default)(this.long0 + (x - this.x0) / (this.a * this.rc));
    p.y = (0, $aDUFA.default)(this.lat0 + (y - this.y0) / this.a);
    return p;
}
var $936a7dd52884a3fc$export$e4b2ac9215619f8d = [
    "Equirectangular",
    "Equidistant_Cylindrical",
    "eqc"
];
var $936a7dd52884a3fc$export$2e2bcd8739ae039 = {
    init: $936a7dd52884a3fc$export$2cd8252107eb640b,
    forward: $936a7dd52884a3fc$export$174bb771924e7eb1,
    inverse: $936a7dd52884a3fc$export$70ae2c07e401031b,
    names: $936a7dd52884a3fc$export$e4b2ac9215619f8d
};

});

parcelRegister("2Lrqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $20353e9e716518d0$export$2e2bcd8739ae039);

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $f3cKo = parcelRequire("f3cKo");

var $gyVUi = parcelRequire("gyVUi");

var $3eeGT = parcelRequire("3eeGT");
var $20353e9e716518d0$var$MAX_ITER = 20;
function $20353e9e716518d0$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $bWC4D.default)(this.es);
    this.e1 = (0, $hU8aC.default)(this.es);
    this.e2 = (0, $i9r9A.default)(this.es);
    this.e3 = (0, $bM0eI.default)(this.es);
    this.ml0 = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
}
function $20353e9e716518d0$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y, el;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    el = dlon * Math.sin(lat);
    if (this.sphere) {
        if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
            x = this.a * dlon;
            y = -1 * this.a * this.lat0;
        } else {
            x = this.a * Math.sin(el) / Math.tan(lat);
            y = this.a * ((0, $aDUFA.default)(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
        }
    } else if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.a * dlon;
        y = -1 * this.ml0;
    } else {
        var nl = (0, $3eeGT.default)(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
        x = nl * Math.sin(el);
        y = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $20353e9e716518d0$export$70ae2c07e401031b(p) {
    var lon, lat, x, y, i;
    var al, bl;
    var phi, dphi;
    x = p.x - this.x0;
    y = p.y - this.y0;
    if (this.sphere) {
        if (Math.abs(y + this.a * this.lat0) <= (0, $gyVUi.EPSLN)) {
            lon = (0, $a9oRf.default)(x / this.a + this.long0);
            lat = 0;
        } else {
            al = this.lat0 + y / this.a;
            bl = x * x / this.a / this.a + al * al;
            phi = al;
            var tanphi;
            for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
                tanphi = Math.tan(phi);
                dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
                phi += dphi;
                if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                    lat = phi;
                    break;
                }
            }
            lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * Math.tan(phi) / this.a) / Math.sin(lat));
        }
    } else if (Math.abs(y + this.ml0) <= (0, $gyVUi.EPSLN)) {
        lat = 0;
        lon = (0, $a9oRf.default)(this.long0 + x / this.a);
    } else {
        al = (this.ml0 + y) / this.a;
        bl = x * x / this.a / this.a + al * al;
        phi = al;
        var cl, mln, mlnp, ma;
        var con;
        for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
            con = this.e * Math.sin(phi);
            cl = Math.sqrt(1 - con * con) * Math.tan(phi);
            mln = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, phi);
            mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
            ma = mln / this.a;
            dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
            phi -= dphi;
            if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                lat = phi;
                break;
            }
        }
        //lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
        cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
        lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $20353e9e716518d0$export$e4b2ac9215619f8d = [
    "Polyconic",
    "poly"
];
var $20353e9e716518d0$export$2e2bcd8739ae039 = {
    init: $20353e9e716518d0$export$2cd8252107eb640b,
    forward: $20353e9e716518d0$export$174bb771924e7eb1,
    inverse: $20353e9e716518d0$export$70ae2c07e401031b,
    names: $20353e9e716518d0$export$e4b2ac9215619f8d
};

});

parcelRegister("6Eu1X", function(module, exports) {

$parcel$export(module.exports, "iterations", () => iterations);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $4d7dc5ed367b221e$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
var iterations = 1;
function init() {
    this.A = [];
    this.A[1] = 0.6399175073;
    this.A[2] = -0.1358797613;
    this.A[3] = 0.063294409;
    this.A[4] = -0.02526853;
    this.A[5] = 0.0117879;
    this.A[6] = -0.0055161;
    this.A[7] = 0.0026906;
    this.A[8] = -0.001333;
    this.A[9] = 0.00067;
    this.A[10] = -0.00034;
    this.B_re = [];
    this.B_im = [];
    this.B_re[1] = 0.7557853228;
    this.B_im[1] = 0;
    this.B_re[2] = 0.249204646;
    this.B_im[2] = 0.003371507;
    this.B_re[3] = -0.001541739;
    this.B_im[3] = 0.041058560;
    this.B_re[4] = -0.10162907;
    this.B_im[4] = 0.01727609;
    this.B_re[5] = -0.26623489;
    this.B_im[5] = -0.36249218;
    this.B_re[6] = -0.6870983;
    this.B_im[6] = -1.1651967;
    this.C_re = [];
    this.C_im = [];
    this.C_re[1] = 1.3231270439;
    this.C_im[1] = 0;
    this.C_re[2] = -0.577245789;
    this.C_im[2] = -0.007809598;
    this.C_re[3] = 0.508307513;
    this.C_im[3] = -0.112208952;
    this.C_re[4] = -0.15094762;
    this.C_im[4] = 0.18200602;
    this.C_re[5] = 1.01418179;
    this.C_im[5] = 1.64497696;
    this.C_re[6] = 1.9660549;
    this.C_im[6] = 2.5127645;
    this.D = [];
    this.D[1] = 1.5627014243;
    this.D[2] = 0.5185406398;
    this.D[3] = -0.03333098;
    this.D[4] = -0.1052906;
    this.D[5] = -0.0368594;
    this.D[6] = 0.007317;
    this.D[7] = 0.01220;
    this.D[8] = 0.00394;
    this.D[9] = -0.0013;
}
function forward(p) {
    var n;
    var lon = p.x;
    var lat = p.y;
    var delta_lat = lat - this.lat0;
    var delta_lon = lon - this.long0;
    // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
    // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
    var d_phi = delta_lat / (0, $gyVUi.SEC_TO_RAD) * 1E-5;
    var d_lambda = delta_lon;
    var d_phi_n = 1; // d_phi^0
    var d_psi = 0;
    for(n = 1; n <= 10; n++){
        d_phi_n = d_phi_n * d_phi;
        d_psi = d_psi + this.A[n] * d_phi_n;
    }
    // 2. Calculate theta
    var th_re = d_psi;
    var th_im = d_lambda;
    // 3. Calculate z
    var th_n_re = 1;
    var th_n_im = 0; // theta^0
    var th_n_re1;
    var th_n_im1;
    var z_re = 0;
    var z_im = 0;
    for(n = 1; n <= 6; n++){
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
        z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
    }
    // 4. Calculate easting and northing
    p.x = z_im * this.a + this.x0;
    p.y = z_re * this.a + this.y0;
    return p;
}
function inverse(p) {
    var n;
    var x = p.x;
    var y = p.y;
    var delta_x = x - this.x0;
    var delta_y = y - this.y0;
    // 1. Calculate z
    var z_re = delta_y / this.a;
    var z_im = delta_x / this.a;
    // 2a. Calculate theta - first approximation gives km accuracy
    var z_n_re = 1;
    var z_n_im = 0; // z^0
    var z_n_re1;
    var z_n_im1;
    var th_re = 0;
    var th_im = 0;
    for(n = 1; n <= 6; n++){
        z_n_re1 = z_n_re * z_re - z_n_im * z_im;
        z_n_im1 = z_n_im * z_re + z_n_re * z_im;
        z_n_re = z_n_re1;
        z_n_im = z_n_im1;
        th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
        th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
    }
    // 2b. Iterate to refine the accuracy of the calculation
    //        0 iterations gives km accuracy
    //        1 iteration gives m accuracy -- good enough for most mapping applications
    //        2 iterations bives mm accuracy
    for(var i = 0; i < this.iterations; i++){
        var th_n_re = th_re;
        var th_n_im = th_im;
        var th_n_re1;
        var th_n_im1;
        var num_re = z_re;
        var num_im = z_im;
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        th_n_re = 1;
        th_n_im = 0;
        var den_re = this.B_re[1];
        var den_im = this.B_im[1];
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        // Complex division
        var den2 = den_re * den_re + den_im * den_im;
        th_re = (num_re * den_re + num_im * den_im) / den2;
        th_im = (num_im * den_re - num_re * den_im) / den2;
    }
    // 3. Calculate d_phi              ...                                    // and d_lambda
    var d_psi = th_re;
    var d_lambda = th_im;
    var d_psi_n = 1; // d_psi^0
    var d_phi = 0;
    for(n = 1; n <= 9; n++){
        d_psi_n = d_psi_n * d_psi;
        d_phi = d_phi + this.D[n] * d_psi_n;
    }
    // 4. Calculate latitude and longitude
    // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
    var lat = this.lat0 + d_phi * (0, $gyVUi.SEC_TO_RAD) * 1E5;
    var lon = this.long0 + d_lambda;
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    "New_Zealand_Map_Grid",
    "nzmg"
];
var $4d7dc5ed367b221e$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});

parcelRegister("fpjAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b37863f65bf2a2a4$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");
function $b37863f65bf2a2a4$export$2cd8252107eb640b() {
//no-op
}
function $b37863f65bf2a2a4$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    var x = this.x0 + this.a * dlon;
    var y = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + lat / 2.5)) * 1.25;
    p.x = x;
    p.y = y;
    return p;
}
function $b37863f65bf2a2a4$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon = (0, $a9oRf.default)(this.long0 + p.x / this.a);
    var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);
    p.x = lon;
    p.y = lat;
    return p;
}
var $b37863f65bf2a2a4$export$e4b2ac9215619f8d = [
    "Miller_Cylindrical",
    "mill"
];
var $b37863f65bf2a2a4$export$2e2bcd8739ae039 = {
    init: $b37863f65bf2a2a4$export$2cd8252107eb640b,
    forward: $b37863f65bf2a2a4$export$174bb771924e7eb1,
    inverse: $b37863f65bf2a2a4$export$70ae2c07e401031b,
    names: $b37863f65bf2a2a4$export$e4b2ac9215619f8d
};

});

parcelRegister("eA4Bc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d7febe7a8566f2$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $gqKpL = parcelRequire("gqKpL");

var $hpUQm = parcelRequire("hpUQm");

var $jQUK6 = parcelRequire("jQUK6");

var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
var $a9d7febe7a8566f2$var$MAX_ITER = 20;
function $a9d7febe7a8566f2$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
    -------------------------------------------------*/ if (!this.sphere) this.en = (0, $gqKpL.default)(this.es);
    else {
        this.n = 1;
        this.m = 0;
        this.es = 0;
        this.C_y = Math.sqrt((this.m + 1) / this.n);
        this.C_x = this.C_y / (this.m + 1);
    }
}
function $a9d7febe7a8566f2$export$174bb771924e7eb1(p) {
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    -----------------*/ lon = (0, $a9oRf.default)(lon - this.long0);
    if (this.sphere) {
        if (!this.m) lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
        else {
            var k = this.n * Math.sin(lat);
            for(var i = $a9d7febe7a8566f2$var$MAX_ITER; i; --i){
                var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
                lat -= V;
                if (Math.abs(V) < (0, $gyVUi.EPSLN)) break;
            }
        }
        x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
        y = this.a * this.C_y * lat;
    } else {
        var s = Math.sin(lat);
        var c = Math.cos(lat);
        y = this.a * (0, $hpUQm.default)(lat, s, c, this.en);
        x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $a9d7febe7a8566f2$export$70ae2c07e401031b(p) {
    var lat, temp, lon, s;
    p.x -= this.x0;
    lon = p.x / this.a;
    p.y -= this.y0;
    lat = p.y / this.a;
    if (this.sphere) {
        lat /= this.C_y;
        lon = lon / (this.C_x * (this.m + Math.cos(lat)));
        if (this.m) lat = (0, $ljPJJ.default)((this.m * lat + Math.sin(lat)) / this.n);
        else if (this.n !== 1) lat = (0, $ljPJJ.default)(Math.sin(lat) / this.n);
        lon = (0, $a9oRf.default)(lon + this.long0);
        lat = (0, $aDUFA.default)(lat);
    } else {
        lat = (0, $jQUK6.default)(p.y / this.a, this.es, this.en);
        s = Math.abs(lat);
        if (s < (0, $gyVUi.HALF_PI)) {
            s = Math.sin(lat);
            temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
            //temp = this.long0 + p.x / (this.a * Math.cos(lat));
            lon = (0, $a9oRf.default)(temp);
        } else if (s - (0, $gyVUi.EPSLN) < (0, $gyVUi.HALF_PI)) lon = this.long0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $a9d7febe7a8566f2$export$e4b2ac9215619f8d = [
    "Sinusoidal",
    "sinu"
];
var $a9d7febe7a8566f2$export$2e2bcd8739ae039 = {
    init: $a9d7febe7a8566f2$export$2cd8252107eb640b,
    forward: $a9d7febe7a8566f2$export$174bb771924e7eb1,
    inverse: $a9d7febe7a8566f2$export$70ae2c07e401031b,
    names: $a9d7febe7a8566f2$export$e4b2ac9215619f8d
};

});

parcelRegister("7uCfv", function(module, exports) {

$parcel$export(module.exports, "default", () => $57490138fba0a0b8$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");
function $57490138fba0a0b8$export$2cd8252107eb640b() {}
function $57490138fba0a0b8$export$174bb771924e7eb1(p) {
    /* Forward equations
      -----------------*/ var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    var theta = lat;
    var con = Math.PI * Math.sin(lat);
    /* Iterate using the Newton-Raphson method to find theta
      -----------------------------------------------------*/ while(true){
        var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
        theta += delta_theta;
        if (Math.abs(delta_theta) < (0, $gyVUi.EPSLN)) break;
    }
    theta /= 2;
    /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       --------------------------------------------------------------------------*/ if (Math.PI / 2 - Math.abs(lat) < (0, $gyVUi.EPSLN)) delta_lon = 0;
    var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
    var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function $57490138fba0a0b8$export$70ae2c07e401031b(p) {
    var theta;
    var arg;
    /* Inverse equations
      -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    arg = p.y / (1.4142135623731 * this.a);
    /* Because of division by zero problems, 'arg' can not be 1.  Therefore
       a number very close to one is used instead.
       -------------------------------------------------------------------*/ if (Math.abs(arg) > 0.999999999999) arg = 0.999999999999;
    theta = Math.asin(arg);
    var lon = (0, $a9oRf.default)(this.long0 + p.x / (0.900316316158 * this.a * Math.cos(theta)));
    if (lon < -Math.PI) lon = -Math.PI;
    if (lon > Math.PI) lon = Math.PI;
    arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
    if (Math.abs(arg) > 1) arg = 1;
    var lat = Math.asin(arg);
    p.x = lon;
    p.y = lat;
    return p;
}
var $57490138fba0a0b8$export$e4b2ac9215619f8d = [
    "Mollweide",
    "moll"
];
var $57490138fba0a0b8$export$2e2bcd8739ae039 = {
    init: $57490138fba0a0b8$export$2cd8252107eb640b,
    forward: $57490138fba0a0b8$export$174bb771924e7eb1,
    inverse: $57490138fba0a0b8$export$70ae2c07e401031b,
    names: $57490138fba0a0b8$export$e4b2ac9215619f8d
};

});

parcelRegister("hp0oy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cab513e7d920927e$export$2e2bcd8739ae039);

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $bi5ZC = parcelRequire("bi5ZC");

var $f3cKo = parcelRequire("f3cKo");

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $cfNuL = parcelRequire("cfNuL");

var $gyVUi = parcelRequire("gyVUi");
function $cab513e7d920927e$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.lat2 = this.lat2 || this.lat1;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $bWC4D.default)(this.es);
    this.e1 = (0, $hU8aC.default)(this.es);
    this.e2 = (0, $i9r9A.default)(this.es);
    this.e3 = (0, $bM0eI.default)(this.es);
    this.sinphi = Math.sin(this.lat1);
    this.cosphi = Math.cos(this.lat1);
    this.ms1 = (0, $bi5ZC.default)(this.e, this.sinphi, this.cosphi);
    this.ml1 = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat1);
    if (Math.abs(this.lat1 - this.lat2) < (0, $gyVUi.EPSLN)) this.ns = this.sinphi;
    else {
        this.sinphi = Math.sin(this.lat2);
        this.cosphi = Math.cos(this.lat2);
        this.ms2 = (0, $bi5ZC.default)(this.e, this.sinphi, this.cosphi);
        this.ml2 = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat2);
        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
    }
    this.g = this.ml1 + this.ms1 / this.ns;
    this.ml0 = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    this.rh = this.a * (this.g - this.ml0);
}
function $cab513e7d920927e$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var rh1;
    /* Forward equations
      -----------------*/ if (this.sphere) rh1 = this.a * (this.g - lat);
    else {
        var ml = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, lat);
        rh1 = this.a * (this.g - ml);
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0);
    var x = this.x0 + rh1 * Math.sin(theta);
    var y = this.y0 + this.rh - rh1 * Math.cos(theta);
    p.x = x;
    p.y = y;
    return p;
}
function $cab513e7d920927e$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    var con, rh1, lat, lon;
    if (this.ns >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns);
        lat = (0, $aDUFA.default)(this.g - rh1 / this.a);
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        var ml = this.g - rh1 / this.a;
        lat = (0, $cfNuL.default)(ml, this.e0, this.e1, this.e2, this.e3);
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns);
        p.x = lon;
        p.y = lat;
        return p;
    }
}
var $cab513e7d920927e$export$e4b2ac9215619f8d = [
    "Equidistant_Conic",
    "eqdc"
];
var $cab513e7d920927e$export$2e2bcd8739ae039 = {
    init: $cab513e7d920927e$export$2cd8252107eb640b,
    forward: $cab513e7d920927e$export$174bb771924e7eb1,
    inverse: $cab513e7d920927e$export$70ae2c07e401031b,
    names: $cab513e7d920927e$export$e4b2ac9215619f8d
};

});

parcelRegister("1W450", function(module, exports) {

$parcel$export(module.exports, "default", () => $168e5f6524a6fc5f$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
function $168e5f6524a6fc5f$export$2cd8252107eb640b() {
    //this.R = 6370997; //Radius of earth
    this.R = this.a;
}
function $168e5f6524a6fc5f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    var x, y;
    if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.R * dlon;
        y = this.y0;
    }
    var theta = (0, $ljPJJ.default)(2 * Math.abs(lat / Math.PI));
    if (Math.abs(dlon) <= (0, $gyVUi.EPSLN) || Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
        x = this.x0;
        if (lat >= 0) y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
        else y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
    //  return(OK);
    }
    var al = 0.5 * Math.abs(Math.PI / dlon - dlon / Math.PI);
    var asq = al * al;
    var sinth = Math.sin(theta);
    var costh = Math.cos(theta);
    var g = costh / (sinth + costh - 1);
    var gsq = g * g;
    var m = g * (2 / sinth - 1);
    var msq = m * m;
    var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
    if (dlon < 0) con = -con;
    x = this.x0 + con;
    //con = Math.abs(con / (Math.PI * this.R));
    var q = asq + g;
    con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
    if (lat >= 0) //y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 + con;
    else //y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 - con;
    p.x = x;
    p.y = y;
    return p;
}
function $168e5f6524a6fc5f$export$70ae2c07e401031b(p) {
    var lon, lat;
    var xx, yy, xys, c1, c2, c3;
    var a1;
    var m1;
    var con;
    var th1;
    var d;
    /* inverse equations
    -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    con = Math.PI * this.R;
    xx = p.x / con;
    yy = p.y / con;
    xys = xx * xx + yy * yy;
    c1 = -Math.abs(yy) * (1 + xys);
    c2 = c1 - 2 * yy * yy + xx * xx;
    c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
    d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
    a1 = (c1 - c2 * c2 / 3 / c3) / c3;
    m1 = 2 * Math.sqrt(-a1 / 3);
    con = 3 * d / a1 / m1;
    if (Math.abs(con) > 1) {
        if (con >= 0) con = 1;
        else con = -1;
    }
    th1 = Math.acos(con) / 3;
    if (p.y >= 0) lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    else lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    if (Math.abs(xx) < (0, $gyVUi.EPSLN)) lon = this.long0;
    else lon = (0, $a9oRf.default)(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
    p.x = lon;
    p.y = lat;
    return p;
}
var $168e5f6524a6fc5f$export$e4b2ac9215619f8d = [
    "Van_der_Grinten_I",
    "VanDerGrinten",
    "vandg"
];
var $168e5f6524a6fc5f$export$2e2bcd8739ae039 = {
    init: $168e5f6524a6fc5f$export$2cd8252107eb640b,
    forward: $168e5f6524a6fc5f$export$174bb771924e7eb1,
    inverse: $168e5f6524a6fc5f$export$70ae2c07e401031b,
    names: $168e5f6524a6fc5f$export$e4b2ac9215619f8d
};

});

parcelRegister("i6dz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d34f4dbda3af26$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $f3cKo = parcelRequire("f3cKo");

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $3eeGT = parcelRequire("3eeGT");

var $ljPJJ = parcelRequire("ljPJJ");

var $cfNuL = parcelRequire("cfNuL");
function $d2d34f4dbda3af26$export$2cd8252107eb640b() {
    this.sin_p12 = Math.sin(this.lat0);
    this.cos_p12 = Math.cos(this.lat0);
}
function $d2d34f4dbda3af26$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    var e0, e1, e2, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G, H, GH, Hs, c, kp, cos_c, s, s2, s3, s4, s5;
    if (this.sphere) {
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.sin(dlon);
            p.y = this.y0 - this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.sin(dlon);
            p.y = this.y0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.cos(dlon);
            return p;
        } else {
            //default case
            cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
            c = Math.acos(cos_c);
            kp = c ? c / Math.sin(c) : 1;
            p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
            p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
            return p;
        }
    } else {
        e0 = (0, $bWC4D.default)(this.es);
        e1 = (0, $hU8aC.default)(this.es);
        e2 = (0, $i9r9A.default)(this.es);
        e3 = (0, $bM0eI.default)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North Pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
            p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South Pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
            p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
            return p;
        } else {
            //Default case
            tanphi = sinphi / cosphi;
            Nl1 = (0, $3eeGT.default)(this.a, this.e, this.sin_p12);
            Nl = (0, $3eeGT.default)(this.a, this.e, sinphi);
            psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
            Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
            if (Az === 0) s = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
            else if (Math.abs(Math.abs(Az) - Math.PI) <= (0, $gyVUi.EPSLN)) s = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
            else s = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
            G = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
            H = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
            GH = G * H;
            Hs = H * H;
            s2 = s * s;
            s3 = s2 * s;
            s4 = s3 * s;
            s5 = s4 * s;
            c = Nl1 * s * (1 - s2 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G * G * (1 - 7 * Hs)) - s5 / 48 * GH);
            p.x = this.x0 + c * Math.sin(Az);
            p.y = this.y0 + c * Math.cos(Az);
            return p;
        }
    }
}
function $d2d34f4dbda3af26$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, N1, psi, Az, cosAz, tmp, A, B, D, Ee, F, sinpsi;
    if (this.sphere) {
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        if (rh > 2 * (0, $gyVUi.HALF_PI) * this.a) return;
        z = rh / this.a;
        sinz = Math.sin(z);
        cosz = Math.cos(z);
        lon = this.long0;
        if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) lat = this.lat0;
        else {
            lat = (0, $ljPJJ.default)(cosz * this.sin_p12 + p.y * sinz * this.cos_p12 / rh);
            con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
            if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
                if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y));
                else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y));
            } else /*con = cosz - this.sin_p12 * Math.sin(lat);
        if ((Math.abs(con) < EPSLN) && (Math.abs(p.x) < EPSLN)) {
          //no-op, just keep the lon value as is
        } else {
          var temp = Math.atan2((p.x * sinz * this.cos_p12), (con * rh));
          lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz * this.cos_p12), (con * rh)));
        }*/ lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
        }
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        e0 = (0, $bWC4D.default)(this.es);
        e1 = (0, $hU8aC.default)(this.es);
        e2 = (0, $i9r9A.default)(this.es);
        e3 = (0, $bM0eI.default)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = Mlp - rh;
            lat = (0, $cfNuL.default)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y));
            p.x = lon;
            p.y = lat;
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = rh - Mlp;
            lat = (0, $cfNuL.default)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y));
            p.x = lon;
            p.y = lat;
            return p;
        } else {
            //default case
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            Az = Math.atan2(p.x, p.y);
            N1 = (0, $3eeGT.default)(this.a, this.e, this.sin_p12);
            cosAz = Math.cos(Az);
            tmp = this.e * this.cos_p12 * cosAz;
            A = -tmp * tmp / (1 - this.es);
            B = 3 * this.es * (1 - A) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
            D = rh / N1;
            Ee = D - A * (1 + A) * Math.pow(D, 3) / 6 - B * (1 + 3 * A) * Math.pow(D, 4) / 24;
            F = 1 - A * Ee * Ee / 2 - D * Ee * Ee * Ee / 6;
            psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
            lon = (0, $a9oRf.default)(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
            sinpsi = Math.sin(psi);
            lat = Math.atan2((sinpsi - this.es * F * this.sin_p12) * Math.tan(psi), sinpsi * (1 - this.es));
            p.x = lon;
            p.y = lat;
            return p;
        }
    }
}
var $d2d34f4dbda3af26$export$e4b2ac9215619f8d = [
    "Azimuthal_Equidistant",
    "aeqd"
];
var $d2d34f4dbda3af26$export$2e2bcd8739ae039 = {
    init: $d2d34f4dbda3af26$export$2cd8252107eb640b,
    forward: $d2d34f4dbda3af26$export$174bb771924e7eb1,
    inverse: $d2d34f4dbda3af26$export$70ae2c07e401031b,
    names: $d2d34f4dbda3af26$export$e4b2ac9215619f8d
};

});

parcelRegister("37G1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $24629f153ebf2c1f$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $24629f153ebf2c1f$export$2cd8252107eb640b() {
    //double temp;      /* temporary variable    */
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
}
function $24629f153ebf2c1f$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g, x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ dlon = (0, $a9oRf.default)(lon - this.long0);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.a * ksp * cosphi * Math.sin(dlon);
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $24629f153ebf2c1f$export$70ae2c07e401031b(p) {
    var rh; /* height above ellipsoid      */ 
    var z; /* angle          */ 
    var sinz, cosz; /* sin of z and cos of z      */ 
    var con;
    var lon, lat;
    /* Inverse equations
      -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    z = (0, $ljPJJ.default)(rh / this.a);
    sinz = Math.sin(z);
    cosz = Math.cos(z);
    lon = this.long0;
    if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) {
        lat = this.lat0;
        p.x = lon;
        p.y = lat;
        return p;
    }
    lat = (0, $ljPJJ.default)(cosz * this.sin_p14 + p.y * sinz * this.cos_p14 / rh);
    con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
    if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
        if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y));
        else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y));
        p.x = lon;
        p.y = lat;
        return p;
    }
    lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz));
    p.x = lon;
    p.y = lat;
    return p;
}
var $24629f153ebf2c1f$export$e4b2ac9215619f8d = [
    "ortho"
];
var $24629f153ebf2c1f$export$2e2bcd8739ae039 = {
    init: $24629f153ebf2c1f$export$2cd8252107eb640b,
    forward: $24629f153ebf2c1f$export$174bb771924e7eb1,
    inverse: $24629f153ebf2c1f$export$70ae2c07e401031b,
    names: $24629f153ebf2c1f$export$e4b2ac9215619f8d
};

});

parcelRegister("2XUb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $228cab2632c5bcf7$export$2e2bcd8739ae039);
// QSC projection rewritten from the original PROJ4
// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c

var $gyVUi = parcelRequire("gyVUi");
/* constants */ var $228cab2632c5bcf7$var$FACE_ENUM = {
    FRONT: 1,
    RIGHT: 2,
    BACK: 3,
    LEFT: 4,
    TOP: 5,
    BOTTOM: 6
};
var $228cab2632c5bcf7$var$AREA_ENUM = {
    AREA_0: 1,
    AREA_1: 2,
    AREA_2: 3,
    AREA_3: 4
};
function $228cab2632c5bcf7$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Quadrilateralized Spherical Cube";
    /* Determine the cube face from the center of projection. */ if (this.lat0 >= (0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0) this.face = $228cab2632c5bcf7$var$FACE_ENUM.TOP;
    else if (this.lat0 <= -((0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM;
    else if (Math.abs(this.long0) <= (0, $gyVUi.FORTPI)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.FRONT;
    else if (Math.abs(this.long0) <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) this.face = this.long0 > 0.0 ? $228cab2632c5bcf7$var$FACE_ENUM.RIGHT : $228cab2632c5bcf7$var$FACE_ENUM.LEFT;
    else this.face = $228cab2632c5bcf7$var$FACE_ENUM.BACK;
    /* Fill in useful values for the ellipsoid <-> sphere shift
   * described in [LK12]. */ if (this.es !== 0) {
        this.one_minus_f = 1 - (this.a - this.b) / this.a;
        this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
    }
}
function $228cab2632c5bcf7$export$174bb771924e7eb1(p) {
    var xy = {
        x: 0,
        y: 0
    };
    var lat, lon;
    var theta, phi;
    var t, mu;
    /* nu; */ var area = {
        value: 0
    };
    // move lon according to projection's lon
    p.x -= this.long0;
    /* Convert the geodetic latitude to a geocentric latitude.
   * This corresponds to the shift from the ellipsoid to the sphere
   * described in [LK12]. */ if (this.es !== 0) lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
    else lat = p.y;
    /* Convert the input lat, lon into theta, phi as used by QSC.
   * This depends on the cube face and the area on it.
   * For the top and bottom face, we can compute theta and phi
   * directly from phi, lam. For the other faces, we must use
   * unit sphere cartesian coordinates as an intermediate step. */ lon = p.x; //lon = lp.lam;
    if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = (0, $gyVUi.HALF_PI) - lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = lon - (0, $gyVUi.HALF_PI);
        } else if (lon > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || lon <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = lon > 0.0 ? lon - (0, $gyVUi.SPI) : lon + (0, $gyVUi.SPI);
        } else if (lon > -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) && lon <= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = lon + (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon;
        }
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = (0, $gyVUi.HALF_PI) + lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = -lon + (0, $gyVUi.HALF_PI);
        } else if (lon < (0, $gyVUi.FORTPI) && lon >= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = -lon;
        } else if (lon < -(0, $gyVUi.FORTPI) && lon >= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = -lon - (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon > 0.0 ? -lon + (0, $gyVUi.SPI) : -lon - (0, $gyVUi.SPI);
        }
    } else {
        var q, r, s;
        var sinlat, coslat;
        var sinlon, coslon;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, -(0, $gyVUi.HALF_PI));
        sinlat = Math.sin(lat);
        coslat = Math.cos(lat);
        sinlon = Math.sin(lon);
        coslon = Math.cos(lon);
        q = coslat * coslon;
        r = coslat * sinlon;
        s = sinlat;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.FRONT) {
            phi = Math.acos(q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            phi = Math.acos(r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -q, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            phi = Math.acos(-q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            phi = Math.acos(-r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, q, area);
        } else {
            /* Impossible */ phi = theta = 0;
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        }
    }
    /* Compute mu and nu for the area of definition.
   * For mu, see Eq. (3-21) in [OL76], but note the typos:
   * compare with Eq. (3-14). For nu, see Eq. (3-38). */ mu = Math.atan(12 / (0, $gyVUi.SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos((0, $gyVUi.FORTPI))) - (0, $gyVUi.HALF_PI)));
    t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));
    /* Apply the result to the real area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) mu += (0, $gyVUi.HALF_PI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) mu += (0, $gyVUi.SPI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) mu += 1.5 * (0, $gyVUi.SPI);
    /* Now compute x, y from mu and nu */ xy.x = t * Math.cos(mu);
    xy.y = t * Math.sin(mu);
    xy.x = xy.x * this.a + this.x0;
    xy.y = xy.y * this.a + this.y0;
    p.x = xy.x;
    p.y = xy.y;
    return p;
}
function $228cab2632c5bcf7$export$70ae2c07e401031b(p) {
    var lp = {
        lam: 0,
        phi: 0
    };
    var mu, nu, cosmu, tannu;
    var tantheta, theta, cosphi, phi;
    var t;
    var area = {
        value: 0
    };
    /* de-offset */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    /* Convert the input x, y to the mu and nu angles as used by QSC.
   * This depends on the area of the cube face. */ nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
    mu = Math.atan2(p.y, p.x);
    if (p.x >= 0.0 && p.x >= Math.abs(p.y)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
    else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
        mu -= (0, $gyVUi.HALF_PI);
    } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
        mu = mu < 0.0 ? mu + (0, $gyVUi.SPI) : mu - (0, $gyVUi.SPI);
    } else {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
        mu += (0, $gyVUi.HALF_PI);
    }
    /* Compute phi and theta for the area of definition.
   * The inverse projection is not described in the original paper, but some
   * good hints can be found here (as of 2011-12-14):
   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */ t = (0, $gyVUi.SPI) / 12 * Math.tan(mu);
    tantheta = Math.sin(t) / (Math.cos(t) - 1 / Math.sqrt(2));
    theta = Math.atan(tantheta);
    cosmu = Math.cos(mu);
    tannu = Math.tan(nu);
    cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
    if (cosphi < -1) cosphi = -1;
    else if (cosphi > 1) cosphi = 1;
    /* Apply the result to the real area on the cube face.
   * For the top and bottom face, we can compute phi and lam directly.
   * For the other faces, we must use unit sphere cartesian coordinates
   * as an intermediate step. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = Math.acos(cosphi);
        lp.phi = (0, $gyVUi.HALF_PI) - phi;
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = theta < 0.0 ? theta + (0, $gyVUi.SPI) : theta - (0, $gyVUi.SPI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta;
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = Math.acos(cosphi);
        lp.phi = phi - (0, $gyVUi.HALF_PI);
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = -theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = -theta;
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = -theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta < 0.0 ? -theta - (0, $gyVUi.SPI) : -theta + (0, $gyVUi.SPI);
    } else {
        /* Compute phi and lam via cartesian unit sphere coordinates. */ var q, r, s;
        q = cosphi;
        t = q * q;
        if (t >= 1) s = 0;
        else s = Math.sqrt(1 - t) * Math.sin(theta);
        t += s * s;
        if (t >= 1) r = 0;
        else r = Math.sqrt(1 - t);
        /* Rotate q,r,s into the correct area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) {
            t = r;
            r = -s;
            s = t;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) {
            r = -r;
            s = -s;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) {
            t = r;
            r = s;
            s = -t;
        }
        /* Rotate q,r,s into the correct cube face. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            t = q;
            q = -r;
            r = t;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            q = -q;
            r = -r;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            t = q;
            q = r;
            r = -t;
        }
        /* Now compute phi and lam from the unit sphere coordinates. */ lp.phi = Math.acos(-s) - (0, $gyVUi.HALF_PI);
        lp.lam = Math.atan2(r, q);
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, +(0, $gyVUi.HALF_PI));
    }
    /* Apply the shift from the sphere to the ellipsoid as described
   * in [LK12]. */ if (this.es !== 0) {
        var invert_sign;
        var tanphi, xa;
        invert_sign = lp.phi < 0 ? 1 : 0;
        tanphi = Math.tan(lp.phi);
        xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
        lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
        if (invert_sign) lp.phi = -lp.phi;
    }
    lp.lam += this.long0;
    p.x = lp.lam;
    p.y = lp.phi;
    return p;
}
/* Helper function for forward projection: compute the theta angle
 * and determine the area number. */ function $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, y, x, area) {
    var theta;
    if (phi < (0, $gyVUi.EPSLN)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        theta = 0.0;
    } else {
        theta = Math.atan2(y, x);
        if (Math.abs(theta) <= (0, $gyVUi.FORTPI)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        else if (theta > (0, $gyVUi.FORTPI) && theta <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta -= (0, $gyVUi.HALF_PI);
        } else if (theta > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || theta <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = theta >= 0.0 ? theta - (0, $gyVUi.SPI) : theta + (0, $gyVUi.SPI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta += (0, $gyVUi.HALF_PI);
        }
    }
    return theta;
}
/* Helper function: shift the longitude. */ function $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, offset) {
    var slon = lon + offset;
    if (slon < -(0, $gyVUi.SPI)) slon += (0, $gyVUi.TWO_PI);
    else if (slon > +(0, $gyVUi.SPI)) slon -= (0, $gyVUi.TWO_PI);
    return slon;
}
var $228cab2632c5bcf7$export$e4b2ac9215619f8d = [
    "Quadrilateralized Spherical Cube",
    "Quadrilateralized_Spherical_Cube",
    "qsc"
];
var $228cab2632c5bcf7$export$2e2bcd8739ae039 = {
    init: $228cab2632c5bcf7$export$2cd8252107eb640b,
    forward: $228cab2632c5bcf7$export$174bb771924e7eb1,
    inverse: $228cab2632c5bcf7$export$70ae2c07e401031b,
    names: $228cab2632c5bcf7$export$e4b2ac9215619f8d
};

});

parcelRegister("byZja", function(module, exports) {

$parcel$export(module.exports, "default", () => $86b26d30d3579075$export$2e2bcd8739ae039);
// Robinson projection
// Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
// Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039

var $gyVUi = parcelRequire("gyVUi");

var $a9oRf = parcelRequire("a9oRf");
var $86b26d30d3579075$var$COEFS_X = [
    [
        1.0000,
        2.2199e-17,
        -0.0000715515,
        3.1103e-06
    ],
    [
        0.9986,
        -0.000482243,
        -0.000024897,
        -0.0000013309
    ],
    [
        0.9954,
        -0.00083103,
        -0.0000448605,
        -0.000000986701
    ],
    [
        0.9900,
        -0.00135364,
        -0.000059661,
        3.6777e-06
    ],
    [
        0.9822,
        -0.00167442,
        -0.00000449547,
        -0.00000572411
    ],
    [
        0.9730,
        -0.00214868,
        -0.0000903571,
        1.8736e-08
    ],
    [
        0.9600,
        -0.00305085,
        -0.0000900761,
        1.64917e-06
    ],
    [
        0.9427,
        -0.00382792,
        -0.0000653386,
        -0.0000026154
    ],
    [
        0.9216,
        -0.00467746,
        -0.00010457,
        4.81243e-06
    ],
    [
        0.8962,
        -0.00536223,
        -0.0000323831,
        -0.00000543432
    ],
    [
        0.8679,
        -0.00609363,
        -0.000113898,
        3.32484e-06
    ],
    [
        0.8350,
        -0.00698325,
        -0.0000640253,
        9.34959e-07
    ],
    [
        0.7986,
        -0.00755338,
        -0.0000500009,
        9.35324e-07
    ],
    [
        0.7597,
        -0.00798324,
        -0.000035971,
        -0.00000227626
    ],
    [
        0.7186,
        -0.00851367,
        -0.0000701149,
        -0.0000086303
    ],
    [
        0.6732,
        -0.00986209,
        -0.000199569,
        1.91974e-05
    ],
    [
        0.6213,
        -0.010418,
        8.83923e-05,
        6.24051e-06
    ],
    [
        0.5722,
        -0.00906601,
        0.000182,
        6.24051e-06
    ],
    [
        0.5322,
        -0.00677797,
        0.000275608,
        6.24051e-06
    ]
];
var $86b26d30d3579075$var$COEFS_Y = [
    [
        -0.00000000000000000520417,
        0.0124,
        1.21431e-18,
        -0.0000000000845284
    ],
    [
        0.0620,
        0.0124,
        -0.00000000126793,
        4.22642e-10
    ],
    [
        0.1240,
        0.0124,
        5.07171e-09,
        -0.00000000160604
    ],
    [
        0.1860,
        0.0123999,
        -0.0000000190189,
        6.00152e-09
    ],
    [
        0.2480,
        0.0124002,
        7.10039e-08,
        -0.0000000224
    ],
    [
        0.3100,
        0.0123992,
        -0.000000264997,
        8.35986e-08
    ],
    [
        0.3720,
        0.0124029,
        9.88983e-07,
        -0.000000311994
    ],
    [
        0.4340,
        0.0123893,
        -0.00000369093,
        -0.000000435621
    ],
    [
        0.4958,
        0.0123198,
        -0.0000102252,
        -0.000000345523
    ],
    [
        0.5571,
        0.0121916,
        -0.0000154081,
        -0.000000582288
    ],
    [
        0.6176,
        0.0119938,
        -0.0000241424,
        -0.000000525327
    ],
    [
        0.6769,
        0.011713,
        -0.0000320223,
        -0.000000516405
    ],
    [
        0.7346,
        0.0113541,
        -0.0000397684,
        -0.000000609052
    ],
    [
        0.7903,
        0.0109107,
        -0.0000489042,
        -0.00000104739
    ],
    [
        0.8435,
        0.0103431,
        -0.000064615,
        -0.00000000140374
    ],
    [
        0.8936,
        0.00969686,
        -0.000064636,
        -0.000008547
    ],
    [
        0.9394,
        0.00840947,
        -0.000192841,
        -0.0000042106
    ],
    [
        0.9761,
        0.00616527,
        -0.000256,
        -0.0000042106
    ],
    [
        1.0000,
        0.00328947,
        -0.000319159,
        -0.0000042106
    ]
];
var $86b26d30d3579075$var$FXC = 0.8487;
var $86b26d30d3579075$var$FYC = 1.3523;
var $86b26d30d3579075$var$C1 = (0, $gyVUi.R2D) / 5; // rad to 5-degree interval
var $86b26d30d3579075$var$RC1 = 1 / $86b26d30d3579075$var$C1;
var $86b26d30d3579075$var$NODES = 18;
var $86b26d30d3579075$var$poly3_val = function(coefs, x) {
    return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
};
var $86b26d30d3579075$var$poly3_der = function(coefs, x) {
    return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
};
function $86b26d30d3579075$var$newton_rapshon(f_df, start, max_err, iters) {
    var x = start;
    for(; iters; --iters){
        var upd = f_df(x);
        x -= upd;
        if (Math.abs(upd) < max_err) break;
    }
    return x;
}
function $86b26d30d3579075$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.es = 0;
    this.title = this.title || "Robinson";
}
function $86b26d30d3579075$export$174bb771924e7eb1(ll) {
    var lon = (0, $a9oRf.default)(ll.x - this.long0);
    var dphi = Math.abs(ll.y);
    var i = Math.floor(dphi * $86b26d30d3579075$var$C1);
    if (i < 0) i = 0;
    else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
    dphi = (0, $gyVUi.R2D) * (dphi - $86b26d30d3579075$var$RC1 * i);
    var xy = {
        x: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], dphi) * lon,
        y: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_Y[i], dphi)
    };
    if (ll.y < 0) xy.y = -xy.y;
    xy.x = xy.x * this.a * $86b26d30d3579075$var$FXC + this.x0;
    xy.y = xy.y * this.a * $86b26d30d3579075$var$FYC + this.y0;
    return xy;
}
function $86b26d30d3579075$export$70ae2c07e401031b(xy) {
    var ll = {
        x: (xy.x - this.x0) / (this.a * $86b26d30d3579075$var$FXC),
        y: Math.abs(xy.y - this.y0) / (this.a * $86b26d30d3579075$var$FYC)
    };
    if (ll.y >= 1) {
        ll.x /= $86b26d30d3579075$var$COEFS_X[$86b26d30d3579075$var$NODES][0];
        ll.y = xy.y < 0 ? -(0, $gyVUi.HALF_PI) : (0, $gyVUi.HALF_PI);
    } else {
        // find table interval
        var i = Math.floor(ll.y * $86b26d30d3579075$var$NODES);
        if (i < 0) i = 0;
        else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
        for(;;){
            if ($86b26d30d3579075$var$COEFS_Y[i][0] > ll.y) --i;
            else if ($86b26d30d3579075$var$COEFS_Y[i + 1][0] <= ll.y) ++i;
            else break;
        }
        // linear interpolation in 5 degree interval
        var coefs = $86b26d30d3579075$var$COEFS_Y[i];
        var t = 5 * (ll.y - coefs[0]) / ($86b26d30d3579075$var$COEFS_Y[i + 1][0] - coefs[0]);
        // find t so that poly3_val(coefs, t) = ll.y
        t = $86b26d30d3579075$var$newton_rapshon(function(x) {
            return ($86b26d30d3579075$var$poly3_val(coefs, x) - ll.y) / $86b26d30d3579075$var$poly3_der(coefs, x);
        }, t, (0, $gyVUi.EPSLN), 100);
        ll.x /= $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], t);
        ll.y = (5 * i + t) * (0, $gyVUi.D2R);
        if (xy.y < 0) ll.y = -ll.y;
    }
    ll.x = (0, $a9oRf.default)(ll.x + this.long0);
    return ll;
}
var $86b26d30d3579075$export$e4b2ac9215619f8d = [
    "Robinson",
    "robin"
];
var $86b26d30d3579075$export$2e2bcd8739ae039 = {
    init: $86b26d30d3579075$export$2cd8252107eb640b,
    forward: $86b26d30d3579075$export$174bb771924e7eb1,
    inverse: $86b26d30d3579075$export$70ae2c07e401031b,
    names: $86b26d30d3579075$export$e4b2ac9215619f8d
};

});

parcelRegister("Fj8jS", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c2abe70612fbc5$export$2e2bcd8739ae039);

var $4YPx7 = parcelRequire("4YPx7");
function $07c2abe70612fbc5$export$2cd8252107eb640b() {
    this.name = "geocent";
}
function $07c2abe70612fbc5$export$174bb771924e7eb1(p) {
    var point = (0, $4YPx7.geodeticToGeocentric)(p, this.es, this.a);
    return point;
}
function $07c2abe70612fbc5$export$70ae2c07e401031b(p) {
    var point = (0, $4YPx7.geocentricToGeodetic)(p, this.es, this.a, this.b);
    return point;
}
var $07c2abe70612fbc5$export$e4b2ac9215619f8d = [
    "Geocentric",
    "geocentric",
    "geocent",
    "Geocent"
];
var $07c2abe70612fbc5$export$2e2bcd8739ae039 = {
    init: $07c2abe70612fbc5$export$2cd8252107eb640b,
    forward: $07c2abe70612fbc5$export$174bb771924e7eb1,
    inverse: $07c2abe70612fbc5$export$70ae2c07e401031b,
    names: $07c2abe70612fbc5$export$e4b2ac9215619f8d
};

});

parcelRegister("eJp9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab98c67e9f567a4b$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $jU5gu = parcelRequire("jU5gu");
var $ab98c67e9f567a4b$var$mode = {
    N_POLE: 0,
    S_POLE: 1,
    EQUIT: 2,
    OBLIQ: 3
};
var $ab98c67e9f567a4b$var$params = {
    h: {
        def: 100000,
        num: true
    },
    azi: {
        def: 0,
        num: true,
        degrees: true
    },
    tilt: {
        def: 0,
        num: true,
        degrees: true
    },
    long0: {
        def: 0,
        num: true
    },
    lat0: {
        def: 0,
        num: true
    } // default is Equator, conversion to rad is automatic
};
function $ab98c67e9f567a4b$export$2cd8252107eb640b() {
    Object.keys($ab98c67e9f567a4b$var$params).forEach((function(p) {
        if (typeof this[p] === "undefined") this[p] = $ab98c67e9f567a4b$var$params[p].def;
        else if ($ab98c67e9f567a4b$var$params[p].num && isNaN(this[p])) throw new Error("Invalid parameter value, must be numeric " + p + " = " + this[p]);
        else if ($ab98c67e9f567a4b$var$params[p].num) this[p] = parseFloat(this[p]);
        if ($ab98c67e9f567a4b$var$params[p].degrees) this[p] = this[p] * (0, $gyVUi.D2R);
    }).bind(this));
    if (Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN)) this.mode = this.lat0 < 0 ? $ab98c67e9f567a4b$var$mode.S_POLE : $ab98c67e9f567a4b$var$mode.N_POLE;
    else if (Math.abs(this.lat0) < (0, $gyVUi.EPSLN)) this.mode = $ab98c67e9f567a4b$var$mode.EQUIT;
    else {
        this.mode = $ab98c67e9f567a4b$var$mode.OBLIQ;
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
    this.pn1 = this.h / this.a; // Normalize relative to the Earth's radius
    if (this.pn1 <= 0 || this.pn1 > 1e10) throw new Error("Invalid height");
    this.p = 1 + this.pn1;
    this.rp = 1 / this.p;
    this.h1 = 1 / this.pn1;
    this.pfact = (this.p + 1) * this.h1;
    this.es = 0;
    var omega = this.tilt;
    var gamma = this.azi;
    this.cg = Math.cos(gamma);
    this.sg = Math.sin(gamma);
    this.cw = Math.cos(omega);
    this.sw = Math.sin(omega);
}
function $ab98c67e9f567a4b$export$174bb771924e7eb1(p) {
    p.x -= this.long0;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var coslam = Math.cos(p.x);
    var x, y;
    switch(this.mode){
        case $ab98c67e9f567a4b$var$mode.OBLIQ:
            y = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.EQUIT:
            y = cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.S_POLE:
            y = -sinphi;
            break;
        case $ab98c67e9f567a4b$var$mode.N_POLE:
            y = sinphi;
            break;
    }
    y = this.pn1 / (this.p - y);
    x = y * cosphi * Math.sin(p.x);
    switch(this.mode){
        case $ab98c67e9f567a4b$var$mode.OBLIQ:
            y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.EQUIT:
            y *= sinphi;
            break;
        case $ab98c67e9f567a4b$var$mode.N_POLE:
            y *= -(cosphi * coslam);
            break;
        case $ab98c67e9f567a4b$var$mode.S_POLE:
            y *= cosphi * coslam;
            break;
    }
    // Tilt 
    var yt, ba;
    yt = y * this.cg + x * this.sg;
    ba = 1 / (yt * this.sw * this.h1 + this.cw);
    x = (x * this.cg - y * this.sg) * this.cw * ba;
    y = yt * ba;
    p.x = x * this.a;
    p.y = y * this.a;
    return p;
}
function $ab98c67e9f567a4b$export$70ae2c07e401031b(p) {
    p.x /= this.a;
    p.y /= this.a;
    var r = {
        x: p.x,
        y: p.y
    };
    // Un-Tilt
    var bm, bq, yt;
    yt = 1 / (this.pn1 - p.y * this.sw);
    bm = this.pn1 * p.x * yt;
    bq = this.pn1 * p.y * this.cw * yt;
    p.x = bm * this.cg + bq * this.sg;
    p.y = bq * this.cg - bm * this.sg;
    var rh = (0, $jU5gu.default)(p.x, p.y);
    if (Math.abs(rh) < (0, $gyVUi.EPSLN)) {
        r.x = 0;
        r.y = p.y;
    } else {
        var cosz, sinz;
        sinz = 1 - rh * rh * this.pfact;
        sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
        cosz = Math.sqrt(1 - sinz * sinz);
        switch(this.mode){
            case $ab98c67e9f567a4b$var$mode.OBLIQ:
                r.y = Math.asin(cosz * this.sinph0 + p.y * sinz * this.cosph0 / rh);
                p.y = (cosz - this.sinph0 * Math.sin(r.y)) * rh;
                p.x *= sinz * this.cosph0;
                break;
            case $ab98c67e9f567a4b$var$mode.EQUIT:
                r.y = Math.asin(p.y * sinz / rh);
                p.y = cosz * rh;
                p.x *= sinz;
                break;
            case $ab98c67e9f567a4b$var$mode.N_POLE:
                r.y = Math.asin(cosz);
                p.y = -p.y;
                break;
            case $ab98c67e9f567a4b$var$mode.S_POLE:
                r.y = -Math.asin(cosz);
                break;
        }
        r.x = Math.atan2(p.x, p.y);
    }
    p.x = r.x + this.long0;
    p.y = r.y;
    return p;
}
var $ab98c67e9f567a4b$export$e4b2ac9215619f8d = [
    "Tilted_Perspective",
    "tpers"
];
var $ab98c67e9f567a4b$export$2e2bcd8739ae039 = {
    init: $ab98c67e9f567a4b$export$2cd8252107eb640b,
    forward: $ab98c67e9f567a4b$export$174bb771924e7eb1,
    inverse: $ab98c67e9f567a4b$export$70ae2c07e401031b,
    names: $ab98c67e9f567a4b$export$e4b2ac9215619f8d
};

});

parcelRegister("jJ6PL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5c7855edcbcda04$export$2e2bcd8739ae039);

var $jU5gu = parcelRequire("jU5gu");
function $e5c7855edcbcda04$export$2cd8252107eb640b() {
    this.flip_axis = this.sweep === "x" ? 1 : 0;
    this.h = Number(this.h);
    this.radius_g_1 = this.h / this.a;
    if (this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) throw new Error();
    this.radius_g = 1.0 + this.radius_g_1;
    this.C = this.radius_g * this.radius_g - 1.0;
    if (this.es !== 0.0) {
        var one_es = 1.0 - this.es;
        var rone_es = 1 / one_es;
        this.radius_p = Math.sqrt(one_es);
        this.radius_p2 = one_es;
        this.radius_p_inv2 = rone_es;
        this.shape = "ellipse"; // Use as a condition in the forward and inverse functions.
    } else {
        this.radius_p = 1.0;
        this.radius_p2 = 1.0;
        this.radius_p_inv2 = 1.0;
        this.shape = "sphere"; // Use as a condition in the forward and inverse functions.
    }
    if (!this.title) this.title = "Geostationary Satellite View";
}
function $e5c7855edcbcda04$var$forward(p) {
    var lon = p.x;
    var lat = p.y;
    var tmp, v_x, v_y, v_z;
    lon = lon - this.long0;
    if (this.shape === "ellipse") {
        lat = Math.atan(this.radius_p2 * Math.tan(lat));
        var r = this.radius_p / (0, $jU5gu.default)(this.radius_p * Math.cos(lat), Math.sin(lat));
        v_x = r * Math.cos(lon) * Math.cos(lat);
        v_y = r * Math.sin(lon) * Math.cos(lat);
        v_z = r * Math.sin(lat);
        if ((this.radius_g - v_x) * v_x - v_y * v_y - v_z * v_z * this.radius_p_inv2 < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $jU5gu.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $jU5gu.default)(v_y, tmp));
        }
    } else if (this.shape === "sphere") {
        tmp = Math.cos(lat);
        v_x = Math.cos(lon) * tmp;
        v_y = Math.sin(lon) * tmp;
        v_z = Math.sin(lat);
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $jU5gu.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $jU5gu.default)(v_y, tmp));
        }
    }
    p.x = p.x * this.a;
    p.y = p.y * this.a;
    return p;
}
function $e5c7855edcbcda04$var$inverse(p) {
    var v_x = -1;
    var v_y = 0.0;
    var v_z = 0.0;
    var a, b, det, k;
    p.x = p.x / this.a;
    p.y = p.y / this.a;
    if (this.shape === "ellipse") {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * (0, $jU5gu.default)(1.0, v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * (0, $jU5gu.default)(1.0, v_y);
        }
        var v_zp = v_z / this.radius_p;
        a = v_y * v_y + v_zp * v_zp + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
        p.y = Math.atan(this.radius_p_inv2 * Math.tan(p.y));
    } else if (this.shape === "sphere") {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * Math.sqrt(1.0 + v_z * v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * Math.sqrt(1.0 + v_y * v_y);
        }
        a = v_y * v_y + v_z * v_z + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
    }
    p.x = p.x + this.long0;
    return p;
}
var $e5c7855edcbcda04$export$e4b2ac9215619f8d = [
    "Geostationary Satellite View",
    "Geostationary_Satellite",
    "geos"
];
var $e5c7855edcbcda04$export$2e2bcd8739ae039 = {
    init: $e5c7855edcbcda04$export$2cd8252107eb640b,
    forward: $e5c7855edcbcda04$var$forward,
    inverse: $e5c7855edcbcda04$var$inverse,
    names: $e5c7855edcbcda04$export$e4b2ac9215619f8d
};

});

parcelRegister("cbANR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df30f7b6f96e4d8$export$2e2bcd8739ae039);
/**
 * Copyright 2018 Bernie Jenny, Monash University, Melbourne, Australia.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Equal Earth is a projection inspired by the Robinson projection, but unlike
 * the Robinson projection retains the relative size of areas. The projection
 * was designed in 2018 by Bojan Savric, Tom Patterson and Bernhard Jenny.
 *
 * Publication:
 * Bojan Savric, Tom Patterson & Bernhard Jenny (2018). The Equal Earth map
 * projection, International Journal of Geographical Information Science,
 * DOI: 10.1080/13658816.2018.1504949
 *
 * Code released August 2018
 * Ported to JavaScript and adapted for mapshaper-proj by Matthew Bloch August 2018
 * Modified for proj4js by Andreas Hocevar by Andreas Hocevar March 2024
 */ 
var $a9oRf = parcelRequire("a9oRf");
var $8df30f7b6f96e4d8$var$A1 = 1.340264, $8df30f7b6f96e4d8$var$A2 = -0.081106, $8df30f7b6f96e4d8$var$A3 = 0.000893, $8df30f7b6f96e4d8$var$A4 = 0.003796, $8df30f7b6f96e4d8$var$M = Math.sqrt(3) / 2.0;
function $8df30f7b6f96e4d8$export$2cd8252107eb640b() {
    this.es = 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
}
function $8df30f7b6f96e4d8$export$174bb771924e7eb1(p) {
    var lam = (0, $a9oRf.default)(p.x - this.long0);
    var phi = p.y;
    var paramLat = Math.asin($8df30f7b6f96e4d8$var$M * Math.sin(phi)), paramLatSq = paramLat * paramLat, paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = lam * Math.cos(paramLat) / ($8df30f7b6f96e4d8$var$M * ($8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq)));
    p.y = paramLat * ($8df30f7b6f96e4d8$var$A1 + $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * ($8df30f7b6f96e4d8$var$A3 + $8df30f7b6f96e4d8$var$A4 * paramLatSq));
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $8df30f7b6f96e4d8$export$70ae2c07e401031b(p) {
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    var EPS = 1e-9, NITER = 12, paramLat = p.y, paramLatSq, paramLatPow6, fy, fpy, dlat, i;
    for(i = 0; i < NITER; ++i){
        paramLatSq = paramLat * paramLat;
        paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
        fy = paramLat * ($8df30f7b6f96e4d8$var$A1 + $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * ($8df30f7b6f96e4d8$var$A3 + $8df30f7b6f96e4d8$var$A4 * paramLatSq)) - p.y;
        fpy = $8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq);
        paramLat -= dlat = fy / fpy;
        if (Math.abs(dlat) < EPS) break;
    }
    paramLatSq = paramLat * paramLat;
    paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = $8df30f7b6f96e4d8$var$M * p.x * ($8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq)) / Math.cos(paramLat);
    p.y = Math.asin(Math.sin(paramLat) / $8df30f7b6f96e4d8$var$M);
    p.x = (0, $a9oRf.default)(p.x + this.long0);
    return p;
}
var $8df30f7b6f96e4d8$export$e4b2ac9215619f8d = [
    "eqearth",
    "Equal Earth",
    "Equal_Earth"
];
var $8df30f7b6f96e4d8$export$2e2bcd8739ae039 = {
    init: $8df30f7b6f96e4d8$export$2cd8252107eb640b,
    forward: $8df30f7b6f96e4d8$export$174bb771924e7eb1,
    inverse: $8df30f7b6f96e4d8$export$70ae2c07e401031b,
    names: $8df30f7b6f96e4d8$export$e4b2ac9215619f8d
};

});



parcelRegister("i7vbU", function(module, exports) {
module.exports = new URL("dot.62d09457.svg", import.meta.url).toString();

});

parcelRegister("bviTd", function(module, exports) {
module.exports = new URL("arrow.c5ff6411.png", import.meta.url).toString();

});


parcelRegister("4Z60n", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a11846c6d9add3f$export$2e2bcd8739ae039);
/**
 * @module ol/interaction/Select
 */ 
var $cD8Qe = parcelRequire("cD8Qe");

var $1TIYs = parcelRequire("1TIYs");

var $f18Q2 = parcelRequire("f18Q2");

var $dIG9p = parcelRequire("dIG9p");

var $4U60I = parcelRequire("4U60I");

var $bdrRp = parcelRequire("bdrRp");

var $6wUzV = parcelRequire("6wUzV");

var $gn0g3 = parcelRequire("gn0g3");

var $c3RIb = parcelRequire("c3RIb");

var $fVVyM = parcelRequire("fVVyM");

var $9iPUS = parcelRequire("9iPUS");

var $kqI9g = parcelRequire("kqI9g");
/**
 * @enum {string}
 */ const $3a11846c6d9add3f$var$SelectEventType = {
    /**
   * Triggered when feature(s) has been (de)selected.
   * @event SelectEvent#select
   * @api
   */ SELECT: "select"
};
class $3a11846c6d9add3f$export$1bcc516ebf36ffe2 extends (0, $f18Q2.default) {
    /**
   * @param {SelectEventType} type The event type.
   * @param {Array<import("../Feature.js").default>} selected Selected features.
   * @param {Array<import("../Feature.js").default>} deselected Deselected features.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Associated
   *     {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   */ constructor(type, selected, deselected, mapBrowserEvent){
        super(type);
        /**
     * Selected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */ this.selected = selected;
        /**
     * Deselected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */ this.deselected = deselected;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/**
 * Original feature styles to reset to when features are no longer selected.
 * @type {Object<number, import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction>}
 */ const $3a11846c6d9add3f$var$originalFeatureStyles = {};
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'select', SelectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'select', Return>} SelectOnSignature
 */ /**
 * @classdesc
 * Interaction for selecting vector features. By default, selected features are
 * styled differently, so this interaction can be used for visual highlighting,
 * as well as selecting features for other actions, such as modification or
 * output. There are three ways of controlling which features are selected:
 * using the browser event as defined by the `condition` and optionally the
 * `toggle`, `add`/`remove`, and `multi` options; a `layers` filter; and a
 * further feature filter using the `filter` option.
 *
 * @fires SelectEvent
 * @api
 */ class $3a11846c6d9add3f$var$Select extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {SelectOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {SelectOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {SelectOnSignature<void>}
     */ this.un;
        options = options ? options : {};
        /**
     * @private
     */ this.boundAddFeature_ = this.addFeature_.bind(this);
        /**
     * @private
     */ this.boundRemoveFeature_ = this.removeFeature_.bind(this);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $kqI9g.singleClick);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.addCondition_ = options.addCondition ? options.addCondition : (0, $kqI9g.never);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.removeCondition_ = options.removeCondition ? options.removeCondition : (0, $kqI9g.never);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.toggleCondition_ = options.toggleCondition ? options.toggleCondition : (0, $kqI9g.shiftKeyOnly);
        /**
     * @private
     * @type {boolean}
     */ this.multi_ = options.multi ? options.multi : false;
        /**
     * @private
     * @type {FilterFunction}
     */ this.filter_ = options.filter ? options.filter : (0, $6wUzV.TRUE);
        /**
     * @private
     * @type {number}
     */ this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
        /**
     * @private
     * @type {import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction|null}
     */ this.style_ = options.style !== undefined ? options.style : $3a11846c6d9add3f$var$getDefaultStyleFunction();
        /**
     * @private
     * @type {Collection<Feature>}
     */ this.features_ = options.features || new (0, $cD8Qe.default)();
        /** @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} */ let layerFilter;
        if (options.layers) {
            if (typeof options.layers === "function") layerFilter = options.layers;
            else {
                const layers = options.layers;
                layerFilter = function(layer) {
                    return layers.includes(layer);
                };
            }
        } else layerFilter = (0, $6wUzV.TRUE);
        /**
     * @private
     * @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean}
     */ this.layerFilter_ = layerFilter;
        /**
     * An association between selected feature (key)
     * and layer (value)
     * @private
     * @type {Object<string, import("../layer/Layer.js").default>}
     */ this.featureLayerAssociation_ = {};
    }
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../layer/Layer.js").default} layer Layer.
   * @private
   */ addFeatureLayerAssociation_(feature, layer) {
        this.featureLayerAssociation_[(0, $9iPUS.getUid)(feature)] = layer;
    }
    /**
   * Get the selected features.
   * @return {Collection<Feature>} Features collection.
   * @api
   */ getFeatures() {
        return this.features_;
    }
    /**
   * Returns the Hit-detection tolerance.
   * @return {number} Hit tolerance in pixels.
   * @api
   */ getHitTolerance() {
        return this.hitTolerance_;
    }
    /**
   * Returns the associated {@link module:ol/layer/Vector~VectorLayer vector layer} of
   * a selected feature.
   * @param {import("../Feature.js").default} feature Feature
   * @return {import('../layer/Vector.js').default} Layer.
   * @api
   */ getLayer(feature) {
        return /** @type {import('../layer/Vector.js').default} */ this.featureLayerAssociation_[(0, $9iPUS.getUid)(feature)];
    }
    /**
   * Hit-detection tolerance. Pixels inside the radius around the given position
   * will be checked for features.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @api
   */ setHitTolerance(hitTolerance) {
        this.hitTolerance_ = hitTolerance;
    }
    /**
   * Remove the interaction from its current map, if any,  and attach it to a new
   * map, if any. Pass `null` to just remove the interaction from the current map.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        const currentMap = this.getMap();
        if (currentMap && this.style_) this.features_.forEach(this.restorePreviousStyle_.bind(this));
        super.setMap(map);
        if (map) {
            this.features_.addEventListener((0, $1TIYs.default).ADD, this.boundAddFeature_);
            this.features_.addEventListener((0, $1TIYs.default).REMOVE, this.boundRemoveFeature_);
            if (this.style_) this.features_.forEach(this.applySelectedStyle_.bind(this));
        } else {
            this.features_.removeEventListener((0, $1TIYs.default).ADD, this.boundAddFeature_);
            this.features_.removeEventListener((0, $1TIYs.default).REMOVE, this.boundRemoveFeature_);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ addFeature_(evt) {
        const feature = evt.element;
        if (this.style_) this.applySelectedStyle_(feature);
        if (!this.getLayer(feature)) {
            const layer = /** @type {VectorLayer} */ this.getMap().getAllLayers().find(function(layer) {
                if (layer instanceof (0, $bdrRp.default) && layer.getSource() && layer.getSource().hasFeature(feature)) return layer;
            });
            if (layer) this.addFeatureLayerAssociation_(feature, layer);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ removeFeature_(evt) {
        if (this.style_) this.restorePreviousStyle_(evt.element);
    }
    /**
   * @return {import("../style/Style.js").StyleLike|null} Select style.
   */ getStyle() {
        return this.style_;
    }
    /**
   * @param {Feature} feature Feature
   * @private
   */ applySelectedStyle_(feature) {
        const key = (0, $9iPUS.getUid)(feature);
        if (!(key in $3a11846c6d9add3f$var$originalFeatureStyles)) $3a11846c6d9add3f$var$originalFeatureStyles[key] = feature.getStyle();
        feature.setStyle(this.style_);
    }
    /**
   * @param {Feature} feature Feature
   * @private
   */ restorePreviousStyle_(feature) {
        const interactions = this.getMap().getInteractions().getArray();
        for(let i = interactions.length - 1; i >= 0; --i){
            const interaction = interactions[i];
            if (interaction !== this && interaction instanceof $3a11846c6d9add3f$var$Select && interaction.getStyle() && interaction.getFeatures().getArray().lastIndexOf(feature) !== -1) {
                feature.setStyle(interaction.getStyle());
                return;
            }
        }
        const key = (0, $9iPUS.getUid)(feature);
        feature.setStyle($3a11846c6d9add3f$var$originalFeatureStyles[key]);
        delete $3a11846c6d9add3f$var$originalFeatureStyles[key];
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeatureLayerAssociation_(feature) {
        delete this.featureLayerAssociation_[(0, $9iPUS.getUid)(feature)];
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may change the
   * selected state of features.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const add = this.addCondition_(mapBrowserEvent);
        const remove = this.removeCondition_(mapBrowserEvent);
        const toggle = this.toggleCondition_(mapBrowserEvent);
        const set = !add && !remove && !toggle;
        const map = mapBrowserEvent.map;
        const features = this.getFeatures();
        /**
     * @type {Array<Feature>}
     */ const deselected = [];
        /**
     * @type {Array<Feature>}
     */ const selected = [];
        if (set) {
            // Replace the currently selected feature(s) with the feature(s) at the
            // pixel, or clear the selected feature(s) if there is no feature at
            // the pixel.
            (0, $gn0g3.clear)(this.featureLayerAssociation_);
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, /**
         * @param {import("../Feature.js").FeatureLike} feature Feature.
         * @param {import("../layer/Layer.js").default} layer Layer.
         * @return {boolean|undefined} Continue to iterate over the features.
         */ (feature, layer)=>{
                if (!(feature instanceof (0, $dIG9p.default)) || !this.filter_(feature, layer)) return;
                this.addFeatureLayerAssociation_(feature, layer);
                selected.push(feature);
                return !this.multi_;
            }, {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_
            });
            for(let i = features.getLength() - 1; i >= 0; --i){
                const feature = features.item(i);
                const index = selected.indexOf(feature);
                if (index > -1) // feature is already selected
                selected.splice(index, 1);
                else {
                    features.remove(feature);
                    deselected.push(feature);
                }
            }
            if (selected.length !== 0) features.extend(selected);
        } else {
            // Modify the currently selected feature(s).
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, /**
         * @param {import("../Feature.js").FeatureLike} feature Feature.
         * @param {import("../layer/Layer.js").default} layer Layer.
         * @return {boolean|undefined} Continue to iterate over the features.
         */ (feature, layer)=>{
                if (!(feature instanceof (0, $dIG9p.default)) || !this.filter_(feature, layer)) return;
                if ((add || toggle) && !features.getArray().includes(feature)) {
                    this.addFeatureLayerAssociation_(feature, layer);
                    selected.push(feature);
                } else if ((remove || toggle) && features.getArray().includes(feature)) {
                    deselected.push(feature);
                    this.removeFeatureLayerAssociation_(feature);
                }
                return !this.multi_;
            }, {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_
            });
            for(let j = deselected.length - 1; j >= 0; --j)features.remove(deselected[j]);
            features.extend(selected);
        }
        if (selected.length > 0 || deselected.length > 0) this.dispatchEvent(new $3a11846c6d9add3f$export$1bcc516ebf36ffe2($3a11846c6d9add3f$var$SelectEventType.SELECT, selected, deselected, mapBrowserEvent));
        return true;
    }
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $3a11846c6d9add3f$var$getDefaultStyleFunction() {
    const styles = (0, $c3RIb.createEditingStyle)();
    (0, $fVVyM.extend)(styles["Polygon"], styles["LineString"]);
    (0, $fVVyM.extend)(styles["GeometryCollection"], styles["LineString"]);
    return function(feature) {
        if (!feature.getGeometry()) return null;
        return styles[feature.getGeometry().getType()];
    };
}
var $3a11846c6d9add3f$export$2e2bcd8739ae039 = $3a11846c6d9add3f$var$Select;

});

parcelRegister("1SJ4B", function(module, exports) {

$parcel$export(module.exports, "parseCoords", () => $15edcc33b5078d35$export$93ac7bc215bb896c);

var $dpRHA = parcelRequire("dpRHA");
function $15edcc33b5078d35$export$93ac7bc215bb896c(coordinates) {
    if (typeof coordinates === "string") {
        var parts = coordinates.split(",");
        coordinates = [
            parseFloat(parts[1]),
            parseFloat(parts[0])
        ];
    }
    return (0, $dpRHA.fromLonLat)(coordinates);
}

});

parcelRegister("lwfqC", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == "symbol" || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, "");
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
module.exports = $faa88de4f0afd1d0$var$debounce;

});


parcelRegister("3ZIPg", function(module, exports) {

$parcel$export(module.exports, "render", () => $2e89d7132dcc41cc$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $2e89d7132dcc41cc$var$_hoisted_1 = {
    class: "container py-5"
};
const $2e89d7132dcc41cc$var$_hoisted_2 = {
    "aria-label": "breadcrumb",
    class: "mb-4"
};
const $2e89d7132dcc41cc$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $2e89d7132dcc41cc$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $2e89d7132dcc41cc$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $2e89d7132dcc41cc$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $2e89d7132dcc41cc$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $2e89d7132dcc41cc$var$_hoisted_8 = {
    key: 0
};
const $2e89d7132dcc41cc$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $2e89d7132dcc41cc$var$_hoisted_10 = [
    $2e89d7132dcc41cc$var$_hoisted_9
];
const $2e89d7132dcc41cc$var$_hoisted_11 = {
    key: 1
};
const $2e89d7132dcc41cc$var$_hoisted_12 = {
    class: "row mb-4"
};
const $2e89d7132dcc41cc$var$_hoisted_13 = {
    class: "col-md-4"
};
const $2e89d7132dcc41cc$var$_hoisted_14 = {
    class: "form-label",
    for: "limits",
    required: ""
};
const $2e89d7132dcc41cc$var$_hoisted_15 = {
    value: ""
};
const $2e89d7132dcc41cc$var$_hoisted_16 = [
    "value"
];
const $2e89d7132dcc41cc$var$_hoisted_17 = {
    class: "col-md-4"
};
const $2e89d7132dcc41cc$var$_hoisted_18 = {
    class: "form-label",
    for: "startYear",
    required: ""
};
const $2e89d7132dcc41cc$var$_hoisted_19 = [
    "min"
];
const $2e89d7132dcc41cc$var$_hoisted_20 = {
    class: "col-md-4"
};
const $2e89d7132dcc41cc$var$_hoisted_21 = {
    class: "form-label",
    for: "endYear",
    required: ""
};
const $2e89d7132dcc41cc$var$_hoisted_22 = [
    "max"
];
const $2e89d7132dcc41cc$var$_hoisted_23 = {
    class: "mb-4"
};
const $2e89d7132dcc41cc$var$_hoisted_24 = {
    class: "mb-2"
};
const $2e89d7132dcc41cc$var$_hoisted_25 = {
    class: "row"
};
const $2e89d7132dcc41cc$var$_hoisted_26 = {
    class: "col-md-2"
};
const $2e89d7132dcc41cc$var$_hoisted_27 = {
    class: "input-group mb-3"
};
const $2e89d7132dcc41cc$var$_hoisted_28 = {
    class: "input-group-text"
};
const $2e89d7132dcc41cc$var$_hoisted_29 = [
    "onUpdate:modelValue",
    "id"
];
const $2e89d7132dcc41cc$var$_hoisted_30 = [
    "for"
];
const $2e89d7132dcc41cc$var$_hoisted_31 = {
    class: "input-group mb-3"
};
const $2e89d7132dcc41cc$var$_hoisted_32 = {
    class: "input-group-text"
};
const $2e89d7132dcc41cc$var$_hoisted_33 = [
    "disabled",
    "onUpdate:modelValue",
    "id"
];
const $2e89d7132dcc41cc$var$_hoisted_34 = [
    "for"
];
const $2e89d7132dcc41cc$var$_hoisted_35 = {
    class: "button-group"
};
const $2e89d7132dcc41cc$var$_hoisted_36 = [
    "disabled"
];
const $2e89d7132dcc41cc$var$_hoisted_37 = [
    "disabled"
];
const $2e89d7132dcc41cc$var$_hoisted_38 = {
    key: 0,
    class: "mb-3 overflow-auto"
};
const $2e89d7132dcc41cc$var$_hoisted_39 = {
    class: "nav nav-tabs",
    id: "nav-tab",
    role: "tablist"
};
const $2e89d7132dcc41cc$var$_hoisted_40 = {
    class: "nav-link active",
    id: "map-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#map",
    type: "button",
    role: "tab",
    "aria-controls": "map",
    "aria-selected": "true"
};
const $2e89d7132dcc41cc$var$_hoisted_41 = {
    class: "tab-content",
    id: "nav-tabContent"
};
const $2e89d7132dcc41cc$var$_hoisted_42 = {
    class: "tab-pane fade show active",
    id: "map",
    role: "tabpanel",
    "aria-labelledby": "map-tab"
};
const $2e89d7132dcc41cc$var$_hoisted_43 = {
    key: 0,
    style: {
        "position": "absolute",
        "top": "50%",
        "left": "50%",
        "transform": "translate(-50%, -50%)",
        "padding": "10px"
    }
};
const $2e89d7132dcc41cc$var$_hoisted_44 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
    class: "spinner-border",
    role: "status",
    "aria-hidden": "true"
}, null, -1);
const $2e89d7132dcc41cc$var$_hoisted_45 = [
    $2e89d7132dcc41cc$var$_hoisted_44
];
const $2e89d7132dcc41cc$var$_hoisted_46 = {
    ref: "map",
    class: "map"
};
const $2e89d7132dcc41cc$var$_hoisted_47 = {
    style: {
        "display": "none"
    }
};
const $2e89d7132dcc41cc$var$_hoisted_48 = {
    id: "popup",
    class: "ol-popup",
    ref: "popup"
};
const $2e89d7132dcc41cc$var$_hoisted_49 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "btn-group btn-group-toggle",
    "data-toggle": "buttons",
    style: {
        "width": "100%"
    }
}, null, -1);
const $2e89d7132dcc41cc$var$_hoisted_50 = {
    href: "#",
    id: "popup-closer",
    class: "ol-popup-closer",
    ref: "popupCloser"
};
const $2e89d7132dcc41cc$var$_hoisted_51 = {
    id: "popup-content"
};
const $2e89d7132dcc41cc$var$_hoisted_52 = {
    class: "display compact responsive nowrap",
    width: "100%",
    ref: "popUpDataTable"
};
const $2e89d7132dcc41cc$var$_hoisted_53 = {
    class: "tab-pane fade",
    id: "data",
    role: "tabpanel",
    "aria-labelledby": "data-tab"
};
const $2e89d7132dcc41cc$var$_hoisted_54 = {
    class: "d-grid gap-2 d-md-flex mb-4"
};
function $2e89d7132dcc41cc$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_DataTable = (0, $TusQn.resolveComponent)("DataTable");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2e89d7132dcc41cc$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("activityPlan")), 1),
        (0, $TusQn.createElementVNode)("nav", $2e89d7132dcc41cc$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $2e89d7132dcc41cc$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $2e89d7132dcc41cc$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: `/modelings`
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $2e89d7132dcc41cc$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $2e89d7132dcc41cc$var$_hoisted_6, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: `/modeling/${this.$route.params.id}/modelingresult/${this.$route.params.modelingResultId}`
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("modelingResult")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $2e89d7132dcc41cc$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("activityPlan")), 1)
            ])
        ]),
        $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2e89d7132dcc41cc$var$_hoisted_8, $2e89d7132dcc41cc$var$_hoisted_10)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2e89d7132dcc41cc$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_13, [
                    (0, $TusQn.createElementVNode)("label", $2e89d7132dcc41cc$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("limits")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                        id: "limits",
                        class: "form-select",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.limit = $event)
                    }, [
                        (0, $TusQn.createElementVNode)("option", $2e89d7132dcc41cc$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                        $data.limitList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 0
                        }, (0, $TusQn.renderList)($data.limitList, (limit, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                key: i,
                                value: limit.id
                            }, (0, $8POXm.toDisplayString)(limit.name), 9, $2e89d7132dcc41cc$var$_hoisted_16);
                        }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                    ], 512), [
                        [
                            (0, $eeJ70.vModelSelect),
                            $data.data.limit,
                            void 0,
                            {
                                number: true
                            }
                        ]
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_17, [
                    (0, $TusQn.createElementVNode)("label", $2e89d7132dcc41cc$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("startYear")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.selectionStartYear = $event),
                        min: $data.data.selectionStartYear,
                        type: "number",
                        class: "form-control",
                        id: "startYear"
                    }, null, 8, $2e89d7132dcc41cc$var$_hoisted_19), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.selectionStartYear,
                            void 0,
                            {
                                number: true
                            }
                        ]
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_20, [
                    (0, $TusQn.createElementVNode)("label", $2e89d7132dcc41cc$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("endYear")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.selectionEndYear = $event),
                        max: $data.data.selectionEndYear,
                        type: "number",
                        class: "form-control",
                        id: "endYear"
                    }, null, 8, $2e89d7132dcc41cc$var$_hoisted_22), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.selectionEndYear,
                            void 0,
                            {
                                number: true
                            }
                        ]
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_23, [
                (0, $TusQn.createElementVNode)("h4", $2e89d7132dcc41cc$var$_hoisted_24, (0, $8POXm.toDisplayString)(_ctx.$t("assetType")), 1),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.assetTypeList, (assetType, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: i,
                        class: "mb-3 border-bottom"
                    }, [
                        (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_25, [
                            (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_26, [
                                (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_27, [
                                    (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_28, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            class: "form-check-input mt-0",
                                            type: "checkbox",
                                            "onUpdate:modelValue": ($event)=>assetType.checked = $event,
                                            id: "forecast_" + i
                                        }, null, 8, $2e89d7132dcc41cc$var$_hoisted_29), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                assetType.checked
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("label", {
                                        type: "text",
                                        for: "forecast_" + i,
                                        class: "form-control"
                                    }, [
                                        (0, $TusQn.createElementVNode)("b", null, (0, $8POXm.toDisplayString)(assetType.name), 1)
                                    ], 8, $2e89d7132dcc41cc$var$_hoisted_30)
                                ])
                            ]),
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(assetType.activities, (activity, i)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                    key: i,
                                    class: "mb-3 col-md-3"
                                }, [
                                    (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_31, [
                                        (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_32, [
                                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                class: "form-check-input mt-0",
                                                type: "checkbox",
                                                disabled: !assetType.checked,
                                                "onUpdate:modelValue": ($event)=>activity.checked = $event,
                                                id: "activity_" + activity.id
                                            }, null, 8, $2e89d7132dcc41cc$var$_hoisted_33), [
                                                [
                                                    (0, $eeJ70.vModelCheckbox),
                                                    activity.checked
                                                ]
                                            ])
                                        ]),
                                        (0, $TusQn.createElementVNode)("label", {
                                            type: "text",
                                            for: "activity_" + activity.id,
                                            class: "form-control"
                                        }, (0, $8POXm.toDisplayString)(activity.name), 9, $2e89d7132dcc41cc$var$_hoisted_34)
                                    ])
                                ]);
                            }), 128))
                        ])
                    ]);
                }), 128))
            ]),
            (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_35, [
                (0, $TusQn.createElementVNode)("button", {
                    disabled: !$data.data.limit,
                    onClick: _cache[3] || (_cache[3] = ($event)=>$options.exportActivityPlan()),
                    class: "btn btn-sm btn-primary mb-4"
                }, "Export csv", 8, $2e89d7132dcc41cc$var$_hoisted_36),
                (0, $TusQn.createElementVNode)("button", {
                    disabled: !$data.data.limit,
                    onClick: _cache[4] || (_cache[4] = ($event)=>$options.exportShp()),
                    class: "btn btn-sm btn-primary mb-4 ms-2"
                }, "Export shp", 8, $2e89d7132dcc41cc$var$_hoisted_37)
            ]),
            $data.renderMap && $data.mapCenter ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2e89d7132dcc41cc$var$_hoisted_38, [
                (0, $TusQn.createElementVNode)("nav", null, [
                    (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_39, [
                        (0, $TusQn.createElementVNode)("button", $2e89d7132dcc41cc$var$_hoisted_40, (0, $8POXm.toDisplayString)(_ctx.$t("map")), 1),
                        (0, $TusQn.createElementVNode)("button", {
                            class: "nav-link",
                            onClick: _cache[5] || (_cache[5] = ($event)=>$options.adjustDt()),
                            id: "data-tab",
                            "data-bs-toggle": "tab",
                            "data-bs-target": "#data",
                            type: "button",
                            role: "tab",
                            "aria-controls": "data",
                            "aria-selected": "false"
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("data")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_41, [
                    (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_42, [
                        _ctx.mapLoading ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2e89d7132dcc41cc$var$_hoisted_43, $2e89d7132dcc41cc$var$_hoisted_45)) : (0, $TusQn.createCommentVNode)("", true),
                        (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_46, null, 512),
                        (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_47, [
                            (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_48, [
                                $2e89d7132dcc41cc$var$_hoisted_49,
                                (0, $TusQn.createElementVNode)("a", $2e89d7132dcc41cc$var$_hoisted_50, null, 512),
                                (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_51, [
                                    (0, $TusQn.createElementVNode)("table", $2e89d7132dcc41cc$var$_hoisted_52, null, 512)
                                ])
                            ], 512)
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_53, [
                        (0, $TusQn.createVNode)(_component_DataTable, {
                            ref: "dt",
                            pageLength: 5,
                            lengthMenu: [
                                5,
                                25,
                                50,
                                75,
                                100
                            ],
                            columns: $data.tableColumns,
                            options: $data.tableOptions,
                            data: $data.tableData,
                            class: "display"
                        }, null, 8, [
                            "columns",
                            "options",
                            "data"
                        ])
                    ])
                ])
            ])) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("div", $2e89d7132dcc41cc$var$_hoisted_54, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    onClick: _cache[6] || (_cache[6] = ($event)=>_ctx.$router.push({
                            path: `/modeling/${this.$route.params.id}/modelingresult/${this.$route.params.modelingResultId}`
                        }))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
            ])
        ]))
    ]);
}

});

parcelRegister("d0uZX", function(module, exports) {

$parcel$export(module.exports, "default", () => $978352110925bab6$export$2e2bcd8739ae039);
let $978352110925bab6$var$NOOP = ()=>{};
var $978352110925bab6$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("j13HV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $dd80fc883d419c85$export$2e2bcd8739ae039);

var $gxt0C = parcelRequire("gxt0C");

var $l6otV = parcelRequire("l6otV");

var $gOjKo = parcelRequire("gOjKo");

var $1M4Zs = parcelRequire("1M4Zs");
var $dd80fc883d419c85$export$2e2bcd8739ae039 = {
    name: "resultCharts",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var result = await (0, $gxt0C.default).sumarizedCostGraph(this.$route.params.id, this.$route.params.modelingResultId);
            this.groups = result.groups;
            this.packages = result.packages;
            this.chartConfigs = result.limits.map((limit)=>({
                    limitId: limit.limitId,
                    limitName: limit.limitName,
                    charts: limit.charts,
                    selectedGroupId: null,
                    selectedPackageId: null
                }));
            this.pending = false;
        },
        colorizeSeries (series) {
            return series.map((s, i)=>({
                    ...s,
                    color: this.generateColors(series.length)[i] // HSL barva pro každou sérii
                }));
        },
        getSelectedChart (cfg) {
            var selectedChart = cfg.selectedGroupId == null ? cfg.charts.find((c)=>c.groupId == null) : cfg.charts.find((c)=>c.groupId === cfg.selectedGroupId);
            if (!selectedChart) return null;
            if (cfg.selectedPackageId == null) return selectedChart;
            const filtered = {
                ...selectedChart,
                series: (selectedChart.series || []).filter((s)=>Number(s.packageId) === Number(cfg.selectedPackageId))
            };
            return filtered.series.length ? filtered : null;
        },
        makeOptions (chart, limitName) {
            const colors = this.generateColors(chart.series.length);
            return {
                chart: {
                    type: "bar",
                    height: 500
                },
                title: {
                    text: `${this.$t("summarizedCostCharts")} - ${limitName}`
                },
                xaxis: {
                    categories: chart.years,
                    title: {
                        text: this.$t("year")
                    }
                },
                yaxis: {
                    labels: {
                        formatter: (v)=>(0, $1M4Zs.formatAmount)(v, chart.currency)
                    },
                    title: {
                        text: `${this.$t("totalPackageCost")} ${chart.currency}`
                    }
                },
                tooltip: {
                    y: {
                        formatter: (v)=>(0, $1M4Zs.formatAmount)(v, chart.currency)
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "50%",
                        endingShape: "rounded"
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    position: "top"
                },
                colors: colors
            };
        },
        generateColors (count) {
            return Array.from({
                length: count
            }, (_, i)=>{
                const hue = Math.round(360 * i / count);
                return `hsl(${hue}, 70%, 50%)`;
            });
        }
    },
    data () {
        return {
            chartConfigs: [],
            assetTypeList: [],
            groups: [],
            packages: [],
            pending: true,
            isUserAdmin: false,
            modelingName: ""
        };
    }
};

});

parcelRegister("5ZWze", function(module, exports) {

$parcel$export(module.exports, "render", () => $45e01482331cc9c7$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $45e01482331cc9c7$var$_hoisted_1 = {
    class: "container py-5"
};
const $45e01482331cc9c7$var$_hoisted_2 = {
    "aria-label": "breadcrumb",
    class: "mb-4"
};
const $45e01482331cc9c7$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $45e01482331cc9c7$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $45e01482331cc9c7$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $45e01482331cc9c7$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $45e01482331cc9c7$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $45e01482331cc9c7$var$_hoisted_8 = {
    key: 0
};
const $45e01482331cc9c7$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $45e01482331cc9c7$var$_hoisted_10 = [
    $45e01482331cc9c7$var$_hoisted_9
];
const $45e01482331cc9c7$var$_hoisted_11 = {
    key: 1
};
const $45e01482331cc9c7$var$_hoisted_12 = {
    class: "col-md-8"
};
const $45e01482331cc9c7$var$_hoisted_13 = {
    class: "mb-3"
};
const $45e01482331cc9c7$var$_hoisted_14 = {
    class: "col-md-4"
};
const $45e01482331cc9c7$var$_hoisted_15 = [
    "onUpdate:modelValue"
];
const $45e01482331cc9c7$var$_hoisted_16 = {
    value: null
};
const $45e01482331cc9c7$var$_hoisted_17 = [
    "value"
];
const $45e01482331cc9c7$var$_hoisted_18 = [
    "onUpdate:modelValue"
];
const $45e01482331cc9c7$var$_hoisted_19 = {
    value: null
};
const $45e01482331cc9c7$var$_hoisted_20 = [
    "value"
];
const $45e01482331cc9c7$var$_hoisted_21 = {
    class: "d-grid gap-2 d-md-flex mb-4"
};
function $45e01482331cc9c7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_apexchart = (0, $TusQn.resolveComponent)("apexchart");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $45e01482331cc9c7$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("sumarizedCostCharts")), 1),
        (0, $TusQn.createElementVNode)("nav", $45e01482331cc9c7$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $45e01482331cc9c7$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $45e01482331cc9c7$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $45e01482331cc9c7$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $45e01482331cc9c7$var$_hoisted_6, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: `/modeling/${this.$route.params.id}/modelingresult/${this.$route.params.modelingResultId}`
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("modelingResult")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $45e01482331cc9c7$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("sumarizedCostCharts")), 1)
            ])
        ]),
        $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $45e01482331cc9c7$var$_hoisted_8, $45e01482331cc9c7$var$_hoisted_10)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $45e01482331cc9c7$var$_hoisted_11, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.chartConfigs, (cfg)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "row mb-5",
                    key: cfg.limitId
                }, [
                    (0, $TusQn.createElementVNode)("div", $45e01482331cc9c7$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("h5", $45e01482331cc9c7$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("limit")) + ": " + (0, $8POXm.toDisplayString)(cfg.limitName), 1),
                        $options.getSelectedChart(cfg) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_apexchart, {
                            key: 0,
                            type: "bar",
                            width: "800",
                            height: 500,
                            options: $options.makeOptions($options.getSelectedChart(cfg), cfg.limitName),
                            series: $options.colorizeSeries($options.getSelectedChart(cfg).series),
                            class: "d-flex justify-content-center"
                        }, null, 8, [
                            "options",
                            "series"
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $45e01482331cc9c7$var$_hoisted_14, [
                        (0, $TusQn.createElementVNode)("label", null, (0, $8POXm.toDisplayString)(_ctx.$t("area")), 1),
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                            class: "form-select mb-4",
                            "onUpdate:modelValue": ($event)=>cfg.selectedGroupId = $event
                        }, [
                            (0, $TusQn.createElementVNode)("option", $45e01482331cc9c7$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("allAreas")), 1),
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.groups, (g)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                    key: g.value,
                                    value: Number(g.value)
                                }, (0, $8POXm.toDisplayString)(g.name), 9, $45e01482331cc9c7$var$_hoisted_17);
                            }), 128))
                        ], 8, $45e01482331cc9c7$var$_hoisted_15), [
                            [
                                (0, $eeJ70.vModelSelect),
                                cfg.selectedGroupId
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("label", null, (0, $8POXm.toDisplayString)(_ctx.$t("packages")), 1),
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                            class: "form-select",
                            "onUpdate:modelValue": ($event)=>cfg.selectedPackageId = $event
                        }, [
                            (0, $TusQn.createElementVNode)("option", $45e01482331cc9c7$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("allPackages")), 1),
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.packages, (p)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                    key: p.value,
                                    value: Number(p.value)
                                }, (0, $8POXm.toDisplayString)(p.name), 9, $45e01482331cc9c7$var$_hoisted_20);
                            }), 128))
                        ], 8, $45e01482331cc9c7$var$_hoisted_18), [
                            [
                                (0, $eeJ70.vModelSelect),
                                cfg.selectedPackageId
                            ]
                        ])
                    ])
                ]);
            }), 128)),
            (0, $TusQn.createElementVNode)("div", $45e01482331cc9c7$var$_hoisted_21, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$router.push({
                            path: `/modeling/${this.$route.params.id}/modelingresult/${this.$route.params.modelingResultId}`
                        }))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
            ])
        ]))
    ]);
}

});

parcelRegister("4MMvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $37c145c6495073d8$export$2e2bcd8739ae039);
let $37c145c6495073d8$var$NOOP = ()=>{};
var $37c145c6495073d8$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("jjztH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e0fb4fdb9cc03644$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $ch9iu = parcelRequire("ch9iu");

var $l6otV = parcelRequire("l6otV");

var $fihz0 = parcelRequire("fihz0");

var $bfIrw = parcelRequire("bfIrw");

var $4mWlF = parcelRequire("4mWlF");

var $9jDAx = parcelRequire("9jDAx");

var $5DwXE = parcelRequire("5DwXE");

var $9DiKA = parcelRequire("9DiKA");

var $haRZ2 = parcelRequire("haRZ2");

var $bdrRp = parcelRequire("bdrRp");

var $bnthu = parcelRequire("bnthu");

var $ndRlY = parcelRequire("ndRlY");

var $4Z60n = parcelRequire("4Z60n");

var $1SJ4B = parcelRequire("1SJ4B");



var $9OqbI = parcelRequire("9OqbI");

var $cVZH2 = parcelRequire("cVZH2");

var $gOjKo = parcelRequire("gOjKo");
(0, $fihz0.default).use((0, $bfIrw.default));
const $e0fb4fdb9cc03644$var$__default__ = {
    name: "datasetDetail",
    components: {
        DatasetDeleteModal: $9OqbI.default,
        DatasetXlsxUploadDialog: $cVZH2.default,
        DataTable: $fihz0.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        datasetZipDownload () {
            var request = (0, $ch9iu.default).datasetZipDownload(this.$route.params.id, this.$route.params.datasetId);
            window.open(request.url);
        },
        showDeleteDataset () {
            this.datasetToDeleteId = this.data.id;
            this.showDatasetDeleteModal = true;
        },
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            this.data = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, this.$route.params.datasetId);
            const modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            if (this.data.content) {
                this.content = JSON.parse(this.data.content);
                this.tableColumns = [];
                if (this.content.headers) this.tableColumns = this.content.headers.map((h)=>({
                        data: h.name,
                        title: this.$t(h.alias),
                        defaultContent: "",
                        width: 100
                    }));
            }
            this.sections = await (0, $ch9iu.default).datasetSections(this.$route.params.id, this.$route.params.datasetId);
            // if sections contain type - we render map
            this.renderMap = this.sections[0]?.["type"] != null;
            this.tableData = this.sections.map((s)=>s["properties"]);
            this.pending = false;
            if (this.renderMap && this.content.center) {
                await (0, $TusQn.nextTick)();
                this.adjustDt();
                this.initMap();
            }
        },
        async onSubmit () {
            try {
                if (this.data.name.length > 0) {
                    this.data.content = JSON.stringify(this.content);
                    await (0, $ch9iu.default).datasetUpdate(this.$route.params.id, this.data);
                    this.showSuccess();
                } else this.showEmptyNameError();
            } catch (error) {
                console.error("Error updating data:", error);
            }
        },
        async initMap () {
            var self = this;
            self.mapLoading = true;
            if (!self.$refs.map) return;
            // Release previous map
            if (self.map) self.map.setTarget(undefined);
            if (self.popUpDataTable) self.popUpDataTable.destroy(true);
            const layers = [
                new (0, $4mWlF.default)({
                    source: new (0, $9jDAx.default)()
                })
            ];
            const overlay = new (0, $haRZ2.default)({
                element: self.$refs.popup,
                autoPan: {
                    animation: {
                        duration: 250
                    }
                }
            });
            if (self.$refs["popupCloser"]) self.$refs["popupCloser"].onclick = ()=>{
                overlay.setPosition(undefined);
                self.$refs["popupCloser"].blur();
                return false;
            };
            var projection = 'GEOGCS["WGS 84", DATUM["World Geodetic System 1984", SPHEROID["WGS 84", 6378137.0, 298.257223563, AUTHORITY["EPSG","7030"]], AUTHORITY["EPSG","6326"]], PRIMEM["Greenwich", 0.0, AUTHORITY["EPSG","8901"]], UNIT["degree", 0.017453292519943295], AXIS["Geodetic longitude", EAST], AXIS["Geodetic latitude", NORTH], AUTHORITY["EPSG","4326"]]';
            const features = (0, $ndRlY.getFeaturesFromSections)(self.sections, projection);
            if (features.length > 0) {
                const vector = new (0, $bdrRp.default)({
                    source: new (0, $bnthu.default)({
                        features: features
                    }),
                    style: (feature, resolution)=>(0, $ndRlY.defaultLineStyleFunction)(feature, resolution, "#000000", 4)
                });
                layers.push(vector);
            }
            const view = new (0, $9DiKA.default)({
                center: (0, $1SJ4B.parseCoords)(this.content.center),
                zoom: 12
            });
            var map = new (0, $5DwXE.default)({
                target: self.$refs.map,
                layers: layers,
                overlays: [
                    overlay
                ],
                view: view
            });
            const select = new (0, $4Z60n.default)({
                style: function(feature, resolution) {
                    return (0, $ndRlY.defaultLineStyleFunction)(feature, resolution, "#A020F0", 4);
                }
            });
            select.on("select", (evt)=>{
                if (evt.selected && evt.selected.length > 0) {
                    self.selectedFeatures = evt.target.getFeatures().getArray();
                    self.selectedFeatureIndex = self.selectedFeatures.length;
                    self.setPopupTableData();
                    overlay.setPosition(evt.mapBrowserEvent.coordinate);
                } else {
                    self.selectedFeatures = [];
                    self.selectedFeatureIndex = 0;
                    overlay.setPosition(undefined);
                    self.$refs.popupCloser.blur();
                }
            });
            map.addInteraction(select);
            self.mapLoading = false;
        },
        destroyMap () {
            if (this.map) this.map.setTarget(undefined);
        },
        adjustDt () {
            const api = this.$refs.dt?.dt;
            if (!api) return;
            api.columns.adjust();
        },
        setPopupTableData () {
            var self = this;
            new (0, $bfIrw.default)(self.$refs["popUpDataTable"]).destroy();
            var currentSelectedFeature = self.selectedFeatures[self.selectedFeatureIndex - 1];
            var currentSelectedFeatureProperties = currentSelectedFeature.get("properties");
            var tmpDataTable = [];
            for(var property in currentSelectedFeatureProperties)tmpDataTable.push({
                name: property,
                value: currentSelectedFeatureProperties[property]
            });
            self.popUpDataTable = new (0, $bfIrw.default)(self.$refs["popUpDataTable"], {
                scrollY: "300px",
                scrollCollapse: true,
                paging: false,
                searching: false,
                info: false,
                columns: [
                    {
                        "data": "name",
                        "title": this.$t("attribute")
                    },
                    {
                        "data": "value",
                        "title": this.$t("value")
                    }
                ]
            }).clear().rows.add(tmpDataTable).draw();
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "datasetUpdateSucessfull",
            type: "success"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            map: null,
            popUpDataTable: null,
            tableColumns: [],
            tableData: [],
            tableOptions: {
                fixedHeader: {
                    header: false,
                    footer: true
                },
                scrollX: true,
                scrollY: 350,
                order: [
                    0,
                    "desc"
                ]
            },
            data: {
                name: "",
                id: 0,
                description: ""
            },
            modelingName: null,
            pending: true,
            mapLoading: true,
            selectedFeatures: [],
            selectedFeatureIndex: 0,
            sections: [],
            select: null,
            datasetToDeleteId: 0,
            showDatasetDeleteModal: false,
            showImportXlsxModal: false,
            isUserAdmin: false,
            content: {},
            renderMap: false
        };
    }
};
var $e0fb4fdb9cc03644$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.assign($e0fb4fdb9cc03644$var$__default__, {
    setup (__props, { expose: __expose }) {
        __expose();
        const map = (0, $01W3b.ref)(null);
        const popup = (0, $01W3b.ref)(null);
        const popUpDataTable = (0, $01W3b.ref)(null);
        const popupCloser = (0, $01W3b.ref)(null);
        const __returned__ = {
            map: map,
            popup: popup,
            popUpDataTable: popUpDataTable,
            popupCloser: popupCloser,
            ref: $01W3b.ref,
            nextTick: $TusQn.nextTick,
            get DatasetApi () {
                return 0, $ch9iu.default;
            },
            get ModelingApi () {
                return 0, $l6otV.default;
            },
            get DataTable () {
                return 0, $fihz0.default;
            },
            get DataTablesLib () {
                return 0, $bfIrw.default;
            },
            get TileLayer () {
                return 0, $4mWlF.default;
            },
            get OSM () {
                return 0, $9jDAx.default;
            },
            get Map () {
                return 0, $5DwXE.default;
            },
            get View () {
                return 0, $9DiKA.default;
            },
            get Overlay () {
                return 0, $haRZ2.default;
            },
            get VectorLayer () {
                return 0, $bdrRp.default;
            },
            get VectorSource () {
                return 0, $bnthu.default;
            },
            get getFeaturesFromSections () {
                return 0, $ndRlY.getFeaturesFromSections;
            },
            get defaultLineStyleFunction () {
                return 0, $ndRlY.defaultLineStyleFunction;
            },
            get Select () {
                return 0, $4Z60n.default;
            },
            get parseCoords () {
                return 0, $1SJ4B.parseCoords;
            },
            DatasetDeleteModal: $9OqbI.default,
            DatasetXlsxUploadDialog: $cVZH2.default,
            get CheckIfUserIsEditor () {
                return 0, $gOjKo.CheckIfUserIsEditor;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("9OqbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $724d18f146bb5f7a$export$2e2bcd8739ae039);
let $724d18f146bb5f7a$var$script;



let $724d18f146bb5f7a$var$initialize = ()=>{
    $724d18f146bb5f7a$var$script = (parcelRequire("iBYYR"));
    if ($724d18f146bb5f7a$var$script.__esModule) $724d18f146bb5f7a$var$script = $724d18f146bb5f7a$var$script.default;
    $724d18f146bb5f7a$var$script.render = (parcelRequire("359PW")).render;
    (parcelRequire("eekNQ")).default($724d18f146bb5f7a$var$script);
    $724d18f146bb5f7a$var$script.__scopeId = "data-v-5d31a1";
    $724d18f146bb5f7a$var$script.__file = "DatasetDeleteModal.vue";
};
$724d18f146bb5f7a$var$initialize();
var $724d18f146bb5f7a$export$2e2bcd8739ae039 = $724d18f146bb5f7a$var$script;

});
parcelRegister("iBYYR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d8cafc3293e7001c$export$2e2bcd8739ae039);

var $eHCxc = parcelRequire("eHCxc");

var $ch9iu = parcelRequire("ch9iu");
var $d8cafc3293e7001c$export$2e2bcd8739ae039 = {
    name: "datasetDeleteModal",
    props: {
        datasetId: {
            type: Number,
            required: true
        },
        modelingId: {
            type: Number,
            required: true
        }
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            var assetTypes = await (0, $eHCxc.default).assetTypeList(this.modelingId);
            this.canDeleteDataset = assetTypes.filter((a)=>a.datasetId == this.datasetId).length == 0;
        },
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteDataset () {
            await (0, $ch9iu.default).datasetDelete(this.modelingId, this.datasetId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    },
    data () {
        return {
            canDeleteDataset: false
        };
    }
};

});

parcelRegister("359PW", function(module, exports) {

$parcel$export(module.exports, "render", () => $23e9781bee75b7cf$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $23e9781bee75b7cf$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $23e9781bee75b7cf$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $23e9781bee75b7cf$var$_hoisted_3 = {
    class: "modal-content"
};
const $23e9781bee75b7cf$var$_hoisted_4 = {
    class: "modal-header"
};
const $23e9781bee75b7cf$var$_hoisted_5 = {
    class: "modal-title"
};
const $23e9781bee75b7cf$var$_hoisted_6 = {
    class: "modal-body"
};
const $23e9781bee75b7cf$var$_hoisted_7 = {
    key: 0,
    style: {
        "margin-bottom": "0"
    }
};
const $23e9781bee75b7cf$var$_hoisted_8 = {
    key: 1
};
const $23e9781bee75b7cf$var$_hoisted_9 = {
    class: "modal-footer"
};
const $23e9781bee75b7cf$var$_hoisted_10 = [
    "disabled"
];
function $23e9781bee75b7cf$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $23e9781bee75b7cf$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $23e9781bee75b7cf$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $23e9781bee75b7cf$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $23e9781bee75b7cf$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $23e9781bee75b7cf$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("datasetDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $23e9781bee75b7cf$var$_hoisted_6, [
                                $data.canDeleteDataset ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $23e9781bee75b7cf$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisDataset")), 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $23e9781bee75b7cf$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("cannotDeleteDataset")), 1))
                            ]),
                            (0, $TusQn.createElementVNode)("div", $23e9781bee75b7cf$var$_hoisted_9, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteDataset && $options.deleteDataset(...args)),
                                    disabled: !$data.canDeleteDataset
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 9, $23e9781bee75b7cf$var$_hoisted_10)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("eekNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5c2828b7a28edc3$export$2e2bcd8739ae039);
let $a5c2828b7a28edc3$var$NOOP = ()=>{};
var $a5c2828b7a28edc3$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("cVZH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $96aaa9e60a9fcf24$export$2e2bcd8739ae039);
let $96aaa9e60a9fcf24$var$script;



let $96aaa9e60a9fcf24$var$initialize = ()=>{
    $96aaa9e60a9fcf24$var$script = (parcelRequire("gzL2p"));
    if ($96aaa9e60a9fcf24$var$script.__esModule) $96aaa9e60a9fcf24$var$script = $96aaa9e60a9fcf24$var$script.default;
    $96aaa9e60a9fcf24$var$script.render = (parcelRequire("k96bj")).render;
    (parcelRequire("cjruV")).default($96aaa9e60a9fcf24$var$script);
    $96aaa9e60a9fcf24$var$script.__scopeId = "data-v-7b81a9";
    $96aaa9e60a9fcf24$var$script.__file = "DatasetXlsxUploadDialog.vue";
};
$96aaa9e60a9fcf24$var$initialize();
var $96aaa9e60a9fcf24$export$2e2bcd8739ae039 = $96aaa9e60a9fcf24$var$script;

});
parcelRegister("gzL2p", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c11466fc5f96335a$export$2e2bcd8739ae039);

var $ch9iu = parcelRequire("ch9iu");
var $c11466fc5f96335a$export$2e2bcd8739ae039 = {
    name: "DatasetXlsxUploadDialog",
    props: {
        datasetId: {
            type: Number,
            required: true
        },
        modelingId: {
            type: Number,
            required: true
        }
    },
    methods: {
        onFileChanged (event) {
            const target = event.target;
            if (target && target.files) this.files = target.files;
        },
        close () {
            this.files = [];
            this.$emit("close");
        },
        formatNames (files) {
            return files.length === 1 ? files[0].name : `${files.length} files selected`;
        },
        async uploadFiles () {
            const excelType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const allowedExtensions = [
                "xlsx",
                "shp",
                "dbf",
                "shx",
                "cpg",
                "prj",
                "qmd"
            ];
            try {
                var result = {};
                this.syncLoading = "";
                if (this.files.length > 0) {
                    var file = this.files[0];
                    const extension = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length);
                    if (allowedExtensions.includes(extension)) {
                        if (file.type == excelType) result = await (0, $ch9iu.default).datasetXlsxUpload(this.modelingId, this.datasetId, this.files);
                        else result = await (0, $ch9iu.default).datasetUpload(this.modelingId, this.datasetId, this.files);
                        if (result.status == 1 || result.status == 2) {
                            this.showError({
                                title: "Error!",
                                message: result.message,
                                type: "error"
                            });
                            this.close();
                        } else {
                            this.close();
                            this.showSuccess();
                            this.$emit("reload");
                        }
                    } else this.showErrorWrongFileType();
                } else this.showError();
                this.buttonLoading = "hidden";
            } catch (e) {
                this.showError({
                    title: "Error!",
                    message: e.message,
                    type: "error"
                });
                this.close();
            }
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "filesUploaded",
            type: "success"
        },
        showError: {
            title: "error",
            message: "errorWhileUploadingFiles",
            type: "error"
        },
        showErrorWrongFileType: {
            title: "error",
            message: "errorWhileUploadingFilesWrongType",
            type: "error"
        }
    },
    data () {
        return {
            hiddenAlert: "hidden",
            buttonLoading: "btn btn-primary",
            syncLoading: "hidden",
            files: []
        };
    }
};

});

parcelRegister("k96bj", function(module, exports) {

$parcel$export(module.exports, "render", () => $eaa9716789fe0d5f$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $eaa9716789fe0d5f$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
};
const $eaa9716789fe0d5f$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered modal-lg",
    role: "document"
};
const $eaa9716789fe0d5f$var$_hoisted_3 = {
    class: "modal-content"
};
const $eaa9716789fe0d5f$var$_hoisted_4 = {
    class: "modal-footer"
};
const $eaa9716789fe0d5f$var$_hoisted_5 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
    class: "spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
}, null, -1);
function $eaa9716789fe0d5f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $eaa9716789fe0d5f$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $eaa9716789fe0d5f$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $eaa9716789fe0d5f$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("input", {
                                type: "file",
                                class: "form-control",
                                multiple: "true",
                                onChange: _cache[0] || (_cache[0] = ($event)=>$options.onFileChanged($event))
                            }, null, 32),
                            (0, $TusQn.createElementVNode)("div", $eaa9716789fe0d5f$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("button", {
                                    class: (0, $8POXm.normalizeClass)([
                                        $data.buttonLoading,
                                        $data.syncLoading
                                    ]),
                                    type: "button",
                                    disabled: ""
                                }, [
                                    $eaa9716789fe0d5f$var$_hoisted_5,
                                    (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("loading")), 1)
                                ], 2),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.uploadFiles && $options.uploadFiles(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("upload")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("cjruV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f6c96e337d5dd12$export$2e2bcd8739ae039);
let $8f6c96e337d5dd12$var$NOOP = ()=>{};
var $8f6c96e337d5dd12$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("aWhm5", function(module, exports) {

$parcel$export(module.exports, "render", () => $7f6cc88f3b17b001$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $7f6cc88f3b17b001$var$_hoisted_1 = {
    key: 0
};
const $7f6cc88f3b17b001$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $7f6cc88f3b17b001$var$_hoisted_3 = [
    $7f6cc88f3b17b001$var$_hoisted_2
];
const $7f6cc88f3b17b001$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $7f6cc88f3b17b001$var$_hoisted_5 = {
    ref: "breadcrumb",
    "aria-label": "breadcrumb"
};
const $7f6cc88f3b17b001$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $7f6cc88f3b17b001$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $7f6cc88f3b17b001$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $7f6cc88f3b17b001$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $7f6cc88f3b17b001$var$_hoisted_10 = {
    class: "row"
};
const $7f6cc88f3b17b001$var$_hoisted_11 = {
    class: "mb-3 col-md-4"
};
const $7f6cc88f3b17b001$var$_hoisted_12 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $7f6cc88f3b17b001$var$_hoisted_13 = {
    class: "mb-3 col-md-8"
};
const $7f6cc88f3b17b001$var$_hoisted_14 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $7f6cc88f3b17b001$var$_hoisted_15 = {
    key: 0,
    class: "mb-3 overflow-auto"
};
const $7f6cc88f3b17b001$var$_hoisted_16 = {
    class: "nav nav-tabs",
    id: "nav-tab",
    role: "tablist"
};
const $7f6cc88f3b17b001$var$_hoisted_17 = {
    class: "nav-link active",
    id: "map-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#map",
    type: "button",
    role: "tab",
    "aria-controls": "map",
    "aria-selected": "true"
};
const $7f6cc88f3b17b001$var$_hoisted_18 = {
    class: "tab-content",
    id: "nav-tabContent"
};
const $7f6cc88f3b17b001$var$_hoisted_19 = {
    class: "tab-pane fade show active",
    id: "map",
    role: "tabpanel",
    "aria-labelledby": "map-tab"
};
const $7f6cc88f3b17b001$var$_hoisted_20 = {
    key: 0,
    style: {
        "position": "absolute",
        "top": "50%",
        "left": "50%",
        "transform": "translate(-50%, -50%)",
        "padding": "10px"
    }
};
const $7f6cc88f3b17b001$var$_hoisted_21 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
    class: "spinner-border",
    role: "status",
    "aria-hidden": "true"
}, null, -1);
const $7f6cc88f3b17b001$var$_hoisted_22 = [
    $7f6cc88f3b17b001$var$_hoisted_21
];
const $7f6cc88f3b17b001$var$_hoisted_23 = {
    ref: "map",
    class: "map"
};
const $7f6cc88f3b17b001$var$_hoisted_24 = {
    style: {
        "display": "none"
    }
};
const $7f6cc88f3b17b001$var$_hoisted_25 = {
    id: "popup",
    class: "ol-popup",
    ref: "popup"
};
const $7f6cc88f3b17b001$var$_hoisted_26 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "btn-group btn-group-toggle",
    "data-toggle": "buttons",
    style: {
        "width": "100%"
    }
}, null, -1);
const $7f6cc88f3b17b001$var$_hoisted_27 = {
    href: "#",
    id: "popup-closer",
    class: "ol-popup-closer",
    ref: "popupCloser"
};
const $7f6cc88f3b17b001$var$_hoisted_28 = {
    id: "popup-content"
};
const $7f6cc88f3b17b001$var$_hoisted_29 = {
    class: "display compact responsive nowrap",
    width: "100%",
    ref: "popUpDataTable"
};
const $7f6cc88f3b17b001$var$_hoisted_30 = {
    class: "tab-pane fade",
    id: "data",
    role: "tabpanel",
    "aria-labelledby": "data-tab"
};
const $7f6cc88f3b17b001$var$_hoisted_31 = {
    key: 1,
    class: "mb-3 overflow-auto"
};
const $7f6cc88f3b17b001$var$_hoisted_32 = {
    class: "d-grid gap-2 d-md-flex"
};
const $7f6cc88f3b17b001$var$_hoisted_33 = {
    key: 1,
    class: "ms-auto"
};
function $7f6cc88f3b17b001$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7f6cc88f3b17b001$var$_hoisted_1, $7f6cc88f3b17b001$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7f6cc88f3b17b001$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("datasetDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $7f6cc88f3b17b001$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $7f6cc88f3b17b001$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $7f6cc88f3b17b001$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $7f6cc88f3b17b001$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $7f6cc88f3b17b001$var$_hoisted_9, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ], 512),
        (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_10, [
            (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("label", $7f6cc88f3b17b001$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("label", $7f6cc88f3b17b001$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        $data.renderMap && $data.content.center ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7f6cc88f3b17b001$var$_hoisted_15, [
            (0, $TusQn.createElementVNode)("nav", null, [
                (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_16, [
                    (0, $TusQn.createElementVNode)("button", $7f6cc88f3b17b001$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("map")), 1),
                    (0, $TusQn.createElementVNode)("button", {
                        class: "nav-link",
                        onClick: _cache[2] || (_cache[2] = ($event)=>$options.adjustDt()),
                        id: "data-tab",
                        "data-bs-toggle": "tab",
                        "data-bs-target": "#data",
                        type: "button",
                        role: "tab",
                        "aria-controls": "data",
                        "aria-selected": "false"
                    }, (0, $8POXm.toDisplayString)(_ctx.$t("data")), 1)
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_19, [
                    $data.mapLoading ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7f6cc88f3b17b001$var$_hoisted_20, $7f6cc88f3b17b001$var$_hoisted_22)) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_23, null, 512),
                    (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_24, [
                        (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_25, [
                            $7f6cc88f3b17b001$var$_hoisted_26,
                            (0, $TusQn.createElementVNode)("a", $7f6cc88f3b17b001$var$_hoisted_27, null, 512),
                            (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_28, [
                                (0, $TusQn.createElementVNode)("table", $7f6cc88f3b17b001$var$_hoisted_29, null, 512)
                            ])
                        ], 512)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_30, [
                    (0, $TusQn.createVNode)($setup["DataTable"], {
                        ref: "dt",
                        pageLength: 5,
                        lengthMenu: [
                            5,
                            25,
                            50,
                            75,
                            100
                        ],
                        columns: $data.tableColumns,
                        options: $data.tableOptions,
                        data: $data.tableData,
                        class: "display"
                    }, null, 8, [
                        "columns",
                        "options",
                        "data"
                    ])
                ])
            ])
        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7f6cc88f3b17b001$var$_hoisted_31, [
            (0, $TusQn.createVNode)($setup["DataTable"], {
                ref: "dt",
                pageLength: 5,
                lengthMenu: [
                    5,
                    25,
                    50,
                    75,
                    100
                ],
                columns: $data.tableColumns,
                options: $data.tableOptions,
                data: $data.tableData,
                class: "display"
            }, null, 8, [
                "columns",
                "options",
                "data"
            ])
        ])),
        (0, $TusQn.createElementVNode)("div", $7f6cc88f3b17b001$var$_hoisted_32, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[3] || (_cache[3] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[4] || (_cache[4] = (...args)=>$options.showDeleteDataset && $options.showDeleteDataset(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[5] || (_cache[5] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1),
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7f6cc88f3b17b001$var$_hoisted_33, [
                (0, $TusQn.createElementVNode)("button", {
                    class: "btn btn-secondary me-2",
                    onClick: _cache[6] || (_cache[6] = (...args)=>$options.datasetZipDownload && $options.datasetZipDownload(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("downloadZip")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    class: "btn btn-secondary",
                    onClick: _cache[7] || (_cache[7] = ($event)=>$data.showImportXlsxModal = true)
                }, (0, $8POXm.toDisplayString)(_ctx.$t("Upload")), 1)
            ])) : (0, $TusQn.createCommentVNode)("", true)
        ]),
        $data.showDatasetDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["DatasetDeleteModal"], {
            key: 2,
            onReload: _cache[8] || (_cache[8] = ($event)=>_ctx.$router.go(-1)),
            onCloseDeleteDialog: _cache[9] || (_cache[9] = ($event)=>$data.showDatasetDeleteModal = false),
            "dataset-id": $data.data.id,
            "modeling-id": _ctx.$route.params.id
        }, null, 8, [
            "dataset-id",
            "modeling-id"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.showImportXlsxModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["DatasetXlsxUploadDialog"], {
            key: 3,
            onReload: _cache[10] || (_cache[10] = ($event)=>_ctx.$router.go(0)),
            onClose: _cache[11] || (_cache[11] = ($event)=>$data.showImportXlsxModal = false),
            "dataset-id": $data.data.id,
            "modeling-id": _ctx.$route.params.id
        }, null, 8, [
            "dataset-id",
            "modeling-id"
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("jhZsT", function(module, exports) {

$parcel$export(module.exports, "default", () => $039fbaf9f7743ddd$export$2e2bcd8739ae039);
let $039fbaf9f7743ddd$var$NOOP = ()=>{};
var $039fbaf9f7743ddd$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("bleg2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $841cb7235ae7fe27$export$2e2bcd8739ae039);

var $ch9iu = parcelRequire("ch9iu");

var $l6otV = parcelRequire("l6otV");
var $841cb7235ae7fe27$export$2e2bcd8739ae039 = {
    name: "datasetCreate",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                this.data.content = JSON.stringify(this.content);
                await (0, $ch9iu.default).datasetCreate(this.$route.params.id, this.data);
                this.$router.push({
                    name: "modeling",
                    params: {
                        id: this.$route.params.id
                    }
                });
            } else this.showEmptyNameError();
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0
            },
            modelingName: null,
            pending: true,
            content: {
                headers: [],
                center: ""
            }
        };
    },
    notifications: {
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    }
};

});

parcelRegister("lKRYg", function(module, exports) {

$parcel$export(module.exports, "render", () => $fd67c26076fefb0b$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $fd67c26076fefb0b$var$_hoisted_1 = {
    key: 0
};
const $fd67c26076fefb0b$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $fd67c26076fefb0b$var$_hoisted_3 = [
    $fd67c26076fefb0b$var$_hoisted_2
];
const $fd67c26076fefb0b$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $fd67c26076fefb0b$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $fd67c26076fefb0b$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $fd67c26076fefb0b$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $fd67c26076fefb0b$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $fd67c26076fefb0b$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $fd67c26076fefb0b$var$_hoisted_10 = {
    class: "row"
};
const $fd67c26076fefb0b$var$_hoisted_11 = {
    class: "mb-3 col-md-4"
};
const $fd67c26076fefb0b$var$_hoisted_12 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $fd67c26076fefb0b$var$_hoisted_13 = {
    class: "mb-3 col-md-8"
};
const $fd67c26076fefb0b$var$_hoisted_14 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $fd67c26076fefb0b$var$_hoisted_15 = {
    class: "d-grid gap-2 d-md-flex"
};
function $fd67c26076fefb0b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $fd67c26076fefb0b$var$_hoisted_1, $fd67c26076fefb0b$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $fd67c26076fefb0b$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("datasetCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $fd67c26076fefb0b$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $fd67c26076fefb0b$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $fd67c26076fefb0b$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $fd67c26076fefb0b$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $fd67c26076fefb0b$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("datasetCreate")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $fd67c26076fefb0b$var$_hoisted_10, [
            (0, $TusQn.createElementVNode)("div", $fd67c26076fefb0b$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("label", $fd67c26076fefb0b$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $fd67c26076fefb0b$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("label", $fd67c26076fefb0b$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $fd67c26076fefb0b$var$_hoisted_15, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[2] || (_cache[2] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("5dmut", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cbf9cc881a6507a$export$2e2bcd8739ae039);
let $3cbf9cc881a6507a$var$NOOP = ()=>{};
var $3cbf9cc881a6507a$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("a2uhx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $74f194a58969afeb$export$2e2bcd8739ae039);

var $eHCxc = parcelRequire("eHCxc");

var $ch9iu = parcelRequire("ch9iu");

var $8i3Lm = parcelRequire("8i3Lm");

var $97tK3 = parcelRequire("97tK3");

var $l6otV = parcelRequire("l6otV");

var $gOjKo = parcelRequire("gOjKo");

var $gEQGX = parcelRequire("gEQGX");

var $bGY22 = parcelRequire("bGY22");
var $74f194a58969afeb$export$2e2bcd8739ae039 = {
    name: "forecastCreate",
    watch: {
        $route: "requestData"
    },
    components: {
        ForecastCopyModal: $gEQGX.default,
        ForecastDeleteModal: $bGY22.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            this.data = await (0, $8i3Lm.default).forecastDetail(this.$route.params.id, this.$route.params.forecastId);
            this.assetTypes = await (0, $eHCxc.default).assetTypeList(this.$route.params.id);
            this.lifeCycles = await (0, $97tK3.default).lifeCycleList(this.$route.params.id);
            for(var i in this.assetTypes){
                var assetType = this.assetTypes[i];
                var foundAssetType = this.data?.forecastAssetTypes?.find((v)=>v.assetTypeId == assetType.id);
                var assetTypeLifeCycles = this.lifeCycles.filter((l)=>l.assetTypeId == assetType.id);
                var forecastAssetTypeObject = {
                    checked: false,
                    name: assetType.name,
                    assetTypeId: assetType.id,
                    lifeCycles: []
                };
                if (foundAssetType != null) forecastAssetTypeObject.checked = true;
                for(var o in assetTypeLifeCycles){
                    var lifeCycle = assetTypeLifeCycles[o];
                    forecastAssetTypeObject.lifeCycles.push({
                        checked: foundAssetType?.lifeCycles?.includes(lifeCycle.id),
                        name: lifeCycle.name,
                        id: lifeCycle.id
                    });
                }
                this.clientForecastAssetTypes.push(forecastAssetTypeObject);
            }
            this.datasets = await (0, $ch9iu.default).datasetList(this.$route.params.id);
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                if (this.data.startYear > 0 && this.data.endYear > 0) {
                    var forecastAssetTypes = [];
                    for(var i in this.clientForecastAssetTypes){
                        var forecastAssetType = this.clientForecastAssetTypes[i];
                        var assetTypeObject = {
                            assetTypeId: 0,
                            lifeCycles: []
                        };
                        if (forecastAssetType.checked) {
                            assetTypeObject.assetTypeId = forecastAssetType.assetTypeId;
                            for(var o in forecastAssetType.lifeCycles){
                                var lifeCycle = forecastAssetType.lifeCycles[o];
                                if (lifeCycle.checked) assetTypeObject.lifeCycles.push(lifeCycle.id);
                            }
                        }
                        if (assetTypeObject.assetTypeId > 0) forecastAssetTypes.push(assetTypeObject);
                    }
                    this.data.forecastAssetTypes = forecastAssetTypes;
                    await (0, $8i3Lm.default).forecastUpdate(this.$route.params.id, this.data);
                    this.showSuccess();
                } else this.showErrorStartEndYear();
            } else this.showEmptyNameError();
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "forecastUpdated",
            type: "success"
        },
        showErrorStartEndYear: {
            title: "error",
            message: "errorStartEndYearForecast",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                id: 0,
                name: "",
                startYear: "",
                endYear: "",
                forecastAssetTypes: []
            },
            lifeCycles: [],
            assetTypes: [],
            datasets: [],
            showAddForecastLifeCycle: false,
            selectedAssetTypeIndex: -1,
            selectedAssetTypeId: 0,
            selectedLifeCycles: [],
            modelingName: null,
            pending: true,
            showCopyForecast: false,
            clientForecastAssetTypes: [],
            showDeleteModal: false,
            isUserAdmin: false
        };
    }
};

});
parcelRegister("97tK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a3bd695c1d94598$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $6a3bd695c1d94598$var$lifeCycleApi = {
    lifeCycleList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/lifeCycle`);
        const res = await req;
        return res.body;
    },
    lifeCycleDetail: async (modelingId, lifeCycle)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/lifeCycle/${lifeCycle}`);
        const res = await req;
        return res.body;
    },
    lifeCycleUpdate: async (modelingId, lifeCycle)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/lifeCycle/${lifeCycle.id}`).send(lifeCycle);
        const res = await req;
        return res.body;
    },
    lifeCycleCreate: async (modelingId, lifeCycle)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/lifeCycle`).send(lifeCycle);
        const res = await req;
        return res.body;
    },
    lifeCycleDelete: async (modelingId, lifeCycleId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/lifeCycle/${lifeCycleId}`);
        await req;
    }
};
var $6a3bd695c1d94598$export$2e2bcd8739ae039 = $6a3bd695c1d94598$var$lifeCycleApi;

});

parcelRegister("gEQGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $c209414203c50f08$export$2e2bcd8739ae039);
let $c209414203c50f08$var$script;



let $c209414203c50f08$var$initialize = ()=>{
    $c209414203c50f08$var$script = (parcelRequire("aWwor"));
    if ($c209414203c50f08$var$script.__esModule) $c209414203c50f08$var$script = $c209414203c50f08$var$script.default;
    $c209414203c50f08$var$script.render = (parcelRequire("6Z4J7")).render;
    (parcelRequire("jXHi0")).default($c209414203c50f08$var$script);
    $c209414203c50f08$var$script.__scopeId = "data-v-cab31d";
    $c209414203c50f08$var$script.__file = "ForecastCopyModal.vue";
};
$c209414203c50f08$var$initialize();
var $c209414203c50f08$export$2e2bcd8739ae039 = $c209414203c50f08$var$script;

});
parcelRegister("aWwor", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7f7872ccb76cb780$export$2e2bcd8739ae039);

var $8i3Lm = parcelRequire("8i3Lm");
var $7f7872ccb76cb780$export$2e2bcd8739ae039 = {
    name: "ForecastCopyModal",
    notifications: {
        showSuccessCopy: {
            title: "success",
            message: "forecastCopied",
            type: "success"
        }
    },
    methods: {
        close () {
            this.$emit("close");
        },
        async confirm () {
            var forecastId = await (0, $8i3Lm.default).forecastCopy(this.$parent.$route.params.id, this.$parent.$route.params.forecastId);
            this.$emit("close");
            this.showSuccessCopy();
            this.$router.push({
                path: `/modeling/${this.$route.params.id}/forecast/${forecastId}`
            });
        }
    }
};

});

parcelRegister("6Z4J7", function(module, exports) {

$parcel$export(module.exports, "render", () => $515c1b34f47adfa9$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $515c1b34f47adfa9$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $515c1b34f47adfa9$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $515c1b34f47adfa9$var$_hoisted_3 = {
    class: "modal-content"
};
const $515c1b34f47adfa9$var$_hoisted_4 = {
    class: "modal-header"
};
const $515c1b34f47adfa9$var$_hoisted_5 = {
    class: "modal-title"
};
const $515c1b34f47adfa9$var$_hoisted_6 = {
    class: "modal-body"
};
const $515c1b34f47adfa9$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0"
    }
};
const $515c1b34f47adfa9$var$_hoisted_8 = {
    class: "modal-footer"
};
function $515c1b34f47adfa9$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $515c1b34f47adfa9$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $515c1b34f47adfa9$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $515c1b34f47adfa9$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $515c1b34f47adfa9$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $515c1b34f47adfa9$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("forecastCopy")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $515c1b34f47adfa9$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", $515c1b34f47adfa9$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaCopyThisForecast")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $515c1b34f47adfa9$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.confirm && $options.confirm(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("confirm")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("jXHi0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8851b5f2e16a91d$export$2e2bcd8739ae039);
let $e8851b5f2e16a91d$var$NOOP = ()=>{};
var $e8851b5f2e16a91d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("bGY22", function(module, exports) {

$parcel$export(module.exports, "default", () => $88322f0ef8e289bc$export$2e2bcd8739ae039);
let $88322f0ef8e289bc$var$script;



let $88322f0ef8e289bc$var$initialize = ()=>{
    $88322f0ef8e289bc$var$script = (parcelRequire("02Ww0"));
    if ($88322f0ef8e289bc$var$script.__esModule) $88322f0ef8e289bc$var$script = $88322f0ef8e289bc$var$script.default;
    $88322f0ef8e289bc$var$script.render = (parcelRequire("5DhIr")).render;
    (parcelRequire("3Bq1y")).default($88322f0ef8e289bc$var$script);
    $88322f0ef8e289bc$var$script.__scopeId = "data-v-d4da78";
    $88322f0ef8e289bc$var$script.__file = "ForecastDeleteModal.vue";
};
$88322f0ef8e289bc$var$initialize();
var $88322f0ef8e289bc$export$2e2bcd8739ae039 = $88322f0ef8e289bc$var$script;

});
parcelRegister("02Ww0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $008d93e794f9938b$export$2e2bcd8739ae039);

var $8i3Lm = parcelRequire("8i3Lm");
var $008d93e794f9938b$export$2e2bcd8739ae039 = {
    name: "ForecastDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteForecast () {
            await (0, $8i3Lm.default).forecastDelete(this.$parent.$route.params.id, this.$parent.$route.params.forecastId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("5DhIr", function(module, exports) {

$parcel$export(module.exports, "render", () => $419e563e1a49db41$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $419e563e1a49db41$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $419e563e1a49db41$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $419e563e1a49db41$var$_hoisted_3 = {
    class: "modal-content"
};
const $419e563e1a49db41$var$_hoisted_4 = {
    class: "modal-header"
};
const $419e563e1a49db41$var$_hoisted_5 = {
    class: "modal-title"
};
const $419e563e1a49db41$var$_hoisted_6 = {
    class: "modal-body"
};
const $419e563e1a49db41$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0"
    }
};
const $419e563e1a49db41$var$_hoisted_8 = {
    class: "modal-footer"
};
function $419e563e1a49db41$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $419e563e1a49db41$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $419e563e1a49db41$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $419e563e1a49db41$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $419e563e1a49db41$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $419e563e1a49db41$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("forecastDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $419e563e1a49db41$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", $419e563e1a49db41$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisForecast")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $419e563e1a49db41$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteForecast && $options.deleteForecast(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("3Bq1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $29f9039e6ed1500c$export$2e2bcd8739ae039);
let $29f9039e6ed1500c$var$NOOP = ()=>{};
var $29f9039e6ed1500c$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("cv38H", function(module, exports) {

$parcel$export(module.exports, "render", () => $919ad0aab5d5fac0$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $919ad0aab5d5fac0$var$_hoisted_1 = {
    key: 0
};
const $919ad0aab5d5fac0$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $919ad0aab5d5fac0$var$_hoisted_3 = [
    $919ad0aab5d5fac0$var$_hoisted_2
];
const $919ad0aab5d5fac0$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $919ad0aab5d5fac0$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $919ad0aab5d5fac0$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $919ad0aab5d5fac0$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $919ad0aab5d5fac0$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $919ad0aab5d5fac0$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $919ad0aab5d5fac0$var$_hoisted_10 = {
    class: "row mb-3"
};
const $919ad0aab5d5fac0$var$_hoisted_11 = {
    class: "col-md-4"
};
const $919ad0aab5d5fac0$var$_hoisted_12 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $919ad0aab5d5fac0$var$_hoisted_13 = {
    class: "col-md-8"
};
const $919ad0aab5d5fac0$var$_hoisted_14 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $919ad0aab5d5fac0$var$_hoisted_15 = {
    class: "row mb-4"
};
const $919ad0aab5d5fac0$var$_hoisted_16 = {
    class: "col-md-3"
};
const $919ad0aab5d5fac0$var$_hoisted_17 = {
    class: "form-label",
    for: "startYear",
    required: ""
};
const $919ad0aab5d5fac0$var$_hoisted_18 = {
    class: "col-md-3"
};
const $919ad0aab5d5fac0$var$_hoisted_19 = {
    class: "form-label",
    for: "endYear",
    required: ""
};
const $919ad0aab5d5fac0$var$_hoisted_20 = {
    class: "col-md-3"
};
const $919ad0aab5d5fac0$var$_hoisted_21 = {
    class: "form-label",
    for: "inflationRate",
    required: ""
};
const $919ad0aab5d5fac0$var$_hoisted_22 = {
    class: "col-md-3"
};
const $919ad0aab5d5fac0$var$_hoisted_23 = {
    class: "form-label",
    for: "discountRate",
    required: ""
};
const $919ad0aab5d5fac0$var$_hoisted_24 = {
    class: "mb-4"
};
const $919ad0aab5d5fac0$var$_hoisted_25 = {
    class: "row"
};
const $919ad0aab5d5fac0$var$_hoisted_26 = {
    class: "col-md-2"
};
const $919ad0aab5d5fac0$var$_hoisted_27 = {
    class: "input-group mb-3"
};
const $919ad0aab5d5fac0$var$_hoisted_28 = {
    class: "input-group-text"
};
const $919ad0aab5d5fac0$var$_hoisted_29 = [
    "onUpdate:modelValue",
    "id"
];
const $919ad0aab5d5fac0$var$_hoisted_30 = [
    "for"
];
const $919ad0aab5d5fac0$var$_hoisted_31 = {
    class: "input-group mb-3"
};
const $919ad0aab5d5fac0$var$_hoisted_32 = {
    class: "input-group-text"
};
const $919ad0aab5d5fac0$var$_hoisted_33 = [
    "onUpdate:modelValue",
    "id"
];
const $919ad0aab5d5fac0$var$_hoisted_34 = [
    "for"
];
const $919ad0aab5d5fac0$var$_hoisted_35 = {
    class: "d-grid gap-2 d-md-flex"
};
function $919ad0aab5d5fac0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_ForecastCopyModal = (0, $TusQn.resolveComponent)("ForecastCopyModal");
    const _component_ForecastDeleteModal = (0, $TusQn.resolveComponent)("ForecastDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $919ad0aab5d5fac0$var$_hoisted_1, $919ad0aab5d5fac0$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $919ad0aab5d5fac0$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("forecastUpdate")), 1),
        (0, $TusQn.createElementVNode)("nav", $919ad0aab5d5fac0$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $919ad0aab5d5fac0$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $919ad0aab5d5fac0$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $919ad0aab5d5fac0$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $919ad0aab5d5fac0$var$_hoisted_9, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_10, [
            (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("label", $919ad0aab5d5fac0$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("label", $919ad0aab5d5fac0$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_15, [
            (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_16, [
                (0, $TusQn.createElementVNode)("label", $919ad0aab5d5fac0$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("startYear")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.startYear = $event),
                    type: "text",
                    class: "form-control",
                    id: "startYear"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.startYear
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("label", $919ad0aab5d5fac0$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("endYear")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.endYear = $event),
                    type: "text",
                    class: "form-control",
                    id: "endYear"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.endYear
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_20, [
                (0, $TusQn.createElementVNode)("label", $919ad0aab5d5fac0$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("inflationRate")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.inflationRate = $event),
                    type: "number",
                    class: "form-control",
                    id: "inflationRate"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.inflationRate
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_22, [
                (0, $TusQn.createElementVNode)("label", $919ad0aab5d5fac0$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("discountRate")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.data.discountRate = $event),
                    type: "number",
                    class: "form-control",
                    id: "discountRate"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.discountRate
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_24, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("forecastAssetTypes")), 1),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.clientForecastAssetTypes, (forecastAssetType, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: i,
                    class: "mb-3 border-bottom"
                }, [
                    (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_25, [
                        (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_26, [
                            (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_27, [
                                (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_28, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        class: "form-check-input mt-0",
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event)=>forecastAssetType.checked = $event,
                                        id: "forecast_" + i
                                    }, null, 8, $919ad0aab5d5fac0$var$_hoisted_29), [
                                        [
                                            (0, $eeJ70.vModelCheckbox),
                                            forecastAssetType.checked
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("label", {
                                    type: "text",
                                    for: "forecast_" + i,
                                    class: "form-control"
                                }, (0, $8POXm.toDisplayString)(forecastAssetType.name), 9, $919ad0aab5d5fac0$var$_hoisted_30)
                            ])
                        ]),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(forecastAssetType.lifeCycles, (lifeCycle, o)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                class: "mb-3 col-md-3",
                                key: o
                            }, [
                                (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_31, [
                                    (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_32, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            class: "form-check-input mt-0",
                                            type: "checkbox",
                                            "onUpdate:modelValue": ($event)=>lifeCycle.checked = $event,
                                            id: "lifeCycle_" + i + o
                                        }, null, 8, $919ad0aab5d5fac0$var$_hoisted_33), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                lifeCycle.checked
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("label", {
                                        type: "text",
                                        for: "lifeCycle_" + i + o,
                                        class: "form-control",
                                        readonly: ""
                                    }, (0, $8POXm.toDisplayString)(lifeCycle.name), 9, $919ad0aab5d5fac0$var$_hoisted_34)
                                ])
                            ]);
                        }), 128))
                    ])
                ]);
            }), 128))
        ]),
        (0, $TusQn.createElementVNode)("div", $919ad0aab5d5fac0$var$_hoisted_35, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[6] || (_cache[6] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[7] || (_cache[7] = ($event)=>$data.showDeleteModal = true)
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[8] || (_cache[8] = ($event)=>$data.showCopyForecast = true)
                }, (0, $8POXm.toDisplayString)(_ctx.$t("copy")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[9] || (_cache[9] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showCopyForecast ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ForecastCopyModal, {
            key: 0,
            onClose: _cache[10] || (_cache[10] = ($event)=>$data.showCopyForecast = false),
            onConfirm: _cache[11] || (_cache[11] = ($event)=>_ctx.confirmForecastCopyModal())
        })) : (0, $TusQn.createCommentVNode)("", true),
        $data.showDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ForecastDeleteModal, {
            key: 1,
            onClose: _cache[12] || (_cache[12] = ($event)=>$data.showDeleteModal = false),
            onReload: _cache[13] || (_cache[13] = ($event)=>_ctx.$router.go(-1))
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("4icYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3202e76b0a74c83b$export$2e2bcd8739ae039);
let $3202e76b0a74c83b$var$NOOP = ()=>{};
var $3202e76b0a74c83b$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("hfdrB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c8de441bef06be81$export$2e2bcd8739ae039);

var $eHCxc = parcelRequire("eHCxc");

var $ch9iu = parcelRequire("ch9iu");

var $8i3Lm = parcelRequire("8i3Lm");

var $97tK3 = parcelRequire("97tK3");

var $l6otV = parcelRequire("l6otV");
var $c8de441bef06be81$export$2e2bcd8739ae039 = {
    name: "forecastCreate",
    watch: {
        $route: "requestData"
    },
    components: {},
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.assetTypes = await (0, $eHCxc.default).assetTypeList(this.$route.params.id);
            this.lifeCycles = await (0, $97tK3.default).lifeCycleList(this.$route.params.id);
            this.datasets = await (0, $ch9iu.default).datasetList(this.$route.params.id);
            for(var i in this.assetTypes){
                var assetType = this.assetTypes[i];
                var assetTypeLifeCycles = this.lifeCycles.filter((l)=>l.assetTypeId == assetType.id);
                var forecastAssetTypeObject = {
                    checked: false,
                    name: assetType.name,
                    assetTypeId: assetType.id,
                    lifeCycles: []
                };
                for(var o in assetTypeLifeCycles){
                    var lifeCycle = assetTypeLifeCycles[o];
                    forecastAssetTypeObject.lifeCycles.push({
                        checked: false,
                        name: lifeCycle.name,
                        id: lifeCycle.id
                    });
                }
                this.clientForecastAssetTypes.push(forecastAssetTypeObject);
            }
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                if (this.data.startYear > 0 && this.data.endYear > 0) {
                    var forecastAssetTypes = [];
                    for(var i in this.clientForecastAssetTypes){
                        var forecastAssetType = this.clientForecastAssetTypes[i];
                        var assetTypeObject = {
                            assetTypeId: 0,
                            lifeCycles: []
                        };
                        if (forecastAssetType.checked) {
                            assetTypeObject.assetTypeId = forecastAssetType.assetTypeId;
                            for(var o in forecastAssetType.lifeCycles){
                                var lifeCycle = forecastAssetType.lifeCycles[o];
                                if (lifeCycle.checked) assetTypeObject.lifeCycles.push(lifeCycle.id);
                            }
                        }
                        if (assetTypeObject.assetTypeId > 0) forecastAssetTypes.push(assetTypeObject);
                    }
                    this.data.forecastAssetTypes = forecastAssetTypes;
                    await (0, $8i3Lm.default).forecastCreate(this.$route.params.id, this.data);
                    this.$router.push({
                        name: "modeling",
                        params: {
                            id: this.$route.params.id
                        }
                    });
                } else this.showErrorStartEndYear();
            } else this.showEmptyNameError();
        }
    },
    data () {
        return {
            data: {
                id: 0,
                name: "",
                startYear: "",
                endYear: "",
                forecastAssetTypes: []
            },
            lifeCycles: [],
            assetTypes: [],
            datasets: [],
            showAddForecastLifeCycle: false,
            selectedAssetTypeIndex: -1,
            selectedAssetTypeId: 0,
            selectedLifeCycles: [],
            modelingName: null,
            pending: true,
            clientForecastAssetTypes: []
        };
    },
    notifications: {
        showErrorStartEndYear: {
            title: "error",
            message: "errorStartEndYearForecast",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    }
};

});

parcelRegister("jzXIK", function(module, exports) {

$parcel$export(module.exports, "render", () => $e40f9c799a7f44ff$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $e40f9c799a7f44ff$var$_hoisted_1 = {
    key: 0
};
const $e40f9c799a7f44ff$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $e40f9c799a7f44ff$var$_hoisted_3 = [
    $e40f9c799a7f44ff$var$_hoisted_2
];
const $e40f9c799a7f44ff$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $e40f9c799a7f44ff$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $e40f9c799a7f44ff$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $e40f9c799a7f44ff$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $e40f9c799a7f44ff$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $e40f9c799a7f44ff$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $e40f9c799a7f44ff$var$_hoisted_10 = {
    class: "row mb-3"
};
const $e40f9c799a7f44ff$var$_hoisted_11 = {
    class: "col-md-4"
};
const $e40f9c799a7f44ff$var$_hoisted_12 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $e40f9c799a7f44ff$var$_hoisted_13 = {
    class: "col-md-8"
};
const $e40f9c799a7f44ff$var$_hoisted_14 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $e40f9c799a7f44ff$var$_hoisted_15 = {
    class: "row mb-4"
};
const $e40f9c799a7f44ff$var$_hoisted_16 = {
    class: "col-md-3"
};
const $e40f9c799a7f44ff$var$_hoisted_17 = {
    class: "form-label",
    for: "startYear",
    required: ""
};
const $e40f9c799a7f44ff$var$_hoisted_18 = {
    class: "col-md-3"
};
const $e40f9c799a7f44ff$var$_hoisted_19 = {
    class: "form-label",
    for: "endYear",
    required: ""
};
const $e40f9c799a7f44ff$var$_hoisted_20 = {
    class: "col-md-3"
};
const $e40f9c799a7f44ff$var$_hoisted_21 = {
    class: "form-label",
    for: "inflationRate",
    required: ""
};
const $e40f9c799a7f44ff$var$_hoisted_22 = {
    class: "col-md-3"
};
const $e40f9c799a7f44ff$var$_hoisted_23 = {
    class: "form-label",
    for: "discountRate",
    required: ""
};
const $e40f9c799a7f44ff$var$_hoisted_24 = {
    class: "mb-4"
};
const $e40f9c799a7f44ff$var$_hoisted_25 = {
    class: "row"
};
const $e40f9c799a7f44ff$var$_hoisted_26 = {
    class: "col-md-2"
};
const $e40f9c799a7f44ff$var$_hoisted_27 = {
    class: "input-group mb-3"
};
const $e40f9c799a7f44ff$var$_hoisted_28 = {
    class: "input-group-text"
};
const $e40f9c799a7f44ff$var$_hoisted_29 = [
    "onUpdate:modelValue"
];
const $e40f9c799a7f44ff$var$_hoisted_30 = [
    "for"
];
const $e40f9c799a7f44ff$var$_hoisted_31 = {
    class: "input-group mb-3"
};
const $e40f9c799a7f44ff$var$_hoisted_32 = {
    class: "input-group-text"
};
const $e40f9c799a7f44ff$var$_hoisted_33 = [
    "onUpdate:modelValue",
    "disabled"
];
const $e40f9c799a7f44ff$var$_hoisted_34 = [
    "onUpdate:modelValue",
    "id"
];
const $e40f9c799a7f44ff$var$_hoisted_35 = {
    class: "d-grid gap-2 d-md-flex"
};
function $e40f9c799a7f44ff$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e40f9c799a7f44ff$var$_hoisted_1, $e40f9c799a7f44ff$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e40f9c799a7f44ff$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("forecastCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $e40f9c799a7f44ff$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $e40f9c799a7f44ff$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $e40f9c799a7f44ff$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $e40f9c799a7f44ff$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $e40f9c799a7f44ff$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("forecastCreate")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_10, [
            (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("label", $e40f9c799a7f44ff$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("label", $e40f9c799a7f44ff$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_15, [
            (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_16, [
                (0, $TusQn.createElementVNode)("label", $e40f9c799a7f44ff$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("startYear")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.startYear = $event),
                    type: "text",
                    class: "form-control",
                    id: "startYear"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.startYear
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("label", $e40f9c799a7f44ff$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("endYear")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.endYear = $event),
                    type: "text",
                    class: "form-control",
                    id: "endYear"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.endYear
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_20, [
                (0, $TusQn.createElementVNode)("label", $e40f9c799a7f44ff$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("inflationRate")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.inflationRate = $event),
                    type: "number",
                    class: "form-control",
                    id: "inflationRate"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.inflationRate
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_22, [
                (0, $TusQn.createElementVNode)("label", $e40f9c799a7f44ff$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("discountRate")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.data.discountRate = $event),
                    type: "number",
                    class: "form-control",
                    id: "discountRate"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.discountRate
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_24, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("forecastAssetTypes")), 1),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.clientForecastAssetTypes, (forecastAssetType, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: i,
                    class: "mb-3 border-bottom"
                }, [
                    (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_25, [
                        (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_26, [
                            (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_27, [
                                (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_28, [
                                    (0, $TusQn.withDirectives)(((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("input", {
                                        class: "form-check-input mt-0",
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event)=>forecastAssetType.checked = $event,
                                        key: "forecast_" + i
                                    }, null, 8, $e40f9c799a7f44ff$var$_hoisted_29)), [
                                        [
                                            (0, $eeJ70.vModelCheckbox),
                                            forecastAssetType.checked
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("label", {
                                    type: "text",
                                    for: "forecast_" + i,
                                    class: "form-control",
                                    disabled: ""
                                }, (0, $8POXm.toDisplayString)(forecastAssetType.name), 9, $e40f9c799a7f44ff$var$_hoisted_30)
                            ])
                        ]),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(forecastAssetType.lifeCycles, (lifeCycle, o)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                class: "mb-3 col-md-3",
                                key: o
                            }, [
                                (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_31, [
                                    (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_32, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            class: "form-check-input mt-0",
                                            type: "checkbox",
                                            "onUpdate:modelValue": ($event)=>lifeCycle.checked = $event,
                                            disabled: !forecastAssetType.checked
                                        }, null, 8, $e40f9c799a7f44ff$var$_hoisted_33), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                lifeCycle.checked
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        type: "text",
                                        class: "form-control",
                                        "onUpdate:modelValue": ($event)=>lifeCycle.name = $event,
                                        disabled: "",
                                        id: "lifeCycle_" + o
                                    }, null, 8, $e40f9c799a7f44ff$var$_hoisted_34), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            lifeCycle.name
                                        ]
                                    ])
                                ])
                            ]);
                        }), 128))
                    ])
                ]);
            }), 128))
        ]),
        (0, $TusQn.createElementVNode)("div", $e40f9c799a7f44ff$var$_hoisted_35, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[6] || (_cache[6] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[7] || (_cache[7] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("eFk8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $aad48471fe3dfb71$export$2e2bcd8739ae039);
let $aad48471fe3dfb71$var$NOOP = ()=>{};
var $aad48471fe3dfb71$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("80568", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5d32472740dd60a4$export$2e2bcd8739ae039);

var $fmQKt = parcelRequire("fmQKt");

var $l6otV = parcelRequire("l6otV");

var $gxt0C = parcelRequire("gxt0C");

var $hqjNp = parcelRequire("hqjNp");

var $8ANHo = parcelRequire("8ANHo");

var $6ZVZ7 = parcelRequire("6ZVZ7");

var $gOjKo = parcelRequire("gOjKo");

var $45fvw = parcelRequire("45fvw");
var $5d32472740dd60a4$export$2e2bcd8739ae039 = {
    name: "selectiondetail",
    watch: {
        $route: "requestData"
    },
    components: {
        SelectionAnalyseModal: $hqjNp.default,
        SelectionValidateModal: $8ANHo.default,
        ModelingResultDeleteModal: $6ZVZ7.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var selectionId = this.$route.params.selectionId;
            this.data = await (0, $fmQKt.default).selectionDetail(this.$route.params.id, selectionId);
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            await this.loadAnalysisList();
            this.pending = false;
        },
        getCreatedDate (date) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format("DD.MM.YYYY HH:mm");
        },
        startPollingAnalysis () {
            if (this.pollingHandle) return;
            this.pollingHandle = setInterval(()=>{
                this.loadAnalysisList();
            }, 3000); // 3 vteřiny
        },
        async closeAnalyseSetions () {
            this.showAnalysisStarted();
            this.showAnalyseSelection = false;
            await this.loadAnalysisList();
            this.startPollingAnalysis();
        },
        async loadAnalysisList () {
            const selectionId = this.$route.params.selectionId;
            this.analysisList = await (0, $gxt0C.default).analysisList(this.$route.params.id, `?selectionId=${selectionId}`);
            // Pokud stále nějaký nedoběhl
            const hasRunning = this.analysisList.some((x)=>x.state === 0 || x.state === 201);
            if (!hasRunning && this.pollingHandle) {
                clearInterval(this.pollingHandle);
                this.pollingHandle = null;
            }
        },
        showDeleteModelingResultModal (item) {
            this.modelingResultIdToDelete = item.id;
            this.showModelingResultDelete = true;
        },
        async confirmModelingResultDeletion () {
            await this.loadAnalysisList();
            this.showModelingResultDelete = false;
            this.showModelingResultDeleted();
        }
    },
    beforeUnmount () {
        if (this.pollingHandle) clearInterval(this.pollingHandle);
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "selectionUpdated",
            type: "success"
        },
        showError: {
            title: "error",
            message: "selectionErrorUpdate",
            type: "error"
        },
        showModelingResultDeleted: {
            title: "success",
            message: "modelingResultDeleted",
            type: "success"
        },
        showAnalysisStarted: {
            title: "success",
            message: "analysisStarted",
            type: "success"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionGroup: [],
                selectionPackage: [],
                selectionLimit: []
            },
            analysisList: [],
            showSelectionDeleteModal: false,
            showAnalyseSelection: false,
            showValidateSelection: false,
            showModelingResultDelete: false,
            modelingResultIdToDelete: null,
            pending: true,
            modelingName: "",
            isUserAdmin: false,
            pollingHandle: null
        };
    }
};

});
parcelRegister("hqjNp", function(module, exports) {

$parcel$export(module.exports, "default", () => $caf4386b6141eb04$export$2e2bcd8739ae039);
let $caf4386b6141eb04$var$script;



let $caf4386b6141eb04$var$initialize = ()=>{
    $caf4386b6141eb04$var$script = (parcelRequire("gqsRB"));
    if ($caf4386b6141eb04$var$script.__esModule) $caf4386b6141eb04$var$script = $caf4386b6141eb04$var$script.default;
    $caf4386b6141eb04$var$script.render = (parcelRequire("dMiKx")).render;
    (parcelRequire("gfkxn")).default($caf4386b6141eb04$var$script);
    $caf4386b6141eb04$var$script.__scopeId = "data-v-ec7e7a";
    $caf4386b6141eb04$var$script.__file = "SelectionAnalyseModal.vue";
};
$caf4386b6141eb04$var$initialize();
var $caf4386b6141eb04$export$2e2bcd8739ae039 = $caf4386b6141eb04$var$script;

});
parcelRegister("gqsRB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bf5576c495f036f0$export$2e2bcd8739ae039);

var $gxt0C = parcelRequire("gxt0C");
var $bf5576c495f036f0$export$2e2bcd8739ae039 = {
    name: "selectionAnalyseModal",
    methods: {
        close () {
            this.$emit("close");
        },
        async analyseSelection () {
            await (0, $gxt0C.default).analyseSelection(this.$parent.$route.params.id, this.$parent.$route.params.selectionId);
            this.$emit("close");
            this.$emit("started");
        }
    }
};

});

parcelRegister("dMiKx", function(module, exports) {

$parcel$export(module.exports, "render", () => $a07e4d52e58afccd$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $a07e4d52e58afccd$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $a07e4d52e58afccd$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $a07e4d52e58afccd$var$_hoisted_3 = {
    class: "modal-content"
};
const $a07e4d52e58afccd$var$_hoisted_4 = {
    class: "modal-header"
};
const $a07e4d52e58afccd$var$_hoisted_5 = {
    class: "modal-title"
};
const $a07e4d52e58afccd$var$_hoisted_6 = {
    class: "modal-body"
};
const $a07e4d52e58afccd$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0"
    }
};
const $a07e4d52e58afccd$var$_hoisted_8 = {
    class: "modal-footer"
};
function $a07e4d52e58afccd$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $a07e4d52e58afccd$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $a07e4d52e58afccd$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $a07e4d52e58afccd$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $a07e4d52e58afccd$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $a07e4d52e58afccd$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("simulation")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $a07e4d52e58afccd$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", $a07e4d52e58afccd$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaRunSimulation")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $a07e4d52e58afccd$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.analyseSelection && $options.analyseSelection(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("analyse")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("gfkxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd3dfa5d18924c88$export$2e2bcd8739ae039);
let $bd3dfa5d18924c88$var$NOOP = ()=>{};
var $bd3dfa5d18924c88$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("8ANHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $64183cad2c3ba199$export$2e2bcd8739ae039);
let $64183cad2c3ba199$var$script;



let $64183cad2c3ba199$var$initialize = ()=>{
    $64183cad2c3ba199$var$script = (parcelRequire("k2Pcy"));
    if ($64183cad2c3ba199$var$script.__esModule) $64183cad2c3ba199$var$script = $64183cad2c3ba199$var$script.default;
    $64183cad2c3ba199$var$script.render = (parcelRequire("9P0HR")).render;
    (parcelRequire("6H8Qb")).default($64183cad2c3ba199$var$script);
    $64183cad2c3ba199$var$script.__scopeId = "data-v-ab0471";
    $64183cad2c3ba199$var$script.__file = "SelectionValidateModal.vue";
};
$64183cad2c3ba199$var$initialize();
var $64183cad2c3ba199$export$2e2bcd8739ae039 = $64183cad2c3ba199$var$script;

});
parcelRegister("k2Pcy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e97bb615a3b4f03f$export$2e2bcd8739ae039);

var $gxt0C = parcelRequire("gxt0C");
var $e97bb615a3b4f03f$export$2e2bcd8739ae039 = {
    name: "selectionAnalyseModal",
    mounted () {
        this.validateData();
    },
    methods: {
        async validateData () {
            this.pending = true;
            this.validation = await (0, $gxt0C.default).validateSelection(this.$parent.$route.params.id, this.$parent.$route.params.selectionId);
            this.pending = false;
        },
        close () {
            this.$emit("close");
        }
    },
    data () {
        return {
            validation: "",
            pending: true
        };
    },
    computed: {
        formattedString () {
            return this.validation.trim(); //(/\s/g, '');
        }
    }
};

});

parcelRegister("9P0HR", function(module, exports) {

$parcel$export(module.exports, "render", () => $72696cc7bf12f796$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $72696cc7bf12f796$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $72696cc7bf12f796$var$_hoisted_2 = {
    class: "selection-validate-modal modal-dialog modal-dialog-centered",
    role: "document"
};
const $72696cc7bf12f796$var$_hoisted_3 = {
    class: "modal-content"
};
const $72696cc7bf12f796$var$_hoisted_4 = {
    class: "modal-header"
};
const $72696cc7bf12f796$var$_hoisted_5 = {
    class: "modal-title"
};
const $72696cc7bf12f796$var$_hoisted_6 = {
    key: 0,
    class: "modal-body fs-6 font-monospace"
};
const $72696cc7bf12f796$var$_hoisted_7 = {
    style: {
        "overflow": "unset"
    }
};
const $72696cc7bf12f796$var$_hoisted_8 = [
    "innerHTML"
];
const $72696cc7bf12f796$var$_hoisted_9 = {
    key: 1,
    class: "modal-body"
};
const $72696cc7bf12f796$var$_hoisted_10 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "spinner-border center-loading-element",
    role: "status"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
        class: "sr-only"
    }, "Loading...")
], -1);
const $72696cc7bf12f796$var$_hoisted_11 = [
    $72696cc7bf12f796$var$_hoisted_10
];
const $72696cc7bf12f796$var$_hoisted_12 = {
    class: "modal-footer"
};
function $72696cc7bf12f796$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $72696cc7bf12f796$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $72696cc7bf12f796$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $72696cc7bf12f796$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $72696cc7bf12f796$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $72696cc7bf12f796$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("validation")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            !$data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $72696cc7bf12f796$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("pre", $72696cc7bf12f796$var$_hoisted_7, [
                                    (0, $TusQn.createTextVNode)("                            "),
                                    (0, $TusQn.createElementVNode)("p", {
                                        innerHTML: $options.formattedString
                                    }, null, 8, $72696cc7bf12f796$var$_hoisted_8),
                                    (0, $TusQn.createTextVNode)("\n                        ")
                                ])
                            ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $72696cc7bf12f796$var$_hoisted_9, $72696cc7bf12f796$var$_hoisted_11)),
                            (0, $TusQn.createElementVNode)("div", $72696cc7bf12f796$var$_hoisted_12, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("6H8Qb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dfd9dc7e77e1961$export$2e2bcd8739ae039);
let $4dfd9dc7e77e1961$var$NOOP = ()=>{};
var $4dfd9dc7e77e1961$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("6ZVZ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $51856b2654fcabb5$export$2e2bcd8739ae039);
let $51856b2654fcabb5$var$script;



let $51856b2654fcabb5$var$initialize = ()=>{
    $51856b2654fcabb5$var$script = (parcelRequire("hgd9a"));
    if ($51856b2654fcabb5$var$script.__esModule) $51856b2654fcabb5$var$script = $51856b2654fcabb5$var$script.default;
    $51856b2654fcabb5$var$script.render = (parcelRequire("3ZWjh")).render;
    (parcelRequire("hoRWE")).default($51856b2654fcabb5$var$script);
    $51856b2654fcabb5$var$script.__scopeId = "data-v-ff0bcd";
    $51856b2654fcabb5$var$script.__file = "ModelingResultDeleteModal.vue";
};
$51856b2654fcabb5$var$initialize();
var $51856b2654fcabb5$export$2e2bcd8739ae039 = $51856b2654fcabb5$var$script;

});
parcelRegister("hgd9a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c90e2100eaa32c7b$export$2e2bcd8739ae039);

var $gxt0C = parcelRequire("gxt0C");
var $c90e2100eaa32c7b$export$2e2bcd8739ae039 = {
    name: "modelingResultDeleteModal",
    methods: {
        close () {
            this.$emit("close");
        },
        async deleteModelingResult () {
            await (0, $gxt0C.default).analysisDelete(this.$parent.$route.params.id, this.$parent.modelingResultIdToDelete);
            this.$emit("confirm");
        }
    }
};

});

parcelRegister("3ZWjh", function(module, exports) {

$parcel$export(module.exports, "render", () => $2e944cc1fc2fc8f2$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $2e944cc1fc2fc8f2$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $2e944cc1fc2fc8f2$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $2e944cc1fc2fc8f2$var$_hoisted_3 = {
    class: "modal-content"
};
const $2e944cc1fc2fc8f2$var$_hoisted_4 = {
    class: "modal-header"
};
const $2e944cc1fc2fc8f2$var$_hoisted_5 = {
    class: "modal-title"
};
const $2e944cc1fc2fc8f2$var$_hoisted_6 = {
    class: "modal-body"
};
const $2e944cc1fc2fc8f2$var$_hoisted_7 = {
    class: "modal-footer"
};
function $2e944cc1fc2fc8f2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $2e944cc1fc2fc8f2$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $2e944cc1fc2fc8f2$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $2e944cc1fc2fc8f2$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $2e944cc1fc2fc8f2$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $2e944cc1fc2fc8f2$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("Delete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $2e944cc1fc2fc8f2$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisModelingResult")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $2e944cc1fc2fc8f2$var$_hoisted_7, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteModelingResult && $options.deleteModelingResult(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("hoRWE", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae85edafa3aaae$export$2e2bcd8739ae039);
let $caae85edafa3aaae$var$NOOP = ()=>{};
var $caae85edafa3aaae$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("2zGl7", function(module, exports) {

$parcel$export(module.exports, "render", () => $1dffb16e9e12720b$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $1dffb16e9e12720b$var$_hoisted_1 = {
    key: 0
};
const $1dffb16e9e12720b$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $1dffb16e9e12720b$var$_hoisted_3 = [
    $1dffb16e9e12720b$var$_hoisted_2
];
const $1dffb16e9e12720b$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $1dffb16e9e12720b$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $1dffb16e9e12720b$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $1dffb16e9e12720b$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $1dffb16e9e12720b$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $1dffb16e9e12720b$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $1dffb16e9e12720b$var$_hoisted_10 = {
    class: "text-center mb-4"
};
const $1dffb16e9e12720b$var$_hoisted_11 = {
    class: "btn btn-secondary float-end"
};
const $1dffb16e9e12720b$var$_hoisted_12 = {
    class: "row mb-4"
};
const $1dffb16e9e12720b$var$_hoisted_13 = {
    class: "col-sm-3"
};
const $1dffb16e9e12720b$var$_hoisted_14 = {
    class: "card text-center"
};
const $1dffb16e9e12720b$var$_hoisted_15 = {
    class: "card-body"
};
const $1dffb16e9e12720b$var$_hoisted_16 = {
    class: "card-title"
};
const $1dffb16e9e12720b$var$_hoisted_17 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $1dffb16e9e12720b$var$_hoisted_18 = {
    key: 1,
    class: "card-body"
};
const $1dffb16e9e12720b$var$_hoisted_19 = {
    class: "btn btn-sm btn-light"
};
const $1dffb16e9e12720b$var$_hoisted_20 = {
    class: "col-sm-3"
};
const $1dffb16e9e12720b$var$_hoisted_21 = {
    class: "card text-center"
};
const $1dffb16e9e12720b$var$_hoisted_22 = {
    class: "card-body"
};
const $1dffb16e9e12720b$var$_hoisted_23 = {
    class: "card-title"
};
const $1dffb16e9e12720b$var$_hoisted_24 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $1dffb16e9e12720b$var$_hoisted_25 = {
    key: 1,
    class: "card-body"
};
const $1dffb16e9e12720b$var$_hoisted_26 = {
    class: "btn btn-sm btn-light"
};
const $1dffb16e9e12720b$var$_hoisted_27 = {
    class: "col-sm-3"
};
const $1dffb16e9e12720b$var$_hoisted_28 = {
    class: "card text-center"
};
const $1dffb16e9e12720b$var$_hoisted_29 = {
    class: "card-body"
};
const $1dffb16e9e12720b$var$_hoisted_30 = {
    class: "card-title"
};
const $1dffb16e9e12720b$var$_hoisted_31 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $1dffb16e9e12720b$var$_hoisted_32 = {
    key: 1,
    class: "card-body"
};
const $1dffb16e9e12720b$var$_hoisted_33 = {
    class: "btn btn-sm btn-light"
};
const $1dffb16e9e12720b$var$_hoisted_34 = {
    key: 0
};
const $1dffb16e9e12720b$var$_hoisted_35 = {
    class: "text-center mb-4 mt-4"
};
const $1dffb16e9e12720b$var$_hoisted_36 = {
    class: "table table-bordered",
    style: {
        "border-radius": "5px"
    }
};
const $1dffb16e9e12720b$var$_hoisted_37 = {
    scope: "col"
};
const $1dffb16e9e12720b$var$_hoisted_38 = {
    scope: "col"
};
const $1dffb16e9e12720b$var$_hoisted_39 = {
    scope: "col"
};
const $1dffb16e9e12720b$var$_hoisted_40 = {
    scope: "col"
};
const $1dffb16e9e12720b$var$_hoisted_41 = {
    scope: "col"
};
const $1dffb16e9e12720b$var$_hoisted_42 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $1dffb16e9e12720b$var$_hoisted_43 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $1dffb16e9e12720b$var$_hoisted_44 = {
    class: "text-center"
};
const $1dffb16e9e12720b$var$_hoisted_45 = {
    key: 0,
    class: "spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
};
const $1dffb16e9e12720b$var$_hoisted_46 = {
    key: 1,
    class: "text-danger"
};
const $1dffb16e9e12720b$var$_hoisted_47 = {
    class: "btn btn-sm btn-light"
};
const $1dffb16e9e12720b$var$_hoisted_48 = [
    "onClick"
];
function $1dffb16e9e12720b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_SelectionAnalyseModal = (0, $TusQn.resolveComponent)("SelectionAnalyseModal");
    const _component_ModelingResultDeleteModal = (0, $TusQn.resolveComponent)("ModelingResultDeleteModal");
    const _component_SelectionValidateModal = (0, $TusQn.resolveComponent)("SelectionValidateModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1dffb16e9e12720b$var$_hoisted_1, $1dffb16e9e12720b$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1dffb16e9e12720b$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("selectionDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $1dffb16e9e12720b$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $1dffb16e9e12720b$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $1dffb16e9e12720b$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $1dffb16e9e12720b$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $1dffb16e9e12720b$var$_hoisted_9, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("h3", $1dffb16e9e12720b$var$_hoisted_10, [
            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name) + " ", 1),
            (0, $TusQn.createVNode)(_component_RouterLink, {
                to: "/modeling/" + this.$route.params.id + "/selectioninfo/" + this.$route.params.selectionId
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createElementVNode)("button", $1dffb16e9e12720b$var$_hoisted_11, (0, $8POXm.toDisplayString)(_ctx.$t("detail")), 1)
                    ]),
                _: 1
            }, 8, [
                "to"
            ]),
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    class: "btn btn-secondary float-end me-2",
                    onClick: _cache[0] || (_cache[0] = ($event)=>$data.showAnalyseSelection = true)
                }, (0, $8POXm.toDisplayString)(_ctx.$t("runSimulation")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    class: "btn btn-secondary float-end me-2",
                    onClick: _cache[1] || (_cache[1] = ($event)=>$data.showValidateSelection = true)
                }, (0, $8POXm.toDisplayString)(_ctx.$t("validate")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true)
        ]),
        (0, $TusQn.createElementVNode)("div", $1dffb16e9e12720b$var$_hoisted_12, [
            (0, $TusQn.createElementVNode)("div", $1dffb16e9e12720b$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("div", $1dffb16e9e12720b$var$_hoisted_14, [
                    (0, $TusQn.createElementVNode)("div", $1dffb16e9e12720b$var$_hoisted_15, [
                        (0, $TusQn.createElementVNode)("h5", $1dffb16e9e12720b$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("areas")), 1)
                    ]),
                    $data.data.selectionGroup.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $1dffb16e9e12720b$var$_hoisted_17, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.selectionGroup, (item, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                class: "list-group-item",
                                key: i
                            }, [
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId + "/group/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ])
                            ]);
                        }), 128))
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1dffb16e9e12720b$var$_hoisted_18, [
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId + "/groupcreate"
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createElementVNode)("button", $1dffb16e9e12720b$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("addArea")), 1)
                                ]),
                            _: 1
                        }, 8, [
                            "to"
                        ])
                    ])) : (0, $TusQn.createCommentVNode)("", true)
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $1dffb16e9e12720b$var$_hoisted_20, [
                (0, $TusQn.createElementVNode)("div", $1dffb16e9e12720b$var$_hoisted_21, [
                    (0, $TusQn.createElementVNode)("div", $1dffb16e9e12720b$var$_hoisted_22, [
                        (0, $TusQn.createElementVNode)("h5", $1dffb16e9e12720b$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("packages")), 1)
                    ]),
                    $data.data.selectionPackage.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $1dffb16e9e12720b$var$_hoisted_24, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.selectionPackage, (item, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                class: "list-group-item",
                                key: i
                            }, [
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId + "/package/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ])
                            ]);
                        }), 128))
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1dffb16e9e12720b$var$_hoisted_25, [
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId + "/packagecreate"
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createElementVNode)("button", $1dffb16e9e12720b$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("addPackage")), 1)
                                ]),
                            _: 1
                        }, 8, [
                            "to"
                        ])
                    ])) : (0, $TusQn.createCommentVNode)("", true)
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $1dffb16e9e12720b$var$_hoisted_27, [
                (0, $TusQn.createElementVNode)("div", $1dffb16e9e12720b$var$_hoisted_28, [
                    (0, $TusQn.createElementVNode)("div", $1dffb16e9e12720b$var$_hoisted_29, [
                        (0, $TusQn.createElementVNode)("h5", $1dffb16e9e12720b$var$_hoisted_30, (0, $8POXm.toDisplayString)(_ctx.$t("limits")), 1)
                    ]),
                    $data.data.selectionLimit.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $1dffb16e9e12720b$var$_hoisted_31, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.selectionLimit, (item, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                class: "list-group-item",
                                key: i
                            }, [
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId + "/limit/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ])
                            ]);
                        }), 128))
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1dffb16e9e12720b$var$_hoisted_32, [
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId + "/limitcreate"
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createElementVNode)("button", $1dffb16e9e12720b$var$_hoisted_33, (0, $8POXm.toDisplayString)(_ctx.$t("addLimit")), 1)
                                ]),
                            _: 1
                        }, 8, [
                            "to"
                        ])
                    ])) : (0, $TusQn.createCommentVNode)("", true)
                ])
            ]),
            $data.analysisList.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1dffb16e9e12720b$var$_hoisted_34, [
                (0, $TusQn.createElementVNode)("h3", $1dffb16e9e12720b$var$_hoisted_35, (0, $8POXm.toDisplayString)(_ctx.$t("results")), 1),
                (0, $TusQn.createElementVNode)("table", $1dffb16e9e12720b$var$_hoisted_36, [
                    (0, $TusQn.createElementVNode)("thead", null, [
                        (0, $TusQn.createElementVNode)("tr", null, [
                            (0, $TusQn.createElementVNode)("th", $1dffb16e9e12720b$var$_hoisted_37, (0, $8POXm.toDisplayString)(_ctx.$t("forecastName")), 1),
                            (0, $TusQn.createElementVNode)("th", $1dffb16e9e12720b$var$_hoisted_38, (0, $8POXm.toDisplayString)(_ctx.$t("selectionName")), 1),
                            (0, $TusQn.createElementVNode)("th", $1dffb16e9e12720b$var$_hoisted_39, (0, $8POXm.toDisplayString)(_ctx.$t("selectionStartYear")), 1),
                            (0, $TusQn.createElementVNode)("th", $1dffb16e9e12720b$var$_hoisted_40, (0, $8POXm.toDisplayString)(_ctx.$t("selectionEndYear")), 1),
                            (0, $TusQn.createElementVNode)("th", $1dffb16e9e12720b$var$_hoisted_41, (0, $8POXm.toDisplayString)(_ctx.$t("createdDate")), 1),
                            $1dffb16e9e12720b$var$_hoisted_42,
                            $1dffb16e9e12720b$var$_hoisted_43
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("tbody", null, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.analysisList, (item, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                key: i,
                                class: "align-middle"
                            }, [
                                (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(item.forecastName), 1),
                                (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(item.selectionName), 1),
                                (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(item.selectionStartYear), 1),
                                (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(item.selectionEndYear), 1),
                                (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(this.getCreatedDate(item.createdDate)), 1),
                                (0, $TusQn.createElementVNode)("td", $1dffb16e9e12720b$var$_hoisted_44, [
                                    item.state === 0 || item.state === 201 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $1dffb16e9e12720b$var$_hoisted_45)) : item.state === 500 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $1dffb16e9e12720b$var$_hoisted_46, (0, $8POXm.toDisplayString)(_ctx.$t("resultFailed")), 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_RouterLink, {
                                        key: 2,
                                        to: "/modeling/" + _ctx.$route.params.id + "/modelingresult/" + item.id
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createElementVNode)("button", $1dffb16e9e12720b$var$_hoisted_47, (0, $8POXm.toDisplayString)(_ctx.$t("detail")), 1)
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "to"
                                    ]))
                                ]),
                                (0, $TusQn.createElementVNode)("td", null, [
                                    (0, $TusQn.createElementVNode)("i", {
                                        style: {
                                            "display": "block",
                                            "text-align": "center",
                                            "cursor": "pointer"
                                        },
                                        onClick: ($event)=>$options.showDeleteModelingResultModal(item),
                                        class: "fas fa-sm fa-trash"
                                    }, null, 8, $1dffb16e9e12720b$var$_hoisted_48)
                                ])
                            ]);
                        }), 128))
                    ])
                ])
            ])) : (0, $TusQn.createCommentVNode)("", true)
        ]),
        $data.showAnalyseSelection ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_SelectionAnalyseModal, {
            key: 0,
            onClose: _cache[2] || (_cache[2] = ($event)=>$data.showAnalyseSelection = false),
            onStarted: $options.closeAnalyseSetions,
            onConfirm: _cache[3] || (_cache[3] = ($event)=>$data.showAnalyseSelection = false)
        }, null, 8, [
            "onStarted"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.showModelingResultDelete ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ModelingResultDeleteModal, {
            key: 1,
            onClose: _cache[4] || (_cache[4] = ($event)=>$data.showModelingResultDelete = false),
            onConfirm: $options.confirmModelingResultDeletion
        }, null, 8, [
            "onConfirm"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.showValidateSelection ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_SelectionValidateModal, {
            key: 2,
            onClose: _cache[5] || (_cache[5] = ($event)=>$data.showValidateSelection = false),
            onConfirm: _cache[6] || (_cache[6] = ($event)=>$data.showValidateSelection = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("8LU47", function(module, exports) {

$parcel$export(module.exports, "default", () => $662e33f61dec630d$export$2e2bcd8739ae039);
let $662e33f61dec630d$var$NOOP = ()=>{};
var $662e33f61dec630d$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("3FEOo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2ac4dbcdb5fb02dd$export$2e2bcd8739ae039);

var $fmQKt = parcelRequire("fmQKt");
var $2ac4dbcdb5fb02dd$export$2e2bcd8739ae039 = {
    name: "selectioncreate",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.data.forecastId = this.$route.params.forecastId;
            this.pending = false;
        },
        async onSubmit () {
            try {
                if (this.data.name.length > 0) {
                    this.data.selectionGroup = [
                        {
                            id: 0,
                            name: "All Asset Types",
                            selectionGroupAssetType: []
                        }
                    ];
                    await (0, $fmQKt.default).selectionCreate(this.$route.params.id, this.data);
                    this.showSuccess();
                    this.$router.go(-1);
                } else this.showEmptyNameError();
            } catch  {
                this.showError();
            }
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "selectionCreated",
            type: "success"
        },
        showError: {
            title: "error",
            message: "selectionError",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                id: 0,
                name: "",
                description: "",
                mandatoryVariants: false,
                allowBreakLifecycleVariants: false,
                forecastId: 0,
                selectionMethod: "budget",
                coreBenefitMethod: "significant"
            },
            pending: true,
            modelingName: ""
        };
    }
};

});

parcelRegister("enwjS", function(module, exports) {

$parcel$export(module.exports, "render", () => $a77c48b074bd448c$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $a77c48b074bd448c$var$_hoisted_1 = {
    key: 0
};
const $a77c48b074bd448c$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $a77c48b074bd448c$var$_hoisted_3 = [
    $a77c48b074bd448c$var$_hoisted_2
];
const $a77c48b074bd448c$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $a77c48b074bd448c$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $a77c48b074bd448c$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $a77c48b074bd448c$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $a77c48b074bd448c$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $a77c48b074bd448c$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $a77c48b074bd448c$var$_hoisted_10 = {
    class: "row mb-4"
};
const $a77c48b074bd448c$var$_hoisted_11 = {
    class: "mb-3 col-md-4"
};
const $a77c48b074bd448c$var$_hoisted_12 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $a77c48b074bd448c$var$_hoisted_13 = {
    class: "mb-3 col-md-4"
};
const $a77c48b074bd448c$var$_hoisted_14 = {
    class: "form-label",
    for: "selectionMethod",
    required: ""
};
const $a77c48b074bd448c$var$_hoisted_15 = {
    value: ""
};
const $a77c48b074bd448c$var$_hoisted_16 = {
    value: "budget"
};
const $a77c48b074bd448c$var$_hoisted_17 = {
    class: "mb-3 col-md-4"
};
const $a77c48b074bd448c$var$_hoisted_18 = {
    class: "form-label",
    for: "coreBenefitMethod",
    required: ""
};
const $a77c48b074bd448c$var$_hoisted_19 = {
    value: "significant"
};
const $a77c48b074bd448c$var$_hoisted_20 = {
    value: "performance"
};
const $a77c48b074bd448c$var$_hoisted_21 = {
    class: "mb-3 col-md-12"
};
const $a77c48b074bd448c$var$_hoisted_22 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $a77c48b074bd448c$var$_hoisted_23 = {
    class: "row mb-4"
};
const $a77c48b074bd448c$var$_hoisted_24 = {
    class: "col-2"
};
const $a77c48b074bd448c$var$_hoisted_25 = {
    class: "form-check-label ps-2",
    for: "mandatoryVariants"
};
const $a77c48b074bd448c$var$_hoisted_26 = {
    class: "col-3"
};
const $a77c48b074bd448c$var$_hoisted_27 = {
    class: "form-check-label ps-2",
    for: "allowBreakLifecycleVariants"
};
const $a77c48b074bd448c$var$_hoisted_28 = {
    class: "col-3"
};
const $a77c48b074bd448c$var$_hoisted_29 = {
    class: "form-check-label ps-2",
    for: "allowNotFirstVariants"
};
const $a77c48b074bd448c$var$_hoisted_30 = {
    class: "d-grid gap-2 d-md-flex"
};
function $a77c48b074bd448c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a77c48b074bd448c$var$_hoisted_1, $a77c48b074bd448c$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a77c48b074bd448c$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("selectionCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $a77c48b074bd448c$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $a77c48b074bd448c$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $a77c48b074bd448c$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $a77c48b074bd448c$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $a77c48b074bd448c$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $a77c48b074bd448c$var$_hoisted_10, [
            (0, $TusQn.createElementVNode)("div", $a77c48b074bd448c$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("label", $a77c48b074bd448c$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $a77c48b074bd448c$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("label", $a77c48b074bd448c$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("selectionMethod")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.selectionMethod = $event),
                    class: "form-select"
                }, [
                    (0, $TusQn.createElementVNode)("option", $a77c48b074bd448c$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    (0, $TusQn.createElementVNode)("option", $a77c48b074bd448c$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("budget")), 1)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.selectionMethod
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $a77c48b074bd448c$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("label", $a77c48b074bd448c$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("coreBenefitMethod")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.coreBenefitMethod = $event),
                    class: "form-select"
                }, [
                    (0, $TusQn.createElementVNode)("option", $a77c48b074bd448c$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("significantNumber")), 1),
                    (0, $TusQn.createElementVNode)("option", $a77c48b074bd448c$var$_hoisted_20, (0, $8POXm.toDisplayString)(_ctx.$t("performance")), 1)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.coreBenefitMethod
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $a77c48b074bd448c$var$_hoisted_21, [
                (0, $TusQn.createElementVNode)("label", $a77c48b074bd448c$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $a77c48b074bd448c$var$_hoisted_23, [
            (0, $TusQn.createElementVNode)("div", $a77c48b074bd448c$var$_hoisted_24, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.mandatoryVariants = $event),
                    type: "checkbox",
                    id: "mandatoryVariants"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.mandatoryVariants
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $a77c48b074bd448c$var$_hoisted_25, (0, $8POXm.toDisplayString)(_ctx.$t("mandatoryVariants")), 1)
            ]),
            (0, $TusQn.createElementVNode)("div", $a77c48b074bd448c$var$_hoisted_26, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.data.allowBreakLifecycleVariants = $event),
                    type: "checkbox",
                    id: "allowBreakLifecycleVariants"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.allowBreakLifecycleVariants
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $a77c48b074bd448c$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("allowBreakLifecycleVariants")), 1)
            ]),
            (0, $TusQn.createElementVNode)("div", $a77c48b074bd448c$var$_hoisted_28, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.data.allowNotFirstVariants = $event),
                    type: "checkbox",
                    id: "allowNotFirstVariants"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.allowNotFirstVariants
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $a77c48b074bd448c$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("allowNotFirstVariants")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $a77c48b074bd448c$var$_hoisted_30, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[7] || (_cache[7] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[8] || (_cache[8] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("1SF1e", function(module, exports) {

$parcel$export(module.exports, "default", () => $15eaa712a7ab0552$export$2e2bcd8739ae039);
let $15eaa712a7ab0552$var$NOOP = ()=>{};
var $15eaa712a7ab0552$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("6BFr6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4cf6571d0c6509b8$export$2e2bcd8739ae039);

var $l6otV = parcelRequire("l6otV");

var $gxt0C = parcelRequire("gxt0C");

var $fmQKt = parcelRequire("fmQKt");

var $gOjKo = parcelRequire("gOjKo");

var $90aFZ = parcelRequire("90aFZ");
var $4cf6571d0c6509b8$export$2e2bcd8739ae039 = {
    name: "selectioninfo",
    watch: {
        $route: "requestData"
    },
    components: {
        SelectionDeleteModal: $90aFZ.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var modelingResultList = await (0, $gxt0C.default).analysisList(this.$route.params.id);
            for(var i in modelingResultList){
                var result = modelingResultList[i];
                if (result.selectionId == this.$route.params.selectionId) this.foundSelections.push({
                    resultId: result.id,
                    name: "Modeling Result"
                });
            }
            var selectionId = this.$route.params.selectionId;
            var data = await (0, $fmQKt.default).selectionDetail(this.$route.params.id, selectionId);
            this.data = data;
            if (data.selectionGroup?.length > 0 || data.selectionLimit?.length > 0 || data.selectionPackage.length > 0) this.selectionNotEmpty = true;
            this.pending = false;
        },
        async onSubmit () {
            try {
                if (this.data.name.length > 0) {
                    await (0, $fmQKt.default).selectionUpdate(this.$route.params.id, this.data);
                    this.showSuccess();
                } else this.showEmptyNameError();
            } catch  {
                this.showError();
            }
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "selectionUpdated",
            type: "success"
        },
        showError: {
            title: "error",
            message: "selectionErrorUpdate",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionMethod: ""
            },
            showSelectionDeleteModal: false,
            pending: true,
            modelingName: "",
            isUserAdmin: false,
            foundSelections: [],
            selectionNotEmpty: false
        };
    }
};

});
parcelRegister("90aFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $68dc6538400aab9a$export$2e2bcd8739ae039);
let $68dc6538400aab9a$var$script;



let $68dc6538400aab9a$var$initialize = ()=>{
    $68dc6538400aab9a$var$script = (parcelRequire("hbHNL"));
    if ($68dc6538400aab9a$var$script.__esModule) $68dc6538400aab9a$var$script = $68dc6538400aab9a$var$script.default;
    $68dc6538400aab9a$var$script.render = (parcelRequire("gfCd5")).render;
    (parcelRequire("2MlZv")).default($68dc6538400aab9a$var$script);
    $68dc6538400aab9a$var$script.__scopeId = "data-v-ceb5ee";
    $68dc6538400aab9a$var$script.__file = "SelectionDeleteModal.vue";
};
$68dc6538400aab9a$var$initialize();
var $68dc6538400aab9a$export$2e2bcd8739ae039 = $68dc6538400aab9a$var$script;

});
parcelRegister("hbHNL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c83570dbb78662f8$export$2e2bcd8739ae039);

var $fmQKt = parcelRequire("fmQKt");
var $c83570dbb78662f8$export$2e2bcd8739ae039 = {
    name: "selectionDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteSelection () {
            await (0, $fmQKt.default).selectionDelete(this.$parent.$route.params.id, this.$parent.$route.params.selectionId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("gfCd5", function(module, exports) {

$parcel$export(module.exports, "render", () => $bd4bafc6de68b67a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $bd4bafc6de68b67a$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $bd4bafc6de68b67a$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $bd4bafc6de68b67a$var$_hoisted_3 = {
    class: "modal-content"
};
const $bd4bafc6de68b67a$var$_hoisted_4 = {
    class: "modal-header"
};
const $bd4bafc6de68b67a$var$_hoisted_5 = {
    class: "modal-title"
};
const $bd4bafc6de68b67a$var$_hoisted_6 = {
    class: "modal-body"
};
const $bd4bafc6de68b67a$var$_hoisted_7 = {
    key: 0,
    class: "form-label"
};
const $bd4bafc6de68b67a$var$_hoisted_8 = {
    class: "form-label"
};
const $bd4bafc6de68b67a$var$_hoisted_9 = {
    key: 2
};
const $bd4bafc6de68b67a$var$_hoisted_10 = {
    class: "modal-footer"
};
const $bd4bafc6de68b67a$var$_hoisted_11 = [
    "disabled"
];
function $bd4bafc6de68b67a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $bd4bafc6de68b67a$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $bd4bafc6de68b67a$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $bd4bafc6de68b67a$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $bd4bafc6de68b67a$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $bd4bafc6de68b67a$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("selectionDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $bd4bafc6de68b67a$var$_hoisted_6, [
                                this.$parent.selectionNotEmpty ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("label", $bd4bafc6de68b67a$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("selectionNotEmpty")), 1)) : this.$parent.foundSelections.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 1
                                }, [
                                    (0, $TusQn.createElementVNode)("label", $bd4bafc6de68b67a$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("cannotDeleteSelection")), 1),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(this.$parent.foundSelections, (selection, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                            key: i
                                        }, [
                                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                                to: "/modeling/" + this.$route.params.id + "/modelingresult/" + selection.resultId
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(selection.name) + " - Id: " + (0, $8POXm.toDisplayString)(selection.resultId), 1)
                                                    ]),
                                                _: 2
                                            }, 1032, [
                                                "to"
                                            ])
                                        ]);
                                    }), 128))
                                ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $bd4bafc6de68b67a$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisSelection")), 1))
                            ]),
                            (0, $TusQn.createElementVNode)("div", $bd4bafc6de68b67a$var$_hoisted_10, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteSelection && $options.deleteSelection(...args)),
                                    disabled: this.$parent.foundSelections.length > 0 || this.$parent.selectionNotEmpty
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 9, $bd4bafc6de68b67a$var$_hoisted_11)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("2MlZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $20611f6735e927a5$export$2e2bcd8739ae039);
let $20611f6735e927a5$var$NOOP = ()=>{};
var $20611f6735e927a5$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("eiM2a", function(module, exports) {

$parcel$export(module.exports, "render", () => $a69801a9ec021593$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $a69801a9ec021593$var$_hoisted_1 = {
    key: 0
};
const $a69801a9ec021593$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $a69801a9ec021593$var$_hoisted_3 = [
    $a69801a9ec021593$var$_hoisted_2
];
const $a69801a9ec021593$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $a69801a9ec021593$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $a69801a9ec021593$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $a69801a9ec021593$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $a69801a9ec021593$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $a69801a9ec021593$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $a69801a9ec021593$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $a69801a9ec021593$var$_hoisted_11 = {
    class: "row mb-4"
};
const $a69801a9ec021593$var$_hoisted_12 = {
    class: "mb-3 col-md-4"
};
const $a69801a9ec021593$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $a69801a9ec021593$var$_hoisted_14 = {
    class: "mb-3 col-md-4"
};
const $a69801a9ec021593$var$_hoisted_15 = {
    class: "form-label",
    for: "selectionMethod",
    required: ""
};
const $a69801a9ec021593$var$_hoisted_16 = {
    value: ""
};
const $a69801a9ec021593$var$_hoisted_17 = {
    value: "budget"
};
const $a69801a9ec021593$var$_hoisted_18 = {
    class: "mb-3 col-md-4"
};
const $a69801a9ec021593$var$_hoisted_19 = {
    class: "form-label",
    for: "coreBenefitMethod",
    required: ""
};
const $a69801a9ec021593$var$_hoisted_20 = {
    value: "significant"
};
const $a69801a9ec021593$var$_hoisted_21 = {
    value: "performance"
};
const $a69801a9ec021593$var$_hoisted_22 = {
    class: "mb-3 col-md-12"
};
const $a69801a9ec021593$var$_hoisted_23 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $a69801a9ec021593$var$_hoisted_24 = {
    class: "row mb-4"
};
const $a69801a9ec021593$var$_hoisted_25 = {
    class: "col-2"
};
const $a69801a9ec021593$var$_hoisted_26 = {
    class: "form-check-label ps-2",
    for: "mandatoryVariants"
};
const $a69801a9ec021593$var$_hoisted_27 = {
    class: "col-3"
};
const $a69801a9ec021593$var$_hoisted_28 = {
    class: "form-check-label ps-2",
    for: "allowBreakLifecycleVariants"
};
const $a69801a9ec021593$var$_hoisted_29 = {
    class: "col-3"
};
const $a69801a9ec021593$var$_hoisted_30 = {
    class: "form-check-label ps-2",
    for: "allowNotFirstVariants"
};
const $a69801a9ec021593$var$_hoisted_31 = {
    class: "d-grid gap-2 d-md-flex"
};
function $a69801a9ec021593$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_SelectionDeleteModal = (0, $TusQn.resolveComponent)("SelectionDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a69801a9ec021593$var$_hoisted_1, $a69801a9ec021593$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a69801a9ec021593$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("selectionInfo")), 1),
        (0, $TusQn.createElementVNode)("nav", $a69801a9ec021593$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $a69801a9ec021593$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $a69801a9ec021593$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $a69801a9ec021593$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $a69801a9ec021593$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $a69801a9ec021593$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.data.name) + " detail", 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $a69801a9ec021593$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $a69801a9ec021593$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $a69801a9ec021593$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $a69801a9ec021593$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $a69801a9ec021593$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("selectionMethod")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.selectionMethod = $event),
                    class: "form-select"
                }, [
                    (0, $TusQn.createElementVNode)("option", $a69801a9ec021593$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    (0, $TusQn.createElementVNode)("option", $a69801a9ec021593$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("budget")), 1)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.selectionMethod
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $a69801a9ec021593$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("label", $a69801a9ec021593$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("coreBenefitMethod")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.coreBenefitMethod = $event),
                    class: "form-select"
                }, [
                    (0, $TusQn.createElementVNode)("option", $a69801a9ec021593$var$_hoisted_20, (0, $8POXm.toDisplayString)(_ctx.$t("significantNumber")), 1),
                    (0, $TusQn.createElementVNode)("option", $a69801a9ec021593$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("performance")), 1)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.coreBenefitMethod
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $a69801a9ec021593$var$_hoisted_22, [
                (0, $TusQn.createElementVNode)("label", $a69801a9ec021593$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $a69801a9ec021593$var$_hoisted_24, [
            (0, $TusQn.createElementVNode)("div", $a69801a9ec021593$var$_hoisted_25, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.mandatoryVariants = $event),
                    type: "checkbox",
                    id: "mandatoryVariants"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.mandatoryVariants
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $a69801a9ec021593$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("mandatoryVariants")), 1)
            ]),
            (0, $TusQn.createElementVNode)("div", $a69801a9ec021593$var$_hoisted_27, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.data.allowBreakLifecycleVariants = $event),
                    type: "checkbox",
                    id: "allowBreakLifecycleVariants"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.allowBreakLifecycleVariants
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $a69801a9ec021593$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("allowBreakLifecycleVariants")), 1)
            ]),
            (0, $TusQn.createElementVNode)("div", $a69801a9ec021593$var$_hoisted_29, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.data.allowNotFirstVariants = $event),
                    type: "checkbox",
                    id: "allowNotFirstVariants"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.allowNotFirstVariants
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $a69801a9ec021593$var$_hoisted_30, (0, $8POXm.toDisplayString)(_ctx.$t("allowNotFirstVariants")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $a69801a9ec021593$var$_hoisted_31, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[7] || (_cache[7] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[8] || (_cache[8] = ($event)=>$data.showSelectionDeleteModal = true)
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[9] || (_cache[9] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showSelectionDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_SelectionDeleteModal, {
            key: 0,
            onReload: _cache[10] || (_cache[10] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}`
                })),
            onCloseDeleteDialog: _cache[11] || (_cache[11] = ($event)=>$data.showSelectionDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("c1bPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bfec24284f84f14$export$2e2bcd8739ae039);
let $8bfec24284f84f14$var$NOOP = ()=>{};
var $8bfec24284f84f14$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("2dHfG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $19de58950c959a83$export$2e2bcd8739ae039);

var $l6otV = parcelRequire("l6otV");

var $eHCxc = parcelRequire("eHCxc");

var $eqtu6 = parcelRequire("eqtu6");

var $5Sel1 = parcelRequire("5Sel1");

var $gOjKo = parcelRequire("gOjKo");
var $19de58950c959a83$export$2e2bcd8739ae039 = {
    name: "performancedetail",
    watch: {
        $route: "requestData"
    },
    components: {
        PerformanceDeleteModal: $5Sel1.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        showTableFunction () {
            this.generateGraph();
            this.showTable = !this.showTable;
        },
        updateTheoreticalAgeStart (value, i) {
            var range = this.data.performanceRanges[i + 1];
            if (range) range.startTheoreticalAge = value;
            // Pokud je hodnota vyšší než lifespan, nastavíme lifespan
            if (value > this.data.lifespan) this.data.performanceRanges[i].endTheoreticalAge = this.data.lifespan;
        },
        updateAssetPerformanceStart (value, i) {
            var range = this.data.performanceRanges[i + 1];
            if (range) range.startAssetPerformance = value;
        },
        generateGraph () {
            let seriesData = [];
            for (let performance of this.data.performanceRanges){
                seriesData.push({
                    x: performance.startTheoreticalAge,
                    y: performance.startAssetPerformance
                });
                seriesData.push({
                    x: performance.endTheoreticalAge,
                    y: performance.endAssetPerformance
                });
            }
            this.series = [
                {
                    name: "Asset Performance",
                    data: seriesData
                }
            ];
        },
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var modelingInfo = await (0, $l6otV.default).modelingInfo(this.$route.params.id);
            var foundAssetType = modelingInfo.assetTypes.find((a)=>a.id == this.$route.params.assetTypeId);
            if (foundAssetType != null) for(var i in foundAssetType.lifeCycles){
                var lifeCycle = foundAssetType.lifeCycles[i];
                var performance = lifeCycle.performance;
                if (performance && performance.id == this.$route.params.performanceId) this.foundPerformances.push({
                    lifeCycleId: lifeCycle.id,
                    performanceId: performance.performanceId,
                    name: "LifeCycle - " + lifeCycle.name + " - " + performance.name
                });
            }
            this.data = await (0, $eqtu6.default).performanceDetail(this.$route.params.id, this.$route.params.performanceId);
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        removePerformanceRange (rowIndex) {
            this.data.performanceRanges.splice(rowIndex, 1);
        },
        addPerformanceRange () {
            this.data.performanceRanges.push({
                description: "",
                startTheoreticalAge: this.getMinStartTheoreticalAge(),
                endTheoreticalAge: 0,
                startAssetPerformance: this.getMinStartAssetPerformance(),
                endAssetPerformance: 0.0
            });
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                const max = Math.max(...this.data.performanceRanges.map((o)=>o.endTheoreticalAge));
                if (max > this.data.lifespan) this.showLifespanError();
                else {
                    await (0, $eqtu6.default).performanceUpdate(this.$route.params.id, this.data);
                    this.showSuccess();
                }
            } else this.showEmptyNameError();
        },
        getMinStartTheoreticalAge () {
            var minStartTheoreticalAge = 0;
            if (this.data.performanceRanges.length > 0) minStartTheoreticalAge = this.data.performanceRanges[this.data.performanceRanges.length - 1].endTheoreticalAge;
            return minStartTheoreticalAge;
        },
        getMinStartAssetPerformance () {
            var minStartAssetPerformance = 0;
            if (this.data.performanceRanges.length > 0) minStartAssetPerformance = this.data.performanceRanges[this.data.performanceRanges.length - 1].endAssetPerformance;
            return minStartAssetPerformance;
        },
        showDeletePerformance () {
            this.performanceToDeleteId = this.data.id;
            this.showPerformanceDeleteModal = true;
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "performanceUpdated",
            type: "success"
        },
        showLifespanError: {
            title: "error",
            message: "lifespanError",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: "",
                performance: {},
                performanceRanges: []
            },
            performanceToDeleteId: 0,
            showPerformanceDeleteModal: false,
            modelingName: null,
            assetTypeName: null,
            pending: true,
            showTable: true,
            chartOptions: {
                chart: {
                    type: "line",
                    animations: {
                        enabled: false
                    },
                    height: 350,
                    toolbar: {
                        show: false
                    }
                },
                xaxis: {
                    title: {
                        text: "Theoretical Age"
                    },
                    categories: []
                },
                yaxis: {
                    title: {
                        text: "Asset Performance"
                    }
                }
            },
            series: [],
            foundPerformances: [],
            isUserAdmin: false
        };
    }
};

});
parcelRegister("eqtu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a80a5d6a12392201$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $a80a5d6a12392201$var$performanceApi = {
    performanceList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/performance`);
        const res = await req;
        return res.body;
    },
    performanceDetail: async (modelingId, performance)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/performance/${performance}`);
        const res = await req;
        return res.body;
    },
    performanceUpdate: async (modelingId, performance)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/performance/${performance.id}`).send(performance);
        const res = await req;
        return res.body;
    },
    performanceCreate: async (modelingId, performance)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/performance`).send(performance);
        const res = await req;
        return res.body;
    },
    performanceDelete: async (modelingId, performanceId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/performance/${performanceId}`);
        await req;
    }
};
var $a80a5d6a12392201$export$2e2bcd8739ae039 = $a80a5d6a12392201$var$performanceApi;

});

parcelRegister("5Sel1", function(module, exports) {

$parcel$export(module.exports, "default", () => $446d1e1f25702bfe$export$2e2bcd8739ae039);
let $446d1e1f25702bfe$var$script;



let $446d1e1f25702bfe$var$initialize = ()=>{
    $446d1e1f25702bfe$var$script = (parcelRequire("gvBIw"));
    if ($446d1e1f25702bfe$var$script.__esModule) $446d1e1f25702bfe$var$script = $446d1e1f25702bfe$var$script.default;
    $446d1e1f25702bfe$var$script.render = (parcelRequire("doZM6")).render;
    (parcelRequire("8y4US")).default($446d1e1f25702bfe$var$script);
    $446d1e1f25702bfe$var$script.__scopeId = "data-v-0ea09e";
    $446d1e1f25702bfe$var$script.__file = "PerformanceDeleteModal.vue";
};
$446d1e1f25702bfe$var$initialize();
var $446d1e1f25702bfe$export$2e2bcd8739ae039 = $446d1e1f25702bfe$var$script;

});
parcelRegister("gvBIw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c04ccc6e50c5b2ef$export$2e2bcd8739ae039);

var $eqtu6 = parcelRequire("eqtu6");
var $c04ccc6e50c5b2ef$export$2e2bcd8739ae039 = {
    name: "performanceDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deletePerformance () {
            await (0, $eqtu6.default).performanceDelete(this.$parent.$route.params.id, this.$parent.performanceToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("doZM6", function(module, exports) {

$parcel$export(module.exports, "render", () => $9c1d6f6fdc5fc625$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $9c1d6f6fdc5fc625$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $9c1d6f6fdc5fc625$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $9c1d6f6fdc5fc625$var$_hoisted_3 = {
    class: "modal-content"
};
const $9c1d6f6fdc5fc625$var$_hoisted_4 = {
    class: "modal-header"
};
const $9c1d6f6fdc5fc625$var$_hoisted_5 = {
    class: "modal-title"
};
const $9c1d6f6fdc5fc625$var$_hoisted_6 = {
    class: "modal-body"
};
const $9c1d6f6fdc5fc625$var$_hoisted_7 = {
    class: "form-label"
};
const $9c1d6f6fdc5fc625$var$_hoisted_8 = {
    key: 1
};
const $9c1d6f6fdc5fc625$var$_hoisted_9 = {
    class: "modal-footer"
};
const $9c1d6f6fdc5fc625$var$_hoisted_10 = [
    "disabled"
];
function $9c1d6f6fdc5fc625$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $9c1d6f6fdc5fc625$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $9c1d6f6fdc5fc625$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $9c1d6f6fdc5fc625$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $9c1d6f6fdc5fc625$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $9c1d6f6fdc5fc625$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("performanceDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $9c1d6f6fdc5fc625$var$_hoisted_6, [
                                this.$parent.foundPerformances.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 0
                                }, [
                                    (0, $TusQn.createElementVNode)("label", $9c1d6f6fdc5fc625$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("cannotDeletePerformance")), 1),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(this.$parent.foundPerformances, (performance, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                            key: i
                                        }, [
                                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                                to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/lifecycle/" + performance.lifeCycleId
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(performance.name), 1)
                                                    ]),
                                                _: 2
                                            }, 1032, [
                                                "to"
                                            ])
                                        ]);
                                    }), 128))
                                ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $9c1d6f6fdc5fc625$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisPerformance")), 1))
                            ]),
                            (0, $TusQn.createElementVNode)("div", $9c1d6f6fdc5fc625$var$_hoisted_9, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deletePerformance && $options.deletePerformance(...args)),
                                    disabled: this.$parent.foundPerformances.length > 0
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 9, $9c1d6f6fdc5fc625$var$_hoisted_10)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("8y4US", function(module, exports) {

$parcel$export(module.exports, "default", () => $63954ff8651bb984$export$2e2bcd8739ae039);
let $63954ff8651bb984$var$NOOP = ()=>{};
var $63954ff8651bb984$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("bbT5L", function(module, exports) {

$parcel$export(module.exports, "render", () => $825b74e8c7294bfe$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $825b74e8c7294bfe$var$_hoisted_1 = {
    key: 0
};
const $825b74e8c7294bfe$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $825b74e8c7294bfe$var$_hoisted_3 = [
    $825b74e8c7294bfe$var$_hoisted_2
];
const $825b74e8c7294bfe$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $825b74e8c7294bfe$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $825b74e8c7294bfe$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $825b74e8c7294bfe$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $825b74e8c7294bfe$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $825b74e8c7294bfe$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $825b74e8c7294bfe$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $825b74e8c7294bfe$var$_hoisted_11 = {
    class: "row mb-4"
};
const $825b74e8c7294bfe$var$_hoisted_12 = {
    class: "col-md-4"
};
const $825b74e8c7294bfe$var$_hoisted_13 = {
    class: "form-label",
    for: "performanceName",
    required: ""
};
const $825b74e8c7294bfe$var$_hoisted_14 = {
    class: "col-md-4"
};
const $825b74e8c7294bfe$var$_hoisted_15 = {
    class: "form-label",
    for: "performanceDescription",
    required: ""
};
const $825b74e8c7294bfe$var$_hoisted_16 = {
    class: "col-md-4"
};
const $825b74e8c7294bfe$var$_hoisted_17 = {
    class: "form-label",
    for: "performanceLifespan",
    required: ""
};
const $825b74e8c7294bfe$var$_hoisted_18 = {
    key: 0,
    class: "mb-4"
};
const $825b74e8c7294bfe$var$_hoisted_19 = {
    class: "table"
};
const $825b74e8c7294bfe$var$_hoisted_20 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $825b74e8c7294bfe$var$_hoisted_21 = {
    scope: "col"
};
const $825b74e8c7294bfe$var$_hoisted_22 = {
    scope: "col"
};
const $825b74e8c7294bfe$var$_hoisted_23 = {
    scope: "col"
};
const $825b74e8c7294bfe$var$_hoisted_24 = {
    scope: "col"
};
const $825b74e8c7294bfe$var$_hoisted_25 = {
    scope: "row"
};
const $825b74e8c7294bfe$var$_hoisted_26 = [
    "onClick"
];
const $825b74e8c7294bfe$var$_hoisted_27 = [
    "onUpdate:modelValue",
    "id"
];
const $825b74e8c7294bfe$var$_hoisted_28 = [
    "onUpdate:modelValue",
    "max",
    "onInput",
    "id"
];
const $825b74e8c7294bfe$var$_hoisted_29 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $825b74e8c7294bfe$var$_hoisted_30 = [
    "onUpdate:modelValue",
    "onInput",
    "id"
];
const $825b74e8c7294bfe$var$_hoisted_31 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $825b74e8c7294bfe$var$_hoisted_32 = [
    $825b74e8c7294bfe$var$_hoisted_31
];
const $825b74e8c7294bfe$var$_hoisted_33 = {
    key: 1,
    class: "mb-4"
};
const $825b74e8c7294bfe$var$_hoisted_34 = {
    class: "d-grid gap-2 d-md-flex"
};
function $825b74e8c7294bfe$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_apexchart = (0, $TusQn.resolveComponent)("apexchart");
    const _component_PerformanceDeleteModal = (0, $TusQn.resolveComponent)("PerformanceDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $825b74e8c7294bfe$var$_hoisted_1, $825b74e8c7294bfe$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $825b74e8c7294bfe$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("performanceDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $825b74e8c7294bfe$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $825b74e8c7294bfe$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $825b74e8c7294bfe$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $825b74e8c7294bfe$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $825b74e8c7294bfe$var$_hoisted_9, [
                    (0, $TusQn.createElementVNode)("a", {
                        class: "link",
                        style: {
                            "cursor": "pointer"
                        },
                        onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$router.go(-1))
                    }, (0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                ]),
                (0, $TusQn.createElementVNode)("li", $825b74e8c7294bfe$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $825b74e8c7294bfe$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $825b74e8c7294bfe$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $825b74e8c7294bfe$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("performanceName")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "performanceName"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $825b74e8c7294bfe$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $825b74e8c7294bfe$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("performanceDescription")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "performanceDescription"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $825b74e8c7294bfe$var$_hoisted_16, [
                (0, $TusQn.createElementVNode)("label", $825b74e8c7294bfe$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("performanceLifespan")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.lifespan = $event),
                    type: "text",
                    class: "form-control",
                    id: "performanceLifespan"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.lifespan
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            class: "fa fa-eye btn btn-outline-primary float-end",
            onClick: _cache[4] || (_cache[4] = (...args)=>$options.showTableFunction && $options.showTableFunction(...args))
        }),
        $data.showTable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $825b74e8c7294bfe$var$_hoisted_18, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("performanceRanges")), 1),
            (0, $TusQn.createElementVNode)("table", $825b74e8c7294bfe$var$_hoisted_19, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $825b74e8c7294bfe$var$_hoisted_20,
                        (0, $TusQn.createElementVNode)("th", $825b74e8c7294bfe$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("startTheoreticalAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $825b74e8c7294bfe$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("endTheoreticalAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $825b74e8c7294bfe$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("startAssetPerformance")), 1),
                        (0, $TusQn.createElementVNode)("th", $825b74e8c7294bfe$var$_hoisted_24, (0, $8POXm.toDisplayString)(_ctx.$t("endAssetPerformance")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.performanceRanges, (performanceRange, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $825b74e8c7294bfe$var$_hoisted_25, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removePerformanceRange(i)
                                }, null, 8, $825b74e8c7294bfe$var$_hoisted_26)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>performanceRange.startTheoreticalAge = $event,
                                    disabled: "",
                                    type: "number",
                                    class: "form-control",
                                    id: "startTheoreticalAge_" + i
                                }, null, 8, $825b74e8c7294bfe$var$_hoisted_27), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        performanceRange.startTheoreticalAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>performanceRange.endTheoreticalAge = $event,
                                    max: $data.data.lifespan,
                                    onInput: ($event)=>$options.updateTheoreticalAgeStart(performanceRange.endTheoreticalAge, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endTheoreticalAge_" + i
                                }, null, 40, $825b74e8c7294bfe$var$_hoisted_28), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        performanceRange.endTheoreticalAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>performanceRange.startAssetPerformance = $event,
                                    disabled: i > 0,
                                    type: "number",
                                    class: "form-control",
                                    id: "startAssetPerformance_" + i
                                }, null, 8, $825b74e8c7294bfe$var$_hoisted_29), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        performanceRange.startAssetPerformance
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>performanceRange.endAssetPerformance = $event,
                                    onInput: ($event)=>$options.updateAssetPerformanceStart(performanceRange.endAssetPerformance, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endAssetPerformance_" + i
                                }, null, 40, $825b74e8c7294bfe$var$_hoisted_30), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        performanceRange.endAssetPerformance
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[5] || (_cache[5] = (...args)=>$options.addPerformanceRange && $options.addPerformanceRange(...args))
            }, $825b74e8c7294bfe$var$_hoisted_32)
        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $825b74e8c7294bfe$var$_hoisted_33, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("performanceRangesChart")), 1),
            (0, $TusQn.createVNode)(_component_apexchart, {
                class: "d-flex justify-content-center",
                type: "line",
                width: "800px",
                options: $data.chartOptions,
                series: $data.series
            }, null, 8, [
                "options",
                "series"
            ])
        ])),
        (0, $TusQn.createElementVNode)("div", $825b74e8c7294bfe$var$_hoisted_34, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[6] || (_cache[6] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[7] || (_cache[7] = (...args)=>$options.showDeletePerformance && $options.showDeletePerformance(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[8] || (_cache[8] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showPerformanceDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_PerformanceDeleteModal, {
            key: 2,
            onReload: _cache[9] || (_cache[9] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                })),
            onCloseDeleteDialog: _cache[10] || (_cache[10] = ($event)=>$data.showPerformanceDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("HAyNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0830605eab62624d$export$2e2bcd8739ae039);
let $0830605eab62624d$var$NOOP = ()=>{};
var $0830605eab62624d$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("lHYFU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fcdcaded94dc91eb$export$2e2bcd8739ae039);

var $l6otV = parcelRequire("l6otV");

var $eHCxc = parcelRequire("eHCxc");

var $eqtu6 = parcelRequire("eqtu6");
var $fcdcaded94dc91eb$export$2e2bcd8739ae039 = {
    name: "performanceCreate",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        updateTheoreticalAgeStart (value, i) {
            var range = this.data.performanceRanges[i + 1];
            if (range) range.startTheoreticalAge = value;
        },
        updateAssetPerformanceStart (value, i) {
            var range = this.data.performanceRanges[i + 1];
            if (range) range.startAssetPerformance = value;
        },
        async requestData () {
            this.pending = true;
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                const max = Math.max(...this.data.performanceRanges.map((o)=>o.endTheoreticalAge));
                if (max > this.data.lifespan) this.showLifespanError();
                else {
                    this.data.assetTypeId = this.$route.params.assetTypeId;
                    await (0, $eqtu6.default).performanceCreate(this.$route.params.id, this.data);
                    this.$router.go(-1);
                }
            } else this.showEmptyNameError();
        },
        removePerformanceRange (rowIndex) {
            this.data.performanceRanges.splice(rowIndex, 1);
        },
        addPerformanceRange () {
            this.data.performanceRanges.push({
                description: "",
                startTheoreticalAge: this.getMinStartTheoreticalAge(),
                endTheoreticalAge: 0,
                startAssetPerformance: this.getMinStartAssetPerformance(),
                endAssetPerformance: 0.0,
                color: "#000000"
            });
        },
        getMinStartTheoreticalAge () {
            var minStartTheoreticalAge = 0;
            if (this.data.performanceRanges.length > 0) minStartTheoreticalAge = this.data.performanceRanges[this.data.performanceRanges.length - 1].endTheoreticalAge;
            return minStartTheoreticalAge;
        },
        getMinStartAssetPerformance () {
            var minStartAssetPerformance = 0;
            if (this.data.performanceRanges.length > 0) minStartAssetPerformance = this.data.performanceRanges[this.data.performanceRanges.length - 1].endAssetPerformance;
            return minStartAssetPerformance;
        }
    },
    notifications: {
        showLifespanError: {
            title: "error",
            message: "lifespanError",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0,
                lifespan: 0,
                performanceRanges: [
                    {
                        name: "",
                        startTheoreticalAge: 0,
                        endTheoreticalAge: 0,
                        startAssetPerformance: 0.0,
                        endAssetPerformance: 0.0,
                        color: "#000000"
                    }
                ]
            },
            modelingName: null,
            assetTypeName: null,
            pending: true
        };
    }
};

});

parcelRegister("468lg", function(module, exports) {

$parcel$export(module.exports, "render", () => $2fbe318135e9ef4e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $2fbe318135e9ef4e$var$_hoisted_1 = {
    key: 0
};
const $2fbe318135e9ef4e$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $2fbe318135e9ef4e$var$_hoisted_3 = [
    $2fbe318135e9ef4e$var$_hoisted_2
];
const $2fbe318135e9ef4e$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $2fbe318135e9ef4e$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $2fbe318135e9ef4e$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $2fbe318135e9ef4e$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $2fbe318135e9ef4e$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $2fbe318135e9ef4e$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $2fbe318135e9ef4e$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $2fbe318135e9ef4e$var$_hoisted_11 = {
    class: "row mb-4"
};
const $2fbe318135e9ef4e$var$_hoisted_12 = {
    class: "col-md-4"
};
const $2fbe318135e9ef4e$var$_hoisted_13 = {
    class: "form-label",
    for: "performanceName",
    required: ""
};
const $2fbe318135e9ef4e$var$_hoisted_14 = {
    class: "col-md-4"
};
const $2fbe318135e9ef4e$var$_hoisted_15 = {
    class: "form-label",
    for: "performanceDescription",
    required: ""
};
const $2fbe318135e9ef4e$var$_hoisted_16 = {
    class: "col-md-4"
};
const $2fbe318135e9ef4e$var$_hoisted_17 = {
    class: "form-label",
    for: "performanceLifespan",
    required: ""
};
const $2fbe318135e9ef4e$var$_hoisted_18 = {
    class: "mb-4"
};
const $2fbe318135e9ef4e$var$_hoisted_19 = {
    class: "table"
};
const $2fbe318135e9ef4e$var$_hoisted_20 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $2fbe318135e9ef4e$var$_hoisted_21 = {
    scope: "col"
};
const $2fbe318135e9ef4e$var$_hoisted_22 = {
    scope: "col"
};
const $2fbe318135e9ef4e$var$_hoisted_23 = {
    scope: "col"
};
const $2fbe318135e9ef4e$var$_hoisted_24 = {
    scope: "col"
};
const $2fbe318135e9ef4e$var$_hoisted_25 = {
    scope: "row"
};
const $2fbe318135e9ef4e$var$_hoisted_26 = [
    "onClick"
];
const $2fbe318135e9ef4e$var$_hoisted_27 = [
    "onUpdate:modelValue",
    "id"
];
const $2fbe318135e9ef4e$var$_hoisted_28 = [
    "onUpdate:modelValue",
    "max",
    "onInput",
    "id"
];
const $2fbe318135e9ef4e$var$_hoisted_29 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $2fbe318135e9ef4e$var$_hoisted_30 = [
    "onUpdate:modelValue",
    "onInput",
    "id"
];
const $2fbe318135e9ef4e$var$_hoisted_31 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $2fbe318135e9ef4e$var$_hoisted_32 = [
    $2fbe318135e9ef4e$var$_hoisted_31
];
const $2fbe318135e9ef4e$var$_hoisted_33 = {
    class: "d-grid gap-2 d-md-flex"
};
function $2fbe318135e9ef4e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2fbe318135e9ef4e$var$_hoisted_1, $2fbe318135e9ef4e$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2fbe318135e9ef4e$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("performanceCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $2fbe318135e9ef4e$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $2fbe318135e9ef4e$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $2fbe318135e9ef4e$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $2fbe318135e9ef4e$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $2fbe318135e9ef4e$var$_hoisted_9, [
                    (0, $TusQn.createElementVNode)("a", {
                        class: "link",
                        style: {
                            "cursor": "pointer"
                        },
                        onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$router.go(-1))
                    }, (0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                ]),
                (0, $TusQn.createElementVNode)("li", $2fbe318135e9ef4e$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("performanceCreate")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $2fbe318135e9ef4e$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $2fbe318135e9ef4e$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $2fbe318135e9ef4e$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("performanceName")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "performanceName"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $2fbe318135e9ef4e$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $2fbe318135e9ef4e$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("performanceDescription")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "performanceDescription"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $2fbe318135e9ef4e$var$_hoisted_16, [
                (0, $TusQn.createElementVNode)("label", $2fbe318135e9ef4e$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("performanceLifespan")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.lifespan = $event),
                    type: "text",
                    class: "form-control",
                    id: "performanceLifespan"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.lifespan
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $2fbe318135e9ef4e$var$_hoisted_18, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("performanceRanges")), 1),
            (0, $TusQn.createElementVNode)("table", $2fbe318135e9ef4e$var$_hoisted_19, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $2fbe318135e9ef4e$var$_hoisted_20,
                        (0, $TusQn.createElementVNode)("th", $2fbe318135e9ef4e$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("startTheoreticalAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $2fbe318135e9ef4e$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("endTheoreticalAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $2fbe318135e9ef4e$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("startAssetPerformance")), 1),
                        (0, $TusQn.createElementVNode)("th", $2fbe318135e9ef4e$var$_hoisted_24, (0, $8POXm.toDisplayString)(_ctx.$t("endAssetPerformance")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.performanceRanges, (performanceRange, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $2fbe318135e9ef4e$var$_hoisted_25, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removePerformanceRange(i)
                                }, null, 8, $2fbe318135e9ef4e$var$_hoisted_26)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>performanceRange.startTheoreticalAge = $event,
                                    disabled: "",
                                    type: "number",
                                    class: "form-control",
                                    id: "startTheoreticalAge_" + i
                                }, null, 8, $2fbe318135e9ef4e$var$_hoisted_27), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        performanceRange.startTheoreticalAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>performanceRange.endTheoreticalAge = $event,
                                    max: $data.data.lifespan,
                                    onInput: ($event)=>$options.updateTheoreticalAgeStart(performanceRange.endTheoreticalAge, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endTheoreticalAge_" + i
                                }, null, 40, $2fbe318135e9ef4e$var$_hoisted_28), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        performanceRange.endTheoreticalAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>performanceRange.startAssetPerformance = $event,
                                    disabled: i > 0,
                                    type: "number",
                                    class: "form-control",
                                    id: "startAssetPerformance_" + i
                                }, null, 8, $2fbe318135e9ef4e$var$_hoisted_29), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        performanceRange.startAssetPerformance
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>performanceRange.endAssetPerformance = $event,
                                    onInput: ($event)=>$options.updateAssetPerformanceStart(performanceRange.endAssetPerformance, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endAssetPerformance_" + i
                                }, null, 40, $2fbe318135e9ef4e$var$_hoisted_30), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        performanceRange.endAssetPerformance
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[4] || (_cache[4] = (...args)=>$options.addPerformanceRange && $options.addPerformanceRange(...args))
            }, $2fbe318135e9ef4e$var$_hoisted_32)
        ]),
        (0, $TusQn.createElementVNode)("div", $2fbe318135e9ef4e$var$_hoisted_33, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[5] || (_cache[5] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[6] || (_cache[6] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("e1W4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $a36e357bb8349685$export$2e2bcd8739ae039);
let $a36e357bb8349685$var$NOOP = ()=>{};
var $a36e357bb8349685$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("hykzY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cc759343941ab6b4$export$2e2bcd8739ae039);

var $2E8nV = parcelRequire("2E8nV");

var $l6otV = parcelRequire("l6otV");

var $bpHT7 = parcelRequire("bpHT7");
var $cc759343941ab6b4$export$2e2bcd8739ae039 = {
    name: "modelingdetail",
    watch: {
        $route: "requestData"
    },
    components: {
        GroupToModelingDialog: $2E8nV.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async saveModeling () {
            this.data.content = JSON.stringify(this.content);
            await (0, $l6otV.default).modelingUpdate(this.data);
            this.showSuccess();
        },
        async requestData () {
            var data = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.content = JSON.parse(data.content);
            this.data = data;
            this.groups = await (0, $bpHT7.default).list();
        },
        confirmModal (modalData) {
            this.modalData = modalData;
            this.data.groupName = modalData.name;
            this.data.groupId = modalData.id;
            this.closeModal();
        },
        showModal () {
            this.isModalVisible = true;
        },
        closeModal () {
            this.isModalVisible = false;
        },
        groupCheck (group, event) {
            if (!this.content.groups) this.content.groups = [];
            if (event.target.checked) {
                var index = this.content.groups.findIndex((f)=>f.groupId == group.id);
                if (index < 0) this.content.groups.push({
                    "groupId": group.id
                });
            } else {
                var index = this.content.groups.findIndex((f)=>f.groupId == group.id);
                if (index >= 0) this.content.groups.splice(index, 1);
            }
        },
        isGroupChecked (item) {
            return this.content["groups"]?.findIndex((f)=>f["groupId"] == item.id) >= 0;
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "modelingUpdated",
            type: "success"
        }
    },
    data () {
        return {
            groups: [],
            content: {},
            data: {
                name: "",
                groupName: "",
                groups: [],
                groupId: 0
            },
            isModalVisible: false
        };
    }
};

});
parcelRegister("2E8nV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ed5d2469409b3f6$export$2e2bcd8739ae039);
let $1ed5d2469409b3f6$var$script;



let $1ed5d2469409b3f6$var$initialize = ()=>{
    $1ed5d2469409b3f6$var$script = (parcelRequire("dZrDQ"));
    if ($1ed5d2469409b3f6$var$script.__esModule) $1ed5d2469409b3f6$var$script = $1ed5d2469409b3f6$var$script.default;
    $1ed5d2469409b3f6$var$script.render = (parcelRequire("1xQJ9")).render;
    (parcelRequire("aUxiD")).default($1ed5d2469409b3f6$var$script);
    $1ed5d2469409b3f6$var$script.__scopeId = "data-v-8f5025";
    $1ed5d2469409b3f6$var$script.__file = "GroupToModelingDialog.vue";
};
$1ed5d2469409b3f6$var$initialize();
var $1ed5d2469409b3f6$export$2e2bcd8739ae039 = $1ed5d2469409b3f6$var$script;

});
parcelRegister("dZrDQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a2f669f07897c975$export$2e2bcd8739ae039);

var $bpHT7 = parcelRequire("bpHT7");
var $a2f669f07897c975$export$2e2bcd8739ae039 = {
    name: "GroupToUserDialog",
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            try {
                this.list = await (0, $bpHT7.default).list();
                this.checked();
            } catch (error) {}
        },
        checked (id) {
            if (this.$parent.data && this.$parent.data.groupId && this.$parent.data.groupId === id) return true;
            else return false;
        },
        onChange (data) {
            this.selectedRadio = data;
        },
        close () {
            this.$emit("close");
        },
        confirm () {
            this.$emit("confirm", this.selectedRadio);
        }
    },
    data () {
        return {
            list: [],
            selectedRadio: {}
        };
    }
};

});
parcelRegister("bpHT7", function(module, exports) {

$parcel$export(module.exports, "default", () => $84f412c22abfd646$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $84f412c22abfd646$var$GroupApi = {
    list: async ()=>{
        const req = (0, $f5Koy.default).get(`/api/group`);
        const res = await req;
        return res.body;
    },
    detail: async (group)=>{
        const req = (0, $f5Koy.default).get(`/api/group/${group}`);
        const res = await req;
        return res.body;
    },
    setPassword: async (id, password)=>{
        const req = (0, $f5Koy.default).put(`/api/group/${id}/resetpassword`).send(password);
        const res = await req;
        return res.body;
    },
    update: async (group)=>{
        const req = (0, $f5Koy.default).put(`/api/group/${group.id}`).send(group);
        const res = await req;
        return res.body;
    },
    create: async (group)=>{
        const req = (0, $f5Koy.default).post(`/api/group`).send(group);
        const res = await req;
        return res.body;
    },
    delete: async (groupId)=>{
        const req = (0, $f5Koy.default).delete(`/api/group/${groupId}`);
        await req;
    }
};
var $84f412c22abfd646$export$2e2bcd8739ae039 = $84f412c22abfd646$var$GroupApi;

});


parcelRegister("1xQJ9", function(module, exports) {

$parcel$export(module.exports, "render", () => $1201c6085fe565a2$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $1201c6085fe565a2$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
};
const $1201c6085fe565a2$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg",
    role: "document"
};
const $1201c6085fe565a2$var$_hoisted_3 = {
    class: "modal-content"
};
const $1201c6085fe565a2$var$_hoisted_4 = {
    class: "modal-header"
};
const $1201c6085fe565a2$var$_hoisted_5 = {
    class: "modal-title"
};
const $1201c6085fe565a2$var$_hoisted_6 = {
    class: "modal-body",
    style: {
        "padding": "0",
        "height": "196px"
    }
};
const $1201c6085fe565a2$var$_hoisted_7 = {
    class: "table"
};
const $1201c6085fe565a2$var$_hoisted_8 = {
    key: 0,
    class: "bodyDialog"
};
const $1201c6085fe565a2$var$_hoisted_9 = {
    class: "form-check"
};
const $1201c6085fe565a2$var$_hoisted_10 = [
    "for"
];
const $1201c6085fe565a2$var$_hoisted_11 = [
    "checked",
    "id",
    "onChange"
];
const $1201c6085fe565a2$var$_hoisted_12 = {
    class: "modal-footer"
};
function $1201c6085fe565a2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $1201c6085fe565a2$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $1201c6085fe565a2$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $1201c6085fe565a2$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $1201c6085fe565a2$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $1201c6085fe565a2$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $1201c6085fe565a2$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("table", $1201c6085fe565a2$var$_hoisted_7, [
                                    $data.list.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $1201c6085fe565a2$var$_hoisted_8, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.list, (item, i)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                                key: i
                                            }, [
                                                (0, $TusQn.createElementVNode)("td", $1201c6085fe565a2$var$_hoisted_9, [
                                                    (0, $TusQn.createElementVNode)("label", {
                                                        style: {
                                                            "padding-left": "20px"
                                                        },
                                                        class: "margin form-check-label",
                                                        for: item.id
                                                    }, [
                                                        (0, $TusQn.createElementVNode)("input", {
                                                            checked: $options.checked(item.id),
                                                            id: item.id,
                                                            type: "radio",
                                                            class: "form-check-input",
                                                            onChange: ($event)=>$options.onChange({
                                                                    id: item.id,
                                                                    name: item.name
                                                                }),
                                                            name: "optradio"
                                                        }, null, 40, $1201c6085fe565a2$var$_hoisted_11),
                                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                                    ], 8, $1201c6085fe565a2$var$_hoisted_10)
                                                ])
                                            ]);
                                        }), 128))
                                    ])) : (0, $TusQn.createCommentVNode)("", true)
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("div", $1201c6085fe565a2$var$_hoisted_12, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.confirm && $options.confirm(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("confirm")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("aUxiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f18f6f7c5a37616$export$2e2bcd8739ae039);
let $7f18f6f7c5a37616$var$NOOP = ()=>{};
var $7f18f6f7c5a37616$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("38ifr", function(module, exports) {

$parcel$export(module.exports, "render", () => $248046208ca2e946$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $248046208ca2e946$var$_hoisted_1 = {
    class: "container py-5"
};
const $248046208ca2e946$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $248046208ca2e946$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $248046208ca2e946$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $248046208ca2e946$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $248046208ca2e946$var$_hoisted_6 = {
    class: "row mb-3"
};
const $248046208ca2e946$var$_hoisted_7 = {
    class: "col-md-6"
};
const $248046208ca2e946$var$_hoisted_8 = {
    class: "form-label"
};
const $248046208ca2e946$var$_hoisted_9 = {
    class: "col-md-6"
};
const $248046208ca2e946$var$_hoisted_10 = {
    class: "form-label"
};
const $248046208ca2e946$var$_hoisted_11 = {
    class: "row col-md-12"
};
const $248046208ca2e946$var$_hoisted_12 = {
    class: "form-label"
};
const $248046208ca2e946$var$_hoisted_13 = {
    class: "input-group mb-3"
};
const $248046208ca2e946$var$_hoisted_14 = [
    "for"
];
const $248046208ca2e946$var$_hoisted_15 = {
    class: "input-group-text"
};
const $248046208ca2e946$var$_hoisted_16 = [
    "id",
    "onChange",
    "checked"
];
const $248046208ca2e946$var$_hoisted_17 = {
    class: "row mb-3"
};
const $248046208ca2e946$var$_hoisted_18 = {
    class: "col-md-6"
};
const $248046208ca2e946$var$_hoisted_19 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "form-label",
    style: {
        "display": "block"
    }
}, "\xa0", -1);
function $248046208ca2e946$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_GroupToModelingDialog = (0, $TusQn.resolveComponent)("GroupToModelingDialog");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $248046208ca2e946$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("modelingDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $248046208ca2e946$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $248046208ca2e946$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $248046208ca2e946$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $248046208ca2e946$var$_hoisted_5, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $248046208ca2e946$var$_hoisted_6, [
            (0, $TusQn.createElementVNode)("div", $248046208ca2e946$var$_hoisted_7, [
                (0, $TusQn.createElementVNode)("label", $248046208ca2e946$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event)
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $248046208ca2e946$var$_hoisted_9, [
                (0, $TusQn.createElementVNode)("label", $248046208ca2e946$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("currency")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.currency = $event)
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.currency
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $248046208ca2e946$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("label", $248046208ca2e946$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.groups, (item, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "col-md-3",
                    key: i
                }, [
                    (0, $TusQn.createElementVNode)("div", $248046208ca2e946$var$_hoisted_13, [
                        (0, $TusQn.createElementVNode)("label", {
                            class: "form-control readonly",
                            for: "group_" + i
                        }, (0, $8POXm.toDisplayString)(item.name), 9, $248046208ca2e946$var$_hoisted_14),
                        (0, $TusQn.createElementVNode)("div", $248046208ca2e946$var$_hoisted_15, [
                            (0, $TusQn.createElementVNode)("input", {
                                class: "form-check-input mt-0",
                                type: "checkbox",
                                id: "group_" + i,
                                onChange: ($event)=>$options.groupCheck(item, $event),
                                checked: $options.isGroupChecked(item)
                            }, null, 40, $248046208ca2e946$var$_hoisted_16)
                        ])
                    ])
                ]);
            }), 128))
        ]),
        (0, $TusQn.createElementVNode)("div", $248046208ca2e946$var$_hoisted_17, [
            (0, $TusQn.createElementVNode)("div", $248046208ca2e946$var$_hoisted_18, [
                $248046208ca2e946$var$_hoisted_19,
                (0, $TusQn.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.saveModeling && $options.saveModeling(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1)
            ])
        ]),
        (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_GroupToModelingDialog, {
            onClose: $options.closeModal,
            onConfirm: $options.confirmModal
        }, null, 8, [
            "onClose",
            "onConfirm"
        ]), [
            [
                (0, $eeJ70.vShow),
                $data.isModalVisible
            ]
        ])
    ]);
}

});

parcelRegister("eNKdo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac697da7ee00b459$export$2e2bcd8739ae039);
let $ac697da7ee00b459$var$NOOP = ()=>{};
var $ac697da7ee00b459$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("aWpmT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7f72ffc6ee0a1b93$export$2e2bcd8739ae039);

var $eHCxc = parcelRequire("eHCxc");

var $2gQQk = parcelRequire("2gQQk");

var $97tK3 = parcelRequire("97tK3");

var $j9vnd = parcelRequire("j9vnd");

var $eqtu6 = parcelRequire("eqtu6");

var $ch9iu = parcelRequire("ch9iu");

var $l6otV = parcelRequire("l6otV");

var $gOjKo = parcelRequire("gOjKo");

var $gM1Yh = parcelRequire("gM1Yh");

var $fUmC0 = parcelRequire("fUmC0");

var $aYIG6 = parcelRequire("aYIG6");

var $ljJJR = parcelRequire("ljJJR");
var $7f72ffc6ee0a1b93$export$2e2bcd8739ae039 = {
    name: "modelingdetail",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var assetTypeId = this.$route.params.assetTypeId;
            this.data = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, assetTypeId);
            this.dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, this.data.datasetId);
            var activityList = await (0, $2gQQk.default).activityList(this.$route.params.id);
            this.activityList = activityList.filter((a)=>a.assetTypeId == assetTypeId);
            var lifeCycleList = await (0, $97tK3.default).lifeCycleList(this.$route.params.id);
            this.lifeCycleList = lifeCycleList.filter((a)=>a.assetTypeId == assetTypeId);
            var benefitList = await (0, $j9vnd.default).benefitList(this.$route.params.id);
            this.benefitList = benefitList.filter((a)=>a.assetTypeId == assetTypeId);
            var performanceList = await (0, $eqtu6.default).performanceList(this.$route.params.id);
            this.performanceList = performanceList.filter((a)=>a.assetTypeId == assetTypeId);
            var parameterList = await (0, $gM1Yh.default).parameterList(this.$route.params.id);
            this.parameterList = parameterList.filter((a)=>a.assetTypeId == assetTypeId);
            var kpiList = await (0, $aYIG6.default).kpiList(this.$route.params.id);
            this.kpiList = kpiList.filter((a)=>a.assetTypeId == assetTypeId).sort((x, y)=>x.order - y.order);
            this.curveList = await (0, $fUmC0.default).curveList(this.$route.params.id);
            this.evaluationList = await (0, $ljJJR.default).evaluationList(this.$route.params.id);
            this.pending = false;
        },
        moveKpi (i, direction) {
            const list = [
                ...this.kpiList
            ];
            const j = i + direction;
            if (j < 0 || j >= list.length || i < 0 || i >= list.length) return;
            if (list.some((k)=>k.order == null || k.order <= 0)) list.forEach((k, idx)=>{
                k.order = idx + 1;
            });
            const tmp = list[i].order;
            list[i].order = list[j].order;
            list[j].order = tmp;
            list.sort((x, y)=>x.order - y.order);
            this.kpiList = list;
            this.updateKpiOrder();
        },
        async updateKpiOrder () {
            await (0, $aYIG6.default).updateKPIOrder(this.$route.params.id, this.kpiList);
        },
        filteredCurveList (curveList, parameterId) {
            return curveList.filter((a)=>a.parameterId == parameterId);
        },
        filteredEvaluationList (evaluationList, kpiId) {
            return evaluationList.filter((a)=>a.keyPerformanceIndicatorId == kpiId);
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "assetTypeUpdated",
            type: "success"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: ""
            },
            dataset: {},
            datasetList: [],
            assetTypeList: [],
            activityList: [],
            lifeCycleList: [],
            benefitList: [],
            performanceList: [],
            parameterList: [],
            curveList: [],
            kpiList: [],
            evaluationList: [],
            activityToDeleteId: 0,
            showActivityDeleteModal: false,
            pending: true,
            isUserAdmin: false
        };
    }
};

});
parcelRegister("2gQQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a7610ea14739357$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $1a7610ea14739357$var$activityApi = {
    activityList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/activity`);
        const res = await req;
        return res.body;
    },
    activityDetail: async (modelingId, activity)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/activity/${activity}`);
        const res = await req;
        return res.body;
    },
    activityUpdate: async (modelingId, activity)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/activity/${activity.id}`).send(activity);
        const res = await req;
        return res.body;
    },
    activityCreate: async (modelingId, activity)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/activity`).send(activity);
        const res = await req;
        return res.body;
    },
    activityDelete: async (modelingId, activityId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/activity/${activityId}`);
        await req;
    }
};
var $1a7610ea14739357$export$2e2bcd8739ae039 = $1a7610ea14739357$var$activityApi;

});

parcelRegister("j9vnd", function(module, exports) {

$parcel$export(module.exports, "default", () => $df1731b3bf64471a$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $df1731b3bf64471a$var$benefitApi = {
    benefitList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/benefit`);
        const res = await req;
        return res.body;
    },
    benefitDetail: async (modelingId, benefit)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/benefit/${benefit}`);
        const res = await req;
        return res.body;
    },
    benefitUpdate: async (modelingId, benefit)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/benefit/${benefit.id}`).send(benefit);
        const res = await req;
        return res.body;
    },
    benefitCreate: async (modelingId, benefit)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/benefit`).send(benefit);
        const res = await req;
        return res.body;
    },
    benefitDelete: async (modelingId, benefitId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/benefit/${benefitId}`);
        await req;
    }
};
var $df1731b3bf64471a$export$2e2bcd8739ae039 = $df1731b3bf64471a$var$benefitApi;

});

parcelRegister("gM1Yh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c362a8836a158049$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $c362a8836a158049$var$parameterApi = {
    parameterList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/parameter`);
        const res = await req;
        return res.body;
    },
    parameterDetail: async (modelingId, parameter)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/parameter/${parameter}`);
        const res = await req;
        return res.body;
    },
    parameterUpdate: async (modelingId, parameter)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/parameter/${parameter.id}`).send(parameter);
        const res = await req;
        return res.body;
    },
    parameterCreate: async (modelingId, parameter)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/parameter`).send(parameter);
        const res = await req;
        return res.body;
    },
    parameterDelete: async (modelingId, parameterId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/parameter/${parameterId}`);
        await req;
    },
    evaluationList: async (modelingId, parameterId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/parameter/${parameterId}/evaluation`);
        const res = await req;
        return res.body;
    },
    evaluationDetail: async (modelingId, parameterId, evaluation)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/parameter/${parameterId}/evaluation/${evaluation}`);
        const res = await req;
        return res.body;
    },
    evaluationUpdate: async (modelingId, parameterId, evaluation)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/parameter/${parameterId}/evaluation/${evaluation.id}`).send(evaluation);
        const res = await req;
        return res.body;
    },
    evaluationCreate: async (modelingId, parameterId, evaluation)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/parameter/${parameterId}/evaluation`).send(evaluation);
        const res = await req;
        return res.body;
    },
    evaluationDelete: async (modelingId, parameterId, evaluationId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/parameter/${parameterId}/evaluation/${evaluationId}`);
        await req;
    }
};
var $c362a8836a158049$export$2e2bcd8739ae039 = $c362a8836a158049$var$parameterApi;

});

parcelRegister("fUmC0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b94da03c180a8f25$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $b94da03c180a8f25$var$curveApi = {
    curveList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/curve`);
        const res = await req;
        return res.body;
    },
    curveDetail: async (modelingId, curve)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/curve/${curve}`);
        const res = await req;
        return res.body;
    },
    curveUpdate: async (modelingId, curve)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/curve/${curve.id}`).send(curve);
        const res = await req;
        return res.body;
    },
    curveCreate: async (modelingId, curve)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/curve`).send(curve);
        const res = await req;
        return res.body;
    },
    curveDelete: async (modelingId, curveId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/curve/${curveId}/force`);
        await req;
    }
};
var $b94da03c180a8f25$export$2e2bcd8739ae039 = $b94da03c180a8f25$var$curveApi;

});

parcelRegister("aYIG6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fe22a1d462a2ed4$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $7fe22a1d462a2ed4$var$kpiApi = {
    kpiList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/kpi`);
        const res = await req;
        return res.body;
    },
    kpiDetail: async (modelingId, keyPerformanceIndicator)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/kpi/${keyPerformanceIndicator}`);
        const res = await req;
        return res.body;
    },
    kpiUpdate: async (modelingId, keyPerformanceIndicator)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/kpi/${keyPerformanceIndicator.id}`).send(keyPerformanceIndicator);
        const res = await req;
        return res.body;
    },
    kpiCreate: async (modelingId, keyPerformanceIndicator)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/kpi`).send(keyPerformanceIndicator);
        const res = await req;
        return res.body;
    },
    kpiDelete: async (modelingId, keyPerformanceIndicatorId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/kpi/${keyPerformanceIndicatorId}`);
        await req;
    },
    updateKPIOrder: async (modelingId, kpiList)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/kpi/updateorder`).send(kpiList);
        const res = await req;
        return res.body;
    }
};
var $7fe22a1d462a2ed4$export$2e2bcd8739ae039 = $7fe22a1d462a2ed4$var$kpiApi;

});

parcelRegister("ljJJR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f84eda10a857d5fb$export$2e2bcd8739ae039);

var $f5Koy = parcelRequire("f5Koy");
const $f84eda10a857d5fb$var$evaluationApi = {
    evaluationList: async (modelingId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/evaluation`);
        const res = await req;
        return res.body;
    },
    evaluationListByKpi: async (modelingId, kpiId)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/evaluation/bykpi/${kpiId}`);
        const res = await req;
        return res.body;
    },
    evaluationDetail: async (modelingId, evaluation)=>{
        const req = (0, $f5Koy.default).get(`/api/modeling/${modelingId}/evaluation/${evaluation}`);
        const res = await req;
        return res.body;
    },
    evaluationUpdate: async (modelingId, evaluation)=>{
        const req = (0, $f5Koy.default).put(`/api/modeling/${modelingId}/evaluation/${evaluation.id}`).send(evaluation);
        const res = await req;
        return res.body;
    },
    evaluationCreate: async (modelingId, evaluation)=>{
        const req = (0, $f5Koy.default).post(`/api/modeling/${modelingId}/evaluation`).send(evaluation);
        const res = await req;
        return res.body;
    },
    evaluationDelete: async (modelingId, evaluationId)=>{
        const req = (0, $f5Koy.default).delete(`/api/modeling/${modelingId}/evaluation/${evaluationId}/force`);
        await req;
    }
};
var $f84eda10a857d5fb$export$2e2bcd8739ae039 = $f84eda10a857d5fb$var$evaluationApi;

});


parcelRegister("1Eea2", function(module, exports) {

$parcel$export(module.exports, "render", () => $133482e922fe189b$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $133482e922fe189b$var$_hoisted_1 = {
    key: 0
};
const $133482e922fe189b$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $133482e922fe189b$var$_hoisted_3 = [
    $133482e922fe189b$var$_hoisted_2
];
const $133482e922fe189b$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $133482e922fe189b$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $133482e922fe189b$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $133482e922fe189b$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $133482e922fe189b$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $133482e922fe189b$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $133482e922fe189b$var$_hoisted_10 = {
    class: "text-center mb-4"
};
const $133482e922fe189b$var$_hoisted_11 = {
    class: "btn btn-secondary float-end"
};
const $133482e922fe189b$var$_hoisted_12 = {
    class: "row mb-4"
};
const $133482e922fe189b$var$_hoisted_13 = {
    class: "col-sm-3"
};
const $133482e922fe189b$var$_hoisted_14 = {
    class: "card text-center"
};
const $133482e922fe189b$var$_hoisted_15 = {
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_16 = {
    class: "card-title"
};
const $133482e922fe189b$var$_hoisted_17 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $133482e922fe189b$var$_hoisted_18 = {
    key: 1,
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_19 = {
    class: "btn btn-sm btn-light"
};
const $133482e922fe189b$var$_hoisted_20 = {
    class: "col-sm-3"
};
const $133482e922fe189b$var$_hoisted_21 = {
    class: "card text-center"
};
const $133482e922fe189b$var$_hoisted_22 = {
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_23 = {
    class: "card-title"
};
const $133482e922fe189b$var$_hoisted_24 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $133482e922fe189b$var$_hoisted_25 = {
    key: 1,
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_26 = {
    class: "btn btn-sm btn-light"
};
const $133482e922fe189b$var$_hoisted_27 = {
    class: "col-sm-3"
};
const $133482e922fe189b$var$_hoisted_28 = {
    class: "card text-center"
};
const $133482e922fe189b$var$_hoisted_29 = {
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_30 = {
    class: "card-title"
};
const $133482e922fe189b$var$_hoisted_31 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $133482e922fe189b$var$_hoisted_32 = {
    key: 1,
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_33 = {
    class: "btn btn-sm btn-light"
};
const $133482e922fe189b$var$_hoisted_34 = {
    class: "col-sm-3"
};
const $133482e922fe189b$var$_hoisted_35 = {
    class: "card text-center"
};
const $133482e922fe189b$var$_hoisted_36 = {
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_37 = {
    class: "card-title"
};
const $133482e922fe189b$var$_hoisted_38 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $133482e922fe189b$var$_hoisted_39 = {
    key: 1,
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_40 = {
    class: "btn btn-sm btn-light"
};
const $133482e922fe189b$var$_hoisted_41 = {
    class: "text-center mb-4"
};
const $133482e922fe189b$var$_hoisted_42 = {
    class: "row mb-4"
};
const $133482e922fe189b$var$_hoisted_43 = {
    class: "card text-center"
};
const $133482e922fe189b$var$_hoisted_44 = {
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_45 = {
    class: "card-title"
};
const $133482e922fe189b$var$_hoisted_46 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $133482e922fe189b$var$_hoisted_47 = {
    key: 1,
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_48 = {
    class: "btn btn-sm btn-light"
};
const $133482e922fe189b$var$_hoisted_49 = {
    key: 0,
    class: "col-sm-3"
};
const $133482e922fe189b$var$_hoisted_50 = {
    class: "card text-center"
};
const $133482e922fe189b$var$_hoisted_51 = {
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_52 = {
    class: "list-group list-group-flush"
};
const $133482e922fe189b$var$_hoisted_53 = {
    class: "list-group-item"
};
const $133482e922fe189b$var$_hoisted_54 = {
    class: "btn btn-sm btn-light"
};
const $133482e922fe189b$var$_hoisted_55 = {
    class: "text-center mb-4"
};
const $133482e922fe189b$var$_hoisted_56 = {
    class: "row mb-4"
};
const $133482e922fe189b$var$_hoisted_57 = {
    class: "card text-center"
};
const $133482e922fe189b$var$_hoisted_58 = {
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_59 = {
    class: "card-title"
};
const $133482e922fe189b$var$_hoisted_60 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $133482e922fe189b$var$_hoisted_61 = {
    key: 1,
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_62 = {
    class: "float-start"
};
const $133482e922fe189b$var$_hoisted_63 = [
    "disabled",
    "onClick"
];
const $133482e922fe189b$var$_hoisted_64 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa fa-arrow-left"
}, null, -1);
const $133482e922fe189b$var$_hoisted_65 = [
    $133482e922fe189b$var$_hoisted_64
];
const $133482e922fe189b$var$_hoisted_66 = {
    class: "btn btn-sm btn-light"
};
const $133482e922fe189b$var$_hoisted_67 = {
    class: "float-end"
};
const $133482e922fe189b$var$_hoisted_68 = [
    "disabled",
    "onClick"
];
const $133482e922fe189b$var$_hoisted_69 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa fa-arrow-right"
}, null, -1);
const $133482e922fe189b$var$_hoisted_70 = [
    $133482e922fe189b$var$_hoisted_69
];
const $133482e922fe189b$var$_hoisted_71 = {
    key: 0,
    class: "col-sm-3"
};
const $133482e922fe189b$var$_hoisted_72 = {
    class: "card text-center"
};
const $133482e922fe189b$var$_hoisted_73 = {
    class: "card-body"
};
const $133482e922fe189b$var$_hoisted_74 = {
    class: "list-group list-group-flush"
};
const $133482e922fe189b$var$_hoisted_75 = {
    class: "list-group-item"
};
const $133482e922fe189b$var$_hoisted_76 = {
    class: "btn btn-sm btn-light"
};
function $133482e922fe189b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $133482e922fe189b$var$_hoisted_1, $133482e922fe189b$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $133482e922fe189b$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("assetTypeDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $133482e922fe189b$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $133482e922fe189b$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $133482e922fe189b$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $133482e922fe189b$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $133482e922fe189b$var$_hoisted_9, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", null, [
            (0, $TusQn.createElementVNode)("h3", $133482e922fe189b$var$_hoisted_10, [
                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name) + " ", 1),
                (0, $TusQn.createVNode)(_component_RouterLink, {
                    to: "/modeling/" + this.$route.params.id + "/assettypeinfoset/" + this.$route.params.assetTypeId
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createElementVNode)("button", $133482e922fe189b$var$_hoisted_11, (0, $8POXm.toDisplayString)(_ctx.$t("detail")), 1)
                        ]),
                    _: 1
                }, 8, [
                    "to"
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_13, [
                    (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_14, [
                        (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_15, [
                            (0, $TusQn.createElementVNode)("h5", $133482e922fe189b$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("activityList")), 1)
                        ]),
                        $data.activityList.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $133482e922fe189b$var$_hoisted_17, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.activityList, (item, i)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "list-group-item",
                                    key: i
                                }, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/activity/" + item.id
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name || item.id), 1)
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "to"
                                    ])
                                ]);
                            }), 128))
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $133482e922fe189b$var$_hoisted_18, [
                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/activitycreate"
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createElementVNode)("button", $133482e922fe189b$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("addActivity")), 1)
                                    ]),
                                _: 1
                            }, 8, [
                                "to"
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_20, [
                    (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_21, [
                        (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_22, [
                            (0, $TusQn.createElementVNode)("h5", $133482e922fe189b$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("performanceList")), 1)
                        ]),
                        $data.performanceList.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $133482e922fe189b$var$_hoisted_24, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.performanceList, (item, i)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "list-group-item",
                                    key: i
                                }, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/performance/" + item.id
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name || item.id), 1)
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "to"
                                    ])
                                ]);
                            }), 128))
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $133482e922fe189b$var$_hoisted_25, [
                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/performancecreate"
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createElementVNode)("button", $133482e922fe189b$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("addPerformance")), 1)
                                    ]),
                                _: 1
                            }, 8, [
                                "to"
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_27, [
                    (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_28, [
                        (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_29, [
                            (0, $TusQn.createElementVNode)("h5", $133482e922fe189b$var$_hoisted_30, (0, $8POXm.toDisplayString)(_ctx.$t("benefitList")), 1)
                        ]),
                        $data.benefitList.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $133482e922fe189b$var$_hoisted_31, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.benefitList, (item, i)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "list-group-item",
                                    key: i
                                }, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/benefit/" + item.id
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name || item.id), 1)
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "to"
                                    ])
                                ]);
                            }), 128))
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $133482e922fe189b$var$_hoisted_32, [
                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/benefitcreate"
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createElementVNode)("button", $133482e922fe189b$var$_hoisted_33, (0, $8POXm.toDisplayString)(_ctx.$t("addBenefit")), 1)
                                    ]),
                                _: 1
                            }, 8, [
                                "to"
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_34, [
                    (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_35, [
                        (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_36, [
                            (0, $TusQn.createElementVNode)("h5", $133482e922fe189b$var$_hoisted_37, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycleList")), 1)
                        ]),
                        $data.lifeCycleList.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $133482e922fe189b$var$_hoisted_38, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.lifeCycleList, (item, i)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "list-group-item",
                                    key: i
                                }, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/lifecycle/" + item.id
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name || item.id), 1)
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "to"
                                    ])
                                ]);
                            }), 128))
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $133482e922fe189b$var$_hoisted_39, [
                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/lifecyclecreate"
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createElementVNode)("button", $133482e922fe189b$var$_hoisted_40, (0, $8POXm.toDisplayString)(_ctx.$t("addLifeCycle")), 1)
                                    ]),
                                _: 1
                            }, 8, [
                                "to"
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("h3", $133482e922fe189b$var$_hoisted_41, (0, $8POXm.toDisplayString)(_ctx.$t("parameters")), 1),
            (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_42, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.parameterList, (item, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        class: "col-sm-3 mb-4",
                        key: i
                    }, [
                        (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_43, [
                            (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_44, [
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    style: {
                                        "color": "black"
                                    },
                                    to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/parameter/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createElementVNode)("h5", $133482e922fe189b$var$_hoisted_45, (0, $8POXm.toDisplayString)(item.name), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ])
                            ]),
                            $data.curveList.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $133482e922fe189b$var$_hoisted_46, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.filteredCurveList($data.curveList, item.id), (item, i)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                        class: "list-group-item",
                                        key: i
                                    }, [
                                        (0, $TusQn.createVNode)(_component_RouterLink, {
                                            to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/curve/" + item.id
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "to"
                                        ])
                                    ]);
                                }), 128))
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $133482e922fe189b$var$_hoisted_47, [
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/curvecreate/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createElementVNode)("button", $133482e922fe189b$var$_hoisted_48, (0, $8POXm.toDisplayString)(_ctx.$t("addCurve")), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ])
                            ])) : (0, $TusQn.createCommentVNode)("", true)
                        ])
                    ]);
                }), 128)),
                $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $133482e922fe189b$var$_hoisted_49, [
                    (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_50, [
                        (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_51, [
                            (0, $TusQn.createElementVNode)("ul", $133482e922fe189b$var$_hoisted_52, [
                                (0, $TusQn.createElementVNode)("li", $133482e922fe189b$var$_hoisted_53, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/parametercreate/"
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createElementVNode)("button", $133482e922fe189b$var$_hoisted_54, (0, $8POXm.toDisplayString)(_ctx.$t("addParameter")), 1)
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "to"
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ]),
            (0, $TusQn.createElementVNode)("h3", $133482e922fe189b$var$_hoisted_55, (0, $8POXm.toDisplayString)(_ctx.$t("kpi")), 1),
            (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_56, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.kpiList, (item, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        class: "col-sm-3 mb-4",
                        key: item.id
                    }, [
                        (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_57, [
                            (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_58, [
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    style: {
                                        "color": "black"
                                    },
                                    to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/kpi/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createElementVNode)("h5", $133482e922fe189b$var$_hoisted_59, (0, $8POXm.toDisplayString)(item.name), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ])
                            ]),
                            $data.evaluationList.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $133482e922fe189b$var$_hoisted_60, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.filteredEvaluationList($data.evaluationList, item.id), (item, i)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                        class: "list-group-item",
                                        key: i
                                    }, [
                                        (0, $TusQn.createVNode)(_component_RouterLink, {
                                            to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/evaluation/" + item.id
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "to"
                                        ])
                                    ]);
                                }), 128))
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $133482e922fe189b$var$_hoisted_61, [
                                (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_62, [
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: "btn btn-sm btn-light me-1",
                                        disabled: i === 0,
                                        onClick: ($event)=>$options.moveKpi(i, -1)
                                    }, $133482e922fe189b$var$_hoisted_65, 8, $133482e922fe189b$var$_hoisted_63)
                                ]),
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/evaluationcreate/" + item.id
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createElementVNode)("button", $133482e922fe189b$var$_hoisted_66, (0, $8POXm.toDisplayString)(_ctx.$t("addEvaluation")), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ]),
                                (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_67, [
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: "btn btn-sm btn-light",
                                        disabled: i === $data.kpiList.length - 1,
                                        onClick: ($event)=>$options.moveKpi(i, 1)
                                    }, $133482e922fe189b$var$_hoisted_70, 8, $133482e922fe189b$var$_hoisted_68)
                                ])
                            ])) : (0, $TusQn.createCommentVNode)("", true)
                        ])
                    ]);
                }), 128)),
                $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $133482e922fe189b$var$_hoisted_71, [
                    (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_72, [
                        (0, $TusQn.createElementVNode)("div", $133482e922fe189b$var$_hoisted_73, [
                            (0, $TusQn.createElementVNode)("ul", $133482e922fe189b$var$_hoisted_74, [
                                (0, $TusQn.createElementVNode)("li", $133482e922fe189b$var$_hoisted_75, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/kpicreate/"
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createElementVNode)("button", $133482e922fe189b$var$_hoisted_76, (0, $8POXm.toDisplayString)(_ctx.$t("addKpi")), 1)
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "to"
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ])
        ])
    ]));
}

});

parcelRegister("kRlIb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2f99962d17c1f8e$export$2e2bcd8739ae039);
let $f2f99962d17c1f8e$var$NOOP = ()=>{};
var $f2f99962d17c1f8e$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("2UCrW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $21eea30ed8a30b97$export$2e2bcd8739ae039);

var $eHCxc = parcelRequire("eHCxc");

var $l6otV = parcelRequire("l6otV");
var $21eea30ed8a30b97$export$2e2bcd8739ae039 = {
    name: "assettypecreate",
    watch: {
        $route: "requestData"
    },
    notifications: {
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                this.data.datasetId = this.$route.params.datasetId;
                this.data.visualizationValue = "performance";
                var assetType = await (0, $eHCxc.default).assetTypeCreate(this.$route.params.id, this.data);
                this.$router.push({
                    path: `/modeling/${this.$route.params.id}/assettype/${assetType.id}`
                });
            } else this.showEmptyNameError();
        }
    },
    data () {
        return {
            data: {
                name: "",
                visualizationValue: "",
                id: 0
            },
            modelingName: null,
            pending: true
        };
    }
};

});

parcelRegister("c1Nps", function(module, exports) {

$parcel$export(module.exports, "render", () => $8c1be7bed04d9456$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $8c1be7bed04d9456$var$_hoisted_1 = {
    key: 0
};
const $8c1be7bed04d9456$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $8c1be7bed04d9456$var$_hoisted_3 = [
    $8c1be7bed04d9456$var$_hoisted_2
];
const $8c1be7bed04d9456$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $8c1be7bed04d9456$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $8c1be7bed04d9456$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $8c1be7bed04d9456$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $8c1be7bed04d9456$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $8c1be7bed04d9456$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $8c1be7bed04d9456$var$_hoisted_10 = {
    class: "row"
};
const $8c1be7bed04d9456$var$_hoisted_11 = {
    class: "mb-3 col-md-4"
};
const $8c1be7bed04d9456$var$_hoisted_12 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $8c1be7bed04d9456$var$_hoisted_13 = {
    class: "mb-3 col-md-8"
};
const $8c1be7bed04d9456$var$_hoisted_14 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $8c1be7bed04d9456$var$_hoisted_15 = {
    class: "d-grid gap-2 d-md-flex"
};
function $8c1be7bed04d9456$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8c1be7bed04d9456$var$_hoisted_1, $8c1be7bed04d9456$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8c1be7bed04d9456$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("assetTypeCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $8c1be7bed04d9456$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $8c1be7bed04d9456$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $8c1be7bed04d9456$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $8c1be7bed04d9456$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $8c1be7bed04d9456$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("assetTypeCreate")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $8c1be7bed04d9456$var$_hoisted_10, [
            (0, $TusQn.createElementVNode)("div", $8c1be7bed04d9456$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("label", $8c1be7bed04d9456$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $8c1be7bed04d9456$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("label", $8c1be7bed04d9456$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $8c1be7bed04d9456$var$_hoisted_15, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[2] || (_cache[2] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("ewYjP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a942d7e2e1496546$export$2e2bcd8739ae039);
let $a942d7e2e1496546$var$NOOP = ()=>{};
var $a942d7e2e1496546$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("iK9JN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $da541390b37ca686$export$2e2bcd8739ae039);

var $eHCxc = parcelRequire("eHCxc");

var $l6otV = parcelRequire("l6otV");

var $eqtu6 = parcelRequire("eqtu6");

var $ch9iu = parcelRequire("ch9iu");

var $gOjKo = parcelRequire("gOjKo");

var $37Voi = parcelRequire("37Voi");

var $gM1Yh = parcelRequire("gM1Yh");

var $aYIG6 = parcelRequire("aYIG6");
var $da541390b37ca686$export$2e2bcd8739ae039 = {
    name: "assettypecreate",
    watch: {
        $route: "requestData"
    },
    components: {
        AssetTypeDeleteModal: $37Voi.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var assetTypeId = this.$route.params.assetTypeId;
            this.data = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, assetTypeId);
            var modelingInfo = await (0, $l6otV.default).modelingInfo(this.$route.params.id);
            var assetType = modelingInfo.assetTypes.find((a)=>a.id == this.$route.params.assetTypeId);
            var performances = await (0, $eqtu6.default).performanceList(this.$route.params.id);
            var performancesForCurrentAssetType = performances.filter((p)=>p.assetTypeId == this.$route.params.assetTypeId);
            if (assetType.activities.length > 0 || assetType.benefits.length > 0 || assetType.lifeCycles.length > 0 || assetType?.parameters?.length > 0 || assetType?.keyPerformanceIndicators?.length > 0 || performancesForCurrentAssetType.length > 0) this.assetTypeNotEmpty = true;
            for(var i in modelingInfo.forecastModels){
                var forecast = modelingInfo.forecastModels[i];
                var exists = forecast.assetTypes.find((assetType)=>assetType.assetTypeId == this.$route.params.assetTypeId);
                if (exists) this.foundAssetTypes.push({
                    forecastId: forecast.id,
                    name: "Forecast - " + forecast.name
                });
            }
            var visualizationValues = [
                {
                    name: "Performance",
                    id: "performance"
                }
            ];
            var parameterList = await (0, $gM1Yh.default).parameterList(this.$route.params.id);
            var keyPerformanceIndicators = await (0, $aYIG6.default).kpiList(this.$route.params.id);
            for(var i in parameterList.filter((p)=>p.assetTypeId == this.$route.params.assetTypeId)){
                var parameter = parameterList[i];
                visualizationValues.push({
                    name: parameter.name,
                    id: "parameter_" + parameter.id
                });
            }
            for(var i in keyPerformanceIndicators.filter((k)=>k.assetTypeId == this.$route.params.assetTypeId)){
                var kpi = keyPerformanceIndicators[i];
                visualizationValues.push({
                    name: kpi.name,
                    id: "kpi_" + kpi.id
                });
            }
            this.visualizationValues = visualizationValues;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, this.data.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var clientHeaders = [];
            for(var i in this.data.assetTypeInfoSet){
                var foundInfoset = this.data.assetTypeInfoSet[i];
                clientHeaders.push({
                    id: foundInfoset.id,
                    leading: foundInfoset.leading,
                    headerName: foundInfoset.headerName,
                    alias: foundInfoset.alias,
                    order: foundInfoset.order
                });
            }
            for(var i in this.datasetHeaders){
                var header = this.datasetHeaders[i];
                var foundInfoset = clientHeaders.findIndex((a)=>a.headerName == header.name);
                if (foundInfoset == -1) clientHeaders.push({
                    leading: false,
                    headerName: header.name,
                    alias: header.alias,
                    order: this.getLastOrder(clientHeaders)
                });
            }
            this.clientHeaders = clientHeaders;
            this.assetTypeClassification = this.data.assetTypeClassification;
            var assetAttribute = this.data.assetAttribute;
            if (this.datasetHeaders.findIndex((d)=>d.name == assetAttribute) < 0 && this.missingDatasetHeaders.findIndex((d)=>d.name == assetAttribute) < 0) this.missingDatasetHeaders.push({
                name: assetAttribute,
                alias: assetAttribute
            });
            var lifeCycleAgeAttribute = this.data.lifeCycleAgeAttribute;
            if (this.datasetHeaders.findIndex((d)=>d.name == lifeCycleAgeAttribute) < 0 && this.missingDatasetHeaders.findIndex((d)=>d.name == lifeCycleAgeAttribute) < 0) this.missingDatasetHeaders.push({
                name: lifeCycleAgeAttribute,
                alias: lifeCycleAgeAttribute
            });
            var weightAttribute = this.data.weightAttribute;
            if (this.datasetHeaders.findIndex((d)=>d.name == weightAttribute) < 0 && this.missingDatasetHeaders.findIndex((d)=>d.name == weightAttribute) < 0) this.missingDatasetHeaders.push({
                name: weightAttribute,
                alias: weightAttribute
            });
            var assetAttributeYear = this.data.assetAttributeYear;
            if (this.datasetHeaders.findIndex((d)=>d.name == assetAttributeYear) < 0 && this.missingDatasetHeaders.findIndex((d)=>d.name == assetAttributeYear) < 0) this.missingDatasetHeaders.push({
                name: assetAttributeYear,
                alias: assetAttributeYear
            });
            this.pending = false;
        },
        removeClassification (rowIndex) {
            this.assetTypeClassification.splice(rowIndex, 1);
        },
        addClassification () {
            this.assetTypeClassification.push({
                startAssetPerformance: this.getClassification(),
                endAssetPerformance: 0,
                name: "",
                color: ""
            });
        },
        getClassification () {
            var minAssetPerformanceFrom = 0;
            if (this.assetTypeClassification.length > 0) minAssetPerformanceFrom = this.assetTypeClassification[this.assetTypeClassification.length - 1].endAssetPerformance;
            return minAssetPerformanceFrom;
        },
        updateAssetTypeClassificationStart (value, i) {
            var range = this.assetTypeClassification[i + 1];
            if (range) range.startAssetPerformance = value;
        },
        isFormValid () {
            var assetAttribute = this.data.assetAttribute;
            if (this.datasetHeaders.findIndex((d)=>d.name == assetAttribute) < 0 && assetAttribute != "") return false;
            var lifeCycleAgeAttribute = this.data.lifeCycleAgeAttribute;
            if (this.datasetHeaders.findIndex((d)=>d.name == lifeCycleAgeAttribute) < 0 && lifeCycleAgeAttribute != "") return false;
            var weightAttribute = this.data.weightAttribute;
            if (this.datasetHeaders.findIndex((d)=>d.name == weightAttribute) < 0 && weightAttribute != "") return false;
            return true;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                var assetTypeInfoSet = [];
                for(var i in this.clientHeaders){
                    var header = this.clientHeaders[i];
                    if (header.leading) assetTypeInfoSet.push({
                        id: header.id,
                        leading: header.leading,
                        headerName: header.headerName,
                        alias: header.alias,
                        order: header.order
                    });
                }
                this.data.assetTypeInfoSet = assetTypeInfoSet;
                this.data.assetTypeClassification = this.assetTypeClassification;
                await (0, $eHCxc.default).assetTypeUpdate(this.$route.params.id, this.data);
                if (!this.isFormValid()) this.showWarning();
                else this.showSuccess();
            } else this.showEmptyNameError();
        },
        moveAssetTypeInfoSetUp (i) {
            var assetTypeInfoSet = this.clientHeaders;
            if (i > 0) {
                let indexOfInfoSetUp = i - 1;
                let tmpOrder = assetTypeInfoSet[indexOfInfoSetUp].order;
                assetTypeInfoSet[indexOfInfoSetUp].order = assetTypeInfoSet[i].order;
                assetTypeInfoSet[i].order = tmpOrder;
                assetTypeInfoSet.sort((a, b)=>a.order - b.order);
                this.clientHeaders = assetTypeInfoSet;
            }
        },
        moveAssetTypeInfoSetDown (i) {
            var assetTypeInfoSet = this.clientHeaders;
            if (i >= 0) {
                let indexOfInfoSetDown = i + 1;
                let tmpOrder = assetTypeInfoSet[indexOfInfoSetDown].order;
                assetTypeInfoSet[indexOfInfoSetDown].order = assetTypeInfoSet[i].order;
                assetTypeInfoSet[i].order = tmpOrder;
                assetTypeInfoSet.sort((a, b)=>a.order - b.order);
                this.clientHeaders = assetTypeInfoSet;
            }
        },
        getLastOrder (clientHeaders) {
            var order = 0;
            if (clientHeaders[clientHeaders.length - 1]) order = clientHeaders[clientHeaders.length - 1].order + 1;
            return order;
        },
        orderedClientHeaders (clientHeaders) {
            return clientHeaders.sort((a, b)=>a.order - b.order);
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0
            },
            modelingName: null,
            pending: true,
            datasetHeaders: [],
            missingDatasetHeaders: [],
            assetTypeClassification: [],
            clientHeaders: [],
            isUserAdmin: false,
            foundAssetTypes: [],
            visualizationValues: [],
            assetTypeNotEmpty: false,
            showDeleteAssetType: false
        };
    },
    notifications: {
        showWarning: {
            title: "warning",
            message: "warningAttributeRemoved",
            type: "warn"
        },
        showSuccess: {
            title: "success",
            message: "assetTypeInfosetUpdated",
            type: "success"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    }
};

});
parcelRegister("37Voi", function(module, exports) {

$parcel$export(module.exports, "default", () => $246e8b273ee315b7$export$2e2bcd8739ae039);
let $246e8b273ee315b7$var$script;



let $246e8b273ee315b7$var$initialize = ()=>{
    $246e8b273ee315b7$var$script = (parcelRequire("bftWk"));
    if ($246e8b273ee315b7$var$script.__esModule) $246e8b273ee315b7$var$script = $246e8b273ee315b7$var$script.default;
    $246e8b273ee315b7$var$script.render = (parcelRequire("fFJQf")).render;
    (parcelRequire("X792N")).default($246e8b273ee315b7$var$script);
    $246e8b273ee315b7$var$script.__scopeId = "data-v-7e6e04";
    $246e8b273ee315b7$var$script.__file = "AssetTypeDeleteModal.vue";
};
$246e8b273ee315b7$var$initialize();
var $246e8b273ee315b7$export$2e2bcd8739ae039 = $246e8b273ee315b7$var$script;

});
parcelRegister("bftWk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $830851d6c8ebe5d2$export$2e2bcd8739ae039);

var $eHCxc = parcelRequire("eHCxc");
var $830851d6c8ebe5d2$export$2e2bcd8739ae039 = {
    name: "benefitDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteAssetType () {
            await (0, $eHCxc.default).assetTypeDelete(this.$parent.$route.params.id, this.$parent.$route.params.assetTypeId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("fFJQf", function(module, exports) {

$parcel$export(module.exports, "render", () => $b68e3e8e8fbc078c$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $b68e3e8e8fbc078c$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $b68e3e8e8fbc078c$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $b68e3e8e8fbc078c$var$_hoisted_3 = {
    class: "modal-content"
};
const $b68e3e8e8fbc078c$var$_hoisted_4 = {
    class: "modal-header"
};
const $b68e3e8e8fbc078c$var$_hoisted_5 = {
    class: "modal-title"
};
const $b68e3e8e8fbc078c$var$_hoisted_6 = {
    class: "modal-body"
};
const $b68e3e8e8fbc078c$var$_hoisted_7 = {
    key: 0,
    class: "form-label"
};
const $b68e3e8e8fbc078c$var$_hoisted_8 = {
    class: "form-label"
};
const $b68e3e8e8fbc078c$var$_hoisted_9 = {
    key: 2
};
const $b68e3e8e8fbc078c$var$_hoisted_10 = {
    class: "modal-footer"
};
const $b68e3e8e8fbc078c$var$_hoisted_11 = [
    "disabled"
];
function $b68e3e8e8fbc078c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $b68e3e8e8fbc078c$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $b68e3e8e8fbc078c$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $b68e3e8e8fbc078c$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $b68e3e8e8fbc078c$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $b68e3e8e8fbc078c$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("assetTypeDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $b68e3e8e8fbc078c$var$_hoisted_6, [
                                this.$parent.assetTypeNotEmpty ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("label", $b68e3e8e8fbc078c$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("assetTypeNotEmpty")), 1)) : this.$parent.foundAssetTypes.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 1
                                }, [
                                    (0, $TusQn.createElementVNode)("label", $b68e3e8e8fbc078c$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("cannotDeleteAssetType")), 1),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(this.$parent.foundAssetTypes, (assetType, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                            key: i
                                        }, [
                                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                                to: "/modeling/" + this.$route.params.id + "/forecast/" + assetType.forecastId
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(assetType.name), 1)
                                                    ]),
                                                _: 2
                                            }, 1032, [
                                                "to"
                                            ])
                                        ]);
                                    }), 128))
                                ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $b68e3e8e8fbc078c$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisAssetType")), 1))
                            ]),
                            (0, $TusQn.createElementVNode)("div", $b68e3e8e8fbc078c$var$_hoisted_10, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteAssetType && $options.deleteAssetType(...args)),
                                    disabled: this.$parent.foundAssetTypes.length > 0 || this.$parent.assetTypeNotEmpty
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 9, $b68e3e8e8fbc078c$var$_hoisted_11)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("X792N", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b1b0da037502e3b$export$2e2bcd8739ae039);
let $0b1b0da037502e3b$var$NOOP = ()=>{};
var $0b1b0da037502e3b$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("crkDC", function(module, exports) {

$parcel$export(module.exports, "render", () => $90e803ea8a8cdcd5$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $90e803ea8a8cdcd5$var$_hoisted_1 = {
    key: 0
};
const $90e803ea8a8cdcd5$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $90e803ea8a8cdcd5$var$_hoisted_3 = [
    $90e803ea8a8cdcd5$var$_hoisted_2
];
const $90e803ea8a8cdcd5$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $90e803ea8a8cdcd5$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $90e803ea8a8cdcd5$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $90e803ea8a8cdcd5$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $90e803ea8a8cdcd5$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $90e803ea8a8cdcd5$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $90e803ea8a8cdcd5$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $90e803ea8a8cdcd5$var$_hoisted_11 = {
    class: "row"
};
const $90e803ea8a8cdcd5$var$_hoisted_12 = {
    class: "mb-3 col-md-4"
};
const $90e803ea8a8cdcd5$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $90e803ea8a8cdcd5$var$_hoisted_14 = {
    class: "mb-3 col-md-8"
};
const $90e803ea8a8cdcd5$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $90e803ea8a8cdcd5$var$_hoisted_16 = {
    class: "row"
};
const $90e803ea8a8cdcd5$var$_hoisted_17 = {
    class: "mb-3 col-md-4"
};
const $90e803ea8a8cdcd5$var$_hoisted_18 = {
    class: "form-label",
    for: "assetAttribute",
    required: ""
};
const $90e803ea8a8cdcd5$var$_hoisted_19 = {
    disabled: ""
};
const $90e803ea8a8cdcd5$var$_hoisted_20 = [
    "value"
];
const $90e803ea8a8cdcd5$var$_hoisted_21 = [
    "value"
];
const $90e803ea8a8cdcd5$var$_hoisted_22 = {
    class: "mb-3 col-md-4"
};
const $90e803ea8a8cdcd5$var$_hoisted_23 = {
    class: "form-label",
    for: "assetAttributeYear",
    required: ""
};
const $90e803ea8a8cdcd5$var$_hoisted_24 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    selected: "",
    value: ""
}, null, -1);
const $90e803ea8a8cdcd5$var$_hoisted_25 = [
    "value"
];
const $90e803ea8a8cdcd5$var$_hoisted_26 = [
    "value"
];
const $90e803ea8a8cdcd5$var$_hoisted_27 = {
    class: "mb-3 col-md-4"
};
const $90e803ea8a8cdcd5$var$_hoisted_28 = {
    class: "form-label",
    for: "lifeCycleAgeAttribute",
    required: ""
};
const $90e803ea8a8cdcd5$var$_hoisted_29 = {
    disabled: ""
};
const $90e803ea8a8cdcd5$var$_hoisted_30 = [
    "value"
];
const $90e803ea8a8cdcd5$var$_hoisted_31 = [
    "value"
];
const $90e803ea8a8cdcd5$var$_hoisted_32 = {
    class: "mb-3 col-md-4"
};
const $90e803ea8a8cdcd5$var$_hoisted_33 = {
    class: "form-label",
    for: "weightAttribute",
    required: ""
};
const $90e803ea8a8cdcd5$var$_hoisted_34 = {
    disabled: ""
};
const $90e803ea8a8cdcd5$var$_hoisted_35 = [
    "value"
];
const $90e803ea8a8cdcd5$var$_hoisted_36 = [
    "value"
];
const $90e803ea8a8cdcd5$var$_hoisted_37 = {
    class: "mb-3 col-md-4"
};
const $90e803ea8a8cdcd5$var$_hoisted_38 = {
    class: "form-label",
    for: "visualizationValue",
    required: ""
};
const $90e803ea8a8cdcd5$var$_hoisted_39 = {
    disabled: ""
};
const $90e803ea8a8cdcd5$var$_hoisted_40 = [
    "value"
];
const $90e803ea8a8cdcd5$var$_hoisted_41 = {
    class: "mb-3 col-md-4"
};
const $90e803ea8a8cdcd5$var$_hoisted_42 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "form-label"
}, "\xa0", -1);
const $90e803ea8a8cdcd5$var$_hoisted_43 = {
    class: "form-check"
};
const $90e803ea8a8cdcd5$var$_hoisted_44 = {
    class: "form-check-label",
    for: "recalculateLifeCycleAge"
};
const $90e803ea8a8cdcd5$var$_hoisted_45 = {
    class: "row mb-4"
};
const $90e803ea8a8cdcd5$var$_hoisted_46 = {
    class: "mb-4"
};
const $90e803ea8a8cdcd5$var$_hoisted_47 = {
    class: "table"
};
const $90e803ea8a8cdcd5$var$_hoisted_48 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $90e803ea8a8cdcd5$var$_hoisted_49 = {
    scope: "col"
};
const $90e803ea8a8cdcd5$var$_hoisted_50 = {
    scope: "col"
};
const $90e803ea8a8cdcd5$var$_hoisted_51 = {
    scope: "col"
};
const $90e803ea8a8cdcd5$var$_hoisted_52 = {
    scope: "col"
};
const $90e803ea8a8cdcd5$var$_hoisted_53 = {
    scope: "row"
};
const $90e803ea8a8cdcd5$var$_hoisted_54 = [
    "onClick"
];
const $90e803ea8a8cdcd5$var$_hoisted_55 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $90e803ea8a8cdcd5$var$_hoisted_56 = [
    "onUpdate:modelValue",
    "onInput",
    "id"
];
const $90e803ea8a8cdcd5$var$_hoisted_57 = [
    "onUpdate:modelValue",
    "id"
];
const $90e803ea8a8cdcd5$var$_hoisted_58 = [
    "onUpdate:modelValue",
    "id"
];
const $90e803ea8a8cdcd5$var$_hoisted_59 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $90e803ea8a8cdcd5$var$_hoisted_60 = [
    $90e803ea8a8cdcd5$var$_hoisted_59
];
const $90e803ea8a8cdcd5$var$_hoisted_61 = {
    class: "row mb-4"
};
const $90e803ea8a8cdcd5$var$_hoisted_62 = {
    class: "table"
};
const $90e803ea8a8cdcd5$var$_hoisted_63 = {
    scope: "col"
};
const $90e803ea8a8cdcd5$var$_hoisted_64 = {
    scope: "col"
};
const $90e803ea8a8cdcd5$var$_hoisted_65 = {
    scope: "col"
};
const $90e803ea8a8cdcd5$var$_hoisted_66 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $90e803ea8a8cdcd5$var$_hoisted_67 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $90e803ea8a8cdcd5$var$_hoisted_68 = {
    class: "form-check"
};
const $90e803ea8a8cdcd5$var$_hoisted_69 = [
    "onUpdate:modelValue",
    "id"
];
const $90e803ea8a8cdcd5$var$_hoisted_70 = [
    "onUpdate:modelValue",
    "id"
];
const $90e803ea8a8cdcd5$var$_hoisted_71 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $90e803ea8a8cdcd5$var$_hoisted_72 = {
    key: 0
};
const $90e803ea8a8cdcd5$var$_hoisted_73 = [
    "onClick"
];
const $90e803ea8a8cdcd5$var$_hoisted_74 = {
    key: 1
};
const $90e803ea8a8cdcd5$var$_hoisted_75 = [
    "onClick"
];
const $90e803ea8a8cdcd5$var$_hoisted_76 = {
    class: "d-grid gap-2 d-md-flex"
};
function $90e803ea8a8cdcd5$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_AssetTypeDeleteModal = (0, $TusQn.resolveComponent)("AssetTypeDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $90e803ea8a8cdcd5$var$_hoisted_1, $90e803ea8a8cdcd5$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $90e803ea8a8cdcd5$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("assetTypeDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $90e803ea8a8cdcd5$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $90e803ea8a8cdcd5$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $90e803ea8a8cdcd5$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $90e803ea8a8cdcd5$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $90e803ea8a8cdcd5$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $90e803ea8a8cdcd5$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.data.name) + " detail ", 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $90e803ea8a8cdcd5$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $90e803ea8a8cdcd5$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("label", $90e803ea8a8cdcd5$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("assetAttribute")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "assetAttribute",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.assetAttribute = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $90e803ea8a8cdcd5$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $90e803ea8a8cdcd5$var$_hoisted_20);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                    $data.missingDatasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 1
                    }, (0, $TusQn.renderList)($data.missingDatasetHeaders, (missingDatasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            disabled: "",
                            value: missingDatasetHeader.name
                        }, (0, $8POXm.toDisplayString)(missingDatasetHeader.alias), 9, $90e803ea8a8cdcd5$var$_hoisted_21);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.assetAttribute
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_22, [
                (0, $TusQn.createElementVNode)("label", $90e803ea8a8cdcd5$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("assetAttributeYear")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "assetAttributeYear",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.assetAttributeYear = $event)
                }, [
                    $90e803ea8a8cdcd5$var$_hoisted_24,
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $90e803ea8a8cdcd5$var$_hoisted_25);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                    $data.missingDatasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 1
                    }, (0, $TusQn.renderList)($data.missingDatasetHeaders, (missingDatasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            disabled: "",
                            value: missingDatasetHeader.name
                        }, (0, $8POXm.toDisplayString)(missingDatasetHeader.alias), 9, $90e803ea8a8cdcd5$var$_hoisted_26);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.assetAttributeYear
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_27, [
                (0, $TusQn.createElementVNode)("label", $90e803ea8a8cdcd5$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycleAgeAttribute")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "lifeCycleAgeAttribute",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.lifeCycleAgeAttribute = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $90e803ea8a8cdcd5$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $90e803ea8a8cdcd5$var$_hoisted_30);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                    $data.missingDatasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 1
                    }, (0, $TusQn.renderList)($data.missingDatasetHeaders, (missingDatasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            disabled: "",
                            value: missingDatasetHeader.name
                        }, (0, $8POXm.toDisplayString)(missingDatasetHeader.alias), 9, $90e803ea8a8cdcd5$var$_hoisted_31);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.lifeCycleAgeAttribute
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_32, [
                (0, $TusQn.createElementVNode)("label", $90e803ea8a8cdcd5$var$_hoisted_33, (0, $8POXm.toDisplayString)(_ctx.$t("weightAttribute")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "weightAttribute",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.data.weightAttribute = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $90e803ea8a8cdcd5$var$_hoisted_34, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $90e803ea8a8cdcd5$var$_hoisted_35);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                    $data.missingDatasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 1
                    }, (0, $TusQn.renderList)($data.missingDatasetHeaders, (missingDatasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            disabled: "",
                            value: missingDatasetHeader.name
                        }, (0, $8POXm.toDisplayString)(missingDatasetHeader.alias), 9, $90e803ea8a8cdcd5$var$_hoisted_36);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.weightAttribute
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_37, [
                (0, $TusQn.createElementVNode)("label", $90e803ea8a8cdcd5$var$_hoisted_38, (0, $8POXm.toDisplayString)(_ctx.$t("visualizationValue")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "visualizationValue",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.data.visualizationValue = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $90e803ea8a8cdcd5$var$_hoisted_39, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.visualizationValues.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.visualizationValues, (visualizationValue, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: visualizationValue.id
                        }, (0, $8POXm.toDisplayString)(visualizationValue.name), 9, $90e803ea8a8cdcd5$var$_hoisted_40);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.visualizationValue
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_41, [
                $90e803ea8a8cdcd5$var$_hoisted_42,
                (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_43, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$data.data.recalculateLifeCycleAge = $event),
                        id: "recalculateLifeCycleAge",
                        checked: ""
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelCheckbox),
                            $data.data.recalculateLifeCycleAge
                        ]
                    ]),
                    (0, $TusQn.createElementVNode)("label", $90e803ea8a8cdcd5$var$_hoisted_44, (0, $8POXm.toDisplayString)(_ctx.$t("recalculateLifeCycleAge")), 1)
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_45, [
            (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_46, [
                (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("classificationOfAssetAttribute")), 1),
                (0, $TusQn.createElementVNode)("table", $90e803ea8a8cdcd5$var$_hoisted_47, [
                    (0, $TusQn.createElementVNode)("thead", null, [
                        (0, $TusQn.createElementVNode)("tr", null, [
                            $90e803ea8a8cdcd5$var$_hoisted_48,
                            (0, $TusQn.createElementVNode)("th", $90e803ea8a8cdcd5$var$_hoisted_49, (0, $8POXm.toDisplayString)(_ctx.$t("startAssetPerformance")), 1),
                            (0, $TusQn.createElementVNode)("th", $90e803ea8a8cdcd5$var$_hoisted_50, (0, $8POXm.toDisplayString)(_ctx.$t("endAssetPerformance")), 1),
                            (0, $TusQn.createElementVNode)("th", $90e803ea8a8cdcd5$var$_hoisted_51, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                            (0, $TusQn.createElementVNode)("th", $90e803ea8a8cdcd5$var$_hoisted_52, (0, $8POXm.toDisplayString)(_ctx.$t("color")), 1)
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("tbody", null, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.assetTypeClassification, (classificationOfAssetPerformance, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                class: "align-middle",
                                key: i
                            }, [
                                (0, $TusQn.createElementVNode)("th", $90e803ea8a8cdcd5$var$_hoisted_53, [
                                    (0, $TusQn.createElementVNode)("i", {
                                        class: "fa fa-remove",
                                        onClick: ($event)=>$options.removeClassification(i)
                                    }, null, 8, $90e803ea8a8cdcd5$var$_hoisted_54)
                                ]),
                                (0, $TusQn.createElementVNode)("td", null, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        "onUpdate:modelValue": ($event)=>classificationOfAssetPerformance.startAssetPerformance = $event,
                                        disabled: i != 0,
                                        type: "number",
                                        class: "form-control",
                                        id: "startAssetPerformance_" + i
                                    }, null, 8, $90e803ea8a8cdcd5$var$_hoisted_55), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            classificationOfAssetPerformance.startAssetPerformance
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("td", null, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        "onUpdate:modelValue": ($event)=>classificationOfAssetPerformance.endAssetPerformance = $event,
                                        onInput: ($event)=>$options.updateAssetTypeClassificationStart(classificationOfAssetPerformance.endAssetPerformance, i),
                                        type: "number",
                                        class: "form-control",
                                        id: "endAssetPerformance_" + i
                                    }, null, 40, $90e803ea8a8cdcd5$var$_hoisted_56), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            classificationOfAssetPerformance.endAssetPerformance
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("td", null, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        "onUpdate:modelValue": ($event)=>classificationOfAssetPerformance.name = $event,
                                        type: "text",
                                        class: "form-control",
                                        id: "name_" + i
                                    }, null, 8, $90e803ea8a8cdcd5$var$_hoisted_57), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            classificationOfAssetPerformance.name
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("td", null, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        "onUpdate:modelValue": ($event)=>classificationOfAssetPerformance.color = $event,
                                        type: "color",
                                        id: "color_" + i
                                    }, null, 8, $90e803ea8a8cdcd5$var$_hoisted_58), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            classificationOfAssetPerformance.color
                                        ]
                                    ])
                                ])
                            ]);
                        }), 128))
                    ])
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    class: "btn btn-secondary w-25 mx-auto d-block",
                    onClick: _cache[8] || (_cache[8] = (...args)=>$options.addClassification && $options.addClassification(...args))
                }, $90e803ea8a8cdcd5$var$_hoisted_60)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_61, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("infosetAttributes")), 1),
            (0, $TusQn.createElementVNode)("table", $90e803ea8a8cdcd5$var$_hoisted_62, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        (0, $TusQn.createElementVNode)("th", $90e803ea8a8cdcd5$var$_hoisted_63, (0, $8POXm.toDisplayString)(_ctx.$t("leading")), 1),
                        (0, $TusQn.createElementVNode)("th", $90e803ea8a8cdcd5$var$_hoisted_64, (0, $8POXm.toDisplayString)(_ctx.$t("headerName")), 1),
                        (0, $TusQn.createElementVNode)("th", $90e803ea8a8cdcd5$var$_hoisted_65, (0, $8POXm.toDisplayString)(_ctx.$t("alias")), 1),
                        $90e803ea8a8cdcd5$var$_hoisted_66,
                        $90e803ea8a8cdcd5$var$_hoisted_67
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.orderedClientHeaders($data.clientHeaders), (infoSet, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_68, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event)=>infoSet.leading = $event,
                                        id: "leading_" + i
                                    }, null, 8, $90e803ea8a8cdcd5$var$_hoisted_69), [
                                        [
                                            (0, $eeJ70.vModelCheckbox),
                                            infoSet.leading
                                        ]
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>infoSet.headerName = $event,
                                    disabled: "",
                                    type: "text",
                                    class: "form-control",
                                    id: "headerName_" + i
                                }, null, 8, $90e803ea8a8cdcd5$var$_hoisted_70), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        infoSet.headerName
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>infoSet.alias = $event,
                                    disabled: !infoSet.leading,
                                    type: "text",
                                    class: "form-control",
                                    id: "alias_" + i
                                }, null, 8, $90e803ea8a8cdcd5$var$_hoisted_71), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        infoSet.alias
                                    ]
                                ])
                            ]),
                            infoSet.leading ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("td", $90e803ea8a8cdcd5$var$_hoisted_72, [
                                i < $data.clientHeaders.length - 1 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("i", {
                                    key: 0,
                                    class: "fa fa-arrow-down",
                                    onClick: ($event)=>$options.moveAssetTypeInfoSetDown(i)
                                }, null, 8, $90e803ea8a8cdcd5$var$_hoisted_73)) : (0, $TusQn.createCommentVNode)("", true)
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            infoSet.leading ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("td", $90e803ea8a8cdcd5$var$_hoisted_74, [
                                i != 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("i", {
                                    key: 0,
                                    class: "fa fa-arrow-up",
                                    onClick: ($event)=>$options.moveAssetTypeInfoSetUp(i)
                                }, null, 8, $90e803ea8a8cdcd5$var$_hoisted_75)) : (0, $TusQn.createCommentVNode)("", true)
                            ])) : (0, $TusQn.createCommentVNode)("", true)
                        ]);
                    }), 128))
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $90e803ea8a8cdcd5$var$_hoisted_76, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[9] || (_cache[9] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[10] || (_cache[10] = ($event)=>$data.showDeleteAssetType = true)
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[11] || (_cache[11] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showDeleteAssetType ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_AssetTypeDeleteModal, {
            key: 0,
            onReload: _cache[12] || (_cache[12] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}`
                })),
            onCloseDeleteDialog: _cache[13] || (_cache[13] = ($event)=>$data.showDeleteAssetType = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("aIi91", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ccc169299cfe64e$export$2e2bcd8739ae039);
let $7ccc169299cfe64e$var$NOOP = ()=>{};
var $7ccc169299cfe64e$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("eEK8D", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $aab8973d34f00577$export$2e2bcd8739ae039);

var $2gQQk = parcelRequire("2gQQk");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $97ZUR = parcelRequire("97ZUR");

var $l6otV = parcelRequire("l6otV");

var $gOjKo = parcelRequire("gOjKo");
var $aab8973d34f00577$export$2e2bcd8739ae039 = {
    name: "activitydetail",
    watch: {
        $route: "requestData"
    },
    components: {
        ActivityDeleteModal: $97ZUR.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var modelingInfo = await (0, $l6otV.default).modelingInfo(this.$route.params.id);
            var foundAssetType = modelingInfo.assetTypes.find((a)=>a.id == this.$route.params.assetTypeId);
            if (foundAssetType != null) {
                for(var i in foundAssetType.lifeCycles){
                    var lifeCycle = foundAssetType.lifeCycles[i];
                    for(var o in lifeCycle.lifeCycleActivities){
                        var activity = lifeCycle.lifeCycleActivities[o];
                        if (activity.activityId == this.$route.params.activityId) this.foundActivities.push({
                            lifeCycleId: lifeCycle.id,
                            activityId: activity.activityId,
                            name: "LifeCycle - " + lifeCycle.name + " - " + activity.activityName
                        });
                    }
                }
                for(var i in foundAssetType.parameters){
                    var parameter = foundAssetType.parameters[i];
                    for(var o in parameter.curves){
                        var curve = parameter.curves[o];
                        for(var u in curve.effects){
                            var effect = curve.effects[u];
                            if (effect.activityId == this.$route.params.activityId) this.foundActivities.push({
                                curveId: curve.id,
                                activityId: effect.activityId,
                                type: "curve",
                                name: "Parameter - " + parameter.name + " - Curve - " + curve.name
                            });
                        }
                    }
                }
            }
            this.data = await (0, $2gQQk.default).activityDetail(this.$route.params.id, this.$route.params.activityId);
            if (this.data.costFactor) this.costFactors = this.data.costFactor.split(";");
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            for(var i in this.costFactors){
                var attr = this.costFactors[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr) < 0 && this.missingDatasetHeaders.findIndex((d)=>d.name == attr) < 0) this.missingDatasetHeaders.push({
                    name: attr,
                    alias: attr
                });
            }
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                if (this.costFactors.length > 1) this.data.costFactor = this.costFactors.join(";");
                else this.data.costFactor = this.costFactors.join("");
                await (0, $2gQQk.default).activityUpdate(this.$route.params.id, this.data);
                if (!this.isFormValid()) this.showWarning();
                else this.showSuccess();
            } else this.showEmptyNameError();
        },
        isFormValid () {
            for(var i in this.costFactors){
                var attr = this.costFactors[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr) < 0 && attr != "") return false;
            }
            return true;
        },
        showDeleteActivity () {
            this.activityToDeleteId = this.data.id;
            this.showActivityDeleteModal = true;
        },
        addCostFactor () {
            this.costFactors.push({
                name: ""
            });
        },
        removeCostFactor (i) {
            this.costFactors.splice(i, 1);
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "activityUpdated",
            type: "success"
        },
        showWarning: {
            title: "warning",
            message: "warningAttributeRemoved",
            type: "warn"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            costFactors: [],
            missingDatasetHeaders: [],
            datasetHeaders: [],
            data: {
                name: "",
                id: ""
            },
            showActivityDeleteModal: false,
            activityToDeleteId: 0,
            modelingName: null,
            assetTypeName: null,
            foundActivities: [],
            pending: true,
            isUserAdmin: false
        };
    }
};

});
parcelRegister("97ZUR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a54cbc097f1d833$export$2e2bcd8739ae039);
let $6a54cbc097f1d833$var$script;



let $6a54cbc097f1d833$var$initialize = ()=>{
    $6a54cbc097f1d833$var$script = (parcelRequire("5KRN9"));
    if ($6a54cbc097f1d833$var$script.__esModule) $6a54cbc097f1d833$var$script = $6a54cbc097f1d833$var$script.default;
    $6a54cbc097f1d833$var$script.render = (parcelRequire("6XJXR")).render;
    (parcelRequire("jqDVJ")).default($6a54cbc097f1d833$var$script);
    $6a54cbc097f1d833$var$script.__scopeId = "data-v-93a735";
    $6a54cbc097f1d833$var$script.__file = "ActivityDeleteModal.vue";
};
$6a54cbc097f1d833$var$initialize();
var $6a54cbc097f1d833$export$2e2bcd8739ae039 = $6a54cbc097f1d833$var$script;

});
parcelRegister("5KRN9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $430af98943883076$export$2e2bcd8739ae039);

var $2gQQk = parcelRequire("2gQQk");
var $430af98943883076$export$2e2bcd8739ae039 = {
    name: "activityDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        buildRouterLink (activity) {
            if (activity.type == "curve") return "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/curve/" + activity.curveId;
            else return "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/lifecycle/" + activity.lifeCycleId;
        },
        async deleteActivity () {
            await (0, $2gQQk.default).activityDelete(this.$parent.$route.params.id, this.$parent.activityToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("6XJXR", function(module, exports) {

$parcel$export(module.exports, "render", () => $014ee6d823a04816$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $014ee6d823a04816$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $014ee6d823a04816$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $014ee6d823a04816$var$_hoisted_3 = {
    class: "modal-content"
};
const $014ee6d823a04816$var$_hoisted_4 = {
    class: "modal-header"
};
const $014ee6d823a04816$var$_hoisted_5 = {
    class: "modal-title"
};
const $014ee6d823a04816$var$_hoisted_6 = {
    class: "modal-body"
};
const $014ee6d823a04816$var$_hoisted_7 = {
    class: "form-label"
};
const $014ee6d823a04816$var$_hoisted_8 = {
    key: 1
};
const $014ee6d823a04816$var$_hoisted_9 = {
    class: "modal-footer"
};
const $014ee6d823a04816$var$_hoisted_10 = [
    "disabled"
];
function $014ee6d823a04816$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $014ee6d823a04816$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $014ee6d823a04816$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $014ee6d823a04816$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $014ee6d823a04816$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $014ee6d823a04816$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("activityDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $014ee6d823a04816$var$_hoisted_6, [
                                this.$parent.foundActivities.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 0
                                }, [
                                    (0, $TusQn.createElementVNode)("label", $014ee6d823a04816$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("cannotDeleteActivity")), 1),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(this.$parent.foundActivities, (activity, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                            key: i
                                        }, [
                                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                                to: $options.buildRouterLink(activity)
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(activity.name), 1)
                                                    ]),
                                                _: 2
                                            }, 1032, [
                                                "to"
                                            ])
                                        ]);
                                    }), 128))
                                ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $014ee6d823a04816$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisActivity")), 1))
                            ]),
                            (0, $TusQn.createElementVNode)("div", $014ee6d823a04816$var$_hoisted_9, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteActivity && $options.deleteActivity(...args)),
                                    disabled: this.$parent.foundActivities.length > 0
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 9, $014ee6d823a04816$var$_hoisted_10)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("jqDVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e24f6b593e1e8831$export$2e2bcd8739ae039);
let $e24f6b593e1e8831$var$NOOP = ()=>{};
var $e24f6b593e1e8831$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("iWrCV", function(module, exports) {

$parcel$export(module.exports, "render", () => $dca312e2371bf7d1$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $dca312e2371bf7d1$var$_hoisted_1 = {
    key: 0
};
const $dca312e2371bf7d1$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $dca312e2371bf7d1$var$_hoisted_3 = [
    $dca312e2371bf7d1$var$_hoisted_2
];
const $dca312e2371bf7d1$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $dca312e2371bf7d1$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $dca312e2371bf7d1$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $dca312e2371bf7d1$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $dca312e2371bf7d1$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $dca312e2371bf7d1$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $dca312e2371bf7d1$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $dca312e2371bf7d1$var$_hoisted_11 = {
    class: "row"
};
const $dca312e2371bf7d1$var$_hoisted_12 = {
    class: "mb-3 col-md-4"
};
const $dca312e2371bf7d1$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $dca312e2371bf7d1$var$_hoisted_14 = {
    class: "mb-3 col-md-8"
};
const $dca312e2371bf7d1$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $dca312e2371bf7d1$var$_hoisted_16 = {
    class: "row mb-3"
};
const $dca312e2371bf7d1$var$_hoisted_17 = {
    class: "mb-3 col-md-4"
};
const $dca312e2371bf7d1$var$_hoisted_18 = {
    class: "form-label",
    for: "unit",
    required: ""
};
const $dca312e2371bf7d1$var$_hoisted_19 = {
    class: "mb-3 col-md-3"
};
const $dca312e2371bf7d1$var$_hoisted_20 = {
    class: "form-label",
    for: "unitCost",
    required: ""
};
const $dca312e2371bf7d1$var$_hoisted_21 = {
    class: "mb-3 col-md-2"
};
const $dca312e2371bf7d1$var$_hoisted_22 = {
    class: "form-label",
    for: "activityColor",
    required: ""
};
const $dca312e2371bf7d1$var$_hoisted_23 = {
    class: "form-label",
    for: "costFactor",
    required: ""
};
const $dca312e2371bf7d1$var$_hoisted_24 = {
    class: "row"
};
const $dca312e2371bf7d1$var$_hoisted_25 = {
    class: "input-group mb-3"
};
const $dca312e2371bf7d1$var$_hoisted_26 = [
    "id",
    "onUpdate:modelValue"
];
const $dca312e2371bf7d1$var$_hoisted_27 = {
    disabled: ""
};
const $dca312e2371bf7d1$var$_hoisted_28 = [
    "value"
];
const $dca312e2371bf7d1$var$_hoisted_29 = [
    "value"
];
const $dca312e2371bf7d1$var$_hoisted_30 = {
    class: "input-group-text",
    id: "basic-addon2"
};
const $dca312e2371bf7d1$var$_hoisted_31 = [
    "onClick"
];
const $dca312e2371bf7d1$var$_hoisted_32 = {
    class: "mb-3 col-md-3"
};
const $dca312e2371bf7d1$var$_hoisted_33 = {
    class: "row mb-3"
};
const $dca312e2371bf7d1$var$_hoisted_34 = {
    class: "mb-3 col-md-6"
};
const $dca312e2371bf7d1$var$_hoisted_35 = {
    class: "form-check-label",
    for: "rootActivity"
};
const $dca312e2371bf7d1$var$_hoisted_36 = {
    class: "input-group"
};
const $dca312e2371bf7d1$var$_hoisted_37 = {
    class: "input-group-text"
};
const $dca312e2371bf7d1$var$_hoisted_38 = [
    "disabled"
];
const $dca312e2371bf7d1$var$_hoisted_39 = [
    "disabled"
];
const $dca312e2371bf7d1$var$_hoisted_40 = {
    value: "0"
};
const $dca312e2371bf7d1$var$_hoisted_41 = {
    value: "1"
};
const $dca312e2371bf7d1$var$_hoisted_42 = {
    value: "2"
};
const $dca312e2371bf7d1$var$_hoisted_43 = {
    class: "d-grid gap-2 d-md-flex"
};
function $dca312e2371bf7d1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_ActivityDeleteModal = (0, $TusQn.resolveComponent)("ActivityDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $dca312e2371bf7d1$var$_hoisted_1, $dca312e2371bf7d1$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $dca312e2371bf7d1$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("activityDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $dca312e2371bf7d1$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $dca312e2371bf7d1$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $dca312e2371bf7d1$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $dca312e2371bf7d1$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $dca312e2371bf7d1$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $dca312e2371bf7d1$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $dca312e2371bf7d1$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $dca312e2371bf7d1$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("label", $dca312e2371bf7d1$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("unit")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.unit = $event),
                    type: "text",
                    class: "form-control",
                    id: "unit"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.unit
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_19, [
                (0, $TusQn.createElementVNode)("label", $dca312e2371bf7d1$var$_hoisted_20, (0, $8POXm.toDisplayString)(_ctx.$t("unitCost")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.unitCost = $event),
                    type: "number",
                    class: "form-control",
                    id: "unitCost"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.unitCost
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_21, [
                (0, $TusQn.createElementVNode)("label", $dca312e2371bf7d1$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("activityColor")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.activityColor = $event),
                    type: "color",
                    class: "form-control",
                    id: "activityColor"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.activityColor
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("label", $dca312e2371bf7d1$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("costFactor")), 1),
        (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_24, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.costFactors, (costFactor, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "mb-3 col-md-3",
                    key: i
                }, [
                    (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_25, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                            id: "costFactor_" + i,
                            class: "form-select",
                            "onUpdate:modelValue": ($event)=>$data.costFactors[i] = $event
                        }, [
                            (0, $TusQn.createElementVNode)("option", $dca312e2371bf7d1$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                            $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 0
                            }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                    key: i,
                                    value: datasetHeader.name
                                }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $dca312e2371bf7d1$var$_hoisted_28);
                            }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                            $data.missingDatasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 1
                            }, (0, $TusQn.renderList)($data.missingDatasetHeaders, (missingDatasetHeader, i)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                    key: i,
                                    disabled: "",
                                    value: missingDatasetHeader.name
                                }, (0, $8POXm.toDisplayString)(missingDatasetHeader.alias), 9, $dca312e2371bf7d1$var$_hoisted_29);
                            }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                        ], 8, $dca312e2371bf7d1$var$_hoisted_26), [
                            [
                                (0, $eeJ70.vModelSelect),
                                $data.costFactors[i]
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("span", $dca312e2371bf7d1$var$_hoisted_30, [
                            (0, $TusQn.createElementVNode)("i", {
                                class: "fa fa-remove",
                                onClick: ($event)=>$options.removeCostFactor(i)
                            }, null, 8, $dca312e2371bf7d1$var$_hoisted_31)
                        ])
                    ])
                ]);
            }), 128)),
            (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_32, [
                (0, $TusQn.createElementVNode)("button", {
                    class: "form-control btn btn-light",
                    id: "unit",
                    onClick: _cache[5] || (_cache[5] = (...args)=>$options.addCostFactor && $options.addCostFactor(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("addCostFactor")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_33, [
            (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_34, [
                (0, $TusQn.createElementVNode)("label", $dca312e2371bf7d1$var$_hoisted_35, (0, $8POXm.toDisplayString)(_ctx.$t("rootActivity")), 1),
                (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_36, [
                    (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_37, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "form-check-input mt-0",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.data.rootActivity = $event),
                            type: "checkbox",
                            id: "rootActivity"
                        }, null, 512), [
                            [
                                (0, $eeJ70.vModelCheckbox),
                                $data.data.rootActivity
                            ]
                        ])
                    ]),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        disabled: !$data.data.rootActivity,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$data.data.rootActivityEffect = $event),
                        type: "number",
                        class: "form-control",
                        id: "rootActivityEffect"
                    }, null, 8, $dca312e2371bf7d1$var$_hoisted_38), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.rootActivityEffect
                        ]
                    ]),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                        disabled: !$data.data.rootActivity,
                        class: "form-select",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$data.data.rootActivityEffectType = $event)
                    }, [
                        (0, $TusQn.createElementVNode)("option", $dca312e2371bf7d1$var$_hoisted_40, (0, $8POXm.toDisplayString)(_ctx.$t("Absolute")), 1),
                        (0, $TusQn.createElementVNode)("option", $dca312e2371bf7d1$var$_hoisted_41, (0, $8POXm.toDisplayString)(_ctx.$t("Relative")), 1),
                        (0, $TusQn.createElementVNode)("option", $dca312e2371bf7d1$var$_hoisted_42, (0, $8POXm.toDisplayString)(_ctx.$t("Differential")), 1)
                    ], 8, $dca312e2371bf7d1$var$_hoisted_39), [
                        [
                            (0, $eeJ70.vModelSelect),
                            $data.data.rootActivityEffectType
                        ]
                    ])
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $dca312e2371bf7d1$var$_hoisted_43, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[9] || (_cache[9] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[10] || (_cache[10] = (...args)=>$options.showDeleteActivity && $options.showDeleteActivity(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[11] || (_cache[11] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showActivityDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ActivityDeleteModal, {
            key: 0,
            onReload: _cache[12] || (_cache[12] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                })),
            onCloseDeleteDialog: _cache[13] || (_cache[13] = ($event)=>$data.showActivityDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("ifts3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4907926f8b09547$export$2e2bcd8739ae039);
let $d4907926f8b09547$var$NOOP = ()=>{};
var $d4907926f8b09547$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("gRek3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c45cb4bebd9ab0cb$export$2e2bcd8739ae039);

var $2gQQk = parcelRequire("2gQQk");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $l6otV = parcelRequire("l6otV");
var $c45cb4bebd9ab0cb$export$2e2bcd8739ae039 = {
    name: "activityCreate",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                if (this.costFactors.length > 1) this.data.costFactor = this.costFactors.join(";");
                else this.data.costFactor = this.costFactors.join("");
                this.data.assetTypeId = this.$route.params.assetTypeId;
                await (0, $2gQQk.default).activityCreate(this.$route.params.id, this.data);
                this.$router.go(-1);
            } else this.showEmptyNameError();
        },
        addCostFactor () {
            this.costFactors.push({
                name: ""
            });
        },
        removeCostFactor (i) {
            this.costFactors.splice(i, 1);
        }
    },
    notifications: {
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            costFactors: [],
            datasetHeaders: [],
            data: {
                name: "",
                activityColor: "#004C83",
                rootActivity: false,
                rootActivityEffect: 0,
                rootActivityEffectType: 0,
                id: 0
            },
            modelingName: null,
            assetTypeName: null,
            pending: true
        };
    }
};

});

parcelRegister("gqcWW", function(module, exports) {

$parcel$export(module.exports, "render", () => $bf491e99148678e3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $bf491e99148678e3$var$_hoisted_1 = {
    key: 0
};
const $bf491e99148678e3$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $bf491e99148678e3$var$_hoisted_3 = [
    $bf491e99148678e3$var$_hoisted_2
];
const $bf491e99148678e3$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $bf491e99148678e3$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $bf491e99148678e3$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $bf491e99148678e3$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $bf491e99148678e3$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $bf491e99148678e3$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $bf491e99148678e3$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $bf491e99148678e3$var$_hoisted_11 = {
    class: "row"
};
const $bf491e99148678e3$var$_hoisted_12 = {
    class: "mb-3 col-md-4"
};
const $bf491e99148678e3$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $bf491e99148678e3$var$_hoisted_14 = {
    class: "mb-3 col-md-8"
};
const $bf491e99148678e3$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $bf491e99148678e3$var$_hoisted_16 = {
    class: "row mb-3"
};
const $bf491e99148678e3$var$_hoisted_17 = {
    class: "mb-3 col-md-4"
};
const $bf491e99148678e3$var$_hoisted_18 = {
    class: "form-label",
    for: "unit",
    required: ""
};
const $bf491e99148678e3$var$_hoisted_19 = {
    class: "mb-3 col-md-3"
};
const $bf491e99148678e3$var$_hoisted_20 = {
    class: "form-label",
    for: "unitCost",
    required: ""
};
const $bf491e99148678e3$var$_hoisted_21 = {
    class: "mb-3 col-md-2"
};
const $bf491e99148678e3$var$_hoisted_22 = {
    class: "form-label",
    for: "activityColor",
    required: ""
};
const $bf491e99148678e3$var$_hoisted_23 = {
    class: "form-label",
    for: "costFactor",
    required: ""
};
const $bf491e99148678e3$var$_hoisted_24 = {
    class: "row"
};
const $bf491e99148678e3$var$_hoisted_25 = {
    class: "input-group mb-3"
};
const $bf491e99148678e3$var$_hoisted_26 = [
    "id",
    "onUpdate:modelValue"
];
const $bf491e99148678e3$var$_hoisted_27 = {
    disabled: ""
};
const $bf491e99148678e3$var$_hoisted_28 = [
    "value"
];
const $bf491e99148678e3$var$_hoisted_29 = {
    class: "input-group-text",
    id: "basic-addon2"
};
const $bf491e99148678e3$var$_hoisted_30 = [
    "onClick"
];
const $bf491e99148678e3$var$_hoisted_31 = {
    class: "mb-3 col-md-3"
};
const $bf491e99148678e3$var$_hoisted_32 = {
    class: "row mb-3"
};
const $bf491e99148678e3$var$_hoisted_33 = {
    class: "mb-3 col-md-6"
};
const $bf491e99148678e3$var$_hoisted_34 = {
    class: "form-check-label",
    for: "rootActivity"
};
const $bf491e99148678e3$var$_hoisted_35 = {
    class: "input-group"
};
const $bf491e99148678e3$var$_hoisted_36 = {
    class: "input-group-text"
};
const $bf491e99148678e3$var$_hoisted_37 = [
    "disabled"
];
const $bf491e99148678e3$var$_hoisted_38 = [
    "disabled"
];
const $bf491e99148678e3$var$_hoisted_39 = {
    value: "0"
};
const $bf491e99148678e3$var$_hoisted_40 = {
    value: "1"
};
const $bf491e99148678e3$var$_hoisted_41 = {
    value: "2"
};
const $bf491e99148678e3$var$_hoisted_42 = {
    class: "d-grid gap-2 d-md-flex"
};
function $bf491e99148678e3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $bf491e99148678e3$var$_hoisted_1, $bf491e99148678e3$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $bf491e99148678e3$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("activityCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $bf491e99148678e3$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $bf491e99148678e3$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $bf491e99148678e3$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $bf491e99148678e3$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $bf491e99148678e3$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $bf491e99148678e3$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("activityCreate")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $bf491e99148678e3$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $bf491e99148678e3$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("label", $bf491e99148678e3$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("unit")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.unit = $event),
                    type: "text",
                    class: "form-control",
                    id: "unit"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.unit
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_19, [
                (0, $TusQn.createElementVNode)("label", $bf491e99148678e3$var$_hoisted_20, (0, $8POXm.toDisplayString)(_ctx.$t("unitCost")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.unitCost = $event),
                    type: "number",
                    class: "form-control",
                    id: "unitCost"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.unitCost
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_21, [
                (0, $TusQn.createElementVNode)("label", $bf491e99148678e3$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("activityColor")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.activityColor = $event),
                    type: "color",
                    class: "form-control",
                    id: "activityColor"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.activityColor
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("label", $bf491e99148678e3$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("costFactor")), 1),
        (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_24, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.costFactors, (costFactor, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "mb-3 col-md-3",
                    key: i
                }, [
                    (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_25, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                            id: "changeToLifecycleId_" + i,
                            class: "form-select",
                            "onUpdate:modelValue": ($event)=>$data.costFactors[i] = $event
                        }, [
                            (0, $TusQn.createElementVNode)("option", $bf491e99148678e3$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                            $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 0
                            }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                    key: i,
                                    value: datasetHeader.name
                                }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $bf491e99148678e3$var$_hoisted_28);
                            }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                        ], 8, $bf491e99148678e3$var$_hoisted_26), [
                            [
                                (0, $eeJ70.vModelSelect),
                                $data.costFactors[i]
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("span", $bf491e99148678e3$var$_hoisted_29, [
                            (0, $TusQn.createElementVNode)("i", {
                                class: "fa fa-remove",
                                onClick: ($event)=>$options.removeCostFactor(i)
                            }, null, 8, $bf491e99148678e3$var$_hoisted_30)
                        ])
                    ])
                ]);
            }), 128)),
            (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_31, [
                (0, $TusQn.createElementVNode)("button", {
                    class: "form-control btn btn-light",
                    id: "unit",
                    onClick: _cache[5] || (_cache[5] = (...args)=>$options.addCostFactor && $options.addCostFactor(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("addCostFactor")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_32, [
            (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_33, [
                (0, $TusQn.createElementVNode)("label", $bf491e99148678e3$var$_hoisted_34, (0, $8POXm.toDisplayString)(_ctx.$t("rootActivity")), 1),
                (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_35, [
                    (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_36, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "form-check-input mt-0",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.data.rootActivity = $event),
                            type: "checkbox",
                            id: "rootActivity"
                        }, null, 512), [
                            [
                                (0, $eeJ70.vModelCheckbox),
                                $data.data.rootActivity
                            ]
                        ])
                    ]),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        disabled: !$data.data.rootActivity,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$data.data.rootActivityEffect = $event),
                        type: "number",
                        class: "form-control",
                        id: "rootActivityEffect"
                    }, null, 8, $bf491e99148678e3$var$_hoisted_37), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.rootActivityEffect
                        ]
                    ]),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                        disabled: !$data.data.rootActivity,
                        class: "form-select",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$data.data.rootActivityEffectType = $event)
                    }, [
                        (0, $TusQn.createElementVNode)("option", $bf491e99148678e3$var$_hoisted_39, (0, $8POXm.toDisplayString)(_ctx.$t("Absolute")), 1),
                        (0, $TusQn.createElementVNode)("option", $bf491e99148678e3$var$_hoisted_40, (0, $8POXm.toDisplayString)(_ctx.$t("Relative")), 1),
                        (0, $TusQn.createElementVNode)("option", $bf491e99148678e3$var$_hoisted_41, (0, $8POXm.toDisplayString)(_ctx.$t("Differential")), 1)
                    ], 8, $bf491e99148678e3$var$_hoisted_38), [
                        [
                            (0, $eeJ70.vModelSelect),
                            $data.data.rootActivityEffectType
                        ]
                    ])
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $bf491e99148678e3$var$_hoisted_42, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[9] || (_cache[9] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[10] || (_cache[10] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("DXsKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0781c4abf06d9969$export$2e2bcd8739ae039);
let $0781c4abf06d9969$var$NOOP = ()=>{};
var $0781c4abf06d9969$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("3YAVM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2e539f646429cbef$export$2e2bcd8739ae039);

var $gM1Yh = parcelRequire("gM1Yh");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $ftVMi = parcelRequire("ftVMi");

var $l6otV = parcelRequire("l6otV");

var $gOjKo = parcelRequire("gOjKo");
var $2e539f646429cbef$export$2e2bcd8739ae039 = {
    name: "parameterdetail",
    watch: {
        $route: "requestData"
    },
    components: {
        ParameterDeleteModal: $ftVMi.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            this.data = await (0, $gM1Yh.default).parameterDetail(this.$route.params.id, this.$route.params.parameterId);
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            this.evaluationList = await (0, $gM1Yh.default).evaluationList(this.$route.params.id, this.$route.params.parameterId);
            // this.evaluationList = evaluationList.filter(e => e.parameterId == this.$route.params.parameterId);
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            for(var i in this.costFactors){
                var attr = this.costFactors[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr) < 0 && this.missingDatasetHeaders.findIndex((d)=>d.name == attr) < 0) this.missingDatasetHeaders.push({
                    name: attr,
                    alias: attr
                });
            }
            this.pending = false;
        },
        isFormValid () {
            for(var i in this.costFactors){
                var attr = this.costFactors[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr) < 0 && attr != "") return false;
            }
            return true;
        },
        showDeleteParameter () {
            this.parameterToDeleteId = this.data.id;
            this.showParameterDeleteModal = true;
        },
        removeParameterClass (rowIndex) {
            this.data.parameterClasses.splice(rowIndex, 1);
        },
        addParameterClass () {
            this.data.parameterClasses.push({
                color: "#000000",
                name: "",
                startClassification: this.getMinStartParameterClass(),
                endClassification: 0.0
            });
        },
        updateParameterClassStart (value, i) {
            var range = this.data.parameterClasses[i + 1];
            if (range) range.startClassification = value;
        },
        getMinStartParameterClass () {
            var minStartParameterClass = 0;
            if (this.data.parameterClasses.length > 0) minStartParameterClass = this.data.parameterClasses[this.data.parameterClasses.length - 1].endClassification;
            return minStartParameterClass;
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "parameterUpdated",
            type: "success"
        },
        showWarning: {
            title: "warning",
            message: "warningAttributeRemoved",
            type: "warn"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            costFactors: [],
            missingDatasetHeaders: [],
            datasetHeaders: [],
            evaluationList: [],
            data: {
                name: "",
                id: ""
            },
            showParameterDeleteModal: false,
            parameterToDeleteId: 0,
            modelingName: null,
            assetTypeName: null,
            pending: true,
            isUserAdmin: false
        };
    }
};

});
parcelRegister("ftVMi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b45661f0df62a35d$export$2e2bcd8739ae039);
let $b45661f0df62a35d$var$script;



let $b45661f0df62a35d$var$initialize = ()=>{
    $b45661f0df62a35d$var$script = (parcelRequire("lhJXv"));
    if ($b45661f0df62a35d$var$script.__esModule) $b45661f0df62a35d$var$script = $b45661f0df62a35d$var$script.default;
    $b45661f0df62a35d$var$script.render = (parcelRequire("jbZlM")).render;
    (parcelRequire("6S3YE")).default($b45661f0df62a35d$var$script);
    $b45661f0df62a35d$var$script.__scopeId = "data-v-4befc4";
    $b45661f0df62a35d$var$script.__file = "ParameterDeleteModal.vue";
};
$b45661f0df62a35d$var$initialize();
var $b45661f0df62a35d$export$2e2bcd8739ae039 = $b45661f0df62a35d$var$script;

});
parcelRegister("lhJXv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f7eed5f0f18af816$export$2e2bcd8739ae039);
parcelRequire("ecd4d");

var $gM1Yh = parcelRequire("gM1Yh");
var $f7eed5f0f18af816$export$2e2bcd8739ae039 = {
    name: "parameterDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteParameter () {
            await (0, $gM1Yh.default).parameterDelete(this.$parent.$route.params.id, this.$parent.parameterToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("jbZlM", function(module, exports) {

$parcel$export(module.exports, "render", () => $df8ea244f74ef690$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $df8ea244f74ef690$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $df8ea244f74ef690$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $df8ea244f74ef690$var$_hoisted_3 = {
    class: "modal-content"
};
const $df8ea244f74ef690$var$_hoisted_4 = {
    class: "modal-header"
};
const $df8ea244f74ef690$var$_hoisted_5 = {
    class: "modal-title"
};
const $df8ea244f74ef690$var$_hoisted_6 = {
    class: "modal-body"
};
const $df8ea244f74ef690$var$_hoisted_7 = {
    key: 0,
    class: "form-label"
};
const $df8ea244f74ef690$var$_hoisted_8 = {
    key: 1,
    class: "form-label"
};
const $df8ea244f74ef690$var$_hoisted_9 = {
    key: 2
};
const $df8ea244f74ef690$var$_hoisted_10 = {
    class: "modal-footer"
};
const $df8ea244f74ef690$var$_hoisted_11 = [
    "disabled"
];
function $df8ea244f74ef690$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $df8ea244f74ef690$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $df8ea244f74ef690$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $df8ea244f74ef690$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $df8ea244f74ef690$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $df8ea244f74ef690$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("parameterDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $df8ea244f74ef690$var$_hoisted_6, [
                                this.$parent.parameterContainsEvaluation ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("label", $df8ea244f74ef690$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("parameterContainsEvaluation")), 1)) : (0, $TusQn.createCommentVNode)("", true),
                                this.$parent.parameterContainsCurves ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("label", $df8ea244f74ef690$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("parameterContainsCurves")), 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $df8ea244f74ef690$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisParameter")), 1))
                            ]),
                            (0, $TusQn.createElementVNode)("div", $df8ea244f74ef690$var$_hoisted_10, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteParameter && $options.deleteParameter(...args)),
                                    disabled: this.$parent.parameterContainsEvaluation || this.$parent.parameterContainsCurves
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 9, $df8ea244f74ef690$var$_hoisted_11)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("6S3YE", function(module, exports) {

$parcel$export(module.exports, "default", () => $500adf08e67249e3$export$2e2bcd8739ae039);
let $500adf08e67249e3$var$NOOP = ()=>{};
var $500adf08e67249e3$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("icSbV", function(module, exports) {

$parcel$export(module.exports, "render", () => $d413623b069010c1$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $d413623b069010c1$var$_hoisted_1 = {
    key: 0
};
const $d413623b069010c1$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $d413623b069010c1$var$_hoisted_3 = [
    $d413623b069010c1$var$_hoisted_2
];
const $d413623b069010c1$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $d413623b069010c1$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $d413623b069010c1$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $d413623b069010c1$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $d413623b069010c1$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $d413623b069010c1$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $d413623b069010c1$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $d413623b069010c1$var$_hoisted_11 = {
    class: "text-center mb-4"
};
const $d413623b069010c1$var$_hoisted_12 = {
    class: "btn btn-secondary float-end"
};
const $d413623b069010c1$var$_hoisted_13 = {
    class: "mb-3 col-sm-3 ms-auto me-auto"
};
const $d413623b069010c1$var$_hoisted_14 = {
    class: "card text-center"
};
const $d413623b069010c1$var$_hoisted_15 = {
    class: "card-body"
};
const $d413623b069010c1$var$_hoisted_16 = {
    class: "card-title"
};
const $d413623b069010c1$var$_hoisted_17 = {
    key: 0,
    class: "list-group list-group-flush"
};
const $d413623b069010c1$var$_hoisted_18 = {
    class: "card-body"
};
const $d413623b069010c1$var$_hoisted_19 = {
    class: "btn btn-sm btn-light"
};
const $d413623b069010c1$var$_hoisted_20 = {
    class: "d-grid gap-2 d-md-flex"
};
function $d413623b069010c1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_ParameterDeleteModal = (0, $TusQn.resolveComponent)("ParameterDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d413623b069010c1$var$_hoisted_1, $d413623b069010c1$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d413623b069010c1$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("parameterDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $d413623b069010c1$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $d413623b069010c1$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $d413623b069010c1$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $d413623b069010c1$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $d413623b069010c1$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $d413623b069010c1$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("h3", $d413623b069010c1$var$_hoisted_11, [
            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name) + " ", 1),
            (0, $TusQn.createVNode)(_component_RouterLink, {
                to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/parameter/" + this.$route.params.parameterId + "/parameterinfo"
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createElementVNode)("button", $d413623b069010c1$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("detail")), 1)
                    ]),
                _: 1
            }, 8, [
                "to"
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $d413623b069010c1$var$_hoisted_13, [
            (0, $TusQn.createElementVNode)("div", $d413623b069010c1$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("div", $d413623b069010c1$var$_hoisted_15, [
                    (0, $TusQn.createElementVNode)("h5", $d413623b069010c1$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("evaluation")), 1)
                ]),
                $data.evaluationList.length >= 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $d413623b069010c1$var$_hoisted_17, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.evaluationList, (item, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                            class: "list-group-item",
                            key: i
                        }, [
                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/parameter/" + this.$route.params.parameterId + "/evaluation/" + item.id
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name || item.id), 1)
                                    ]),
                                _: 2
                            }, 1032, [
                                "to"
                            ])
                        ]);
                    }), 128))
                ])) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.createElementVNode)("div", $d413623b069010c1$var$_hoisted_18, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/parameter/" + this.$route.params.parameterId + "/evaluationcreate"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createElementVNode)("button", $d413623b069010c1$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("addEvaluation")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $d413623b069010c1$var$_hoisted_20, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showParameterDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ParameterDeleteModal, {
            key: 0,
            onReload: _cache[1] || (_cache[1] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                })),
            onCloseDeleteDialog: _cache[2] || (_cache[2] = ($event)=>$data.showParameterDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("eik26", function(module, exports) {

$parcel$export(module.exports, "default", () => $a682493fbbabb2d8$export$2e2bcd8739ae039);
let $a682493fbbabb2d8$var$NOOP = ()=>{};
var $a682493fbbabb2d8$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("9B0W0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6fc84b53343ab3cf$export$2e2bcd8739ae039);

var $gM1Yh = parcelRequire("gM1Yh");

var $fUmC0 = parcelRequire("fUmC0");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $ftVMi = parcelRequire("ftVMi");

var $l6otV = parcelRequire("l6otV");

var $gOjKo = parcelRequire("gOjKo");
var $6fc84b53343ab3cf$export$2e2bcd8739ae039 = {
    name: "parameterdetail",
    watch: {
        $route: "requestData"
    },
    components: {
        ParameterDeleteModal: $ftVMi.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            this.data = await (0, $gM1Yh.default).parameterDetail(this.$route.params.id, this.$route.params.parameterId);
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var evaluationList = await (0, $gM1Yh.default).evaluationList(this.$route.params.id, this.$route.params.parameterId);
            var curveList = await (0, $fUmC0.default).curveList(this.$route.params.id);
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            if (evaluationList.length > 0) this.parameterContainsEvaluation = true;
            if (curveList.length > 0 && curveList.findIndex((c)=>c.parameterId == this.$route.params.parameterId) >= 0) this.parameterContainsCurves = true;
            for(var i in this.costFactors){
                var attr = this.costFactors[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr) < 0 && this.missingDatasetHeaders.findIndex((d)=>d.name == attr) < 0) this.missingDatasetHeaders.push({
                    name: attr,
                    alias: attr
                });
            }
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                if (this.costFactors.length > 1) this.data.costFactor = this.costFactors.join(";");
                else this.data.costFactor = this.costFactors.join("");
                await (0, $gM1Yh.default).parameterUpdate(this.$route.params.id, this.data);
                if (!this.isFormValid()) this.showWarning();
                else this.showSuccess();
            } else this.showEmptyNameError();
        },
        isFormValid () {
            for(var i in this.costFactors){
                var attr = this.costFactors[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr) < 0 && attr != "") return false;
            }
            return true;
        },
        removeParameterClass (rowIndex) {
            this.data.parameterClasses.splice(rowIndex, 1);
        },
        addParameterClass () {
            this.data.parameterClasses.push({
                color: "#000000",
                name: "",
                startClassification: this.getMinStartParameterClass(),
                endClassification: 0.0
            });
        },
        updateParameterClassStart (value, i) {
            var range = this.data.parameterClasses[i + 1];
            if (range) range.startClassification = value;
        },
        getMinStartParameterClass () {
            var minStartParameterClass = 0;
            if (this.data.parameterClasses.length > 0) minStartParameterClass = this.data.parameterClasses[this.data.parameterClasses.length - 1].endClassification;
            return minStartParameterClass;
        },
        showDeleteParameter () {
            this.parameterToDeleteId = this.data.id;
            this.showParameterDeleteModal = true;
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "parameterUpdated",
            type: "success"
        },
        showWarning: {
            title: "warning",
            message: "warningAttributeRemoved",
            type: "warn"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            costFactors: [],
            missingDatasetHeaders: [],
            datasetHeaders: [],
            data: {
                name: "",
                id: ""
            },
            showParameterDeleteModal: false,
            parameterToDeleteId: 0,
            modelingName: null,
            assetTypeName: null,
            pending: true,
            isUserAdmin: false,
            parameterContainsEvaluation: false,
            parameterContainsCurves: false
        };
    }
};

});

parcelRegister("58dds", function(module, exports) {

$parcel$export(module.exports, "render", () => $3bc7f385e9353d7c$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $3bc7f385e9353d7c$var$_hoisted_1 = {
    key: 0
};
const $3bc7f385e9353d7c$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $3bc7f385e9353d7c$var$_hoisted_3 = [
    $3bc7f385e9353d7c$var$_hoisted_2
];
const $3bc7f385e9353d7c$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $3bc7f385e9353d7c$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $3bc7f385e9353d7c$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $3bc7f385e9353d7c$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $3bc7f385e9353d7c$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $3bc7f385e9353d7c$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $3bc7f385e9353d7c$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $3bc7f385e9353d7c$var$_hoisted_11 = {
    class: "breadcrumb-item"
};
const $3bc7f385e9353d7c$var$_hoisted_12 = {
    class: "row mb-3"
};
const $3bc7f385e9353d7c$var$_hoisted_13 = {
    class: "col-md-3"
};
const $3bc7f385e9353d7c$var$_hoisted_14 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $3bc7f385e9353d7c$var$_hoisted_15 = {
    class: "col-md-3"
};
const $3bc7f385e9353d7c$var$_hoisted_16 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $3bc7f385e9353d7c$var$_hoisted_17 = {
    class: "col-md-3"
};
const $3bc7f385e9353d7c$var$_hoisted_18 = {
    class: "form-label",
    for: "parameterAttribute",
    required: ""
};
const $3bc7f385e9353d7c$var$_hoisted_19 = {
    disabled: ""
};
const $3bc7f385e9353d7c$var$_hoisted_20 = [
    "value"
];
const $3bc7f385e9353d7c$var$_hoisted_21 = {
    class: "col-md-3"
};
const $3bc7f385e9353d7c$var$_hoisted_22 = {
    class: "form-label",
    for: "parameterAttributeYear",
    required: ""
};
const $3bc7f385e9353d7c$var$_hoisted_23 = {
    disabled: ""
};
const $3bc7f385e9353d7c$var$_hoisted_24 = [
    "value"
];
const $3bc7f385e9353d7c$var$_hoisted_25 = {
    class: "row mb-3"
};
const $3bc7f385e9353d7c$var$_hoisted_26 = {
    class: "col-2"
};
const $3bc7f385e9353d7c$var$_hoisted_27 = {
    class: "form-check-label ps-2",
    for: "toTheResults"
};
const $3bc7f385e9353d7c$var$_hoisted_28 = {
    class: "mb-3"
};
const $3bc7f385e9353d7c$var$_hoisted_29 = {
    class: "table"
};
const $3bc7f385e9353d7c$var$_hoisted_30 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $3bc7f385e9353d7c$var$_hoisted_31 = {
    scope: "col"
};
const $3bc7f385e9353d7c$var$_hoisted_32 = {
    scope: "col"
};
const $3bc7f385e9353d7c$var$_hoisted_33 = {
    scope: "col"
};
const $3bc7f385e9353d7c$var$_hoisted_34 = {
    scope: "col"
};
const $3bc7f385e9353d7c$var$_hoisted_35 = {
    scope: "row"
};
const $3bc7f385e9353d7c$var$_hoisted_36 = [
    "onClick"
];
const $3bc7f385e9353d7c$var$_hoisted_37 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $3bc7f385e9353d7c$var$_hoisted_38 = [
    "onUpdate:modelValue",
    "onInput",
    "id"
];
const $3bc7f385e9353d7c$var$_hoisted_39 = [
    "onUpdate:modelValue",
    "id"
];
const $3bc7f385e9353d7c$var$_hoisted_40 = [
    "onUpdate:modelValue",
    "id"
];
const $3bc7f385e9353d7c$var$_hoisted_41 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $3bc7f385e9353d7c$var$_hoisted_42 = [
    $3bc7f385e9353d7c$var$_hoisted_41
];
const $3bc7f385e9353d7c$var$_hoisted_43 = {
    class: "d-grid gap-2 d-md-flex"
};
function $3bc7f385e9353d7c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_ParameterDeleteModal = (0, $TusQn.resolveComponent)("ParameterDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $3bc7f385e9353d7c$var$_hoisted_1, $3bc7f385e9353d7c$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $3bc7f385e9353d7c$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("parameterDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $3bc7f385e9353d7c$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $3bc7f385e9353d7c$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $3bc7f385e9353d7c$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $3bc7f385e9353d7c$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $3bc7f385e9353d7c$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $3bc7f385e9353d7c$var$_hoisted_10, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/parameter/" + this.$route.params.parameterId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name || _ctx.$t("parameter")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $3bc7f385e9353d7c$var$_hoisted_11, (0, $8POXm.toDisplayString)(_ctx.$t("parameterDetail")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $3bc7f385e9353d7c$var$_hoisted_12, [
            (0, $TusQn.createElementVNode)("div", $3bc7f385e9353d7c$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("label", $3bc7f385e9353d7c$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $3bc7f385e9353d7c$var$_hoisted_15, [
                (0, $TusQn.createElementVNode)("label", $3bc7f385e9353d7c$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $3bc7f385e9353d7c$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("label", $3bc7f385e9353d7c$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("parameterAttribute")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "parameterAttribute",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.parameterAttribute = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $3bc7f385e9353d7c$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $3bc7f385e9353d7c$var$_hoisted_20);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.parameterAttribute
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $3bc7f385e9353d7c$var$_hoisted_21, [
                (0, $TusQn.createElementVNode)("label", $3bc7f385e9353d7c$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("parameterAttributeYear")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "parameterAttributeYear",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.parameterAttributeYear = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $3bc7f385e9353d7c$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $3bc7f385e9353d7c$var$_hoisted_24);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.parameterAttributeYear
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $3bc7f385e9353d7c$var$_hoisted_25, [
            (0, $TusQn.createElementVNode)("div", $3bc7f385e9353d7c$var$_hoisted_26, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.toTheResults = $event),
                    type: "checkbox",
                    id: "toTheResults"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.toTheResults
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $3bc7f385e9353d7c$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("toTheResults")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $3bc7f385e9353d7c$var$_hoisted_28, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("parameterClasses")), 1),
            (0, $TusQn.createElementVNode)("table", $3bc7f385e9353d7c$var$_hoisted_29, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $3bc7f385e9353d7c$var$_hoisted_30,
                        (0, $TusQn.createElementVNode)("th", $3bc7f385e9353d7c$var$_hoisted_31, (0, $8POXm.toDisplayString)(_ctx.$t("startClassification")), 1),
                        (0, $TusQn.createElementVNode)("th", $3bc7f385e9353d7c$var$_hoisted_32, (0, $8POXm.toDisplayString)(_ctx.$t("endClassification")), 1),
                        (0, $TusQn.createElementVNode)("th", $3bc7f385e9353d7c$var$_hoisted_33, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $3bc7f385e9353d7c$var$_hoisted_34, (0, $8POXm.toDisplayString)(_ctx.$t("color")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.parameterClasses, (parameterClass, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $3bc7f385e9353d7c$var$_hoisted_35, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeParameterClass(i)
                                }, null, 8, $3bc7f385e9353d7c$var$_hoisted_36)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.startClassification = $event,
                                    disabled: i > 0,
                                    type: "number",
                                    class: "form-control",
                                    id: "startClassification_" + i
                                }, null, 8, $3bc7f385e9353d7c$var$_hoisted_37), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.startClassification
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.endClassification = $event,
                                    onInput: ($event)=>$options.updateParameterClassStart(parameterClass.endClassification, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endClassification_" + i
                                }, null, 40, $3bc7f385e9353d7c$var$_hoisted_38), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.endClassification
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.name = $event,
                                    type: "string",
                                    class: "form-control",
                                    id: "name_" + i
                                }, null, 8, $3bc7f385e9353d7c$var$_hoisted_39), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.color = $event,
                                    type: "color",
                                    class: "form-control",
                                    id: "color_" + i
                                }, null, 8, $3bc7f385e9353d7c$var$_hoisted_40), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.color
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[5] || (_cache[5] = (...args)=>$options.addParameterClass && $options.addParameterClass(...args))
            }, $3bc7f385e9353d7c$var$_hoisted_42)
        ]),
        (0, $TusQn.createElementVNode)("div", $3bc7f385e9353d7c$var$_hoisted_43, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[6] || (_cache[6] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[7] || (_cache[7] = (...args)=>$options.showDeleteParameter && $options.showDeleteParameter(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[8] || (_cache[8] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}/parameter/${this.$route.params.parameterId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showParameterDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ParameterDeleteModal, {
            key: 0,
            onReload: _cache[9] || (_cache[9] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                })),
            onCloseDeleteDialog: _cache[10] || (_cache[10] = ($event)=>$data.showParameterDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("Gxvey", function(module, exports) {

$parcel$export(module.exports, "default", () => $07fde94fa84836c2$export$2e2bcd8739ae039);
let $07fde94fa84836c2$var$NOOP = ()=>{};
var $07fde94fa84836c2$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("lke6x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f866681987d13cde$export$2e2bcd8739ae039);

var $gM1Yh = parcelRequire("gM1Yh");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $l6otV = parcelRequire("l6otV");
var $f866681987d13cde$export$2e2bcd8739ae039 = {
    name: "parameterCreate",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                this.data.assetTypeId = this.$route.params.assetTypeId;
                await (0, $gM1Yh.default).parameterCreate(this.$route.params.id, this.data);
                this.$router.go(-1);
            } else this.showEmptyNameError();
        },
        removeParameterClass (rowIndex) {
            this.data.parameterClasses.splice(rowIndex, 1);
        },
        addParameterClass () {
            this.data.parameterClasses.push({
                color: "#000000",
                name: "",
                startClassification: this.getMinStartParameterClass(),
                endClassification: 0.0
            });
        },
        updateParameterClassStart (value, i) {
            var range = this.data.parameterClasses[i + 1];
            if (range) range.startClassification = value;
        },
        getMinStartParameterClass () {
            var minStartParameterClass = 0;
            if (this.data.parameterClasses.length > 0) minStartParameterClass = this.data.parameterClasses[this.data.parameterClasses.length - 1].endClassification;
            return minStartParameterClass;
        }
    },
    notifications: {
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            datasetHeaders: [],
            data: {
                name: "",
                description: "",
                parameterClasses: [],
                id: 0
            },
            modelingName: null,
            assetTypeName: null,
            pending: true
        };
    }
};

});

parcelRegister("7Othq", function(module, exports) {

$parcel$export(module.exports, "render", () => $5b03ea4d6ee485f5$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $5b03ea4d6ee485f5$var$_hoisted_1 = {
    key: 0
};
const $5b03ea4d6ee485f5$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $5b03ea4d6ee485f5$var$_hoisted_3 = [
    $5b03ea4d6ee485f5$var$_hoisted_2
];
const $5b03ea4d6ee485f5$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $5b03ea4d6ee485f5$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $5b03ea4d6ee485f5$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $5b03ea4d6ee485f5$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $5b03ea4d6ee485f5$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $5b03ea4d6ee485f5$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $5b03ea4d6ee485f5$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $5b03ea4d6ee485f5$var$_hoisted_11 = {
    class: "row mb-3"
};
const $5b03ea4d6ee485f5$var$_hoisted_12 = {
    class: "col-md-3"
};
const $5b03ea4d6ee485f5$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $5b03ea4d6ee485f5$var$_hoisted_14 = {
    class: "col-md-3"
};
const $5b03ea4d6ee485f5$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $5b03ea4d6ee485f5$var$_hoisted_16 = {
    class: "col-md-3"
};
const $5b03ea4d6ee485f5$var$_hoisted_17 = {
    class: "form-label",
    for: "parameterAttribute",
    required: ""
};
const $5b03ea4d6ee485f5$var$_hoisted_18 = {
    disabled: ""
};
const $5b03ea4d6ee485f5$var$_hoisted_19 = [
    "value"
];
const $5b03ea4d6ee485f5$var$_hoisted_20 = {
    class: "col-md-3"
};
const $5b03ea4d6ee485f5$var$_hoisted_21 = {
    class: "form-label",
    for: "parameterAttributeYear",
    required: ""
};
const $5b03ea4d6ee485f5$var$_hoisted_22 = {
    disabled: ""
};
const $5b03ea4d6ee485f5$var$_hoisted_23 = [
    "value"
];
const $5b03ea4d6ee485f5$var$_hoisted_24 = {
    class: "row mb-3"
};
const $5b03ea4d6ee485f5$var$_hoisted_25 = {
    class: "col-2"
};
const $5b03ea4d6ee485f5$var$_hoisted_26 = {
    class: "form-check-label ps-2",
    for: "toTheResults"
};
const $5b03ea4d6ee485f5$var$_hoisted_27 = {
    class: "mb-3"
};
const $5b03ea4d6ee485f5$var$_hoisted_28 = {
    class: "table"
};
const $5b03ea4d6ee485f5$var$_hoisted_29 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $5b03ea4d6ee485f5$var$_hoisted_30 = {
    scope: "col"
};
const $5b03ea4d6ee485f5$var$_hoisted_31 = {
    scope: "col"
};
const $5b03ea4d6ee485f5$var$_hoisted_32 = {
    scope: "col"
};
const $5b03ea4d6ee485f5$var$_hoisted_33 = {
    scope: "col"
};
const $5b03ea4d6ee485f5$var$_hoisted_34 = {
    scope: "row"
};
const $5b03ea4d6ee485f5$var$_hoisted_35 = [
    "onClick"
];
const $5b03ea4d6ee485f5$var$_hoisted_36 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $5b03ea4d6ee485f5$var$_hoisted_37 = [
    "onUpdate:modelValue",
    "onInput",
    "id"
];
const $5b03ea4d6ee485f5$var$_hoisted_38 = [
    "onUpdate:modelValue",
    "id"
];
const $5b03ea4d6ee485f5$var$_hoisted_39 = [
    "onUpdate:modelValue",
    "id"
];
const $5b03ea4d6ee485f5$var$_hoisted_40 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $5b03ea4d6ee485f5$var$_hoisted_41 = [
    $5b03ea4d6ee485f5$var$_hoisted_40
];
const $5b03ea4d6ee485f5$var$_hoisted_42 = {
    class: "d-grid gap-2 d-md-flex"
};
function $5b03ea4d6ee485f5$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5b03ea4d6ee485f5$var$_hoisted_1, $5b03ea4d6ee485f5$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5b03ea4d6ee485f5$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("parameterCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $5b03ea4d6ee485f5$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $5b03ea4d6ee485f5$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $5b03ea4d6ee485f5$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $5b03ea4d6ee485f5$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $5b03ea4d6ee485f5$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $5b03ea4d6ee485f5$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("parameterCreate")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $5b03ea4d6ee485f5$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $5b03ea4d6ee485f5$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $5b03ea4d6ee485f5$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $5b03ea4d6ee485f5$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $5b03ea4d6ee485f5$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $5b03ea4d6ee485f5$var$_hoisted_16, [
                (0, $TusQn.createElementVNode)("label", $5b03ea4d6ee485f5$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("parameterAttribute")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "parameterAttribute",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.parameterAttribute = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $5b03ea4d6ee485f5$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $5b03ea4d6ee485f5$var$_hoisted_19);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.parameterAttribute
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $5b03ea4d6ee485f5$var$_hoisted_20, [
                (0, $TusQn.createElementVNode)("label", $5b03ea4d6ee485f5$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("parameterAttributeYear")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "parameterAttributeYear",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.parameterAttributeYear = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $5b03ea4d6ee485f5$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $5b03ea4d6ee485f5$var$_hoisted_23);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.parameterAttributeYear
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $5b03ea4d6ee485f5$var$_hoisted_24, [
            (0, $TusQn.createElementVNode)("div", $5b03ea4d6ee485f5$var$_hoisted_25, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.toTheResults = $event),
                    type: "checkbox",
                    id: "toTheResults"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.toTheResults
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $5b03ea4d6ee485f5$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("toTheResults")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $5b03ea4d6ee485f5$var$_hoisted_27, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("parameterClasses")), 1),
            (0, $TusQn.createElementVNode)("table", $5b03ea4d6ee485f5$var$_hoisted_28, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $5b03ea4d6ee485f5$var$_hoisted_29,
                        (0, $TusQn.createElementVNode)("th", $5b03ea4d6ee485f5$var$_hoisted_30, (0, $8POXm.toDisplayString)(_ctx.$t("startClassification")), 1),
                        (0, $TusQn.createElementVNode)("th", $5b03ea4d6ee485f5$var$_hoisted_31, (0, $8POXm.toDisplayString)(_ctx.$t("endClassification")), 1),
                        (0, $TusQn.createElementVNode)("th", $5b03ea4d6ee485f5$var$_hoisted_32, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $5b03ea4d6ee485f5$var$_hoisted_33, (0, $8POXm.toDisplayString)(_ctx.$t("color")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.parameterClasses, (parameterClass, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $5b03ea4d6ee485f5$var$_hoisted_34, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeParameterClass(i)
                                }, null, 8, $5b03ea4d6ee485f5$var$_hoisted_35)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.startClassification = $event,
                                    disabled: i > 0,
                                    type: "number",
                                    class: "form-control",
                                    id: "startClassification_" + i
                                }, null, 8, $5b03ea4d6ee485f5$var$_hoisted_36), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.startClassification
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.endClassification = $event,
                                    onInput: ($event)=>$options.updateParameterClassStart(parameterClass.endClassification, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endClassification_" + i
                                }, null, 40, $5b03ea4d6ee485f5$var$_hoisted_37), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.endClassification
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.name = $event,
                                    type: "string",
                                    class: "form-control",
                                    id: "name_" + i
                                }, null, 8, $5b03ea4d6ee485f5$var$_hoisted_38), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.color = $event,
                                    type: "color",
                                    class: "form-control",
                                    id: "color_" + i
                                }, null, 8, $5b03ea4d6ee485f5$var$_hoisted_39), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.color
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[5] || (_cache[5] = (...args)=>$options.addParameterClass && $options.addParameterClass(...args))
            }, $5b03ea4d6ee485f5$var$_hoisted_41)
        ]),
        (0, $TusQn.createElementVNode)("div", $5b03ea4d6ee485f5$var$_hoisted_42, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[6] || (_cache[6] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[7] || (_cache[7] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("3kKte", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d749672f1402a4$export$2e2bcd8739ae039);
let $26d749672f1402a4$var$NOOP = ()=>{};
var $26d749672f1402a4$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("fChua", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b5e7f7eb0dde0f8c$export$2e2bcd8739ae039);

var $aYIG6 = parcelRequire("aYIG6");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $f3GZf = parcelRequire("f3GZf");

var $l6otV = parcelRequire("l6otV");

var $gOjKo = parcelRequire("gOjKo");
var $b5e7f7eb0dde0f8c$export$2e2bcd8739ae039 = {
    name: "KeyPerformanceIndicatorDetail",
    watch: {
        $route: "requestData"
    },
    components: {
        KPIDeleteModal: $f3GZf.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            this.data = await (0, $aYIG6.default).kpiDetail(this.$route.params.id, this.$route.params.keyPerformanceIndicatorId);
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                await (0, $aYIG6.default).kpiUpdate(this.$route.params.id, this.data);
                this.showSuccess();
            } else this.showEmptyNameError();
        },
        showDeleteKpi () {
            this.keyPerformanceIndicatorToDeleteId = this.data.id;
            this.showKeyPerformanceIndicatorDeleteModal = true;
        },
        removeKpiClassification (rowIndex) {
            this.data.kpiClassifications.splice(rowIndex, 1);
        },
        addKpiClassification () {
            this.data.kpiClassifications.push({
                color: "#000000",
                name: "",
                startClassification: this.getMinStartKpiClassification(),
                endClassification: 0.0
            });
        },
        updateKpiClassificationStart (value, i) {
            var range = this.data.kpiClassifications[i + 1];
            if (range) range.startClassification = value;
        },
        getMinStartKpiClassification () {
            var minStartKpiClassification = 0;
            if (this.data.kpiClassifications.length > 0) minStartKpiClassification = this.data.kpiClassifications[this.data.kpiClassifications.length - 1].endClassification;
            return minStartKpiClassification;
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "kpiUpdated",
            type: "success"
        },
        showWarning: {
            title: "warning",
            message: "warningAttributeRemoved",
            type: "warn"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            costFactors: [],
            missingDatasetHeaders: [],
            datasetHeaders: [],
            evaluationList: [],
            data: {
                name: "",
                id: "",
                kpiClassifications: []
            },
            showKeyPerformanceIndicatorDeleteModal: false,
            keyPerformanceIndicatorToDeleteId: 0,
            modelingName: null,
            assetTypeName: null,
            pending: true,
            isUserAdmin: false
        };
    }
};

});
parcelRegister("f3GZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $af687b1e6d283888$export$2e2bcd8739ae039);
let $af687b1e6d283888$var$script;



let $af687b1e6d283888$var$initialize = ()=>{
    $af687b1e6d283888$var$script = (parcelRequire("iXAT2"));
    if ($af687b1e6d283888$var$script.__esModule) $af687b1e6d283888$var$script = $af687b1e6d283888$var$script.default;
    $af687b1e6d283888$var$script.render = (parcelRequire("8TorK")).render;
    (parcelRequire("8aXHB")).default($af687b1e6d283888$var$script);
    $af687b1e6d283888$var$script.__scopeId = "data-v-83a2a1";
    $af687b1e6d283888$var$script.__file = "KPIDeleteModal.vue";
};
$af687b1e6d283888$var$initialize();
var $af687b1e6d283888$export$2e2bcd8739ae039 = $af687b1e6d283888$var$script;

});
parcelRegister("iXAT2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $dcda599827d99762$export$2e2bcd8739ae039);

var $ljJJR = parcelRequire("ljJJR");

var $aYIG6 = parcelRequire("aYIG6");
var $dcda599827d99762$export$2e2bcd8739ae039 = {
    name: "kpiDeleteModal",
    mounted () {
        this.requestDependencies();
    },
    methods: {
        async requestDependencies () {
            this.dependentEvaluations = await (0, $ljJJR.default).evaluationListByKpi(this.$parent.$route.params.id, this.$parent.keyPerformanceIndicatorToDeleteId);
        },
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteKeyPerformanceIndicator () {
            await (0, $aYIG6.default).kpiDelete(this.$parent.$route.params.id, this.$parent.keyPerformanceIndicatorToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    },
    data () {
        return {
            dependentEvaluations: []
        };
    }
};

});

parcelRegister("8TorK", function(module, exports) {

$parcel$export(module.exports, "render", () => $67966c5b07473c09$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $67966c5b07473c09$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $67966c5b07473c09$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $67966c5b07473c09$var$_hoisted_3 = {
    class: "modal-content"
};
const $67966c5b07473c09$var$_hoisted_4 = {
    class: "modal-header"
};
const $67966c5b07473c09$var$_hoisted_5 = {
    class: "modal-title"
};
const $67966c5b07473c09$var$_hoisted_6 = {
    class: "modal-body"
};
const $67966c5b07473c09$var$_hoisted_7 = {
    class: "form-label"
};
const $67966c5b07473c09$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("br", null, null, -1);
const $67966c5b07473c09$var$_hoisted_9 = {
    key: 1
};
const $67966c5b07473c09$var$_hoisted_10 = {
    class: "modal-footer"
};
const $67966c5b07473c09$var$_hoisted_11 = [
    "disabled"
];
function $67966c5b07473c09$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $67966c5b07473c09$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $67966c5b07473c09$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $67966c5b07473c09$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $67966c5b07473c09$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $67966c5b07473c09$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("kpiDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $67966c5b07473c09$var$_hoisted_6, [
                                this.dependentEvaluations.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 0
                                }, [
                                    (0, $TusQn.createElementVNode)("label", $67966c5b07473c09$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("cannotDeleteKeyPerformanceIndicator")), 1),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(this.dependentEvaluations, (evaluation, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                            key: i
                                        }, [
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(evaluation.name), 1),
                                            $67966c5b07473c09$var$_hoisted_8
                                        ]);
                                    }), 128))
                                ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $67966c5b07473c09$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisKeyPerformanceIndicator")), 1))
                            ]),
                            (0, $TusQn.createElementVNode)("div", $67966c5b07473c09$var$_hoisted_10, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteKeyPerformanceIndicator && $options.deleteKeyPerformanceIndicator(...args)),
                                    disabled: this.dependentEvaluations.length > 0
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 9, $67966c5b07473c09$var$_hoisted_11)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("8aXHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f3d9186fb723f8c$export$2e2bcd8739ae039);
let $5f3d9186fb723f8c$var$NOOP = ()=>{};
var $5f3d9186fb723f8c$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("UeFvr", function(module, exports) {

$parcel$export(module.exports, "render", () => $0a909bed278bbe66$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $0a909bed278bbe66$var$_hoisted_1 = {
    key: 0
};
const $0a909bed278bbe66$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $0a909bed278bbe66$var$_hoisted_3 = [
    $0a909bed278bbe66$var$_hoisted_2
];
const $0a909bed278bbe66$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $0a909bed278bbe66$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $0a909bed278bbe66$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $0a909bed278bbe66$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $0a909bed278bbe66$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $0a909bed278bbe66$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $0a909bed278bbe66$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $0a909bed278bbe66$var$_hoisted_11 = {
    class: "row mb-3"
};
const $0a909bed278bbe66$var$_hoisted_12 = {
    class: "col-md-4"
};
const $0a909bed278bbe66$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $0a909bed278bbe66$var$_hoisted_14 = {
    class: "col-md-4"
};
const $0a909bed278bbe66$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $0a909bed278bbe66$var$_hoisted_16 = {
    class: "col-md-4"
};
const $0a909bed278bbe66$var$_hoisted_17 = {
    class: "form-label",
    for: "evaluationMethod",
    required: ""
};
const $0a909bed278bbe66$var$_hoisted_18 = {
    disabled: ""
};
const $0a909bed278bbe66$var$_hoisted_19 = {
    value: "cwpc"
};
const $0a909bed278bbe66$var$_hoisted_20 = {
    class: "row mb-3"
};
const $0a909bed278bbe66$var$_hoisted_21 = {
    class: "col-2"
};
const $0a909bed278bbe66$var$_hoisted_22 = {
    class: "form-check-label ps-2",
    for: "toTheResults"
};
const $0a909bed278bbe66$var$_hoisted_23 = {
    class: "mb-3"
};
const $0a909bed278bbe66$var$_hoisted_24 = {
    class: "table"
};
const $0a909bed278bbe66$var$_hoisted_25 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $0a909bed278bbe66$var$_hoisted_26 = {
    scope: "col"
};
const $0a909bed278bbe66$var$_hoisted_27 = {
    scope: "col"
};
const $0a909bed278bbe66$var$_hoisted_28 = {
    scope: "col"
};
const $0a909bed278bbe66$var$_hoisted_29 = {
    scope: "col"
};
const $0a909bed278bbe66$var$_hoisted_30 = {
    scope: "row"
};
const $0a909bed278bbe66$var$_hoisted_31 = [
    "onClick"
];
const $0a909bed278bbe66$var$_hoisted_32 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $0a909bed278bbe66$var$_hoisted_33 = [
    "onUpdate:modelValue",
    "onInput",
    "id"
];
const $0a909bed278bbe66$var$_hoisted_34 = [
    "onUpdate:modelValue",
    "id"
];
const $0a909bed278bbe66$var$_hoisted_35 = [
    "onUpdate:modelValue",
    "id"
];
const $0a909bed278bbe66$var$_hoisted_36 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $0a909bed278bbe66$var$_hoisted_37 = [
    $0a909bed278bbe66$var$_hoisted_36
];
const $0a909bed278bbe66$var$_hoisted_38 = {
    class: "d-grid gap-2 d-md-flex"
};
function $0a909bed278bbe66$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_KPIDeleteModal = (0, $TusQn.resolveComponent)("KPIDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0a909bed278bbe66$var$_hoisted_1, $0a909bed278bbe66$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0a909bed278bbe66$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("kpiDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $0a909bed278bbe66$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $0a909bed278bbe66$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $0a909bed278bbe66$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $0a909bed278bbe66$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $0a909bed278bbe66$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $0a909bed278bbe66$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $0a909bed278bbe66$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $0a909bed278bbe66$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $0a909bed278bbe66$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $0a909bed278bbe66$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $0a909bed278bbe66$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $0a909bed278bbe66$var$_hoisted_16, [
                (0, $TusQn.createElementVNode)("label", $0a909bed278bbe66$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationMethod")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "evaluationMethod",
                    class: "form-select",
                    disabled: "",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.evaluationMethod = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $0a909bed278bbe66$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    (0, $TusQn.createElementVNode)("option", $0a909bed278bbe66$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("cwpc")), 1)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.evaluationMethod
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $0a909bed278bbe66$var$_hoisted_20, [
            (0, $TusQn.createElementVNode)("div", $0a909bed278bbe66$var$_hoisted_21, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.toTheResults = $event),
                    type: "checkbox",
                    id: "toTheResults"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.toTheResults
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $0a909bed278bbe66$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("toTheResults")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $0a909bed278bbe66$var$_hoisted_23, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("kpiClassification")), 1),
            (0, $TusQn.createElementVNode)("table", $0a909bed278bbe66$var$_hoisted_24, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $0a909bed278bbe66$var$_hoisted_25,
                        (0, $TusQn.createElementVNode)("th", $0a909bed278bbe66$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("startClassification")), 1),
                        (0, $TusQn.createElementVNode)("th", $0a909bed278bbe66$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("endClassification")), 1),
                        (0, $TusQn.createElementVNode)("th", $0a909bed278bbe66$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $0a909bed278bbe66$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("color")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.kpiClassifications, (kpiClassification, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $0a909bed278bbe66$var$_hoisted_30, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeKpiClassification(i)
                                }, null, 8, $0a909bed278bbe66$var$_hoisted_31)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>kpiClassification.startClassification = $event,
                                    disabled: i > 0,
                                    type: "number",
                                    class: "form-control",
                                    id: "startClassification_" + i
                                }, null, 8, $0a909bed278bbe66$var$_hoisted_32), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        kpiClassification.startClassification
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>kpiClassification.endClassification = $event,
                                    onInput: ($event)=>$options.updateKpiClassificationStart(kpiClassification.endClassification, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endClassification_" + i
                                }, null, 40, $0a909bed278bbe66$var$_hoisted_33), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        kpiClassification.endClassification
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>kpiClassification.name = $event,
                                    type: "string",
                                    class: "form-control",
                                    id: "name_" + i
                                }, null, 8, $0a909bed278bbe66$var$_hoisted_34), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        kpiClassification.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>kpiClassification.color = $event,
                                    type: "color",
                                    class: "form-control",
                                    id: "color_" + i
                                }, null, 8, $0a909bed278bbe66$var$_hoisted_35), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        kpiClassification.color
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[4] || (_cache[4] = (...args)=>$options.addKpiClassification && $options.addKpiClassification(...args))
            }, $0a909bed278bbe66$var$_hoisted_37)
        ]),
        (0, $TusQn.createElementVNode)("div", $0a909bed278bbe66$var$_hoisted_38, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[5] || (_cache[5] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[6] || (_cache[6] = (...args)=>$options.showDeleteKpi && $options.showDeleteKpi(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[7] || (_cache[7] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showKeyPerformanceIndicatorDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_KPIDeleteModal, {
            key: 0,
            onReload: _cache[8] || (_cache[8] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                })),
            onCloseDeleteDialog: _cache[9] || (_cache[9] = ($event)=>$data.showKeyPerformanceIndicatorDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("9h9a4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c0ccedc6a47e8f8$export$2e2bcd8739ae039);
let $6c0ccedc6a47e8f8$var$NOOP = ()=>{};
var $6c0ccedc6a47e8f8$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("96cjs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $69fe39ae1b11d92a$export$2e2bcd8739ae039);

var $aYIG6 = parcelRequire("aYIG6");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $l6otV = parcelRequire("l6otV");
var $69fe39ae1b11d92a$export$2e2bcd8739ae039 = {
    name: "parameterCreate",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                var kpiList = await (0, $aYIG6.default).kpiList(this.$route.params.id);
                this.kpiList = kpiList.filter((a)=>a.assetTypeId == this.$route.params.assetTypeId).sort((x, y)=>x.order - y.order);
                this.data.order = this.kpiList[this.kpiList.length - 1] ? this.kpiList[this.kpiList.length - 1].order + 1 : 1;
                this.data.assetTypeId = this.$route.params.assetTypeId;
                await (0, $aYIG6.default).kpiCreate(this.$route.params.id, this.data);
                this.$router.go(-1);
            } else this.showEmptyNameError();
        },
        removeKpiClassification (rowIndex) {
            this.data.kpiClassifications.splice(rowIndex, 1);
        },
        addKpiClassification () {
            this.data.kpiClassifications.push({
                color: "#000000",
                name: "",
                startClassification: this.getMinStartKpiClassification(),
                endClassification: 0.0
            });
        },
        updateKpiClassificationStart (value, i) {
            var range = this.data.kpiClassifications[i + 1];
            if (range) range.startClassification = value;
        },
        getMinStartKpiClassification () {
            var minStartKpiClassification = 0;
            if (this.data.kpiClassifications.length > 0) minStartKpiClassification = this.data.kpiClassifications[this.data.kpiClassifications.length - 1].endClassification;
            return minStartKpiClassification;
        }
    },
    notifications: {
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            datasetHeaders: [],
            data: {
                name: "",
                description: "",
                kpiClassifications: [],
                id: 0
            },
            modelingName: null,
            assetTypeName: null,
            pending: true
        };
    }
};

});

parcelRegister("aCV4w", function(module, exports) {

$parcel$export(module.exports, "render", () => $7bc9b9459cfb4fcb$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $7bc9b9459cfb4fcb$var$_hoisted_1 = {
    key: 0
};
const $7bc9b9459cfb4fcb$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $7bc9b9459cfb4fcb$var$_hoisted_3 = [
    $7bc9b9459cfb4fcb$var$_hoisted_2
];
const $7bc9b9459cfb4fcb$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $7bc9b9459cfb4fcb$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $7bc9b9459cfb4fcb$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $7bc9b9459cfb4fcb$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $7bc9b9459cfb4fcb$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $7bc9b9459cfb4fcb$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $7bc9b9459cfb4fcb$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $7bc9b9459cfb4fcb$var$_hoisted_11 = {
    class: "row mb-3"
};
const $7bc9b9459cfb4fcb$var$_hoisted_12 = {
    class: "col-md-4"
};
const $7bc9b9459cfb4fcb$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $7bc9b9459cfb4fcb$var$_hoisted_14 = {
    class: "col-md-4"
};
const $7bc9b9459cfb4fcb$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $7bc9b9459cfb4fcb$var$_hoisted_16 = {
    class: "col-md-4"
};
const $7bc9b9459cfb4fcb$var$_hoisted_17 = {
    class: "form-label",
    for: "evaluationMethod",
    required: ""
};
const $7bc9b9459cfb4fcb$var$_hoisted_18 = {
    disabled: ""
};
const $7bc9b9459cfb4fcb$var$_hoisted_19 = {
    value: "cwpc"
};
const $7bc9b9459cfb4fcb$var$_hoisted_20 = {
    class: "row mb-3"
};
const $7bc9b9459cfb4fcb$var$_hoisted_21 = {
    class: "col-2"
};
const $7bc9b9459cfb4fcb$var$_hoisted_22 = {
    class: "form-check-label ps-2",
    for: "toTheResults"
};
const $7bc9b9459cfb4fcb$var$_hoisted_23 = {
    class: "mb-3"
};
const $7bc9b9459cfb4fcb$var$_hoisted_24 = {
    class: "table"
};
const $7bc9b9459cfb4fcb$var$_hoisted_25 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $7bc9b9459cfb4fcb$var$_hoisted_26 = {
    scope: "col"
};
const $7bc9b9459cfb4fcb$var$_hoisted_27 = {
    scope: "col"
};
const $7bc9b9459cfb4fcb$var$_hoisted_28 = {
    scope: "col"
};
const $7bc9b9459cfb4fcb$var$_hoisted_29 = {
    scope: "col"
};
const $7bc9b9459cfb4fcb$var$_hoisted_30 = {
    scope: "row"
};
const $7bc9b9459cfb4fcb$var$_hoisted_31 = [
    "onClick"
];
const $7bc9b9459cfb4fcb$var$_hoisted_32 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $7bc9b9459cfb4fcb$var$_hoisted_33 = [
    "onUpdate:modelValue",
    "onInput",
    "id"
];
const $7bc9b9459cfb4fcb$var$_hoisted_34 = [
    "onUpdate:modelValue",
    "id"
];
const $7bc9b9459cfb4fcb$var$_hoisted_35 = [
    "onUpdate:modelValue",
    "id"
];
const $7bc9b9459cfb4fcb$var$_hoisted_36 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $7bc9b9459cfb4fcb$var$_hoisted_37 = [
    $7bc9b9459cfb4fcb$var$_hoisted_36
];
const $7bc9b9459cfb4fcb$var$_hoisted_38 = {
    class: "d-grid gap-2 d-md-flex"
};
function $7bc9b9459cfb4fcb$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7bc9b9459cfb4fcb$var$_hoisted_1, $7bc9b9459cfb4fcb$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7bc9b9459cfb4fcb$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("kpiCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $7bc9b9459cfb4fcb$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $7bc9b9459cfb4fcb$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $7bc9b9459cfb4fcb$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $7bc9b9459cfb4fcb$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $7bc9b9459cfb4fcb$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $7bc9b9459cfb4fcb$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("kpiCreate")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $7bc9b9459cfb4fcb$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $7bc9b9459cfb4fcb$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $7bc9b9459cfb4fcb$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7bc9b9459cfb4fcb$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $7bc9b9459cfb4fcb$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7bc9b9459cfb4fcb$var$_hoisted_16, [
                (0, $TusQn.createElementVNode)("label", $7bc9b9459cfb4fcb$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationMethod")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "evaluationMethod",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.evaluationMethod = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $7bc9b9459cfb4fcb$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    (0, $TusQn.createElementVNode)("option", $7bc9b9459cfb4fcb$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("cwpc")), 1)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.evaluationMethod
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $7bc9b9459cfb4fcb$var$_hoisted_20, [
            (0, $TusQn.createElementVNode)("div", $7bc9b9459cfb4fcb$var$_hoisted_21, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.toTheResults = $event),
                    type: "checkbox",
                    id: "toTheResults"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.toTheResults
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $7bc9b9459cfb4fcb$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("toTheResults")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $7bc9b9459cfb4fcb$var$_hoisted_23, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("kpiClassification")), 1),
            (0, $TusQn.createElementVNode)("table", $7bc9b9459cfb4fcb$var$_hoisted_24, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $7bc9b9459cfb4fcb$var$_hoisted_25,
                        (0, $TusQn.createElementVNode)("th", $7bc9b9459cfb4fcb$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("startClassification")), 1),
                        (0, $TusQn.createElementVNode)("th", $7bc9b9459cfb4fcb$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("endClassification")), 1),
                        (0, $TusQn.createElementVNode)("th", $7bc9b9459cfb4fcb$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $7bc9b9459cfb4fcb$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("color")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.kpiClassifications, (kpiClassification, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $7bc9b9459cfb4fcb$var$_hoisted_30, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeKpiClassification(i)
                                }, null, 8, $7bc9b9459cfb4fcb$var$_hoisted_31)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>kpiClassification.startClassification = $event,
                                    disabled: i > 0,
                                    type: "number",
                                    class: "form-control",
                                    id: "startClassification_" + i
                                }, null, 8, $7bc9b9459cfb4fcb$var$_hoisted_32), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        kpiClassification.startClassification
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>kpiClassification.endClassification = $event,
                                    onInput: ($event)=>$options.updateKpiClassificationStart(kpiClassification.endClassification, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endClassification_" + i
                                }, null, 40, $7bc9b9459cfb4fcb$var$_hoisted_33), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        kpiClassification.endClassification
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>kpiClassification.name = $event,
                                    type: "string",
                                    class: "form-control",
                                    id: "name_" + i
                                }, null, 8, $7bc9b9459cfb4fcb$var$_hoisted_34), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        kpiClassification.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>kpiClassification.color = $event,
                                    type: "color",
                                    class: "form-control",
                                    id: "color_" + i
                                }, null, 8, $7bc9b9459cfb4fcb$var$_hoisted_35), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        kpiClassification.color
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[4] || (_cache[4] = (...args)=>$options.addKpiClassification && $options.addKpiClassification(...args))
            }, $7bc9b9459cfb4fcb$var$_hoisted_37)
        ]),
        (0, $TusQn.createElementVNode)("div", $7bc9b9459cfb4fcb$var$_hoisted_38, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[5] || (_cache[5] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[6] || (_cache[6] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("4jnTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $323b7831b0c9b37e$export$2e2bcd8739ae039);
let $323b7831b0c9b37e$var$NOOP = ()=>{};
var $323b7831b0c9b37e$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("bUVCO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8ad19fc5de1d5ece$export$2e2bcd8739ae039);

var $97tK3 = parcelRequire("97tK3");

var $eqtu6 = parcelRequire("eqtu6");

var $2gQQk = parcelRequire("2gQQk");

var $ch9iu = parcelRequire("ch9iu");

var $l6otV = parcelRequire("l6otV");

var $eHCxc = parcelRequire("eHCxc");

var $kRTV5 = parcelRequire("kRTV5");

var $gOjKo = parcelRequire("gOjKo");
var $8ad19fc5de1d5ece$export$2e2bcd8739ae039 = {
    name: "lifeCycleDetail",
    watch: {
        $route: "requestData"
    },
    components: {
        LifeCycleDeleteModal: $kRTV5.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        showTableFunction () {
            this.generateGraph();
            this.showTable = !this.showTable;
        },
        generateGraph () {
            var foundPerformance = this.performanceList.find((p)=>p.id == this.data.performanceId);
            var maxTheoreticalAge = 0;
            this.series = [];
            this.chartOptions.yaxis = [];
            this.chartOptions.xaxis = [];
            if (foundPerformance) {
                let seriesData = [];
                var assetPerformances = foundPerformance.performanceRanges.map((a)=>a.endAssetPerformance);
                var maxAssetPerformance = Math.max(...assetPerformances);
                var theoreticalAges = foundPerformance.performanceRanges.map((a)=>a.endTheoreticalAge);
                maxTheoreticalAge = Math.max(...theoreticalAges);
                for (let performance of foundPerformance.performanceRanges){
                    seriesData.push({
                        x: performance.startTheoreticalAge,
                        y: performance.startAssetPerformance
                    });
                    seriesData.push({
                        x: performance.endTheoreticalAge,
                        y: performance.endAssetPerformance
                    });
                }
                this.series.push({
                    name: "Asset Condition",
                    type: "line",
                    dashed: true,
                    color: "#2E93fA",
                    data: seriesData
                });
                this.chartOptions.yaxis.push({
                    seriesName: "Asset Condition",
                    min: 0,
                    max: maxAssetPerformance,
                    tickAmount: maxAssetPerformance,
                    labels: {
                        formatter: function(val) {
                            return val.toFixed(1); // Customize the labels on the primary y-axis
                        }
                    },
                    title: {
                        text: "Performance"
                    }
                });
            }
            var significants = this.data.lifeCycleActivities.map((a)=>a.significant);
            var maxActivity = Math.max(...significants);
            var maxAges = this.data.lifeCycleActivities.map((a)=>a.maxAge);
            var maxActivityAge = Math.max(...maxAges);
            var ages = [];
            var theoreticalAge = 0;
            for(let age = 0; age <= maxActivityAge; age++){
                var foundRange = foundPerformance.performanceRanges.find((a)=>a.startTheoreticalAge <= theoreticalAge && theoreticalAge <= a.endTheoreticalAge);
                if (foundRange) {
                    var slope = (foundRange.endAssetPerformance - foundRange.startAssetPerformance) / (foundRange.endTheoreticalAge - foundRange.startTheoreticalAge);
                    var fixedResult = (foundRange.startAssetPerformance + slope * (theoreticalAge - foundRange.startTheoreticalAge)).toFixed(2);
                    ages.push({
                        x: age,
                        y: parseFloat(fixedResult)
                    }); // Ensure the fixedResult is a number
                }
                theoreticalAge++;
                for(var i in this.data.lifeCycleActivities){
                    var activity = this.data.lifeCycleActivities[i];
                    var activityWithoutEffect = (activity.minAge + activity.maxAge) / 2;
                    if (age == Math.ceil(activityWithoutEffect)) {
                        var foundActivity = this.activityList.find((a)=>a.id == activity.activityId);
                        // selected activity is rool
                        if (foundActivity?.rootActivity) theoreticalAge = 0;
                        else {
                            if (activity.effectType == 0) theoreticalAge = Math.round(activity.effect);
                            else if (activity.effectType == 1) theoreticalAge = Math.round(theoreticalAge * activity.effect);
                            else if (activity.effectType == 2) theoreticalAge = Math.round(theoreticalAge + activity.effect);
                        }
                    }
                }
            }
            this.series.push({
                name: "LC - Asset Condition",
                type: "line",
                color: "#2E93fA",
                data: ages
            });
            this.chartOptions.yaxis.push({
                seriesName: "LC - Asset Condition",
                max: maxAssetPerformance,
                tickAmount: maxAssetPerformance,
                show: false
            });
            // format years 
            this.chartOptions.xaxis = {
                tickAmount: 10,
                labels: {
                    formatter: function(value) {
                        return value.toFixed();
                    }
                }
            };
            for(var i in this.data.lifeCycleActivities){
                var activity = this.data.lifeCycleActivities[i];
                var foundActivity = this.activityList.find((a)=>a.id == activity.activityId);
                // Znázornění obdelníků dle minAge/maxAge a significant
                this.series.push({
                    name: foundActivity?.name || "Empty",
                    type: "area",
                    color: foundActivity?.activityColor || "#004C83",
                    data: [
                        {
                            x: activity.minAge,
                            y: activity.significant
                        },
                        {
                            x: activity.maxAge,
                            y: activity.significant
                        }
                    ]
                });
                this.chartOptions.yaxis.push({
                    seriesName: foundActivity?.name || "Empty",
                    min: 0,
                    max: maxActivity,
                    opposite: true,
                    show: i == 1,
                    title: {
                        text: "Significant"
                    }
                });
                // Pokud má noAct - rozšířím o šedou část
                if (activity.noAct) {
                    this.series.push({
                        name: "",
                        type: "area",
                        color: "#D3D3D3",
                        zIndex: 1,
                        data: [
                            {
                                x: activity.maxAge,
                                y: activity.significant
                            },
                            {
                                x: activity.maxAge + activity.noAct,
                                y: activity.significant
                            }
                        ]
                    });
                    this.chartOptions.yaxis.push({
                        seriesName: foundActivity?.name + "_noact" + i || "Empty",
                        min: 0,
                        max: maxActivity,
                        show: false
                    });
                }
            }
            // Určím, který prvek je dashed
            var dashArray = this.series.map((s)=>{
                if (s.dashed) return 4;
                return 0;
            });
            // Určím width prvků
            var widthArray = this.series.map((s)=>{
                if (s.dashed || s.type == "line") return 2;
                return 0;
            });
            this.chartOptions.stroke = {
                width: widthArray,
                curve: "straight",
                dashArray: dashArray
            };
        },
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var modelingInfo = await (0, $l6otV.default).modelingInfo(this.$route.params.id);
            for(var i in modelingInfo.selections){
                var selection = modelingInfo.selections[i];
                for(var o in selection.packages){
                    var selectionPackage = selection.packages[o];
                    for(var u in selectionPackage.lifeCycles){
                        var lifeCycle = selectionPackage.lifeCycles[u];
                        if (lifeCycle && lifeCycle.lifeCycleId == this.$route.params.lifeCycleId) this.foundLifeCycles.push({
                            selectionId: selection.id,
                            selectionPackageId: selectionPackage.id,
                            name: "Selection - " + selection.name + " - " + selectionPackage.name
                        });
                    }
                }
            }
            this.data = await (0, $97tK3.default).lifeCycleDetail(this.$route.params.id, this.$route.params.lifeCycleId);
            var performanceList = await (0, $eqtu6.default).performanceList(this.$route.params.id);
            this.performanceList = performanceList.filter((p)=>p.assetTypeId == this.$route.params.assetTypeId);
            var activityList = await (0, $2gQQk.default).activityList(this.$route.params.id);
            this.activityList = activityList.filter((a)=>a.assetTypeId == this.$route.params.assetTypeId);
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            this.generateGraph();
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var lifeCycleList = await (0, $97tK3.default).lifeCycleList(this.$route.params.id);
            this.lifeCycleList = lifeCycleList.filter((l)=>l.assetTypeId == this.$route.params.assetTypeId && l.id != this.$route.params.lifeCycleId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            for(var i in this.data.lifeCycleFilters){
                var attr = this.data.lifeCycleFilters[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr.name) < 0 && this.missingDatasetFilterHeaders.findIndex((d)=>d.name == attr.name) < 0) this.missingDatasetFilterHeaders.push({
                    name: attr.name,
                    alias: attr.name
                });
            }
            var mandatoryActAttr = this.data.mandatoryActAttr;
            if (this.datasetHeaders.findIndex((d)=>d.name == mandatoryActAttr) < 0 && this.missingDatasetHeaders.findIndex((d)=>d.name == mandatoryActAttr) < 0) this.missingDatasetHeaders.push({
                name: mandatoryActAttr,
                alias: mandatoryActAttr
            });
            var mandatoryActYearAttr = this.data.mandatoryActYearAttr;
            if (this.datasetHeaders.findIndex((d)=>d.name == mandatoryActYearAttr) < 0 && this.missingDatasetHeaders.findIndex((d)=>d.name == mandatoryActYearAttr) < 0) this.missingDatasetHeaders.push({
                name: mandatoryActYearAttr,
                alias: mandatoryActYearAttr
            });
            var mandatoryActCostAttr = this.data.mandatoryActCostAttr;
            if (this.datasetHeaders.findIndex((d)=>d.name == mandatoryActCostAttr) < 0 && this.missingDatasetHeaders.findIndex((d)=>d.name == mandatoryActCostAttr) < 0) this.missingDatasetHeaders.push({
                name: mandatoryActCostAttr,
                alias: mandatoryActCostAttr
            });
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                if (this.data.performanceId > 0) {
                    if (!this.areLifeCycleActivitiesValid()) this.showActivitiesError();
                    else if (!this.areLifeCycleFilterNumberAndSignValid()) this.showFiltersError();
                    else {
                        await (0, $97tK3.default).lifeCycleUpdate(this.$route.params.id, this.data);
                        if (!this.isFormValid()) this.showWarning();
                        else if (!this.areLifeCycleFiltersValid()) this.showFiltersWarning();
                        else this.showSuccess();
                        this.generateGraph();
                    }
                } else this.showMissingPerformanceWarning();
            } else this.showEmptyNameError();
        },
        isFormValid () {
            var mandatoryActAttr = this.data.mandatoryActAttr;
            if (this.datasetHeaders.findIndex((d)=>d.name == mandatoryActAttr) < 0 && mandatoryActAttr != "") return false;
            var mandatoryActYearAttr = this.data.mandatoryActYearAttr;
            if (this.datasetHeaders.findIndex((d)=>d.name == mandatoryActYearAttr) < 0 && mandatoryActYearAttr != "") return false;
            return true;
        },
        areLifeCycleFiltersValid () {
            for(var i in this.data.lifeCycleFilters){
                var attr = this.data.lifeCycleFilters[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr.name) < 0 || attr.name == "") return false;
            }
            return true;
        },
        areLifeCycleFilterNumberAndSignValid () {
            for(var i in this.data.lifeCycleFilters){
                var attr = this.data.lifeCycleFilters[i];
                if (attr.number === "") return false;
                if (attr.sign === "") return false;
            }
            return true;
        },
        areLifeCycleActivitiesValid () {
            for(var i in this.data.lifeCycleActivities){
                var attr = this.data.lifeCycleActivities[i];
                if (attr.minAge === "") return false;
                if (attr.maxAge === "") return false;
                if (attr.noAct === "") return false;
                if (attr.significant === "") return false;
                if (attr.effect === "") return false;
                if (attr.activityId == 0) return false;
            }
            return true;
        },
        addLifeCycleActivity () {
            this.data.lifeCycleActivities.push({
                activityId: 0,
                activityName: "",
                activityUnitCost: 0,
                activityCostFactor: "",
                minAge: this.getMinAge(),
                maxAge: 0,
                noAct: 0,
                significant: 0,
                effect: 0,
                effectType: 0,
                notFirst: false,
                changeToLifecycleId: 0,
                root: false,
                order: this.getActivityOrder()
            });
        },
        getMinAge () {
            var minAge = 0;
            if (this.data.lifeCycleActivities.length > 0) minAge = this.data.lifeCycleActivities[this.data.lifeCycleActivities.length - 1].maxAge;
            return minAge;
        },
        getActivityOrder () {
            var order = 0;
            if (this.data.lifeCycleActivities.length > 0) order = this.data.lifeCycleActivities[this.data.lifeCycleActivities.length - 1].order + 1;
            return order;
        },
        removeLifeCycleActivity (rowIndex) {
            this.data.lifeCycleActivities.splice(rowIndex, 1);
        },
        removeLifeCycleFilter (rowIndex) {
            this.data.lifeCycleFilters.splice(rowIndex, 1);
        },
        addLifeCycleFilter () {
            this.data.lifeCycleFilters.push({
                name: "",
                sign: "=",
                number: 0
            });
        },
        getActivityName (activity) {
            return `${activity.name} ${activity.rootActivity ? " (root)" : ""}`;
        },
        moveActivityUp (i) {
            var lifeCycleActivities = this.data.lifeCycleActivities;
            if (i > 0) {
                let indexOfActivityUp = i - 1;
                let tmpOrder = lifeCycleActivities[indexOfActivityUp].order;
                lifeCycleActivities[indexOfActivityUp].order = lifeCycleActivities[i].order;
                lifeCycleActivities[i].order = tmpOrder;
                lifeCycleActivities.sort((a, b)=>a.order - b.order);
                this.data.lifeCycleActivities = lifeCycleActivities;
            }
        },
        moveActivityDown (i) {
            var lifeCycleActivities = this.data.lifeCycleActivities;
            if (i >= 0) {
                let indexOfActivityDown = i + 1;
                let tmpOrder = lifeCycleActivities[indexOfActivityDown].order;
                lifeCycleActivities[indexOfActivityDown].order = lifeCycleActivities[i].order;
                lifeCycleActivities[i].order = tmpOrder;
                lifeCycleActivities.sort((a, b)=>a.order - b.order);
                this.data.lifeCycleActivities = lifeCycleActivities;
            }
        },
        orderedLifeCycleActivities (lifeCycleActivities) {
            return lifeCycleActivities.sort((a, b)=>a.order - b.order);
        },
        showDeleteLifeCycle () {
            this.lifeCycleToDeleteId = this.data.id;
            this.showLifeCycleDeleteModal = true;
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "lifeCycleUpdated",
            type: "success"
        },
        showWarning: {
            title: "warning",
            message: "warningAttributeRemoved",
            type: "warn"
        },
        showFiltersWarning: {
            title: "warning",
            message: "filtersWarning",
            type: "warn"
        },
        showActivitiesError: {
            title: "error",
            message: "activitiesError",
            type: "error"
        },
        showFiltersError: {
            title: "error",
            message: "filtersError",
            type: "error"
        },
        showMissingPerformanceWarning: {
            title: "error",
            message: "missingPerformanceWarning",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            datasetHeaders: [],
            missingDatasetHeaders: [],
            missingDatasetFilterHeaders: [],
            foundLifeCycles: [],
            data: {
                name: "",
                performanceId: 0,
                lifeCycleActivities: [
                    {
                        activityId: 0,
                        activityName: "",
                        activityUnitCost: 0,
                        activityCostFactor: "",
                        minAge: 0,
                        maxAge: 0,
                        noAct: 0,
                        significant: 0,
                        effect: 0,
                        notFirst: false,
                        changeToLifecycleId: 0,
                        root: false,
                        order: 0
                    }
                ],
                lifeCycleFilters: [
                    {
                        name: "",
                        sign: "",
                        number: 0
                    }
                ],
                id: 0
            },
            series: [],
            chartOptions: {
                chart: {
                    animations: {
                        enabled: false
                    },
                    height: 350,
                    type: "line",
                    stacked: false,
                    toolbar: {
                        show: false
                    }
                },
                stroke: {},
                xaxis: {
                    type: "category",
                    min: 0
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: "",
                    align: "left",
                    offsetX: 110
                },
                yaxis: []
            },
            lifeCycleList: [],
            performanceList: [],
            activityList: [],
            lifeCycleToDeleteId: 0,
            showLifeCycleDeleteModal: false,
            modelingName: null,
            assetTypeName: null,
            pending: true,
            showTable: true,
            isUserAdmin: false
        };
    }
};

});
parcelRegister("kRTV5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3142264fd788a64$export$2e2bcd8739ae039);
let $f3142264fd788a64$var$script;



let $f3142264fd788a64$var$initialize = ()=>{
    $f3142264fd788a64$var$script = (parcelRequire("6NuFI"));
    if ($f3142264fd788a64$var$script.__esModule) $f3142264fd788a64$var$script = $f3142264fd788a64$var$script.default;
    $f3142264fd788a64$var$script.render = (parcelRequire("kFuyg")).render;
    (parcelRequire("5xFgN")).default($f3142264fd788a64$var$script);
    $f3142264fd788a64$var$script.__scopeId = "data-v-8b71ec";
    $f3142264fd788a64$var$script.__file = "LifeCycleDeleteModal.vue";
};
$f3142264fd788a64$var$initialize();
var $f3142264fd788a64$export$2e2bcd8739ae039 = $f3142264fd788a64$var$script;

});
parcelRegister("6NuFI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4f2f1c722bbdc687$export$2e2bcd8739ae039);

var $97tK3 = parcelRequire("97tK3");
var $4f2f1c722bbdc687$export$2e2bcd8739ae039 = {
    name: "lifeCycleDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteLifeCycle () {
            await (0, $97tK3.default).lifeCycleDelete(this.$parent.$route.params.id, this.$parent.lifeCycleToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("kFuyg", function(module, exports) {

$parcel$export(module.exports, "render", () => $f0bf55e185888f38$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $f0bf55e185888f38$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $f0bf55e185888f38$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $f0bf55e185888f38$var$_hoisted_3 = {
    class: "modal-content"
};
const $f0bf55e185888f38$var$_hoisted_4 = {
    class: "modal-header"
};
const $f0bf55e185888f38$var$_hoisted_5 = {
    class: "modal-title"
};
const $f0bf55e185888f38$var$_hoisted_6 = {
    class: "modal-body"
};
const $f0bf55e185888f38$var$_hoisted_7 = {
    class: "form-label"
};
const $f0bf55e185888f38$var$_hoisted_8 = {
    key: 1
};
const $f0bf55e185888f38$var$_hoisted_9 = {
    class: "modal-footer"
};
const $f0bf55e185888f38$var$_hoisted_10 = [
    "disabled"
];
function $f0bf55e185888f38$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $f0bf55e185888f38$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $f0bf55e185888f38$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $f0bf55e185888f38$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $f0bf55e185888f38$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $f0bf55e185888f38$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycleDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $f0bf55e185888f38$var$_hoisted_6, [
                                this.$parent.foundLifeCycles.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 0
                                }, [
                                    (0, $TusQn.createElementVNode)("label", $f0bf55e185888f38$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("cannotDeleteLifeCycle")), 1),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(this.$parent.foundLifeCycles, (lifeCycle, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                            key: i
                                        }, [
                                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                                to: "/modeling/" + this.$route.params.id + "/selection/" + lifeCycle.selectionId + "/package/" + lifeCycle.selectionPackageId
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(lifeCycle.name), 1)
                                                    ]),
                                                _: 2
                                            }, 1032, [
                                                "to"
                                            ])
                                        ]);
                                    }), 128))
                                ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $f0bf55e185888f38$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisLifeCycle")), 1))
                            ]),
                            (0, $TusQn.createElementVNode)("div", $f0bf55e185888f38$var$_hoisted_9, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteLifeCycle && $options.deleteLifeCycle(...args)),
                                    disabled: this.$parent.foundLifeCycles.length > 0
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 9, $f0bf55e185888f38$var$_hoisted_10)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("5xFgN", function(module, exports) {

$parcel$export(module.exports, "default", () => $40900c291b9283f2$export$2e2bcd8739ae039);
let $40900c291b9283f2$var$NOOP = ()=>{};
var $40900c291b9283f2$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("aM7pf", function(module, exports) {

$parcel$export(module.exports, "render", () => $7d8421ca8f4bc1e4$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $7d8421ca8f4bc1e4$var$_hoisted_1 = {
    key: 0
};
const $7d8421ca8f4bc1e4$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $7d8421ca8f4bc1e4$var$_hoisted_3 = [
    $7d8421ca8f4bc1e4$var$_hoisted_2
];
const $7d8421ca8f4bc1e4$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $7d8421ca8f4bc1e4$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $7d8421ca8f4bc1e4$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $7d8421ca8f4bc1e4$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $7d8421ca8f4bc1e4$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $7d8421ca8f4bc1e4$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $7d8421ca8f4bc1e4$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $7d8421ca8f4bc1e4$var$_hoisted_11 = {
    class: "row mb-4"
};
const $7d8421ca8f4bc1e4$var$_hoisted_12 = {
    class: "col-md-4"
};
const $7d8421ca8f4bc1e4$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $7d8421ca8f4bc1e4$var$_hoisted_14 = {
    class: "col-md-4"
};
const $7d8421ca8f4bc1e4$var$_hoisted_15 = {
    class: "form-label",
    for: "performanceId",
    required: ""
};
const $7d8421ca8f4bc1e4$var$_hoisted_16 = {
    disabled: ""
};
const $7d8421ca8f4bc1e4$var$_hoisted_17 = [
    "value"
];
const $7d8421ca8f4bc1e4$var$_hoisted_18 = {
    class: "col-md-4"
};
const $7d8421ca8f4bc1e4$var$_hoisted_19 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $7d8421ca8f4bc1e4$var$_hoisted_20 = {
    class: "row mb-4"
};
const $7d8421ca8f4bc1e4$var$_hoisted_21 = {
    class: "col-md-4"
};
const $7d8421ca8f4bc1e4$var$_hoisted_22 = {
    class: "form-label",
    for: "mandatoryActAttr",
    required: ""
};
const $7d8421ca8f4bc1e4$var$_hoisted_23 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $7d8421ca8f4bc1e4$var$_hoisted_24 = [
    "value"
];
const $7d8421ca8f4bc1e4$var$_hoisted_25 = [
    "value"
];
const $7d8421ca8f4bc1e4$var$_hoisted_26 = {
    class: "col-md-4"
};
const $7d8421ca8f4bc1e4$var$_hoisted_27 = {
    class: "form-label",
    for: "mandatoryActYearAttr",
    required: ""
};
const $7d8421ca8f4bc1e4$var$_hoisted_28 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $7d8421ca8f4bc1e4$var$_hoisted_29 = [
    "value"
];
const $7d8421ca8f4bc1e4$var$_hoisted_30 = [
    "value"
];
const $7d8421ca8f4bc1e4$var$_hoisted_31 = {
    class: "col-md-4"
};
const $7d8421ca8f4bc1e4$var$_hoisted_32 = {
    class: "form-label",
    for: "mandatoryActCostAttr",
    required: ""
};
const $7d8421ca8f4bc1e4$var$_hoisted_33 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $7d8421ca8f4bc1e4$var$_hoisted_34 = [
    "value"
];
const $7d8421ca8f4bc1e4$var$_hoisted_35 = [
    "value"
];
const $7d8421ca8f4bc1e4$var$_hoisted_36 = {
    key: 0,
    class: "mb-4"
};
const $7d8421ca8f4bc1e4$var$_hoisted_37 = {
    class: "table"
};
const $7d8421ca8f4bc1e4$var$_hoisted_38 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $7d8421ca8f4bc1e4$var$_hoisted_39 = {
    scope: "col",
    class: "col-2"
};
const $7d8421ca8f4bc1e4$var$_hoisted_40 = {
    scope: "col"
};
const $7d8421ca8f4bc1e4$var$_hoisted_41 = {
    scope: "col"
};
const $7d8421ca8f4bc1e4$var$_hoisted_42 = {
    scope: "col"
};
const $7d8421ca8f4bc1e4$var$_hoisted_43 = {
    scope: "col"
};
const $7d8421ca8f4bc1e4$var$_hoisted_44 = {
    scope: "col"
};
const $7d8421ca8f4bc1e4$var$_hoisted_45 = {
    scope: "col"
};
const $7d8421ca8f4bc1e4$var$_hoisted_46 = {
    scope: "col"
};
const $7d8421ca8f4bc1e4$var$_hoisted_47 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $7d8421ca8f4bc1e4$var$_hoisted_48 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $7d8421ca8f4bc1e4$var$_hoisted_49 = {
    scope: "row"
};
const $7d8421ca8f4bc1e4$var$_hoisted_50 = [
    "onClick"
];
const $7d8421ca8f4bc1e4$var$_hoisted_51 = [
    "id",
    "onUpdate:modelValue"
];
const $7d8421ca8f4bc1e4$var$_hoisted_52 = {
    disabled: ""
};
const $7d8421ca8f4bc1e4$var$_hoisted_53 = [
    "value"
];
const $7d8421ca8f4bc1e4$var$_hoisted_54 = [
    "onUpdate:modelValue",
    "id"
];
const $7d8421ca8f4bc1e4$var$_hoisted_55 = [
    "onUpdate:modelValue",
    "id"
];
const $7d8421ca8f4bc1e4$var$_hoisted_56 = [
    "onUpdate:modelValue",
    "id"
];
const $7d8421ca8f4bc1e4$var$_hoisted_57 = [
    "onUpdate:modelValue",
    "id"
];
const $7d8421ca8f4bc1e4$var$_hoisted_58 = {
    class: "input-group"
};
const $7d8421ca8f4bc1e4$var$_hoisted_59 = [
    "onUpdate:modelValue",
    "id"
];
const $7d8421ca8f4bc1e4$var$_hoisted_60 = [
    "id",
    "onUpdate:modelValue"
];
const $7d8421ca8f4bc1e4$var$_hoisted_61 = {
    value: "0"
};
const $7d8421ca8f4bc1e4$var$_hoisted_62 = {
    value: "1"
};
const $7d8421ca8f4bc1e4$var$_hoisted_63 = {
    value: "2"
};
const $7d8421ca8f4bc1e4$var$_hoisted_64 = {
    class: "form-check"
};
const $7d8421ca8f4bc1e4$var$_hoisted_65 = [
    "onUpdate:modelValue",
    "id"
];
const $7d8421ca8f4bc1e4$var$_hoisted_66 = [
    "id",
    "onUpdate:modelValue"
];
const $7d8421ca8f4bc1e4$var$_hoisted_67 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    selected: "",
    value: 0
}, null, -1);
const $7d8421ca8f4bc1e4$var$_hoisted_68 = [
    "value"
];
const $7d8421ca8f4bc1e4$var$_hoisted_69 = [
    "onClick"
];
const $7d8421ca8f4bc1e4$var$_hoisted_70 = [
    "onClick"
];
const $7d8421ca8f4bc1e4$var$_hoisted_71 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $7d8421ca8f4bc1e4$var$_hoisted_72 = [
    $7d8421ca8f4bc1e4$var$_hoisted_71
];
const $7d8421ca8f4bc1e4$var$_hoisted_73 = {
    key: 1,
    class: "mb-4"
};
const $7d8421ca8f4bc1e4$var$_hoisted_74 = {
    class: "mb-3"
};
const $7d8421ca8f4bc1e4$var$_hoisted_75 = {
    class: "mb-3"
};
const $7d8421ca8f4bc1e4$var$_hoisted_76 = {
    class: "table"
};
const $7d8421ca8f4bc1e4$var$_hoisted_77 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $7d8421ca8f4bc1e4$var$_hoisted_78 = {
    scope: "col"
};
const $7d8421ca8f4bc1e4$var$_hoisted_79 = {
    scope: "col"
};
const $7d8421ca8f4bc1e4$var$_hoisted_80 = {
    scope: "col"
};
const $7d8421ca8f4bc1e4$var$_hoisted_81 = {
    scope: "row"
};
const $7d8421ca8f4bc1e4$var$_hoisted_82 = [
    "onClick"
];
const $7d8421ca8f4bc1e4$var$_hoisted_83 = [
    "id",
    "onUpdate:modelValue"
];
const $7d8421ca8f4bc1e4$var$_hoisted_84 = {
    disabled: ""
};
const $7d8421ca8f4bc1e4$var$_hoisted_85 = [
    "value"
];
const $7d8421ca8f4bc1e4$var$_hoisted_86 = [
    "value"
];
const $7d8421ca8f4bc1e4$var$_hoisted_87 = [
    "onUpdate:modelValue",
    "id"
];
const $7d8421ca8f4bc1e4$var$_hoisted_88 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<option value="=">=</option><option value="&gt;">&gt;</option><option value="&lt;">&lt;</option><option value="&gt;=">&gt;=</option><option value="&lt;=">&lt;=</option>', 5);
const $7d8421ca8f4bc1e4$var$_hoisted_93 = [
    $7d8421ca8f4bc1e4$var$_hoisted_88
];
const $7d8421ca8f4bc1e4$var$_hoisted_94 = [
    "onUpdate:modelValue",
    "id"
];
const $7d8421ca8f4bc1e4$var$_hoisted_95 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $7d8421ca8f4bc1e4$var$_hoisted_96 = [
    $7d8421ca8f4bc1e4$var$_hoisted_95
];
const $7d8421ca8f4bc1e4$var$_hoisted_97 = {
    class: "d-grid gap-2 d-md-flex"
};
function $7d8421ca8f4bc1e4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_apexchart = (0, $TusQn.resolveComponent)("apexchart");
    const _component_LifeCycleDeleteModal = (0, $TusQn.resolveComponent)("LifeCycleDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7d8421ca8f4bc1e4$var$_hoisted_1, $7d8421ca8f4bc1e4$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7d8421ca8f4bc1e4$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycleDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $7d8421ca8f4bc1e4$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $7d8421ca8f4bc1e4$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $7d8421ca8f4bc1e4$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $7d8421ca8f4bc1e4$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $7d8421ca8f4bc1e4$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $7d8421ca8f4bc1e4$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $7d8421ca8f4bc1e4$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $7d8421ca8f4bc1e4$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("performance")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.performanceId = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $7d8421ca8f4bc1e4$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.performanceList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.performanceList, (performance, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: performance.id
                        }, (0, $8POXm.toDisplayString)(performance.name), 9, $7d8421ca8f4bc1e4$var$_hoisted_17);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.performanceId
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("label", $7d8421ca8f4bc1e4$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_20, [
            (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_21, [
                (0, $TusQn.createElementVNode)("label", $7d8421ca8f4bc1e4$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("mandatoryActAttr")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "mandatoryActAttr",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.mandatoryActAttr = $event)
                }, [
                    $7d8421ca8f4bc1e4$var$_hoisted_23,
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $7d8421ca8f4bc1e4$var$_hoisted_24);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                    $data.missingDatasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 1
                    }, (0, $TusQn.renderList)($data.missingDatasetHeaders, (missingDatasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            disabled: "",
                            value: missingDatasetHeader.name
                        }, (0, $8POXm.toDisplayString)(missingDatasetHeader.alias), 9, $7d8421ca8f4bc1e4$var$_hoisted_25);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.mandatoryActAttr
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_26, [
                (0, $TusQn.createElementVNode)("label", $7d8421ca8f4bc1e4$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("mandatoryActYearAttr")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "mandatoryActYearAttr",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.mandatoryActYearAttr = $event)
                }, [
                    $7d8421ca8f4bc1e4$var$_hoisted_28,
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $7d8421ca8f4bc1e4$var$_hoisted_29);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                    $data.missingDatasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 1
                    }, (0, $TusQn.renderList)($data.missingDatasetHeaders, (missingDatasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            disabled: "",
                            value: missingDatasetHeader.name
                        }, (0, $8POXm.toDisplayString)(missingDatasetHeader.alias), 9, $7d8421ca8f4bc1e4$var$_hoisted_30);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.mandatoryActYearAttr
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_31, [
                (0, $TusQn.createElementVNode)("label", $7d8421ca8f4bc1e4$var$_hoisted_32, (0, $8POXm.toDisplayString)(_ctx.$t("mandatoryActCostAttr")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "mandatoryActCostAttr",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.data.mandatoryActCostAttr = $event)
                }, [
                    $7d8421ca8f4bc1e4$var$_hoisted_33,
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $7d8421ca8f4bc1e4$var$_hoisted_34);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                    $data.missingDatasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 1
                    }, (0, $TusQn.renderList)($data.missingDatasetHeaders, (missingDatasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            disabled: "",
                            value: missingDatasetHeader.name
                        }, (0, $8POXm.toDisplayString)(missingDatasetHeader.alias), 9, $7d8421ca8f4bc1e4$var$_hoisted_35);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.mandatoryActCostAttr
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            class: "fa fa-eye btn btn-outline-primary float-end",
            onClick: _cache[6] || (_cache[6] = (...args)=>$options.showTableFunction && $options.showTableFunction(...args))
        }),
        $data.showTable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7d8421ca8f4bc1e4$var$_hoisted_36, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycleActivities")), 1),
            (0, $TusQn.createElementVNode)("table", $7d8421ca8f4bc1e4$var$_hoisted_37, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $7d8421ca8f4bc1e4$var$_hoisted_38,
                        (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_39, (0, $8POXm.toDisplayString)(_ctx.$t("activity")), 1),
                        (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_40, (0, $8POXm.toDisplayString)(_ctx.$t("minAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_41, (0, $8POXm.toDisplayString)(_ctx.$t("maxAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_42, (0, $8POXm.toDisplayString)(_ctx.$t("noAct")), 1),
                        (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_43, (0, $8POXm.toDisplayString)(_ctx.$t("signif")), 1),
                        (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_44, (0, $8POXm.toDisplayString)(_ctx.$t("effect")), 1),
                        (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_45, (0, $8POXm.toDisplayString)(_ctx.$t("notFirst")), 1),
                        (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_46, (0, $8POXm.toDisplayString)(_ctx.$t("changeToLifeCycle")), 1),
                        $7d8421ca8f4bc1e4$var$_hoisted_47,
                        $7d8421ca8f4bc1e4$var$_hoisted_48
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.orderedLifeCycleActivities($data.data.lifeCycleActivities), (lifeCycleActivity, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_49, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeLifeCycleActivity(i)
                                }, null, 8, $7d8421ca8f4bc1e4$var$_hoisted_50)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "activityId_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.activityId = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $7d8421ca8f4bc1e4$var$_hoisted_52, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.activityList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.activityList, (activity, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: activity.id
                                        }, (0, $8POXm.toDisplayString)($options.getActivityName(activity)), 9, $7d8421ca8f4bc1e4$var$_hoisted_53);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $7d8421ca8f4bc1e4$var$_hoisted_51), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        lifeCycleActivity.activityId
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.minAge = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "minAge_" + i
                                }, null, 8, $7d8421ca8f4bc1e4$var$_hoisted_54), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        lifeCycleActivity.minAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.maxAge = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "maxAge_" + i
                                }, null, 8, $7d8421ca8f4bc1e4$var$_hoisted_55), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        lifeCycleActivity.maxAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.noAct = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "noAct_" + i
                                }, null, 8, $7d8421ca8f4bc1e4$var$_hoisted_56), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        lifeCycleActivity.noAct
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.significant = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "significant_" + i
                                }, null, 8, $7d8421ca8f4bc1e4$var$_hoisted_57), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        lifeCycleActivity.significant
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_58, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        "onUpdate:modelValue": ($event)=>lifeCycleActivity.effect = $event,
                                        type: "number",
                                        class: "form-control",
                                        id: "effect_" + i
                                    }, null, 8, $7d8421ca8f4bc1e4$var$_hoisted_59), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            lifeCycleActivity.effect
                                        ]
                                    ]),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        id: "effecttype_" + i,
                                        class: "form-select",
                                        "onUpdate:modelValue": ($event)=>lifeCycleActivity.effectType = $event
                                    }, [
                                        (0, $TusQn.createElementVNode)("option", $7d8421ca8f4bc1e4$var$_hoisted_61, (0, $8POXm.toDisplayString)(_ctx.$t("Absolute")), 1),
                                        (0, $TusQn.createElementVNode)("option", $7d8421ca8f4bc1e4$var$_hoisted_62, (0, $8POXm.toDisplayString)(_ctx.$t("Relative")), 1),
                                        (0, $TusQn.createElementVNode)("option", $7d8421ca8f4bc1e4$var$_hoisted_63, (0, $8POXm.toDisplayString)(_ctx.$t("Differential")), 1)
                                    ], 8, $7d8421ca8f4bc1e4$var$_hoisted_60), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            lifeCycleActivity.effectType
                                        ]
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_64, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event)=>lifeCycleActivity.notFirst = $event,
                                        id: "notFirst_" + i
                                    }, null, 8, $7d8421ca8f4bc1e4$var$_hoisted_65), [
                                        [
                                            (0, $eeJ70.vModelCheckbox),
                                            lifeCycleActivity.notFirst
                                        ]
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "changeToLifecycleId_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.changeToLifecycleId = $event
                                }, [
                                    $7d8421ca8f4bc1e4$var$_hoisted_67,
                                    $data.lifeCycleList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.lifeCycleList, (lifeCycle, o)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: o,
                                            value: lifeCycle.id
                                        }, (0, $8POXm.toDisplayString)(lifeCycle.name), 9, $7d8421ca8f4bc1e4$var$_hoisted_68);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $7d8421ca8f4bc1e4$var$_hoisted_66), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        lifeCycleActivity.changeToLifecycleId
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                i < $data.data.lifeCycleActivities.length - 1 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("i", {
                                    key: 0,
                                    class: "fa fa-arrow-down",
                                    onClick: ($event)=>$options.moveActivityDown(i)
                                }, null, 8, $7d8421ca8f4bc1e4$var$_hoisted_69)) : (0, $TusQn.createCommentVNode)("", true)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                i != 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("i", {
                                    key: 0,
                                    class: "fa fa-arrow-up",
                                    onClick: ($event)=>$options.moveActivityUp(i)
                                }, null, 8, $7d8421ca8f4bc1e4$var$_hoisted_70)) : (0, $TusQn.createCommentVNode)("", true)
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[7] || (_cache[7] = (...args)=>$options.addLifeCycleActivity && $options.addLifeCycleActivity(...args))
            }, $7d8421ca8f4bc1e4$var$_hoisted_72)
        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7d8421ca8f4bc1e4$var$_hoisted_73, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycleActivitiesChart")), 1),
            (0, $TusQn.createVNode)(_component_apexchart, {
                class: "d-flex justify-content-center",
                type: "line",
                width: "800px",
                options: $data.chartOptions,
                series: $data.series
            }, null, 8, [
                "options",
                "series"
            ])
        ])),
        (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_74, [
            (0, $TusQn.createElementVNode)("h4", $7d8421ca8f4bc1e4$var$_hoisted_75, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycleFilters")), 1),
            (0, $TusQn.createElementVNode)("table", $7d8421ca8f4bc1e4$var$_hoisted_76, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $7d8421ca8f4bc1e4$var$_hoisted_77,
                        (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_78, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_79, (0, $8POXm.toDisplayString)(_ctx.$t("sign")), 1),
                        (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_80, (0, $8POXm.toDisplayString)(_ctx.$t("number")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.lifeCycleFilters, (lifeCycleFilter, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $7d8421ca8f4bc1e4$var$_hoisted_81, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeLifeCycleFilter(i)
                                }, null, 8, $7d8421ca8f4bc1e4$var$_hoisted_82)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "name_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>lifeCycleFilter.name = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $7d8421ca8f4bc1e4$var$_hoisted_84, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $7d8421ca8f4bc1e4$var$_hoisted_85);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                                    $data.missingDatasetFilterHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 1
                                    }, (0, $TusQn.renderList)($data.missingDatasetFilterHeaders, (missingDatasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            disabled: "",
                                            value: missingDatasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(missingDatasetHeader.alias), 9, $7d8421ca8f4bc1e4$var$_hoisted_86);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $7d8421ca8f4bc1e4$var$_hoisted_83), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        lifeCycleFilter.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleFilter.sign = $event,
                                    class: "form-select",
                                    id: "sign_" + i
                                }, $7d8421ca8f4bc1e4$var$_hoisted_93, 8, $7d8421ca8f4bc1e4$var$_hoisted_87), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        lifeCycleFilter.sign
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleFilter.number = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "number_" + i
                                }, null, 8, $7d8421ca8f4bc1e4$var$_hoisted_94), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        lifeCycleFilter.number
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[8] || (_cache[8] = (...args)=>$options.addLifeCycleFilter && $options.addLifeCycleFilter(...args))
            }, $7d8421ca8f4bc1e4$var$_hoisted_96)
        ]),
        (0, $TusQn.createElementVNode)("div", $7d8421ca8f4bc1e4$var$_hoisted_97, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[9] || (_cache[9] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[10] || (_cache[10] = (...args)=>$options.showDeleteLifeCycle && $options.showDeleteLifeCycle(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[11] || (_cache[11] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showLifeCycleDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_LifeCycleDeleteModal, {
            key: 2,
            onReload: _cache[12] || (_cache[12] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                })),
            onCloseDeleteDialog: _cache[13] || (_cache[13] = ($event)=>$data.showLifeCycleDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("3yMZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $297a8b5dee745fab$export$2e2bcd8739ae039);
let $297a8b5dee745fab$var$NOOP = ()=>{};
var $297a8b5dee745fab$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("fswk9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b4128b6fb0b100fc$export$2e2bcd8739ae039);

var $97tK3 = parcelRequire("97tK3");

var $eqtu6 = parcelRequire("eqtu6");

var $2gQQk = parcelRequire("2gQQk");

var $ch9iu = parcelRequire("ch9iu");

var $l6otV = parcelRequire("l6otV");

var $eHCxc = parcelRequire("eHCxc");
var $b4128b6fb0b100fc$export$2e2bcd8739ae039 = {
    name: "lifeCycleCreate",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var lifeCycleList = await (0, $97tK3.default).lifeCycleList(this.$route.params.id);
            this.lifeCycleList = lifeCycleList.filter((l)=>l.assetTypeId == this.$route.params.assetTypeId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var performanceList = await (0, $eqtu6.default).performanceList(this.$route.params.id);
            this.performanceList = performanceList.filter((p)=>p.assetTypeId == this.$route.params.assetTypeId);
            var activityList = await (0, $2gQQk.default).activityList(this.$route.params.id);
            this.activityList = activityList.filter((a)=>a.assetTypeId == this.$route.params.assetTypeId);
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                if (this.data.performanceId > 0) {
                    if (!this.areLifeCycleActivitiesValid()) this.showActivitiesError();
                    else if (!this.areLifeCycleFilterNumberAndSignValid()) this.showFiltersError();
                    else if (!this.isFormValid()) this.showWarning();
                    else {
                        this.data.assetTypeId = this.$route.params.assetTypeId;
                        await (0, $97tK3.default).lifeCycleCreate(this.$route.params.id, this.data);
                        this.$router.go(-1);
                    }
                } else this.showMissingPerformanceWarning();
            } else this.showEmptyNameError();
        },
        areLifeCycleFilterNumberAndSignValid () {
            for(var i in this.data.lifeCycleFilters){
                var attr = this.data.lifeCycleFilters[i];
                if (attr.number === "") return false;
                if (attr.sign === "") return false;
            }
            return true;
        },
        areLifeCycleActivitiesValid () {
            for(var i in this.data.lifeCycleActivities){
                var attr = this.data.lifeCycleActivities[i];
                if (attr.minAge === "") return false;
                if (attr.maxAge === "") return false;
                if (attr.noAct === "") return false;
                if (attr.significant === "") return false;
                if (attr.effect === "") return false;
                if (attr.activityId == 0) return false;
            }
            return true;
        },
        isFormValid () {
            var mandatoryActAttr = this.data.mandatoryActAttr;
            if (this.datasetHeaders.findIndex((d)=>d.name == mandatoryActAttr) < 0 && mandatoryActAttr != "") return false;
            var mandatoryActYearAttr = this.data.mandatoryActYearAttr;
            if (this.datasetHeaders.findIndex((d)=>d.name == mandatoryActYearAttr) < 0 && mandatoryActYearAttr != "") return false;
            return true;
        },
        addLifeCycleActivity () {
            this.data.lifeCycleActivities.push({
                activityId: 0,
                activityName: "",
                activityUnitCost: 0,
                activityCostFactor: "",
                minAge: this.getMinAge(),
                maxAge: 0,
                noAct: 0,
                significant: 0,
                effect: 0,
                effectType: 0,
                notFirst: false,
                changeToLifecycleId: 0,
                root: false,
                order: this.getActivityOrder()
            });
        },
        getMinAge () {
            var minAge = 0;
            if (this.data.lifeCycleActivities.length > 0) minAge = this.data.lifeCycleActivities[this.data.lifeCycleActivities.length - 1].maxAge;
            return minAge;
        },
        getActivityOrder () {
            var order = 0;
            if (this.data.lifeCycleActivities.length > 0) order = this.data.lifeCycleActivities[this.data.lifeCycleActivities.length - 1].order + 1;
            return order;
        },
        removeLifeCycleActivity (rowIndex) {
            this.data.lifeCycleActivities.splice(rowIndex, 1);
        },
        removeLifeCycleFilter (rowIndex) {
            this.data.lifeCycleFilters.splice(rowIndex, 1);
        },
        addLifeCycleFilter () {
            this.data.lifeCycleFilters.push({
                name: "",
                sign: "=",
                number: 0
            });
        },
        getActivityName (activity) {
            return `${activity.name} ${activity.rootActivity ? " (root)" : ""}`;
        },
        moveActivityUp (i) {
            var lifeCycleActivities = this.data.lifeCycleActivities;
            if (i > 0) {
                let indexOfActivityUp = i - 1;
                let tmpOrder = lifeCycleActivities[indexOfActivityUp].order;
                lifeCycleActivities[indexOfActivityUp].order = lifeCycleActivities[i].order;
                lifeCycleActivities[i].order = tmpOrder;
                lifeCycleActivities.sort((a, b)=>a.order - b.order);
                this.data.lifeCycleActivities = lifeCycleActivities;
            }
        },
        moveActivityDown (i) {
            var lifeCycleActivities = this.data.lifeCycleActivities;
            if (i >= 0) {
                let indexOfActivityDown = i + 1;
                let tmpOrder = lifeCycleActivities[indexOfActivityDown].order;
                lifeCycleActivities[indexOfActivityDown].order = lifeCycleActivities[i].order;
                lifeCycleActivities[i].order = tmpOrder;
                lifeCycleActivities.sort((a, b)=>a.order - b.order);
                this.data.lifeCycleActivities = lifeCycleActivities;
            }
        },
        orderedLifeCycleActivities (lifeCycleActivities) {
            return lifeCycleActivities.sort((a, b)=>a.order - b.order);
        }
    },
    notifications: {
        showMissingPerformanceWarning: {
            title: "error",
            message: "missingPerformanceWarning",
            type: "error"
        },
        showFiltersWarning: {
            title: "warning",
            message: "filtersWarning",
            type: "warn"
        },
        showFiltersError: {
            title: "error",
            message: "filtersError",
            type: "error"
        },
        showActivitiesError: {
            title: "error",
            message: "activitiesError",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            datasetHeaders: [],
            data: {
                id: 0,
                name: "",
                description: "",
                performanceId: 0,
                assetTypeId: 0,
                mandatoryActAttr: "",
                mandatoryActYearAttr: "",
                mandatoryActCostAttr: "",
                lifeCycleActivities: [],
                lifeCycleFilters: []
            },
            lifeCycleList: [],
            performanceList: [],
            activityList: [],
            modelingName: null,
            assetTypeName: null,
            pending: true
        };
    }
};

});

parcelRegister("hlURL", function(module, exports) {

$parcel$export(module.exports, "render", () => $ca20824015081bd7$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $ca20824015081bd7$var$_hoisted_1 = {
    key: 0
};
const $ca20824015081bd7$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $ca20824015081bd7$var$_hoisted_3 = [
    $ca20824015081bd7$var$_hoisted_2
];
const $ca20824015081bd7$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $ca20824015081bd7$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $ca20824015081bd7$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $ca20824015081bd7$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $ca20824015081bd7$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $ca20824015081bd7$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $ca20824015081bd7$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $ca20824015081bd7$var$_hoisted_11 = {
    class: "row mb-4"
};
const $ca20824015081bd7$var$_hoisted_12 = {
    class: "col-md-4"
};
const $ca20824015081bd7$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $ca20824015081bd7$var$_hoisted_14 = {
    class: "col-md-4"
};
const $ca20824015081bd7$var$_hoisted_15 = {
    class: "form-label",
    for: "performanceId",
    required: ""
};
const $ca20824015081bd7$var$_hoisted_16 = {
    disabled: ""
};
const $ca20824015081bd7$var$_hoisted_17 = [
    "value"
];
const $ca20824015081bd7$var$_hoisted_18 = {
    class: "col-md-4"
};
const $ca20824015081bd7$var$_hoisted_19 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $ca20824015081bd7$var$_hoisted_20 = {
    class: "row mb-4"
};
const $ca20824015081bd7$var$_hoisted_21 = {
    class: "col-md-4"
};
const $ca20824015081bd7$var$_hoisted_22 = {
    class: "form-label",
    for: "mandatoryActAttr",
    required: ""
};
const $ca20824015081bd7$var$_hoisted_23 = {
    disabled: ""
};
const $ca20824015081bd7$var$_hoisted_24 = [
    "value"
];
const $ca20824015081bd7$var$_hoisted_25 = {
    class: "col-md-4"
};
const $ca20824015081bd7$var$_hoisted_26 = {
    class: "form-label",
    for: "mandatoryActYearAttr",
    required: ""
};
const $ca20824015081bd7$var$_hoisted_27 = {
    disabled: ""
};
const $ca20824015081bd7$var$_hoisted_28 = [
    "value"
];
const $ca20824015081bd7$var$_hoisted_29 = {
    class: "col-md-4"
};
const $ca20824015081bd7$var$_hoisted_30 = {
    class: "form-label",
    for: "mandatoryActCostAttr",
    required: ""
};
const $ca20824015081bd7$var$_hoisted_31 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $ca20824015081bd7$var$_hoisted_32 = [
    "value"
];
const $ca20824015081bd7$var$_hoisted_33 = {
    class: "mb-4"
};
const $ca20824015081bd7$var$_hoisted_34 = {
    class: "table"
};
const $ca20824015081bd7$var$_hoisted_35 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $ca20824015081bd7$var$_hoisted_36 = {
    scope: "col",
    class: "col-2"
};
const $ca20824015081bd7$var$_hoisted_37 = {
    scope: "col"
};
const $ca20824015081bd7$var$_hoisted_38 = {
    scope: "col"
};
const $ca20824015081bd7$var$_hoisted_39 = {
    scope: "col"
};
const $ca20824015081bd7$var$_hoisted_40 = {
    scope: "col"
};
const $ca20824015081bd7$var$_hoisted_41 = {
    scope: "col"
};
const $ca20824015081bd7$var$_hoisted_42 = {
    scope: "col"
};
const $ca20824015081bd7$var$_hoisted_43 = {
    scope: "col"
};
const $ca20824015081bd7$var$_hoisted_44 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $ca20824015081bd7$var$_hoisted_45 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $ca20824015081bd7$var$_hoisted_46 = {
    scope: "row"
};
const $ca20824015081bd7$var$_hoisted_47 = [
    "onClick"
];
const $ca20824015081bd7$var$_hoisted_48 = [
    "id",
    "onUpdate:modelValue"
];
const $ca20824015081bd7$var$_hoisted_49 = {
    disabled: ""
};
const $ca20824015081bd7$var$_hoisted_50 = [
    "value"
];
const $ca20824015081bd7$var$_hoisted_51 = [
    "onUpdate:modelValue",
    "id"
];
const $ca20824015081bd7$var$_hoisted_52 = [
    "onUpdate:modelValue",
    "id"
];
const $ca20824015081bd7$var$_hoisted_53 = [
    "onUpdate:modelValue",
    "id"
];
const $ca20824015081bd7$var$_hoisted_54 = [
    "onUpdate:modelValue",
    "id"
];
const $ca20824015081bd7$var$_hoisted_55 = {
    class: "input-group"
};
const $ca20824015081bd7$var$_hoisted_56 = [
    "onUpdate:modelValue",
    "id"
];
const $ca20824015081bd7$var$_hoisted_57 = [
    "id",
    "onUpdate:modelValue"
];
const $ca20824015081bd7$var$_hoisted_58 = {
    value: "0"
};
const $ca20824015081bd7$var$_hoisted_59 = {
    value: "1"
};
const $ca20824015081bd7$var$_hoisted_60 = {
    value: "2"
};
const $ca20824015081bd7$var$_hoisted_61 = {
    class: "form-check"
};
const $ca20824015081bd7$var$_hoisted_62 = [
    "onUpdate:modelValue",
    "id"
];
const $ca20824015081bd7$var$_hoisted_63 = [
    "id",
    "onUpdate:modelValue"
];
const $ca20824015081bd7$var$_hoisted_64 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    selected: "",
    value: 0
}, null, -1);
const $ca20824015081bd7$var$_hoisted_65 = [
    "value"
];
const $ca20824015081bd7$var$_hoisted_66 = [
    "onClick"
];
const $ca20824015081bd7$var$_hoisted_67 = [
    "onClick"
];
const $ca20824015081bd7$var$_hoisted_68 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $ca20824015081bd7$var$_hoisted_69 = [
    $ca20824015081bd7$var$_hoisted_68
];
const $ca20824015081bd7$var$_hoisted_70 = {
    class: "mb-3"
};
const $ca20824015081bd7$var$_hoisted_71 = {
    class: "mb-3"
};
const $ca20824015081bd7$var$_hoisted_72 = {
    class: "table"
};
const $ca20824015081bd7$var$_hoisted_73 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $ca20824015081bd7$var$_hoisted_74 = {
    scope: "col"
};
const $ca20824015081bd7$var$_hoisted_75 = {
    scope: "col"
};
const $ca20824015081bd7$var$_hoisted_76 = {
    scope: "col"
};
const $ca20824015081bd7$var$_hoisted_77 = {
    scope: "row"
};
const $ca20824015081bd7$var$_hoisted_78 = [
    "onClick"
];
const $ca20824015081bd7$var$_hoisted_79 = [
    "id",
    "onUpdate:modelValue"
];
const $ca20824015081bd7$var$_hoisted_80 = {
    disabled: ""
};
const $ca20824015081bd7$var$_hoisted_81 = [
    "value"
];
const $ca20824015081bd7$var$_hoisted_82 = [
    "onUpdate:modelValue",
    "id"
];
const $ca20824015081bd7$var$_hoisted_83 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<option value="=">=</option><option value="&gt;">&gt;</option><option value="&lt;">&lt;</option><option value="&gt;=">&gt;=</option><option value="&lt;=">&lt;=</option>', 5);
const $ca20824015081bd7$var$_hoisted_88 = [
    $ca20824015081bd7$var$_hoisted_83
];
const $ca20824015081bd7$var$_hoisted_89 = [
    "onUpdate:modelValue",
    "id"
];
const $ca20824015081bd7$var$_hoisted_90 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $ca20824015081bd7$var$_hoisted_91 = [
    $ca20824015081bd7$var$_hoisted_90
];
const $ca20824015081bd7$var$_hoisted_92 = {
    class: "d-grid gap-2 d-md-flex"
};
function $ca20824015081bd7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $ca20824015081bd7$var$_hoisted_1, $ca20824015081bd7$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $ca20824015081bd7$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycleCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $ca20824015081bd7$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $ca20824015081bd7$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $ca20824015081bd7$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $ca20824015081bd7$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $ca20824015081bd7$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $ca20824015081bd7$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycleCreate")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $ca20824015081bd7$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $ca20824015081bd7$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("performance")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.performanceId = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $ca20824015081bd7$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.performanceList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.performanceList, (performance, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: performance.id
                        }, (0, $8POXm.toDisplayString)(performance.name), 9, $ca20824015081bd7$var$_hoisted_17);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.performanceId
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("label", $ca20824015081bd7$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_20, [
            (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_21, [
                (0, $TusQn.createElementVNode)("label", $ca20824015081bd7$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("mandatoryActAttr")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "mandatoryActAttr",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.mandatoryActAttr = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $ca20824015081bd7$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $ca20824015081bd7$var$_hoisted_24);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.mandatoryActAttr
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_25, [
                (0, $TusQn.createElementVNode)("label", $ca20824015081bd7$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("mandatoryActYearAttr")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "mandatoryActYearAttr",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.mandatoryActYearAttr = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $ca20824015081bd7$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $ca20824015081bd7$var$_hoisted_28);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.mandatoryActYearAttr
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_29, [
                (0, $TusQn.createElementVNode)("label", $ca20824015081bd7$var$_hoisted_30, (0, $8POXm.toDisplayString)(_ctx.$t("mandatoryActCostAttr")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "mandatoryActCostAttr",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.data.mandatoryActCostAttr = $event)
                }, [
                    $ca20824015081bd7$var$_hoisted_31,
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $ca20824015081bd7$var$_hoisted_32);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.mandatoryActCostAttr
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_33, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycleActivities")), 1),
            (0, $TusQn.createElementVNode)("table", $ca20824015081bd7$var$_hoisted_34, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $ca20824015081bd7$var$_hoisted_35,
                        (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_36, (0, $8POXm.toDisplayString)(_ctx.$t("activity")), 1),
                        (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_37, (0, $8POXm.toDisplayString)(_ctx.$t("minAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_38, (0, $8POXm.toDisplayString)(_ctx.$t("maxAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_39, (0, $8POXm.toDisplayString)(_ctx.$t("noAct")), 1),
                        (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_40, (0, $8POXm.toDisplayString)(_ctx.$t("signif")), 1),
                        (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_41, (0, $8POXm.toDisplayString)(_ctx.$t("effect")), 1),
                        (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_42, (0, $8POXm.toDisplayString)(_ctx.$t("notFirst")), 1),
                        (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_43, (0, $8POXm.toDisplayString)(_ctx.$t("changeToLifeCycle")), 1),
                        $ca20824015081bd7$var$_hoisted_44,
                        $ca20824015081bd7$var$_hoisted_45
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.lifeCycleActivities, (lifeCycleActivity, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_46, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeLifeCycleActivity(i)
                                }, null, 8, $ca20824015081bd7$var$_hoisted_47)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "activityId_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.activityId = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $ca20824015081bd7$var$_hoisted_49, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.activityList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.activityList, (activity, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: activity.id
                                        }, (0, $8POXm.toDisplayString)($options.getActivityName(activity)), 9, $ca20824015081bd7$var$_hoisted_50);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $ca20824015081bd7$var$_hoisted_48), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        lifeCycleActivity.activityId
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.minAge = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "minAge_" + i
                                }, null, 8, $ca20824015081bd7$var$_hoisted_51), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        lifeCycleActivity.minAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.maxAge = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "maxAge_" + i
                                }, null, 8, $ca20824015081bd7$var$_hoisted_52), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        lifeCycleActivity.maxAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.noAct = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "noAct_" + i
                                }, null, 8, $ca20824015081bd7$var$_hoisted_53), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        lifeCycleActivity.noAct
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.significant = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "significant_" + i
                                }, null, 8, $ca20824015081bd7$var$_hoisted_54), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        lifeCycleActivity.significant
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_55, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        "onUpdate:modelValue": ($event)=>lifeCycleActivity.effect = $event,
                                        type: "number",
                                        class: "form-control",
                                        id: "effect_" + i
                                    }, null, 8, $ca20824015081bd7$var$_hoisted_56), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            lifeCycleActivity.effect
                                        ]
                                    ]),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        id: "effecttype_" + i,
                                        class: "form-select",
                                        "onUpdate:modelValue": ($event)=>lifeCycleActivity.effectType = $event
                                    }, [
                                        (0, $TusQn.createElementVNode)("option", $ca20824015081bd7$var$_hoisted_58, (0, $8POXm.toDisplayString)(_ctx.$t("Absolute")), 1),
                                        (0, $TusQn.createElementVNode)("option", $ca20824015081bd7$var$_hoisted_59, (0, $8POXm.toDisplayString)(_ctx.$t("Relative")), 1),
                                        (0, $TusQn.createElementVNode)("option", $ca20824015081bd7$var$_hoisted_60, (0, $8POXm.toDisplayString)(_ctx.$t("Differential")), 1)
                                    ], 8, $ca20824015081bd7$var$_hoisted_57), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            lifeCycleActivity.effectType
                                        ]
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_61, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event)=>lifeCycleActivity.notFirst = $event,
                                        id: "notFirst_" + i
                                    }, null, 8, $ca20824015081bd7$var$_hoisted_62), [
                                        [
                                            (0, $eeJ70.vModelCheckbox),
                                            lifeCycleActivity.notFirst
                                        ]
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "changeToLifecycleId_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>lifeCycleActivity.changeToLifecycleId = $event
                                }, [
                                    $ca20824015081bd7$var$_hoisted_64,
                                    $data.lifeCycleList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.lifeCycleList, (lifeCycle, o)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: o,
                                            value: lifeCycle.id
                                        }, (0, $8POXm.toDisplayString)(lifeCycle.name), 9, $ca20824015081bd7$var$_hoisted_65);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $ca20824015081bd7$var$_hoisted_63), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        lifeCycleActivity.changeToLifecycleId
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                i < $data.data.lifeCycleActivities.length - 1 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("i", {
                                    key: 0,
                                    class: "fa fa-arrow-down",
                                    onClick: ($event)=>$options.moveActivityDown(i)
                                }, null, 8, $ca20824015081bd7$var$_hoisted_66)) : (0, $TusQn.createCommentVNode)("", true)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                i != 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("i", {
                                    key: 0,
                                    class: "fa fa-arrow-up",
                                    onClick: ($event)=>$options.moveActivityUp(i)
                                }, null, 8, $ca20824015081bd7$var$_hoisted_67)) : (0, $TusQn.createCommentVNode)("", true)
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[6] || (_cache[6] = (...args)=>$options.addLifeCycleActivity && $options.addLifeCycleActivity(...args))
            }, $ca20824015081bd7$var$_hoisted_69)
        ]),
        (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_70, [
            (0, $TusQn.createElementVNode)("h4", $ca20824015081bd7$var$_hoisted_71, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycleFilters")), 1),
            (0, $TusQn.createElementVNode)("table", $ca20824015081bd7$var$_hoisted_72, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $ca20824015081bd7$var$_hoisted_73,
                        (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_74, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_75, (0, $8POXm.toDisplayString)(_ctx.$t("sign")), 1),
                        (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_76, (0, $8POXm.toDisplayString)(_ctx.$t("number")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.lifeCycleFilters, (lifeCycleFilter, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $ca20824015081bd7$var$_hoisted_77, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeLifeCycleFilter(i)
                                }, null, 8, $ca20824015081bd7$var$_hoisted_78)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "name_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>lifeCycleFilter.name = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $ca20824015081bd7$var$_hoisted_80, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $ca20824015081bd7$var$_hoisted_81);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $ca20824015081bd7$var$_hoisted_79), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        lifeCycleFilter.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleFilter.sign = $event,
                                    class: "form-select",
                                    id: "sign_" + i
                                }, $ca20824015081bd7$var$_hoisted_88, 8, $ca20824015081bd7$var$_hoisted_82), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        lifeCycleFilter.sign
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>lifeCycleFilter.number = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "number_" + i
                                }, null, 8, $ca20824015081bd7$var$_hoisted_89), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        lifeCycleFilter.number
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[7] || (_cache[7] = (...args)=>$options.addLifeCycleFilter && $options.addLifeCycleFilter(...args))
            }, $ca20824015081bd7$var$_hoisted_91)
        ]),
        (0, $TusQn.createElementVNode)("div", $ca20824015081bd7$var$_hoisted_92, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[8] || (_cache[8] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[9] || (_cache[9] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("eOX7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $aca3971cf10b7d0d$export$2e2bcd8739ae039);
let $aca3971cf10b7d0d$var$NOOP = ()=>{};
var $aca3971cf10b7d0d$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("lbdCn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f6b5305234610062$export$2e2bcd8739ae039);

var $j9vnd = parcelRequire("j9vnd");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $l6otV = parcelRequire("l6otV");

var $3Le0i = parcelRequire("3Le0i");

var $3Wfig = parcelRequire("3Wfig");

var $gOjKo = parcelRequire("gOjKo");
var $f6b5305234610062$export$2e2bcd8739ae039 = {
    name: "benefitDetail",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    components: {
        BenefitDeleteModal: $3Le0i.default,
        BenefitCalculationModal: $3Wfig.default
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var modelingInfo = await (0, $l6otV.default).modelingInfo(this.$route.params.id);
            for(var i in modelingInfo.selections){
                var selection = modelingInfo.selections[i];
                for(var o in selection.packages){
                    var selectionPackage = selection.packages[o];
                    var exists = selectionPackage.lifeCycles.find((lifeCycle)=>lifeCycle.benefitId == this.$route.params.benefitId);
                    if (exists) this.foundBenefits.push({
                        selectionId: selection.id,
                        selectionPackageId: selectionPackage.id,
                        name: "Selection - " + selection.name + " - " + selectionPackage.name
                    });
                }
            }
            this.data = await (0, $j9vnd.default).benefitDetail(this.$route.params.id, this.$route.params.benefitId);
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            for(var i in this.data.benefitAttributes){
                var attr = this.data.benefitAttributes[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr.name) < 0 && this.missingDatasetHeaders.findIndex((d)=>d.name == attr.name) < 0) this.missingDatasetHeaders.push({
                    name: attr.name,
                    alias: attr.name
                });
            }
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                await (0, $j9vnd.default).benefitUpdate(this.$route.params.id, this.data);
                if (!this.isFormValid()) this.showWarning();
                else this.showSuccess();
            } else this.showEmptyNameError();
        },
        isFormValid () {
            for(var i in this.data.benefitAttributes){
                var attr = this.data.benefitAttributes[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr.name) < 0 || attr.name == "") return false;
            }
            return true;
        },
        addBenefitAttribute () {
            this.data.benefitAttributes.push({
                name: "",
                biggerMoreBenefit: false,
                weight: 0
            });
        },
        removeBenefitAttribute (rowIndex) {
            this.data.benefitAttributes.splice(rowIndex, 1);
        },
        showDeleteBenefit () {
            this.benefitToDeleteId = this.data.id;
            this.showBenefitDeleteModal = true;
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "benefitUpdated",
            type: "success"
        },
        showWarning: {
            title: "warning",
            message: "warningAttributeRemoved",
            type: "warn"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            datasetHeaders: [],
            missingDatasetHeaders: [],
            data: {
                name: "",
                benefitAttributes: [
                    {
                        name: "",
                        weight: 0,
                        biggerMoreBenefit: false
                    }
                ],
                id: 0
            },
            benefitToDeleteId: 0,
            showBenefitDeleteModal: false,
            showBenefitCalculationModal: false,
            modelingName: null,
            assetTypeName: null,
            pending: true,
            foundBenefits: [],
            isUserAdmin: false
        };
    }
};

});
parcelRegister("3Le0i", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bd09fbe3cd9635f$export$2e2bcd8739ae039);
let $2bd09fbe3cd9635f$var$script;



let $2bd09fbe3cd9635f$var$initialize = ()=>{
    $2bd09fbe3cd9635f$var$script = (parcelRequire("3dcHz"));
    if ($2bd09fbe3cd9635f$var$script.__esModule) $2bd09fbe3cd9635f$var$script = $2bd09fbe3cd9635f$var$script.default;
    $2bd09fbe3cd9635f$var$script.render = (parcelRequire("i1z8B")).render;
    (parcelRequire("dhuOw")).default($2bd09fbe3cd9635f$var$script);
    $2bd09fbe3cd9635f$var$script.__scopeId = "data-v-bac3fa";
    $2bd09fbe3cd9635f$var$script.__file = "BenefitDeleteModal.vue";
};
$2bd09fbe3cd9635f$var$initialize();
var $2bd09fbe3cd9635f$export$2e2bcd8739ae039 = $2bd09fbe3cd9635f$var$script;

});
parcelRegister("3dcHz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $256c70505f072f5e$export$2e2bcd8739ae039);

var $j9vnd = parcelRequire("j9vnd");
var $256c70505f072f5e$export$2e2bcd8739ae039 = {
    name: "benefitDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteBenefit () {
            await (0, $j9vnd.default).benefitDelete(this.$parent.$route.params.id, this.$parent.benefitToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("i1z8B", function(module, exports) {

$parcel$export(module.exports, "render", () => $d1f3939877971d87$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $d1f3939877971d87$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $d1f3939877971d87$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $d1f3939877971d87$var$_hoisted_3 = {
    class: "modal-content"
};
const $d1f3939877971d87$var$_hoisted_4 = {
    class: "modal-header"
};
const $d1f3939877971d87$var$_hoisted_5 = {
    class: "modal-title"
};
const $d1f3939877971d87$var$_hoisted_6 = {
    class: "modal-body"
};
const $d1f3939877971d87$var$_hoisted_7 = {
    class: "form-label"
};
const $d1f3939877971d87$var$_hoisted_8 = {
    key: 1
};
const $d1f3939877971d87$var$_hoisted_9 = {
    class: "modal-footer"
};
const $d1f3939877971d87$var$_hoisted_10 = [
    "disabled"
];
function $d1f3939877971d87$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $d1f3939877971d87$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $d1f3939877971d87$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $d1f3939877971d87$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $d1f3939877971d87$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $d1f3939877971d87$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("benefitDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $d1f3939877971d87$var$_hoisted_6, [
                                this.$parent.foundBenefits.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 0
                                }, [
                                    (0, $TusQn.createElementVNode)("label", $d1f3939877971d87$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("cannotDeleteBenefit")), 1),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(this.$parent.foundBenefits, (benefit, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                            key: i
                                        }, [
                                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                                to: "/modeling/" + this.$route.params.id + "/selection/" + benefit.selectionId + "/package/" + benefit.selectionPackageId
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(benefit.name), 1)
                                                    ]),
                                                _: 2
                                            }, 1032, [
                                                "to"
                                            ])
                                        ]);
                                    }), 128))
                                ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $d1f3939877971d87$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisBenefit")), 1))
                            ]),
                            (0, $TusQn.createElementVNode)("div", $d1f3939877971d87$var$_hoisted_9, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteBenefit && $options.deleteBenefit(...args)),
                                    disabled: this.$parent.foundBenefits.length > 0
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 9, $d1f3939877971d87$var$_hoisted_10)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("dhuOw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ab4c3dd5e46ac90$export$2e2bcd8739ae039);
let $9ab4c3dd5e46ac90$var$NOOP = ()=>{};
var $9ab4c3dd5e46ac90$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("3Wfig", function(module, exports) {

$parcel$export(module.exports, "default", () => $2de2a6d7a8187c05$export$2e2bcd8739ae039);
let $2de2a6d7a8187c05$var$script;



let $2de2a6d7a8187c05$var$initialize = ()=>{
    $2de2a6d7a8187c05$var$script = (parcelRequire("hhhGb"));
    if ($2de2a6d7a8187c05$var$script.__esModule) $2de2a6d7a8187c05$var$script = $2de2a6d7a8187c05$var$script.default;
    $2de2a6d7a8187c05$var$script.render = (parcelRequire("1JOcl")).render;
    (parcelRequire("7QJOH")).default($2de2a6d7a8187c05$var$script);
    $2de2a6d7a8187c05$var$script.__scopeId = "data-v-0b9cd0";
    $2de2a6d7a8187c05$var$script.__file = "BenefitCalculationModal.vue";
};
$2de2a6d7a8187c05$var$initialize();
var $2de2a6d7a8187c05$export$2e2bcd8739ae039 = $2de2a6d7a8187c05$var$script;

});
parcelRegister("hhhGb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c941bcf6787c5a9d$export$2e2bcd8739ae039);

var $fihz0 = parcelRequire("fihz0");

var $bfIrw = parcelRequire("bfIrw");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");
(0, $fihz0.default).use((0, $bfIrw.default));
var $c941bcf6787c5a9d$export$2e2bcd8739ae039 = {
    name: "benefitCalculationModal",
    mounted () {
        this.fetchData();
    },
    components: {
        DataTable: $fihz0.default
    },
    methods: {
        async fetchData () {
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$parent.$route.params.id, this.$parent.$route.params.assetTypeId);
            var datasetRecords = await (0, $ch9iu.default).datasetSections(this.$parent.$route.params.id, assetType.datasetId);
            this.data = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            if (this.data.content) {
                this.content = JSON.parse(this.data.content);
                this.tableColumns = [];
                if (this.content.headers) this.tableColumns = this.content.headers.map((h)=>({
                        data: h.name,
                        title: this.$t(h.alias),
                        defaultContent: "",
                        width: 100
                    }));
            }
            this.tableData = datasetRecords.map((s)=>s["properties"]);
            this.tableColumns.unshift({
                data: "BENEFIT",
                title: this.$t("benefit"),
                defaultContent: "",
                width: 100
            });
            var minMaxValues = {};
            for(var i in this.$parent.data.benefitAttributes){
                var attribute = this.$parent.data.benefitAttributes[i];
                var attributeValues = [];
                for(var i in datasetRecords){
                    var datasetRecord = datasetRecords[i];
                    var validProp = datasetRecord.properties[assetType.assetAttribute];
                    // If assetAttribute not number skip
                    if (!Number(validProp)) continue;
                    var datasetprop = datasetRecord.properties[attribute.name?.toUpperCase()];
                    attributeValues.push(datasetprop);
                }
                minMaxValues[attribute.name?.toUpperCase()] = {
                    minMaxValues: attributeValues,
                    biggerMoreBenefit: attribute.biggerMoreBenefit,
                    weight: attribute.weight
                };
            }
            for(var i in this.tableData){
                var data = this.tableData[i];
                var validProp = data[assetType.assetAttribute];
                // If assetAttribute not number skip
                if (!Number(validProp)) continue;
                var result = this.valuateCalculationResult(minMaxValues, data);
                data["BENEFIT"] = result;
            }
            this.tableDataLoaded = true;
        },
        close () {
            this.$emit("closeDeleteDialog");
        },
        valuateCalculationResult (values, data) {
            var benefitSum = 0;
            var benefitKoefSum = 0;
            for(var i in values){
                var attribute = values[i];
                var attrMinValue = Math.min(...attribute.minMaxValues);
                var attrMaxValue = Math.max(...attribute.minMaxValues);
                var scale = attrMaxValue - attrMinValue;
                if (scale > 0) {
                    var value = data[i];
                    if (attribute.biggerMoreBenefit) {
                        var k = (value - attrMinValue) / scale;
                        benefitSum += attribute.weight;
                        benefitKoefSum += k * attribute.weight;
                    } else {
                        var k = (attrMaxValue - value) / scale;
                        benefitSum += attribute.weight;
                        benefitKoefSum += k * attribute.weight;
                    }
                }
            }
            if (benefitSum > 0) return benefitKoefSum / benefitSum;
        }
    },
    data () {
        return {
            benefitAttributes: [],
            testingSection1: 0,
            testingSection2: 0,
            tableColumns: [],
            tableData: [],
            tableOptions: {
                fixedHeader: {
                    header: false,
                    footer: true
                },
                scrollX: true,
                scrollY: 350,
                order: [
                    0,
                    "desc"
                ]
            },
            tableDataLoaded: false
        };
    }
};

});

parcelRegister("1JOcl", function(module, exports) {

$parcel$export(module.exports, "render", () => $1440eeb1f5c5bceb$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $1440eeb1f5c5bceb$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $1440eeb1f5c5bceb$var$_hoisted_2 = {
    class: "modal-dialog modal-xl modal-dialog-centered",
    role: "document"
};
const $1440eeb1f5c5bceb$var$_hoisted_3 = {
    class: "modal-content",
    style: {
        "width": "1000px"
    }
};
const $1440eeb1f5c5bceb$var$_hoisted_4 = {
    class: "modal-header"
};
const $1440eeb1f5c5bceb$var$_hoisted_5 = {
    class: "modal-title"
};
const $1440eeb1f5c5bceb$var$_hoisted_6 = {
    class: "modal-body"
};
const $1440eeb1f5c5bceb$var$_hoisted_7 = {
    key: 0,
    style: {
        "width": "100%"
    }
};
const $1440eeb1f5c5bceb$var$_hoisted_8 = {
    key: 1,
    class: "d-flex justify-content-center"
};
const $1440eeb1f5c5bceb$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "spinner-border",
    role: "status"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
        class: "sr-only"
    }, "Loading...")
], -1);
const $1440eeb1f5c5bceb$var$_hoisted_10 = [
    $1440eeb1f5c5bceb$var$_hoisted_9
];
const $1440eeb1f5c5bceb$var$_hoisted_11 = {
    class: "modal-footer"
};
function $1440eeb1f5c5bceb$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DataTable = (0, $TusQn.resolveComponent)("DataTable");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $1440eeb1f5c5bceb$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $1440eeb1f5c5bceb$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $1440eeb1f5c5bceb$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $1440eeb1f5c5bceb$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $1440eeb1f5c5bceb$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("benefitSpecification")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $1440eeb1f5c5bceb$var$_hoisted_6, [
                                $data.tableDataLoaded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1440eeb1f5c5bceb$var$_hoisted_7, [
                                    (0, $TusQn.createVNode)(_component_DataTable, {
                                        pageLength: 5,
                                        lengthMenu: [
                                            5,
                                            25,
                                            50,
                                            75,
                                            100
                                        ],
                                        columns: $data.tableColumns,
                                        data: $data.tableData,
                                        options: $data.tableOptions,
                                        class: "display"
                                    }, null, 8, [
                                        "columns",
                                        "data",
                                        "options"
                                    ])
                                ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1440eeb1f5c5bceb$var$_hoisted_8, $1440eeb1f5c5bceb$var$_hoisted_10))
                            ]),
                            (0, $TusQn.createElementVNode)("div", $1440eeb1f5c5bceb$var$_hoisted_11, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("7QJOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b70edf5ea02a153$export$2e2bcd8739ae039);
let $5b70edf5ea02a153$var$NOOP = ()=>{};
var $5b70edf5ea02a153$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("cdZSC", function(module, exports) {

$parcel$export(module.exports, "render", () => $8e66b3007cbea95e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $8e66b3007cbea95e$var$_hoisted_1 = {
    key: 0
};
const $8e66b3007cbea95e$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $8e66b3007cbea95e$var$_hoisted_3 = [
    $8e66b3007cbea95e$var$_hoisted_2
];
const $8e66b3007cbea95e$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $8e66b3007cbea95e$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $8e66b3007cbea95e$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $8e66b3007cbea95e$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $8e66b3007cbea95e$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $8e66b3007cbea95e$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $8e66b3007cbea95e$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $8e66b3007cbea95e$var$_hoisted_11 = {
    class: "row mb-4"
};
const $8e66b3007cbea95e$var$_hoisted_12 = {
    class: "mb-3 col-md-4"
};
const $8e66b3007cbea95e$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $8e66b3007cbea95e$var$_hoisted_14 = {
    class: "mb-3 col-md-8"
};
const $8e66b3007cbea95e$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $8e66b3007cbea95e$var$_hoisted_16 = {
    class: "mb-4"
};
const $8e66b3007cbea95e$var$_hoisted_17 = {
    class: "table"
};
const $8e66b3007cbea95e$var$_hoisted_18 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $8e66b3007cbea95e$var$_hoisted_19 = {
    scope: "col"
};
const $8e66b3007cbea95e$var$_hoisted_20 = {
    scope: "col"
};
const $8e66b3007cbea95e$var$_hoisted_21 = {
    scope: "col"
};
const $8e66b3007cbea95e$var$_hoisted_22 = {
    scope: "row"
};
const $8e66b3007cbea95e$var$_hoisted_23 = [
    "onClick"
];
const $8e66b3007cbea95e$var$_hoisted_24 = [
    "onUpdate:modelValue",
    "aria-placeholder"
];
const $8e66b3007cbea95e$var$_hoisted_25 = {
    disabled: ""
};
const $8e66b3007cbea95e$var$_hoisted_26 = [
    "value"
];
const $8e66b3007cbea95e$var$_hoisted_27 = [
    "value"
];
const $8e66b3007cbea95e$var$_hoisted_28 = [
    "onUpdate:modelValue",
    "id"
];
const $8e66b3007cbea95e$var$_hoisted_29 = {
    class: "form-check"
};
const $8e66b3007cbea95e$var$_hoisted_30 = [
    "onUpdate:modelValue",
    "id"
];
const $8e66b3007cbea95e$var$_hoisted_31 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $8e66b3007cbea95e$var$_hoisted_32 = [
    $8e66b3007cbea95e$var$_hoisted_31
];
const $8e66b3007cbea95e$var$_hoisted_33 = {
    class: "d-grid gap-2 d-md-flex"
};
function $8e66b3007cbea95e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_BenefitDeleteModal = (0, $TusQn.resolveComponent)("BenefitDeleteModal");
    const _component_BenefitCalculationModal = (0, $TusQn.resolveComponent)("BenefitCalculationModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8e66b3007cbea95e$var$_hoisted_1, $8e66b3007cbea95e$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8e66b3007cbea95e$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("benefitDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $8e66b3007cbea95e$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $8e66b3007cbea95e$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $8e66b3007cbea95e$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $8e66b3007cbea95e$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $8e66b3007cbea95e$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $8e66b3007cbea95e$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $8e66b3007cbea95e$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $8e66b3007cbea95e$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $8e66b3007cbea95e$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $8e66b3007cbea95e$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $8e66b3007cbea95e$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            class: "fa fa-table btn btn-outline-primary float-end",
            onClick: _cache[2] || (_cache[2] = ($event)=>$data.showBenefitCalculationModal = true)
        }),
        (0, $TusQn.createElementVNode)("div", $8e66b3007cbea95e$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("benefitAttributes")), 1),
            (0, $TusQn.createElementVNode)("table", $8e66b3007cbea95e$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $8e66b3007cbea95e$var$_hoisted_18,
                        (0, $TusQn.createElementVNode)("th", $8e66b3007cbea95e$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $8e66b3007cbea95e$var$_hoisted_20, (0, $8POXm.toDisplayString)(_ctx.$t("weight")), 1),
                        (0, $TusQn.createElementVNode)("th", $8e66b3007cbea95e$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("biggerMoreBenefit")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.benefitAttributes, (benefitAttribute, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $8e66b3007cbea95e$var$_hoisted_22, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeBenefitAttribute(i)
                                }, null, 8, $8e66b3007cbea95e$var$_hoisted_23)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>benefitAttribute.name = $event,
                                    "aria-placeholder": benefitAttribute.name
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $8e66b3007cbea95e$var$_hoisted_25, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $8e66b3007cbea95e$var$_hoisted_26);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                                    $data.missingDatasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 1
                                    }, (0, $TusQn.renderList)($data.missingDatasetHeaders, (missingDatasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            disabled: "",
                                            value: missingDatasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(missingDatasetHeader.alias), 9, $8e66b3007cbea95e$var$_hoisted_27);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $8e66b3007cbea95e$var$_hoisted_24), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        benefitAttribute.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>benefitAttribute.weight = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "weight_" + i
                                }, null, 8, $8e66b3007cbea95e$var$_hoisted_28), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        benefitAttribute.weight
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.createElementVNode)("div", $8e66b3007cbea95e$var$_hoisted_29, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event)=>benefitAttribute.biggerMoreBenefit = $event,
                                        id: "biggerMoreBenefit_" + i,
                                        checked: ""
                                    }, null, 8, $8e66b3007cbea95e$var$_hoisted_30), [
                                        [
                                            (0, $eeJ70.vModelCheckbox),
                                            benefitAttribute.biggerMoreBenefit
                                        ]
                                    ])
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[3] || (_cache[3] = (...args)=>$options.addBenefitAttribute && $options.addBenefitAttribute(...args))
            }, $8e66b3007cbea95e$var$_hoisted_32)
        ]),
        (0, $TusQn.createElementVNode)("div", $8e66b3007cbea95e$var$_hoisted_33, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[4] || (_cache[4] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[5] || (_cache[5] = (...args)=>$options.showDeleteBenefit && $options.showDeleteBenefit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[6] || (_cache[6] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showBenefitDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_BenefitDeleteModal, {
            key: 0,
            onReload: _cache[7] || (_cache[7] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                })),
            onCloseDeleteDialog: _cache[8] || (_cache[8] = ($event)=>$data.showBenefitDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true),
        $data.showBenefitCalculationModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_BenefitCalculationModal, {
            key: 1,
            onCloseDeleteDialog: _cache[9] || (_cache[9] = ($event)=>$data.showBenefitCalculationModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("5IkEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $42911462e83cf100$export$2e2bcd8739ae039);
let $42911462e83cf100$var$NOOP = ()=>{};
var $42911462e83cf100$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("g6dfm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bb877b64b02cd7e1$export$2e2bcd8739ae039);

var $j9vnd = parcelRequire("j9vnd");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $l6otV = parcelRequire("l6otV");
var $bb877b64b02cd7e1$export$2e2bcd8739ae039 = {
    name: "benefitCreate",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                this.data.assetTypeId = this.$route.params.assetTypeId;
                await (0, $j9vnd.default).benefitCreate(this.$route.params.id, this.data);
                this.$router.go(-1);
            } else this.showEmptyNameError();
        },
        addBenefitAttribute () {
            this.data.benefitAttributes.push({
                name: "",
                biggerMoreBenefit: false,
                weight: 0
            });
        },
        removeBenefitAttribute (rowIndex) {
            this.data.benefitAttributes.splice(rowIndex, 1);
        }
    },
    data () {
        return {
            datasetHeaders: [],
            data: {
                name: "",
                benefitAttributes: [
                    {
                        name: "",
                        weight: 0,
                        biggerMoreBenefit: false
                    }
                ],
                id: 0
            },
            modelingName: null,
            assetTypeName: null,
            pending: true
        };
    },
    notifications: {
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    }
};

});

parcelRegister("juKJr", function(module, exports) {

$parcel$export(module.exports, "render", () => $e31511ab2c1caab7$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $e31511ab2c1caab7$var$_hoisted_1 = {
    key: 0
};
const $e31511ab2c1caab7$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $e31511ab2c1caab7$var$_hoisted_3 = [
    $e31511ab2c1caab7$var$_hoisted_2
];
const $e31511ab2c1caab7$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $e31511ab2c1caab7$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $e31511ab2c1caab7$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $e31511ab2c1caab7$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $e31511ab2c1caab7$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $e31511ab2c1caab7$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $e31511ab2c1caab7$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $e31511ab2c1caab7$var$_hoisted_11 = {
    class: "row mb-4"
};
const $e31511ab2c1caab7$var$_hoisted_12 = {
    class: "mb-3 col-md-4"
};
const $e31511ab2c1caab7$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $e31511ab2c1caab7$var$_hoisted_14 = {
    class: "mb-3 col-md-8"
};
const $e31511ab2c1caab7$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $e31511ab2c1caab7$var$_hoisted_16 = {
    class: "mb-4"
};
const $e31511ab2c1caab7$var$_hoisted_17 = {
    class: "table"
};
const $e31511ab2c1caab7$var$_hoisted_18 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $e31511ab2c1caab7$var$_hoisted_19 = {
    scope: "col"
};
const $e31511ab2c1caab7$var$_hoisted_20 = {
    scope: "col"
};
const $e31511ab2c1caab7$var$_hoisted_21 = {
    scope: "col"
};
const $e31511ab2c1caab7$var$_hoisted_22 = {
    scope: "row"
};
const $e31511ab2c1caab7$var$_hoisted_23 = [
    "onClick"
];
const $e31511ab2c1caab7$var$_hoisted_24 = [
    "onUpdate:modelValue"
];
const $e31511ab2c1caab7$var$_hoisted_25 = {
    disabled: ""
};
const $e31511ab2c1caab7$var$_hoisted_26 = [
    "value"
];
const $e31511ab2c1caab7$var$_hoisted_27 = [
    "onUpdate:modelValue",
    "id"
];
const $e31511ab2c1caab7$var$_hoisted_28 = {
    class: "form-check"
};
const $e31511ab2c1caab7$var$_hoisted_29 = [
    "onUpdate:modelValue",
    "id"
];
const $e31511ab2c1caab7$var$_hoisted_30 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $e31511ab2c1caab7$var$_hoisted_31 = [
    $e31511ab2c1caab7$var$_hoisted_30
];
const $e31511ab2c1caab7$var$_hoisted_32 = {
    class: "d-grid gap-2 d-md-flex"
};
function $e31511ab2c1caab7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e31511ab2c1caab7$var$_hoisted_1, $e31511ab2c1caab7$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e31511ab2c1caab7$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("benefitCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $e31511ab2c1caab7$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $e31511ab2c1caab7$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $e31511ab2c1caab7$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $e31511ab2c1caab7$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $e31511ab2c1caab7$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $e31511ab2c1caab7$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("benefitCreate")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $e31511ab2c1caab7$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $e31511ab2c1caab7$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $e31511ab2c1caab7$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $e31511ab2c1caab7$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $e31511ab2c1caab7$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $e31511ab2c1caab7$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("benefitAttributes")), 1),
            (0, $TusQn.createElementVNode)("table", $e31511ab2c1caab7$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $e31511ab2c1caab7$var$_hoisted_18,
                        (0, $TusQn.createElementVNode)("th", $e31511ab2c1caab7$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $e31511ab2c1caab7$var$_hoisted_20, (0, $8POXm.toDisplayString)(_ctx.$t("weight")), 1),
                        (0, $TusQn.createElementVNode)("th", $e31511ab2c1caab7$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("biggerMoreBenefit")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.benefitAttributes, (benefitAttribute, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $e31511ab2c1caab7$var$_hoisted_22, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeBenefitAttribute(i)
                                }, null, 8, $e31511ab2c1caab7$var$_hoisted_23)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>benefitAttribute.name = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $e31511ab2c1caab7$var$_hoisted_25, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $e31511ab2c1caab7$var$_hoisted_26);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $e31511ab2c1caab7$var$_hoisted_24), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        benefitAttribute.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>benefitAttribute.weight = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "weight_" + i
                                }, null, 8, $e31511ab2c1caab7$var$_hoisted_27), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        benefitAttribute.weight
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.createElementVNode)("div", $e31511ab2c1caab7$var$_hoisted_28, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event)=>benefitAttribute.biggerMoreBenefit = $event,
                                        id: "biggerMoreBenefit_" + i,
                                        checked: ""
                                    }, null, 8, $e31511ab2c1caab7$var$_hoisted_29), [
                                        [
                                            (0, $eeJ70.vModelCheckbox),
                                            benefitAttribute.biggerMoreBenefit
                                        ]
                                    ])
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[2] || (_cache[2] = (...args)=>$options.addBenefitAttribute && $options.addBenefitAttribute(...args))
            }, $e31511ab2c1caab7$var$_hoisted_31)
        ]),
        (0, $TusQn.createElementVNode)("div", $e31511ab2c1caab7$var$_hoisted_32, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[3] || (_cache[3] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("1RkLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $15aadac67b14bd09$export$2e2bcd8739ae039);
let $15aadac67b14bd09$var$NOOP = ()=>{};
var $15aadac67b14bd09$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("7nO4i", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $560184e31a035a07$export$2e2bcd8739ae039);

var $bpHT7 = parcelRequire("bpHT7");
var $560184e31a035a07$export$2e2bcd8739ae039 = {
    methods: {
        async onSubmit () {
            this.model.domain = "";
            let group = await (0, $bpHT7.default).create(this.model);
            this.$router.push({
                name: "groupdetail",
                params: {
                    id: group.id
                }
            });
        }
    },
    data () {
        return {
            model: {
                name: ""
            }
        };
    }
};

});

parcelRegister("b2pYX", function(module, exports) {

$parcel$export(module.exports, "render", () => $8094092328c84827$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $8094092328c84827$var$_hoisted_1 = {
    class: "container py-5"
};
const $8094092328c84827$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $8094092328c84827$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $8094092328c84827$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $8094092328c84827$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $8094092328c84827$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $8094092328c84827$var$_hoisted_7 = {
    class: "mb-3 col-md-4"
};
const $8094092328c84827$var$_hoisted_8 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $8094092328c84827$var$_hoisted_9 = [
    "placeholder"
];
function $8094092328c84827$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8094092328c84827$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("groupCreation")), 1),
        (0, $TusQn.createElementVNode)("nav", $8094092328c84827$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $8094092328c84827$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $8094092328c84827$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modelings"
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $8094092328c84827$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/groups"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $8094092328c84827$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $8094092328c84827$var$_hoisted_7, [
            (0, $TusQn.createElementVNode)("label", $8094092328c84827$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.model.name = $event),
                type: "text",
                class: "form-control",
                id: "name",
                placeholder: _ctx.$t("enterGroupName")
            }, null, 8, $8094092328c84827$var$_hoisted_9), [
                [
                    (0, $eeJ70.vModelText),
                    $data.model.name
                ]
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[1] || (_cache[1] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
        }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
    ]);
}

});

parcelRegister("2HPgC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f875d8033845ab5$export$2e2bcd8739ae039);
let $1f875d8033845ab5$var$NOOP = ()=>{};
var $1f875d8033845ab5$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("8SDMh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $677238e3229860f5$export$2e2bcd8739ae039);

var $bpHT7 = parcelRequire("bpHT7");
var $677238e3229860f5$export$2e2bcd8739ae039 = {
    name: "groupdetail",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async saveGroup () {
            await (0, $bpHT7.default).update(this.data);
            this.showSuccess();
        },
        async requestData () {
            this.data = await (0, $bpHT7.default).detail(this.$route.params.id);
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "groupUpdated",
            type: "success"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: ""
            }
        };
    }
};

});

parcelRegister("kkOwD", function(module, exports) {

$parcel$export(module.exports, "render", () => $ecdcde35bc17306e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $ecdcde35bc17306e$var$_hoisted_1 = {
    class: "container py-5"
};
const $ecdcde35bc17306e$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $ecdcde35bc17306e$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $ecdcde35bc17306e$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $ecdcde35bc17306e$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $ecdcde35bc17306e$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $ecdcde35bc17306e$var$_hoisted_7 = {
    class: "row mb-3"
};
const $ecdcde35bc17306e$var$_hoisted_8 = {
    class: "col-md-6"
};
const $ecdcde35bc17306e$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "form-label"
}, "Id", -1);
const $ecdcde35bc17306e$var$_hoisted_10 = {
    class: "row mb-3"
};
const $ecdcde35bc17306e$var$_hoisted_11 = {
    class: "col-md-6"
};
const $ecdcde35bc17306e$var$_hoisted_12 = {
    class: "form-label"
};
function $ecdcde35bc17306e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $ecdcde35bc17306e$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("groupDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $ecdcde35bc17306e$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $ecdcde35bc17306e$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $ecdcde35bc17306e$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modelings"
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $ecdcde35bc17306e$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/groups"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $ecdcde35bc17306e$var$_hoisted_6, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $ecdcde35bc17306e$var$_hoisted_7, [
            (0, $TusQn.createElementVNode)("div", $ecdcde35bc17306e$var$_hoisted_8, [
                $ecdcde35bc17306e$var$_hoisted_9,
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    disabled: "",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.id = $event)
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.id
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $ecdcde35bc17306e$var$_hoisted_10, [
            (0, $TusQn.createElementVNode)("div", $ecdcde35bc17306e$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("label", $ecdcde35bc17306e$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.name = $event)
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = (...args)=>$options.saveGroup && $options.saveGroup(...args))
        }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1)
    ]);
}

});

parcelRegister("9rJHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e0a15fc998ae960$export$2e2bcd8739ae039);
let $6e0a15fc998ae960$var$NOOP = ()=>{};
var $6e0a15fc998ae960$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("2OxhC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $20ca11a45b12f159$export$2e2bcd8739ae039);

var $bpHT7 = parcelRequire("bpHT7");

var $hsNrV = parcelRequire("hsNrV");
var $20ca11a45b12f159$export$2e2bcd8739ae039 = {
    name: "groups",
    components: {
        GroupModal: $hsNrV.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.list = await (0, $bpHT7.default).list();
        },
        showDeleteGroupModal (item) {
            this.groupToDeleteId = item.id;
            this.groupToDeleteName = item.name;
            this.isModalVisible = true;
        }
    },
    data () {
        return {
            groupToDeleteId: "",
            groupToDeleteName: "",
            isModalVisible: false,
            list: []
        };
    }
};

});
parcelRegister("hsNrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6b68cbde55696b$export$2e2bcd8739ae039);
let $cb6b68cbde55696b$var$script;



let $cb6b68cbde55696b$var$initialize = ()=>{
    $cb6b68cbde55696b$var$script = (parcelRequire("iZL5G"));
    if ($cb6b68cbde55696b$var$script.__esModule) $cb6b68cbde55696b$var$script = $cb6b68cbde55696b$var$script.default;
    $cb6b68cbde55696b$var$script.render = (parcelRequire("4oL9q")).render;
    (parcelRequire("3Pyf8")).default($cb6b68cbde55696b$var$script);
    $cb6b68cbde55696b$var$script.__scopeId = "data-v-4ab927";
    $cb6b68cbde55696b$var$script.__file = "GroupDeleteModal.vue";
};
$cb6b68cbde55696b$var$initialize();
var $cb6b68cbde55696b$export$2e2bcd8739ae039 = $cb6b68cbde55696b$var$script;

});
parcelRegister("iZL5G", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $dd4273bdbdb03817$export$2e2bcd8739ae039);

var $bpHT7 = parcelRequire("bpHT7");
var $dd4273bdbdb03817$export$2e2bcd8739ae039 = {
    name: "groupDeleteModal",
    methods: {
        close () {
            this.$parent.isModalVisible = false;
        },
        async deleteGroup () {
            await (0, $bpHT7.default).delete(this.$parent.groupToDeleteId);
            this.close();
            this.$emit("reload");
        }
    }
};

});

parcelRegister("4oL9q", function(module, exports) {

$parcel$export(module.exports, "render", () => $333dfa83c6866616$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $333dfa83c6866616$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $333dfa83c6866616$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $333dfa83c6866616$var$_hoisted_3 = {
    class: "modal-content"
};
const $333dfa83c6866616$var$_hoisted_4 = {
    class: "modal-header"
};
const $333dfa83c6866616$var$_hoisted_5 = {
    class: "modal-title"
};
const $333dfa83c6866616$var$_hoisted_6 = {
    class: "modal-body"
};
const $333dfa83c6866616$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0"
    }
};
const $333dfa83c6866616$var$_hoisted_8 = {
    class: "modal-footer"
};
function $333dfa83c6866616$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $333dfa83c6866616$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $333dfa83c6866616$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $333dfa83c6866616$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $333dfa83c6866616$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $333dfa83c6866616$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("groupDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $333dfa83c6866616$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", $333dfa83c6866616$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisGroup")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $333dfa83c6866616$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteGroup && $options.deleteGroup(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("3Pyf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ca0b27aaf269279$export$2e2bcd8739ae039);
let $2ca0b27aaf269279$var$NOOP = ()=>{};
var $2ca0b27aaf269279$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("dSNeQ", function(module, exports) {

$parcel$export(module.exports, "render", () => $a1b68341ccaf2284$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $a1b68341ccaf2284$var$_hoisted_1 = {
    class: "table table-bordered table-responsive-md"
};
const $a1b68341ccaf2284$var$_hoisted_2 = {
    class: "text-center"
};
const $a1b68341ccaf2284$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-lg fa-plus"
}, null, -1);
const $a1b68341ccaf2284$var$_hoisted_4 = {
    key: 0
};
const $a1b68341ccaf2284$var$_hoisted_5 = [
    "onClick"
];
function $a1b68341ccaf2284$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_GroupModal = (0, $TusQn.resolveComponent)("GroupModal");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        (0, $TusQn.createElementVNode)("table", $a1b68341ccaf2284$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("thead", null, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.createElementVNode)("th", $a1b68341ccaf2284$var$_hoisted_2, [
                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("groups")) + " ", 1),
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            style: {
                                "float": "right"
                            },
                            to: {
                                name: "groupadd"
                            }
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    $a1b68341ccaf2284$var$_hoisted_3
                                ]),
                            _: 1
                        })
                    ])
                ])
            ]),
            $data.list.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $a1b68341ccaf2284$var$_hoisted_4, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.list, (item, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                        key: i
                    }, [
                        (0, $TusQn.createElementVNode)("td", null, [
                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                to: {
                                    name: "groupdetail",
                                    params: {
                                        id: item.id
                                    }
                                }
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                    ]),
                                _: 2
                            }, 1032, [
                                "to"
                            ]),
                            (0, $TusQn.createElementVNode)("i", {
                                style: {
                                    "float": "right",
                                    "padding-top": "10px",
                                    "cursor": "pointer"
                                },
                                onClick: ($event)=>$options.showDeleteGroupModal(item),
                                class: "fas fa-sm fa-trash"
                            }, null, 8, $a1b68341ccaf2284$var$_hoisted_5)
                        ])
                    ]);
                }), 128))
            ])) : (0, $TusQn.createCommentVNode)("", true)
        ]),
        $data.isModalVisible ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_GroupModal, {
            key: 0,
            onReload: $options.requestData
        }, null, 8, [
            "onReload"
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("bHQX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $885cc8d80190f4c8$export$2e2bcd8739ae039);
let $885cc8d80190f4c8$var$NOOP = ()=>{};
var $885cc8d80190f4c8$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("1ulgA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $115916dc6f1f52bc$export$2e2bcd8739ae039);

var $l6otV = parcelRequire("l6otV");

var $bpHT7 = parcelRequire("bpHT7");
var $115916dc6f1f52bc$export$2e2bcd8739ae039 = {
    mounted () {
        this.requestData();
    },
    methods: {
        async onSubmit () {
            this.data.content = JSON.stringify(this.content);
            await (0, $l6otV.default).modelingCreate(this.data);
            this.$router.push("/settings/modelings");
        },
        async requestData () {
            this.groups = await (0, $bpHT7.default).list();
        },
        groupCheck (group, event) {
            if (!this.content.groups) this.content.groups = [];
            if (event.target.checked) {
                var index = this.content.groups.findIndex((f)=>f.groupId == group.id);
                if (index < 0) this.content.groups.push({
                    "groupId": group.id
                });
            } else {
                var index = this.content.groups.findIndex((f)=>f.groupId == group.id);
                if (index >= 0) this.content.groups.splice(index, 1);
            }
        },
        isGroupChecked (item) {
            return this.content["groups"]?.findIndex((f)=>f["groupId"] == item.id) >= 0;
        }
    },
    data () {
        return {
            groups: [],
            content: {},
            data: {
                name: "",
                currency: "",
                content: "{}"
            }
        };
    }
};

});

parcelRegister("7YUFD", function(module, exports) {

$parcel$export(module.exports, "render", () => $5cfa189249218a19$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $5cfa189249218a19$var$_hoisted_1 = {
    class: "container py-5"
};
const $5cfa189249218a19$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $5cfa189249218a19$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $5cfa189249218a19$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $5cfa189249218a19$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $5cfa189249218a19$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $5cfa189249218a19$var$_hoisted_7 = {
    class: "row mb-3"
};
const $5cfa189249218a19$var$_hoisted_8 = {
    class: "col-md-3"
};
const $5cfa189249218a19$var$_hoisted_9 = {
    class: "form-label",
    for: "name"
};
const $5cfa189249218a19$var$_hoisted_10 = {
    class: "col-md-6"
};
const $5cfa189249218a19$var$_hoisted_11 = {
    class: "form-label"
};
const $5cfa189249218a19$var$_hoisted_12 = {
    class: "row col-md-12"
};
const $5cfa189249218a19$var$_hoisted_13 = {
    class: "form-label"
};
const $5cfa189249218a19$var$_hoisted_14 = {
    class: "input-group mb-3"
};
const $5cfa189249218a19$var$_hoisted_15 = [
    "for"
];
const $5cfa189249218a19$var$_hoisted_16 = {
    class: "input-group-text"
};
const $5cfa189249218a19$var$_hoisted_17 = [
    "id",
    "onChange",
    "checked"
];
const $5cfa189249218a19$var$_hoisted_18 = {
    class: "row"
};
const $5cfa189249218a19$var$_hoisted_19 = {
    class: "col-md-4"
};
function $5cfa189249218a19$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5cfa189249218a19$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("modelingCreation")), 1),
        (0, $TusQn.createElementVNode)("nav", $5cfa189249218a19$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $5cfa189249218a19$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $5cfa189249218a19$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modelings"
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $5cfa189249218a19$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $5cfa189249218a19$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $5cfa189249218a19$var$_hoisted_7, [
            (0, $TusQn.createElementVNode)("div", $5cfa189249218a19$var$_hoisted_8, [
                (0, $TusQn.createElementVNode)("label", $5cfa189249218a19$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("modelingName")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name",
                    placeholder: "Enter modeling name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $5cfa189249218a19$var$_hoisted_10, [
                (0, $TusQn.createElementVNode)("label", $5cfa189249218a19$var$_hoisted_11, (0, $8POXm.toDisplayString)(_ctx.$t("currency")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.currency = $event)
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.currency
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $5cfa189249218a19$var$_hoisted_12, [
            (0, $TusQn.createElementVNode)("label", $5cfa189249218a19$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.groups, (item, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "col-md-3",
                    key: i
                }, [
                    (0, $TusQn.createElementVNode)("div", $5cfa189249218a19$var$_hoisted_14, [
                        (0, $TusQn.createElementVNode)("label", {
                            class: "form-control readonly",
                            for: "group_" + i
                        }, (0, $8POXm.toDisplayString)(item.name), 9, $5cfa189249218a19$var$_hoisted_15),
                        (0, $TusQn.createElementVNode)("div", $5cfa189249218a19$var$_hoisted_16, [
                            (0, $TusQn.createElementVNode)("input", {
                                class: "form-check-input mt-0",
                                type: "checkbox",
                                id: "group_" + i,
                                onChange: ($event)=>$options.groupCheck(item, $event),
                                checked: $options.isGroupChecked(item)
                            }, null, 40, $5cfa189249218a19$var$_hoisted_17)
                        ])
                    ])
                ]);
            }), 128))
        ]),
        (0, $TusQn.createElementVNode)("div", $5cfa189249218a19$var$_hoisted_18, [
            (0, $TusQn.createElementVNode)("div", $5cfa189249218a19$var$_hoisted_19, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1)
            ])
        ])
    ]);
}

});

parcelRegister("5JZHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42e1054ce0133ab2$export$2e2bcd8739ae039);
let $42e1054ce0133ab2$var$NOOP = ()=>{};
var $42e1054ce0133ab2$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("5GDRK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $423fcc8b5c8a14d4$export$2e2bcd8739ae039);

var $l6otV = parcelRequire("l6otV");

var $4pFH4 = parcelRequire("4pFH4");
var $423fcc8b5c8a14d4$export$2e2bcd8739ae039 = {
    name: "ModelingList",
    components: {
        ModelingDeleteModal: $4pFH4.default
    },
    mounted () {
        this.requestData();
    },
    computed: {
        listOfModelings () {
            if (!this.filterInput) return this.modelingList.sort((a, b)=>a.name.localeCompare(b.name));
            else {
                const lowerCaseFilter = this.filterInput.toLowerCase();
                return this.modelingList.sort((a, b)=>a.name.localeCompare(b.name)).filter((modeling)=>{
                    if (modeling.name.toLowerCase().includes(lowerCaseFilter)) return modeling;
                });
            }
        }
    },
    methods: {
        async requestData () {
            this.modelingList = await (0, $l6otV.default).modelingList();
        },
        showDeleteModelingModal (item) {
            this.modelingToDeleteId = item.id;
            this.modelingToDeleteName = item.name;
            this.isModalVisible = true;
        }
    },
    data () {
        return {
            modelingList: [],
            modelingToDeleteName: "",
            modelingToDeleteId: "",
            isModalVisible: false,
            filterInput: ""
        };
    }
};

});
parcelRegister("4pFH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3369d6b3c6863b0a$export$2e2bcd8739ae039);
let $3369d6b3c6863b0a$var$script;



let $3369d6b3c6863b0a$var$initialize = ()=>{
    $3369d6b3c6863b0a$var$script = (parcelRequire("cyZN0"));
    if ($3369d6b3c6863b0a$var$script.__esModule) $3369d6b3c6863b0a$var$script = $3369d6b3c6863b0a$var$script.default;
    $3369d6b3c6863b0a$var$script.render = (parcelRequire("jYunz")).render;
    (parcelRequire("akr7j")).default($3369d6b3c6863b0a$var$script);
    $3369d6b3c6863b0a$var$script.__scopeId = "data-v-c8857f";
    $3369d6b3c6863b0a$var$script.__file = "ModelingDeleteModal.vue";
};
$3369d6b3c6863b0a$var$initialize();
var $3369d6b3c6863b0a$export$2e2bcd8739ae039 = $3369d6b3c6863b0a$var$script;

});
parcelRegister("cyZN0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9258971e517bb054$export$2e2bcd8739ae039);

var $l6otV = parcelRequire("l6otV");
var $9258971e517bb054$export$2e2bcd8739ae039 = {
    name: "modelingModal",
    methods: {
        close () {
            this.$parent.isModalVisible = false;
        },
        async deleteModeling () {
            this.syncLoading = "";
            await (0, $l6otV.default).modelingDelete(this.$parent.modelingToDeleteId);
            this.close();
            this.$emit("reload");
        }
    },
    data () {
        return {
            buttonLoading: "btn btn-primary",
            syncLoading: "hidden",
            files: []
        };
    }
};

});

parcelRegister("jYunz", function(module, exports) {

$parcel$export(module.exports, "render", () => $e8ab2f8fe5879afc$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $e8ab2f8fe5879afc$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $e8ab2f8fe5879afc$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $e8ab2f8fe5879afc$var$_hoisted_3 = {
    class: "modal-content"
};
const $e8ab2f8fe5879afc$var$_hoisted_4 = {
    class: "modal-header"
};
const $e8ab2f8fe5879afc$var$_hoisted_5 = {
    class: "modal-title"
};
const $e8ab2f8fe5879afc$var$_hoisted_6 = {
    class: "modal-body"
};
const $e8ab2f8fe5879afc$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0",
        "color": "red"
    }
};
const $e8ab2f8fe5879afc$var$_hoisted_8 = {
    class: "modal-footer"
};
const $e8ab2f8fe5879afc$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
    class: "spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
}, null, -1);
function $e8ab2f8fe5879afc$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $e8ab2f8fe5879afc$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $e8ab2f8fe5879afc$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $e8ab2f8fe5879afc$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $e8ab2f8fe5879afc$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $e8ab2f8fe5879afc$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("modelingDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $e8ab2f8fe5879afc$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisModeling")), 1),
                                (0, $TusQn.createElementVNode)("p", $e8ab2f8fe5879afc$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("allDataWillBeLost")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $e8ab2f8fe5879afc$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    class: (0, $8POXm.normalizeClass)([
                                        $data.buttonLoading,
                                        $data.syncLoading
                                    ]),
                                    type: "button",
                                    disabled: ""
                                }, [
                                    $e8ab2f8fe5879afc$var$_hoisted_9,
                                    (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("loading")), 1)
                                ], 2),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteModeling && $options.deleteModeling(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("akr7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $7850ce864eab2711$export$2e2bcd8739ae039);
let $7850ce864eab2711$var$NOOP = ()=>{};
var $7850ce864eab2711$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("jihxJ", function(module, exports) {

$parcel$export(module.exports, "render", () => $e0bd4e6e585ac7c3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $e0bd4e6e585ac7c3$var$_hoisted_1 = {
    class: "modeling-list table-responsive"
};
const $e0bd4e6e585ac7c3$var$_hoisted_2 = {
    class: "table table-bordered table-responsive-md"
};
const $e0bd4e6e585ac7c3$var$_hoisted_3 = {
    class: "text-center"
};
const $e0bd4e6e585ac7c3$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-lg fa-plus"
}, null, -1);
const $e0bd4e6e585ac7c3$var$_hoisted_5 = {
    key: 0
};
const $e0bd4e6e585ac7c3$var$_hoisted_6 = [
    "placeholder"
];
const $e0bd4e6e585ac7c3$var$_hoisted_7 = [
    "onClick"
];
const $e0bd4e6e585ac7c3$var$_hoisted_8 = {
    key: 1
};
const $e0bd4e6e585ac7c3$var$_hoisted_9 = [
    "placeholder"
];
function $e0bd4e6e585ac7c3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_ModelingDeleteModal = (0, $TusQn.resolveComponent)("ModelingDeleteModal");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e0bd4e6e585ac7c3$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("table", $e0bd4e6e585ac7c3$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("thead", null, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.createElementVNode)("th", $e0bd4e6e585ac7c3$var$_hoisted_3, [
                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("modelings")) + " ", 1),
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            style: {
                                "float": "right"
                            },
                            to: {
                                name: "modelingadd"
                            }
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    $e0bd4e6e585ac7c3$var$_hoisted_4
                                ]),
                            _: 1
                        })
                    ])
                ])
            ]),
            $options.listOfModelings.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $e0bd4e6e585ac7c3$var$_hoisted_5, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        style: {
                            "border": "none"
                        },
                        class: "form-control",
                        placeholder: _ctx.$t("modelingName"),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.filterInput = $event),
                        type: "search"
                    }, null, 8, $e0bd4e6e585ac7c3$var$_hoisted_6), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.filterInput
                        ]
                    ])
                ]),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.listOfModelings, (item, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                        key: i
                    }, [
                        (0, $TusQn.createElementVNode)("td", null, [
                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                to: {
                                    name: "settingsmodelingdetail",
                                    params: {
                                        id: item.id
                                    }
                                }
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                    ]),
                                _: 2
                            }, 1032, [
                                "to"
                            ]),
                            (0, $TusQn.createElementVNode)("i", {
                                style: {
                                    "float": "right",
                                    "padding-top": "10px",
                                    "cursor": "pointer"
                                },
                                onClick: ($event)=>$options.showDeleteModelingModal(item),
                                class: "fas fa-sm fa-trash"
                            }, null, 8, $e0bd4e6e585ac7c3$var$_hoisted_7)
                        ])
                    ]);
                }), 128))
            ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $e0bd4e6e585ac7c3$var$_hoisted_8, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-control",
                        placeholder: _ctx.$t("filterByName"),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.filterInput = $event),
                        type: "search"
                    }, null, 8, $e0bd4e6e585ac7c3$var$_hoisted_9), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.filterInput
                        ]
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tr", null, (0, $8POXm.toDisplayString)(_ctx.$t("noAssignedModeling")), 1)
            ]))
        ]),
        $data.isModalVisible ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ModelingDeleteModal, {
            key: 0,
            onReload: $options.requestData
        }, null, 8, [
            "onReload"
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("dKE9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $a02eb74061d75a6a$export$2e2bcd8739ae039);
let $a02eb74061d75a6a$var$NOOP = ()=>{};
var $a02eb74061d75a6a$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("fReej", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b8b6d7fecf5748d9$export$2e2bcd8739ae039);

var $fmQKt = parcelRequire("fmQKt");

var $8i3Lm = parcelRequire("8i3Lm");

var $l6otV = parcelRequire("l6otV");

var $eHCxc = parcelRequire("eHCxc");

var $hnrNT = parcelRequire("hnrNT");

var $ch9iu = parcelRequire("ch9iu");

var $gOjKo = parcelRequire("gOjKo");
var $b8b6d7fecf5748d9$export$2e2bcd8739ae039 = {
    name: "selectiondetail",
    watch: {
        $route: "requestData"
    },
    components: {
        SelectionGroupDeleteModal: $hnrNT.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        getDatasetHeaders (groupAssetType) {
            var headers = [];
            var foundAssetType = this.assetTypes.find((a)=>a.id == groupAssetType.assetTypeId);
            var foundDataset = this.datasets.find((d)=>d.id == foundAssetType.datasetId);
            var datasetContent = JSON.parse(foundDataset.content);
            headers = datasetContent["headers"];
            if (headers.findIndex((d)=>d.name == groupAssetType.filterAttributeName) < 0) headers.push({
                name: groupAssetType.filterAttributeName,
                alias: groupAssetType.filterAttributeName,
                disabled: true
            });
            return headers;
        },
        async confirmGroupDelete () {
            this.pending = true;
            this.data.selectionGroup = this.data.selectionGroup.filter((l)=>l.id != this.$route.params.groupId);
            await (0, $fmQKt.default).selectionUpdate(this.$route.params.id, this.data);
            this.$router.push({
                path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}`
            });
        },
        getCurrentGroup () {
            var group = this.data.selectionGroup.filter((g)=>g.id == this.$route.params.groupId);
            if (group.length > 0) {
                this.selectionGroupName = group[0].name;
                return group;
            }
        },
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var selectionId = this.$route.params.selectionId;
            this.data = await (0, $fmQKt.default).selectionDetail(this.$route.params.id, selectionId);
            var forecast = await (0, $8i3Lm.default).forecastDetail(this.$route.params.id, this.data.forecastId);
            var currentGroup = this.data.selectionGroup.find((g)=>g.id == this.$route.params.groupId);
            // group multiplicator = LC - forecast 
            var groupMultiplicatorForecast = [];
            for(var o in forecast.forecastAssetTypes){
                var assetType = forecast.forecastAssetTypes[o];
                // ignore not in groups
                groupMultiplicatorForecast.push({
                    assetTypeId: assetType.assetTypeId
                });
            }
            var selectionGroupAssetTypes = [];
            // for each AT and LC = GROUP
            for(var o in groupMultiplicatorForecast){
                var object = groupMultiplicatorForecast[o];
                var selectionGroupAssetTypeObject = {
                    checked: false,
                    assetTypeId: object.assetTypeId,
                    filterAttributeName: "",
                    filterSign: "=",
                    filterValue: "",
                    selectionGroupId: this.$route.params.groupId
                };
                var foundSelectionGroupAssetType = currentGroup?.selectionGroupAssetType?.find((v)=>v.assetTypeId == object.assetTypeId);
                if (foundSelectionGroupAssetType) selectionGroupAssetTypeObject.id = foundSelectionGroupAssetType.id, selectionGroupAssetTypeObject.checked = true, selectionGroupAssetTypeObject.assetTypeId = foundSelectionGroupAssetType.assetTypeId, selectionGroupAssetTypeObject.filterAttributeName = foundSelectionGroupAssetType.filterAttributeName, selectionGroupAssetTypeObject.filterSign = foundSelectionGroupAssetType.filterSign, selectionGroupAssetTypeObject.filterValue = foundSelectionGroupAssetType.filterValue, selectionGroupAssetTypeObject.selectionGroupId = foundSelectionGroupAssetType.selectionGroupId;
                selectionGroupAssetTypes.push(selectionGroupAssetTypeObject);
            }
            this.datasets = await (0, $ch9iu.default).datasetList(this.$route.params.id);
            this.selectionGroupAssetType = selectionGroupAssetTypes;
            var assetTypes = await (0, $eHCxc.default).assetTypeList(this.$route.params.id);
            this.assetTypes = assetTypes.filter((f)=>forecast.forecastAssetTypes.findIndex((a)=>a.assetTypeId == f.id) >= 0);
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            try {
                var selectionGroup = this.data.selectionGroup.find((g)=>g.id == this.$route.params.groupId);
                if (selectionGroup.name.length > 0) {
                    var selectionGroupAssetTypes = [];
                    for(var i in this.selectionGroupAssetType){
                        var assetType = this.selectionGroupAssetType[i];
                        if (assetType.checked) selectionGroupAssetTypes.push({
                            "id": assetType.id || 0,
                            "selectionGroupId": assetType.selectionGroupId,
                            "assetTypeId": assetType.assetTypeId,
                            "filterAttributeName": assetType.filterAttributeName,
                            "filterSign": assetType.filterSign,
                            "filterValue": assetType.filterValue
                        });
                    }
                    selectionGroup.selectionGroupAssetType = selectionGroupAssetTypes;
                    await (0, $fmQKt.default).selectionUpdate(this.$route.params.id, this.data);
                    this.showSuccess();
                } else this.showEmptyNameError();
            } catch  {
                this.showError();
            }
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "selectionGroupUpdated",
            type: "success"
        },
        showError: {
            title: "error",
            message: "selectionGroupErrorUpdate!",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionGroup: [],
                selectionPackage: [],
                selectionLimit: []
            },
            selectionGroupName: "",
            assetTypes: [],
            pending: true,
            modelingName: "",
            showSelectionGroupDeleteModal: false,
            selectionGroupAssetType: [],
            datasetHeaders: [],
            missingDatasetFilterHeaders: [],
            datasets: [],
            isUserAdmin: false
        };
    }
};

});
parcelRegister("hnrNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca6a26e676a44b37$export$2e2bcd8739ae039);
let $ca6a26e676a44b37$var$script;



let $ca6a26e676a44b37$var$initialize = ()=>{
    $ca6a26e676a44b37$var$script = (parcelRequire("7CrXn"));
    if ($ca6a26e676a44b37$var$script.__esModule) $ca6a26e676a44b37$var$script = $ca6a26e676a44b37$var$script.default;
    $ca6a26e676a44b37$var$script.render = (parcelRequire("lyyjP")).render;
    (parcelRequire("5ghSm")).default($ca6a26e676a44b37$var$script);
    $ca6a26e676a44b37$var$script.__scopeId = "data-v-bee461";
    $ca6a26e676a44b37$var$script.__file = "SelectionGroupDeleteModal.vue";
};
$ca6a26e676a44b37$var$initialize();
var $ca6a26e676a44b37$export$2e2bcd8739ae039 = $ca6a26e676a44b37$var$script;

});
parcelRegister("7CrXn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $58c1c4a302c36577$export$2e2bcd8739ae039);
var $58c1c4a302c36577$export$2e2bcd8739ae039 = {
    name: "selectionGroupDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteSelectionGroup () {
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("lyyjP", function(module, exports) {

$parcel$export(module.exports, "render", () => $fb1764eee41f9af0$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $fb1764eee41f9af0$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $fb1764eee41f9af0$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $fb1764eee41f9af0$var$_hoisted_3 = {
    class: "modal-content"
};
const $fb1764eee41f9af0$var$_hoisted_4 = {
    class: "modal-header"
};
const $fb1764eee41f9af0$var$_hoisted_5 = {
    class: "modal-title"
};
const $fb1764eee41f9af0$var$_hoisted_6 = {
    class: "modal-body"
};
const $fb1764eee41f9af0$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0"
    }
};
const $fb1764eee41f9af0$var$_hoisted_8 = {
    class: "modal-footer"
};
function $fb1764eee41f9af0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $fb1764eee41f9af0$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $fb1764eee41f9af0$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $fb1764eee41f9af0$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $fb1764eee41f9af0$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $fb1764eee41f9af0$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("selectionAreaDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $fb1764eee41f9af0$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", $fb1764eee41f9af0$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisSelectionArea")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $fb1764eee41f9af0$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteSelectionGroup && $options.deleteSelectionGroup(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("5ghSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d4c501c63f1c310$export$2e2bcd8739ae039);
let $3d4c501c63f1c310$var$NOOP = ()=>{};
var $3d4c501c63f1c310$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("1VcHK", function(module, exports) {

$parcel$export(module.exports, "render", () => $1664f8298ed153d3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $1664f8298ed153d3$var$_hoisted_1 = {
    key: 0
};
const $1664f8298ed153d3$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $1664f8298ed153d3$var$_hoisted_3 = [
    $1664f8298ed153d3$var$_hoisted_2
];
const $1664f8298ed153d3$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $1664f8298ed153d3$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $1664f8298ed153d3$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $1664f8298ed153d3$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $1664f8298ed153d3$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $1664f8298ed153d3$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $1664f8298ed153d3$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $1664f8298ed153d3$var$_hoisted_11 = {
    class: "mb-3"
};
const $1664f8298ed153d3$var$_hoisted_12 = {
    class: "row"
};
const $1664f8298ed153d3$var$_hoisted_13 = {
    class: "mb-3 col-md-4"
};
const $1664f8298ed153d3$var$_hoisted_14 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $1664f8298ed153d3$var$_hoisted_15 = [
    "onUpdate:modelValue"
];
const $1664f8298ed153d3$var$_hoisted_16 = {
    class: "form-label",
    for: "costFactor",
    required: ""
};
const $1664f8298ed153d3$var$_hoisted_17 = {
    class: "row"
};
const $1664f8298ed153d3$var$_hoisted_18 = {
    class: "mb-3 col-md-12"
};
const $1664f8298ed153d3$var$_hoisted_19 = {
    class: "row"
};
const $1664f8298ed153d3$var$_hoisted_20 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "col-md-1"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
        class: "form-label"
    })
], -1);
const $1664f8298ed153d3$var$_hoisted_21 = {
    class: "col-md-3"
};
const $1664f8298ed153d3$var$_hoisted_22 = {
    class: "form-label"
};
const $1664f8298ed153d3$var$_hoisted_23 = {
    class: "col-md-3"
};
const $1664f8298ed153d3$var$_hoisted_24 = {
    class: "form-label"
};
const $1664f8298ed153d3$var$_hoisted_25 = {
    class: "col-md-2"
};
const $1664f8298ed153d3$var$_hoisted_26 = {
    class: "form-label"
};
const $1664f8298ed153d3$var$_hoisted_27 = {
    class: "col-md-3"
};
const $1664f8298ed153d3$var$_hoisted_28 = {
    class: "form-label"
};
const $1664f8298ed153d3$var$_hoisted_29 = {
    class: "row"
};
const $1664f8298ed153d3$var$_hoisted_30 = {
    class: "col-md-1"
};
const $1664f8298ed153d3$var$_hoisted_31 = [
    "onUpdate:modelValue",
    "id"
];
const $1664f8298ed153d3$var$_hoisted_32 = {
    class: "col-md-3"
};
const $1664f8298ed153d3$var$_hoisted_33 = [
    "onUpdate:modelValue",
    "id"
];
const $1664f8298ed153d3$var$_hoisted_34 = [
    "value"
];
const $1664f8298ed153d3$var$_hoisted_35 = {
    class: "col-md-3"
};
const $1664f8298ed153d3$var$_hoisted_36 = [
    "id",
    "onUpdate:modelValue",
    "disabled"
];
const $1664f8298ed153d3$var$_hoisted_37 = {
    disabled: ""
};
const $1664f8298ed153d3$var$_hoisted_38 = [
    "disabled",
    "value"
];
const $1664f8298ed153d3$var$_hoisted_39 = {
    class: "col-md-2"
};
const $1664f8298ed153d3$var$_hoisted_40 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $1664f8298ed153d3$var$_hoisted_41 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<option value=""></option><option value="=">=</option><option value="&gt;">&gt;</option><option value="&lt;">&lt;</option><option value="&gt;=">&gt;=</option><option value="&lt;=">&lt;=</option>', 6);
const $1664f8298ed153d3$var$_hoisted_47 = [
    $1664f8298ed153d3$var$_hoisted_41
];
const $1664f8298ed153d3$var$_hoisted_48 = {
    class: "col-md-3"
};
const $1664f8298ed153d3$var$_hoisted_49 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $1664f8298ed153d3$var$_hoisted_50 = {
    class: "d-grid gap-2 d-md-flex"
};
function $1664f8298ed153d3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_SelectionGroupDeleteModal = (0, $TusQn.resolveComponent)("SelectionGroupDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1664f8298ed153d3$var$_hoisted_1, $1664f8298ed153d3$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $1664f8298ed153d3$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("areaDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $1664f8298ed153d3$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $1664f8298ed153d3$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $1664f8298ed153d3$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $1664f8298ed153d3$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $1664f8298ed153d3$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name || _ctx.$t("selection")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $1664f8298ed153d3$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.selectionGroupName), 1)
            ])
        ]),
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getCurrentGroup(), (group, i)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: i,
                class: "row"
            }, [
                (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_11, [
                    (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_13, [
                            (0, $TusQn.createElementVNode)("label", $1664f8298ed153d3$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": ($event)=>group.name = $event,
                                type: "text",
                                class: "form-control",
                                id: "name"
                            }, null, 8, $1664f8298ed153d3$var$_hoisted_15), [
                                [
                                    (0, $eeJ70.vModelText),
                                    group.name
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("h4", $1664f8298ed153d3$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("selectionAreaAssetTypes")), 1),
                    (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_17, [
                        (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_18, [
                            (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_19, [
                                $1664f8298ed153d3$var$_hoisted_20,
                                (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_21, [
                                    (0, $TusQn.createElementVNode)("label", $1664f8298ed153d3$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("assetType")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_23, [
                                    (0, $TusQn.createElementVNode)("label", $1664f8298ed153d3$var$_hoisted_24, (0, $8POXm.toDisplayString)(_ctx.$t("filterAttributeName")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_25, [
                                    (0, $TusQn.createElementVNode)("label", $1664f8298ed153d3$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("filterSign")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_27, [
                                    (0, $TusQn.createElementVNode)("label", $1664f8298ed153d3$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("filterValue")), 1)
                                ])
                            ])
                        ]),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.selectionGroupAssetType, (groupAssetType, o)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                class: "mb-3 col-md-12",
                                key: o
                            }, [
                                (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_29, [
                                    (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_30, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            class: "form-check-input",
                                            "onUpdate:modelValue": ($event)=>groupAssetType.checked = $event,
                                            type: "checkbox",
                                            id: "checked_" + o
                                        }, null, 8, $1664f8298ed153d3$var$_hoisted_31), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                groupAssetType.checked
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_32, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            class: "form-select",
                                            "onUpdate:modelValue": ($event)=>groupAssetType.assetTypeId = $event,
                                            disabled: "",
                                            id: "assetTypeId" + o
                                        }, [
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.assetTypes, (assetType, u)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: u,
                                                    value: assetType.id
                                                }, (0, $8POXm.toDisplayString)(assetType.name), 9, $1664f8298ed153d3$var$_hoisted_34);
                                            }), 128))
                                        ], 8, $1664f8298ed153d3$var$_hoisted_33), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                groupAssetType.assetTypeId
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_35, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            id: "name_" + o,
                                            class: "form-select",
                                            "onUpdate:modelValue": ($event)=>groupAssetType.filterAttributeName = $event,
                                            disabled: !groupAssetType.checked
                                        }, [
                                            (0, $TusQn.createElementVNode)("option", $1664f8298ed153d3$var$_hoisted_37, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getDatasetHeaders(groupAssetType), (datasetHeader, i)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    disabled: datasetHeader.disabled,
                                                    key: i,
                                                    value: datasetHeader.name
                                                }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $1664f8298ed153d3$var$_hoisted_38);
                                            }), 128))
                                        ], 8, $1664f8298ed153d3$var$_hoisted_36), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                groupAssetType.filterAttributeName
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_39, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>groupAssetType.filterSign = $event,
                                            disabled: !groupAssetType.checked,
                                            class: "form-select",
                                            id: "filterSign_" + o
                                        }, $1664f8298ed153d3$var$_hoisted_47, 8, $1664f8298ed153d3$var$_hoisted_40), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                groupAssetType.filterSign
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_48, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            "onUpdate:modelValue": ($event)=>groupAssetType.filterValue = $event,
                                            disabled: !groupAssetType.checked,
                                            type: "text",
                                            class: "form-control",
                                            id: "filterValue_" + o
                                        }, null, 8, $1664f8298ed153d3$var$_hoisted_49), [
                                            [
                                                (0, $eeJ70.vModelText),
                                                groupAssetType.filterValue
                                            ]
                                        ])
                                    ])
                                ])
                            ]);
                        }), 128))
                    ])
                ])
            ]);
        }), 128)),
        (0, $TusQn.createElementVNode)("div", $1664f8298ed153d3$var$_hoisted_50, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[1] || (_cache[1] = ($event)=>$data.showSelectionGroupDeleteModal = true)
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showSelectionGroupDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_SelectionGroupDeleteModal, {
            key: 0,
            onReload: _cache[3] || (_cache[3] = ($event)=>$options.confirmGroupDelete()),
            onCloseDeleteDialog: _cache[4] || (_cache[4] = ($event)=>$data.showSelectionGroupDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("jhbn0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0886cb58da7d30a$export$2e2bcd8739ae039);
let $e0886cb58da7d30a$var$NOOP = ()=>{};
var $e0886cb58da7d30a$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("l25nm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f4fdf45fc5560e6a$export$2e2bcd8739ae039);

var $fmQKt = parcelRequire("fmQKt");

var $8i3Lm = parcelRequire("8i3Lm");

var $l6otV = parcelRequire("l6otV");

var $eHCxc = parcelRequire("eHCxc");

var $ch9iu = parcelRequire("ch9iu");
var $f4fdf45fc5560e6a$export$2e2bcd8739ae039 = {
    name: "selectiondetail",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        getDatasetHeaders (groupAssetType) {
            var headers = [];
            var foundAssetType = this.assetTypes.find((a)=>a.id == groupAssetType.assetTypeId);
            var foundDataset = this.datasets.find((d)=>d.id == foundAssetType.datasetId);
            var datasetContent = JSON.parse(foundDataset.content);
            headers = datasetContent["headers"];
            if (headers.findIndex((d)=>d.name == groupAssetType.filterAttributeName) < 0) headers.push({
                name: groupAssetType.filterAttributeName,
                alias: groupAssetType.filterAttributeName,
                disabled: true
            });
            return headers;
        },
        getCurrentGroup () {
            var group = this.data.selectionGroup.filter((g)=>g.id == 0);
            if (group.length > 0) {
                this.selectionGroupName = group[0].name;
                return group;
            }
        },
        async requestData () {
            this.pending = true;
            var selectionId = this.$route.params.selectionId;
            this.data = await (0, $fmQKt.default).selectionDetail(this.$route.params.id, selectionId);
            var forecast = await (0, $8i3Lm.default).forecastDetail(this.$route.params.id, this.data.forecastId);
            // Inicializace nové skupiny
            this.data.selectionGroup.push({
                id: 0,
                selectionGroupAssetType: []
            });
            // group multiplicator = LC - forecast 
            var groupMultiplicatorForecast = [];
            for(var o in forecast.forecastAssetTypes){
                var assetType = forecast.forecastAssetTypes[o];
                // ignore not in groups
                groupMultiplicatorForecast.push({
                    assetTypeId: assetType.assetTypeId
                });
            }
            var selectionGroupAssetTypes = [];
            // for each AT and LC = GROUP
            for(var o in groupMultiplicatorForecast){
                var object = groupMultiplicatorForecast[o];
                var selectionGroupAssetTypeObject = {
                    checked: false,
                    assetTypeId: object.assetTypeId,
                    filterAttributeName: "",
                    filterSign: "=",
                    filterValue: "",
                    selectionGroupId: 0
                };
                selectionGroupAssetTypes.push(selectionGroupAssetTypeObject);
            }
            this.datasets = await (0, $ch9iu.default).datasetList(this.$route.params.id);
            this.selectionGroupAssetType = selectionGroupAssetTypes;
            var assetTypes = await (0, $eHCxc.default).assetTypeList(this.$route.params.id);
            this.assetTypes = assetTypes.filter((f)=>forecast.forecastAssetTypes.findIndex((a)=>a.assetTypeId == f.id) >= 0);
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            try {
                var selectionGroup = this.data.selectionGroup.find((g)=>g.id == 0);
                if (selectionGroup.name && selectionGroup.name.length > 0) {
                    var selectionGroupAssetTypes = [];
                    for(var i in this.selectionGroupAssetType){
                        var assetType = this.selectionGroupAssetType[i];
                        if (assetType.checked) selectionGroupAssetTypes.push({
                            "id": assetType.id || 0,
                            "selectionGroupId": assetType.selectionGroupId,
                            "assetTypeId": assetType.assetTypeId,
                            "filterAttributeName": assetType.filterAttributeName,
                            "filterSign": assetType.filterSign,
                            "filterValue": assetType.filterValue
                        });
                    }
                    selectionGroup.selectionGroupAssetType = selectionGroupAssetTypes;
                    await (0, $fmQKt.default).selectionUpdate(this.$route.params.id, this.data);
                    this.showSuccess();
                    this.$router.go(-1);
                } else this.showEmptyNameError();
            } catch  {
                this.showError();
            }
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "selectionGroupCreated",
            type: "success"
        },
        showError: {
            title: "error",
            message: "selectionGroupError!",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionGroup: [],
                selectionPackage: [],
                selectionLimit: []
            },
            selectionGroupName: "",
            assetTypes: [],
            datasets: [],
            pending: true,
            modelingName: "",
            selectionGroupAssetType: []
        };
    }
};

});

parcelRegister("8d3X0", function(module, exports) {

$parcel$export(module.exports, "render", () => $5fa29a25ce2755f0$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $5fa29a25ce2755f0$var$_hoisted_1 = {
    key: 0
};
const $5fa29a25ce2755f0$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $5fa29a25ce2755f0$var$_hoisted_3 = [
    $5fa29a25ce2755f0$var$_hoisted_2
];
const $5fa29a25ce2755f0$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $5fa29a25ce2755f0$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $5fa29a25ce2755f0$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $5fa29a25ce2755f0$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $5fa29a25ce2755f0$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $5fa29a25ce2755f0$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $5fa29a25ce2755f0$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $5fa29a25ce2755f0$var$_hoisted_11 = {
    class: "mb-3"
};
const $5fa29a25ce2755f0$var$_hoisted_12 = {
    class: "row"
};
const $5fa29a25ce2755f0$var$_hoisted_13 = {
    class: "mb-3 col-md-4"
};
const $5fa29a25ce2755f0$var$_hoisted_14 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $5fa29a25ce2755f0$var$_hoisted_15 = [
    "onUpdate:modelValue"
];
const $5fa29a25ce2755f0$var$_hoisted_16 = {
    class: "form-label",
    for: "costFactor",
    required: ""
};
const $5fa29a25ce2755f0$var$_hoisted_17 = {
    class: "row"
};
const $5fa29a25ce2755f0$var$_hoisted_18 = {
    class: "mb-3 col-md-12"
};
const $5fa29a25ce2755f0$var$_hoisted_19 = {
    class: "row"
};
const $5fa29a25ce2755f0$var$_hoisted_20 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "col-md-1"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
        class: "form-label"
    })
], -1);
const $5fa29a25ce2755f0$var$_hoisted_21 = {
    class: "col-md-3"
};
const $5fa29a25ce2755f0$var$_hoisted_22 = {
    class: "form-label"
};
const $5fa29a25ce2755f0$var$_hoisted_23 = {
    class: "col-md-3"
};
const $5fa29a25ce2755f0$var$_hoisted_24 = {
    class: "form-label"
};
const $5fa29a25ce2755f0$var$_hoisted_25 = {
    class: "col-md-2"
};
const $5fa29a25ce2755f0$var$_hoisted_26 = {
    class: "form-label"
};
const $5fa29a25ce2755f0$var$_hoisted_27 = {
    class: "col-md-3"
};
const $5fa29a25ce2755f0$var$_hoisted_28 = {
    class: "form-label"
};
const $5fa29a25ce2755f0$var$_hoisted_29 = {
    class: "row"
};
const $5fa29a25ce2755f0$var$_hoisted_30 = {
    class: "col-md-1"
};
const $5fa29a25ce2755f0$var$_hoisted_31 = [
    "onUpdate:modelValue",
    "id"
];
const $5fa29a25ce2755f0$var$_hoisted_32 = {
    class: "col-md-3"
};
const $5fa29a25ce2755f0$var$_hoisted_33 = [
    "onUpdate:modelValue",
    "id"
];
const $5fa29a25ce2755f0$var$_hoisted_34 = [
    "value"
];
const $5fa29a25ce2755f0$var$_hoisted_35 = {
    class: "col-md-3"
};
const $5fa29a25ce2755f0$var$_hoisted_36 = [
    "id",
    "onUpdate:modelValue",
    "disabled"
];
const $5fa29a25ce2755f0$var$_hoisted_37 = {
    disabled: ""
};
const $5fa29a25ce2755f0$var$_hoisted_38 = [
    "disabled",
    "value"
];
const $5fa29a25ce2755f0$var$_hoisted_39 = {
    class: "col-md-2"
};
const $5fa29a25ce2755f0$var$_hoisted_40 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $5fa29a25ce2755f0$var$_hoisted_41 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<option value=""></option><option value="=">=</option><option value="&gt;">&gt;</option><option value="&lt;">&lt;</option><option value="&gt;=">&gt;=</option><option value="&lt;=">&lt;=</option>', 6);
const $5fa29a25ce2755f0$var$_hoisted_47 = [
    $5fa29a25ce2755f0$var$_hoisted_41
];
const $5fa29a25ce2755f0$var$_hoisted_48 = {
    class: "col-md-3"
};
const $5fa29a25ce2755f0$var$_hoisted_49 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $5fa29a25ce2755f0$var$_hoisted_50 = {
    class: "d-grid gap-2 d-md-flex"
};
function $5fa29a25ce2755f0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5fa29a25ce2755f0$var$_hoisted_1, $5fa29a25ce2755f0$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5fa29a25ce2755f0$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("areaCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $5fa29a25ce2755f0$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $5fa29a25ce2755f0$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $5fa29a25ce2755f0$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $5fa29a25ce2755f0$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $5fa29a25ce2755f0$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name || _ctx.$t("selection")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $5fa29a25ce2755f0$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getCurrentGroup(), (group, i)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: i,
                class: "row"
            }, [
                (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_11, [
                    (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_13, [
                            (0, $TusQn.createElementVNode)("label", $5fa29a25ce2755f0$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": ($event)=>group.name = $event,
                                type: "text",
                                class: "form-control",
                                id: "name"
                            }, null, 8, $5fa29a25ce2755f0$var$_hoisted_15), [
                                [
                                    (0, $eeJ70.vModelText),
                                    group.name
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("h4", $5fa29a25ce2755f0$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("selectionAreaAssetTypes")), 1),
                    (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_17, [
                        (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_18, [
                            (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_19, [
                                $5fa29a25ce2755f0$var$_hoisted_20,
                                (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_21, [
                                    (0, $TusQn.createElementVNode)("label", $5fa29a25ce2755f0$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("assetType")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_23, [
                                    (0, $TusQn.createElementVNode)("label", $5fa29a25ce2755f0$var$_hoisted_24, (0, $8POXm.toDisplayString)(_ctx.$t("filterAttributeName")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_25, [
                                    (0, $TusQn.createElementVNode)("label", $5fa29a25ce2755f0$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("filterSign")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_27, [
                                    (0, $TusQn.createElementVNode)("label", $5fa29a25ce2755f0$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("filterValue")), 1)
                                ])
                            ])
                        ]),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.selectionGroupAssetType, (groupAssetType, o)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                class: "mb-3 col-md-12",
                                key: o
                            }, [
                                (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_29, [
                                    (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_30, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            class: "form-check-input",
                                            "onUpdate:modelValue": ($event)=>groupAssetType.checked = $event,
                                            type: "checkbox",
                                            id: "checked_" + o
                                        }, null, 8, $5fa29a25ce2755f0$var$_hoisted_31), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                groupAssetType.checked
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_32, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            class: "form-select",
                                            "onUpdate:modelValue": ($event)=>groupAssetType.assetTypeId = $event,
                                            disabled: "",
                                            id: "assetTypeId" + o
                                        }, [
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.assetTypes, (assetType, u)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: u,
                                                    value: assetType.id
                                                }, (0, $8POXm.toDisplayString)(assetType.name), 9, $5fa29a25ce2755f0$var$_hoisted_34);
                                            }), 128))
                                        ], 8, $5fa29a25ce2755f0$var$_hoisted_33), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                groupAssetType.assetTypeId
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_35, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            id: "name_" + o,
                                            class: "form-select",
                                            "onUpdate:modelValue": ($event)=>groupAssetType.filterAttributeName = $event,
                                            disabled: !groupAssetType.checked
                                        }, [
                                            (0, $TusQn.createElementVNode)("option", $5fa29a25ce2755f0$var$_hoisted_37, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getDatasetHeaders(groupAssetType), (datasetHeader, i)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    disabled: datasetHeader.disabled,
                                                    key: i,
                                                    value: datasetHeader.name
                                                }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $5fa29a25ce2755f0$var$_hoisted_38);
                                            }), 128))
                                        ], 8, $5fa29a25ce2755f0$var$_hoisted_36), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                groupAssetType.filterAttributeName
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_39, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>groupAssetType.filterSign = $event,
                                            disabled: !groupAssetType.checked,
                                            class: "form-select",
                                            id: "filterSign_" + o
                                        }, $5fa29a25ce2755f0$var$_hoisted_47, 8, $5fa29a25ce2755f0$var$_hoisted_40), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                groupAssetType.filterSign
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_48, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            "onUpdate:modelValue": ($event)=>groupAssetType.filterValue = $event,
                                            disabled: !groupAssetType.checked,
                                            type: "text",
                                            class: "form-control",
                                            id: "filterValue_" + o
                                        }, null, 8, $5fa29a25ce2755f0$var$_hoisted_49), [
                                            [
                                                (0, $eeJ70.vModelText),
                                                groupAssetType.filterValue
                                            ]
                                        ])
                                    ])
                                ])
                            ]);
                        }), 128))
                    ])
                ])
            ]);
        }), 128)),
        (0, $TusQn.createElementVNode)("div", $5fa29a25ce2755f0$var$_hoisted_50, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("8on5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $61c27ab2b8cb51d0$export$2e2bcd8739ae039);
let $61c27ab2b8cb51d0$var$NOOP = ()=>{};
var $61c27ab2b8cb51d0$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("famF4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b0a95e40f49db13a$export$2e2bcd8739ae039);

var $fmQKt = parcelRequire("fmQKt");

var $8i3Lm = parcelRequire("8i3Lm");

var $l6otV = parcelRequire("l6otV");

var $eHCxc = parcelRequire("eHCxc");

var $j9vnd = parcelRequire("j9vnd");

var $97tK3 = parcelRequire("97tK3");

var $g1MFT = parcelRequire("g1MFT");

var $gOjKo = parcelRequire("gOjKo");
var $b0a95e40f49db13a$export$2e2bcd8739ae039 = {
    name: "selectionpackage",
    watch: {
        $route: "requestData"
    },
    components: {
        SelectionPackageDeleteModal: $g1MFT.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        areAllLifeCyclesChecked () {
            return this.packageLifeCycleViewModel.filter((l)=>!l.checked).length == -1;
        },
        checkAllPackageLifeCycles (event) {
            for(var i in this.packageLifeCycleViewModel){
                var lifeCycle = this.packageLifeCycleViewModel[i];
                lifeCycle.checked = event.target.checked;
            }
        },
        async confirmPackageDelete () {
            this.pending = true;
            this.data.selectionPackage = this.data.selectionPackage.filter((l)=>l.id != this.$route.params.packageId);
            await (0, $fmQKt.default).selectionUpdate(this.$route.params.id, this.data);
            this.$router.push({
                path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}`
            });
        },
        filteredBenefits (assetTypeId) {
            return this.benefits.filter((b)=>b.assetTypeId == assetTypeId);
        },
        getCurrentPackage () {
            var selectionPackage = this.data.selectionPackage.filter((g)=>g.id == this.$route.params.packageId);
            if (selectionPackage.length > 0) {
                this.selectionPackageName = selectionPackage[0].name;
                return selectionPackage;
            }
        },
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var selectionId = this.$route.params.selectionId;
            this.data = await (0, $fmQKt.default).selectionDetail(this.$route.params.id, selectionId);
            var forecast = await (0, $8i3Lm.default).forecastDetail(this.$route.params.id, this.data.forecastId);
            var currentPackage = this.data.selectionPackage.find((g)=>g.id == this.$route.params.packageId);
            this.assetTypes = await (0, $eHCxc.default).assetTypeList(this.$route.params.id);
            this.lifeCycles = await (0, $97tK3.default).lifeCycleList(this.$route.params.id);
            var packageLifeCycleViewModel = [];
            this.benefits = await (0, $j9vnd.default).benefitList(this.$route.params.id);
            for(var i in this.data.selectionGroup){
                var group = this.data.selectionGroup[i];
                var groupMultiplicatorForecast = [];
                // group multiplicator = LC - forecast 
                for(var o in forecast.forecastAssetTypes){
                    var assetType = forecast.forecastAssetTypes[o];
                    // ignore not in groups
                    if (group.selectionGroupAssetType.length > 0) {
                        if (group.selectionGroupAssetType.findIndex((a)=>a.assetTypeId == assetType.assetTypeId) == -1) continue;
                    }
                    for(var u in assetType.lifeCycles){
                        var lifeCycleId = assetType.lifeCycles[u];
                        groupMultiplicatorForecast.push({
                            assetTypeId: assetType.assetTypeId,
                            lifeCycleId: lifeCycleId
                        });
                    }
                }
                // for each AT and LC = GROUP
                for(var o in groupMultiplicatorForecast){
                    var object = groupMultiplicatorForecast[o];
                    var assetTypeBenefit = this.benefits.find((b)=>b.assetTypeId == object.assetTypeId);
                    var packageLifeCycleViewModelObject = {
                        benefitId: assetTypeBenefit?.id,
                        benefitWeight: 1,
                        checked: false,
                        selectionPackageId: this.$route.params.packageId,
                        assetTypeId: object.assetTypeId,
                        lifeCycleId: object.lifeCycleId,
                        name: group.name,
                        selectionGroupId: group.id
                    };
                    var foundSelectionPackageLifeCycle = currentPackage?.selectionPackageLifeCycle?.find((v)=>v.selectionGroupId == group.id && v.lifeCycleId == object.lifeCycleId);
                    if (foundSelectionPackageLifeCycle) {
                        // TODO prepsani modelu
                        packageLifeCycleViewModelObject.benefitId = foundSelectionPackageLifeCycle.benefitId;
                        packageLifeCycleViewModelObject.benefitWeight = foundSelectionPackageLifeCycle.benefitWeight;
                        packageLifeCycleViewModelObject.id = foundSelectionPackageLifeCycle.id, packageLifeCycleViewModelObject.checked = true, packageLifeCycleViewModelObject.selectionPackageId = foundSelectionPackageLifeCycle.id, packageLifeCycleViewModelObject.assetTypeId = object.assetTypeId, packageLifeCycleViewModelObject.lifeCycleId = object.lifeCycleId, packageLifeCycleViewModelObject.name = group.name, packageLifeCycleViewModelObject.selectionGroupId = group.id;
                    }
                    packageLifeCycleViewModel.push(packageLifeCycleViewModelObject);
                }
            }
            this.packageLifeCycleViewModel = packageLifeCycleViewModel;
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            var selectionPackage = this.data.selectionPackage.find((g)=>g.id == this.$route.params.packageId);
            if (selectionPackage.name.length > 0) try {
                var selectionPackageLifeCycles = [];
                for(var i in this.packageLifeCycleViewModel){
                    var packageLifeCycle = this.packageLifeCycleViewModel[i];
                    if (packageLifeCycle.checked) selectionPackageLifeCycles.push({
                        "id": packageLifeCycle.id || 0,
                        "selectionPackageId": packageLifeCycle.selectionPackageId,
                        "selectionGroupId": packageLifeCycle.selectionGroupId,
                        "lifeCycleId": packageLifeCycle.lifeCycleId,
                        "benefitId": packageLifeCycle.benefitId,
                        "benefitWeight": packageLifeCycle.benefitWeight
                    });
                }
                selectionPackage.selectionPackageLifeCycle = selectionPackageLifeCycles;
                await (0, $fmQKt.default).selectionUpdate(this.$route.params.id, this.data);
                this.showSuccess();
            } catch  {
                this.showError();
            }
            else this.showEmptyNameError();
        }
    },
    notifications: {
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        },
        showSuccess: {
            title: "success",
            message: "selectionPackageUpdated",
            type: "success"
        },
        showError: {
            title: "error",
            message: "selectionPackageErrorUpdate",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionGroups: [],
                selectionPackage: [],
                selectionLimit: []
            },
            selectionPackageName: "",
            assetTypes: [],
            lifeCycles: [],
            benefits: [],
            pending: true,
            modelingName: "",
            showSelectionPackageDeleteModal: false,
            packageLifeCycleViewModel: [],
            isUserAdmin: false
        };
    }
};

});
parcelRegister("g1MFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bab27f1814825a2e$export$2e2bcd8739ae039);
let $bab27f1814825a2e$var$script;



let $bab27f1814825a2e$var$initialize = ()=>{
    $bab27f1814825a2e$var$script = (parcelRequire("4fP1Z"));
    if ($bab27f1814825a2e$var$script.__esModule) $bab27f1814825a2e$var$script = $bab27f1814825a2e$var$script.default;
    $bab27f1814825a2e$var$script.render = (parcelRequire("bo16l")).render;
    (parcelRequire("7GMSc")).default($bab27f1814825a2e$var$script);
    $bab27f1814825a2e$var$script.__scopeId = "data-v-da50d1";
    $bab27f1814825a2e$var$script.__file = "SelectionPackageDeleteModal.vue";
};
$bab27f1814825a2e$var$initialize();
var $bab27f1814825a2e$export$2e2bcd8739ae039 = $bab27f1814825a2e$var$script;

});
parcelRegister("4fP1Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $319025dd2f1cced1$export$2e2bcd8739ae039);
var $319025dd2f1cced1$export$2e2bcd8739ae039 = {
    name: "selectionDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteSelectionPackage () {
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("bo16l", function(module, exports) {

$parcel$export(module.exports, "render", () => $84a2ca4cfe67aab2$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $84a2ca4cfe67aab2$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $84a2ca4cfe67aab2$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $84a2ca4cfe67aab2$var$_hoisted_3 = {
    class: "modal-content"
};
const $84a2ca4cfe67aab2$var$_hoisted_4 = {
    class: "modal-header"
};
const $84a2ca4cfe67aab2$var$_hoisted_5 = {
    class: "modal-title"
};
const $84a2ca4cfe67aab2$var$_hoisted_6 = {
    class: "modal-body"
};
const $84a2ca4cfe67aab2$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0"
    }
};
const $84a2ca4cfe67aab2$var$_hoisted_8 = {
    class: "modal-footer"
};
function $84a2ca4cfe67aab2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $84a2ca4cfe67aab2$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $84a2ca4cfe67aab2$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $84a2ca4cfe67aab2$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $84a2ca4cfe67aab2$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $84a2ca4cfe67aab2$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("selectionPackageDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $84a2ca4cfe67aab2$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", $84a2ca4cfe67aab2$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisSelectionPackage")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $84a2ca4cfe67aab2$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteSelectionPackage && $options.deleteSelectionPackage(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("7GMSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $59925dd297649e85$export$2e2bcd8739ae039);
let $59925dd297649e85$var$NOOP = ()=>{};
var $59925dd297649e85$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("hth4S", function(module, exports) {

$parcel$export(module.exports, "render", () => $cb8264636fb16ffc$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $cb8264636fb16ffc$var$_hoisted_1 = {
    key: 0
};
const $cb8264636fb16ffc$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $cb8264636fb16ffc$var$_hoisted_3 = [
    $cb8264636fb16ffc$var$_hoisted_2
];
const $cb8264636fb16ffc$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $cb8264636fb16ffc$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $cb8264636fb16ffc$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $cb8264636fb16ffc$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $cb8264636fb16ffc$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $cb8264636fb16ffc$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $cb8264636fb16ffc$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $cb8264636fb16ffc$var$_hoisted_11 = {
    class: "mb-3"
};
const $cb8264636fb16ffc$var$_hoisted_12 = {
    class: "row"
};
const $cb8264636fb16ffc$var$_hoisted_13 = {
    class: "mb-3 col-md-4"
};
const $cb8264636fb16ffc$var$_hoisted_14 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $cb8264636fb16ffc$var$_hoisted_15 = [
    "onUpdate:modelValue"
];
const $cb8264636fb16ffc$var$_hoisted_16 = {
    class: "form-label",
    for: "costFactor",
    required: ""
};
const $cb8264636fb16ffc$var$_hoisted_17 = {
    class: "row"
};
const $cb8264636fb16ffc$var$_hoisted_18 = {
    class: "mb-3 col-md-12"
};
const $cb8264636fb16ffc$var$_hoisted_19 = {
    class: "row"
};
const $cb8264636fb16ffc$var$_hoisted_20 = {
    class: "col-md-1"
};
const $cb8264636fb16ffc$var$_hoisted_21 = [
    "checked",
    "id"
];
const $cb8264636fb16ffc$var$_hoisted_22 = {
    class: "col-md-2"
};
const $cb8264636fb16ffc$var$_hoisted_23 = {
    class: "form-label"
};
const $cb8264636fb16ffc$var$_hoisted_24 = {
    class: "col-md-2"
};
const $cb8264636fb16ffc$var$_hoisted_25 = {
    class: "form-label"
};
const $cb8264636fb16ffc$var$_hoisted_26 = {
    class: "col-md-3"
};
const $cb8264636fb16ffc$var$_hoisted_27 = {
    class: "form-label"
};
const $cb8264636fb16ffc$var$_hoisted_28 = {
    class: "col-md-2"
};
const $cb8264636fb16ffc$var$_hoisted_29 = {
    class: "form-label"
};
const $cb8264636fb16ffc$var$_hoisted_30 = {
    class: "col-md-2"
};
const $cb8264636fb16ffc$var$_hoisted_31 = {
    class: "form-label"
};
const $cb8264636fb16ffc$var$_hoisted_32 = {
    class: "row"
};
const $cb8264636fb16ffc$var$_hoisted_33 = {
    class: "col-md-1"
};
const $cb8264636fb16ffc$var$_hoisted_34 = [
    "onUpdate:modelValue",
    "id"
];
const $cb8264636fb16ffc$var$_hoisted_35 = {
    class: "col-md-2"
};
const $cb8264636fb16ffc$var$_hoisted_36 = [
    "onUpdate:modelValue",
    "id"
];
const $cb8264636fb16ffc$var$_hoisted_37 = [
    "value"
];
const $cb8264636fb16ffc$var$_hoisted_38 = {
    class: "col-md-2"
};
const $cb8264636fb16ffc$var$_hoisted_39 = [
    "onUpdate:modelValue",
    "id"
];
const $cb8264636fb16ffc$var$_hoisted_40 = [
    "value"
];
const $cb8264636fb16ffc$var$_hoisted_41 = {
    class: "col-md-3"
};
const $cb8264636fb16ffc$var$_hoisted_42 = [
    "onUpdate:modelValue",
    "id"
];
const $cb8264636fb16ffc$var$_hoisted_43 = [
    "value"
];
const $cb8264636fb16ffc$var$_hoisted_44 = {
    class: "col-md-2"
};
const $cb8264636fb16ffc$var$_hoisted_45 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $cb8264636fb16ffc$var$_hoisted_46 = {
    value: ""
};
const $cb8264636fb16ffc$var$_hoisted_47 = [
    "value"
];
const $cb8264636fb16ffc$var$_hoisted_48 = {
    class: "col-md-2"
};
const $cb8264636fb16ffc$var$_hoisted_49 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $cb8264636fb16ffc$var$_hoisted_50 = {
    class: "d-grid gap-2 d-md-flex"
};
function $cb8264636fb16ffc$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_SelectionPackageDeleteModal = (0, $TusQn.resolveComponent)("SelectionPackageDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $cb8264636fb16ffc$var$_hoisted_1, $cb8264636fb16ffc$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $cb8264636fb16ffc$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("packageDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $cb8264636fb16ffc$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $cb8264636fb16ffc$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $cb8264636fb16ffc$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $cb8264636fb16ffc$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $cb8264636fb16ffc$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name || _ctx.$t("selection")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $cb8264636fb16ffc$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.selectionPackageName), 1)
            ])
        ]),
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getCurrentPackage(), (selectionPackage, i)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: i,
                class: "row"
            }, [
                (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_11, [
                    (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_13, [
                            (0, $TusQn.createElementVNode)("label", $cb8264636fb16ffc$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": ($event)=>selectionPackage.name = $event,
                                type: "text",
                                class: "form-control",
                                id: "name"
                            }, null, 8, $cb8264636fb16ffc$var$_hoisted_15), [
                                [
                                    (0, $eeJ70.vModelText),
                                    selectionPackage.name
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("h4", $cb8264636fb16ffc$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("packageLifeCycleViewModel")), 1),
                    (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_17, [
                        (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_18, [
                            (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_19, [
                                (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_20, [
                                    (0, $TusQn.createElementVNode)("input", {
                                        class: "form-check-input",
                                        onClick: _cache[0] || (_cache[0] = ($event)=>$options.checkAllPackageLifeCycles($event)),
                                        checked: $options.areAllLifeCyclesChecked(),
                                        type: "checkbox",
                                        id: "checked_" + _ctx.o
                                    }, null, 8, $cb8264636fb16ffc$var$_hoisted_21)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_22, [
                                    (0, $TusQn.createElementVNode)("label", $cb8264636fb16ffc$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("area")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_24, [
                                    (0, $TusQn.createElementVNode)("label", $cb8264636fb16ffc$var$_hoisted_25, (0, $8POXm.toDisplayString)(_ctx.$t("assetType")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_26, [
                                    (0, $TusQn.createElementVNode)("label", $cb8264636fb16ffc$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycle")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_28, [
                                    (0, $TusQn.createElementVNode)("label", $cb8264636fb16ffc$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("benefit")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_30, [
                                    (0, $TusQn.createElementVNode)("label", $cb8264636fb16ffc$var$_hoisted_31, (0, $8POXm.toDisplayString)(_ctx.$t("benefitWeight")), 1)
                                ])
                            ])
                        ]),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.packageLifeCycleViewModel, (packageLifeCycle, o)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                class: "mb-3 col-md-12",
                                key: o
                            }, [
                                (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_32, [
                                    (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_33, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            class: "form-check-input",
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.checked = $event,
                                            type: "checkbox",
                                            id: "checked_" + o
                                        }, null, 8, $cb8264636fb16ffc$var$_hoisted_34), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                packageLifeCycle.checked
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_35, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            class: "form-select",
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.selectionGroupId = $event,
                                            disabled: "",
                                            id: "selectionGroupId" + o
                                        }, [
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.selectionGroup, (group, u)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: u,
                                                    value: group.id
                                                }, (0, $8POXm.toDisplayString)(group.name), 9, $cb8264636fb16ffc$var$_hoisted_37);
                                            }), 128))
                                        ], 8, $cb8264636fb16ffc$var$_hoisted_36), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                packageLifeCycle.selectionGroupId
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_38, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.assetTypeId = $event,
                                            disabled: "",
                                            class: "form-select",
                                            id: "assetType" + o
                                        }, [
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.assetTypes, (assetType, u)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: u,
                                                    value: assetType.id
                                                }, (0, $8POXm.toDisplayString)(assetType.name), 9, $cb8264636fb16ffc$var$_hoisted_40);
                                            }), 128))
                                        ], 8, $cb8264636fb16ffc$var$_hoisted_39), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                packageLifeCycle.assetTypeId
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_41, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.lifeCycleId = $event,
                                            disabled: "",
                                            class: "form-select",
                                            id: "lifeCycle" + o
                                        }, [
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.lifeCycles, (lifeCycle, u)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: u,
                                                    value: lifeCycle.id
                                                }, (0, $8POXm.toDisplayString)(lifeCycle.name), 9, $cb8264636fb16ffc$var$_hoisted_43);
                                            }), 128))
                                        ], 8, $cb8264636fb16ffc$var$_hoisted_42), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                packageLifeCycle.lifeCycleId
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_44, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            class: "form-select",
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.benefitId = $event,
                                            disabled: !packageLifeCycle.checked,
                                            id: "benefitId" + o
                                        }, [
                                            (0, $TusQn.createElementVNode)("option", $cb8264636fb16ffc$var$_hoisted_46, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.filteredBenefits(packageLifeCycle.assetTypeId), (benefit, u)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: u,
                                                    value: benefit.id
                                                }, (0, $8POXm.toDisplayString)(benefit.name), 9, $cb8264636fb16ffc$var$_hoisted_47);
                                            }), 128))
                                        ], 8, $cb8264636fb16ffc$var$_hoisted_45), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                packageLifeCycle.benefitId
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_48, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.benefitWeight = $event,
                                            disabled: !packageLifeCycle.checked,
                                            max: "1",
                                            class: "form-control",
                                            id: "benefitWeight_" + o,
                                            type: "number"
                                        }, null, 8, $cb8264636fb16ffc$var$_hoisted_49), [
                                            [
                                                (0, $eeJ70.vModelText),
                                                packageLifeCycle.benefitWeight
                                            ]
                                        ])
                                    ])
                                ])
                            ]);
                        }), 128))
                    ])
                ])
            ]);
        }), 128)),
        (0, $TusQn.createElementVNode)("div", $cb8264636fb16ffc$var$_hoisted_50, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[2] || (_cache[2] = ($event)=>$data.showSelectionPackageDeleteModal = true)
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showSelectionPackageDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_SelectionPackageDeleteModal, {
            key: 0,
            onReload: _cache[4] || (_cache[4] = ($event)=>$options.confirmPackageDelete()),
            onCloseDeleteDialog: _cache[5] || (_cache[5] = ($event)=>$data.showSelectionPackageDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("9ZjXC", function(module, exports) {

$parcel$export(module.exports, "default", () => $74594b4cd5d0f6f3$export$2e2bcd8739ae039);
let $74594b4cd5d0f6f3$var$NOOP = ()=>{};
var $74594b4cd5d0f6f3$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("1tRTX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $11424fa083738f49$export$2e2bcd8739ae039);

var $fmQKt = parcelRequire("fmQKt");

var $8i3Lm = parcelRequire("8i3Lm");

var $l6otV = parcelRequire("l6otV");

var $eHCxc = parcelRequire("eHCxc");

var $j9vnd = parcelRequire("j9vnd");

var $97tK3 = parcelRequire("97tK3");
var $11424fa083738f49$export$2e2bcd8739ae039 = {
    name: "selectionpackage",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        checkAllPackageLifeCycles (event) {
            for(var i in this.packageLifeCycleViewModel){
                var lifeCycle = this.packageLifeCycleViewModel[i];
                lifeCycle.checked = event.target.checked;
            }
        },
        filteredBenefits (assetTypeId) {
            return this.benefits.filter((b)=>b.assetTypeId == assetTypeId);
        },
        getCurrentPackage () {
            var selectionPackage = this.data.selectionPackage.filter((g)=>g.id == 0);
            if (selectionPackage.length > 0) {
                this.selectionPackageName = selectionPackage[0].name;
                return selectionPackage;
            }
        },
        async requestData () {
            this.pending = true;
            var selectionId = this.$route.params.selectionId;
            this.data = await (0, $fmQKt.default).selectionDetail(this.$route.params.id, selectionId);
            var forecast = await (0, $8i3Lm.default).forecastDetail(this.$route.params.id, this.data.forecastId);
            // Inicializace nového package
            this.data.selectionPackage.push({
                id: 0,
                selectionPackageLifeCycle: []
            });
            this.assetTypes = await (0, $eHCxc.default).assetTypeList(this.$route.params.id);
            this.lifeCycles = await (0, $97tK3.default).lifeCycleList(this.$route.params.id);
            var packageLifeCycleViewModel = [];
            this.benefits = await (0, $j9vnd.default).benefitList(this.$route.params.id);
            for(var i in this.data.selectionGroup){
                var group = this.data.selectionGroup[i];
                var groupMultiplicatorForecast = [];
                // group multiplicator = LC - forecast 
                for(var o in forecast.forecastAssetTypes){
                    var assetType = forecast.forecastAssetTypes[o];
                    // ignore not in groups
                    if (group.selectionGroupAssetType.length > 0) {
                        if (group.selectionGroupAssetType.findIndex((a)=>a.assetTypeId == assetType.assetTypeId) == -1) continue;
                    }
                    for(var u in assetType.lifeCycles){
                        var lifeCycleId = assetType.lifeCycles[u];
                        groupMultiplicatorForecast.push({
                            assetTypeId: assetType.assetTypeId,
                            lifeCycleId: lifeCycleId
                        });
                    }
                }
                // for each AT and LC = GROUP
                for(var o in groupMultiplicatorForecast){
                    var object = groupMultiplicatorForecast[o];
                    var assetTypeBenefit = this.benefits.find((b)=>b.assetTypeId == object.assetTypeId);
                    var packageLifeCycleViewModelObject = {
                        benefitId: assetTypeBenefit?.id,
                        benefitWeight: 1,
                        checked: false,
                        selectionPackageId: this.$route.params.packageId,
                        assetTypeId: object.assetTypeId,
                        lifeCycleId: object.lifeCycleId,
                        name: group.name,
                        selectionGroupId: group.id
                    };
                    packageLifeCycleViewModel.push(packageLifeCycleViewModelObject);
                }
            }
            this.packageLifeCycleViewModel = packageLifeCycleViewModel;
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            var selectionPackage = this.data.selectionPackage.find((g)=>g.id == 0);
            if (selectionPackage.name && selectionPackage.name.length > 0) try {
                var selectionPackageLifeCycles = [];
                for(var i in this.packageLifeCycleViewModel){
                    var packageLifeCycle = this.packageLifeCycleViewModel[i];
                    if (packageLifeCycle.checked) selectionPackageLifeCycles.push({
                        "id": packageLifeCycle.id || 0,
                        "selectionPackageId": packageLifeCycle.selectionPackageId,
                        "selectionGroupId": packageLifeCycle.selectionGroupId,
                        "lifeCycleId": packageLifeCycle.lifeCycleId,
                        "benefitId": packageLifeCycle.benefitId,
                        "benefitWeight": packageLifeCycle.benefitWeight
                    });
                }
                selectionPackage.selectionPackageLifeCycle = selectionPackageLifeCycles;
                await (0, $fmQKt.default).selectionUpdate(this.$route.params.id, this.data);
                this.showSuccess();
                this.$router.go(-1);
            } catch  {
                this.showError();
            }
            else this.showEmptyNameError();
        }
    },
    notifications: {
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        },
        showSuccess: {
            title: "success",
            message: "selectionPackageCreated",
            type: "success"
        },
        showError: {
            title: "error",
            message: "selectionPackageError",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionGroups: [],
                selectionPackage: [],
                selectionLimit: []
            },
            selectionPackageName: "",
            assetTypes: [],
            lifeCycles: [],
            benefits: [],
            pending: true,
            modelingName: "",
            packageLifeCycleViewModel: []
        };
    }
};

});

parcelRegister("5bnwW", function(module, exports) {

$parcel$export(module.exports, "render", () => $3c603b7c0c709dbc$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $3c603b7c0c709dbc$var$_hoisted_1 = {
    key: 0
};
const $3c603b7c0c709dbc$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $3c603b7c0c709dbc$var$_hoisted_3 = [
    $3c603b7c0c709dbc$var$_hoisted_2
];
const $3c603b7c0c709dbc$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $3c603b7c0c709dbc$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $3c603b7c0c709dbc$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $3c603b7c0c709dbc$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $3c603b7c0c709dbc$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $3c603b7c0c709dbc$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $3c603b7c0c709dbc$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $3c603b7c0c709dbc$var$_hoisted_11 = {
    class: "mb-3"
};
const $3c603b7c0c709dbc$var$_hoisted_12 = {
    class: "row"
};
const $3c603b7c0c709dbc$var$_hoisted_13 = {
    class: "mb-3 col-md-4"
};
const $3c603b7c0c709dbc$var$_hoisted_14 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $3c603b7c0c709dbc$var$_hoisted_15 = [
    "onUpdate:modelValue"
];
const $3c603b7c0c709dbc$var$_hoisted_16 = {
    class: "form-label",
    for: "costFactor",
    required: ""
};
const $3c603b7c0c709dbc$var$_hoisted_17 = {
    class: "row"
};
const $3c603b7c0c709dbc$var$_hoisted_18 = {
    class: "mb-3 col-md-12"
};
const $3c603b7c0c709dbc$var$_hoisted_19 = {
    class: "row"
};
const $3c603b7c0c709dbc$var$_hoisted_20 = {
    class: "col-md-1"
};
const $3c603b7c0c709dbc$var$_hoisted_21 = [
    "id"
];
const $3c603b7c0c709dbc$var$_hoisted_22 = {
    class: "col-md-2"
};
const $3c603b7c0c709dbc$var$_hoisted_23 = {
    class: "form-label"
};
const $3c603b7c0c709dbc$var$_hoisted_24 = {
    class: "col-md-2"
};
const $3c603b7c0c709dbc$var$_hoisted_25 = {
    class: "form-label"
};
const $3c603b7c0c709dbc$var$_hoisted_26 = {
    class: "col-md-3"
};
const $3c603b7c0c709dbc$var$_hoisted_27 = {
    class: "form-label"
};
const $3c603b7c0c709dbc$var$_hoisted_28 = {
    class: "col-md-2"
};
const $3c603b7c0c709dbc$var$_hoisted_29 = {
    class: "form-label"
};
const $3c603b7c0c709dbc$var$_hoisted_30 = {
    class: "col-md-2"
};
const $3c603b7c0c709dbc$var$_hoisted_31 = {
    class: "form-label"
};
const $3c603b7c0c709dbc$var$_hoisted_32 = {
    class: "row"
};
const $3c603b7c0c709dbc$var$_hoisted_33 = {
    class: "col-md-1"
};
const $3c603b7c0c709dbc$var$_hoisted_34 = [
    "onUpdate:modelValue",
    "id"
];
const $3c603b7c0c709dbc$var$_hoisted_35 = {
    class: "col-md-2"
};
const $3c603b7c0c709dbc$var$_hoisted_36 = [
    "onUpdate:modelValue",
    "id"
];
const $3c603b7c0c709dbc$var$_hoisted_37 = [
    "value"
];
const $3c603b7c0c709dbc$var$_hoisted_38 = {
    class: "col-md-2"
};
const $3c603b7c0c709dbc$var$_hoisted_39 = [
    "onUpdate:modelValue",
    "id"
];
const $3c603b7c0c709dbc$var$_hoisted_40 = [
    "value"
];
const $3c603b7c0c709dbc$var$_hoisted_41 = {
    class: "col-md-3"
};
const $3c603b7c0c709dbc$var$_hoisted_42 = [
    "onUpdate:modelValue",
    "id"
];
const $3c603b7c0c709dbc$var$_hoisted_43 = [
    "value"
];
const $3c603b7c0c709dbc$var$_hoisted_44 = {
    class: "col-md-2"
};
const $3c603b7c0c709dbc$var$_hoisted_45 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $3c603b7c0c709dbc$var$_hoisted_46 = {
    value: ""
};
const $3c603b7c0c709dbc$var$_hoisted_47 = [
    "value"
];
const $3c603b7c0c709dbc$var$_hoisted_48 = {
    class: "col-md-2"
};
const $3c603b7c0c709dbc$var$_hoisted_49 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $3c603b7c0c709dbc$var$_hoisted_50 = {
    class: "d-grid gap-2 d-md-flex"
};
function $3c603b7c0c709dbc$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $3c603b7c0c709dbc$var$_hoisted_1, $3c603b7c0c709dbc$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $3c603b7c0c709dbc$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("packageCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $3c603b7c0c709dbc$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $3c603b7c0c709dbc$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $3c603b7c0c709dbc$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $3c603b7c0c709dbc$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $3c603b7c0c709dbc$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name || _ctx.$t("selection")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $3c603b7c0c709dbc$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getCurrentPackage(), (selectionPackage, i)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: i,
                class: "row"
            }, [
                (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_11, [
                    (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_13, [
                            (0, $TusQn.createElementVNode)("label", $3c603b7c0c709dbc$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": ($event)=>selectionPackage.name = $event,
                                type: "text",
                                class: "form-control",
                                id: "name"
                            }, null, 8, $3c603b7c0c709dbc$var$_hoisted_15), [
                                [
                                    (0, $eeJ70.vModelText),
                                    selectionPackage.name
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("h4", $3c603b7c0c709dbc$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("packageLifeCycleViewModel")), 1),
                    (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_17, [
                        (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_18, [
                            (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_19, [
                                (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_20, [
                                    (0, $TusQn.createElementVNode)("input", {
                                        class: "form-check-input",
                                        onClick: _cache[0] || (_cache[0] = ($event)=>$options.checkAllPackageLifeCycles($event)),
                                        type: "checkbox",
                                        id: "checked_" + _ctx.o
                                    }, null, 8, $3c603b7c0c709dbc$var$_hoisted_21)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_22, [
                                    (0, $TusQn.createElementVNode)("label", $3c603b7c0c709dbc$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("area")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_24, [
                                    (0, $TusQn.createElementVNode)("label", $3c603b7c0c709dbc$var$_hoisted_25, (0, $8POXm.toDisplayString)(_ctx.$t("assetType")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_26, [
                                    (0, $TusQn.createElementVNode)("label", $3c603b7c0c709dbc$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("lifeCycle")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_28, [
                                    (0, $TusQn.createElementVNode)("label", $3c603b7c0c709dbc$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("benefit")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_30, [
                                    (0, $TusQn.createElementVNode)("label", $3c603b7c0c709dbc$var$_hoisted_31, (0, $8POXm.toDisplayString)(_ctx.$t("benefitWeight")), 1)
                                ])
                            ])
                        ]),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.packageLifeCycleViewModel, (packageLifeCycle, o)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                class: "mb-3 col-md-12",
                                key: o
                            }, [
                                (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_32, [
                                    (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_33, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            class: "form-check-input",
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.checked = $event,
                                            type: "checkbox",
                                            id: "checked_" + o
                                        }, null, 8, $3c603b7c0c709dbc$var$_hoisted_34), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                packageLifeCycle.checked
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_35, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            class: "form-select",
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.selectionGroupId = $event,
                                            disabled: "",
                                            id: "selectionGroupId" + o
                                        }, [
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.selectionGroup, (group, u)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: u,
                                                    value: group.id
                                                }, (0, $8POXm.toDisplayString)(group.name), 9, $3c603b7c0c709dbc$var$_hoisted_37);
                                            }), 128))
                                        ], 8, $3c603b7c0c709dbc$var$_hoisted_36), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                packageLifeCycle.selectionGroupId
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_38, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.assetTypeId = $event,
                                            disabled: "",
                                            class: "form-select",
                                            id: "assetType" + o
                                        }, [
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.assetTypes, (assetType, u)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: u,
                                                    value: assetType.id
                                                }, (0, $8POXm.toDisplayString)(assetType.name), 9, $3c603b7c0c709dbc$var$_hoisted_40);
                                            }), 128))
                                        ], 8, $3c603b7c0c709dbc$var$_hoisted_39), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                packageLifeCycle.assetTypeId
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_41, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.lifeCycleId = $event,
                                            disabled: "",
                                            class: "form-select",
                                            id: "lifeCycle" + o
                                        }, [
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.lifeCycles, (lifeCycle, u)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: u,
                                                    value: lifeCycle.id
                                                }, (0, $8POXm.toDisplayString)(lifeCycle.name), 9, $3c603b7c0c709dbc$var$_hoisted_43);
                                            }), 128))
                                        ], 8, $3c603b7c0c709dbc$var$_hoisted_42), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                packageLifeCycle.lifeCycleId
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_44, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            class: "form-select",
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.benefitId = $event,
                                            disabled: !packageLifeCycle.checked,
                                            id: "benefitId" + o
                                        }, [
                                            (0, $TusQn.createElementVNode)("option", $3c603b7c0c709dbc$var$_hoisted_46, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.filteredBenefits(packageLifeCycle.assetTypeId), (benefit, u)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: u,
                                                    value: benefit.id
                                                }, (0, $8POXm.toDisplayString)(benefit.name), 9, $3c603b7c0c709dbc$var$_hoisted_47);
                                            }), 128))
                                        ], 8, $3c603b7c0c709dbc$var$_hoisted_45), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                packageLifeCycle.benefitId
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_48, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            "onUpdate:modelValue": ($event)=>packageLifeCycle.benefitWeight = $event,
                                            disabled: !packageLifeCycle.checked,
                                            max: "1",
                                            class: "form-control",
                                            id: "benefitWeight_" + o,
                                            type: "number"
                                        }, null, 8, $3c603b7c0c709dbc$var$_hoisted_49), [
                                            [
                                                (0, $eeJ70.vModelText),
                                                packageLifeCycle.benefitWeight
                                            ]
                                        ])
                                    ])
                                ])
                            ]);
                        }), 128))
                    ])
                ])
            ]);
        }), 128)),
        (0, $TusQn.createElementVNode)("div", $3c603b7c0c709dbc$var$_hoisted_50, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("eJLt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $abaa16c622528b21$export$2e2bcd8739ae039);
let $abaa16c622528b21$var$NOOP = ()=>{};
var $abaa16c622528b21$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("c0RzE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8bef0acf4a17f342$export$2e2bcd8739ae039);

var $fmQKt = parcelRequire("fmQKt");

var $8i3Lm = parcelRequire("8i3Lm");

var $l6otV = parcelRequire("l6otV");

var $eHCxc = parcelRequire("eHCxc");

var $bAEqO = parcelRequire("bAEqO");

var $3hVz4 = parcelRequire("3hVz4");

var $gOjKo = parcelRequire("gOjKo");
var $8bef0acf4a17f342$export$2e2bcd8739ae039 = {
    name: "selectionLimitdetail",
    watch: {
        $route: "requestData"
    },
    components: {
        SelectionLimitPackageYearDialog: $bAEqO.default,
        SelectionLimitDeleteModal: $3hVz4.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async confirmLimitDelete () {
            this.pending = true;
            this.data.selectionLimit = this.data.selectionLimit.filter((l)=>l.id != this.$route.params.limitId);
            await (0, $fmQKt.default).selectionUpdate(this.$route.params.id, this.data);
            this.$router.push({
                path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}`
            });
        },
        updateYearlyLimits (limitPackage) {
            if (limitPackage.inputMethod == "yearly") for(var i in limitPackage.selectionLimitPackageYear){
                var year = limitPackage.selectionLimitPackageYear[i];
                year.limitValue = limitPackage.limitValue;
            }
            else if (limitPackage.inputMethod == "divided") {
                var value = (limitPackage.limitValue * limitPackage.totalLimitValue) ?? 0;
                for(var i in limitPackage.selectionLimitPackageYear){
                    var year = limitPackage.selectionLimitPackageYear[i];
                    year.limitValue = value;
                }
            }
        },
        getSelectionPackageName (id) {
            var foundPackage = this.data.selectionPackage.find((s)=>s.id == id);
            if (foundPackage) return foundPackage.name;
        },
        showSelectionLimitPackageYear (limitPackage) {
            this.currentSelectionLimitPackage = limitPackage;
            this.disableEditForCurrentYears = limitPackage.inputMethod != "custom";
            this.showSelectionLimitPackageYearDialog = true;
        },
        getCurrentLimit () {
            var limit = this.data.selectionLimit.filter((g)=>g.id == this.$route.params.limitId);
            if (limit.length > 0) {
                this.selectionLimitName = limit[0].name;
                return limit;
            }
        },
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var selectionId = this.$route.params.selectionId;
            this.data = await (0, $fmQKt.default).selectionDetail(this.$route.params.id, selectionId);
            var forecast = await (0, $8i3Lm.default).forecastDetail(this.$route.params.id, this.data.forecastId);
            var years = [];
            for(let year = forecast.startYear; year <= forecast.endYear; year++)years.push(year);
            var currentLimit = this.data.selectionLimit.find((g)=>g.id == this.$route.params.limitId);
            var selectionLimitPackages = [];
            for(var i in this.data.selectionPackage){
                var selectionPackage = this.data.selectionPackage[i];
                var selectionPackageObject = {
                    checked: false,
                    selectionPackageId: selectionPackage.id,
                    totalLimitValue: null,
                    limitValue: null,
                    inputMethod: "",
                    unlimited: false,
                    selectionLimitPackageYear: years.map((y)=>{
                        return {
                            year: y,
                            limitValue: 0
                        };
                    }),
                    limitId: this.$route.params.limitId
                };
                var foundSelectionLimitPackage = currentLimit?.selectionLimitPackage?.find((v)=>v.selectionPackageId == selectionPackage.id);
                if (foundSelectionLimitPackage) {
                    selectionPackageObject.id = foundSelectionLimitPackage.id;
                    selectionPackageObject.checked = true;
                    selectionPackageObject.selectionPackageId = foundSelectionLimitPackage.selectionPackageId;
                    selectionPackageObject.totalLimitValue = foundSelectionLimitPackage.totalLimitValue;
                    selectionPackageObject.limitValue = foundSelectionLimitPackage.limitValue;
                    selectionPackageObject.inputMethod = foundSelectionLimitPackage.inputMethod;
                    selectionPackageObject.unlimited = foundSelectionLimitPackage.unlimited;
                    var selectionLimitPackageYears = [];
                    for(var o in years){
                        var year = years[o];
                        var foundYear = foundSelectionLimitPackage.selectionLimitPackageYear.find((s)=>s.year == year);
                        selectionLimitPackageYears.push({
                            year: year,
                            limitValue: foundYear?.limitValue || 0
                        });
                    }
                    selectionPackageObject.selectionLimitPackageYear = selectionLimitPackageYears;
                }
                selectionLimitPackages.push(selectionPackageObject);
            }
            this.selectionLimitPackages = selectionLimitPackages;
            var assetTypes = await (0, $eHCxc.default).assetTypeList(this.$route.params.id);
            this.assetTypes = assetTypes.filter((f)=>forecast.forecastAssetTypes.findIndex((a)=>a.assetTypeId == f.id) >= 0);
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            try {
                var selectionLimit = this.data.selectionLimit.find((g)=>g.id == this.$route.params.limitId);
                if (selectionLimit.name.length > 0) {
                    var selectionLimitPackages = [];
                    for(var i in this.selectionLimitPackages){
                        var limitPackage = this.selectionLimitPackages[i];
                        var limitPackageObject = {
                            "id": limitPackage.id || 0,
                            "selectionPackageId": limitPackage.selectionPackageId,
                            "totalLimitValue": limitPackage.totalLimitValue,
                            "limitValue": limitPackage.limitValue,
                            "unlimited": limitPackage.unlimited,
                            "inputMethod": limitPackage.inputMethod,
                            "selectionLimitPackageYear": limitPackage.selectionLimitPackageYear
                        };
                        if (limitPackage.checked) {
                            if (limitPackage.unlimited) {
                                limitPackageObject.totalLimitValue = null;
                                limitPackageObject.limitValue = 0;
                                limitPackageObject.inputMethod = "";
                                limitPackageObject.selectionLimitPackageYear = [];
                            }
                            if (limitPackageObject.totalLimitValue === "") limitPackageObject.totalLimitValue = null;
                            if (limitPackageObject.limitValue === "") limitPackageObject.limitValue = null;
                            selectionLimitPackages.push(limitPackageObject);
                        }
                    }
                    var foundInvalid = selectionLimitPackages.find((s)=>!s.unlimited && s.limitValue == null);
                    if (foundInvalid) this.showEmptyInputsError();
                    else {
                        selectionLimit.selectionLimitPackage = selectionLimitPackages;
                        await (0, $fmQKt.default).selectionUpdate(this.$route.params.id, this.data);
                        this.showSuccess();
                    }
                } else this.showEmptyNameError();
            } catch  {
                this.showError();
            }
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "selectionLimitUpdated",
            type: "success"
        },
        showError: {
            title: "error",
            message: "selectionLimitErrorUpdate!",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        },
        showEmptyInputsError: {
            title: "error",
            message: "limitPackagesMissingValues",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionGroup: [],
                selectionPackage: [],
                selectionLimit: []
            },
            selectionLimitName: "",
            years: [],
            assetTypes: [],
            pending: true,
            modelingName: "",
            selectionLimitPackages: [],
            showSelectionLimitPackageYearDialog: false,
            showSelectionLimitDeleteModal: false,
            currentSelectionLimitPackage: {
                selectionLimitPackageYear: []
            },
            disableEditForCurrentYears: false,
            isUserAdmin: false
        };
    }
};

});
parcelRegister("bAEqO", function(module, exports) {

$parcel$export(module.exports, "default", () => $87026b5cd083c84a$export$2e2bcd8739ae039);
let $87026b5cd083c84a$var$script;



let $87026b5cd083c84a$var$initialize = ()=>{
    $87026b5cd083c84a$var$script = (parcelRequire("1bQkW"));
    if ($87026b5cd083c84a$var$script.__esModule) $87026b5cd083c84a$var$script = $87026b5cd083c84a$var$script.default;
    $87026b5cd083c84a$var$script.render = (parcelRequire("l18OD")).render;
    (parcelRequire("jW6PW")).default($87026b5cd083c84a$var$script);
    $87026b5cd083c84a$var$script.__scopeId = "data-v-c317b1";
    $87026b5cd083c84a$var$script.__file = "SelectionLimitPackageYearDialog.vue";
};
$87026b5cd083c84a$var$initialize();
var $87026b5cd083c84a$export$2e2bcd8739ae039 = $87026b5cd083c84a$var$script;

});
parcelRegister("1bQkW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0ddf6a8591d9294e$export$2e2bcd8739ae039);
var $0ddf6a8591d9294e$export$2e2bcd8739ae039 = {
    name: "SelectionLimitPackageYearDialog",
    methods: {
        close () {
            this.$emit("close");
        },
        confirm () {
            this.$emit("confirm");
        }
    },
    data () {
        return {
            list: [],
            selectedRadio: {}
        };
    }
};

});

parcelRegister("l18OD", function(module, exports) {

$parcel$export(module.exports, "render", () => $f4d087907ec9042a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $f4d087907ec9042a$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
};
const $f4d087907ec9042a$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl",
    role: "document"
};
const $f4d087907ec9042a$var$_hoisted_3 = {
    class: "modal-content",
    style: {
        "width": "1140px"
    }
};
const $f4d087907ec9042a$var$_hoisted_4 = {
    class: "modal-header"
};
const $f4d087907ec9042a$var$_hoisted_5 = {
    class: "modal-title"
};
const $f4d087907ec9042a$var$_hoisted_6 = {
    class: "modal-body"
};
const $f4d087907ec9042a$var$_hoisted_7 = {
    key: 0,
    class: "table-responsive"
};
const $f4d087907ec9042a$var$_hoisted_8 = {
    class: "table"
};
const $f4d087907ec9042a$var$_hoisted_9 = {
    scope: "col"
};
const $f4d087907ec9042a$var$_hoisted_10 = {
    scope: "col"
};
const $f4d087907ec9042a$var$_hoisted_11 = {
    scope: "row"
};
const $f4d087907ec9042a$var$_hoisted_12 = [
    "onUpdate:modelValue",
    "id"
];
const $f4d087907ec9042a$var$_hoisted_13 = {
    scope: "row"
};
const $f4d087907ec9042a$var$_hoisted_14 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $f4d087907ec9042a$var$_hoisted_15 = {
    class: "modal-footer"
};
function $f4d087907ec9042a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $f4d087907ec9042a$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $f4d087907ec9042a$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $f4d087907ec9042a$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $f4d087907ec9042a$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $f4d087907ec9042a$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("selectionLimitPackageYears")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $f4d087907ec9042a$var$_hoisted_6, [
                                this.$parent.currentSelectionLimitPackage.selectionLimitPackageYear.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $f4d087907ec9042a$var$_hoisted_7, [
                                    (0, $TusQn.createElementVNode)("table", $f4d087907ec9042a$var$_hoisted_8, [
                                        (0, $TusQn.createElementVNode)("thead", null, [
                                            (0, $TusQn.createElementVNode)("tr", null, [
                                                (0, $TusQn.createElementVNode)("th", $f4d087907ec9042a$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("predictiveYear")), 1),
                                                (0, $TusQn.createElementVNode)("th", $f4d087907ec9042a$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("limit")), 1)
                                            ])
                                        ]),
                                        (0, $TusQn.createElementVNode)("tbody", null, [
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(this.$parent.currentSelectionLimitPackage.selectionLimitPackageYear, (packageYear, i)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                                    class: "align-middle",
                                                    key: i
                                                }, [
                                                    (0, $TusQn.createElementVNode)("th", $f4d087907ec9042a$var$_hoisted_11, [
                                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                            "onUpdate:modelValue": ($event)=>packageYear.year = $event,
                                                            disabled: "",
                                                            type: "text",
                                                            class: "form-control",
                                                            id: "year_" + i
                                                        }, null, 8, $f4d087907ec9042a$var$_hoisted_12), [
                                                            [
                                                                (0, $eeJ70.vModelText),
                                                                packageYear.year
                                                            ]
                                                        ])
                                                    ]),
                                                    (0, $TusQn.createElementVNode)("th", $f4d087907ec9042a$var$_hoisted_13, [
                                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                            "onUpdate:modelValue": ($event)=>packageYear.limitValue = $event,
                                                            disabled: this.$parent.currentSelectionLimitPackage.inputMethod != "custom",
                                                            type: "number",
                                                            class: "form-control",
                                                            id: "limitValue" + i
                                                        }, null, 8, $f4d087907ec9042a$var$_hoisted_14), [
                                                            [
                                                                (0, $eeJ70.vModelText),
                                                                packageYear.limitValue
                                                            ]
                                                        ])
                                                    ])
                                                ]);
                                            }), 128))
                                        ])
                                    ])
                                ])) : (0, $TusQn.createCommentVNode)("", true)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $f4d087907ec9042a$var$_hoisted_15, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.confirm && $options.confirm(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("confirm")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("jW6PW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e838bcb79f8c7a13$export$2e2bcd8739ae039);
let $e838bcb79f8c7a13$var$NOOP = ()=>{};
var $e838bcb79f8c7a13$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("3hVz4", function(module, exports) {

$parcel$export(module.exports, "default", () => $264f9cc7eb85925b$export$2e2bcd8739ae039);
let $264f9cc7eb85925b$var$script;



let $264f9cc7eb85925b$var$initialize = ()=>{
    $264f9cc7eb85925b$var$script = (parcelRequire("83QQH"));
    if ($264f9cc7eb85925b$var$script.__esModule) $264f9cc7eb85925b$var$script = $264f9cc7eb85925b$var$script.default;
    $264f9cc7eb85925b$var$script.render = (parcelRequire("aQFEZ")).render;
    (parcelRequire("5Ongx")).default($264f9cc7eb85925b$var$script);
    $264f9cc7eb85925b$var$script.__scopeId = "data-v-648efa";
    $264f9cc7eb85925b$var$script.__file = "SelectionLimitDeleteModal.vue";
};
$264f9cc7eb85925b$var$initialize();
var $264f9cc7eb85925b$export$2e2bcd8739ae039 = $264f9cc7eb85925b$var$script;

});
parcelRegister("83QQH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5de7993cebf7d090$export$2e2bcd8739ae039);
var $5de7993cebf7d090$export$2e2bcd8739ae039 = {
    name: "selectionLimitDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteLimitSelection () {
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("aQFEZ", function(module, exports) {

$parcel$export(module.exports, "render", () => $7e5f138d0862df43$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $7e5f138d0862df43$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $7e5f138d0862df43$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $7e5f138d0862df43$var$_hoisted_3 = {
    class: "modal-content"
};
const $7e5f138d0862df43$var$_hoisted_4 = {
    class: "modal-header"
};
const $7e5f138d0862df43$var$_hoisted_5 = {
    class: "modal-title"
};
const $7e5f138d0862df43$var$_hoisted_6 = {
    class: "modal-body"
};
const $7e5f138d0862df43$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0"
    }
};
const $7e5f138d0862df43$var$_hoisted_8 = {
    class: "modal-footer"
};
function $7e5f138d0862df43$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $7e5f138d0862df43$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $7e5f138d0862df43$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $7e5f138d0862df43$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $7e5f138d0862df43$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $7e5f138d0862df43$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("selectionLimitDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $7e5f138d0862df43$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", $7e5f138d0862df43$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisSelectionLimit")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $7e5f138d0862df43$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteLimitSelection && $options.deleteLimitSelection(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("5Ongx", function(module, exports) {

$parcel$export(module.exports, "default", () => $43b3ab5c5fad1d14$export$2e2bcd8739ae039);
let $43b3ab5c5fad1d14$var$NOOP = ()=>{};
var $43b3ab5c5fad1d14$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("81ijN", function(module, exports) {

$parcel$export(module.exports, "render", () => $5d6ca05d36e327b9$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $5d6ca05d36e327b9$var$_hoisted_1 = {
    key: 0
};
const $5d6ca05d36e327b9$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $5d6ca05d36e327b9$var$_hoisted_3 = [
    $5d6ca05d36e327b9$var$_hoisted_2
];
const $5d6ca05d36e327b9$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $5d6ca05d36e327b9$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $5d6ca05d36e327b9$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $5d6ca05d36e327b9$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $5d6ca05d36e327b9$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $5d6ca05d36e327b9$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $5d6ca05d36e327b9$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $5d6ca05d36e327b9$var$_hoisted_11 = {
    class: "mb-3"
};
const $5d6ca05d36e327b9$var$_hoisted_12 = {
    class: "row"
};
const $5d6ca05d36e327b9$var$_hoisted_13 = {
    class: "mb-3 col-md-4"
};
const $5d6ca05d36e327b9$var$_hoisted_14 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $5d6ca05d36e327b9$var$_hoisted_15 = [
    "onUpdate:modelValue"
];
const $5d6ca05d36e327b9$var$_hoisted_16 = {
    class: "form-label",
    for: "costFactor",
    required: ""
};
const $5d6ca05d36e327b9$var$_hoisted_17 = {
    class: "row"
};
const $5d6ca05d36e327b9$var$_hoisted_18 = {
    class: "mb-3 col-md-12"
};
const $5d6ca05d36e327b9$var$_hoisted_19 = {
    class: "row"
};
const $5d6ca05d36e327b9$var$_hoisted_20 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "col-md-1"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
        class: "form-label"
    })
], -1);
const $5d6ca05d36e327b9$var$_hoisted_21 = {
    class: "col-md-3"
};
const $5d6ca05d36e327b9$var$_hoisted_22 = {
    class: "form-label"
};
const $5d6ca05d36e327b9$var$_hoisted_23 = {
    class: "col-md-1"
};
const $5d6ca05d36e327b9$var$_hoisted_24 = {
    class: "form-label"
};
const $5d6ca05d36e327b9$var$_hoisted_25 = {
    class: "col-md-2"
};
const $5d6ca05d36e327b9$var$_hoisted_26 = {
    class: "form-label"
};
const $5d6ca05d36e327b9$var$_hoisted_27 = {
    class: "col-md-2"
};
const $5d6ca05d36e327b9$var$_hoisted_28 = {
    class: "form-label"
};
const $5d6ca05d36e327b9$var$_hoisted_29 = {
    class: "col-md-2"
};
const $5d6ca05d36e327b9$var$_hoisted_30 = {
    class: "form-label"
};
const $5d6ca05d36e327b9$var$_hoisted_31 = {
    class: "row"
};
const $5d6ca05d36e327b9$var$_hoisted_32 = {
    class: "col-md-1 mb-auto mt-auto"
};
const $5d6ca05d36e327b9$var$_hoisted_33 = [
    "onUpdate:modelValue",
    "id"
];
const $5d6ca05d36e327b9$var$_hoisted_34 = {
    class: "col-md-3"
};
const $5d6ca05d36e327b9$var$_hoisted_35 = [
    "value",
    "id"
];
const $5d6ca05d36e327b9$var$_hoisted_36 = {
    class: "col-md-1 mb-auto mt-auto"
};
const $5d6ca05d36e327b9$var$_hoisted_37 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $5d6ca05d36e327b9$var$_hoisted_38 = {
    class: "col-md-2"
};
const $5d6ca05d36e327b9$var$_hoisted_39 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $5d6ca05d36e327b9$var$_hoisted_40 = {
    class: "col-md-2"
};
const $5d6ca05d36e327b9$var$_hoisted_41 = [
    "onUpdate:modelValue",
    "disabled",
    "onInput",
    "id"
];
const $5d6ca05d36e327b9$var$_hoisted_42 = {
    class: "col-md-2"
};
const $5d6ca05d36e327b9$var$_hoisted_43 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $5d6ca05d36e327b9$var$_hoisted_44 = {
    value: "",
    disabled: ""
};
const $5d6ca05d36e327b9$var$_hoisted_45 = {
    value: "custom"
};
const $5d6ca05d36e327b9$var$_hoisted_46 = {
    value: "yearly"
};
const $5d6ca05d36e327b9$var$_hoisted_47 = {
    value: "divided"
};
const $5d6ca05d36e327b9$var$_hoisted_48 = {
    class: "col-md-1"
};
const $5d6ca05d36e327b9$var$_hoisted_49 = [
    "onClick"
];
const $5d6ca05d36e327b9$var$_hoisted_50 = {
    class: "d-grid gap-2 d-md-flex"
};
function $5d6ca05d36e327b9$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_SelectionLimitPackageYearDialog = (0, $TusQn.resolveComponent)("SelectionLimitPackageYearDialog");
    const _component_SelectionLimitDeleteModal = (0, $TusQn.resolveComponent)("SelectionLimitDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5d6ca05d36e327b9$var$_hoisted_1, $5d6ca05d36e327b9$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5d6ca05d36e327b9$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("limitDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $5d6ca05d36e327b9$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $5d6ca05d36e327b9$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $5d6ca05d36e327b9$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $5d6ca05d36e327b9$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $5d6ca05d36e327b9$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name || _ctx.$t("selection")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $5d6ca05d36e327b9$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.selectionLimitName), 1)
            ])
        ]),
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getCurrentLimit(), (limit, i)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: i,
                class: "row"
            }, [
                (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_11, [
                    (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_13, [
                            (0, $TusQn.createElementVNode)("label", $5d6ca05d36e327b9$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": ($event)=>limit.name = $event,
                                type: "text",
                                class: "form-control",
                                id: "name"
                            }, null, 8, $5d6ca05d36e327b9$var$_hoisted_15), [
                                [
                                    (0, $eeJ70.vModelText),
                                    limit.name
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("h4", $5d6ca05d36e327b9$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("selectionLimitPackages")), 1),
                    (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_17, [
                        (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_18, [
                            (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_19, [
                                $5d6ca05d36e327b9$var$_hoisted_20,
                                (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_21, [
                                    (0, $TusQn.createElementVNode)("label", $5d6ca05d36e327b9$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("package")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_23, [
                                    (0, $TusQn.createElementVNode)("label", $5d6ca05d36e327b9$var$_hoisted_24, (0, $8POXm.toDisplayString)(_ctx.$t("unlimited")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_25, [
                                    (0, $TusQn.createElementVNode)("label", $5d6ca05d36e327b9$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("totalLimitValue")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_27, [
                                    (0, $TusQn.createElementVNode)("label", $5d6ca05d36e327b9$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("limitValue")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_29, [
                                    (0, $TusQn.createElementVNode)("label", $5d6ca05d36e327b9$var$_hoisted_30, (0, $8POXm.toDisplayString)(_ctx.$t("inputMethod")), 1)
                                ])
                            ])
                        ]),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.selectionLimitPackages, (limitPackage, o)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                class: "mb-3 col-md-12",
                                key: o
                            }, [
                                (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_31, [
                                    (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_32, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            class: "form-check-input",
                                            "onUpdate:modelValue": ($event)=>limitPackage.checked = $event,
                                            type: "checkbox",
                                            id: "checked_" + o
                                        }, null, 8, $5d6ca05d36e327b9$var$_hoisted_33), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                limitPackage.checked
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_34, [
                                        (0, $TusQn.createElementVNode)("input", {
                                            class: "form-control",
                                            disabled: "",
                                            value: $options.getSelectionPackageName(limitPackage.selectionPackageId),
                                            type: "text",
                                            id: "package" + o
                                        }, null, 8, $5d6ca05d36e327b9$var$_hoisted_35)
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_36, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            "onUpdate:modelValue": ($event)=>limitPackage.unlimited = $event,
                                            disabled: !limitPackage.checked,
                                            class: "form-check-input",
                                            id: "unlimited" + o,
                                            type: "checkbox"
                                        }, null, 8, $5d6ca05d36e327b9$var$_hoisted_37), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                limitPackage.unlimited
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_38, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            "onUpdate:modelValue": ($event)=>limitPackage.totalLimitValue = $event,
                                            disabled: !limitPackage.checked || limitPackage.unlimited,
                                            class: "form-control",
                                            id: "totalLimitValue" + o,
                                            type: "number"
                                        }, null, 8, $5d6ca05d36e327b9$var$_hoisted_39), [
                                            [
                                                (0, $eeJ70.vModelText),
                                                limitPackage.totalLimitValue
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_40, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            "onUpdate:modelValue": ($event)=>limitPackage.limitValue = $event,
                                            disabled: !limitPackage.checked || limitPackage.unlimited,
                                            onInput: ($event)=>$options.updateYearlyLimits(limitPackage),
                                            class: "form-control",
                                            id: "limitValue" + o,
                                            type: "number"
                                        }, null, 40, $5d6ca05d36e327b9$var$_hoisted_41), [
                                            [
                                                (0, $eeJ70.vModelText),
                                                limitPackage.limitValue
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_42, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>limitPackage.inputMethod = $event,
                                            disabled: !limitPackage.checked || limitPackage.unlimited,
                                            class: "form-select",
                                            id: "inputMethod" + o
                                        }, [
                                            (0, $TusQn.createElementVNode)("option", $5d6ca05d36e327b9$var$_hoisted_44, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                            (0, $TusQn.createElementVNode)("option", $5d6ca05d36e327b9$var$_hoisted_45, (0, $8POXm.toDisplayString)(_ctx.$t("custom")), 1),
                                            (0, $TusQn.createElementVNode)("option", $5d6ca05d36e327b9$var$_hoisted_46, (0, $8POXm.toDisplayString)(_ctx.$t("yearly")), 1),
                                            (0, $TusQn.createElementVNode)("option", $5d6ca05d36e327b9$var$_hoisted_47, (0, $8POXm.toDisplayString)(_ctx.$t("divided")), 1)
                                        ], 8, $5d6ca05d36e327b9$var$_hoisted_43), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                limitPackage.inputMethod
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_48, [
                                        (0, $TusQn.createElementVNode)("button", {
                                            class: "btn btn-secondary",
                                            onClick: ($event)=>$options.showSelectionLimitPackageYear(limitPackage)
                                        }, (0, $8POXm.toDisplayString)(_ctx.$t("years")), 9, $5d6ca05d36e327b9$var$_hoisted_49)
                                    ])
                                ])
                            ]);
                        }), 128))
                    ])
                ])
            ]);
        }), 128)),
        (0, $TusQn.createElementVNode)("div", $5d6ca05d36e327b9$var$_hoisted_50, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[1] || (_cache[1] = ($event)=>$data.showSelectionLimitDeleteModal = true)
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_SelectionLimitPackageYearDialog, {
            onClose: _cache[3] || (_cache[3] = ($event)=>$data.showSelectionLimitPackageYearDialog = false),
            onConfirm: _cache[4] || (_cache[4] = ($event)=>$data.showSelectionLimitPackageYearDialog = false)
        }, null, 512), [
            [
                (0, $eeJ70.vShow),
                $data.showSelectionLimitPackageYearDialog
            ]
        ]),
        $data.showSelectionLimitDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_SelectionLimitDeleteModal, {
            key: 0,
            onReload: _cache[5] || (_cache[5] = ($event)=>$options.confirmLimitDelete()),
            onCloseDeleteDialog: _cache[6] || (_cache[6] = ($event)=>$data.showSelectionLimitDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("9RBi4", function(module, exports) {

$parcel$export(module.exports, "default", () => $72e5fd6d41b1c03a$export$2e2bcd8739ae039);
let $72e5fd6d41b1c03a$var$NOOP = ()=>{};
var $72e5fd6d41b1c03a$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("bk5BK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $83e5e98ab7df0e5c$export$2e2bcd8739ae039);

var $fmQKt = parcelRequire("fmQKt");

var $8i3Lm = parcelRequire("8i3Lm");

var $l6otV = parcelRequire("l6otV");

var $eHCxc = parcelRequire("eHCxc");

var $bAEqO = parcelRequire("bAEqO");
var $83e5e98ab7df0e5c$export$2e2bcd8739ae039 = {
    name: "selectionLimitcreate",
    watch: {
        $route: "requestData"
    },
    components: {
        SelectionLimitPackageYearDialog: $bAEqO.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        updateYearlyLimits (limitPackage) {
            if (limitPackage.inputMethod == "yearly") for(var i in limitPackage.selectionLimitPackageYear){
                var year = limitPackage.selectionLimitPackageYear[i];
                year.limitValue = limitPackage.limitValue;
            }
            else if (limitPackage.inputMethod == "divided") {
                var value = (limitPackage.limitValue * limitPackage.totalLimitValue) ?? 0;
                for(var i in limitPackage.selectionLimitPackageYear){
                    var year = limitPackage.selectionLimitPackageYear[i];
                    year.limitValue = value;
                }
            }
        },
        getSelectionPackageName (id) {
            var foundPackage = this.data.selectionPackage.find((s)=>s.id == id);
            if (foundPackage) return foundPackage.name;
        },
        showSelectionLimitPackageYear (limitPackage) {
            this.currentSelectionLimitPackage = limitPackage;
            this.showSelectionLimitPackageYearDialog = true;
        },
        getCurrentLimit () {
            var limit = this.data.selectionLimit.filter((g)=>g.id == 0);
            if (limit.length > 0) {
                this.selectionLimitName = limit[0].name;
                return limit;
            }
        },
        async requestData () {
            this.pending = true;
            var selectionId = this.$route.params.selectionId;
            this.data = await (0, $fmQKt.default).selectionDetail(this.$route.params.id, selectionId);
            // Inicializace nového package
            this.data.selectionLimit.push({
                id: 0,
                selectionLimitPackage: []
            });
            var forecast = await (0, $8i3Lm.default).forecastDetail(this.$route.params.id, this.data.forecastId);
            var years = [];
            for(let year = forecast.startYear; year <= forecast.endYear; year++)years.push(year);
            var selectionLimitPackages = [];
            for(var i in this.data.selectionPackage){
                var selectionPackage = this.data.selectionPackage[i];
                var selectionPackageObject = {
                    checked: false,
                    selectionPackageId: selectionPackage.id,
                    totalLimitValue: null,
                    limitValue: null,
                    inputMethod: "",
                    unlimited: false,
                    selectionLimitPackageYear: years.map((y)=>{
                        return {
                            year: y,
                            limitValue: 0
                        };
                    }),
                    limitId: this.$route.params.limitId
                };
                selectionLimitPackages.push(selectionPackageObject);
            }
            this.selectionLimitPackages = selectionLimitPackages;
            var assetTypes = await (0, $eHCxc.default).assetTypeList(this.$route.params.id);
            this.assetTypes = assetTypes.filter((f)=>forecast.forecastAssetTypes.findIndex((a)=>a.assetTypeId == f.id) >= 0);
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            try {
                var selectionLimit = this.data.selectionLimit.find((g)=>g.id == 0);
                if (selectionLimit.name && selectionLimit.name.length > 0) {
                    var selectionLimitPackages = [];
                    for(var i in this.selectionLimitPackages){
                        var limitPackage = this.selectionLimitPackages[i];
                        var limitPackageObject = {
                            "id": limitPackage.id || 0,
                            "selectionPackageId": limitPackage.selectionPackageId,
                            "totalLimitValue": limitPackage.totalLimitValue,
                            "limitValue": limitPackage.limitValue,
                            "unlimited": limitPackage.unlimited,
                            "inputMethod": limitPackage.inputMethod,
                            "selectionLimitPackageYear": limitPackage.selectionLimitPackageYear
                        };
                        if (limitPackage.checked) {
                            if (limitPackage.unlimited) {
                                limitPackageObject.totalLimitValue = null;
                                limitPackageObject.limitValue = 0;
                                limitPackageObject.inputMethod = "";
                                limitPackageObject.selectionLimitPackageYear = [];
                            }
                            if (limitPackageObject.totalLimitValue === "") limitPackageObject.totalLimitValue = null;
                            if (limitPackageObject.limitValue === "") limitPackageObject.limitValue = null;
                            selectionLimitPackages.push(limitPackageObject);
                        }
                    }
                    var foundInvalid = selectionLimitPackages.find((s)=>!s.unlimited && s.limitValue == null);
                    if (foundInvalid) this.showEmptyInputsError();
                    else {
                        selectionLimit.selectionLimitPackage = selectionLimitPackages;
                        await (0, $fmQKt.default).selectionUpdate(this.$route.params.id, this.data);
                        this.showSuccess();
                        this.$router.go(-1);
                    }
                } else this.showEmptyNameError();
            } catch  {
                this.showError();
            }
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "selectionLimitCreated",
            type: "success"
        },
        showError: {
            title: "error",
            message: "selectionLimitError",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        },
        showEmptyInputsError: {
            title: "error",
            message: "limitPackagesMissingValues",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionGroup: [],
                selectionPackage: [],
                selectionLimit: []
            },
            selectionLimitName: "",
            years: [],
            assetTypes: [],
            pending: true,
            modelingName: "",
            selectionLimitPackages: [],
            showSelectionLimitPackageYearDialog: false,
            currentSelectionLimitPackage: {
                selectionLimitPackageYear: []
            },
            disableEditForCurrentYears: false
        };
    }
};

});

parcelRegister("l17Vw", function(module, exports) {

$parcel$export(module.exports, "render", () => $f4cfd70dfd1f4efb$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $f4cfd70dfd1f4efb$var$_hoisted_1 = {
    key: 0
};
const $f4cfd70dfd1f4efb$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $f4cfd70dfd1f4efb$var$_hoisted_3 = [
    $f4cfd70dfd1f4efb$var$_hoisted_2
];
const $f4cfd70dfd1f4efb$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $f4cfd70dfd1f4efb$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $f4cfd70dfd1f4efb$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $f4cfd70dfd1f4efb$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $f4cfd70dfd1f4efb$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $f4cfd70dfd1f4efb$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $f4cfd70dfd1f4efb$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $f4cfd70dfd1f4efb$var$_hoisted_11 = {
    class: "mb-3"
};
const $f4cfd70dfd1f4efb$var$_hoisted_12 = {
    class: "row"
};
const $f4cfd70dfd1f4efb$var$_hoisted_13 = {
    class: "mb-3 col-md-4"
};
const $f4cfd70dfd1f4efb$var$_hoisted_14 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $f4cfd70dfd1f4efb$var$_hoisted_15 = [
    "onUpdate:modelValue"
];
const $f4cfd70dfd1f4efb$var$_hoisted_16 = {
    class: "form-label",
    for: "costFactor",
    required: ""
};
const $f4cfd70dfd1f4efb$var$_hoisted_17 = {
    class: "row"
};
const $f4cfd70dfd1f4efb$var$_hoisted_18 = {
    class: "mb-3 col-md-12"
};
const $f4cfd70dfd1f4efb$var$_hoisted_19 = {
    class: "row"
};
const $f4cfd70dfd1f4efb$var$_hoisted_20 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "col-md-1"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
        class: "form-label"
    })
], -1);
const $f4cfd70dfd1f4efb$var$_hoisted_21 = {
    class: "col-md-3"
};
const $f4cfd70dfd1f4efb$var$_hoisted_22 = {
    class: "form-label"
};
const $f4cfd70dfd1f4efb$var$_hoisted_23 = {
    class: "col-md-1"
};
const $f4cfd70dfd1f4efb$var$_hoisted_24 = {
    class: "form-label"
};
const $f4cfd70dfd1f4efb$var$_hoisted_25 = {
    class: "col-md-2"
};
const $f4cfd70dfd1f4efb$var$_hoisted_26 = {
    class: "form-label"
};
const $f4cfd70dfd1f4efb$var$_hoisted_27 = {
    class: "col-md-2"
};
const $f4cfd70dfd1f4efb$var$_hoisted_28 = {
    class: "form-label"
};
const $f4cfd70dfd1f4efb$var$_hoisted_29 = {
    class: "col-md-2"
};
const $f4cfd70dfd1f4efb$var$_hoisted_30 = {
    class: "form-label"
};
const $f4cfd70dfd1f4efb$var$_hoisted_31 = {
    class: "row"
};
const $f4cfd70dfd1f4efb$var$_hoisted_32 = {
    class: "col-md-1 mb-auto mt-auto"
};
const $f4cfd70dfd1f4efb$var$_hoisted_33 = [
    "onUpdate:modelValue",
    "id"
];
const $f4cfd70dfd1f4efb$var$_hoisted_34 = {
    class: "col-md-3"
};
const $f4cfd70dfd1f4efb$var$_hoisted_35 = [
    "value",
    "id"
];
const $f4cfd70dfd1f4efb$var$_hoisted_36 = {
    class: "col-md-1 mb-auto mt-auto"
};
const $f4cfd70dfd1f4efb$var$_hoisted_37 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $f4cfd70dfd1f4efb$var$_hoisted_38 = {
    class: "col-md-2"
};
const $f4cfd70dfd1f4efb$var$_hoisted_39 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $f4cfd70dfd1f4efb$var$_hoisted_40 = {
    class: "col-md-2"
};
const $f4cfd70dfd1f4efb$var$_hoisted_41 = [
    "onUpdate:modelValue",
    "disabled",
    "onInput",
    "id"
];
const $f4cfd70dfd1f4efb$var$_hoisted_42 = {
    class: "col-md-2"
};
const $f4cfd70dfd1f4efb$var$_hoisted_43 = [
    "onUpdate:modelValue",
    "disabled",
    "onChange",
    "id"
];
const $f4cfd70dfd1f4efb$var$_hoisted_44 = {
    value: "",
    disabled: ""
};
const $f4cfd70dfd1f4efb$var$_hoisted_45 = {
    value: "custom"
};
const $f4cfd70dfd1f4efb$var$_hoisted_46 = {
    value: "yearly"
};
const $f4cfd70dfd1f4efb$var$_hoisted_47 = {
    value: "divided"
};
const $f4cfd70dfd1f4efb$var$_hoisted_48 = {
    class: "col-md-1"
};
const $f4cfd70dfd1f4efb$var$_hoisted_49 = [
    "onClick"
];
const $f4cfd70dfd1f4efb$var$_hoisted_50 = {
    class: "d-grid gap-2 d-md-flex"
};
function $f4cfd70dfd1f4efb$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_SelectionLimitPackageYearDialog = (0, $TusQn.resolveComponent)("SelectionLimitPackageYearDialog");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $f4cfd70dfd1f4efb$var$_hoisted_1, $f4cfd70dfd1f4efb$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $f4cfd70dfd1f4efb$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("limitCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $f4cfd70dfd1f4efb$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $f4cfd70dfd1f4efb$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $f4cfd70dfd1f4efb$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $f4cfd70dfd1f4efb$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $f4cfd70dfd1f4efb$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/selection/" + this.$route.params.selectionId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.data.name || _ctx.$t("selection")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $f4cfd70dfd1f4efb$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getCurrentLimit(), (limit, i)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: i,
                class: "row"
            }, [
                (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_11, [
                    (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_13, [
                            (0, $TusQn.createElementVNode)("label", $f4cfd70dfd1f4efb$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": ($event)=>limit.name = $event,
                                type: "text",
                                class: "form-control",
                                id: "name"
                            }, null, 8, $f4cfd70dfd1f4efb$var$_hoisted_15), [
                                [
                                    (0, $eeJ70.vModelText),
                                    limit.name
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("h4", $f4cfd70dfd1f4efb$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("selectionLimitPackages")), 1),
                    (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_17, [
                        (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_18, [
                            (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_19, [
                                $f4cfd70dfd1f4efb$var$_hoisted_20,
                                (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_21, [
                                    (0, $TusQn.createElementVNode)("label", $f4cfd70dfd1f4efb$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("package")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_23, [
                                    (0, $TusQn.createElementVNode)("label", $f4cfd70dfd1f4efb$var$_hoisted_24, (0, $8POXm.toDisplayString)(_ctx.$t("unlimited")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_25, [
                                    (0, $TusQn.createElementVNode)("label", $f4cfd70dfd1f4efb$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("totalLimitValue")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_27, [
                                    (0, $TusQn.createElementVNode)("label", $f4cfd70dfd1f4efb$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("limitValue")), 1)
                                ]),
                                (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_29, [
                                    (0, $TusQn.createElementVNode)("label", $f4cfd70dfd1f4efb$var$_hoisted_30, (0, $8POXm.toDisplayString)(_ctx.$t("inputMethod")), 1)
                                ])
                            ])
                        ]),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.selectionLimitPackages, (limitPackage, o)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                class: "mb-3 col-md-12",
                                key: o
                            }, [
                                (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_31, [
                                    (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_32, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            class: "form-check-input",
                                            "onUpdate:modelValue": ($event)=>limitPackage.checked = $event,
                                            type: "checkbox",
                                            id: "checked_" + o
                                        }, null, 8, $f4cfd70dfd1f4efb$var$_hoisted_33), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                limitPackage.checked
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_34, [
                                        (0, $TusQn.createElementVNode)("input", {
                                            class: "form-control",
                                            disabled: "",
                                            value: $options.getSelectionPackageName(limitPackage.selectionPackageId),
                                            type: "text",
                                            id: "package" + o
                                        }, null, 8, $f4cfd70dfd1f4efb$var$_hoisted_35)
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_36, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            "onUpdate:modelValue": ($event)=>limitPackage.unlimited = $event,
                                            disabled: !limitPackage.checked,
                                            class: "form-check-input",
                                            id: "unlimited" + o,
                                            type: "checkbox"
                                        }, null, 8, $f4cfd70dfd1f4efb$var$_hoisted_37), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                limitPackage.unlimited
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_38, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            "onUpdate:modelValue": ($event)=>limitPackage.totalLimitValue = $event,
                                            disabled: !limitPackage.checked || limitPackage.unlimited,
                                            class: "form-control",
                                            id: "totalLimitValue" + o,
                                            type: "number"
                                        }, null, 8, $f4cfd70dfd1f4efb$var$_hoisted_39), [
                                            [
                                                (0, $eeJ70.vModelText),
                                                limitPackage.totalLimitValue
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_40, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            "onUpdate:modelValue": ($event)=>limitPackage.limitValue = $event,
                                            disabled: !limitPackage.checked || limitPackage.unlimited,
                                            onInput: ($event)=>$options.updateYearlyLimits(limitPackage),
                                            class: "form-control",
                                            id: "limitValue" + o,
                                            type: "number"
                                        }, null, 40, $f4cfd70dfd1f4efb$var$_hoisted_41), [
                                            [
                                                (0, $eeJ70.vModelText),
                                                limitPackage.limitValue
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_42, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>limitPackage.inputMethod = $event,
                                            disabled: !limitPackage.checked || limitPackage.unlimited,
                                            onChange: ($event)=>$options.updateYearlyLimits(limitPackage),
                                            class: "form-select",
                                            id: "inputMethod" + o
                                        }, [
                                            (0, $TusQn.createElementVNode)("option", $f4cfd70dfd1f4efb$var$_hoisted_44, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                            (0, $TusQn.createElementVNode)("option", $f4cfd70dfd1f4efb$var$_hoisted_45, (0, $8POXm.toDisplayString)(_ctx.$t("custom")), 1),
                                            (0, $TusQn.createElementVNode)("option", $f4cfd70dfd1f4efb$var$_hoisted_46, (0, $8POXm.toDisplayString)(_ctx.$t("yearly")), 1),
                                            (0, $TusQn.createElementVNode)("option", $f4cfd70dfd1f4efb$var$_hoisted_47, (0, $8POXm.toDisplayString)(_ctx.$t("divided")), 1)
                                        ], 40, $f4cfd70dfd1f4efb$var$_hoisted_43), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                limitPackage.inputMethod
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_48, [
                                        (0, $TusQn.createElementVNode)("button", {
                                            class: "btn btn-secondary",
                                            onClick: ($event)=>$options.showSelectionLimitPackageYear(limitPackage)
                                        }, (0, $8POXm.toDisplayString)(_ctx.$t("years")), 9, $f4cfd70dfd1f4efb$var$_hoisted_49)
                                    ])
                                ])
                            ]);
                        }), 128))
                    ])
                ])
            ]);
        }), 128)),
        (0, $TusQn.createElementVNode)("div", $f4cfd70dfd1f4efb$var$_hoisted_50, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_SelectionLimitPackageYearDialog, {
            onClose: _cache[2] || (_cache[2] = ($event)=>$data.showSelectionLimitPackageYearDialog = false),
            onConfirm: _cache[3] || (_cache[3] = ($event)=>$data.showSelectionLimitPackageYearDialog = false)
        }, null, 512), [
            [
                (0, $eeJ70.vShow),
                $data.showSelectionLimitPackageYearDialog
            ]
        ])
    ]));
}

});

parcelRegister("835KA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dc31079b968ecff$export$2e2bcd8739ae039);
let $5dc31079b968ecff$var$NOOP = ()=>{};
var $5dc31079b968ecff$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("cHK1h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $93fd32bf04319744$export$2e2bcd8739ae039);

var $926P8 = parcelRequire("926P8");

var $fpsjg = parcelRequire("fpsjg");
var $93fd32bf04319744$export$2e2bcd8739ae039 = {
    components: {
        GroupToUserDialog: $fpsjg.default
    },
    methods: {
        async onSubmit () {
            let content = JSON.parse(this.data.content);
            content.team = this.data.teamName;
            content.role = this.data.role;
            content.groupId = this.data.groupId;
            this.data.content = JSON.stringify(content);
            let user = await (0, $926P8.default).create(this.data);
            await (0, $926P8.default).setPassword(user.id, this.data);
            this.$router.push({
                name: "userdetail",
                params: {
                    id: user.id
                }
            });
        },
        confirmModal (modalData) {
            this.modalData = modalData;
            this.data.groupName = modalData.name;
            this.data.groupId = modalData.id;
            this.closeModal();
        },
        showModal () {
            this.isModalVisible = true;
        },
        closeModal () {
            this.isModalVisible = false;
        }
    },
    data () {
        return {
            isModalVisible: false,
            data: {
                groupName: "",
                groupId: 0,
                userName: "",
                name: "",
                role: "",
                teamName: "",
                content: "{}",
                password: ""
            }
        };
    }
};

});
parcelRegister("fpsjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b37f268a3a196e27$export$2e2bcd8739ae039);
let $b37f268a3a196e27$var$script;



let $b37f268a3a196e27$var$initialize = ()=>{
    $b37f268a3a196e27$var$script = (parcelRequire("bGzV3"));
    if ($b37f268a3a196e27$var$script.__esModule) $b37f268a3a196e27$var$script = $b37f268a3a196e27$var$script.default;
    $b37f268a3a196e27$var$script.render = (parcelRequire("kNJoj")).render;
    (parcelRequire("dybZP")).default($b37f268a3a196e27$var$script);
    $b37f268a3a196e27$var$script.__scopeId = "data-v-369e7d";
    $b37f268a3a196e27$var$script.__file = "GroupToUserDialog.vue";
};
$b37f268a3a196e27$var$initialize();
var $b37f268a3a196e27$export$2e2bcd8739ae039 = $b37f268a3a196e27$var$script;

});
parcelRegister("bGzV3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $881f7abee00f901c$export$2e2bcd8739ae039);

var $bpHT7 = parcelRequire("bpHT7");
var $881f7abee00f901c$export$2e2bcd8739ae039 = {
    name: "GroupToUserDialog",
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            try {
                this.list = await (0, $bpHT7.default).list();
                this.checked();
            } catch (error) {}
        },
        checked (id) {
            if (this.$parent.data && this.$parent.data.groupId && this.$parent.data.groupId === id) return true;
            else return false;
        },
        onChange (data) {
            this.selectedRadio = data;
        },
        close () {
            this.$emit("close");
        },
        confirm () {
            this.$emit("confirm", this.selectedRadio);
        }
    },
    data () {
        return {
            list: [],
            selectedRadio: {}
        };
    }
};

});

parcelRegister("kNJoj", function(module, exports) {

$parcel$export(module.exports, "render", () => $f24b97fc30589a68$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $f24b97fc30589a68$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
};
const $f24b97fc30589a68$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg",
    role: "document"
};
const $f24b97fc30589a68$var$_hoisted_3 = {
    class: "modal-content"
};
const $f24b97fc30589a68$var$_hoisted_4 = {
    class: "modal-header"
};
const $f24b97fc30589a68$var$_hoisted_5 = {
    class: "modal-title"
};
const $f24b97fc30589a68$var$_hoisted_6 = {
    class: "modal-body",
    style: {
        "padding": "0",
        "height": "196px"
    }
};
const $f24b97fc30589a68$var$_hoisted_7 = {
    class: "table"
};
const $f24b97fc30589a68$var$_hoisted_8 = {
    key: 0,
    class: "bodyDialog"
};
const $f24b97fc30589a68$var$_hoisted_9 = {
    class: "form-check"
};
const $f24b97fc30589a68$var$_hoisted_10 = [
    "for"
];
const $f24b97fc30589a68$var$_hoisted_11 = [
    "checked",
    "id",
    "onChange"
];
const $f24b97fc30589a68$var$_hoisted_12 = {
    class: "modal-footer"
};
function $f24b97fc30589a68$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $f24b97fc30589a68$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $f24b97fc30589a68$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $f24b97fc30589a68$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $f24b97fc30589a68$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $f24b97fc30589a68$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $f24b97fc30589a68$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("table", $f24b97fc30589a68$var$_hoisted_7, [
                                    $data.list.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $f24b97fc30589a68$var$_hoisted_8, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.list, (item, i)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                                key: i
                                            }, [
                                                (0, $TusQn.createElementVNode)("td", $f24b97fc30589a68$var$_hoisted_9, [
                                                    (0, $TusQn.createElementVNode)("label", {
                                                        style: {
                                                            "padding-left": "20px"
                                                        },
                                                        class: "margin form-check-label",
                                                        for: item.id
                                                    }, [
                                                        (0, $TusQn.createElementVNode)("input", {
                                                            checked: $options.checked(item.id),
                                                            id: item.id,
                                                            type: "radio",
                                                            class: "form-check-input",
                                                            onChange: ($event)=>$options.onChange({
                                                                    id: item.id,
                                                                    name: item.name
                                                                }),
                                                            name: "optradio"
                                                        }, null, 40, $f24b97fc30589a68$var$_hoisted_11),
                                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                                    ], 8, $f24b97fc30589a68$var$_hoisted_10)
                                                ])
                                            ]);
                                        }), 128))
                                    ])) : (0, $TusQn.createCommentVNode)("", true)
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("div", $f24b97fc30589a68$var$_hoisted_12, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.confirm && $options.confirm(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("confirm")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("dybZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd7c18e234f2c7c$export$2e2bcd8739ae039);
let $9dd7c18e234f2c7c$var$NOOP = ()=>{};
var $9dd7c18e234f2c7c$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("cm9ph", function(module, exports) {

$parcel$export(module.exports, "render", () => $8feed614790c1348$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $8feed614790c1348$var$_hoisted_1 = {
    class: "container py-5"
};
const $8feed614790c1348$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $8feed614790c1348$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $8feed614790c1348$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $8feed614790c1348$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $8feed614790c1348$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $8feed614790c1348$var$_hoisted_7 = {
    class: "row"
};
const $8feed614790c1348$var$_hoisted_8 = {
    class: "mb-3 col-md-6"
};
const $8feed614790c1348$var$_hoisted_9 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $8feed614790c1348$var$_hoisted_10 = [
    "placeholder"
];
const $8feed614790c1348$var$_hoisted_11 = {
    class: "mb-3 col-md-6"
};
const $8feed614790c1348$var$_hoisted_12 = {
    class: "form-label"
};
const $8feed614790c1348$var$_hoisted_13 = {
    disabled: ""
};
const $8feed614790c1348$var$_hoisted_14 = {
    id: "viewer"
};
const $8feed614790c1348$var$_hoisted_15 = {
    value: "LyzarEditor",
    id: "editor"
};
const $8feed614790c1348$var$_hoisted_16 = {
    id: "admin"
};
const $8feed614790c1348$var$_hoisted_17 = {
    class: "row mb-3"
};
const $8feed614790c1348$var$_hoisted_18 = {
    class: "col-md-6"
};
const $8feed614790c1348$var$_hoisted_19 = {
    class: "form-label",
    for: "userName",
    required: ""
};
const $8feed614790c1348$var$_hoisted_20 = [
    "placeholder"
];
const $8feed614790c1348$var$_hoisted_21 = {
    class: "col-md-6"
};
const $8feed614790c1348$var$_hoisted_22 = {
    class: "form-label"
};
const $8feed614790c1348$var$_hoisted_23 = [
    "placeholder"
];
const $8feed614790c1348$var$_hoisted_24 = {
    class: "row mb-3"
};
const $8feed614790c1348$var$_hoisted_25 = {
    class: "col-md-6"
};
const $8feed614790c1348$var$_hoisted_26 = {
    class: "form-label",
    for: "password"
};
const $8feed614790c1348$var$_hoisted_27 = [
    "placeholder"
];
const $8feed614790c1348$var$_hoisted_28 = {
    class: "col-md-6"
};
const $8feed614790c1348$var$_hoisted_29 = {
    class: "form-label"
};
const $8feed614790c1348$var$_hoisted_30 = {
    class: "input-group"
};
const $8feed614790c1348$var$_hoisted_31 = [
    "placeholder"
];
const $8feed614790c1348$var$_hoisted_32 = {
    class: "input-group-append"
};
function $8feed614790c1348$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_GroupToUserDialog = (0, $TusQn.resolveComponent)("GroupToUserDialog");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8feed614790c1348$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("userCreation")), 1),
        (0, $TusQn.createElementVNode)("nav", $8feed614790c1348$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $8feed614790c1348$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $8feed614790c1348$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modelings"
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $8feed614790c1348$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/users"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("users")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $8feed614790c1348$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $8feed614790c1348$var$_hoisted_7, [
            (0, $TusQn.createElementVNode)("div", $8feed614790c1348$var$_hoisted_8, [
                (0, $TusQn.createElementVNode)("label", $8feed614790c1348$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name",
                    placeholder: _ctx.$t("enterUserName")
                }, null, 8, $8feed614790c1348$var$_hoisted_10), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $8feed614790c1348$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("label", $8feed614790c1348$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("role")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "role",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.role = $event),
                    class: "form-control"
                }, [
                    (0, $TusQn.createElementVNode)("option", $8feed614790c1348$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("chooseRole")), 1),
                    (0, $TusQn.createElementVNode)("option", $8feed614790c1348$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("viewer")), 1),
                    (0, $TusQn.createElementVNode)("option", $8feed614790c1348$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("editor")), 1),
                    (0, $TusQn.createElementVNode)("option", $8feed614790c1348$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("admin")), 1)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.role
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $8feed614790c1348$var$_hoisted_17, [
            (0, $TusQn.createElementVNode)("div", $8feed614790c1348$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("label", $8feed614790c1348$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("loginName")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.userName = $event),
                    type: "text",
                    class: "form-control",
                    id: "userName",
                    placeholder: _ctx.$t("enterLogin")
                }, null, 8, $8feed614790c1348$var$_hoisted_20), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.userName
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $8feed614790c1348$var$_hoisted_21, [
                (0, $TusQn.createElementVNode)("label", $8feed614790c1348$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("team")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-control",
                    placeholder: _ctx.$t("teamName"),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.teamName = $event)
                }, null, 8, $8feed614790c1348$var$_hoisted_23), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.teamName
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $8feed614790c1348$var$_hoisted_24, [
            (0, $TusQn.createElementVNode)("div", $8feed614790c1348$var$_hoisted_25, [
                (0, $TusQn.createElementVNode)("label", $8feed614790c1348$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("password")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.password = $event),
                    type: "Password",
                    class: "form-control",
                    id: "password",
                    placeholder: _ctx.$t("enterPassword")
                }, null, 8, $8feed614790c1348$var$_hoisted_27), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.password
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $8feed614790c1348$var$_hoisted_28, [
                (0, $TusQn.createElementVNode)("label", $8feed614790c1348$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("group")), 1),
                (0, $TusQn.createElementVNode)("div", $8feed614790c1348$var$_hoisted_30, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-control",
                        placeholder: _ctx.$t("chooseGroup"),
                        onClick: _cache[5] || (_cache[5] = (...args)=>$options.showModal && $options.showModal(...args)),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.data.groupName = $event),
                        readonly: ""
                    }, null, 8, $8feed614790c1348$var$_hoisted_31), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.groupName
                        ]
                    ]),
                    (0, $TusQn.createElementVNode)("div", $8feed614790c1348$var$_hoisted_32, [
                        (0, $TusQn.createElementVNode)("button", {
                            class: "btn btn-outline-secondary",
                            onClick: _cache[7] || (_cache[7] = (...args)=>$options.showModal && $options.showModal(...args)),
                            type: "button"
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("choose")), 1)
                    ])
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[8] || (_cache[8] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
        }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
        (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_GroupToUserDialog, {
            onClose: $options.closeModal,
            onConfirm: $options.confirmModal
        }, null, 8, [
            "onClose",
            "onConfirm"
        ]), [
            [
                (0, $eeJ70.vShow),
                $data.isModalVisible
            ]
        ])
    ]);
}

});

parcelRegister("fbziw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0e3437cdc5a9a35$export$2e2bcd8739ae039);
let $b0e3437cdc5a9a35$var$NOOP = ()=>{};
var $b0e3437cdc5a9a35$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("7goMD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $549d4082e19bd7c5$export$2e2bcd8739ae039);

var $fpsjg = parcelRequire("fpsjg");

var $926P8 = parcelRequire("926P8");

var $bpHT7 = parcelRequire("bpHT7");
var $549d4082e19bd7c5$export$2e2bcd8739ae039 = {
    name: "userdetail",
    components: {
        GroupToUserDialog: $fpsjg.default
    },
    data () {
        return {
            pending: true,
            isModalVisible: false,
            error: false,
            data: {
                groupName: "",
                groupId: 0,
                name: "",
                userName: "",
                teamName: "",
                role: ""
            }
        };
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "userUpdated",
            type: "success"
        }
    },
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        confirmModal (modalData) {
            this.modalData = modalData;
            this.data.groupName = modalData.name;
            this.data.groupId = modalData.id;
            this.closeModal();
        },
        showModal () {
            this.isModalVisible = true;
        },
        closeModal () {
            this.isModalVisible = false;
        },
        async saveUser () {
            let content = JSON.parse(this.data.content);
            content.groupId = this.data.groupId;
            content.team = this.data.teamName;
            content.role = this.data.role;
            this.data.content = JSON.stringify(content);
            await (0, $926P8.default).update(this.data);
            this.showSuccess();
        },
        async requestData () {
            let self = this;
            this.pending = true;
            try {
                const data = await (0, $926P8.default).detail(this.$route.params.id);
                this.data = data;
                this.error = false;
                if (data && data.content != null) {
                    let content = JSON.parse(data.content);
                    if (content.groupId && content.groupId > 0) {
                        self.data.groupId = content.groupId;
                        let groupName = await (0, $bpHT7.default).detail(content.groupId);
                        if (groupName) self.data.groupName = groupName.name;
                    } else self.data.groupId = 0;
                    if (content.team) self.data.teamName = content.team;
                    if (content.role) self.data.role = content.role;
                }
            } catch (e) {
                this.data = null;
                this.error = e;
            }
            this.pending = false;
        }
    },
    render () {
        return this.$scopedSlots.default({
            pending: this.pending,
            error: this.error,
            data: this.data
        });
    }
};

});

parcelRegister("i5xnQ", function(module, exports) {

$parcel$export(module.exports, "render", () => $d2b296e65686e299$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $d2b296e65686e299$var$_hoisted_1 = {
    class: "container py-5"
};
const $d2b296e65686e299$var$_hoisted_2 = {
    key: 0
};
const $d2b296e65686e299$var$_hoisted_3 = {
    key: 1
};
const $d2b296e65686e299$var$_hoisted_4 = {
    key: 2
};
const $d2b296e65686e299$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $d2b296e65686e299$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $d2b296e65686e299$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $d2b296e65686e299$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $d2b296e65686e299$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $d2b296e65686e299$var$_hoisted_10 = {
    class: "row mb-3"
};
const $d2b296e65686e299$var$_hoisted_11 = {
    class: "col-md-6"
};
const $d2b296e65686e299$var$_hoisted_12 = {
    class: "form-label"
};
const $d2b296e65686e299$var$_hoisted_13 = {
    class: "col-md-6"
};
const $d2b296e65686e299$var$_hoisted_14 = {
    class: "form-label"
};
const $d2b296e65686e299$var$_hoisted_15 = {
    disabled: ""
};
const $d2b296e65686e299$var$_hoisted_16 = {
    value: "Viewer",
    id: "viewer"
};
const $d2b296e65686e299$var$_hoisted_17 = {
    value: "LyzarEditor",
    id: "editor"
};
const $d2b296e65686e299$var$_hoisted_18 = {
    value: "Admin",
    id: "admin"
};
const $d2b296e65686e299$var$_hoisted_19 = {
    class: "row mb-3"
};
const $d2b296e65686e299$var$_hoisted_20 = {
    class: "col-md-6"
};
const $d2b296e65686e299$var$_hoisted_21 = {
    class: "form-label"
};
const $d2b296e65686e299$var$_hoisted_22 = {
    class: "col-md-6"
};
const $d2b296e65686e299$var$_hoisted_23 = {
    class: "form-label"
};
const $d2b296e65686e299$var$_hoisted_24 = [
    "placeholder"
];
const $d2b296e65686e299$var$_hoisted_25 = {
    class: "row mb-3"
};
const $d2b296e65686e299$var$_hoisted_26 = {
    class: "col-md-6"
};
const $d2b296e65686e299$var$_hoisted_27 = {
    class: "form-label"
};
const $d2b296e65686e299$var$_hoisted_28 = {
    class: "input-group"
};
const $d2b296e65686e299$var$_hoisted_29 = [
    "placeholder"
];
const $d2b296e65686e299$var$_hoisted_30 = {
    class: "input-group-append"
};
const $d2b296e65686e299$var$_hoisted_31 = {
    class: "col-md-6"
};
const $d2b296e65686e299$var$_hoisted_32 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    style: {
        "display": "block"
    }
}, "\xa0", -1);
function $d2b296e65686e299$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_GroupToUserDialog = (0, $TusQn.resolveComponent)("GroupToUserDialog");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d2b296e65686e299$var$_hoisted_1, [
        $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d2b296e65686e299$var$_hoisted_2, (0, $8POXm.toDisplayString)(_ctx.$t("loading")), 1)) : $data.error ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d2b296e65686e299$var$_hoisted_3, (0, $8POXm.toDisplayString)(_ctx.$t("error")), 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d2b296e65686e299$var$_hoisted_4, [
            (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("userDetail")), 1),
            (0, $TusQn.createElementVNode)("nav", $d2b296e65686e299$var$_hoisted_5, [
                (0, $TusQn.createElementVNode)("ol", $d2b296e65686e299$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("li", $d2b296e65686e299$var$_hoisted_7, [
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            to: {
                                name: "modelings"
                            }
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                                ]),
                            _: 1
                        })
                    ]),
                    (0, $TusQn.createElementVNode)("li", $d2b296e65686e299$var$_hoisted_8, [
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            to: "/settings/users"
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("users")), 1)
                                ]),
                            _: 1
                        })
                    ]),
                    (0, $TusQn.createElementVNode)("li", $d2b296e65686e299$var$_hoisted_9, (0, $8POXm.toDisplayString)($data.data.name), 1)
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $d2b296e65686e299$var$_hoisted_10, [
                (0, $TusQn.createElementVNode)("div", $d2b296e65686e299$var$_hoisted_11, [
                    (0, $TusQn.createElementVNode)("label", $d2b296e65686e299$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.name
                        ]
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $d2b296e65686e299$var$_hoisted_13, [
                    (0, $TusQn.createElementVNode)("label", $d2b296e65686e299$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("role")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                        id: "role",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.role = $event),
                        class: "form-control"
                    }, [
                        (0, $TusQn.createElementVNode)("option", $d2b296e65686e299$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("chooseRole")), 1),
                        (0, $TusQn.createElementVNode)("option", $d2b296e65686e299$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("viewer")), 1),
                        (0, $TusQn.createElementVNode)("option", $d2b296e65686e299$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("editor")), 1),
                        (0, $TusQn.createElementVNode)("option", $d2b296e65686e299$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("admin")), 1)
                    ], 512), [
                        [
                            (0, $eeJ70.vModelSelect),
                            $data.data.role
                        ]
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $d2b296e65686e299$var$_hoisted_19, [
                (0, $TusQn.createElementVNode)("div", $d2b296e65686e299$var$_hoisted_20, [
                    (0, $TusQn.createElementVNode)("label", $d2b296e65686e299$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("loginName")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.userName = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.userName
                        ]
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $d2b296e65686e299$var$_hoisted_22, [
                    (0, $TusQn.createElementVNode)("label", $d2b296e65686e299$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("team")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-control",
                        placeholder: _ctx.$t("teamName"),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.teamName = $event)
                    }, null, 8, $d2b296e65686e299$var$_hoisted_24), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.teamName
                        ]
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $d2b296e65686e299$var$_hoisted_25, [
                (0, $TusQn.createElementVNode)("div", $d2b296e65686e299$var$_hoisted_26, [
                    (0, $TusQn.createElementVNode)("label", $d2b296e65686e299$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("group")), 1),
                    (0, $TusQn.createElementVNode)("div", $d2b296e65686e299$var$_hoisted_28, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "form-control",
                            placeholder: _ctx.$t("chooseGroup"),
                            onClick: _cache[4] || (_cache[4] = (...args)=>$options.showModal && $options.showModal(...args)),
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.data.groupName = $event),
                            readonly: ""
                        }, null, 8, $d2b296e65686e299$var$_hoisted_29), [
                            [
                                (0, $eeJ70.vModelText),
                                $data.data.groupName
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("div", $d2b296e65686e299$var$_hoisted_30, [
                            (0, $TusQn.createElementVNode)("button", {
                                class: "btn btn-outline-secondary",
                                onClick: _cache[6] || (_cache[6] = (...args)=>$options.showModal && $options.showModal(...args)),
                                type: "button"
                            }, (0, $8POXm.toDisplayString)(_ctx.$t("choose")), 1)
                        ])
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $d2b296e65686e299$var$_hoisted_31, [
                    $d2b296e65686e299$var$_hoisted_32,
                    (0, $TusQn.createElementVNode)("button", {
                        class: "btn btn-primary",
                        onClick: _cache[7] || (_cache[7] = (...args)=>$options.saveUser && $options.saveUser(...args)),
                        style: {
                            "float": "right"
                        }
                    }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1)
                ])
            ])
        ])),
        (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_GroupToUserDialog, {
            onClose: $options.closeModal,
            onConfirm: $options.confirmModal
        }, null, 8, [
            "onClose",
            "onConfirm"
        ]), [
            [
                (0, $eeJ70.vShow),
                $data.isModalVisible
            ]
        ])
    ]);
}

});

parcelRegister("fZlOG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba3d79d2bb799404$export$2e2bcd8739ae039);
let $ba3d79d2bb799404$var$NOOP = ()=>{};
var $ba3d79d2bb799404$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("aiCIV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $77f99f805dc281d1$export$2e2bcd8739ae039);

var $926P8 = parcelRequire("926P8");

var $bEbCE = parcelRequire("bEbCE");

var $66Tap = parcelRequire("66Tap");
var $77f99f805dc281d1$export$2e2bcd8739ae039 = {
    name: "users",
    components: {
        UserDeleteModal: $66Tap.default,
        PasswordModal: $bEbCE.default
    },
    mounted () {
        this.requestData();
    },
    data () {
        return {
            userToDeleteId: "",
            userToDeleteName: "",
            userToChangePasswordId: "",
            userToChangePasswordName: "",
            isDeleteModalVisible: false,
            modalId: 0,
            isModalVisible: false,
            list: []
        };
    },
    methods: {
        async requestData () {
            this.list = await (0, $926P8.default).list();
        },
        showDeleteUserModal (user) {
            this.userToDeleteId = user.id;
            this.userToDeleteName = user.name;
            this.isDeleteModalVisible = true;
        },
        closeDeleteModal () {
            this.isDeleteModalVisible = false;
        },
        confirmModal (modalData) {
            this.modalData = modalData;
            this.data.parentName = modalData.name;
            this.data.parentId = modalData.id;
            this.closeModal();
        },
        showModal (user) {
            this.userToChangePasswordId = user.id;
            this.userToChangePasswordName = user.name;
            this.isModalVisible = true;
        },
        closeModal () {
            this.isModalVisible = false;
        }
    }
};

});
parcelRegister("bEbCE", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac72189812afff$export$2e2bcd8739ae039);
let $87ac72189812afff$var$script;



let $87ac72189812afff$var$initialize = ()=>{
    $87ac72189812afff$var$script = (parcelRequire("61CmL"));
    if ($87ac72189812afff$var$script.__esModule) $87ac72189812afff$var$script = $87ac72189812afff$var$script.default;
    $87ac72189812afff$var$script.render = (parcelRequire("hCrlc")).render;
    (parcelRequire("2G5Rg")).default($87ac72189812afff$var$script);
    $87ac72189812afff$var$script.__scopeId = "data-v-bce173";
    $87ac72189812afff$var$script.__file = "UserPasswordDialog.vue";
};
$87ac72189812afff$var$initialize();
var $87ac72189812afff$export$2e2bcd8739ae039 = $87ac72189812afff$var$script;

});
parcelRegister("61CmL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $463098cc2d82769c$export$2e2bcd8739ae039);

var $926P8 = parcelRequire("926P8");
var $463098cc2d82769c$export$2e2bcd8739ae039 = {
    name: "modal",
    notifications: {
        showSuccess: {
            title: "Password change",
            message: "Password succesfully changed!",
            type: "success"
        },
        showError: {
            title: "Password change",
            message: "Your password is too short!",
            type: "error"
        }
    },
    methods: {
        close () {
            this.$emit("close");
            this.danger = "";
            this.model.password = "";
        },
        async setPassword () {
            if (this.model.password.length > 3) {
                await (0, $926P8.default).setPassword(this.$parent.userToChangePasswordId, this.model);
                this.showSuccess();
                this.$emit("close");
                this.danger = "";
                this.model.password = "";
            } else {
                this.showError();
                this.danger = "danger";
            }
        }
    },
    data () {
        return {
            danger: "",
            model: {
                password: ""
            }
        };
    }
};

});

parcelRegister("hCrlc", function(module, exports) {

$parcel$export(module.exports, "render", () => $cd3b31a34e06a461$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $cd3b31a34e06a461$var$_hoisted_1 = {
    class: "user-password-dialog modal modal-fade",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
};
const $cd3b31a34e06a461$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered modal-lg"
};
const $cd3b31a34e06a461$var$_hoisted_3 = {
    class: "modal-content"
};
const $cd3b31a34e06a461$var$_hoisted_4 = {
    class: "modal-header"
};
const $cd3b31a34e06a461$var$_hoisted_5 = {
    class: "modal-title"
};
const $cd3b31a34e06a461$var$_hoisted_6 = {
    class: "modal-body"
};
const $cd3b31a34e06a461$var$_hoisted_7 = {
    class: "modal-footer"
};
function $cd3b31a34e06a461$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $cd3b31a34e06a461$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $cd3b31a34e06a461$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $cd3b31a34e06a461$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $cd3b31a34e06a461$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("h5", $cd3b31a34e06a461$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("passwordChange")), 1),
                    (0, $TusQn.createElementVNode)("button", {
                        type: "button",
                        class: "btn-close",
                        onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                        "data-dismiss": "modal",
                        "aria-label": "Close"
                    })
                ]),
                (0, $TusQn.createElementVNode)("div", $cd3b31a34e06a461$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("form", null, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: (0, $8POXm.normalizeClass)([
                                "form-control",
                                $data.danger
                            ]),
                            type: "password",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.model.password = $event)
                        }, null, 2), [
                            [
                                (0, $eeJ70.vModelText),
                                $data.model.password
                            ]
                        ])
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $cd3b31a34e06a461$var$_hoisted_7, [
                    (0, $TusQn.createElementVNode)("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[2] || (_cache[2] = (...args)=>$options.close && $options.close(...args)),
                        "data-dismiss": "modal"
                    }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                    (0, $TusQn.createElementVNode)("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[3] || (_cache[3] = (...args)=>$options.setPassword && $options.setPassword(...args))
                    }, (0, $8POXm.toDisplayString)(_ctx.$t("confirm")), 1)
                ])
            ])
        ])
    ]);
}

});

parcelRegister("2G5Rg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f340c50a22ce830$export$2e2bcd8739ae039);
let $1f340c50a22ce830$var$NOOP = ()=>{};
var $1f340c50a22ce830$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("66Tap", function(module, exports) {

$parcel$export(module.exports, "default", () => $472e18a0d7c517bd$export$2e2bcd8739ae039);
let $472e18a0d7c517bd$var$script;



let $472e18a0d7c517bd$var$initialize = ()=>{
    $472e18a0d7c517bd$var$script = (parcelRequire("jrhpb"));
    if ($472e18a0d7c517bd$var$script.__esModule) $472e18a0d7c517bd$var$script = $472e18a0d7c517bd$var$script.default;
    $472e18a0d7c517bd$var$script.render = (parcelRequire("6JVeX")).render;
    (parcelRequire("7253J")).default($472e18a0d7c517bd$var$script);
    $472e18a0d7c517bd$var$script.__scopeId = "data-v-9efb71";
    $472e18a0d7c517bd$var$script.__file = "UserDeleteModal.vue";
};
$472e18a0d7c517bd$var$initialize();
var $472e18a0d7c517bd$export$2e2bcd8739ae039 = $472e18a0d7c517bd$var$script;

});
parcelRegister("jrhpb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e26e0a421988a9b5$export$2e2bcd8739ae039);

var $926P8 = parcelRequire("926P8");
var $e26e0a421988a9b5$export$2e2bcd8739ae039 = {
    name: "userModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteUser () {
            await (0, $926P8.default).delete(this.$parent.userToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("6JVeX", function(module, exports) {

$parcel$export(module.exports, "render", () => $4e8358c18aa5ae8e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $4e8358c18aa5ae8e$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $4e8358c18aa5ae8e$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $4e8358c18aa5ae8e$var$_hoisted_3 = {
    class: "modal-content"
};
const $4e8358c18aa5ae8e$var$_hoisted_4 = {
    class: "modal-header"
};
const $4e8358c18aa5ae8e$var$_hoisted_5 = {
    class: "modal-title"
};
const $4e8358c18aa5ae8e$var$_hoisted_6 = {
    class: "modal-body"
};
const $4e8358c18aa5ae8e$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0"
    }
};
const $4e8358c18aa5ae8e$var$_hoisted_8 = {
    class: "modal-footer"
};
function $4e8358c18aa5ae8e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $4e8358c18aa5ae8e$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $4e8358c18aa5ae8e$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $4e8358c18aa5ae8e$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $4e8358c18aa5ae8e$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $4e8358c18aa5ae8e$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("userDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $4e8358c18aa5ae8e$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", $4e8358c18aa5ae8e$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisUser")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $4e8358c18aa5ae8e$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteUser && $options.deleteUser(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("7253J", function(module, exports) {

$parcel$export(module.exports, "default", () => $51eca4f62c9ca961$export$2e2bcd8739ae039);
let $51eca4f62c9ca961$var$NOOP = ()=>{};
var $51eca4f62c9ca961$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("DOw7n", function(module, exports) {

$parcel$export(module.exports, "render", () => $077ad443682feb1d$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $077ad443682feb1d$var$_hoisted_1 = {
    class: "table table-bordered table-responsive-md"
};
const $077ad443682feb1d$var$_hoisted_2 = {
    class: "text-center"
};
const $077ad443682feb1d$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-lg fa-plus"
}, null, -1);
const $077ad443682feb1d$var$_hoisted_4 = {
    key: 0
};
const $077ad443682feb1d$var$_hoisted_5 = [
    "onClick"
];
const $077ad443682feb1d$var$_hoisted_6 = [
    "onClick"
];
function $077ad443682feb1d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_PasswordModal = (0, $TusQn.resolveComponent)("PasswordModal");
    const _component_UserDeleteModal = (0, $TusQn.resolveComponent)("UserDeleteModal");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        (0, $TusQn.createElementVNode)("table", $077ad443682feb1d$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("thead", null, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.createElementVNode)("th", $077ad443682feb1d$var$_hoisted_2, [
                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("users")) + " ", 1),
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            style: {
                                "float": "right"
                            },
                            to: {
                                name: "useradd"
                            }
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    $077ad443682feb1d$var$_hoisted_3
                                ]),
                            _: 1
                        })
                    ])
                ])
            ]),
            $data.list.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $077ad443682feb1d$var$_hoisted_4, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.list, (user, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                        key: i
                    }, [
                        (0, $TusQn.createElementVNode)("td", null, [
                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                to: {
                                    name: "userdetail",
                                    params: {
                                        id: user.id
                                    }
                                }
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(user.name), 1)
                                    ]),
                                _: 2
                            }, 1032, [
                                "to"
                            ]),
                            (0, $TusQn.createElementVNode)("i", {
                                style: {
                                    "cursor": "pointer",
                                    "float": "right",
                                    "padding-top": "10px"
                                },
                                title: "Delete user",
                                onClick: ($event)=>$options.showDeleteUserModal(user),
                                class: "fas fa-sm fa-trash"
                            }, null, 8, $077ad443682feb1d$var$_hoisted_5),
                            (0, $TusQn.createElementVNode)("i", {
                                style: {
                                    "cursor": "pointer",
                                    "float": "right",
                                    "padding-top": "10px",
                                    "padding-right": "15px"
                                },
                                title: "Change password",
                                onClick: ($event)=>$options.showModal(user),
                                class: "fa fa-sm fa-key",
                                "aria-hidden": "true"
                            }, null, 8, $077ad443682feb1d$var$_hoisted_6)
                        ])
                    ]);
                }), 128))
            ])) : (0, $TusQn.createCommentVNode)("", true)
        ]),
        (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_PasswordModal, {
            onClose: $options.closeModal,
            onConfirm: $options.confirmModal
        }, null, 8, [
            "onClose",
            "onConfirm"
        ]), [
            [
                (0, $eeJ70.vShow),
                $data.isModalVisible
            ]
        ]),
        (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_UserDeleteModal, {
            onReload: $options.requestData,
            onCloseDeleteDialog: $options.closeDeleteModal
        }, null, 8, [
            "onReload",
            "onCloseDeleteDialog"
        ]), [
            [
                (0, $eeJ70.vShow),
                $data.isDeleteModalVisible
            ]
        ])
    ]);
}

});

parcelRegister("7zsoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5831d4e332b67ddc$export$2e2bcd8739ae039);
let $5831d4e332b67ddc$var$NOOP = ()=>{};
var $5831d4e332b67ddc$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("6mSVy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4a2f678d025fc1ae$export$2e2bcd8739ae039);

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $l6otV = parcelRequire("l6otV");

var $gM1Yh = parcelRequire("gM1Yh");
var $4a2f678d025fc1ae$export$2e2bcd8739ae039 = {
    name: "parameterEvaluationCreate",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var parameterClasses = [];
            var parameter = await (0, $gM1Yh.default).parameterDetail(this.$route.params.id, this.$route.params.parameterId);
            this.parameterName = parameter.name;
            for(var i in parameter.parameterClasses){
                var parameterClass = parameter.parameterClasses[i];
                parameterClasses.push({
                    name: parameterClass.name,
                    parameterClassId: parameterClass.id,
                    startParameter: 0.0,
                    endParameter: 0.0
                });
            }
            this.parameterClasses = parameterClasses;
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                this.data.assetTypeId = this.$route.params.assetTypeId;
                this.data.parameterEvaluationTransformation = this.parameterClasses;
                await (0, $gM1Yh.default).evaluationCreate(this.$route.params.id, this.$route.params.parameterId, this.data);
                this.$router.go(-1);
            } else this.showEmptyNameError();
        },
        updateParameterEvaluationTransformationStart (value, i) {
            var range = this.parameterClasses[i + 1];
            if (range) range.startParameter = value;
        },
        getMinStartParameterEvaluationTransformation () {
            var minStartParameter = 0;
            if (this.parameterClasses.length > 0) minStartParameter = this.parameterClasses[this.parameterClasses.length - 1].endParameter;
            return minStartParameter;
        },
        removeEvaluationFilter (rowIndex) {
            this.data.parameterEvaluationFilter.splice(rowIndex, 1);
        },
        addEvaluationFilter () {
            this.data.parameterEvaluationFilter.push({
                name: "",
                sign: "",
                number: 0
            });
        }
    },
    notifications: {
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            datasetHeaders: [],
            data: {
                name: "",
                description: "",
                parameterEvaluationFilter: [],
                parameterEvaluationTransformation: [],
                id: 0
            },
            modelingName: null,
            assetTypeName: null,
            parameterName: null,
            parameterClasses: [],
            pending: true
        };
    }
};

});

parcelRegister("7zE21", function(module, exports) {

$parcel$export(module.exports, "render", () => $583adab9fc7b4556$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $583adab9fc7b4556$var$_hoisted_1 = {
    key: 0
};
const $583adab9fc7b4556$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $583adab9fc7b4556$var$_hoisted_3 = [
    $583adab9fc7b4556$var$_hoisted_2
];
const $583adab9fc7b4556$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $583adab9fc7b4556$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $583adab9fc7b4556$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $583adab9fc7b4556$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $583adab9fc7b4556$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $583adab9fc7b4556$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $583adab9fc7b4556$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $583adab9fc7b4556$var$_hoisted_11 = {
    class: "breadcrumb-item"
};
const $583adab9fc7b4556$var$_hoisted_12 = {
    class: "row mb-3"
};
const $583adab9fc7b4556$var$_hoisted_13 = {
    class: "col-md-4"
};
const $583adab9fc7b4556$var$_hoisted_14 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $583adab9fc7b4556$var$_hoisted_15 = {
    class: "col-md-8"
};
const $583adab9fc7b4556$var$_hoisted_16 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $583adab9fc7b4556$var$_hoisted_17 = {
    class: "mb-3"
};
const $583adab9fc7b4556$var$_hoisted_18 = {
    class: "table"
};
const $583adab9fc7b4556$var$_hoisted_19 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $583adab9fc7b4556$var$_hoisted_20 = {
    scope: "col"
};
const $583adab9fc7b4556$var$_hoisted_21 = {
    scope: "col"
};
const $583adab9fc7b4556$var$_hoisted_22 = {
    scope: "col"
};
const $583adab9fc7b4556$var$_hoisted_23 = {
    scope: "row"
};
const $583adab9fc7b4556$var$_hoisted_24 = [
    "onClick"
];
const $583adab9fc7b4556$var$_hoisted_25 = [
    "id",
    "onUpdate:modelValue"
];
const $583adab9fc7b4556$var$_hoisted_26 = {
    disabled: ""
};
const $583adab9fc7b4556$var$_hoisted_27 = [
    "disabled",
    "value"
];
const $583adab9fc7b4556$var$_hoisted_28 = [
    "onUpdate:modelValue",
    "id"
];
const $583adab9fc7b4556$var$_hoisted_29 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<option value=""></option><option value="=">=</option><option value="&gt;">&gt;</option><option value="&lt;">&lt;</option><option value="&gt;=">&gt;=</option><option value="&lt;=">&lt;=</option>', 6);
const $583adab9fc7b4556$var$_hoisted_35 = [
    $583adab9fc7b4556$var$_hoisted_29
];
const $583adab9fc7b4556$var$_hoisted_36 = [
    "onUpdate:modelValue",
    "id"
];
const $583adab9fc7b4556$var$_hoisted_37 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $583adab9fc7b4556$var$_hoisted_38 = [
    $583adab9fc7b4556$var$_hoisted_37
];
const $583adab9fc7b4556$var$_hoisted_39 = {
    class: "mb-3"
};
const $583adab9fc7b4556$var$_hoisted_40 = {
    class: "table"
};
const $583adab9fc7b4556$var$_hoisted_41 = {
    scope: "col"
};
const $583adab9fc7b4556$var$_hoisted_42 = {
    scope: "col"
};
const $583adab9fc7b4556$var$_hoisted_43 = {
    scope: "col"
};
const $583adab9fc7b4556$var$_hoisted_44 = [
    "onUpdate:modelValue",
    "id"
];
const $583adab9fc7b4556$var$_hoisted_45 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $583adab9fc7b4556$var$_hoisted_46 = [
    "onUpdate:modelValue",
    "onInput",
    "id"
];
const $583adab9fc7b4556$var$_hoisted_47 = {
    class: "d-grid gap-2 d-md-flex"
};
function $583adab9fc7b4556$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $583adab9fc7b4556$var$_hoisted_1, $583adab9fc7b4556$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $583adab9fc7b4556$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $583adab9fc7b4556$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $583adab9fc7b4556$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $583adab9fc7b4556$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $583adab9fc7b4556$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $583adab9fc7b4556$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $583adab9fc7b4556$var$_hoisted_10, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/parameter/" + this.$route.params.parameterId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.parameterName || _ctx.$t("parameter")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $583adab9fc7b4556$var$_hoisted_11, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationCreate")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $583adab9fc7b4556$var$_hoisted_12, [
            (0, $TusQn.createElementVNode)("div", $583adab9fc7b4556$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("label", $583adab9fc7b4556$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $583adab9fc7b4556$var$_hoisted_15, [
                (0, $TusQn.createElementVNode)("label", $583adab9fc7b4556$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $583adab9fc7b4556$var$_hoisted_17, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationFilter")), 1),
            (0, $TusQn.createElementVNode)("table", $583adab9fc7b4556$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $583adab9fc7b4556$var$_hoisted_19,
                        (0, $TusQn.createElementVNode)("th", $583adab9fc7b4556$var$_hoisted_20, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $583adab9fc7b4556$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("sign")), 1),
                        (0, $TusQn.createElementVNode)("th", $583adab9fc7b4556$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("number")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.parameterEvaluationFilter, (evaluationFilter, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $583adab9fc7b4556$var$_hoisted_23, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeEvaluationFilter(i)
                                }, null, 8, $583adab9fc7b4556$var$_hoisted_24)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "name_" + _ctx.o,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.name = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $583adab9fc7b4556$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            disabled: datasetHeader.disabled,
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $583adab9fc7b4556$var$_hoisted_27);
                                    }), 128))
                                ], 8, $583adab9fc7b4556$var$_hoisted_25), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        evaluationFilter.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.sign = $event,
                                    class: "form-select",
                                    id: "sign_" + _ctx.o
                                }, $583adab9fc7b4556$var$_hoisted_35, 8, $583adab9fc7b4556$var$_hoisted_28), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        evaluationFilter.sign
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.number = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "number_number" + i
                                }, null, 8, $583adab9fc7b4556$var$_hoisted_36), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        evaluationFilter.number
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[2] || (_cache[2] = (...args)=>$options.addEvaluationFilter && $options.addEvaluationFilter(...args))
            }, $583adab9fc7b4556$var$_hoisted_38)
        ]),
        (0, $TusQn.createElementVNode)("div", $583adab9fc7b4556$var$_hoisted_39, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("classTransformation")), 1),
            (0, $TusQn.createElementVNode)("table", $583adab9fc7b4556$var$_hoisted_40, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        (0, $TusQn.createElementVNode)("th", $583adab9fc7b4556$var$_hoisted_41, (0, $8POXm.toDisplayString)(_ctx.$t("className")), 1),
                        (0, $TusQn.createElementVNode)("th", $583adab9fc7b4556$var$_hoisted_42, (0, $8POXm.toDisplayString)(_ctx.$t("startParameter")), 1),
                        (0, $TusQn.createElementVNode)("th", $583adab9fc7b4556$var$_hoisted_43, (0, $8POXm.toDisplayString)(_ctx.$t("endParameter")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.parameterClasses, (parameterClass, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.name = $event,
                                    disabled: "",
                                    class: "form-control",
                                    id: "parameterClass.name_" + i
                                }, null, 8, $583adab9fc7b4556$var$_hoisted_44), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.startParameter = $event,
                                    disabled: i > 0,
                                    type: "number",
                                    class: "form-control",
                                    id: "startParameter_" + i
                                }, null, 8, $583adab9fc7b4556$var$_hoisted_45), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.startParameter
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.endParameter = $event,
                                    onInput: ($event)=>$options.updateParameterEvaluationTransformationStart(parameterClass.endParameter, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endParameter_" + i
                                }, null, 40, $583adab9fc7b4556$var$_hoisted_46), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.endParameter
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $583adab9fc7b4556$var$_hoisted_47, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[3] || (_cache[3] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}/parameter/${this.$route.params.parameterId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("fWRjK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9c5a185f86c7d66$export$2e2bcd8739ae039);
let $b9c5a185f86c7d66$var$NOOP = ()=>{};
var $b9c5a185f86c7d66$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("1wSLe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $11d341fb88a28e58$export$2e2bcd8739ae039);

var $gM1Yh = parcelRequire("gM1Yh");

var $ch9iu = parcelRequire("ch9iu");

var $eHCxc = parcelRequire("eHCxc");

var $ftVMi = parcelRequire("ftVMi");

var $l6otV = parcelRequire("l6otV");

var $gOjKo = parcelRequire("gOjKo");
var $11d341fb88a28e58$export$2e2bcd8739ae039 = {
    name: "parameterdetail",
    watch: {
        $route: "requestData"
    },
    components: {
        ParameterDeleteModal: $ftVMi.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            var parameter = await (0, $gM1Yh.default).parameterDetail(this.$route.params.id, this.$route.params.parameterId);
            this.parameterName = parameter.name;
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            this.datasetHeaders = JSON.parse(dataset.content).headers;
            this.data = await (0, $gM1Yh.default).evaluationDetail(this.$route.params.id, this.$route.params.parameterId, this.$route.params.evaluationId);
            this.parameterClasses = parameter.parameterClasses.map((cls)=>{
                const t = this.data.parameterEvaluationTransformation.find((tr)=>tr.parameterClassId === cls.id);
                return {
                    // ...cls,
                    name: cls.name,
                    parameterClassId: cls.id,
                    startParameter: t?.startParameter ?? 0,
                    endParameter: t?.endParameter ?? 0
                };
            });
            this.pending = false;
        },
        async onSubmit () {
            if (this.data.name.length > 0) {
                this.data.parameterEvaluationTransformation = this.parameterClasses;
                await (0, $gM1Yh.default).evaluationUpdate(this.$route.params.id, this.$route.params.parameterId, this.data);
                if (!this.isFormValid()) this.showWarning();
                else this.showSuccess();
            } else this.showEmptyNameError();
        },
        isFormValid () {
            for(var i in this.data.parameterEvaluationFilter){
                var attr = this.data.parameterEvaluationFilter[i].name;
                if (this.datasetHeaders.findIndex((d)=>d.name == attr) < 0 && attr != "") return false;
            }
            return true;
        },
        showDeleteParameter () {
            this.parameterToDeleteId = this.data.id;
            this.showParameterDeleteModal = true;
        },
        updateParameterEvaluationTransformationStart (value, i) {
            var range = this.parameterClasses[i + 1];
            if (range) range.startParameter = value;
        },
        getMinStartParameterEvaluationTransformation () {
            var minStartParameter = 0;
            if (this.parameterClasses.length > 0) minStartParameter = this.parameterClasses[this.parameterClasses.length - 1].endParameter;
            return minStartParameter;
        },
        removeEvaluationFilter (rowIndex) {
            this.data.parameterEvaluationFilter.splice(rowIndex, 1);
        },
        addEvaluationFilter () {
            this.data.parameterEvaluationFilter.push({
                name: "",
                sign: "",
                number: 0
            });
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "evaluationUpdated",
            type: "success"
        },
        showWarning: {
            title: "warning",
            message: "warningAttributeRemoved",
            type: "warn"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            costFactors: [],
            missingDatasetHeaders: [],
            datasetHeaders: [],
            data: {
                name: "",
                id: ""
            },
            showParameterDeleteModal: false,
            parameterToDeleteId: 0,
            modelingName: null,
            assetTypeName: null,
            parameterName: null,
            pending: true,
            isUserAdmin: false,
            parameterClasses: []
        };
    }
};

});

parcelRegister("7ong8", function(module, exports) {

$parcel$export(module.exports, "render", () => $561cd114820e1974$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $561cd114820e1974$var$_hoisted_1 = {
    key: 0
};
const $561cd114820e1974$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $561cd114820e1974$var$_hoisted_3 = [
    $561cd114820e1974$var$_hoisted_2
];
const $561cd114820e1974$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $561cd114820e1974$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $561cd114820e1974$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $561cd114820e1974$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $561cd114820e1974$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $561cd114820e1974$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $561cd114820e1974$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $561cd114820e1974$var$_hoisted_11 = {
    class: "breadcrumb-item"
};
const $561cd114820e1974$var$_hoisted_12 = {
    class: "row mb-3"
};
const $561cd114820e1974$var$_hoisted_13 = {
    class: "col-md-4"
};
const $561cd114820e1974$var$_hoisted_14 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $561cd114820e1974$var$_hoisted_15 = {
    class: "col-md-8"
};
const $561cd114820e1974$var$_hoisted_16 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $561cd114820e1974$var$_hoisted_17 = {
    class: "mb-3"
};
const $561cd114820e1974$var$_hoisted_18 = {
    class: "table"
};
const $561cd114820e1974$var$_hoisted_19 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $561cd114820e1974$var$_hoisted_20 = {
    scope: "col"
};
const $561cd114820e1974$var$_hoisted_21 = {
    scope: "col"
};
const $561cd114820e1974$var$_hoisted_22 = {
    scope: "col"
};
const $561cd114820e1974$var$_hoisted_23 = {
    scope: "row"
};
const $561cd114820e1974$var$_hoisted_24 = [
    "onClick"
];
const $561cd114820e1974$var$_hoisted_25 = [
    "id",
    "onUpdate:modelValue"
];
const $561cd114820e1974$var$_hoisted_26 = {
    disabled: ""
};
const $561cd114820e1974$var$_hoisted_27 = [
    "disabled",
    "value"
];
const $561cd114820e1974$var$_hoisted_28 = [
    "onUpdate:modelValue",
    "id"
];
const $561cd114820e1974$var$_hoisted_29 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<option value=""></option><option value="=">=</option><option value="&gt;">&gt;</option><option value="&lt;">&lt;</option><option value="&gt;=">&gt;=</option><option value="&lt;=">&lt;=</option>', 6);
const $561cd114820e1974$var$_hoisted_35 = [
    $561cd114820e1974$var$_hoisted_29
];
const $561cd114820e1974$var$_hoisted_36 = [
    "onUpdate:modelValue",
    "id"
];
const $561cd114820e1974$var$_hoisted_37 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $561cd114820e1974$var$_hoisted_38 = [
    $561cd114820e1974$var$_hoisted_37
];
const $561cd114820e1974$var$_hoisted_39 = {
    class: "mb-3"
};
const $561cd114820e1974$var$_hoisted_40 = {
    class: "table"
};
const $561cd114820e1974$var$_hoisted_41 = {
    scope: "col"
};
const $561cd114820e1974$var$_hoisted_42 = {
    scope: "col"
};
const $561cd114820e1974$var$_hoisted_43 = {
    scope: "col"
};
const $561cd114820e1974$var$_hoisted_44 = [
    "onUpdate:modelValue",
    "id"
];
const $561cd114820e1974$var$_hoisted_45 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $561cd114820e1974$var$_hoisted_46 = [
    "onUpdate:modelValue",
    "onInput",
    "id"
];
const $561cd114820e1974$var$_hoisted_47 = {
    class: "d-grid gap-2 d-md-flex"
};
function $561cd114820e1974$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_ParameterDeleteModal = (0, $TusQn.resolveComponent)("ParameterDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $561cd114820e1974$var$_hoisted_1, $561cd114820e1974$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $561cd114820e1974$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $561cd114820e1974$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $561cd114820e1974$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $561cd114820e1974$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $561cd114820e1974$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $561cd114820e1974$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $561cd114820e1974$var$_hoisted_10, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId + "/parameter/" + this.$route.params.parameterId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.parameterName || _ctx.$t("parameter")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $561cd114820e1974$var$_hoisted_11, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $561cd114820e1974$var$_hoisted_12, [
            (0, $TusQn.createElementVNode)("div", $561cd114820e1974$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("label", $561cd114820e1974$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $561cd114820e1974$var$_hoisted_15, [
                (0, $TusQn.createElementVNode)("label", $561cd114820e1974$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $561cd114820e1974$var$_hoisted_17, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationFilter")), 1),
            (0, $TusQn.createElementVNode)("table", $561cd114820e1974$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $561cd114820e1974$var$_hoisted_19,
                        (0, $TusQn.createElementVNode)("th", $561cd114820e1974$var$_hoisted_20, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $561cd114820e1974$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("sign")), 1),
                        (0, $TusQn.createElementVNode)("th", $561cd114820e1974$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("number")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.parameterEvaluationFilter, (evaluationFilter, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $561cd114820e1974$var$_hoisted_23, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeEvaluationFilter(i)
                                }, null, 8, $561cd114820e1974$var$_hoisted_24)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "name_" + _ctx.o,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.name = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $561cd114820e1974$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            disabled: datasetHeader.disabled,
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $561cd114820e1974$var$_hoisted_27);
                                    }), 128))
                                ], 8, $561cd114820e1974$var$_hoisted_25), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        evaluationFilter.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.sign = $event,
                                    class: "form-select",
                                    id: "sign_" + _ctx.o
                                }, $561cd114820e1974$var$_hoisted_35, 8, $561cd114820e1974$var$_hoisted_28), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        evaluationFilter.sign
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.number = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "number_number" + i
                                }, null, 8, $561cd114820e1974$var$_hoisted_36), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        evaluationFilter.number
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[2] || (_cache[2] = (...args)=>$options.addEvaluationFilter && $options.addEvaluationFilter(...args))
            }, $561cd114820e1974$var$_hoisted_38)
        ]),
        (0, $TusQn.createElementVNode)("div", $561cd114820e1974$var$_hoisted_39, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("classTransformation")), 1),
            (0, $TusQn.createElementVNode)("table", $561cd114820e1974$var$_hoisted_40, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        (0, $TusQn.createElementVNode)("th", $561cd114820e1974$var$_hoisted_41, (0, $8POXm.toDisplayString)(_ctx.$t("className")), 1),
                        (0, $TusQn.createElementVNode)("th", $561cd114820e1974$var$_hoisted_42, (0, $8POXm.toDisplayString)(_ctx.$t("startParameter")), 1),
                        (0, $TusQn.createElementVNode)("th", $561cd114820e1974$var$_hoisted_43, (0, $8POXm.toDisplayString)(_ctx.$t("endParameter")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.parameterClasses, (parameterClass, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.name = $event,
                                    disabled: "",
                                    class: "form-control",
                                    id: "parameterClass.name_" + i
                                }, null, 8, $561cd114820e1974$var$_hoisted_44), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.startParameter = $event,
                                    disabled: i > 0,
                                    type: "number",
                                    class: "form-control",
                                    id: "startParameter_" + i
                                }, null, 8, $561cd114820e1974$var$_hoisted_45), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.startParameter
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>parameterClass.endParameter = $event,
                                    onInput: ($event)=>$options.updateParameterEvaluationTransformationStart(parameterClass.endParameter, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endParameter_" + i
                                }, null, 40, $561cd114820e1974$var$_hoisted_46), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        parameterClass.endParameter
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $561cd114820e1974$var$_hoisted_47, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[3] || (_cache[3] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}/parameter/${this.$route.params.parameterId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showParameterDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ParameterDeleteModal, {
            key: 0,
            onReload: _cache[5] || (_cache[5] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                })),
            onCloseDeleteDialog: _cache[6] || (_cache[6] = ($event)=>$data.showParameterDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("5XS9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $457c7978e3bb249a$export$2e2bcd8739ae039);
let $457c7978e3bb249a$var$NOOP = ()=>{};
var $457c7978e3bb249a$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("e9p5C", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a4d55e3c0fbea858$export$2e2bcd8739ae039);

var $eHCxc = parcelRequire("eHCxc");

var $ch9iu = parcelRequire("ch9iu");

var $fUmC0 = parcelRequire("fUmC0");

var $2gQQk = parcelRequire("2gQQk");

var $l6otV = parcelRequire("l6otV");
var $a4d55e3c0fbea858$export$2e2bcd8739ae039 = {
    name: "curvecreate",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.data.parameterId = this.$route.params.parameterId;
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var activityList = await (0, $2gQQk.default).activityList(this.$route.params.id);
            this.activityList = activityList.filter((a)=>a.assetTypeId == this.$route.params.assetTypeId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var curveList = await (0, $fUmC0.default).curveList(this.$route.params.id);
            this.curveList = curveList.filter((a)=>a.parameterId == this.$route.params.parameterId);
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            this.pending = false;
        },
        async onSubmit () {
            try {
                if (this.data.name.length > 0) {
                    this.data.curveGroup = [
                        {
                            id: 0,
                            name: "All Asset Types",
                            curveGroupAssetType: []
                        }
                    ];
                    await (0, $fUmC0.default).curveCreate(this.$route.params.id, this.data);
                    this.showSuccess();
                    this.$router.go(-1);
                } else this.showEmptyNameError();
            } catch  {
                this.showError();
            }
        },
        showTableFunction () {
            this.generateGraph();
            this.showTable = !this.showTable;
        },
        generateGraph () {
            let seriesData = [];
            for (let range of this.data.curveRanges){
                seriesData.push({
                    x: range.startAge,
                    y: range.startValue
                });
                seriesData.push({
                    x: range.endAge,
                    y: range.endValue
                });
            }
            this.series = [
                {
                    name: "Value",
                    data: seriesData
                }
            ];
        },
        removeCurveFilter (rowIndex) {
            this.data.curveFilters.splice(rowIndex, 1);
        },
        addCurveFilter () {
            this.data.curveFilters.push({
                name: "",
                sign: "=",
                number: 0
            });
        },
        removeCurveActivityEffect (rowIndex) {
            this.data.curveActivityEffects.splice(rowIndex, 1);
        },
        addCurveActivityEffect () {
            this.data.curveActivityEffects.push({
                effect: 0,
                effectType: 0,
                changeToCurveId: 0
            });
        },
        updateCurveAgeStart (value, i) {
            var range = this.data.curveRanges[i + 1];
            if (range) range.startAge = value;
        },
        updateCurveStartValue (value, i) {
            var range = this.data.curveRanges[i + 1];
            if (range) range.startValue = value;
        },
        removeCurveRange (rowIndex) {
            this.data.curveRanges.splice(rowIndex, 1);
        },
        addCurveRange () {
            this.data.curveRanges.push({
                description: "",
                startAge: this.getMinStartAge(),
                endAge: 0,
                startValue: this.getMinStartValue(),
                endValue: 0.0
            });
        },
        getMinStartAge () {
            var minStartAge = 0;
            if (this.data.curveRanges.length > 0) minStartAge = this.data.curveRanges[this.data.curveRanges.length - 1].endAge;
            return minStartAge;
        },
        getMinStartValue () {
            var minStartValue = 0;
            if (this.data.curveRanges.length > 0) minStartValue = this.data.curveRanges[this.data.curveRanges.length - 1].endValue;
            return minStartValue;
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "curveCreated",
            type: "success"
        },
        showError: {
            title: "error",
            message: "curveError",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            showTable: true,
            data: {
                id: 0,
                name: "",
                description: "",
                curveRanges: [],
                curveFilters: [],
                curveActivityEffects: [],
                coefficientAttribute: "",
                coefficientForecastOnly: false
            },
            curveList: [],
            pending: true,
            modelingName: "",
            series: [],
            chartOptions: {
                chart: {
                    type: "line",
                    animations: {
                        enabled: false
                    },
                    height: 350,
                    toolbar: {
                        show: false
                    }
                },
                xaxis: {
                    title: {
                        text: "Age"
                    }
                },
                yaxis: {
                    title: {
                        text: "Value"
                    }
                }
            }
        };
    }
};

});

parcelRegister("adMBy", function(module, exports) {

$parcel$export(module.exports, "render", () => $7710d23035a6bee7$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $7710d23035a6bee7$var$_hoisted_1 = {
    key: 0
};
const $7710d23035a6bee7$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $7710d23035a6bee7$var$_hoisted_3 = [
    $7710d23035a6bee7$var$_hoisted_2
];
const $7710d23035a6bee7$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $7710d23035a6bee7$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $7710d23035a6bee7$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $7710d23035a6bee7$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $7710d23035a6bee7$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $7710d23035a6bee7$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $7710d23035a6bee7$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $7710d23035a6bee7$var$_hoisted_11 = {
    class: "row mb-4"
};
const $7710d23035a6bee7$var$_hoisted_12 = {
    class: "mb-3 col-md-4"
};
const $7710d23035a6bee7$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $7710d23035a6bee7$var$_hoisted_14 = {
    class: "mb-3 col-md-8"
};
const $7710d23035a6bee7$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $7710d23035a6bee7$var$_hoisted_16 = {
    class: "row mb-4"
};
const $7710d23035a6bee7$var$_hoisted_17 = {
    class: "mb-3 col-md-4"
};
const $7710d23035a6bee7$var$_hoisted_18 = {
    class: "form-label",
    for: "coefficientAttribute",
    required: ""
};
const $7710d23035a6bee7$var$_hoisted_19 = {
    disabled: ""
};
const $7710d23035a6bee7$var$_hoisted_20 = [
    "value"
];
const $7710d23035a6bee7$var$_hoisted_21 = {
    class: "mb-3 col-md-4"
};
const $7710d23035a6bee7$var$_hoisted_22 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "form-label"
}, "\xa0", -1);
const $7710d23035a6bee7$var$_hoisted_23 = {
    class: "form-check"
};
const $7710d23035a6bee7$var$_hoisted_24 = {
    class: "form-check-label",
    for: "coefficientForecastOnly"
};
const $7710d23035a6bee7$var$_hoisted_25 = {
    key: 0,
    class: "mb-3"
};
const $7710d23035a6bee7$var$_hoisted_26 = {
    class: "table"
};
const $7710d23035a6bee7$var$_hoisted_27 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $7710d23035a6bee7$var$_hoisted_28 = {
    scope: "col"
};
const $7710d23035a6bee7$var$_hoisted_29 = {
    scope: "col"
};
const $7710d23035a6bee7$var$_hoisted_30 = {
    scope: "col"
};
const $7710d23035a6bee7$var$_hoisted_31 = {
    scope: "col"
};
const $7710d23035a6bee7$var$_hoisted_32 = {
    scope: "row"
};
const $7710d23035a6bee7$var$_hoisted_33 = [
    "onClick"
];
const $7710d23035a6bee7$var$_hoisted_34 = [
    "onUpdate:modelValue",
    "id"
];
const $7710d23035a6bee7$var$_hoisted_35 = [
    "onUpdate:modelValue",
    "max",
    "onInput",
    "id"
];
const $7710d23035a6bee7$var$_hoisted_36 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $7710d23035a6bee7$var$_hoisted_37 = [
    "onUpdate:modelValue",
    "onInput",
    "id"
];
const $7710d23035a6bee7$var$_hoisted_38 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $7710d23035a6bee7$var$_hoisted_39 = [
    $7710d23035a6bee7$var$_hoisted_38
];
const $7710d23035a6bee7$var$_hoisted_40 = {
    key: 1,
    class: "mb-3"
};
const $7710d23035a6bee7$var$_hoisted_41 = {
    class: "mb-3"
};
const $7710d23035a6bee7$var$_hoisted_42 = {
    class: "mb-3"
};
const $7710d23035a6bee7$var$_hoisted_43 = {
    class: "table"
};
const $7710d23035a6bee7$var$_hoisted_44 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $7710d23035a6bee7$var$_hoisted_45 = {
    scope: "col"
};
const $7710d23035a6bee7$var$_hoisted_46 = {
    scope: "col"
};
const $7710d23035a6bee7$var$_hoisted_47 = {
    scope: "col"
};
const $7710d23035a6bee7$var$_hoisted_48 = {
    scope: "row"
};
const $7710d23035a6bee7$var$_hoisted_49 = [
    "onClick"
];
const $7710d23035a6bee7$var$_hoisted_50 = [
    "id",
    "onUpdate:modelValue"
];
const $7710d23035a6bee7$var$_hoisted_51 = {
    disabled: ""
};
const $7710d23035a6bee7$var$_hoisted_52 = [
    "value"
];
const $7710d23035a6bee7$var$_hoisted_53 = [
    "onUpdate:modelValue",
    "id"
];
const $7710d23035a6bee7$var$_hoisted_54 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<option value="=">=</option><option value="&gt;">&gt;</option><option value="&lt;">&lt;</option><option value="&gt;=">&gt;=</option><option value="&lt;=">&lt;=</option>', 5);
const $7710d23035a6bee7$var$_hoisted_59 = [
    $7710d23035a6bee7$var$_hoisted_54
];
const $7710d23035a6bee7$var$_hoisted_60 = [
    "onUpdate:modelValue",
    "id"
];
const $7710d23035a6bee7$var$_hoisted_61 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $7710d23035a6bee7$var$_hoisted_62 = [
    $7710d23035a6bee7$var$_hoisted_61
];
const $7710d23035a6bee7$var$_hoisted_63 = {
    class: "mb-3"
};
const $7710d23035a6bee7$var$_hoisted_64 = {
    class: "mb-3"
};
const $7710d23035a6bee7$var$_hoisted_65 = {
    class: "table"
};
const $7710d23035a6bee7$var$_hoisted_66 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $7710d23035a6bee7$var$_hoisted_67 = {
    scope: "col"
};
const $7710d23035a6bee7$var$_hoisted_68 = {
    scope: "col"
};
const $7710d23035a6bee7$var$_hoisted_69 = {
    scope: "col"
};
const $7710d23035a6bee7$var$_hoisted_70 = {
    scope: "row"
};
const $7710d23035a6bee7$var$_hoisted_71 = [
    "onClick"
];
const $7710d23035a6bee7$var$_hoisted_72 = [
    "id",
    "onUpdate:modelValue"
];
const $7710d23035a6bee7$var$_hoisted_73 = {
    disabled: ""
};
const $7710d23035a6bee7$var$_hoisted_74 = [
    "value"
];
const $7710d23035a6bee7$var$_hoisted_75 = {
    class: "input-group"
};
const $7710d23035a6bee7$var$_hoisted_76 = [
    "onUpdate:modelValue",
    "id"
];
const $7710d23035a6bee7$var$_hoisted_77 = [
    "id",
    "onUpdate:modelValue"
];
const $7710d23035a6bee7$var$_hoisted_78 = {
    value: "0"
};
const $7710d23035a6bee7$var$_hoisted_79 = {
    value: "1"
};
const $7710d23035a6bee7$var$_hoisted_80 = {
    value: "2"
};
const $7710d23035a6bee7$var$_hoisted_81 = [
    "onUpdate:modelValue",
    "id"
];
const $7710d23035a6bee7$var$_hoisted_82 = {
    disabled: ""
};
const $7710d23035a6bee7$var$_hoisted_83 = [
    "value"
];
const $7710d23035a6bee7$var$_hoisted_84 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $7710d23035a6bee7$var$_hoisted_85 = [
    $7710d23035a6bee7$var$_hoisted_84
];
const $7710d23035a6bee7$var$_hoisted_86 = {
    class: "d-grid gap-2 d-md-flex"
};
function $7710d23035a6bee7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_apexchart = (0, $TusQn.resolveComponent)("apexchart");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7710d23035a6bee7$var$_hoisted_1, $7710d23035a6bee7$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7710d23035a6bee7$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("curveCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $7710d23035a6bee7$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $7710d23035a6bee7$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $7710d23035a6bee7$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $7710d23035a6bee7$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $7710d23035a6bee7$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $7710d23035a6bee7$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $7710d23035a6bee7$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $7710d23035a6bee7$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $7710d23035a6bee7$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7710d23035a6bee7$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $7710d23035a6bee7$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $7710d23035a6bee7$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("div", $7710d23035a6bee7$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("label", $7710d23035a6bee7$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("coefficientAttribute")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "coefficientAttribute",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.coefficientAttribute = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $7710d23035a6bee7$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    _ctx.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)(_ctx.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $7710d23035a6bee7$var$_hoisted_20);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.coefficientAttribute
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7710d23035a6bee7$var$_hoisted_21, [
                $7710d23035a6bee7$var$_hoisted_22,
                (0, $TusQn.createElementVNode)("div", $7710d23035a6bee7$var$_hoisted_23, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.coefficientForecastOnly = $event),
                        id: "coefficientForecastOnly",
                        checked: ""
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelCheckbox),
                            $data.data.coefficientForecastOnly
                        ]
                    ]),
                    (0, $TusQn.createElementVNode)("label", $7710d23035a6bee7$var$_hoisted_24, (0, $8POXm.toDisplayString)(_ctx.$t("coefficientForecastOnly")), 1)
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            class: "fa fa-eye btn btn-outline-primary float-end",
            onClick: _cache[4] || (_cache[4] = (...args)=>$options.showTableFunction && $options.showTableFunction(...args))
        }),
        $data.showTable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7710d23035a6bee7$var$_hoisted_25, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("curveRange")), 1),
            (0, $TusQn.createElementVNode)("table", $7710d23035a6bee7$var$_hoisted_26, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $7710d23035a6bee7$var$_hoisted_27,
                        (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("startAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("endAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_30, (0, $8POXm.toDisplayString)(_ctx.$t("startValue")), 1),
                        (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_31, (0, $8POXm.toDisplayString)(_ctx.$t("endValue")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.curveRanges, (curveRange, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_32, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeCurveRange(i)
                                }, null, 8, $7710d23035a6bee7$var$_hoisted_33)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>curveRange.startAge = $event,
                                    disabled: "",
                                    type: "number",
                                    class: "form-control",
                                    id: "startAge_" + i
                                }, null, 8, $7710d23035a6bee7$var$_hoisted_34), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        curveRange.startAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>curveRange.endAge = $event,
                                    max: $data.data.lifespan,
                                    onInput: ($event)=>$options.updateCurveAgeStart(curveRange.endAge, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endAge_" + i
                                }, null, 40, $7710d23035a6bee7$var$_hoisted_35), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        curveRange.endAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>curveRange.startValue = $event,
                                    disabled: i > 0,
                                    type: "number",
                                    class: "form-control",
                                    id: "startValue_" + i
                                }, null, 8, $7710d23035a6bee7$var$_hoisted_36), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        curveRange.startValue
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>curveRange.endValue = $event,
                                    onInput: ($event)=>$options.updateCurveStartValue(curveRange.endValue, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endValue_" + i
                                }, null, 40, $7710d23035a6bee7$var$_hoisted_37), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        curveRange.endValue
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[5] || (_cache[5] = (...args)=>$options.addCurveRange && $options.addCurveRange(...args))
            }, $7710d23035a6bee7$var$_hoisted_39)
        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7710d23035a6bee7$var$_hoisted_40, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("curveRangeChart")), 1),
            (0, $TusQn.createVNode)(_component_apexchart, {
                class: "d-flex justify-content-center",
                type: "line",
                width: "800px",
                options: $data.chartOptions,
                series: $data.series
            }, null, 8, [
                "options",
                "series"
            ])
        ])),
        (0, $TusQn.createElementVNode)("div", $7710d23035a6bee7$var$_hoisted_41, [
            (0, $TusQn.createElementVNode)("h4", $7710d23035a6bee7$var$_hoisted_42, (0, $8POXm.toDisplayString)(_ctx.$t("curveFilters")), 1),
            (0, $TusQn.createElementVNode)("table", $7710d23035a6bee7$var$_hoisted_43, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $7710d23035a6bee7$var$_hoisted_44,
                        (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_45, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_46, (0, $8POXm.toDisplayString)(_ctx.$t("sign")), 1),
                        (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_47, (0, $8POXm.toDisplayString)(_ctx.$t("number")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.curveFilters, (curveFilter, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_48, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeCurveFilter(i)
                                }, null, 8, $7710d23035a6bee7$var$_hoisted_49)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "name_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>curveFilter.name = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $7710d23035a6bee7$var$_hoisted_51, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    _ctx.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)(_ctx.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $7710d23035a6bee7$var$_hoisted_52);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $7710d23035a6bee7$var$_hoisted_50), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        curveFilter.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    "onUpdate:modelValue": ($event)=>curveFilter.sign = $event,
                                    class: "form-select",
                                    id: "sign_" + i
                                }, $7710d23035a6bee7$var$_hoisted_59, 8, $7710d23035a6bee7$var$_hoisted_53), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        curveFilter.sign
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>curveFilter.number = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "number_" + i
                                }, null, 8, $7710d23035a6bee7$var$_hoisted_60), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        curveFilter.number
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[6] || (_cache[6] = (...args)=>$options.addCurveFilter && $options.addCurveFilter(...args))
            }, $7710d23035a6bee7$var$_hoisted_62)
        ]),
        (0, $TusQn.createElementVNode)("div", $7710d23035a6bee7$var$_hoisted_63, [
            (0, $TusQn.createElementVNode)("h4", $7710d23035a6bee7$var$_hoisted_64, (0, $8POXm.toDisplayString)(_ctx.$t("curveActivityEffects")), 1),
            (0, $TusQn.createElementVNode)("table", $7710d23035a6bee7$var$_hoisted_65, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $7710d23035a6bee7$var$_hoisted_66,
                        (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_67, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_68, (0, $8POXm.toDisplayString)(_ctx.$t("effect")), 1),
                        (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_69, (0, $8POXm.toDisplayString)(_ctx.$t("changeToCurve")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.curveActivityEffects, (curveActivityEffect, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $7710d23035a6bee7$var$_hoisted_70, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeCurveActivityEffect(i)
                                }, null, 8, $7710d23035a6bee7$var$_hoisted_71)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "activityId_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>curveActivityEffect.activityId = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $7710d23035a6bee7$var$_hoisted_73, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    _ctx.activityList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)(_ctx.activityList, (activity, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: activity.id
                                        }, (0, $8POXm.toDisplayString)(activity.name), 9, $7710d23035a6bee7$var$_hoisted_74);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $7710d23035a6bee7$var$_hoisted_72), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        curveActivityEffect.activityId
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.createElementVNode)("div", $7710d23035a6bee7$var$_hoisted_75, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        "onUpdate:modelValue": ($event)=>curveActivityEffect.effect = $event,
                                        type: "number",
                                        class: "form-control",
                                        id: "effect_" + i
                                    }, null, 8, $7710d23035a6bee7$var$_hoisted_76), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            curveActivityEffect.effect
                                        ]
                                    ]),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        id: "effecttype_" + i,
                                        class: "form-select",
                                        "onUpdate:modelValue": ($event)=>curveActivityEffect.effectType = $event
                                    }, [
                                        (0, $TusQn.createElementVNode)("option", $7710d23035a6bee7$var$_hoisted_78, (0, $8POXm.toDisplayString)(_ctx.$t("Absolute")), 1),
                                        (0, $TusQn.createElementVNode)("option", $7710d23035a6bee7$var$_hoisted_79, (0, $8POXm.toDisplayString)(_ctx.$t("Relative")), 1),
                                        (0, $TusQn.createElementVNode)("option", $7710d23035a6bee7$var$_hoisted_80, (0, $8POXm.toDisplayString)(_ctx.$t("Differential")), 1)
                                    ], 8, $7710d23035a6bee7$var$_hoisted_77), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            curveActivityEffect.effectType
                                        ]
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    "onUpdate:modelValue": ($event)=>curveActivityEffect.changeToCurve = $event,
                                    class: "form-select",
                                    id: "changeToCurve_" + i
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $7710d23035a6bee7$var$_hoisted_82, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.curveList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.curveList, (curve, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: curve.name
                                        }, (0, $8POXm.toDisplayString)(curve.name), 9, $7710d23035a6bee7$var$_hoisted_83);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $7710d23035a6bee7$var$_hoisted_81), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        curveActivityEffect.changeToCurve
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[7] || (_cache[7] = (...args)=>$options.addCurveActivityEffect && $options.addCurveActivityEffect(...args))
            }, $7710d23035a6bee7$var$_hoisted_85)
        ]),
        (0, $TusQn.createElementVNode)("div", $7710d23035a6bee7$var$_hoisted_86, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[8] || (_cache[8] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[9] || (_cache[9] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("ltUFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa38451b766c6dbc$export$2e2bcd8739ae039);
let $fa38451b766c6dbc$var$NOOP = ()=>{};
var $fa38451b766c6dbc$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("8fsEv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6015f3344faf79ee$export$2e2bcd8739ae039);

var $eHCxc = parcelRequire("eHCxc");

var $2gQQk = parcelRequire("2gQQk");

var $fUmC0 = parcelRequire("fUmC0");

var $ch9iu = parcelRequire("ch9iu");

var $l6otV = parcelRequire("l6otV");

var $gM1Yh = parcelRequire("gM1Yh");

var $jjXIw = parcelRequire("jjXIw");

var $gOjKo = parcelRequire("gOjKo");
var $6015f3344faf79ee$export$2e2bcd8739ae039 = {
    name: "curvedetail",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    components: {
        CurveDeleteModal: $jjXIw.default
    },
    methods: {
        async onSubmit () {
            if (this.data.name.length > 0) {
                await (0, $fUmC0.default).curveUpdate(this.$route.params.id, this.data);
                if (!this.checkCurveFilters()) this.showFiltersWarning();
                else this.showSuccess();
            } else this.showEmptyNameError();
        },
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            this.data = await (0, $fUmC0.default).curveDetail(this.$route.params.id, this.$route.params.curveId);
            this.parameter = await (0, $gM1Yh.default).parameterDetail(this.$route.params.id, this.data.parameterId);
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.parameter.assetTypeId);
            this.assetTypeName = assetType.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var activityList = await (0, $2gQQk.default).activityList(this.$route.params.id);
            this.activityList = activityList.filter((a)=>a.assetTypeId == this.$route.params.assetTypeId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var curveList = await (0, $fUmC0.default).curveList(this.$route.params.id);
            this.curveList = curveList.filter((a)=>a.parameterId == this.data.parameterId && a.id != this.$route.params.curveId);
            for(var i in this.data.curveFilters){
                var attr = this.data.curveFilters[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr.name) < 0 && this.missingDatasetFilterHeaders.findIndex((d)=>d.name == attr.name) < 0) this.missingDatasetFilterHeaders.push({
                    name: attr.name,
                    alias: attr.name
                });
            }
            // for(var i in this.data.curveActivityEffects) {
            //     var attr = this.data.curveActivityEffects[i];
            //     if(this.datasetHeaders.findIndex(d => d.name == attr.name) < 0 && this.missingDatasetFilterHeaders.findIndex(d => d.name == attr.name) < 0) {
            //         this.missingDatasetFilterHeaders.push({ name: attr.name, alias: attr.name });
            //     }
            // }
            this.pending = false;
        },
        showTableFunction () {
            this.generateGraph();
            this.showTable = !this.showTable;
        },
        generateGraph () {
            let seriesData = [];
            for (let range of this.data.curveRanges){
                seriesData.push({
                    x: range.startAge,
                    y: range.startValue
                });
                seriesData.push({
                    x: range.endAge,
                    y: range.endValue
                });
            }
            this.series = [
                {
                    name: "Value",
                    data: seriesData
                }
            ];
        },
        removeCurveFilter (rowIndex) {
            this.data.curveFilters.splice(rowIndex, 1);
        },
        addCurveFilter () {
            this.data.curveFilters.push({
                name: "",
                sign: "=",
                number: 0
            });
        },
        removeCurveActivityEffect (rowIndex) {
            this.data.curveActivityEffects.splice(rowIndex, 1);
        },
        addCurveActivityEffect () {
            this.data.curveActivityEffects.push({
                effect: 0,
                effectType: 0,
                changeToCurveId: 0
            });
        },
        updateCurveAgeStart (value, i) {
            var range = this.data.curveRanges[i + 1];
            if (range) range.startAge = value;
        },
        updateCurveStartValue (value, i) {
            var range = this.data.curveRanges[i + 1];
            if (range) range.startValue = value;
        },
        removeCurveRange (rowIndex) {
            this.data.curveRanges.splice(rowIndex, 1);
        },
        addCurveRange () {
            this.data.curveRanges.push({
                description: "",
                startAge: this.getMinStartAge(),
                endAge: 0,
                startValue: this.getMinStartValue(),
                endValue: 0.0
            });
        },
        getMinStartAge () {
            var minStartAge = 0;
            if (this.data.curveRanges.length > 0) minStartAge = this.data.curveRanges[this.data.curveRanges.length - 1].endAge;
            return minStartAge;
        },
        getMinStartValue () {
            var minStartValue = 0;
            if (this.data.curveRanges.length > 0) minStartValue = this.data.curveRanges[this.data.curveRanges.length - 1].endValue;
            return minStartValue;
        },
        showDeleteCurve () {
            this.curveToDeleteId = this.data.id;
            this.showCurveDeleteModal = true;
        },
        checkCurveFilters () {
            for(var i in this.data.curveFilters){
                var attr = this.data.curveFilters[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr.name) < 0 || attr.name == "") return false;
            }
            return true;
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "curveUpdated",
            type: "success"
        },
        showActivityEffectsWarning: {
            title: "warning",
            message: "curveActivityEffectsWarning",
            type: "warn"
        },
        showFiltersWarning: {
            title: "warning",
            message: "curveFiltersWarning",
            type: "warn"
        },
        showError: {
            title: "error",
            message: "curveErrorUpdate",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            parameter: {},
            datasetHeaders: [],
            missingDatasetFilterHeaders: [],
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                curveGroup: [],
                curvePackage: [],
                curveLimit: []
            },
            showCurveDeleteModal: false,
            showAnalyseCurve: false,
            showValidateCurve: false,
            pending: true,
            modelingName: "",
            showTable: true,
            curveList: [],
            curveToDeleteId: 0,
            isUserAdmin: false,
            activityList: [],
            series: [],
            chartOptions: {
                chart: {
                    type: "line",
                    animations: {
                        enabled: false
                    },
                    height: 350,
                    toolbar: {
                        show: false
                    }
                },
                xaxis: {
                    title: {
                        text: "Age"
                    }
                },
                yaxis: {
                    title: {
                        text: "Value"
                    }
                }
            }
        };
    }
};

});
parcelRegister("jjXIw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e10e1d39ed6ed3e8$export$2e2bcd8739ae039);
let $e10e1d39ed6ed3e8$var$script;



let $e10e1d39ed6ed3e8$var$initialize = ()=>{
    $e10e1d39ed6ed3e8$var$script = (parcelRequire("5jHwb"));
    if ($e10e1d39ed6ed3e8$var$script.__esModule) $e10e1d39ed6ed3e8$var$script = $e10e1d39ed6ed3e8$var$script.default;
    $e10e1d39ed6ed3e8$var$script.render = (parcelRequire("k0tYL")).render;
    (parcelRequire("73xMd")).default($e10e1d39ed6ed3e8$var$script);
    $e10e1d39ed6ed3e8$var$script.__scopeId = "data-v-47faab";
    $e10e1d39ed6ed3e8$var$script.__file = "CurveDeleteModal.vue";
};
$e10e1d39ed6ed3e8$var$initialize();
var $e10e1d39ed6ed3e8$export$2e2bcd8739ae039 = $e10e1d39ed6ed3e8$var$script;

});
parcelRegister("5jHwb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3df07bde076da65c$export$2e2bcd8739ae039);

var $fUmC0 = parcelRequire("fUmC0");
var $3df07bde076da65c$export$2e2bcd8739ae039 = {
    name: "curveDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteCurve () {
            await (0, $fUmC0.default).curveDelete(this.$parent.$route.params.id, this.$parent.$route.params.curveId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("k0tYL", function(module, exports) {

$parcel$export(module.exports, "render", () => $e90b0fef5de82cd2$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $e90b0fef5de82cd2$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $e90b0fef5de82cd2$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $e90b0fef5de82cd2$var$_hoisted_3 = {
    class: "modal-content"
};
const $e90b0fef5de82cd2$var$_hoisted_4 = {
    class: "modal-header"
};
const $e90b0fef5de82cd2$var$_hoisted_5 = {
    class: "modal-title"
};
const $e90b0fef5de82cd2$var$_hoisted_6 = {
    class: "modal-body"
};
const $e90b0fef5de82cd2$var$_hoisted_7 = {
    class: "modal-footer"
};
function $e90b0fef5de82cd2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $e90b0fef5de82cd2$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $e90b0fef5de82cd2$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $e90b0fef5de82cd2$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $e90b0fef5de82cd2$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $e90b0fef5de82cd2$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("curveDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $e90b0fef5de82cd2$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisCurve")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $e90b0fef5de82cd2$var$_hoisted_7, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteCurve && $options.deleteCurve(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("73xMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $52330391c5e5b29d$export$2e2bcd8739ae039);
let $52330391c5e5b29d$var$NOOP = ()=>{};
var $52330391c5e5b29d$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("iDKwv", function(module, exports) {

$parcel$export(module.exports, "render", () => $d91ff518008976da$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $d91ff518008976da$var$_hoisted_1 = {
    key: 0
};
const $d91ff518008976da$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $d91ff518008976da$var$_hoisted_3 = [
    $d91ff518008976da$var$_hoisted_2
];
const $d91ff518008976da$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $d91ff518008976da$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $d91ff518008976da$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $d91ff518008976da$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $d91ff518008976da$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $d91ff518008976da$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $d91ff518008976da$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $d91ff518008976da$var$_hoisted_11 = {
    class: "row mb-4"
};
const $d91ff518008976da$var$_hoisted_12 = {
    class: "mb-3 col-md-4"
};
const $d91ff518008976da$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $d91ff518008976da$var$_hoisted_14 = {
    class: "mb-3 col-md-8"
};
const $d91ff518008976da$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $d91ff518008976da$var$_hoisted_16 = {
    class: "row mb-4"
};
const $d91ff518008976da$var$_hoisted_17 = {
    class: "mb-3 col-md-4"
};
const $d91ff518008976da$var$_hoisted_18 = {
    class: "form-label",
    for: "coefficientAttribute",
    required: ""
};
const $d91ff518008976da$var$_hoisted_19 = {
    disabled: ""
};
const $d91ff518008976da$var$_hoisted_20 = [
    "value"
];
const $d91ff518008976da$var$_hoisted_21 = {
    class: "mb-3 col-md-4"
};
const $d91ff518008976da$var$_hoisted_22 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "form-label"
}, "\xa0", -1);
const $d91ff518008976da$var$_hoisted_23 = {
    class: "form-check"
};
const $d91ff518008976da$var$_hoisted_24 = {
    class: "form-check-label",
    for: "coefficientForecastOnly"
};
const $d91ff518008976da$var$_hoisted_25 = {
    key: 0,
    class: "mb-3"
};
const $d91ff518008976da$var$_hoisted_26 = {
    class: "table"
};
const $d91ff518008976da$var$_hoisted_27 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $d91ff518008976da$var$_hoisted_28 = {
    scope: "col"
};
const $d91ff518008976da$var$_hoisted_29 = {
    scope: "col"
};
const $d91ff518008976da$var$_hoisted_30 = {
    scope: "col"
};
const $d91ff518008976da$var$_hoisted_31 = {
    scope: "col"
};
const $d91ff518008976da$var$_hoisted_32 = {
    scope: "row"
};
const $d91ff518008976da$var$_hoisted_33 = [
    "onClick"
];
const $d91ff518008976da$var$_hoisted_34 = [
    "onUpdate:modelValue",
    "id"
];
const $d91ff518008976da$var$_hoisted_35 = [
    "onUpdate:modelValue",
    "max",
    "onInput",
    "id"
];
const $d91ff518008976da$var$_hoisted_36 = [
    "onUpdate:modelValue",
    "disabled",
    "id"
];
const $d91ff518008976da$var$_hoisted_37 = [
    "onUpdate:modelValue",
    "onInput",
    "id"
];
const $d91ff518008976da$var$_hoisted_38 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $d91ff518008976da$var$_hoisted_39 = [
    $d91ff518008976da$var$_hoisted_38
];
const $d91ff518008976da$var$_hoisted_40 = {
    key: 1,
    class: "mb-3"
};
const $d91ff518008976da$var$_hoisted_41 = {
    class: "mb-3"
};
const $d91ff518008976da$var$_hoisted_42 = {
    class: "mb-3"
};
const $d91ff518008976da$var$_hoisted_43 = {
    class: "table"
};
const $d91ff518008976da$var$_hoisted_44 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $d91ff518008976da$var$_hoisted_45 = {
    scope: "col"
};
const $d91ff518008976da$var$_hoisted_46 = {
    scope: "col"
};
const $d91ff518008976da$var$_hoisted_47 = {
    scope: "col"
};
const $d91ff518008976da$var$_hoisted_48 = {
    scope: "row"
};
const $d91ff518008976da$var$_hoisted_49 = [
    "onClick"
];
const $d91ff518008976da$var$_hoisted_50 = [
    "id",
    "onUpdate:modelValue"
];
const $d91ff518008976da$var$_hoisted_51 = {
    disabled: ""
};
const $d91ff518008976da$var$_hoisted_52 = [
    "value"
];
const $d91ff518008976da$var$_hoisted_53 = [
    "onUpdate:modelValue",
    "id"
];
const $d91ff518008976da$var$_hoisted_54 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<option value="=">=</option><option value="&gt;">&gt;</option><option value="&lt;">&lt;</option><option value="&gt;=">&gt;=</option><option value="&lt;=">&lt;=</option>', 5);
const $d91ff518008976da$var$_hoisted_59 = [
    $d91ff518008976da$var$_hoisted_54
];
const $d91ff518008976da$var$_hoisted_60 = [
    "onUpdate:modelValue",
    "id"
];
const $d91ff518008976da$var$_hoisted_61 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $d91ff518008976da$var$_hoisted_62 = [
    $d91ff518008976da$var$_hoisted_61
];
const $d91ff518008976da$var$_hoisted_63 = {
    class: "mb-3"
};
const $d91ff518008976da$var$_hoisted_64 = {
    class: "mb-3"
};
const $d91ff518008976da$var$_hoisted_65 = {
    class: "table"
};
const $d91ff518008976da$var$_hoisted_66 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $d91ff518008976da$var$_hoisted_67 = {
    scope: "col"
};
const $d91ff518008976da$var$_hoisted_68 = {
    scope: "col"
};
const $d91ff518008976da$var$_hoisted_69 = {
    scope: "col"
};
const $d91ff518008976da$var$_hoisted_70 = {
    scope: "row"
};
const $d91ff518008976da$var$_hoisted_71 = [
    "onClick"
];
const $d91ff518008976da$var$_hoisted_72 = [
    "id",
    "onUpdate:modelValue"
];
const $d91ff518008976da$var$_hoisted_73 = {
    disabled: ""
};
const $d91ff518008976da$var$_hoisted_74 = [
    "value"
];
const $d91ff518008976da$var$_hoisted_75 = {
    class: "input-group"
};
const $d91ff518008976da$var$_hoisted_76 = [
    "onUpdate:modelValue",
    "id"
];
const $d91ff518008976da$var$_hoisted_77 = [
    "id",
    "onUpdate:modelValue"
];
const $d91ff518008976da$var$_hoisted_78 = {
    value: "0"
};
const $d91ff518008976da$var$_hoisted_79 = {
    value: "1"
};
const $d91ff518008976da$var$_hoisted_80 = {
    value: "2"
};
const $d91ff518008976da$var$_hoisted_81 = [
    "onUpdate:modelValue",
    "id"
];
const $d91ff518008976da$var$_hoisted_82 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $d91ff518008976da$var$_hoisted_83 = [
    "value"
];
const $d91ff518008976da$var$_hoisted_84 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $d91ff518008976da$var$_hoisted_85 = [
    $d91ff518008976da$var$_hoisted_84
];
const $d91ff518008976da$var$_hoisted_86 = {
    class: "d-grid gap-2 d-md-flex"
};
function $d91ff518008976da$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_apexchart = (0, $TusQn.resolveComponent)("apexchart");
    const _component_CurveDeleteModal = (0, $TusQn.resolveComponent)("CurveDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d91ff518008976da$var$_hoisted_1, $d91ff518008976da$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d91ff518008976da$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("curveDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $d91ff518008976da$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $d91ff518008976da$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $d91ff518008976da$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $d91ff518008976da$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $d91ff518008976da$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $d91ff518008976da$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $d91ff518008976da$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $d91ff518008976da$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $d91ff518008976da$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $d91ff518008976da$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $d91ff518008976da$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $d91ff518008976da$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("div", $d91ff518008976da$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("label", $d91ff518008976da$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("coefficientAttribute")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "coefficientAttribute",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.coefficientAttribute = $event)
                }, [
                    (0, $TusQn.createElementVNode)("option", $d91ff518008976da$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            key: i,
                            value: datasetHeader.name
                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $d91ff518008976da$var$_hoisted_20);
                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.coefficientAttribute
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $d91ff518008976da$var$_hoisted_21, [
                $d91ff518008976da$var$_hoisted_22,
                (0, $TusQn.createElementVNode)("div", $d91ff518008976da$var$_hoisted_23, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.coefficientForecastOnly = $event),
                        id: "coefficientForecastOnly",
                        checked: ""
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelCheckbox),
                            $data.data.coefficientForecastOnly
                        ]
                    ]),
                    (0, $TusQn.createElementVNode)("label", $d91ff518008976da$var$_hoisted_24, (0, $8POXm.toDisplayString)(_ctx.$t("coefficientForecastOnly")), 1)
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            class: "fa fa-eye btn btn-outline-primary float-end",
            onClick: _cache[4] || (_cache[4] = (...args)=>$options.showTableFunction && $options.showTableFunction(...args))
        }),
        $data.showTable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d91ff518008976da$var$_hoisted_25, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("curveRange")), 1),
            (0, $TusQn.createElementVNode)("table", $d91ff518008976da$var$_hoisted_26, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $d91ff518008976da$var$_hoisted_27,
                        (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("startAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("endAge")), 1),
                        (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_30, (0, $8POXm.toDisplayString)(_ctx.$t("startValue")), 1),
                        (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_31, (0, $8POXm.toDisplayString)(_ctx.$t("endValue")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.curveRanges, (curveRange, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_32, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeCurveRange(i)
                                }, null, 8, $d91ff518008976da$var$_hoisted_33)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>curveRange.startAge = $event,
                                    disabled: "",
                                    type: "number",
                                    class: "form-control",
                                    id: "startAge_" + i
                                }, null, 8, $d91ff518008976da$var$_hoisted_34), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        curveRange.startAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>curveRange.endAge = $event,
                                    max: $data.data.lifespan,
                                    onInput: ($event)=>$options.updateCurveAgeStart(curveRange.endAge, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endAge_" + i
                                }, null, 40, $d91ff518008976da$var$_hoisted_35), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        curveRange.endAge
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>curveRange.startValue = $event,
                                    disabled: i > 0,
                                    type: "number",
                                    class: "form-control",
                                    id: "startValue_" + i
                                }, null, 8, $d91ff518008976da$var$_hoisted_36), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        curveRange.startValue
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>curveRange.endValue = $event,
                                    onInput: ($event)=>$options.updateCurveStartValue(curveRange.endValue, i),
                                    type: "number",
                                    class: "form-control",
                                    id: "endValue_" + i
                                }, null, 40, $d91ff518008976da$var$_hoisted_37), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        curveRange.endValue
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[5] || (_cache[5] = (...args)=>$options.addCurveRange && $options.addCurveRange(...args))
            }, $d91ff518008976da$var$_hoisted_39)
        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d91ff518008976da$var$_hoisted_40, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("curveRangeChart")), 1),
            (0, $TusQn.createVNode)(_component_apexchart, {
                class: "d-flex justify-content-center",
                type: "line",
                width: "800px",
                options: $data.chartOptions,
                series: $data.series
            }, null, 8, [
                "options",
                "series"
            ])
        ])),
        (0, $TusQn.createElementVNode)("div", $d91ff518008976da$var$_hoisted_41, [
            (0, $TusQn.createElementVNode)("h4", $d91ff518008976da$var$_hoisted_42, (0, $8POXm.toDisplayString)(_ctx.$t("curveFilters")), 1),
            (0, $TusQn.createElementVNode)("table", $d91ff518008976da$var$_hoisted_43, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $d91ff518008976da$var$_hoisted_44,
                        (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_45, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_46, (0, $8POXm.toDisplayString)(_ctx.$t("sign")), 1),
                        (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_47, (0, $8POXm.toDisplayString)(_ctx.$t("number")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.curveFilters, (curveFilter, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_48, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeCurveFilter(i)
                                }, null, 8, $d91ff518008976da$var$_hoisted_49)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "name_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>curveFilter.name = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $d91ff518008976da$var$_hoisted_51, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $d91ff518008976da$var$_hoisted_52);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $d91ff518008976da$var$_hoisted_50), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        curveFilter.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    "onUpdate:modelValue": ($event)=>curveFilter.sign = $event,
                                    class: "form-select",
                                    id: "sign_" + i
                                }, $d91ff518008976da$var$_hoisted_59, 8, $d91ff518008976da$var$_hoisted_53), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        curveFilter.sign
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>curveFilter.number = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "number_" + i
                                }, null, 8, $d91ff518008976da$var$_hoisted_60), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        curveFilter.number
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[6] || (_cache[6] = (...args)=>$options.addCurveFilter && $options.addCurveFilter(...args))
            }, $d91ff518008976da$var$_hoisted_62)
        ]),
        (0, $TusQn.createElementVNode)("div", $d91ff518008976da$var$_hoisted_63, [
            (0, $TusQn.createElementVNode)("h4", $d91ff518008976da$var$_hoisted_64, (0, $8POXm.toDisplayString)(_ctx.$t("curveActivityEffects")), 1),
            (0, $TusQn.createElementVNode)("table", $d91ff518008976da$var$_hoisted_65, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $d91ff518008976da$var$_hoisted_66,
                        (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_67, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_68, (0, $8POXm.toDisplayString)(_ctx.$t("effect")), 1),
                        (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_69, (0, $8POXm.toDisplayString)(_ctx.$t("changeToCurve")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.curveActivityEffects, (curveActivityEffect, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $d91ff518008976da$var$_hoisted_70, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeCurveActivityEffect(i)
                                }, null, 8, $d91ff518008976da$var$_hoisted_71)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "activityId_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>curveActivityEffect.activityId = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $d91ff518008976da$var$_hoisted_73, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.activityList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.activityList, (activity, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: activity.id
                                        }, (0, $8POXm.toDisplayString)(activity.name), 9, $d91ff518008976da$var$_hoisted_74);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $d91ff518008976da$var$_hoisted_72), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        curveActivityEffect.activityId
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.createElementVNode)("div", $d91ff518008976da$var$_hoisted_75, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        "onUpdate:modelValue": ($event)=>curveActivityEffect.effect = $event,
                                        type: "number",
                                        class: "form-control",
                                        id: "effect_" + i
                                    }, null, 8, $d91ff518008976da$var$_hoisted_76), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            curveActivityEffect.effect
                                        ]
                                    ]),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        id: "effecttype_" + i,
                                        class: "form-select",
                                        "onUpdate:modelValue": ($event)=>curveActivityEffect.effectType = $event
                                    }, [
                                        (0, $TusQn.createElementVNode)("option", $d91ff518008976da$var$_hoisted_78, (0, $8POXm.toDisplayString)(_ctx.$t("Absolute")), 1),
                                        (0, $TusQn.createElementVNode)("option", $d91ff518008976da$var$_hoisted_79, (0, $8POXm.toDisplayString)(_ctx.$t("Relative")), 1),
                                        (0, $TusQn.createElementVNode)("option", $d91ff518008976da$var$_hoisted_80, (0, $8POXm.toDisplayString)(_ctx.$t("Differential")), 1)
                                    ], 8, $d91ff518008976da$var$_hoisted_77), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            curveActivityEffect.effectType
                                        ]
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    "onUpdate:modelValue": ($event)=>curveActivityEffect.changeToCurveId = $event,
                                    class: "form-select",
                                    id: "changeToCurve_" + i
                                }, [
                                    $d91ff518008976da$var$_hoisted_82,
                                    $data.curveList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.curveList, (curve, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: curve.id
                                        }, (0, $8POXm.toDisplayString)(curve.name), 9, $d91ff518008976da$var$_hoisted_83);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $d91ff518008976da$var$_hoisted_81), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        curveActivityEffect.changeToCurveId
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[7] || (_cache[7] = (...args)=>$options.addCurveActivityEffect && $options.addCurveActivityEffect(...args))
            }, $d91ff518008976da$var$_hoisted_85)
        ]),
        (0, $TusQn.createElementVNode)("div", $d91ff518008976da$var$_hoisted_86, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[8] || (_cache[8] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[9] || (_cache[9] = (...args)=>$options.showDeleteCurve && $options.showDeleteCurve(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[10] || (_cache[10] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showCurveDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_CurveDeleteModal, {
            key: 2,
            onReload: _cache[11] || (_cache[11] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                })),
            onCloseDeleteDialog: _cache[12] || (_cache[12] = ($event)=>$data.showCurveDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("3qfc9", function(module, exports) {

$parcel$export(module.exports, "default", () => $27df96312bfa4e85$export$2e2bcd8739ae039);
let $27df96312bfa4e85$var$NOOP = ()=>{};
var $27df96312bfa4e85$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("6Ydpq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5132bf6c2e477be0$export$2e2bcd8739ae039);

var $eHCxc = parcelRequire("eHCxc");

var $ch9iu = parcelRequire("ch9iu");

var $ljJJR = parcelRequire("ljJJR");

var $aYIG6 = parcelRequire("aYIG6");

var $l6otV = parcelRequire("l6otV");

var $gM1Yh = parcelRequire("gM1Yh");
var $5132bf6c2e477be0$export$2e2bcd8739ae039 = {
    name: "evaluationcreate",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.pending = true;
            this.data.keyPerformanceIndicatorId = this.$route.params.keyPerformanceIndicatorId;
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var evaluationList = await (0, $ljJJR.default).evaluationList(this.$route.params.id);
            this.evaluationList = evaluationList.filter((a)=>a.keyPerformanceIndicatorId == this.$route.params.keyPerformanceIndicatorId);
            var parameterList = await (0, $gM1Yh.default).parameterList(this.$route.params.id);
            this.parameterList = parameterList.filter((a)=>a.assetTypeId == assetType.id);
            var kpiList = await (0, $aYIG6.default).kpiList(this.$route.params.id);
            this.kpiList = kpiList.filter((a)=>a.assetTypeId == assetType.id);
            this.pending = false;
        },
        async onSubmit () {
            try {
                if (this.data.name.length > 0) {
                    await (0, $ljJJR.default).evaluationCreate(this.$route.params.id, this.data);
                    this.showSuccess();
                    this.$router.go(-1);
                } else this.showEmptyNameError();
            } catch  {
                this.showError();
            }
        },
        onSelectChange (event, index) {
            const select = event.target;
            const option = select.options[select.selectedIndex];
            const type = option.getAttribute("name");
            const value = select.value;
            const row = this.data.evaluationParameters[index];
            if (type == "parameter") {
                row.parameterId = Number(value);
                row.kpiId = null;
            } else if (type == "kpi") {
                row.parameterId = null;
                row.kpiId = Number(value);
            }
        },
        removeEvaluationFilter (rowIndex) {
            this.data.evaluationFilters.splice(rowIndex, 1);
        },
        addEvaluationFilter () {
            this.data.evaluationFilters.push({
                name: "",
                sign: "=",
                number: 0
            });
        },
        removeEvaluationParameter (rowIndex) {
            this.data.evaluationParameters.splice(rowIndex, 1);
        },
        addEvaluationParameter () {
            this.data.evaluationParameters.push({
                evaluationId: 0,
                parameterId: 0,
                kpiId: 0,
                weight: 0.0,
                useAttribute: false,
                weightAttribute: ""
            });
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "evaluationCreated",
            type: "success"
        },
        showError: {
            title: "error",
            message: "evaluationError",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            data: {
                id: 0,
                name: "",
                description: "",
                evaluationParameters: [],
                evaluationFilters: [],
                multiply: false,
                recalculateWeight: false,
                weightAverage: false,
                additionalProportion: 0,
                increasingValue: 0
            },
            parameterList: [],
            evaluationList: [],
            kpiList: [],
            pending: true,
            modelingName: ""
        };
    }
};

});

parcelRegister("7ASaG", function(module, exports) {

$parcel$export(module.exports, "render", () => $5875ea7b7e9f7cee$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $5875ea7b7e9f7cee$var$_hoisted_1 = {
    key: 0
};
const $5875ea7b7e9f7cee$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $5875ea7b7e9f7cee$var$_hoisted_3 = [
    $5875ea7b7e9f7cee$var$_hoisted_2
];
const $5875ea7b7e9f7cee$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $5875ea7b7e9f7cee$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $5875ea7b7e9f7cee$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $5875ea7b7e9f7cee$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $5875ea7b7e9f7cee$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $5875ea7b7e9f7cee$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $5875ea7b7e9f7cee$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $5875ea7b7e9f7cee$var$_hoisted_11 = {
    class: "row mb-4"
};
const $5875ea7b7e9f7cee$var$_hoisted_12 = {
    class: "mb-3 col-md-4"
};
const $5875ea7b7e9f7cee$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $5875ea7b7e9f7cee$var$_hoisted_14 = {
    class: "mb-3 col-md-8"
};
const $5875ea7b7e9f7cee$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $5875ea7b7e9f7cee$var$_hoisted_16 = {
    class: "row mb-4"
};
const $5875ea7b7e9f7cee$var$_hoisted_17 = {
    class: "mb-3 col-md-4"
};
const $5875ea7b7e9f7cee$var$_hoisted_18 = {
    class: "form-label",
    for: "additionalProportion",
    required: ""
};
const $5875ea7b7e9f7cee$var$_hoisted_19 = {
    class: "mb-3 col-md-8"
};
const $5875ea7b7e9f7cee$var$_hoisted_20 = {
    class: "form-label",
    for: "increasingValue",
    required: ""
};
const $5875ea7b7e9f7cee$var$_hoisted_21 = {
    class: "row mb-4"
};
const $5875ea7b7e9f7cee$var$_hoisted_22 = {
    class: "col-2"
};
const $5875ea7b7e9f7cee$var$_hoisted_23 = {
    class: "form-check-label ps-2",
    for: "recalculateWeight"
};
const $5875ea7b7e9f7cee$var$_hoisted_24 = {
    class: "col-2"
};
const $5875ea7b7e9f7cee$var$_hoisted_25 = {
    class: "form-check-label ps-2",
    for: "weightAverage"
};
const $5875ea7b7e9f7cee$var$_hoisted_26 = {
    class: "col-2"
};
const $5875ea7b7e9f7cee$var$_hoisted_27 = {
    class: "form-check-label ps-2",
    for: "multiply"
};
const $5875ea7b7e9f7cee$var$_hoisted_28 = {
    class: "mb-3"
};
const $5875ea7b7e9f7cee$var$_hoisted_29 = {
    class: "table"
};
const $5875ea7b7e9f7cee$var$_hoisted_30 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $5875ea7b7e9f7cee$var$_hoisted_31 = {
    scope: "col"
};
const $5875ea7b7e9f7cee$var$_hoisted_32 = {
    scope: "col"
};
const $5875ea7b7e9f7cee$var$_hoisted_33 = {
    scope: "col"
};
const $5875ea7b7e9f7cee$var$_hoisted_34 = {
    scope: "col"
};
const $5875ea7b7e9f7cee$var$_hoisted_35 = {
    scope: "row"
};
const $5875ea7b7e9f7cee$var$_hoisted_36 = [
    "onClick"
];
const $5875ea7b7e9f7cee$var$_hoisted_37 = [
    "id",
    "onChange"
];
const $5875ea7b7e9f7cee$var$_hoisted_38 = {
    selected: "",
    disabled: ""
};
const $5875ea7b7e9f7cee$var$_hoisted_39 = [
    "value"
];
const $5875ea7b7e9f7cee$var$_hoisted_40 = [
    "value"
];
const $5875ea7b7e9f7cee$var$_hoisted_41 = [
    "onUpdate:modelValue",
    "id"
];
const $5875ea7b7e9f7cee$var$_hoisted_42 = [
    "onUpdate:modelValue",
    "id"
];
const $5875ea7b7e9f7cee$var$_hoisted_43 = [
    "id",
    "onUpdate:modelValue",
    "disabled"
];
const $5875ea7b7e9f7cee$var$_hoisted_44 = {
    disabled: ""
};
const $5875ea7b7e9f7cee$var$_hoisted_45 = [
    "value"
];
const $5875ea7b7e9f7cee$var$_hoisted_46 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $5875ea7b7e9f7cee$var$_hoisted_47 = [
    $5875ea7b7e9f7cee$var$_hoisted_46
];
const $5875ea7b7e9f7cee$var$_hoisted_48 = {
    class: "mb-3"
};
const $5875ea7b7e9f7cee$var$_hoisted_49 = {
    class: "mb-3"
};
const $5875ea7b7e9f7cee$var$_hoisted_50 = {
    class: "table"
};
const $5875ea7b7e9f7cee$var$_hoisted_51 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $5875ea7b7e9f7cee$var$_hoisted_52 = {
    scope: "col"
};
const $5875ea7b7e9f7cee$var$_hoisted_53 = {
    scope: "col"
};
const $5875ea7b7e9f7cee$var$_hoisted_54 = {
    scope: "col"
};
const $5875ea7b7e9f7cee$var$_hoisted_55 = {
    scope: "row"
};
const $5875ea7b7e9f7cee$var$_hoisted_56 = [
    "onClick"
];
const $5875ea7b7e9f7cee$var$_hoisted_57 = [
    "id",
    "onUpdate:modelValue"
];
const $5875ea7b7e9f7cee$var$_hoisted_58 = {
    disabled: ""
};
const $5875ea7b7e9f7cee$var$_hoisted_59 = [
    "value"
];
const $5875ea7b7e9f7cee$var$_hoisted_60 = [
    "onUpdate:modelValue",
    "id"
];
const $5875ea7b7e9f7cee$var$_hoisted_61 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<option value="=">=</option><option value="&gt;">&gt;</option><option value="&lt;">&lt;</option><option value="&gt;=">&gt;=</option><option value="&lt;=">&lt;=</option>', 5);
const $5875ea7b7e9f7cee$var$_hoisted_66 = [
    $5875ea7b7e9f7cee$var$_hoisted_61
];
const $5875ea7b7e9f7cee$var$_hoisted_67 = [
    "onUpdate:modelValue",
    "id"
];
const $5875ea7b7e9f7cee$var$_hoisted_68 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $5875ea7b7e9f7cee$var$_hoisted_69 = [
    $5875ea7b7e9f7cee$var$_hoisted_68
];
const $5875ea7b7e9f7cee$var$_hoisted_70 = {
    class: "d-grid gap-2 d-md-flex"
};
function $5875ea7b7e9f7cee$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5875ea7b7e9f7cee$var$_hoisted_1, $5875ea7b7e9f7cee$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5875ea7b7e9f7cee$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationCreate")), 1),
        (0, $TusQn.createElementVNode)("nav", $5875ea7b7e9f7cee$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $5875ea7b7e9f7cee$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $5875ea7b7e9f7cee$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $5875ea7b7e9f7cee$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $5875ea7b7e9f7cee$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $5875ea7b7e9f7cee$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $5875ea7b7e9f7cee$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $5875ea7b7e9f7cee$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("label", $5875ea7b7e9f7cee$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("additionalProportion")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.additionalProportion = $event),
                    type: "number",
                    class: "form-control",
                    id: "additionalProportion"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.additionalProportion
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_19, [
                (0, $TusQn.createElementVNode)("label", $5875ea7b7e9f7cee$var$_hoisted_20, (0, $8POXm.toDisplayString)(_ctx.$t("increasingValue")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.increasingValue = $event),
                    type: "number",
                    class: "form-control",
                    id: "increasingValue"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.increasingValue
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_21, [
            (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_22, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.recalculateWeight = $event),
                    type: "checkbox",
                    id: "recalculateWeight"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.recalculateWeight
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $5875ea7b7e9f7cee$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("recalculateWeight")), 1)
            ]),
            (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_24, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.data.weightAverage = $event),
                    type: "checkbox",
                    id: "weightAverage"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.weightAverage
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $5875ea7b7e9f7cee$var$_hoisted_25, (0, $8POXm.toDisplayString)(_ctx.$t("weightAverage")), 1)
            ]),
            (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_26, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.data.multiply = $event),
                    type: "checkbox",
                    id: "multiply"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.multiply
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $5875ea7b7e9f7cee$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("multiply")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_28, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationParameters")), 1),
            (0, $TusQn.createElementVNode)("table", $5875ea7b7e9f7cee$var$_hoisted_29, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $5875ea7b7e9f7cee$var$_hoisted_30,
                        (0, $TusQn.createElementVNode)("th", $5875ea7b7e9f7cee$var$_hoisted_31, (0, $8POXm.toDisplayString)(_ctx.$t("parameter")), 1),
                        (0, $TusQn.createElementVNode)("th", $5875ea7b7e9f7cee$var$_hoisted_32, (0, $8POXm.toDisplayString)(_ctx.$t("weight")), 1),
                        (0, $TusQn.createElementVNode)("th", $5875ea7b7e9f7cee$var$_hoisted_33, (0, $8POXm.toDisplayString)(_ctx.$t("useAttribute")), 1),
                        (0, $TusQn.createElementVNode)("th", $5875ea7b7e9f7cee$var$_hoisted_34, (0, $8POXm.toDisplayString)(_ctx.$t("weightAttribute")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.evaluationParameters, (evaluationParameter, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $5875ea7b7e9f7cee$var$_hoisted_35, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeEvaluationParameter(i)
                                }, null, 8, $5875ea7b7e9f7cee$var$_hoisted_36)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.createElementVNode)("select", {
                                    id: "parameter_" + i,
                                    class: "form-select",
                                    onChange: ($event)=>$options.onSelectChange($event, i)
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $5875ea7b7e9f7cee$var$_hoisted_38, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.parameterList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.parameterList, (parameter, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            name: "parameter",
                                            value: parameter.id
                                        }, (0, $8POXm.toDisplayString)(parameter.name), 9, $5875ea7b7e9f7cee$var$_hoisted_39);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                                    $data.kpiList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 1
                                    }, (0, $TusQn.renderList)($data.kpiList, (kpi, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            name: "kpi",
                                            value: kpi.id
                                        }, (0, $8POXm.toDisplayString)(kpi.name), 9, $5875ea7b7e9f7cee$var$_hoisted_40);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 40, $5875ea7b7e9f7cee$var$_hoisted_37)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>evaluationParameter.weight = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "weight_" + i
                                }, null, 8, $5875ea7b7e9f7cee$var$_hoisted_41), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        evaluationParameter.weight
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>evaluationParameter.useAttribute = $event,
                                    type: "checkbox",
                                    class: "form-check-input",
                                    id: "useAttribute_" + i
                                }, null, 8, $5875ea7b7e9f7cee$var$_hoisted_42), [
                                    [
                                        (0, $eeJ70.vModelCheckbox),
                                        evaluationParameter.useAttribute
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "weightAttribute_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>evaluationParameter.weightAttribute = $event,
                                    disabled: !evaluationParameter.useAttribute
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $5875ea7b7e9f7cee$var$_hoisted_44, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    _ctx.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)(_ctx.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $5875ea7b7e9f7cee$var$_hoisted_45);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $5875ea7b7e9f7cee$var$_hoisted_43), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        evaluationParameter.weightAttribute
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[7] || (_cache[7] = (...args)=>$options.addEvaluationParameter && $options.addEvaluationParameter(...args))
            }, $5875ea7b7e9f7cee$var$_hoisted_47)
        ]),
        (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_48, [
            (0, $TusQn.createElementVNode)("h4", $5875ea7b7e9f7cee$var$_hoisted_49, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationFilters")), 1),
            (0, $TusQn.createElementVNode)("table", $5875ea7b7e9f7cee$var$_hoisted_50, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $5875ea7b7e9f7cee$var$_hoisted_51,
                        (0, $TusQn.createElementVNode)("th", $5875ea7b7e9f7cee$var$_hoisted_52, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $5875ea7b7e9f7cee$var$_hoisted_53, (0, $8POXm.toDisplayString)(_ctx.$t("sign")), 1),
                        (0, $TusQn.createElementVNode)("th", $5875ea7b7e9f7cee$var$_hoisted_54, (0, $8POXm.toDisplayString)(_ctx.$t("number")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.evaluationFilters, (evaluationFilter, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $5875ea7b7e9f7cee$var$_hoisted_55, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeEvaluationFilter(i)
                                }, null, 8, $5875ea7b7e9f7cee$var$_hoisted_56)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "name_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.name = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $5875ea7b7e9f7cee$var$_hoisted_58, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    _ctx.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)(_ctx.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $5875ea7b7e9f7cee$var$_hoisted_59);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $5875ea7b7e9f7cee$var$_hoisted_57), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        evaluationFilter.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.sign = $event,
                                    class: "form-select",
                                    id: "sign_" + i
                                }, $5875ea7b7e9f7cee$var$_hoisted_66, 8, $5875ea7b7e9f7cee$var$_hoisted_60), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        evaluationFilter.sign
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.number = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "number_" + i
                                }, null, 8, $5875ea7b7e9f7cee$var$_hoisted_67), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        evaluationFilter.number
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[8] || (_cache[8] = (...args)=>$options.addEvaluationFilter && $options.addEvaluationFilter(...args))
            }, $5875ea7b7e9f7cee$var$_hoisted_69)
        ]),
        (0, $TusQn.createElementVNode)("div", $5875ea7b7e9f7cee$var$_hoisted_70, [
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[9] || (_cache[9] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[10] || (_cache[10] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ])
    ]));
}

});

parcelRegister("aBkbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7d05124f10fbde$export$2e2bcd8739ae039);
let $7b7d05124f10fbde$var$NOOP = ()=>{};
var $7b7d05124f10fbde$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("ikdAY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d574a3fbf969839b$export$2e2bcd8739ae039);

var $eHCxc = parcelRequire("eHCxc");

var $ljJJR = parcelRequire("ljJJR");

var $ch9iu = parcelRequire("ch9iu");

var $l6otV = parcelRequire("l6otV");

var $6kMfA = parcelRequire("6kMfA");

var $gOjKo = parcelRequire("gOjKo");

var $aYIG6 = parcelRequire("aYIG6");

var $gM1Yh = parcelRequire("gM1Yh");
var $d574a3fbf969839b$export$2e2bcd8739ae039 = {
    name: "evaluationdetail",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    components: {
        EvaluationDeleteModal: $6kMfA.default
    },
    methods: {
        async onSubmit () {
            if (this.data.name.length > 0) {
                await (0, $ljJJR.default).evaluationUpdate(this.$route.params.id, this.data);
                if (!this.checkEvaluationFilters()) this.showFiltersWarning();
                else this.showSuccess();
            } else this.showEmptyNameError();
        },
        async requestData () {
            this.pending = true;
            this.isUserAdmin = await (0, $gOjKo.CheckIfUserIsEditor)();
            this.data = await (0, $ljJJR.default).evaluationDetail(this.$route.params.id, this.$route.params.evaluationId);
            this.kpi = await (0, $aYIG6.default).kpiDetail(this.$route.params.id, this.data.keyPerformanceIndicatorId);
            var assetType = await (0, $eHCxc.default).assetTypeDetail(this.$route.params.id, this.kpi.assetTypeId);
            this.assetTypeName = assetType.name;
            var dataset = await (0, $ch9iu.default).datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];
            var modeling = await (0, $l6otV.default).modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            var parameterList = await (0, $gM1Yh.default).parameterList(this.$route.params.id);
            this.parameterList = parameterList.filter((a)=>a.assetTypeId == assetType.id);
            var kpiList = await (0, $aYIG6.default).kpiList(this.$route.params.id);
            this.kpiList = kpiList.filter((a)=>a.assetTypeId == assetType.id);
            for(var i in this.data.evaluationFilters){
                var attr = this.data.evaluationFilters[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr.name) < 0 && this.missingDatasetFilterHeaders.findIndex((d)=>d.name == attr.name) < 0) this.missingDatasetFilterHeaders.push({
                    name: attr.name,
                    alias: attr.name
                });
            }
            this.pending = false;
        },
        onSelectChange (event, index) {
            const select = event.target;
            const option = select.options[select.selectedIndex];
            const type = option.getAttribute("name");
            const value = select.value;
            const row = this.data.evaluationParameters[index];
            if (type == "parameter") {
                row.parameterId = Number(value);
                row.kpiId = null;
            } else if (type == "kpi") {
                row.parameterId = null;
                row.kpiId = Number(value);
            }
        },
        removeEvaluationFilter (rowIndex) {
            this.data.evaluationFilters.splice(rowIndex, 1);
        },
        addEvaluationFilter () {
            this.data.evaluationFilters.push({
                name: "",
                sign: "=",
                number: 0
            });
        },
        removeEvaluationParameter (rowIndex) {
            this.data.evaluationParameters.splice(rowIndex, 1);
        },
        addEvaluationParameter () {
            this.data.evaluationParameters.push({
                evaluationId: 0,
                parameterId: 0,
                kpiId: 0,
                weight: 0.0,
                useAttribute: false,
                weightAttribute: ""
            });
        },
        showDeleteEvaluation () {
            this.evaluationToDeleteId = this.data.id;
            this.showEvaluationDeleteModal = true;
        },
        checkEvaluationFilters () {
            for(var i in this.data.evaluationFilters){
                var attr = this.data.evaluationFilters[i];
                if (this.datasetHeaders.findIndex((d)=>d.name == attr.name) < 0 || attr.name == "") return false;
            }
            return true;
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "evaluationUpdated",
            type: "success"
        },
        showFiltersWarning: {
            title: "warning",
            message: "evaluationFiltersWarning",
            type: "warn"
        },
        showError: {
            title: "error",
            message: "evaluationErrorUpdate",
            type: "error"
        },
        showEmptyNameError: {
            title: "error",
            message: "emptyName",
            type: "error"
        }
    },
    data () {
        return {
            parameter: {},
            datasetHeaders: [],
            missingDatasetFilterHeaders: [],
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                evaluationGroup: [],
                evaluationPackage: [],
                evaluationLimit: []
            },
            showEvaluationDeleteModal: false,
            showAnalyseEvaluation: false,
            showValidateEvaluation: false,
            pending: true,
            modelingName: "",
            parameterList: [],
            kpiList: [],
            evaluationToDeleteId: 0,
            isUserAdmin: false
        };
    }
};

});
parcelRegister("6kMfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $49ca09e0fe597376$export$2e2bcd8739ae039);
let $49ca09e0fe597376$var$script;



let $49ca09e0fe597376$var$initialize = ()=>{
    $49ca09e0fe597376$var$script = (parcelRequire("a4nGK"));
    if ($49ca09e0fe597376$var$script.__esModule) $49ca09e0fe597376$var$script = $49ca09e0fe597376$var$script.default;
    $49ca09e0fe597376$var$script.render = (parcelRequire("9z02C")).render;
    (parcelRequire("ccoNU")).default($49ca09e0fe597376$var$script);
    $49ca09e0fe597376$var$script.__scopeId = "data-v-410116";
    $49ca09e0fe597376$var$script.__file = "EvaluationDeleteModal.vue";
};
$49ca09e0fe597376$var$initialize();
var $49ca09e0fe597376$export$2e2bcd8739ae039 = $49ca09e0fe597376$var$script;

});
parcelRegister("a4nGK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $754ca720d12d8376$export$2e2bcd8739ae039);

var $ljJJR = parcelRequire("ljJJR");
var $754ca720d12d8376$export$2e2bcd8739ae039 = {
    name: "evaluationDeleteModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteEvaluation () {
            await (0, $ljJJR.default).evaluationDelete(this.$parent.$route.params.id, this.$parent.evaluationToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("9z02C", function(module, exports) {

$parcel$export(module.exports, "render", () => $6f676a267c1c6679$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $6f676a267c1c6679$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $6f676a267c1c6679$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $6f676a267c1c6679$var$_hoisted_3 = {
    class: "modal-content"
};
const $6f676a267c1c6679$var$_hoisted_4 = {
    class: "modal-header"
};
const $6f676a267c1c6679$var$_hoisted_5 = {
    class: "modal-title"
};
const $6f676a267c1c6679$var$_hoisted_6 = {
    class: "modal-body"
};
const $6f676a267c1c6679$var$_hoisted_7 = {
    class: "modal-footer"
};
function $6f676a267c1c6679$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $6f676a267c1c6679$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $6f676a267c1c6679$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $6f676a267c1c6679$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $6f676a267c1c6679$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $6f676a267c1c6679$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $6f676a267c1c6679$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisEvaluation")), 1),
                            (0, $TusQn.createElementVNode)("div", $6f676a267c1c6679$var$_hoisted_7, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteEvaluation && $options.deleteEvaluation(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("ccoNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e19d897356c98c8$export$2e2bcd8739ae039);
let $8e19d897356c98c8$var$NOOP = ()=>{};
var $8e19d897356c98c8$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("hceHp", function(module, exports) {

$parcel$export(module.exports, "render", () => $c84ef59d1ad4d1ce$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $c84ef59d1ad4d1ce$var$_hoisted_1 = {
    key: 0
};
const $c84ef59d1ad4d1ce$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "d-flex justify-content-center loading-center"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "spinner-border",
        role: "status"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
            class: "sr-only"
        }, "Loading...")
    ])
], -1);
const $c84ef59d1ad4d1ce$var$_hoisted_3 = [
    $c84ef59d1ad4d1ce$var$_hoisted_2
];
const $c84ef59d1ad4d1ce$var$_hoisted_4 = {
    key: 1,
    class: "container py-5"
};
const $c84ef59d1ad4d1ce$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $c84ef59d1ad4d1ce$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $c84ef59d1ad4d1ce$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $c84ef59d1ad4d1ce$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $c84ef59d1ad4d1ce$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $c84ef59d1ad4d1ce$var$_hoisted_10 = {
    class: "breadcrumb-item"
};
const $c84ef59d1ad4d1ce$var$_hoisted_11 = {
    class: "row mb-4"
};
const $c84ef59d1ad4d1ce$var$_hoisted_12 = {
    class: "mb-3 col-md-4"
};
const $c84ef59d1ad4d1ce$var$_hoisted_13 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $c84ef59d1ad4d1ce$var$_hoisted_14 = {
    class: "mb-3 col-md-8"
};
const $c84ef59d1ad4d1ce$var$_hoisted_15 = {
    class: "form-label",
    for: "description",
    required: ""
};
const $c84ef59d1ad4d1ce$var$_hoisted_16 = {
    class: "row mb-4"
};
const $c84ef59d1ad4d1ce$var$_hoisted_17 = {
    class: "mb-3 col-md-4"
};
const $c84ef59d1ad4d1ce$var$_hoisted_18 = {
    class: "form-label",
    for: "additionalProportion",
    required: ""
};
const $c84ef59d1ad4d1ce$var$_hoisted_19 = {
    class: "mb-3 col-md-8"
};
const $c84ef59d1ad4d1ce$var$_hoisted_20 = {
    class: "form-label",
    for: "increasingValue",
    required: ""
};
const $c84ef59d1ad4d1ce$var$_hoisted_21 = {
    class: "row mb-4"
};
const $c84ef59d1ad4d1ce$var$_hoisted_22 = {
    class: "col-2"
};
const $c84ef59d1ad4d1ce$var$_hoisted_23 = {
    class: "form-check-label ps-2",
    for: "recalculateWeight"
};
const $c84ef59d1ad4d1ce$var$_hoisted_24 = {
    class: "col-2"
};
const $c84ef59d1ad4d1ce$var$_hoisted_25 = {
    class: "form-check-label ps-2",
    for: "weightAverage"
};
const $c84ef59d1ad4d1ce$var$_hoisted_26 = {
    class: "col-2"
};
const $c84ef59d1ad4d1ce$var$_hoisted_27 = {
    class: "form-check-label ps-2",
    for: "multiply"
};
const $c84ef59d1ad4d1ce$var$_hoisted_28 = {
    class: "mb-3"
};
const $c84ef59d1ad4d1ce$var$_hoisted_29 = {
    class: "table"
};
const $c84ef59d1ad4d1ce$var$_hoisted_30 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $c84ef59d1ad4d1ce$var$_hoisted_31 = {
    scope: "col"
};
const $c84ef59d1ad4d1ce$var$_hoisted_32 = {
    scope: "col"
};
const $c84ef59d1ad4d1ce$var$_hoisted_33 = {
    scope: "col"
};
const $c84ef59d1ad4d1ce$var$_hoisted_34 = {
    scope: "col"
};
const $c84ef59d1ad4d1ce$var$_hoisted_35 = {
    scope: "row"
};
const $c84ef59d1ad4d1ce$var$_hoisted_36 = [
    "onClick"
];
const $c84ef59d1ad4d1ce$var$_hoisted_37 = [
    "id",
    "onChange"
];
const $c84ef59d1ad4d1ce$var$_hoisted_38 = {
    selected: "",
    disabled: ""
};
const $c84ef59d1ad4d1ce$var$_hoisted_39 = [
    "selected",
    "value"
];
const $c84ef59d1ad4d1ce$var$_hoisted_40 = [
    "selected",
    "value"
];
const $c84ef59d1ad4d1ce$var$_hoisted_41 = [
    "onUpdate:modelValue",
    "id"
];
const $c84ef59d1ad4d1ce$var$_hoisted_42 = [
    "onUpdate:modelValue",
    "id"
];
const $c84ef59d1ad4d1ce$var$_hoisted_43 = [
    "id",
    "onUpdate:modelValue",
    "disabled"
];
const $c84ef59d1ad4d1ce$var$_hoisted_44 = {
    disabled: ""
};
const $c84ef59d1ad4d1ce$var$_hoisted_45 = [
    "value"
];
const $c84ef59d1ad4d1ce$var$_hoisted_46 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $c84ef59d1ad4d1ce$var$_hoisted_47 = [
    $c84ef59d1ad4d1ce$var$_hoisted_46
];
const $c84ef59d1ad4d1ce$var$_hoisted_48 = {
    class: "mb-3"
};
const $c84ef59d1ad4d1ce$var$_hoisted_49 = {
    class: "mb-3"
};
const $c84ef59d1ad4d1ce$var$_hoisted_50 = {
    class: "table"
};
const $c84ef59d1ad4d1ce$var$_hoisted_51 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    scope: "col"
}, null, -1);
const $c84ef59d1ad4d1ce$var$_hoisted_52 = {
    scope: "col"
};
const $c84ef59d1ad4d1ce$var$_hoisted_53 = {
    scope: "col"
};
const $c84ef59d1ad4d1ce$var$_hoisted_54 = {
    scope: "col"
};
const $c84ef59d1ad4d1ce$var$_hoisted_55 = {
    scope: "row"
};
const $c84ef59d1ad4d1ce$var$_hoisted_56 = [
    "onClick"
];
const $c84ef59d1ad4d1ce$var$_hoisted_57 = [
    "id",
    "onUpdate:modelValue"
];
const $c84ef59d1ad4d1ce$var$_hoisted_58 = {
    disabled: ""
};
const $c84ef59d1ad4d1ce$var$_hoisted_59 = [
    "value"
];
const $c84ef59d1ad4d1ce$var$_hoisted_60 = [
    "onUpdate:modelValue",
    "id"
];
const $c84ef59d1ad4d1ce$var$_hoisted_61 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<option value="=">=</option><option value="&gt;">&gt;</option><option value="&lt;">&lt;</option><option value="&gt;=">&gt;=</option><option value="&lt;=">&lt;=</option>', 5);
const $c84ef59d1ad4d1ce$var$_hoisted_66 = [
    $c84ef59d1ad4d1ce$var$_hoisted_61
];
const $c84ef59d1ad4d1ce$var$_hoisted_67 = [
    "onUpdate:modelValue",
    "id"
];
const $c84ef59d1ad4d1ce$var$_hoisted_68 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fa-solid fa-plus"
}, null, -1);
const $c84ef59d1ad4d1ce$var$_hoisted_69 = [
    $c84ef59d1ad4d1ce$var$_hoisted_68
];
const $c84ef59d1ad4d1ce$var$_hoisted_70 = {
    class: "d-grid gap-2 d-md-flex"
};
function $c84ef59d1ad4d1ce$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_EvaluationDeleteModal = (0, $TusQn.resolveComponent)("EvaluationDeleteModal");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $c84ef59d1ad4d1ce$var$_hoisted_1, $c84ef59d1ad4d1ce$var$_hoisted_3)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $c84ef59d1ad4d1ce$var$_hoisted_4, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $c84ef59d1ad4d1ce$var$_hoisted_5, [
            (0, $TusQn.createElementVNode)("ol", $c84ef59d1ad4d1ce$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("li", $c84ef59d1ad4d1ce$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modelings"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $c84ef59d1ad4d1ce$var$_hoisted_8, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modeling",
                            params: {
                                id: this.$route.params.id
                            }
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($data.modelingName || _ctx.$t("modelings")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $c84ef59d1ad4d1ce$var$_hoisted_9, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/modeling/" + this.$route.params.id + "/assettype/" + this.$route.params.assetTypeId
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.assetTypeName || _ctx.$t("assetType")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to"
                    ])
                ]),
                (0, $TusQn.createElementVNode)("li", $c84ef59d1ad4d1ce$var$_hoisted_10, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_11, [
            (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("label", $c84ef59d1ad4d1ce$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("label", $c84ef59d1ad4d1ce$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("description")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.description = $event),
                    type: "text",
                    class: "form-control",
                    id: "description"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.description
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("label", $c84ef59d1ad4d1ce$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("additionalProportion")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.additionalProportion = $event),
                    type: "number",
                    class: "form-control",
                    id: "additionalProportion"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.additionalProportion
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_19, [
                (0, $TusQn.createElementVNode)("label", $c84ef59d1ad4d1ce$var$_hoisted_20, (0, $8POXm.toDisplayString)(_ctx.$t("increasingValue")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.increasingValue = $event),
                    type: "number",
                    class: "form-control",
                    id: "increasingValue"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.increasingValue
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_21, [
            (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_22, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.recalculateWeight = $event),
                    type: "checkbox",
                    id: "recalculateWeight"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.recalculateWeight
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $c84ef59d1ad4d1ce$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("recalculateWeight")), 1)
            ]),
            (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_24, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.data.weightAverage = $event),
                    type: "checkbox",
                    id: "weightAverage"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.weightAverage
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $c84ef59d1ad4d1ce$var$_hoisted_25, (0, $8POXm.toDisplayString)(_ctx.$t("weightAverage")), 1)
            ]),
            (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_26, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.data.multiply = $event),
                    type: "checkbox",
                    id: "multiply"
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelCheckbox),
                        $data.data.multiply
                    ]
                ]),
                (0, $TusQn.createElementVNode)("label", $c84ef59d1ad4d1ce$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("multiply")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_28, [
            (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationParameters")), 1),
            (0, $TusQn.createElementVNode)("table", $c84ef59d1ad4d1ce$var$_hoisted_29, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $c84ef59d1ad4d1ce$var$_hoisted_30,
                        (0, $TusQn.createElementVNode)("th", $c84ef59d1ad4d1ce$var$_hoisted_31, (0, $8POXm.toDisplayString)(_ctx.$t("parameter")), 1),
                        (0, $TusQn.createElementVNode)("th", $c84ef59d1ad4d1ce$var$_hoisted_32, (0, $8POXm.toDisplayString)(_ctx.$t("weight")), 1),
                        (0, $TusQn.createElementVNode)("th", $c84ef59d1ad4d1ce$var$_hoisted_33, (0, $8POXm.toDisplayString)(_ctx.$t("useAttribute")), 1),
                        (0, $TusQn.createElementVNode)("th", $c84ef59d1ad4d1ce$var$_hoisted_34, (0, $8POXm.toDisplayString)(_ctx.$t("weightAttribute")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.evaluationParameters, (evaluationParameter, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $c84ef59d1ad4d1ce$var$_hoisted_35, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeEvaluationParameter(i)
                                }, null, 8, $c84ef59d1ad4d1ce$var$_hoisted_36)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.createElementVNode)("select", {
                                    id: "parameter_" + i,
                                    class: "form-select",
                                    onChange: ($event)=>$options.onSelectChange($event, i)
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $c84ef59d1ad4d1ce$var$_hoisted_38, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.parameterList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.parameterList, (parameter, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            selected: evaluationParameter.parameterId == parameter.id,
                                            key: i,
                                            name: "parameter",
                                            value: parameter.id
                                        }, (0, $8POXm.toDisplayString)(parameter.name), 9, $c84ef59d1ad4d1ce$var$_hoisted_39);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true),
                                    $data.kpiList.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 1
                                    }, (0, $TusQn.renderList)($data.kpiList, (kpi, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            selected: evaluationParameter.kpiId == kpi.id,
                                            name: "kpi",
                                            value: kpi.id
                                        }, (0, $8POXm.toDisplayString)(kpi.name), 9, $c84ef59d1ad4d1ce$var$_hoisted_40);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 40, $c84ef59d1ad4d1ce$var$_hoisted_37)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>evaluationParameter.weight = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "weight_" + i
                                }, null, 8, $c84ef59d1ad4d1ce$var$_hoisted_41), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        evaluationParameter.weight
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>evaluationParameter.useAttribute = $event,
                                    type: "checkbox",
                                    class: "form-check-input",
                                    id: "useAttribute_" + i
                                }, null, 8, $c84ef59d1ad4d1ce$var$_hoisted_42), [
                                    [
                                        (0, $eeJ70.vModelCheckbox),
                                        evaluationParameter.useAttribute
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "weightAttribute_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>evaluationParameter.weightAttribute = $event,
                                    disabled: !evaluationParameter.useAttribute
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $c84ef59d1ad4d1ce$var$_hoisted_44, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $c84ef59d1ad4d1ce$var$_hoisted_45);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $c84ef59d1ad4d1ce$var$_hoisted_43), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        evaluationParameter.weightAttribute
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[7] || (_cache[7] = (...args)=>$options.addEvaluationParameter && $options.addEvaluationParameter(...args))
            }, $c84ef59d1ad4d1ce$var$_hoisted_47)
        ]),
        (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_48, [
            (0, $TusQn.createElementVNode)("h4", $c84ef59d1ad4d1ce$var$_hoisted_49, (0, $8POXm.toDisplayString)(_ctx.$t("evaluationFilters")), 1),
            (0, $TusQn.createElementVNode)("table", $c84ef59d1ad4d1ce$var$_hoisted_50, [
                (0, $TusQn.createElementVNode)("thead", null, [
                    (0, $TusQn.createElementVNode)("tr", null, [
                        $c84ef59d1ad4d1ce$var$_hoisted_51,
                        (0, $TusQn.createElementVNode)("th", $c84ef59d1ad4d1ce$var$_hoisted_52, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                        (0, $TusQn.createElementVNode)("th", $c84ef59d1ad4d1ce$var$_hoisted_53, (0, $8POXm.toDisplayString)(_ctx.$t("sign")), 1),
                        (0, $TusQn.createElementVNode)("th", $c84ef59d1ad4d1ce$var$_hoisted_54, (0, $8POXm.toDisplayString)(_ctx.$t("number")), 1)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tbody", null, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.data.evaluationFilters, (evaluationFilter, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                            class: "align-middle",
                            key: i
                        }, [
                            (0, $TusQn.createElementVNode)("th", $c84ef59d1ad4d1ce$var$_hoisted_55, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: "fa fa-remove",
                                    onClick: ($event)=>$options.removeEvaluationFilter(i)
                                }, null, 8, $c84ef59d1ad4d1ce$var$_hoisted_56)
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    id: "name_" + i,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.name = $event
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $c84ef59d1ad4d1ce$var$_hoisted_58, (0, $8POXm.toDisplayString)(_ctx.$t("select")), 1),
                                    $data.datasetHeaders.length > 0 ? ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                        key: 0
                                    }, (0, $TusQn.renderList)($data.datasetHeaders, (datasetHeader, i)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: i,
                                            value: datasetHeader.name
                                        }, (0, $8POXm.toDisplayString)(datasetHeader.alias), 9, $c84ef59d1ad4d1ce$var$_hoisted_59);
                                    }), 128)) : (0, $TusQn.createCommentVNode)("", true)
                                ], 8, $c84ef59d1ad4d1ce$var$_hoisted_57), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        evaluationFilter.name
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.sign = $event,
                                    class: "form-select",
                                    id: "sign_" + i
                                }, $c84ef59d1ad4d1ce$var$_hoisted_66, 8, $c84ef59d1ad4d1ce$var$_hoisted_60), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        evaluationFilter.sign
                                    ]
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("td", null, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>evaluationFilter.number = $event,
                                    type: "number",
                                    class: "form-control",
                                    id: "number_" + i
                                }, null, 8, $c84ef59d1ad4d1ce$var$_hoisted_67), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        evaluationFilter.number
                                    ]
                                ])
                            ])
                        ]);
                    }), 128))
                ])
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-secondary w-25 mx-auto d-block",
                onClick: _cache[8] || (_cache[8] = (...args)=>$options.addEvaluationFilter && $options.addEvaluationFilter(...args))
            }, $c84ef59d1ad4d1ce$var$_hoisted_69)
        ]),
        (0, $TusQn.createElementVNode)("div", $c84ef59d1ad4d1ce$var$_hoisted_70, [
            $data.isUserAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                key: 0
            }, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[9] || (_cache[9] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1),
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[10] || (_cache[10] = (...args)=>$options.showDeleteEvaluation && $options.showDeleteEvaluation(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
            ], 64)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[11] || (_cache[11] = ($event)=>_ctx.$router.push({
                        path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                    }))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("back")), 1)
        ]),
        $data.showEvaluationDeleteModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_EvaluationDeleteModal, {
            key: 0,
            onReload: _cache[12] || (_cache[12] = ($event)=>_ctx.$router.push({
                    path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}`
                })),
            onCloseDeleteDialog: _cache[13] || (_cache[13] = ($event)=>$data.showEvaluationDeleteModal = false)
        })) : (0, $TusQn.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("7mHJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $55cc83e4351f448f$export$2e2bcd8739ae039);
let $55cc83e4351f448f$var$NOOP = ()=>{};
var $55cc83e4351f448f$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("h8ls9", function(module, exports) {

$parcel$export(module.exports, "fadeOut", () => fadeOut);
$parcel$export(module.exports, "LIB_NAME", () => LIB_NAME);
$parcel$export(module.exports, "ERROR", () => ERROR);
$parcel$export(module.exports, "WARN", () => WARN);
$parcel$export(module.exports, "SUCCESS", () => SUCCESS);
$parcel$export(module.exports, "INFO", () => INFO);
$parcel$export(module.exports, "CONTAINER_CLASS", () => CONTAINER_CLASS);
$parcel$export(module.exports, "NOTIFICATION_CLASS", () => NOTIFICATION_CLASS);
$parcel$export(module.exports, "TITLE_CLASS", () => TITLE_CLASS);
$parcel$export(module.exports, "ICON_CLASS", () => ICON_CLASS);
$parcel$export(module.exports, "MESSAGE_CLASS", () => MESSAGE_CLASS);
$parcel$export(module.exports, "ERROR_CLASS", () => ERROR_CLASS);
$parcel$export(module.exports, "WARN_CLASS", () => WARN_CLASS);
$parcel$export(module.exports, "SUCCESS_CLASS", () => SUCCESS_CLASS);
$parcel$export(module.exports, "INFO_CLASS", () => INFO_CLASS);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => DEFAULT_TIMEOUT);
$parcel$export(module.exports, "flatten", () => flatten);
$parcel$export(module.exports, "makeCss", () => makeCss);
$parcel$export(module.exports, "appendStyles", () => appendStyles);
$parcel$export(module.exports, "makeNode", () => makeNode);
$parcel$export(module.exports, "config", () => config);
$parcel$export(module.exports, "createIcon", () => createIcon);
$parcel$export(module.exports, "addElem", () => addElem);
$parcel$export(module.exports, "getTypeClass", () => getTypeClass);
$parcel$export(module.exports, "default", () => $c793d3262494b830$export$2e2bcd8739ae039);
function fadeOut(element, cb) {
    if (element.style.opacity && element.style.opacity > 0.05) element.style.opacity = element.style.opacity - 0.05;
    else if (element.style.opacity && element.style.opacity <= 0.1) {
        if (element.parentNode) {
            element.parentNode.removeChild(element);
            if (cb) cb();
        }
    } else element.style.opacity = 0.9;
    setTimeout(()=>fadeOut.apply(this, [
            element,
            cb
        ]), 1000 / 30);
}
const LIB_NAME = "mini-toastr";
const ERROR = "error";
const WARN = "warn";
const SUCCESS = "success";
const INFO = "info";
const CONTAINER_CLASS = LIB_NAME;
const NOTIFICATION_CLASS = `${LIB_NAME}__notification`;
const TITLE_CLASS = `${LIB_NAME}-notification__title`;
const ICON_CLASS = `${LIB_NAME}-notification__icon`;
const MESSAGE_CLASS = `${LIB_NAME}-notification__message`;
const ERROR_CLASS = `-${ERROR}`;
const WARN_CLASS = `-${WARN}`;
const SUCCESS_CLASS = `-${SUCCESS}`;
const INFO_CLASS = `-${INFO}`;
const DEFAULT_TIMEOUT = 3000;
const EMPTY_STRING = "";
function flatten(obj, into, prefix) {
    into = into || {};
    prefix = prefix || EMPTY_STRING;
    for(const k in obj)if (obj.hasOwnProperty(k)) {
        const prop = obj[k];
        if (prop && typeof prop === "object" && !(prop instanceof Date || prop instanceof RegExp)) flatten(prop, into, prefix + k + " ");
        else if (into[prefix] && typeof into[prefix] === "object") into[prefix][k] = prop;
        else {
            into[prefix] = {};
            into[prefix][k] = prop;
        }
    }
    return into;
}
function makeCss(obj) {
    const flat = flatten(obj);
    let str = JSON.stringify(flat, null, 2);
    str = str.replace(/"([^"]*)": {/g, "$1 {").replace(/"([^"]*)"/g, "$1").replace(/(\w*-?\w*): ([\w\d .#]*),?/g, "$1: $2;").replace(/},/g, "}\n").replace(/ &([.:])/g, "$1");
    str = str.substr(1, str.lastIndexOf("}") - 1);
    return str;
}
function appendStyles(css) {
    let head = document.head || document.getElementsByTagName("head")[0];
    let styleElem = makeNode("style");
    styleElem.id = `${LIB_NAME}-styles`;
    styleElem.type = "text/css";
    if (styleElem.styleSheet) styleElem.styleSheet.cssText = css;
    else styleElem.appendChild(document.createTextNode(css));
    head.appendChild(styleElem);
}
const config = {
    types: {
        ERROR: ERROR,
        WARN: WARN,
        SUCCESS: SUCCESS,
        INFO: INFO
    },
    animation: fadeOut,
    timeout: DEFAULT_TIMEOUT,
    icons: {},
    appendTarget: document.body,
    node: makeNode(),
    allowHtml: false,
    style: {
        [`.${CONTAINER_CLASS}`]: {
            position: "fixed",
            "z-index": 99999,
            right: "12px",
            top: "12px"
        },
        [`.${NOTIFICATION_CLASS}`]: {
            cursor: "pointer",
            padding: "12px 18px",
            margin: "0 0 6px 0",
            "background-color": "#000",
            opacity: 0.8,
            color: "#fff",
            "border-radius": "3px",
            "box-shadow": "#3c3b3b 0 0 12px",
            width: "300px",
            [`&.${ERROR_CLASS}`]: {
                "background-color": "#D5122B"
            },
            [`&.${WARN_CLASS}`]: {
                "background-color": "#F5AA1E"
            },
            [`&.${SUCCESS_CLASS}`]: {
                "background-color": "#7AC13E"
            },
            [`&.${INFO_CLASS}`]: {
                "background-color": "#4196E1"
            },
            "&:hover": {
                opacity: 1,
                "box-shadow": "#000 0 0 12px"
            }
        },
        [`.${TITLE_CLASS}`]: {
            "font-weight": "500"
        },
        [`.${MESSAGE_CLASS}`]: {
            display: "inline-block",
            "vertical-align": "middle",
            width: "240px",
            padding: "0 12px"
        }
    }
};
function makeNode(type = "div") {
    return document.createElement(type);
}
function createIcon(node, type, config) {
    const iconNode = makeNode(config.icons[type].nodeType);
    const attrs = config.icons[type].attrs;
    for(const k in attrs)if (attrs.hasOwnProperty(k)) iconNode.setAttribute(k, attrs[k]);
    node.appendChild(iconNode);
}
function addElem(node, text, className, config) {
    const elem = makeNode();
    elem.className = className;
    if (config.allowHtml) elem.innerHTML = text;
    else elem.appendChild(document.createTextNode(text));
    node.appendChild(elem);
}
function getTypeClass(type) {
    if (type === SUCCESS) return SUCCESS_CLASS;
    if (type === WARN) return WARN_CLASS;
    if (type === ERROR) return ERROR_CLASS;
    if (type === INFO) return INFO_CLASS;
    return EMPTY_STRING;
}
const miniToastr = {
    config: config,
    isInitialised: false,
    showMessage (message, title, type, timeout, cb, overrideConf) {
        const config = {};
        Object.assign(config, this.config);
        Object.assign(config, overrideConf);
        const notificationElem = makeNode();
        notificationElem.className = `${NOTIFICATION_CLASS} ${getTypeClass(type)}`;
        notificationElem.onclick = function() {
            config.animation(notificationElem, null);
        };
        if (title) addElem(notificationElem, title, TITLE_CLASS, config);
        if (config.icons[type]) createIcon(notificationElem, type, config);
        if (message) addElem(notificationElem, message, MESSAGE_CLASS, config);
        config.node.insertBefore(notificationElem, config.node.firstChild);
        setTimeout(()=>config.animation(notificationElem, cb), timeout || config.timeout);
        if (cb) cb();
        return this;
    },
    init (aConfig) {
        const newConfig = {};
        Object.assign(newConfig, config);
        Object.assign(newConfig, aConfig);
        this.config = newConfig;
        const cssStr = makeCss(newConfig.style);
        appendStyles(cssStr);
        newConfig.node.id = CONTAINER_CLASS;
        newConfig.node.className = CONTAINER_CLASS;
        newConfig.appendTarget.appendChild(newConfig.node);
        Object.keys(newConfig.types).forEach((v)=>{
            this[newConfig.types[v]] = (function(message, title, timeout, cb, config) {
                this.showMessage(message, title, newConfig.types[v], timeout, cb, config);
                return this;
            }).bind(this);
        });
        this.isInitialised = true;
        return this;
    },
    setIcon (type, nodeType = "i", attrs = []) {
        attrs.class = attrs.class ? attrs.class + " " + ICON_CLASS : ICON_CLASS;
        this.config.icons[type] = {
            nodeType: nodeType,
            attrs: attrs
        };
    }
};
var $c793d3262494b830$export$2e2bcd8739ae039 = miniToastr;

});


let $65b882e90cc2c305$var$script;


let $65b882e90cc2c305$var$initialize = ()=>{
    $65b882e90cc2c305$var$script = {};
    $65b882e90cc2c305$var$script.render = (parcelRequire("fLfPA")).render;
    (parcelRequire("fP2DP")).default($65b882e90cc2c305$var$script);
    $65b882e90cc2c305$var$script.__scopeId = "data-v-8f393f";
    $65b882e90cc2c305$var$script.__file = "App.vue";
};
$65b882e90cc2c305$var$initialize();
var $65b882e90cc2c305$export$2e2bcd8739ae039 = $65b882e90cc2c305$var$script;


/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $cc4ed71c4f27adbc$exports = {};

$parcel$export($cc4ed71c4f27adbc$exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);
$parcel$export($cc4ed71c4f27adbc$exports, "detectOverflow", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperBase", () => $60bdf67e43f5dfcb$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperLite", () => $ef991c361ca719ad$export$8f7491d57c8f97a9);
var $1472b89a65155de2$exports = {};

$parcel$export($1472b89a65155de2$exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export($1472b89a65155de2$exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export($1472b89a65155de2$exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export($1472b89a65155de2$exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export($1472b89a65155de2$exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export($1472b89a65155de2$exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export($1472b89a65155de2$exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export($1472b89a65155de2$exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export($1472b89a65155de2$exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export($1472b89a65155de2$exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export($1472b89a65155de2$exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export($1472b89a65155de2$exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export($1472b89a65155de2$exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export($1472b89a65155de2$exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export($1472b89a65155de2$exports, "beforeRead", () => $1472b89a65155de2$export$421679a7c3d56e);
$parcel$export($1472b89a65155de2$exports, "read", () => $1472b89a65155de2$export$aafa59e2e03f2942);
$parcel$export($1472b89a65155de2$exports, "afterRead", () => $1472b89a65155de2$export$6964f6c886723980);
$parcel$export($1472b89a65155de2$exports, "beforeMain", () => $1472b89a65155de2$export$c65e99957a05207c);
$parcel$export($1472b89a65155de2$exports, "main", () => $1472b89a65155de2$export$f22da7240b7add18);
$parcel$export($1472b89a65155de2$exports, "afterMain", () => $1472b89a65155de2$export$bab79516f2d662fe);
$parcel$export($1472b89a65155de2$exports, "beforeWrite", () => $1472b89a65155de2$export$8d4d2d70e7d46032);
$parcel$export($1472b89a65155de2$exports, "write", () => $1472b89a65155de2$export$68d8715fc104d294);
$parcel$export($1472b89a65155de2$exports, "afterWrite", () => $1472b89a65155de2$export$70a6e5159acce2e6);
$parcel$export($1472b89a65155de2$exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $a3382052de3d061b$exports = {};

$parcel$export($a3382052de3d061b$exports, "applyStyles", () => $7deefb3680d4558f$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "arrow", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "computeStyles", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "eventListeners", () => $e7d7845625089588$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "flip", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "hide", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "offset", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "popperOffsets", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "preventOverflow", () => $865d356b2ca960a5$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $ef991c361ca719ad$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039)
];
var $ef991c361ca719ad$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $ef991c361ca719ad$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $1472b89a65155de2$exports);
$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $a3382052de3d061b$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$elementMap = new Map();
const $e9dd36436aec3b21$var$Data = {
    set (element, key, instance) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) $e9dd36436aec3b21$var$elementMap.set(element, new Map());
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($e9dd36436aec3b21$var$elementMap.has(element)) return $e9dd36436aec3b21$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) return;
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $e9dd36436aec3b21$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$MAX_UID = 1000000;
const $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER = 1000;
const $e9dd36436aec3b21$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $e9dd36436aec3b21$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $e9dd36436aec3b21$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $e9dd36436aec3b21$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $e9dd36436aec3b21$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $e9dd36436aec3b21$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER;
};
const $e9dd36436aec3b21$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($e9dd36436aec3b21$var$TRANSITION_END));
};
const $e9dd36436aec3b21$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $e9dd36436aec3b21$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($e9dd36436aec3b21$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($e9dd36436aec3b21$var$parseSelector(object));
    return null;
};
const $e9dd36436aec3b21$var$isVisible = (element)=>{
    if (!$e9dd36436aec3b21$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $e9dd36436aec3b21$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $e9dd36436aec3b21$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $e9dd36436aec3b21$var$findShadowRoot(element.parentNode);
};
const $e9dd36436aec3b21$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $e9dd36436aec3b21$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $e9dd36436aec3b21$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $e9dd36436aec3b21$var$DOMContentLoadedCallbacks = [];
const $e9dd36436aec3b21$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$e9dd36436aec3b21$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $e9dd36436aec3b21$var$DOMContentLoadedCallbacks)callback();
        });
        $e9dd36436aec3b21$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $e9dd36436aec3b21$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $e9dd36436aec3b21$var$defineJQueryPlugin = (plugin)=>{
    $e9dd36436aec3b21$var$onDOMContentLoaded(()=>{
        const $ = $e9dd36436aec3b21$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $e9dd36436aec3b21$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $e9dd36436aec3b21$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $e9dd36436aec3b21$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $e9dd36436aec3b21$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
        $e9dd36436aec3b21$var$execute(callback);
    };
    transitionElement.addEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $e9dd36436aec3b21$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $e9dd36436aec3b21$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $e9dd36436aec3b21$var$stripNameRegex = /\..*/;
const $e9dd36436aec3b21$var$stripUidRegex = /::\d+$/;
const $e9dd36436aec3b21$var$eventRegistry = {}; // Events storage
let $e9dd36436aec3b21$var$uidEvent = 1;
const $e9dd36436aec3b21$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $e9dd36436aec3b21$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $e9dd36436aec3b21$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$e9dd36436aec3b21$var$uidEvent++}` || element.uidEvent || $e9dd36436aec3b21$var$uidEvent++;
}
function $e9dd36436aec3b21$var$getElementEvents(element) {
    const uid = $e9dd36436aec3b21$var$makeEventUid(element);
    element.uidEvent = uid;
    $e9dd36436aec3b21$var$eventRegistry[uid] = $e9dd36436aec3b21$var$eventRegistry[uid] || {};
    return $e9dd36436aec3b21$var$eventRegistry[uid];
}
function $e9dd36436aec3b21$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $e9dd36436aec3b21$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $e9dd36436aec3b21$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $e9dd36436aec3b21$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $e9dd36436aec3b21$var$getTypeEvent(originalTypeEvent);
    if (!$e9dd36436aec3b21$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $e9dd36436aec3b21$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $e9dd36436aec3b21$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $e9dd36436aec3b21$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $e9dd36436aec3b21$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $e9dd36436aec3b21$var$makeEventUid(callable, originalTypeEvent.replace($e9dd36436aec3b21$var$namespaceRegex, ""));
    const fn = isDelegated ? $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, handler, callable) : $e9dd36436aec3b21$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $e9dd36436aec3b21$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $e9dd36436aec3b21$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($e9dd36436aec3b21$var$stripNameRegex, "");
    return $e9dd36436aec3b21$var$customEvents[event] || event;
}
const $e9dd36436aec3b21$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $e9dd36436aec3b21$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($e9dd36436aec3b21$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $e9dd36436aec3b21$var$getjQuery();
        const typeEvent = $e9dd36436aec3b21$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $e9dd36436aec3b21$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $e9dd36436aec3b21$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $e9dd36436aec3b21$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $e9dd36436aec3b21$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $e9dd36436aec3b21$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $e9dd36436aec3b21$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $e9dd36436aec3b21$var$normalizeData(element.getAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $e9dd36436aec3b21$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $e9dd36436aec3b21$var$isElement(value) ? "element" : $e9dd36436aec3b21$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$VERSION = "5.3.3";
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$BaseComponent extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        element = $e9dd36436aec3b21$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $e9dd36436aec3b21$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $e9dd36436aec3b21$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $e9dd36436aec3b21$var$Data.get($e9dd36436aec3b21$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $e9dd36436aec3b21$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(",").map((sel)=>$e9dd36436aec3b21$var$parseSelector(sel)).join(",") : null;
};
const $e9dd36436aec3b21$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$e9dd36436aec3b21$var$isDisabled(el) && $e9dd36436aec3b21$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        if (selector) return $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $e9dd36436aec3b21$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($e9dd36436aec3b21$var$isDisabled(this)) return;
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$f = "alert";
const $e9dd36436aec3b21$var$DATA_KEY$a = "bs.alert";
const $e9dd36436aec3b21$var$EVENT_KEY$b = `.${$e9dd36436aec3b21$var$DATA_KEY$a}`;
const $e9dd36436aec3b21$var$EVENT_CLOSE = `close${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$EVENT_CLOSED = `closed${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$5 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$caec2af78bcc877f extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$e = "button";
const $e9dd36436aec3b21$var$DATA_KEY$9 = "bs.button";
const $e9dd36436aec3b21$var$EVENT_KEY$a = `.${$e9dd36436aec3b21$var$DATA_KEY$9}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$6 = ".data-api";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3 = "active";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6 = `click${$e9dd36436aec3b21$var$EVENT_KEY$a}${$e9dd36436aec3b21$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$353f5b6fc5456de1 extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5);
    const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$d = "swipe";
const $e9dd36436aec3b21$var$EVENT_KEY$9 = ".bs.swipe";
const $e9dd36436aec3b21$var$EVENT_TOUCHSTART = `touchstart${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHMOVE = `touchmove${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHEND = `touchend${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERDOWN = `pointerdown${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERUP = `pointerup${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH = "touch";
const $e9dd36436aec3b21$var$POINTER_TYPE_PEN = "pen";
const $e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $e9dd36436aec3b21$var$SWIPE_THRESHOLD = 40;
const $e9dd36436aec3b21$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $e9dd36436aec3b21$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Swipe extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$e9dd36436aec3b21$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$c;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$c;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$d;
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $e9dd36436aec3b21$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $e9dd36436aec3b21$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $e9dd36436aec3b21$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_PEN || event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$c = "carousel";
const $e9dd36436aec3b21$var$DATA_KEY$8 = "bs.carousel";
const $e9dd36436aec3b21$var$EVENT_KEY$8 = `.${$e9dd36436aec3b21$var$DATA_KEY$8}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$5 = ".data-api";
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $e9dd36436aec3b21$var$ORDER_NEXT = "next";
const $e9dd36436aec3b21$var$ORDER_PREV = "prev";
const $e9dd36436aec3b21$var$DIRECTION_LEFT = "left";
const $e9dd36436aec3b21$var$DIRECTION_RIGHT = "right";
const $e9dd36436aec3b21$var$EVENT_SLIDE = `slide${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_SLID = `slid${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN$1 = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1 = `mouseenter${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1 = `mouseleave${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_DRAG_START = `dragstart${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3 = `load${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5 = `click${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL = "carousel";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2 = "active";
const $e9dd36436aec3b21$var$CLASS_NAME_SLIDE = "slide";
const $e9dd36436aec3b21$var$CLASS_NAME_END = "carousel-item-end";
const $e9dd36436aec3b21$var$CLASS_NAME_START = "carousel-item-start";
const $e9dd36436aec3b21$var$CLASS_NAME_NEXT = "carousel-item-next";
const $e9dd36436aec3b21$var$CLASS_NAME_PREV = "carousel-item-prev";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE = ".active";
const $e9dd36436aec3b21$var$SELECTOR_ITEM = ".carousel-item";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM = $e9dd36436aec3b21$var$SELECTOR_ACTIVE + $e9dd36436aec3b21$var$SELECTOR_ITEM;
const $e9dd36436aec3b21$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $e9dd36436aec3b21$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $e9dd36436aec3b21$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $e9dd36436aec3b21$var$KEY_TO_DIRECTION = {
    [$e9dd36436aec3b21$var$ARROW_LEFT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_RIGHT,
    [$e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_LEFT
};
const $e9dd36436aec3b21$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $e9dd36436aec3b21$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$144901db2ea8e967 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$b;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$b;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$c;
    }
    // Public
    next() {
        this._slide($e9dd36436aec3b21$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $e9dd36436aec3b21$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($e9dd36436aec3b21$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $e9dd36436aec3b21$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $e9dd36436aec3b21$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM_IMG, this._element))$e9dd36436aec3b21$var$EventHandler.on(img, $e9dd36436aec3b21$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $e9dd36436aec3b21$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $e9dd36436aec3b21$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $e9dd36436aec3b21$var$ORDER_NEXT;
        const nextElement = element || $e9dd36436aec3b21$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $e9dd36436aec3b21$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($e9dd36436aec3b21$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_START : $e9dd36436aec3b21$var$CLASS_NAME_END;
        const orderClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_NEXT : $e9dd36436aec3b21$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $e9dd36436aec3b21$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($e9dd36436aec3b21$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($e9dd36436aec3b21$var$isRTL()) return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_PREV : $e9dd36436aec3b21$var$ORDER_NEXT;
        return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($e9dd36436aec3b21$var$isRTL()) return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_LEFT : $e9dd36436aec3b21$var$DIRECTION_RIGHT;
        return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_RIGHT : $e9dd36436aec3b21$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5, $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($e9dd36436aec3b21$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$b = "collapse";
const $e9dd36436aec3b21$var$DATA_KEY$7 = "bs.collapse";
const $e9dd36436aec3b21$var$EVENT_KEY$7 = `.${$e9dd36436aec3b21$var$DATA_KEY$7}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$4 = ".data-api";
const $e9dd36436aec3b21$var$EVENT_SHOW$6 = `show${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$6 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$6 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$6 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4 = `click${$e9dd36436aec3b21$var$EVENT_KEY$7}${$e9dd36436aec3b21$var$DATA_API_KEY$4}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE = "collapse";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING = "collapsing";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED = "collapsed";
const $e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE} .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE}`;
const $e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $e9dd36436aec3b21$var$WIDTH = "width";
const $e9dd36436aec3b21$var$HEIGHT = "height";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $e9dd36436aec3b21$var$Default$a = {
    parent: null,
    toggle: true
};
const $e9dd36436aec3b21$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$78768a9af065a7b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $e9dd36436aec3b21$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $e9dd36436aec3b21$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$a;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$a;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $e9dd36436aec3b21$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL) ? $e9dd36436aec3b21$var$WIDTH : $e9dd36436aec3b21$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.getMultipleElementsFromSelector(this))$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$a = "dropdown";
const $e9dd36436aec3b21$var$DATA_KEY$6 = "bs.dropdown";
const $e9dd36436aec3b21$var$EVENT_KEY$6 = `.${$e9dd36436aec3b21$var$DATA_KEY$6}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$3 = ".data-api";
const $e9dd36436aec3b21$var$ESCAPE_KEY$2 = "Escape";
const $e9dd36436aec3b21$var$TAB_KEY$1 = "Tab";
const $e9dd36436aec3b21$var$ARROW_UP_KEY$1 = "ArrowUp";
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $e9dd36436aec3b21$var$EVENT_HIDE$5 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$5 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$5 = `show${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$5 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3 = `click${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API = `keyup${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$6 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP = "dropup";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPEND = "dropend";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPSTART = "dropstart";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3}.${$e9dd36436aec3b21$var$CLASS_NAME_SHOW$6}`;
const $e9dd36436aec3b21$var$SELECTOR_MENU = ".dropdown-menu";
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR = ".navbar";
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $e9dd36436aec3b21$var$PLACEMENT_TOP = $e9dd36436aec3b21$var$isRTL() ? "top-end" : "top-start";
const $e9dd36436aec3b21$var$PLACEMENT_TOPEND = $e9dd36436aec3b21$var$isRTL() ? "top-start" : "top-end";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOM = $e9dd36436aec3b21$var$isRTL() ? "bottom-end" : "bottom-start";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND = $e9dd36436aec3b21$var$isRTL() ? "bottom-start" : "bottom-end";
const $e9dd36436aec3b21$var$PLACEMENT_RIGHT = $e9dd36436aec3b21$var$isRTL() ? "left-start" : "right-start";
const $e9dd36436aec3b21$var$PLACEMENT_LEFT = $e9dd36436aec3b21$var$isRTL() ? "right-start" : "left-start";
const $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER = "top";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $e9dd36436aec3b21$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $e9dd36436aec3b21$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$931cbfb6bfb85fc extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $e9dd36436aec3b21$var$SelectorEngine.next(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.prev(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$9;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$9;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, "mouseover", $e9dd36436aec3b21$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, "mouseover", $e9dd36436aec3b21$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$e9dd36436aec3b21$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$e9dd36436aec3b21$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $cc4ed71c4f27adbc$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($e9dd36436aec3b21$var$isElement(this._config.reference)) referenceElement = $e9dd36436aec3b21$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $cc4ed71c4f27adbc$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPEND)) return $e9dd36436aec3b21$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPSTART)) return $e9dd36436aec3b21$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP)) return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_TOPEND : $e9dd36436aec3b21$var$PLACEMENT_TOP;
        return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND : $e9dd36436aec3b21$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $e9dd36436aec3b21$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$e9dd36436aec3b21$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $e9dd36436aec3b21$var$getNextActiveElement(items, target, key === $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $e9dd36436aec3b21$var$TAB_KEY$1) return;
        const openToggles = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $e9dd36436aec3b21$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $e9dd36436aec3b21$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $e9dd36436aec3b21$var$ARROW_UP_KEY$1,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3) ? this : $e9dd36436aec3b21$var$SelectorEngine.prev(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.next(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_MENU, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$9 = "backdrop";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$4 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$5 = "show";
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN = `mousedown.bs.${$e9dd36436aec3b21$var$NAME$9}`;
const $e9dd36436aec3b21$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $e9dd36436aec3b21$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Backdrop extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$8;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$8;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $e9dd36436aec3b21$var$reflow(element);
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $e9dd36436aec3b21$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $e9dd36436aec3b21$var$EventHandler.on(element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN, ()=>{
            $e9dd36436aec3b21$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$8 = "focustrap";
const $e9dd36436aec3b21$var$DATA_KEY$5 = "bs.focustrap";
const $e9dd36436aec3b21$var$EVENT_KEY$5 = `.${$e9dd36436aec3b21$var$DATA_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$2 = `focusin${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB = `keydown.tab${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$TAB_KEY = "Tab";
const $e9dd36436aec3b21$var$TAB_NAV_FORWARD = "forward";
const $e9dd36436aec3b21$var$TAB_NAV_BACKWARD = "backward";
const $e9dd36436aec3b21$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $e9dd36436aec3b21$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$FocusTrap extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$7;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$7;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5); // guard against infinite focus loop
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $e9dd36436aec3b21$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $e9dd36436aec3b21$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $e9dd36436aec3b21$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $e9dd36436aec3b21$var$TAB_NAV_BACKWARD : $e9dd36436aec3b21$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $e9dd36436aec3b21$var$PROPERTY_PADDING = "padding-right";
const $e9dd36436aec3b21$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $e9dd36436aec3b21$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($e9dd36436aec3b21$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$7 = "modal";
const $e9dd36436aec3b21$var$DATA_KEY$4 = "bs.modal";
const $e9dd36436aec3b21$var$EVENT_KEY$4 = `.${$e9dd36436aec3b21$var$DATA_KEY$4}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$2 = ".data-api";
const $e9dd36436aec3b21$var$ESCAPE_KEY$1 = "Escape";
const $e9dd36436aec3b21$var$EVENT_HIDE$4 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$4 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$4 = `show${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$4 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE$1 = `resize${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS = `click.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2 = `click${$e9dd36436aec3b21$var$EVENT_KEY$4}${$e9dd36436aec3b21$var$DATA_API_KEY$2}`;
const $e9dd36436aec3b21$var$CLASS_NAME_OPEN = "modal-open";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$3 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$4 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_STATIC = "modal-static";
const $e9dd36436aec3b21$var$OPEN_SELECTOR$1 = ".modal.show";
const $e9dd36436aec3b21$var$SELECTOR_DIALOG = ".modal-dialog";
const $e9dd36436aec3b21$var$SELECTOR_MODAL_BODY = ".modal-body";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $e9dd36436aec3b21$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $e9dd36436aec3b21$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$2b77a92f1a5ad772 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $e9dd36436aec3b21$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$6;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$6;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(window, $e9dd36436aec3b21$var$EVENT_KEY$4);
        $e9dd36436aec3b21$var$EventHandler.off(this._dialog, $e9dd36436aec3b21$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $e9dd36436aec3b21$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$4, ()=>{
            if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$6 = "offcanvas";
const $e9dd36436aec3b21$var$DATA_KEY$3 = "bs.offcanvas";
const $e9dd36436aec3b21$var$EVENT_KEY$3 = `.${$e9dd36436aec3b21$var$DATA_KEY$3}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$1 = ".data-api";
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2 = `load${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$ESCAPE_KEY = "Escape";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$3 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1 = "showing";
const $e9dd36436aec3b21$var$CLASS_NAME_HIDING = "hiding";
const $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $e9dd36436aec3b21$var$OPEN_SELECTOR = ".offcanvas.show";
const $e9dd36436aec3b21$var$EVENT_SHOW$3 = `show${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$3 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$3 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$3 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE = `resize${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1 = `click${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $e9dd36436aec3b21$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $e9dd36436aec3b21$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$591ca0244c9dfcd4 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$5;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$5;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3, $e9dd36436aec3b21$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $e9dd36436aec3b21$var$Backdrop({
            className: $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $e9dd36436aec3b21$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$OPEN_SELECTOR))$e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $e9dd36436aec3b21$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $e9dd36436aec3b21$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $e9dd36436aec3b21$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $e9dd36436aec3b21$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($e9dd36436aec3b21$var$uriAttributes.has(attributeName)) return Boolean($e9dd36436aec3b21$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $e9dd36436aec3b21$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$e9dd36436aec3b21$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$5 = "TemplateFactory";
const $e9dd36436aec3b21$var$Default$4 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $e9dd36436aec3b21$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $e9dd36436aec3b21$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$TemplateFactory extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$4;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$4;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $e9dd36436aec3b21$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($e9dd36436aec3b21$var$isElement(content)) {
            this._putElementInTemplate($e9dd36436aec3b21$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $e9dd36436aec3b21$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$4 = "tooltip";
const $e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$2 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_MODAL = "modal";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2 = "show";
const $e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $e9dd36436aec3b21$var$SELECTOR_MODAL = `.${$e9dd36436aec3b21$var$CLASS_NAME_MODAL}`;
const $e9dd36436aec3b21$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $e9dd36436aec3b21$var$TRIGGER_HOVER = "hover";
const $e9dd36436aec3b21$var$TRIGGER_FOCUS = "focus";
const $e9dd36436aec3b21$var$TRIGGER_CLICK = "click";
const $e9dd36436aec3b21$var$TRIGGER_MANUAL = "manual";
const $e9dd36436aec3b21$var$EVENT_HIDE$2 = "hide";
const $e9dd36436aec3b21$var$EVENT_HIDDEN$2 = "hidden";
const $e9dd36436aec3b21$var$EVENT_SHOW$2 = "show";
const $e9dd36436aec3b21$var$EVENT_SHOWN$2 = "shown";
const $e9dd36436aec3b21$var$EVENT_INSERTED = "inserted";
const $e9dd36436aec3b21$var$EVENT_CLICK$1 = "click";
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$1 = "focusin";
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT$1 = "focusout";
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER = "mouseenter";
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE = "mouseleave";
const $e9dd36436aec3b21$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $e9dd36436aec3b21$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $e9dd36436aec3b21$var$isRTL() ? "right" : "left"
};
const $e9dd36436aec3b21$var$Default$3 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $e9dd36436aec3b21$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$28c660c63b792dea extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        if (typeof $cc4ed71c4f27adbc$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$3;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$3;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $e9dd36436aec3b21$var$EventHandler.off(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOW$2));
        const shadowRoot = $e9dd36436aec3b21$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, "mouseover", $e9dd36436aec3b21$var$noop);
        const complete = ()=>{
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, "mouseover", $e9dd36436aec3b21$var$noop);
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_FADE$2, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $e9dd36436aec3b21$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $e9dd36436aec3b21$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $e9dd36436aec3b21$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $e9dd36436aec3b21$var$AttachmentMap[placement.toUpperCase()];
        return $cc4ed71c4f27adbc$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $e9dd36436aec3b21$var$EventHandler.on(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $e9dd36436aec3b21$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSEENTER) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSELEAVE) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSOUT$1);
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $e9dd36436aec3b21$var$EventHandler.on(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $e9dd36436aec3b21$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $e9dd36436aec3b21$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$3 = "popover";
const $e9dd36436aec3b21$var$SELECTOR_TITLE = ".popover-header";
const $e9dd36436aec3b21$var$SELECTOR_CONTENT = ".popover-body";
const $e9dd36436aec3b21$var$Default$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $e9dd36436aec3b21$var$DefaultType$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$5b6b19405a83ff9d extends $e9dd36436aec3b21$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$2;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$2;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TITLE]: this._getTitle(),
            [$e9dd36436aec3b21$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$2 = "scrollspy";
const $e9dd36436aec3b21$var$DATA_KEY$2 = "bs.scrollspy";
const $e9dd36436aec3b21$var$EVENT_KEY$2 = `.${$e9dd36436aec3b21$var$DATA_KEY$2}`;
const $e9dd36436aec3b21$var$DATA_API_KEY = ".data-api";
const $e9dd36436aec3b21$var$EVENT_ACTIVATE = `activate${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_CLICK = `click${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1 = `load${$e9dd36436aec3b21$var$EVENT_KEY$2}${$e9dd36436aec3b21$var$DATA_API_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1 = "active";
const $e9dd36436aec3b21$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS = "[href]";
const $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $e9dd36436aec3b21$var$SELECTOR_NAV_LINKS = ".nav-link";
const $e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS = `${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS} > ${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS}`;
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN = ".dropdown";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $e9dd36436aec3b21$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $e9dd36436aec3b21$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$a6472a5298a374be extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$1;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$1;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $e9dd36436aec3b21$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $e9dd36436aec3b21$var$EventHandler.off(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK);
        $e9dd36436aec3b21$var$EventHandler.on(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK, $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $e9dd36436aec3b21$var$isDisabled(anchor)) continue;
            const observableSection = $e9dd36436aec3b21$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($e9dd36436aec3b21$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($e9dd36436aec3b21$var$SELECTOR_DROPDOWN)).classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $e9dd36436aec3b21$var$SelectorEngine.parents(target, $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $e9dd36436aec3b21$var$SelectorEngine.prev(listGroup, $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS))item.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $e9dd36436aec3b21$var$SelectorEngine.find(`${$e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS}.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_SPY))$e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$1 = "tab";
const $e9dd36436aec3b21$var$DATA_KEY$1 = "bs.tab";
const $e9dd36436aec3b21$var$EVENT_KEY$1 = `.${$e9dd36436aec3b21$var$DATA_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$1 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$1 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$1 = `show${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$1 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API = `click${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API = `load${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY = "ArrowLeft";
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY = "ArrowRight";
const $e9dd36436aec3b21$var$ARROW_UP_KEY = "ArrowUp";
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY = "ArrowDown";
const $e9dd36436aec3b21$var$HOME_KEY = "Home";
const $e9dd36436aec3b21$var$END_KEY = "End";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE = "active";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$1 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1 = "show";
const $e9dd36436aec3b21$var$CLASS_DROPDOWN = "dropdown";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $e9dd36436aec3b21$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $e9dd36436aec3b21$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $e9dd36436aec3b21$var$SELECTOR_INNER = `.nav-link${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $e9dd36436aec3b21$var$SELECTOR_INNER_ELEM = `${$e9dd36436aec3b21$var$SELECTOR_INNER}, ${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$3e41faf802a29e71 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($e9dd36436aec3b21$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $e9dd36436aec3b21$var$EventHandler.trigger(active, $e9dd36436aec3b21$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(innerElem, $e9dd36436aec3b21$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        this._activate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $e9dd36436aec3b21$var$ARROW_LEFT_KEY,
            $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
            $e9dd36436aec3b21$var$ARROW_UP_KEY,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY,
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$e9dd36436aec3b21$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $e9dd36436aec3b21$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
                $e9dd36436aec3b21$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $e9dd36436aec3b21$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($e9dd36436aec3b21$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE, $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM) ? elem : $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($e9dd36436aec3b21$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE))$e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME = "toast";
const $e9dd36436aec3b21$var$DATA_KEY = "bs.toast";
const $e9dd36436aec3b21$var$EVENT_KEY = `.${$e9dd36436aec3b21$var$DATA_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOVER = `mouseover${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOUT = `mouseout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN = `focusin${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT = `focusout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDE = `hide${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN = `hidden${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOW = `show${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN = `shown${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING = "showing";
const $e9dd36436aec3b21$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $e9dd36436aec3b21$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$8d8dc7d5f743331b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME;
    }
    // Public
    show() {
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW, $e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING, $e9dd36436aec3b21$var$CLASS_NAME_SHOW);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN);
        };
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$8d8dc7d5f743331b);





/*!
  * vue-router v4.3.2
  * (c) 2024 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
function $e0da45b668fffb6e$export$5a2d366b2d9f38f6() {
    return $e0da45b668fffb6e$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $e0da45b668fffb6e$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const $e0da45b668fffb6e$export$bc32a04c49ed7464 = typeof Proxy === "function";


const $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $55cc2ea2e53f2ca6$export$a0897f44accbe922 = "plugin:settings:set";



let $2138e2947b5f69c4$var$supported;
let $2138e2947b5f69c4$var$perf;
function $2138e2947b5f69c4$export$70d26280bc1ca547() {
    var _a;
    if ($2138e2947b5f69c4$var$supported !== undefined) return $2138e2947b5f69c4$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = window.performance;
    } else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = globalThis.perf_hooks.performance;
    } else $2138e2947b5f69c4$var$supported = false;
    return $2138e2947b5f69c4$var$supported;
}
function $2138e2947b5f69c4$export$461939dd4422153() {
    return $2138e2947b5f69c4$export$70d26280bc1ca547() ? $2138e2947b5f69c4$var$perf.now() : Date.now();
}


class $5dd8e5d828be8ae1$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $2138e2947b5f69c4$export$461939dd4422153)();
            }
        };
        if (hook) hook.on((0, $55cc2ea2e53f2ca6$export$a0897f44accbe922), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}





function $de8f43bece76d38a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $e0da45b668fffb6e$export$c22522a4dfa48e9c)();
    const hook = (0, $e0da45b668fffb6e$export$5a2d366b2d9f38f6)();
    const enableProxy = (0, $e0da45b668fffb6e$export$bc32a04c49ed7464) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $5dd8e5d828be8ae1$export$5728f3776e9b2ac1)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}


const $a809ac530d32f081$var$isBrowser = typeof document !== "undefined";
function $a809ac530d32f081$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module";
}
const $a809ac530d32f081$var$assign = Object.assign;
function $a809ac530d32f081$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $a809ac530d32f081$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $a809ac530d32f081$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $a809ac530d32f081$var$isArray = Array.isArray;
function $a809ac530d32f081$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
/**
 * Encoding Rules (␣ = Space)
 * - Path: ␣ " < > # ? { }
 * - Query: ␣ " < > # & =
 * - Hash: ␣ " < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $a809ac530d32f081$var$HASH_RE = /#/g; // %23
const $a809ac530d32f081$var$AMPERSAND_RE = /&/g; // %26
const $a809ac530d32f081$var$SLASH_RE = /\//g; // %2F
const $a809ac530d32f081$var$EQUAL_RE = /=/g; // %3D
const $a809ac530d32f081$var$IM_RE = /\?/g; // %3F
const $a809ac530d32f081$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $a809ac530d32f081$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $a809ac530d32f081$var$ENC_CARET_RE = /%5E/g; // ^
const $a809ac530d32f081$var$ENC_BACKTICK_RE = /%60/g; // `
const $a809ac530d32f081$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $a809ac530d32f081$var$ENC_PIPE_RE = /%7C/g; // |
const $a809ac530d32f081$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $a809ac530d32f081$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$commonEncode(text) {
    return encodeURI("" + text).replace($a809ac530d32f081$var$ENC_PIPE_RE, "|").replace($a809ac530d32f081$var$ENC_BRACKET_OPEN_RE, "[").replace($a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeHash(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, "{").replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, "}").replace($a809ac530d32f081$var$ENC_CARET_RE, "^");
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeQueryValue(text) {
    return $a809ac530d32f081$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($a809ac530d32f081$var$PLUS_RE, "%2B").replace($a809ac530d32f081$var$ENC_SPACE_RE, "+").replace($a809ac530d32f081$var$HASH_RE, "%23").replace($a809ac530d32f081$var$AMPERSAND_RE, "%26").replace($a809ac530d32f081$var$ENC_BACKTICK_RE, "`").replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, "{").replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, "}").replace($a809ac530d32f081$var$ENC_CARET_RE, "^");
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $a809ac530d32f081$var$encodeQueryKey(text) {
    return $a809ac530d32f081$var$encodeQueryValue(text).replace($a809ac530d32f081$var$EQUAL_RE, "%3D");
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodePath(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$HASH_RE, "%23").replace($a809ac530d32f081$var$IM_RE, "%3F");
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeParam(text) {
    return text == null ? "" : $a809ac530d32f081$var$encodePath(text).replace($a809ac530d32f081$var$SLASH_RE, "%2F");
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $a809ac530d32f081$var$decode(text) {
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
const $a809ac530d32f081$var$TRAILING_SLASH_RE = /\/$/;
const $a809ac530d32f081$var$removeTrailingSlash = (path)=>path.replace($a809ac530d32f081$var$TRAILING_SLASH_RE, "");
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $a809ac530d32f081$var$parseURL(parseQuery, location1, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf("#");
    let searchPos = location1.indexOf("?");
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $a809ac530d32f081$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && "?") + searchString + hash,
        path: path,
        query: query,
        hash: $a809ac530d32f081$var$decode(hash)
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $a809ac530d32f081$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : "";
    return location1.path + (query && "?") + query + (location1.hash || "");
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $a809ac530d32f081$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $a809ac530d32f081$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $a809ac530d32f081$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $a809ac530d32f081$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $a809ac530d32f081$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$a809ac530d32f081$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $a809ac530d32f081$var$isSameRouteLocationParamsValue(a, b) {
    return $a809ac530d32f081$var$isArray(a) ? $a809ac530d32f081$var$isEquivalentArray(a, b) : $a809ac530d32f081$var$isArray(b) ? $a809ac530d32f081$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $a809ac530d32f081$var$isEquivalentArray(a, b) {
    return $a809ac530d32f081$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $a809ac530d32f081$var$resolveRelativePath(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    // make . and ./ the same (../ === .., ../../ === ../..)
    // this is the same behavior as new URL()
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === ".") continue;
        // go up in the from array
        if (segment === "..") // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
var $a809ac530d32f081$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($a809ac530d32f081$var$NavigationType || ($a809ac530d32f081$var$NavigationType = {}));
var $a809ac530d32f081$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($a809ac530d32f081$var$NavigationDirection || ($a809ac530d32f081$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $a809ac530d32f081$var$START = "";
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $a809ac530d32f081$var$normalizeBase(base) {
    if (!base) {
        if ($a809ac530d32f081$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $a809ac530d32f081$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $a809ac530d32f081$var$BEFORE_HASH_RE = /^[^#]+#/;
function $a809ac530d32f081$var$createHref(base, location1) {
    return base.replace($a809ac530d32f081$var$BEFORE_HASH_RE, "#") + location1;
}
function $a809ac530d32f081$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $a809ac530d32f081$var$computeScrollPosition = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $a809ac530d32f081$var$scrollToPosition(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $a809ac530d32f081$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $a809ac530d32f081$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $a809ac530d32f081$var$scrollPositions = new Map();
function $a809ac530d32f081$var$saveScrollPosition(key, scrollPosition) {
    $a809ac530d32f081$var$scrollPositions.set(key, scrollPosition);
}
function $a809ac530d32f081$var$getSavedScrollPosition(key) {
    const scroll = $a809ac530d32f081$var$scrollPositions.get(key);
    // consume it so it's not used again
    $a809ac530d32f081$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $a809ac530d32f081$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param base - The base path
 * @param location - The window.location object
 */ function $a809ac530d32f081$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return $a809ac530d32f081$var$stripBase(pathFromHash, "");
    }
    const path = $a809ac530d32f081$var$stripBase(pathname, base);
    return path + search + hash;
}
function $a809ac530d32f081$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $a809ac530d32f081$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $a809ac530d32f081$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $a809ac530d32f081$var$NavigationDirection.forward : $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($a809ac530d32f081$var$assign({}, history1.state, {
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        }), "");
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("beforeunload", beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener("popstate", popStateHandler);
    // TODO: could we use 'pagehide' or 'visibilitychange' instead?
    // https://developer.chrome.com/blog/page-lifecycle-api/
    window.addEventListener("beforeunload", beforeUnloadListener, {
        passive: true
    });
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $a809ac530d32f081$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $a809ac530d32f081$var$computeScrollPosition() : null
    };
}
function $a809ac530d32f081$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $a809ac530d32f081$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $a809ac530d32f081$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            // Force the navigation, this also resets the call count
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        const state = $a809ac530d32f081$var$assign({}, history1.state, $a809ac530d32f081$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $a809ac530d32f081$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        });
        changeLocation(currentState.current, currentState, true);
        const state = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $a809ac530d32f081$export$7b4942f78e7b8a49(base) {
    base = $a809ac530d32f081$var$normalizeBase(base);
    const historyNavigation = $a809ac530d32f081$var$useHistoryStateNavigation(base);
    const historyListeners = $a809ac530d32f081$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $a809ac530d32f081$var$assign({
        // it's overridden right after
        location: "",
        base: base,
        go: go,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $a809ac530d32f081$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        $a809ac530d32f081$var$START
    ];
    let position = 0;
    base = $a809ac530d32f081$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position !== queue.length) // we are in the middle, we remove everything from here in the queue
        queue.splice(position);
        queue.push(location1);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $a809ac530d32f081$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $a809ac530d32f081$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base),
        replace (to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push (to, data) {
            setLocation(to);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                $a809ac530d32f081$var$START
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $a809ac530d32f081$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : "";
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes("#")) base += "#";
    return $a809ac530d32f081$export$7b4942f78e7b8a49(base);
}
function $a809ac530d32f081$var$isRouteLocation(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $a809ac530d32f081$var$isRouteName(name) {
    return typeof name === "string" || typeof name === "symbol";
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $a809ac530d32f081$export$e44be9a9779c480b = {
    path: "/",
    name: undefined,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
const $a809ac530d32f081$var$NavigationFailureSymbol = Symbol("");
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $a809ac530d32f081$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($a809ac530d32f081$export$35710516f95d6a57 || ($a809ac530d32f081$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $a809ac530d32f081$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$a809ac530d32f081$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
 * Creates a typed NavigationFailure object.
 * @internal
 * @param type - NavigationFailureType
 * @param params - { from, to }
 */ function $a809ac530d32f081$var$createRouterError(type, params) {
    return $a809ac530d32f081$var$assign(new Error(), {
        type: type,
        [$a809ac530d32f081$var$NavigationFailureSymbol]: true
    }, params);
}
function $a809ac530d32f081$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $a809ac530d32f081$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $a809ac530d32f081$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $a809ac530d32f081$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location1 = {};
    for (const key of $a809ac530d32f081$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $a809ac530d32f081$var$BASE_PARAM_PATTERN = "[^/]+?";
const $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $a809ac530d32f081$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $a809ac530d32f081$var$tokensToParser(segments, extraOptions) {
    const options = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? "^" : "";
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($a809ac530d32f081$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $a809ac530d32f081$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $a809ac530d32f081$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === ".*") subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : "";
                    if ($a809ac530d32f081$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $a809ac530d32f081$var$isArray(param) ? param.join("/") : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith("/")) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $a809ac530d32f081$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $a809ac530d32f081$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $a809ac530d32f081$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($a809ac530d32f081$var$isLastScoreNegative(aScore)) return 1;
        if ($a809ac530d32f081$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $a809ac530d32f081$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $a809ac530d32f081$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ""
};
const $a809ac530d32f081$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $a809ac530d32f081$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $a809ac530d32f081$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = "";
    // custom regexp for a param
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === "(") state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($a809ac530d32f081$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ")") {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $a809ac530d32f081$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $a809ac530d32f081$var$tokensToParser($a809ac530d32f081$var$tokenizePath(record.path), options);
    const matcher = $a809ac530d32f081$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $a809ac530d32f081$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $a809ac530d32f081$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $a809ac530d32f081$var$normalizeRouteRecord(record);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $a809ac530d32f081$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($a809ac530d32f081$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            }));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            // create the object beforehand, so it can be passed to children
            matcher = $a809ac530d32f081$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
            // TODO: add normalized records for more flexibility
            // if (parent && isAliasRecord(originalRecord)) {
            //   parent.children.push(originalRecord)
            // }
            // Avoid adding a record that doesn't display anything. This allows passing through records without a component to
            // not be reached and pass through the catch all route
            if (matcher.record.components && Object.keys(matcher.record.components).length || matcher.record.name || matcher.record.redirect) insertMatcher(matcher);
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $a809ac530d32f081$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($a809ac530d32f081$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        let i = 0;
        while(i < matchers.length && $a809ac530d32f081$var$comparePathParserScore(matcher, matchers[i]) >= 0 && // Adding children with empty path should still appear before the parent
        // https://github.com/vuejs/router/issues/1124
        (matcher.record.path !== matchers[i].record.path || !$a809ac530d32f081$var$isRecordChildOf(matcher, matchers[i])))i++;
        matchers.splice(i, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            name = matcher.record.name;
            params = $a809ac530d32f081$var$assign(// paramsFromLocation is a new object
            $a809ac530d32f081$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $a809ac530d32f081$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if (location1.path != null) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $a809ac530d32f081$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $a809ac530d32f081$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $a809ac530d32f081$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $a809ac530d32f081$var$normalizeRouteRecord(record) {
    return {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: undefined,
        beforeEnter: record.beforeEnter,
        props: $a809ac530d32f081$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $a809ac530d32f081$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $a809ac530d32f081$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $a809ac530d32f081$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$a809ac530d32f081$var$assign(meta, record.meta), {});
}
function $a809ac530d32f081$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $a809ac530d32f081$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $a809ac530d32f081$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $a809ac530d32f081$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
function $a809ac530d32f081$var$isRecordChildOf(record, parent) {
    return parent.children.some((child)=>child === record || $a809ac530d32f081$var$isRecordChildOf(record, child));
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $a809ac530d32f081$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === "" || search === "?") return query;
    const hasLeadingIM = search[0] === "?";
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($a809ac530d32f081$var$PLUS_RE, " ");
        // allow the = character
        const eqPos = searchParam.indexOf("=");
        const key = $a809ac530d32f081$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $a809ac530d32f081$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$a809ac530d32f081$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $a809ac530d32f081$export$d33b45a8f796a30(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $a809ac530d32f081$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? "&" : "") + key;
            continue;
        }
        // keep null values
        const values = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v && $a809ac530d32f081$var$encodeQueryValue(v)) : [
            value && $a809ac530d32f081$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? "&" : "") + key;
                if (value != null) search += "=" + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $a809ac530d32f081$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $a809ac530d32f081$export$7f4879db1558672d = Symbol("");
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $a809ac530d32f081$export$9b3825c34ca1427a = Symbol("");
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $a809ac530d32f081$export$b6c0da8b9dae491f = Symbol("");
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $a809ac530d32f081$export$3aca783e9a3e6e9e = Symbol("");
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $a809ac530d32f081$export$54c8124bead129f8 = Symbol("");
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $a809ac530d32f081$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
function $a809ac530d32f081$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $TusQn.onUnmounted)(removeFromList);
    (0, $TusQn.onDeactivated)(removeFromList);
    (0, $TusQn.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$d7fcdd004b009a9e(leaveGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$46b4cb99461f4cc7(updateGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($a809ac530d32f081$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($a809ac530d32f081$var$isRouteLocation(valid)) reject($a809ac530d32f081$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $a809ac530d32f081$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $a809ac530d32f081$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $a809ac530d32f081$var$extractComponentsGuards(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        // skip update and leave guards if the route component is not mounted
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($a809ac530d32f081$var$isRouteComponent(rawComponent)) {
            // __vccOpts is added by vue-class-component and contain the regular options
            const options = rawComponent.__vccOpts || rawComponent;
            const guard = options[guardType];
            guard && guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext));
        } else {
            // start requesting the chunk already
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}"`));
                    const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                    // replace the function with the resolved component
                    // cannot be null or undefined because we went into the for loop
                    record.components[name] = resolvedComponent;
                    // __vccOpts is added by vue-class-component and contain the regular options
                    const options = resolvedComponent.__vccOpts || resolvedComponent;
                    const guard = options[guardType];
                    return guard && $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $a809ac530d32f081$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $a809ac530d32f081$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
function $a809ac530d32f081$export$dcf14c9974fe2767(props) {
    const router = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
    const currentRoute = (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $01W3b.computed)(()=>{
        const to = (0, $01W3b.unref)(props.to);
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $01W3b.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $a809ac530d32f081$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $a809ac530d32f081$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && $a809ac530d32f081$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $a809ac530d32f081$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($a809ac530d32f081$var$guardEvent(e)) return router[(0, $01W3b.unref)(props.replace) ? "replace" : "push"]((0, $01W3b.unref)(props.to)).catch($a809ac530d32f081$var$noop);
        return Promise.resolve();
    }
    // devtools only
    if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $TusQn.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = $a809ac530d32f081$var$isRouteLocation((0, $01W3b.unref)(props.to)) ? null : 'Invalid "to" value';
            }, {
                flush: "post"
            });
        }
    }
    /**
     * NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
     */ return {
        route: route,
        href: (0, $01W3b.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
const $a809ac530d32f081$var$RouterLinkImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        }
    },
    useLink: $a809ac530d32f081$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $01W3b.reactive)($a809ac530d32f081$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
        const elClass = (0, $01W3b.computed)(()=>({
                [$a809ac530d32f081$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$a809ac530d32f081$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && slots.default(link);
            return props.custom ? children : (0, $TusQn.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $a809ac530d32f081$export$fce709ebdac448ed = $a809ac530d32f081$var$RouterLinkImpl;
function $a809ac530d32f081$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $a809ac530d32f081$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$a809ac530d32f081$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $a809ac530d32f081$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $a809ac530d32f081$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $a809ac530d32f081$var$RouterViewImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: "RouterView",
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $TusQn.inject)($a809ac530d32f081$export$54c8124bead129f8);
        const routeToDisplay = (0, $01W3b.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $TusQn.inject)($a809ac530d32f081$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $01W3b.computed)(()=>{
            let initialDepth = (0, $01W3b.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $01W3b.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $TusQn.provide)($a809ac530d32f081$export$9b3825c34ca1427a, (0, $01W3b.computed)(()=>depth.value + 1));
        (0, $TusQn.provide)($a809ac530d32f081$export$7f4879db1558672d, matchedRouteRef);
        (0, $TusQn.provide)($a809ac530d32f081$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $01W3b.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $TusQn.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$a809ac530d32f081$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $TusQn.h)(ViewComponent, $a809ac530d32f081$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $a809ac530d32f081$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $a809ac530d32f081$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $a809ac530d32f081$export$d941f00e9b9a537 = $a809ac530d32f081$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $a809ac530d32f081$var$warnDeprecatedUsage() {
    const instance = (0, $TusQn.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        $a809ac530d32f081$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $a809ac530d32f081$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $a809ac530d32f081$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$a809ac530d32f081$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $a809ac530d32f081$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $a809ac530d32f081$var$routerId = 0;
function $a809ac530d32f081$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $a809ac530d32f081$var$routerId++;
    (0, $de8f43bece76d38a$export$63b9a9bba9f20f3e)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") console.warn("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $a809ac530d32f081$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $a809ac530d32f081$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($a809ac530d32f081$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $a809ac530d32f081$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $a809ac530d32f081$var$RED_100;
                        textColor = $a809ac530d32f081$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $a809ac530d32f081$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $a809ac530d32f081$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $TusQn.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay("beforeEach"),
                from: $a809ac530d32f081$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $a809ac530d32f081$var$formatRouteLocation(to, "Target location")
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $a809ac530d32f081$var$formatDisplay("\u274C");
            } else data.status = $a809ac530d32f081$var$formatDisplay("\u2705");
            // we set here to have the right order
            data.from = $a809ac530d32f081$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $a809ac530d32f081$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent || // these routes have a parent with no component which will not appear in the view
                // therefore we still need to include them
                !route.parent.record.components);
            // reset match state to false
            routes.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $a809ac530d32f081$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$a809ac530d32f081$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($a809ac530d32f081$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $a809ac530d32f081$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$a809ac530d32f081$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $a809ac530d32f081$var$PINK_500 = 0xec4899;
const $a809ac530d32f081$var$BLUE_600 = 0x2563eb;
const $a809ac530d32f081$var$LIME_500 = 0x84cc16;
const $a809ac530d32f081$var$CYAN_400 = 0x22d3ee;
const $a809ac530d32f081$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $a809ac530d32f081$var$DARK = 0x666666;
const $a809ac530d32f081$var$RED_100 = 0xfee2e2;
const $a809ac530d32f081$var$RED_700 = 0xb91c1c;
function $a809ac530d32f081$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 0xffffff,
        backgroundColor: $a809ac530d32f081$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($a809ac530d32f081$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($a809ac530d32f081$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $a809ac530d32f081$var$routeRecordId = 0;
const $a809ac530d32f081$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $a809ac530d32f081$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $a809ac530d32f081$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$a809ac530d32f081$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$a809ac530d32f081$var$markRouteRecordActive(childRoute, currentRoute));
}
function $a809ac530d32f081$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
}
function $a809ac530d32f081$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($a809ac530d32f081$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ""), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $a809ac530d32f081$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
}
function $a809ac530d32f081$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $a809ac530d32f081$export$baddd0131ee8c05b(options) {
    const matcher = $a809ac530d32f081$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $a809ac530d32f081$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $a809ac530d32f081$export$d33b45a8f796a30;
    const routerHistory = options.history;
    const beforeGuards = $a809ac530d32f081$var$useCallbacks();
    const beforeResolveGuards = $a809ac530d32f081$var$useCallbacks();
    const afterGuards = $a809ac530d32f081$var$useCallbacks();
    const currentRoute = (0, $01W3b.shallowRef)($a809ac530d32f081$export$e44be9a9779c480b);
    let pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($a809ac530d32f081$var$isBrowser && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = $a809ac530d32f081$var$applyToParams.bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($a809ac530d32f081$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $a809ac530d32f081$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            // locationNormalized is always a new object
            return $a809ac530d32f081$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $a809ac530d32f081$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        let matcherLocation;
        // path could be relative in object as well
        if (rawLocation.path != null) matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
            path: $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            // remove any nullish param
            const targetParams = $a809ac530d32f081$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $a809ac530d32f081$var$stringifyURL(stringifyQuery$1, $a809ac530d32f081$var$assign({}, rawLocation, {
            hash: $a809ac530d32f081$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return $a809ac530d32f081$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $a809ac530d32f081$export$d33b45a8f796a30 ? $a809ac530d32f081$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? $a809ac530d32f081$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $a809ac530d32f081$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $a809ac530d32f081$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($a809ac530d32f081$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            return $a809ac530d32f081$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($a809ac530d32f081$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? $a809ac530d32f081$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $a809ac530d32f081$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$a809ac530d32f081$export$873de56207a30e5a(error) ? $a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($a809ac530d32f081$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) return pushWithRedirect(// keep options
                $a809ac530d32f081$var$assign({
                    replace: // preserve an existing replacement but allow the redirect to override it
                    replace
                }, locationAsObject(failure.to), {
                    state: typeof failure.to === "object" ? $a809ac530d32f081$var$assign({}, data, failure.to.state) : data,
                    force: force
                }), // preserve the original redirectedFrom if any
                redirectedFrom || toLocation);
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        // support Vue < 3.3
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $a809ac530d32f081$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $a809ac530d32f081$var$extractComponentsGuards(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $a809ac530d32f081$var$extractComponentsGuards(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of enteringRecords)// do not trigger beforeEnter on reused views
            if (record.beforeEnter) {
                if ($a809ac530d32f081$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($a809ac530d32f081$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($a809ac530d32f081$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $a809ac530d32f081$var$extractComponentsGuards(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$a809ac530d32f081$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $a809ac530d32f081$export$e44be9a9779c480b;
        const state = !$a809ac530d32f081$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $a809ac530d32f081$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($a809ac530d32f081$var$assign(shouldRedirect, {
                    replace: true
                }), toLocation).catch($a809ac530d32f081$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$saveScrollPosition($a809ac530d32f081$var$getScrollKey(from.fullPath, info.delta), $a809ac530d32f081$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $a809ac530d32f081$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($a809ac530d32f081$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$a809ac530d32f081$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $a809ac530d32f081$var$NavigationType.pop && $a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            })// avoid warnings in the console about uncaught rejections, they are logged by triggerErrors
            .catch($a809ac530d32f081$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $a809ac530d32f081$var$useCallbacks();
    let errorListeners = $a809ac530d32f081$var$useCallbacks();
    let ready;
    /**
     * Trigger errorListeners added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        // reject the error no matter there were error listeners or not
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $a809ac530d32f081$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$a809ac530d32f081$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $a809ac530d32f081$var$getSavedScrollPosition($a809ac530d32f081$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $TusQn.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $a809ac530d32f081$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component("RouterLink", $a809ac530d32f081$export$fce709ebdac448ed);
            app.component("RouterView", $a809ac530d32f081$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $01W3b.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($a809ac530d32f081$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $a809ac530d32f081$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in $a809ac530d32f081$export$e44be9a9779c480b)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide($a809ac530d32f081$export$b6c0da8b9dae491f, router);
            app.provide($a809ac530d32f081$export$3aca783e9a3e6e9e, (0, $01W3b.shallowReactive)(reactiveRoute));
            app.provide($a809ac530d32f081$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $a809ac530d32f081$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$addDevtools(app, router, matcher);
        }
    };
    // TODO: type this as NavigationGuardReturn or similar instead of any
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
function $a809ac530d32f081$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $a809ac530d32f081$export$9a302a45f65d0572() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $a809ac530d32f081$export$3f79f0b98112cf57() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
}


let $c76da6a997a95812$var$script;



let $c76da6a997a95812$var$initialize = ()=>{
    $c76da6a997a95812$var$script = (parcelRequire("4q2En"));
    if ($c76da6a997a95812$var$script.__esModule) $c76da6a997a95812$var$script = $c76da6a997a95812$var$script.default;
    $c76da6a997a95812$var$script.render = (parcelRequire("gMOUR")).render;
    (parcelRequire("fhwaF")).default($c76da6a997a95812$var$script);
    $c76da6a997a95812$var$script.__scopeId = "data-v-230d27";
    $c76da6a997a95812$var$script.__file = "Login.vue";
};
$c76da6a997a95812$var$initialize();
var $c76da6a997a95812$export$2e2bcd8739ae039 = $c76da6a997a95812$var$script;


let $ea9442045aa70520$var$script;



let $ea9442045aa70520$var$initialize = ()=>{
    $ea9442045aa70520$var$script = (parcelRequire("utY1T"));
    if ($ea9442045aa70520$var$script.__esModule) $ea9442045aa70520$var$script = $ea9442045aa70520$var$script.default;
    $ea9442045aa70520$var$script.render = (parcelRequire("3FNfL")).render;
    (parcelRequire("79szO")).default($ea9442045aa70520$var$script);
    $ea9442045aa70520$var$script.__scopeId = "data-v-a1d182";
    $ea9442045aa70520$var$script.__file = "Modelings.vue";
};
$ea9442045aa70520$var$initialize();
var $ea9442045aa70520$export$2e2bcd8739ae039 = $ea9442045aa70520$var$script;


let $3f98e29a5305f88e$var$script;



let $3f98e29a5305f88e$var$initialize = ()=>{
    $3f98e29a5305f88e$var$script = (parcelRequire("bOqrG"));
    if ($3f98e29a5305f88e$var$script.__esModule) $3f98e29a5305f88e$var$script = $3f98e29a5305f88e$var$script.default;
    $3f98e29a5305f88e$var$script.render = (parcelRequire("TuEYg")).render;
    (parcelRequire("4SCIc")).default($3f98e29a5305f88e$var$script);
    $3f98e29a5305f88e$var$script.__scopeId = "data-v-6b190d";
    $3f98e29a5305f88e$var$script.__file = "Settings.vue";
};
$3f98e29a5305f88e$var$initialize();
var $3f98e29a5305f88e$export$2e2bcd8739ae039 = $3f98e29a5305f88e$var$script;


let $c3acc8244e2e7a3e$var$script;



let $c3acc8244e2e7a3e$var$initialize = ()=>{
    $c3acc8244e2e7a3e$var$script = (parcelRequire("hPYqr"));
    if ($c3acc8244e2e7a3e$var$script.__esModule) $c3acc8244e2e7a3e$var$script = $c3acc8244e2e7a3e$var$script.default;
    $c3acc8244e2e7a3e$var$script.render = (parcelRequire("2f3ob")).render;
    (parcelRequire("6gWsL")).default($c3acc8244e2e7a3e$var$script);
    $c3acc8244e2e7a3e$var$script.__scopeId = "data-v-50d5a1";
    $c3acc8244e2e7a3e$var$script.__file = "ModelingDetail.vue";
};
$c3acc8244e2e7a3e$var$initialize();
var $c3acc8244e2e7a3e$export$2e2bcd8739ae039 = $c3acc8244e2e7a3e$var$script;


let $046c9a7be0becd94$var$script;



let $046c9a7be0becd94$var$initialize = ()=>{
    $046c9a7be0becd94$var$script = (parcelRequire("1xUz0"));
    if ($046c9a7be0becd94$var$script.__esModule) $046c9a7be0becd94$var$script = $046c9a7be0becd94$var$script.default;
    $046c9a7be0becd94$var$script.render = (parcelRequire("iWfCP")).render;
    (parcelRequire("hTo1j")).default($046c9a7be0becd94$var$script);
    $046c9a7be0becd94$var$script.__scopeId = "data-v-a68837";
    $046c9a7be0becd94$var$script.__file = "ModelingImport.vue";
};
$046c9a7be0becd94$var$initialize();
var $046c9a7be0becd94$export$2e2bcd8739ae039 = $046c9a7be0becd94$var$script;


let $68adbe8957f1cbbc$var$script;



let $68adbe8957f1cbbc$var$initialize = ()=>{
    $68adbe8957f1cbbc$var$script = (parcelRequire("69ZUf"));
    if ($68adbe8957f1cbbc$var$script.__esModule) $68adbe8957f1cbbc$var$script = $68adbe8957f1cbbc$var$script.default;
    $68adbe8957f1cbbc$var$script.render = (parcelRequire("alXN7")).render;
    (parcelRequire("bzWxe")).default($68adbe8957f1cbbc$var$script);
    $68adbe8957f1cbbc$var$script.__scopeId = "data-v-4b7d2c";
    $68adbe8957f1cbbc$var$script.__file = "ModelingResultDetail.vue";
};
$68adbe8957f1cbbc$var$initialize();
var $68adbe8957f1cbbc$export$2e2bcd8739ae039 = $68adbe8957f1cbbc$var$script;


let $69e4d34e699b6503$var$script;



let $69e4d34e699b6503$var$initialize = ()=>{
    $69e4d34e699b6503$var$script = (parcelRequire("gcV6I"));
    if ($69e4d34e699b6503$var$script.__esModule) $69e4d34e699b6503$var$script = $69e4d34e699b6503$var$script.default;
    $69e4d34e699b6503$var$script.render = (parcelRequire("kQFDA")).render;
    (parcelRequire("leArl")).default($69e4d34e699b6503$var$script);
    $69e4d34e699b6503$var$script.__scopeId = "data-v-fde53e";
    $69e4d34e699b6503$var$script.__file = "WeightedAverageCharts.vue";
};
$69e4d34e699b6503$var$initialize();
var $69e4d34e699b6503$export$2e2bcd8739ae039 = $69e4d34e699b6503$var$script;


let $d71591a4e0629a50$var$script;



let $d71591a4e0629a50$var$initialize = ()=>{
    $d71591a4e0629a50$var$script = (parcelRequire("g3X4a"));
    if ($d71591a4e0629a50$var$script.__esModule) $d71591a4e0629a50$var$script = $d71591a4e0629a50$var$script.default;
    $d71591a4e0629a50$var$script.render = (parcelRequire("XAxNH")).render;
    (parcelRequire("ifxsT")).default($d71591a4e0629a50$var$script);
    $d71591a4e0629a50$var$script.__scopeId = "data-v-df2834";
    $d71591a4e0629a50$var$script.__file = "ActivityCharts.vue";
};
$d71591a4e0629a50$var$initialize();
var $d71591a4e0629a50$export$2e2bcd8739ae039 = $d71591a4e0629a50$var$script;


let $29761039fe0cae32$var$script;



let $29761039fe0cae32$var$initialize = ()=>{
    $29761039fe0cae32$var$script = (parcelRequire("8JMqw"));
    if ($29761039fe0cae32$var$script.__esModule) $29761039fe0cae32$var$script = $29761039fe0cae32$var$script.default;
    $29761039fe0cae32$var$script.render = (parcelRequire("iBWWz")).render;
    (parcelRequire("eGNRM")).default($29761039fe0cae32$var$script);
    $29761039fe0cae32$var$script.__scopeId = "data-v-eaee72";
    $29761039fe0cae32$var$script.__file = "DistributionCharts.vue";
};
$29761039fe0cae32$var$initialize();
var $29761039fe0cae32$export$2e2bcd8739ae039 = $29761039fe0cae32$var$script;


let $228e8b9fbccc8f06$var$script;




let $228e8b9fbccc8f06$var$initialize = ()=>{
    $228e8b9fbccc8f06$var$script = (parcelRequire("a1Unm"));
    if ($228e8b9fbccc8f06$var$script.__esModule) $228e8b9fbccc8f06$var$script = $228e8b9fbccc8f06$var$script.default;
    $228e8b9fbccc8f06$var$script.render = (parcelRequire("3ZIPg")).render;
    $228e8b9fbccc8f06$var$script.__cssModules = {};
    (parcelRequire("d0uZX")).default($228e8b9fbccc8f06$var$script);
    $228e8b9fbccc8f06$var$script.__scopeId = "data-v-7703db";
    $228e8b9fbccc8f06$var$script.__file = "ActivityPlan.vue";
};
$228e8b9fbccc8f06$var$initialize();
var $228e8b9fbccc8f06$export$2e2bcd8739ae039 = $228e8b9fbccc8f06$var$script;


let $cfbc9f3b1e96952d$var$script;



let $cfbc9f3b1e96952d$var$initialize = ()=>{
    $cfbc9f3b1e96952d$var$script = (parcelRequire("j13HV"));
    if ($cfbc9f3b1e96952d$var$script.__esModule) $cfbc9f3b1e96952d$var$script = $cfbc9f3b1e96952d$var$script.default;
    $cfbc9f3b1e96952d$var$script.render = (parcelRequire("5ZWze")).render;
    (parcelRequire("4MMvy")).default($cfbc9f3b1e96952d$var$script);
    $cfbc9f3b1e96952d$var$script.__scopeId = "data-v-b8aaf5";
    $cfbc9f3b1e96952d$var$script.__file = "SumarizedCostCharts.vue";
};
$cfbc9f3b1e96952d$var$initialize();
var $cfbc9f3b1e96952d$export$2e2bcd8739ae039 = $cfbc9f3b1e96952d$var$script;


let $4e33ba4cc5bf79c8$var$script;



let $4e33ba4cc5bf79c8$var$initialize = ()=>{
    $4e33ba4cc5bf79c8$var$script = (parcelRequire("jjztH"));
    if ($4e33ba4cc5bf79c8$var$script.__esModule) $4e33ba4cc5bf79c8$var$script = $4e33ba4cc5bf79c8$var$script.default;
    $4e33ba4cc5bf79c8$var$script.render = (parcelRequire("aWhm5")).render;
    (parcelRequire("jhZsT")).default($4e33ba4cc5bf79c8$var$script);
    $4e33ba4cc5bf79c8$var$script.__scopeId = "data-v-6b229d";
    $4e33ba4cc5bf79c8$var$script.__file = "DatasetDetail.vue";
};
$4e33ba4cc5bf79c8$var$initialize();
var $4e33ba4cc5bf79c8$export$2e2bcd8739ae039 = $4e33ba4cc5bf79c8$var$script;


let $349e67f683e38e61$var$script;



let $349e67f683e38e61$var$initialize = ()=>{
    $349e67f683e38e61$var$script = (parcelRequire("bleg2"));
    if ($349e67f683e38e61$var$script.__esModule) $349e67f683e38e61$var$script = $349e67f683e38e61$var$script.default;
    $349e67f683e38e61$var$script.render = (parcelRequire("lKRYg")).render;
    (parcelRequire("5dmut")).default($349e67f683e38e61$var$script);
    $349e67f683e38e61$var$script.__scopeId = "data-v-61998d";
    $349e67f683e38e61$var$script.__file = "DatasetCreate.vue";
};
$349e67f683e38e61$var$initialize();
var $349e67f683e38e61$export$2e2bcd8739ae039 = $349e67f683e38e61$var$script;


let $876883fdd7304afa$var$script;



let $876883fdd7304afa$var$initialize = ()=>{
    $876883fdd7304afa$var$script = (parcelRequire("a2uhx"));
    if ($876883fdd7304afa$var$script.__esModule) $876883fdd7304afa$var$script = $876883fdd7304afa$var$script.default;
    $876883fdd7304afa$var$script.render = (parcelRequire("cv38H")).render;
    (parcelRequire("4icYc")).default($876883fdd7304afa$var$script);
    $876883fdd7304afa$var$script.__scopeId = "data-v-0a1040";
    $876883fdd7304afa$var$script.__file = "ForecastDetail.vue";
};
$876883fdd7304afa$var$initialize();
var $876883fdd7304afa$export$2e2bcd8739ae039 = $876883fdd7304afa$var$script;


let $04c2e0ef087dba0e$var$script;



let $04c2e0ef087dba0e$var$initialize = ()=>{
    $04c2e0ef087dba0e$var$script = (parcelRequire("hfdrB"));
    if ($04c2e0ef087dba0e$var$script.__esModule) $04c2e0ef087dba0e$var$script = $04c2e0ef087dba0e$var$script.default;
    $04c2e0ef087dba0e$var$script.render = (parcelRequire("jzXIK")).render;
    (parcelRequire("eFk8K")).default($04c2e0ef087dba0e$var$script);
    $04c2e0ef087dba0e$var$script.__scopeId = "data-v-a35303";
    $04c2e0ef087dba0e$var$script.__file = "ForecastCreate.vue";
};
$04c2e0ef087dba0e$var$initialize();
var $04c2e0ef087dba0e$export$2e2bcd8739ae039 = $04c2e0ef087dba0e$var$script;


let $d32a61d3fd3f7781$var$script;



let $d32a61d3fd3f7781$var$initialize = ()=>{
    $d32a61d3fd3f7781$var$script = (parcelRequire("80568"));
    if ($d32a61d3fd3f7781$var$script.__esModule) $d32a61d3fd3f7781$var$script = $d32a61d3fd3f7781$var$script.default;
    $d32a61d3fd3f7781$var$script.render = (parcelRequire("2zGl7")).render;
    (parcelRequire("8LU47")).default($d32a61d3fd3f7781$var$script);
    $d32a61d3fd3f7781$var$script.__scopeId = "data-v-227ade";
    $d32a61d3fd3f7781$var$script.__file = "SelectionDetail.vue";
};
$d32a61d3fd3f7781$var$initialize();
var $d32a61d3fd3f7781$export$2e2bcd8739ae039 = $d32a61d3fd3f7781$var$script;


let $15247a98f1cab60a$var$script;



let $15247a98f1cab60a$var$initialize = ()=>{
    $15247a98f1cab60a$var$script = (parcelRequire("3FEOo"));
    if ($15247a98f1cab60a$var$script.__esModule) $15247a98f1cab60a$var$script = $15247a98f1cab60a$var$script.default;
    $15247a98f1cab60a$var$script.render = (parcelRequire("enwjS")).render;
    (parcelRequire("1SF1e")).default($15247a98f1cab60a$var$script);
    $15247a98f1cab60a$var$script.__scopeId = "data-v-99e7a2";
    $15247a98f1cab60a$var$script.__file = "SelectionCreate.vue";
};
$15247a98f1cab60a$var$initialize();
var $15247a98f1cab60a$export$2e2bcd8739ae039 = $15247a98f1cab60a$var$script;


let $f64d9472de02a15f$var$script;



let $f64d9472de02a15f$var$initialize = ()=>{
    $f64d9472de02a15f$var$script = (parcelRequire("6BFr6"));
    if ($f64d9472de02a15f$var$script.__esModule) $f64d9472de02a15f$var$script = $f64d9472de02a15f$var$script.default;
    $f64d9472de02a15f$var$script.render = (parcelRequire("eiM2a")).render;
    (parcelRequire("c1bPQ")).default($f64d9472de02a15f$var$script);
    $f64d9472de02a15f$var$script.__scopeId = "data-v-023805";
    $f64d9472de02a15f$var$script.__file = "SelectionInfo.vue";
};
$f64d9472de02a15f$var$initialize();
var $f64d9472de02a15f$export$2e2bcd8739ae039 = $f64d9472de02a15f$var$script;


let $fdec5a7c143bf722$var$script;



let $fdec5a7c143bf722$var$initialize = ()=>{
    $fdec5a7c143bf722$var$script = (parcelRequire("2dHfG"));
    if ($fdec5a7c143bf722$var$script.__esModule) $fdec5a7c143bf722$var$script = $fdec5a7c143bf722$var$script.default;
    $fdec5a7c143bf722$var$script.render = (parcelRequire("bbT5L")).render;
    (parcelRequire("HAyNu")).default($fdec5a7c143bf722$var$script);
    $fdec5a7c143bf722$var$script.__scopeId = "data-v-f3acb3";
    $fdec5a7c143bf722$var$script.__file = "PerformanceDetail.vue";
};
$fdec5a7c143bf722$var$initialize();
var $fdec5a7c143bf722$export$2e2bcd8739ae039 = $fdec5a7c143bf722$var$script;


let $38b68ebe3739e355$var$script;



let $38b68ebe3739e355$var$initialize = ()=>{
    $38b68ebe3739e355$var$script = (parcelRequire("lHYFU"));
    if ($38b68ebe3739e355$var$script.__esModule) $38b68ebe3739e355$var$script = $38b68ebe3739e355$var$script.default;
    $38b68ebe3739e355$var$script.render = (parcelRequire("468lg")).render;
    (parcelRequire("e1W4O")).default($38b68ebe3739e355$var$script);
    $38b68ebe3739e355$var$script.__scopeId = "data-v-ef0e44";
    $38b68ebe3739e355$var$script.__file = "PerformanceCreate.vue";
};
$38b68ebe3739e355$var$initialize();
var $38b68ebe3739e355$export$2e2bcd8739ae039 = $38b68ebe3739e355$var$script;


let $145a7a7302ebebff$var$script;



let $145a7a7302ebebff$var$initialize = ()=>{
    $145a7a7302ebebff$var$script = (parcelRequire("hykzY"));
    if ($145a7a7302ebebff$var$script.__esModule) $145a7a7302ebebff$var$script = $145a7a7302ebebff$var$script.default;
    $145a7a7302ebebff$var$script.render = (parcelRequire("38ifr")).render;
    (parcelRequire("eNKdo")).default($145a7a7302ebebff$var$script);
    $145a7a7302ebebff$var$script.__scopeId = "data-v-2d67ee";
    $145a7a7302ebebff$var$script.__file = "ModelingDetail.vue";
};
$145a7a7302ebebff$var$initialize();
var $145a7a7302ebebff$export$2e2bcd8739ae039 = $145a7a7302ebebff$var$script;


let $ef8fae230a037615$var$script;



let $ef8fae230a037615$var$initialize = ()=>{
    $ef8fae230a037615$var$script = (parcelRequire("aWpmT"));
    if ($ef8fae230a037615$var$script.__esModule) $ef8fae230a037615$var$script = $ef8fae230a037615$var$script.default;
    $ef8fae230a037615$var$script.render = (parcelRequire("1Eea2")).render;
    (parcelRequire("kRlIb")).default($ef8fae230a037615$var$script);
    $ef8fae230a037615$var$script.__scopeId = "data-v-e52866";
    $ef8fae230a037615$var$script.__file = "AssetTypeDetail.vue";
};
$ef8fae230a037615$var$initialize();
var $ef8fae230a037615$export$2e2bcd8739ae039 = $ef8fae230a037615$var$script;


let $1d3fb0232a7e05bb$var$script;



let $1d3fb0232a7e05bb$var$initialize = ()=>{
    $1d3fb0232a7e05bb$var$script = (parcelRequire("2UCrW"));
    if ($1d3fb0232a7e05bb$var$script.__esModule) $1d3fb0232a7e05bb$var$script = $1d3fb0232a7e05bb$var$script.default;
    $1d3fb0232a7e05bb$var$script.render = (parcelRequire("c1Nps")).render;
    (parcelRequire("ewYjP")).default($1d3fb0232a7e05bb$var$script);
    $1d3fb0232a7e05bb$var$script.__scopeId = "data-v-5e298d";
    $1d3fb0232a7e05bb$var$script.__file = "AssetTypeCreate.vue";
};
$1d3fb0232a7e05bb$var$initialize();
var $1d3fb0232a7e05bb$export$2e2bcd8739ae039 = $1d3fb0232a7e05bb$var$script;


let $53232ac00f62884a$var$script;



let $53232ac00f62884a$var$initialize = ()=>{
    $53232ac00f62884a$var$script = (parcelRequire("iK9JN"));
    if ($53232ac00f62884a$var$script.__esModule) $53232ac00f62884a$var$script = $53232ac00f62884a$var$script.default;
    $53232ac00f62884a$var$script.render = (parcelRequire("crkDC")).render;
    (parcelRequire("aIi91")).default($53232ac00f62884a$var$script);
    $53232ac00f62884a$var$script.__scopeId = "data-v-e4551f";
    $53232ac00f62884a$var$script.__file = "AssetTypeInfoSet.vue";
};
$53232ac00f62884a$var$initialize();
var $53232ac00f62884a$export$2e2bcd8739ae039 = $53232ac00f62884a$var$script;


let $e0342ec7aa5fa7e5$var$script;



let $e0342ec7aa5fa7e5$var$initialize = ()=>{
    $e0342ec7aa5fa7e5$var$script = (parcelRequire("eEK8D"));
    if ($e0342ec7aa5fa7e5$var$script.__esModule) $e0342ec7aa5fa7e5$var$script = $e0342ec7aa5fa7e5$var$script.default;
    $e0342ec7aa5fa7e5$var$script.render = (parcelRequire("iWrCV")).render;
    (parcelRequire("ifts3")).default($e0342ec7aa5fa7e5$var$script);
    $e0342ec7aa5fa7e5$var$script.__scopeId = "data-v-b907a4";
    $e0342ec7aa5fa7e5$var$script.__file = "ActivityDetail.vue";
};
$e0342ec7aa5fa7e5$var$initialize();
var $e0342ec7aa5fa7e5$export$2e2bcd8739ae039 = $e0342ec7aa5fa7e5$var$script;


let $dc66ffca8d812c15$var$script;



let $dc66ffca8d812c15$var$initialize = ()=>{
    $dc66ffca8d812c15$var$script = (parcelRequire("gRek3"));
    if ($dc66ffca8d812c15$var$script.__esModule) $dc66ffca8d812c15$var$script = $dc66ffca8d812c15$var$script.default;
    $dc66ffca8d812c15$var$script.render = (parcelRequire("gqcWW")).render;
    (parcelRequire("DXsKe")).default($dc66ffca8d812c15$var$script);
    $dc66ffca8d812c15$var$script.__scopeId = "data-v-24797d";
    $dc66ffca8d812c15$var$script.__file = "ActivityCreate.vue";
};
$dc66ffca8d812c15$var$initialize();
var $dc66ffca8d812c15$export$2e2bcd8739ae039 = $dc66ffca8d812c15$var$script;


let $1c862e79087ad3fa$var$script;



let $1c862e79087ad3fa$var$initialize = ()=>{
    $1c862e79087ad3fa$var$script = (parcelRequire("3YAVM"));
    if ($1c862e79087ad3fa$var$script.__esModule) $1c862e79087ad3fa$var$script = $1c862e79087ad3fa$var$script.default;
    $1c862e79087ad3fa$var$script.render = (parcelRequire("icSbV")).render;
    (parcelRequire("eik26")).default($1c862e79087ad3fa$var$script);
    $1c862e79087ad3fa$var$script.__scopeId = "data-v-48e9c8";
    $1c862e79087ad3fa$var$script.__file = "ParameterDetail.vue";
};
$1c862e79087ad3fa$var$initialize();
var $1c862e79087ad3fa$export$2e2bcd8739ae039 = $1c862e79087ad3fa$var$script;


let $f28fac21db37e636$var$script;



let $f28fac21db37e636$var$initialize = ()=>{
    $f28fac21db37e636$var$script = (parcelRequire("9B0W0"));
    if ($f28fac21db37e636$var$script.__esModule) $f28fac21db37e636$var$script = $f28fac21db37e636$var$script.default;
    $f28fac21db37e636$var$script.render = (parcelRequire("58dds")).render;
    (parcelRequire("Gxvey")).default($f28fac21db37e636$var$script);
    $f28fac21db37e636$var$script.__scopeId = "data-v-ce1645";
    $f28fac21db37e636$var$script.__file = "ParameterInfoDetail.vue";
};
$f28fac21db37e636$var$initialize();
var $f28fac21db37e636$export$2e2bcd8739ae039 = $f28fac21db37e636$var$script;


let $6cbabaa9768f4bf3$var$script;



let $6cbabaa9768f4bf3$var$initialize = ()=>{
    $6cbabaa9768f4bf3$var$script = (parcelRequire("lke6x"));
    if ($6cbabaa9768f4bf3$var$script.__esModule) $6cbabaa9768f4bf3$var$script = $6cbabaa9768f4bf3$var$script.default;
    $6cbabaa9768f4bf3$var$script.render = (parcelRequire("7Othq")).render;
    (parcelRequire("3kKte")).default($6cbabaa9768f4bf3$var$script);
    $6cbabaa9768f4bf3$var$script.__scopeId = "data-v-449ac5";
    $6cbabaa9768f4bf3$var$script.__file = "ParameterCreate.vue";
};
$6cbabaa9768f4bf3$var$initialize();
var $6cbabaa9768f4bf3$export$2e2bcd8739ae039 = $6cbabaa9768f4bf3$var$script;


let $a71f6b4534b549f7$var$script;



let $a71f6b4534b549f7$var$initialize = ()=>{
    $a71f6b4534b549f7$var$script = (parcelRequire("fChua"));
    if ($a71f6b4534b549f7$var$script.__esModule) $a71f6b4534b549f7$var$script = $a71f6b4534b549f7$var$script.default;
    $a71f6b4534b549f7$var$script.render = (parcelRequire("UeFvr")).render;
    (parcelRequire("9h9a4")).default($a71f6b4534b549f7$var$script);
    $a71f6b4534b549f7$var$script.__scopeId = "data-v-c69378";
    $a71f6b4534b549f7$var$script.__file = "KPIDetail.vue";
};
$a71f6b4534b549f7$var$initialize();
var $a71f6b4534b549f7$export$2e2bcd8739ae039 = $a71f6b4534b549f7$var$script;


let $4891c1e560b68d54$var$script;



let $4891c1e560b68d54$var$initialize = ()=>{
    $4891c1e560b68d54$var$script = (parcelRequire("96cjs"));
    if ($4891c1e560b68d54$var$script.__esModule) $4891c1e560b68d54$var$script = $4891c1e560b68d54$var$script.default;
    $4891c1e560b68d54$var$script.render = (parcelRequire("aCV4w")).render;
    (parcelRequire("4jnTm")).default($4891c1e560b68d54$var$script);
    $4891c1e560b68d54$var$script.__scopeId = "data-v-5af064";
    $4891c1e560b68d54$var$script.__file = "KPICreate.vue";
};
$4891c1e560b68d54$var$initialize();
var $4891c1e560b68d54$export$2e2bcd8739ae039 = $4891c1e560b68d54$var$script;


let $3f253181c2e751e6$var$script;



let $3f253181c2e751e6$var$initialize = ()=>{
    $3f253181c2e751e6$var$script = (parcelRequire("bUVCO"));
    if ($3f253181c2e751e6$var$script.__esModule) $3f253181c2e751e6$var$script = $3f253181c2e751e6$var$script.default;
    $3f253181c2e751e6$var$script.render = (parcelRequire("aM7pf")).render;
    (parcelRequire("3yMZ6")).default($3f253181c2e751e6$var$script);
    $3f253181c2e751e6$var$script.__scopeId = "data-v-0da72f";
    $3f253181c2e751e6$var$script.__file = "LifeCycleDetail.vue";
};
$3f253181c2e751e6$var$initialize();
var $3f253181c2e751e6$export$2e2bcd8739ae039 = $3f253181c2e751e6$var$script;


let $fefe03a1ab546cab$var$script;



let $fefe03a1ab546cab$var$initialize = ()=>{
    $fefe03a1ab546cab$var$script = (parcelRequire("fswk9"));
    if ($fefe03a1ab546cab$var$script.__esModule) $fefe03a1ab546cab$var$script = $fefe03a1ab546cab$var$script.default;
    $fefe03a1ab546cab$var$script.render = (parcelRequire("hlURL")).render;
    (parcelRequire("eOX7a")).default($fefe03a1ab546cab$var$script);
    $fefe03a1ab546cab$var$script.__scopeId = "data-v-731229";
    $fefe03a1ab546cab$var$script.__file = "LifeCycleCreate.vue";
};
$fefe03a1ab546cab$var$initialize();
var $fefe03a1ab546cab$export$2e2bcd8739ae039 = $fefe03a1ab546cab$var$script;


let $c02da7b56d9ab4d1$var$script;



let $c02da7b56d9ab4d1$var$initialize = ()=>{
    $c02da7b56d9ab4d1$var$script = (parcelRequire("lbdCn"));
    if ($c02da7b56d9ab4d1$var$script.__esModule) $c02da7b56d9ab4d1$var$script = $c02da7b56d9ab4d1$var$script.default;
    $c02da7b56d9ab4d1$var$script.render = (parcelRequire("cdZSC")).render;
    (parcelRequire("5IkEk")).default($c02da7b56d9ab4d1$var$script);
    $c02da7b56d9ab4d1$var$script.__scopeId = "data-v-62c256";
    $c02da7b56d9ab4d1$var$script.__file = "BenefitDetail.vue";
};
$c02da7b56d9ab4d1$var$initialize();
var $c02da7b56d9ab4d1$export$2e2bcd8739ae039 = $c02da7b56d9ab4d1$var$script;


let $8f44c755ccf6c4c9$var$script;



let $8f44c755ccf6c4c9$var$initialize = ()=>{
    $8f44c755ccf6c4c9$var$script = (parcelRequire("g6dfm"));
    if ($8f44c755ccf6c4c9$var$script.__esModule) $8f44c755ccf6c4c9$var$script = $8f44c755ccf6c4c9$var$script.default;
    $8f44c755ccf6c4c9$var$script.render = (parcelRequire("juKJr")).render;
    (parcelRequire("1RkLZ")).default($8f44c755ccf6c4c9$var$script);
    $8f44c755ccf6c4c9$var$script.__scopeId = "data-v-460377";
    $8f44c755ccf6c4c9$var$script.__file = "BenefitCreate.vue";
};
$8f44c755ccf6c4c9$var$initialize();
var $8f44c755ccf6c4c9$export$2e2bcd8739ae039 = $8f44c755ccf6c4c9$var$script;


let $b52197d2028081ea$var$script;



let $b52197d2028081ea$var$initialize = ()=>{
    $b52197d2028081ea$var$script = (parcelRequire("7nO4i"));
    if ($b52197d2028081ea$var$script.__esModule) $b52197d2028081ea$var$script = $b52197d2028081ea$var$script.default;
    $b52197d2028081ea$var$script.render = (parcelRequire("b2pYX")).render;
    (parcelRequire("2HPgC")).default($b52197d2028081ea$var$script);
    $b52197d2028081ea$var$script.__scopeId = "data-v-fbf0fd";
    $b52197d2028081ea$var$script.__file = "GroupAdd.vue";
};
$b52197d2028081ea$var$initialize();
var $b52197d2028081ea$export$2e2bcd8739ae039 = $b52197d2028081ea$var$script;


let $da795e44050f7ad3$var$script;



let $da795e44050f7ad3$var$initialize = ()=>{
    $da795e44050f7ad3$var$script = (parcelRequire("8SDMh"));
    if ($da795e44050f7ad3$var$script.__esModule) $da795e44050f7ad3$var$script = $da795e44050f7ad3$var$script.default;
    $da795e44050f7ad3$var$script.render = (parcelRequire("kkOwD")).render;
    (parcelRequire("9rJHx")).default($da795e44050f7ad3$var$script);
    $da795e44050f7ad3$var$script.__scopeId = "data-v-771664";
    $da795e44050f7ad3$var$script.__file = "GroupDetail.vue";
};
$da795e44050f7ad3$var$initialize();
var $da795e44050f7ad3$export$2e2bcd8739ae039 = $da795e44050f7ad3$var$script;


let $7cc410198110697b$var$script;



let $7cc410198110697b$var$initialize = ()=>{
    $7cc410198110697b$var$script = (parcelRequire("2OxhC"));
    if ($7cc410198110697b$var$script.__esModule) $7cc410198110697b$var$script = $7cc410198110697b$var$script.default;
    $7cc410198110697b$var$script.render = (parcelRequire("dSNeQ")).render;
    (parcelRequire("bHQX1")).default($7cc410198110697b$var$script);
    $7cc410198110697b$var$script.__scopeId = "data-v-09e54e";
    $7cc410198110697b$var$script.__file = "GroupList.vue";
};
$7cc410198110697b$var$initialize();
var $7cc410198110697b$export$2e2bcd8739ae039 = $7cc410198110697b$var$script;


let $1127d54e621bca25$var$script;



let $1127d54e621bca25$var$initialize = ()=>{
    $1127d54e621bca25$var$script = (parcelRequire("1ulgA"));
    if ($1127d54e621bca25$var$script.__esModule) $1127d54e621bca25$var$script = $1127d54e621bca25$var$script.default;
    $1127d54e621bca25$var$script.render = (parcelRequire("7YUFD")).render;
    (parcelRequire("5JZHQ")).default($1127d54e621bca25$var$script);
    $1127d54e621bca25$var$script.__scopeId = "data-v-5ba398";
    $1127d54e621bca25$var$script.__file = "ModelingAdd.vue";
};
$1127d54e621bca25$var$initialize();
var $1127d54e621bca25$export$2e2bcd8739ae039 = $1127d54e621bca25$var$script;


let $08856b415590a236$var$script;



let $08856b415590a236$var$initialize = ()=>{
    $08856b415590a236$var$script = (parcelRequire("5GDRK"));
    if ($08856b415590a236$var$script.__esModule) $08856b415590a236$var$script = $08856b415590a236$var$script.default;
    $08856b415590a236$var$script.render = (parcelRequire("jihxJ")).render;
    (parcelRequire("dKE9n")).default($08856b415590a236$var$script);
    $08856b415590a236$var$script.__scopeId = "data-v-0b4585";
    $08856b415590a236$var$script.__file = "ModelingList.vue";
};
$08856b415590a236$var$initialize();
var $08856b415590a236$export$2e2bcd8739ae039 = $08856b415590a236$var$script;


let $88dfa9dbc689093e$var$script;



let $88dfa9dbc689093e$var$initialize = ()=>{
    $88dfa9dbc689093e$var$script = (parcelRequire("fReej"));
    if ($88dfa9dbc689093e$var$script.__esModule) $88dfa9dbc689093e$var$script = $88dfa9dbc689093e$var$script.default;
    $88dfa9dbc689093e$var$script.render = (parcelRequire("1VcHK")).render;
    (parcelRequire("jhbn0")).default($88dfa9dbc689093e$var$script);
    $88dfa9dbc689093e$var$script.__scopeId = "data-v-57f7b9";
    $88dfa9dbc689093e$var$script.__file = "SelectionGroupDetail.vue";
};
$88dfa9dbc689093e$var$initialize();
var $88dfa9dbc689093e$export$2e2bcd8739ae039 = $88dfa9dbc689093e$var$script;


let $3aaca5ac67a3486f$var$script;



let $3aaca5ac67a3486f$var$initialize = ()=>{
    $3aaca5ac67a3486f$var$script = (parcelRequire("l25nm"));
    if ($3aaca5ac67a3486f$var$script.__esModule) $3aaca5ac67a3486f$var$script = $3aaca5ac67a3486f$var$script.default;
    $3aaca5ac67a3486f$var$script.render = (parcelRequire("8d3X0")).render;
    (parcelRequire("8on5V")).default($3aaca5ac67a3486f$var$script);
    $3aaca5ac67a3486f$var$script.__scopeId = "data-v-b8235f";
    $3aaca5ac67a3486f$var$script.__file = "SelectionGroupCreate.vue";
};
$3aaca5ac67a3486f$var$initialize();
var $3aaca5ac67a3486f$export$2e2bcd8739ae039 = $3aaca5ac67a3486f$var$script;


let $8d9daf293a702f16$var$script;



let $8d9daf293a702f16$var$initialize = ()=>{
    $8d9daf293a702f16$var$script = (parcelRequire("famF4"));
    if ($8d9daf293a702f16$var$script.__esModule) $8d9daf293a702f16$var$script = $8d9daf293a702f16$var$script.default;
    $8d9daf293a702f16$var$script.render = (parcelRequire("hth4S")).render;
    (parcelRequire("9ZjXC")).default($8d9daf293a702f16$var$script);
    $8d9daf293a702f16$var$script.__scopeId = "data-v-7f70b7";
    $8d9daf293a702f16$var$script.__file = "SelectionPackageDetail.vue";
};
$8d9daf293a702f16$var$initialize();
var $8d9daf293a702f16$export$2e2bcd8739ae039 = $8d9daf293a702f16$var$script;


let $bbe5bd3518d09621$var$script;



let $bbe5bd3518d09621$var$initialize = ()=>{
    $bbe5bd3518d09621$var$script = (parcelRequire("1tRTX"));
    if ($bbe5bd3518d09621$var$script.__esModule) $bbe5bd3518d09621$var$script = $bbe5bd3518d09621$var$script.default;
    $bbe5bd3518d09621$var$script.render = (parcelRequire("5bnwW")).render;
    (parcelRequire("eJLt4")).default($bbe5bd3518d09621$var$script);
    $bbe5bd3518d09621$var$script.__scopeId = "data-v-d2c688";
    $bbe5bd3518d09621$var$script.__file = "SelectionPackageCreate.vue";
};
$bbe5bd3518d09621$var$initialize();
var $bbe5bd3518d09621$export$2e2bcd8739ae039 = $bbe5bd3518d09621$var$script;


let $5f94ea72919761e8$var$script;



let $5f94ea72919761e8$var$initialize = ()=>{
    $5f94ea72919761e8$var$script = (parcelRequire("c0RzE"));
    if ($5f94ea72919761e8$var$script.__esModule) $5f94ea72919761e8$var$script = $5f94ea72919761e8$var$script.default;
    $5f94ea72919761e8$var$script.render = (parcelRequire("81ijN")).render;
    (parcelRequire("9RBi4")).default($5f94ea72919761e8$var$script);
    $5f94ea72919761e8$var$script.__scopeId = "data-v-f30ef5";
    $5f94ea72919761e8$var$script.__file = "SelectionLimitDetail.vue";
};
$5f94ea72919761e8$var$initialize();
var $5f94ea72919761e8$export$2e2bcd8739ae039 = $5f94ea72919761e8$var$script;


let $e71edd73eafdd9d1$var$script;



let $e71edd73eafdd9d1$var$initialize = ()=>{
    $e71edd73eafdd9d1$var$script = (parcelRequire("bk5BK"));
    if ($e71edd73eafdd9d1$var$script.__esModule) $e71edd73eafdd9d1$var$script = $e71edd73eafdd9d1$var$script.default;
    $e71edd73eafdd9d1$var$script.render = (parcelRequire("l17Vw")).render;
    (parcelRequire("835KA")).default($e71edd73eafdd9d1$var$script);
    $e71edd73eafdd9d1$var$script.__scopeId = "data-v-175a50";
    $e71edd73eafdd9d1$var$script.__file = "SelectionLimitCreate.vue";
};
$e71edd73eafdd9d1$var$initialize();
var $e71edd73eafdd9d1$export$2e2bcd8739ae039 = $e71edd73eafdd9d1$var$script;


let $d779a208be0962cf$var$script;



let $d779a208be0962cf$var$initialize = ()=>{
    $d779a208be0962cf$var$script = (parcelRequire("cHK1h"));
    if ($d779a208be0962cf$var$script.__esModule) $d779a208be0962cf$var$script = $d779a208be0962cf$var$script.default;
    $d779a208be0962cf$var$script.render = (parcelRequire("cm9ph")).render;
    (parcelRequire("fbziw")).default($d779a208be0962cf$var$script);
    $d779a208be0962cf$var$script.__scopeId = "data-v-c963f4";
    $d779a208be0962cf$var$script.__file = "UserAdd.vue";
};
$d779a208be0962cf$var$initialize();
var $d779a208be0962cf$export$2e2bcd8739ae039 = $d779a208be0962cf$var$script;


let $4fb7f29878493d58$var$script;



let $4fb7f29878493d58$var$initialize = ()=>{
    $4fb7f29878493d58$var$script = (parcelRequire("7goMD"));
    if ($4fb7f29878493d58$var$script.__esModule) $4fb7f29878493d58$var$script = $4fb7f29878493d58$var$script.default;
    $4fb7f29878493d58$var$script.render = (parcelRequire("i5xnQ")).render;
    (parcelRequire("fZlOG")).default($4fb7f29878493d58$var$script);
    $4fb7f29878493d58$var$script.__scopeId = "data-v-b788b7";
    $4fb7f29878493d58$var$script.__file = "UserDetail.vue";
};
$4fb7f29878493d58$var$initialize();
var $4fb7f29878493d58$export$2e2bcd8739ae039 = $4fb7f29878493d58$var$script;


let $b0c11f6ef9519475$var$script;



let $b0c11f6ef9519475$var$initialize = ()=>{
    $b0c11f6ef9519475$var$script = (parcelRequire("aiCIV"));
    if ($b0c11f6ef9519475$var$script.__esModule) $b0c11f6ef9519475$var$script = $b0c11f6ef9519475$var$script.default;
    $b0c11f6ef9519475$var$script.render = (parcelRequire("DOw7n")).render;
    (parcelRequire("7zsoQ")).default($b0c11f6ef9519475$var$script);
    $b0c11f6ef9519475$var$script.__scopeId = "data-v-586a65";
    $b0c11f6ef9519475$var$script.__file = "UserList.vue";
};
$b0c11f6ef9519475$var$initialize();
var $b0c11f6ef9519475$export$2e2bcd8739ae039 = $b0c11f6ef9519475$var$script;


let $770f8d442c38844d$var$script;



let $770f8d442c38844d$var$initialize = ()=>{
    $770f8d442c38844d$var$script = (parcelRequire("6mSVy"));
    if ($770f8d442c38844d$var$script.__esModule) $770f8d442c38844d$var$script = $770f8d442c38844d$var$script.default;
    $770f8d442c38844d$var$script.render = (parcelRequire("7zE21")).render;
    (parcelRequire("fWRjK")).default($770f8d442c38844d$var$script);
    $770f8d442c38844d$var$script.__scopeId = "data-v-f63eea";
    $770f8d442c38844d$var$script.__file = "ParameterEvaluationCreate.vue";
};
$770f8d442c38844d$var$initialize();
var $770f8d442c38844d$export$2e2bcd8739ae039 = $770f8d442c38844d$var$script;


let $726c65d311f7b058$var$script;



let $726c65d311f7b058$var$initialize = ()=>{
    $726c65d311f7b058$var$script = (parcelRequire("1wSLe"));
    if ($726c65d311f7b058$var$script.__esModule) $726c65d311f7b058$var$script = $726c65d311f7b058$var$script.default;
    $726c65d311f7b058$var$script.render = (parcelRequire("7ong8")).render;
    (parcelRequire("5XS9Y")).default($726c65d311f7b058$var$script);
    $726c65d311f7b058$var$script.__scopeId = "data-v-647b9f";
    $726c65d311f7b058$var$script.__file = "ParameterEvaluationDetail.vue";
};
$726c65d311f7b058$var$initialize();
var $726c65d311f7b058$export$2e2bcd8739ae039 = $726c65d311f7b058$var$script;


let $276dd5b2cdf7d99a$var$script;



let $276dd5b2cdf7d99a$var$initialize = ()=>{
    $276dd5b2cdf7d99a$var$script = (parcelRequire("e9p5C"));
    if ($276dd5b2cdf7d99a$var$script.__esModule) $276dd5b2cdf7d99a$var$script = $276dd5b2cdf7d99a$var$script.default;
    $276dd5b2cdf7d99a$var$script.render = (parcelRequire("adMBy")).render;
    (parcelRequire("ltUFZ")).default($276dd5b2cdf7d99a$var$script);
    $276dd5b2cdf7d99a$var$script.__scopeId = "data-v-8fcdad";
    $276dd5b2cdf7d99a$var$script.__file = "CurveCreate.vue";
};
$276dd5b2cdf7d99a$var$initialize();
var $276dd5b2cdf7d99a$export$2e2bcd8739ae039 = $276dd5b2cdf7d99a$var$script;


let $883d7ad2335776ef$var$script;



let $883d7ad2335776ef$var$initialize = ()=>{
    $883d7ad2335776ef$var$script = (parcelRequire("8fsEv"));
    if ($883d7ad2335776ef$var$script.__esModule) $883d7ad2335776ef$var$script = $883d7ad2335776ef$var$script.default;
    $883d7ad2335776ef$var$script.render = (parcelRequire("iDKwv")).render;
    (parcelRequire("3qfc9")).default($883d7ad2335776ef$var$script);
    $883d7ad2335776ef$var$script.__scopeId = "data-v-3563bc";
    $883d7ad2335776ef$var$script.__file = "CurveDetail.vue";
};
$883d7ad2335776ef$var$initialize();
var $883d7ad2335776ef$export$2e2bcd8739ae039 = $883d7ad2335776ef$var$script;


let $0ec2ec261c9a3f3c$var$script;



let $0ec2ec261c9a3f3c$var$initialize = ()=>{
    $0ec2ec261c9a3f3c$var$script = (parcelRequire("6Ydpq"));
    if ($0ec2ec261c9a3f3c$var$script.__esModule) $0ec2ec261c9a3f3c$var$script = $0ec2ec261c9a3f3c$var$script.default;
    $0ec2ec261c9a3f3c$var$script.render = (parcelRequire("7ASaG")).render;
    (parcelRequire("aBkbK")).default($0ec2ec261c9a3f3c$var$script);
    $0ec2ec261c9a3f3c$var$script.__scopeId = "data-v-d00f36";
    $0ec2ec261c9a3f3c$var$script.__file = "EvaluationCreate.vue";
};
$0ec2ec261c9a3f3c$var$initialize();
var $0ec2ec261c9a3f3c$export$2e2bcd8739ae039 = $0ec2ec261c9a3f3c$var$script;


let $fcc283b7cb98b154$var$script;



let $fcc283b7cb98b154$var$initialize = ()=>{
    $fcc283b7cb98b154$var$script = (parcelRequire("ikdAY"));
    if ($fcc283b7cb98b154$var$script.__esModule) $fcc283b7cb98b154$var$script = $fcc283b7cb98b154$var$script.default;
    $fcc283b7cb98b154$var$script.render = (parcelRequire("hceHp")).render;
    (parcelRequire("7mHJO")).default($fcc283b7cb98b154$var$script);
    $fcc283b7cb98b154$var$script.__scopeId = "data-v-6d2606";
    $fcc283b7cb98b154$var$script.__file = "EvaluationDetail.vue";
};
$fcc283b7cb98b154$var$initialize();
var $fcc283b7cb98b154$export$2e2bcd8739ae039 = $fcc283b7cb98b154$var$script;



var $72Xwp = parcelRequire("72Xwp");
const $0dc597825647b4a5$var$routes = [
    {
        path: "/",
        name: "Login",
        component: (0, $c76da6a997a95812$export$2e2bcd8739ae039)
    },
    {
        path: "/modelings",
        name: "Modelings",
        component: (0, $ea9442045aa70520$export$2e2bcd8739ae039)
    },
    {
        path: "/modeling/:id",
        // component: Modeling,
        props: true,
        children: [
            {
                path: "/modeling/:id/modelingresult/:modelingResultId",
                name: "modelingresult",
                component: (0, $68adbe8957f1cbbc$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "modelingresult/:modelingResultId",
                props: true,
                children: [
                    {
                        path: "weightedaverage",
                        component: (0, $69e4d34e699b6503$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "activity",
                        component: (0, $d71591a4e0629a50$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "distribution",
                        component: (0, $29761039fe0cae32$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "activityplan",
                        component: (0, $228e8b9fbccc8f06$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "sumarizedcost",
                        component: (0, $cfbc9f3b1e96952d$export$2e2bcd8739ae039),
                        props: true
                    }
                ]
            },
            {
                path: "datasetcreate",
                component: (0, $349e67f683e38e61$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "dataset/:datasetId",
                component: (0, $4e33ba4cc5bf79c8$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "forecastcreate",
                component: (0, $04c2e0ef087dba0e$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "forecast/:forecastId",
                component: (0, $876883fdd7304afa$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "selection/:selectionId",
                component: (0, $d32a61d3fd3f7781$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "selectioncreate/:forecastId",
                component: (0, $15247a98f1cab60a$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "selectioninfo/:selectionId",
                component: (0, $f64d9472de02a15f$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "selection/:selectionId/group/:groupId",
                component: (0, $88dfa9dbc689093e$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "selection/:selectionId/groupcreate",
                component: (0, $3aaca5ac67a3486f$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "selection/:selectionId/package/:packageId",
                component: (0, $8d9daf293a702f16$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "selection/:selectionId/packagecreate",
                component: (0, $bbe5bd3518d09621$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "selection/:selectionId/limit/:limitId",
                component: (0, $5f94ea72919761e8$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "selection/:selectionId/limitcreate",
                component: (0, $e71edd73eafdd9d1$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "assettypecreate/:datasetId",
                component: (0, $1d3fb0232a7e05bb$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "assettype/:assetTypeId",
                component: (0, $ef8fae230a037615$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "assettypeinfoset/:assetTypeId",
                component: (0, $53232ac00f62884a$export$2e2bcd8739ae039),
                props: true
            },
            {
                path: "assettype/:assetTypeId",
                props: true,
                children: [
                    {
                        path: "activity/:activityId",
                        component: (0, $e0342ec7aa5fa7e5$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "activitycreate",
                        component: (0, $dc66ffca8d812c15$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "parameter/:parameterId",
                        component: (0, $1c862e79087ad3fa$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "parameter/:parameterId/parameterinfo",
                        component: (0, $f28fac21db37e636$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "parametercreate",
                        component: (0, $6cbabaa9768f4bf3$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "parameter/:parameterId",
                        props: true,
                        children: [
                            {
                                path: "evaluation/:evaluationId",
                                component: (0, $726c65d311f7b058$export$2e2bcd8739ae039),
                                props: true
                            },
                            {
                                path: "evaluationcreate",
                                component: (0, $770f8d442c38844d$export$2e2bcd8739ae039),
                                props: true
                            }
                        ]
                    },
                    {
                        path: "curve/:curveId",
                        component: (0, $883d7ad2335776ef$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "curvecreate/:parameterId",
                        component: (0, $276dd5b2cdf7d99a$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "kpi/:keyPerformanceIndicatorId",
                        component: (0, $a71f6b4534b549f7$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "kpicreate",
                        component: (0, $4891c1e560b68d54$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "evaluation/:evaluationId",
                        component: (0, $fcc283b7cb98b154$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "evaluationcreate/:keyPerformanceIndicatorId",
                        component: (0, $0ec2ec261c9a3f3c$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "lifecycle/:lifeCycleId",
                        component: (0, $3f253181c2e751e6$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "lifecyclecreate",
                        component: (0, $fefe03a1ab546cab$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "benefit/:benefitId",
                        component: (0, $c02da7b56d9ab4d1$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "benefitcreate",
                        component: (0, $8f44c755ccf6c4c9$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "performancecreate",
                        component: (0, $38b68ebe3739e355$export$2e2bcd8739ae039),
                        props: true
                    },
                    {
                        path: "performance/:performanceId",
                        component: (0, $fdec5a7c143bf722$export$2e2bcd8739ae039),
                        props: true
                    }
                ]
            }
        ]
    },
    {
        path: "/groupadd",
        name: "groupadd",
        component: (0, $b52197d2028081ea$export$2e2bcd8739ae039)
    },
    {
        path: "/groupdetail/:id",
        name: "groupdetail",
        component: (0, $da795e44050f7ad3$export$2e2bcd8739ae039),
        props: true
    },
    //ADMIN - SETTINGS
    {
        path: "/modelingadd",
        name: "modelingadd",
        component: (0, $1127d54e621bca25$export$2e2bcd8739ae039)
    },
    {
        path: "/modeling/:id",
        name: "modeling",
        component: (0, $c3acc8244e2e7a3e$export$2e2bcd8739ae039),
        props: true
    },
    {
        path: "/modeling/:id/import",
        component: (0, $046c9a7be0becd94$export$2e2bcd8739ae039),
        props: true
    },
    {
        path: "/settingsmodelingdetail/:id",
        name: "settingsmodelingdetail",
        component: (0, $145a7a7302ebebff$export$2e2bcd8739ae039),
        props: true
    },
    // {
    //     path: '/admininspectiondetail/:id',
    //     name: 'admininspectiondetail',
    //     component: AdminInspectionDetail,
    //     props: true
    // },
    // {
    //     path: '/modelingview/:id',
    //     name: 'modelingview',
    //     component: AdminModelingView,
    //     props: true
    // },
    {
        path: "/userdetail/:id",
        name: "userdetail",
        component: (0, $4fb7f29878493d58$export$2e2bcd8739ae039),
        props: true
    },
    {
        path: "/useradd",
        name: "useradd",
        component: (0, $d779a208be0962cf$export$2e2bcd8739ae039)
    },
    {
        path: "/settings",
        name: "settings",
        component: (0, $3f98e29a5305f88e$export$2e2bcd8739ae039),
        props: true,
        children: [
            {
                path: "users",
                name: "users",
                component: (0, $b0c11f6ef9519475$export$2e2bcd8739ae039)
            },
            {
                path: "groups",
                name: "groups",
                component: (0, $7cc410198110697b$export$2e2bcd8739ae039)
            },
            {
                path: "modelings",
                name: "modelings",
                component: (0, $08856b415590a236$export$2e2bcd8739ae039)
            }
        ]
    }
];
const $0dc597825647b4a5$var$router = (0, $a809ac530d32f081$export$baddd0131ee8c05b)({
    history: (0, $a809ac530d32f081$export$542bc3a76486c94d)(),
    routes: $0dc597825647b4a5$var$routes
});
$0dc597825647b4a5$var$router.beforeEach(async (to, from, next)=>{
    var auth = await (0, $72Xwp.default).auth();
    if (to.name !== "Login" && !auth.isAuthenticated) next({
        name: "Login",
        query: {
            returnUrl: to.fullPath
        }
    });
    else next();
});
if (!window.indexedDB) console.log("Your browser doesn't support a stable version of IndexedDB. Such and such feature will not be available.");
var $0dc597825647b4a5$export$2e2bcd8739ae039 = $0dc597825647b4a5$var$router;


var $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES;
(function(DEFAULT_MESSAGE_TYPES) {
    DEFAULT_MESSAGE_TYPES["error"] = "error";
    DEFAULT_MESSAGE_TYPES["warn"] = "warn";
    DEFAULT_MESSAGE_TYPES["info"] = "info";
    DEFAULT_MESSAGE_TYPES["success"] = "success";
})($0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES || ($0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES = {}));
const $0b901d553092e5c6$var$VueNotifications = {
    types: {
        error: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.error,
        warn: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.warn,
        info: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.info,
        success: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.success
    },
    propertyName: "notifications",
    config: {
        type: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.info,
        timeout: 3000
    },
    pluginOptions: {},
    installed: false,
    install (vueConstructor, pluginOptions) {
        if (this.installed) throw console.error("VueNotifications: plugin already installed");
        const mixin = $0b901d553092e5c6$var$makeMixin();
        vueConstructor.mixin(mixin);
        this.setPluginOptions(pluginOptions);
        this.installed = true;
    },
    setPluginOptions (pluginOptions) {
        this.pluginOptions = pluginOptions;
    }
};
function $0b901d553092e5c6$var$getValues(config, vueApp) {
    let result = {
        type: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.info
    };
    Object.keys(config).forEach((field)=>{
        if (field === "cb") result = {
            ...result,
            [field]: config[field].bind(vueApp)
        };
        else result = {
            ...result,
            [field]: typeof config[field] === "function" ? config[field].call(vueApp) : config[field]
        };
    });
    return result;
}
function $0b901d553092e5c6$var$showMessage(config, vueApp) {
    const valuesObj = $0b901d553092e5c6$var$getValues(config, vueApp);
    const isMethodOverridden = $0b901d553092e5c6$var$VueNotifications.pluginOptions[valuesObj.type];
    const method = isMethodOverridden ? $0b901d553092e5c6$var$VueNotifications.pluginOptions[valuesObj.type] : console.log;
    method(valuesObj, vueApp);
    if (config.cb) config.cb();
}
function $0b901d553092e5c6$var$setMethod(vueApp, name, componentOptions) {
    let { methods: methods } = componentOptions;
    if (!methods) methods = {};
    if (!methods[name]) methods[name] = $0b901d553092e5c6$var$makeMethod(vueApp, name, componentOptions);
    else console.warn(`VueNotifications: trying to create method which is already exist: ${name}`);
}
function $0b901d553092e5c6$var$makeMethod(vueApp, methodName, componentOptions) {
    return (config)=>{
        // TODO (S.Panfilov) 'componentOptions' is an extended 'ComponentOptions' with our 'VueNotifications.propertyName'
        const pluginOptions = componentOptions[$0b901d553092e5c6$var$VueNotifications.propertyName];
        const methodConfig = pluginOptions ? pluginOptions[methodName] : {};
        const newConfig = {
            ...$0b901d553092e5c6$var$VueNotifications.config,
            ...methodConfig,
            ...config
        };
        $0b901d553092e5c6$var$showMessage(newConfig, vueApp);
    };
}
function $0b901d553092e5c6$var$initVueNotificationPlugin(vueApp, notifications) {
    if (!notifications) return;
    Object.keys(notifications).forEach((name)=>$0b901d553092e5c6$var$setMethod(vueApp, name, vueApp.$options));
    vueApp.$emit("vue-notifications-initiated");
}
function $0b901d553092e5c6$var$unlinkVueNotificationPlugin(vueApp, notifications) {
    if (!notifications) return;
    const { methods: methods } = vueApp.$options;
    if (!methods) return;
    Object.keys(notifications).forEach((name)=>{
        if (methods[name]) {
            methods[name] = undefined;
            delete methods[name];
        }
    });
    vueApp.$emit("vue-notifications-unlinked");
}
function $0b901d553092e5c6$var$makeMixin() {
    return {
        beforeCreate () {
            const notificationsField = this.$options[$0b901d553092e5c6$var$VueNotifications.propertyName];
            if (notificationsField) $0b901d553092e5c6$var$initVueNotificationPlugin(this, notificationsField);
        },
        beforeDestroy: function() {
            const notificationsField = this.$options[$0b901d553092e5c6$var$VueNotifications.propertyName];
            $0b901d553092e5c6$var$unlinkVueNotificationPlugin(this, notificationsField);
        }
    };
}
if (typeof window !== "undefined" && window.Vue) window.Vue.use($0b901d553092e5c6$var$VueNotifications);
var $0b901d553092e5c6$export$2e2bcd8739ae039 = $0b901d553092e5c6$var$VueNotifications;


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
function $a0ff767aa05ebc8a$var$ei(_) {
    return _ && _.__esModule && Object.prototype.hasOwnProperty.call(_, "default") ? _.default : _;
}
var $a0ff767aa05ebc8a$var$Ue = {
    exports: {}
};
/*!
 * ApexCharts v3.45.2
 * (c) 2018-2024 ApexCharts
 * Released under the MIT License.
 */ (function(_, Re) {
    function Ae(y, e) {
        var t = Object.keys(y);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(y);
            e && (i = i.filter(function(a) {
                return Object.getOwnPropertyDescriptor(y, a).enumerable;
            })), t.push.apply(t, i);
        }
        return t;
    }
    function X(y) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e] != null ? arguments[e] : {};
            e % 2 ? Ae(Object(t), !0).forEach(function(i) {
                ee(y, i, t[i]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(t)) : Ae(Object(t)).forEach(function(i) {
                Object.defineProperty(y, i, Object.getOwnPropertyDescriptor(t, i));
            });
        }
        return y;
    }
    function U(y) {
        return U = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
            return typeof e;
        } : function(e) {
            return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, U(y);
    }
    function F(y, e) {
        if (!(y instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function ce(y, e) {
        for(var t = 0; t < e.length; t++){
            var i = e[t];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(y, i.key, i);
        }
    }
    function Y(y, e, t) {
        return e && ce(y.prototype, e), t && ce(y, t), y;
    }
    function ee(y, e, t) {
        return e in y ? Object.defineProperty(y, e, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : y[e] = t, y;
    }
    function ge(y, e) {
        if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
        y.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: y,
                writable: !0,
                configurable: !0
            }
        }), e && Se(y, e);
    }
    function me(y) {
        return me = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, me(y);
    }
    function Se(y, e) {
        return Se = Object.setPrototypeOf || function(t, i) {
            return t.__proto__ = i, t;
        }, Se(y, e);
    }
    function ze(y) {
        if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return y;
    }
    function ue(y) {
        var e = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch  {
                return !1;
            }
        }();
        return function() {
            var t, i = me(y);
            if (e) {
                var a = me(this).constructor;
                t = Reflect.construct(i, arguments, a);
            } else t = i.apply(this, arguments);
            return function(s, r) {
                if (r && (typeof r == "object" || typeof r == "function")) return r;
                if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                return ze(s);
            }(this, t);
        };
    }
    function Me(y, e) {
        return function(t) {
            if (Array.isArray(t)) return t;
        }(y) || function(t, i) {
            var a = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
            if (a != null) {
                var s, r, n = [], o = !0, h = !1;
                try {
                    for(a = a.call(t); !(o = (s = a.next()).done) && (n.push(s.value), !i || n.length !== i); o = !0);
                } catch (c) {
                    h = !0, r = c;
                } finally{
                    try {
                        o || a.return == null || a.return();
                    } finally{
                        if (h) throw r;
                    }
                }
                return n;
            }
        }(y, e) || Xe(y, e) || function() {
            throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
    }
    function J(y) {
        return function(e) {
            if (Array.isArray(e)) return Ce(e);
        }(y) || function(e) {
            if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
        }(y) || Xe(y) || function() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
    }
    function Xe(y, e) {
        if (y) {
            if (typeof y == "string") return Ce(y, e);
            var t = Object.prototype.toString.call(y).slice(8, -1);
            return t === "Object" && y.constructor && (t = y.constructor.name), t === "Map" || t === "Set" ? Array.from(y) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Ce(y, e) : void 0;
        }
    }
    function Ce(y, e) {
        (e == null || e > y.length) && (e = y.length);
        for(var t = 0, i = new Array(e); t < e; t++)i[t] = y[t];
        return i;
    }
    var P = function() {
        function y() {
            F(this, y);
        }
        return Y(y, [
            {
                key: "shadeRGBColor",
                value: function(e, t) {
                    var i = t.split(","), a = e < 0 ? 0 : 255, s = e < 0 ? -1 * e : e, r = parseInt(i[0].slice(4), 10), n = parseInt(i[1], 10), o = parseInt(i[2], 10);
                    return "rgb(" + (Math.round((a - r) * s) + r) + "," + (Math.round((a - n) * s) + n) + "," + (Math.round((a - o) * s) + o) + ")";
                }
            },
            {
                key: "shadeHexColor",
                value: function(e, t) {
                    var i = parseInt(t.slice(1), 16), a = e < 0 ? 0 : 255, s = e < 0 ? -1 * e : e, r = i >> 16, n = i >> 8 & 255, o = 255 & i;
                    return "#" + (16777216 + 65536 * (Math.round((a - r) * s) + r) + 256 * (Math.round((a - n) * s) + n) + (Math.round((a - o) * s) + o)).toString(16).slice(1);
                }
            },
            {
                key: "shadeColor",
                value: function(e, t) {
                    return y.isColorHex(t) ? this.shadeHexColor(e, t) : this.shadeRGBColor(e, t);
                }
            }
        ], [
            {
                key: "bind",
                value: function(e, t) {
                    return function() {
                        return e.apply(t, arguments);
                    };
                }
            },
            {
                key: "isObject",
                value: function(e) {
                    return e && U(e) === "object" && !Array.isArray(e) && e != null;
                }
            },
            {
                key: "is",
                value: function(e, t) {
                    return Object.prototype.toString.call(t) === "[object " + e + "]";
                }
            },
            {
                key: "listToArray",
                value: function(e) {
                    var t, i = [];
                    for(t = 0; t < e.length; t++)i[t] = e[t];
                    return i;
                }
            },
            {
                key: "extend",
                value: function(e, t) {
                    var i = this;
                    typeof Object.assign != "function" && (Object.assign = function(s) {
                        if (s == null) throw new TypeError("Cannot convert undefined or null to object");
                        for(var r = Object(s), n = 1; n < arguments.length; n++){
                            var o = arguments[n];
                            if (o != null) for(var h in o)o.hasOwnProperty(h) && (r[h] = o[h]);
                        }
                        return r;
                    });
                    var a = Object.assign({}, e);
                    return this.isObject(e) && this.isObject(t) && Object.keys(t).forEach(function(s) {
                        i.isObject(t[s]) && s in e ? a[s] = i.extend(e[s], t[s]) : Object.assign(a, ee({}, s, t[s]));
                    }), a;
                }
            },
            {
                key: "extendArray",
                value: function(e, t) {
                    var i = [];
                    return e.map(function(a) {
                        i.push(y.extend(t, a));
                    }), e = i;
                }
            },
            {
                key: "monthMod",
                value: function(e) {
                    return e % 12;
                }
            },
            {
                key: "clone",
                value: function(e) {
                    if (y.is("Array", e)) {
                        for(var t = [], i = 0; i < e.length; i++)t[i] = this.clone(e[i]);
                        return t;
                    }
                    if (y.is("Null", e)) return null;
                    if (y.is("Date", e)) return e;
                    if (U(e) === "object") {
                        var a = {};
                        for(var s in e)e.hasOwnProperty(s) && (a[s] = this.clone(e[s]));
                        return a;
                    }
                    return e;
                }
            },
            {
                key: "log10",
                value: function(e) {
                    return Math.log(e) / Math.LN10;
                }
            },
            {
                key: "roundToBase10",
                value: function(e) {
                    return Math.pow(10, Math.floor(Math.log10(e)));
                }
            },
            {
                key: "roundToBase",
                value: function(e, t) {
                    return Math.pow(t, Math.floor(Math.log(e) / Math.log(t)));
                }
            },
            {
                key: "parseNumber",
                value: function(e) {
                    return e === null ? e : parseFloat(e);
                }
            },
            {
                key: "stripNumber",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
                    return Number.isInteger(e) ? e : parseFloat(e.toPrecision(t));
                }
            },
            {
                key: "randomId",
                value: function() {
                    return (Math.random() + 1).toString(36).substring(4);
                }
            },
            {
                key: "noExponents",
                value: function(e) {
                    var t = String(e).split(/[eE]/);
                    if (t.length === 1) return t[0];
                    var i = "", a = e < 0 ? "-" : "", s = t[0].replace(".", ""), r = Number(t[1]) + 1;
                    if (r < 0) {
                        for(i = a + "0."; r++;)i += "0";
                        return i + s.replace(/^-/, "");
                    }
                    for(r -= s.length; r--;)i += "0";
                    return s + i;
                }
            },
            {
                key: "getDimensions",
                value: function(e) {
                    var t = getComputedStyle(e, null), i = e.clientHeight, a = e.clientWidth;
                    return i -= parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), [
                        a -= parseFloat(t.paddingLeft) + parseFloat(t.paddingRight),
                        i
                    ];
                }
            },
            {
                key: "getBoundingClientRect",
                value: function(e) {
                    var t = e.getBoundingClientRect();
                    return {
                        top: t.top,
                        right: t.right,
                        bottom: t.bottom,
                        left: t.left,
                        width: e.clientWidth,
                        height: e.clientHeight,
                        x: t.left,
                        y: t.top
                    };
                }
            },
            {
                key: "getLargestStringFromArr",
                value: function(e) {
                    return e.reduce(function(t, i) {
                        return Array.isArray(i) && (i = i.reduce(function(a, s) {
                            return a.length > s.length ? a : s;
                        })), t.length > i.length ? t : i;
                    }, 0);
                }
            },
            {
                key: "hexToRgba",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "#999999", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.6;
                    e.substring(0, 1) !== "#" && (e = "#999999");
                    var i = e.replace("#", "");
                    i = i.match(new RegExp("(.{" + i.length / 3 + "})", "g"));
                    for(var a = 0; a < i.length; a++)i[a] = parseInt(i[a].length === 1 ? i[a] + i[a] : i[a], 16);
                    return t !== void 0 && i.push(t), "rgba(" + i.join(",") + ")";
                }
            },
            {
                key: "getOpacityFromRGBA",
                value: function(e) {
                    return parseFloat(e.replace(/^.*,(.+)\)/, "$1"));
                }
            },
            {
                key: "rgb2hex",
                value: function(e) {
                    return (e = e.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && e.length === 4 ? "#" + ("0" + parseInt(e[1], 10).toString(16)).slice(-2) + ("0" + parseInt(e[2], 10).toString(16)).slice(-2) + ("0" + parseInt(e[3], 10).toString(16)).slice(-2) : "";
                }
            },
            {
                key: "isColorHex",
                value: function(e) {
                    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(e);
                }
            },
            {
                key: "getPolygonPos",
                value: function(e, t) {
                    for(var i = [], a = 2 * Math.PI / t, s = 0; s < t; s++){
                        var r = {};
                        r.x = e * Math.sin(s * a), r.y = -e * Math.cos(s * a), i.push(r);
                    }
                    return i;
                }
            },
            {
                key: "polarToCartesian",
                value: function(e, t, i, a) {
                    var s = (a - 90) * Math.PI / 180;
                    return {
                        x: e + i * Math.cos(s),
                        y: t + i * Math.sin(s)
                    };
                }
            },
            {
                key: "escapeString",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x", i = e.toString().slice();
                    return i = i.replace(/[` ~!@#$%^&*()|+\=?;:'",.<>{}[\]\\/]/gi, t);
                }
            },
            {
                key: "negToZero",
                value: function(e) {
                    return e < 0 ? 0 : e;
                }
            },
            {
                key: "moveIndexInArray",
                value: function(e, t, i) {
                    if (i >= e.length) for(var a = i - e.length + 1; a--;)e.push(void 0);
                    return e.splice(i, 0, e.splice(t, 1)[0]), e;
                }
            },
            {
                key: "extractNumber",
                value: function(e) {
                    return parseFloat(e.replace(/[^\d.]*/g, ""));
                }
            },
            {
                key: "findAncestor",
                value: function(e, t) {
                    for(; (e = e.parentElement) && !e.classList.contains(t););
                    return e;
                }
            },
            {
                key: "setELstyles",
                value: function(e, t) {
                    for(var i in t)t.hasOwnProperty(i) && (e.style.key = t[i]);
                }
            },
            {
                key: "isNumber",
                value: function(e) {
                    return !isNaN(e) && parseFloat(Number(e)) === e && !isNaN(parseInt(e, 10));
                }
            },
            {
                key: "isFloat",
                value: function(e) {
                    return Number(e) === e && e % 1 != 0;
                }
            },
            {
                key: "isSafari",
                value: function() {
                    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                }
            },
            {
                key: "isFirefox",
                value: function() {
                    return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
                }
            },
            {
                key: "isIE11",
                value: function() {
                    if (window.navigator.userAgent.indexOf("MSIE") !== -1 || window.navigator.appVersion.indexOf("Trident/") > -1) return !0;
                }
            },
            {
                key: "isIE",
                value: function() {
                    var e = window.navigator.userAgent, t = e.indexOf("MSIE ");
                    if (t > 0) return parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
                    if (e.indexOf("Trident/") > 0) {
                        var i = e.indexOf("rv:");
                        return parseInt(e.substring(i + 3, e.indexOf(".", i)), 10);
                    }
                    var a = e.indexOf("Edge/");
                    return a > 0 && parseInt(e.substring(a + 5, e.indexOf(".", a)), 10);
                }
            }
        ]), y;
    }(), de = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.setEasingFunctions();
        }
        return Y(y, [
            {
                key: "setEasingFunctions",
                value: function() {
                    var e;
                    if (!this.w.globals.easing) {
                        switch(this.w.config.chart.animations.easing){
                            case "linear":
                                e = "-";
                                break;
                            case "easein":
                                e = "<";
                                break;
                            case "easeout":
                                e = ">";
                                break;
                            case "easeinout":
                            default:
                                e = "<>";
                                break;
                            case "swing":
                                e = function(t) {
                                    var i = 1.70158;
                                    return (t -= 1) * t * ((i + 1) * t + i) + 1;
                                };
                                break;
                            case "bounce":
                                e = function(t) {
                                    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
                                };
                                break;
                            case "elastic":
                                e = function(t) {
                                    return t === !!t ? t : Math.pow(2, -10 * t) * Math.sin((t - 0.075) * (2 * Math.PI) / 0.3) + 1;
                                };
                        }
                        this.w.globals.easing = e;
                    }
                }
            },
            {
                key: "animateLine",
                value: function(e, t, i, a) {
                    e.attr(t).animate(a).attr(i);
                }
            },
            {
                key: "animateMarker",
                value: function(e, t, i, a, s, r) {
                    t || (t = 0), e.attr({
                        r: t,
                        width: t,
                        height: t
                    }).animate(a, s).attr({
                        r: i,
                        width: i.width,
                        height: i.height
                    }).afterAll(function() {
                        r();
                    });
                }
            },
            {
                key: "animateCircle",
                value: function(e, t, i, a, s) {
                    e.attr({
                        r: t.r,
                        cx: t.cx,
                        cy: t.cy
                    }).animate(a, s).attr({
                        r: i.r,
                        cx: i.cx,
                        cy: i.cy
                    });
                }
            },
            {
                key: "animateRect",
                value: function(e, t, i, a, s) {
                    e.attr(t).animate(a).attr(i).afterAll(function() {
                        return s();
                    });
                }
            },
            {
                key: "animatePathsGradually",
                value: function(e) {
                    var t = e.el, i = e.realIndex, a = e.j, s = e.fill, r = e.pathFrom, n = e.pathTo, o = e.speed, h = e.delay, c = this.w, d = 0;
                    c.config.chart.animations.animateGradually.enabled && (d = c.config.chart.animations.animateGradually.delay), c.config.chart.animations.dynamicAnimation.enabled && c.globals.dataChanged && c.config.chart.type !== "bar" && (d = 0), this.morphSVG(t, i, a, c.config.chart.type !== "line" || c.globals.comboCharts ? s : "stroke", r, n, o, h * d);
                }
            },
            {
                key: "showDelayedElements",
                value: function() {
                    this.w.globals.delayedElements.forEach(function(e) {
                        var t = e.el;
                        t.classList.remove("apexcharts-element-hidden"), t.classList.add("apexcharts-hidden-element-shown");
                    });
                }
            },
            {
                key: "animationCompleted",
                value: function(e) {
                    var t = this.w;
                    t.globals.animationEnded || (t.globals.animationEnded = !0, this.showDelayedElements(), typeof t.config.chart.events.animationEnd == "function" && t.config.chart.events.animationEnd(this.ctx, {
                        el: e,
                        w: t
                    }));
                }
            },
            {
                key: "morphSVG",
                value: function(e, t, i, a, s, r, n, o) {
                    var h = this, c = this.w;
                    s || (s = e.attr("pathFrom")), r || (r = e.attr("pathTo"));
                    var d = function(g) {
                        return c.config.chart.type === "radar" && (n = 1), "M 0 ".concat(c.globals.gridHeight);
                    };
                    (!s || s.indexOf("undefined") > -1 || s.indexOf("NaN") > -1) && (s = d()), (!r || r.indexOf("undefined") > -1 || r.indexOf("NaN") > -1) && (r = d()), c.globals.shouldAnimate || (n = 1), e.plot(s).animate(1, c.globals.easing, o).plot(s).animate(n, c.globals.easing, o).plot(r).afterAll(function() {
                        P.isNumber(i) ? i === c.globals.series[c.globals.maxValsInArrayIndex].length - 2 && c.globals.shouldAnimate && h.animationCompleted(e) : a !== "none" && c.globals.shouldAnimate && (!c.globals.comboCharts && t === c.globals.series.length - 1 || c.globals.comboCharts) && h.animationCompleted(e), h.showDelayedElements();
                    });
                }
            }
        ]), y;
    }(), Z = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "getDefaultFilter",
                value: function(e, t) {
                    var i = this.w;
                    e.unfilter(!0), new window.SVG.Filter().size("120%", "180%", "-5%", "-40%"), i.config.states.normal.filter !== "none" ? this.applyFilter(e, t, i.config.states.normal.filter.type, i.config.states.normal.filter.value) : i.config.chart.dropShadow.enabled && this.dropShadow(e, i.config.chart.dropShadow, t);
                }
            },
            {
                key: "addNormalFilter",
                value: function(e, t) {
                    var i = this.w;
                    i.config.chart.dropShadow.enabled && !e.node.classList.contains("apexcharts-marker") && this.dropShadow(e, i.config.chart.dropShadow, t);
                }
            },
            {
                key: "addLightenFilter",
                value: function(e, t, i) {
                    var a = this, s = this.w, r = i.intensity;
                    e.unfilter(!0), new window.SVG.Filter(), e.filter(function(n) {
                        var o = s.config.chart.dropShadow;
                        (o.enabled ? a.addShadow(n, t, o) : n).componentTransfer({
                            rgb: {
                                type: "linear",
                                slope: 1.5,
                                intercept: r
                            }
                        });
                    }), e.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(e.filterer.node);
                }
            },
            {
                key: "addDarkenFilter",
                value: function(e, t, i) {
                    var a = this, s = this.w, r = i.intensity;
                    e.unfilter(!0), new window.SVG.Filter(), e.filter(function(n) {
                        var o = s.config.chart.dropShadow;
                        (o.enabled ? a.addShadow(n, t, o) : n).componentTransfer({
                            rgb: {
                                type: "linear",
                                slope: r
                            }
                        });
                    }), e.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(e.filterer.node);
                }
            },
            {
                key: "applyFilter",
                value: function(e, t, i) {
                    var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
                    switch(i){
                        case "none":
                            this.addNormalFilter(e, t);
                            break;
                        case "lighten":
                            this.addLightenFilter(e, t, {
                                intensity: a
                            });
                            break;
                        case "darken":
                            this.addDarkenFilter(e, t, {
                                intensity: a
                            });
                    }
                }
            },
            {
                key: "addShadow",
                value: function(e, t, i) {
                    var a = i.blur, s = i.top, r = i.left, n = i.color, o = i.opacity, h = e.flood(Array.isArray(n) ? n[t] : n, o).composite(e.sourceAlpha, "in").offset(r, s).gaussianBlur(a).merge(e.source);
                    return e.blend(e.source, h);
                }
            },
            {
                key: "dropShadow",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = t.top, s = t.left, r = t.blur, n = t.color, o = t.opacity, h = t.noUserSpaceOnUse, c = this.w;
                    return e.unfilter(!0), P.isIE() && c.config.chart.type === "radialBar" || (n = Array.isArray(n) ? n[i] : n, e.filter(function(d) {
                        var g = null;
                        g = P.isSafari() || P.isFirefox() || P.isIE() ? d.flood(n, o).composite(d.sourceAlpha, "in").offset(s, a).gaussianBlur(r) : d.flood(n, o).composite(d.sourceAlpha, "in").offset(s, a).gaussianBlur(r).merge(d.source), d.blend(d.source, g);
                    }), h || e.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(e.filterer.node)), e;
                }
            },
            {
                key: "setSelectionFilter",
                value: function(e, t, i) {
                    var a = this.w;
                    if (a.globals.selectedDataPoints[t] !== void 0 && a.globals.selectedDataPoints[t].indexOf(i) > -1) {
                        e.node.setAttribute("selected", !0);
                        var s = a.config.states.active.filter;
                        s !== "none" && this.applyFilter(e, t, s.type, s.value);
                    }
                }
            },
            {
                key: "_scaleFilterSize",
                value: function(e) {
                    (function(t) {
                        for(var i in t)t.hasOwnProperty(i) && e.setAttribute(i, t[i]);
                    })({
                        width: "200%",
                        height: "200%",
                        x: "-50%",
                        y: "-50%"
                    });
                }
            }
        ]), y;
    }(), M = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "roundPathCorners",
                value: function(e, t) {
                    function i(S, C, L) {
                        var I = C.x - S.x, z = C.y - S.y, T = Math.sqrt(I * I + z * z);
                        return a(S, C, Math.min(1, L / T));
                    }
                    function a(S, C, L) {
                        return {
                            x: S.x + (C.x - S.x) * L,
                            y: S.y + (C.y - S.y) * L
                        };
                    }
                    function s(S, C) {
                        S.length > 2 && (S[S.length - 2] = C.x, S[S.length - 1] = C.y);
                    }
                    function r(S) {
                        return {
                            x: parseFloat(S[S.length - 2]),
                            y: parseFloat(S[S.length - 1])
                        };
                    }
                    e.indexOf("NaN") > -1 && (e = "");
                    var n = e.split(/[,\s]/).reduce(function(S, C) {
                        var L = C.match("([a-zA-Z])(.+)");
                        return L ? (S.push(L[1]), S.push(L[2])) : S.push(C), S;
                    }, []).reduce(function(S, C) {
                        return parseFloat(C) == C && S.length ? S[S.length - 1].push(C) : S.push([
                            C
                        ]), S;
                    }, []), o = [];
                    if (n.length > 1) {
                        var h = r(n[0]), c = null;
                        n[n.length - 1][0] == "Z" && n[0].length > 2 && (c = [
                            "L",
                            h.x,
                            h.y
                        ], n[n.length - 1] = c), o.push(n[0]);
                        for(var d = 1; d < n.length; d++){
                            var g = o[o.length - 1], p = n[d], f = p == c ? n[1] : n[d + 1];
                            if (f && g && g.length > 2 && p[0] == "L" && f.length > 2 && f[0] == "L") {
                                var b, m, w = r(g), A = r(p), l = r(f);
                                b = i(A, w, t), m = i(A, l, t), s(p, b), p.origPoint = A, o.push(p);
                                var u = a(b, A, 0.5), x = a(A, m, 0.5), v = [
                                    "C",
                                    u.x,
                                    u.y,
                                    x.x,
                                    x.y,
                                    m.x,
                                    m.y
                                ];
                                v.origPoint = A, o.push(v);
                            } else o.push(p);
                        }
                        if (c) {
                            var k = r(o[o.length - 1]);
                            o.push([
                                "Z"
                            ]), s(o[0], k);
                        }
                    } else o = n;
                    return o.reduce(function(S, C) {
                        return S + C.join(" ") + " ";
                    }, "");
                }
            },
            {
                key: "drawLine",
                value: function(e, t, i, a) {
                    var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "#a8a8a8", r = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, o = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "butt";
                    return this.w.globals.dom.Paper.line().attr({
                        x1: e,
                        y1: t,
                        x2: i,
                        y2: a,
                        stroke: s,
                        "stroke-dasharray": r,
                        "stroke-width": n,
                        "stroke-linecap": o
                    });
                }
            },
            {
                key: "drawRect",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, r = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "#fefefe", n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1, o = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, h = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : null, c = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : 0, d = this.w.globals.dom.Paper.rect();
                    return d.attr({
                        x: e,
                        y: t,
                        width: i > 0 ? i : 0,
                        height: a > 0 ? a : 0,
                        rx: s,
                        ry: s,
                        opacity: n,
                        "stroke-width": o !== null ? o : 0,
                        stroke: h !== null ? h : "none",
                        "stroke-dasharray": c
                    }), d.node.setAttribute("fill", r), d;
                }
            },
            {
                key: "drawPolygon",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "#e1e1e1", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "none";
                    return this.w.globals.dom.Paper.polygon(e).attr({
                        fill: a,
                        stroke: t,
                        "stroke-width": i
                    });
                }
            },
            {
                key: "drawCircle",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                    e < 0 && (e = 0);
                    var i = this.w.globals.dom.Paper.circle(2 * e);
                    return t !== null && i.attr(t), i;
                }
            },
            {
                key: "drawPath",
                value: function(e) {
                    var t = e.d, i = t === void 0 ? "" : t, a = e.stroke, s = a === void 0 ? "#a8a8a8" : a, r = e.strokeWidth, n = r === void 0 ? 1 : r, o = e.fill, h = e.fillOpacity, c = h === void 0 ? 1 : h, d = e.strokeOpacity, g = d === void 0 ? 1 : d, p = e.classes, f = e.strokeLinecap, b = f === void 0 ? null : f, m = e.strokeDashArray, w = m === void 0 ? 0 : m, A = this.w;
                    return b === null && (b = A.config.stroke.lineCap), (i.indexOf("undefined") > -1 || i.indexOf("NaN") > -1) && (i = "M 0 ".concat(A.globals.gridHeight)), A.globals.dom.Paper.path(i).attr({
                        fill: o,
                        "fill-opacity": c,
                        stroke: s,
                        "stroke-opacity": g,
                        "stroke-linecap": b,
                        "stroke-width": n,
                        "stroke-dasharray": w,
                        class: p
                    });
                }
            },
            {
                key: "group",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, t = this.w.globals.dom.Paper.group();
                    return e !== null && t.attr(e), t;
                }
            },
            {
                key: "move",
                value: function(e, t) {
                    var i = [
                        "M",
                        e,
                        t
                    ].join(" ");
                    return i;
                }
            },
            {
                key: "line",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, a = null;
                    return i === null ? a = [
                        " L",
                        e,
                        t
                    ].join(" ") : i === "H" ? a = [
                        " H",
                        e
                    ].join(" ") : i === "V" && (a = [
                        " V",
                        t
                    ].join(" ")), a;
                }
            },
            {
                key: "curve",
                value: function(e, t, i, a, s, r) {
                    var n = [
                        "C",
                        e,
                        t,
                        i,
                        a,
                        s,
                        r
                    ].join(" ");
                    return n;
                }
            },
            {
                key: "quadraticCurve",
                value: function(e, t, i, a) {
                    return [
                        "Q",
                        e,
                        t,
                        i,
                        a
                    ].join(" ");
                }
            },
            {
                key: "arc",
                value: function(e, t, i, a, s, r, n) {
                    var o = "A";
                    arguments.length > 7 && arguments[7] !== void 0 && arguments[7] && (o = "a");
                    var h = [
                        o,
                        e,
                        t,
                        i,
                        a,
                        s,
                        r,
                        n
                    ].join(" ");
                    return h;
                }
            },
            {
                key: "renderPaths",
                value: function(e) {
                    var t, i = e.j, a = e.realIndex, s = e.pathFrom, r = e.pathTo, n = e.stroke, o = e.strokeWidth, h = e.strokeLinecap, c = e.fill, d = e.animationDelay, g = e.initialSpeed, p = e.dataChangeSpeed, f = e.className, b = e.shouldClipToGrid, m = b === void 0 || b, w = e.bindEventsOnPaths, A = w === void 0 || w, l = e.drawShadow, u = l === void 0 || l, x = this.w, v = new Z(this.ctx), k = new de(this.ctx), S = this.w.config.chart.animations.enabled, C = S && this.w.config.chart.animations.dynamicAnimation.enabled, L = !!(S && !x.globals.resized || C && x.globals.dataChanged && x.globals.shouldAnimate);
                    L ? t = s : (t = r, x.globals.animationEnded = !0);
                    var I = x.config.stroke.dashArray, z = 0;
                    z = Array.isArray(I) ? I[a] : x.config.stroke.dashArray;
                    var T = this.drawPath({
                        d: t,
                        stroke: n,
                        strokeWidth: o,
                        fill: c,
                        fillOpacity: 1,
                        classes: f,
                        strokeLinecap: h,
                        strokeDashArray: z
                    });
                    if (T.attr("index", a), m && T.attr({
                        "clip-path": "url(#gridRectMask".concat(x.globals.cuid, ")")
                    }), x.config.states.normal.filter.type !== "none") v.getDefaultFilter(T, a);
                    else if (x.config.chart.dropShadow.enabled && u && (!x.config.chart.dropShadow.enabledOnSeries || x.config.chart.dropShadow.enabledOnSeries && x.config.chart.dropShadow.enabledOnSeries.indexOf(a) !== -1)) {
                        var E = x.config.chart.dropShadow;
                        v.dropShadow(T, E, a);
                    }
                    A && (T.node.addEventListener("mouseenter", this.pathMouseEnter.bind(this, T)), T.node.addEventListener("mouseleave", this.pathMouseLeave.bind(this, T)), T.node.addEventListener("mousedown", this.pathMouseDown.bind(this, T))), T.attr({
                        pathTo: r,
                        pathFrom: s
                    });
                    var R = {
                        el: T,
                        j: i,
                        realIndex: a,
                        pathFrom: s,
                        pathTo: r,
                        fill: c,
                        strokeWidth: o,
                        delay: d
                    };
                    return !S || x.globals.resized || x.globals.dataChanged ? !x.globals.resized && x.globals.dataChanged || k.showDelayedElements() : k.animatePathsGradually(X(X({}, R), {}, {
                        speed: g
                    })), x.globals.dataChanged && C && L && k.animatePathsGradually(X(X({}, R), {}, {
                        speed: p
                    })), T;
                }
            },
            {
                key: "drawPattern",
                value: function(e, t, i) {
                    var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "#a8a8a8", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
                    return this.w.globals.dom.Paper.pattern(t, i, function(r) {
                        e === "horizontalLines" ? r.line(0, 0, i, 0).stroke({
                            color: a,
                            width: s + 1
                        }) : e === "verticalLines" ? r.line(0, 0, 0, t).stroke({
                            color: a,
                            width: s + 1
                        }) : e === "slantedLines" ? r.line(0, 0, t, i).stroke({
                            color: a,
                            width: s
                        }) : e === "squares" ? r.rect(t, i).fill("none").stroke({
                            color: a,
                            width: s
                        }) : e === "circles" && r.circle(t).fill("none").stroke({
                            color: a,
                            width: s
                        });
                    });
                }
            },
            {
                key: "drawGradient",
                value: function(e, t, i, a, s) {
                    var r, n = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, h = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, c = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0, d = this.w;
                    t.length < 9 && t.indexOf("#") === 0 && (t = P.hexToRgba(t, a)), i.length < 9 && i.indexOf("#") === 0 && (i = P.hexToRgba(i, s));
                    var g = 0, p = 1, f = 1, b = null;
                    o !== null && (g = o[0] !== void 0 ? o[0] / 100 : 0, p = o[1] !== void 0 ? o[1] / 100 : 1, f = o[2] !== void 0 ? o[2] / 100 : 1, b = o[3] !== void 0 ? o[3] / 100 : null);
                    var m = !(d.config.chart.type !== "donut" && d.config.chart.type !== "pie" && d.config.chart.type !== "polarArea" && d.config.chart.type !== "bubble");
                    if (r = h === null || h.length === 0 ? d.globals.dom.Paper.gradient(m ? "radial" : "linear", function(l) {
                        l.at(g, t, a), l.at(p, i, s), l.at(f, i, s), b !== null && l.at(b, t, a);
                    }) : d.globals.dom.Paper.gradient(m ? "radial" : "linear", function(l) {
                        (Array.isArray(h[c]) ? h[c] : h).forEach(function(u) {
                            l.at(u.offset / 100, u.color, u.opacity);
                        });
                    }), m) {
                        var w = d.globals.gridWidth / 2, A = d.globals.gridHeight / 2;
                        d.config.chart.type !== "bubble" ? r.attr({
                            gradientUnits: "userSpaceOnUse",
                            cx: w,
                            cy: A,
                            r: n
                        }) : r.attr({
                            cx: 0.5,
                            cy: 0.5,
                            r: 0.8,
                            fx: 0.2,
                            fy: 0.2
                        });
                    } else e === "vertical" ? r.from(0, 0).to(0, 1) : e === "diagonal" ? r.from(0, 0).to(1, 1) : e === "horizontal" ? r.from(0, 1).to(1, 1) : e === "diagonal2" && r.from(1, 0).to(0, 1);
                    return r;
                }
            },
            {
                key: "getTextBasedOnMaxWidth",
                value: function(e) {
                    var t = e.text, i = e.maxWidth, a = e.fontSize, s = e.fontFamily, r = this.getTextRects(t, a, s), n = r.width / t.length, o = Math.floor(i / n);
                    return i < r.width ? t.slice(0, o - 3) + "..." : t;
                }
            },
            {
                key: "drawText",
                value: function(e) {
                    var t = this, i = e.x, a = e.y, s = e.text, r = e.textAnchor, n = e.fontSize, o = e.fontFamily, h = e.fontWeight, c = e.foreColor, d = e.opacity, g = e.maxWidth, p = e.cssClass, f = p === void 0 ? "" : p, b = e.isPlainText, m = b === void 0 || b, w = e.dominantBaseline, A = w === void 0 ? "auto" : w, l = this.w;
                    s === void 0 && (s = "");
                    var u = s;
                    r || (r = "start"), c && c.length || (c = l.config.chart.foreColor), o = o || l.config.chart.fontFamily, h = h || "regular";
                    var x, v = {
                        maxWidth: g,
                        fontSize: n = n || "11px",
                        fontFamily: o
                    };
                    return Array.isArray(s) ? x = l.globals.dom.Paper.text(function(k) {
                        for(var S = 0; S < s.length; S++)u = s[S], g && (u = t.getTextBasedOnMaxWidth(X({
                            text: s[S]
                        }, v))), S === 0 ? k.tspan(u) : k.tspan(u).newLine();
                    }) : (g && (u = this.getTextBasedOnMaxWidth(X({
                        text: s
                    }, v))), x = m ? l.globals.dom.Paper.plain(s) : l.globals.dom.Paper.text(function(k) {
                        return k.tspan(u);
                    })), x.attr({
                        x: i,
                        y: a,
                        "text-anchor": r,
                        "dominant-baseline": A,
                        "font-size": n,
                        "font-family": o,
                        "font-weight": h,
                        fill: c,
                        class: "apexcharts-text " + f
                    }), x.node.style.fontFamily = o, x.node.style.opacity = d, x;
                }
            },
            {
                key: "drawMarker",
                value: function(e, t, i) {
                    e = e || 0;
                    var a = i.pSize || 0, s = null;
                    if (i.shape === "square" || i.shape === "rect") {
                        var r = i.pRadius === void 0 ? a / 2 : i.pRadius;
                        t !== null && a || (a = 0, r = 0);
                        var n = 1.2 * a + r, o = this.drawRect(n, n, n, n, r);
                        o.attr({
                            x: e - n / 2,
                            y: t - n / 2,
                            cx: e,
                            cy: t,
                            class: i.class ? i.class : "",
                            fill: i.pointFillColor,
                            "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                            stroke: i.pointStrokeColor,
                            "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                            "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                        }), s = o;
                    } else i.shape !== "circle" && i.shape || (P.isNumber(t) || (a = 0, t = 0), s = this.drawCircle(a, {
                        cx: e,
                        cy: t,
                        class: i.class ? i.class : "",
                        stroke: i.pointStrokeColor,
                        fill: i.pointFillColor,
                        "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                        "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                        "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                    }));
                    return s;
                }
            },
            {
                key: "pathMouseEnter",
                value: function(e, t) {
                    var i = this.w, a = new Z(this.ctx), s = parseInt(e.node.getAttribute("index"), 10), r = parseInt(e.node.getAttribute("j"), 10);
                    if (typeof i.config.chart.events.dataPointMouseEnter == "function" && i.config.chart.events.dataPointMouseEnter(t, this.ctx, {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }), this.ctx.events.fireEvent("dataPointMouseEnter", [
                        t,
                        this.ctx,
                        {
                            seriesIndex: s,
                            dataPointIndex: r,
                            w: i
                        }
                    ]), (i.config.states.active.filter.type === "none" || e.node.getAttribute("selected") !== "true") && i.config.states.hover.filter.type !== "none" && !i.globals.isTouchDevice) {
                        var n = i.config.states.hover.filter;
                        a.applyFilter(e, s, n.type, n.value);
                    }
                }
            },
            {
                key: "pathMouseLeave",
                value: function(e, t) {
                    var i = this.w, a = new Z(this.ctx), s = parseInt(e.node.getAttribute("index"), 10), r = parseInt(e.node.getAttribute("j"), 10);
                    typeof i.config.chart.events.dataPointMouseLeave == "function" && i.config.chart.events.dataPointMouseLeave(t, this.ctx, {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }), this.ctx.events.fireEvent("dataPointMouseLeave", [
                        t,
                        this.ctx,
                        {
                            seriesIndex: s,
                            dataPointIndex: r,
                            w: i
                        }
                    ]), i.config.states.active.filter.type !== "none" && e.node.getAttribute("selected") === "true" || i.config.states.hover.filter.type !== "none" && a.getDefaultFilter(e, s);
                }
            },
            {
                key: "pathMouseDown",
                value: function(e, t) {
                    var i = this.w, a = new Z(this.ctx), s = parseInt(e.node.getAttribute("index"), 10), r = parseInt(e.node.getAttribute("j"), 10), n = "false";
                    if (e.node.getAttribute("selected") === "true") {
                        if (e.node.setAttribute("selected", "false"), i.globals.selectedDataPoints[s].indexOf(r) > -1) {
                            var o = i.globals.selectedDataPoints[s].indexOf(r);
                            i.globals.selectedDataPoints[s].splice(o, 1);
                        }
                    } else {
                        if (!i.config.states.active.allowMultipleDataPointsSelection && i.globals.selectedDataPoints.length > 0) {
                            i.globals.selectedDataPoints = [];
                            var h = i.globals.dom.Paper.select(".apexcharts-series path").members, c = i.globals.dom.Paper.select(".apexcharts-series circle, .apexcharts-series rect").members, d = function(f) {
                                Array.prototype.forEach.call(f, function(b) {
                                    b.node.setAttribute("selected", "false"), a.getDefaultFilter(b, s);
                                });
                            };
                            d(h), d(c);
                        }
                        e.node.setAttribute("selected", "true"), n = "true", i.globals.selectedDataPoints[s] === void 0 && (i.globals.selectedDataPoints[s] = []), i.globals.selectedDataPoints[s].push(r);
                    }
                    if (n === "true") {
                        var g = i.config.states.active.filter;
                        if (g !== "none") a.applyFilter(e, s, g.type, g.value);
                        else if (i.config.states.hover.filter !== "none" && !i.globals.isTouchDevice) {
                            var p = i.config.states.hover.filter;
                            a.applyFilter(e, s, p.type, p.value);
                        }
                    } else i.config.states.active.filter.type !== "none" && (i.config.states.hover.filter.type === "none" || i.globals.isTouchDevice ? a.getDefaultFilter(e, s) : (p = i.config.states.hover.filter, a.applyFilter(e, s, p.type, p.value)));
                    typeof i.config.chart.events.dataPointSelection == "function" && i.config.chart.events.dataPointSelection(t, this.ctx, {
                        selectedDataPoints: i.globals.selectedDataPoints,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }), t && this.ctx.events.fireEvent("dataPointSelection", [
                        t,
                        this.ctx,
                        {
                            selectedDataPoints: i.globals.selectedDataPoints,
                            seriesIndex: s,
                            dataPointIndex: r,
                            w: i
                        }
                    ]);
                }
            },
            {
                key: "rotateAroundCenter",
                value: function(e) {
                    var t = {};
                    return e && typeof e.getBBox == "function" && (t = e.getBBox()), {
                        x: t.x + t.width / 2,
                        y: t.y + t.height / 2
                    };
                }
            },
            {
                key: "getTextRects",
                value: function(e, t, i, a) {
                    var s = !(arguments.length > 4 && arguments[4] !== void 0) || arguments[4], r = this.w, n = this.drawText({
                        x: -200,
                        y: -200,
                        text: e,
                        textAnchor: "start",
                        fontSize: t,
                        fontFamily: i,
                        foreColor: "#fff",
                        opacity: 0
                    });
                    a && n.attr("transform", a), r.globals.dom.Paper.add(n);
                    var o = n.bbox();
                    return s || (o = n.node.getBoundingClientRect()), n.remove(), {
                        width: o.width,
                        height: o.height
                    };
                }
            },
            {
                key: "placeTextWithEllipsis",
                value: function(e, t, i) {
                    if (typeof e.getComputedTextLength == "function" && (e.textContent = t, t.length > 0 && e.getComputedTextLength() >= i / 1.1)) {
                        for(var a = t.length - 3; a > 0; a -= 3)if (e.getSubStringLength(0, a) <= i / 1.1) return void (e.textContent = t.substring(0, a) + "...");
                        e.textContent = ".";
                    }
                }
            }
        ], [
            {
                key: "setAttrs",
                value: function(e, t) {
                    for(var i in t)t.hasOwnProperty(i) && e.setAttribute(i, t[i]);
                }
            }
        ]), y;
    }(), q = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "getStackedSeriesTotals",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = this.w, i = [];
                    if (t.globals.series.length === 0) return i;
                    for(var a = 0; a < t.globals.series[t.globals.maxValsInArrayIndex].length; a++){
                        for(var s = 0, r = 0; r < t.globals.series.length; r++)t.globals.series[r][a] !== void 0 && e.indexOf(r) === -1 && (s += t.globals.series[r][a]);
                        i.push(s);
                    }
                    return i;
                }
            },
            {
                key: "getSeriesTotalByIndex",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                    return e === null ? this.w.config.series.reduce(function(t, i) {
                        return t + i;
                    }, 0) : this.w.globals.series[e].reduce(function(t, i) {
                        return t + i;
                    }, 0);
                }
            },
            {
                key: "getStackedSeriesTotalsByGroups",
                value: function() {
                    var e = this, t = this.w, i = [];
                    return t.globals.seriesGroups.forEach(function(a) {
                        var s = [];
                        t.config.series.forEach(function(n, o) {
                            a.indexOf(n.name) > -1 && s.push(o);
                        });
                        var r = t.globals.series.map(function(n, o) {
                            return s.indexOf(o) === -1 ? o : -1;
                        }).filter(function(n) {
                            return n !== -1;
                        });
                        i.push(e.getStackedSeriesTotals(r));
                    }), i;
                }
            },
            {
                key: "isSeriesNull",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                    return (e === null ? this.w.config.series.filter(function(t) {
                        return t !== null;
                    }) : this.w.config.series[e].data.filter(function(t) {
                        return t !== null;
                    })).length === 0;
                }
            },
            {
                key: "seriesHaveSameValues",
                value: function(e) {
                    return this.w.globals.series[e].every(function(t, i, a) {
                        return t === a[0];
                    });
                }
            },
            {
                key: "getCategoryLabels",
                value: function(e) {
                    var t = this.w, i = e.slice();
                    return t.config.xaxis.convertedCatToNumeric && (i = e.map(function(a, s) {
                        return t.config.xaxis.labels.formatter(a - t.globals.minX + 1);
                    })), i;
                }
            },
            {
                key: "getLargestSeries",
                value: function() {
                    var e = this.w;
                    e.globals.maxValsInArrayIndex = e.globals.series.map(function(t) {
                        return t.length;
                    }).indexOf(Math.max.apply(Math, e.globals.series.map(function(t) {
                        return t.length;
                    })));
                }
            },
            {
                key: "getLargestMarkerSize",
                value: function() {
                    var e = this.w, t = 0;
                    return e.globals.markers.size.forEach(function(i) {
                        t = Math.max(t, i);
                    }), e.config.markers.discrete && e.config.markers.discrete.length && e.config.markers.discrete.forEach(function(i) {
                        t = Math.max(t, i.size);
                    }), t > 0 && (t += e.config.markers.hover.sizeOffset + 1), e.globals.markers.largestSize = t, t;
                }
            },
            {
                key: "getSeriesTotals",
                value: function() {
                    var e = this.w;
                    e.globals.seriesTotals = e.globals.series.map(function(t, i) {
                        var a = 0;
                        if (Array.isArray(t)) for(var s = 0; s < t.length; s++)a += t[s];
                        else a += t;
                        return a;
                    });
                }
            },
            {
                key: "getSeriesTotalsXRange",
                value: function(e, t) {
                    var i = this.w;
                    return i.globals.series.map(function(a, s) {
                        for(var r = 0, n = 0; n < a.length; n++)i.globals.seriesX[s][n] > e && i.globals.seriesX[s][n] < t && (r += a[n]);
                        return r;
                    });
                }
            },
            {
                key: "getPercentSeries",
                value: function() {
                    var e = this.w;
                    e.globals.seriesPercent = e.globals.series.map(function(t, i) {
                        var a = [];
                        if (Array.isArray(t)) for(var s = 0; s < t.length; s++){
                            var r = e.globals.stackedSeriesTotals[s], n = 0;
                            r && (n = 100 * t[s] / r), a.push(n);
                        }
                        else {
                            var o = 100 * t / e.globals.seriesTotals.reduce(function(h, c) {
                                return h + c;
                            }, 0);
                            a.push(o);
                        }
                        return a;
                    });
                }
            },
            {
                key: "getCalculatedRatios",
                value: function() {
                    var e, t, i, a = this.w.globals, s = [], r = 0, n = [], o = 0.1, h = 0;
                    if (a.yRange = [], a.isMultipleYAxis) for(var c = 0; c < a.minYArr.length; c++)a.yRange.push(Math.abs(a.minYArr[c] - a.maxYArr[c])), n.push(0);
                    else a.yRange.push(Math.abs(a.minY - a.maxY));
                    a.xRange = Math.abs(a.maxX - a.minX), a.zRange = Math.abs(a.maxZ - a.minZ);
                    for(var d = 0; d < a.yRange.length; d++)s.push(a.yRange[d] / a.gridHeight);
                    if (t = a.xRange / a.gridWidth, e = a.yRange / a.gridWidth, i = a.xRange / a.gridHeight, (r = a.zRange / a.gridHeight * 16) || (r = 1), a.minY !== Number.MIN_VALUE && Math.abs(a.minY) !== 0 && (a.hasNegs = !0), a.isMultipleYAxis) {
                        n = [];
                        for(var g = 0; g < s.length; g++)n.push(-a.minYArr[g] / s[g]);
                    } else n.push(-a.minY / s[0]), a.minY !== Number.MIN_VALUE && Math.abs(a.minY) !== 0 && (o = -a.minY / e, h = a.minX / t);
                    return {
                        yRatio: s,
                        invertedYRatio: e,
                        zRatio: r,
                        xRatio: t,
                        invertedXRatio: i,
                        baseLineInvertedY: o,
                        baseLineY: n,
                        baseLineX: h
                    };
                }
            },
            {
                key: "getLogSeries",
                value: function(e) {
                    var t = this, i = this.w;
                    return i.globals.seriesLog = e.map(function(a, s) {
                        return i.config.yaxis[s] && i.config.yaxis[s].logarithmic ? a.map(function(r) {
                            return r === null ? null : t.getLogVal(i.config.yaxis[s].logBase, r, s);
                        }) : a;
                    }), i.globals.invalidLogScale ? e : i.globals.seriesLog;
                }
            },
            {
                key: "getBaseLog",
                value: function(e, t) {
                    return Math.log(t) / Math.log(e);
                }
            },
            {
                key: "getLogVal",
                value: function(e, t, i) {
                    if (t === 0) return 0;
                    var a = this.w, s = a.globals.minYArr[i] === 0 ? -1 : this.getBaseLog(e, a.globals.minYArr[i]), r = (a.globals.maxYArr[i] === 0 ? 0 : this.getBaseLog(e, a.globals.maxYArr[i])) - s;
                    return t < 1 ? t / r : (this.getBaseLog(e, t) - s) / r;
                }
            },
            {
                key: "getLogYRatios",
                value: function(e) {
                    var t = this, i = this.w, a = this.w.globals;
                    return a.yLogRatio = e.slice(), a.logYRange = a.yRange.map(function(s, r) {
                        if (i.config.yaxis[r] && t.w.config.yaxis[r].logarithmic) {
                            var n, o = -Number.MAX_VALUE, h = Number.MIN_VALUE;
                            return a.seriesLog.forEach(function(c, d) {
                                c.forEach(function(g) {
                                    i.config.yaxis[d] && i.config.yaxis[d].logarithmic && (o = Math.max(g, o), h = Math.min(g, h));
                                });
                            }), n = Math.pow(a.yRange[r], Math.abs(h - o) / a.yRange[r]), a.yLogRatio[r] = n / a.gridHeight, n;
                        }
                    }), a.invalidLogScale ? e.slice() : a.yLogRatio;
                }
            }
        ], [
            {
                key: "checkComboSeries",
                value: function(e) {
                    var t = !1, i = 0, a = 0;
                    return e.length && e[0].type !== void 0 && e.forEach(function(s) {
                        s.type !== "bar" && s.type !== "column" && s.type !== "candlestick" && s.type !== "boxPlot" || i++, s.type !== void 0 && a++;
                    }), a > 0 && (t = !0), {
                        comboBarCount: i,
                        comboCharts: t
                    };
                }
            },
            {
                key: "extendArrayProps",
                value: function(e, t, i) {
                    return t.yaxis && (t = e.extendYAxis(t, i)), t.annotations && (t.annotations.yaxis && (t = e.extendYAxisAnnotations(t)), t.annotations.xaxis && (t = e.extendXAxisAnnotations(t)), t.annotations.points && (t = e.extendPointAnnotations(t))), t;
                }
            }
        ]), y;
    }(), ve = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.annoCtx = e;
        }
        return Y(y, [
            {
                key: "setOrientations",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, i = this.w;
                    if (e.label.orientation === "vertical") {
                        var a = t !== null ? t : 0, s = i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(a, "']"));
                        if (s !== null) {
                            var r = s.getBoundingClientRect();
                            s.setAttribute("x", parseFloat(s.getAttribute("x")) - r.height + 4), e.label.position === "top" ? s.setAttribute("y", parseFloat(s.getAttribute("y")) + r.width) : s.setAttribute("y", parseFloat(s.getAttribute("y")) - r.width);
                            var n = this.annoCtx.graphics.rotateAroundCenter(s), o = n.x, h = n.y;
                            s.setAttribute("transform", "rotate(-90 ".concat(o, " ").concat(h, ")"));
                        }
                    }
                }
            },
            {
                key: "addBackgroundToAnno",
                value: function(e, t) {
                    var i = this.w;
                    if (!e || t.label.text === void 0 || t.label.text !== void 0 && !String(t.label.text).trim()) return null;
                    var a = i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(), s = e.getBoundingClientRect(), r = t.label.style.padding.left, n = t.label.style.padding.right, o = t.label.style.padding.top, h = t.label.style.padding.bottom;
                    t.label.orientation === "vertical" && (o = t.label.style.padding.left, h = t.label.style.padding.right, r = t.label.style.padding.top, n = t.label.style.padding.bottom);
                    var c = s.left - a.left - r, d = s.top - a.top - o, g = this.annoCtx.graphics.drawRect(c - i.globals.barPadForNumericAxis, d, s.width + r + n, s.height + o + h, t.label.borderRadius, t.label.style.background, 1, t.label.borderWidth, t.label.borderColor, 0);
                    return t.id && g.node.classList.add(t.id), g;
                }
            },
            {
                key: "annotationsBackground",
                value: function() {
                    var e = this, t = this.w, i = function(a, s, r) {
                        var n = t.globals.dom.baseEl.querySelector(".apexcharts-".concat(r, "-annotations .apexcharts-").concat(r, "-annotation-label[rel='").concat(s, "']"));
                        if (n) {
                            var o = n.parentNode, h = e.addBackgroundToAnno(n, a);
                            h && (o.insertBefore(h.node, n), a.label.mouseEnter && h.node.addEventListener("mouseenter", a.label.mouseEnter.bind(e, a)), a.label.mouseLeave && h.node.addEventListener("mouseleave", a.label.mouseLeave.bind(e, a)), a.label.click && h.node.addEventListener("click", a.label.click.bind(e, a)));
                        }
                    };
                    t.config.annotations.xaxis.map(function(a, s) {
                        i(a, s, "xaxis");
                    }), t.config.annotations.yaxis.map(function(a, s) {
                        i(a, s, "yaxis");
                    }), t.config.annotations.points.map(function(a, s) {
                        i(a, s, "point");
                    });
                }
            },
            {
                key: "getY1Y2",
                value: function(e, t) {
                    var i, a = e === "y1" ? t.y : t.y2, s = this.w;
                    if (this.annoCtx.invertAxis) {
                        var r = s.globals.labels.indexOf(a);
                        s.config.xaxis.convertedCatToNumeric && (r = s.globals.categoryLabels.indexOf(a));
                        var n = s.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child(" + (r + 1) + ")");
                        n && (i = parseFloat(n.getAttribute("y"))), t.seriesIndex !== void 0 && s.globals.barHeight && (i = i - s.globals.barHeight / 2 * (s.globals.series.length - 1) + s.globals.barHeight * t.seriesIndex);
                    } else {
                        var o;
                        s.config.yaxis[t.yAxisIndex].logarithmic ? o = (a = new q(this.annoCtx.ctx).getLogVal(a, t.yAxisIndex)) / s.globals.yLogRatio[t.yAxisIndex] : o = (a - s.globals.minYArr[t.yAxisIndex]) / (s.globals.yRange[t.yAxisIndex] / s.globals.gridHeight), i = s.globals.gridHeight - o, !t.marker || t.y !== void 0 && t.y !== null || (i = 0), s.config.yaxis[t.yAxisIndex] && s.config.yaxis[t.yAxisIndex].reversed && (i = o);
                    }
                    return typeof a == "string" && a.indexOf("px") > -1 && (i = parseFloat(a)), i;
                }
            },
            {
                key: "getX1X2",
                value: function(e, t) {
                    var i = this.w, a = this.annoCtx.invertAxis ? i.globals.minY : i.globals.minX, s = this.annoCtx.invertAxis ? i.globals.maxY : i.globals.maxX, r = this.annoCtx.invertAxis ? i.globals.yRange[0] : i.globals.xRange, n = (t.x - a) / (r / i.globals.gridWidth);
                    this.annoCtx.inversedReversedAxis && (n = (s - t.x) / (r / i.globals.gridWidth)), i.config.xaxis.type !== "category" && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || (n = this.getStringX(t.x));
                    var o = (t.x2 - a) / (r / i.globals.gridWidth);
                    return this.annoCtx.inversedReversedAxis && (o = (s - t.x2) / (r / i.globals.gridWidth)), i.config.xaxis.type !== "category" && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || (o = this.getStringX(t.x2)), t.x !== void 0 && t.x !== null || !t.marker || (n = i.globals.gridWidth), e === "x1" && typeof t.x == "string" && t.x.indexOf("px") > -1 && (n = parseFloat(t.x)), e === "x2" && typeof t.x2 == "string" && t.x2.indexOf("px") > -1 && (o = parseFloat(t.x2)), t.seriesIndex !== void 0 && i.globals.barWidth && !this.annoCtx.invertAxis && (n = n - i.globals.barWidth / 2 * (i.globals.series.length - 1) + i.globals.barWidth * t.seriesIndex), e === "x1" ? n : o;
                }
            },
            {
                key: "getStringX",
                value: function(e) {
                    var t = this.w, i = e;
                    t.config.xaxis.convertedCatToNumeric && t.globals.categoryLabels.length && (e = t.globals.categoryLabels.indexOf(e) + 1);
                    var a = t.globals.labels.indexOf(e), s = t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child(" + (a + 1) + ")");
                    return s && (i = parseFloat(s.getAttribute("x"))), i;
                }
            }
        ]), y;
    }(), Oe = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.annoCtx = e, this.invertAxis = this.annoCtx.invertAxis, this.helpers = new ve(this.annoCtx);
        }
        return Y(y, [
            {
                key: "addXaxisAnnotation",
                value: function(e, t, i) {
                    var a, s = this.w, r = this.helpers.getX1X2("x1", e), n = e.label.text, o = e.strokeDashArray;
                    if (P.isNumber(r)) {
                        if (e.x2 === null || e.x2 === void 0) {
                            var h = this.annoCtx.graphics.drawLine(r + e.offsetX, 0 + e.offsetY, r + e.offsetX, s.globals.gridHeight + e.offsetY, e.borderColor, o, e.borderWidth);
                            t.appendChild(h.node), e.id && h.node.classList.add(e.id);
                        } else {
                            if ((a = this.helpers.getX1X2("x2", e)) < r) {
                                var c = r;
                                r = a, a = c;
                            }
                            var d = this.annoCtx.graphics.drawRect(r + e.offsetX, 0 + e.offsetY, a - r, s.globals.gridHeight + e.offsetY, 0, e.fillColor, e.opacity, 1, e.borderColor, o);
                            d.node.classList.add("apexcharts-annotation-rect"), d.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), t.appendChild(d.node), e.id && d.node.classList.add(e.id);
                        }
                        var g = this.annoCtx.graphics.getTextRects(n, parseFloat(e.label.style.fontSize)), p = e.label.position === "top" ? 4 : e.label.position === "center" ? s.globals.gridHeight / 2 + (e.label.orientation === "vertical" ? g.width / 2 : 0) : s.globals.gridHeight, f = this.annoCtx.graphics.drawText({
                            x: r + e.label.offsetX,
                            y: p + e.label.offsetY - (e.label.orientation === "vertical" ? e.label.position === "top" ? g.width / 2 - 12 : -g.width / 2 : 0),
                            text: n,
                            textAnchor: e.label.textAnchor,
                            fontSize: e.label.style.fontSize,
                            fontFamily: e.label.style.fontFamily,
                            fontWeight: e.label.style.fontWeight,
                            foreColor: e.label.style.color,
                            cssClass: "apexcharts-xaxis-annotation-label ".concat(e.label.style.cssClass, " ").concat(e.id ? e.id : "")
                        });
                        f.attr({
                            rel: i
                        }), t.appendChild(f.node), this.annoCtx.helpers.setOrientations(e, i);
                    }
                }
            },
            {
                key: "drawXAxisAnnotations",
                value: function() {
                    var e = this, t = this.w, i = this.annoCtx.graphics.group({
                        class: "apexcharts-xaxis-annotations"
                    });
                    return t.config.annotations.xaxis.map(function(a, s) {
                        e.addXaxisAnnotation(a, i.node, s);
                    }), i;
                }
            }
        ]), y;
    }(), He = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.annoCtx = e, this.helpers = new ve(this.annoCtx);
        }
        return Y(y, [
            {
                key: "addYaxisAnnotation",
                value: function(e, t, i) {
                    var a, s = this.w, r = e.strokeDashArray, n = this.helpers.getY1Y2("y1", e), o = e.label.text;
                    if (e.y2 === null || e.y2 === void 0) {
                        var h = this.annoCtx.graphics.drawLine(0 + e.offsetX, n + e.offsetY, this._getYAxisAnnotationWidth(e), n + e.offsetY, e.borderColor, r, e.borderWidth);
                        t.appendChild(h.node), e.id && h.node.classList.add(e.id);
                    } else {
                        if ((a = this.helpers.getY1Y2("y2", e)) > n) {
                            var c = n;
                            n = a, a = c;
                        }
                        var d = this.annoCtx.graphics.drawRect(0 + e.offsetX, a + e.offsetY, this._getYAxisAnnotationWidth(e), n - a, 0, e.fillColor, e.opacity, 1, e.borderColor, r);
                        d.node.classList.add("apexcharts-annotation-rect"), d.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), t.appendChild(d.node), e.id && d.node.classList.add(e.id);
                    }
                    var g = e.label.position === "right" ? s.globals.gridWidth : e.label.position === "center" ? s.globals.gridWidth / 2 : 0, p = this.annoCtx.graphics.drawText({
                        x: g + e.label.offsetX,
                        y: (a ?? n) + e.label.offsetY - 3,
                        text: o,
                        textAnchor: e.label.textAnchor,
                        fontSize: e.label.style.fontSize,
                        fontFamily: e.label.style.fontFamily,
                        fontWeight: e.label.style.fontWeight,
                        foreColor: e.label.style.color,
                        cssClass: "apexcharts-yaxis-annotation-label ".concat(e.label.style.cssClass, " ").concat(e.id ? e.id : "")
                    });
                    p.attr({
                        rel: i
                    }), t.appendChild(p.node);
                }
            },
            {
                key: "_getYAxisAnnotationWidth",
                value: function(e) {
                    var t = this.w;
                    return t.globals.gridWidth, (e.width.indexOf("%") > -1 ? t.globals.gridWidth * parseInt(e.width, 10) / 100 : parseInt(e.width, 10)) + e.offsetX;
                }
            },
            {
                key: "drawYAxisAnnotations",
                value: function() {
                    var e = this, t = this.w, i = this.annoCtx.graphics.group({
                        class: "apexcharts-yaxis-annotations"
                    });
                    return t.config.annotations.yaxis.map(function(a, s) {
                        e.addYaxisAnnotation(a, i.node, s);
                    }), i;
                }
            }
        ]), y;
    }(), pe = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.annoCtx = e, this.helpers = new ve(this.annoCtx);
        }
        return Y(y, [
            {
                key: "addPointAnnotation",
                value: function(e, t, i) {
                    this.w;
                    var a = this.helpers.getX1X2("x1", e), s = this.helpers.getY1Y2("y1", e);
                    if (P.isNumber(a)) {
                        var r = {
                            pSize: e.marker.size,
                            pointStrokeWidth: e.marker.strokeWidth,
                            pointFillColor: e.marker.fillColor,
                            pointStrokeColor: e.marker.strokeColor,
                            shape: e.marker.shape,
                            pRadius: e.marker.radius,
                            class: "apexcharts-point-annotation-marker ".concat(e.marker.cssClass, " ").concat(e.id ? e.id : "")
                        }, n = this.annoCtx.graphics.drawMarker(a + e.marker.offsetX, s + e.marker.offsetY, r);
                        t.appendChild(n.node);
                        var o = e.label.text ? e.label.text : "", h = this.annoCtx.graphics.drawText({
                            x: a + e.label.offsetX,
                            y: s + e.label.offsetY - e.marker.size - parseFloat(e.label.style.fontSize) / 1.6,
                            text: o,
                            textAnchor: e.label.textAnchor,
                            fontSize: e.label.style.fontSize,
                            fontFamily: e.label.style.fontFamily,
                            fontWeight: e.label.style.fontWeight,
                            foreColor: e.label.style.color,
                            cssClass: "apexcharts-point-annotation-label ".concat(e.label.style.cssClass, " ").concat(e.id ? e.id : "")
                        });
                        if (h.attr({
                            rel: i
                        }), t.appendChild(h.node), e.customSVG.SVG) {
                            var c = this.annoCtx.graphics.group({
                                class: "apexcharts-point-annotations-custom-svg " + e.customSVG.cssClass
                            });
                            c.attr({
                                transform: "translate(".concat(a + e.customSVG.offsetX, ", ").concat(s + e.customSVG.offsetY, ")")
                            }), c.node.innerHTML = e.customSVG.SVG, t.appendChild(c.node);
                        }
                        if (e.image.path) {
                            var d = e.image.width ? e.image.width : 20, g = e.image.height ? e.image.height : 20;
                            n = this.annoCtx.addImage({
                                x: a + e.image.offsetX - d / 2,
                                y: s + e.image.offsetY - g / 2,
                                width: d,
                                height: g,
                                path: e.image.path,
                                appendTo: ".apexcharts-point-annotations"
                            });
                        }
                        e.mouseEnter && n.node.addEventListener("mouseenter", e.mouseEnter.bind(this, e)), e.mouseLeave && n.node.addEventListener("mouseleave", e.mouseLeave.bind(this, e)), e.click && n.node.addEventListener("click", e.click.bind(this, e));
                    }
                }
            },
            {
                key: "drawPointAnnotations",
                value: function() {
                    var e = this, t = this.w, i = this.annoCtx.graphics.group({
                        class: "apexcharts-point-annotations"
                    });
                    return t.config.annotations.points.map(function(a, s) {
                        e.addPointAnnotation(a, i.node, s);
                    }), i;
                }
            }
        ]), y;
    }(), H = {
        name: "en",
        options: {
            months: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            shortMonths: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            days: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            shortDays: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            toolbar: {
                exportToSVG: "Download SVG",
                exportToPNG: "Download PNG",
                exportToCSV: "Download CSV",
                menu: "Menu",
                selection: "Selection",
                selectionZoom: "Selection Zoom",
                zoomIn: "Zoom In",
                zoomOut: "Zoom Out",
                pan: "Panning",
                reset: "Reset Zoom"
            }
        }
    }, G = function() {
        function y() {
            F(this, y), this.yAxis = {
                show: !0,
                showAlways: !1,
                showForNullSeries: !0,
                seriesName: void 0,
                opposite: !1,
                reversed: !1,
                logarithmic: !1,
                logBase: 10,
                tickAmount: void 0,
                stepSize: void 0,
                forceNiceScale: !1,
                max: void 0,
                min: void 0,
                floating: !1,
                decimalsInFloat: void 0,
                labels: {
                    show: !0,
                    minWidth: 0,
                    maxWidth: 160,
                    offsetX: 0,
                    offsetY: 0,
                    align: void 0,
                    rotate: 0,
                    padding: 20,
                    style: {
                        colors: [],
                        fontSize: "11px",
                        fontWeight: 400,
                        fontFamily: void 0,
                        cssClass: ""
                    },
                    formatter: void 0
                },
                axisBorder: {
                    show: !1,
                    color: "#e0e0e0",
                    width: 1,
                    offsetX: 0,
                    offsetY: 0
                },
                axisTicks: {
                    show: !1,
                    color: "#e0e0e0",
                    width: 6,
                    offsetX: 0,
                    offsetY: 0
                },
                title: {
                    text: void 0,
                    rotate: -90,
                    offsetY: 0,
                    offsetX: 0,
                    style: {
                        color: void 0,
                        fontSize: "11px",
                        fontWeight: 900,
                        fontFamily: void 0,
                        cssClass: ""
                    }
                },
                tooltip: {
                    enabled: !1,
                    offsetX: 0
                },
                crosshairs: {
                    show: !0,
                    position: "front",
                    stroke: {
                        color: "#b6b6b6",
                        width: 1,
                        dashArray: 0
                    }
                }
            }, this.pointAnnotation = {
                id: void 0,
                x: 0,
                y: null,
                yAxisIndex: 0,
                seriesIndex: void 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                marker: {
                    size: 4,
                    fillColor: "#fff",
                    strokeWidth: 2,
                    strokeColor: "#333",
                    shape: "circle",
                    offsetX: 0,
                    offsetY: 0,
                    radius: 2,
                    cssClass: ""
                },
                label: {
                    borderColor: "#c2c2c2",
                    borderWidth: 1,
                    borderRadius: 2,
                    text: void 0,
                    textAnchor: "middle",
                    offsetX: 0,
                    offsetY: 0,
                    mouseEnter: void 0,
                    mouseLeave: void 0,
                    click: void 0,
                    style: {
                        background: "#fff",
                        color: void 0,
                        fontSize: "11px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        cssClass: "",
                        padding: {
                            left: 5,
                            right: 5,
                            top: 2,
                            bottom: 2
                        }
                    }
                },
                customSVG: {
                    SVG: void 0,
                    cssClass: void 0,
                    offsetX: 0,
                    offsetY: 0
                },
                image: {
                    path: void 0,
                    width: 20,
                    height: 20,
                    offsetX: 0,
                    offsetY: 0
                }
            }, this.yAxisAnnotation = {
                id: void 0,
                y: 0,
                y2: null,
                strokeDashArray: 1,
                fillColor: "#c2c2c2",
                borderColor: "#c2c2c2",
                borderWidth: 1,
                opacity: 0.3,
                offsetX: 0,
                offsetY: 0,
                width: "100%",
                yAxisIndex: 0,
                label: {
                    borderColor: "#c2c2c2",
                    borderWidth: 1,
                    borderRadius: 2,
                    text: void 0,
                    textAnchor: "end",
                    position: "right",
                    offsetX: 0,
                    offsetY: -3,
                    mouseEnter: void 0,
                    mouseLeave: void 0,
                    click: void 0,
                    style: {
                        background: "#fff",
                        color: void 0,
                        fontSize: "11px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        cssClass: "",
                        padding: {
                            left: 5,
                            right: 5,
                            top: 2,
                            bottom: 2
                        }
                    }
                }
            }, this.xAxisAnnotation = {
                id: void 0,
                x: 0,
                x2: null,
                strokeDashArray: 1,
                fillColor: "#c2c2c2",
                borderColor: "#c2c2c2",
                borderWidth: 1,
                opacity: 0.3,
                offsetX: 0,
                offsetY: 0,
                label: {
                    borderColor: "#c2c2c2",
                    borderWidth: 1,
                    borderRadius: 2,
                    text: void 0,
                    textAnchor: "middle",
                    orientation: "vertical",
                    position: "top",
                    offsetX: 0,
                    offsetY: 0,
                    mouseEnter: void 0,
                    mouseLeave: void 0,
                    click: void 0,
                    style: {
                        background: "#fff",
                        color: void 0,
                        fontSize: "11px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        cssClass: "",
                        padding: {
                            left: 5,
                            right: 5,
                            top: 2,
                            bottom: 2
                        }
                    }
                }
            }, this.text = {
                x: 0,
                y: 0,
                text: "",
                textAnchor: "start",
                foreColor: void 0,
                fontSize: "13px",
                fontFamily: void 0,
                fontWeight: 400,
                appendTo: ".apexcharts-annotations",
                backgroundColor: "transparent",
                borderColor: "#c2c2c2",
                borderRadius: 0,
                borderWidth: 0,
                paddingLeft: 4,
                paddingRight: 4,
                paddingTop: 2,
                paddingBottom: 2
            };
        }
        return Y(y, [
            {
                key: "init",
                value: function() {
                    return {
                        annotations: {
                            yaxis: [
                                this.yAxisAnnotation
                            ],
                            xaxis: [
                                this.xAxisAnnotation
                            ],
                            points: [
                                this.pointAnnotation
                            ],
                            texts: [],
                            images: [],
                            shapes: []
                        },
                        chart: {
                            animations: {
                                enabled: !0,
                                easing: "easeinout",
                                speed: 800,
                                animateGradually: {
                                    delay: 150,
                                    enabled: !0
                                },
                                dynamicAnimation: {
                                    enabled: !0,
                                    speed: 350
                                }
                            },
                            background: "transparent",
                            locales: [
                                H
                            ],
                            defaultLocale: "en",
                            dropShadow: {
                                enabled: !1,
                                enabledOnSeries: void 0,
                                top: 2,
                                left: 2,
                                blur: 4,
                                color: "#000",
                                opacity: 0.35
                            },
                            events: {
                                animationEnd: void 0,
                                beforeMount: void 0,
                                mounted: void 0,
                                updated: void 0,
                                click: void 0,
                                mouseMove: void 0,
                                mouseLeave: void 0,
                                xAxisLabelClick: void 0,
                                legendClick: void 0,
                                markerClick: void 0,
                                selection: void 0,
                                dataPointSelection: void 0,
                                dataPointMouseEnter: void 0,
                                dataPointMouseLeave: void 0,
                                beforeZoom: void 0,
                                beforeResetZoom: void 0,
                                zoomed: void 0,
                                scrolled: void 0,
                                brushScrolled: void 0
                            },
                            foreColor: "#373d3f",
                            fontFamily: "Helvetica, Arial, sans-serif",
                            height: "auto",
                            parentHeightOffset: 15,
                            redrawOnParentResize: !0,
                            redrawOnWindowResize: !0,
                            id: void 0,
                            group: void 0,
                            nonce: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            selection: {
                                enabled: !1,
                                type: "x",
                                fill: {
                                    color: "#24292e",
                                    opacity: 0.1
                                },
                                stroke: {
                                    width: 1,
                                    color: "#24292e",
                                    opacity: 0.4,
                                    dashArray: 3
                                },
                                xaxis: {
                                    min: void 0,
                                    max: void 0
                                },
                                yaxis: {
                                    min: void 0,
                                    max: void 0
                                }
                            },
                            sparkline: {
                                enabled: !1
                            },
                            brush: {
                                enabled: !1,
                                autoScaleYaxis: !0,
                                target: void 0,
                                targets: void 0
                            },
                            stacked: !1,
                            stackOnlyBar: !0,
                            stackType: "normal",
                            toolbar: {
                                show: !0,
                                offsetX: 0,
                                offsetY: 0,
                                tools: {
                                    download: !0,
                                    selection: !0,
                                    zoom: !0,
                                    zoomin: !0,
                                    zoomout: !0,
                                    pan: !0,
                                    reset: !0,
                                    customIcons: []
                                },
                                export: {
                                    csv: {
                                        filename: void 0,
                                        columnDelimiter: ",",
                                        headerCategory: "category",
                                        headerValue: "value",
                                        dateFormatter: function(e) {
                                            return new Date(e).toDateString();
                                        }
                                    },
                                    png: {
                                        filename: void 0
                                    },
                                    svg: {
                                        filename: void 0
                                    }
                                },
                                autoSelected: "zoom"
                            },
                            type: "line",
                            width: "100%",
                            zoom: {
                                enabled: !0,
                                type: "x",
                                autoScaleYaxis: !1,
                                zoomedArea: {
                                    fill: {
                                        color: "#90CAF9",
                                        opacity: 0.4
                                    },
                                    stroke: {
                                        color: "#0D47A1",
                                        opacity: 0.4,
                                        width: 1
                                    }
                                }
                            }
                        },
                        plotOptions: {
                            area: {
                                fillTo: "origin"
                            },
                            bar: {
                                horizontal: !1,
                                columnWidth: "70%",
                                barHeight: "70%",
                                distributed: !1,
                                borderRadius: 0,
                                borderRadiusApplication: "around",
                                borderRadiusWhenStacked: "last",
                                rangeBarOverlap: !0,
                                rangeBarGroupRows: !1,
                                hideZeroBarsWhenGrouped: !1,
                                isDumbbell: !1,
                                dumbbellColors: void 0,
                                isFunnel: !1,
                                isFunnel3d: !0,
                                colors: {
                                    ranges: [],
                                    backgroundBarColors: [],
                                    backgroundBarOpacity: 1,
                                    backgroundBarRadius: 0
                                },
                                dataLabels: {
                                    position: "top",
                                    maxItems: 100,
                                    hideOverflowingLabels: !0,
                                    orientation: "horizontal",
                                    total: {
                                        enabled: !1,
                                        formatter: void 0,
                                        offsetX: 0,
                                        offsetY: 0,
                                        style: {
                                            color: "#373d3f",
                                            fontSize: "12px",
                                            fontFamily: void 0,
                                            fontWeight: 600
                                        }
                                    }
                                }
                            },
                            bubble: {
                                zScaling: !0,
                                minBubbleRadius: void 0,
                                maxBubbleRadius: void 0
                            },
                            candlestick: {
                                colors: {
                                    upward: "#00B746",
                                    downward: "#EF403C"
                                },
                                wick: {
                                    useFillColor: !0
                                }
                            },
                            boxPlot: {
                                colors: {
                                    upper: "#00E396",
                                    lower: "#008FFB"
                                }
                            },
                            heatmap: {
                                radius: 2,
                                enableShades: !0,
                                shadeIntensity: 0.5,
                                reverseNegativeShade: !1,
                                distributed: !1,
                                useFillColorAsStroke: !1,
                                colorScale: {
                                    inverse: !1,
                                    ranges: [],
                                    min: void 0,
                                    max: void 0
                                }
                            },
                            treemap: {
                                enableShades: !0,
                                shadeIntensity: 0.5,
                                distributed: !1,
                                reverseNegativeShade: !1,
                                useFillColorAsStroke: !1,
                                borderRadius: 4,
                                dataLabels: {
                                    format: "scale"
                                },
                                colorScale: {
                                    inverse: !1,
                                    ranges: [],
                                    min: void 0,
                                    max: void 0
                                }
                            },
                            radialBar: {
                                inverseOrder: !1,
                                startAngle: 0,
                                endAngle: 360,
                                offsetX: 0,
                                offsetY: 0,
                                hollow: {
                                    margin: 5,
                                    size: "50%",
                                    background: "transparent",
                                    image: void 0,
                                    imageWidth: 150,
                                    imageHeight: 150,
                                    imageOffsetX: 0,
                                    imageOffsetY: 0,
                                    imageClipped: !0,
                                    position: "front",
                                    dropShadow: {
                                        enabled: !1,
                                        top: 0,
                                        left: 0,
                                        blur: 3,
                                        color: "#000",
                                        opacity: 0.5
                                    }
                                },
                                track: {
                                    show: !0,
                                    startAngle: void 0,
                                    endAngle: void 0,
                                    background: "#f2f2f2",
                                    strokeWidth: "97%",
                                    opacity: 1,
                                    margin: 5,
                                    dropShadow: {
                                        enabled: !1,
                                        top: 0,
                                        left: 0,
                                        blur: 3,
                                        color: "#000",
                                        opacity: 0.5
                                    }
                                },
                                dataLabels: {
                                    show: !0,
                                    name: {
                                        show: !0,
                                        fontSize: "16px",
                                        fontFamily: void 0,
                                        fontWeight: 600,
                                        color: void 0,
                                        offsetY: 0,
                                        formatter: function(e) {
                                            return e;
                                        }
                                    },
                                    value: {
                                        show: !0,
                                        fontSize: "14px",
                                        fontFamily: void 0,
                                        fontWeight: 400,
                                        color: void 0,
                                        offsetY: 16,
                                        formatter: function(e) {
                                            return e + "%";
                                        }
                                    },
                                    total: {
                                        show: !1,
                                        label: "Total",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        fontFamily: void 0,
                                        color: void 0,
                                        formatter: function(e) {
                                            return e.globals.seriesTotals.reduce(function(t, i) {
                                                return t + i;
                                            }, 0) / e.globals.series.length + "%";
                                        }
                                    }
                                },
                                barLabels: {
                                    enabled: !1,
                                    margin: 5,
                                    useSeriesColors: !0,
                                    fontFamily: void 0,
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    formatter: function(e) {
                                        return e;
                                    },
                                    onClick: void 0
                                }
                            },
                            pie: {
                                customScale: 1,
                                offsetX: 0,
                                offsetY: 0,
                                startAngle: 0,
                                endAngle: 360,
                                expandOnClick: !0,
                                dataLabels: {
                                    offset: 0,
                                    minAngleToShowLabel: 10
                                },
                                donut: {
                                    size: "65%",
                                    background: "transparent",
                                    labels: {
                                        show: !1,
                                        name: {
                                            show: !0,
                                            fontSize: "16px",
                                            fontFamily: void 0,
                                            fontWeight: 600,
                                            color: void 0,
                                            offsetY: -10,
                                            formatter: function(e) {
                                                return e;
                                            }
                                        },
                                        value: {
                                            show: !0,
                                            fontSize: "20px",
                                            fontFamily: void 0,
                                            fontWeight: 400,
                                            color: void 0,
                                            offsetY: 10,
                                            formatter: function(e) {
                                                return e;
                                            }
                                        },
                                        total: {
                                            show: !1,
                                            showAlways: !1,
                                            label: "Total",
                                            fontSize: "16px",
                                            fontWeight: 400,
                                            fontFamily: void 0,
                                            color: void 0,
                                            formatter: function(e) {
                                                return e.globals.seriesTotals.reduce(function(t, i) {
                                                    return t + i;
                                                }, 0);
                                            }
                                        }
                                    }
                                }
                            },
                            polarArea: {
                                rings: {
                                    strokeWidth: 1,
                                    strokeColor: "#e8e8e8"
                                },
                                spokes: {
                                    strokeWidth: 1,
                                    connectorColors: "#e8e8e8"
                                }
                            },
                            radar: {
                                size: void 0,
                                offsetX: 0,
                                offsetY: 0,
                                polygons: {
                                    strokeWidth: 1,
                                    strokeColors: "#e8e8e8",
                                    connectorColors: "#e8e8e8",
                                    fill: {
                                        colors: void 0
                                    }
                                }
                            }
                        },
                        colors: void 0,
                        dataLabels: {
                            enabled: !0,
                            enabledOnSeries: void 0,
                            formatter: function(e) {
                                return e !== null ? e : "";
                            },
                            textAnchor: "middle",
                            distributed: !1,
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0,
                                fontWeight: 600,
                                colors: void 0
                            },
                            background: {
                                enabled: !0,
                                foreColor: "#fff",
                                borderRadius: 2,
                                padding: 4,
                                opacity: 0.9,
                                borderWidth: 1,
                                borderColor: "#fff",
                                dropShadow: {
                                    enabled: !1,
                                    top: 1,
                                    left: 1,
                                    blur: 1,
                                    color: "#000",
                                    opacity: 0.45
                                }
                            },
                            dropShadow: {
                                enabled: !1,
                                top: 1,
                                left: 1,
                                blur: 1,
                                color: "#000",
                                opacity: 0.45
                            }
                        },
                        fill: {
                            type: "solid",
                            colors: void 0,
                            opacity: 0.85,
                            gradient: {
                                shade: "dark",
                                type: "horizontal",
                                shadeIntensity: 0.5,
                                gradientToColors: void 0,
                                inverseColors: !0,
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [
                                    0,
                                    50,
                                    100
                                ],
                                colorStops: []
                            },
                            image: {
                                src: [],
                                width: void 0,
                                height: void 0
                            },
                            pattern: {
                                style: "squares",
                                width: 6,
                                height: 6,
                                strokeWidth: 2
                            }
                        },
                        forecastDataPoints: {
                            count: 0,
                            fillOpacity: 0.5,
                            strokeWidth: void 0,
                            dashArray: 4
                        },
                        grid: {
                            show: !0,
                            borderColor: "#e0e0e0",
                            strokeDashArray: 0,
                            position: "back",
                            xaxis: {
                                lines: {
                                    show: !1
                                }
                            },
                            yaxis: {
                                lines: {
                                    show: !0
                                }
                            },
                            row: {
                                colors: void 0,
                                opacity: 0.5
                            },
                            column: {
                                colors: void 0,
                                opacity: 0.5
                            },
                            padding: {
                                top: 0,
                                right: 10,
                                bottom: 0,
                                left: 12
                            }
                        },
                        labels: [],
                        legend: {
                            show: !0,
                            showForSingleSeries: !1,
                            showForNullSeries: !0,
                            showForZeroSeries: !0,
                            floating: !1,
                            position: "bottom",
                            horizontalAlign: "center",
                            inverseOrder: !1,
                            fontSize: "12px",
                            fontFamily: void 0,
                            fontWeight: 400,
                            width: void 0,
                            height: void 0,
                            formatter: void 0,
                            tooltipHoverFormatter: void 0,
                            offsetX: -20,
                            offsetY: 4,
                            customLegendItems: [],
                            labels: {
                                colors: void 0,
                                useSeriesColors: !1
                            },
                            markers: {
                                width: 12,
                                height: 12,
                                strokeWidth: 0,
                                fillColors: void 0,
                                strokeColor: "#fff",
                                radius: 12,
                                customHTML: void 0,
                                offsetX: 0,
                                offsetY: 0,
                                onClick: void 0
                            },
                            itemMargin: {
                                horizontal: 5,
                                vertical: 2
                            },
                            onItemClick: {
                                toggleDataSeries: !0
                            },
                            onItemHover: {
                                highlightDataSeries: !0
                            }
                        },
                        markers: {
                            discrete: [],
                            size: 0,
                            colors: void 0,
                            strokeColors: "#fff",
                            strokeWidth: 2,
                            strokeOpacity: 0.9,
                            strokeDashArray: 0,
                            fillOpacity: 1,
                            shape: "circle",
                            width: 8,
                            height: 8,
                            radius: 2,
                            offsetX: 0,
                            offsetY: 0,
                            onClick: void 0,
                            onDblClick: void 0,
                            showNullDataPoints: !0,
                            hover: {
                                size: void 0,
                                sizeOffset: 3
                            }
                        },
                        noData: {
                            text: void 0,
                            align: "center",
                            verticalAlign: "middle",
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                color: void 0,
                                fontSize: "14px",
                                fontFamily: void 0
                            }
                        },
                        responsive: [],
                        series: void 0,
                        states: {
                            normal: {
                                filter: {
                                    type: "none",
                                    value: 0
                                }
                            },
                            hover: {
                                filter: {
                                    type: "lighten",
                                    value: 0.1
                                }
                            },
                            active: {
                                allowMultipleDataPointsSelection: !1,
                                filter: {
                                    type: "darken",
                                    value: 0.5
                                }
                            }
                        },
                        title: {
                            text: void 0,
                            align: "left",
                            margin: 5,
                            offsetX: 0,
                            offsetY: 0,
                            floating: !1,
                            style: {
                                fontSize: "14px",
                                fontWeight: 900,
                                fontFamily: void 0,
                                color: void 0
                            }
                        },
                        subtitle: {
                            text: void 0,
                            align: "left",
                            margin: 5,
                            offsetX: 0,
                            offsetY: 30,
                            floating: !1,
                            style: {
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                color: void 0
                            }
                        },
                        stroke: {
                            show: !0,
                            curve: "smooth",
                            lineCap: "butt",
                            width: 2,
                            colors: void 0,
                            dashArray: 0,
                            fill: {
                                type: "solid",
                                colors: void 0,
                                opacity: 0.85,
                                gradient: {
                                    shade: "dark",
                                    type: "horizontal",
                                    shadeIntensity: 0.5,
                                    gradientToColors: void 0,
                                    inverseColors: !0,
                                    opacityFrom: 1,
                                    opacityTo: 1,
                                    stops: [
                                        0,
                                        50,
                                        100
                                    ],
                                    colorStops: []
                                }
                            }
                        },
                        tooltip: {
                            enabled: !0,
                            enabledOnSeries: void 0,
                            shared: !0,
                            hideEmptySeries: !1,
                            followCursor: !1,
                            intersect: !1,
                            inverseOrder: !1,
                            custom: void 0,
                            fillSeriesColor: !1,
                            theme: "light",
                            cssClass: "",
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0
                            },
                            onDatasetHover: {
                                highlightDataSeries: !1
                            },
                            x: {
                                show: !0,
                                format: "dd MMM",
                                formatter: void 0
                            },
                            y: {
                                formatter: void 0,
                                title: {
                                    formatter: function(e) {
                                        return e ? e + ": " : "";
                                    }
                                }
                            },
                            z: {
                                formatter: void 0,
                                title: "Size: "
                            },
                            marker: {
                                show: !0,
                                fillColors: void 0
                            },
                            items: {
                                display: "flex"
                            },
                            fixed: {
                                enabled: !1,
                                position: "topRight",
                                offsetX: 0,
                                offsetY: 0
                            }
                        },
                        xaxis: {
                            type: "category",
                            categories: [],
                            convertedCatToNumeric: !1,
                            offsetX: 0,
                            offsetY: 0,
                            overwriteCategories: void 0,
                            labels: {
                                show: !0,
                                rotate: -45,
                                rotateAlways: !1,
                                hideOverlappingLabels: !0,
                                trim: !1,
                                minHeight: void 0,
                                maxHeight: 120,
                                showDuplicates: !0,
                                style: {
                                    colors: [],
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    fontFamily: void 0,
                                    cssClass: ""
                                },
                                offsetX: 0,
                                offsetY: 0,
                                format: void 0,
                                formatter: void 0,
                                datetimeUTC: !0,
                                datetimeFormatter: {
                                    year: "yyyy",
                                    month: "MMM 'yy",
                                    day: "dd MMM",
                                    hour: "HH:mm",
                                    minute: "HH:mm:ss",
                                    second: "HH:mm:ss"
                                }
                            },
                            group: {
                                groups: [],
                                style: {
                                    colors: [],
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    fontFamily: void 0,
                                    cssClass: ""
                                }
                            },
                            axisBorder: {
                                show: !0,
                                color: "#e0e0e0",
                                width: "100%",
                                height: 1,
                                offsetX: 0,
                                offsetY: 0
                            },
                            axisTicks: {
                                show: !0,
                                color: "#e0e0e0",
                                height: 6,
                                offsetX: 0,
                                offsetY: 0
                            },
                            stepSize: void 0,
                            tickAmount: void 0,
                            tickPlacement: "on",
                            min: void 0,
                            max: void 0,
                            range: void 0,
                            floating: !1,
                            decimalsInFloat: void 0,
                            position: "bottom",
                            title: {
                                text: void 0,
                                offsetX: 0,
                                offsetY: 0,
                                style: {
                                    color: void 0,
                                    fontSize: "12px",
                                    fontWeight: 900,
                                    fontFamily: void 0,
                                    cssClass: ""
                                }
                            },
                            crosshairs: {
                                show: !0,
                                width: 1,
                                position: "back",
                                opacity: 0.9,
                                stroke: {
                                    color: "#b6b6b6",
                                    width: 1,
                                    dashArray: 3
                                },
                                fill: {
                                    type: "solid",
                                    color: "#B1B9C4",
                                    gradient: {
                                        colorFrom: "#D8E3F0",
                                        colorTo: "#BED1E6",
                                        stops: [
                                            0,
                                            100
                                        ],
                                        opacityFrom: 0.4,
                                        opacityTo: 0.5
                                    }
                                },
                                dropShadow: {
                                    enabled: !1,
                                    left: 0,
                                    top: 0,
                                    blur: 1,
                                    opacity: 0.4
                                }
                            },
                            tooltip: {
                                enabled: !0,
                                offsetY: 0,
                                formatter: void 0,
                                style: {
                                    fontSize: "12px",
                                    fontFamily: void 0
                                }
                            }
                        },
                        yaxis: this.yAxis,
                        theme: {
                            mode: "light",
                            palette: "palette1",
                            monochrome: {
                                enabled: !1,
                                color: "#008FFB",
                                shadeTo: "light",
                                shadeIntensity: 0.65
                            }
                        }
                    };
                }
            }
        ]), y;
    }(), ie = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.graphics = new M(this.ctx), this.w.globals.isBarHorizontal && (this.invertAxis = !0), this.helpers = new ve(this), this.xAxisAnnotations = new Oe(this), this.yAxisAnnotations = new He(this), this.pointsAnnotations = new pe(this), this.w.globals.isBarHorizontal && this.w.config.yaxis[0].reversed && (this.inversedReversedAxis = !0), this.xDivision = this.w.globals.gridWidth / this.w.globals.dataPoints;
        }
        return Y(y, [
            {
                key: "drawAxesAnnotations",
                value: function() {
                    var e = this.w;
                    if (e.globals.axisCharts) {
                        for(var t = this.yAxisAnnotations.drawYAxisAnnotations(), i = this.xAxisAnnotations.drawXAxisAnnotations(), a = this.pointsAnnotations.drawPointAnnotations(), s = e.config.chart.animations.enabled, r = [
                            t,
                            i,
                            a
                        ], n = [
                            i.node,
                            t.node,
                            a.node
                        ], o = 0; o < 3; o++)e.globals.dom.elGraphical.add(r[o]), !s || e.globals.resized || e.globals.dataChanged || e.config.chart.type !== "scatter" && e.config.chart.type !== "bubble" && e.globals.dataPoints > 1 && n[o].classList.add("apexcharts-element-hidden"), e.globals.delayedElements.push({
                            el: n[o],
                            index: 0
                        });
                        this.helpers.annotationsBackground();
                    }
                }
            },
            {
                key: "drawImageAnnos",
                value: function() {
                    var e = this;
                    this.w.config.annotations.images.map(function(t, i) {
                        e.addImage(t, i);
                    });
                }
            },
            {
                key: "drawTextAnnos",
                value: function() {
                    var e = this;
                    this.w.config.annotations.texts.map(function(t, i) {
                        e.addText(t, i);
                    });
                }
            },
            {
                key: "addXaxisAnnotation",
                value: function(e, t, i) {
                    this.xAxisAnnotations.addXaxisAnnotation(e, t, i);
                }
            },
            {
                key: "addYaxisAnnotation",
                value: function(e, t, i) {
                    this.yAxisAnnotations.addYaxisAnnotation(e, t, i);
                }
            },
            {
                key: "addPointAnnotation",
                value: function(e, t, i) {
                    this.pointsAnnotations.addPointAnnotation(e, t, i);
                }
            },
            {
                key: "addText",
                value: function(e, t) {
                    var i = e.x, a = e.y, s = e.text, r = e.textAnchor, n = e.foreColor, o = e.fontSize, h = e.fontFamily, c = e.fontWeight, d = e.cssClass, g = e.backgroundColor, p = e.borderWidth, f = e.strokeDashArray, b = e.borderRadius, m = e.borderColor, w = e.appendTo, A = w === void 0 ? ".apexcharts-svg" : w, l = e.paddingLeft, u = l === void 0 ? 4 : l, x = e.paddingRight, v = x === void 0 ? 4 : x, k = e.paddingBottom, S = k === void 0 ? 2 : k, C = e.paddingTop, L = C === void 0 ? 2 : C, I = this.w, z = this.graphics.drawText({
                        x: i,
                        y: a,
                        text: s,
                        textAnchor: r || "start",
                        fontSize: o || "12px",
                        fontWeight: c || "regular",
                        fontFamily: h || I.config.chart.fontFamily,
                        foreColor: n || I.config.chart.foreColor,
                        cssClass: d
                    }), T = I.globals.dom.baseEl.querySelector(A);
                    T && T.appendChild(z.node);
                    var E = z.bbox();
                    if (s) {
                        var R = this.graphics.drawRect(E.x - u, E.y - L, E.width + u + v, E.height + S + L, b, g || "transparent", 1, p, m, f);
                        T.insertBefore(R.node, z.node);
                    }
                }
            },
            {
                key: "addImage",
                value: function(e, t) {
                    var i = this.w, a = e.path, s = e.x, r = s === void 0 ? 0 : s, n = e.y, o = n === void 0 ? 0 : n, h = e.width, c = h === void 0 ? 20 : h, d = e.height, g = d === void 0 ? 20 : d, p = e.appendTo, f = p === void 0 ? ".apexcharts-svg" : p, b = i.globals.dom.Paper.image(a);
                    b.size(c, g).move(r, o);
                    var m = i.globals.dom.baseEl.querySelector(f);
                    return m && m.appendChild(b.node), b;
                }
            },
            {
                key: "addXaxisAnnotationExternal",
                value: function(e, t, i) {
                    return this.addAnnotationExternal({
                        params: e,
                        pushToMemory: t,
                        context: i,
                        type: "xaxis",
                        contextMethod: i.addXaxisAnnotation
                    }), i;
                }
            },
            {
                key: "addYaxisAnnotationExternal",
                value: function(e, t, i) {
                    return this.addAnnotationExternal({
                        params: e,
                        pushToMemory: t,
                        context: i,
                        type: "yaxis",
                        contextMethod: i.addYaxisAnnotation
                    }), i;
                }
            },
            {
                key: "addPointAnnotationExternal",
                value: function(e, t, i) {
                    return this.invertAxis === void 0 && (this.invertAxis = i.w.globals.isBarHorizontal), this.addAnnotationExternal({
                        params: e,
                        pushToMemory: t,
                        context: i,
                        type: "point",
                        contextMethod: i.addPointAnnotation
                    }), i;
                }
            },
            {
                key: "addAnnotationExternal",
                value: function(e) {
                    var t = e.params, i = e.pushToMemory, a = e.context, s = e.type, r = e.contextMethod, n = a, o = n.w, h = o.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations")), c = h.childNodes.length + 1, d = new G(), g = Object.assign({}, s === "xaxis" ? d.xAxisAnnotation : s === "yaxis" ? d.yAxisAnnotation : d.pointAnnotation), p = P.extend(g, t);
                    switch(s){
                        case "xaxis":
                            this.addXaxisAnnotation(p, h, c);
                            break;
                        case "yaxis":
                            this.addYaxisAnnotation(p, h, c);
                            break;
                        case "point":
                            this.addPointAnnotation(p, h, c);
                    }
                    var f = o.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(c, "']")), b = this.helpers.addBackgroundToAnno(f, p);
                    return b && h.insertBefore(b.node, f), i && o.globals.memory.methodsToExec.push({
                        context: n,
                        id: p.id ? p.id : P.randomId(),
                        method: r,
                        label: "addAnnotation",
                        params: t
                    }), a;
                }
            },
            {
                key: "clearAnnotations",
                value: function(e) {
                    var t = e.w, i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations");
                    t.globals.memory.methodsToExec.map(function(a, s) {
                        a.label !== "addText" && a.label !== "addAnnotation" || t.globals.memory.methodsToExec.splice(s, 1);
                    }), i = P.listToArray(i), Array.prototype.forEach.call(i, function(a) {
                        for(; a.firstChild;)a.removeChild(a.firstChild);
                    });
                }
            },
            {
                key: "removeAnnotation",
                value: function(e, t) {
                    var i = e.w, a = i.globals.dom.baseEl.querySelectorAll(".".concat(t));
                    a && (i.globals.memory.methodsToExec.map(function(s, r) {
                        s.id === t && i.globals.memory.methodsToExec.splice(r, 1);
                    }), Array.prototype.forEach.call(a, function(s) {
                        s.parentElement.removeChild(s);
                    }));
                }
            }
        ]), y;
    }(), B = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.months31 = [
                1,
                3,
                5,
                7,
                8,
                10,
                12
            ], this.months30 = [
                2,
                4,
                6,
                9,
                11
            ], this.daysCntOfYear = [
                0,
                31,
                59,
                90,
                120,
                151,
                181,
                212,
                243,
                273,
                304,
                334
            ];
        }
        return Y(y, [
            {
                key: "isValidDate",
                value: function(e) {
                    return typeof e != "number" && !isNaN(this.parseDate(e));
                }
            },
            {
                key: "getTimeStamp",
                value: function(e) {
                    return Date.parse(e) ? this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(e).toISOString().substr(0, 25)).getTime() : new Date(e).getTime() : e;
                }
            },
            {
                key: "getDate",
                value: function(e) {
                    return this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(e).toUTCString()) : new Date(e);
                }
            },
            {
                key: "parseDate",
                value: function(e) {
                    var t = Date.parse(e);
                    if (!isNaN(t)) return this.getTimeStamp(e);
                    var i = Date.parse(e.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                    return i = this.getTimeStamp(i);
                }
            },
            {
                key: "parseDateWithTimezone",
                value: function(e) {
                    return Date.parse(e.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                }
            },
            {
                key: "formatDate",
                value: function(e, t) {
                    var i = this.w.globals.locale, a = this.w.config.xaxis.labels.datetimeUTC, s = [
                        "\0"
                    ].concat(J(i.months)), r = [
                        "\x01"
                    ].concat(J(i.shortMonths)), n = [
                        "\x02"
                    ].concat(J(i.days)), o = [
                        "\x03"
                    ].concat(J(i.shortDays));
                    function h(S, C) {
                        var L = S + "";
                        for(C = C || 2; L.length < C;)L = "0" + L;
                        return L;
                    }
                    var c = a ? e.getUTCFullYear() : e.getFullYear();
                    t = (t = (t = t.replace(/(^|[^\\])yyyy+/g, "$1" + c)).replace(/(^|[^\\])yy/g, "$1" + c.toString().substr(2, 2))).replace(/(^|[^\\])y/g, "$1" + c);
                    var d = (a ? e.getUTCMonth() : e.getMonth()) + 1;
                    t = (t = (t = (t = t.replace(/(^|[^\\])MMMM+/g, "$1" + s[0])).replace(/(^|[^\\])MMM/g, "$1" + r[0])).replace(/(^|[^\\])MM/g, "$1" + h(d))).replace(/(^|[^\\])M/g, "$1" + d);
                    var g = a ? e.getUTCDate() : e.getDate();
                    t = (t = (t = (t = t.replace(/(^|[^\\])dddd+/g, "$1" + n[0])).replace(/(^|[^\\])ddd/g, "$1" + o[0])).replace(/(^|[^\\])dd/g, "$1" + h(g))).replace(/(^|[^\\])d/g, "$1" + g);
                    var p = a ? e.getUTCHours() : e.getHours(), f = p > 12 ? p - 12 : p === 0 ? 12 : p;
                    t = (t = (t = (t = t.replace(/(^|[^\\])HH+/g, "$1" + h(p))).replace(/(^|[^\\])H/g, "$1" + p)).replace(/(^|[^\\])hh+/g, "$1" + h(f))).replace(/(^|[^\\])h/g, "$1" + f);
                    var b = a ? e.getUTCMinutes() : e.getMinutes();
                    t = (t = t.replace(/(^|[^\\])mm+/g, "$1" + h(b))).replace(/(^|[^\\])m/g, "$1" + b);
                    var m = a ? e.getUTCSeconds() : e.getSeconds();
                    t = (t = t.replace(/(^|[^\\])ss+/g, "$1" + h(m))).replace(/(^|[^\\])s/g, "$1" + m);
                    var w = a ? e.getUTCMilliseconds() : e.getMilliseconds();
                    t = t.replace(/(^|[^\\])fff+/g, "$1" + h(w, 3)), w = Math.round(w / 10), t = t.replace(/(^|[^\\])ff/g, "$1" + h(w)), w = Math.round(w / 10);
                    var A = p < 12 ? "AM" : "PM";
                    t = (t = (t = t.replace(/(^|[^\\])f/g, "$1" + w)).replace(/(^|[^\\])TT+/g, "$1" + A)).replace(/(^|[^\\])T/g, "$1" + A.charAt(0));
                    var l = A.toLowerCase();
                    t = (t = t.replace(/(^|[^\\])tt+/g, "$1" + l)).replace(/(^|[^\\])t/g, "$1" + l.charAt(0));
                    var u = -e.getTimezoneOffset(), x = a || !u ? "Z" : u > 0 ? "+" : "-";
                    if (!a) {
                        var v = (u = Math.abs(u)) % 60;
                        x += h(Math.floor(u / 60)) + ":" + h(v);
                    }
                    t = t.replace(/(^|[^\\])K/g, "$1" + x);
                    var k = (a ? e.getUTCDay() : e.getDay()) + 1;
                    return t = (t = (t = (t = (t = t.replace(new RegExp(n[0], "g"), n[k])).replace(new RegExp(o[0], "g"), o[k])).replace(new RegExp(s[0], "g"), s[d])).replace(new RegExp(r[0], "g"), r[d])).replace(/\\(.)/g, "$1");
                }
            },
            {
                key: "getTimeUnitsfromTimestamp",
                value: function(e, t, i) {
                    var a = this.w;
                    a.config.xaxis.min !== void 0 && (e = a.config.xaxis.min), a.config.xaxis.max !== void 0 && (t = a.config.xaxis.max);
                    var s = this.getDate(e), r = this.getDate(t), n = this.formatDate(s, "yyyy MM dd HH mm ss fff").split(" "), o = this.formatDate(r, "yyyy MM dd HH mm ss fff").split(" ");
                    return {
                        minMillisecond: parseInt(n[6], 10),
                        maxMillisecond: parseInt(o[6], 10),
                        minSecond: parseInt(n[5], 10),
                        maxSecond: parseInt(o[5], 10),
                        minMinute: parseInt(n[4], 10),
                        maxMinute: parseInt(o[4], 10),
                        minHour: parseInt(n[3], 10),
                        maxHour: parseInt(o[3], 10),
                        minDate: parseInt(n[2], 10),
                        maxDate: parseInt(o[2], 10),
                        minMonth: parseInt(n[1], 10) - 1,
                        maxMonth: parseInt(o[1], 10) - 1,
                        minYear: parseInt(n[0], 10),
                        maxYear: parseInt(o[0], 10)
                    };
                }
            },
            {
                key: "isLeapYear",
                value: function(e) {
                    return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
                }
            },
            {
                key: "calculcateLastDaysOfMonth",
                value: function(e, t, i) {
                    return this.determineDaysOfMonths(e, t) - i;
                }
            },
            {
                key: "determineDaysOfYear",
                value: function(e) {
                    var t = 365;
                    return this.isLeapYear(e) && (t = 366), t;
                }
            },
            {
                key: "determineRemainingDaysOfYear",
                value: function(e, t, i) {
                    var a = this.daysCntOfYear[t] + i;
                    return t > 1 && this.isLeapYear() && a++, a;
                }
            },
            {
                key: "determineDaysOfMonths",
                value: function(e, t) {
                    var i = 30;
                    switch(e = P.monthMod(e), !0){
                        case this.months30.indexOf(e) > -1:
                            e === 2 && (i = this.isLeapYear(t) ? 29 : 28);
                            break;
                        case this.months31.indexOf(e) > -1:
                        default:
                            i = 31;
                    }
                    return i;
                }
            }
        ]), y;
    }(), re = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.tooltipKeyFormat = "dd MMM";
        }
        return Y(y, [
            {
                key: "xLabelFormat",
                value: function(e, t, i, a) {
                    var s = this.w;
                    if (s.config.xaxis.type === "datetime" && s.config.xaxis.labels.formatter === void 0 && s.config.tooltip.x.formatter === void 0) {
                        var r = new B(this.ctx);
                        return r.formatDate(r.getDate(t), s.config.tooltip.x.format);
                    }
                    return e(t, i, a);
                }
            },
            {
                key: "defaultGeneralFormatter",
                value: function(e) {
                    return Array.isArray(e) ? e.map(function(t) {
                        return t;
                    }) : e;
                }
            },
            {
                key: "defaultYFormatter",
                value: function(e, t, i) {
                    var a = this.w;
                    return P.isNumber(e) && (e = a.globals.yValueDecimal !== 0 ? e.toFixed(t.decimalsInFloat !== void 0 ? t.decimalsInFloat : a.globals.yValueDecimal) : a.globals.maxYArr[i] - a.globals.minYArr[i] < 5 ? e.toFixed(1) : e.toFixed(0)), e;
                }
            },
            {
                key: "setLabelFormatters",
                value: function() {
                    var e = this, t = this.w;
                    return t.globals.xaxisTooltipFormatter = function(i) {
                        return e.defaultGeneralFormatter(i);
                    }, t.globals.ttKeyFormatter = function(i) {
                        return e.defaultGeneralFormatter(i);
                    }, t.globals.ttZFormatter = function(i) {
                        return i;
                    }, t.globals.legendFormatter = function(i) {
                        return e.defaultGeneralFormatter(i);
                    }, t.config.xaxis.labels.formatter !== void 0 ? t.globals.xLabelFormatter = t.config.xaxis.labels.formatter : t.globals.xLabelFormatter = function(i) {
                        if (P.isNumber(i)) {
                            if (!t.config.xaxis.convertedCatToNumeric && t.config.xaxis.type === "numeric") {
                                if (P.isNumber(t.config.xaxis.decimalsInFloat)) return i.toFixed(t.config.xaxis.decimalsInFloat);
                                var a = t.globals.maxX - t.globals.minX;
                                return a > 0 && a < 100 ? i.toFixed(1) : i.toFixed(0);
                            }
                            return t.globals.isBarHorizontal && t.globals.maxY - t.globals.minYArr < 4 ? i.toFixed(1) : i.toFixed(0);
                        }
                        return i;
                    }, typeof t.config.tooltip.x.formatter == "function" ? t.globals.ttKeyFormatter = t.config.tooltip.x.formatter : t.globals.ttKeyFormatter = t.globals.xLabelFormatter, typeof t.config.xaxis.tooltip.formatter == "function" && (t.globals.xaxisTooltipFormatter = t.config.xaxis.tooltip.formatter), (Array.isArray(t.config.tooltip.y) || t.config.tooltip.y.formatter !== void 0) && (t.globals.ttVal = t.config.tooltip.y), t.config.tooltip.z.formatter !== void 0 && (t.globals.ttZFormatter = t.config.tooltip.z.formatter), t.config.legend.formatter !== void 0 && (t.globals.legendFormatter = t.config.legend.formatter), t.config.yaxis.forEach(function(i, a) {
                        i.labels.formatter !== void 0 ? t.globals.yLabelFormatters[a] = i.labels.formatter : t.globals.yLabelFormatters[a] = function(s) {
                            return t.globals.xyCharts ? Array.isArray(s) ? s.map(function(r) {
                                return e.defaultYFormatter(r, i, a);
                            }) : e.defaultYFormatter(s, i, a) : s;
                        };
                    }), t.globals;
                }
            },
            {
                key: "heatmapLabelFormatters",
                value: function() {
                    var e = this.w;
                    if (e.config.chart.type === "heatmap") {
                        e.globals.yAxisScale[0].result = e.globals.seriesNames.slice();
                        var t = e.globals.seriesNames.reduce(function(i, a) {
                            return i.length > a.length ? i : a;
                        }, 0);
                        e.globals.yAxisScale[0].niceMax = t, e.globals.yAxisScale[0].niceMin = t;
                    }
                }
            }
        ]), y;
    }(), fe = function(y) {
        var e, t = y.isTimeline, i = y.ctx, a = y.seriesIndex, s = y.dataPointIndex, r = y.y1, n = y.y2, o = y.w, h = o.globals.seriesRangeStart[a][s], c = o.globals.seriesRangeEnd[a][s], d = o.globals.labels[s], g = o.config.series[a].name ? o.config.series[a].name : "", p = o.globals.ttKeyFormatter, f = o.config.tooltip.y.title.formatter, b = {
            w: o,
            seriesIndex: a,
            dataPointIndex: s,
            start: h,
            end: c
        };
        typeof f == "function" && (g = f(g, b)), (e = o.config.series[a].data[s]) !== null && e !== void 0 && e.x && (d = o.config.series[a].data[s].x), t || o.config.xaxis.type === "datetime" && (d = new re(i).xLabelFormat(o.globals.ttKeyFormatter, d, d, {
            i: void 0,
            dateFormatter: new B(i).formatDate,
            w: o
        })), typeof p == "function" && (d = p(d, b)), Number.isFinite(r) && Number.isFinite(n) && (h = r, c = n);
        var m = "", w = "", A = o.globals.colors[a];
        if (o.config.tooltip.x.formatter === void 0) {
            if (o.config.xaxis.type === "datetime") {
                var l = new B(i);
                m = l.formatDate(l.getDate(h), o.config.tooltip.x.format), w = l.formatDate(l.getDate(c), o.config.tooltip.x.format);
            } else m = h, w = c;
        } else m = o.config.tooltip.x.formatter(h), w = o.config.tooltip.x.formatter(c);
        return {
            start: h,
            end: c,
            startVal: m,
            endVal: w,
            ylabel: d,
            color: A,
            seriesName: g
        };
    }, ne = function(y) {
        var e = y.color, t = y.seriesName, i = y.ylabel, a = y.start, s = y.end, r = y.seriesIndex, n = y.dataPointIndex, o = y.ctx.tooltip.tooltipLabels.getFormatters(r);
        a = o.yLbFormatter(a), s = o.yLbFormatter(s);
        var h = o.yLbFormatter(y.w.globals.series[r][n]), c = `<span class="value start-value">
  `.concat(a, `
  </span> <span class="separator">-</span> <span class="value end-value">
  `).concat(s, `
  </span>`);
        return '<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: ' + e + '">' + (t || "") + '</span></div><div> <span class="category">' + i + ": </span> " + (y.w.globals.comboCharts ? y.w.config.series[r].type === "rangeArea" || y.w.config.series[r].type === "rangeBar" ? c : "<span>".concat(h, "</span>") : c) + " </div></div>";
    }, oe = function() {
        function y(e) {
            F(this, y), this.opts = e;
        }
        return Y(y, [
            {
                key: "hideYAxis",
                value: function() {
                    this.opts.yaxis[0].show = !1, this.opts.yaxis[0].title.text = "", this.opts.yaxis[0].axisBorder.show = !1, this.opts.yaxis[0].axisTicks.show = !1, this.opts.yaxis[0].floating = !0;
                }
            },
            {
                key: "line",
                value: function() {
                    return {
                        chart: {
                            animations: {
                                easing: "swing"
                            }
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        stroke: {
                            width: 5,
                            curve: "straight"
                        },
                        markers: {
                            size: 0,
                            hover: {
                                sizeOffset: 6
                            }
                        },
                        xaxis: {
                            crosshairs: {
                                width: 1
                            }
                        }
                    };
                }
            },
            {
                key: "sparkline",
                value: function(e) {
                    return this.hideYAxis(), P.extend(e, {
                        grid: {
                            show: !1,
                            padding: {
                                left: 0,
                                right: 0,
                                top: 0,
                                bottom: 0
                            }
                        },
                        legend: {
                            show: !1
                        },
                        xaxis: {
                            labels: {
                                show: !1
                            },
                            tooltip: {
                                enabled: !1
                            },
                            axisBorder: {
                                show: !1
                            },
                            axisTicks: {
                                show: !1
                            }
                        },
                        chart: {
                            toolbar: {
                                show: !1
                            },
                            zoom: {
                                enabled: !1
                            }
                        },
                        dataLabels: {
                            enabled: !1
                        }
                    });
                }
            },
            {
                key: "bar",
                value: function() {
                    return {
                        chart: {
                            stacked: !1,
                            animations: {
                                easing: "swing"
                            }
                        },
                        plotOptions: {
                            bar: {
                                dataLabels: {
                                    position: "center"
                                }
                            }
                        },
                        dataLabels: {
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            },
                            background: {
                                enabled: !1
                            }
                        },
                        stroke: {
                            width: 0,
                            lineCap: "round"
                        },
                        fill: {
                            opacity: 0.85
                        },
                        legend: {
                            markers: {
                                shape: "square",
                                radius: 2,
                                size: 8
                            }
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0
                        },
                        xaxis: {
                            tooltip: {
                                enabled: !1
                            },
                            tickPlacement: "between",
                            crosshairs: {
                                width: "barWidth",
                                position: "back",
                                fill: {
                                    type: "gradient"
                                },
                                dropShadow: {
                                    enabled: !1
                                },
                                stroke: {
                                    width: 0
                                }
                            }
                        }
                    };
                }
            },
            {
                key: "funnel",
                value: function() {
                    return this.hideYAxis(), X(X({}, this.bar()), {}, {
                        chart: {
                            animations: {
                                easing: "linear",
                                speed: 800,
                                animateGradually: {
                                    enabled: !1
                                }
                            }
                        },
                        plotOptions: {
                            bar: {
                                horizontal: !0,
                                borderRadiusApplication: "around",
                                borderRadius: 0,
                                dataLabels: {
                                    position: "center"
                                }
                            }
                        },
                        grid: {
                            show: !1,
                            padding: {
                                left: 0,
                                right: 0
                            }
                        },
                        xaxis: {
                            labels: {
                                show: !1
                            },
                            tooltip: {
                                enabled: !1
                            },
                            axisBorder: {
                                show: !1
                            },
                            axisTicks: {
                                show: !1
                            }
                        }
                    });
                }
            },
            {
                key: "candlestick",
                value: function() {
                    var e = this;
                    return {
                        stroke: {
                            width: 1,
                            colors: [
                                "#333"
                            ]
                        },
                        fill: {
                            opacity: 1
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        tooltip: {
                            shared: !0,
                            custom: function(t) {
                                var i = t.seriesIndex, a = t.dataPointIndex, s = t.w;
                                return e._getBoxTooltip(s, i, a, [
                                    "Open",
                                    "High",
                                    "",
                                    "Low",
                                    "Close"
                                ], "candlestick");
                            }
                        },
                        states: {
                            active: {
                                filter: {
                                    type: "none"
                                }
                            }
                        },
                        xaxis: {
                            crosshairs: {
                                width: 1
                            }
                        }
                    };
                }
            },
            {
                key: "boxPlot",
                value: function() {
                    var e = this;
                    return {
                        chart: {
                            animations: {
                                dynamicAnimation: {
                                    enabled: !1
                                }
                            }
                        },
                        stroke: {
                            width: 1,
                            colors: [
                                "#24292e"
                            ]
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        tooltip: {
                            shared: !0,
                            custom: function(t) {
                                var i = t.seriesIndex, a = t.dataPointIndex, s = t.w;
                                return e._getBoxTooltip(s, i, a, [
                                    "Minimum",
                                    "Q1",
                                    "Median",
                                    "Q3",
                                    "Maximum"
                                ], "boxPlot");
                            }
                        },
                        markers: {
                            size: 5,
                            strokeWidth: 1,
                            strokeColors: "#111"
                        },
                        xaxis: {
                            crosshairs: {
                                width: 1
                            }
                        }
                    };
                }
            },
            {
                key: "rangeBar",
                value: function() {
                    return {
                        chart: {
                            animations: {
                                animateGradually: !1
                            }
                        },
                        stroke: {
                            width: 0,
                            lineCap: "square"
                        },
                        plotOptions: {
                            bar: {
                                borderRadius: 0,
                                dataLabels: {
                                    position: "center"
                                }
                            }
                        },
                        dataLabels: {
                            enabled: !1,
                            formatter: function(e, t) {
                                t.ctx;
                                var i = t.seriesIndex, a = t.dataPointIndex, s = t.w, r = function() {
                                    var n = s.globals.seriesRangeStart[i][a];
                                    return s.globals.seriesRangeEnd[i][a] - n;
                                };
                                return s.globals.comboCharts ? s.config.series[i].type === "rangeBar" || s.config.series[i].type === "rangeArea" ? r() : e : r();
                            },
                            background: {
                                enabled: !1
                            },
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            }
                        },
                        markers: {
                            size: 10
                        },
                        tooltip: {
                            shared: !1,
                            followCursor: !0,
                            custom: function(e) {
                                return e.w.config.plotOptions && e.w.config.plotOptions.bar && e.w.config.plotOptions.bar.horizontal ? function(t) {
                                    var i = fe(X(X({}, t), {}, {
                                        isTimeline: !0
                                    })), a = i.color, s = i.seriesName, r = i.ylabel, n = i.startVal, o = i.endVal;
                                    return ne(X(X({}, t), {}, {
                                        color: a,
                                        seriesName: s,
                                        ylabel: r,
                                        start: n,
                                        end: o
                                    }));
                                }(e) : function(t) {
                                    var i = fe(t), a = i.color, s = i.seriesName, r = i.ylabel, n = i.start, o = i.end;
                                    return ne(X(X({}, t), {}, {
                                        color: a,
                                        seriesName: s,
                                        ylabel: r,
                                        start: n,
                                        end: o
                                    }));
                                }(e);
                            }
                        },
                        xaxis: {
                            tickPlacement: "between",
                            tooltip: {
                                enabled: !1
                            },
                            crosshairs: {
                                stroke: {
                                    width: 0
                                }
                            }
                        }
                    };
                }
            },
            {
                key: "dumbbell",
                value: function(e) {
                    var t, i;
                    return (t = e.plotOptions.bar) !== null && t !== void 0 && t.barHeight || (e.plotOptions.bar.barHeight = 2), (i = e.plotOptions.bar) !== null && i !== void 0 && i.columnWidth || (e.plotOptions.bar.columnWidth = 2), e;
                }
            },
            {
                key: "area",
                value: function() {
                    return {
                        stroke: {
                            width: 4,
                            fill: {
                                type: "solid",
                                gradient: {
                                    inverseColors: !1,
                                    shade: "light",
                                    type: "vertical",
                                    opacityFrom: 0.65,
                                    opacityTo: 0.5,
                                    stops: [
                                        0,
                                        100,
                                        100
                                    ]
                                }
                            }
                        },
                        fill: {
                            type: "gradient",
                            gradient: {
                                inverseColors: !1,
                                shade: "light",
                                type: "vertical",
                                opacityFrom: 0.65,
                                opacityTo: 0.5,
                                stops: [
                                    0,
                                    100,
                                    100
                                ]
                            }
                        },
                        markers: {
                            size: 0,
                            hover: {
                                sizeOffset: 6
                            }
                        },
                        tooltip: {
                            followCursor: !1
                        }
                    };
                }
            },
            {
                key: "rangeArea",
                value: function() {
                    return {
                        stroke: {
                            curve: "straight",
                            width: 0
                        },
                        fill: {
                            type: "solid",
                            opacity: 0.6
                        },
                        markers: {
                            size: 0
                        },
                        states: {
                            hover: {
                                filter: {
                                    type: "none"
                                }
                            },
                            active: {
                                filter: {
                                    type: "none"
                                }
                            }
                        },
                        tooltip: {
                            intersect: !1,
                            shared: !0,
                            followCursor: !0,
                            custom: function(e) {
                                return function(t) {
                                    var i = fe(t), a = i.color, s = i.seriesName, r = i.ylabel, n = i.start, o = i.end;
                                    return ne(X(X({}, t), {}, {
                                        color: a,
                                        seriesName: s,
                                        ylabel: r,
                                        start: n,
                                        end: o
                                    }));
                                }(e);
                            }
                        }
                    };
                }
            },
            {
                key: "brush",
                value: function(e) {
                    return P.extend(e, {
                        chart: {
                            toolbar: {
                                autoSelected: "selection",
                                show: !1
                            },
                            zoom: {
                                enabled: !1
                            }
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        stroke: {
                            width: 1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        xaxis: {
                            tooltip: {
                                enabled: !1
                            }
                        }
                    });
                }
            },
            {
                key: "stacked100",
                value: function(e) {
                    e.dataLabels = e.dataLabels || {}, e.dataLabels.formatter = e.dataLabels.formatter || void 0;
                    var t = e.dataLabels.formatter;
                    return e.yaxis.forEach(function(i, a) {
                        e.yaxis[a].min = 0, e.yaxis[a].max = 100;
                    }), e.chart.type === "bar" && (e.dataLabels.formatter = t || function(i) {
                        return typeof i == "number" && i ? i.toFixed(0) + "%" : i;
                    }), e;
                }
            },
            {
                key: "stackedBars",
                value: function() {
                    var e = this.bar();
                    return X(X({}, e), {}, {
                        plotOptions: X(X({}, e.plotOptions), {}, {
                            bar: X(X({}, e.plotOptions.bar), {}, {
                                borderRadiusApplication: "end",
                                borderRadiusWhenStacked: "last"
                            })
                        })
                    });
                }
            },
            {
                key: "convertCatToNumeric",
                value: function(e) {
                    return e.xaxis.convertedCatToNumeric = !0, e;
                }
            },
            {
                key: "convertCatToNumericXaxis",
                value: function(e, t, i) {
                    e.xaxis.type = "numeric", e.xaxis.labels = e.xaxis.labels || {}, e.xaxis.labels.formatter = e.xaxis.labels.formatter || function(r) {
                        return P.isNumber(r) ? Math.floor(r) : r;
                    };
                    var a = e.xaxis.labels.formatter, s = e.xaxis.categories && e.xaxis.categories.length ? e.xaxis.categories : e.labels;
                    return i && i.length && (s = i.map(function(r) {
                        return Array.isArray(r) ? r : String(r);
                    })), s && s.length && (e.xaxis.labels.formatter = function(r) {
                        return P.isNumber(r) ? a(s[Math.floor(r) - 1]) : a(r);
                    }), e.xaxis.categories = [], e.labels = [], e.xaxis.tickAmount = e.xaxis.tickAmount || "dataPoints", e;
                }
            },
            {
                key: "bubble",
                value: function() {
                    return {
                        dataLabels: {
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            }
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0
                        },
                        xaxis: {
                            crosshairs: {
                                width: 0
                            }
                        },
                        fill: {
                            type: "solid",
                            gradient: {
                                shade: "light",
                                inverse: !0,
                                shadeIntensity: 0.55,
                                opacityFrom: 0.4,
                                opacityTo: 0.8
                            }
                        }
                    };
                }
            },
            {
                key: "scatter",
                value: function() {
                    return {
                        dataLabels: {
                            enabled: !1
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0
                        },
                        markers: {
                            size: 6,
                            strokeWidth: 1,
                            hover: {
                                sizeOffset: 2
                            }
                        }
                    };
                }
            },
            {
                key: "heatmap",
                value: function() {
                    return {
                        chart: {
                            stacked: !1
                        },
                        fill: {
                            opacity: 1
                        },
                        dataLabels: {
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            }
                        },
                        stroke: {
                            colors: [
                                "#fff"
                            ]
                        },
                        tooltip: {
                            followCursor: !0,
                            marker: {
                                show: !1
                            },
                            x: {
                                show: !1
                            }
                        },
                        legend: {
                            position: "top",
                            markers: {
                                shape: "square",
                                size: 10,
                                offsetY: 2
                            }
                        },
                        grid: {
                            padding: {
                                right: 20
                            }
                        }
                    };
                }
            },
            {
                key: "treemap",
                value: function() {
                    return {
                        chart: {
                            zoom: {
                                enabled: !1
                            }
                        },
                        dataLabels: {
                            style: {
                                fontSize: 14,
                                fontWeight: 600,
                                colors: [
                                    "#fff"
                                ]
                            }
                        },
                        stroke: {
                            show: !0,
                            width: 2,
                            colors: [
                                "#fff"
                            ]
                        },
                        legend: {
                            show: !1
                        },
                        fill: {
                            gradient: {
                                stops: [
                                    0,
                                    100
                                ]
                            }
                        },
                        tooltip: {
                            followCursor: !0,
                            x: {
                                show: !1
                            }
                        },
                        grid: {
                            padding: {
                                left: 0,
                                right: 0
                            }
                        },
                        xaxis: {
                            crosshairs: {
                                show: !1
                            },
                            tooltip: {
                                enabled: !1
                            }
                        }
                    };
                }
            },
            {
                key: "pie",
                value: function() {
                    return {
                        chart: {
                            toolbar: {
                                show: !1
                            }
                        },
                        plotOptions: {
                            pie: {
                                donut: {
                                    labels: {
                                        show: !1
                                    }
                                }
                            }
                        },
                        dataLabels: {
                            formatter: function(e) {
                                return e.toFixed(1) + "%";
                            },
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            },
                            background: {
                                enabled: !1
                            },
                            dropShadow: {
                                enabled: !0
                            }
                        },
                        stroke: {
                            colors: [
                                "#fff"
                            ]
                        },
                        fill: {
                            opacity: 1,
                            gradient: {
                                shade: "light",
                                stops: [
                                    0,
                                    100
                                ]
                            }
                        },
                        tooltip: {
                            theme: "dark",
                            fillSeriesColor: !0
                        },
                        legend: {
                            position: "right"
                        }
                    };
                }
            },
            {
                key: "donut",
                value: function() {
                    return {
                        chart: {
                            toolbar: {
                                show: !1
                            }
                        },
                        dataLabels: {
                            formatter: function(e) {
                                return e.toFixed(1) + "%";
                            },
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            },
                            background: {
                                enabled: !1
                            },
                            dropShadow: {
                                enabled: !0
                            }
                        },
                        stroke: {
                            colors: [
                                "#fff"
                            ]
                        },
                        fill: {
                            opacity: 1,
                            gradient: {
                                shade: "light",
                                shadeIntensity: 0.35,
                                stops: [
                                    80,
                                    100
                                ],
                                opacityFrom: 1,
                                opacityTo: 1
                            }
                        },
                        tooltip: {
                            theme: "dark",
                            fillSeriesColor: !0
                        },
                        legend: {
                            position: "right"
                        }
                    };
                }
            },
            {
                key: "polarArea",
                value: function() {
                    return this.opts.yaxis[0].tickAmount = this.opts.yaxis[0].tickAmount ? this.opts.yaxis[0].tickAmount : 6, {
                        chart: {
                            toolbar: {
                                show: !1
                            }
                        },
                        dataLabels: {
                            formatter: function(e) {
                                return e.toFixed(1) + "%";
                            },
                            enabled: !1
                        },
                        stroke: {
                            show: !0,
                            width: 2
                        },
                        fill: {
                            opacity: 0.7
                        },
                        tooltip: {
                            theme: "dark",
                            fillSeriesColor: !0
                        },
                        legend: {
                            position: "right"
                        }
                    };
                }
            },
            {
                key: "radar",
                value: function() {
                    return this.opts.yaxis[0].labels.offsetY = this.opts.yaxis[0].labels.offsetY ? this.opts.yaxis[0].labels.offsetY : 6, {
                        dataLabels: {
                            enabled: !1,
                            style: {
                                fontSize: "11px"
                            }
                        },
                        stroke: {
                            width: 2
                        },
                        markers: {
                            size: 3,
                            strokeWidth: 1,
                            strokeOpacity: 1
                        },
                        fill: {
                            opacity: 0.2
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0,
                            followCursor: !0
                        },
                        grid: {
                            show: !1
                        },
                        xaxis: {
                            labels: {
                                formatter: function(e) {
                                    return e;
                                },
                                style: {
                                    colors: [
                                        "#a8a8a8"
                                    ],
                                    fontSize: "11px"
                                }
                            },
                            tooltip: {
                                enabled: !1
                            },
                            crosshairs: {
                                show: !1
                            }
                        }
                    };
                }
            },
            {
                key: "radialBar",
                value: function() {
                    return {
                        chart: {
                            animations: {
                                dynamicAnimation: {
                                    enabled: !0,
                                    speed: 800
                                }
                            },
                            toolbar: {
                                show: !1
                            }
                        },
                        fill: {
                            gradient: {
                                shade: "dark",
                                shadeIntensity: 0.4,
                                inverseColors: !1,
                                type: "diagonal2",
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [
                                    70,
                                    98,
                                    100
                                ]
                            }
                        },
                        legend: {
                            show: !1,
                            position: "right"
                        },
                        tooltip: {
                            enabled: !1,
                            fillSeriesColor: !0
                        }
                    };
                }
            },
            {
                key: "_getBoxTooltip",
                value: function(e, t, i, a, s) {
                    var r = e.globals.seriesCandleO[t][i], n = e.globals.seriesCandleH[t][i], o = e.globals.seriesCandleM[t][i], h = e.globals.seriesCandleL[t][i], c = e.globals.seriesCandleC[t][i];
                    return e.config.series[t].type && e.config.series[t].type !== s ? `<div class="apexcharts-custom-tooltip">
          `.concat(e.config.series[t].name ? e.config.series[t].name : "series-" + (t + 1), ": <strong>").concat(e.globals.series[t][i], `</strong>
        </div>`) : '<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(e.config.chart.type, '">') + "<div>".concat(a[0], ': <span class="value">') + r + "</span></div>" + "<div>".concat(a[1], ': <span class="value">') + n + "</span></div>" + (o ? "<div>".concat(a[2], ': <span class="value">') + o + "</span></div>" : "") + "<div>".concat(a[3], ': <span class="value">') + h + "</span></div>" + "<div>".concat(a[4], ': <span class="value">') + c + "</span></div></div>";
                }
            }
        ]), y;
    }(), Le = function() {
        function y(e) {
            F(this, y), this.opts = e;
        }
        return Y(y, [
            {
                key: "init",
                value: function(e) {
                    var t = e.responsiveOverride, i = this.opts, a = new G(), s = new oe(i);
                    this.chartType = i.chart.type, i = this.extendYAxis(i), i = this.extendAnnotations(i);
                    var r = a.init(), n = {};
                    if (i && U(i) === "object") {
                        var o, h, c, d, g, p, f, b, m = {};
                        m = [
                            "line",
                            "area",
                            "bar",
                            "candlestick",
                            "boxPlot",
                            "rangeBar",
                            "rangeArea",
                            "bubble",
                            "scatter",
                            "heatmap",
                            "treemap",
                            "pie",
                            "polarArea",
                            "donut",
                            "radar",
                            "radialBar"
                        ].indexOf(i.chart.type) !== -1 ? s[i.chart.type]() : s.line(), (o = i.plotOptions) !== null && o !== void 0 && (h = o.bar) !== null && h !== void 0 && h.isFunnel && (m = s.funnel()), i.chart.stacked && i.chart.type === "bar" && (m = s.stackedBars()), (c = i.chart.brush) !== null && c !== void 0 && c.enabled && (m = s.brush(m)), i.chart.stacked && i.chart.stackType === "100%" && (i = s.stacked100(i)), (d = i.plotOptions) !== null && d !== void 0 && (g = d.bar) !== null && g !== void 0 && g.isDumbbell && (i = s.dumbbell(i)), this.checkForDarkTheme(window.Apex), this.checkForDarkTheme(i), i.xaxis = i.xaxis || window.Apex.xaxis || {}, t || (i.xaxis.convertedCatToNumeric = !1), ((p = (i = this.checkForCatToNumericXAxis(this.chartType, m, i)).chart.sparkline) !== null && p !== void 0 && p.enabled || (f = window.Apex.chart) !== null && f !== void 0 && (b = f.sparkline) !== null && b !== void 0 && b.enabled) && (m = s.sparkline(m)), n = P.extend(r, m);
                    }
                    var w = P.extend(n, window.Apex);
                    return r = P.extend(w, i), r = this.handleUserInputErrors(r);
                }
            },
            {
                key: "checkForCatToNumericXAxis",
                value: function(e, t, i) {
                    var a, s, r = new oe(i), n = (e === "bar" || e === "boxPlot") && ((a = i.plotOptions) === null || a === void 0 || (s = a.bar) === null || s === void 0 ? void 0 : s.horizontal), o = e === "pie" || e === "polarArea" || e === "donut" || e === "radar" || e === "radialBar" || e === "heatmap", h = i.xaxis.type !== "datetime" && i.xaxis.type !== "numeric", c = i.xaxis.tickPlacement ? i.xaxis.tickPlacement : t.xaxis && t.xaxis.tickPlacement;
                    return n || o || !h || c === "between" || (i = r.convertCatToNumeric(i)), i;
                }
            },
            {
                key: "extendYAxis",
                value: function(e, t) {
                    var i = new G();
                    (e.yaxis === void 0 || !e.yaxis || Array.isArray(e.yaxis) && e.yaxis.length === 0) && (e.yaxis = {}), e.yaxis.constructor !== Array && window.Apex.yaxis && window.Apex.yaxis.constructor !== Array && (e.yaxis = P.extend(e.yaxis, window.Apex.yaxis)), e.yaxis.constructor !== Array ? e.yaxis = [
                        P.extend(i.yAxis, e.yaxis)
                    ] : e.yaxis = P.extendArray(e.yaxis, i.yAxis);
                    var a = !1;
                    e.yaxis.forEach(function(r) {
                        r.logarithmic && (a = !0);
                    });
                    var s = e.series;
                    return t && !s && (s = t.config.series), a && s.length !== e.yaxis.length && s.length && (e.yaxis = s.map(function(r, n) {
                        if (r.name || (s[n].name = "series-".concat(n + 1)), e.yaxis[n]) return e.yaxis[n].seriesName = s[n].name, e.yaxis[n];
                        var o = P.extend(i.yAxis, e.yaxis[0]);
                        return o.show = !1, o;
                    })), a && s.length > 1 && s.length !== e.yaxis.length && console.warn("A multi-series logarithmic chart should have equal number of series and y-axes"), e;
                }
            },
            {
                key: "extendAnnotations",
                value: function(e) {
                    return e.annotations === void 0 && (e.annotations = {}, e.annotations.yaxis = [], e.annotations.xaxis = [], e.annotations.points = []), e = this.extendYAxisAnnotations(e), e = this.extendXAxisAnnotations(e), e = this.extendPointAnnotations(e);
                }
            },
            {
                key: "extendYAxisAnnotations",
                value: function(e) {
                    var t = new G();
                    return e.annotations.yaxis = P.extendArray(e.annotations.yaxis !== void 0 ? e.annotations.yaxis : [], t.yAxisAnnotation), e;
                }
            },
            {
                key: "extendXAxisAnnotations",
                value: function(e) {
                    var t = new G();
                    return e.annotations.xaxis = P.extendArray(e.annotations.xaxis !== void 0 ? e.annotations.xaxis : [], t.xAxisAnnotation), e;
                }
            },
            {
                key: "extendPointAnnotations",
                value: function(e) {
                    var t = new G();
                    return e.annotations.points = P.extendArray(e.annotations.points !== void 0 ? e.annotations.points : [], t.pointAnnotation), e;
                }
            },
            {
                key: "checkForDarkTheme",
                value: function(e) {
                    e.theme && e.theme.mode === "dark" && (e.tooltip || (e.tooltip = {}), e.tooltip.theme !== "light" && (e.tooltip.theme = "dark"), e.chart.foreColor || (e.chart.foreColor = "#f6f7f8"), e.chart.background || (e.chart.background = "#424242"), e.theme.palette || (e.theme.palette = "palette4"));
                }
            },
            {
                key: "handleUserInputErrors",
                value: function(e) {
                    var t = e;
                    if (t.tooltip.shared && t.tooltip.intersect) throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");
                    if (t.chart.type === "bar" && t.plotOptions.bar.horizontal) {
                        if (t.yaxis.length > 1) throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");
                        t.yaxis[0].reversed && (t.yaxis[0].opposite = !0), t.xaxis.tooltip.enabled = !1, t.yaxis[0].tooltip.enabled = !1, t.chart.zoom.enabled = !1;
                    }
                    return t.chart.type !== "bar" && t.chart.type !== "rangeBar" || t.tooltip.shared && t.xaxis.crosshairs.width === "barWidth" && t.series.length > 1 && (t.xaxis.crosshairs.width = "tickWidth"), t.chart.type !== "candlestick" && t.chart.type !== "boxPlot" || t.yaxis[0].reversed && (console.warn("Reversed y-axis in ".concat(t.chart.type, " chart is not supported.")), t.yaxis[0].reversed = !1), t;
                }
            }
        ]), y;
    }(), Ze = function() {
        function y() {
            F(this, y);
        }
        return Y(y, [
            {
                key: "initGlobalVars",
                value: function(e) {
                    e.series = [], e.seriesCandleO = [], e.seriesCandleH = [], e.seriesCandleM = [], e.seriesCandleL = [], e.seriesCandleC = [], e.seriesRangeStart = [], e.seriesRangeEnd = [], e.seriesRange = [], e.seriesPercent = [], e.seriesGoals = [], e.seriesX = [], e.seriesZ = [], e.seriesNames = [], e.seriesTotals = [], e.seriesLog = [], e.seriesColors = [], e.stackedSeriesTotals = [], e.seriesXvalues = [], e.seriesYvalues = [], e.labels = [], e.hasXaxisGroups = !1, e.groups = [], e.hasSeriesGroups = !1, e.seriesGroups = [], e.categoryLabels = [], e.timescaleLabels = [], e.noLabelsProvided = !1, e.resizeTimer = null, e.selectionResizeTimer = null, e.delayedElements = [], e.pointsArray = [], e.dataLabelsRects = [], e.isXNumeric = !1, e.skipLastTimelinelabel = !1, e.skipFirstTimelinelabel = !1, e.isDataXYZ = !1, e.isMultiLineX = !1, e.isMultipleYAxis = !1, e.maxY = -Number.MAX_VALUE, e.minY = Number.MIN_VALUE, e.minYArr = [], e.maxYArr = [], e.maxX = -Number.MAX_VALUE, e.minX = Number.MAX_VALUE, e.initialMaxX = -Number.MAX_VALUE, e.initialMinX = Number.MAX_VALUE, e.maxDate = 0, e.minDate = Number.MAX_VALUE, e.minZ = Number.MAX_VALUE, e.maxZ = -Number.MAX_VALUE, e.minXDiff = Number.MAX_VALUE, e.yAxisScale = [], e.xAxisScale = null, e.xAxisTicksPositions = [], e.yLabelsCoords = [], e.yTitleCoords = [], e.barPadForNumericAxis = 0, e.padHorizontal = 0, e.xRange = 0, e.yRange = [], e.zRange = 0, e.dataPoints = 0, e.xTickAmount = 0;
                }
            },
            {
                key: "globalVars",
                value: function(e) {
                    return {
                        chartID: null,
                        cuid: null,
                        events: {
                            beforeMount: [],
                            mounted: [],
                            updated: [],
                            clicked: [],
                            selection: [],
                            dataPointSelection: [],
                            zoomed: [],
                            scrolled: []
                        },
                        colors: [],
                        clientX: null,
                        clientY: null,
                        fill: {
                            colors: []
                        },
                        stroke: {
                            colors: []
                        },
                        dataLabels: {
                            style: {
                                colors: []
                            }
                        },
                        radarPolygons: {
                            fill: {
                                colors: []
                            }
                        },
                        markers: {
                            colors: [],
                            size: e.markers.size,
                            largestSize: 0
                        },
                        animationEnded: !1,
                        isTouchDevice: "ontouchstart" in window || navigator.msMaxTouchPoints,
                        isDirty: !1,
                        isExecCalled: !1,
                        initialConfig: null,
                        initialSeries: [],
                        lastXAxis: [],
                        lastYAxis: [],
                        columnSeries: null,
                        labels: [],
                        timescaleLabels: [],
                        noLabelsProvided: !1,
                        allSeriesCollapsed: !1,
                        collapsedSeries: [],
                        collapsedSeriesIndices: [],
                        ancillaryCollapsedSeries: [],
                        ancillaryCollapsedSeriesIndices: [],
                        risingSeries: [],
                        dataFormatXNumeric: !1,
                        capturedSeriesIndex: -1,
                        capturedDataPointIndex: -1,
                        selectedDataPoints: [],
                        goldenPadding: 35,
                        invalidLogScale: !1,
                        ignoreYAxisIndexes: [],
                        yAxisSameScaleIndices: [],
                        maxValsInArrayIndex: 0,
                        radialSize: 0,
                        selection: void 0,
                        zoomEnabled: e.chart.toolbar.autoSelected === "zoom" && e.chart.toolbar.tools.zoom && e.chart.zoom.enabled,
                        panEnabled: e.chart.toolbar.autoSelected === "pan" && e.chart.toolbar.tools.pan,
                        selectionEnabled: e.chart.toolbar.autoSelected === "selection" && e.chart.toolbar.tools.selection,
                        yaxis: null,
                        mousedown: !1,
                        lastClientPosition: {},
                        visibleXRange: void 0,
                        yValueDecimal: 0,
                        total: 0,
                        SVGNS: "http://www.w3.org/2000/svg",
                        svgWidth: 0,
                        svgHeight: 0,
                        noData: !1,
                        locale: {},
                        dom: {},
                        memory: {
                            methodsToExec: []
                        },
                        shouldAnimate: !0,
                        skipLastTimelinelabel: !1,
                        skipFirstTimelinelabel: !1,
                        delayedElements: [],
                        axisCharts: !0,
                        isDataXYZ: !1,
                        resized: !1,
                        resizeTimer: null,
                        comboCharts: !1,
                        dataChanged: !1,
                        previousPaths: [],
                        allSeriesHasEqualX: !0,
                        pointsArray: [],
                        dataLabelsRects: [],
                        lastDrawnDataLabelsIndexes: [],
                        hasNullValues: !1,
                        easing: null,
                        zoomed: !1,
                        gridWidth: 0,
                        gridHeight: 0,
                        rotateXLabels: !1,
                        defaultLabels: !1,
                        xLabelFormatter: void 0,
                        yLabelFormatters: [],
                        xaxisTooltipFormatter: void 0,
                        ttKeyFormatter: void 0,
                        ttVal: void 0,
                        ttZFormatter: void 0,
                        LINE_HEIGHT_RATIO: 1.618,
                        xAxisLabelsHeight: 0,
                        xAxisGroupLabelsHeight: 0,
                        xAxisLabelsWidth: 0,
                        yAxisLabelsWidth: 0,
                        scaleX: 1,
                        scaleY: 1,
                        translateX: 0,
                        translateY: 0,
                        translateYAxisX: [],
                        yAxisWidths: [],
                        translateXAxisY: 0,
                        translateXAxisX: 0,
                        tooltip: null
                    };
                }
            },
            {
                key: "init",
                value: function(e) {
                    var t = this.globalVars(e);
                    return this.initGlobalVars(t), t.initialConfig = P.extend({}, e), t.initialSeries = P.clone(e.series), t.lastXAxis = P.clone(t.initialConfig.xaxis), t.lastYAxis = P.clone(t.initialConfig.yaxis), t;
                }
            }
        ]), y;
    }(), ft = function() {
        function y(e) {
            F(this, y), this.opts = e;
        }
        return Y(y, [
            {
                key: "init",
                value: function() {
                    var e = new Le(this.opts).init({
                        responsiveOverride: !1
                    });
                    return {
                        config: e,
                        globals: new Ze().init(e)
                    };
                }
            }
        ]), y;
    }(), ae = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.opts = null, this.seriesIndex = 0;
        }
        return Y(y, [
            {
                key: "clippedImgArea",
                value: function(e) {
                    var t = this.w, i = t.config, a = parseInt(t.globals.gridWidth, 10), s = parseInt(t.globals.gridHeight, 10), r = a > s ? a : s, n = e.image, o = 0, h = 0;
                    e.width === void 0 && e.height === void 0 ? i.fill.image.width !== void 0 && i.fill.image.height !== void 0 ? (o = i.fill.image.width + 1, h = i.fill.image.height) : (o = r + 1, h = r) : (o = e.width, h = e.height);
                    var c = document.createElementNS(t.globals.SVGNS, "pattern");
                    M.setAttrs(c, {
                        id: e.patternID,
                        patternUnits: e.patternUnits ? e.patternUnits : "userSpaceOnUse",
                        width: o + "px",
                        height: h + "px"
                    });
                    var d = document.createElementNS(t.globals.SVGNS, "image");
                    c.appendChild(d), d.setAttributeNS(window.SVG.xlink, "href", n), M.setAttrs(d, {
                        x: 0,
                        y: 0,
                        preserveAspectRatio: "none",
                        width: o + "px",
                        height: h + "px"
                    }), d.style.opacity = e.opacity, t.globals.dom.elDefs.node.appendChild(c);
                }
            },
            {
                key: "getSeriesIndex",
                value: function(e) {
                    var t = this.w, i = t.config.chart.type;
                    return (i === "bar" || i === "rangeBar") && t.config.plotOptions.bar.distributed || i === "heatmap" || i === "treemap" ? this.seriesIndex = e.seriesNumber : this.seriesIndex = e.seriesNumber % t.globals.series.length, this.seriesIndex;
                }
            },
            {
                key: "fillPath",
                value: function(e) {
                    var t = this.w;
                    this.opts = e;
                    var i, a, s, r = this.w.config;
                    this.seriesIndex = this.getSeriesIndex(e);
                    var n = this.getFillColors()[this.seriesIndex];
                    t.globals.seriesColors[this.seriesIndex] !== void 0 && (n = t.globals.seriesColors[this.seriesIndex]), typeof n == "function" && (n = n({
                        seriesIndex: this.seriesIndex,
                        dataPointIndex: e.dataPointIndex,
                        value: e.value,
                        w: t
                    }));
                    var o = e.fillType ? e.fillType : this.getFillType(this.seriesIndex), h = Array.isArray(r.fill.opacity) ? r.fill.opacity[this.seriesIndex] : r.fill.opacity;
                    e.color && (n = e.color), n || (n = "#fff", console.warn("undefined color - ApexCharts"));
                    var c = n;
                    if (n.indexOf("rgb") === -1 ? n.length < 9 && (c = P.hexToRgba(n, h)) : n.indexOf("rgba") > -1 && (h = P.getOpacityFromRGBA(n)), e.opacity && (h = e.opacity), o === "pattern" && (a = this.handlePatternFill({
                        fillConfig: e.fillConfig,
                        patternFill: a,
                        fillColor: n,
                        fillOpacity: h,
                        defaultColor: c
                    })), o === "gradient" && (s = this.handleGradientFill({
                        fillConfig: e.fillConfig,
                        fillColor: n,
                        fillOpacity: h,
                        i: this.seriesIndex
                    })), o === "image") {
                        var d = r.fill.image.src, g = e.patternID ? e.patternID : "";
                        this.clippedImgArea({
                            opacity: h,
                            image: Array.isArray(d) ? e.seriesNumber < d.length ? d[e.seriesNumber] : d[0] : d,
                            width: e.width ? e.width : void 0,
                            height: e.height ? e.height : void 0,
                            patternUnits: e.patternUnits,
                            patternID: "pattern".concat(t.globals.cuid).concat(e.seriesNumber + 1).concat(g)
                        }), i = "url(#pattern".concat(t.globals.cuid).concat(e.seriesNumber + 1).concat(g, ")");
                    } else i = o === "gradient" ? s : o === "pattern" ? a : c;
                    return e.solid && (i = c), i;
                }
            },
            {
                key: "getFillType",
                value: function(e) {
                    var t = this.w;
                    return Array.isArray(t.config.fill.type) ? t.config.fill.type[e] : t.config.fill.type;
                }
            },
            {
                key: "getFillColors",
                value: function() {
                    var e = this.w, t = e.config, i = this.opts, a = [];
                    return e.globals.comboCharts ? e.config.series[this.seriesIndex].type === "line" ? Array.isArray(e.globals.stroke.colors) ? a = e.globals.stroke.colors : a.push(e.globals.stroke.colors) : Array.isArray(e.globals.fill.colors) ? a = e.globals.fill.colors : a.push(e.globals.fill.colors) : t.chart.type === "line" ? Array.isArray(e.globals.stroke.colors) ? a = e.globals.stroke.colors : a.push(e.globals.stroke.colors) : Array.isArray(e.globals.fill.colors) ? a = e.globals.fill.colors : a.push(e.globals.fill.colors), i.fillColors !== void 0 && (a = [], Array.isArray(i.fillColors) ? a = i.fillColors.slice() : a.push(i.fillColors)), a;
                }
            },
            {
                key: "handlePatternFill",
                value: function(e) {
                    var t = e.fillConfig, i = e.patternFill, a = e.fillColor, s = e.fillOpacity, r = e.defaultColor, n = this.w.config.fill;
                    t && (n = t);
                    var o = this.opts, h = new M(this.ctx), c = Array.isArray(n.pattern.strokeWidth) ? n.pattern.strokeWidth[this.seriesIndex] : n.pattern.strokeWidth, d = a;
                    return Array.isArray(n.pattern.style) ? i = n.pattern.style[o.seriesNumber] !== void 0 ? h.drawPattern(n.pattern.style[o.seriesNumber], n.pattern.width, n.pattern.height, d, c, s) : r : i = h.drawPattern(n.pattern.style, n.pattern.width, n.pattern.height, d, c, s), i;
                }
            },
            {
                key: "handleGradientFill",
                value: function(e) {
                    var t = e.fillColor, i = e.fillOpacity, a = e.fillConfig, s = e.i, r = this.w.config.fill;
                    a && (r = X(X({}, r), a));
                    var n, o = this.opts, h = new M(this.ctx), c = new P(), d = r.gradient.type, g = t, p = r.gradient.opacityFrom === void 0 ? i : Array.isArray(r.gradient.opacityFrom) ? r.gradient.opacityFrom[s] : r.gradient.opacityFrom;
                    g.indexOf("rgba") > -1 && (p = P.getOpacityFromRGBA(g));
                    var f = r.gradient.opacityTo === void 0 ? i : Array.isArray(r.gradient.opacityTo) ? r.gradient.opacityTo[s] : r.gradient.opacityTo;
                    if (r.gradient.gradientToColors === void 0 || r.gradient.gradientToColors.length === 0) n = r.gradient.shade === "dark" ? c.shadeColor(-1 * parseFloat(r.gradient.shadeIntensity), t.indexOf("rgb") > -1 ? P.rgb2hex(t) : t) : c.shadeColor(parseFloat(r.gradient.shadeIntensity), t.indexOf("rgb") > -1 ? P.rgb2hex(t) : t);
                    else if (r.gradient.gradientToColors[o.seriesNumber]) {
                        var b = r.gradient.gradientToColors[o.seriesNumber];
                        n = b, b.indexOf("rgba") > -1 && (f = P.getOpacityFromRGBA(b));
                    } else n = t;
                    if (r.gradient.gradientFrom && (g = r.gradient.gradientFrom), r.gradient.gradientTo && (n = r.gradient.gradientTo), r.gradient.inverseColors) {
                        var m = g;
                        g = n, n = m;
                    }
                    return g.indexOf("rgb") > -1 && (g = P.rgb2hex(g)), n.indexOf("rgb") > -1 && (n = P.rgb2hex(n)), h.drawGradient(d, g, n, p, f, o.size, r.gradient.stops, r.gradient.colorStops, s);
                }
            }
        ]), y;
    }(), Pe = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "setGlobalMarkerSize",
                value: function() {
                    var e = this.w;
                    if (e.globals.markers.size = Array.isArray(e.config.markers.size) ? e.config.markers.size : [
                        e.config.markers.size
                    ], e.globals.markers.size.length > 0) {
                        if (e.globals.markers.size.length < e.globals.series.length + 1) for(var t = 0; t <= e.globals.series.length; t++)e.globals.markers.size[t] === void 0 && e.globals.markers.size.push(e.globals.markers.size[0]);
                    } else e.globals.markers.size = e.config.series.map(function(i) {
                        return e.config.markers.size;
                    });
                }
            },
            {
                key: "plotChartMarkers",
                value: function(e, t, i, a) {
                    var s, r = arguments.length > 4 && arguments[4] !== void 0 && arguments[4], n = this.w, o = t, h = e, c = null, d = new M(this.ctx), g = n.config.markers.discrete && n.config.markers.discrete.length;
                    if ((n.globals.markers.size[t] > 0 || r || g) && (c = d.group({
                        class: r || g ? "" : "apexcharts-series-markers"
                    })).attr("clip-path", "url(#gridRectMarkerMask".concat(n.globals.cuid, ")")), Array.isArray(h.x)) for(var p = 0; p < h.x.length; p++){
                        var f = i;
                        i === 1 && p === 0 && (f = 0), i === 1 && p === 1 && (f = 1);
                        var b = "apexcharts-marker";
                        if (n.config.chart.type !== "line" && n.config.chart.type !== "area" || n.globals.comboCharts || n.config.tooltip.intersect || (b += " no-pointer-events"), (Array.isArray(n.config.markers.size) ? n.globals.markers.size[t] > 0 : n.config.markers.size > 0) || r || g) {
                            P.isNumber(h.y[p]) ? b += " w".concat(P.randomId()) : b = "apexcharts-nullpoint";
                            var m = this.getMarkerConfig({
                                cssClass: b,
                                seriesIndex: t,
                                dataPointIndex: f
                            });
                            n.config.series[o].data[f] && (n.config.series[o].data[f].fillColor && (m.pointFillColor = n.config.series[o].data[f].fillColor), n.config.series[o].data[f].strokeColor && (m.pointStrokeColor = n.config.series[o].data[f].strokeColor)), a && (m.pSize = a), (h.x[p] < 0 || h.x[p] > n.globals.gridWidth || h.y[p] < -n.globals.markers.largestSize || h.y[p] > n.globals.gridHeight + n.globals.markers.largestSize) && (m.pSize = 0), (s = d.drawMarker(h.x[p], h.y[p], m)).attr("rel", f), s.attr("j", f), s.attr("index", t), s.node.setAttribute("default-marker-size", m.pSize), new Z(this.ctx).setSelectionFilter(s, t, f), this.addEvents(s), c && c.add(s);
                        } else n.globals.pointsArray[t] === void 0 && (n.globals.pointsArray[t] = []), n.globals.pointsArray[t].push([
                            h.x[p],
                            h.y[p]
                        ]);
                    }
                    return c;
                }
            },
            {
                key: "getMarkerConfig",
                value: function(e) {
                    var t = e.cssClass, i = e.seriesIndex, a = e.dataPointIndex, s = a === void 0 ? null : a, r = e.finishRadius, n = r === void 0 ? null : r, o = this.w, h = this.getMarkerStyle(i), c = o.globals.markers.size[i], d = o.config.markers;
                    return s !== null && d.discrete.length && d.discrete.map(function(g) {
                        g.seriesIndex === i && g.dataPointIndex === s && (h.pointStrokeColor = g.strokeColor, h.pointFillColor = g.fillColor, c = g.size, h.pointShape = g.shape);
                    }), {
                        pSize: n === null ? c : n,
                        pRadius: d.radius,
                        width: Array.isArray(d.width) ? d.width[i] : d.width,
                        height: Array.isArray(d.height) ? d.height[i] : d.height,
                        pointStrokeWidth: Array.isArray(d.strokeWidth) ? d.strokeWidth[i] : d.strokeWidth,
                        pointStrokeColor: h.pointStrokeColor,
                        pointFillColor: h.pointFillColor,
                        shape: h.pointShape || (Array.isArray(d.shape) ? d.shape[i] : d.shape),
                        class: t,
                        pointStrokeOpacity: Array.isArray(d.strokeOpacity) ? d.strokeOpacity[i] : d.strokeOpacity,
                        pointStrokeDashArray: Array.isArray(d.strokeDashArray) ? d.strokeDashArray[i] : d.strokeDashArray,
                        pointFillOpacity: Array.isArray(d.fillOpacity) ? d.fillOpacity[i] : d.fillOpacity,
                        seriesIndex: i
                    };
                }
            },
            {
                key: "addEvents",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx);
                    e.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this.ctx, e)), e.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this.ctx, e)), e.node.addEventListener("mousedown", i.pathMouseDown.bind(this.ctx, e)), e.node.addEventListener("click", t.config.markers.onClick), e.node.addEventListener("dblclick", t.config.markers.onDblClick), e.node.addEventListener("touchstart", i.pathMouseDown.bind(this.ctx, e), {
                        passive: !0
                    });
                }
            },
            {
                key: "getMarkerStyle",
                value: function(e) {
                    var t = this.w, i = t.globals.markers.colors, a = t.config.markers.strokeColor || t.config.markers.strokeColors;
                    return {
                        pointStrokeColor: Array.isArray(a) ? a[e] : a,
                        pointFillColor: Array.isArray(i) ? i[e] : i
                    };
                }
            }
        ]), y;
    }(), $e = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled;
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e, t, i) {
                    var a = this.w, s = new M(this.ctx), r = i.realIndex, n = i.pointsPos, o = i.zRatio, h = i.elParent, c = s.group({
                        class: "apexcharts-series-markers apexcharts-series-".concat(a.config.chart.type)
                    });
                    if (c.attr("clip-path", "url(#gridRectMarkerMask".concat(a.globals.cuid, ")")), Array.isArray(n.x)) for(var d = 0; d < n.x.length; d++){
                        var g = t + 1, p = !0;
                        t === 0 && d === 0 && (g = 0), t === 0 && d === 1 && (g = 1);
                        var f = 0, b = a.globals.markers.size[r];
                        if (o !== 1 / 0) {
                            var m = a.config.plotOptions.bubble;
                            b = a.globals.seriesZ[r][g], m.zScaling && (b /= o), m.minBubbleRadius && b < m.minBubbleRadius && (b = m.minBubbleRadius), m.maxBubbleRadius && b > m.maxBubbleRadius && (b = m.maxBubbleRadius);
                        }
                        a.config.chart.animations.enabled || (f = b);
                        var w = n.x[d], A = n.y[d];
                        if (f = f || 0, A !== null && a.globals.series[r][g] !== void 0 || (p = !1), p) {
                            var l = this.drawPoint(w, A, f, b, r, g, t);
                            c.add(l);
                        }
                        h.add(c);
                    }
                }
            },
            {
                key: "drawPoint",
                value: function(e, t, i, a, s, r, n) {
                    var o = this.w, h = s, c = new de(this.ctx), d = new Z(this.ctx), g = new ae(this.ctx), p = new Pe(this.ctx), f = new M(this.ctx), b = p.getMarkerConfig({
                        cssClass: "apexcharts-marker",
                        seriesIndex: h,
                        dataPointIndex: r,
                        finishRadius: o.config.chart.type === "bubble" || o.globals.comboCharts && o.config.series[s] && o.config.series[s].type === "bubble" ? a : null
                    });
                    a = b.pSize;
                    var m, w = g.fillPath({
                        seriesNumber: s,
                        dataPointIndex: r,
                        color: b.pointFillColor,
                        patternUnits: "objectBoundingBox",
                        value: o.globals.series[s][n]
                    });
                    if (b.shape === "circle" ? m = f.drawCircle(i) : b.shape !== "square" && b.shape !== "rect" || (m = f.drawRect(0, 0, b.width - b.pointStrokeWidth / 2, b.height - b.pointStrokeWidth / 2, b.pRadius)), o.config.series[h].data[r] && o.config.series[h].data[r].fillColor && (w = o.config.series[h].data[r].fillColor), m.attr({
                        x: e - b.width / 2 - b.pointStrokeWidth / 2,
                        y: t - b.height / 2 - b.pointStrokeWidth / 2,
                        cx: e,
                        cy: t,
                        fill: w,
                        "fill-opacity": b.pointFillOpacity,
                        stroke: b.pointStrokeColor,
                        r: a,
                        "stroke-width": b.pointStrokeWidth,
                        "stroke-dasharray": b.pointStrokeDashArray,
                        "stroke-opacity": b.pointStrokeOpacity
                    }), o.config.chart.dropShadow.enabled) {
                        var A = o.config.chart.dropShadow;
                        d.dropShadow(m, A, s);
                    }
                    if (!this.initialAnim || o.globals.dataChanged || o.globals.resized) o.globals.animationEnded = !0;
                    else {
                        var l = o.config.chart.animations.speed;
                        c.animateMarker(m, 0, b.shape === "circle" ? a : {
                            width: b.width,
                            height: b.height
                        }, l, o.globals.easing, function() {
                            window.setTimeout(function() {
                                c.animationCompleted(m);
                            }, 100);
                        });
                    }
                    if (o.globals.dataChanged && b.shape === "circle") {
                        if (this.dynamicAnim) {
                            var u, x, v, k, S = o.config.chart.animations.dynamicAnimation.speed;
                            (k = o.globals.previousPaths[s] && o.globals.previousPaths[s][n]) != null && (u = k.x, x = k.y, v = k.r !== void 0 ? k.r : a);
                            for(var C = 0; C < o.globals.collapsedSeries.length; C++)o.globals.collapsedSeries[C].index === s && (S = 1, a = 0);
                            e === 0 && t === 0 && (a = 0), c.animateCircle(m, {
                                cx: u,
                                cy: x,
                                r: v
                            }, {
                                cx: e,
                                cy: t,
                                r: a
                            }, S, o.globals.easing);
                        } else m.attr({
                            r: a
                        });
                    }
                    return m.attr({
                        rel: r,
                        j: r,
                        index: s,
                        "default-marker-size": a
                    }), d.setSelectionFilter(m, s, r), p.addEvents(m), m.node.classList.add("apexcharts-marker"), m;
                }
            },
            {
                key: "centerTextInBubble",
                value: function(e) {
                    var t = this.w;
                    return {
                        y: e += parseInt(t.config.dataLabels.style.fontSize, 10) / 4
                    };
                }
            }
        ]), y;
    }(), ye = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "dataLabelsCorrection",
                value: function(e, t, i, a, s, r, n) {
                    var o = this.w, h = !1, c = new M(this.ctx).getTextRects(i, n), d = c.width, g = c.height;
                    t < 0 && (t = 0), t > o.globals.gridHeight + g && (t = o.globals.gridHeight + g / 2), o.globals.dataLabelsRects[a] === void 0 && (o.globals.dataLabelsRects[a] = []), o.globals.dataLabelsRects[a].push({
                        x: e,
                        y: t,
                        width: d,
                        height: g
                    });
                    var p = o.globals.dataLabelsRects[a].length - 2, f = o.globals.lastDrawnDataLabelsIndexes[a] !== void 0 ? o.globals.lastDrawnDataLabelsIndexes[a][o.globals.lastDrawnDataLabelsIndexes[a].length - 1] : 0;
                    if (o.globals.dataLabelsRects[a][p] !== void 0) {
                        var b = o.globals.dataLabelsRects[a][f];
                        (e > b.x + b.width || t > b.y + b.height || t + g < b.y || e + d < b.x) && (h = !0);
                    }
                    return (s === 0 || r) && (h = !0), {
                        x: e,
                        y: t,
                        textRects: c,
                        drawnextLabel: h
                    };
                }
            },
            {
                key: "drawDataLabel",
                value: function(e) {
                    var t = this, i = e.type, a = e.pos, s = e.i, r = e.j, n = e.isRangeStart, o = e.strokeWidth, h = o === void 0 ? 2 : o, c = this.w, d = new M(this.ctx), g = c.config.dataLabels, p = 0, f = 0, b = r, m = null;
                    if (!g.enabled || !Array.isArray(a.x)) return m;
                    m = d.group({
                        class: "apexcharts-data-labels"
                    });
                    for(var w = 0; w < a.x.length; w++)if (p = a.x[w] + g.offsetX, f = a.y[w] + g.offsetY + h, !isNaN(p)) {
                        r === 1 && w === 0 && (b = 0), r === 1 && w === 1 && (b = 1);
                        var A = c.globals.series[s][b];
                        i === "rangeArea" && (A = n ? c.globals.seriesRangeStart[s][b] : c.globals.seriesRangeEnd[s][b]);
                        var l = "", u = function(x) {
                            return c.config.dataLabels.formatter(x, {
                                ctx: t.ctx,
                                seriesIndex: s,
                                dataPointIndex: b,
                                w: c
                            });
                        };
                        c.config.chart.type === "bubble" ? (l = u(A = c.globals.seriesZ[s][b]), f = a.y[w], f = new $e(this.ctx).centerTextInBubble(f, s, b).y) : A !== void 0 && (l = u(A)), this.plotDataLabelsText({
                            x: p,
                            y: f,
                            text: l,
                            i: s,
                            j: b,
                            parent: m,
                            offsetCorrection: !0,
                            dataLabelsConfig: c.config.dataLabels
                        });
                    }
                    return m;
                }
            },
            {
                key: "plotDataLabelsText",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx), a = e.x, s = e.y, r = e.i, n = e.j, o = e.text, h = e.textAnchor, c = e.fontSize, d = e.parent, g = e.dataLabelsConfig, p = e.color, f = e.alwaysDrawDataLabel, b = e.offsetCorrection;
                    if (!(Array.isArray(t.config.dataLabels.enabledOnSeries) && t.config.dataLabels.enabledOnSeries.indexOf(r) < 0)) {
                        var m = {
                            x: a,
                            y: s,
                            drawnextLabel: !0,
                            textRects: null
                        };
                        b && (m = this.dataLabelsCorrection(a, s, o, r, n, f, parseInt(g.style.fontSize, 10))), t.globals.zoomed || (a = m.x, s = m.y), m.textRects && (a < -20 - m.textRects.width || a > t.globals.gridWidth + m.textRects.width + 30) && (o = "");
                        var w = t.globals.dataLabels.style.colors[r];
                        ((t.config.chart.type === "bar" || t.config.chart.type === "rangeBar") && t.config.plotOptions.bar.distributed || t.config.dataLabels.distributed) && (w = t.globals.dataLabels.style.colors[n]), typeof w == "function" && (w = w({
                            series: t.globals.series,
                            seriesIndex: r,
                            dataPointIndex: n,
                            w: t
                        })), p && (w = p);
                        var A = g.offsetX, l = g.offsetY;
                        if (t.config.chart.type !== "bar" && t.config.chart.type !== "rangeBar" || (A = 0, l = 0), m.drawnextLabel) {
                            var u = i.drawText({
                                width: 100,
                                height: parseInt(g.style.fontSize, 10),
                                x: a + A,
                                y: s + l,
                                foreColor: w,
                                textAnchor: h || g.textAnchor,
                                text: o,
                                fontSize: c || g.style.fontSize,
                                fontFamily: g.style.fontFamily,
                                fontWeight: g.style.fontWeight || "normal"
                            });
                            if (u.attr({
                                class: "apexcharts-datalabel",
                                cx: a,
                                cy: s
                            }), g.dropShadow.enabled) {
                                var x = g.dropShadow;
                                new Z(this.ctx).dropShadow(u, x);
                            }
                            d.add(u), t.globals.lastDrawnDataLabelsIndexes[r] === void 0 && (t.globals.lastDrawnDataLabelsIndexes[r] = []), t.globals.lastDrawnDataLabelsIndexes[r].push(n);
                        }
                    }
                }
            },
            {
                key: "addBackgroundToDataLabel",
                value: function(e, t) {
                    var i = this.w, a = i.config.dataLabels.background, s = a.padding, r = a.padding / 2, n = t.width, o = t.height, h = new M(this.ctx).drawRect(t.x - s, t.y - r / 2, n + 2 * s, o + r, a.borderRadius, i.config.chart.background === "transparent" ? "#fff" : i.config.chart.background, a.opacity, a.borderWidth, a.borderColor);
                    return a.dropShadow.enabled && new Z(this.ctx).dropShadow(h, a.dropShadow), h;
                }
            },
            {
                key: "dataLabelsBackground",
                value: function() {
                    var e = this.w;
                    if (e.config.chart.type !== "bubble") for(var t = e.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"), i = 0; i < t.length; i++){
                        var a = t[i], s = a.getBBox(), r = null;
                        if (s.width && s.height && (r = this.addBackgroundToDataLabel(a, s)), r) {
                            a.parentNode.insertBefore(r.node, a);
                            var n = a.getAttribute("fill");
                            e.config.chart.animations.enabled && !e.globals.resized && !e.globals.dataChanged ? r.animate().attr({
                                fill: n
                            }) : r.attr({
                                fill: n
                            }), a.setAttribute("fill", e.config.dataLabels.background.foreColor);
                        }
                    }
                }
            },
            {
                key: "bringForward",
                value: function() {
                    for(var e = this.w, t = e.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"), i = e.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"), a = 0; a < t.length; a++)i && i.insertBefore(t[a], i.nextSibling);
                }
            }
        ]), y;
    }(), te = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.legendInactiveClass = "legend-mouseover-inactive";
        }
        return Y(y, [
            {
                key: "getAllSeriesEls",
                value: function() {
                    return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series");
                }
            },
            {
                key: "getSeriesByName",
                value: function(e) {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat(P.escapeString(e), "']"));
                }
            },
            {
                key: "isSeriesHidden",
                value: function(e) {
                    var t = this.getSeriesByName(e), i = parseInt(t.getAttribute("data:realIndex"), 10);
                    return {
                        isHidden: t.classList.contains("apexcharts-series-collapsed"),
                        realIndex: i
                    };
                }
            },
            {
                key: "addCollapsedClassToSeries",
                value: function(e, t) {
                    var i = this.w;
                    function a(s) {
                        for(var r = 0; r < s.length; r++)s[r].index === t && e.node.classList.add("apexcharts-series-collapsed");
                    }
                    a(i.globals.collapsedSeries), a(i.globals.ancillaryCollapsedSeries);
                }
            },
            {
                key: "toggleSeries",
                value: function(e) {
                    var t = this.isSeriesHidden(e);
                    return this.ctx.legend.legendHelpers.toggleDataSeries(t.realIndex, t.isHidden), t.isHidden;
                }
            },
            {
                key: "showSeries",
                value: function(e) {
                    var t = this.isSeriesHidden(e);
                    t.isHidden && this.ctx.legend.legendHelpers.toggleDataSeries(t.realIndex, !0);
                }
            },
            {
                key: "hideSeries",
                value: function(e) {
                    var t = this.isSeriesHidden(e);
                    t.isHidden || this.ctx.legend.legendHelpers.toggleDataSeries(t.realIndex, !1);
                }
            },
            {
                key: "resetSeries",
                value: function() {
                    var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0], t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], a = this.w, s = P.clone(a.globals.initialSeries);
                    a.globals.previousPaths = [], i ? (a.globals.collapsedSeries = [], a.globals.ancillaryCollapsedSeries = [], a.globals.collapsedSeriesIndices = [], a.globals.ancillaryCollapsedSeriesIndices = []) : s = this.emptyCollapsedSeries(s), a.config.series = s, e && (t && (a.globals.zoomed = !1, this.ctx.updateHelpers.revertDefaultAxisMinMax()), this.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled));
                }
            },
            {
                key: "emptyCollapsedSeries",
                value: function(e) {
                    for(var t = this.w, i = 0; i < e.length; i++)t.globals.collapsedSeriesIndices.indexOf(i) > -1 && (e[i].data = []);
                    return e;
                }
            },
            {
                key: "toggleSeriesOnHover",
                value: function(e, t) {
                    var i = this.w;
                    t || (t = e.target);
                    var a = i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels");
                    if (e.type === "mousemove") {
                        var s = parseInt(t.getAttribute("rel"), 10) - 1, r = null, n = null;
                        i.globals.axisCharts || i.config.chart.type === "radialBar" ? i.globals.axisCharts ? (r = i.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(s, "']")), n = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(s, "']"))) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "']")) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "'] path"));
                        for(var o = 0; o < a.length; o++)a[o].classList.add(this.legendInactiveClass);
                        r !== null && (i.globals.axisCharts || r.parentNode.classList.remove(this.legendInactiveClass), r.classList.remove(this.legendInactiveClass), n !== null && n.classList.remove(this.legendInactiveClass));
                    } else if (e.type === "mouseout") for(var h = 0; h < a.length; h++)a[h].classList.remove(this.legendInactiveClass);
                }
            },
            {
                key: "highlightRangeInSeries",
                value: function(e, t) {
                    var i = this, a = this.w, s = a.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"), r = function(o) {
                        for(var h = 0; h < s.length; h++)s[h].classList[o](i.legendInactiveClass);
                    };
                    if (e.type === "mousemove") {
                        var n = parseInt(t.getAttribute("rel"), 10) - 1;
                        r("add"), function(o) {
                            for(var h = 0; h < s.length; h++){
                                var c = parseInt(s[h].getAttribute("val"), 10);
                                c >= o.from && c <= o.to && s[h].classList.remove(i.legendInactiveClass);
                            }
                        }(a.config.plotOptions.heatmap.colorScale.ranges[n]);
                    } else e.type === "mouseout" && r("remove");
                }
            },
            {
                key: "getActiveConfigSeriesIndex",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "asc", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = this.w, a = 0;
                    if (i.config.series.length > 1) {
                        for(var s = i.config.series.map(function(n, o) {
                            return n.data && n.data.length > 0 && i.globals.collapsedSeriesIndices.indexOf(o) === -1 && (!i.globals.comboCharts || t.length === 0 || t.length && t.indexOf(i.config.series[o].type) > -1) ? o : -1;
                        }), r = e === "asc" ? 0 : s.length - 1; e === "asc" ? r < s.length : r >= 0; e === "asc" ? r++ : r--)if (s[r] !== -1) {
                            a = s[r];
                            break;
                        }
                    }
                    return a;
                }
            },
            {
                key: "getBarSeriesIndices",
                value: function() {
                    return this.w.globals.comboCharts ? this.w.config.series.map(function(e, t) {
                        return e.type === "bar" || e.type === "column" ? t : -1;
                    }).filter(function(e) {
                        return e !== -1;
                    }) : this.w.config.series.map(function(e, t) {
                        return t;
                    });
                }
            },
            {
                key: "getPreviousPaths",
                value: function() {
                    var e = this.w;
                    function t(r, n, o) {
                        for(var h = r[n].childNodes, c = {
                            type: o,
                            paths: [],
                            realIndex: r[n].getAttribute("data:realIndex")
                        }, d = 0; d < h.length; d++)if (h[d].hasAttribute("pathTo")) {
                            var g = h[d].getAttribute("pathTo");
                            c.paths.push({
                                d: g
                            });
                        }
                        e.globals.previousPaths.push(c);
                    }
                    e.globals.previousPaths = [], [
                        "line",
                        "area",
                        "bar",
                        "rangebar",
                        "rangeArea",
                        "candlestick",
                        "radar"
                    ].forEach(function(r) {
                        for(var n, o = (n = r, e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(n, "-series .apexcharts-series"))), h = 0; h < o.length; h++)t(o, h, r);
                    }), this.handlePrevBubbleScatterPaths("bubble"), this.handlePrevBubbleScatterPaths("scatter");
                    var i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(e.config.chart.type, " .apexcharts-series"));
                    if (i.length > 0) for(var a = function(r) {
                        for(var n = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(e.config.chart.type, " .apexcharts-series[data\\:realIndex='").concat(r, "'] rect")), o = [], h = function(d) {
                            var g = function(f) {
                                return n[d].getAttribute(f);
                            }, p = {
                                x: parseFloat(g("x")),
                                y: parseFloat(g("y")),
                                width: parseFloat(g("width")),
                                height: parseFloat(g("height"))
                            };
                            o.push({
                                rect: p,
                                color: n[d].getAttribute("color")
                            });
                        }, c = 0; c < n.length; c++)h(c);
                        e.globals.previousPaths.push(o);
                    }, s = 0; s < i.length; s++)a(s);
                    e.globals.axisCharts || (e.globals.previousPaths = e.globals.series);
                }
            },
            {
                key: "handlePrevBubbleScatterPaths",
                value: function(e) {
                    var t = this.w, i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(e, "-series .apexcharts-series"));
                    if (i.length > 0) for(var a = 0; a < i.length; a++){
                        for(var s = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(e, "-series .apexcharts-series[data\\:realIndex='").concat(a, "'] circle")), r = [], n = 0; n < s.length; n++)r.push({
                            x: s[n].getAttribute("cx"),
                            y: s[n].getAttribute("cy"),
                            r: s[n].getAttribute("r")
                        });
                        t.globals.previousPaths.push(r);
                    }
                }
            },
            {
                key: "clearPreviousPaths",
                value: function() {
                    var e = this.w;
                    e.globals.previousPaths = [], e.globals.allSeriesCollapsed = !1;
                }
            },
            {
                key: "handleNoData",
                value: function() {
                    var e = this.w, t = e.config.noData, i = new M(this.ctx), a = e.globals.svgWidth / 2, s = e.globals.svgHeight / 2, r = "middle";
                    if (e.globals.noData = !0, e.globals.animationEnded = !0, t.align === "left" ? (a = 10, r = "start") : t.align === "right" && (a = e.globals.svgWidth - 10, r = "end"), t.verticalAlign === "top" ? s = 50 : t.verticalAlign === "bottom" && (s = e.globals.svgHeight - 50), a += t.offsetX, s = s + parseInt(t.style.fontSize, 10) + 2 + t.offsetY, t.text !== void 0 && t.text !== "") {
                        var n = i.drawText({
                            x: a,
                            y: s,
                            text: t.text,
                            textAnchor: r,
                            fontSize: t.style.fontSize,
                            fontFamily: t.style.fontFamily,
                            foreColor: t.style.color,
                            opacity: 1,
                            class: "apexcharts-text-nodata"
                        });
                        e.globals.dom.Paper.add(n);
                    }
                }
            },
            {
                key: "setNullSeriesToZeroValues",
                value: function(e) {
                    for(var t = this.w, i = 0; i < e.length; i++)if (e[i].length === 0) for(var a = 0; a < e[t.globals.maxValsInArrayIndex].length; a++)e[i].push(0);
                    return e;
                }
            },
            {
                key: "hasAllSeriesEqualX",
                value: function() {
                    for(var e = !0, t = this.w, i = this.filteredSeriesX(), a = 0; a < i.length - 1; a++)if (i[a][0] !== i[a + 1][0]) {
                        e = !1;
                        break;
                    }
                    return t.globals.allSeriesHasEqualX = e, e;
                }
            },
            {
                key: "filteredSeriesX",
                value: function() {
                    var e = this.w.globals.seriesX.map(function(t) {
                        return t.length > 0 ? t : [];
                    });
                    return e;
                }
            }
        ]), y;
    }(), Je = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.twoDSeries = [], this.threeDSeries = [], this.twoDSeriesX = [], this.seriesGoals = [], this.coreUtils = new q(this.ctx);
        }
        return Y(y, [
            {
                key: "isMultiFormat",
                value: function() {
                    return this.isFormatXY() || this.isFormat2DArray();
                }
            },
            {
                key: "isFormatXY",
                value: function() {
                    var e = this.w.config.series.slice(), t = new te(this.ctx);
                    if (this.activeSeriesIndex = t.getActiveConfigSeriesIndex(), e[this.activeSeriesIndex].data !== void 0 && e[this.activeSeriesIndex].data.length > 0 && e[this.activeSeriesIndex].data[0] !== null && e[this.activeSeriesIndex].data[0].x !== void 0 && e[this.activeSeriesIndex].data[0] !== null) return !0;
                }
            },
            {
                key: "isFormat2DArray",
                value: function() {
                    var e = this.w.config.series.slice(), t = new te(this.ctx);
                    if (this.activeSeriesIndex = t.getActiveConfigSeriesIndex(), e[this.activeSeriesIndex].data !== void 0 && e[this.activeSeriesIndex].data.length > 0 && e[this.activeSeriesIndex].data[0] !== void 0 && e[this.activeSeriesIndex].data[0] !== null && e[this.activeSeriesIndex].data[0].constructor === Array) return !0;
                }
            },
            {
                key: "handleFormat2DArray",
                value: function(e, t) {
                    for(var i = this.w.config, a = this.w.globals, s = i.chart.type === "boxPlot" || i.series[t].type === "boxPlot", r = 0; r < e[t].data.length; r++)if (e[t].data[r][1] !== void 0 && (Array.isArray(e[t].data[r][1]) && e[t].data[r][1].length === 4 && !s ? this.twoDSeries.push(P.parseNumber(e[t].data[r][1][3])) : e[t].data[r].length >= 5 ? this.twoDSeries.push(P.parseNumber(e[t].data[r][4])) : this.twoDSeries.push(P.parseNumber(e[t].data[r][1])), a.dataFormatXNumeric = !0), i.xaxis.type === "datetime") {
                        var n = new Date(e[t].data[r][0]);
                        n = new Date(n).getTime(), this.twoDSeriesX.push(n);
                    } else this.twoDSeriesX.push(e[t].data[r][0]);
                    for(var o = 0; o < e[t].data.length; o++)e[t].data[o][2] !== void 0 && (this.threeDSeries.push(e[t].data[o][2]), a.isDataXYZ = !0);
                }
            },
            {
                key: "handleFormatXY",
                value: function(e, t) {
                    var i = this.w.config, a = this.w.globals, s = new B(this.ctx), r = t;
                    a.collapsedSeriesIndices.indexOf(t) > -1 && (r = this.activeSeriesIndex);
                    for(var n = 0; n < e[t].data.length; n++)e[t].data[n].y !== void 0 && (Array.isArray(e[t].data[n].y) ? this.twoDSeries.push(P.parseNumber(e[t].data[n].y[e[t].data[n].y.length - 1])) : this.twoDSeries.push(P.parseNumber(e[t].data[n].y))), e[t].data[n].goals !== void 0 && Array.isArray(e[t].data[n].goals) ? (this.seriesGoals[t] === void 0 && (this.seriesGoals[t] = []), this.seriesGoals[t].push(e[t].data[n].goals)) : (this.seriesGoals[t] === void 0 && (this.seriesGoals[t] = []), this.seriesGoals[t].push(null));
                    for(var o = 0; o < e[r].data.length; o++){
                        var h = typeof e[r].data[o].x == "string", c = Array.isArray(e[r].data[o].x), d = !c && !!s.isValidDate(e[r].data[o].x);
                        if (h || d) {
                            if (h || i.xaxis.convertedCatToNumeric) {
                                var g = a.isBarHorizontal && a.isRangeData;
                                i.xaxis.type !== "datetime" || g ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(e[r].data[o].x), isNaN(e[r].data[o].x) || this.w.config.xaxis.type === "category" || typeof e[r].data[o].x == "string" || (a.isXNumeric = !0)) : this.twoDSeriesX.push(s.parseDate(e[r].data[o].x));
                            } else i.xaxis.type === "datetime" ? this.twoDSeriesX.push(s.parseDate(e[r].data[o].x.toString())) : (a.dataFormatXNumeric = !0, a.isXNumeric = !0, this.twoDSeriesX.push(parseFloat(e[r].data[o].x)));
                        } else c ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(e[r].data[o].x)) : (a.isXNumeric = !0, a.dataFormatXNumeric = !0, this.twoDSeriesX.push(e[r].data[o].x));
                    }
                    if (e[t].data[0] && e[t].data[0].z !== void 0) {
                        for(var p = 0; p < e[t].data.length; p++)this.threeDSeries.push(e[t].data[p].z);
                        a.isDataXYZ = !0;
                    }
                }
            },
            {
                key: "handleRangeData",
                value: function(e, t) {
                    var i = this.w.globals, a = {};
                    return this.isFormat2DArray() ? a = this.handleRangeDataFormat("array", e, t) : this.isFormatXY() && (a = this.handleRangeDataFormat("xy", e, t)), i.seriesRangeStart.push(a.start), i.seriesRangeEnd.push(a.end), i.seriesRange.push(a.rangeUniques), i.seriesRange.forEach(function(s, r) {
                        s && s.forEach(function(n, o) {
                            n.y.forEach(function(h, c) {
                                for(var d = 0; d < n.y.length; d++)if (c !== d) {
                                    var g = h.y1, p = h.y2, f = n.y[d].y1;
                                    g <= n.y[d].y2 && f <= p && (n.overlaps.indexOf(h.rangeName) < 0 && n.overlaps.push(h.rangeName), n.overlaps.indexOf(n.y[d].rangeName) < 0 && n.overlaps.push(n.y[d].rangeName));
                                }
                            });
                        });
                    }), a;
                }
            },
            {
                key: "handleCandleStickBoxData",
                value: function(e, t) {
                    var i = this.w.globals, a = {};
                    return this.isFormat2DArray() ? a = this.handleCandleStickBoxDataFormat("array", e, t) : this.isFormatXY() && (a = this.handleCandleStickBoxDataFormat("xy", e, t)), i.seriesCandleO[t] = a.o, i.seriesCandleH[t] = a.h, i.seriesCandleM[t] = a.m, i.seriesCandleL[t] = a.l, i.seriesCandleC[t] = a.c, a;
                }
            },
            {
                key: "handleRangeDataFormat",
                value: function(e, t, i) {
                    var a = [], s = [], r = t[i].data.filter(function(c, d, g) {
                        return d === g.findIndex(function(p) {
                            return p.x === c.x;
                        });
                    }).map(function(c, d) {
                        return {
                            x: c.x,
                            overlaps: [],
                            y: []
                        };
                    });
                    if (e === "array") for(var n = 0; n < t[i].data.length; n++)Array.isArray(t[i].data[n]) ? (a.push(t[i].data[n][1][0]), s.push(t[i].data[n][1][1])) : (a.push(t[i].data[n]), s.push(t[i].data[n]));
                    else if (e === "xy") for(var o = function(c) {
                        var d = Array.isArray(t[i].data[c].y), g = P.randomId(), p = t[i].data[c].x, f = {
                            y1: d ? t[i].data[c].y[0] : t[i].data[c].y,
                            y2: d ? t[i].data[c].y[1] : t[i].data[c].y,
                            rangeName: g
                        };
                        t[i].data[c].rangeName = g;
                        var b = r.findIndex(function(m) {
                            return m.x === p;
                        });
                        r[b].y.push(f), a.push(f.y1), s.push(f.y2);
                    }, h = 0; h < t[i].data.length; h++)o(h);
                    return {
                        start: a,
                        end: s,
                        rangeUniques: r
                    };
                }
            },
            {
                key: "handleCandleStickBoxDataFormat",
                value: function(e, t, i) {
                    var a = this.w, s = a.config.chart.type === "boxPlot" || a.config.series[i].type === "boxPlot", r = [], n = [], o = [], h = [], c = [];
                    if (e === "array") {
                        if (s && t[i].data[0].length === 6 || !s && t[i].data[0].length === 5) for(var d = 0; d < t[i].data.length; d++)r.push(t[i].data[d][1]), n.push(t[i].data[d][2]), s ? (o.push(t[i].data[d][3]), h.push(t[i].data[d][4]), c.push(t[i].data[d][5])) : (h.push(t[i].data[d][3]), c.push(t[i].data[d][4]));
                        else for(var g = 0; g < t[i].data.length; g++)Array.isArray(t[i].data[g][1]) && (r.push(t[i].data[g][1][0]), n.push(t[i].data[g][1][1]), s ? (o.push(t[i].data[g][1][2]), h.push(t[i].data[g][1][3]), c.push(t[i].data[g][1][4])) : (h.push(t[i].data[g][1][2]), c.push(t[i].data[g][1][3])));
                    } else if (e === "xy") for(var p = 0; p < t[i].data.length; p++)Array.isArray(t[i].data[p].y) && (r.push(t[i].data[p].y[0]), n.push(t[i].data[p].y[1]), s ? (o.push(t[i].data[p].y[2]), h.push(t[i].data[p].y[3]), c.push(t[i].data[p].y[4])) : (h.push(t[i].data[p].y[2]), c.push(t[i].data[p].y[3])));
                    return {
                        o: r,
                        h: n,
                        m: o,
                        l: h,
                        c: c
                    };
                }
            },
            {
                key: "parseDataAxisCharts",
                value: function(e) {
                    var t, i = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.ctx, s = this.w.config, r = this.w.globals, n = new B(a), o = s.labels.length > 0 ? s.labels.slice() : s.xaxis.categories.slice();
                    if (r.isRangeBar = s.chart.type === "rangeBar" && r.isBarHorizontal, r.hasXaxisGroups = s.xaxis.type === "category" && s.xaxis.group.groups.length > 0, r.hasXaxisGroups && (r.groups = s.xaxis.group.groups), r.hasSeriesGroups = (t = e[0]) === null || t === void 0 ? void 0 : t.group, r.hasSeriesGroups) {
                        var h = [], c = J(new Set(e.map(function(f) {
                            return f.group;
                        })));
                        e.forEach(function(f, b) {
                            var m = c.indexOf(f.group);
                            h[m] || (h[m] = []), h[m].push(f.name);
                        }), r.seriesGroups = h;
                    }
                    for(var d = function() {
                        for(var f = 0; f < o.length; f++)if (typeof o[f] == "string") {
                            if (!n.isValidDate(o[f])) throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");
                            i.twoDSeriesX.push(n.parseDate(o[f]));
                        } else i.twoDSeriesX.push(o[f]);
                    }, g = 0; g < e.length; g++){
                        if (this.twoDSeries = [], this.twoDSeriesX = [], this.threeDSeries = [], e[g].data === void 0) return void console.error("It is a possibility that you may have not included 'data' property in series.");
                        if (s.chart.type !== "rangeBar" && s.chart.type !== "rangeArea" && e[g].type !== "rangeBar" && e[g].type !== "rangeArea" || (r.isRangeData = !0, s.chart.type !== "rangeBar" && s.chart.type !== "rangeArea" || this.handleRangeData(e, g)), this.isMultiFormat()) this.isFormat2DArray() ? this.handleFormat2DArray(e, g) : this.isFormatXY() && this.handleFormatXY(e, g), s.chart.type !== "candlestick" && e[g].type !== "candlestick" && s.chart.type !== "boxPlot" && e[g].type !== "boxPlot" || this.handleCandleStickBoxData(e, g), r.series.push(this.twoDSeries), r.labels.push(this.twoDSeriesX), r.seriesX.push(this.twoDSeriesX), r.seriesGoals = this.seriesGoals, g !== this.activeSeriesIndex || this.fallbackToCategory || (r.isXNumeric = !0);
                        else {
                            s.xaxis.type === "datetime" ? (r.isXNumeric = !0, d(), r.seriesX.push(this.twoDSeriesX)) : s.xaxis.type === "numeric" && (r.isXNumeric = !0, o.length > 0 && (this.twoDSeriesX = o, r.seriesX.push(this.twoDSeriesX))), r.labels.push(this.twoDSeriesX);
                            var p = e[g].data.map(function(f) {
                                return P.parseNumber(f);
                            });
                            r.series.push(p);
                        }
                        r.seriesZ.push(this.threeDSeries), e[g].name !== void 0 ? r.seriesNames.push(e[g].name) : r.seriesNames.push("series-" + parseInt(g + 1, 10)), e[g].color !== void 0 ? r.seriesColors.push(e[g].color) : r.seriesColors.push(void 0);
                    }
                    return this.w;
                }
            },
            {
                key: "parseDataNonAxisCharts",
                value: function(e) {
                    var t = this.w.globals, i = this.w.config;
                    t.series = e.slice(), t.seriesNames = i.labels.slice();
                    for(var a = 0; a < t.series.length; a++)t.seriesNames[a] === void 0 && t.seriesNames.push("series-" + (a + 1));
                    return this.w;
                }
            },
            {
                key: "handleExternalLabelsData",
                value: function(e) {
                    var t = this.w.config, i = this.w.globals;
                    t.xaxis.categories.length > 0 ? i.labels = t.xaxis.categories : t.labels.length > 0 ? i.labels = t.labels.slice() : this.fallbackToCategory ? (i.labels = i.labels[0], i.seriesRange.length && (i.seriesRange.map(function(a) {
                        a.forEach(function(s) {
                            i.labels.indexOf(s.x) < 0 && s.x && i.labels.push(s.x);
                        });
                    }), i.labels = Array.from(new Set(i.labels.map(JSON.stringify)), JSON.parse)), t.xaxis.convertedCatToNumeric && (new oe(t).convertCatToNumericXaxis(t, this.ctx, i.seriesX[0]), this._generateExternalLabels(e))) : this._generateExternalLabels(e);
                }
            },
            {
                key: "_generateExternalLabels",
                value: function(e) {
                    var t = this.w.globals, i = this.w.config, a = [];
                    if (t.axisCharts) {
                        if (t.series.length > 0) {
                            if (this.isFormatXY()) for(var s = i.series.map(function(d, g) {
                                return d.data.filter(function(p, f, b) {
                                    return b.findIndex(function(m) {
                                        return m.x === p.x;
                                    }) === f;
                                });
                            }), r = s.reduce(function(d, g, p, f) {
                                return f[d].length > g.length ? d : p;
                            }, 0), n = 0; n < s[r].length; n++)a.push(n + 1);
                            else for(var o = 0; o < t.series[t.maxValsInArrayIndex].length; o++)a.push(o + 1);
                        }
                        t.seriesX = [];
                        for(var h = 0; h < e.length; h++)t.seriesX.push(a);
                        this.w.globals.isBarHorizontal || (t.isXNumeric = !0);
                    }
                    if (a.length === 0) {
                        a = t.axisCharts ? [] : t.series.map(function(d, g) {
                            return g + 1;
                        });
                        for(var c = 0; c < e.length; c++)t.seriesX.push(a);
                    }
                    t.labels = a, i.xaxis.convertedCatToNumeric && (t.categoryLabels = a.map(function(d) {
                        return i.xaxis.labels.formatter(d);
                    })), t.noLabelsProvided = !0;
                }
            },
            {
                key: "parseData",
                value: function(e) {
                    var t = this.w, i = t.config, a = t.globals;
                    if (this.excludeCollapsedSeriesInYAxis(), this.fallbackToCategory = !1, this.ctx.core.resetGlobals(), this.ctx.core.isMultipleY(), a.axisCharts ? (this.parseDataAxisCharts(e), this.coreUtils.getLargestSeries()) : this.parseDataNonAxisCharts(e), i.chart.stacked) {
                        var s = new te(this.ctx);
                        a.series = s.setNullSeriesToZeroValues(a.series);
                    }
                    this.coreUtils.getSeriesTotals(), a.axisCharts && (a.stackedSeriesTotals = this.coreUtils.getStackedSeriesTotals(), a.stackedSeriesTotalsByGroups = this.coreUtils.getStackedSeriesTotalsByGroups()), this.coreUtils.getPercentSeries(), a.dataFormatXNumeric || a.isXNumeric && (i.xaxis.type !== "numeric" || i.labels.length !== 0 || i.xaxis.categories.length !== 0) || this.handleExternalLabelsData(e);
                    for(var r = this.coreUtils.getCategoryLabels(a.labels), n = 0; n < r.length; n++)if (Array.isArray(r[n])) {
                        a.isMultiLineX = !0;
                        break;
                    }
                }
            },
            {
                key: "excludeCollapsedSeriesInYAxis",
                value: function() {
                    var e = this, t = this.w;
                    t.globals.ignoreYAxisIndexes = t.globals.collapsedSeries.map(function(i, a) {
                        if (e.w.globals.isMultipleYAxis && !t.config.chart.stacked) return i.index;
                    });
                }
            }
        ]), y;
    }(), xe = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "getLabel",
                value: function(e, t, i, a) {
                    var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], r = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "12px", n = !(arguments.length > 6 && arguments[6] !== void 0) || arguments[6], o = this.w, h = e[a] === void 0 ? "" : e[a], c = h, d = o.globals.xLabelFormatter, g = o.config.xaxis.labels.formatter, p = !1, f = new re(this.ctx), b = h;
                    n && (c = f.xLabelFormat(d, h, b, {
                        i: a,
                        dateFormatter: new B(this.ctx).formatDate,
                        w: o
                    }), g !== void 0 && (c = g(h, e[a], {
                        i: a,
                        dateFormatter: new B(this.ctx).formatDate,
                        w: o
                    })));
                    var m, w;
                    t.length > 0 ? (m = t[a].unit, w = null, t.forEach(function(x) {
                        x.unit === "month" ? w = "year" : x.unit === "day" ? w = "month" : x.unit === "hour" ? w = "day" : x.unit === "minute" && (w = "hour");
                    }), p = w === m, i = t[a].position, c = t[a].value) : o.config.xaxis.type === "datetime" && g === void 0 && (c = ""), c === void 0 && (c = ""), c = Array.isArray(c) ? c : c.toString();
                    var A = new M(this.ctx), l = {};
                    l = o.globals.rotateXLabels && n ? A.getTextRects(c, parseInt(r, 10), null, "rotate(".concat(o.config.xaxis.labels.rotate, " 0 0)"), !1) : A.getTextRects(c, parseInt(r, 10));
                    var u = !o.config.xaxis.labels.showDuplicates && this.ctx.timeScale;
                    return !Array.isArray(c) && (c.indexOf("NaN") === 0 || c.toLowerCase().indexOf("invalid") === 0 || c.toLowerCase().indexOf("infinity") >= 0 || s.indexOf(c) >= 0 && u) && (c = ""), {
                        x: i,
                        text: c,
                        textRect: l,
                        isBold: p
                    };
                }
            },
            {
                key: "checkLabelBasedOnTickamount",
                value: function(e, t, i) {
                    var a = this.w, s = a.config.xaxis.tickAmount;
                    return s === "dataPoints" && (s = Math.round(a.globals.gridWidth / 120)), s > i || e % Math.round(i / (s + 1)) == 0 || (t.text = ""), t;
                }
            },
            {
                key: "checkForOverflowingLabels",
                value: function(e, t, i, a, s) {
                    var r = this.w;
                    if (e === 0 && r.globals.skipFirstTimelinelabel && (t.text = ""), e === i - 1 && r.globals.skipLastTimelinelabel && (t.text = ""), r.config.xaxis.labels.hideOverlappingLabels && a.length > 0) {
                        var n = s[s.length - 1];
                        t.x < n.textRect.width / (r.globals.rotateXLabels ? Math.abs(r.config.xaxis.labels.rotate) / 12 : 1.01) + n.x && (t.text = "");
                    }
                    return t;
                }
            },
            {
                key: "checkForReversedLabels",
                value: function(e, t) {
                    var i = this.w;
                    return i.config.yaxis[e] && i.config.yaxis[e].reversed && t.reverse(), t;
                }
            },
            {
                key: "isYAxisHidden",
                value: function(e) {
                    var t = this.w, i = new q(this.ctx);
                    return !t.config.yaxis[e].show || !t.config.yaxis[e].showForNullSeries && i.isSeriesNull(e) && t.globals.collapsedSeriesIndices.indexOf(e) === -1;
                }
            },
            {
                key: "getYAxisForeColor",
                value: function(e, t) {
                    var i = this.w;
                    return Array.isArray(e) && i.globals.yAxisScale[t] && this.ctx.theme.pushExtraColors(e, i.globals.yAxisScale[t].result.length, !1), e;
                }
            },
            {
                key: "drawYAxisTicks",
                value: function(e, t, i, a, s, r, n) {
                    var o = this.w, h = new M(this.ctx), c = o.globals.translateY;
                    if (a.show && t > 0) {
                        o.config.yaxis[s].opposite === !0 && (e += a.width);
                        for(var d = t; d >= 0; d--){
                            var g = c + t / 10 + o.config.yaxis[s].labels.offsetY - 1;
                            o.globals.isBarHorizontal && (g = r * d), o.config.chart.type === "heatmap" && (g += r / 2);
                            var p = h.drawLine(e + i.offsetX - a.width + a.offsetX, g + a.offsetY, e + i.offsetX + a.offsetX, g + a.offsetY, a.color);
                            n.add(p), c += r;
                        }
                    }
                }
            }
        ]), y;
    }(), Ee = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "scaleSvgNode",
                value: function(e, t) {
                    var i = parseFloat(e.getAttributeNS(null, "width")), a = parseFloat(e.getAttributeNS(null, "height"));
                    e.setAttributeNS(null, "width", i * t), e.setAttributeNS(null, "height", a * t), e.setAttributeNS(null, "viewBox", "0 0 " + i + " " + a);
                }
            },
            {
                key: "fixSvgStringForIe11",
                value: function(e) {
                    if (!P.isIE11()) return e.replace(/&nbsp;/g, "&#160;");
                    var t = 0, i = e.replace(/xmlns="http:\/\/www.w3.org\/2000\/svg"/g, function(a) {
                        return ++t === 2 ? 'xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev"' : a;
                    });
                    return i = (i = i.replace(/xmlns:NS\d+=""/g, "")).replace(/NS\d+:(\w+:\w+=")/g, "$1");
                }
            },
            {
                key: "getSvgString",
                value: function(e) {
                    e == null && (e = 1);
                    var t = this.w.globals.dom.Paper.svg();
                    if (e !== 1) {
                        var i = this.w.globals.dom.Paper.node.cloneNode(!0);
                        this.scaleSvgNode(i, e), t = new XMLSerializer().serializeToString(i);
                    }
                    return this.fixSvgStringForIe11(t);
                }
            },
            {
                key: "cleanup",
                value: function() {
                    var e = this.w, t = e.globals.dom.baseEl.getElementsByClassName("apexcharts-xcrosshairs"), i = e.globals.dom.baseEl.getElementsByClassName("apexcharts-ycrosshairs"), a = e.globals.dom.baseEl.querySelectorAll(".apexcharts-zoom-rect, .apexcharts-selection-rect");
                    Array.prototype.forEach.call(a, function(s) {
                        s.setAttribute("width", 0);
                    }), t && t[0] && (t[0].setAttribute("x", -500), t[0].setAttribute("x1", -500), t[0].setAttribute("x2", -500)), i && i[0] && (i[0].setAttribute("y", -100), i[0].setAttribute("y1", -100), i[0].setAttribute("y2", -100));
                }
            },
            {
                key: "svgUrl",
                value: function() {
                    this.cleanup();
                    var e = this.getSvgString(), t = new Blob([
                        e
                    ], {
                        type: "image/svg+xml;charset=utf-8"
                    });
                    return URL.createObjectURL(t);
                }
            },
            {
                key: "dataURI",
                value: function(e) {
                    var t = this;
                    return new Promise(function(i) {
                        var a = t.w, s = e ? e.scale || e.width / a.globals.svgWidth : 1;
                        t.cleanup();
                        var r = document.createElement("canvas");
                        r.width = a.globals.svgWidth * s, r.height = parseInt(a.globals.dom.elWrap.style.height, 10) * s;
                        var n = a.config.chart.background === "transparent" ? "#fff" : a.config.chart.background, o = r.getContext("2d");
                        o.fillStyle = n, o.fillRect(0, 0, r.width * s, r.height * s);
                        var h = t.getSvgString(s);
                        if (window.canvg && P.isIE11()) {
                            var c = window.canvg.Canvg.fromString(o, h, {
                                ignoreClear: !0,
                                ignoreDimensions: !0
                            });
                            c.start();
                            var d = r.msToBlob();
                            c.stop(), i({
                                blob: d
                            });
                        } else {
                            var g = "data:image/svg+xml," + encodeURIComponent(h), p = new Image();
                            p.crossOrigin = "anonymous", p.onload = function() {
                                if (o.drawImage(p, 0, 0), r.msToBlob) {
                                    var f = r.msToBlob();
                                    i({
                                        blob: f
                                    });
                                } else {
                                    var b = r.toDataURL("image/png");
                                    i({
                                        imgURI: b
                                    });
                                }
                            }, p.src = g;
                        }
                    });
                }
            },
            {
                key: "exportToSVG",
                value: function() {
                    this.triggerDownload(this.svgUrl(), this.w.config.chart.toolbar.export.svg.filename, ".svg");
                }
            },
            {
                key: "exportToPng",
                value: function() {
                    var e = this;
                    this.dataURI().then(function(t) {
                        var i = t.imgURI, a = t.blob;
                        a ? navigator.msSaveOrOpenBlob(a, e.w.globals.chartID + ".png") : e.triggerDownload(i, e.w.config.chart.toolbar.export.png.filename, ".png");
                    });
                }
            },
            {
                key: "exportToCSV",
                value: function(e) {
                    var t = this, i = e.series, a = e.fileName, s = e.columnDelimiter, r = s === void 0 ? "," : s, n = e.lineDelimiter, o = n === void 0 ? `
` : n, h = this.w;
                    i || (i = h.config.series);
                    var c, d, g = [], p = [], f = "", b = h.globals.series.map(function(v, k) {
                        return h.globals.collapsedSeriesIndices.indexOf(k) === -1 ? v : [];
                    }), m = function(v) {
                        return h.config.xaxis.type === "datetime" && String(v).length >= 10;
                    }, w = Math.max.apply(Math, J(i.map(function(v) {
                        return v.data ? v.data.length : 0;
                    }))), A = new Je(this.ctx), l = new xe(this.ctx), u = function(v) {
                        var k = "";
                        if (h.globals.axisCharts) {
                            if (h.config.xaxis.type === "category" || h.config.xaxis.convertedCatToNumeric) {
                                if (h.globals.isBarHorizontal) {
                                    var S = h.globals.yLabelFormatters[0], C = new te(t.ctx).getActiveConfigSeriesIndex();
                                    k = S(h.globals.labels[v], {
                                        seriesIndex: C,
                                        dataPointIndex: v,
                                        w: h
                                    });
                                } else k = l.getLabel(h.globals.labels, h.globals.timescaleLabels, 0, v).text;
                            }
                            h.config.xaxis.type === "datetime" && (h.config.xaxis.categories.length ? k = h.config.xaxis.categories[v] : h.config.labels.length && (k = h.config.labels[v]));
                        } else k = h.config.labels[v];
                        return Array.isArray(k) && (k = k.join(" ")), P.isNumber(k) ? k : k.split(r).join("");
                    }, x = function(v, k) {
                        if (g.length && k === 0 && p.push(g.join(r)), v.data) {
                            v.data = v.data.length && v.data || J(Array(w)).map(function() {
                                return "";
                            });
                            for(var S = 0; S < v.data.length; S++){
                                g = [];
                                var C = u(S);
                                if (C || (A.isFormatXY() ? C = i[k].data[S].x : A.isFormat2DArray() && (C = i[k].data[S] ? i[k].data[S][0] : "")), k === 0) {
                                    g.push(m(C) ? h.config.chart.toolbar.export.csv.dateFormatter(C) : P.isNumber(C) ? C : C.split(r).join(""));
                                    for(var L = 0; L < h.globals.series.length; L++){
                                        var I;
                                        A.isFormatXY() ? g.push((I = i[L].data[S]) === null || I === void 0 ? void 0 : I.y) : g.push(b[L][S]);
                                    }
                                }
                                (h.config.chart.type === "candlestick" || v.type && v.type === "candlestick") && (g.pop(), g.push(h.globals.seriesCandleO[k][S]), g.push(h.globals.seriesCandleH[k][S]), g.push(h.globals.seriesCandleL[k][S]), g.push(h.globals.seriesCandleC[k][S])), (h.config.chart.type === "boxPlot" || v.type && v.type === "boxPlot") && (g.pop(), g.push(h.globals.seriesCandleO[k][S]), g.push(h.globals.seriesCandleH[k][S]), g.push(h.globals.seriesCandleM[k][S]), g.push(h.globals.seriesCandleL[k][S]), g.push(h.globals.seriesCandleC[k][S])), h.config.chart.type === "rangeBar" && (g.pop(), g.push(h.globals.seriesRangeStart[k][S]), g.push(h.globals.seriesRangeEnd[k][S])), g.length && p.push(g.join(r));
                            }
                        }
                    };
                    g.push(h.config.chart.toolbar.export.csv.headerCategory), h.config.chart.type === "boxPlot" ? (g.push("minimum"), g.push("q1"), g.push("median"), g.push("q3"), g.push("maximum")) : h.config.chart.type === "candlestick" ? (g.push("open"), g.push("high"), g.push("low"), g.push("close")) : h.config.chart.type === "rangeBar" ? (g.push("minimum"), g.push("maximum")) : i.map(function(v, k) {
                        var S = (v.name ? v.name : "series-".concat(k)) + "";
                        h.globals.axisCharts && g.push(S.split(r).join("") ? S.split(r).join("") : "series-".concat(k));
                    }), h.globals.axisCharts || (g.push(h.config.chart.toolbar.export.csv.headerValue), p.push(g.join(r))), h.globals.allSeriesHasEqualX || !h.globals.axisCharts || h.config.xaxis.categories.length || h.config.labels.length ? i.map(function(v, k) {
                        h.globals.axisCharts ? x(v, k) : ((g = []).push(h.globals.labels[k].split(r).join("")), g.push(b[k]), p.push(g.join(r)));
                    }) : (c = /* @__PURE__ */ new Set(), d = {}, i.forEach(function(v, k) {
                        v == null || v.data.forEach(function(S) {
                            var C, L;
                            if (A.isFormatXY()) C = S.x, L = S.y;
                            else {
                                if (!A.isFormat2DArray()) return;
                                C = S[0], L = S[1];
                            }
                            d[C] || (d[C] = Array(i.length).fill("")), d[C][k] = L, c.add(C);
                        });
                    }), g.length && p.push(g.join(r)), Array.from(c).sort().forEach(function(v) {
                        p.push([
                            m(v) && h.config.xaxis.type === "datetime" ? h.config.chart.toolbar.export.csv.dateFormatter(v) : P.isNumber(v) ? v : v.split(r).join(""),
                            d[v].join(r)
                        ]);
                    })), f += p.join(o), this.triggerDownload("data:text/csv; charset=utf-8," + encodeURIComponent("\uFEFF" + f), a || h.config.chart.toolbar.export.csv.filename, ".csv");
                }
            },
            {
                key: "triggerDownload",
                value: function(e, t, i) {
                    var a = document.createElement("a");
                    a.href = e, a.download = (t || this.w.globals.chartID) + i, document.body.appendChild(a), a.click(), document.body.removeChild(a);
                }
            }
        ]), y;
    }(), Ie = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.elgrid = t, this.w = e.w;
            var i = this.w;
            this.axesUtils = new xe(e), this.xaxisLabels = i.globals.labels.slice(), i.globals.timescaleLabels.length > 0 && !i.globals.isBarHorizontal && (this.xaxisLabels = i.globals.timescaleLabels.slice()), i.config.xaxis.overwriteCategories && (this.xaxisLabels = i.config.xaxis.overwriteCategories), this.drawnLabels = [], this.drawnLabelsRects = [], i.config.xaxis.position === "top" ? this.offY = 0 : this.offY = i.globals.gridHeight + 1, this.offY = this.offY + i.config.xaxis.axisBorder.offsetY, this.isCategoryBarHorizontal = i.config.chart.type === "bar" && i.config.plotOptions.bar.horizontal, this.xaxisFontSize = i.config.xaxis.labels.style.fontSize, this.xaxisFontFamily = i.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = i.config.xaxis.labels.style.colors, this.xaxisBorderWidth = i.config.xaxis.axisBorder.width, this.isCategoryBarHorizontal && (this.xaxisBorderWidth = i.config.yaxis[0].axisBorder.width.toString()), this.xaxisBorderWidth.indexOf("%") > -1 ? this.xaxisBorderWidth = i.globals.gridWidth * parseInt(this.xaxisBorderWidth, 10) / 100 : this.xaxisBorderWidth = parseInt(this.xaxisBorderWidth, 10), this.xaxisBorderHeight = i.config.xaxis.axisBorder.height, this.yaxis = i.config.yaxis[0];
        }
        return Y(y, [
            {
                key: "drawXaxis",
                value: function() {
                    var e = this.w, t = new M(this.ctx), i = t.group({
                        class: "apexcharts-xaxis",
                        transform: "translate(".concat(e.config.xaxis.offsetX, ", ").concat(e.config.xaxis.offsetY, ")")
                    }), a = t.group({
                        class: "apexcharts-xaxis-texts-g",
                        transform: "translate(".concat(e.globals.translateXAxisX, ", ").concat(e.globals.translateXAxisY, ")")
                    });
                    i.add(a);
                    for(var s = [], r = 0; r < this.xaxisLabels.length; r++)s.push(this.xaxisLabels[r]);
                    if (this.drawXAxisLabelAndGroup(!0, t, a, s, e.globals.isXNumeric, function(f, b) {
                        return b;
                    }), e.globals.hasXaxisGroups) {
                        var n = e.globals.groups;
                        s = [];
                        for(var o = 0; o < n.length; o++)s.push(n[o].title);
                        var h = {};
                        e.config.xaxis.group.style && (h.xaxisFontSize = e.config.xaxis.group.style.fontSize, h.xaxisFontFamily = e.config.xaxis.group.style.fontFamily, h.xaxisForeColors = e.config.xaxis.group.style.colors, h.fontWeight = e.config.xaxis.group.style.fontWeight, h.cssClass = e.config.xaxis.group.style.cssClass), this.drawXAxisLabelAndGroup(!1, t, a, s, !1, function(f, b) {
                            return n[f].cols * b;
                        }, h);
                    }
                    if (e.config.xaxis.title.text !== void 0) {
                        var c = t.group({
                            class: "apexcharts-xaxis-title"
                        }), d = t.drawText({
                            x: e.globals.gridWidth / 2 + e.config.xaxis.title.offsetX,
                            y: this.offY + parseFloat(this.xaxisFontSize) + (e.config.xaxis.position === "bottom" ? e.globals.xAxisLabelsHeight : -e.globals.xAxisLabelsHeight - 10) + e.config.xaxis.title.offsetY,
                            text: e.config.xaxis.title.text,
                            textAnchor: "middle",
                            fontSize: e.config.xaxis.title.style.fontSize,
                            fontFamily: e.config.xaxis.title.style.fontFamily,
                            fontWeight: e.config.xaxis.title.style.fontWeight,
                            foreColor: e.config.xaxis.title.style.color,
                            cssClass: "apexcharts-xaxis-title-text " + e.config.xaxis.title.style.cssClass
                        });
                        c.add(d), i.add(c);
                    }
                    if (e.config.xaxis.axisBorder.show) {
                        var g = e.globals.barPadForNumericAxis, p = t.drawLine(e.globals.padHorizontal + e.config.xaxis.axisBorder.offsetX - g, this.offY, this.xaxisBorderWidth + g, this.offY, e.config.xaxis.axisBorder.color, 0, this.xaxisBorderHeight);
                        this.elgrid && this.elgrid.elGridBorders && e.config.grid.show ? this.elgrid.elGridBorders.add(p) : i.add(p);
                    }
                    return i;
                }
            },
            {
                key: "drawXAxisLabelAndGroup",
                value: function(e, t, i, a, s, r) {
                    var n, o = this, h = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, c = [], d = [], g = this.w, p = h.xaxisFontSize || this.xaxisFontSize, f = h.xaxisFontFamily || this.xaxisFontFamily, b = h.xaxisForeColors || this.xaxisForeColors, m = h.fontWeight || g.config.xaxis.labels.style.fontWeight, w = h.cssClass || g.config.xaxis.labels.style.cssClass, A = g.globals.padHorizontal, l = a.length, u = g.config.xaxis.type === "category" ? g.globals.dataPoints : l;
                    if (u === 0 && l > u && (u = l), s) {
                        var x = u > 1 ? u - 1 : u;
                        n = g.globals.gridWidth / Math.min(x, l - 1), A = A + r(0, n) / 2 + g.config.xaxis.labels.offsetX;
                    } else n = g.globals.gridWidth / u, A = A + r(0, n) + g.config.xaxis.labels.offsetX;
                    for(var v = function(S) {
                        var C = A - r(S, n) / 2 + g.config.xaxis.labels.offsetX;
                        S === 0 && l === 1 && n / 2 === A && u === 1 && (C = g.globals.gridWidth / 2);
                        var L = o.axesUtils.getLabel(a, g.globals.timescaleLabels, C, S, c, p, e), I = 28;
                        if (g.globals.rotateXLabels && e && (I = 22), g.config.xaxis.title.text && g.config.xaxis.position === "top" && (I += parseFloat(g.config.xaxis.title.style.fontSize) + 2), e || (I = I + parseFloat(p) + (g.globals.xAxisLabelsHeight - g.globals.xAxisGroupLabelsHeight) + (g.globals.rotateXLabels ? 10 : 0)), L = g.config.xaxis.tickAmount !== void 0 && g.config.xaxis.tickAmount !== "dataPoints" && g.config.xaxis.type !== "datetime" ? o.axesUtils.checkLabelBasedOnTickamount(S, L, l) : o.axesUtils.checkForOverflowingLabels(S, L, l, c, d), g.config.xaxis.labels.show) {
                            var z = t.drawText({
                                x: L.x,
                                y: o.offY + g.config.xaxis.labels.offsetY + I - (g.config.xaxis.position === "top" ? g.globals.xAxisHeight + g.config.xaxis.axisTicks.height - 2 : 0),
                                text: L.text,
                                textAnchor: "middle",
                                fontWeight: L.isBold ? 600 : m,
                                fontSize: p,
                                fontFamily: f,
                                foreColor: Array.isArray(b) ? e && g.config.xaxis.convertedCatToNumeric ? b[g.globals.minX + S - 1] : b[S] : b,
                                isPlainText: !1,
                                cssClass: (e ? "apexcharts-xaxis-label " : "apexcharts-xaxis-group-label ") + w
                            });
                            if (i.add(z), z.on("click", function(E) {
                                if (typeof g.config.chart.events.xAxisLabelClick == "function") {
                                    var R = Object.assign({}, g, {
                                        labelIndex: S
                                    });
                                    g.config.chart.events.xAxisLabelClick(E, o.ctx, R);
                                }
                            }), e) {
                                var T = document.createElementNS(g.globals.SVGNS, "title");
                                T.textContent = Array.isArray(L.text) ? L.text.join(" ") : L.text, z.node.appendChild(T), L.text !== "" && (c.push(L.text), d.push(L));
                            }
                        }
                        S < l - 1 && (A += r(S + 1, n));
                    }, k = 0; k <= l - 1; k++)v(k);
                }
            },
            {
                key: "drawXaxisInversed",
                value: function(e) {
                    var t, i, a = this, s = this.w, r = new M(this.ctx), n = s.config.yaxis[0].opposite ? s.globals.translateYAxisX[e] : 0, o = r.group({
                        class: "apexcharts-yaxis apexcharts-xaxis-inversed",
                        rel: e
                    }), h = r.group({
                        class: "apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",
                        transform: "translate(" + n + ", 0)"
                    });
                    o.add(h);
                    var c = [];
                    if (s.config.yaxis[e].show) for(var d = 0; d < this.xaxisLabels.length; d++)c.push(this.xaxisLabels[d]);
                    t = s.globals.gridHeight / c.length, i = -t / 2.2;
                    var g = s.globals.yLabelFormatters[0], p = s.config.yaxis[0].labels;
                    if (p.show) for(var f = function(x) {
                        var v = c[x] === void 0 ? "" : c[x];
                        v = g(v, {
                            seriesIndex: e,
                            dataPointIndex: x,
                            w: s
                        });
                        var k = a.axesUtils.getYAxisForeColor(p.style.colors, e), S = 0;
                        Array.isArray(v) && (S = v.length / 2 * parseInt(p.style.fontSize, 10));
                        var C = p.offsetX - 15, L = "end";
                        a.yaxis.opposite && (L = "start"), s.config.yaxis[0].labels.align === "left" ? (C = p.offsetX, L = "start") : s.config.yaxis[0].labels.align === "center" ? (C = p.offsetX, L = "middle") : s.config.yaxis[0].labels.align === "right" && (L = "end");
                        var I = r.drawText({
                            x: C,
                            y: i + t + p.offsetY - S,
                            text: v,
                            textAnchor: L,
                            foreColor: Array.isArray(k) ? k[x] : k,
                            fontSize: p.style.fontSize,
                            fontFamily: p.style.fontFamily,
                            fontWeight: p.style.fontWeight,
                            isPlainText: !1,
                            cssClass: "apexcharts-yaxis-label " + p.style.cssClass,
                            maxWidth: p.maxWidth
                        });
                        h.add(I), I.on("click", function(E) {
                            if (typeof s.config.chart.events.xAxisLabelClick == "function") {
                                var R = Object.assign({}, s, {
                                    labelIndex: x
                                });
                                s.config.chart.events.xAxisLabelClick(E, a.ctx, R);
                            }
                        });
                        var z = document.createElementNS(s.globals.SVGNS, "title");
                        if (z.textContent = Array.isArray(v) ? v.join(" ") : v, I.node.appendChild(z), s.config.yaxis[e].labels.rotate !== 0) {
                            var T = r.rotateAroundCenter(I.node);
                            I.node.setAttribute("transform", "rotate(".concat(s.config.yaxis[e].labels.rotate, " 0 ").concat(T.y, ")"));
                        }
                        i += t;
                    }, b = 0; b <= c.length - 1; b++)f(b);
                    if (s.config.yaxis[0].title.text !== void 0) {
                        var m = r.group({
                            class: "apexcharts-yaxis-title apexcharts-xaxis-title-inversed",
                            transform: "translate(" + n + ", 0)"
                        }), w = r.drawText({
                            x: s.config.yaxis[0].title.offsetX,
                            y: s.globals.gridHeight / 2 + s.config.yaxis[0].title.offsetY,
                            text: s.config.yaxis[0].title.text,
                            textAnchor: "middle",
                            foreColor: s.config.yaxis[0].title.style.color,
                            fontSize: s.config.yaxis[0].title.style.fontSize,
                            fontWeight: s.config.yaxis[0].title.style.fontWeight,
                            fontFamily: s.config.yaxis[0].title.style.fontFamily,
                            cssClass: "apexcharts-yaxis-title-text " + s.config.yaxis[0].title.style.cssClass
                        });
                        m.add(w), o.add(m);
                    }
                    var A = 0;
                    this.isCategoryBarHorizontal && s.config.yaxis[0].opposite && (A = s.globals.gridWidth);
                    var l = s.config.xaxis.axisBorder;
                    if (l.show) {
                        var u = r.drawLine(s.globals.padHorizontal + l.offsetX + A, 1 + l.offsetY, s.globals.padHorizontal + l.offsetX + A, s.globals.gridHeight + l.offsetY, l.color, 0);
                        this.elgrid && this.elgrid.elGridBorders && s.config.grid.show ? this.elgrid.elGridBorders.add(u) : o.add(u);
                    }
                    return s.config.yaxis[0].axisTicks.show && this.axesUtils.drawYAxisTicks(A, c.length, s.config.yaxis[0].axisBorder, s.config.yaxis[0].axisTicks, 0, t, o), o;
                }
            },
            {
                key: "drawXaxisTicks",
                value: function(e, t, i) {
                    var a = this.w, s = e;
                    if (!(e < 0 || e - 2 > a.globals.gridWidth)) {
                        var r = this.offY + a.config.xaxis.axisTicks.offsetY;
                        if (t = t + r + a.config.xaxis.axisTicks.height, a.config.xaxis.position === "top" && (t = r - a.config.xaxis.axisTicks.height), a.config.xaxis.axisTicks.show) {
                            var n = new M(this.ctx).drawLine(e + a.config.xaxis.axisTicks.offsetX, r + a.config.xaxis.offsetY, s + a.config.xaxis.axisTicks.offsetX, t + a.config.xaxis.offsetY, a.config.xaxis.axisTicks.color);
                            i.add(n), n.node.classList.add("apexcharts-xaxis-tick");
                        }
                    }
                }
            },
            {
                key: "getXAxisTicksPositions",
                value: function() {
                    var e = this.w, t = [], i = this.xaxisLabels.length, a = e.globals.padHorizontal;
                    if (e.globals.timescaleLabels.length > 0) for(var s = 0; s < i; s++)a = this.xaxisLabels[s].position, t.push(a);
                    else for(var r = i, n = 0; n < r; n++){
                        var o = r;
                        e.globals.isXNumeric && e.config.chart.type !== "bar" && (o -= 1), a += e.globals.gridWidth / o, t.push(a);
                    }
                    return t;
                }
            },
            {
                key: "xAxisLabelCorrections",
                value: function() {
                    var e = this.w, t = new M(this.ctx), i = e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"), a = e.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text:not(.apexcharts-xaxis-group-label)"), s = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"), r = e.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");
                    if (e.globals.rotateXLabels || e.config.xaxis.labels.rotateAlways) for(var n = 0; n < a.length; n++){
                        var o = t.rotateAroundCenter(a[n]);
                        o.y = o.y - 1, o.x = o.x + 1, a[n].setAttribute("transform", "rotate(".concat(e.config.xaxis.labels.rotate, " ").concat(o.x, " ").concat(o.y, ")")), a[n].setAttribute("text-anchor", "end"), i.setAttribute("transform", "translate(0, ".concat(-10, ")"));
                        var h = a[n].childNodes;
                        e.config.xaxis.labels.trim && Array.prototype.forEach.call(h, function(p) {
                            t.placeTextWithEllipsis(p, p.textContent, e.globals.xAxisLabelsHeight - (e.config.legend.position === "bottom" ? 20 : 10));
                        });
                    }
                    else (function() {
                        for(var p = e.globals.gridWidth / (e.globals.labels.length + 1), f = 0; f < a.length; f++){
                            var b = a[f].childNodes;
                            e.config.xaxis.labels.trim && e.config.xaxis.type !== "datetime" && Array.prototype.forEach.call(b, function(m) {
                                t.placeTextWithEllipsis(m, m.textContent, p);
                            });
                        }
                    })();
                    if (s.length > 0) {
                        var c = s[s.length - 1].getBBox(), d = s[0].getBBox();
                        c.x < -20 && s[s.length - 1].parentNode.removeChild(s[s.length - 1]), d.x + d.width > e.globals.gridWidth && !e.globals.isBarHorizontal && s[0].parentNode.removeChild(s[0]);
                        for(var g = 0; g < r.length; g++)t.placeTextWithEllipsis(r[g], r[g].textContent, e.config.yaxis[0].labels.maxWidth - (e.config.yaxis[0].title.text ? 2 * parseFloat(e.config.yaxis[0].title.style.fontSize) : 0) - 15);
                    }
                }
            }
        ]), y;
    }(), Qe = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
            var t = this.w;
            this.xaxisLabels = t.globals.labels.slice(), this.axesUtils = new xe(e), this.isRangeBar = t.globals.seriesRange.length && t.globals.isBarHorizontal, t.globals.timescaleLabels.length > 0 && (this.xaxisLabels = t.globals.timescaleLabels.slice());
        }
        return Y(y, [
            {
                key: "drawGridArea",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, t = this.w, i = new M(this.ctx);
                    e === null && (e = i.group({
                        class: "apexcharts-grid"
                    }));
                    var a = i.drawLine(t.globals.padHorizontal, 1, t.globals.padHorizontal, t.globals.gridHeight, "transparent"), s = i.drawLine(t.globals.padHorizontal, t.globals.gridHeight, t.globals.gridWidth, t.globals.gridHeight, "transparent");
                    return e.add(s), e.add(a), e;
                }
            },
            {
                key: "drawGrid",
                value: function() {
                    var e = null;
                    return this.w.globals.axisCharts && (e = this.renderGrid(), this.drawGridArea(e.el)), e;
                }
            },
            {
                key: "createGridMask",
                value: function() {
                    var e = this.w, t = e.globals, i = new M(this.ctx), a = Array.isArray(e.config.stroke.width) ? 0 : e.config.stroke.width;
                    if (Array.isArray(e.config.stroke.width)) {
                        var s = 0;
                        e.config.stroke.width.forEach(function(d) {
                            s = Math.max(s, d);
                        }), a = s;
                    }
                    t.dom.elGridRectMask = document.createElementNS(t.SVGNS, "clipPath"), t.dom.elGridRectMask.setAttribute("id", "gridRectMask".concat(t.cuid)), t.dom.elGridRectMarkerMask = document.createElementNS(t.SVGNS, "clipPath"), t.dom.elGridRectMarkerMask.setAttribute("id", "gridRectMarkerMask".concat(t.cuid)), t.dom.elForecastMask = document.createElementNS(t.SVGNS, "clipPath"), t.dom.elForecastMask.setAttribute("id", "forecastMask".concat(t.cuid)), t.dom.elNonForecastMask = document.createElementNS(t.SVGNS, "clipPath"), t.dom.elNonForecastMask.setAttribute("id", "nonForecastMask".concat(t.cuid));
                    var r = e.config.chart.type, n = 0, o = 0;
                    (r === "bar" || r === "rangeBar" || r === "candlestick" || r === "boxPlot" || e.globals.comboBarCount > 0) && e.globals.isXNumeric && !e.globals.isBarHorizontal && (n = e.config.grid.padding.left, o = e.config.grid.padding.right, t.barPadForNumericAxis > n && (n = t.barPadForNumericAxis, o = t.barPadForNumericAxis)), t.dom.elGridRect = i.drawRect(-a - n - 2, 2 * -a - 2, t.gridWidth + a + o + n + 4, t.gridHeight + 4 * a + 4, 0, "#fff");
                    var h = e.globals.markers.largestSize + 1;
                    t.dom.elGridRectMarker = i.drawRect(2 * -h, 2 * -h, t.gridWidth + 4 * h, t.gridHeight + 4 * h, 0, "#fff"), t.dom.elGridRectMask.appendChild(t.dom.elGridRect.node), t.dom.elGridRectMarkerMask.appendChild(t.dom.elGridRectMarker.node);
                    var c = t.dom.baseEl.querySelector("defs");
                    c.appendChild(t.dom.elGridRectMask), c.appendChild(t.dom.elForecastMask), c.appendChild(t.dom.elNonForecastMask), c.appendChild(t.dom.elGridRectMarkerMask);
                }
            },
            {
                key: "_drawGridLines",
                value: function(e) {
                    var t = e.i, i = e.x1, a = e.y1, s = e.x2, r = e.y2, n = e.xCount, o = e.parent, h = this.w;
                    if (!(t === 0 && h.globals.skipFirstTimelinelabel || t === n - 1 && h.globals.skipLastTimelinelabel && !h.config.xaxis.labels.formatter || h.config.chart.type === "radar")) {
                        h.config.grid.xaxis.lines.show && this._drawGridLine({
                            i: t,
                            x1: i,
                            y1: a,
                            x2: s,
                            y2: r,
                            xCount: n,
                            parent: o
                        });
                        var c = 0;
                        if (h.globals.hasXaxisGroups && h.config.xaxis.tickPlacement === "between") {
                            var d = h.globals.groups;
                            if (d) {
                                for(var g = 0, p = 0; g < t && p < d.length; p++)g += d[p].cols;
                                g === t && (c = 0.6 * h.globals.xAxisLabelsHeight);
                            }
                        }
                        new Ie(this.ctx).drawXaxisTicks(i, c, h.globals.dom.elGraphical);
                    }
                }
            },
            {
                key: "_drawGridLine",
                value: function(e) {
                    var t = e.i, i = e.x1, a = e.y1, s = e.x2, r = e.y2, n = e.xCount, o = e.parent, h = this.w, c = !1, d = o.node.classList.contains("apexcharts-gridlines-horizontal"), g = h.config.grid.strokeDashArray, p = h.globals.barPadForNumericAxis;
                    (a === 0 && r === 0 || i === 0 && s === 0) && (c = !0), a === h.globals.gridHeight && r === h.globals.gridHeight && (c = !0), !h.globals.isBarHorizontal || t !== 0 && t !== n - 1 || (c = !0);
                    var f = new M(this).drawLine(i - (d ? p : 0), a, s + (d ? p : 0), r, h.config.grid.borderColor, g);
                    f.node.classList.add("apexcharts-gridline"), c && h.config.grid.show ? this.elGridBorders.add(f) : o.add(f);
                }
            },
            {
                key: "_drawGridBandRect",
                value: function(e) {
                    var t = e.c, i = e.x1, a = e.y1, s = e.x2, r = e.y2, n = e.type, o = this.w, h = new M(this.ctx), c = o.globals.barPadForNumericAxis;
                    if (n !== "column" || o.config.xaxis.type !== "datetime") {
                        var d = o.config.grid[n].colors[t], g = h.drawRect(i - (n === "row" ? c : 0), a, s + (n === "row" ? 2 * c : 0), r, 0, d, o.config.grid[n].opacity);
                        this.elg.add(g), g.attr("clip-path", "url(#gridRectMask".concat(o.globals.cuid, ")")), g.node.classList.add("apexcharts-grid-".concat(n));
                    }
                }
            },
            {
                key: "_drawXYLines",
                value: function(e) {
                    var t = this, i = e.xCount, a = e.tickAmount, s = this.w;
                    if (s.config.grid.xaxis.lines.show || s.config.xaxis.axisTicks.show) {
                        var r, n = s.globals.padHorizontal, o = s.globals.gridHeight;
                        s.globals.timescaleLabels.length ? function(f) {
                            for(var b = f.xC, m = f.x1, w = f.y1, A = f.x2, l = f.y2, u = 0; u < b; u++)m = t.xaxisLabels[u].position, A = t.xaxisLabels[u].position, t._drawGridLines({
                                i: u,
                                x1: m,
                                y1: w,
                                x2: A,
                                y2: l,
                                xCount: i,
                                parent: t.elgridLinesV
                            });
                        }({
                            xC: i,
                            x1: n,
                            y1: 0,
                            x2: r,
                            y2: o
                        }) : (s.globals.isXNumeric && (i = s.globals.xAxisScale.result.length), function(f) {
                            for(var b = f.xC, m = f.x1, w = f.y1, A = f.x2, l = f.y2, u = 0; u < b + (s.globals.isXNumeric ? 0 : 1); u++)u === 0 && b === 1 && s.globals.dataPoints === 1 && (A = m = s.globals.gridWidth / 2), t._drawGridLines({
                                i: u,
                                x1: m,
                                y1: w,
                                x2: A,
                                y2: l,
                                xCount: i,
                                parent: t.elgridLinesV
                            }), A = m += s.globals.gridWidth / (s.globals.isXNumeric ? b - 1 : b);
                        }({
                            xC: i,
                            x1: n,
                            y1: 0,
                            x2: r,
                            y2: o
                        }));
                    }
                    if (s.config.grid.yaxis.lines.show) {
                        var h = 0, c = 0, d = s.globals.gridWidth, g = a + 1;
                        this.isRangeBar && (g = s.globals.labels.length);
                        for(var p = 0; p < g + (this.isRangeBar ? 1 : 0); p++)this._drawGridLine({
                            i: p,
                            xCount: g + (this.isRangeBar ? 1 : 0),
                            x1: 0,
                            y1: h,
                            x2: d,
                            y2: c,
                            parent: this.elgridLinesH
                        }), c = h += s.globals.gridHeight / (this.isRangeBar ? g : a);
                    }
                }
            },
            {
                key: "_drawInvertedXYLines",
                value: function(e) {
                    var t = e.xCount, i = this.w;
                    if (i.config.grid.xaxis.lines.show || i.config.xaxis.axisTicks.show) for(var a, s = i.globals.padHorizontal, r = i.globals.gridHeight, n = 0; n < t + 1; n++)i.config.grid.xaxis.lines.show && this._drawGridLine({
                        i: n,
                        xCount: t + 1,
                        x1: s,
                        y1: 0,
                        x2: a,
                        y2: r,
                        parent: this.elgridLinesV
                    }), new Ie(this.ctx).drawXaxisTicks(s, 0, i.globals.dom.elGraphical), a = s = s + i.globals.gridWidth / t + 0.3;
                    if (i.config.grid.yaxis.lines.show) for(var o = 0, h = 0, c = i.globals.gridWidth, d = 0; d < i.globals.dataPoints + 1; d++)this._drawGridLine({
                        i: d,
                        xCount: i.globals.dataPoints + 1,
                        x1: 0,
                        y1: o,
                        x2: c,
                        y2: h,
                        parent: this.elgridLinesH
                    }), h = o += i.globals.gridHeight / i.globals.dataPoints;
                }
            },
            {
                key: "renderGrid",
                value: function() {
                    var e = this.w, t = new M(this.ctx);
                    this.elg = t.group({
                        class: "apexcharts-grid"
                    }), this.elgridLinesH = t.group({
                        class: "apexcharts-gridlines-horizontal"
                    }), this.elgridLinesV = t.group({
                        class: "apexcharts-gridlines-vertical"
                    }), this.elGridBorders = t.group({
                        class: "apexcharts-grid-borders"
                    }), this.elg.add(this.elgridLinesH), this.elg.add(this.elgridLinesV), e.config.grid.show || (this.elgridLinesV.hide(), this.elgridLinesH.hide(), this.elGridBorders.hide());
                    for(var i, a = e.globals.yAxisScale.length ? e.globals.yAxisScale[0].result.length - 1 : 5, s = 0; s < e.globals.series.length && (e.globals.yAxisScale[s] !== void 0 && (a = e.globals.yAxisScale[s].result.length - 1), !(a > 2)); s++);
                    if (!e.globals.isBarHorizontal || this.isRangeBar) {
                        var r, n, o;
                        i = this.xaxisLabels.length, this.isRangeBar && (i--, a = e.globals.labels.length, e.config.xaxis.tickAmount && e.config.xaxis.labels.formatter && (i = e.config.xaxis.tickAmount), ((r = e.globals.yAxisScale) === null || r === void 0 || (n = r[0]) === null || n === void 0 || (o = n.result) === null || o === void 0 ? void 0 : o.length) > 0 && e.config.xaxis.type !== "datetime" && (i = e.globals.yAxisScale[0].result.length - 1)), this._drawXYLines({
                            xCount: i,
                            tickAmount: a
                        });
                    } else i = a, a = e.globals.xTickAmount, this._drawInvertedXYLines({
                        xCount: i,
                        tickAmount: a
                    });
                    return this.drawGridBands(i, a), {
                        el: this.elg,
                        elGridBorders: this.elGridBorders,
                        xAxisTickWidth: e.globals.gridWidth / i
                    };
                }
            },
            {
                key: "drawGridBands",
                value: function(e, t) {
                    var i = this.w;
                    if (i.config.grid.row.colors !== void 0 && i.config.grid.row.colors.length > 0) for(var a = 0, s = i.globals.gridHeight / t, r = i.globals.gridWidth, n = 0, o = 0; n < t; n++, o++)o >= i.config.grid.row.colors.length && (o = 0), this._drawGridBandRect({
                        c: o,
                        x1: 0,
                        y1: a,
                        x2: r,
                        y2: s,
                        type: "row"
                    }), a += i.globals.gridHeight / t;
                    if (i.config.grid.column.colors !== void 0 && i.config.grid.column.colors.length > 0) for(var h = i.globals.isBarHorizontal || i.config.xaxis.tickPlacement !== "on" || i.config.xaxis.type !== "category" && !i.config.xaxis.convertedCatToNumeric ? e : e - 1, c = i.globals.padHorizontal, d = i.globals.padHorizontal + i.globals.gridWidth / h, g = i.globals.gridHeight, p = 0, f = 0; p < e; p++, f++)f >= i.config.grid.column.colors.length && (f = 0), this._drawGridBandRect({
                        c: f,
                        x1: c,
                        y1: 0,
                        x2: d,
                        y2: g,
                        type: "column"
                    }), c += i.globals.gridWidth / h;
                }
            }
        ]), y;
    }(), we = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "niceScale",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, s = arguments.length > 4 ? arguments[4] : void 0, r = this.w, n = Math.abs(t - e);
                    if ((i = this._adjustTicksForSmallRange(i, a, n)) === "dataPoints" && (i = r.globals.dataPoints - 1), e === Number.MIN_VALUE && t === 0 || !P.isNumber(e) && !P.isNumber(t) || e === Number.MIN_VALUE && t === -Number.MAX_VALUE) return e = 0, t = i, this.linearScale(e, t, i, a, r.config.yaxis[a].stepSize);
                    e > t ? (console.warn("axis.min cannot be greater than axis.max"), t = e + 0.1) : e === t && (e = e === 0 ? 0 : e - 0.5, t = t === 0 ? 2 : t + 0.5);
                    var o = [];
                    n < 1 && s && (r.config.chart.type === "candlestick" || r.config.series[a].type === "candlestick" || r.config.chart.type === "boxPlot" || r.config.series[a].type === "boxPlot" || r.globals.isRangeData) && (t *= 1.01);
                    var h = i + 1;
                    h < 2 ? h = 2 : h > 2 && (h -= 2);
                    var c = n / h, d = Math.floor(P.log10(c)), g = Math.pow(10, d), p = Math.round(c / g);
                    p < 1 && (p = 1);
                    var f = p * g;
                    r.config.yaxis[a].stepSize && (f = r.config.yaxis[a].stepSize), r.globals.isBarHorizontal && r.config.xaxis.stepSize && r.config.xaxis.type !== "datetime" && (f = r.config.xaxis.stepSize);
                    var b = f * Math.floor(e / f), m = f * Math.ceil(t / f), w = b;
                    if (s && n > 2) {
                        for(; o.push(P.stripNumber(w, 7)), !((w += f) > m););
                        return {
                            result: o,
                            niceMin: o[0],
                            niceMax: o[o.length - 1]
                        };
                    }
                    var A = e;
                    (o = []).push(P.stripNumber(A, 7));
                    for(var l = Math.abs(t - e) / i, u = 0; u <= i; u++)A += l, o.push(A);
                    return o[o.length - 2] >= t && o.pop(), {
                        result: o,
                        niceMin: o[0],
                        niceMax: o[o.length - 1]
                    };
                }
            },
            {
                key: "linearScale",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : void 0, r = Math.abs(t - e);
                    (i = this._adjustTicksForSmallRange(i, a, r)) === "dataPoints" && (i = this.w.globals.dataPoints - 1), s || (s = r / i), i === Number.MAX_VALUE && (i = 5, s = 1);
                    for(var n = [], o = e; i >= 0;)n.push(o), o += s, i -= 1;
                    return {
                        result: n,
                        niceMin: n[0],
                        niceMax: n[n.length - 1]
                    };
                }
            },
            {
                key: "logarithmicScaleNice",
                value: function(e, t, i) {
                    t <= 0 && (t = Math.max(e, i)), e <= 0 && (e = Math.min(t, i));
                    for(var a = [], s = Math.ceil(Math.log(t) / Math.log(i) + 1), r = Math.floor(Math.log(e) / Math.log(i)); r < s; r++)a.push(Math.pow(i, r));
                    return {
                        result: a,
                        niceMin: a[0],
                        niceMax: a[a.length - 1]
                    };
                }
            },
            {
                key: "logarithmicScale",
                value: function(e, t, i) {
                    t <= 0 && (t = Math.max(e, i)), e <= 0 && (e = Math.min(t, i));
                    for(var a = [], s = Math.log(t) / Math.log(i), r = Math.log(e) / Math.log(i), n = s - r, o = Math.round(n), h = n / o, c = 0, d = r; c < o; c++, d += h)a.push(Math.pow(i, d));
                    return a.push(Math.pow(i, s)), {
                        result: a,
                        niceMin: e,
                        niceMax: t
                    };
                }
            },
            {
                key: "_adjustTicksForSmallRange",
                value: function(e, t, i) {
                    var a = e;
                    if (t !== void 0 && this.w.config.yaxis[t].labels.formatter && this.w.config.yaxis[t].tickAmount === void 0) {
                        var s = Number(this.w.config.yaxis[t].labels.formatter(1));
                        P.isNumber(s) && this.w.globals.yValueDecimal === 0 && (a = Math.ceil(i));
                    }
                    return a < e ? a : e;
                }
            },
            {
                key: "setYScaleForIndex",
                value: function(e, t, i) {
                    var a = this.w.globals, s = this.w.config, r = a.isBarHorizontal ? s.xaxis : s.yaxis[e];
                    a.yAxisScale[e] === void 0 && (a.yAxisScale[e] = []);
                    var n = Math.abs(i - t);
                    if (r.logarithmic && n <= 5 && (a.invalidLogScale = !0), r.logarithmic && n > 5) a.allSeriesCollapsed = !1, a.yAxisScale[e] = this.logarithmicScale(t, i, r.logBase), a.yAxisScale[e] = r.forceNiceScale ? this.logarithmicScaleNice(t, i, r.logBase) : this.logarithmicScale(t, i, r.logBase);
                    else if (i !== -Number.MAX_VALUE && P.isNumber(i)) {
                        if (a.allSeriesCollapsed = !1, r.min === void 0 && r.max === void 0 || r.forceNiceScale) {
                            var o = s.yaxis[e].max === void 0 && s.yaxis[e].min === void 0 || s.yaxis[e].forceNiceScale;
                            a.yAxisScale[e] = this.niceScale(t, i, r.tickAmount ? r.tickAmount : n < 5 && n > 1 ? n + 1 : 5, e, o);
                        } else a.yAxisScale[e] = this.linearScale(t, i, r.tickAmount, e, s.yaxis[e].stepSize);
                    } else a.yAxisScale[e] = this.linearScale(0, 5, 5, e, s.yaxis[e].stepSize);
                }
            },
            {
                key: "setXScale",
                value: function(e, t) {
                    var i = this.w, a = i.globals, s = Math.abs(t - e);
                    return t !== -Number.MAX_VALUE && P.isNumber(t) ? a.xAxisScale = this.linearScale(e, t, i.config.xaxis.tickAmount ? i.config.xaxis.tickAmount : s < 5 && s > 1 ? s + 1 : 5, 0, i.config.xaxis.stepSize) : a.xAxisScale = this.linearScale(0, 5, 5), a.xAxisScale;
                }
            },
            {
                key: "setMultipleYScales",
                value: function() {
                    var e = this, t = this.w.globals, i = this.w.config, a = t.minYArr.concat([]), s = t.maxYArr.concat([]), r = [];
                    i.yaxis.forEach(function(n, o) {
                        var h = o;
                        i.series.forEach(function(g, p) {
                            g.name === n.seriesName && (h = p, o !== p ? r.push({
                                index: p,
                                similarIndex: o,
                                alreadyExists: !0
                            }) : r.push({
                                index: p
                            }));
                        });
                        var c = a[h], d = s[h];
                        e.setYScaleForIndex(o, c, d);
                    }), this.sameScaleInMultipleAxes(a, s, r);
                }
            },
            {
                key: "sameScaleInMultipleAxes",
                value: function(e, t, i) {
                    var a = this, s = this.w.config, r = this.w.globals, n = [];
                    i.forEach(function(b) {
                        b.alreadyExists && (n[b.index] === void 0 && (n[b.index] = []), n[b.index].push(b.index), n[b.index].push(b.similarIndex));
                    }), r.yAxisSameScaleIndices = n, n.forEach(function(b, m) {
                        n.forEach(function(w, A) {
                            var l, u;
                            m !== A && (l = b, u = w, l.filter(function(x) {
                                return u.indexOf(x) !== -1;
                            })).length > 0 && (n[m] = n[m].concat(n[A]));
                        });
                    });
                    var o = n.map(function(b) {
                        return b.filter(function(m, w) {
                            return b.indexOf(m) === w;
                        });
                    }).map(function(b) {
                        return b.sort();
                    });
                    n = n.filter(function(b) {
                        return !!b;
                    });
                    var h = o.slice(), c = h.map(function(b) {
                        return JSON.stringify(b);
                    });
                    h = h.filter(function(b, m) {
                        return c.indexOf(JSON.stringify(b)) === m;
                    });
                    var d = [], g = [];
                    e.forEach(function(b, m) {
                        h.forEach(function(w, A) {
                            w.indexOf(m) > -1 && (d[A] === void 0 && (d[A] = [], g[A] = []), d[A].push({
                                key: m,
                                value: b
                            }), g[A].push({
                                key: m,
                                value: t[m]
                            }));
                        });
                    });
                    var p = Array.apply(null, Array(h.length)).map(Number.prototype.valueOf, Number.MIN_VALUE), f = Array.apply(null, Array(h.length)).map(Number.prototype.valueOf, -Number.MAX_VALUE);
                    d.forEach(function(b, m) {
                        b.forEach(function(w, A) {
                            p[m] = Math.min(w.value, p[m]);
                        });
                    }), g.forEach(function(b, m) {
                        b.forEach(function(w, A) {
                            f[m] = Math.max(w.value, f[m]);
                        });
                    }), e.forEach(function(b, m) {
                        g.forEach(function(w, A) {
                            var l = p[A], u = f[A];
                            s.chart.stacked && (u = 0, w.forEach(function(x, v) {
                                x.value !== -Number.MAX_VALUE && (u += x.value), l !== Number.MIN_VALUE && (l += d[A][v].value);
                            })), w.forEach(function(x, v) {
                                w[v].key === m && (s.yaxis[m].min !== void 0 && (l = typeof s.yaxis[m].min == "function" ? s.yaxis[m].min(r.minY) : s.yaxis[m].min), s.yaxis[m].max !== void 0 && (u = typeof s.yaxis[m].max == "function" ? s.yaxis[m].max(r.maxY) : s.yaxis[m].max), a.setYScaleForIndex(m, l, u));
                            });
                        });
                    });
                }
            },
            {
                key: "autoScaleY",
                value: function(e, t, i) {
                    e || (e = this);
                    var a = e.w;
                    if (a.globals.isMultipleYAxis || a.globals.collapsedSeries.length) return console.warn("autoScaleYaxis not supported in a multi-yaxis chart."), t;
                    var s = a.globals.seriesX[0], r = a.config.chart.stacked;
                    return t.forEach(function(n, o) {
                        for(var h = 0, c = 0; c < s.length; c++)if (s[c] >= i.xaxis.min) {
                            h = c;
                            break;
                        }
                        var d, g, p = a.globals.minYArr[o], f = a.globals.maxYArr[o], b = a.globals.stackedSeriesTotals;
                        a.globals.series.forEach(function(m, w) {
                            var A = m[h];
                            r ? (A = b[h], d = g = A, b.forEach(function(l, u) {
                                s[u] <= i.xaxis.max && s[u] >= i.xaxis.min && (l > g && l !== null && (g = l), m[u] < d && m[u] !== null && (d = m[u]));
                            })) : (d = g = A, m.forEach(function(l, u) {
                                if (s[u] <= i.xaxis.max && s[u] >= i.xaxis.min) {
                                    var x = l, v = l;
                                    a.globals.series.forEach(function(k, S) {
                                        l !== null && (x = Math.min(k[u], x), v = Math.max(k[u], v));
                                    }), v > g && v !== null && (g = v), x < d && x !== null && (d = x);
                                }
                            })), d === void 0 && g === void 0 && (d = p, g = f), g *= g < 0 ? 0.9 : 1.1, (d *= d < 0 ? 1.1 : 0.9) === 0 && g === 0 && (d = -1, g = 1), g < 0 && g < f && (g = f), d < 0 && d > p && (d = p), t.length > 1 ? (t[w].min = n.min === void 0 ? d : n.min, t[w].max = n.max === void 0 ? g : n.max) : (t[0].min = n.min === void 0 ? d : n.min, t[0].max = n.max === void 0 ? g : n.max);
                        });
                    }), t;
                }
            }
        ]), y;
    }(), De = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.scales = new we(e);
        }
        return Y(y, [
            {
                key: "init",
                value: function() {
                    this.setYRange(), this.setXRange(), this.setZRange();
                }
            },
            {
                key: "getMinYMaxY",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -Number.MAX_VALUE, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, s = this.w.config, r = this.w.globals, n = -Number.MAX_VALUE, o = Number.MIN_VALUE;
                    a === null && (a = e + 1);
                    var h = r.series, c = h, d = h;
                    s.chart.type === "candlestick" ? (c = r.seriesCandleL, d = r.seriesCandleH) : s.chart.type === "boxPlot" ? (c = r.seriesCandleO, d = r.seriesCandleC) : r.isRangeData && (c = r.seriesRangeStart, d = r.seriesRangeEnd);
                    for(var g = e; g < a; g++){
                        r.dataPoints = Math.max(r.dataPoints, h[g].length), r.categoryLabels.length && (r.dataPoints = r.categoryLabels.filter(function(b) {
                            return b !== void 0;
                        }).length), r.labels.length && s.xaxis.type !== "datetime" && r.series.reduce(function(b, m) {
                            return b + m.length;
                        }, 0) !== 0 && (r.dataPoints = Math.max(r.dataPoints, r.labels.length));
                        for(var p = 0; p < r.series[g].length; p++){
                            var f = h[g][p];
                            f !== null && P.isNumber(f) ? (d[g][p] !== void 0 && (n = Math.max(n, d[g][p]), t = Math.min(t, d[g][p])), c[g][p] !== void 0 && (t = Math.min(t, c[g][p]), i = Math.max(i, c[g][p])), this.w.config.chart.type !== "candlestick" && this.w.config.chart.type !== "boxPlot" && this.w.config.chart.type === "rangeArea" && this.w.config.chart.type === "rangeBar" || (this.w.config.chart.type !== "candlestick" && this.w.config.chart.type !== "boxPlot" || r.seriesCandleC[g][p] !== void 0 && (n = Math.max(n, r.seriesCandleO[g][p]), n = Math.max(n, r.seriesCandleH[g][p]), n = Math.max(n, r.seriesCandleL[g][p]), n = Math.max(n, r.seriesCandleC[g][p]), this.w.config.chart.type === "boxPlot" && (n = Math.max(n, r.seriesCandleM[g][p]))), !s.series[g].type || s.series[g].type === "candlestick" && s.series[g].type === "boxPlot" && s.series[g].type === "rangeArea" && s.series[g].type === "rangeBar" || (n = Math.max(n, r.series[g][p]), t = Math.min(t, r.series[g][p])), i = n), r.seriesGoals[g] && r.seriesGoals[g][p] && Array.isArray(r.seriesGoals[g][p]) && r.seriesGoals[g][p].forEach(function(b) {
                                o !== Number.MIN_VALUE && (o = Math.min(o, b.value), t = o), n = Math.max(n, b.value), i = n;
                            }), P.isFloat(f) && (f = P.noExponents(f), r.yValueDecimal = Math.max(r.yValueDecimal, f.toString().split(".")[1].length)), o > c[g][p] && c[g][p] < 0 && (o = c[g][p])) : r.hasNullValues = !0;
                        }
                    }
                    return s.chart.type === "rangeBar" && r.seriesRangeStart.length && r.isBarHorizontal && (o = t), s.chart.type === "bar" && (o < 0 && n < 0 && (n = 0), o === Number.MIN_VALUE && (o = 0)), {
                        minY: o,
                        maxY: n,
                        lowestY: t,
                        highestY: i
                    };
                }
            },
            {
                key: "setYRange",
                value: function() {
                    var e = this.w.globals, t = this.w.config;
                    e.maxY = -Number.MAX_VALUE, e.minY = Number.MIN_VALUE;
                    var i = Number.MAX_VALUE;
                    if (e.isMultipleYAxis) for(var a = 0; a < e.series.length; a++){
                        var s = this.getMinYMaxY(a, i, null, a + 1);
                        e.minYArr.push(s.minY), e.maxYArr.push(s.maxY), i = s.lowestY;
                    }
                    var r = this.getMinYMaxY(0, i, null, e.series.length);
                    if (e.minY = r.minY, e.maxY = r.maxY, i = r.lowestY, t.chart.stacked && this._setStackedMinMax(), (t.chart.type === "line" || t.chart.type === "area" || t.chart.type === "candlestick" || t.chart.type === "boxPlot" || t.chart.type === "rangeBar" && !e.isBarHorizontal) && e.minY === Number.MIN_VALUE && i !== -Number.MAX_VALUE && i !== e.maxY) {
                        var n = e.maxY - i;
                        (i >= 0 && i <= 10 || t.yaxis[0].min !== void 0 || t.yaxis[0].max !== void 0) && (n = 0), e.minY = i - 5 * n / 100, i > 0 && e.minY < 0 && (e.minY = 0), e.maxY = e.maxY + 5 * n / 100;
                    }
                    return t.yaxis.forEach(function(o, h) {
                        o.max !== void 0 && (typeof o.max == "number" ? e.maxYArr[h] = o.max : typeof o.max == "function" && (e.maxYArr[h] = o.max(e.isMultipleYAxis ? e.maxYArr[h] : e.maxY)), e.maxY = e.maxYArr[h]), o.min !== void 0 && (typeof o.min == "number" ? e.minYArr[h] = o.min : typeof o.min == "function" && (e.minYArr[h] = o.min(e.isMultipleYAxis ? e.minYArr[h] === Number.MIN_VALUE ? 0 : e.minYArr[h] : e.minY)), e.minY = e.minYArr[h]);
                    }), e.isBarHorizontal && [
                        "min",
                        "max"
                    ].forEach(function(o) {
                        t.xaxis[o] !== void 0 && typeof t.xaxis[o] == "number" && (o === "min" ? e.minY = t.xaxis[o] : e.maxY = t.xaxis[o]);
                    }), e.isMultipleYAxis ? (this.scales.setMultipleYScales(), e.minY = i, e.yAxisScale.forEach(function(o, h) {
                        e.minYArr[h] = o.niceMin, e.maxYArr[h] = o.niceMax;
                    })) : (this.scales.setYScaleForIndex(0, e.minY, e.maxY), e.minY = e.yAxisScale[0].niceMin, e.maxY = e.yAxisScale[0].niceMax, e.minYArr[0] = e.yAxisScale[0].niceMin, e.maxYArr[0] = e.yAxisScale[0].niceMax), {
                        minY: e.minY,
                        maxY: e.maxY,
                        minYArr: e.minYArr,
                        maxYArr: e.maxYArr,
                        yAxisScale: e.yAxisScale
                    };
                }
            },
            {
                key: "setXRange",
                value: function() {
                    var e = this.w.globals, t = this.w.config, i = t.xaxis.type === "numeric" || t.xaxis.type === "datetime" || t.xaxis.type === "category" && !e.noLabelsProvided || e.noLabelsProvided || e.isXNumeric;
                    if (e.isXNumeric && function() {
                        for(var n = 0; n < e.series.length; n++)if (e.labels[n]) for(var o = 0; o < e.labels[n].length; o++)e.labels[n][o] !== null && P.isNumber(e.labels[n][o]) && (e.maxX = Math.max(e.maxX, e.labels[n][o]), e.initialMaxX = Math.max(e.maxX, e.labels[n][o]), e.minX = Math.min(e.minX, e.labels[n][o]), e.initialMinX = Math.min(e.minX, e.labels[n][o]));
                    }(), e.noLabelsProvided && t.xaxis.categories.length === 0 && (e.maxX = e.labels[e.labels.length - 1], e.initialMaxX = e.labels[e.labels.length - 1], e.minX = 1, e.initialMinX = 1), e.isXNumeric || e.noLabelsProvided || e.dataFormatXNumeric) {
                        var a;
                        if (t.xaxis.tickAmount === void 0 ? (a = Math.round(e.svgWidth / 150), t.xaxis.type === "numeric" && e.dataPoints < 30 && (a = e.dataPoints - 1), a > e.dataPoints && e.dataPoints !== 0 && (a = e.dataPoints - 1)) : t.xaxis.tickAmount === "dataPoints" ? (e.series.length > 1 && (a = e.series[e.maxValsInArrayIndex].length - 1), e.isXNumeric && (a = e.maxX - e.minX - 1)) : a = t.xaxis.tickAmount, e.xTickAmount = a, t.xaxis.max !== void 0 && typeof t.xaxis.max == "number" && (e.maxX = t.xaxis.max), t.xaxis.min !== void 0 && typeof t.xaxis.min == "number" && (e.minX = t.xaxis.min), t.xaxis.range !== void 0 && (e.minX = e.maxX - t.xaxis.range), e.minX !== Number.MAX_VALUE && e.maxX !== -Number.MAX_VALUE) {
                            if (t.xaxis.convertedCatToNumeric && !e.dataFormatXNumeric) {
                                for(var s = [], r = e.minX - 1; r < e.maxX; r++)s.push(r + 1);
                                e.xAxisScale = {
                                    result: s,
                                    niceMin: s[0],
                                    niceMax: s[s.length - 1]
                                };
                            } else e.xAxisScale = this.scales.setXScale(e.minX, e.maxX);
                        } else e.xAxisScale = this.scales.linearScale(0, a, a, 0, t.xaxis.stepSize), e.noLabelsProvided && e.labels.length > 0 && (e.xAxisScale = this.scales.linearScale(1, e.labels.length, a - 1, 0, t.xaxis.stepSize), e.seriesX = e.labels.slice());
                        i && (e.labels = e.xAxisScale.result.slice());
                    }
                    return e.isBarHorizontal && e.labels.length && (e.xTickAmount = e.labels.length), this._handleSingleDataPoint(), this._getMinXDiff(), {
                        minX: e.minX,
                        maxX: e.maxX
                    };
                }
            },
            {
                key: "setZRange",
                value: function() {
                    var e = this.w.globals;
                    if (e.isDataXYZ) {
                        for(var t = 0; t < e.series.length; t++)if (e.seriesZ[t] !== void 0) for(var i = 0; i < e.seriesZ[t].length; i++)e.seriesZ[t][i] !== null && P.isNumber(e.seriesZ[t][i]) && (e.maxZ = Math.max(e.maxZ, e.seriesZ[t][i]), e.minZ = Math.min(e.minZ, e.seriesZ[t][i]));
                    }
                }
            },
            {
                key: "_handleSingleDataPoint",
                value: function() {
                    var e = this.w.globals, t = this.w.config;
                    if (e.minX === e.maxX) {
                        var i = new B(this.ctx);
                        if (t.xaxis.type === "datetime") {
                            var a = i.getDate(e.minX);
                            t.xaxis.labels.datetimeUTC ? a.setUTCDate(a.getUTCDate() - 2) : a.setDate(a.getDate() - 2), e.minX = new Date(a).getTime();
                            var s = i.getDate(e.maxX);
                            t.xaxis.labels.datetimeUTC ? s.setUTCDate(s.getUTCDate() + 2) : s.setDate(s.getDate() + 2), e.maxX = new Date(s).getTime();
                        } else (t.xaxis.type === "numeric" || t.xaxis.type === "category" && !e.noLabelsProvided) && (e.minX = e.minX - 2, e.initialMinX = e.minX, e.maxX = e.maxX + 2, e.initialMaxX = e.maxX);
                    }
                }
            },
            {
                key: "_getMinXDiff",
                value: function() {
                    var e = this.w.globals;
                    e.isXNumeric && e.seriesX.forEach(function(t, i) {
                        t.length === 1 && t.push(e.seriesX[e.maxValsInArrayIndex][e.seriesX[e.maxValsInArrayIndex].length - 1]);
                        var a = t.slice();
                        a.sort(function(s, r) {
                            return s - r;
                        }), a.forEach(function(s, r) {
                            if (r > 0) {
                                var n = s - a[r - 1];
                                n > 0 && (e.minXDiff = Math.min(n, e.minXDiff));
                            }
                        }), e.dataPoints !== 1 && e.minXDiff !== Number.MAX_VALUE || (e.minXDiff = 0.5);
                    });
                }
            },
            {
                key: "_setStackedMinMax",
                value: function() {
                    var e = this, t = this.w.globals;
                    if (t.series.length) {
                        var i = t.seriesGroups;
                        i.length || (i = [
                            this.w.config.series.map(function(r) {
                                return r.name;
                            })
                        ]);
                        var a = {}, s = {};
                        i.forEach(function(r) {
                            a[r] = [], s[r] = [], e.w.config.series.map(function(n, o) {
                                return r.indexOf(n.name) > -1 ? o : null;
                            }).filter(function(n) {
                                return n !== null;
                            }).forEach(function(n) {
                                for(var o = 0; o < t.series[t.maxValsInArrayIndex].length; o++){
                                    var h, c;
                                    a[r][o] === void 0 && (a[r][o] = 0, s[r][o] = 0), (e.w.config.chart.stacked && !t.comboCharts || e.w.config.chart.stacked && t.comboCharts && (!e.w.config.chart.stackOnlyBar || ((h = e.w.config.series) === null || h === void 0 || (c = h[n]) === null || c === void 0 ? void 0 : c.type) === "bar")) && t.series[n][o] !== null && P.isNumber(t.series[n][o]) && (t.series[n][o] > 0 ? a[r][o] += parseFloat(t.series[n][o]) + 1e-4 : s[r][o] += parseFloat(t.series[n][o]));
                                }
                            });
                        }), Object.entries(a).forEach(function(r) {
                            var n = Me(r, 1)[0];
                            a[n].forEach(function(o, h) {
                                t.maxY = Math.max(t.maxY, a[n][h]), t.minY = Math.min(t.minY, s[n][h]);
                            });
                        });
                    }
                }
            }
        ]), y;
    }(), Ne = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.elgrid = t, this.w = e.w;
            var i = this.w;
            this.xaxisFontSize = i.config.xaxis.labels.style.fontSize, this.axisFontFamily = i.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = i.config.xaxis.labels.style.colors, this.isCategoryBarHorizontal = i.config.chart.type === "bar" && i.config.plotOptions.bar.horizontal, this.xAxisoffX = 0, i.config.xaxis.position === "bottom" && (this.xAxisoffX = i.globals.gridHeight), this.drawnLabels = [], this.axesUtils = new xe(e);
        }
        return Y(y, [
            {
                key: "drawYaxis",
                value: function(e) {
                    var t = this, i = this.w, a = new M(this.ctx), s = i.config.yaxis[e].labels.style, r = s.fontSize, n = s.fontFamily, o = s.fontWeight, h = a.group({
                        class: "apexcharts-yaxis",
                        rel: e,
                        transform: "translate(" + i.globals.translateYAxisX[e] + ", 0)"
                    });
                    if (this.axesUtils.isYAxisHidden(e)) return h;
                    var c = a.group({
                        class: "apexcharts-yaxis-texts-g"
                    });
                    h.add(c);
                    var d = i.globals.yAxisScale[e].result.length - 1, g = i.globals.gridHeight / d, p = i.globals.translateY, f = i.globals.yLabelFormatters[e], b = i.globals.yAxisScale[e].result.slice();
                    b = this.axesUtils.checkForReversedLabels(e, b);
                    var m = "";
                    if (i.config.yaxis[e].labels.show) for(var w = function(C) {
                        var L = b[C];
                        L = f(L, C, i);
                        var I = i.config.yaxis[e].labels.padding;
                        i.config.yaxis[e].opposite && i.config.yaxis.length !== 0 && (I *= -1);
                        var z = "end";
                        i.config.yaxis[e].opposite && (z = "start"), i.config.yaxis[e].labels.align === "left" ? z = "start" : i.config.yaxis[e].labels.align === "center" ? z = "middle" : i.config.yaxis[e].labels.align === "right" && (z = "end");
                        var T = t.axesUtils.getYAxisForeColor(s.colors, e), E = i.config.yaxis[e].labels.offsetY;
                        i.config.chart.type === "heatmap" && (E -= (i.globals.gridHeight / i.globals.series.length - 1) / 2);
                        var R = a.drawText({
                            x: I,
                            y: p + d / 10 + E + 1,
                            text: L,
                            textAnchor: z,
                            fontSize: r,
                            fontFamily: n,
                            fontWeight: o,
                            maxWidth: i.config.yaxis[e].labels.maxWidth,
                            foreColor: Array.isArray(T) ? T[C] : T,
                            isPlainText: !1,
                            cssClass: "apexcharts-yaxis-label " + s.cssClass
                        });
                        C === d && (m = R), c.add(R);
                        var O = document.createElementNS(i.globals.SVGNS, "title");
                        if (O.textContent = Array.isArray(L) ? L.join(" ") : L, R.node.appendChild(O), i.config.yaxis[e].labels.rotate !== 0) {
                            var D = a.rotateAroundCenter(m.node), W = a.rotateAroundCenter(R.node);
                            R.node.setAttribute("transform", "rotate(".concat(i.config.yaxis[e].labels.rotate, " ").concat(D.x, " ").concat(W.y, ")"));
                        }
                        p += g;
                    }, A = d; A >= 0; A--)w(A);
                    if (i.config.yaxis[e].title.text !== void 0) {
                        var l = a.group({
                            class: "apexcharts-yaxis-title"
                        }), u = 0;
                        i.config.yaxis[e].opposite && (u = i.globals.translateYAxisX[e]);
                        var x = a.drawText({
                            x: u,
                            y: i.globals.gridHeight / 2 + i.globals.translateY + i.config.yaxis[e].title.offsetY,
                            text: i.config.yaxis[e].title.text,
                            textAnchor: "end",
                            foreColor: i.config.yaxis[e].title.style.color,
                            fontSize: i.config.yaxis[e].title.style.fontSize,
                            fontWeight: i.config.yaxis[e].title.style.fontWeight,
                            fontFamily: i.config.yaxis[e].title.style.fontFamily,
                            cssClass: "apexcharts-yaxis-title-text " + i.config.yaxis[e].title.style.cssClass
                        });
                        l.add(x), h.add(l);
                    }
                    var v = i.config.yaxis[e].axisBorder, k = 31 + v.offsetX;
                    if (i.config.yaxis[e].opposite && (k = -31 - v.offsetX), v.show) {
                        var S = a.drawLine(k, i.globals.translateY + v.offsetY - 2, k, i.globals.gridHeight + i.globals.translateY + v.offsetY + 2, v.color, 0, v.width);
                        h.add(S);
                    }
                    return i.config.yaxis[e].axisTicks.show && this.axesUtils.drawYAxisTicks(k, d, v, i.config.yaxis[e].axisTicks, e, g, h), h;
                }
            },
            {
                key: "drawYaxisInversed",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx), a = i.group({
                        class: "apexcharts-xaxis apexcharts-yaxis-inversed"
                    }), s = i.group({
                        class: "apexcharts-xaxis-texts-g",
                        transform: "translate(".concat(t.globals.translateXAxisX, ", ").concat(t.globals.translateXAxisY, ")")
                    });
                    a.add(s);
                    var r = t.globals.yAxisScale[e].result.length - 1, n = t.globals.gridWidth / r + 0.1, o = n + t.config.xaxis.labels.offsetX, h = t.globals.xLabelFormatter, c = t.globals.yAxisScale[e].result.slice(), d = t.globals.timescaleLabels;
                    d.length > 0 && (this.xaxisLabels = d.slice(), r = (c = d.slice()).length), c = this.axesUtils.checkForReversedLabels(e, c);
                    var g = d.length;
                    if (t.config.xaxis.labels.show) for(var p = g ? 0 : r; g ? p < g : p >= 0; g ? p++ : p--){
                        var f = c[p];
                        f = h(f, p, t);
                        var b = t.globals.gridWidth + t.globals.padHorizontal - (o - n + t.config.xaxis.labels.offsetX);
                        if (d.length) {
                            var m = this.axesUtils.getLabel(c, d, b, p, this.drawnLabels, this.xaxisFontSize);
                            b = m.x, f = m.text, this.drawnLabels.push(m.text), p === 0 && t.globals.skipFirstTimelinelabel && (f = ""), p === c.length - 1 && t.globals.skipLastTimelinelabel && (f = "");
                        }
                        var w = i.drawText({
                            x: b,
                            y: this.xAxisoffX + t.config.xaxis.labels.offsetY + 30 - (t.config.xaxis.position === "top" ? t.globals.xAxisHeight + t.config.xaxis.axisTicks.height - 2 : 0),
                            text: f,
                            textAnchor: "middle",
                            foreColor: Array.isArray(this.xaxisForeColors) ? this.xaxisForeColors[e] : this.xaxisForeColors,
                            fontSize: this.xaxisFontSize,
                            fontFamily: this.xaxisFontFamily,
                            fontWeight: t.config.xaxis.labels.style.fontWeight,
                            isPlainText: !1,
                            cssClass: "apexcharts-xaxis-label " + t.config.xaxis.labels.style.cssClass
                        });
                        s.add(w), w.tspan(f);
                        var A = document.createElementNS(t.globals.SVGNS, "title");
                        A.textContent = f, w.node.appendChild(A), o += n;
                    }
                    return this.inversedYAxisTitleText(a), this.inversedYAxisBorder(a), a;
                }
            },
            {
                key: "inversedYAxisBorder",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx), a = t.config.xaxis.axisBorder;
                    if (a.show) {
                        var s = 0;
                        t.config.chart.type === "bar" && t.globals.isXNumeric && (s -= 15);
                        var r = i.drawLine(t.globals.padHorizontal + s + a.offsetX, this.xAxisoffX, t.globals.gridWidth, this.xAxisoffX, a.color, 0, a.height);
                        this.elgrid && this.elgrid.elGridBorders && t.config.grid.show ? this.elgrid.elGridBorders.add(r) : e.add(r);
                    }
                }
            },
            {
                key: "inversedYAxisTitleText",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx);
                    if (t.config.xaxis.title.text !== void 0) {
                        var a = i.group({
                            class: "apexcharts-xaxis-title apexcharts-yaxis-title-inversed"
                        }), s = i.drawText({
                            x: t.globals.gridWidth / 2 + t.config.xaxis.title.offsetX,
                            y: this.xAxisoffX + parseFloat(this.xaxisFontSize) + parseFloat(t.config.xaxis.title.style.fontSize) + t.config.xaxis.title.offsetY + 20,
                            text: t.config.xaxis.title.text,
                            textAnchor: "middle",
                            fontSize: t.config.xaxis.title.style.fontSize,
                            fontFamily: t.config.xaxis.title.style.fontFamily,
                            fontWeight: t.config.xaxis.title.style.fontWeight,
                            foreColor: t.config.xaxis.title.style.color,
                            cssClass: "apexcharts-xaxis-title-text " + t.config.xaxis.title.style.cssClass
                        });
                        a.add(s), e.add(a);
                    }
                }
            },
            {
                key: "yAxisTitleRotate",
                value: function(e, t) {
                    var i = this.w, a = new M(this.ctx), s = {
                        width: 0,
                        height: 0
                    }, r = {
                        width: 0,
                        height: 0
                    }, n = i.globals.dom.baseEl.querySelector(" .apexcharts-yaxis[rel='".concat(e, "'] .apexcharts-yaxis-texts-g"));
                    n !== null && (s = n.getBoundingClientRect());
                    var o = i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(e, "'] .apexcharts-yaxis-title text"));
                    if (o !== null && (r = o.getBoundingClientRect()), o !== null) {
                        var h = this.xPaddingForYAxisTitle(e, s, r, t);
                        o.setAttribute("x", h.xPos - (t ? 10 : 0));
                    }
                    if (o !== null) {
                        var c = a.rotateAroundCenter(o);
                        o.setAttribute("transform", "rotate(".concat(t ? -1 * i.config.yaxis[e].title.rotate : i.config.yaxis[e].title.rotate, " ").concat(c.x, " ").concat(c.y, ")"));
                    }
                }
            },
            {
                key: "xPaddingForYAxisTitle",
                value: function(e, t, i, a) {
                    var s = this.w, r = 0, n = 0, o = 10;
                    return s.config.yaxis[e].title.text === void 0 || e < 0 ? {
                        xPos: n,
                        padd: 0
                    } : (a ? (n = t.width + s.config.yaxis[e].title.offsetX + i.width / 2 + o / 2, (r += 1) === 0 && (n -= o / 2)) : (n = -1 * t.width + s.config.yaxis[e].title.offsetX + o / 2 + i.width / 2, s.globals.isBarHorizontal && (o = 25, n = -1 * t.width - s.config.yaxis[e].title.offsetX - o)), {
                        xPos: n,
                        padd: o
                    });
                }
            },
            {
                key: "setYAxisXPosition",
                value: function(e, t) {
                    var i = this.w, a = 0, s = 0, r = 18, n = 1;
                    i.config.yaxis.length > 1 && (this.multipleYs = !0), i.config.yaxis.map(function(o, h) {
                        var c = i.globals.ignoreYAxisIndexes.indexOf(h) > -1 || !o.show || o.floating || e[h].width === 0, d = e[h].width + t[h].width;
                        o.opposite ? i.globals.isBarHorizontal ? (s = i.globals.gridWidth + i.globals.translateX - 1, i.globals.translateYAxisX[h] = s - o.labels.offsetX) : (s = i.globals.gridWidth + i.globals.translateX + n, c || (n = n + d + 20), i.globals.translateYAxisX[h] = s - o.labels.offsetX + 20) : (a = i.globals.translateX - r, c || (r = r + d + 20), i.globals.translateYAxisX[h] = a + o.labels.offsetX);
                    });
                }
            },
            {
                key: "setYAxisTextAlignments",
                value: function() {
                    var e = this.w, t = e.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis");
                    (t = P.listToArray(t)).forEach(function(i, a) {
                        var s = e.config.yaxis[a];
                        if (s && !s.floating && s.labels.align !== void 0) {
                            var r = e.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(a, "'] .apexcharts-yaxis-texts-g")), n = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(a, "'] .apexcharts-yaxis-label"));
                            n = P.listToArray(n);
                            var o = r.getBoundingClientRect();
                            s.labels.align === "left" ? (n.forEach(function(h, c) {
                                h.setAttribute("text-anchor", "start");
                            }), s.opposite || r.setAttribute("transform", "translate(-".concat(o.width, ", 0)"))) : s.labels.align === "center" ? (n.forEach(function(h, c) {
                                h.setAttribute("text-anchor", "middle");
                            }), r.setAttribute("transform", "translate(".concat(o.width / 2 * (s.opposite ? 1 : -1), ", 0)"))) : s.labels.align === "right" && (n.forEach(function(h, c) {
                                h.setAttribute("text-anchor", "end");
                            }), s.opposite && r.setAttribute("transform", "translate(".concat(o.width, ", 0)")));
                        }
                    });
                }
            }
        ]), y;
    }(), xt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.documentEvent = P.bind(this.documentEvent, this);
        }
        return Y(y, [
            {
                key: "addEventListener",
                value: function(e, t) {
                    var i = this.w;
                    i.globals.events.hasOwnProperty(e) ? i.globals.events[e].push(t) : i.globals.events[e] = [
                        t
                    ];
                }
            },
            {
                key: "removeEventListener",
                value: function(e, t) {
                    var i = this.w;
                    if (i.globals.events.hasOwnProperty(e)) {
                        var a = i.globals.events[e].indexOf(t);
                        a !== -1 && i.globals.events[e].splice(a, 1);
                    }
                }
            },
            {
                key: "fireEvent",
                value: function(e, t) {
                    var i = this.w;
                    if (i.globals.events.hasOwnProperty(e)) {
                        t && t.length || (t = []);
                        for(var a = i.globals.events[e], s = a.length, r = 0; r < s; r++)a[r].apply(null, t);
                    }
                }
            },
            {
                key: "setupEventHandlers",
                value: function() {
                    var e = this, t = this.w, i = this.ctx, a = t.globals.dom.baseEl.querySelector(t.globals.chartClass);
                    this.ctx.eventList.forEach(function(s) {
                        a.addEventListener(s, function(r) {
                            var n = Object.assign({}, t, {
                                seriesIndex: t.globals.capturedSeriesIndex,
                                dataPointIndex: t.globals.capturedDataPointIndex
                            });
                            r.type === "mousemove" || r.type === "touchmove" ? typeof t.config.chart.events.mouseMove == "function" && t.config.chart.events.mouseMove(r, i, n) : r.type === "mouseleave" || r.type === "touchleave" ? typeof t.config.chart.events.mouseLeave == "function" && t.config.chart.events.mouseLeave(r, i, n) : (r.type === "mouseup" && r.which === 1 || r.type === "touchend") && (typeof t.config.chart.events.click == "function" && t.config.chart.events.click(r, i, n), i.ctx.events.fireEvent("click", [
                                r,
                                i,
                                n
                            ]));
                        }, {
                            capture: !1,
                            passive: !0
                        });
                    }), this.ctx.eventList.forEach(function(s) {
                        t.globals.dom.baseEl.addEventListener(s, e.documentEvent, {
                            passive: !0
                        });
                    }), this.ctx.core.setupBrushHandler();
                }
            },
            {
                key: "documentEvent",
                value: function(e) {
                    var t = this.w, i = e.target.className;
                    if (e.type === "click") {
                        var a = t.globals.dom.baseEl.querySelector(".apexcharts-menu");
                        a && a.classList.contains("apexcharts-menu-open") && i !== "apexcharts-menu-icon" && a.classList.remove("apexcharts-menu-open");
                    }
                    t.globals.clientX = e.type === "touchmove" ? e.touches[0].clientX : e.clientX, t.globals.clientY = e.type === "touchmove" ? e.touches[0].clientY : e.clientY;
                }
            }
        ]), y;
    }(), bt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "setCurrentLocaleValues",
                value: function(e) {
                    var t = this.w.config.chart.locales;
                    window.Apex.chart && window.Apex.chart.locales && window.Apex.chart.locales.length > 0 && (t = this.w.config.chart.locales.concat(window.Apex.chart.locales));
                    var i = t.filter(function(s) {
                        return s.name === e;
                    })[0];
                    if (!i) throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");
                    var a = P.extend(H, i);
                    this.w.globals.locale = a.options;
                }
            }
        ]), y;
    }(), mt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "drawAxis",
                value: function(e, t) {
                    var i, a, s = this, r = this.w.globals, n = this.w.config, o = new Ie(this.ctx, t), h = new Ne(this.ctx, t);
                    r.axisCharts && e !== "radar" && (r.isBarHorizontal ? (a = h.drawYaxisInversed(0), i = o.drawXaxisInversed(0), r.dom.elGraphical.add(i), r.dom.elGraphical.add(a)) : (i = o.drawXaxis(), r.dom.elGraphical.add(i), n.yaxis.map(function(c, d) {
                        if (r.ignoreYAxisIndexes.indexOf(d) === -1 && (a = h.drawYaxis(d), r.dom.Paper.add(a), s.w.config.grid.position === "back")) {
                            var g = r.dom.Paper.children()[1];
                            g.remove(), r.dom.Paper.add(g);
                        }
                    })));
                }
            }
        ]), y;
    }(), We = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "drawXCrosshairs",
                value: function() {
                    var e = this.w, t = new M(this.ctx), i = new Z(this.ctx), a = e.config.xaxis.crosshairs.fill.gradient, s = e.config.xaxis.crosshairs.dropShadow, r = e.config.xaxis.crosshairs.fill.type, n = a.colorFrom, o = a.colorTo, h = a.opacityFrom, c = a.opacityTo, d = a.stops, g = s.enabled, p = s.left, f = s.top, b = s.blur, m = s.color, w = s.opacity, A = e.config.xaxis.crosshairs.fill.color;
                    if (e.config.xaxis.crosshairs.show) {
                        r === "gradient" && (A = t.drawGradient("vertical", n, o, h, c, null, d, null));
                        var l = t.drawRect();
                        e.config.xaxis.crosshairs.width === 1 && (l = t.drawLine());
                        var u = e.globals.gridHeight;
                        (!P.isNumber(u) || u < 0) && (u = 0);
                        var x = e.config.xaxis.crosshairs.width;
                        (!P.isNumber(x) || x < 0) && (x = 0), l.attr({
                            class: "apexcharts-xcrosshairs",
                            x: 0,
                            y: 0,
                            y2: u,
                            width: x,
                            height: u,
                            fill: A,
                            filter: "none",
                            "fill-opacity": e.config.xaxis.crosshairs.opacity,
                            stroke: e.config.xaxis.crosshairs.stroke.color,
                            "stroke-width": e.config.xaxis.crosshairs.stroke.width,
                            "stroke-dasharray": e.config.xaxis.crosshairs.stroke.dashArray
                        }), g && (l = i.dropShadow(l, {
                            left: p,
                            top: f,
                            blur: b,
                            color: m,
                            opacity: w
                        })), e.globals.dom.elGraphical.add(l);
                    }
                }
            },
            {
                key: "drawYCrosshairs",
                value: function() {
                    var e = this.w, t = new M(this.ctx), i = e.config.yaxis[0].crosshairs, a = e.globals.barPadForNumericAxis;
                    if (e.config.yaxis[0].crosshairs.show) {
                        var s = t.drawLine(-a, 0, e.globals.gridWidth + a, 0, i.stroke.color, i.stroke.dashArray, i.stroke.width);
                        s.attr({
                            class: "apexcharts-ycrosshairs"
                        }), e.globals.dom.elGraphical.add(s);
                    }
                    var r = t.drawLine(-a, 0, e.globals.gridWidth + a, 0, i.stroke.color, 0, 0);
                    r.attr({
                        class: "apexcharts-ycrosshairs-hidden"
                    }), e.globals.dom.elGraphical.add(r);
                }
            }
        ]), y;
    }(), vt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "checkResponsiveConfig",
                value: function(e) {
                    var t = this, i = this.w, a = i.config;
                    if (a.responsive.length !== 0) {
                        var s = a.responsive.slice();
                        s.sort(function(h, c) {
                            return h.breakpoint > c.breakpoint ? 1 : c.breakpoint > h.breakpoint ? -1 : 0;
                        }).reverse();
                        var r = new Le({}), n = function() {
                            var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = s[0].breakpoint, d = window.innerWidth > 0 ? window.innerWidth : screen.width;
                            if (d > c) {
                                var g = q.extendArrayProps(r, i.globals.initialConfig, i);
                                h = P.extend(g, h), h = P.extend(i.config, h), t.overrideResponsiveOptions(h);
                            } else for(var p = 0; p < s.length; p++)d < s[p].breakpoint && (h = q.extendArrayProps(r, s[p].options, i), h = P.extend(i.config, h), t.overrideResponsiveOptions(h));
                        };
                        if (e) {
                            var o = q.extendArrayProps(r, e, i);
                            o = P.extend(i.config, o), n(o = P.extend(o, e));
                        } else n({});
                    }
                }
            },
            {
                key: "overrideResponsiveOptions",
                value: function(e) {
                    var t = new Le(e).init({
                        responsiveOverride: !0
                    });
                    this.w.config = t;
                }
            }
        ]), y;
    }(), yt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.colors = [], this.w = e.w;
            var t = this.w;
            this.isColorFn = !1, this.isHeatmapDistributed = t.config.chart.type === "treemap" && t.config.plotOptions.treemap.distributed || t.config.chart.type === "heatmap" && t.config.plotOptions.heatmap.distributed, this.isBarDistributed = t.config.plotOptions.bar.distributed && (t.config.chart.type === "bar" || t.config.chart.type === "rangeBar");
        }
        return Y(y, [
            {
                key: "init",
                value: function() {
                    this.setDefaultColors();
                }
            },
            {
                key: "setDefaultColors",
                value: function() {
                    var e, t = this, i = this.w, a = new P();
                    if (i.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(i.config.theme.mode)), i.config.colors === void 0 || ((e = i.config.colors) === null || e === void 0 ? void 0 : e.length) === 0 ? i.globals.colors = this.predefined() : (i.globals.colors = i.config.colors, Array.isArray(i.config.colors) && i.config.colors.length > 0 && typeof i.config.colors[0] == "function" && (i.globals.colors = i.config.series.map(function(f, b) {
                        var m = i.config.colors[b];
                        return m || (m = i.config.colors[0]), typeof m == "function" ? (t.isColorFn = !0, m({
                            value: i.globals.axisCharts ? i.globals.series[b][0] ? i.globals.series[b][0] : 0 : i.globals.series[b],
                            seriesIndex: b,
                            dataPointIndex: b,
                            w: i
                        })) : m;
                    }))), i.globals.seriesColors.map(function(f, b) {
                        f && (i.globals.colors[b] = f);
                    }), i.config.theme.monochrome.enabled) {
                        var s = [], r = i.globals.series.length;
                        (this.isBarDistributed || this.isHeatmapDistributed) && (r = i.globals.series[0].length * i.globals.series.length);
                        for(var n = i.config.theme.monochrome.color, o = 1 / (r / i.config.theme.monochrome.shadeIntensity), h = i.config.theme.monochrome.shadeTo, c = 0, d = 0; d < r; d++){
                            var g = void 0;
                            h === "dark" ? (g = a.shadeColor(-1 * c, n), c += o) : (g = a.shadeColor(c, n), c += o), s.push(g);
                        }
                        i.globals.colors = s.slice();
                    }
                    var p = i.globals.colors.slice();
                    this.pushExtraColors(i.globals.colors), [
                        "fill",
                        "stroke"
                    ].forEach(function(f) {
                        i.config[f].colors === void 0 ? i.globals[f].colors = t.isColorFn ? i.config.colors : p : i.globals[f].colors = i.config[f].colors.slice(), t.pushExtraColors(i.globals[f].colors);
                    }), i.config.dataLabels.style.colors === void 0 ? i.globals.dataLabels.style.colors = p : i.globals.dataLabels.style.colors = i.config.dataLabels.style.colors.slice(), this.pushExtraColors(i.globals.dataLabels.style.colors, 50), i.config.plotOptions.radar.polygons.fill.colors === void 0 ? i.globals.radarPolygons.fill.colors = [
                        i.config.theme.mode === "dark" ? "#424242" : "none"
                    ] : i.globals.radarPolygons.fill.colors = i.config.plotOptions.radar.polygons.fill.colors.slice(), this.pushExtraColors(i.globals.radarPolygons.fill.colors, 20), i.config.markers.colors === void 0 ? i.globals.markers.colors = p : i.globals.markers.colors = i.config.markers.colors.slice(), this.pushExtraColors(i.globals.markers.colors);
                }
            },
            {
                key: "pushExtraColors",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, a = this.w, s = t || a.globals.series.length;
                    if (i === null && (i = this.isBarDistributed || this.isHeatmapDistributed || a.config.chart.type === "heatmap" && a.config.plotOptions.heatmap.colorScale.inverse), i && a.globals.series.length && (s = a.globals.series[a.globals.maxValsInArrayIndex].length * a.globals.series.length), e.length < s) for(var r = s - e.length, n = 0; n < r; n++)e.push(e[n]);
                }
            },
            {
                key: "updateThemeOptions",
                value: function(e) {
                    e.chart = e.chart || {}, e.tooltip = e.tooltip || {};
                    var t = e.theme.mode || "light", i = e.theme.palette ? e.theme.palette : t === "dark" ? "palette4" : "palette1", a = e.chart.foreColor ? e.chart.foreColor : t === "dark" ? "#f6f7f8" : "#373d3f";
                    return e.tooltip.theme = t, e.chart.foreColor = a, e.theme.palette = i, e;
                }
            },
            {
                key: "predefined",
                value: function() {
                    switch(this.w.config.theme.palette){
                        case "palette1":
                        default:
                            this.colors = [
                                "#008FFB",
                                "#00E396",
                                "#FEB019",
                                "#FF4560",
                                "#775DD0"
                            ];
                            break;
                        case "palette2":
                            this.colors = [
                                "#3f51b5",
                                "#03a9f4",
                                "#4caf50",
                                "#f9ce1d",
                                "#FF9800"
                            ];
                            break;
                        case "palette3":
                            this.colors = [
                                "#33b2df",
                                "#546E7A",
                                "#d4526e",
                                "#13d8aa",
                                "#A5978B"
                            ];
                            break;
                        case "palette4":
                            this.colors = [
                                "#4ecdc4",
                                "#c7f464",
                                "#81D4FA",
                                "#fd6a6a",
                                "#546E7A"
                            ];
                            break;
                        case "palette5":
                            this.colors = [
                                "#2b908f",
                                "#f9a3a4",
                                "#90ee7e",
                                "#fa4443",
                                "#69d2e7"
                            ];
                            break;
                        case "palette6":
                            this.colors = [
                                "#449DD1",
                                "#F86624",
                                "#EA3546",
                                "#662E9B",
                                "#C5D86D"
                            ];
                            break;
                        case "palette7":
                            this.colors = [
                                "#D7263D",
                                "#1B998B",
                                "#2E294E",
                                "#F46036",
                                "#E2C044"
                            ];
                            break;
                        case "palette8":
                            this.colors = [
                                "#662E9B",
                                "#F86624",
                                "#F9C80E",
                                "#EA3546",
                                "#43BCCD"
                            ];
                            break;
                        case "palette9":
                            this.colors = [
                                "#5C4742",
                                "#A5978B",
                                "#8D5B4C",
                                "#5A2A27",
                                "#C4BBAF"
                            ];
                            break;
                        case "palette10":
                            this.colors = [
                                "#A300D6",
                                "#7D02EB",
                                "#5653FE",
                                "#2983FF",
                                "#00B1F2"
                            ];
                    }
                    return this.colors;
                }
            }
        ]), y;
    }(), wt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "draw",
                value: function() {
                    this.drawTitleSubtitle("title"), this.drawTitleSubtitle("subtitle");
                }
            },
            {
                key: "drawTitleSubtitle",
                value: function(e) {
                    var t = this.w, i = e === "title" ? t.config.title : t.config.subtitle, a = t.globals.svgWidth / 2, s = i.offsetY, r = "middle";
                    if (i.align === "left" ? (a = 10, r = "start") : i.align === "right" && (a = t.globals.svgWidth - 10, r = "end"), a += i.offsetX, s = s + parseInt(i.style.fontSize, 10) + i.margin / 2, i.text !== void 0) {
                        var n = new M(this.ctx).drawText({
                            x: a,
                            y: s,
                            text: i.text,
                            textAnchor: r,
                            fontSize: i.style.fontSize,
                            fontFamily: i.style.fontFamily,
                            fontWeight: i.style.fontWeight,
                            foreColor: i.style.color,
                            opacity: 1
                        });
                        n.node.setAttribute("class", "apexcharts-".concat(e, "-text")), t.globals.dom.Paper.add(n);
                    }
                }
            }
        ]), y;
    }(), kt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.dCtx = e;
        }
        return Y(y, [
            {
                key: "getTitleSubtitleCoords",
                value: function(e) {
                    var t = this.w, i = 0, a = 0, s = e === "title" ? t.config.title.floating : t.config.subtitle.floating, r = t.globals.dom.baseEl.querySelector(".apexcharts-".concat(e, "-text"));
                    if (r !== null && !s) {
                        var n = r.getBoundingClientRect();
                        i = n.width, a = t.globals.axisCharts ? n.height + 5 : n.height;
                    }
                    return {
                        width: i,
                        height: a
                    };
                }
            },
            {
                key: "getLegendsRect",
                value: function() {
                    var e = this.w, t = e.globals.dom.elLegendWrap;
                    e.config.legend.height || e.config.legend.position !== "top" && e.config.legend.position !== "bottom" || (t.style.maxHeight = e.globals.svgHeight / 2 + "px");
                    var i = Object.assign({}, P.getBoundingClientRect(t));
                    return t !== null && !e.config.legend.floating && e.config.legend.show ? this.dCtx.lgRect = {
                        x: i.x,
                        y: i.y,
                        height: i.height,
                        width: i.height === 0 ? 0 : i.width
                    } : this.dCtx.lgRect = {
                        x: 0,
                        y: 0,
                        height: 0,
                        width: 0
                    }, e.config.legend.position !== "left" && e.config.legend.position !== "right" || 1.5 * this.dCtx.lgRect.width > e.globals.svgWidth && (this.dCtx.lgRect.width = e.globals.svgWidth / 1.5), this.dCtx.lgRect;
                }
            },
            {
                key: "getLargestStringFromMultiArr",
                value: function(e, t) {
                    var i = e;
                    if (this.w.globals.isMultiLineX) {
                        var a = t.map(function(r, n) {
                            return Array.isArray(r) ? r.length : 1;
                        }), s = Math.max.apply(Math, J(a));
                        i = t[a.indexOf(s)];
                    }
                    return i;
                }
            }
        ]), y;
    }(), At = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.dCtx = e;
        }
        return Y(y, [
            {
                key: "getxAxisLabelsCoords",
                value: function() {
                    var e, t = this.w, i = t.globals.labels.slice();
                    if (t.config.xaxis.convertedCatToNumeric && i.length === 0 && (i = t.globals.categoryLabels), t.globals.timescaleLabels.length > 0) {
                        var a = this.getxAxisTimeScaleLabelsCoords();
                        e = {
                            width: a.width,
                            height: a.height
                        }, t.globals.rotateXLabels = !1;
                    } else {
                        this.dCtx.lgWidthForSideLegends = t.config.legend.position !== "left" && t.config.legend.position !== "right" || t.config.legend.floating ? 0 : this.dCtx.lgRect.width;
                        var s = t.globals.xLabelFormatter, r = P.getLargestStringFromArr(i), n = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, i);
                        t.globals.isBarHorizontal && (n = r = t.globals.yAxisScale[0].result.reduce(function(f, b) {
                            return f.length > b.length ? f : b;
                        }, 0));
                        var o = new re(this.dCtx.ctx), h = r;
                        r = o.xLabelFormat(s, r, h, {
                            i: void 0,
                            dateFormatter: new B(this.dCtx.ctx).formatDate,
                            w: t
                        }), n = o.xLabelFormat(s, n, h, {
                            i: void 0,
                            dateFormatter: new B(this.dCtx.ctx).formatDate,
                            w: t
                        }), (t.config.xaxis.convertedCatToNumeric && r === void 0 || String(r).trim() === "") && (n = r = "1");
                        var c = new M(this.dCtx.ctx), d = c.getTextRects(r, t.config.xaxis.labels.style.fontSize), g = d;
                        if (r !== n && (g = c.getTextRects(n, t.config.xaxis.labels.style.fontSize)), (e = {
                            width: d.width >= g.width ? d.width : g.width,
                            height: d.height >= g.height ? d.height : g.height
                        }).width * i.length > t.globals.svgWidth - this.dCtx.lgWidthForSideLegends - this.dCtx.yAxisWidth - this.dCtx.gridPad.left - this.dCtx.gridPad.right && t.config.xaxis.labels.rotate !== 0 || t.config.xaxis.labels.rotateAlways) {
                            if (!t.globals.isBarHorizontal) {
                                t.globals.rotateXLabels = !0;
                                var p = function(f) {
                                    return c.getTextRects(f, t.config.xaxis.labels.style.fontSize, t.config.xaxis.labels.style.fontFamily, "rotate(".concat(t.config.xaxis.labels.rotate, " 0 0)"), !1);
                                };
                                d = p(r), r !== n && (g = p(n)), e.height = (d.height > g.height ? d.height : g.height) / 1.5, e.width = d.width > g.width ? d.width : g.width;
                            }
                        } else t.globals.rotateXLabels = !1;
                    }
                    return t.config.xaxis.labels.show || (e = {
                        width: 0,
                        height: 0
                    }), {
                        width: e.width,
                        height: e.height
                    };
                }
            },
            {
                key: "getxAxisGroupLabelsCoords",
                value: function() {
                    var e, t = this.w;
                    if (!t.globals.hasXaxisGroups) return {
                        width: 0,
                        height: 0
                    };
                    var i, a = ((e = t.config.xaxis.group.style) === null || e === void 0 ? void 0 : e.fontSize) || t.config.xaxis.labels.style.fontSize, s = t.globals.groups.map(function(d) {
                        return d.title;
                    }), r = P.getLargestStringFromArr(s), n = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, s), o = new M(this.dCtx.ctx), h = o.getTextRects(r, a), c = h;
                    return r !== n && (c = o.getTextRects(n, a)), i = {
                        width: h.width >= c.width ? h.width : c.width,
                        height: h.height >= c.height ? h.height : c.height
                    }, t.config.xaxis.labels.show || (i = {
                        width: 0,
                        height: 0
                    }), {
                        width: i.width,
                        height: i.height
                    };
                }
            },
            {
                key: "getxAxisTitleCoords",
                value: function() {
                    var e = this.w, t = 0, i = 0;
                    if (e.config.xaxis.title.text !== void 0) {
                        var a = new M(this.dCtx.ctx).getTextRects(e.config.xaxis.title.text, e.config.xaxis.title.style.fontSize);
                        t = a.width, i = a.height;
                    }
                    return {
                        width: t,
                        height: i
                    };
                }
            },
            {
                key: "getxAxisTimeScaleLabelsCoords",
                value: function() {
                    var e, t = this.w;
                    this.dCtx.timescaleLabels = t.globals.timescaleLabels.slice();
                    var i = this.dCtx.timescaleLabels.map(function(s) {
                        return s.value;
                    }), a = i.reduce(function(s, r) {
                        return s === void 0 ? (console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"), 0) : s.length > r.length ? s : r;
                    }, 0);
                    return 1.05 * (e = new M(this.dCtx.ctx).getTextRects(a, t.config.xaxis.labels.style.fontSize)).width * i.length > t.globals.gridWidth && t.config.xaxis.labels.rotate !== 0 && (t.globals.overlappingXLabels = !0), e;
                }
            },
            {
                key: "additionalPaddingXLabels",
                value: function(e) {
                    var t = this, i = this.w, a = i.globals, s = i.config, r = s.xaxis.type, n = e.width;
                    a.skipLastTimelinelabel = !1, a.skipFirstTimelinelabel = !1;
                    var o = i.config.yaxis[0].opposite && i.globals.isBarHorizontal, h = function(c, d) {
                        s.yaxis.length > 1 && function(g) {
                            return a.collapsedSeriesIndices.indexOf(g) !== -1;
                        }(d) || function(g) {
                            if (t.dCtx.timescaleLabels && t.dCtx.timescaleLabels.length) {
                                var p = t.dCtx.timescaleLabels[0], f = t.dCtx.timescaleLabels[t.dCtx.timescaleLabels.length - 1].position + n / 1.75 - t.dCtx.yAxisWidthRight, b = p.position - n / 1.75 + t.dCtx.yAxisWidthLeft, m = i.config.legend.position === "right" && t.dCtx.lgRect.width > 0 ? t.dCtx.lgRect.width : 0;
                                f > a.svgWidth - a.translateX - m && (a.skipLastTimelinelabel = !0), b < -(g.show && !g.floating || s.chart.type !== "bar" && s.chart.type !== "candlestick" && s.chart.type !== "rangeBar" && s.chart.type !== "boxPlot" ? 10 : n / 1.75) && (a.skipFirstTimelinelabel = !0);
                            } else r === "datetime" ? t.dCtx.gridPad.right < n && !a.rotateXLabels && (a.skipLastTimelinelabel = !0) : r !== "datetime" && t.dCtx.gridPad.right < n / 2 - t.dCtx.yAxisWidthRight && !a.rotateXLabels && !i.config.xaxis.labels.trim && (i.config.xaxis.tickPlacement !== "between" || i.globals.isBarHorizontal) && (t.dCtx.xPadRight = n / 2 + 1);
                        }(c);
                    };
                    s.yaxis.forEach(function(c, d) {
                        o ? (t.dCtx.gridPad.left < n && (t.dCtx.xPadLeft = n / 2 + 1), t.dCtx.xPadRight = n / 2 + 1) : h(c, d);
                    });
                }
            }
        ]), y;
    }(), St = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.dCtx = e;
        }
        return Y(y, [
            {
                key: "getyAxisLabelsCoords",
                value: function() {
                    var e = this, t = this.w, i = [], a = 10, s = new xe(this.dCtx.ctx);
                    return t.config.yaxis.map(function(r, n) {
                        var o = {
                            seriesIndex: n,
                            dataPointIndex: -1,
                            w: t
                        }, h = t.globals.yAxisScale[n], c = 0;
                        if (!s.isYAxisHidden(n) && r.labels.show && r.labels.minWidth !== void 0 && (c = r.labels.minWidth), !s.isYAxisHidden(n) && r.labels.show && h.result.length) {
                            var d = t.globals.yLabelFormatters[n], g = h.niceMin === Number.MIN_VALUE ? 0 : h.niceMin, p = h.result.reduce(function(u, x) {
                                var v, k;
                                return ((v = String(d(u, o))) === null || v === void 0 ? void 0 : v.length) > ((k = String(d(x, o))) === null || k === void 0 ? void 0 : k.length) ? u : x;
                            }, g), f = p = d(p, o);
                            if (p !== void 0 && p.length !== 0 || (p = h.niceMax), t.globals.isBarHorizontal) {
                                a = 0;
                                var b = t.globals.labels.slice();
                                p = P.getLargestStringFromArr(b), p = d(p, {
                                    seriesIndex: n,
                                    dataPointIndex: -1,
                                    w: t
                                }), f = e.dCtx.dimHelpers.getLargestStringFromMultiArr(p, b);
                            }
                            var m = new M(e.dCtx.ctx), w = "rotate(".concat(r.labels.rotate, " 0 0)"), A = m.getTextRects(p, r.labels.style.fontSize, r.labels.style.fontFamily, w, !1), l = A;
                            p !== f && (l = m.getTextRects(f, r.labels.style.fontSize, r.labels.style.fontFamily, w, !1)), i.push({
                                width: (c > l.width || c > A.width ? c : l.width > A.width ? l.width : A.width) + a,
                                height: l.height > A.height ? l.height : A.height
                            });
                        } else i.push({
                            width: 0,
                            height: 0
                        });
                    }), i;
                }
            },
            {
                key: "getyAxisTitleCoords",
                value: function() {
                    var e = this, t = this.w, i = [];
                    return t.config.yaxis.map(function(a, s) {
                        if (a.show && a.title.text !== void 0) {
                            var r = new M(e.dCtx.ctx), n = "rotate(".concat(a.title.rotate, " 0 0)"), o = r.getTextRects(a.title.text, a.title.style.fontSize, a.title.style.fontFamily, n, !1);
                            i.push({
                                width: o.width,
                                height: o.height
                            });
                        } else i.push({
                            width: 0,
                            height: 0
                        });
                    }), i;
                }
            },
            {
                key: "getTotalYAxisWidth",
                value: function() {
                    var e = this.w, t = 0, i = 0, a = 0, s = e.globals.yAxisScale.length > 1 ? 10 : 0, r = new xe(this.dCtx.ctx), n = function(o, h) {
                        var c = e.config.yaxis[h].floating, d = 0;
                        o.width > 0 && !c ? (d = o.width + s, function(g) {
                            return e.globals.ignoreYAxisIndexes.indexOf(g) > -1;
                        }(h) && (d = d - o.width - s)) : d = c || r.isYAxisHidden(h) ? 0 : 5, e.config.yaxis[h].opposite ? a += d : i += d, t += d;
                    };
                    return e.globals.yLabelsCoords.map(function(o, h) {
                        n(o, h);
                    }), e.globals.yTitleCoords.map(function(o, h) {
                        n(o, h);
                    }), e.globals.isBarHorizontal && !e.config.yaxis[0].floating && (t = e.globals.yLabelsCoords[0].width + e.globals.yTitleCoords[0].width + 15), this.dCtx.yAxisWidthLeft = i, this.dCtx.yAxisWidthRight = a, t;
                }
            }
        ]), y;
    }(), Ct = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.dCtx = e;
        }
        return Y(y, [
            {
                key: "gridPadForColumnsInNumericAxis",
                value: function(e) {
                    var t = this.w;
                    if (t.globals.noData || t.globals.allSeriesCollapsed) return 0;
                    var i = function(c) {
                        return c === "bar" || c === "rangeBar" || c === "candlestick" || c === "boxPlot";
                    }, a = t.config.chart.type, s = 0, r = i(a) ? t.config.series.length : 1;
                    if (t.globals.comboBarCount > 0 && (r = t.globals.comboBarCount), t.globals.collapsedSeries.forEach(function(c) {
                        i(c.type) && (r -= 1);
                    }), t.config.chart.stacked && (r = 1), (i(a) || t.globals.comboBarCount > 0) && t.globals.isXNumeric && !t.globals.isBarHorizontal && r > 0) {
                        var n, o, h = Math.abs(t.globals.initialMaxX - t.globals.initialMinX);
                        h <= 3 && (h = t.globals.dataPoints), n = h / e, t.globals.minXDiff && t.globals.minXDiff / n > 0 && (o = t.globals.minXDiff / n), o > e / 2 && (o /= 2), (s = o / r * parseInt(t.config.plotOptions.bar.columnWidth, 10) / 100) < 1 && (s = 1), s = s / (r > 1 ? 1 : 1.5) + 5, t.globals.barPadForNumericAxis = s;
                    }
                    return s;
                }
            },
            {
                key: "gridPadFortitleSubtitle",
                value: function() {
                    var e = this, t = this.w, i = t.globals, a = this.dCtx.isSparkline || !t.globals.axisCharts ? 0 : 10;
                    [
                        "title",
                        "subtitle"
                    ].forEach(function(n) {
                        t.config[n].text !== void 0 ? a += t.config[n].margin : a += e.dCtx.isSparkline || !t.globals.axisCharts ? 0 : 5;
                    }), !t.config.legend.show || t.config.legend.position !== "bottom" || t.config.legend.floating || t.globals.axisCharts || (a += 10);
                    var s = this.dCtx.dimHelpers.getTitleSubtitleCoords("title"), r = this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");
                    i.gridHeight = i.gridHeight - s.height - r.height - a, i.translateY = i.translateY + s.height + r.height + a;
                }
            },
            {
                key: "setGridXPosForDualYAxis",
                value: function(e, t) {
                    var i = this.w, a = new xe(this.dCtx.ctx);
                    i.config.yaxis.map(function(s, r) {
                        i.globals.ignoreYAxisIndexes.indexOf(r) !== -1 || s.floating || a.isYAxisHidden(r) || (s.opposite && (i.globals.translateX = i.globals.translateX - (t[r].width + e[r].width) - parseInt(i.config.yaxis[r].labels.style.fontSize, 10) / 1.2 - 12), i.globals.translateX < 2 && (i.globals.translateX = 2));
                    });
                }
            }
        ]), y;
    }(), Ye = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.lgRect = {}, this.yAxisWidth = 0, this.yAxisWidthLeft = 0, this.yAxisWidthRight = 0, this.xAxisHeight = 0, this.isSparkline = this.w.config.chart.sparkline.enabled, this.dimHelpers = new kt(this), this.dimYAxis = new St(this), this.dimXAxis = new At(this), this.dimGrid = new Ct(this), this.lgWidthForSideLegends = 0, this.gridPad = this.w.config.grid.padding, this.xPadRight = 0, this.xPadLeft = 0;
        }
        return Y(y, [
            {
                key: "plotCoords",
                value: function() {
                    var e = this, t = this.w, i = t.globals;
                    this.lgRect = this.dimHelpers.getLegendsRect(), this.isSparkline && ((t.config.markers.discrete.length > 0 || t.config.markers.size > 0) && Object.entries(this.gridPad).forEach(function(s) {
                        var r = Me(s, 2), n = r[0], o = r[1];
                        e.gridPad[n] = Math.max(o, e.w.globals.markers.largestSize / 1.5);
                    }), this.gridPad.top = Math.max(t.config.stroke.width / 2, this.gridPad.top), this.gridPad.bottom = Math.max(t.config.stroke.width / 2, this.gridPad.bottom)), i.axisCharts ? this.setDimensionsForAxisCharts() : this.setDimensionsForNonAxisCharts(), this.dimGrid.gridPadFortitleSubtitle(), i.gridHeight = i.gridHeight - this.gridPad.top - this.gridPad.bottom, i.gridWidth = i.gridWidth - this.gridPad.left - this.gridPad.right - this.xPadRight - this.xPadLeft;
                    var a = this.dimGrid.gridPadForColumnsInNumericAxis(i.gridWidth);
                    i.gridWidth = i.gridWidth - 2 * a, i.translateX = i.translateX + this.gridPad.left + this.xPadLeft + (a > 0 ? a + 4 : 0), i.translateY = i.translateY + this.gridPad.top;
                }
            },
            {
                key: "setDimensionsForAxisCharts",
                value: function() {
                    var e = this, t = this.w, i = t.globals, a = this.dimYAxis.getyAxisLabelsCoords(), s = this.dimYAxis.getyAxisTitleCoords();
                    t.globals.yLabelsCoords = [], t.globals.yTitleCoords = [], t.config.yaxis.map(function(p, f) {
                        t.globals.yLabelsCoords.push({
                            width: a[f].width,
                            index: f
                        }), t.globals.yTitleCoords.push({
                            width: s[f].width,
                            index: f
                        });
                    }), this.yAxisWidth = this.dimYAxis.getTotalYAxisWidth();
                    var r = this.dimXAxis.getxAxisLabelsCoords(), n = this.dimXAxis.getxAxisGroupLabelsCoords(), o = this.dimXAxis.getxAxisTitleCoords();
                    this.conditionalChecksForAxisCoords(r, o, n), i.translateXAxisY = t.globals.rotateXLabels ? this.xAxisHeight / 8 : -4, i.translateXAxisX = t.globals.rotateXLabels && t.globals.isXNumeric && t.config.xaxis.labels.rotate <= -45 ? -this.xAxisWidth / 4 : 0, t.globals.isBarHorizontal && (i.rotateXLabels = !1, i.translateXAxisY = parseInt(t.config.xaxis.labels.style.fontSize, 10) / 1.5 * -1), i.translateXAxisY = i.translateXAxisY + t.config.xaxis.labels.offsetY, i.translateXAxisX = i.translateXAxisX + t.config.xaxis.labels.offsetX;
                    var h = this.yAxisWidth, c = this.xAxisHeight;
                    i.xAxisLabelsHeight = this.xAxisHeight - o.height, i.xAxisGroupLabelsHeight = i.xAxisLabelsHeight - r.height, i.xAxisLabelsWidth = this.xAxisWidth, i.xAxisHeight = this.xAxisHeight;
                    var d = 10;
                    (t.config.chart.type === "radar" || this.isSparkline) && (h = 0, c = i.goldenPadding), this.isSparkline && (this.lgRect = {
                        height: 0,
                        width: 0
                    }), (this.isSparkline || t.config.chart.type === "treemap") && (h = 0, c = 0, d = 0), this.isSparkline || this.dimXAxis.additionalPaddingXLabels(r);
                    var g = function() {
                        i.translateX = h, i.gridHeight = i.svgHeight - e.lgRect.height - c - (e.isSparkline || t.config.chart.type === "treemap" ? 0 : t.globals.rotateXLabels ? 10 : 15), i.gridWidth = i.svgWidth - h;
                    };
                    switch(t.config.xaxis.position === "top" && (d = i.xAxisHeight - t.config.xaxis.axisTicks.height - 5), t.config.legend.position){
                        case "bottom":
                            i.translateY = d, g();
                            break;
                        case "top":
                            i.translateY = this.lgRect.height + d, g();
                            break;
                        case "left":
                            i.translateY = d, i.translateX = this.lgRect.width + h, i.gridHeight = i.svgHeight - c - 12, i.gridWidth = i.svgWidth - this.lgRect.width - h;
                            break;
                        case "right":
                            i.translateY = d, i.translateX = h, i.gridHeight = i.svgHeight - c - 12, i.gridWidth = i.svgWidth - this.lgRect.width - h - 5;
                            break;
                        default:
                            throw new Error("Legend position not supported");
                    }
                    this.dimGrid.setGridXPosForDualYAxis(s, a), new Ne(this.ctx).setYAxisXPosition(a, s);
                }
            },
            {
                key: "setDimensionsForNonAxisCharts",
                value: function() {
                    var e = this.w, t = e.globals, i = e.config, a = 0;
                    e.config.legend.show && !e.config.legend.floating && (a = 20);
                    var s = i.chart.type === "pie" || i.chart.type === "polarArea" || i.chart.type === "donut" ? "pie" : "radialBar", r = i.plotOptions[s].offsetY, n = i.plotOptions[s].offsetX;
                    if (!i.legend.show || i.legend.floating) return t.gridHeight = t.svgHeight - i.grid.padding.left + i.grid.padding.right, t.gridWidth = t.gridHeight, t.translateY = r, void (t.translateX = n + (t.svgWidth - t.gridWidth) / 2);
                    switch(i.legend.position){
                        case "bottom":
                            t.gridHeight = t.svgHeight - this.lgRect.height - t.goldenPadding, t.gridWidth = t.svgWidth, t.translateY = r - 10, t.translateX = n + (t.svgWidth - t.gridWidth) / 2;
                            break;
                        case "top":
                            t.gridHeight = t.svgHeight - this.lgRect.height - t.goldenPadding, t.gridWidth = t.svgWidth, t.translateY = this.lgRect.height + r + 10, t.translateX = n + (t.svgWidth - t.gridWidth) / 2;
                            break;
                        case "left":
                            t.gridWidth = t.svgWidth - this.lgRect.width - a, t.gridHeight = i.chart.height !== "auto" ? t.svgHeight : t.gridWidth, t.translateY = r, t.translateX = n + this.lgRect.width + a;
                            break;
                        case "right":
                            t.gridWidth = t.svgWidth - this.lgRect.width - a - 5, t.gridHeight = i.chart.height !== "auto" ? t.svgHeight : t.gridWidth, t.translateY = r, t.translateX = n + 10;
                            break;
                        default:
                            throw new Error("Legend position not supported");
                    }
                }
            },
            {
                key: "conditionalChecksForAxisCoords",
                value: function(e, t, i) {
                    var a = this.w, s = a.globals.hasXaxisGroups ? 2 : 1, r = i.height + e.height + t.height, n = a.globals.isMultiLineX ? 1.2 : a.globals.LINE_HEIGHT_RATIO, o = a.globals.rotateXLabels ? 22 : 10, h = a.globals.rotateXLabels && a.config.legend.position === "bottom" ? 10 : 0;
                    this.xAxisHeight = r * n + s * o + h, this.xAxisWidth = e.width, this.xAxisHeight - t.height > a.config.xaxis.labels.maxHeight && (this.xAxisHeight = a.config.xaxis.labels.maxHeight), a.config.xaxis.labels.minHeight && this.xAxisHeight < a.config.xaxis.labels.minHeight && (this.xAxisHeight = a.config.xaxis.labels.minHeight), a.config.xaxis.floating && (this.xAxisHeight = 0);
                    var c = 0, d = 0;
                    a.config.yaxis.forEach(function(g) {
                        c += g.labels.minWidth, d += g.labels.maxWidth;
                    }), this.yAxisWidth < c && (this.yAxisWidth = c), this.yAxisWidth > d && (this.yAxisWidth = d);
                }
            }
        ]), y;
    }(), Lt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.lgCtx = e;
        }
        return Y(y, [
            {
                key: "getLegendStyles",
                value: function() {
                    var e, t, i, a = document.createElement("style");
                    a.setAttribute("type", "text/css");
                    var s = ((e = this.lgCtx.ctx) === null || e === void 0 || (t = e.opts) === null || t === void 0 || (i = t.chart) === null || i === void 0 ? void 0 : i.nonce) || this.w.config.chart.nonce;
                    s && a.setAttribute("nonce", s);
                    var r = document.createTextNode(`
      .apexcharts-legend {
        display: flex;
        overflow: auto;
        padding: 0 10px;
      }
      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {
        flex-wrap: wrap
      }
      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {
        flex-direction: column;
        bottom: 0;
      }
      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {
        justify-content: flex-start;
      }
      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {
        justify-content: center;
      }
      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {
        justify-content: flex-end;
      }
      .apexcharts-legend-series {
        cursor: pointer;
        line-height: normal;
      }
      .apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series, .apexcharts-legend.apx-legend-position-top .apexcharts-legend-series{
        display: flex;
        align-items: center;
      }
      .apexcharts-legend-text {
        position: relative;
        font-size: 14px;
      }
      .apexcharts-legend-text *, .apexcharts-legend-marker * {
        pointer-events: none;
      }
      .apexcharts-legend-marker {
        position: relative;
        display: inline-block;
        cursor: pointer;
        margin-right: 3px;
        border-style: solid;
      }

      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{
        display: inline-block;
      }
      .apexcharts-legend-series.apexcharts-no-click {
        cursor: auto;
      }
      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {
        display: none !important;
      }
      .apexcharts-inactive-legend {
        opacity: 0.45;
      }`);
                    return a.appendChild(r), a;
                }
            },
            {
                key: "getLegendBBox",
                value: function() {
                    var e = this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(), t = e.width;
                    return {
                        clwh: e.height,
                        clww: t
                    };
                }
            },
            {
                key: "appendToForeignObject",
                value: function() {
                    this.w.globals.dom.elLegendForeign.appendChild(this.getLegendStyles());
                }
            },
            {
                key: "toggleDataSeries",
                value: function(e, t) {
                    var i = this, a = this.w;
                    if (a.globals.axisCharts || a.config.chart.type === "radialBar") {
                        a.globals.resized = !0;
                        var s = null, r = null;
                        a.globals.risingSeries = [], a.globals.axisCharts ? (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e, "']")), r = parseInt(s.getAttribute("data:realIndex"), 10)) : (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(e + 1, "']")), r = parseInt(s.getAttribute("rel"), 10) - 1), t ? [
                            {
                                cs: a.globals.collapsedSeries,
                                csi: a.globals.collapsedSeriesIndices
                            },
                            {
                                cs: a.globals.ancillaryCollapsedSeries,
                                csi: a.globals.ancillaryCollapsedSeriesIndices
                            }
                        ].forEach(function(c) {
                            i.riseCollapsedSeries(c.cs, c.csi, r);
                        }) : this.hideSeries({
                            seriesEl: s,
                            realIndex: r
                        });
                    } else {
                        var n = a.globals.dom.Paper.select(" .apexcharts-series[rel='".concat(e + 1, "'] path")), o = a.config.chart.type;
                        if (o === "pie" || o === "polarArea" || o === "donut") {
                            var h = a.config.plotOptions.pie.donut.labels;
                            new M(this.lgCtx.ctx).pathMouseDown(n.members[0], null), this.lgCtx.ctx.pie.printDataLabelsInner(n.members[0].node, h);
                        }
                        n.fire("click");
                    }
                }
            },
            {
                key: "hideSeries",
                value: function(e) {
                    var t = e.seriesEl, i = e.realIndex, a = this.w, s = P.clone(a.config.series);
                    if (a.globals.axisCharts) {
                        var r = !1;
                        if (a.config.yaxis[i] && a.config.yaxis[i].show && a.config.yaxis[i].showAlways && (r = !0, a.globals.ancillaryCollapsedSeriesIndices.indexOf(i) < 0 && (a.globals.ancillaryCollapsedSeries.push({
                            index: i,
                            data: s[i].data.slice(),
                            type: t.parentNode.className.baseVal.split("-")[1]
                        }), a.globals.ancillaryCollapsedSeriesIndices.push(i))), !r) {
                            a.globals.collapsedSeries.push({
                                index: i,
                                data: s[i].data.slice(),
                                type: t.parentNode.className.baseVal.split("-")[1]
                            }), a.globals.collapsedSeriesIndices.push(i);
                            var n = a.globals.risingSeries.indexOf(i);
                            a.globals.risingSeries.splice(n, 1);
                        }
                    } else a.globals.collapsedSeries.push({
                        index: i,
                        data: s[i]
                    }), a.globals.collapsedSeriesIndices.push(i);
                    for(var o = t.childNodes, h = 0; h < o.length; h++)o[h].classList.contains("apexcharts-series-markers-wrap") && (o[h].classList.contains("apexcharts-hide") ? o[h].classList.remove("apexcharts-hide") : o[h].classList.add("apexcharts-hide"));
                    a.globals.allSeriesCollapsed = a.globals.collapsedSeries.length === a.config.series.length, s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
                }
            },
            {
                key: "riseCollapsedSeries",
                value: function(e, t, i) {
                    var a = this.w, s = P.clone(a.config.series);
                    if (e.length > 0) {
                        for(var r = 0; r < e.length; r++)e[r].index === i && (a.globals.axisCharts ? (s[i].data = e[r].data.slice(), e.splice(r, 1), t.splice(r, 1), a.globals.risingSeries.push(i)) : (s[i] = e[r].data, e.splice(r, 1), t.splice(r, 1), a.globals.risingSeries.push(i)));
                        s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
                    }
                }
            },
            {
                key: "_getSeriesBasedOnCollapsedState",
                value: function(e) {
                    var t = this.w;
                    return t.globals.axisCharts ? e.forEach(function(i, a) {
                        t.globals.collapsedSeriesIndices.indexOf(a) > -1 && (e[a].data = []);
                    }) : e.forEach(function(i, a) {
                        t.globals.collapsedSeriesIndices.indexOf(a) > -1 && (e[a] = 0);
                    }), e;
                }
            }
        ]), y;
    }(), Ke = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.onLegendClick = this.onLegendClick.bind(this), this.onLegendHovered = this.onLegendHovered.bind(this), this.isBarsDistributed = this.w.config.chart.type === "bar" && this.w.config.plotOptions.bar.distributed && this.w.config.series.length === 1, this.legendHelpers = new Lt(this);
        }
        return Y(y, [
            {
                key: "init",
                value: function() {
                    var e = this.w, t = e.globals, i = e.config;
                    if ((i.legend.showForSingleSeries && t.series.length === 1 || this.isBarsDistributed || t.series.length > 1 || !t.axisCharts) && i.legend.show) {
                        for(; t.dom.elLegendWrap.firstChild;)t.dom.elLegendWrap.removeChild(t.dom.elLegendWrap.firstChild);
                        this.drawLegends(), P.isIE11() ? document.getElementsByTagName("head")[0].appendChild(this.legendHelpers.getLegendStyles()) : this.legendHelpers.appendToForeignObject(), i.legend.position === "bottom" || i.legend.position === "top" ? this.legendAlignHorizontal() : i.legend.position !== "right" && i.legend.position !== "left" || this.legendAlignVertical();
                    }
                }
            },
            {
                key: "drawLegends",
                value: function() {
                    var e = this, t = this.w, i = t.config.legend.fontFamily, a = t.globals.seriesNames, s = t.globals.colors.slice();
                    if (t.config.chart.type === "heatmap") {
                        var r = t.config.plotOptions.heatmap.colorScale.ranges;
                        a = r.map(function(T) {
                            return T.name ? T.name : T.from + " - " + T.to;
                        }), s = r.map(function(T) {
                            return T.color;
                        });
                    } else this.isBarsDistributed && (a = t.globals.labels.slice());
                    t.config.legend.customLegendItems.length && (a = t.config.legend.customLegendItems);
                    for(var n = t.globals.legendFormatter, o = t.config.legend.inverseOrder, h = o ? a.length - 1 : 0; o ? h >= 0 : h <= a.length - 1; o ? h-- : h++){
                        var c, d = n(a[h], {
                            seriesIndex: h,
                            w: t
                        }), g = !1, p = !1;
                        if (t.globals.collapsedSeries.length > 0) for(var f = 0; f < t.globals.collapsedSeries.length; f++)t.globals.collapsedSeries[f].index === h && (g = !0);
                        if (t.globals.ancillaryCollapsedSeriesIndices.length > 0) for(var b = 0; b < t.globals.ancillaryCollapsedSeriesIndices.length; b++)t.globals.ancillaryCollapsedSeriesIndices[b] === h && (p = !0);
                        var m = document.createElement("span");
                        m.classList.add("apexcharts-legend-marker");
                        var w = t.config.legend.markers.offsetX, A = t.config.legend.markers.offsetY, l = t.config.legend.markers.height, u = t.config.legend.markers.width, x = t.config.legend.markers.strokeWidth, v = t.config.legend.markers.strokeColor, k = t.config.legend.markers.radius, S = m.style;
                        S.background = s[h], S.color = s[h], S.setProperty("background", s[h], "important"), t.config.legend.markers.fillColors && t.config.legend.markers.fillColors[h] && (S.background = t.config.legend.markers.fillColors[h]), t.globals.seriesColors[h] !== void 0 && (S.background = t.globals.seriesColors[h], S.color = t.globals.seriesColors[h]), S.height = Array.isArray(l) ? parseFloat(l[h]) + "px" : parseFloat(l) + "px", S.width = Array.isArray(u) ? parseFloat(u[h]) + "px" : parseFloat(u) + "px", S.left = (Array.isArray(w) ? parseFloat(w[h]) : parseFloat(w)) + "px", S.top = (Array.isArray(A) ? parseFloat(A[h]) : parseFloat(A)) + "px", S.borderWidth = Array.isArray(x) ? x[h] : x, S.borderColor = Array.isArray(v) ? v[h] : v, S.borderRadius = Array.isArray(k) ? parseFloat(k[h]) + "px" : parseFloat(k) + "px", t.config.legend.markers.customHTML && (Array.isArray(t.config.legend.markers.customHTML) ? t.config.legend.markers.customHTML[h] && (m.innerHTML = t.config.legend.markers.customHTML[h]()) : m.innerHTML = t.config.legend.markers.customHTML()), M.setAttrs(m, {
                            rel: h + 1,
                            "data:collapsed": g || p
                        }), (g || p) && m.classList.add("apexcharts-inactive-legend");
                        var C = document.createElement("div"), L = document.createElement("span");
                        L.classList.add("apexcharts-legend-text"), L.innerHTML = Array.isArray(d) ? d.join(" ") : d;
                        var I = t.config.legend.labels.useSeriesColors ? t.globals.colors[h] : Array.isArray(t.config.legend.labels.colors) ? (c = t.config.legend.labels.colors) === null || c === void 0 ? void 0 : c[h] : t.config.legend.labels.colors;
                        I || (I = t.config.chart.foreColor), L.style.color = I, L.style.fontSize = parseFloat(t.config.legend.fontSize) + "px", L.style.fontWeight = t.config.legend.fontWeight, L.style.fontFamily = i || t.config.chart.fontFamily, M.setAttrs(L, {
                            rel: h + 1,
                            i: h,
                            "data:default-text": encodeURIComponent(d),
                            "data:collapsed": g || p
                        }), C.appendChild(m), C.appendChild(L);
                        var z = new q(this.ctx);
                        t.config.legend.showForZeroSeries || z.getSeriesTotalByIndex(h) === 0 && z.seriesHaveSameValues(h) && !z.isSeriesNull(h) && t.globals.collapsedSeriesIndices.indexOf(h) === -1 && t.globals.ancillaryCollapsedSeriesIndices.indexOf(h) === -1 && C.classList.add("apexcharts-hidden-zero-series"), t.config.legend.showForNullSeries || z.isSeriesNull(h) && t.globals.collapsedSeriesIndices.indexOf(h) === -1 && t.globals.ancillaryCollapsedSeriesIndices.indexOf(h) === -1 && C.classList.add("apexcharts-hidden-null-series"), t.globals.dom.elLegendWrap.appendChild(C), t.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(t.config.legend.horizontalAlign)), t.globals.dom.elLegendWrap.classList.add("apx-legend-position-" + t.config.legend.position), C.classList.add("apexcharts-legend-series"), C.style.margin = "".concat(t.config.legend.itemMargin.vertical, "px ").concat(t.config.legend.itemMargin.horizontal, "px"), t.globals.dom.elLegendWrap.style.width = t.config.legend.width ? t.config.legend.width + "px" : "", t.globals.dom.elLegendWrap.style.height = t.config.legend.height ? t.config.legend.height + "px" : "", M.setAttrs(C, {
                            rel: h + 1,
                            seriesName: P.escapeString(a[h]),
                            "data:collapsed": g || p
                        }), (g || p) && C.classList.add("apexcharts-inactive-legend"), t.config.legend.onItemClick.toggleDataSeries || C.classList.add("apexcharts-no-click");
                    }
                    t.globals.dom.elWrap.addEventListener("click", e.onLegendClick, !0), t.config.legend.onItemHover.highlightDataSeries && t.config.legend.customLegendItems.length === 0 && (t.globals.dom.elWrap.addEventListener("mousemove", e.onLegendHovered, !0), t.globals.dom.elWrap.addEventListener("mouseout", e.onLegendHovered, !0));
                }
            },
            {
                key: "setLegendWrapXY",
                value: function(e, t) {
                    var i = this.w, a = i.globals.dom.elLegendWrap, s = a.getBoundingClientRect(), r = 0, n = 0;
                    if (i.config.legend.position === "bottom") n += i.globals.svgHeight - s.height / 2;
                    else if (i.config.legend.position === "top") {
                        var o = new Ye(this.ctx), h = o.dimHelpers.getTitleSubtitleCoords("title").height, c = o.dimHelpers.getTitleSubtitleCoords("subtitle").height;
                        n = n + (h > 0 ? h - 10 : 0) + (c > 0 ? c - 10 : 0);
                    }
                    a.style.position = "absolute", r = r + e + i.config.legend.offsetX, n = n + t + i.config.legend.offsetY, a.style.left = r + "px", a.style.top = n + "px", i.config.legend.position === "bottom" ? (a.style.top = "auto", a.style.bottom = 5 - i.config.legend.offsetY + "px") : i.config.legend.position === "right" && (a.style.left = "auto", a.style.right = 25 + i.config.legend.offsetX + "px"), [
                        "width",
                        "height"
                    ].forEach(function(d) {
                        a.style[d] && (a.style[d] = parseInt(i.config.legend[d], 10) + "px");
                    });
                }
            },
            {
                key: "legendAlignHorizontal",
                value: function() {
                    var e = this.w;
                    e.globals.dom.elLegendWrap.style.right = 0;
                    var t = this.legendHelpers.getLegendBBox(), i = new Ye(this.ctx), a = i.dimHelpers.getTitleSubtitleCoords("title"), s = i.dimHelpers.getTitleSubtitleCoords("subtitle"), r = 0;
                    e.config.legend.position === "bottom" ? r = -t.clwh / 1.8 : e.config.legend.position === "top" && (r = a.height + s.height + e.config.title.margin + e.config.subtitle.margin - 10), this.setLegendWrapXY(20, r);
                }
            },
            {
                key: "legendAlignVertical",
                value: function() {
                    var e = this.w, t = this.legendHelpers.getLegendBBox(), i = 0;
                    e.config.legend.position === "left" && (i = 20), e.config.legend.position === "right" && (i = e.globals.svgWidth - t.clww - 10), this.setLegendWrapXY(i, 20);
                }
            },
            {
                key: "onLegendHovered",
                value: function(e) {
                    var t = this.w, i = e.target.classList.contains("apexcharts-legend-series") || e.target.classList.contains("apexcharts-legend-text") || e.target.classList.contains("apexcharts-legend-marker");
                    if (t.config.chart.type === "heatmap" || this.isBarsDistributed) {
                        if (i) {
                            var a = parseInt(e.target.getAttribute("rel"), 10) - 1;
                            this.ctx.events.fireEvent("legendHover", [
                                this.ctx,
                                a,
                                this.w
                            ]), new te(this.ctx).highlightRangeInSeries(e, e.target);
                        }
                    } else !e.target.classList.contains("apexcharts-inactive-legend") && i && new te(this.ctx).toggleSeriesOnHover(e, e.target);
                }
            },
            {
                key: "onLegendClick",
                value: function(e) {
                    var t = this.w;
                    if (!t.config.legend.customLegendItems.length && (e.target.classList.contains("apexcharts-legend-series") || e.target.classList.contains("apexcharts-legend-text") || e.target.classList.contains("apexcharts-legend-marker"))) {
                        var i = parseInt(e.target.getAttribute("rel"), 10) - 1, a = e.target.getAttribute("data:collapsed") === "true", s = this.w.config.chart.events.legendClick;
                        typeof s == "function" && s(this.ctx, i, this.w), this.ctx.events.fireEvent("legendClick", [
                            this.ctx,
                            i,
                            this.w
                        ]);
                        var r = this.w.config.legend.markers.onClick;
                        typeof r == "function" && e.target.classList.contains("apexcharts-legend-marker") && (r(this.ctx, i, this.w), this.ctx.events.fireEvent("legendMarkerClick", [
                            this.ctx,
                            i,
                            this.w
                        ])), t.config.chart.type !== "treemap" && t.config.chart.type !== "heatmap" && !this.isBarsDistributed && t.config.legend.onItemClick.toggleDataSeries && this.legendHelpers.toggleDataSeries(i, a);
                    }
                }
            }
        ]), y;
    }(), et = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
            var t = this.w;
            this.ev = this.w.config.chart.events, this.selectedClass = "apexcharts-selected", this.localeValues = this.w.globals.locale.toolbar, this.minX = t.globals.minX, this.maxX = t.globals.maxX;
        }
        return Y(y, [
            {
                key: "createToolbar",
                value: function() {
                    var e = this, t = this.w, i = function() {
                        return document.createElement("div");
                    }, a = i();
                    if (a.setAttribute("class", "apexcharts-toolbar"), a.style.top = t.config.chart.toolbar.offsetY + "px", a.style.right = 3 - t.config.chart.toolbar.offsetX + "px", t.globals.dom.elWrap.appendChild(a), this.elZoom = i(), this.elZoomIn = i(), this.elZoomOut = i(), this.elPan = i(), this.elSelection = i(), this.elZoomReset = i(), this.elMenuIcon = i(), this.elMenu = i(), this.elCustomIcons = [], this.t = t.config.chart.toolbar.tools, Array.isArray(this.t.customIcons)) for(var s = 0; s < this.t.customIcons.length; s++)this.elCustomIcons.push(i());
                    var r = [], n = function(d, g, p) {
                        var f = d.toLowerCase();
                        e.t[f] && t.config.chart.zoom.enabled && r.push({
                            el: g,
                            icon: typeof e.t[f] == "string" ? e.t[f] : p,
                            title: e.localeValues[d],
                            class: "apexcharts-".concat(f, "-icon")
                        });
                    };
                    n("zoomIn", this.elZoomIn, `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
</svg>
`), n("zoomOut", this.elZoomOut, `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
</svg>
`);
                    var o = function(d) {
                        e.t[d] && t.config.chart[d].enabled && r.push({
                            el: d === "zoom" ? e.elZoom : e.elSelection,
                            icon: typeof e.t[d] == "string" ? e.t[d] : d === "zoom" ? `<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
    <path d="M0 0h24v24H0V0z" fill="none"/>
    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>
</svg>` : `<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>
</svg>`,
                            title: e.localeValues[d === "zoom" ? "selectionZoom" : "selection"],
                            class: t.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-".concat(d, "-icon")
                        });
                    };
                    o("zoom"), o("selection"), this.t.pan && t.config.chart.zoom.enabled && r.push({
                        el: this.elPan,
                        icon: typeof this.t.pan == "string" ? this.t.pan : `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">
    <defs>
        <path d="M0 0h24v24H0z" id="a"/>
    </defs>
    <clipPath id="b">
        <use overflow="visible" xlink:href="#a"/>
    </clipPath>
    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>
</svg>`,
                        title: this.localeValues.pan,
                        class: t.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-pan-icon"
                    }), n("reset", this.elZoomReset, `<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
</svg>`), this.t.download && r.push({
                        el: this.elMenuIcon,
                        icon: typeof this.t.download == "string" ? this.t.download : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',
                        title: this.localeValues.menu,
                        class: "apexcharts-menu-icon"
                    });
                    for(var h = 0; h < this.elCustomIcons.length; h++)r.push({
                        el: this.elCustomIcons[h],
                        icon: this.t.customIcons[h].icon,
                        title: this.t.customIcons[h].title,
                        index: this.t.customIcons[h].index,
                        class: "apexcharts-toolbar-custom-icon " + this.t.customIcons[h].class
                    });
                    r.forEach(function(d, g) {
                        d.index && P.moveIndexInArray(r, g, d.index);
                    });
                    for(var c = 0; c < r.length; c++)M.setAttrs(r[c].el, {
                        class: r[c].class,
                        title: r[c].title
                    }), r[c].el.innerHTML = r[c].icon, a.appendChild(r[c].el);
                    this._createHamburgerMenu(a), t.globals.zoomEnabled ? this.elZoom.classList.add(this.selectedClass) : t.globals.panEnabled ? this.elPan.classList.add(this.selectedClass) : t.globals.selectionEnabled && this.elSelection.classList.add(this.selectedClass), this.addToolbarEventListeners();
                }
            },
            {
                key: "_createHamburgerMenu",
                value: function(e) {
                    this.elMenuItems = [], e.appendChild(this.elMenu), M.setAttrs(this.elMenu, {
                        class: "apexcharts-menu"
                    });
                    for(var t = [
                        {
                            name: "exportSVG",
                            title: this.localeValues.exportToSVG
                        },
                        {
                            name: "exportPNG",
                            title: this.localeValues.exportToPNG
                        },
                        {
                            name: "exportCSV",
                            title: this.localeValues.exportToCSV
                        }
                    ], i = 0; i < t.length; i++)this.elMenuItems.push(document.createElement("div")), this.elMenuItems[i].innerHTML = t[i].title, M.setAttrs(this.elMenuItems[i], {
                        class: "apexcharts-menu-item ".concat(t[i].name),
                        title: t[i].title
                    }), this.elMenu.appendChild(this.elMenuItems[i]);
                }
            },
            {
                key: "addToolbarEventListeners",
                value: function() {
                    var e = this;
                    this.elZoomReset.addEventListener("click", this.handleZoomReset.bind(this)), this.elSelection.addEventListener("click", this.toggleZoomSelection.bind(this, "selection")), this.elZoom.addEventListener("click", this.toggleZoomSelection.bind(this, "zoom")), this.elZoomIn.addEventListener("click", this.handleZoomIn.bind(this)), this.elZoomOut.addEventListener("click", this.handleZoomOut.bind(this)), this.elPan.addEventListener("click", this.togglePanning.bind(this)), this.elMenuIcon.addEventListener("click", this.toggleMenu.bind(this)), this.elMenuItems.forEach(function(i) {
                        i.classList.contains("exportSVG") ? i.addEventListener("click", e.handleDownload.bind(e, "svg")) : i.classList.contains("exportPNG") ? i.addEventListener("click", e.handleDownload.bind(e, "png")) : i.classList.contains("exportCSV") && i.addEventListener("click", e.handleDownload.bind(e, "csv"));
                    });
                    for(var t = 0; t < this.t.customIcons.length; t++)this.elCustomIcons[t].addEventListener("click", this.t.customIcons[t].click.bind(this, this.ctx, this.ctx.w));
                }
            },
            {
                key: "toggleZoomSelection",
                value: function(e) {
                    this.ctx.getSyncedCharts().forEach(function(t) {
                        t.ctx.toolbar.toggleOtherControls();
                        var i = e === "selection" ? t.ctx.toolbar.elSelection : t.ctx.toolbar.elZoom, a = e === "selection" ? "selectionEnabled" : "zoomEnabled";
                        t.w.globals[a] = !t.w.globals[a], i.classList.contains(t.ctx.toolbar.selectedClass) ? i.classList.remove(t.ctx.toolbar.selectedClass) : i.classList.add(t.ctx.toolbar.selectedClass);
                    });
                }
            },
            {
                key: "getToolbarIconsReference",
                value: function() {
                    var e = this.w;
                    this.elZoom || (this.elZoom = e.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")), this.elPan || (this.elPan = e.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")), this.elSelection || (this.elSelection = e.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"));
                }
            },
            {
                key: "enableZoomPanFromToolbar",
                value: function(e) {
                    this.toggleOtherControls(), e === "pan" ? this.w.globals.panEnabled = !0 : this.w.globals.zoomEnabled = !0;
                    var t = e === "pan" ? this.elPan : this.elZoom, i = e === "pan" ? this.elZoom : this.elPan;
                    t && t.classList.add(this.selectedClass), i && i.classList.remove(this.selectedClass);
                }
            },
            {
                key: "togglePanning",
                value: function() {
                    this.ctx.getSyncedCharts().forEach(function(e) {
                        e.ctx.toolbar.toggleOtherControls(), e.w.globals.panEnabled = !e.w.globals.panEnabled, e.ctx.toolbar.elPan.classList.contains(e.ctx.toolbar.selectedClass) ? e.ctx.toolbar.elPan.classList.remove(e.ctx.toolbar.selectedClass) : e.ctx.toolbar.elPan.classList.add(e.ctx.toolbar.selectedClass);
                    });
                }
            },
            {
                key: "toggleOtherControls",
                value: function() {
                    var e = this, t = this.w;
                    t.globals.panEnabled = !1, t.globals.zoomEnabled = !1, t.globals.selectionEnabled = !1, this.getToolbarIconsReference(), [
                        this.elPan,
                        this.elSelection,
                        this.elZoom
                    ].forEach(function(i) {
                        i && i.classList.remove(e.selectedClass);
                    });
                }
            },
            {
                key: "handleZoomIn",
                value: function() {
                    var e = this.w;
                    e.globals.isRangeBar && (this.minX = e.globals.minY, this.maxX = e.globals.maxY);
                    var t = (this.minX + this.maxX) / 2, i = (this.minX + t) / 2, a = (this.maxX + t) / 2, s = this._getNewMinXMaxX(i, a);
                    e.globals.disableZoomIn || this.zoomUpdateOptions(s.minX, s.maxX);
                }
            },
            {
                key: "handleZoomOut",
                value: function() {
                    var e = this.w;
                    if (e.globals.isRangeBar && (this.minX = e.globals.minY, this.maxX = e.globals.maxY), !(e.config.xaxis.type === "datetime" && new Date(this.minX).getUTCFullYear() < 1e3)) {
                        var t = (this.minX + this.maxX) / 2, i = this.minX - (t - this.minX), a = this.maxX - (t - this.maxX), s = this._getNewMinXMaxX(i, a);
                        e.globals.disableZoomOut || this.zoomUpdateOptions(s.minX, s.maxX);
                    }
                }
            },
            {
                key: "_getNewMinXMaxX",
                value: function(e, t) {
                    var i = this.w.config.xaxis.convertedCatToNumeric;
                    return {
                        minX: i ? Math.floor(e) : e,
                        maxX: i ? Math.floor(t) : t
                    };
                }
            },
            {
                key: "zoomUpdateOptions",
                value: function(e, t) {
                    var i = this.w;
                    if (e !== void 0 || t !== void 0) {
                        if (!(i.config.xaxis.convertedCatToNumeric && (e < 1 && (e = 1, t = i.globals.dataPoints), t - e < 2))) {
                            var a = {
                                min: e,
                                max: t
                            }, s = this.getBeforeZoomRange(a);
                            s && (a = s.xaxis);
                            var r = {
                                xaxis: a
                            }, n = P.clone(i.globals.initialConfig.yaxis);
                            i.config.chart.zoom.autoScaleYaxis && (n = new we(this.ctx).autoScaleY(this.ctx, n, {
                                xaxis: a
                            })), i.config.chart.group || (r.yaxis = n), this.w.globals.zoomed = !0, this.ctx.updateHelpers._updateOptions(r, !1, this.w.config.chart.animations.dynamicAnimation.enabled), this.zoomCallback(a, n);
                        }
                    } else this.handleZoomReset();
                }
            },
            {
                key: "zoomCallback",
                value: function(e, t) {
                    typeof this.ev.zoomed == "function" && this.ev.zoomed(this.ctx, {
                        xaxis: e,
                        yaxis: t
                    });
                }
            },
            {
                key: "getBeforeZoomRange",
                value: function(e, t) {
                    var i = null;
                    return typeof this.ev.beforeZoom == "function" && (i = this.ev.beforeZoom(this, {
                        xaxis: e,
                        yaxis: t
                    })), i;
                }
            },
            {
                key: "toggleMenu",
                value: function() {
                    var e = this;
                    window.setTimeout(function() {
                        e.elMenu.classList.contains("apexcharts-menu-open") ? e.elMenu.classList.remove("apexcharts-menu-open") : e.elMenu.classList.add("apexcharts-menu-open");
                    }, 0);
                }
            },
            {
                key: "handleDownload",
                value: function(e) {
                    var t = this.w, i = new Ee(this.ctx);
                    switch(e){
                        case "svg":
                            i.exportToSVG(this.ctx);
                            break;
                        case "png":
                            i.exportToPng(this.ctx);
                            break;
                        case "csv":
                            i.exportToCSV({
                                series: t.config.series,
                                columnDelimiter: t.config.chart.toolbar.export.csv.columnDelimiter
                            });
                    }
                }
            },
            {
                key: "handleZoomReset",
                value: function(e) {
                    this.ctx.getSyncedCharts().forEach(function(t) {
                        var i = t.w;
                        if (i.globals.lastXAxis.min = i.globals.initialConfig.xaxis.min, i.globals.lastXAxis.max = i.globals.initialConfig.xaxis.max, t.updateHelpers.revertDefaultAxisMinMax(), typeof i.config.chart.events.beforeResetZoom == "function") {
                            var a = i.config.chart.events.beforeResetZoom(t, i);
                            a && t.updateHelpers.revertDefaultAxisMinMax(a);
                        }
                        typeof i.config.chart.events.zoomed == "function" && t.ctx.toolbar.zoomCallback({
                            min: i.config.xaxis.min,
                            max: i.config.xaxis.max
                        }), i.globals.zoomed = !1;
                        var s = t.ctx.series.emptyCollapsedSeries(P.clone(i.globals.initialSeries));
                        t.updateHelpers._updateSeries(s, i.config.chart.animations.dynamicAnimation.enabled);
                    });
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.elZoom = null, this.elZoomIn = null, this.elZoomOut = null, this.elPan = null, this.elSelection = null, this.elZoomReset = null, this.elMenuIcon = null;
                }
            }
        ]), y;
    }(), Pt = function(y) {
        ge(t, et);
        var e = ue(t);
        function t(i) {
            var a;
            return F(this, t), (a = e.call(this, i)).ctx = i, a.w = i.w, a.dragged = !1, a.graphics = new M(a.ctx), a.eventList = [
                "mousedown",
                "mouseleave",
                "mousemove",
                "touchstart",
                "touchmove",
                "mouseup",
                "touchend"
            ], a.clientX = 0, a.clientY = 0, a.startX = 0, a.endX = 0, a.dragX = 0, a.startY = 0, a.endY = 0, a.dragY = 0, a.moveDirection = "none", a;
        }
        return Y(t, [
            {
                key: "init",
                value: function(i) {
                    var a = this, s = i.xyRatios, r = this.w, n = this;
                    this.xyRatios = s, this.zoomRect = this.graphics.drawRect(0, 0, 0, 0), this.selectionRect = this.graphics.drawRect(0, 0, 0, 0), this.gridRect = r.globals.dom.baseEl.querySelector(".apexcharts-grid"), this.zoomRect.node.classList.add("apexcharts-zoom-rect"), this.selectionRect.node.classList.add("apexcharts-selection-rect"), r.globals.dom.elGraphical.add(this.zoomRect), r.globals.dom.elGraphical.add(this.selectionRect), r.config.chart.selection.type === "x" ? this.slDraggableRect = this.selectionRect.draggable({
                        minX: 0,
                        minY: 0,
                        maxX: r.globals.gridWidth,
                        maxY: r.globals.gridHeight
                    }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : r.config.chart.selection.type === "y" ? this.slDraggableRect = this.selectionRect.draggable({
                        minX: 0,
                        maxX: r.globals.gridWidth
                    }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : this.slDraggableRect = this.selectionRect.draggable().on("dragmove", this.selectionDragging.bind(this, "dragging")), this.preselectedSelection(), this.hoverArea = r.globals.dom.baseEl.querySelector("".concat(r.globals.chartClass, " .apexcharts-svg")), this.hoverArea.classList.add("apexcharts-zoomable"), this.eventList.forEach(function(o) {
                        a.hoverArea.addEventListener(o, n.svgMouseEvents.bind(n, s), {
                            capture: !1,
                            passive: !0
                        });
                    });
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.slDraggableRect && (this.slDraggableRect.draggable(!1), this.slDraggableRect.off(), this.selectionRect.off()), this.selectionRect = null, this.zoomRect = null, this.gridRect = null;
                }
            },
            {
                key: "svgMouseEvents",
                value: function(i, a) {
                    var s = this.w, r = this, n = this.ctx.toolbar, o = s.globals.zoomEnabled ? s.config.chart.zoom.type : s.config.chart.selection.type, h = s.config.chart.toolbar.autoSelected;
                    if (a.shiftKey ? (this.shiftWasPressed = !0, n.enableZoomPanFromToolbar(h === "pan" ? "zoom" : "pan")) : this.shiftWasPressed && (n.enableZoomPanFromToolbar(h), this.shiftWasPressed = !1), a.target) {
                        var c, d = a.target.classList;
                        if (a.target.parentNode && a.target.parentNode !== null && (c = a.target.parentNode.classList), !(d.contains("apexcharts-selection-rect") || d.contains("apexcharts-legend-marker") || d.contains("apexcharts-legend-text") || c && c.contains("apexcharts-toolbar"))) {
                            if (r.clientX = a.type === "touchmove" || a.type === "touchstart" ? a.touches[0].clientX : a.type === "touchend" ? a.changedTouches[0].clientX : a.clientX, r.clientY = a.type === "touchmove" || a.type === "touchstart" ? a.touches[0].clientY : a.type === "touchend" ? a.changedTouches[0].clientY : a.clientY, a.type === "mousedown" && a.which === 1) {
                                var g = r.gridRect.getBoundingClientRect();
                                r.startX = r.clientX - g.left, r.startY = r.clientY - g.top, r.dragged = !1, r.w.globals.mousedown = !0;
                            }
                            if ((a.type === "mousemove" && a.which === 1 || a.type === "touchmove") && (r.dragged = !0, s.globals.panEnabled ? (s.globals.selection = null, r.w.globals.mousedown && r.panDragging({
                                context: r,
                                zoomtype: o,
                                xyRatios: i
                            })) : (r.w.globals.mousedown && s.globals.zoomEnabled || r.w.globals.mousedown && s.globals.selectionEnabled) && (r.selection = r.selectionDrawing({
                                context: r,
                                zoomtype: o
                            }))), a.type === "mouseup" || a.type === "touchend" || a.type === "mouseleave") {
                                var p = r.gridRect.getBoundingClientRect();
                                r.w.globals.mousedown && (r.endX = r.clientX - p.left, r.endY = r.clientY - p.top, r.dragX = Math.abs(r.endX - r.startX), r.dragY = Math.abs(r.endY - r.startY), (s.globals.zoomEnabled || s.globals.selectionEnabled) && r.selectionDrawn({
                                    context: r,
                                    zoomtype: o
                                }), s.globals.panEnabled && s.config.xaxis.convertedCatToNumeric && r.delayedPanScrolled()), s.globals.zoomEnabled && r.hideSelectionRect(this.selectionRect), r.dragged = !1, r.w.globals.mousedown = !1;
                            }
                            this.makeSelectionRectDraggable();
                        }
                    }
                }
            },
            {
                key: "makeSelectionRectDraggable",
                value: function() {
                    var i = this.w;
                    if (this.selectionRect) {
                        var a = this.selectionRect.node.getBoundingClientRect();
                        a.width > 0 && a.height > 0 && this.slDraggableRect.selectize({
                            points: "l, r",
                            pointSize: 8,
                            pointType: "rect"
                        }).resize({
                            constraint: {
                                minX: 0,
                                minY: 0,
                                maxX: i.globals.gridWidth,
                                maxY: i.globals.gridHeight
                            }
                        }).on("resizing", this.selectionDragging.bind(this, "resizing"));
                    }
                }
            },
            {
                key: "preselectedSelection",
                value: function() {
                    var i = this.w, a = this.xyRatios;
                    if (!i.globals.zoomEnabled) {
                        if (i.globals.selection !== void 0 && i.globals.selection !== null) this.drawSelectionRect(i.globals.selection);
                        else if (i.config.chart.selection.xaxis.min !== void 0 && i.config.chart.selection.xaxis.max !== void 0) {
                            var s = (i.config.chart.selection.xaxis.min - i.globals.minX) / a.xRatio, r = i.globals.gridWidth - (i.globals.maxX - i.config.chart.selection.xaxis.max) / a.xRatio - s;
                            i.globals.isRangeBar && (s = (i.config.chart.selection.xaxis.min - i.globals.yAxisScale[0].niceMin) / a.invertedYRatio, r = (i.config.chart.selection.xaxis.max - i.config.chart.selection.xaxis.min) / a.invertedYRatio);
                            var n = {
                                x: s,
                                y: 0,
                                width: r,
                                height: i.globals.gridHeight,
                                translateX: 0,
                                translateY: 0,
                                selectionEnabled: !0
                            };
                            this.drawSelectionRect(n), this.makeSelectionRectDraggable(), typeof i.config.chart.events.selection == "function" && i.config.chart.events.selection(this.ctx, {
                                xaxis: {
                                    min: i.config.chart.selection.xaxis.min,
                                    max: i.config.chart.selection.xaxis.max
                                },
                                yaxis: {}
                            });
                        }
                    }
                }
            },
            {
                key: "drawSelectionRect",
                value: function(i) {
                    var a = i.x, s = i.y, r = i.width, n = i.height, o = i.translateX, h = o === void 0 ? 0 : o, c = i.translateY, d = c === void 0 ? 0 : c, g = this.w, p = this.zoomRect, f = this.selectionRect;
                    if (this.dragged || g.globals.selection !== null) {
                        var b = {
                            transform: "translate(" + h + ", " + d + ")"
                        };
                        g.globals.zoomEnabled && this.dragged && (r < 0 && (r = 1), p.attr({
                            x: a,
                            y: s,
                            width: r,
                            height: n,
                            fill: g.config.chart.zoom.zoomedArea.fill.color,
                            "fill-opacity": g.config.chart.zoom.zoomedArea.fill.opacity,
                            stroke: g.config.chart.zoom.zoomedArea.stroke.color,
                            "stroke-width": g.config.chart.zoom.zoomedArea.stroke.width,
                            "stroke-opacity": g.config.chart.zoom.zoomedArea.stroke.opacity
                        }), M.setAttrs(p.node, b)), g.globals.selectionEnabled && (f.attr({
                            x: a,
                            y: s,
                            width: r > 0 ? r : 0,
                            height: n > 0 ? n : 0,
                            fill: g.config.chart.selection.fill.color,
                            "fill-opacity": g.config.chart.selection.fill.opacity,
                            stroke: g.config.chart.selection.stroke.color,
                            "stroke-width": g.config.chart.selection.stroke.width,
                            "stroke-dasharray": g.config.chart.selection.stroke.dashArray,
                            "stroke-opacity": g.config.chart.selection.stroke.opacity
                        }), M.setAttrs(f.node, b));
                    }
                }
            },
            {
                key: "hideSelectionRect",
                value: function(i) {
                    i && i.attr({
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    });
                }
            },
            {
                key: "selectionDrawing",
                value: function(i) {
                    var a = i.context, s = i.zoomtype, r = this.w, n = a, o = this.gridRect.getBoundingClientRect(), h = n.startX - 1, c = n.startY, d = !1, g = !1, p = n.clientX - o.left - h, f = n.clientY - o.top - c, b = {};
                    return Math.abs(p + h) > r.globals.gridWidth ? p = r.globals.gridWidth - h : n.clientX - o.left < 0 && (p = h), h > n.clientX - o.left && (d = !0, p = Math.abs(p)), c > n.clientY - o.top && (g = !0, f = Math.abs(f)), b = s === "x" ? {
                        x: d ? h - p : h,
                        y: 0,
                        width: p,
                        height: r.globals.gridHeight
                    } : s === "y" ? {
                        x: 0,
                        y: g ? c - f : c,
                        width: r.globals.gridWidth,
                        height: f
                    } : {
                        x: d ? h - p : h,
                        y: g ? c - f : c,
                        width: p,
                        height: f
                    }, n.drawSelectionRect(b), n.selectionDragging("resizing"), b;
                }
            },
            {
                key: "selectionDragging",
                value: function(i, a) {
                    var s = this, r = this.w, n = this.xyRatios, o = this.selectionRect, h = 0;
                    i === "resizing" && (h = 30);
                    var c = function(g) {
                        return parseFloat(o.node.getAttribute(g));
                    }, d = {
                        x: c("x"),
                        y: c("y"),
                        width: c("width"),
                        height: c("height")
                    };
                    r.globals.selection = d, typeof r.config.chart.events.selection == "function" && r.globals.selectionEnabled && (clearTimeout(this.w.globals.selectionResizeTimer), this.w.globals.selectionResizeTimer = window.setTimeout(function() {
                        var g, p, f, b, m = s.gridRect.getBoundingClientRect(), w = o.node.getBoundingClientRect();
                        r.globals.isRangeBar ? (g = r.globals.yAxisScale[0].niceMin + (w.left - m.left) * n.invertedYRatio, p = r.globals.yAxisScale[0].niceMin + (w.right - m.left) * n.invertedYRatio, f = 0, b = 1) : (g = r.globals.xAxisScale.niceMin + (w.left - m.left) * n.xRatio, p = r.globals.xAxisScale.niceMin + (w.right - m.left) * n.xRatio, f = r.globals.yAxisScale[0].niceMin + (m.bottom - w.bottom) * n.yRatio[0], b = r.globals.yAxisScale[0].niceMax - (w.top - m.top) * n.yRatio[0]);
                        var A = {
                            xaxis: {
                                min: g,
                                max: p
                            },
                            yaxis: {
                                min: f,
                                max: b
                            }
                        };
                        r.config.chart.events.selection(s.ctx, A), r.config.chart.brush.enabled && r.config.chart.events.brushScrolled !== void 0 && r.config.chart.events.brushScrolled(s.ctx, A);
                    }, h));
                }
            },
            {
                key: "selectionDrawn",
                value: function(i) {
                    var a = i.context, s = i.zoomtype, r = this.w, n = a, o = this.xyRatios, h = this.ctx.toolbar;
                    if (n.startX > n.endX) {
                        var c = n.startX;
                        n.startX = n.endX, n.endX = c;
                    }
                    if (n.startY > n.endY) {
                        var d = n.startY;
                        n.startY = n.endY, n.endY = d;
                    }
                    var g = void 0, p = void 0;
                    r.globals.isRangeBar ? (g = r.globals.yAxisScale[0].niceMin + n.startX * o.invertedYRatio, p = r.globals.yAxisScale[0].niceMin + n.endX * o.invertedYRatio) : (g = r.globals.xAxisScale.niceMin + n.startX * o.xRatio, p = r.globals.xAxisScale.niceMin + n.endX * o.xRatio);
                    var f = [], b = [];
                    if (r.config.yaxis.forEach(function(k, S) {
                        f.push(r.globals.yAxisScale[S].niceMax - o.yRatio[S] * n.startY), b.push(r.globals.yAxisScale[S].niceMax - o.yRatio[S] * n.endY);
                    }), n.dragged && (n.dragX > 10 || n.dragY > 10) && g !== p) {
                        if (r.globals.zoomEnabled) {
                            var m = P.clone(r.globals.initialConfig.yaxis), w = P.clone(r.globals.initialConfig.xaxis);
                            if (r.globals.zoomed = !0, r.config.xaxis.convertedCatToNumeric && (g = Math.floor(g), p = Math.floor(p), g < 1 && (g = 1, p = r.globals.dataPoints), p - g < 2 && (p = g + 1)), s !== "xy" && s !== "x" || (w = {
                                min: g,
                                max: p
                            }), s !== "xy" && s !== "y" || m.forEach(function(k, S) {
                                m[S].min = b[S], m[S].max = f[S];
                            }), r.config.chart.zoom.autoScaleYaxis) {
                                var A = new we(n.ctx);
                                m = A.autoScaleY(n.ctx, m, {
                                    xaxis: w
                                });
                            }
                            if (h) {
                                var l = h.getBeforeZoomRange(w, m);
                                l && (w = l.xaxis ? l.xaxis : w, m = l.yaxis ? l.yaxis : m);
                            }
                            var u = {
                                xaxis: w
                            };
                            r.config.chart.group || (u.yaxis = m), n.ctx.updateHelpers._updateOptions(u, !1, n.w.config.chart.animations.dynamicAnimation.enabled), typeof r.config.chart.events.zoomed == "function" && h.zoomCallback(w, m);
                        } else if (r.globals.selectionEnabled) {
                            var x, v = null;
                            x = {
                                min: g,
                                max: p
                            }, s !== "xy" && s !== "y" || (v = P.clone(r.config.yaxis)).forEach(function(k, S) {
                                v[S].min = b[S], v[S].max = f[S];
                            }), r.globals.selection = n.selection, typeof r.config.chart.events.selection == "function" && r.config.chart.events.selection(n.ctx, {
                                xaxis: x,
                                yaxis: v
                            });
                        }
                    }
                }
            },
            {
                key: "panDragging",
                value: function(i) {
                    var a = i.context, s = this.w, r = a;
                    if (s.globals.lastClientPosition.x !== void 0) {
                        var n = s.globals.lastClientPosition.x - r.clientX, o = s.globals.lastClientPosition.y - r.clientY;
                        Math.abs(n) > Math.abs(o) && n > 0 ? this.moveDirection = "left" : Math.abs(n) > Math.abs(o) && n < 0 ? this.moveDirection = "right" : Math.abs(o) > Math.abs(n) && o > 0 ? this.moveDirection = "up" : Math.abs(o) > Math.abs(n) && o < 0 && (this.moveDirection = "down");
                    }
                    s.globals.lastClientPosition = {
                        x: r.clientX,
                        y: r.clientY
                    };
                    var h = s.globals.isRangeBar ? s.globals.minY : s.globals.minX, c = s.globals.isRangeBar ? s.globals.maxY : s.globals.maxX;
                    s.config.xaxis.convertedCatToNumeric || r.panScrolled(h, c);
                }
            },
            {
                key: "delayedPanScrolled",
                value: function() {
                    var i = this.w, a = i.globals.minX, s = i.globals.maxX, r = (i.globals.maxX - i.globals.minX) / 2;
                    this.moveDirection === "left" ? (a = i.globals.minX + r, s = i.globals.maxX + r) : this.moveDirection === "right" && (a = i.globals.minX - r, s = i.globals.maxX - r), a = Math.floor(a), s = Math.floor(s), this.updateScrolledChart({
                        xaxis: {
                            min: a,
                            max: s
                        }
                    }, a, s);
                }
            },
            {
                key: "panScrolled",
                value: function(i, a) {
                    var s = this.w, r = this.xyRatios, n = P.clone(s.globals.initialConfig.yaxis), o = r.xRatio, h = s.globals.minX, c = s.globals.maxX;
                    s.globals.isRangeBar && (o = r.invertedYRatio, h = s.globals.minY, c = s.globals.maxY), this.moveDirection === "left" ? (i = h + s.globals.gridWidth / 15 * o, a = c + s.globals.gridWidth / 15 * o) : this.moveDirection === "right" && (i = h - s.globals.gridWidth / 15 * o, a = c - s.globals.gridWidth / 15 * o), s.globals.isRangeBar || (i < s.globals.initialMinX || a > s.globals.initialMaxX) && (i = h, a = c);
                    var d = {
                        min: i,
                        max: a
                    };
                    s.config.chart.zoom.autoScaleYaxis && (n = new we(this.ctx).autoScaleY(this.ctx, n, {
                        xaxis: d
                    }));
                    var g = {
                        xaxis: {
                            min: i,
                            max: a
                        }
                    };
                    s.config.chart.group || (g.yaxis = n), this.updateScrolledChart(g, i, a);
                }
            },
            {
                key: "updateScrolledChart",
                value: function(i, a, s) {
                    var r = this.w;
                    this.ctx.updateHelpers._updateOptions(i, !1, !1), typeof r.config.chart.events.scrolled == "function" && r.config.chart.events.scrolled(this.ctx, {
                        xaxis: {
                            min: a,
                            max: s
                        }
                    });
                }
            }
        ]), t;
    }(), tt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx;
        }
        return Y(y, [
            {
                key: "getNearestValues",
                value: function(e) {
                    var t = e.hoverArea, i = e.elGrid, a = e.clientX, s = e.clientY, r = this.w, n = i.getBoundingClientRect(), o = n.width, h = n.height, c = o / (r.globals.dataPoints - 1), d = h / r.globals.dataPoints, g = this.hasBars();
                    !r.globals.comboCharts && !g || r.config.xaxis.convertedCatToNumeric || (c = o / r.globals.dataPoints);
                    var p = a - n.left - r.globals.barPadForNumericAxis, f = s - n.top;
                    p < 0 || f < 0 || p > o || f > h ? (t.classList.remove("hovering-zoom"), t.classList.remove("hovering-pan")) : r.globals.zoomEnabled ? (t.classList.remove("hovering-pan"), t.classList.add("hovering-zoom")) : r.globals.panEnabled && (t.classList.remove("hovering-zoom"), t.classList.add("hovering-pan"));
                    var b = Math.round(p / c), m = Math.floor(f / d);
                    g && !r.config.xaxis.convertedCatToNumeric && (b = Math.ceil(p / c), b -= 1);
                    var w = null, A = null, l = r.globals.seriesXvalues.map(function(S) {
                        return S.filter(function(C) {
                            return P.isNumber(C);
                        });
                    }), u = r.globals.seriesYvalues.map(function(S) {
                        return S.filter(function(C) {
                            return P.isNumber(C);
                        });
                    });
                    if (r.globals.isXNumeric) {
                        var x = this.ttCtx.getElGrid().getBoundingClientRect(), v = p * (x.width / o), k = f * (x.height / h);
                        w = (A = this.closestInMultiArray(v, k, l, u)).index, b = A.j, w !== null && (l = r.globals.seriesXvalues[w], b = (A = this.closestInArray(v, l)).index);
                    }
                    return r.globals.capturedSeriesIndex = w === null ? -1 : w, (!b || b < 1) && (b = 0), r.globals.isBarHorizontal ? r.globals.capturedDataPointIndex = m : r.globals.capturedDataPointIndex = b, {
                        capturedSeries: w,
                        j: r.globals.isBarHorizontal ? m : b,
                        hoverX: p,
                        hoverY: f
                    };
                }
            },
            {
                key: "closestInMultiArray",
                value: function(e, t, i, a) {
                    var s = this.w, r = 0, n = null, o = -1;
                    s.globals.series.length > 1 ? r = this.getFirstActiveXArray(i) : n = 0;
                    var h = i[r][0], c = Math.abs(e - h);
                    if (i.forEach(function(p) {
                        p.forEach(function(f, b) {
                            var m = Math.abs(e - f);
                            m <= c && (c = m, o = b);
                        });
                    }), o !== -1) {
                        var d = a[r][o], g = Math.abs(t - d);
                        n = r, a.forEach(function(p, f) {
                            var b = Math.abs(t - p[o]);
                            b <= g && (g = b, n = f);
                        });
                    }
                    return {
                        index: n,
                        j: o
                    };
                }
            },
            {
                key: "getFirstActiveXArray",
                value: function(e) {
                    for(var t = this.w, i = 0, a = e.map(function(r, n) {
                        return r.length > 0 ? n : -1;
                    }), s = 0; s < a.length; s++)if (a[s] !== -1 && t.globals.collapsedSeriesIndices.indexOf(s) === -1 && t.globals.ancillaryCollapsedSeriesIndices.indexOf(s) === -1) {
                        i = a[s];
                        break;
                    }
                    return i;
                }
            },
            {
                key: "closestInArray",
                value: function(e, t) {
                    for(var i = t[0], a = null, s = Math.abs(e - i), r = 0; r < t.length; r++){
                        var n = Math.abs(e - t[r]);
                        n < s && (s = n, a = r);
                    }
                    return {
                        index: a
                    };
                }
            },
            {
                key: "isXoverlap",
                value: function(e) {
                    var t = [], i = this.w.globals.seriesX.filter(function(s) {
                        return s[0] !== void 0;
                    });
                    if (i.length > 0) for(var a = 0; a < i.length - 1; a++)i[a][e] !== void 0 && i[a + 1][e] !== void 0 && i[a][e] !== i[a + 1][e] && t.push("unEqual");
                    return t.length === 0;
                }
            },
            {
                key: "isInitialSeriesSameLen",
                value: function() {
                    for(var e = !0, t = this.w.globals.initialSeries, i = 0; i < t.length - 1; i++)if (t[i].data.length !== t[i + 1].data.length) {
                        e = !1;
                        break;
                    }
                    return e;
                }
            },
            {
                key: "getBarsHeight",
                value: function(e) {
                    return J(e).reduce(function(t, i) {
                        return t + i.getBBox().height;
                    }, 0);
                }
            },
            {
                key: "getElMarkers",
                value: function(e) {
                    return typeof e == "number" ? this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-series-markers-wrap > *")) : this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap > *");
                }
            },
            {
                key: "getAllMarkers",
                value: function() {
                    var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");
                    (e = J(e)).sort(function(i, a) {
                        var s = Number(i.getAttribute("data:realIndex")), r = Number(a.getAttribute("data:realIndex"));
                        return r < s ? 1 : r > s ? -1 : 0;
                    });
                    var t = [];
                    return e.forEach(function(i) {
                        t.push(i.querySelector(".apexcharts-marker"));
                    }), t;
                }
            },
            {
                key: "hasMarkers",
                value: function(e) {
                    return this.getElMarkers(e).length > 0;
                }
            },
            {
                key: "getElBars",
                value: function() {
                    return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series");
                }
            },
            {
                key: "hasBars",
                value: function() {
                    return this.getElBars().length > 0;
                }
            },
            {
                key: "getHoverMarkerSize",
                value: function(e) {
                    var t = this.w, i = t.config.markers.hover.size;
                    return i === void 0 && (i = t.globals.markers.size[e] + t.config.markers.hover.sizeOffset), i;
                }
            },
            {
                key: "toggleAllTooltipSeriesGroups",
                value: function(e) {
                    var t = this.w, i = this.ttCtx;
                    i.allTooltipSeriesGroups.length === 0 && (i.allTooltipSeriesGroups = t.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));
                    for(var a = i.allTooltipSeriesGroups, s = 0; s < a.length; s++)e === "enable" ? (a[s].classList.add("apexcharts-active"), a[s].style.display = t.config.tooltip.items.display) : (a[s].classList.remove("apexcharts-active"), a[s].style.display = "none");
                }
            }
        ]), y;
    }(), It = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.ctx = e.ctx, this.ttCtx = e, this.tooltipUtil = new tt(e);
        }
        return Y(y, [
            {
                key: "drawSeriesTexts",
                value: function(e) {
                    var t = e.shared, i = t === void 0 || t, a = e.ttItems, s = e.i, r = s === void 0 ? 0 : s, n = e.j, o = n === void 0 ? null : n, h = e.y1, c = e.y2, d = e.e, g = this.w;
                    g.config.tooltip.custom !== void 0 ? this.handleCustomTooltip({
                        i: r,
                        j: o,
                        y1: h,
                        y2: c,
                        w: g
                    }) : this.toggleActiveInactiveSeries(i);
                    var p = this.getValuesToPrint({
                        i: r,
                        j: o
                    });
                    this.printLabels({
                        i: r,
                        j: o,
                        values: p,
                        ttItems: a,
                        shared: i,
                        e: d
                    });
                    var f = this.ttCtx.getElTooltip();
                    this.ttCtx.tooltipRect.ttWidth = f.getBoundingClientRect().width, this.ttCtx.tooltipRect.ttHeight = f.getBoundingClientRect().height;
                }
            },
            {
                key: "printLabels",
                value: function(e) {
                    var t, i = this, a = e.i, s = e.j, r = e.values, n = e.ttItems, o = e.shared, h = e.e, c = this.w, d = [], g = function(x) {
                        return c.globals.seriesGoals[x] && c.globals.seriesGoals[x][s] && Array.isArray(c.globals.seriesGoals[x][s]);
                    }, p = r.xVal, f = r.zVal, b = r.xAxisTTVal, m = "", w = c.globals.colors[a];
                    s !== null && c.config.plotOptions.bar.distributed && (w = c.globals.colors[s]);
                    for(var A = function(x, v) {
                        var k = i.getFormatters(a);
                        m = i.getSeriesName({
                            fn: k.yLbTitleFormatter,
                            index: a,
                            seriesIndex: a,
                            j: s
                        }), c.config.chart.type === "treemap" && (m = k.yLbTitleFormatter(String(c.config.series[a].data[s].x), {
                            series: c.globals.series,
                            seriesIndex: a,
                            dataPointIndex: s,
                            w: c
                        }));
                        var S = c.config.tooltip.inverseOrder ? v : x;
                        if (c.globals.axisCharts) {
                            var C = function(z) {
                                var T, E, R, O;
                                return c.globals.isRangeData ? k.yLbFormatter((T = c.globals.seriesRangeStart) === null || T === void 0 || (E = T[z]) === null || E === void 0 ? void 0 : E[s], {
                                    series: c.globals.seriesRangeStart,
                                    seriesIndex: z,
                                    dataPointIndex: s,
                                    w: c
                                }) + " - " + k.yLbFormatter((R = c.globals.seriesRangeEnd) === null || R === void 0 || (O = R[z]) === null || O === void 0 ? void 0 : O[s], {
                                    series: c.globals.seriesRangeEnd,
                                    seriesIndex: z,
                                    dataPointIndex: s,
                                    w: c
                                }) : k.yLbFormatter(c.globals.series[z][s], {
                                    series: c.globals.series,
                                    seriesIndex: z,
                                    dataPointIndex: s,
                                    w: c
                                });
                            };
                            if (o) k = i.getFormatters(S), m = i.getSeriesName({
                                fn: k.yLbTitleFormatter,
                                index: S,
                                seriesIndex: a,
                                j: s
                            }), w = c.globals.colors[S], t = C(S), g(S) && (d = c.globals.seriesGoals[S][s].map(function(z) {
                                return {
                                    attrs: z,
                                    val: k.yLbFormatter(z.value, {
                                        seriesIndex: S,
                                        dataPointIndex: s,
                                        w: c
                                    })
                                };
                            }));
                            else {
                                var L, I = h == null || (L = h.target) === null || L === void 0 ? void 0 : L.getAttribute("fill");
                                I && (w = I.indexOf("url") !== -1 ? document.querySelector(I.substr(4).slice(0, -1)).childNodes[0].getAttribute("stroke") : I), t = C(a), g(a) && Array.isArray(c.globals.seriesGoals[a][s]) && (d = c.globals.seriesGoals[a][s].map(function(z) {
                                    return {
                                        attrs: z,
                                        val: k.yLbFormatter(z.value, {
                                            seriesIndex: a,
                                            dataPointIndex: s,
                                            w: c
                                        })
                                    };
                                }));
                            }
                        }
                        s === null && (t = k.yLbFormatter(c.globals.series[a], X(X({}, c), {}, {
                            seriesIndex: a,
                            dataPointIndex: a
                        }))), i.DOMHandling({
                            i: a,
                            t: S,
                            j: s,
                            ttItems: n,
                            values: {
                                val: t,
                                goalVals: d,
                                xVal: p,
                                xAxisTTVal: b,
                                zVal: f
                            },
                            seriesName: m,
                            shared: o,
                            pColor: w
                        });
                    }, l = 0, u = c.globals.series.length - 1; l < c.globals.series.length; l++, u--)A(l, u);
                }
            },
            {
                key: "getFormatters",
                value: function(e) {
                    var t, i = this.w, a = i.globals.yLabelFormatters[e];
                    return i.globals.ttVal !== void 0 ? Array.isArray(i.globals.ttVal) ? (a = i.globals.ttVal[e] && i.globals.ttVal[e].formatter, t = i.globals.ttVal[e] && i.globals.ttVal[e].title && i.globals.ttVal[e].title.formatter) : (a = i.globals.ttVal.formatter, typeof i.globals.ttVal.title.formatter == "function" && (t = i.globals.ttVal.title.formatter)) : t = i.config.tooltip.y.title.formatter, typeof a != "function" && (a = i.globals.yLabelFormatters[0] ? i.globals.yLabelFormatters[0] : function(s) {
                        return s;
                    }), typeof t != "function" && (t = function(s) {
                        return s;
                    }), {
                        yLbFormatter: a,
                        yLbTitleFormatter: t
                    };
                }
            },
            {
                key: "getSeriesName",
                value: function(e) {
                    var t = e.fn, i = e.index, a = e.seriesIndex, s = e.j, r = this.w;
                    return t(String(r.globals.seriesNames[i]), {
                        series: r.globals.series,
                        seriesIndex: a,
                        dataPointIndex: s,
                        w: r
                    });
                }
            },
            {
                key: "DOMHandling",
                value: function(e) {
                    e.i;
                    var t = e.t, i = e.j, a = e.ttItems, s = e.values, r = e.seriesName, n = e.shared, o = e.pColor, h = this.w, c = this.ttCtx, d = s.val, g = s.goalVals, p = s.xVal, f = s.xAxisTTVal, b = s.zVal, m = null;
                    m = a[t].children, h.config.tooltip.fillSeriesColor && (a[t].style.backgroundColor = o, m[0].style.display = "none"), c.showTooltipTitle && (c.tooltipTitle === null && (c.tooltipTitle = h.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")), c.tooltipTitle.innerHTML = p), c.isXAxisTooltipEnabled && (c.xaxisTooltipText.innerHTML = f !== "" ? f : p);
                    var w = a[t].querySelector(".apexcharts-tooltip-text-y-label");
                    w && (w.innerHTML = r || "");
                    var A = a[t].querySelector(".apexcharts-tooltip-text-y-value");
                    A && (A.innerHTML = d !== void 0 ? d : ""), m[0] && m[0].classList.contains("apexcharts-tooltip-marker") && (h.config.tooltip.marker.fillColors && Array.isArray(h.config.tooltip.marker.fillColors) && (o = h.config.tooltip.marker.fillColors[t]), m[0].style.backgroundColor = o), h.config.tooltip.marker.show || (m[0].style.display = "none");
                    var l = a[t].querySelector(".apexcharts-tooltip-text-goals-label"), u = a[t].querySelector(".apexcharts-tooltip-text-goals-value");
                    if (g.length && h.globals.seriesGoals[t]) {
                        var x = function() {
                            var S = "<div >", C = "<div>";
                            g.forEach(function(L, I) {
                                S += ' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(L.attrs.strokeColor, '; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(L.attrs.name, "</div>"), C += "<div>".concat(L.val, "</div>");
                            }), l.innerHTML = S + "</div>", u.innerHTML = C + "</div>";
                        };
                        n ? h.globals.seriesGoals[t][i] && Array.isArray(h.globals.seriesGoals[t][i]) ? x() : (l.innerHTML = "", u.innerHTML = "") : x();
                    } else l.innerHTML = "", u.innerHTML = "";
                    if (b !== null && (a[t].querySelector(".apexcharts-tooltip-text-z-label").innerHTML = h.config.tooltip.z.title, a[t].querySelector(".apexcharts-tooltip-text-z-value").innerHTML = b !== void 0 ? b : ""), n && m[0]) {
                        if (h.config.tooltip.hideEmptySeries) {
                            var v = a[t].querySelector(".apexcharts-tooltip-marker"), k = a[t].querySelector(".apexcharts-tooltip-text");
                            parseFloat(d) == 0 ? (v.style.display = "none", k.style.display = "none") : (v.style.display = "block", k.style.display = "block");
                        }
                        d == null || h.globals.ancillaryCollapsedSeriesIndices.indexOf(t) > -1 || h.globals.collapsedSeriesIndices.indexOf(t) > -1 ? m[0].parentNode.style.display = "none" : m[0].parentNode.style.display = h.config.tooltip.items.display;
                    }
                }
            },
            {
                key: "toggleActiveInactiveSeries",
                value: function(e) {
                    var t = this.w;
                    if (e) this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");
                    else {
                        this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");
                        var i = t.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group");
                        i && (i.classList.add("apexcharts-active"), i.style.display = t.config.tooltip.items.display);
                    }
                }
            },
            {
                key: "getValuesToPrint",
                value: function(e) {
                    var t = e.i, i = e.j, a = this.w, s = this.ctx.series.filteredSeriesX(), r = "", n = "", o = null, h = null, c = {
                        series: a.globals.series,
                        seriesIndex: t,
                        dataPointIndex: i,
                        w: a
                    }, d = a.globals.ttZFormatter;
                    i === null ? h = a.globals.series[t] : a.globals.isXNumeric && a.config.chart.type !== "treemap" ? (r = s[t][i], s[t].length === 0 && (r = s[this.tooltipUtil.getFirstActiveXArray(s)][i])) : r = a.globals.labels[i] !== void 0 ? a.globals.labels[i] : "";
                    var g = r;
                    return a.globals.isXNumeric && a.config.xaxis.type === "datetime" ? r = new re(this.ctx).xLabelFormat(a.globals.ttKeyFormatter, g, g, {
                        i: void 0,
                        dateFormatter: new B(this.ctx).formatDate,
                        w: this.w
                    }) : r = a.globals.isBarHorizontal ? a.globals.yLabelFormatters[0](g, c) : a.globals.xLabelFormatter(g, c), a.config.tooltip.x.formatter !== void 0 && (r = a.globals.ttKeyFormatter(g, c)), a.globals.seriesZ.length > 0 && a.globals.seriesZ[t].length > 0 && (o = d(a.globals.seriesZ[t][i], a)), n = typeof a.config.xaxis.tooltip.formatter == "function" ? a.globals.xaxisTooltipFormatter(g, c) : r, {
                        val: Array.isArray(h) ? h.join(" ") : h,
                        xVal: Array.isArray(r) ? r.join(" ") : r,
                        xAxisTTVal: Array.isArray(n) ? n.join(" ") : n,
                        zVal: o
                    };
                }
            },
            {
                key: "handleCustomTooltip",
                value: function(e) {
                    var t = e.i, i = e.j, a = e.y1, s = e.y2, r = e.w, n = this.ttCtx.getElTooltip(), o = r.config.tooltip.custom;
                    Array.isArray(o) && o[t] && (o = o[t]), n.innerHTML = o({
                        ctx: this.ctx,
                        series: r.globals.series,
                        seriesIndex: t,
                        dataPointIndex: i,
                        y1: a,
                        y2: s,
                        w: r
                    });
                }
            }
        ]), y;
    }(), it = function() {
        function y(e) {
            F(this, y), this.ttCtx = e, this.ctx = e.ctx, this.w = e.w;
        }
        return Y(y, [
            {
                key: "moveXCrosshairs",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, i = this.ttCtx, a = this.w, s = i.getElXCrosshairs(), r = e - i.xcrosshairsWidth / 2, n = a.globals.labels.slice().length;
                    if (t !== null && (r = a.globals.gridWidth / n * t), s === null || a.globals.isBarHorizontal || (s.setAttribute("x", r), s.setAttribute("x1", r), s.setAttribute("x2", r), s.setAttribute("y2", a.globals.gridHeight), s.classList.add("apexcharts-active")), r < 0 && (r = 0), r > a.globals.gridWidth && (r = a.globals.gridWidth), i.isXAxisTooltipEnabled) {
                        var o = r;
                        a.config.xaxis.crosshairs.width !== "tickWidth" && a.config.xaxis.crosshairs.width !== "barWidth" || (o = r + i.xcrosshairsWidth / 2), this.moveXAxisTooltip(o);
                    }
                }
            },
            {
                key: "moveYCrosshairs",
                value: function(e) {
                    var t = this.ttCtx;
                    t.ycrosshairs !== null && M.setAttrs(t.ycrosshairs, {
                        y1: e,
                        y2: e
                    }), t.ycrosshairsHidden !== null && M.setAttrs(t.ycrosshairsHidden, {
                        y1: e,
                        y2: e
                    });
                }
            },
            {
                key: "moveXAxisTooltip",
                value: function(e) {
                    var t = this.w, i = this.ttCtx;
                    if (i.xaxisTooltip !== null && i.xcrosshairsWidth !== 0) {
                        i.xaxisTooltip.classList.add("apexcharts-active");
                        var a = i.xaxisOffY + t.config.xaxis.tooltip.offsetY + t.globals.translateY + 1 + t.config.xaxis.offsetY;
                        if (e -= i.xaxisTooltip.getBoundingClientRect().width / 2, !isNaN(e)) {
                            e += t.globals.translateX;
                            var s;
                            s = new M(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML), i.xaxisTooltipText.style.minWidth = s.width + "px", i.xaxisTooltip.style.left = e + "px", i.xaxisTooltip.style.top = a + "px";
                        }
                    }
                }
            },
            {
                key: "moveYAxisTooltip",
                value: function(e) {
                    var t = this.w, i = this.ttCtx;
                    i.yaxisTTEls === null && (i.yaxisTTEls = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                    var a = parseInt(i.ycrosshairsHidden.getAttribute("y1"), 10), s = t.globals.translateY + a, r = i.yaxisTTEls[e].getBoundingClientRect().height, n = t.globals.translateYAxisX[e] - 2;
                    t.config.yaxis[e].opposite && (n -= 26), s -= r / 2, t.globals.ignoreYAxisIndexes.indexOf(e) === -1 ? (i.yaxisTTEls[e].classList.add("apexcharts-active"), i.yaxisTTEls[e].style.top = s + "px", i.yaxisTTEls[e].style.left = n + t.config.yaxis[e].tooltip.offsetX + "px") : i.yaxisTTEls[e].classList.remove("apexcharts-active");
                }
            },
            {
                key: "moveTooltip",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, a = this.w, s = this.ttCtx, r = s.getElTooltip(), n = s.tooltipRect, o = i !== null ? parseFloat(i) : 1, h = parseFloat(e) + o + 5, c = parseFloat(t) + o / 2;
                    if (h > a.globals.gridWidth / 2 && (h = h - n.ttWidth - o - 10), h > a.globals.gridWidth - n.ttWidth - 10 && (h = a.globals.gridWidth - n.ttWidth), h < -20 && (h = -20), a.config.tooltip.followCursor) {
                        var d = s.getElGrid().getBoundingClientRect();
                        (h = s.e.clientX - d.left) > a.globals.gridWidth / 2 && (h -= s.tooltipRect.ttWidth), (c = s.e.clientY + a.globals.translateY - d.top) > a.globals.gridHeight / 2 && (c -= s.tooltipRect.ttHeight);
                    } else a.globals.isBarHorizontal || n.ttHeight / 2 + c > a.globals.gridHeight && (c = a.globals.gridHeight - n.ttHeight + a.globals.translateY);
                    isNaN(h) || (h += a.globals.translateX, r.style.left = h + "px", r.style.top = c + "px");
                }
            },
            {
                key: "moveMarkers",
                value: function(e, t) {
                    var i = this.w, a = this.ttCtx;
                    if (i.globals.markers.size[e] > 0) for(var s = i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-marker")), r = 0; r < s.length; r++)parseInt(s[r].getAttribute("rel"), 10) === t && (a.marker.resetPointsSize(), a.marker.enlargeCurrentPoint(t, s[r]));
                    else a.marker.resetPointsSize(), this.moveDynamicPointOnHover(t, e);
                }
            },
            {
                key: "moveDynamicPointOnHover",
                value: function(e, t) {
                    var i, a, s = this.w, r = this.ttCtx, n = s.globals.pointsArray, o = r.tooltipUtil.getHoverMarkerSize(t), h = s.config.series[t].type;
                    if (!h || h !== "column" && h !== "candlestick" && h !== "boxPlot") {
                        i = n[t][e][0], a = n[t][e][1] ? n[t][e][1] : 0;
                        var c = s.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-series-markers circle"));
                        c && a < s.globals.gridHeight && a > 0 && (c.setAttribute("r", o), c.setAttribute("cx", i), c.setAttribute("cy", a)), this.moveXCrosshairs(i), r.fixedTooltip || this.moveTooltip(i, a, o);
                    }
                }
            },
            {
                key: "moveDynamicPointsOnHover",
                value: function(e) {
                    var t, i = this.ttCtx, a = i.w, s = 0, r = 0, n = a.globals.pointsArray;
                    t = new te(this.ctx).getActiveConfigSeriesIndex("asc", [
                        "line",
                        "area",
                        "scatter",
                        "bubble"
                    ]);
                    var o = i.tooltipUtil.getHoverMarkerSize(t);
                    n[t] && (s = n[t][e][0], r = n[t][e][1]);
                    var h = i.tooltipUtil.getAllMarkers();
                    if (h !== null) for(var c = 0; c < a.globals.series.length; c++){
                        var d = n[c];
                        if (a.globals.comboCharts && d === void 0 && h.splice(c, 0, null), d && d.length) {
                            var g = n[c][e][1], p = void 0;
                            if (h[c].setAttribute("cx", s), a.config.chart.type === "rangeArea" && !a.globals.comboCharts) {
                                var f = e + a.globals.series[c].length;
                                p = n[c][f][1], g -= Math.abs(g - p) / 2;
                            }
                            g !== null && !isNaN(g) && g < a.globals.gridHeight + o && g + o > 0 ? (h[c] && h[c].setAttribute("r", o), h[c] && h[c].setAttribute("cy", g)) : h[c] && h[c].setAttribute("r", 0);
                        }
                    }
                    this.moveXCrosshairs(s), i.fixedTooltip || this.moveTooltip(s, r || a.globals.gridHeight, o);
                }
            },
            {
                key: "moveStickyTooltipOverBars",
                value: function(e, t) {
                    var i = this.w, a = this.ttCtx, s = i.globals.columnSeries ? i.globals.columnSeries.length : i.globals.series.length, r = s >= 2 && s % 2 == 0 ? Math.floor(s / 2) : Math.floor(s / 2) + 1;
                    i.globals.isBarHorizontal && (r = new te(this.ctx).getActiveConfigSeriesIndex("desc") + 1);
                    var n = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(r, "'] path[j='").concat(e, "'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(e, "'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(e, "'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(e, "']"));
                    n || typeof t != "number" || (n = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[data\\:realIndex='".concat(t, "'] path[j='").concat(e, `'],
        .apexcharts-candlestick-series .apexcharts-series[data\\:realIndex='`).concat(t, "'] path[j='").concat(e, `'],
        .apexcharts-boxPlot-series .apexcharts-series[data\\:realIndex='`).concat(t, "'] path[j='").concat(e, `'],
        .apexcharts-rangebar-series .apexcharts-series[data\\:realIndex='`).concat(t, "'] path[j='").concat(e, "']")));
                    var o = n ? parseFloat(n.getAttribute("cx")) : 0, h = n ? parseFloat(n.getAttribute("cy")) : 0, c = n ? parseFloat(n.getAttribute("barWidth")) : 0, d = a.getElGrid().getBoundingClientRect(), g = n && (n.classList.contains("apexcharts-candlestick-area") || n.classList.contains("apexcharts-boxPlot-area"));
                    i.globals.isXNumeric ? (n && !g && (o -= s % 2 != 0 ? c / 2 : 0), n && g && i.globals.comboCharts && (o -= c / 2)) : i.globals.isBarHorizontal || (o = a.xAxisTicksPositions[e - 1] + a.dataPointsDividedWidth / 2, isNaN(o) && (o = a.xAxisTicksPositions[e] - a.dataPointsDividedWidth / 2)), i.globals.isBarHorizontal ? h -= a.tooltipRect.ttHeight : i.config.tooltip.followCursor ? h = a.e.clientY - d.top - a.tooltipRect.ttHeight / 2 : h + a.tooltipRect.ttHeight + 15 > i.globals.gridHeight && (h = i.globals.gridHeight), i.globals.isBarHorizontal || this.moveXCrosshairs(o), a.fixedTooltip || this.moveTooltip(o, h || i.globals.gridHeight);
                }
            }
        ]), y;
    }(), Tt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx, this.tooltipPosition = new it(e);
        }
        return Y(y, [
            {
                key: "drawDynamicPoints",
                value: function() {
                    var e = this.w, t = new M(this.ctx), i = new Pe(this.ctx), a = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                    a = J(a), e.config.chart.stacked && a.sort(function(d, g) {
                        return parseFloat(d.getAttribute("data:realIndex")) - parseFloat(g.getAttribute("data:realIndex"));
                    });
                    for(var s = 0; s < a.length; s++){
                        var r = a[s].querySelector(".apexcharts-series-markers-wrap");
                        if (r !== null) {
                            var n = void 0, o = "apexcharts-marker w".concat((Math.random() + 1).toString(36).substring(4));
                            e.config.chart.type !== "line" && e.config.chart.type !== "area" || e.globals.comboCharts || e.config.tooltip.intersect || (o += " no-pointer-events");
                            var h = i.getMarkerConfig({
                                cssClass: o,
                                seriesIndex: Number(r.getAttribute("data:realIndex"))
                            });
                            (n = t.drawMarker(0, 0, h)).node.setAttribute("default-marker-size", 0);
                            var c = document.createElementNS(e.globals.SVGNS, "g");
                            c.classList.add("apexcharts-series-markers"), c.appendChild(n.node), r.appendChild(c);
                        }
                    }
                }
            },
            {
                key: "enlargeCurrentPoint",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, s = this.w;
                    s.config.chart.type !== "bubble" && this.newPointSize(e, t);
                    var r = t.getAttribute("cx"), n = t.getAttribute("cy");
                    if (i !== null && a !== null && (r = i, n = a), this.tooltipPosition.moveXCrosshairs(r), !this.fixedTooltip) {
                        if (s.config.chart.type === "radar") {
                            var o = this.ttCtx.getElGrid().getBoundingClientRect();
                            r = this.ttCtx.e.clientX - o.left;
                        }
                        this.tooltipPosition.moveTooltip(r, n, s.config.markers.hover.size);
                    }
                }
            },
            {
                key: "enlargePoints",
                value: function(e) {
                    for(var t = this.w, i = this, a = this.ttCtx, s = e, r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), n = t.config.markers.hover.size, o = 0; o < r.length; o++){
                        var h = r[o].getAttribute("rel"), c = r[o].getAttribute("index");
                        if (n === void 0 && (n = t.globals.markers.size[c] + t.config.markers.hover.sizeOffset), s === parseInt(h, 10)) {
                            i.newPointSize(s, r[o]);
                            var d = r[o].getAttribute("cx"), g = r[o].getAttribute("cy");
                            i.tooltipPosition.moveXCrosshairs(d), a.fixedTooltip || i.tooltipPosition.moveTooltip(d, g, n);
                        } else i.oldPointSize(r[o]);
                    }
                }
            },
            {
                key: "newPointSize",
                value: function(e, t) {
                    var i = this.w, a = i.config.markers.hover.size, s = e === 0 ? t.parentNode.firstChild : t.parentNode.lastChild;
                    if (s.getAttribute("default-marker-size") !== "0") {
                        var r = parseInt(s.getAttribute("index"), 10);
                        a === void 0 && (a = i.globals.markers.size[r] + i.config.markers.hover.sizeOffset), a < 0 && (a = 0), s.setAttribute("r", a);
                    }
                }
            },
            {
                key: "oldPointSize",
                value: function(e) {
                    var t = parseFloat(e.getAttribute("default-marker-size"));
                    e.setAttribute("r", t);
                }
            },
            {
                key: "resetPointsSize",
                value: function() {
                    for(var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), t = 0; t < e.length; t++){
                        var i = parseFloat(e[t].getAttribute("default-marker-size"));
                        P.isNumber(i) && i >= 0 ? e[t].setAttribute("r", i) : e[t].setAttribute("r", 0);
                    }
                }
            }
        ]), y;
    }(), zt = function() {
        function y(e) {
            F(this, y), this.w = e.w;
            var t = this.w;
            this.ttCtx = e, this.isVerticalGroupedRangeBar = !t.globals.isBarHorizontal && t.config.chart.type === "rangeBar" && t.config.plotOptions.bar.rangeBarGroupRows;
        }
        return Y(y, [
            {
                key: "getAttr",
                value: function(e, t) {
                    return parseFloat(e.target.getAttribute(t));
                }
            },
            {
                key: "handleHeatTreeTooltip",
                value: function(e) {
                    var t = e.e, i = e.opt, a = e.x, s = e.y, r = e.type, n = this.ttCtx, o = this.w;
                    if (t.target.classList.contains("apexcharts-".concat(r, "-rect"))) {
                        var h = this.getAttr(t, "i"), c = this.getAttr(t, "j"), d = this.getAttr(t, "cx"), g = this.getAttr(t, "cy"), p = this.getAttr(t, "width"), f = this.getAttr(t, "height");
                        if (n.tooltipLabels.drawSeriesTexts({
                            ttItems: i.ttItems,
                            i: h,
                            j: c,
                            shared: !1,
                            e: t
                        }), o.globals.capturedSeriesIndex = h, o.globals.capturedDataPointIndex = c, a = d + n.tooltipRect.ttWidth / 2 + p, s = g + n.tooltipRect.ttHeight / 2 - f / 2, n.tooltipPosition.moveXCrosshairs(d + p / 2), a > o.globals.gridWidth / 2 && (a = d - n.tooltipRect.ttWidth / 2 + p), n.w.config.tooltip.followCursor) {
                            var b = o.globals.dom.elWrap.getBoundingClientRect();
                            a = o.globals.clientX - b.left - (a > o.globals.gridWidth / 2 ? n.tooltipRect.ttWidth : 0), s = o.globals.clientY - b.top - (s > o.globals.gridHeight / 2 ? n.tooltipRect.ttHeight : 0);
                        }
                    }
                    return {
                        x: a,
                        y: s
                    };
                }
            },
            {
                key: "handleMarkerTooltip",
                value: function(e) {
                    var t, i, a = e.e, s = e.opt, r = e.x, n = e.y, o = this.w, h = this.ttCtx;
                    if (a.target.classList.contains("apexcharts-marker")) {
                        var c = parseInt(s.paths.getAttribute("cx"), 10), d = parseInt(s.paths.getAttribute("cy"), 10), g = parseFloat(s.paths.getAttribute("val"));
                        if (i = parseInt(s.paths.getAttribute("rel"), 10), t = parseInt(s.paths.parentNode.parentNode.parentNode.getAttribute("rel"), 10) - 1, h.intersect) {
                            var p = P.findAncestor(s.paths, "apexcharts-series");
                            p && (t = parseInt(p.getAttribute("data:realIndex"), 10));
                        }
                        if (h.tooltipLabels.drawSeriesTexts({
                            ttItems: s.ttItems,
                            i: t,
                            j: i,
                            shared: !h.showOnIntersect && o.config.tooltip.shared,
                            e: a
                        }), a.type === "mouseup" && h.markerClick(a, t, i), o.globals.capturedSeriesIndex = t, o.globals.capturedDataPointIndex = i, r = c, n = d + o.globals.translateY - 1.4 * h.tooltipRect.ttHeight, h.w.config.tooltip.followCursor) {
                            var f = h.getElGrid().getBoundingClientRect();
                            n = h.e.clientY + o.globals.translateY - f.top;
                        }
                        g < 0 && (n = d), h.marker.enlargeCurrentPoint(i, s.paths, r, n);
                    }
                    return {
                        x: r,
                        y: n
                    };
                }
            },
            {
                key: "handleBarTooltip",
                value: function(e) {
                    var t, i, a = e.e, s = e.opt, r = this.w, n = this.ttCtx, o = n.getElTooltip(), h = 0, c = 0, d = 0, g = this.getBarTooltipXY({
                        e: a,
                        opt: s
                    });
                    t = g.i;
                    var p = g.barHeight, f = g.j;
                    r.globals.capturedSeriesIndex = t, r.globals.capturedDataPointIndex = f, r.globals.isBarHorizontal && n.tooltipUtil.hasBars() || !r.config.tooltip.shared ? (c = g.x, d = g.y, i = Array.isArray(r.config.stroke.width) ? r.config.stroke.width[t] : r.config.stroke.width, h = c) : r.globals.comboCharts || r.config.tooltip.shared || (h /= 2), isNaN(d) && (d = r.globals.svgHeight - n.tooltipRect.ttHeight);
                    var b = parseInt(s.paths.parentNode.getAttribute("data:realIndex"), 10), m = r.globals.isMultipleYAxis ? r.config.yaxis[b] && r.config.yaxis[b].reversed : r.config.yaxis[0].reversed;
                    if (c + n.tooltipRect.ttWidth > r.globals.gridWidth && !m ? c -= n.tooltipRect.ttWidth : c < 0 && (c = 0), n.w.config.tooltip.followCursor) {
                        var w = n.getElGrid().getBoundingClientRect();
                        d = n.e.clientY - w.top;
                    }
                    n.tooltip === null && (n.tooltip = r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")), r.config.tooltip.shared || (r.globals.comboBarCount > 0 ? n.tooltipPosition.moveXCrosshairs(h + i / 2) : n.tooltipPosition.moveXCrosshairs(h)), !n.fixedTooltip && (!r.config.tooltip.shared || r.globals.isBarHorizontal && n.tooltipUtil.hasBars()) && (m && (c -= n.tooltipRect.ttWidth) < 0 && (c = 0), !m || r.globals.isBarHorizontal && n.tooltipUtil.hasBars() || (d = d + p - 2 * (r.globals.series[t][f] < 0 ? p : 0)), d = d + r.globals.translateY - n.tooltipRect.ttHeight / 2, o.style.left = c + r.globals.translateX + "px", o.style.top = d + "px");
                }
            },
            {
                key: "getBarTooltipXY",
                value: function(e) {
                    var t = this, i = e.e, a = e.opt, s = this.w, r = null, n = this.ttCtx, o = 0, h = 0, c = 0, d = 0, g = 0, p = i.target.classList;
                    if (p.contains("apexcharts-bar-area") || p.contains("apexcharts-candlestick-area") || p.contains("apexcharts-boxPlot-area") || p.contains("apexcharts-rangebar-area")) {
                        var f = i.target, b = f.getBoundingClientRect(), m = a.elGrid.getBoundingClientRect(), w = b.height;
                        g = b.height;
                        var A = b.width, l = parseInt(f.getAttribute("cx"), 10), u = parseInt(f.getAttribute("cy"), 10);
                        d = parseFloat(f.getAttribute("barWidth"));
                        var x = i.type === "touchmove" ? i.touches[0].clientX : i.clientX;
                        r = parseInt(f.getAttribute("j"), 10), o = parseInt(f.parentNode.getAttribute("rel"), 10) - 1;
                        var v = f.getAttribute("data-range-y1"), k = f.getAttribute("data-range-y2");
                        s.globals.comboCharts && (o = parseInt(f.parentNode.getAttribute("data:realIndex"), 10));
                        var S = function(L) {
                            return s.globals.isXNumeric ? l - A / 2 : t.isVerticalGroupedRangeBar ? l + A / 2 : l - n.dataPointsDividedWidth + A / 2;
                        }, C = function() {
                            return u - n.dataPointsDividedHeight + w / 2 - n.tooltipRect.ttHeight / 2;
                        };
                        n.tooltipLabels.drawSeriesTexts({
                            ttItems: a.ttItems,
                            i: o,
                            j: r,
                            y1: v ? parseInt(v, 10) : null,
                            y2: k ? parseInt(k, 10) : null,
                            shared: !n.showOnIntersect && s.config.tooltip.shared,
                            e: i
                        }), s.config.tooltip.followCursor ? s.globals.isBarHorizontal ? (h = x - m.left + 15, c = C()) : (h = S(), c = i.clientY - m.top - n.tooltipRect.ttHeight / 2 - 15) : s.globals.isBarHorizontal ? ((h = l) < n.xyRatios.baseLineInvertedY && (h = l - n.tooltipRect.ttWidth), c = C()) : (h = S(), c = u);
                    }
                    return {
                        x: h,
                        y: c,
                        barHeight: g,
                        barWidth: d,
                        i: o,
                        j: r
                    };
                }
            }
        ]), y;
    }(), Mt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.ttCtx = e;
        }
        return Y(y, [
            {
                key: "drawXaxisTooltip",
                value: function() {
                    var e = this.w, t = this.ttCtx, i = e.config.xaxis.position === "bottom";
                    t.xaxisOffY = i ? e.globals.gridHeight + 1 : -e.globals.xAxisHeight - e.config.xaxis.axisTicks.height + 3;
                    var a = i ? "apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom" : "apexcharts-xaxistooltip apexcharts-xaxistooltip-top", s = e.globals.dom.elWrap;
                    t.isXAxisTooltipEnabled && e.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip") === null && (t.xaxisTooltip = document.createElement("div"), t.xaxisTooltip.setAttribute("class", a + " apexcharts-theme-" + e.config.tooltip.theme), s.appendChild(t.xaxisTooltip), t.xaxisTooltipText = document.createElement("div"), t.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"), t.xaxisTooltipText.style.fontFamily = e.config.xaxis.tooltip.style.fontFamily || e.config.chart.fontFamily, t.xaxisTooltipText.style.fontSize = e.config.xaxis.tooltip.style.fontSize, t.xaxisTooltip.appendChild(t.xaxisTooltipText));
                }
            },
            {
                key: "drawYaxisTooltip",
                value: function() {
                    for(var e = this.w, t = this.ttCtx, i = function(s) {
                        var r = e.config.yaxis[s].opposite || e.config.yaxis[s].crosshairs.opposite;
                        t.yaxisOffX = r ? e.globals.gridWidth + 1 : 1;
                        var n = "apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(s, r ? " apexcharts-yaxistooltip-right" : " apexcharts-yaxistooltip-left");
                        e.globals.yAxisSameScaleIndices.map(function(h, c) {
                            h.map(function(d, g) {
                                g === s && (n += e.config.yaxis[g].show ? " " : " apexcharts-yaxistooltip-hidden");
                            });
                        });
                        var o = e.globals.dom.elWrap;
                        e.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(s)) === null && (t.yaxisTooltip = document.createElement("div"), t.yaxisTooltip.setAttribute("class", n + " apexcharts-theme-" + e.config.tooltip.theme), o.appendChild(t.yaxisTooltip), s === 0 && (t.yaxisTooltipText = []), t.yaxisTooltipText[s] = document.createElement("div"), t.yaxisTooltipText[s].classList.add("apexcharts-yaxistooltip-text"), t.yaxisTooltip.appendChild(t.yaxisTooltipText[s]));
                    }, a = 0; a < e.config.yaxis.length; a++)i(a);
                }
            },
            {
                key: "setXCrosshairWidth",
                value: function() {
                    var e = this.w, t = this.ttCtx, i = t.getElXCrosshairs();
                    if (t.xcrosshairsWidth = parseInt(e.config.xaxis.crosshairs.width, 10), e.globals.comboCharts) {
                        var a = e.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                        if (a !== null && e.config.xaxis.crosshairs.width === "barWidth") {
                            var s = parseFloat(a.getAttribute("barWidth"));
                            t.xcrosshairsWidth = s;
                        } else if (e.config.xaxis.crosshairs.width === "tickWidth") {
                            var r = e.globals.labels.length;
                            t.xcrosshairsWidth = e.globals.gridWidth / r;
                        }
                    } else if (e.config.xaxis.crosshairs.width === "tickWidth") {
                        var n = e.globals.labels.length;
                        t.xcrosshairsWidth = e.globals.gridWidth / n;
                    } else if (e.config.xaxis.crosshairs.width === "barWidth") {
                        var o = e.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                        if (o !== null) {
                            var h = parseFloat(o.getAttribute("barWidth"));
                            t.xcrosshairsWidth = h;
                        } else t.xcrosshairsWidth = 1;
                    }
                    e.globals.isBarHorizontal && (t.xcrosshairsWidth = 0), i !== null && t.xcrosshairsWidth > 0 && i.setAttribute("width", t.xcrosshairsWidth);
                }
            },
            {
                key: "handleYCrosshair",
                value: function() {
                    var e = this.w, t = this.ttCtx;
                    t.ycrosshairs = e.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"), t.ycrosshairsHidden = e.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden");
                }
            },
            {
                key: "drawYaxisTooltipText",
                value: function(e, t, i) {
                    var a = this.ttCtx, s = this.w, r = s.globals.yLabelFormatters[e];
                    if (a.yaxisTooltips[e]) {
                        var n = a.getElGrid().getBoundingClientRect(), o = (t - n.top) * i.yRatio[e], h = s.globals.maxYArr[e] - s.globals.minYArr[e], c = s.globals.minYArr[e] + (h - o);
                        a.tooltipPosition.moveYCrosshairs(t - n.top), a.yaxisTooltipText[e].innerHTML = r(c), a.tooltipPosition.moveYAxisTooltip(e);
                    }
                }
            }
        ]), y;
    }(), at = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
            var t = this.w;
            this.tConfig = t.config.tooltip, this.tooltipUtil = new tt(this), this.tooltipLabels = new It(this), this.tooltipPosition = new it(this), this.marker = new Tt(this), this.intersect = new zt(this), this.axesTooltip = new Mt(this), this.showOnIntersect = this.tConfig.intersect, this.showTooltipTitle = this.tConfig.x.show, this.fixedTooltip = this.tConfig.fixed.enabled, this.xaxisTooltip = null, this.yaxisTTEls = null, this.isBarShared = !t.globals.isBarHorizontal && this.tConfig.shared, this.lastHoverTime = Date.now();
        }
        return Y(y, [
            {
                key: "getElTooltip",
                value: function(e) {
                    return e || (e = this), e.w.globals.dom.baseEl ? e.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip") : null;
                }
            },
            {
                key: "getElXCrosshairs",
                value: function() {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs");
                }
            },
            {
                key: "getElGrid",
                value: function() {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid");
                }
            },
            {
                key: "drawTooltip",
                value: function(e) {
                    var t = this.w;
                    this.xyRatios = e, this.isXAxisTooltipEnabled = t.config.xaxis.tooltip.enabled && t.globals.axisCharts, this.yaxisTooltips = t.config.yaxis.map(function(r, n) {
                        return !!(r.show && r.tooltip.enabled && t.globals.axisCharts);
                    }), this.allTooltipSeriesGroups = [], t.globals.axisCharts || (this.showTooltipTitle = !1);
                    var i = document.createElement("div");
                    if (i.classList.add("apexcharts-tooltip"), t.config.tooltip.cssClass && i.classList.add(t.config.tooltip.cssClass), i.classList.add("apexcharts-theme-".concat(this.tConfig.theme)), t.globals.dom.elWrap.appendChild(i), t.globals.axisCharts) {
                        this.axesTooltip.drawXaxisTooltip(), this.axesTooltip.drawYaxisTooltip(), this.axesTooltip.setXCrosshairWidth(), this.axesTooltip.handleYCrosshair();
                        var a = new Ie(this.ctx);
                        this.xAxisTicksPositions = a.getXAxisTicksPositions();
                    }
                    if (!t.globals.comboCharts && !this.tConfig.intersect && t.config.chart.type !== "rangeBar" || this.tConfig.shared || (this.showOnIntersect = !0), t.config.markers.size !== 0 && t.globals.markers.largestSize !== 0 || this.marker.drawDynamicPoints(this), t.globals.collapsedSeries.length !== t.globals.series.length) {
                        this.dataPointsDividedHeight = t.globals.gridHeight / t.globals.dataPoints, this.dataPointsDividedWidth = t.globals.gridWidth / t.globals.dataPoints, this.showTooltipTitle && (this.tooltipTitle = document.createElement("div"), this.tooltipTitle.classList.add("apexcharts-tooltip-title"), this.tooltipTitle.style.fontFamily = this.tConfig.style.fontFamily || t.config.chart.fontFamily, this.tooltipTitle.style.fontSize = this.tConfig.style.fontSize, i.appendChild(this.tooltipTitle));
                        var s = t.globals.series.length;
                        (t.globals.xyCharts || t.globals.comboCharts) && this.tConfig.shared && (s = this.showOnIntersect ? 1 : t.globals.series.length), this.legendLabels = t.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"), this.ttItems = this.createTTElements(s), this.addSVGEvents();
                    }
                }
            },
            {
                key: "createTTElements",
                value: function(e) {
                    for(var t = this, i = this.w, a = [], s = this.getElTooltip(), r = function(o) {
                        var h = document.createElement("div");
                        h.classList.add("apexcharts-tooltip-series-group"), h.style.order = i.config.tooltip.inverseOrder ? e - o : o + 1, t.tConfig.shared && t.tConfig.enabledOnSeries && Array.isArray(t.tConfig.enabledOnSeries) && t.tConfig.enabledOnSeries.indexOf(o) < 0 && h.classList.add("apexcharts-tooltip-series-group-hidden");
                        var c = document.createElement("span");
                        c.classList.add("apexcharts-tooltip-marker"), c.style.backgroundColor = i.globals.colors[o], h.appendChild(c);
                        var d = document.createElement("div");
                        d.classList.add("apexcharts-tooltip-text"), d.style.fontFamily = t.tConfig.style.fontFamily || i.config.chart.fontFamily, d.style.fontSize = t.tConfig.style.fontSize, [
                            "y",
                            "goals",
                            "z"
                        ].forEach(function(g) {
                            var p = document.createElement("div");
                            p.classList.add("apexcharts-tooltip-".concat(g, "-group"));
                            var f = document.createElement("span");
                            f.classList.add("apexcharts-tooltip-text-".concat(g, "-label")), p.appendChild(f);
                            var b = document.createElement("span");
                            b.classList.add("apexcharts-tooltip-text-".concat(g, "-value")), p.appendChild(b), d.appendChild(p);
                        }), h.appendChild(d), s.appendChild(h), a.push(h);
                    }, n = 0; n < e; n++)r(n);
                    return a;
                }
            },
            {
                key: "addSVGEvents",
                value: function() {
                    var e = this.w, t = e.config.chart.type, i = this.getElTooltip(), a = !(t !== "bar" && t !== "candlestick" && t !== "boxPlot" && t !== "rangeBar"), s = t === "area" || t === "line" || t === "scatter" || t === "bubble" || t === "radar", r = e.globals.dom.Paper.node, n = this.getElGrid();
                    n && (this.seriesBound = n.getBoundingClientRect());
                    var o, h = [], c = [], d = {
                        hoverArea: r,
                        elGrid: n,
                        tooltipEl: i,
                        tooltipY: h,
                        tooltipX: c,
                        ttItems: this.ttItems
                    };
                    if (e.globals.axisCharts && (s ? o = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker") : a ? o = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area") : t !== "heatmap" && t !== "treemap" || (o = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")), o && o.length)) for(var g = 0; g < o.length; g++)h.push(o[g].getAttribute("cy")), c.push(o[g].getAttribute("cx"));
                    if (e.globals.xyCharts && !this.showOnIntersect || e.globals.comboCharts && !this.showOnIntersect || a && this.tooltipUtil.hasBars() && this.tConfig.shared) this.addPathsEventListeners([
                        r
                    ], d);
                    else if (a && !e.globals.comboCharts || s && this.showOnIntersect) this.addDatapointEventsListeners(d);
                    else if (!e.globals.axisCharts || t === "heatmap" || t === "treemap") {
                        var p = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                        this.addPathsEventListeners(p, d);
                    }
                    if (this.showOnIntersect) {
                        var f = e.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");
                        f.length > 0 && this.addPathsEventListeners(f, d), this.tooltipUtil.hasBars() && !this.tConfig.shared && this.addDatapointEventsListeners(d);
                    }
                }
            },
            {
                key: "drawFixedTooltipRect",
                value: function() {
                    var e = this.w, t = this.getElTooltip(), i = t.getBoundingClientRect(), a = i.width + 10, s = i.height + 10, r = this.tConfig.fixed.offsetX, n = this.tConfig.fixed.offsetY, o = this.tConfig.fixed.position.toLowerCase();
                    return o.indexOf("right") > -1 && (r = r + e.globals.svgWidth - a + 10), o.indexOf("bottom") > -1 && (n = n + e.globals.svgHeight - s - 10), t.style.left = r + "px", t.style.top = n + "px", {
                        x: r,
                        y: n,
                        ttWidth: a,
                        ttHeight: s
                    };
                }
            },
            {
                key: "addDatapointEventsListeners",
                value: function(e) {
                    var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");
                    this.addPathsEventListeners(t, e);
                }
            },
            {
                key: "addPathsEventListeners",
                value: function(e, t) {
                    for(var i = this, a = function(r) {
                        var n = {
                            paths: e[r],
                            tooltipEl: t.tooltipEl,
                            tooltipY: t.tooltipY,
                            tooltipX: t.tooltipX,
                            elGrid: t.elGrid,
                            hoverArea: t.hoverArea,
                            ttItems: t.ttItems
                        };
                        [
                            "mousemove",
                            "mouseup",
                            "touchmove",
                            "mouseout",
                            "touchend"
                        ].map(function(o) {
                            return e[r].addEventListener(o, i.onSeriesHover.bind(i, n), {
                                capture: !1,
                                passive: !0
                            });
                        });
                    }, s = 0; s < e.length; s++)a(s);
                }
            },
            {
                key: "onSeriesHover",
                value: function(e, t) {
                    var i = this, a = Date.now() - this.lastHoverTime;
                    a >= 100 ? this.seriesHover(e, t) : (clearTimeout(this.seriesHoverTimeout), this.seriesHoverTimeout = setTimeout(function() {
                        i.seriesHover(e, t);
                    }, 100 - a));
                }
            },
            {
                key: "seriesHover",
                value: function(e, t) {
                    var i = this;
                    this.lastHoverTime = Date.now();
                    var a = [], s = this.w;
                    s.config.chart.group && (a = this.ctx.getGroupedCharts()), s.globals.axisCharts && (s.globals.minX === -1 / 0 && s.globals.maxX === 1 / 0 || s.globals.dataPoints === 0) || (a.length ? a.forEach(function(r) {
                        var n = i.getElTooltip(r), o = {
                            paths: e.paths,
                            tooltipEl: n,
                            tooltipY: e.tooltipY,
                            tooltipX: e.tooltipX,
                            elGrid: e.elGrid,
                            hoverArea: e.hoverArea,
                            ttItems: r.w.globals.tooltip.ttItems
                        };
                        r.w.globals.minX === i.w.globals.minX && r.w.globals.maxX === i.w.globals.maxX && r.w.globals.tooltip.seriesHoverByContext({
                            chartCtx: r,
                            ttCtx: r.w.globals.tooltip,
                            opt: o,
                            e: t
                        });
                    }) : this.seriesHoverByContext({
                        chartCtx: this.ctx,
                        ttCtx: this.w.globals.tooltip,
                        opt: e,
                        e: t
                    }));
                }
            },
            {
                key: "seriesHoverByContext",
                value: function(e) {
                    var t = e.chartCtx, i = e.ttCtx, a = e.opt, s = e.e, r = t.w, n = this.getElTooltip();
                    n && (i.tooltipRect = {
                        x: 0,
                        y: 0,
                        ttWidth: n.getBoundingClientRect().width,
                        ttHeight: n.getBoundingClientRect().height
                    }, i.e = s, i.tooltipUtil.hasBars() && !r.globals.comboCharts && !i.isBarShared && this.tConfig.onDatasetHover.highlightDataSeries && new te(t).toggleSeriesOnHover(s, s.target.parentNode), i.fixedTooltip && i.drawFixedTooltipRect(), r.globals.axisCharts ? i.axisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    }) : i.nonAxisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    }));
                }
            },
            {
                key: "axisChartsTooltips",
                value: function(e) {
                    var t, i, a = e.e, s = e.opt, r = this.w, n = s.elGrid.getBoundingClientRect(), o = a.type === "touchmove" ? a.touches[0].clientX : a.clientX, h = a.type === "touchmove" ? a.touches[0].clientY : a.clientY;
                    if (this.clientY = h, this.clientX = o, r.globals.capturedSeriesIndex = -1, r.globals.capturedDataPointIndex = -1, h < n.top || h > n.top + n.height) this.handleMouseOut(s);
                    else {
                        if (Array.isArray(this.tConfig.enabledOnSeries) && !r.config.tooltip.shared) {
                            var c = parseInt(s.paths.getAttribute("index"), 10);
                            if (this.tConfig.enabledOnSeries.indexOf(c) < 0) return void this.handleMouseOut(s);
                        }
                        var d = this.getElTooltip(), g = this.getElXCrosshairs(), p = r.globals.xyCharts || r.config.chart.type === "bar" && !r.globals.isBarHorizontal && this.tooltipUtil.hasBars() && this.tConfig.shared || r.globals.comboCharts && this.tooltipUtil.hasBars();
                        if (a.type === "mousemove" || a.type === "touchmove" || a.type === "mouseup") {
                            if (r.globals.collapsedSeries.length + r.globals.ancillaryCollapsedSeries.length === r.globals.series.length) return;
                            g !== null && g.classList.add("apexcharts-active");
                            var f = this.yaxisTooltips.filter(function(w) {
                                return w === !0;
                            });
                            if (this.ycrosshairs !== null && f.length && this.ycrosshairs.classList.add("apexcharts-active"), p && !this.showOnIntersect) this.handleStickyTooltip(a, o, h, s);
                            else if (r.config.chart.type === "heatmap" || r.config.chart.type === "treemap") {
                                var b = this.intersect.handleHeatTreeTooltip({
                                    e: a,
                                    opt: s,
                                    x: t,
                                    y: i,
                                    type: r.config.chart.type
                                });
                                t = b.x, i = b.y, d.style.left = t + "px", d.style.top = i + "px";
                            } else this.tooltipUtil.hasBars() && this.intersect.handleBarTooltip({
                                e: a,
                                opt: s
                            }), this.tooltipUtil.hasMarkers() && this.intersect.handleMarkerTooltip({
                                e: a,
                                opt: s,
                                x: t,
                                y: i
                            });
                            if (this.yaxisTooltips.length) for(var m = 0; m < r.config.yaxis.length; m++)this.axesTooltip.drawYaxisTooltipText(m, h, this.xyRatios);
                            s.tooltipEl.classList.add("apexcharts-active");
                        } else a.type !== "mouseout" && a.type !== "touchend" || this.handleMouseOut(s);
                    }
                }
            },
            {
                key: "nonAxisChartsTooltips",
                value: function(e) {
                    var t = e.e, i = e.opt, a = e.tooltipRect, s = this.w, r = i.paths.getAttribute("rel"), n = this.getElTooltip(), o = s.globals.dom.elWrap.getBoundingClientRect();
                    if (t.type === "mousemove" || t.type === "touchmove") {
                        n.classList.add("apexcharts-active"), this.tooltipLabels.drawSeriesTexts({
                            ttItems: i.ttItems,
                            i: parseInt(r, 10) - 1,
                            shared: !1
                        });
                        var h = s.globals.clientX - o.left - a.ttWidth / 2, c = s.globals.clientY - o.top - a.ttHeight - 10;
                        if (n.style.left = h + "px", n.style.top = c + "px", s.config.legend.tooltipHoverFormatter) {
                            var d = r - 1, g = (0, s.config.legend.tooltipHoverFormatter)(this.legendLabels[d].getAttribute("data:default-text"), {
                                seriesIndex: d,
                                dataPointIndex: d,
                                w: s
                            });
                            this.legendLabels[d].innerHTML = g;
                        }
                    } else t.type !== "mouseout" && t.type !== "touchend" || (n.classList.remove("apexcharts-active"), s.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(p) {
                        var f = p.getAttribute("data:default-text");
                        p.innerHTML = decodeURIComponent(f);
                    }));
                }
            },
            {
                key: "handleStickyTooltip",
                value: function(e, t, i, a) {
                    var s = this.w, r = this.tooltipUtil.getNearestValues({
                        context: this,
                        hoverArea: a.hoverArea,
                        elGrid: a.elGrid,
                        clientX: t,
                        clientY: i
                    }), n = r.j, o = r.capturedSeries;
                    s.globals.collapsedSeriesIndices.includes(o) && (o = null);
                    var h = a.elGrid.getBoundingClientRect();
                    if (r.hoverX < 0 || r.hoverX > h.width) this.handleMouseOut(a);
                    else if (o !== null) this.handleStickyCapturedSeries(e, o, a, n);
                    else if (this.tooltipUtil.isXoverlap(n) || s.globals.isBarHorizontal) {
                        var c = s.globals.series.findIndex(function(d, g) {
                            return !s.globals.collapsedSeriesIndices.includes(g);
                        });
                        this.create(e, this, c, n, a.ttItems);
                    }
                }
            },
            {
                key: "handleStickyCapturedSeries",
                value: function(e, t, i, a) {
                    var s = this.w;
                    if (!this.tConfig.shared && s.globals.series[t][a] === null) return void this.handleMouseOut(i);
                    if (s.globals.series[t][a] !== void 0) this.tConfig.shared && this.tooltipUtil.isXoverlap(a) && this.tooltipUtil.isInitialSeriesSameLen() ? this.create(e, this, t, a, i.ttItems) : this.create(e, this, t, a, i.ttItems, !1);
                    else if (this.tooltipUtil.isXoverlap(a)) {
                        var r = s.globals.series.findIndex(function(n, o) {
                            return !s.globals.collapsedSeriesIndices.includes(o);
                        });
                        this.create(e, this, r, a, i.ttItems);
                    }
                }
            },
            {
                key: "deactivateHoverFilter",
                value: function() {
                    for(var e = this.w, t = new M(this.ctx), i = e.globals.dom.Paper.select(".apexcharts-bar-area"), a = 0; a < i.length; a++)t.pathMouseLeave(i[a]);
                }
            },
            {
                key: "handleMouseOut",
                value: function(e) {
                    var t = this.w, i = this.getElXCrosshairs();
                    if (e.tooltipEl.classList.remove("apexcharts-active"), this.deactivateHoverFilter(), t.config.chart.type !== "bubble" && this.marker.resetPointsSize(), i !== null && i.classList.remove("apexcharts-active"), this.ycrosshairs !== null && this.ycrosshairs.classList.remove("apexcharts-active"), this.isXAxisTooltipEnabled && this.xaxisTooltip.classList.remove("apexcharts-active"), this.yaxisTooltips.length) {
                        this.yaxisTTEls === null && (this.yaxisTTEls = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                        for(var a = 0; a < this.yaxisTTEls.length; a++)this.yaxisTTEls[a].classList.remove("apexcharts-active");
                    }
                    t.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(s) {
                        var r = s.getAttribute("data:default-text");
                        s.innerHTML = decodeURIComponent(r);
                    });
                }
            },
            {
                key: "markerClick",
                value: function(e, t, i) {
                    var a = this.w;
                    typeof a.config.chart.events.markerClick == "function" && a.config.chart.events.markerClick(e, this.ctx, {
                        seriesIndex: t,
                        dataPointIndex: i,
                        w: a
                    }), this.ctx.events.fireEvent("markerClick", [
                        e,
                        this.ctx,
                        {
                            seriesIndex: t,
                            dataPointIndex: i,
                            w: a
                        }
                    ]);
                }
            },
            {
                key: "create",
                value: function(e, t, i, a, s) {
                    var r, n, o, h, c, d, g, p, f, b, m, w, A, l, u, x, v = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, k = this.w, S = t;
                    e.type === "mouseup" && this.markerClick(e, i, a), v === null && (v = this.tConfig.shared);
                    var C = this.tooltipUtil.hasMarkers(i), L = this.tooltipUtil.getElBars();
                    if (k.config.legend.tooltipHoverFormatter) {
                        var I = k.config.legend.tooltipHoverFormatter, z = Array.from(this.legendLabels);
                        z.forEach(function(se) {
                            var K = se.getAttribute("data:default-text");
                            se.innerHTML = decodeURIComponent(K);
                        });
                        for(var T = 0; T < z.length; T++){
                            var E = z[T], R = parseInt(E.getAttribute("i"), 10), O = decodeURIComponent(E.getAttribute("data:default-text")), D = I(O, {
                                seriesIndex: v ? R : i,
                                dataPointIndex: a,
                                w: k
                            });
                            if (v) E.innerHTML = k.globals.collapsedSeriesIndices.indexOf(R) < 0 ? D : O;
                            else if (E.innerHTML = R === i ? D : O, i === R) break;
                        }
                    }
                    var W = X(X({
                        ttItems: s,
                        i: i,
                        j: a
                    }, ((r = k.globals.seriesRange) === null || r === void 0 || (n = r[i]) === null || n === void 0 || (o = n[a]) === null || o === void 0 || (h = o.y[0]) === null || h === void 0 ? void 0 : h.y1) !== void 0 && {
                        y1: (c = k.globals.seriesRange) === null || c === void 0 || (d = c[i]) === null || d === void 0 || (g = d[a]) === null || g === void 0 || (p = g.y[0]) === null || p === void 0 ? void 0 : p.y1
                    }), ((f = k.globals.seriesRange) === null || f === void 0 || (b = f[i]) === null || b === void 0 || (m = b[a]) === null || m === void 0 || (w = m.y[0]) === null || w === void 0 ? void 0 : w.y2) !== void 0 && {
                        y2: (A = k.globals.seriesRange) === null || A === void 0 || (l = A[i]) === null || l === void 0 || (u = l[a]) === null || u === void 0 || (x = u.y[0]) === null || x === void 0 ? void 0 : x.y2
                    });
                    if (v) {
                        if (S.tooltipLabels.drawSeriesTexts(X(X({}, W), {}, {
                            shared: !this.showOnIntersect && this.tConfig.shared
                        })), C) k.globals.markers.largestSize > 0 ? S.marker.enlargePoints(a) : S.tooltipPosition.moveDynamicPointsOnHover(a);
                        else if (this.tooltipUtil.hasBars() && (this.barSeriesHeight = this.tooltipUtil.getBarsHeight(L), this.barSeriesHeight > 0)) {
                            var N = new M(this.ctx), V = k.globals.dom.Paper.select(".apexcharts-bar-area[j='".concat(a, "']"));
                            this.deactivateHoverFilter(), this.tooltipPosition.moveStickyTooltipOverBars(a, i);
                            for(var j = 0; j < V.length; j++)N.pathMouseEnter(V[j]);
                        }
                    } else S.tooltipLabels.drawSeriesTexts(X({
                        shared: !1
                    }, W)), this.tooltipUtil.hasBars() && S.tooltipPosition.moveStickyTooltipOverBars(a, i), C && S.tooltipPosition.moveMarkers(i, a);
                }
            }
        ]), y;
    }(), Xt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.barCtx = e, this.totalFormatter = this.w.config.plotOptions.bar.dataLabels.total.formatter, this.totalFormatter || (this.totalFormatter = this.w.config.dataLabels.formatter);
        }
        return Y(y, [
            {
                key: "handleBarDataLabels",
                value: function(e) {
                    var t = e.x, i = e.y, a = e.y1, s = e.y2, r = e.i, n = e.j, o = e.realIndex, h = e.groupIndex, c = e.series, d = e.barHeight, g = e.barWidth, p = e.barXPosition, f = e.barYPosition, b = e.visibleSeries, m = e.renderedPath, w = this.w, A = new M(this.barCtx.ctx), l = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[o] : this.barCtx.strokeWidth, u = t + parseFloat(g * b), x = i + parseFloat(d * b);
                    w.globals.isXNumeric && !w.globals.isBarHorizontal && (u = t + parseFloat(g * (b + 1)), x = i + parseFloat(d * (b + 1)) - l);
                    var v, k = null, S = t, C = i, L = {}, I = w.config.dataLabels, z = this.barCtx.barOptions.dataLabels, T = this.barCtx.barOptions.dataLabels.total;
                    f !== void 0 && this.barCtx.isRangeBar && (x = f, C = f), p !== void 0 && this.barCtx.isVerticalGroupedRangeBar && (u = p, S = p);
                    var E = I.offsetX, R = I.offsetY, O = {
                        width: 0,
                        height: 0
                    };
                    if (w.config.dataLabels.enabled) {
                        var D = this.barCtx.series[r][n];
                        O = A.getTextRects(w.globals.yLabelFormatters[0](D), parseFloat(I.style.fontSize));
                    }
                    var W = {
                        x: t,
                        y: i,
                        i: r,
                        j: n,
                        realIndex: o,
                        groupIndex: h || -1,
                        renderedPath: m,
                        bcx: u,
                        bcy: x,
                        barHeight: d,
                        barWidth: g,
                        textRects: O,
                        strokeWidth: l,
                        dataLabelsX: S,
                        dataLabelsY: C,
                        dataLabelsConfig: I,
                        barDataLabelsConfig: z,
                        barTotalDataLabelsConfig: T,
                        offX: E,
                        offY: R
                    };
                    return L = this.barCtx.isHorizontal ? this.calculateBarsDataLabelsPosition(W) : this.calculateColumnsDataLabelsPosition(W), m.attr({
                        cy: L.bcy,
                        cx: L.bcx,
                        j: n,
                        val: c[r][n],
                        barHeight: d,
                        barWidth: g
                    }), v = this.drawCalculatedDataLabels({
                        x: L.dataLabelsX,
                        y: L.dataLabelsY,
                        val: this.barCtx.isRangeBar ? [
                            a,
                            s
                        ] : c[r][n],
                        i: o,
                        j: n,
                        barWidth: g,
                        barHeight: d,
                        textRects: O,
                        dataLabelsConfig: I
                    }), w.config.chart.stacked && T.enabled && (k = this.drawTotalDataLabels({
                        x: L.totalDataLabelsX,
                        y: L.totalDataLabelsY,
                        barWidth: g,
                        barHeight: d,
                        realIndex: o,
                        textAnchor: L.totalDataLabelsAnchor,
                        val: this.getStackedTotalDataLabel({
                            realIndex: o,
                            j: n
                        }),
                        dataLabelsConfig: I,
                        barTotalDataLabelsConfig: T
                    })), {
                        dataLabels: v,
                        totalDataLabels: k
                    };
                }
            },
            {
                key: "getStackedTotalDataLabel",
                value: function(e) {
                    var t = e.realIndex, i = e.j, a = this.w, s = this.barCtx.stackedSeriesTotals[i];
                    return this.totalFormatter && (s = this.totalFormatter(s, X(X({}, a), {}, {
                        seriesIndex: t,
                        dataPointIndex: i,
                        w: a
                    }))), s;
                }
            },
            {
                key: "calculateColumnsDataLabelsPosition",
                value: function(e) {
                    var t, i, a = this.w, s = e.i, r = e.j, n = e.realIndex, o = e.groupIndex, h = e.y, c = e.bcx, d = e.barWidth, g = e.barHeight, p = e.textRects, f = e.dataLabelsX, b = e.dataLabelsY, m = e.dataLabelsConfig, w = e.barDataLabelsConfig, A = e.barTotalDataLabelsConfig, l = e.strokeWidth, u = e.offX, x = e.offY;
                    g = Math.abs(g);
                    var v = a.config.plotOptions.bar.dataLabels.orientation === "vertical", k = this.barCtx.barHelpers.getZeroValueEncounters({
                        i: s,
                        j: r
                    }).zeroEncounters;
                    c = c - l / 2 + (o !== -1 ? o * d : 0);
                    var S = a.globals.gridWidth / a.globals.dataPoints;
                    this.barCtx.isVerticalGroupedRangeBar ? f += d / 2 : (f = a.globals.isXNumeric ? c - d / 2 + u : c - S + d / 2 + u, k > 0 && a.config.plotOptions.bar.hideZeroBarsWhenGrouped && (f -= d * k)), v && (f = f + p.height / 2 - l / 2 - 2);
                    var C = this.barCtx.series[s][r] < 0, L = h;
                    switch(this.barCtx.isReversed && (L = h - g + (C ? 2 * g : 0), h -= g), w.position){
                        case "center":
                            b = v ? C ? L - g / 2 + x : L + g / 2 - x : C ? L - g / 2 + p.height / 2 + x : L + g / 2 + p.height / 2 - x;
                            break;
                        case "bottom":
                            b = v ? C ? L - g + x : L + g - x : C ? L - g + p.height + l + x : L + g - p.height / 2 + l - x;
                            break;
                        case "top":
                            b = v ? C ? L + x : L - x : C ? L - p.height / 2 - x : L + p.height + x;
                    }
                    if (this.barCtx.lastActiveBarSerieIndex === n && A.enabled) {
                        var I = new M(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                            realIndex: n,
                            j: r
                        }), m.fontSize);
                        t = C ? L - I.height / 2 - x - A.offsetY + 18 : L + I.height + x + A.offsetY - 18, i = f + A.offsetX;
                    }
                    return a.config.chart.stacked || (b < 0 ? b = 0 + l : b + p.height / 3 > a.globals.gridHeight && (b = a.globals.gridHeight - l)), {
                        bcx: c,
                        bcy: h,
                        dataLabelsX: f,
                        dataLabelsY: b,
                        totalDataLabelsX: i,
                        totalDataLabelsY: t,
                        totalDataLabelsAnchor: "middle"
                    };
                }
            },
            {
                key: "calculateBarsDataLabelsPosition",
                value: function(e) {
                    var t = this.w, i = e.x, a = e.i, s = e.j, r = e.realIndex, n = e.groupIndex, o = e.bcy, h = e.barHeight, c = e.barWidth, d = e.textRects, g = e.dataLabelsX, p = e.strokeWidth, f = e.dataLabelsConfig, b = e.barDataLabelsConfig, m = e.barTotalDataLabelsConfig, w = e.offX, A = e.offY, l = t.globals.gridHeight / t.globals.dataPoints;
                    c = Math.abs(c);
                    var u, x, v = (o += n !== -1 ? n * h : 0) - (this.barCtx.isRangeBar ? 0 : l) + h / 2 + d.height / 2 + A - 3, k = "start", S = this.barCtx.series[a][s] < 0, C = i;
                    switch(this.barCtx.isReversed && (C = i + c - (S ? 2 * c : 0), i = t.globals.gridWidth - c), b.position){
                        case "center":
                            g = S ? C + c / 2 - w : Math.max(d.width / 2, C - c / 2) + w;
                            break;
                        case "bottom":
                            g = S ? C + c - p - Math.round(d.width / 2) - w : C - c + p + Math.round(d.width / 2) + w;
                            break;
                        case "top":
                            g = S ? C - p + Math.round(d.width / 2) - w : C - p - Math.round(d.width / 2) + w;
                    }
                    if (this.barCtx.lastActiveBarSerieIndex === r && m.enabled) {
                        var L = new M(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                            realIndex: r,
                            j: s
                        }), f.fontSize);
                        S ? (u = C - p + Math.round(L.width / 2) - w - m.offsetX - 15, k = "end") : u = C - p - Math.round(L.width / 2) + w + m.offsetX + 15, x = v + m.offsetY;
                    }
                    return t.config.chart.stacked || (g < 0 ? g = g + d.width + p : g + d.width / 2 > t.globals.gridWidth && (g = t.globals.gridWidth - d.width - p)), {
                        bcx: i,
                        bcy: o,
                        dataLabelsX: g,
                        dataLabelsY: v,
                        totalDataLabelsX: u,
                        totalDataLabelsY: x,
                        totalDataLabelsAnchor: k
                    };
                }
            },
            {
                key: "drawCalculatedDataLabels",
                value: function(e) {
                    var t = e.x, i = e.y, a = e.val, s = e.i, r = e.j, n = e.textRects, o = e.barHeight, h = e.barWidth, c = e.dataLabelsConfig, d = this.w, g = "rotate(0)";
                    d.config.plotOptions.bar.dataLabels.orientation === "vertical" && (g = "rotate(-90, ".concat(t, ", ").concat(i, ")"));
                    var p = new ye(this.barCtx.ctx), f = new M(this.barCtx.ctx), b = c.formatter, m = null, w = d.globals.collapsedSeriesIndices.indexOf(s) > -1;
                    if (c.enabled && !w) {
                        m = f.group({
                            class: "apexcharts-data-labels",
                            transform: g
                        });
                        var A = "";
                        a !== void 0 && (A = b(a, X(X({}, d), {}, {
                            seriesIndex: s,
                            dataPointIndex: r,
                            w: d
                        }))), !a && d.config.plotOptions.bar.hideZeroBarsWhenGrouped && (A = "");
                        var l = d.globals.series[s][r] < 0, u = d.config.plotOptions.bar.dataLabels.position;
                        d.config.plotOptions.bar.dataLabels.orientation === "vertical" && (u === "top" && (c.textAnchor = l ? "end" : "start"), u === "center" && (c.textAnchor = "middle"), u === "bottom" && (c.textAnchor = l ? "end" : "start")), this.barCtx.isRangeBar && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && h < f.getTextRects(A, parseFloat(c.style.fontSize)).width && (A = ""), d.config.chart.stacked && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && (this.barCtx.isHorizontal ? n.width / 1.6 > Math.abs(h) && (A = "") : n.height / 1.6 > Math.abs(o) && (A = ""));
                        var x = X({}, c);
                        this.barCtx.isHorizontal && a < 0 && (c.textAnchor === "start" ? x.textAnchor = "end" : c.textAnchor === "end" && (x.textAnchor = "start")), p.plotDataLabelsText({
                            x: t,
                            y: i,
                            text: A,
                            i: s,
                            j: r,
                            parent: m,
                            dataLabelsConfig: x,
                            alwaysDrawDataLabel: !0,
                            offsetCorrection: !0
                        });
                    }
                    return m;
                }
            },
            {
                key: "drawTotalDataLabels",
                value: function(e) {
                    var t, i = e.x, a = e.y, s = e.val, r = e.barWidth, n = e.barHeight, o = e.realIndex, h = e.textAnchor, c = e.barTotalDataLabelsConfig, d = this.w, g = new M(this.barCtx.ctx);
                    return c.enabled && i !== void 0 && a !== void 0 && this.barCtx.lastActiveBarSerieIndex === o && (t = g.drawText({
                        x: i - (!d.globals.isBarHorizontal && d.globals.seriesGroups.length ? r / d.globals.seriesGroups.length : 0),
                        y: a - (d.globals.isBarHorizontal && d.globals.seriesGroups.length ? n / d.globals.seriesGroups.length : 0),
                        foreColor: c.style.color,
                        text: s,
                        textAnchor: h,
                        fontFamily: c.style.fontFamily,
                        fontSize: c.style.fontSize,
                        fontWeight: c.style.fontWeight
                    })), t;
                }
            }
        ]), y;
    }(), Et = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.barCtx = e;
        }
        return Y(y, [
            {
                key: "initVariables",
                value: function(e) {
                    var t = this.w;
                    this.barCtx.series = e, this.barCtx.totalItems = 0, this.barCtx.seriesLen = 0, this.barCtx.visibleI = -1, this.barCtx.visibleItems = 1;
                    for(var i = 0; i < e.length; i++)if (e[i].length > 0 && (this.barCtx.seriesLen = this.barCtx.seriesLen + 1, this.barCtx.totalItems += e[i].length), t.globals.isXNumeric) for(var a = 0; a < e[i].length; a++)t.globals.seriesX[i][a] > t.globals.minX && t.globals.seriesX[i][a] < t.globals.maxX && this.barCtx.visibleItems++;
                    else this.barCtx.visibleItems = t.globals.dataPoints;
                    this.barCtx.seriesLen === 0 && (this.barCtx.seriesLen = 1), this.barCtx.zeroSerieses = [], t.globals.comboCharts || this.checkZeroSeries({
                        series: e
                    });
                }
            },
            {
                key: "initialPositions",
                value: function() {
                    var e, t, i, a, s, r, n, o, h = this.w, c = h.globals.dataPoints;
                    this.barCtx.isRangeBar && (c = h.globals.labels.length);
                    var d = this.barCtx.seriesLen;
                    if (h.config.plotOptions.bar.rangeBarGroupRows && (d = 1), this.barCtx.isHorizontal) s = (i = h.globals.gridHeight / c) / d, h.globals.isXNumeric && (s = (i = h.globals.gridHeight / this.barCtx.totalItems) / this.barCtx.seriesLen), s = s * parseInt(this.barCtx.barOptions.barHeight, 10) / 100, String(this.barCtx.barOptions.barHeight).indexOf("%") === -1 && (s = parseInt(this.barCtx.barOptions.barHeight, 10)), o = this.barCtx.baseLineInvertedY + h.globals.padHorizontal + (this.barCtx.isReversed ? h.globals.gridWidth : 0) - (this.barCtx.isReversed ? 2 * this.barCtx.baseLineInvertedY : 0), this.barCtx.isFunnel && (o = h.globals.gridWidth / 2), t = (i - s * this.barCtx.seriesLen) / 2;
                    else {
                        if (a = h.globals.gridWidth / this.barCtx.visibleItems, h.config.xaxis.convertedCatToNumeric && (a = h.globals.gridWidth / h.globals.dataPoints), r = a / d * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100, h.globals.isXNumeric) {
                            var g = this.barCtx.xRatio;
                            h.globals.minXDiff && h.globals.minXDiff !== 0.5 && h.globals.minXDiff / g > 0 && (a = h.globals.minXDiff / g), (r = a / d * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100) < 1 && (r = 1);
                        }
                        String(this.barCtx.barOptions.columnWidth).indexOf("%") === -1 && (r = parseInt(this.barCtx.barOptions.columnWidth, 10)), n = h.globals.gridHeight - this.barCtx.baseLineY[this.barCtx.yaxisIndex] - (this.barCtx.isReversed ? h.globals.gridHeight : 0) + (this.barCtx.isReversed ? 2 * this.barCtx.baseLineY[this.barCtx.yaxisIndex] : 0), e = h.globals.padHorizontal + (a - r * this.barCtx.seriesLen) / 2;
                    }
                    return h.globals.barHeight = s, h.globals.barWidth = r, {
                        x: e,
                        y: t,
                        yDivision: i,
                        xDivision: a,
                        barHeight: s,
                        barWidth: r,
                        zeroH: n,
                        zeroW: o
                    };
                }
            },
            {
                key: "initializeStackedPrevVars",
                value: function(e) {
                    var t = e.w;
                    t.globals.hasSeriesGroups ? t.globals.seriesGroups.forEach(function(i) {
                        e[i] || (e[i] = {}), e[i].prevY = [], e[i].prevX = [], e[i].prevYF = [], e[i].prevXF = [], e[i].prevYVal = [], e[i].prevXVal = [];
                    }) : (e.prevY = [], e.prevX = [], e.prevYF = [], e.prevXF = [], e.prevYVal = [], e.prevXVal = []);
                }
            },
            {
                key: "initializeStackedXYVars",
                value: function(e) {
                    var t = e.w;
                    t.globals.hasSeriesGroups ? t.globals.seriesGroups.forEach(function(i) {
                        e[i] || (e[i] = {}), e[i].xArrj = [], e[i].xArrjF = [], e[i].xArrjVal = [], e[i].yArrj = [], e[i].yArrjF = [], e[i].yArrjVal = [];
                    }) : (e.xArrj = [], e.xArrjF = [], e.xArrjVal = [], e.yArrj = [], e.yArrjF = [], e.yArrjVal = []);
                }
            },
            {
                key: "getPathFillColor",
                value: function(e, t, i, a) {
                    var s, r, n, o, h = this.w, c = new ae(this.barCtx.ctx), d = null, g = this.barCtx.barOptions.distributed ? i : t;
                    return this.barCtx.barOptions.colors.ranges.length > 0 && this.barCtx.barOptions.colors.ranges.map(function(p) {
                        e[t][i] >= p.from && e[t][i] <= p.to && (d = p.color);
                    }), h.config.series[t].data[i] && h.config.series[t].data[i].fillColor && (d = h.config.series[t].data[i].fillColor), c.fillPath({
                        seriesNumber: this.barCtx.barOptions.distributed ? g : a,
                        dataPointIndex: i,
                        color: d,
                        value: e[t][i],
                        fillConfig: (s = h.config.series[t].data[i]) === null || s === void 0 ? void 0 : s.fill,
                        fillType: (r = h.config.series[t].data[i]) !== null && r !== void 0 && (n = r.fill) !== null && n !== void 0 && n.type ? (o = h.config.series[t].data[i]) === null || o === void 0 ? void 0 : o.fill.type : Array.isArray(h.config.fill.type) ? h.config.fill.type[t] : h.config.fill.type
                    });
                }
            },
            {
                key: "getStrokeWidth",
                value: function(e, t, i) {
                    var a = 0, s = this.w;
                    return this.barCtx.series[e][t] === void 0 || this.barCtx.series[e][t] === null ? this.barCtx.isNullValue = !0 : this.barCtx.isNullValue = !1, s.config.stroke.show && (this.barCtx.isNullValue || (a = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[i] : this.barCtx.strokeWidth)), a;
                }
            },
            {
                key: "shouldApplyRadius",
                value: function(e) {
                    var t = this.w, i = !1;
                    return t.config.plotOptions.bar.borderRadius > 0 && (t.config.chart.stacked && t.config.plotOptions.bar.borderRadiusWhenStacked === "last" ? this.barCtx.lastActiveBarSerieIndex === e && (i = !0) : i = !0), i;
                }
            },
            {
                key: "barBackground",
                value: function(e) {
                    var t = e.j, i = e.i, a = e.x1, s = e.x2, r = e.y1, n = e.y2, o = e.elSeries, h = this.w, c = new M(this.barCtx.ctx), d = new te(this.barCtx.ctx).getActiveConfigSeriesIndex();
                    if (this.barCtx.barOptions.colors.backgroundBarColors.length > 0 && d === i) {
                        t >= this.barCtx.barOptions.colors.backgroundBarColors.length && (t %= this.barCtx.barOptions.colors.backgroundBarColors.length);
                        var g = this.barCtx.barOptions.colors.backgroundBarColors[t], p = c.drawRect(a !== void 0 ? a : 0, r !== void 0 ? r : 0, s !== void 0 ? s : h.globals.gridWidth, n !== void 0 ? n : h.globals.gridHeight, this.barCtx.barOptions.colors.backgroundBarRadius, g, this.barCtx.barOptions.colors.backgroundBarOpacity);
                        o.add(p), p.node.classList.add("apexcharts-backgroundBar");
                    }
                }
            },
            {
                key: "getColumnPaths",
                value: function(e) {
                    var t, i = e.barWidth, a = e.barXPosition, s = e.y1, r = e.y2, n = e.strokeWidth, o = e.seriesGroup, h = e.realIndex, c = e.i, d = e.j, g = e.w, p = new M(this.barCtx.ctx);
                    (n = Array.isArray(n) ? n[h] : n) || (n = 0);
                    var f = i, b = a;
                    (t = g.config.series[h].data[d]) !== null && t !== void 0 && t.columnWidthOffset && (b = a - g.config.series[h].data[d].columnWidthOffset / 2, f = i + g.config.series[h].data[d].columnWidthOffset);
                    var m = b, w = b + f;
                    s += 1e-3, r += 1e-3;
                    var A = p.move(m, s), l = p.move(m, s), u = p.line(w - n, s);
                    if (g.globals.previousPaths.length > 0 && (l = this.barCtx.getPreviousPath(h, d, !1)), A = A + p.line(m, r) + p.line(w - n, r) + p.line(w - n, s) + (g.config.plotOptions.bar.borderRadiusApplication === "around" ? " Z" : " z"), l = l + p.line(m, s) + u + u + u + u + u + p.line(m, s) + (g.config.plotOptions.bar.borderRadiusApplication === "around" ? " Z" : " z"), this.shouldApplyRadius(h) && (A = p.roundPathCorners(A, g.config.plotOptions.bar.borderRadius)), g.config.chart.stacked) {
                        var x = this.barCtx;
                        g.globals.hasSeriesGroups && o && (x = this.barCtx[o]), x.yArrj.push(r), x.yArrjF.push(Math.abs(s - r)), x.yArrjVal.push(this.barCtx.series[c][d]);
                    }
                    return {
                        pathTo: A,
                        pathFrom: l
                    };
                }
            },
            {
                key: "getBarpaths",
                value: function(e) {
                    var t, i = e.barYPosition, a = e.barHeight, s = e.x1, r = e.x2, n = e.strokeWidth, o = e.seriesGroup, h = e.realIndex, c = e.i, d = e.j, g = e.w, p = new M(this.barCtx.ctx);
                    (n = Array.isArray(n) ? n[h] : n) || (n = 0);
                    var f = i, b = a;
                    (t = g.config.series[h].data[d]) !== null && t !== void 0 && t.barHeightOffset && (f = i - g.config.series[h].data[d].barHeightOffset / 2, b = a + g.config.series[h].data[d].barHeightOffset);
                    var m = f, w = f + b;
                    s += 1e-3, r += 1e-3;
                    var A = p.move(s, m), l = p.move(s, m);
                    g.globals.previousPaths.length > 0 && (l = this.barCtx.getPreviousPath(h, d, !1));
                    var u = p.line(s, w - n);
                    if (A = A + p.line(r, m) + p.line(r, w - n) + u + (g.config.plotOptions.bar.borderRadiusApplication === "around" ? " Z" : " z"), l = l + p.line(s, m) + u + u + u + u + u + p.line(s, m) + (g.config.plotOptions.bar.borderRadiusApplication === "around" ? " Z" : " z"), this.shouldApplyRadius(h) && (A = p.roundPathCorners(A, g.config.plotOptions.bar.borderRadius)), g.config.chart.stacked) {
                        var x = this.barCtx;
                        g.globals.hasSeriesGroups && o && (x = this.barCtx[o]), x.xArrj.push(r), x.xArrjF.push(Math.abs(s - r)), x.xArrjVal.push(this.barCtx.series[c][d]);
                    }
                    return {
                        pathTo: A,
                        pathFrom: l
                    };
                }
            },
            {
                key: "checkZeroSeries",
                value: function(e) {
                    for(var t = e.series, i = this.w, a = 0; a < t.length; a++){
                        for(var s = 0, r = 0; r < t[i.globals.maxValsInArrayIndex].length; r++)s += t[a][r];
                        s === 0 && this.barCtx.zeroSerieses.push(a);
                    }
                }
            },
            {
                key: "getXForValue",
                value: function(e, t) {
                    var i = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2] ? t : null;
                    return e != null && (i = t + e / this.barCtx.invertedYRatio - 2 * (this.barCtx.isReversed ? e / this.barCtx.invertedYRatio : 0)), i;
                }
            },
            {
                key: "getYForValue",
                value: function(e, t) {
                    var i = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2] ? t : null;
                    return e != null && (i = t - e / this.barCtx.yRatio[this.barCtx.yaxisIndex] + 2 * (this.barCtx.isReversed ? e / this.barCtx.yRatio[this.barCtx.yaxisIndex] : 0)), i;
                }
            },
            {
                key: "getGoalValues",
                value: function(e, t, i, a, s) {
                    var r = this, n = this.w, o = [], h = function(g, p) {
                        var f;
                        o.push((ee(f = {}, e, e === "x" ? r.getXForValue(g, t, !1) : r.getYForValue(g, i, !1)), ee(f, "attrs", p), f));
                    };
                    if (n.globals.seriesGoals[a] && n.globals.seriesGoals[a][s] && Array.isArray(n.globals.seriesGoals[a][s]) && n.globals.seriesGoals[a][s].forEach(function(g) {
                        h(g.value, g);
                    }), this.barCtx.barOptions.isDumbbell && n.globals.seriesRange.length) {
                        var c = this.barCtx.barOptions.dumbbellColors ? this.barCtx.barOptions.dumbbellColors : n.globals.colors, d = {
                            strokeHeight: e === "x" ? 0 : n.globals.markers.size[a],
                            strokeWidth: e === "x" ? n.globals.markers.size[a] : 0,
                            strokeDashArray: 0,
                            strokeLineCap: "round",
                            strokeColor: Array.isArray(c[a]) ? c[a][0] : c[a]
                        };
                        h(n.globals.seriesRangeStart[a][s], d), h(n.globals.seriesRangeEnd[a][s], X(X({}, d), {}, {
                            strokeColor: Array.isArray(c[a]) ? c[a][1] : c[a]
                        }));
                    }
                    return o;
                }
            },
            {
                key: "drawGoalLine",
                value: function(e) {
                    var t = e.barXPosition, i = e.barYPosition, a = e.goalX, s = e.goalY, r = e.barWidth, n = e.barHeight, o = new M(this.barCtx.ctx), h = o.group({
                        className: "apexcharts-bar-goals-groups"
                    });
                    h.node.classList.add("apexcharts-element-hidden"), this.barCtx.w.globals.delayedElements.push({
                        el: h.node
                    }), h.attr("clip-path", "url(#gridRectMarkerMask".concat(this.barCtx.w.globals.cuid, ")"));
                    var c = null;
                    return this.barCtx.isHorizontal ? Array.isArray(a) && a.forEach(function(d) {
                        var g = d.attrs.strokeHeight !== void 0 ? d.attrs.strokeHeight : n / 2, p = i + g + n / 2;
                        c = o.drawLine(d.x, p - 2 * g, d.x, p, d.attrs.strokeColor ? d.attrs.strokeColor : void 0, d.attrs.strokeDashArray, d.attrs.strokeWidth ? d.attrs.strokeWidth : 2, d.attrs.strokeLineCap), h.add(c);
                    }) : Array.isArray(s) && s.forEach(function(d) {
                        var g = d.attrs.strokeWidth !== void 0 ? d.attrs.strokeWidth : r / 2, p = t + g + r / 2;
                        c = o.drawLine(p - 2 * g, d.y, p, d.y, d.attrs.strokeColor ? d.attrs.strokeColor : void 0, d.attrs.strokeDashArray, d.attrs.strokeHeight ? d.attrs.strokeHeight : 2, d.attrs.strokeLineCap), h.add(c);
                    }), h;
                }
            },
            {
                key: "drawBarShadow",
                value: function(e) {
                    var t = e.prevPaths, i = e.currPaths, a = e.color, s = this.w, r = t.x, n = t.x1, o = t.barYPosition, h = i.x, c = i.x1, d = i.barYPosition, g = o + i.barHeight, p = new M(this.barCtx.ctx), f = new P(), b = p.move(n, g) + p.line(r, g) + p.line(h, d) + p.line(c, d) + p.line(n, g) + (s.config.plotOptions.bar.borderRadiusApplication === "around" ? " Z" : " z");
                    return p.drawPath({
                        d: b,
                        fill: f.shadeColor(0.5, P.rgb2hex(a)),
                        stroke: "none",
                        strokeWidth: 0,
                        fillOpacity: 1,
                        classes: "apexcharts-bar-shadows"
                    });
                }
            },
            {
                key: "getZeroValueEncounters",
                value: function(e) {
                    var t = e.i, i = e.j, a = this.w, s = 0, r = 0;
                    return a.globals.seriesPercent.forEach(function(n, o) {
                        n[i] && s++, o < t && n[i] === 0 && r++;
                    }), {
                        nonZeroColumns: s,
                        zeroEncounters: r
                    };
                }
            }
        ]), y;
    }(), ke = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.w = e.w;
            var i = this.w;
            this.barOptions = i.config.plotOptions.bar, this.isHorizontal = this.barOptions.horizontal, this.strokeWidth = i.config.stroke.width, this.isNullValue = !1, this.isRangeBar = i.globals.seriesRange.length && this.isHorizontal, this.isVerticalGroupedRangeBar = !i.globals.isBarHorizontal && i.globals.seriesRange.length && i.config.plotOptions.bar.rangeBarGroupRows, this.isFunnel = this.barOptions.isFunnel, this.xyRatios = t, this.xyRatios !== null && (this.xRatio = t.xRatio, this.yRatio = t.yRatio, this.invertedXRatio = t.invertedXRatio, this.invertedYRatio = t.invertedYRatio, this.baseLineY = t.baseLineY, this.baseLineInvertedY = t.baseLineInvertedY), this.yaxisIndex = 0, this.seriesLen = 0, this.pathArr = [];
            var a = new te(this.ctx);
            this.lastActiveBarSerieIndex = a.getActiveConfigSeriesIndex("desc", [
                "bar",
                "column"
            ]);
            var s = a.getBarSeriesIndices(), r = new q(this.ctx);
            this.stackedSeriesTotals = r.getStackedSeriesTotals(this.w.config.series.map(function(n, o) {
                return s.indexOf(o) === -1 ? o : -1;
            }).filter(function(n) {
                return n !== -1;
            })), this.barHelpers = new Et(this);
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e, t) {
                    var i = this.w, a = new M(this.ctx), s = new q(this.ctx, i);
                    e = s.getLogSeries(e), this.series = e, this.yRatio = s.getLogYRatios(this.yRatio), this.barHelpers.initVariables(e);
                    var r = a.group({
                        class: "apexcharts-bar-series apexcharts-plot-series"
                    });
                    i.config.dataLabels.enabled && this.totalItems > this.barOptions.dataLabels.maxItems && console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering - ApexCharts");
                    for(var n = 0, o = 0; n < e.length; n++, o++){
                        var h, c, d, g, p = void 0, f = void 0, b = [], m = [], w = i.globals.comboCharts ? t[n] : n, A = a.group({
                            class: "apexcharts-series",
                            rel: n + 1,
                            seriesName: P.escapeString(i.globals.seriesNames[w]),
                            "data:realIndex": w
                        });
                        this.ctx.series.addCollapsedClassToSeries(A, w), e[n].length > 0 && (this.visibleI = this.visibleI + 1);
                        var l = 0, u = 0;
                        this.yRatio.length > 1 && (this.yaxisIndex = w), this.isReversed = i.config.yaxis[this.yaxisIndex] && i.config.yaxis[this.yaxisIndex].reversed;
                        var x = this.barHelpers.initialPositions();
                        f = x.y, l = x.barHeight, c = x.yDivision, g = x.zeroW, p = x.x, u = x.barWidth, h = x.xDivision, d = x.zeroH, this.horizontal || m.push(p + u / 2);
                        var v = a.group({
                            class: "apexcharts-datalabels",
                            "data:realIndex": w
                        });
                        i.globals.delayedElements.push({
                            el: v.node
                        }), v.node.classList.add("apexcharts-element-hidden");
                        var k = a.group({
                            class: "apexcharts-bar-goals-markers"
                        }), S = a.group({
                            class: "apexcharts-bar-shadows"
                        });
                        i.globals.delayedElements.push({
                            el: S.node
                        }), S.node.classList.add("apexcharts-element-hidden");
                        for(var C = 0; C < i.globals.dataPoints; C++){
                            var L = this.barHelpers.getStrokeWidth(n, C, w), I = null, z = {
                                indexes: {
                                    i: n,
                                    j: C,
                                    realIndex: w,
                                    bc: o
                                },
                                x: p,
                                y: f,
                                strokeWidth: L,
                                elSeries: A
                            };
                            this.isHorizontal ? (I = this.drawBarPaths(X(X({}, z), {}, {
                                barHeight: l,
                                zeroW: g,
                                yDivision: c
                            })), u = this.series[n][C] / this.invertedYRatio) : (I = this.drawColumnPaths(X(X({}, z), {}, {
                                xDivision: h,
                                barWidth: u,
                                zeroH: d
                            })), l = this.series[n][C] / this.yRatio[this.yaxisIndex]);
                            var T = this.barHelpers.getPathFillColor(e, n, C, w);
                            if (this.isFunnel && this.barOptions.isFunnel3d && this.pathArr.length && C > 0) {
                                var E = this.barHelpers.drawBarShadow({
                                    color: typeof T == "string" && (T == null ? void 0 : T.indexOf("url")) === -1 ? T : P.hexToRgba(i.globals.colors[n]),
                                    prevPaths: this.pathArr[this.pathArr.length - 1],
                                    currPaths: I
                                });
                                E && S.add(E);
                            }
                            this.pathArr.push(I);
                            var R = this.barHelpers.drawGoalLine({
                                barXPosition: I.barXPosition,
                                barYPosition: I.barYPosition,
                                goalX: I.goalX,
                                goalY: I.goalY,
                                barHeight: l,
                                barWidth: u
                            });
                            R && k.add(R), f = I.y, p = I.x, C > 0 && m.push(p + u / 2), b.push(f), this.renderSeries({
                                realIndex: w,
                                pathFill: T,
                                j: C,
                                i: n,
                                pathFrom: I.pathFrom,
                                pathTo: I.pathTo,
                                strokeWidth: L,
                                elSeries: A,
                                x: p,
                                y: f,
                                series: e,
                                barHeight: I.barHeight ? I.barHeight : l,
                                barWidth: I.barWidth ? I.barWidth : u,
                                elDataLabelsWrap: v,
                                elGoalsMarkers: k,
                                elBarShadows: S,
                                visibleSeries: this.visibleI,
                                type: "bar"
                            });
                        }
                        i.globals.seriesXvalues[w] = m, i.globals.seriesYvalues[w] = b, r.add(A);
                    }
                    return r;
                }
            },
            {
                key: "renderSeries",
                value: function(e) {
                    var t = e.realIndex, i = e.pathFill, a = e.lineFill, s = e.j, r = e.i, n = e.groupIndex, o = e.pathFrom, h = e.pathTo, c = e.strokeWidth, d = e.elSeries, g = e.x, p = e.y, f = e.y1, b = e.y2, m = e.series, w = e.barHeight, A = e.barWidth, l = e.barXPosition, u = e.barYPosition, x = e.elDataLabelsWrap, v = e.elGoalsMarkers, k = e.elBarShadows, S = e.visibleSeries, C = e.type, L = this.w, I = new M(this.ctx);
                    a || (a = this.barOptions.distributed ? L.globals.stroke.colors[s] : L.globals.stroke.colors[t]), L.config.series[r].data[s] && L.config.series[r].data[s].strokeColor && (a = L.config.series[r].data[s].strokeColor), this.isNullValue && (i = "none");
                    var z = s / L.config.chart.animations.animateGradually.delay * (L.config.chart.animations.speed / L.globals.dataPoints) / 2.4, T = I.renderPaths({
                        i: r,
                        j: s,
                        realIndex: t,
                        pathFrom: o,
                        pathTo: h,
                        stroke: a,
                        strokeWidth: c,
                        strokeLineCap: L.config.stroke.lineCap,
                        fill: i,
                        animationDelay: z,
                        initialSpeed: L.config.chart.animations.speed,
                        dataChangeSpeed: L.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-".concat(C, "-area")
                    });
                    T.attr("clip-path", "url(#gridRectMask".concat(L.globals.cuid, ")"));
                    var E = L.config.forecastDataPoints;
                    E.count > 0 && s >= L.globals.dataPoints - E.count && (T.node.setAttribute("stroke-dasharray", E.dashArray), T.node.setAttribute("stroke-width", E.strokeWidth), T.node.setAttribute("fill-opacity", E.fillOpacity)), f !== void 0 && b !== void 0 && (T.attr("data-range-y1", f), T.attr("data-range-y2", b)), new Z(this.ctx).setSelectionFilter(T, t, s), d.add(T);
                    var R = new Xt(this).handleBarDataLabels({
                        x: g,
                        y: p,
                        y1: f,
                        y2: b,
                        i: r,
                        j: s,
                        series: m,
                        realIndex: t,
                        groupIndex: n,
                        barHeight: w,
                        barWidth: A,
                        barXPosition: l,
                        barYPosition: u,
                        renderedPath: T,
                        visibleSeries: S
                    });
                    return R.dataLabels !== null && x.add(R.dataLabels), R.totalDataLabels && x.add(R.totalDataLabels), d.add(x), v && d.add(v), k && d.add(k), d;
                }
            },
            {
                key: "drawBarPaths",
                value: function(e) {
                    var t, i = e.indexes, a = e.barHeight, s = e.strokeWidth, r = e.zeroW, n = e.x, o = e.y, h = e.yDivision, c = e.elSeries, d = this.w, g = i.i, p = i.j;
                    if (d.globals.isXNumeric) t = (o = (d.globals.seriesX[g][p] - d.globals.minX) / this.invertedXRatio - a) + a * this.visibleI;
                    else if (d.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                        var f = 0, b = 0;
                        d.globals.seriesPercent.forEach(function(w, A) {
                            w[p] && f++, A < g && w[p] === 0 && b++;
                        }), f > 0 && (a = this.seriesLen * a / f), t = o + a * this.visibleI, t -= a * b;
                    } else t = o + a * this.visibleI;
                    this.isFunnel && (r -= (this.barHelpers.getXForValue(this.series[g][p], r) - r) / 2), n = this.barHelpers.getXForValue(this.series[g][p], r);
                    var m = this.barHelpers.getBarpaths({
                        barYPosition: t,
                        barHeight: a,
                        x1: r,
                        x2: n,
                        strokeWidth: s,
                        series: this.series,
                        realIndex: i.realIndex,
                        i: g,
                        j: p,
                        w: d
                    });
                    return d.globals.isXNumeric || (o += h), this.barHelpers.barBackground({
                        j: p,
                        i: g,
                        y1: t - a * this.visibleI,
                        y2: a * this.seriesLen,
                        elSeries: c
                    }), {
                        pathTo: m.pathTo,
                        pathFrom: m.pathFrom,
                        x1: r,
                        x: n,
                        y: o,
                        goalX: this.barHelpers.getGoalValues("x", r, null, g, p),
                        barYPosition: t,
                        barHeight: a
                    };
                }
            },
            {
                key: "drawColumnPaths",
                value: function(e) {
                    var t, i = e.indexes, a = e.x, s = e.y, r = e.xDivision, n = e.barWidth, o = e.zeroH, h = e.strokeWidth, c = e.elSeries, d = this.w, g = i.realIndex, p = i.i, f = i.j, b = i.bc;
                    if (d.globals.isXNumeric) {
                        var m = this.getBarXForNumericXAxis({
                            x: a,
                            j: f,
                            realIndex: g,
                            barWidth: n
                        });
                        a = m.x, t = m.barXPosition;
                    } else if (d.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                        var w = this.barHelpers.getZeroValueEncounters({
                            i: p,
                            j: f
                        }), A = w.nonZeroColumns, l = w.zeroEncounters;
                        A > 0 && (n = this.seriesLen * n / A), t = a + n * this.visibleI, t -= n * l;
                    } else t = a + n * this.visibleI;
                    s = this.barHelpers.getYForValue(this.series[p][f], o);
                    var u = this.barHelpers.getColumnPaths({
                        barXPosition: t,
                        barWidth: n,
                        y1: o,
                        y2: s,
                        strokeWidth: h,
                        series: this.series,
                        realIndex: i.realIndex,
                        i: p,
                        j: f,
                        w: d
                    });
                    return d.globals.isXNumeric || (a += r), this.barHelpers.barBackground({
                        bc: b,
                        j: f,
                        i: p,
                        x1: t - h / 2 - n * this.visibleI,
                        x2: n * this.seriesLen + h / 2,
                        elSeries: c
                    }), {
                        pathTo: u.pathTo,
                        pathFrom: u.pathFrom,
                        x: a,
                        y: s,
                        goalY: this.barHelpers.getGoalValues("y", null, o, p, f),
                        barXPosition: t,
                        barWidth: n
                    };
                }
            },
            {
                key: "getBarXForNumericXAxis",
                value: function(e) {
                    var t = e.x, i = e.barWidth, a = e.realIndex, s = e.j, r = this.w, n = a;
                    return r.globals.seriesX[a].length || (n = r.globals.maxValsInArrayIndex), r.globals.seriesX[n][s] && (t = (r.globals.seriesX[n][s] - r.globals.minX) / this.xRatio - i * this.seriesLen / 2), {
                        barXPosition: t + i * this.visibleI,
                        x: t
                    };
                }
            },
            {
                key: "getPreviousPath",
                value: function(e, t) {
                    for(var i, a = this.w, s = 0; s < a.globals.previousPaths.length; s++){
                        var r = a.globals.previousPaths[s];
                        r.paths && r.paths.length > 0 && parseInt(r.realIndex, 10) === parseInt(e, 10) && a.globals.previousPaths[s].paths[t] !== void 0 && (i = a.globals.previousPaths[s].paths[t].d);
                    }
                    return i;
                }
            }
        ]), y;
    }(), st = function(y) {
        ge(t, ke);
        var e = ue(t);
        function t() {
            return F(this, t), e.apply(this, arguments);
        }
        return Y(t, [
            {
                key: "draw",
                value: function(i, a) {
                    var s = this, r = this.w;
                    this.graphics = new M(this.ctx), this.bar = new ke(this.ctx, this.xyRatios);
                    var n = new q(this.ctx, r);
                    i = n.getLogSeries(i), this.yRatio = n.getLogYRatios(this.yRatio), this.barHelpers.initVariables(i), r.config.chart.stackType === "100%" && (i = r.globals.seriesPercent.slice()), this.series = i, this.barHelpers.initializeStackedPrevVars(this);
                    for(var o = this.graphics.group({
                        class: "apexcharts-bar-series apexcharts-plot-series"
                    }), h = 0, c = 0, d = function(f, b) {
                        var m = void 0, w = void 0, A = void 0, l = void 0, u = -1;
                        s.groupCtx = s, r.globals.seriesGroups.forEach(function(V, j) {
                            V.indexOf(r.config.series[f].name) > -1 && (u = j);
                        }), u !== -1 && (s.groupCtx = s[r.globals.seriesGroups[u]]);
                        var x = [], v = [], k = r.globals.comboCharts ? a[f] : f;
                        s.yRatio.length > 1 && (s.yaxisIndex = k), s.isReversed = r.config.yaxis[s.yaxisIndex] && r.config.yaxis[s.yaxisIndex].reversed;
                        var S = s.graphics.group({
                            class: "apexcharts-series",
                            seriesName: P.escapeString(r.globals.seriesNames[k]),
                            rel: f + 1,
                            "data:realIndex": k
                        });
                        s.ctx.series.addCollapsedClassToSeries(S, k);
                        var C = s.graphics.group({
                            class: "apexcharts-datalabels",
                            "data:realIndex": k
                        }), L = s.graphics.group({
                            class: "apexcharts-bar-goals-markers"
                        }), I = 0, z = 0, T = s.initialPositions(h, c, m, w, A, l);
                        c = T.y, I = T.barHeight, w = T.yDivision, l = T.zeroW, h = T.x, z = T.barWidth, m = T.xDivision, A = T.zeroH, r.globals.barHeight = I, r.globals.barWidth = z, s.barHelpers.initializeStackedXYVars(s), s.groupCtx.prevY.length === 1 && s.groupCtx.prevY[0].every(function(V) {
                            return isNaN(V);
                        }) && (s.groupCtx.prevY[0] = s.groupCtx.prevY[0].map(function(V) {
                            return A;
                        }), s.groupCtx.prevYF[0] = s.groupCtx.prevYF[0].map(function(V) {
                            return 0;
                        }));
                        for(var E = 0; E < r.globals.dataPoints; E++){
                            var R = s.barHelpers.getStrokeWidth(f, E, k), O = {
                                indexes: {
                                    i: f,
                                    j: E,
                                    realIndex: k,
                                    bc: b
                                },
                                strokeWidth: R,
                                x: h,
                                y: c,
                                elSeries: S,
                                groupIndex: u,
                                seriesGroup: r.globals.seriesGroups[u]
                            }, D = null;
                            s.isHorizontal ? (D = s.drawStackedBarPaths(X(X({}, O), {}, {
                                zeroW: l,
                                barHeight: I,
                                yDivision: w
                            })), z = s.series[f][E] / s.invertedYRatio) : (D = s.drawStackedColumnPaths(X(X({}, O), {}, {
                                xDivision: m,
                                barWidth: z,
                                zeroH: A
                            })), I = s.series[f][E] / s.yRatio[s.yaxisIndex]);
                            var W = s.barHelpers.drawGoalLine({
                                barXPosition: D.barXPosition,
                                barYPosition: D.barYPosition,
                                goalX: D.goalX,
                                goalY: D.goalY,
                                barHeight: I,
                                barWidth: z
                            });
                            W && L.add(W), c = D.y, h = D.x, x.push(h), v.push(c);
                            var N = s.barHelpers.getPathFillColor(i, f, E, k);
                            S = s.renderSeries({
                                realIndex: k,
                                pathFill: N,
                                j: E,
                                i: f,
                                groupIndex: u,
                                pathFrom: D.pathFrom,
                                pathTo: D.pathTo,
                                strokeWidth: R,
                                elSeries: S,
                                x: h,
                                y: c,
                                series: i,
                                barHeight: I,
                                barWidth: z,
                                elDataLabelsWrap: C,
                                elGoalsMarkers: L,
                                type: "bar",
                                visibleSeries: 0
                            });
                        }
                        r.globals.seriesXvalues[k] = x, r.globals.seriesYvalues[k] = v, s.groupCtx.prevY.push(s.groupCtx.yArrj), s.groupCtx.prevYF.push(s.groupCtx.yArrjF), s.groupCtx.prevYVal.push(s.groupCtx.yArrjVal), s.groupCtx.prevX.push(s.groupCtx.xArrj), s.groupCtx.prevXF.push(s.groupCtx.xArrjF), s.groupCtx.prevXVal.push(s.groupCtx.xArrjVal), o.add(S);
                    }, g = 0, p = 0; g < i.length; g++, p++)d(g, p);
                    return o;
                }
            },
            {
                key: "initialPositions",
                value: function(i, a, s, r, n, o) {
                    var h, c, d, g, p = this.w;
                    return this.isHorizontal ? (d = (d = r = p.globals.gridHeight / p.globals.dataPoints) * parseInt(p.config.plotOptions.bar.barHeight, 10) / 100, String(p.config.plotOptions.bar.barHeight).indexOf("%") === -1 && (d = parseInt(p.config.plotOptions.bar.barHeight, 10)), o = this.baseLineInvertedY + p.globals.padHorizontal + (this.isReversed ? p.globals.gridWidth : 0) - (this.isReversed ? 2 * this.baseLineInvertedY : 0), a = (r - d) / 2) : (g = s = p.globals.gridWidth / p.globals.dataPoints, g = p.globals.isXNumeric && p.globals.dataPoints > 1 ? (s = p.globals.minXDiff / this.xRatio) * parseInt(this.barOptions.columnWidth, 10) / 100 : g * parseInt(p.config.plotOptions.bar.columnWidth, 10) / 100, String(p.config.plotOptions.bar.columnWidth).indexOf("%") === -1 && (g = parseInt(p.config.plotOptions.bar.columnWidth, 10)), n = p.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? p.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), i = p.globals.padHorizontal + (s - g) / 2), {
                        x: i,
                        y: a,
                        yDivision: r,
                        xDivision: s,
                        barHeight: (h = p.globals.seriesGroups) !== null && h !== void 0 && h.length ? d / p.globals.seriesGroups.length : d,
                        barWidth: (c = p.globals.seriesGroups) !== null && c !== void 0 && c.length ? g / p.globals.seriesGroups.length : g,
                        zeroH: n,
                        zeroW: o
                    };
                }
            },
            {
                key: "drawStackedBarPaths",
                value: function(i) {
                    for(var a, s = i.indexes, r = i.barHeight, n = i.strokeWidth, o = i.zeroW, h = i.x, c = i.y, d = i.groupIndex, g = i.seriesGroup, p = i.yDivision, f = i.elSeries, b = this.w, m = c + (d !== -1 ? d * r : 0), w = s.i, A = s.j, l = 0, u = 0; u < this.groupCtx.prevXF.length; u++)l += this.groupCtx.prevXF[u][A];
                    var x = w;
                    if (g && (x = g.indexOf(b.config.series[w].name)), x > 0) {
                        var v = o;
                        this.groupCtx.prevXVal[x - 1][A] < 0 ? v = this.series[w][A] >= 0 ? this.groupCtx.prevX[x - 1][A] + l - 2 * (this.isReversed ? l : 0) : this.groupCtx.prevX[x - 1][A] : this.groupCtx.prevXVal[x - 1][A] >= 0 && (v = this.series[w][A] >= 0 ? this.groupCtx.prevX[x - 1][A] : this.groupCtx.prevX[x - 1][A] - l + 2 * (this.isReversed ? l : 0)), a = v;
                    } else a = o;
                    h = this.series[w][A] === null ? a : a + this.series[w][A] / this.invertedYRatio - 2 * (this.isReversed ? this.series[w][A] / this.invertedYRatio : 0);
                    var k = this.barHelpers.getBarpaths({
                        barYPosition: m,
                        barHeight: r,
                        x1: a,
                        x2: h,
                        strokeWidth: n,
                        series: this.series,
                        realIndex: s.realIndex,
                        seriesGroup: g,
                        i: w,
                        j: A,
                        w: b
                    });
                    return this.barHelpers.barBackground({
                        j: A,
                        i: w,
                        y1: m,
                        y2: r,
                        elSeries: f
                    }), c += p, {
                        pathTo: k.pathTo,
                        pathFrom: k.pathFrom,
                        goalX: this.barHelpers.getGoalValues("x", o, null, w, A),
                        barYPosition: m,
                        x: h,
                        y: c
                    };
                }
            },
            {
                key: "drawStackedColumnPaths",
                value: function(i) {
                    var a = i.indexes, s = i.x, r = i.y, n = i.xDivision, o = i.barWidth, h = i.zeroH, c = i.groupIndex, d = i.seriesGroup, g = i.elSeries, p = this.w, f = a.i, b = a.j, m = a.bc;
                    if (p.globals.isXNumeric) {
                        var w = p.globals.seriesX[f][b];
                        w || (w = 0), s = (w - p.globals.minX) / this.xRatio - o / 2, p.globals.seriesGroups.length && (s = (w - p.globals.minX) / this.xRatio - o / 2 * p.globals.seriesGroups.length);
                    }
                    for(var A, l = s + (c !== -1 ? c * o : 0), u = 0, x = 0; x < this.groupCtx.prevYF.length; x++)u += isNaN(this.groupCtx.prevYF[x][b]) ? 0 : this.groupCtx.prevYF[x][b];
                    var v = f;
                    if (d && (v = d.indexOf(p.config.series[f].name)), v > 0 && !p.globals.isXNumeric || v > 0 && p.globals.isXNumeric && p.globals.seriesX[f - 1][b] === p.globals.seriesX[f][b]) {
                        var k, S, C, L = Math.min(this.yRatio.length + 1, f + 1);
                        if (this.groupCtx.prevY[v - 1] !== void 0 && this.groupCtx.prevY[v - 1].length) for(var I = 1; I < L; I++){
                            var z;
                            if (!isNaN((z = this.groupCtx.prevY[v - I]) === null || z === void 0 ? void 0 : z[b])) {
                                C = this.groupCtx.prevY[v - I][b];
                                break;
                            }
                        }
                        for(var T = 1; T < L; T++){
                            var E, R;
                            if (((E = this.groupCtx.prevYVal[v - T]) === null || E === void 0 ? void 0 : E[b]) < 0) {
                                S = this.series[f][b] >= 0 ? C - u + 2 * (this.isReversed ? u : 0) : C;
                                break;
                            }
                            if (((R = this.groupCtx.prevYVal[v - T]) === null || R === void 0 ? void 0 : R[b]) >= 0) {
                                S = this.series[f][b] >= 0 ? C : C + u - 2 * (this.isReversed ? u : 0);
                                break;
                            }
                        }
                        S === void 0 && (S = p.globals.gridHeight), A = (k = this.groupCtx.prevYF[0]) !== null && k !== void 0 && k.every(function(D) {
                            return D === 0;
                        }) && this.groupCtx.prevYF.slice(1, v).every(function(D) {
                            return D.every(function(W) {
                                return isNaN(W);
                            });
                        }) ? h : S;
                    } else A = h;
                    r = this.series[f][b] ? A - this.series[f][b] / this.yRatio[this.yaxisIndex] + 2 * (this.isReversed ? this.series[f][b] / this.yRatio[this.yaxisIndex] : 0) : A;
                    var O = this.barHelpers.getColumnPaths({
                        barXPosition: l,
                        barWidth: o,
                        y1: A,
                        y2: r,
                        yRatio: this.yRatio[this.yaxisIndex],
                        strokeWidth: this.strokeWidth,
                        series: this.series,
                        seriesGroup: d,
                        realIndex: a.realIndex,
                        i: f,
                        j: b,
                        w: p
                    });
                    return this.barHelpers.barBackground({
                        bc: m,
                        j: b,
                        i: f,
                        x1: l,
                        x2: o,
                        elSeries: g
                    }), s += n, {
                        pathTo: O.pathTo,
                        pathFrom: O.pathFrom,
                        goalY: this.barHelpers.getGoalValues("y", null, h, f, b),
                        barXPosition: l,
                        x: p.globals.isXNumeric ? s - n : s,
                        y: r
                    };
                }
            }
        ]), t;
    }(), Be = function(y) {
        ge(t, ke);
        var e = ue(t);
        function t() {
            return F(this, t), e.apply(this, arguments);
        }
        return Y(t, [
            {
                key: "draw",
                value: function(i, a, s) {
                    var r = this, n = this.w, o = new M(this.ctx), h = n.globals.comboCharts ? a : n.config.chart.type, c = new ae(this.ctx);
                    this.candlestickOptions = this.w.config.plotOptions.candlestick, this.boxOptions = this.w.config.plotOptions.boxPlot, this.isHorizontal = n.config.plotOptions.bar.horizontal;
                    var d = new q(this.ctx, n);
                    i = d.getLogSeries(i), this.series = i, this.yRatio = d.getLogYRatios(this.yRatio), this.barHelpers.initVariables(i);
                    for(var g = o.group({
                        class: "apexcharts-".concat(h, "-series apexcharts-plot-series")
                    }), p = function(b) {
                        r.isBoxPlot = n.config.chart.type === "boxPlot" || n.config.series[b].type === "boxPlot";
                        var m, w, A, l, u = void 0, x = void 0, v = [], k = [], S = n.globals.comboCharts ? s[b] : b, C = o.group({
                            class: "apexcharts-series",
                            seriesName: P.escapeString(n.globals.seriesNames[S]),
                            rel: b + 1,
                            "data:realIndex": S
                        });
                        r.ctx.series.addCollapsedClassToSeries(C, S), i[b].length > 0 && (r.visibleI = r.visibleI + 1);
                        var L, I;
                        r.yRatio.length > 1 && (r.yaxisIndex = S);
                        var z = r.barHelpers.initialPositions();
                        x = z.y, L = z.barHeight, w = z.yDivision, l = z.zeroW, u = z.x, I = z.barWidth, m = z.xDivision, A = z.zeroH, k.push(u + I / 2);
                        for(var T = o.group({
                            class: "apexcharts-datalabels",
                            "data:realIndex": S
                        }), E = function(O) {
                            var D = r.barHelpers.getStrokeWidth(b, O, S), W = null, N = {
                                indexes: {
                                    i: b,
                                    j: O,
                                    realIndex: S
                                },
                                x: u,
                                y: x,
                                strokeWidth: D,
                                elSeries: C
                            };
                            W = r.isHorizontal ? r.drawHorizontalBoxPaths(X(X({}, N), {}, {
                                yDivision: w,
                                barHeight: L,
                                zeroW: l
                            })) : r.drawVerticalBoxPaths(X(X({}, N), {}, {
                                xDivision: m,
                                barWidth: I,
                                zeroH: A
                            })), x = W.y, u = W.x, O > 0 && k.push(u + I / 2), v.push(x), W.pathTo.forEach(function(V, j) {
                                var se = !r.isBoxPlot && r.candlestickOptions.wick.useFillColor ? W.color[j] : n.globals.stroke.colors[b], K = c.fillPath({
                                    seriesNumber: S,
                                    dataPointIndex: O,
                                    color: W.color[j],
                                    value: i[b][O]
                                });
                                r.renderSeries({
                                    realIndex: S,
                                    pathFill: K,
                                    lineFill: se,
                                    j: O,
                                    i: b,
                                    pathFrom: W.pathFrom,
                                    pathTo: V,
                                    strokeWidth: D,
                                    elSeries: C,
                                    x: u,
                                    y: x,
                                    series: i,
                                    barHeight: L,
                                    barWidth: I,
                                    elDataLabelsWrap: T,
                                    visibleSeries: r.visibleI,
                                    type: n.config.chart.type
                                });
                            });
                        }, R = 0; R < n.globals.dataPoints; R++)E(R);
                        n.globals.seriesXvalues[S] = k, n.globals.seriesYvalues[S] = v, g.add(C);
                    }, f = 0; f < i.length; f++)p(f);
                    return g;
                }
            },
            {
                key: "drawVerticalBoxPaths",
                value: function(i) {
                    var a = i.indexes, s = i.x;
                    i.y;
                    var r = i.xDivision, n = i.barWidth, o = i.zeroH, h = i.strokeWidth, c = this.w, d = new M(this.ctx), g = a.i, p = a.j, f = !0, b = c.config.plotOptions.candlestick.colors.upward, m = c.config.plotOptions.candlestick.colors.downward, w = "";
                    this.isBoxPlot && (w = [
                        this.boxOptions.colors.lower,
                        this.boxOptions.colors.upper
                    ]);
                    var A = this.yRatio[this.yaxisIndex], l = a.realIndex, u = this.getOHLCValue(l, p), x = o, v = o;
                    u.o > u.c && (f = !1);
                    var k = Math.min(u.o, u.c), S = Math.max(u.o, u.c), C = u.m;
                    c.globals.isXNumeric && (s = (c.globals.seriesX[l][p] - c.globals.minX) / this.xRatio - n / 2);
                    var L = s + n * this.visibleI;
                    this.series[g][p] === void 0 || this.series[g][p] === null ? (k = o, S = o) : (k = o - k / A, S = o - S / A, x = o - u.h / A, v = o - u.l / A, C = o - u.m / A);
                    var I = d.move(L, o), z = d.move(L + n / 2, k);
                    return c.globals.previousPaths.length > 0 && (z = this.getPreviousPath(l, p, !0)), I = this.isBoxPlot ? [
                        d.move(L, k) + d.line(L + n / 2, k) + d.line(L + n / 2, x) + d.line(L + n / 4, x) + d.line(L + n - n / 4, x) + d.line(L + n / 2, x) + d.line(L + n / 2, k) + d.line(L + n, k) + d.line(L + n, C) + d.line(L, C) + d.line(L, k + h / 2),
                        d.move(L, C) + d.line(L + n, C) + d.line(L + n, S) + d.line(L + n / 2, S) + d.line(L + n / 2, v) + d.line(L + n - n / 4, v) + d.line(L + n / 4, v) + d.line(L + n / 2, v) + d.line(L + n / 2, S) + d.line(L, S) + d.line(L, C) + "z"
                    ] : [
                        d.move(L, S) + d.line(L + n / 2, S) + d.line(L + n / 2, x) + d.line(L + n / 2, S) + d.line(L + n, S) + d.line(L + n, k) + d.line(L + n / 2, k) + d.line(L + n / 2, v) + d.line(L + n / 2, k) + d.line(L, k) + d.line(L, S - h / 2)
                    ], z += d.move(L, k), c.globals.isXNumeric || (s += r), {
                        pathTo: I,
                        pathFrom: z,
                        x: s,
                        y: S,
                        barXPosition: L,
                        color: this.isBoxPlot ? w : f ? [
                            b
                        ] : [
                            m
                        ]
                    };
                }
            },
            {
                key: "drawHorizontalBoxPaths",
                value: function(i) {
                    var a = i.indexes;
                    i.x;
                    var s = i.y, r = i.yDivision, n = i.barHeight, o = i.zeroW, h = i.strokeWidth, c = this.w, d = new M(this.ctx), g = a.i, p = a.j, f = this.boxOptions.colors.lower;
                    this.isBoxPlot && (f = [
                        this.boxOptions.colors.lower,
                        this.boxOptions.colors.upper
                    ]);
                    var b = this.invertedYRatio, m = a.realIndex, w = this.getOHLCValue(m, p), A = o, l = o, u = Math.min(w.o, w.c), x = Math.max(w.o, w.c), v = w.m;
                    c.globals.isXNumeric && (s = (c.globals.seriesX[m][p] - c.globals.minX) / this.invertedXRatio - n / 2);
                    var k = s + n * this.visibleI;
                    this.series[g][p] === void 0 || this.series[g][p] === null ? (u = o, x = o) : (u = o + u / b, x = o + x / b, A = o + w.h / b, l = o + w.l / b, v = o + w.m / b);
                    var S = d.move(o, k), C = d.move(u, k + n / 2);
                    return c.globals.previousPaths.length > 0 && (C = this.getPreviousPath(m, p, !0)), S = [
                        d.move(u, k) + d.line(u, k + n / 2) + d.line(A, k + n / 2) + d.line(A, k + n / 2 - n / 4) + d.line(A, k + n / 2 + n / 4) + d.line(A, k + n / 2) + d.line(u, k + n / 2) + d.line(u, k + n) + d.line(v, k + n) + d.line(v, k) + d.line(u + h / 2, k),
                        d.move(v, k) + d.line(v, k + n) + d.line(x, k + n) + d.line(x, k + n / 2) + d.line(l, k + n / 2) + d.line(l, k + n - n / 4) + d.line(l, k + n / 4) + d.line(l, k + n / 2) + d.line(x, k + n / 2) + d.line(x, k) + d.line(v, k) + "z"
                    ], C += d.move(u, k), c.globals.isXNumeric || (s += r), {
                        pathTo: S,
                        pathFrom: C,
                        x: x,
                        y: s,
                        barYPosition: k,
                        color: f
                    };
                }
            },
            {
                key: "getOHLCValue",
                value: function(i, a) {
                    var s = this.w;
                    return {
                        o: this.isBoxPlot ? s.globals.seriesCandleH[i][a] : s.globals.seriesCandleO[i][a],
                        h: this.isBoxPlot ? s.globals.seriesCandleO[i][a] : s.globals.seriesCandleH[i][a],
                        m: s.globals.seriesCandleM[i][a],
                        l: this.isBoxPlot ? s.globals.seriesCandleC[i][a] : s.globals.seriesCandleL[i][a],
                        c: this.isBoxPlot ? s.globals.seriesCandleL[i][a] : s.globals.seriesCandleC[i][a]
                    };
                }
            }
        ]), t;
    }(), rt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "checkColorRange",
                value: function() {
                    var e = this.w, t = !1, i = e.config.plotOptions[e.config.chart.type];
                    return i.colorScale.ranges.length > 0 && i.colorScale.ranges.map(function(a, s) {
                        a.from <= 0 && (t = !0);
                    }), t;
                }
            },
            {
                key: "getShadeColor",
                value: function(e, t, i, a) {
                    var s = this.w, r = 1, n = s.config.plotOptions[e].shadeIntensity, o = this.determineColor(e, t, i);
                    s.globals.hasNegs || a ? r = s.config.plotOptions[e].reverseNegativeShade ? o.percent < 0 ? o.percent / 100 * (1.25 * n) : (1 - o.percent / 100) * (1.25 * n) : o.percent <= 0 ? 1 - (1 + o.percent / 100) * n : (1 - o.percent / 100) * n : (r = 1 - o.percent / 100, e === "treemap" && (r = (1 - o.percent / 100) * (1.25 * n)));
                    var h = o.color, c = new P();
                    return s.config.plotOptions[e].enableShades && (h = this.w.config.theme.mode === "dark" ? P.hexToRgba(c.shadeColor(-1 * r, o.color), s.config.fill.opacity) : P.hexToRgba(c.shadeColor(r, o.color), s.config.fill.opacity)), {
                        color: h,
                        colorProps: o
                    };
                }
            },
            {
                key: "determineColor",
                value: function(e, t, i) {
                    var a = this.w, s = a.globals.series[t][i], r = a.config.plotOptions[e], n = r.colorScale.inverse ? i : t;
                    r.distributed && a.config.chart.type === "treemap" && (n = i);
                    var o = a.globals.colors[n], h = null, c = Math.min.apply(Math, J(a.globals.series[t])), d = Math.max.apply(Math, J(a.globals.series[t]));
                    r.distributed || e !== "heatmap" || (c = a.globals.minY, d = a.globals.maxY), r.colorScale.min !== void 0 && (c = r.colorScale.min < a.globals.minY ? r.colorScale.min : a.globals.minY, d = r.colorScale.max > a.globals.maxY ? r.colorScale.max : a.globals.maxY);
                    var g = Math.abs(d) + Math.abs(c), p = 100 * s / (g === 0 ? g - 1e-6 : g);
                    return r.colorScale.ranges.length > 0 && r.colorScale.ranges.map(function(f, b) {
                        if (s >= f.from && s <= f.to) {
                            o = f.color, h = f.foreColor ? f.foreColor : null, c = f.from, d = f.to;
                            var m = Math.abs(d) + Math.abs(c);
                            p = 100 * s / (m === 0 ? m - 1e-6 : m);
                        }
                    }), {
                        color: o,
                        foreColor: h,
                        percent: p
                    };
                }
            },
            {
                key: "calculateDataLabels",
                value: function(e) {
                    var t = e.text, i = e.x, a = e.y, s = e.i, r = e.j, n = e.colorProps, o = e.fontSize, h = this.w.config.dataLabels, c = new M(this.ctx), d = new ye(this.ctx), g = null;
                    if (h.enabled) {
                        g = c.group({
                            class: "apexcharts-data-labels"
                        });
                        var p = h.offsetX, f = h.offsetY, b = i + p, m = a + parseFloat(h.style.fontSize) / 3 + f;
                        d.plotDataLabelsText({
                            x: b,
                            y: m,
                            text: t,
                            i: s,
                            j: r,
                            color: n.foreColor,
                            parent: g,
                            fontSize: o,
                            dataLabelsConfig: h
                        });
                    }
                    return g;
                }
            },
            {
                key: "addListeners",
                value: function(e) {
                    var t = new M(this.ctx);
                    e.node.addEventListener("mouseenter", t.pathMouseEnter.bind(this, e)), e.node.addEventListener("mouseleave", t.pathMouseLeave.bind(this, e)), e.node.addEventListener("mousedown", t.pathMouseDown.bind(this, e));
                }
            }
        ]), y;
    }(), Yt = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.w = e.w, this.xRatio = t.xRatio, this.yRatio = t.yRatio, this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.helpers = new rt(e), this.rectRadius = this.w.config.plotOptions.heatmap.radius, this.strokeWidth = this.w.config.stroke.show ? this.w.config.stroke.width : 0;
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx), a = i.group({
                        class: "apexcharts-heatmap"
                    });
                    a.attr("clip-path", "url(#gridRectMask".concat(t.globals.cuid, ")"));
                    var s = t.globals.gridWidth / t.globals.dataPoints, r = t.globals.gridHeight / t.globals.series.length, n = 0, o = !1;
                    this.negRange = this.helpers.checkColorRange();
                    var h = e.slice();
                    t.config.yaxis[0].reversed && (o = !0, h.reverse());
                    for(var c = o ? 0 : h.length - 1; o ? c < h.length : c >= 0; o ? c++ : c--){
                        var d = i.group({
                            class: "apexcharts-series apexcharts-heatmap-series",
                            seriesName: P.escapeString(t.globals.seriesNames[c]),
                            rel: c + 1,
                            "data:realIndex": c
                        });
                        if (this.ctx.series.addCollapsedClassToSeries(d, c), t.config.chart.dropShadow.enabled) {
                            var g = t.config.chart.dropShadow;
                            new Z(this.ctx).dropShadow(d, g, c);
                        }
                        for(var p = 0, f = t.config.plotOptions.heatmap.shadeIntensity, b = 0; b < h[c].length; b++){
                            var m = this.helpers.getShadeColor(t.config.chart.type, c, b, this.negRange), w = m.color, A = m.colorProps;
                            t.config.fill.type === "image" && (w = new ae(this.ctx).fillPath({
                                seriesNumber: c,
                                dataPointIndex: b,
                                opacity: t.globals.hasNegs ? A.percent < 0 ? 1 - (1 + A.percent / 100) : f + A.percent / 100 : A.percent / 100,
                                patternID: P.randomId(),
                                width: t.config.fill.image.width ? t.config.fill.image.width : s,
                                height: t.config.fill.image.height ? t.config.fill.image.height : r
                            }));
                            var l = this.rectRadius, u = i.drawRect(p, n, s, r, l);
                            if (u.attr({
                                cx: p,
                                cy: n
                            }), u.node.classList.add("apexcharts-heatmap-rect"), d.add(u), u.attr({
                                fill: w,
                                i: c,
                                index: c,
                                j: b,
                                val: e[c][b],
                                "stroke-width": this.strokeWidth,
                                stroke: t.config.plotOptions.heatmap.useFillColorAsStroke ? w : t.globals.stroke.colors[0],
                                color: w
                            }), this.helpers.addListeners(u), t.config.chart.animations.enabled && !t.globals.dataChanged) {
                                var x = 1;
                                t.globals.resized || (x = t.config.chart.animations.speed), this.animateHeatMap(u, p, n, s, r, x);
                            }
                            if (t.globals.dataChanged) {
                                var v = 1;
                                if (this.dynamicAnim.enabled && t.globals.shouldAnimate) {
                                    v = this.dynamicAnim.speed;
                                    var k = t.globals.previousPaths[c] && t.globals.previousPaths[c][b] && t.globals.previousPaths[c][b].color;
                                    k || (k = "rgba(255, 255, 255, 0)"), this.animateHeatColor(u, P.isColorHex(k) ? k : P.rgb2hex(k), P.isColorHex(w) ? w : P.rgb2hex(w), v);
                                }
                            }
                            var S = (0, t.config.dataLabels.formatter)(t.globals.series[c][b], {
                                value: t.globals.series[c][b],
                                seriesIndex: c,
                                dataPointIndex: b,
                                w: t
                            }), C = this.helpers.calculateDataLabels({
                                text: S,
                                x: p + s / 2,
                                y: n + r / 2,
                                i: c,
                                j: b,
                                colorProps: A,
                                series: h
                            });
                            C !== null && d.add(C), p += s;
                        }
                        n += r, a.add(d);
                    }
                    var L = t.globals.yAxisScale[0].result.slice();
                    return t.config.yaxis[0].reversed ? L.unshift("") : L.push(""), t.globals.yAxisScale[0].result = L, a;
                }
            },
            {
                key: "animateHeatMap",
                value: function(e, t, i, a, s, r) {
                    var n = new de(this.ctx);
                    n.animateRect(e, {
                        x: t + a / 2,
                        y: i + s / 2,
                        width: 0,
                        height: 0
                    }, {
                        x: t,
                        y: i,
                        width: a,
                        height: s
                    }, r, function() {
                        n.animationCompleted(e);
                    });
                }
            },
            {
                key: "animateHeatColor",
                value: function(e, t, i, a) {
                    e.attr({
                        fill: t
                    }).animate(a).attr({
                        fill: i
                    });
                }
            }
        ]), y;
    }(), nt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "drawYAxisTexts",
                value: function(e, t, i, a) {
                    var s = this.w, r = s.config.yaxis[0], n = s.globals.yLabelFormatters[0];
                    return new M(this.ctx).drawText({
                        x: e + r.labels.offsetX,
                        y: t + r.labels.offsetY,
                        text: n(a, i),
                        textAnchor: "middle",
                        fontSize: r.labels.style.fontSize,
                        fontFamily: r.labels.style.fontFamily,
                        foreColor: Array.isArray(r.labels.style.colors) ? r.labels.style.colors[i] : r.labels.style.colors
                    });
                }
            }
        ]), y;
    }(), ot = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
            var t = this.w;
            this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animBeginArr = [
                0
            ], this.animDur = 0, this.donutDataLabels = this.w.config.plotOptions.pie.donut.labels, this.lineColorArr = t.globals.stroke.colors !== void 0 ? t.globals.stroke.colors : t.globals.colors, this.defaultSize = Math.min(t.globals.gridWidth, t.globals.gridHeight), this.centerY = this.defaultSize / 2, this.centerX = t.globals.gridWidth / 2, t.config.chart.type === "radialBar" ? this.fullAngle = 360 : this.fullAngle = Math.abs(t.config.plotOptions.pie.endAngle - t.config.plotOptions.pie.startAngle), this.initialAngle = t.config.plotOptions.pie.startAngle % this.fullAngle, t.globals.radialSize = this.defaultSize / 2.05 - t.config.stroke.width - (t.config.chart.sparkline.enabled ? 0 : t.config.chart.dropShadow.blur), this.donutSize = t.globals.radialSize * parseInt(t.config.plotOptions.pie.donut.size, 10) / 100, this.maxY = 0, this.sliceLabels = [], this.sliceSizes = [], this.prevSectorAngleArr = [];
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e) {
                    var t = this, i = this.w, a = new M(this.ctx);
                    if (this.ret = a.group({
                        class: "apexcharts-pie"
                    }), i.globals.noData) return this.ret;
                    for(var s = 0, r = 0; r < e.length; r++)s += P.negToZero(e[r]);
                    var n = [], o = a.group();
                    s === 0 && (s = 1e-5), e.forEach(function(k) {
                        t.maxY = Math.max(t.maxY, k);
                    }), i.config.yaxis[0].max && (this.maxY = i.config.yaxis[0].max), i.config.grid.position === "back" && this.chartType === "polarArea" && this.drawPolarElements(this.ret);
                    for(var h = 0; h < e.length; h++){
                        var c = this.fullAngle * P.negToZero(e[h]) / s;
                        n.push(c), this.chartType === "polarArea" ? (n[h] = this.fullAngle / e.length, this.sliceSizes.push(i.globals.radialSize * e[h] / this.maxY)) : this.sliceSizes.push(i.globals.radialSize);
                    }
                    if (i.globals.dataChanged) {
                        for(var d, g = 0, p = 0; p < i.globals.previousPaths.length; p++)g += P.negToZero(i.globals.previousPaths[p]);
                        for(var f = 0; f < i.globals.previousPaths.length; f++)d = this.fullAngle * P.negToZero(i.globals.previousPaths[f]) / g, this.prevSectorAngleArr.push(d);
                    }
                    this.donutSize < 0 && (this.donutSize = 0);
                    var b = i.config.plotOptions.pie.customScale, m = i.globals.gridWidth / 2, w = i.globals.gridHeight / 2, A = m - i.globals.gridWidth / 2 * b, l = w - i.globals.gridHeight / 2 * b;
                    if (this.chartType === "donut") {
                        var u = a.drawCircle(this.donutSize);
                        u.attr({
                            cx: this.centerX,
                            cy: this.centerY,
                            fill: i.config.plotOptions.pie.donut.background ? i.config.plotOptions.pie.donut.background : "transparent"
                        }), o.add(u);
                    }
                    var x = this.drawArcs(n, e);
                    if (this.sliceLabels.forEach(function(k) {
                        x.add(k);
                    }), o.attr({
                        transform: "translate(".concat(A, ", ").concat(l, ") scale(").concat(b, ")")
                    }), o.add(x), this.ret.add(o), this.donutDataLabels.show) {
                        var v = this.renderInnerDataLabels(this.donutDataLabels, {
                            hollowSize: this.donutSize,
                            centerX: this.centerX,
                            centerY: this.centerY,
                            opacity: this.donutDataLabels.show,
                            translateX: A,
                            translateY: l
                        });
                        this.ret.add(v);
                    }
                    return i.config.grid.position === "front" && this.chartType === "polarArea" && this.drawPolarElements(this.ret), this.ret;
                }
            },
            {
                key: "drawArcs",
                value: function(e, t) {
                    var i = this.w, a = new Z(this.ctx), s = new M(this.ctx), r = new ae(this.ctx), n = s.group({
                        class: "apexcharts-slices"
                    }), o = this.initialAngle, h = this.initialAngle, c = this.initialAngle, d = this.initialAngle;
                    this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0;
                    for(var g = 0; g < e.length; g++){
                        var p = s.group({
                            class: "apexcharts-series apexcharts-pie-series",
                            seriesName: P.escapeString(i.globals.seriesNames[g]),
                            rel: g + 1,
                            "data:realIndex": g
                        });
                        n.add(p), h = d, c = (o = c) + e[g], d = h + this.prevSectorAngleArr[g];
                        var f = c < o ? this.fullAngle + c - o : c - o, b = r.fillPath({
                            seriesNumber: g,
                            size: this.sliceSizes[g],
                            value: t[g]
                        }), m = this.getChangedPath(h, d), w = s.drawPath({
                            d: m,
                            stroke: Array.isArray(this.lineColorArr) ? this.lineColorArr[g] : this.lineColorArr,
                            strokeWidth: 0,
                            fill: b,
                            fillOpacity: i.config.fill.opacity,
                            classes: "apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(g)
                        });
                        if (w.attr({
                            index: 0,
                            j: g
                        }), a.setSelectionFilter(w, 0, g), i.config.chart.dropShadow.enabled) {
                            var A = i.config.chart.dropShadow;
                            a.dropShadow(w, A, g);
                        }
                        this.addListeners(w, this.donutDataLabels), M.setAttrs(w.node, {
                            "data:angle": f,
                            "data:startAngle": o,
                            "data:strokeWidth": this.strokeWidth,
                            "data:value": t[g]
                        });
                        var l = {
                            x: 0,
                            y: 0
                        };
                        this.chartType === "pie" || this.chartType === "polarArea" ? l = P.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize / 1.25 + i.config.plotOptions.pie.dataLabels.offset, (o + f / 2) % this.fullAngle) : this.chartType === "donut" && (l = P.polarToCartesian(this.centerX, this.centerY, (i.globals.radialSize + this.donutSize) / 2 + i.config.plotOptions.pie.dataLabels.offset, (o + f / 2) % this.fullAngle)), p.add(w);
                        var u = 0;
                        if (!this.initialAnim || i.globals.resized || i.globals.dataChanged ? this.animBeginArr.push(0) : ((u = f / this.fullAngle * i.config.chart.animations.speed) === 0 && (u = 1), this.animDur = u + this.animDur, this.animBeginArr.push(this.animDur)), this.dynamicAnim && i.globals.dataChanged ? this.animatePaths(w, {
                            size: this.sliceSizes[g],
                            endAngle: c,
                            startAngle: o,
                            prevStartAngle: h,
                            prevEndAngle: d,
                            animateStartingPos: !0,
                            i: g,
                            animBeginArr: this.animBeginArr,
                            shouldSetPrevPaths: !0,
                            dur: i.config.chart.animations.dynamicAnimation.speed
                        }) : this.animatePaths(w, {
                            size: this.sliceSizes[g],
                            endAngle: c,
                            startAngle: o,
                            i: g,
                            totalItems: e.length - 1,
                            animBeginArr: this.animBeginArr,
                            dur: u
                        }), i.config.plotOptions.pie.expandOnClick && this.chartType !== "polarArea" && w.click(this.pieClicked.bind(this, g)), i.globals.selectedDataPoints[0] !== void 0 && i.globals.selectedDataPoints[0].indexOf(g) > -1 && this.pieClicked(g), i.config.dataLabels.enabled) {
                            var x = l.x, v = l.y, k = 100 * f / this.fullAngle + "%";
                            if (f !== 0 && i.config.plotOptions.pie.dataLabels.minAngleToShowLabel < e[g]) {
                                var S = i.config.dataLabels.formatter;
                                S !== void 0 && (k = S(i.globals.seriesPercent[g][0], {
                                    seriesIndex: g,
                                    w: i
                                }));
                                var C = i.globals.dataLabels.style.colors[g], L = s.group({
                                    class: "apexcharts-datalabels"
                                }), I = s.drawText({
                                    x: x,
                                    y: v,
                                    text: k,
                                    textAnchor: "middle",
                                    fontSize: i.config.dataLabels.style.fontSize,
                                    fontFamily: i.config.dataLabels.style.fontFamily,
                                    fontWeight: i.config.dataLabels.style.fontWeight,
                                    foreColor: C
                                });
                                if (L.add(I), i.config.dataLabels.dropShadow.enabled) {
                                    var z = i.config.dataLabels.dropShadow;
                                    a.dropShadow(I, z);
                                }
                                I.node.classList.add("apexcharts-pie-label"), i.config.chart.animations.animate && i.globals.resized === !1 && (I.node.classList.add("apexcharts-pie-label-delay"), I.node.style.animationDelay = i.config.chart.animations.speed / 940 + "s"), this.sliceLabels.push(L);
                            }
                        }
                    }
                    return n;
                }
            },
            {
                key: "addListeners",
                value: function(e, t) {
                    var i = new M(this.ctx);
                    e.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this, e)), e.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this, e)), e.node.addEventListener("mouseleave", this.revertDataLabelsInner.bind(this, e.node, t)), e.node.addEventListener("mousedown", i.pathMouseDown.bind(this, e)), this.donutDataLabels.total.showAlways || (e.node.addEventListener("mouseenter", this.printDataLabelsInner.bind(this, e.node, t)), e.node.addEventListener("mousedown", this.printDataLabelsInner.bind(this, e.node, t)));
                }
            },
            {
                key: "animatePaths",
                value: function(e, t) {
                    var i = this.w, a = t.endAngle < t.startAngle ? this.fullAngle + t.endAngle - t.startAngle : t.endAngle - t.startAngle, s = a, r = t.startAngle, n = t.startAngle;
                    t.prevStartAngle !== void 0 && t.prevEndAngle !== void 0 && (r = t.prevEndAngle, s = t.prevEndAngle < t.prevStartAngle ? this.fullAngle + t.prevEndAngle - t.prevStartAngle : t.prevEndAngle - t.prevStartAngle), t.i === i.config.series.length - 1 && (a + n > this.fullAngle ? t.endAngle = t.endAngle - (a + n) : a + n < this.fullAngle && (t.endAngle = t.endAngle + (this.fullAngle - (a + n)))), a === this.fullAngle && (a = this.fullAngle - 0.01), this.animateArc(e, r, n, a, s, t);
                }
            },
            {
                key: "animateArc",
                value: function(e, t, i, a, s, r) {
                    var n, o = this, h = this.w, c = new de(this.ctx), d = r.size;
                    (isNaN(t) || isNaN(s)) && (t = i, s = a, r.dur = 0);
                    var g = a, p = i, f = t < i ? this.fullAngle + t - i : t - i;
                    h.globals.dataChanged && r.shouldSetPrevPaths && r.prevEndAngle && (n = o.getPiePath({
                        me: o,
                        startAngle: r.prevStartAngle,
                        angle: r.prevEndAngle < r.prevStartAngle ? this.fullAngle + r.prevEndAngle - r.prevStartAngle : r.prevEndAngle - r.prevStartAngle,
                        size: d
                    }), e.attr({
                        d: n
                    })), r.dur !== 0 ? e.animate(r.dur, h.globals.easing, r.animBeginArr[r.i]).afterAll(function() {
                        o.chartType !== "pie" && o.chartType !== "donut" && o.chartType !== "polarArea" || this.animate(h.config.chart.animations.dynamicAnimation.speed).attr({
                            "stroke-width": o.strokeWidth
                        }), r.i === h.config.series.length - 1 && c.animationCompleted(e);
                    }).during(function(b) {
                        g = f + (a - f) * b, r.animateStartingPos && (g = s + (a - s) * b, p = t - s + (i - (t - s)) * b), n = o.getPiePath({
                            me: o,
                            startAngle: p,
                            angle: g,
                            size: d
                        }), e.node.setAttribute("data:pathOrig", n), e.attr({
                            d: n
                        });
                    }) : (n = o.getPiePath({
                        me: o,
                        startAngle: p,
                        angle: a,
                        size: d
                    }), r.isTrack || (h.globals.animationEnded = !0), e.node.setAttribute("data:pathOrig", n), e.attr({
                        d: n,
                        "stroke-width": o.strokeWidth
                    }));
                }
            },
            {
                key: "pieClicked",
                value: function(e) {
                    var t, i = this.w, a = this, s = a.sliceSizes[e] + (i.config.plotOptions.pie.expandOnClick ? 4 : 0), r = i.globals.dom.Paper.select(".apexcharts-".concat(a.chartType.toLowerCase(), "-slice-").concat(e)).members[0];
                    if (r.attr("data:pieClicked") !== "true") {
                        var n = i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");
                        Array.prototype.forEach.call(n, function(d) {
                            d.setAttribute("data:pieClicked", "false");
                            var g = d.getAttribute("data:pathOrig");
                            g && d.setAttribute("d", g);
                        }), r.attr("data:pieClicked", "true");
                        var o = parseInt(r.attr("data:startAngle"), 10), h = parseInt(r.attr("data:angle"), 10);
                        t = a.getPiePath({
                            me: a,
                            startAngle: o,
                            angle: h,
                            size: s
                        }), h !== 360 && r.plot(t);
                    } else {
                        r.attr({
                            "data:pieClicked": "false"
                        }), this.revertDataLabelsInner(r.node, this.donutDataLabels);
                        var c = r.attr("data:pathOrig");
                        r.attr({
                            d: c
                        });
                    }
                }
            },
            {
                key: "getChangedPath",
                value: function(e, t) {
                    var i = "";
                    return this.dynamicAnim && this.w.globals.dataChanged && (i = this.getPiePath({
                        me: this,
                        startAngle: e,
                        angle: t - e,
                        size: this.size
                    })), i;
                }
            },
            {
                key: "getPiePath",
                value: function(e) {
                    var t, i = e.me, a = e.startAngle, s = e.angle, r = e.size, n = new M(this.ctx), o = a, h = Math.PI * (o - 90) / 180, c = s + a;
                    Math.ceil(c) >= this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle && (c = this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle - 0.01), Math.ceil(c) > this.fullAngle && (c -= this.fullAngle);
                    var d = Math.PI * (c - 90) / 180, g = i.centerX + r * Math.cos(h), p = i.centerY + r * Math.sin(h), f = i.centerX + r * Math.cos(d), b = i.centerY + r * Math.sin(d), m = P.polarToCartesian(i.centerX, i.centerY, i.donutSize, c), w = P.polarToCartesian(i.centerX, i.centerY, i.donutSize, o), A = s > 180 ? 1 : 0, l = [
                        "M",
                        g,
                        p,
                        "A",
                        r,
                        r,
                        0,
                        A,
                        1,
                        f,
                        b
                    ];
                    return t = i.chartType === "donut" ? [].concat(l, [
                        "L",
                        m.x,
                        m.y,
                        "A",
                        i.donutSize,
                        i.donutSize,
                        0,
                        A,
                        0,
                        w.x,
                        w.y,
                        "L",
                        g,
                        p,
                        "z"
                    ]).join(" ") : i.chartType === "pie" || i.chartType === "polarArea" ? [].concat(l, [
                        "L",
                        i.centerX,
                        i.centerY,
                        "L",
                        g,
                        p
                    ]).join(" ") : [].concat(l).join(" "), n.roundPathCorners(t, 2 * this.strokeWidth);
                }
            },
            {
                key: "drawPolarElements",
                value: function(e) {
                    var t = this.w, i = new we(this.ctx), a = new M(this.ctx), s = new nt(this.ctx), r = a.group(), n = a.group(), o = i.niceScale(0, Math.ceil(this.maxY), t.config.yaxis[0].tickAmount, 0, !0), h = o.result.reverse(), c = o.result.length;
                    this.maxY = o.niceMax;
                    for(var d = t.globals.radialSize, g = d / (c - 1), p = 0; p < c - 1; p++){
                        var f = a.drawCircle(d);
                        if (f.attr({
                            cx: this.centerX,
                            cy: this.centerY,
                            fill: "none",
                            "stroke-width": t.config.plotOptions.polarArea.rings.strokeWidth,
                            stroke: t.config.plotOptions.polarArea.rings.strokeColor
                        }), t.config.yaxis[0].show) {
                            var b = s.drawYAxisTexts(this.centerX, this.centerY - d + parseInt(t.config.yaxis[0].labels.style.fontSize, 10) / 2, p, h[p]);
                            n.add(b);
                        }
                        r.add(f), d -= g;
                    }
                    this.drawSpokes(e), e.add(r), e.add(n);
                }
            },
            {
                key: "renderInnerDataLabels",
                value: function(e, t) {
                    var i = this.w, a = new M(this.ctx), s = a.group({
                        class: "apexcharts-datalabels-group",
                        transform: "translate(".concat(t.translateX ? t.translateX : 0, ", ").concat(t.translateY ? t.translateY : 0, ") scale(").concat(i.config.plotOptions.pie.customScale, ")")
                    }), r = e.total.show;
                    s.node.style.opacity = t.opacity;
                    var n, o, h = t.centerX, c = t.centerY;
                    n = e.name.color === void 0 ? i.globals.colors[0] : e.name.color;
                    var d = e.name.fontSize, g = e.name.fontFamily, p = e.name.fontWeight;
                    o = e.value.color === void 0 ? i.config.chart.foreColor : e.value.color;
                    var f = e.value.formatter, b = "", m = "";
                    if (r ? (n = e.total.color, d = e.total.fontSize, g = e.total.fontFamily, p = e.total.fontWeight, m = e.total.label, b = e.total.formatter(i)) : i.globals.series.length === 1 && (b = f(i.globals.series[0], i), m = i.globals.seriesNames[0]), m && (m = e.name.formatter(m, e.total.show, i)), e.name.show) {
                        var w = a.drawText({
                            x: h,
                            y: c + parseFloat(e.name.offsetY),
                            text: m,
                            textAnchor: "middle",
                            foreColor: n,
                            fontSize: d,
                            fontWeight: p,
                            fontFamily: g
                        });
                        w.node.classList.add("apexcharts-datalabel-label"), s.add(w);
                    }
                    if (e.value.show) {
                        var A = e.name.show ? parseFloat(e.value.offsetY) + 16 : e.value.offsetY, l = a.drawText({
                            x: h,
                            y: c + A,
                            text: b,
                            textAnchor: "middle",
                            foreColor: o,
                            fontWeight: e.value.fontWeight,
                            fontSize: e.value.fontSize,
                            fontFamily: e.value.fontFamily
                        });
                        l.node.classList.add("apexcharts-datalabel-value"), s.add(l);
                    }
                    return s;
                }
            },
            {
                key: "printInnerLabels",
                value: function(e, t, i, a) {
                    var s, r = this.w;
                    a ? s = e.name.color === void 0 ? r.globals.colors[parseInt(a.parentNode.getAttribute("rel"), 10) - 1] : e.name.color : r.globals.series.length > 1 && e.total.show && (s = e.total.color);
                    var n = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"), o = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");
                    i = (0, e.value.formatter)(i, r), a || typeof e.total.formatter != "function" || (i = e.total.formatter(r));
                    var h = t === e.total.label;
                    t = e.name.formatter(t, h, r), n !== null && (n.textContent = t), o !== null && (o.textContent = i), n !== null && (n.style.fill = s);
                }
            },
            {
                key: "printDataLabelsInner",
                value: function(e, t) {
                    var i = this.w, a = e.getAttribute("data:value"), s = i.globals.seriesNames[parseInt(e.parentNode.getAttribute("rel"), 10) - 1];
                    i.globals.series.length > 1 && this.printInnerLabels(t, s, a, e);
                    var r = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");
                    r !== null && (r.style.opacity = 1);
                }
            },
            {
                key: "drawSpokes",
                value: function(e) {
                    var t = this, i = this.w, a = new M(this.ctx), s = i.config.plotOptions.polarArea.spokes;
                    if (s.strokeWidth !== 0) {
                        for(var r = [], n = 360 / i.globals.series.length, o = 0; o < i.globals.series.length; o++)r.push(P.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize, i.config.plotOptions.pie.startAngle + n * o));
                        r.forEach(function(h, c) {
                            var d = a.drawLine(h.x, h.y, t.centerX, t.centerY, Array.isArray(s.connectorColors) ? s.connectorColors[c] : s.connectorColors);
                            e.add(d);
                        });
                    }
                }
            },
            {
                key: "revertDataLabelsInner",
                value: function(e, t, i) {
                    var a = this, s = this.w, r = s.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group"), n = !1, o = s.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area"), h = function(g) {
                        var p = g.makeSliceOut, f = g.printLabel;
                        Array.prototype.forEach.call(o, function(b) {
                            b.getAttribute("data:pieClicked") === "true" && (p && (n = !0), f && a.printDataLabelsInner(b, t));
                        });
                    };
                    if (h({
                        makeSliceOut: !0,
                        printLabel: !1
                    }), t.total.show && s.globals.series.length > 1) n && !t.total.showAlways ? h({
                        makeSliceOut: !1,
                        printLabel: !0
                    }) : this.printInnerLabels(t, t.total.label, t.total.formatter(s));
                    else if (h({
                        makeSliceOut: !1,
                        printLabel: !0
                    }), !n) {
                        if (s.globals.selectedDataPoints.length && s.globals.series.length > 1) {
                            if (s.globals.selectedDataPoints[0].length > 0) {
                                var c = s.globals.selectedDataPoints[0], d = s.globals.dom.baseEl.querySelector(".apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(c));
                                this.printDataLabelsInner(d, t);
                            } else r && s.globals.selectedDataPoints.length && s.globals.selectedDataPoints[0].length === 0 && (r.style.opacity = 0);
                        } else r && s.globals.series.length > 1 && (r.style.opacity = 0);
                    }
                }
            }
        ]), y;
    }(), Ft = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animDur = 0;
            var t = this.w;
            this.graphics = new M(this.ctx), this.lineColorArr = t.globals.stroke.colors !== void 0 ? t.globals.stroke.colors : t.globals.colors, this.defaultSize = t.globals.svgHeight < t.globals.svgWidth ? t.globals.gridHeight + 1.5 * t.globals.goldenPadding : t.globals.gridWidth, this.isLog = t.config.yaxis[0].logarithmic, this.coreUtils = new q(this.ctx), this.maxValue = this.isLog ? this.coreUtils.getLogVal(t.globals.maxY, 0) : t.globals.maxY, this.minValue = this.isLog ? this.coreUtils.getLogVal(this.w.globals.minY, 0) : t.globals.minY, this.polygons = t.config.plotOptions.radar.polygons, this.strokeWidth = t.config.stroke.show ? t.config.stroke.width : 0, this.size = this.defaultSize / 2.1 - this.strokeWidth - t.config.chart.dropShadow.blur, t.config.xaxis.labels.show && (this.size = this.size - t.globals.xAxisLabelsWidth / 1.75), t.config.plotOptions.radar.size !== void 0 && (this.size = t.config.plotOptions.radar.size), this.dataRadiusOfPercent = [], this.dataRadius = [], this.angleArr = [], this.yaxisLabelsTextsPos = [];
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e) {
                    var t = this, i = this.w, a = new ae(this.ctx), s = [], r = new ye(this.ctx);
                    e.length && (this.dataPointsLen = e[i.globals.maxValsInArrayIndex].length), this.disAngle = 2 * Math.PI / this.dataPointsLen;
                    var n = i.globals.gridWidth / 2, o = i.globals.gridHeight / 2, h = n + i.config.plotOptions.radar.offsetX, c = o + i.config.plotOptions.radar.offsetY, d = this.graphics.group({
                        class: "apexcharts-radar-series apexcharts-plot-series",
                        transform: "translate(".concat(h || 0, ", ").concat(c || 0, ")")
                    }), g = [], p = null, f = null;
                    if (this.yaxisLabels = this.graphics.group({
                        class: "apexcharts-yaxis"
                    }), e.forEach(function(m, w) {
                        var A = m.length === i.globals.dataPoints, l = t.graphics.group().attr({
                            class: "apexcharts-series",
                            "data:longestSeries": A,
                            seriesName: P.escapeString(i.globals.seriesNames[w]),
                            rel: w + 1,
                            "data:realIndex": w
                        });
                        t.dataRadiusOfPercent[w] = [], t.dataRadius[w] = [], t.angleArr[w] = [], m.forEach(function(T, E) {
                            var R = Math.abs(t.maxValue - t.minValue);
                            T += Math.abs(t.minValue), t.isLog && (T = t.coreUtils.getLogVal(T, 0)), t.dataRadiusOfPercent[w][E] = T / R, t.dataRadius[w][E] = t.dataRadiusOfPercent[w][E] * t.size, t.angleArr[w][E] = E * t.disAngle;
                        }), g = t.getDataPointsPos(t.dataRadius[w], t.angleArr[w]);
                        var u = t.createPaths(g, {
                            x: 0,
                            y: 0
                        });
                        p = t.graphics.group({
                            class: "apexcharts-series-markers-wrap apexcharts-element-hidden"
                        }), f = t.graphics.group({
                            class: "apexcharts-datalabels",
                            "data:realIndex": w
                        }), i.globals.delayedElements.push({
                            el: p.node,
                            index: w
                        });
                        var x = {
                            i: w,
                            realIndex: w,
                            animationDelay: w,
                            initialSpeed: i.config.chart.animations.speed,
                            dataChangeSpeed: i.config.chart.animations.dynamicAnimation.speed,
                            className: "apexcharts-radar",
                            shouldClipToGrid: !1,
                            bindEventsOnPaths: !1,
                            stroke: i.globals.stroke.colors[w],
                            strokeLineCap: i.config.stroke.lineCap
                        }, v = null;
                        i.globals.previousPaths.length > 0 && (v = t.getPreviousPath(w));
                        for(var k = 0; k < u.linePathsTo.length; k++){
                            var S = t.graphics.renderPaths(X(X({}, x), {}, {
                                pathFrom: v === null ? u.linePathsFrom[k] : v,
                                pathTo: u.linePathsTo[k],
                                strokeWidth: Array.isArray(t.strokeWidth) ? t.strokeWidth[w] : t.strokeWidth,
                                fill: "none",
                                drawShadow: !1
                            }));
                            l.add(S);
                            var C = a.fillPath({
                                seriesNumber: w
                            }), L = t.graphics.renderPaths(X(X({}, x), {}, {
                                pathFrom: v === null ? u.areaPathsFrom[k] : v,
                                pathTo: u.areaPathsTo[k],
                                strokeWidth: 0,
                                fill: C,
                                drawShadow: !1
                            }));
                            if (i.config.chart.dropShadow.enabled) {
                                var I = new Z(t.ctx), z = i.config.chart.dropShadow;
                                I.dropShadow(L, Object.assign({}, z, {
                                    noUserSpaceOnUse: !0
                                }), w);
                            }
                            l.add(L);
                        }
                        m.forEach(function(T, E) {
                            var R = new Pe(t.ctx).getMarkerConfig({
                                cssClass: "apexcharts-marker",
                                seriesIndex: w,
                                dataPointIndex: E
                            }), O = t.graphics.drawMarker(g[E].x, g[E].y, R);
                            O.attr("rel", E), O.attr("j", E), O.attr("index", w), O.node.setAttribute("default-marker-size", R.pSize);
                            var D = t.graphics.group({
                                class: "apexcharts-series-markers"
                            });
                            D && D.add(O), p.add(D), l.add(p);
                            var W = i.config.dataLabels;
                            if (W.enabled) {
                                var N = W.formatter(i.globals.series[w][E], {
                                    seriesIndex: w,
                                    dataPointIndex: E,
                                    w: i
                                });
                                r.plotDataLabelsText({
                                    x: g[E].x,
                                    y: g[E].y,
                                    text: N,
                                    textAnchor: "middle",
                                    i: w,
                                    j: w,
                                    parent: f,
                                    offsetCorrection: !1,
                                    dataLabelsConfig: X({}, W)
                                });
                            }
                            l.add(f);
                        }), s.push(l);
                    }), this.drawPolygons({
                        parent: d
                    }), i.config.xaxis.labels.show) {
                        var b = this.drawXAxisTexts();
                        d.add(b);
                    }
                    return s.forEach(function(m) {
                        d.add(m);
                    }), d.add(this.yaxisLabels), d;
                }
            },
            {
                key: "drawPolygons",
                value: function(e) {
                    for(var t = this, i = this.w, a = e.parent, s = new nt(this.ctx), r = i.globals.yAxisScale[0].result.reverse(), n = r.length, o = [], h = this.size / (n - 1), c = 0; c < n; c++)o[c] = h * c;
                    o.reverse();
                    var d = [], g = [];
                    o.forEach(function(p, f) {
                        var b = P.getPolygonPos(p, t.dataPointsLen), m = "";
                        b.forEach(function(w, A) {
                            if (f === 0) {
                                var l = t.graphics.drawLine(w.x, w.y, 0, 0, Array.isArray(t.polygons.connectorColors) ? t.polygons.connectorColors[A] : t.polygons.connectorColors);
                                g.push(l);
                            }
                            A === 0 && t.yaxisLabelsTextsPos.push({
                                x: w.x,
                                y: w.y
                            }), m += w.x + "," + w.y + " ";
                        }), d.push(m);
                    }), d.forEach(function(p, f) {
                        var b = t.polygons.strokeColors, m = t.polygons.strokeWidth, w = t.graphics.drawPolygon(p, Array.isArray(b) ? b[f] : b, Array.isArray(m) ? m[f] : m, i.globals.radarPolygons.fill.colors[f]);
                        a.add(w);
                    }), g.forEach(function(p) {
                        a.add(p);
                    }), i.config.yaxis[0].show && this.yaxisLabelsTextsPos.forEach(function(p, f) {
                        var b = s.drawYAxisTexts(p.x, p.y, f, r[f]);
                        t.yaxisLabels.add(b);
                    });
                }
            },
            {
                key: "drawXAxisTexts",
                value: function() {
                    var e = this, t = this.w, i = t.config.xaxis.labels, a = this.graphics.group({
                        class: "apexcharts-xaxis"
                    }), s = P.getPolygonPos(this.size, this.dataPointsLen);
                    return t.globals.labels.forEach(function(r, n) {
                        var o = t.config.xaxis.labels.formatter, h = new ye(e.ctx);
                        if (s[n]) {
                            var c = e.getTextPos(s[n], e.size), d = o(r, {
                                seriesIndex: -1,
                                dataPointIndex: n,
                                w: t
                            });
                            h.plotDataLabelsText({
                                x: c.newX,
                                y: c.newY,
                                text: d,
                                textAnchor: c.textAnchor,
                                i: n,
                                j: n,
                                parent: a,
                                color: Array.isArray(i.style.colors) && i.style.colors[n] ? i.style.colors[n] : "#a8a8a8",
                                dataLabelsConfig: X({
                                    textAnchor: c.textAnchor,
                                    dropShadow: {
                                        enabled: !1
                                    }
                                }, i),
                                offsetCorrection: !1
                            });
                        }
                    }), a;
                }
            },
            {
                key: "createPaths",
                value: function(e, t) {
                    var i = this, a = [], s = [], r = [], n = [];
                    if (e.length) {
                        s = [
                            this.graphics.move(t.x, t.y)
                        ], n = [
                            this.graphics.move(t.x, t.y)
                        ];
                        var o = this.graphics.move(e[0].x, e[0].y), h = this.graphics.move(e[0].x, e[0].y);
                        e.forEach(function(c, d) {
                            o += i.graphics.line(c.x, c.y), h += i.graphics.line(c.x, c.y), d === e.length - 1 && (o += "Z", h += "Z");
                        }), a.push(o), r.push(h);
                    }
                    return {
                        linePathsFrom: s,
                        linePathsTo: a,
                        areaPathsFrom: n,
                        areaPathsTo: r
                    };
                }
            },
            {
                key: "getTextPos",
                value: function(e, t) {
                    var i = "middle", a = e.x, s = e.y;
                    return Math.abs(e.x) >= 10 ? e.x > 0 ? (i = "start", a += 10) : e.x < 0 && (i = "end", a -= 10) : i = "middle", Math.abs(e.y) >= t - 10 && (e.y < 0 ? s -= 10 : e.y > 0 && (s += 10)), {
                        textAnchor: i,
                        newX: a,
                        newY: s
                    };
                }
            },
            {
                key: "getPreviousPath",
                value: function(e) {
                    for(var t = this.w, i = null, a = 0; a < t.globals.previousPaths.length; a++){
                        var s = t.globals.previousPaths[a];
                        s.paths.length > 0 && parseInt(s.realIndex, 10) === parseInt(e, 10) && t.globals.previousPaths[a].paths[0] !== void 0 && (i = t.globals.previousPaths[a].paths[0].d);
                    }
                    return i;
                }
            },
            {
                key: "getDataPointsPos",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.dataPointsLen;
                    e = e || [], t = t || [];
                    for(var a = [], s = 0; s < i; s++){
                        var r = {};
                        r.x = e[s] * Math.sin(t[s]), r.y = -e[s] * Math.cos(t[s]), a.push(r);
                    }
                    return a;
                }
            }
        ]), y;
    }(), Rt = function(y) {
        ge(t, ot);
        var e = ue(t);
        function t(i) {
            var a;
            F(this, t), (a = e.call(this, i)).ctx = i, a.w = i.w, a.animBeginArr = [
                0
            ], a.animDur = 0;
            var s = a.w;
            return a.startAngle = s.config.plotOptions.radialBar.startAngle, a.endAngle = s.config.plotOptions.radialBar.endAngle, a.totalAngle = Math.abs(s.config.plotOptions.radialBar.endAngle - s.config.plotOptions.radialBar.startAngle), a.trackStartAngle = s.config.plotOptions.radialBar.track.startAngle, a.trackEndAngle = s.config.plotOptions.radialBar.track.endAngle, a.barLabels = a.w.config.plotOptions.radialBar.barLabels, a.donutDataLabels = a.w.config.plotOptions.radialBar.dataLabels, a.radialDataLabels = a.donutDataLabels, a.trackStartAngle || (a.trackStartAngle = a.startAngle), a.trackEndAngle || (a.trackEndAngle = a.endAngle), a.endAngle === 360 && (a.endAngle = 359.99), a.margin = parseInt(s.config.plotOptions.radialBar.track.margin, 10), a.onBarLabelClick = a.onBarLabelClick.bind(ze(a)), a;
        }
        return Y(t, [
            {
                key: "draw",
                value: function(i) {
                    var a = this.w, s = new M(this.ctx), r = s.group({
                        class: "apexcharts-radialbar"
                    });
                    if (a.globals.noData) return r;
                    var n = s.group(), o = this.defaultSize / 2, h = a.globals.gridWidth / 2, c = this.defaultSize / 2.05;
                    a.config.chart.sparkline.enabled || (c = c - a.config.stroke.width - a.config.chart.dropShadow.blur);
                    var d = a.globals.fill.colors;
                    if (a.config.plotOptions.radialBar.track.show) {
                        var g = this.drawTracks({
                            size: c,
                            centerX: h,
                            centerY: o,
                            colorArr: d,
                            series: i
                        });
                        n.add(g);
                    }
                    var p = this.drawArcs({
                        size: c,
                        centerX: h,
                        centerY: o,
                        colorArr: d,
                        series: i
                    }), f = 360;
                    a.config.plotOptions.radialBar.startAngle < 0 && (f = this.totalAngle);
                    var b = (360 - f) / 360;
                    if (a.globals.radialSize = c - c * b, this.radialDataLabels.value.show) {
                        var m = Math.max(this.radialDataLabels.value.offsetY, this.radialDataLabels.name.offsetY);
                        a.globals.radialSize += m * b;
                    }
                    return n.add(p.g), a.config.plotOptions.radialBar.hollow.position === "front" && (p.g.add(p.elHollow), p.dataLabels && p.g.add(p.dataLabels)), r.add(n), r;
                }
            },
            {
                key: "drawTracks",
                value: function(i) {
                    var a = this.w, s = new M(this.ctx), r = s.group({
                        class: "apexcharts-tracks"
                    }), n = new Z(this.ctx), o = new ae(this.ctx), h = this.getStrokeWidth(i);
                    i.size = i.size - h / 2;
                    for(var c = 0; c < i.series.length; c++){
                        var d = s.group({
                            class: "apexcharts-radialbar-track apexcharts-track"
                        });
                        r.add(d), d.attr({
                            rel: c + 1
                        }), i.size = i.size - h - this.margin;
                        var g = a.config.plotOptions.radialBar.track, p = o.fillPath({
                            seriesNumber: 0,
                            size: i.size,
                            fillColors: Array.isArray(g.background) ? g.background[c] : g.background,
                            solid: !0
                        }), f = this.trackStartAngle, b = this.trackEndAngle;
                        Math.abs(b) + Math.abs(f) >= 360 && (b = 360 - Math.abs(this.startAngle) - 0.1);
                        var m = s.drawPath({
                            d: "",
                            stroke: p,
                            strokeWidth: h * parseInt(g.strokeWidth, 10) / 100,
                            fill: "none",
                            strokeOpacity: g.opacity,
                            classes: "apexcharts-radialbar-area"
                        });
                        if (g.dropShadow.enabled) {
                            var w = g.dropShadow;
                            n.dropShadow(m, w);
                        }
                        d.add(m), m.attr("id", "apexcharts-radialbarTrack-" + c), this.animatePaths(m, {
                            centerX: i.centerX,
                            centerY: i.centerY,
                            endAngle: b,
                            startAngle: f,
                            size: i.size,
                            i: c,
                            totalItems: 2,
                            animBeginArr: 0,
                            dur: 0,
                            isTrack: !0,
                            easing: a.globals.easing
                        });
                    }
                    return r;
                }
            },
            {
                key: "drawArcs",
                value: function(i) {
                    var a = this.w, s = new M(this.ctx), r = new ae(this.ctx), n = new Z(this.ctx), o = s.group(), h = this.getStrokeWidth(i);
                    i.size = i.size - h / 2;
                    var c = a.config.plotOptions.radialBar.hollow.background, d = i.size - h * i.series.length - this.margin * i.series.length - h * parseInt(a.config.plotOptions.radialBar.track.strokeWidth, 10) / 100 / 2, g = d - a.config.plotOptions.radialBar.hollow.margin;
                    a.config.plotOptions.radialBar.hollow.image !== void 0 && (c = this.drawHollowImage(i, o, d, c));
                    var p = this.drawHollow({
                        size: g,
                        centerX: i.centerX,
                        centerY: i.centerY,
                        fill: c || "transparent"
                    });
                    if (a.config.plotOptions.radialBar.hollow.dropShadow.enabled) {
                        var f = a.config.plotOptions.radialBar.hollow.dropShadow;
                        n.dropShadow(p, f);
                    }
                    var b = 1;
                    !this.radialDataLabels.total.show && a.globals.series.length > 1 && (b = 0);
                    var m = null;
                    this.radialDataLabels.show && (m = this.renderInnerDataLabels(this.radialDataLabels, {
                        hollowSize: d,
                        centerX: i.centerX,
                        centerY: i.centerY,
                        opacity: b
                    })), a.config.plotOptions.radialBar.hollow.position === "back" && (o.add(p), m && o.add(m));
                    var w = !1;
                    a.config.plotOptions.radialBar.inverseOrder && (w = !0);
                    for(var A = w ? i.series.length - 1 : 0; w ? A >= 0 : A < i.series.length; w ? A-- : A++){
                        var l = s.group({
                            class: "apexcharts-series apexcharts-radial-series",
                            seriesName: P.escapeString(a.globals.seriesNames[A])
                        });
                        o.add(l), l.attr({
                            rel: A + 1,
                            "data:realIndex": A
                        }), this.ctx.series.addCollapsedClassToSeries(l, A), i.size = i.size - h - this.margin;
                        var u = r.fillPath({
                            seriesNumber: A,
                            size: i.size,
                            value: i.series[A]
                        }), x = this.startAngle, v = void 0, k = P.negToZero(i.series[A] > 100 ? 100 : i.series[A]) / 100, S = Math.round(this.totalAngle * k) + this.startAngle, C = void 0;
                        a.globals.dataChanged && (v = this.startAngle, C = Math.round(this.totalAngle * P.negToZero(a.globals.previousPaths[A]) / 100) + v), Math.abs(S) + Math.abs(x) >= 360 && (S -= 0.01), Math.abs(C) + Math.abs(v) >= 360 && (C -= 0.01);
                        var L = S - x, I = Array.isArray(a.config.stroke.dashArray) ? a.config.stroke.dashArray[A] : a.config.stroke.dashArray, z = s.drawPath({
                            d: "",
                            stroke: u,
                            strokeWidth: h,
                            fill: "none",
                            fillOpacity: a.config.fill.opacity,
                            classes: "apexcharts-radialbar-area apexcharts-radialbar-slice-" + A,
                            strokeDashArray: I
                        });
                        if (M.setAttrs(z.node, {
                            "data:angle": L,
                            "data:value": i.series[A]
                        }), a.config.chart.dropShadow.enabled) {
                            var T = a.config.chart.dropShadow;
                            n.dropShadow(z, T, A);
                        }
                        if (n.setSelectionFilter(z, 0, A), this.addListeners(z, this.radialDataLabels), l.add(z), z.attr({
                            index: 0,
                            j: A
                        }), this.barLabels.enabled) {
                            var E = P.polarToCartesian(i.centerX, i.centerY, i.size, x), R = this.barLabels.formatter(a.globals.seriesNames[A], {
                                seriesIndex: A,
                                w: a
                            }), O = [
                                "apexcharts-radialbar-label"
                            ];
                            this.barLabels.onClick || O.push("apexcharts-no-click");
                            var D = this.barLabels.useSeriesColors ? a.globals.colors[A] : a.config.chart.foreColor;
                            D || (D = a.config.chart.foreColor);
                            var W = E.x - this.barLabels.margin, N = E.y, V = s.drawText({
                                x: W,
                                y: N,
                                text: R,
                                textAnchor: "end",
                                dominantBaseline: "middle",
                                fontFamily: this.barLabels.fontFamily,
                                fontWeight: this.barLabels.fontWeight,
                                fontSize: this.barLabels.fontSize,
                                foreColor: D,
                                cssClass: O.join(" ")
                            });
                            V.on("click", this.onBarLabelClick), V.attr({
                                rel: A + 1
                            }), x !== 0 && V.attr({
                                "transform-origin": "".concat(W, " ").concat(N),
                                transform: "rotate(".concat(x, " 0 0)")
                            }), l.add(V);
                        }
                        var j = 0;
                        !this.initialAnim || a.globals.resized || a.globals.dataChanged || (j = a.config.chart.animations.speed), a.globals.dataChanged && (j = a.config.chart.animations.dynamicAnimation.speed), this.animDur = j / (1.2 * i.series.length) + this.animDur, this.animBeginArr.push(this.animDur), this.animatePaths(z, {
                            centerX: i.centerX,
                            centerY: i.centerY,
                            endAngle: S,
                            startAngle: x,
                            prevEndAngle: C,
                            prevStartAngle: v,
                            size: i.size,
                            i: A,
                            totalItems: 2,
                            animBeginArr: this.animBeginArr,
                            dur: j,
                            shouldSetPrevPaths: !0,
                            easing: a.globals.easing
                        });
                    }
                    return {
                        g: o,
                        elHollow: p,
                        dataLabels: m
                    };
                }
            },
            {
                key: "drawHollow",
                value: function(i) {
                    var a = new M(this.ctx).drawCircle(2 * i.size);
                    return a.attr({
                        class: "apexcharts-radialbar-hollow",
                        cx: i.centerX,
                        cy: i.centerY,
                        r: i.size,
                        fill: i.fill
                    }), a;
                }
            },
            {
                key: "drawHollowImage",
                value: function(i, a, s, r) {
                    var n = this.w, o = new ae(this.ctx), h = P.randomId(), c = n.config.plotOptions.radialBar.hollow.image;
                    if (n.config.plotOptions.radialBar.hollow.imageClipped) o.clippedImgArea({
                        width: s,
                        height: s,
                        image: c,
                        patternID: "pattern".concat(n.globals.cuid).concat(h)
                    }), r = "url(#pattern".concat(n.globals.cuid).concat(h, ")");
                    else {
                        var d = n.config.plotOptions.radialBar.hollow.imageWidth, g = n.config.plotOptions.radialBar.hollow.imageHeight;
                        if (d === void 0 && g === void 0) {
                            var p = n.globals.dom.Paper.image(c).loaded(function(b) {
                                this.move(i.centerX - b.width / 2 + n.config.plotOptions.radialBar.hollow.imageOffsetX, i.centerY - b.height / 2 + n.config.plotOptions.radialBar.hollow.imageOffsetY);
                            });
                            a.add(p);
                        } else {
                            var f = n.globals.dom.Paper.image(c).loaded(function(b) {
                                this.move(i.centerX - d / 2 + n.config.plotOptions.radialBar.hollow.imageOffsetX, i.centerY - g / 2 + n.config.plotOptions.radialBar.hollow.imageOffsetY), this.size(d, g);
                            });
                            a.add(f);
                        }
                    }
                    return r;
                }
            },
            {
                key: "getStrokeWidth",
                value: function(i) {
                    var a = this.w;
                    return i.size * (100 - parseInt(a.config.plotOptions.radialBar.hollow.size, 10)) / 100 / (i.series.length + 1) - this.margin;
                }
            },
            {
                key: "onBarLabelClick",
                value: function(i) {
                    var a = parseInt(i.target.getAttribute("rel"), 10) - 1, s = this.barLabels.onClick, r = this.w;
                    s && s(r.globals.seriesNames[a], {
                        w: r,
                        seriesIndex: a
                    });
                }
            }
        ]), t;
    }(), Ot = function(y) {
        ge(t, ke);
        var e = ue(t);
        function t() {
            return F(this, t), e.apply(this, arguments);
        }
        return Y(t, [
            {
                key: "draw",
                value: function(i, a) {
                    var s = this.w, r = new M(this.ctx);
                    this.rangeBarOptions = this.w.config.plotOptions.rangeBar, this.series = i, this.seriesRangeStart = s.globals.seriesRangeStart, this.seriesRangeEnd = s.globals.seriesRangeEnd, this.barHelpers.initVariables(i);
                    for(var n = r.group({
                        class: "apexcharts-rangebar-series apexcharts-plot-series"
                    }), o = 0; o < i.length; o++){
                        var h, c, d, g, p = void 0, f = void 0, b = s.globals.comboCharts ? a[o] : o, m = r.group({
                            class: "apexcharts-series",
                            seriesName: P.escapeString(s.globals.seriesNames[b]),
                            rel: o + 1,
                            "data:realIndex": b
                        });
                        this.ctx.series.addCollapsedClassToSeries(m, b), i[o].length > 0 && (this.visibleI = this.visibleI + 1);
                        var w = 0, A = 0;
                        this.yRatio.length > 1 && (this.yaxisIndex = b);
                        var l = this.barHelpers.initialPositions();
                        f = l.y, g = l.zeroW, p = l.x, A = l.barWidth, w = l.barHeight, h = l.xDivision, c = l.yDivision, d = l.zeroH;
                        for(var u = r.group({
                            class: "apexcharts-datalabels",
                            "data:realIndex": b
                        }), x = r.group({
                            class: "apexcharts-rangebar-goals-markers"
                        }), v = 0; v < s.globals.dataPoints; v++){
                            var k, S = this.barHelpers.getStrokeWidth(o, v, b), C = this.seriesRangeStart[o][v], L = this.seriesRangeEnd[o][v], I = null, z = null, T = null, E = {
                                x: p,
                                y: f,
                                strokeWidth: S,
                                elSeries: m
                            }, R = this.seriesLen;
                            if (s.config.plotOptions.bar.rangeBarGroupRows && (R = 1), s.config.series[o].data[v] === void 0) break;
                            if (this.isHorizontal) {
                                T = f + w * this.visibleI;
                                var O = (c - w * R) / 2;
                                if (s.config.series[o].data[v].x) {
                                    var D = this.detectOverlappingBars({
                                        i: o,
                                        j: v,
                                        barYPosition: T,
                                        srty: O,
                                        barHeight: w,
                                        yDivision: c,
                                        initPositions: l
                                    });
                                    w = D.barHeight, T = D.barYPosition;
                                }
                                A = (I = this.drawRangeBarPaths(X({
                                    indexes: {
                                        i: o,
                                        j: v,
                                        realIndex: b
                                    },
                                    barHeight: w,
                                    barYPosition: T,
                                    zeroW: g,
                                    yDivision: c,
                                    y1: C,
                                    y2: L
                                }, E))).barWidth;
                            } else {
                                s.globals.isXNumeric && (p = (s.globals.seriesX[o][v] - s.globals.minX) / this.xRatio - A / 2), z = p + A * this.visibleI;
                                var W = (h - A * R) / 2;
                                if (s.config.series[o].data[v].x) {
                                    var N = this.detectOverlappingBars({
                                        i: o,
                                        j: v,
                                        barXPosition: z,
                                        srtx: W,
                                        barWidth: A,
                                        xDivision: h,
                                        initPositions: l
                                    });
                                    A = N.barWidth, z = N.barXPosition;
                                }
                                w = (I = this.drawRangeColumnPaths(X({
                                    indexes: {
                                        i: o,
                                        j: v,
                                        realIndex: b
                                    },
                                    barWidth: A,
                                    barXPosition: z,
                                    zeroH: d,
                                    xDivision: h
                                }, E))).barHeight;
                            }
                            var V = this.barHelpers.drawGoalLine({
                                barXPosition: I.barXPosition,
                                barYPosition: T,
                                goalX: I.goalX,
                                goalY: I.goalY,
                                barHeight: w,
                                barWidth: A
                            });
                            V && x.add(V), f = I.y, p = I.x;
                            var j = this.barHelpers.getPathFillColor(i, o, v, b), se = s.globals.stroke.colors[b];
                            this.renderSeries((ee(k = {
                                realIndex: b,
                                pathFill: j,
                                lineFill: se,
                                j: v,
                                i: o,
                                x: p,
                                y: f,
                                y1: C,
                                y2: L,
                                pathFrom: I.pathFrom,
                                pathTo: I.pathTo,
                                strokeWidth: S,
                                elSeries: m,
                                series: i,
                                barHeight: w,
                                barWidth: A,
                                barXPosition: z,
                                barYPosition: T
                            }, "barWidth", A), ee(k, "elDataLabelsWrap", u), ee(k, "elGoalsMarkers", x), ee(k, "visibleSeries", this.visibleI), ee(k, "type", "rangebar"), k));
                        }
                        n.add(m);
                    }
                    return n;
                }
            },
            {
                key: "detectOverlappingBars",
                value: function(i) {
                    var a = i.i, s = i.j, r = i.barYPosition, n = i.barXPosition, o = i.srty, h = i.srtx, c = i.barHeight, d = i.barWidth, g = i.yDivision, p = i.xDivision, f = i.initPositions, b = this.w, m = [], w = b.config.series[a].data[s].rangeName, A = b.config.series[a].data[s].x, l = Array.isArray(A) ? A.join(" ") : A, u = b.globals.labels.map(function(v) {
                        return Array.isArray(v) ? v.join(" ") : v;
                    }).indexOf(l), x = b.globals.seriesRange[a].findIndex(function(v) {
                        return v.x === l && v.overlaps.length > 0;
                    });
                    return this.isHorizontal ? (r = b.config.plotOptions.bar.rangeBarGroupRows ? o + g * u : o + c * this.visibleI + g * u, x > -1 && !b.config.plotOptions.bar.rangeBarOverlap && (m = b.globals.seriesRange[a][x].overlaps).indexOf(w) > -1 && (r = (c = f.barHeight / m.length) * this.visibleI + g * (100 - parseInt(this.barOptions.barHeight, 10)) / 100 / 2 + c * (this.visibleI + m.indexOf(w)) + g * u)) : (u > -1 && (n = b.config.plotOptions.bar.rangeBarGroupRows ? h + p * u : h + d * this.visibleI + p * u), x > -1 && !b.config.plotOptions.bar.rangeBarOverlap && (m = b.globals.seriesRange[a][x].overlaps).indexOf(w) > -1 && (n = (d = f.barWidth / m.length) * this.visibleI + p * (100 - parseInt(this.barOptions.barWidth, 10)) / 100 / 2 + d * (this.visibleI + m.indexOf(w)) + p * u)), {
                        barYPosition: r,
                        barXPosition: n,
                        barHeight: c,
                        barWidth: d
                    };
                }
            },
            {
                key: "drawRangeColumnPaths",
                value: function(i) {
                    var a = i.indexes, s = i.x, r = i.xDivision, n = i.barWidth, o = i.barXPosition, h = i.zeroH, c = this.w, d = a.i, g = a.j, p = this.yRatio[this.yaxisIndex], f = a.realIndex, b = this.getRangeValue(f, g), m = Math.min(b.start, b.end), w = Math.max(b.start, b.end);
                    this.series[d][g] === void 0 || this.series[d][g] === null ? m = h : (m = h - m / p, w = h - w / p);
                    var A = Math.abs(w - m), l = this.barHelpers.getColumnPaths({
                        barXPosition: o,
                        barWidth: n,
                        y1: m,
                        y2: w,
                        strokeWidth: this.strokeWidth,
                        series: this.seriesRangeEnd,
                        realIndex: a.realIndex,
                        i: f,
                        j: g,
                        w: c
                    });
                    if (c.globals.isXNumeric) {
                        var u = this.getBarXForNumericXAxis({
                            x: s,
                            j: g,
                            realIndex: f,
                            barWidth: n
                        });
                        s = u.x, o = u.barXPosition;
                    } else s += r;
                    return {
                        pathTo: l.pathTo,
                        pathFrom: l.pathFrom,
                        barHeight: A,
                        x: s,
                        y: w,
                        goalY: this.barHelpers.getGoalValues("y", null, h, d, g),
                        barXPosition: o
                    };
                }
            },
            {
                key: "drawRangeBarPaths",
                value: function(i) {
                    var a = i.indexes, s = i.y, r = i.y1, n = i.y2, o = i.yDivision, h = i.barHeight, c = i.barYPosition, d = i.zeroW, g = this.w, p = d + r / this.invertedYRatio, f = d + n / this.invertedYRatio, b = Math.abs(f - p), m = this.barHelpers.getBarpaths({
                        barYPosition: c,
                        barHeight: h,
                        x1: p,
                        x2: f,
                        strokeWidth: this.strokeWidth,
                        series: this.seriesRangeEnd,
                        i: a.realIndex,
                        realIndex: a.realIndex,
                        j: a.j,
                        w: g
                    });
                    return g.globals.isXNumeric || (s += o), {
                        pathTo: m.pathTo,
                        pathFrom: m.pathFrom,
                        barWidth: b,
                        x: f,
                        goalX: this.barHelpers.getGoalValues("x", d, null, a.realIndex, a.j),
                        y: s
                    };
                }
            },
            {
                key: "getRangeValue",
                value: function(i, a) {
                    var s = this.w;
                    return {
                        start: s.globals.seriesRangeStart[i][a],
                        end: s.globals.seriesRangeEnd[i][a]
                    };
                }
            }
        ]), t;
    }(), Ht = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.lineCtx = e;
        }
        return Y(y, [
            {
                key: "sameValueSeriesFix",
                value: function(e, t) {
                    var i = this.w;
                    if ((i.config.fill.type === "gradient" || i.config.fill.type[e] === "gradient") && new q(this.lineCtx.ctx, i).seriesHaveSameValues(e)) {
                        var a = t[e].slice();
                        a[a.length - 1] = a[a.length - 1] + 1e-6, t[e] = a;
                    }
                    return t;
                }
            },
            {
                key: "calculatePoints",
                value: function(e) {
                    var t = e.series, i = e.realIndex, a = e.x, s = e.y, r = e.i, n = e.j, o = e.prevY, h = this.w, c = [], d = [];
                    if (n === 0) {
                        var g = this.lineCtx.categoryAxisCorrection + h.config.markers.offsetX;
                        h.globals.isXNumeric && (g = (h.globals.seriesX[i][0] - h.globals.minX) / this.lineCtx.xRatio + h.config.markers.offsetX), c.push(g), d.push(P.isNumber(t[r][0]) ? o + h.config.markers.offsetY : null), c.push(a + h.config.markers.offsetX), d.push(P.isNumber(t[r][n + 1]) ? s + h.config.markers.offsetY : null);
                    } else c.push(a + h.config.markers.offsetX), d.push(P.isNumber(t[r][n + 1]) ? s + h.config.markers.offsetY : null);
                    return {
                        x: c,
                        y: d
                    };
                }
            },
            {
                key: "checkPreviousPaths",
                value: function(e) {
                    for(var t = e.pathFromLine, i = e.pathFromArea, a = e.realIndex, s = this.w, r = 0; r < s.globals.previousPaths.length; r++){
                        var n = s.globals.previousPaths[r];
                        (n.type === "line" || n.type === "area") && n.paths.length > 0 && parseInt(n.realIndex, 10) === parseInt(a, 10) && (n.type === "line" ? (this.lineCtx.appendPathFrom = !1, t = s.globals.previousPaths[r].paths[0].d) : n.type === "area" && (this.lineCtx.appendPathFrom = !1, i = s.globals.previousPaths[r].paths[0].d, s.config.stroke.show && s.globals.previousPaths[r].paths[1] && (t = s.globals.previousPaths[r].paths[1].d)));
                    }
                    return {
                        pathFromLine: t,
                        pathFromArea: i
                    };
                }
            },
            {
                key: "determineFirstPrevY",
                value: function(e) {
                    var t, i, a = e.i, s = e.series, r = e.prevY, n = e.lineYPosition, o = this.w, h = o.config.chart.stacked && !o.globals.comboCharts || o.config.chart.stacked && o.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || ((t = this.w.config.series[a]) === null || t === void 0 ? void 0 : t.type) === "bar");
                    if (((i = s[a]) === null || i === void 0 ? void 0 : i[0]) !== void 0) r = (n = h && a > 0 ? this.lineCtx.prevSeriesY[a - 1][0] : this.lineCtx.zeroY) - s[a][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] + 2 * (this.lineCtx.isReversed ? s[a][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] : 0);
                    else if (h && a > 0 && s[a][0] === void 0) {
                        for(var c = a - 1; c >= 0; c--)if (s[c][0] !== null && s[c][0] !== void 0) {
                            r = n = this.lineCtx.prevSeriesY[c][0];
                            break;
                        }
                    }
                    return {
                        prevY: r,
                        lineYPosition: n
                    };
                }
            }
        ]), y;
    }(), Dt = function(y) {
        for(var e, t, i, a, s = function(c) {
            for(var d = [], g = c[0], p = c[1], f = d[0] = Ve(g, p), b = 1, m = c.length - 1; b < m; b++)g = p, p = c[b + 1], d[b] = 0.5 * (f + (f = Ve(g, p)));
            return d[b] = f, d;
        }(y), r = y.length - 1, n = [], o = 0; o < r; o++)i = Ve(y[o], y[o + 1]), Math.abs(i) < 1e-6 ? s[o] = s[o + 1] = 0 : (a = (e = s[o] / i) * e + (t = s[o + 1] / i) * t) > 9 && (a = 3 * i / Math.sqrt(a), s[o] = a * e, s[o + 1] = a * t);
        for(var h = 0; h <= r; h++)a = (y[Math.min(r, h + 1)][0] - y[Math.max(0, h - 1)][0]) / (6 * (1 + s[h] * s[h])), n.push([
            a || 0,
            s[h] * a || 0
        ]);
        return n;
    }, Ge = function(y) {
        for(var e = "", t = 0; t < y.length; t++){
            var i = y[t], a = i.length;
            a > 4 ? (e += "C".concat(i[0], ", ").concat(i[1]), e += ", ".concat(i[2], ", ").concat(i[3]), e += ", ".concat(i[4], ", ").concat(i[5])) : a > 2 && (e += "S".concat(i[0], ", ").concat(i[1]), e += ", ".concat(i[2], ", ").concat(i[3]));
        }
        return e;
    }, lt = function(y) {
        var e = Dt(y), t = y[1], i = y[0], a = [], s = e[1], r = e[0];
        a.push(i, [
            i[0] + r[0],
            i[1] + r[1],
            t[0] - s[0],
            t[1] - s[1],
            t[0],
            t[1]
        ]);
        for(var n = 2, o = e.length; n < o; n++){
            var h = y[n], c = e[n];
            a.push([
                h[0] - c[0],
                h[1] - c[1],
                h[0],
                h[1]
            ]);
        }
        return a;
    };
    function Ve(y, e) {
        return (e[1] - y[1]) / (e[0] - y[0]);
    }
    var je = function() {
        function y(e, t, i) {
            F(this, y), this.ctx = e, this.w = e.w, this.xyRatios = t, this.pointsChart = !(this.w.config.chart.type !== "bubble" && this.w.config.chart.type !== "scatter") || i, this.scatter = new $e(this.ctx), this.noNegatives = this.w.globals.minX === Number.MAX_VALUE, this.lineHelpers = new Ht(this), this.markers = new Pe(this.ctx), this.prevSeriesY = [], this.categoryAxisCorrection = 0, this.yaxisIndex = 0;
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e, t, i, a) {
                    var s, r = this.w, n = new M(this.ctx), o = r.globals.comboCharts ? t : r.config.chart.type, h = n.group({
                        class: "apexcharts-".concat(o, "-series apexcharts-plot-series")
                    }), c = new q(this.ctx, r);
                    this.yRatio = this.xyRatios.yRatio, this.zRatio = this.xyRatios.zRatio, this.xRatio = this.xyRatios.xRatio, this.baseLineY = this.xyRatios.baseLineY, e = c.getLogSeries(e), this.yRatio = c.getLogYRatios(this.yRatio);
                    for(var d = [], g = 0; g < e.length; g++){
                        e = this.lineHelpers.sameValueSeriesFix(g, e);
                        var p = r.globals.comboCharts ? i[g] : g;
                        this._initSerieVariables(e, g, p);
                        var f = [], b = [], m = [], w = r.globals.padHorizontal + this.categoryAxisCorrection;
                        this.ctx.series.addCollapsedClassToSeries(this.elSeries, p), r.globals.isXNumeric && r.globals.seriesX.length > 0 && (w = (r.globals.seriesX[p][0] - r.globals.minX) / this.xRatio), m.push(w);
                        var A, l = w, u = void 0, x = l, v = this.zeroY, k = this.zeroY;
                        v = this.lineHelpers.determineFirstPrevY({
                            i: g,
                            series: e,
                            prevY: v,
                            lineYPosition: 0
                        }).prevY, r.config.stroke.curve === "monotonCubic" && e[g][0] === null ? f.push(null) : f.push(v), A = v, o === "rangeArea" && (u = k = this.lineHelpers.determineFirstPrevY({
                            i: g,
                            series: a,
                            prevY: k,
                            lineYPosition: 0
                        }).prevY, b.push(k));
                        var S = {
                            type: o,
                            series: e,
                            realIndex: p,
                            i: g,
                            x: w,
                            y: 1,
                            pX: l,
                            pY: A,
                            pathsFrom: this._calculatePathsFrom({
                                type: o,
                                series: e,
                                i: g,
                                realIndex: p,
                                prevX: x,
                                prevY: v,
                                prevY2: k
                            }),
                            linePaths: [],
                            areaPaths: [],
                            seriesIndex: i,
                            lineYPosition: 0,
                            xArrj: m,
                            yArrj: f,
                            y2Arrj: b,
                            seriesRangeEnd: a
                        }, C = this._iterateOverDataPoints(X(X({}, S), {}, {
                            iterations: o === "rangeArea" ? e[g].length - 1 : void 0,
                            isRangeStart: !0
                        }));
                        if (o === "rangeArea") {
                            var L = this._calculatePathsFrom({
                                series: a,
                                i: g,
                                realIndex: p,
                                prevX: x,
                                prevY: k
                            }), I = this._iterateOverDataPoints(X(X({}, S), {}, {
                                series: a,
                                pY: u,
                                pathsFrom: L,
                                iterations: a[g].length - 1,
                                isRangeStart: !1
                            }));
                            C.linePaths[0] = I.linePath + C.linePath, C.pathFromLine = I.pathFromLine + C.pathFromLine;
                        }
                        this._handlePaths({
                            type: o,
                            realIndex: p,
                            i: g,
                            paths: C
                        }), this.elSeries.add(this.elPointsMain), this.elSeries.add(this.elDataLabelsWrap), d.push(this.elSeries);
                    }
                    if (((s = r.config.series[0]) === null || s === void 0 ? void 0 : s.zIndex) !== void 0 && d.sort(function(E, R) {
                        return Number(E.node.getAttribute("zIndex")) - Number(R.node.getAttribute("zIndex"));
                    }), r.config.chart.stacked) for(var z = d.length; z > 0; z--)h.add(d[z - 1]);
                    else for(var T = 0; T < d.length; T++)h.add(d[T]);
                    return h;
                }
            },
            {
                key: "_initSerieVariables",
                value: function(e, t, i) {
                    var a = this.w, s = new M(this.ctx);
                    this.xDivision = a.globals.gridWidth / (a.globals.dataPoints - (a.config.xaxis.tickPlacement === "on" ? 1 : 0)), this.strokeWidth = Array.isArray(a.config.stroke.width) ? a.config.stroke.width[i] : a.config.stroke.width, this.yRatio.length > 1 && (this.yaxisIndex = i), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed, this.zeroY = a.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? a.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), this.areaBottomY = this.zeroY, (this.zeroY > a.globals.gridHeight || a.config.plotOptions.area.fillTo === "end") && (this.areaBottomY = a.globals.gridHeight), this.categoryAxisCorrection = this.xDivision / 2, this.elSeries = s.group({
                        class: "apexcharts-series",
                        zIndex: a.config.series[i].zIndex !== void 0 ? a.config.series[i].zIndex : i,
                        seriesName: P.escapeString(a.globals.seriesNames[i])
                    }), this.elPointsMain = s.group({
                        class: "apexcharts-series-markers-wrap",
                        "data:realIndex": i
                    }), this.elDataLabelsWrap = s.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": i
                    });
                    var r = e[t].length === a.globals.dataPoints;
                    this.elSeries.attr({
                        "data:longestSeries": r,
                        rel: t + 1,
                        "data:realIndex": i
                    }), this.appendPathFrom = !0;
                }
            },
            {
                key: "_calculatePathsFrom",
                value: function(e) {
                    var t, i, a, s, r = e.type, n = e.series, o = e.i, h = e.realIndex, c = e.prevX, d = e.prevY, g = e.prevY2, p = this.w, f = new M(this.ctx);
                    if (n[o][0] === null) {
                        for(var b = 0; b < n[o].length; b++)if (n[o][b] !== null) {
                            c = this.xDivision * b, d = this.zeroY - n[o][b] / this.yRatio[this.yaxisIndex], t = f.move(c, d), i = f.move(c, this.areaBottomY);
                            break;
                        }
                    } else t = f.move(c, d), r === "rangeArea" && (t = f.move(c, g) + f.line(c, d)), i = f.move(c, this.areaBottomY) + f.line(c, d);
                    if (a = f.move(-1, this.zeroY) + f.line(-1, this.zeroY), s = f.move(-1, this.zeroY) + f.line(-1, this.zeroY), p.globals.previousPaths.length > 0) {
                        var m = this.lineHelpers.checkPreviousPaths({
                            pathFromLine: a,
                            pathFromArea: s,
                            realIndex: h
                        });
                        a = m.pathFromLine, s = m.pathFromArea;
                    }
                    return {
                        prevX: c,
                        prevY: d,
                        linePath: t,
                        areaPath: i,
                        pathFromLine: a,
                        pathFromArea: s
                    };
                }
            },
            {
                key: "_handlePaths",
                value: function(e) {
                    var t = e.type, i = e.realIndex, a = e.i, s = e.paths, r = this.w, n = new M(this.ctx), o = new ae(this.ctx);
                    this.prevSeriesY.push(s.yArrj), r.globals.seriesXvalues[i] = s.xArrj, r.globals.seriesYvalues[i] = s.yArrj;
                    var h = r.config.forecastDataPoints;
                    if (h.count > 0 && t !== "rangeArea") {
                        var c = r.globals.seriesXvalues[i][r.globals.seriesXvalues[i].length - h.count - 1], d = n.drawRect(c, 0, r.globals.gridWidth, r.globals.gridHeight, 0);
                        r.globals.dom.elForecastMask.appendChild(d.node);
                        var g = n.drawRect(0, 0, c, r.globals.gridHeight, 0);
                        r.globals.dom.elNonForecastMask.appendChild(g.node);
                    }
                    this.pointsChart || r.globals.delayedElements.push({
                        el: this.elPointsMain.node,
                        index: i
                    });
                    var p = {
                        i: a,
                        realIndex: i,
                        animationDelay: a,
                        initialSpeed: r.config.chart.animations.speed,
                        dataChangeSpeed: r.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-".concat(t)
                    };
                    if (t === "area") for(var f = o.fillPath({
                        seriesNumber: i
                    }), b = 0; b < s.areaPaths.length; b++){
                        var m = n.renderPaths(X(X({}, p), {}, {
                            pathFrom: s.pathFromArea,
                            pathTo: s.areaPaths[b],
                            stroke: "none",
                            strokeWidth: 0,
                            strokeLineCap: null,
                            fill: f
                        }));
                        this.elSeries.add(m);
                    }
                    if (r.config.stroke.show && !this.pointsChart) {
                        var w = null;
                        if (t === "line") w = o.fillPath({
                            seriesNumber: i,
                            i: a
                        });
                        else if (r.config.stroke.fill.type === "solid") w = r.globals.stroke.colors[i];
                        else {
                            var A = r.config.fill;
                            r.config.fill = r.config.stroke.fill, w = o.fillPath({
                                seriesNumber: i,
                                i: a
                            }), r.config.fill = A;
                        }
                        for(var l = 0; l < s.linePaths.length; l++){
                            var u = w;
                            t === "rangeArea" && (u = o.fillPath({
                                seriesNumber: i
                            }));
                            var x = X(X({}, p), {}, {
                                pathFrom: s.pathFromLine,
                                pathTo: s.linePaths[l],
                                stroke: w,
                                strokeWidth: this.strokeWidth,
                                strokeLineCap: r.config.stroke.lineCap,
                                fill: t === "rangeArea" ? u : "none"
                            }), v = n.renderPaths(x);
                            if (this.elSeries.add(v), v.attr("fill-rule", "evenodd"), h.count > 0 && t !== "rangeArea") {
                                var k = n.renderPaths(x);
                                k.node.setAttribute("stroke-dasharray", h.dashArray), h.strokeWidth && k.node.setAttribute("stroke-width", h.strokeWidth), this.elSeries.add(k), k.attr("clip-path", "url(#forecastMask".concat(r.globals.cuid, ")")), v.attr("clip-path", "url(#nonForecastMask".concat(r.globals.cuid, ")"));
                            }
                        }
                    }
                }
            },
            {
                key: "_iterateOverDataPoints",
                value: function(e) {
                    var t, i = this, a = e.type, s = e.series, r = e.iterations, n = e.realIndex, o = e.i, h = e.x, c = e.y, d = e.pX, g = e.pY, p = e.pathsFrom, f = e.linePaths, b = e.areaPaths, m = e.seriesIndex, w = e.lineYPosition, A = e.xArrj, l = e.yArrj, u = e.y2Arrj, x = e.isRangeStart, v = e.seriesRangeEnd, k = this.w, S = new M(this.ctx), C = this.yRatio, L = p.prevY, I = p.linePath, z = p.areaPath, T = p.pathFromLine, E = p.pathFromArea, R = P.isNumber(k.globals.minYArr[n]) ? k.globals.minYArr[n] : k.globals.minY;
                    r || (r = k.globals.dataPoints > 1 ? k.globals.dataPoints - 1 : k.globals.dataPoints);
                    for(var O = function(le, he) {
                        return he - le / C[i.yaxisIndex] + 2 * (i.isReversed ? le / C[i.yaxisIndex] : 0);
                    }, D = c, W = k.config.chart.stacked && !k.globals.comboCharts || k.config.chart.stacked && k.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || ((t = this.w.config.series[n]) === null || t === void 0 ? void 0 : t.type) === "bar"), N = 0; N < r; N++){
                        var V = s[o][N + 1] === void 0 || s[o][N + 1] === null;
                        if (k.globals.isXNumeric) {
                            var j = k.globals.seriesX[n][N + 1];
                            k.globals.seriesX[n][N + 1] === void 0 && (j = k.globals.seriesX[n][r - 1]), h = (j - k.globals.minX) / this.xRatio;
                        } else h += this.xDivision;
                        W ? o > 0 && k.globals.collapsedSeries.length < k.config.series.length - 1 ? w = this.prevSeriesY[function(le) {
                            for(var he = le, $ = 0; $ < k.globals.series.length; $++)if (k.globals.collapsedSeriesIndices.indexOf(le) > -1) {
                                he--;
                                break;
                            }
                            return he >= 0 ? he : 0;
                        }(o - 1)][N + 1] : w = this.zeroY : w = this.zeroY, V ? c = O(R, w) : (c = O(s[o][N + 1], w), a === "rangeArea" && (D = O(v[o][N + 1], w))), A.push(h), V && k.config.stroke.curve === "smooth" ? l.push(null) : l.push(c), u.push(D);
                        var se = this.lineHelpers.calculatePoints({
                            series: s,
                            x: h,
                            y: c,
                            realIndex: n,
                            i: o,
                            j: N,
                            prevY: L
                        }), K = this._createPaths({
                            type: a,
                            series: s,
                            i: o,
                            realIndex: n,
                            j: N,
                            x: h,
                            y: c,
                            y2: D,
                            xArrj: A,
                            yArrj: l,
                            y2Arrj: u,
                            pX: d,
                            pY: g,
                            linePath: I,
                            areaPath: z,
                            linePaths: f,
                            areaPaths: b,
                            seriesIndex: m,
                            isRangeStart: x
                        });
                        b = K.areaPaths, f = K.linePaths, d = K.pX, g = K.pY, z = K.areaPath, I = K.linePath, !this.appendPathFrom || k.config.stroke.curve === "monotoneCubic" && a === "rangeArea" || (T += S.line(h, this.zeroY), E += S.line(h, this.zeroY)), this.handleNullDataPoints(s, se, o, N, n), this._handleMarkersAndLabels({
                            type: a,
                            pointsPos: se,
                            i: o,
                            j: N,
                            realIndex: n,
                            isRangeStart: x
                        });
                    }
                    return {
                        yArrj: l,
                        xArrj: A,
                        pathFromArea: E,
                        areaPaths: b,
                        pathFromLine: T,
                        linePaths: f,
                        linePath: I,
                        areaPath: z
                    };
                }
            },
            {
                key: "_handleMarkersAndLabels",
                value: function(e) {
                    var t = e.type, i = e.pointsPos, a = e.isRangeStart, s = e.i, r = e.j, n = e.realIndex, o = this.w, h = new ye(this.ctx);
                    if (this.pointsChart) this.scatter.draw(this.elSeries, r, {
                        realIndex: n,
                        pointsPos: i,
                        zRatio: this.zRatio,
                        elParent: this.elPointsMain
                    });
                    else {
                        o.globals.series[s].length > 1 && this.elPointsMain.node.classList.add("apexcharts-element-hidden");
                        var c = this.markers.plotChartMarkers(i, n, r + 1);
                        c !== null && this.elPointsMain.add(c);
                    }
                    var d = h.drawDataLabel({
                        type: t,
                        isRangeStart: a,
                        pos: i,
                        i: n,
                        j: r + 1
                    });
                    d !== null && this.elDataLabelsWrap.add(d);
                }
            },
            {
                key: "_createPaths",
                value: function(e) {
                    var t = e.type, i = e.series, a = e.i, s = e.realIndex, r = e.j, n = e.x, o = e.y, h = e.xArrj, c = e.yArrj, d = e.y2, g = e.y2Arrj, p = e.pX, f = e.pY, b = e.linePath, m = e.areaPath, w = e.linePaths, A = e.areaPaths, l = e.seriesIndex, u = e.isRangeStart, x = this.w, v = new M(this.ctx), k = x.config.stroke.curve, S = this.areaBottomY;
                    if (Array.isArray(x.config.stroke.curve) && (k = Array.isArray(l) ? x.config.stroke.curve[l[a]] : x.config.stroke.curve[a]), t === "rangeArea" && (x.globals.hasNullValues || x.config.forecastDataPoints.count > 0) && k === "monotoneCubic" && (k = "straight"), k === "monotoneCubic") {
                        var C = t === "rangeArea" ? h.length === x.globals.dataPoints : r === i[a].length - 2, L = h.map(function(W, N) {
                            return [
                                h[N],
                                c[N]
                            ];
                        }).filter(function(W) {
                            return W[1] !== null;
                        });
                        if (C && L.length > 1) {
                            var I = lt(L);
                            if (b += Ge(I), i[a][0] === null ? m = b : m += Ge(I), t === "rangeArea" && u) {
                                b += v.line(h[h.length - 1], g[g.length - 1]);
                                var z = h.slice().reverse(), T = g.slice().reverse(), E = z.map(function(W, N) {
                                    return [
                                        z[N],
                                        T[N]
                                    ];
                                }), R = lt(E);
                                m = b += Ge(R);
                            } else m += v.line(L[L.length - 1][0], S) + v.line(L[0][0], S) + v.move(L[0][0], L[0][1]) + "z";
                            w.push(b), A.push(m);
                        }
                    } else if (k === "smooth") {
                        var O = 0.35 * (n - p);
                        x.globals.hasNullValues ? (i[a][r] !== null && (i[a][r + 1] !== null ? (b = v.move(p, f) + v.curve(p + O, f, n - O, o, n + 1, o), m = v.move(p + 1, f) + v.curve(p + O, f, n - O, o, n + 1, o) + v.line(n, S) + v.line(p, S) + "z") : (b = v.move(p, f), m = v.move(p, f) + "z")), w.push(b), A.push(m)) : (b += v.curve(p + O, f, n - O, o, n, o), m += v.curve(p + O, f, n - O, o, n, o)), p = n, f = o, r === i[a].length - 2 && (m = m + v.curve(p, f, n, o, n, S) + v.move(n, o) + "z", t === "rangeArea" && u ? b = b + v.curve(p, f, n, o, n, d) + v.move(n, d) + "z" : x.globals.hasNullValues || (w.push(b), A.push(m)));
                    } else {
                        if (i[a][r + 1] === null) {
                            b += v.move(n, o);
                            var D = x.globals.isXNumeric ? (x.globals.seriesX[s][r] - x.globals.minX) / this.xRatio : n - this.xDivision;
                            m = m + v.line(D, S) + v.move(n, o) + "z";
                        }
                        i[a][r] === null && (b += v.move(n, o), m += v.move(n, S)), k === "stepline" ? (b = b + v.line(n, null, "H") + v.line(null, o, "V"), m = m + v.line(n, null, "H") + v.line(null, o, "V")) : k === "straight" && (b += v.line(n, o), m += v.line(n, o)), r === i[a].length - 2 && (m = m + v.line(n, S) + v.move(n, o) + "z", t === "rangeArea" && u ? b = b + v.line(n, d) + v.move(n, d) + "z" : (w.push(b), A.push(m)));
                    }
                    return {
                        linePaths: w,
                        areaPaths: A,
                        pX: p,
                        pY: f,
                        linePath: b,
                        areaPath: m
                    };
                }
            },
            {
                key: "handleNullDataPoints",
                value: function(e, t, i, a, s) {
                    var r = this.w;
                    if (e[i][a] === null && r.config.markers.showNullDataPoints || e[i].length === 1) {
                        var n = this.markers.plotChartMarkers(t, s, a + 1, this.strokeWidth - r.config.markers.strokeWidth / 2, !0);
                        n !== null && this.elPointsMain.add(n);
                    }
                }
            }
        ]), y;
    }();
    window.TreemapSquared = {}, window.TreemapSquared.generate = function() {
        function y(n, o, h, c) {
            this.xoffset = n, this.yoffset = o, this.height = c, this.width = h, this.shortestEdge = function() {
                return Math.min(this.height, this.width);
            }, this.getCoordinates = function(d) {
                var g, p = [], f = this.xoffset, b = this.yoffset, m = s(d) / this.height, w = s(d) / this.width;
                if (this.width >= this.height) for(g = 0; g < d.length; g++)p.push([
                    f,
                    b,
                    f + m,
                    b + d[g] / m
                ]), b += d[g] / m;
                else for(g = 0; g < d.length; g++)p.push([
                    f,
                    b,
                    f + d[g] / w,
                    b + w
                ]), f += d[g] / w;
                return p;
            }, this.cutArea = function(d) {
                var g;
                if (this.width >= this.height) {
                    var p = d / this.height, f = this.width - p;
                    g = new y(this.xoffset + p, this.yoffset, f, this.height);
                } else {
                    var b = d / this.width, m = this.height - b;
                    g = new y(this.xoffset, this.yoffset + b, this.width, m);
                }
                return g;
            };
        }
        function e(n, o, h, c, d) {
            c = c === void 0 ? 0 : c, d = d === void 0 ? 0 : d;
            var g = t(function(p, f) {
                var b, m = [], w = f / s(p);
                for(b = 0; b < p.length; b++)m[b] = p[b] * w;
                return m;
            }(n, o * h), [], new y(c, d, o, h), []);
            return function(p) {
                var f, b, m = [];
                for(f = 0; f < p.length; f++)for(b = 0; b < p[f].length; b++)m.push(p[f][b]);
                return m;
            }(g);
        }
        function t(n, o, h, c) {
            var d, g, p;
            if (n.length !== 0) return d = h.shortestEdge(), function(f, b, m) {
                var w;
                if (f.length === 0) return !0;
                (w = f.slice()).push(b);
                var A = i(f, m), l = i(w, m);
                return A >= l;
            }(o, g = n[0], d) ? (o.push(g), t(n.slice(1), o, h, c)) : (p = h.cutArea(s(o), c), c.push(h.getCoordinates(o)), t(n, [], p, c)), c;
            c.push(h.getCoordinates(o));
        }
        function i(n, o) {
            var h = Math.min.apply(Math, n), c = Math.max.apply(Math, n), d = s(n);
            return Math.max(Math.pow(o, 2) * c / Math.pow(d, 2), Math.pow(d, 2) / (Math.pow(o, 2) * h));
        }
        function a(n) {
            return n && n.constructor === Array;
        }
        function s(n) {
            var o, h = 0;
            for(o = 0; o < n.length; o++)h += n[o];
            return h;
        }
        function r(n) {
            var o, h = 0;
            if (a(n[0])) for(o = 0; o < n.length; o++)h += r(n[o]);
            else h = s(n);
            return h;
        }
        return function n(o, h, c, d, g) {
            d = d === void 0 ? 0 : d, g = g === void 0 ? 0 : g;
            var p, f, b = [], m = [];
            if (a(o[0])) {
                for(f = 0; f < o.length; f++)b[f] = r(o[f]);
                for(p = e(b, h, c, d, g), f = 0; f < o.length; f++)m.push(n(o[f], p[f][2] - p[f][0], p[f][3] - p[f][1], p[f][0], p[f][1]));
            } else m = e(o, h, c, d, g);
            return m;
        };
    }();
    var be, Fe, Nt = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.w = e.w, this.strokeWidth = this.w.config.stroke.width, this.helpers = new rt(e), this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.labels = [];
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e) {
                    var t = this, i = this.w, a = new M(this.ctx), s = new ae(this.ctx), r = a.group({
                        class: "apexcharts-treemap"
                    });
                    if (i.globals.noData) return r;
                    var n = [];
                    return e.forEach(function(o) {
                        var h = o.map(function(c) {
                            return Math.abs(c);
                        });
                        n.push(h);
                    }), this.negRange = this.helpers.checkColorRange(), i.config.series.forEach(function(o, h) {
                        o.data.forEach(function(c) {
                            Array.isArray(t.labels[h]) || (t.labels[h] = []), t.labels[h].push(c.x);
                        });
                    }), window.TreemapSquared.generate(n, i.globals.gridWidth, i.globals.gridHeight).forEach(function(o, h) {
                        var c = a.group({
                            class: "apexcharts-series apexcharts-treemap-series",
                            seriesName: P.escapeString(i.globals.seriesNames[h]),
                            rel: h + 1,
                            "data:realIndex": h
                        });
                        if (i.config.chart.dropShadow.enabled) {
                            var d = i.config.chart.dropShadow;
                            new Z(t.ctx).dropShadow(r, d, h);
                        }
                        var g = a.group({
                            class: "apexcharts-data-labels"
                        });
                        o.forEach(function(p, f) {
                            var b = p[0], m = p[1], w = p[2], A = p[3], l = a.drawRect(b, m, w - b, A - m, i.config.plotOptions.treemap.borderRadius, "#fff", 1, t.strokeWidth, i.config.plotOptions.treemap.useFillColorAsStroke ? x : i.globals.stroke.colors[h]);
                            l.attr({
                                cx: b,
                                cy: m,
                                index: h,
                                i: h,
                                j: f,
                                width: w - b,
                                height: A - m
                            });
                            var u = t.helpers.getShadeColor(i.config.chart.type, h, f, t.negRange), x = u.color;
                            i.config.series[h].data[f] !== void 0 && i.config.series[h].data[f].fillColor && (x = i.config.series[h].data[f].fillColor);
                            var v = s.fillPath({
                                color: x,
                                seriesNumber: h,
                                dataPointIndex: f
                            });
                            l.node.classList.add("apexcharts-treemap-rect"), l.attr({
                                fill: v
                            }), t.helpers.addListeners(l);
                            var k = {
                                x: b + (w - b) / 2,
                                y: m + (A - m) / 2,
                                width: 0,
                                height: 0
                            }, S = {
                                x: b,
                                y: m,
                                width: w - b,
                                height: A - m
                            };
                            if (i.config.chart.animations.enabled && !i.globals.dataChanged) {
                                var C = 1;
                                i.globals.resized || (C = i.config.chart.animations.speed), t.animateTreemap(l, k, S, C);
                            }
                            if (i.globals.dataChanged) {
                                var L = 1;
                                t.dynamicAnim.enabled && i.globals.shouldAnimate && (L = t.dynamicAnim.speed, i.globals.previousPaths[h] && i.globals.previousPaths[h][f] && i.globals.previousPaths[h][f].rect && (k = i.globals.previousPaths[h][f].rect), t.animateTreemap(l, k, S, L));
                            }
                            var I = t.getFontSize(p), z = i.config.dataLabels.formatter(t.labels[h][f], {
                                value: i.globals.series[h][f],
                                seriesIndex: h,
                                dataPointIndex: f,
                                w: i
                            });
                            i.config.plotOptions.treemap.dataLabels.format === "truncate" && (I = parseInt(i.config.dataLabels.style.fontSize, 10), z = t.truncateLabels(z, I, b, m, w, A));
                            var T = t.helpers.calculateDataLabels({
                                text: z,
                                x: (b + w) / 2,
                                y: (m + A) / 2 + t.strokeWidth / 2 + I / 3,
                                i: h,
                                j: f,
                                colorProps: u,
                                fontSize: I,
                                series: e
                            });
                            i.config.dataLabels.enabled && T && t.rotateToFitLabel(T, I, z, b, m, w, A), c.add(l), T !== null && c.add(T);
                        }), c.add(g), r.add(c);
                    }), r;
                }
            },
            {
                key: "getFontSize",
                value: function(e) {
                    var t = this.w, i, a, s, r, n = function o(h) {
                        var c, d = 0;
                        if (Array.isArray(h[0])) for(c = 0; c < h.length; c++)d += o(h[c]);
                        else for(c = 0; c < h.length; c++)d += h[c].length;
                        return d;
                    }(this.labels) / function o(h) {
                        var c, d = 0;
                        if (Array.isArray(h[0])) for(c = 0; c < h.length; c++)d += o(h[c]);
                        else for(c = 0; c < h.length; c++)d += 1;
                        return d;
                    }(this.labels);
                    return i = e[2] - e[0], a = e[3] - e[1], s = i * a, r = Math.pow(s, 0.5), Math.min(r / n, parseInt(t.config.dataLabels.style.fontSize, 10));
                }
            },
            {
                key: "rotateToFitLabel",
                value: function(e, t, i, a, s, r, n) {
                    var o = new M(this.ctx), h = o.getTextRects(i, t);
                    if (h.width + this.w.config.stroke.width + 5 > r - a && h.width <= n - s) {
                        var c = o.rotateAroundCenter(e.node);
                        e.node.setAttribute("transform", "rotate(-90 ".concat(c.x, " ").concat(c.y, ") translate(").concat(h.height / 3, ")"));
                    }
                }
            },
            {
                key: "truncateLabels",
                value: function(e, t, i, a, s, r) {
                    var n = new M(this.ctx), o = n.getTextRects(e, t).width + this.w.config.stroke.width + 5 > s - i && r - a > s - i ? r - a : s - i, h = n.getTextBasedOnMaxWidth({
                        text: e,
                        maxWidth: o,
                        fontSize: t
                    });
                    return e.length !== h.length && o / t < 5 ? "" : h;
                }
            },
            {
                key: "animateTreemap",
                value: function(e, t, i, a) {
                    var s = new de(this.ctx);
                    s.animateRect(e, {
                        x: t.x,
                        y: t.y,
                        width: t.width,
                        height: t.height
                    }, {
                        x: i.x,
                        y: i.y,
                        width: i.width,
                        height: i.height
                    }, a, function() {
                        s.animationCompleted(e);
                    });
                }
            }
        ]), y;
    }(), Wt = 86400, Bt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.timeScaleArray = [], this.utc = this.w.config.xaxis.labels.datetimeUTC;
        }
        return Y(y, [
            {
                key: "calculateTimeScaleTicks",
                value: function(e, t) {
                    var i = this, a = this.w;
                    if (a.globals.allSeriesCollapsed) return a.globals.labels = [], a.globals.timescaleLabels = [], [];
                    var s = new B(this.ctx), r = (t - e) / 864e5;
                    this.determineInterval(r), a.globals.disableZoomIn = !1, a.globals.disableZoomOut = !1, r < 11574074074074075e-20 ? a.globals.disableZoomIn = !0 : r > 5e4 && (a.globals.disableZoomOut = !0);
                    var n = s.getTimeUnitsfromTimestamp(e, t, this.utc), o = a.globals.gridWidth / r, h = o / 24, c = h / 60, d = c / 60, g = Math.floor(24 * r), p = Math.floor(1440 * r), f = Math.floor(r * Wt), b = Math.floor(r), m = Math.floor(r / 30), w = Math.floor(r / 365), A = {
                        minMillisecond: n.minMillisecond,
                        minSecond: n.minSecond,
                        minMinute: n.minMinute,
                        minHour: n.minHour,
                        minDate: n.minDate,
                        minMonth: n.minMonth,
                        minYear: n.minYear
                    }, l = {
                        firstVal: A,
                        currentMillisecond: A.minMillisecond,
                        currentSecond: A.minSecond,
                        currentMinute: A.minMinute,
                        currentHour: A.minHour,
                        currentMonthDate: A.minDate,
                        currentDate: A.minDate,
                        currentMonth: A.minMonth,
                        currentYear: A.minYear,
                        daysWidthOnXAxis: o,
                        hoursWidthOnXAxis: h,
                        minutesWidthOnXAxis: c,
                        secondsWidthOnXAxis: d,
                        numberOfSeconds: f,
                        numberOfMinutes: p,
                        numberOfHours: g,
                        numberOfDays: b,
                        numberOfMonths: m,
                        numberOfYears: w
                    };
                    switch(this.tickInterval){
                        case "years":
                            this.generateYearScale(l);
                            break;
                        case "months":
                        case "half_year":
                            this.generateMonthScale(l);
                            break;
                        case "months_days":
                        case "months_fortnight":
                        case "days":
                        case "week_days":
                            this.generateDayScale(l);
                            break;
                        case "hours":
                            this.generateHourScale(l);
                            break;
                        case "minutes_fives":
                        case "minutes":
                            this.generateMinuteScale(l);
                            break;
                        case "seconds_tens":
                        case "seconds_fives":
                        case "seconds":
                            this.generateSecondScale(l);
                    }
                    var u = this.timeScaleArray.map(function(x) {
                        var v = {
                            position: x.position,
                            unit: x.unit,
                            year: x.year,
                            day: x.day ? x.day : 1,
                            hour: x.hour ? x.hour : 0,
                            month: x.month + 1
                        };
                        return x.unit === "month" ? X(X({}, v), {}, {
                            day: 1,
                            value: x.value + 1
                        }) : x.unit === "day" || x.unit === "hour" ? X(X({}, v), {}, {
                            value: x.value
                        }) : x.unit === "minute" ? X(X({}, v), {}, {
                            value: x.value,
                            minute: x.value
                        }) : x.unit === "second" ? X(X({}, v), {}, {
                            value: x.value,
                            minute: x.minute,
                            second: x.second
                        }) : x;
                    });
                    return u.filter(function(x) {
                        var v = 1, k = Math.ceil(a.globals.gridWidth / 120), S = x.value;
                        a.config.xaxis.tickAmount !== void 0 && (k = a.config.xaxis.tickAmount), u.length > k && (v = Math.floor(u.length / k));
                        var C = !1, L = !1;
                        switch(i.tickInterval){
                            case "years":
                                x.unit === "year" && (C = !0);
                                break;
                            case "half_year":
                                v = 7, x.unit === "year" && (C = !0);
                                break;
                            case "months":
                                v = 1, x.unit === "year" && (C = !0);
                                break;
                            case "months_fortnight":
                                v = 15, x.unit !== "year" && x.unit !== "month" || (C = !0), S === 30 && (L = !0);
                                break;
                            case "months_days":
                                v = 10, x.unit === "month" && (C = !0), S === 30 && (L = !0);
                                break;
                            case "week_days":
                                v = 8, x.unit === "month" && (C = !0);
                                break;
                            case "days":
                                v = 1, x.unit === "month" && (C = !0);
                                break;
                            case "hours":
                                x.unit === "day" && (C = !0);
                                break;
                            case "minutes_fives":
                            case "seconds_fives":
                                S % 5 != 0 && (L = !0);
                                break;
                            case "seconds_tens":
                                S % 10 != 0 && (L = !0);
                        }
                        if (i.tickInterval === "hours" || i.tickInterval === "minutes_fives" || i.tickInterval === "seconds_tens" || i.tickInterval === "seconds_fives") {
                            if (!L) return !0;
                        } else if ((S % v == 0 || C) && !L) return !0;
                    });
                }
            },
            {
                key: "recalcDimensionsBasedOnFormat",
                value: function(e, t) {
                    var i = this.w, a = this.formatDates(e), s = this.removeOverlappingTS(a);
                    i.globals.timescaleLabels = s.slice(), new Ye(this.ctx).plotCoords();
                }
            },
            {
                key: "determineInterval",
                value: function(e) {
                    var t = 24 * e, i = 60 * t;
                    switch(!0){
                        case e / 365 > 5:
                            this.tickInterval = "years";
                            break;
                        case e > 800:
                            this.tickInterval = "half_year";
                            break;
                        case e > 180:
                            this.tickInterval = "months";
                            break;
                        case e > 90:
                            this.tickInterval = "months_fortnight";
                            break;
                        case e > 60:
                            this.tickInterval = "months_days";
                            break;
                        case e > 30:
                            this.tickInterval = "week_days";
                            break;
                        case e > 2:
                            this.tickInterval = "days";
                            break;
                        case t > 2.4:
                            this.tickInterval = "hours";
                            break;
                        case i > 15:
                            this.tickInterval = "minutes_fives";
                            break;
                        case i > 5:
                            this.tickInterval = "minutes";
                            break;
                        case i > 1:
                            this.tickInterval = "seconds_tens";
                            break;
                        case 60 * i > 20:
                            this.tickInterval = "seconds_fives";
                            break;
                        default:
                            this.tickInterval = "seconds";
                    }
                }
            },
            {
                key: "generateYearScale",
                value: function(e) {
                    var t = e.firstVal, i = e.currentMonth, a = e.currentYear, s = e.daysWidthOnXAxis, r = e.numberOfYears, n = t.minYear, o = 0, h = new B(this.ctx), c = "year";
                    if (t.minDate > 1 || t.minMonth > 0) {
                        var d = h.determineRemainingDaysOfYear(t.minYear, t.minMonth, t.minDate);
                        o = (h.determineDaysOfYear(t.minYear) - d + 1) * s, n = t.minYear + 1, this.timeScaleArray.push({
                            position: o,
                            value: n,
                            unit: c,
                            year: n,
                            month: P.monthMod(i + 1)
                        });
                    } else t.minDate === 1 && t.minMonth === 0 && this.timeScaleArray.push({
                        position: o,
                        value: n,
                        unit: c,
                        year: a,
                        month: P.monthMod(i + 1)
                    });
                    for(var g = n, p = o, f = 0; f < r; f++)g++, p = h.determineDaysOfYear(g - 1) * s + p, this.timeScaleArray.push({
                        position: p,
                        value: g,
                        unit: c,
                        year: g,
                        month: 1
                    });
                }
            },
            {
                key: "generateMonthScale",
                value: function(e) {
                    var t = e.firstVal, i = e.currentMonthDate, a = e.currentMonth, s = e.currentYear, r = e.daysWidthOnXAxis, n = e.numberOfMonths, o = a, h = 0, c = new B(this.ctx), d = "month", g = 0;
                    if (t.minDate > 1) {
                        h = (c.determineDaysOfMonths(a + 1, t.minYear) - i + 1) * r, o = P.monthMod(a + 1);
                        var p = s + g, f = P.monthMod(o), b = o;
                        o === 0 && (d = "year", b = p, f = 1, p += g += 1), this.timeScaleArray.push({
                            position: h,
                            value: b,
                            unit: d,
                            year: p,
                            month: f
                        });
                    } else this.timeScaleArray.push({
                        position: h,
                        value: o,
                        unit: d,
                        year: s,
                        month: P.monthMod(a)
                    });
                    for(var m = o + 1, w = h, A = 0, l = 1; A < n; A++, l++){
                        (m = P.monthMod(m)) === 0 ? (d = "year", g += 1) : d = "month";
                        var u = this._getYear(s, m, g);
                        w = c.determineDaysOfMonths(m, u) * r + w;
                        var x = m === 0 ? u : m;
                        this.timeScaleArray.push({
                            position: w,
                            value: x,
                            unit: d,
                            year: u,
                            month: m === 0 ? 1 : m
                        }), m++;
                    }
                }
            },
            {
                key: "generateDayScale",
                value: function(e) {
                    var t = e.firstVal, i = e.currentMonth, a = e.currentYear, s = e.hoursWidthOnXAxis, r = e.numberOfDays, n = new B(this.ctx), o = "day", h = t.minDate + 1, c = h, d = function(l, u, x) {
                        return l > n.determineDaysOfMonths(u + 1, x) && (c = 1, o = "month", p = u += 1), u;
                    }, g = (24 - t.minHour) * s, p = h, f = d(c, i, a);
                    t.minHour === 0 && t.minDate === 1 ? (g = 0, p = P.monthMod(t.minMonth), o = "month", c = t.minDate) : t.minDate !== 1 && t.minHour === 0 && t.minMinute === 0 && (g = 0, h = t.minDate, p = h, f = d(c = h, i, a)), this.timeScaleArray.push({
                        position: g,
                        value: p,
                        unit: o,
                        year: this._getYear(a, f, 0),
                        month: P.monthMod(f),
                        day: c
                    });
                    for(var b = g, m = 0; m < r; m++){
                        o = "day", f = d(c += 1, f, this._getYear(a, f, 0));
                        var w = this._getYear(a, f, 0);
                        b = 24 * s + b;
                        var A = c === 1 ? P.monthMod(f) : c;
                        this.timeScaleArray.push({
                            position: b,
                            value: A,
                            unit: o,
                            year: w,
                            month: P.monthMod(f),
                            day: A
                        });
                    }
                }
            },
            {
                key: "generateHourScale",
                value: function(e) {
                    var t = e.firstVal, i = e.currentDate, a = e.currentMonth, s = e.currentYear, r = e.minutesWidthOnXAxis, n = e.numberOfHours, o = new B(this.ctx), h = "hour", c = function(v, k) {
                        return v > o.determineDaysOfMonths(k + 1, s) && (m = 1, k += 1), {
                            month: k,
                            date: m
                        };
                    }, d = function(v, k) {
                        return v > o.determineDaysOfMonths(k + 1, s) ? k += 1 : k;
                    }, g = 60 - (t.minMinute + t.minSecond / 60), p = g * r, f = t.minHour + 1, b = f;
                    g === 60 && (p = 0, b = f = t.minHour);
                    var m = i;
                    b >= 24 && (b = 0, m += 1, h = "day");
                    var w = c(m, a).month;
                    w = d(m, w), this.timeScaleArray.push({
                        position: p,
                        value: f,
                        unit: h,
                        day: m,
                        hour: b,
                        year: s,
                        month: P.monthMod(w)
                    }), b++;
                    for(var A = p, l = 0; l < n; l++){
                        h = "hour", b >= 24 && (b = 0, h = "day", w = c(m += 1, w).month, w = d(m, w));
                        var u = this._getYear(s, w, 0);
                        A = 60 * r + A;
                        var x = b === 0 ? m : b;
                        this.timeScaleArray.push({
                            position: A,
                            value: x,
                            unit: h,
                            hour: b,
                            day: m,
                            year: u,
                            month: P.monthMod(w)
                        }), b++;
                    }
                }
            },
            {
                key: "generateMinuteScale",
                value: function(e) {
                    for(var t = e.currentMillisecond, i = e.currentSecond, a = e.currentMinute, s = e.currentHour, r = e.currentDate, n = e.currentMonth, o = e.currentYear, h = e.minutesWidthOnXAxis, c = e.secondsWidthOnXAxis, d = e.numberOfMinutes, g = a + 1, p = r, f = n, b = o, m = s, w = (60 - i - t / 1e3) * c, A = 0; A < d; A++)g >= 60 && (g = 0, (m += 1) === 24 && (m = 0)), this.timeScaleArray.push({
                        position: w,
                        value: g,
                        unit: "minute",
                        hour: m,
                        minute: g,
                        day: p,
                        year: this._getYear(b, f, 0),
                        month: P.monthMod(f)
                    }), w += h, g++;
                }
            },
            {
                key: "generateSecondScale",
                value: function(e) {
                    for(var t = e.currentMillisecond, i = e.currentSecond, a = e.currentMinute, s = e.currentHour, r = e.currentDate, n = e.currentMonth, o = e.currentYear, h = e.secondsWidthOnXAxis, c = e.numberOfSeconds, d = i + 1, g = a, p = r, f = n, b = o, m = s, w = (1e3 - t) / 1e3 * h, A = 0; A < c; A++)d >= 60 && (d = 0, ++g >= 60 && (g = 0, ++m === 24 && (m = 0))), this.timeScaleArray.push({
                        position: w,
                        value: d,
                        unit: "second",
                        hour: m,
                        minute: g,
                        second: d,
                        day: p,
                        year: this._getYear(b, f, 0),
                        month: P.monthMod(f)
                    }), w += h, d++;
                }
            },
            {
                key: "createRawDateString",
                value: function(e, t) {
                    var i = e.year;
                    return e.month === 0 && (e.month = 1), i += "-" + ("0" + e.month.toString()).slice(-2), e.unit === "day" ? i += e.unit === "day" ? "-" + ("0" + t).slice(-2) : "-01" : i += "-" + ("0" + (e.day ? e.day : "1")).slice(-2), e.unit === "hour" ? i += e.unit === "hour" ? "T" + ("0" + t).slice(-2) : "T00" : i += "T" + ("0" + (e.hour ? e.hour : "0")).slice(-2), e.unit === "minute" ? i += ":" + ("0" + t).slice(-2) : i += ":" + (e.minute ? ("0" + e.minute).slice(-2) : "00"), e.unit === "second" ? i += ":" + ("0" + t).slice(-2) : i += ":00", this.utc && (i += ".000Z"), i;
                }
            },
            {
                key: "formatDates",
                value: function(e) {
                    var t = this, i = this.w;
                    return e.map(function(a) {
                        var s = a.value.toString(), r = new B(t.ctx), n = t.createRawDateString(a, s), o = r.getDate(r.parseDate(n));
                        if (t.utc || (o = r.getDate(r.parseDateWithTimezone(n))), i.config.xaxis.labels.format === void 0) {
                            var h = "dd MMM", c = i.config.xaxis.labels.datetimeFormatter;
                            a.unit === "year" && (h = c.year), a.unit === "month" && (h = c.month), a.unit === "day" && (h = c.day), a.unit === "hour" && (h = c.hour), a.unit === "minute" && (h = c.minute), a.unit === "second" && (h = c.second), s = r.formatDate(o, h);
                        } else s = r.formatDate(o, i.config.xaxis.labels.format);
                        return {
                            dateString: n,
                            position: a.position,
                            value: s,
                            unit: a.unit,
                            year: a.year,
                            month: a.month
                        };
                    });
                }
            },
            {
                key: "removeOverlappingTS",
                value: function(e) {
                    var t, i = this, a = new M(this.ctx), s = !1;
                    e.length > 0 && e[0].value && e.every(function(o) {
                        return o.value.length === e[0].value.length;
                    }) && (s = !0, t = a.getTextRects(e[0].value).width);
                    var r = 0, n = e.map(function(o, h) {
                        if (h > 0 && i.w.config.xaxis.labels.hideOverlappingLabels) {
                            var c = s ? t : a.getTextRects(e[r].value).width, d = e[r].position;
                            return o.position > d + c + 10 ? (r = h, o) : null;
                        }
                        return o;
                    });
                    return n = n.filter(function(o) {
                        return o !== null;
                    });
                }
            },
            {
                key: "_getYear",
                value: function(e, t, i) {
                    return e + Math.floor(t / 12) + i;
                }
            }
        ]), y;
    }(), Gt = function() {
        function y(e, t) {
            F(this, y), this.ctx = t, this.w = t.w, this.el = e;
        }
        return Y(y, [
            {
                key: "setupElements",
                value: function() {
                    var e = this.w.globals, t = this.w.config, i = t.chart.type;
                    e.axisCharts = [
                        "line",
                        "area",
                        "bar",
                        "rangeBar",
                        "rangeArea",
                        "candlestick",
                        "boxPlot",
                        "scatter",
                        "bubble",
                        "radar",
                        "heatmap",
                        "treemap"
                    ].indexOf(i) > -1, e.xyCharts = [
                        "line",
                        "area",
                        "bar",
                        "rangeBar",
                        "rangeArea",
                        "candlestick",
                        "boxPlot",
                        "scatter",
                        "bubble"
                    ].indexOf(i) > -1, e.isBarHorizontal = (t.chart.type === "bar" || t.chart.type === "rangeBar" || t.chart.type === "boxPlot") && t.plotOptions.bar.horizontal, e.chartClass = ".apexcharts" + e.chartID, e.dom.baseEl = this.el, e.dom.elWrap = document.createElement("div"), M.setAttrs(e.dom.elWrap, {
                        id: e.chartClass.substring(1),
                        class: "apexcharts-canvas " + e.chartClass.substring(1)
                    }), this.el.appendChild(e.dom.elWrap), e.dom.Paper = new window.SVG.Doc(e.dom.elWrap), e.dom.Paper.attr({
                        class: "apexcharts-svg",
                        "xmlns:data": "ApexChartsNS",
                        transform: "translate(".concat(t.chart.offsetX, ", ").concat(t.chart.offsetY, ")")
                    }), e.dom.Paper.node.style.background = t.theme.mode !== "dark" || t.chart.background ? t.chart.background : "rgba(0, 0, 0, 0.8)", this.setSVGDimensions(), e.dom.elLegendForeign = document.createElementNS(e.SVGNS, "foreignObject"), M.setAttrs(e.dom.elLegendForeign, {
                        x: 0,
                        y: 0,
                        width: e.svgWidth,
                        height: e.svgHeight
                    }), e.dom.elLegendWrap = document.createElement("div"), e.dom.elLegendWrap.classList.add("apexcharts-legend"), e.dom.elLegendWrap.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), e.dom.elLegendForeign.appendChild(e.dom.elLegendWrap), e.dom.Paper.node.appendChild(e.dom.elLegendForeign), e.dom.elGraphical = e.dom.Paper.group().attr({
                        class: "apexcharts-inner apexcharts-graphical"
                    }), e.dom.elDefs = e.dom.Paper.defs(), e.dom.Paper.add(e.dom.elGraphical), e.dom.elGraphical.add(e.dom.elDefs);
                }
            },
            {
                key: "plotChartType",
                value: function(e, t) {
                    var i = this.w, a = i.config, s = i.globals, r = {
                        series: [],
                        i: []
                    }, n = {
                        series: [],
                        i: []
                    }, o = {
                        series: [],
                        i: []
                    }, h = {
                        series: [],
                        i: []
                    }, c = {
                        series: [],
                        i: []
                    }, d = {
                        series: [],
                        i: []
                    }, g = {
                        series: [],
                        i: []
                    }, p = {
                        series: [],
                        i: []
                    }, f = {
                        series: [],
                        seriesRangeEnd: [],
                        i: []
                    };
                    s.series.map(function(k, S) {
                        var C = 0;
                        e[S].type !== void 0 ? (e[S].type === "column" || e[S].type === "bar" ? (s.series.length > 1 && a.plotOptions.bar.horizontal && console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"), c.series.push(k), c.i.push(S), C++, i.globals.columnSeries = c.series) : e[S].type === "area" ? (n.series.push(k), n.i.push(S), C++) : e[S].type === "line" ? (r.series.push(k), r.i.push(S), C++) : e[S].type === "scatter" ? (o.series.push(k), o.i.push(S)) : e[S].type === "bubble" ? (h.series.push(k), h.i.push(S), C++) : e[S].type === "candlestick" ? (d.series.push(k), d.i.push(S), C++) : e[S].type === "boxPlot" ? (g.series.push(k), g.i.push(S), C++) : e[S].type === "rangeBar" ? (p.series.push(k), p.i.push(S), C++) : e[S].type === "rangeArea" ? (f.series.push(s.seriesRangeStart[S]), f.seriesRangeEnd.push(s.seriesRangeEnd[S]), f.i.push(S), C++) : console.warn("You have specified an unrecognized chart type. Available types for this property are line/area/column/bar/scatter/bubble/candlestick/boxPlot/rangeBar/rangeArea"), C > 1 && (s.comboCharts = !0)) : (r.series.push(k), r.i.push(S));
                    });
                    var b = new je(this.ctx, t), m = new Be(this.ctx, t);
                    this.ctx.pie = new ot(this.ctx);
                    var w = new Rt(this.ctx);
                    this.ctx.rangeBar = new Ot(this.ctx, t);
                    var A = new Ft(this.ctx), l = [];
                    if (s.comboCharts) {
                        if (n.series.length > 0 && l.push(b.draw(n.series, "area", n.i)), c.series.length > 0) {
                            if (i.config.chart.stacked) {
                                var u = new st(this.ctx, t);
                                l.push(u.draw(c.series, c.i));
                            } else this.ctx.bar = new ke(this.ctx, t), l.push(this.ctx.bar.draw(c.series, c.i));
                        }
                        if (f.series.length > 0 && l.push(b.draw(f.series, "rangeArea", f.i, f.seriesRangeEnd)), r.series.length > 0 && l.push(b.draw(r.series, "line", r.i)), d.series.length > 0 && l.push(m.draw(d.series, "candlestick", d.i)), g.series.length > 0 && l.push(m.draw(g.series, "boxPlot", g.i)), p.series.length > 0 && l.push(this.ctx.rangeBar.draw(p.series, p.i)), o.series.length > 0) {
                            var x = new je(this.ctx, t, !0);
                            l.push(x.draw(o.series, "scatter", o.i));
                        }
                        if (h.series.length > 0) {
                            var v = new je(this.ctx, t, !0);
                            l.push(v.draw(h.series, "bubble", h.i));
                        }
                    } else switch(a.chart.type){
                        case "line":
                            l = b.draw(s.series, "line");
                            break;
                        case "area":
                            l = b.draw(s.series, "area");
                            break;
                        case "bar":
                            a.chart.stacked ? l = new st(this.ctx, t).draw(s.series) : (this.ctx.bar = new ke(this.ctx, t), l = this.ctx.bar.draw(s.series));
                            break;
                        case "candlestick":
                            l = new Be(this.ctx, t).draw(s.series, "candlestick");
                            break;
                        case "boxPlot":
                            l = new Be(this.ctx, t).draw(s.series, a.chart.type);
                            break;
                        case "rangeBar":
                            l = this.ctx.rangeBar.draw(s.series);
                            break;
                        case "rangeArea":
                            l = b.draw(s.seriesRangeStart, "rangeArea", void 0, s.seriesRangeEnd);
                            break;
                        case "heatmap":
                            l = new Yt(this.ctx, t).draw(s.series);
                            break;
                        case "treemap":
                            l = new Nt(this.ctx, t).draw(s.series);
                            break;
                        case "pie":
                        case "donut":
                        case "polarArea":
                            l = this.ctx.pie.draw(s.series);
                            break;
                        case "radialBar":
                            l = w.draw(s.series);
                            break;
                        case "radar":
                            l = A.draw(s.series);
                            break;
                        default:
                            l = b.draw(s.series);
                    }
                    return l;
                }
            },
            {
                key: "setSVGDimensions",
                value: function() {
                    var e = this.w.globals, t = this.w.config;
                    e.svgWidth = t.chart.width, e.svgHeight = t.chart.height;
                    var i = P.getDimensions(this.el), a = t.chart.width.toString().split(/[0-9]+/g).pop();
                    a === "%" ? P.isNumber(i[0]) && (i[0].width === 0 && (i = P.getDimensions(this.el.parentNode)), e.svgWidth = i[0] * parseInt(t.chart.width, 10) / 100) : a !== "px" && a !== "" || (e.svgWidth = parseInt(t.chart.width, 10));
                    var s = t.chart.height.toString().split(/[0-9]+/g).pop();
                    if (e.svgHeight !== "auto" && e.svgHeight !== "") {
                        if (s === "%") {
                            var r = P.getDimensions(this.el.parentNode);
                            e.svgHeight = r[1] * parseInt(t.chart.height, 10) / 100;
                        } else e.svgHeight = parseInt(t.chart.height, 10);
                    } else e.axisCharts ? e.svgHeight = e.svgWidth / 1.61 : e.svgHeight = e.svgWidth / 1.2;
                    if (e.svgWidth < 0 && (e.svgWidth = 0), e.svgHeight < 0 && (e.svgHeight = 0), M.setAttrs(e.dom.Paper.node, {
                        width: e.svgWidth,
                        height: e.svgHeight
                    }), s !== "%") {
                        var n = t.chart.sparkline.enabled ? 0 : e.axisCharts ? t.chart.parentHeightOffset : 0;
                        e.dom.Paper.node.parentNode.parentNode.style.minHeight = e.svgHeight + n + "px";
                    }
                    e.dom.elWrap.style.width = e.svgWidth + "px", e.dom.elWrap.style.height = e.svgHeight + "px";
                }
            },
            {
                key: "shiftGraphPosition",
                value: function() {
                    var e = this.w.globals, t = e.translateY, i = {
                        transform: "translate(" + e.translateX + ", " + t + ")"
                    };
                    M.setAttrs(e.dom.elGraphical.node, i);
                }
            },
            {
                key: "resizeNonAxisCharts",
                value: function() {
                    var e = this.w, t = e.globals, i = 0, a = e.config.chart.sparkline.enabled ? 1 : 15;
                    a += e.config.grid.padding.bottom, e.config.legend.position !== "top" && e.config.legend.position !== "bottom" || !e.config.legend.show || e.config.legend.floating || (i = new Ke(this.ctx).legendHelpers.getLegendBBox().clwh + 10);
                    var s = e.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"), r = 2.05 * e.globals.radialSize;
                    if (s && !e.config.chart.sparkline.enabled && e.config.plotOptions.radialBar.startAngle !== 0) {
                        var n = P.getBoundingClientRect(s);
                        r = n.bottom;
                        var o = n.bottom - n.top;
                        r = Math.max(2.05 * e.globals.radialSize, o);
                    }
                    var h = r + t.translateY + i + a;
                    t.dom.elLegendForeign && t.dom.elLegendForeign.setAttribute("height", h), e.config.chart.height && String(e.config.chart.height).indexOf("%") > 0 || (t.dom.elWrap.style.height = h + "px", M.setAttrs(t.dom.Paper.node, {
                        height: h
                    }), t.dom.Paper.node.parentNode.parentNode.style.minHeight = h + "px");
                }
            },
            {
                key: "coreCalculations",
                value: function() {
                    new De(this.ctx).init();
                }
            },
            {
                key: "resetGlobals",
                value: function() {
                    var e = this, t = function() {
                        return e.w.config.series.map(function(s) {
                            return [];
                        });
                    }, i = new Ze(), a = this.w.globals;
                    i.initGlobalVars(a), a.seriesXvalues = t(), a.seriesYvalues = t();
                }
            },
            {
                key: "isMultipleY",
                value: function() {
                    if (this.w.config.yaxis.constructor === Array && this.w.config.yaxis.length > 1) return this.w.globals.isMultipleYAxis = !0, !0;
                }
            },
            {
                key: "xySettings",
                value: function() {
                    var e = null, t = this.w;
                    if (t.globals.axisCharts) {
                        if (t.config.xaxis.crosshairs.position === "back" && new We(this.ctx).drawXCrosshairs(), t.config.yaxis[0].crosshairs.position === "back" && new We(this.ctx).drawYCrosshairs(), t.config.xaxis.type === "datetime" && t.config.xaxis.labels.formatter === void 0) {
                            this.ctx.timeScale = new Bt(this.ctx);
                            var i = [];
                            isFinite(t.globals.minX) && isFinite(t.globals.maxX) && !t.globals.isBarHorizontal ? i = this.ctx.timeScale.calculateTimeScaleTicks(t.globals.minX, t.globals.maxX) : t.globals.isBarHorizontal && (i = this.ctx.timeScale.calculateTimeScaleTicks(t.globals.minY, t.globals.maxY)), this.ctx.timeScale.recalcDimensionsBasedOnFormat(i);
                        }
                        e = new q(this.ctx).getCalculatedRatios();
                    }
                    return e;
                }
            },
            {
                key: "updateSourceChart",
                value: function(e) {
                    this.ctx.w.globals.selection = void 0, this.ctx.updateHelpers._updateOptions({
                        chart: {
                            selection: {
                                xaxis: {
                                    min: e.w.globals.minX,
                                    max: e.w.globals.maxX
                                }
                            }
                        }
                    }, !1, !1);
                }
            },
            {
                key: "setupBrushHandler",
                value: function() {
                    var e = this, t = this.w;
                    if (t.config.chart.brush.enabled && typeof t.config.chart.events.selection != "function") {
                        var i = Array.isArray(t.config.chart.brush.targets) ? t.config.chart.brush.targets : [
                            t.config.chart.brush.target
                        ];
                        i.forEach(function(a) {
                            var s = ApexCharts.getChartByID(a);
                            s.w.globals.brushSource = e.ctx, typeof s.w.config.chart.events.zoomed != "function" && (s.w.config.chart.events.zoomed = function() {
                                e.updateSourceChart(s);
                            }), typeof s.w.config.chart.events.scrolled != "function" && (s.w.config.chart.events.scrolled = function() {
                                e.updateSourceChart(s);
                            });
                        }), t.config.chart.events.selection = function(a, s) {
                            i.forEach(function(r) {
                                var n = ApexCharts.getChartByID(r), o = P.clone(t.config.yaxis);
                                if (t.config.chart.brush.autoScaleYaxis && n.w.globals.series.length === 1) {
                                    var h = new we(n);
                                    o = h.autoScaleY(n, o, s);
                                }
                                var c = n.w.config.yaxis.reduce(function(d, g, p) {
                                    return [].concat(J(d), [
                                        X(X({}, n.w.config.yaxis[p]), {}, {
                                            min: o[0].min,
                                            max: o[0].max
                                        })
                                    ]);
                                }, []);
                                n.ctx.updateHelpers._updateOptions({
                                    xaxis: {
                                        min: s.xaxis.min,
                                        max: s.xaxis.max
                                    },
                                    yaxis: c
                                }, !1, !1, !1, !1);
                            });
                        };
                    }
                }
            }
        ]), y;
    }(), Vt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "_updateOptions",
                value: function(e) {
                    var t = this, i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], a = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], s = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], r = arguments.length > 4 && arguments[4] !== void 0 && arguments[4];
                    return new Promise(function(n) {
                        var o = [
                            t.ctx
                        ];
                        s && (o = t.ctx.getSyncedCharts()), t.ctx.w.globals.isExecCalled && (o = [
                            t.ctx
                        ], t.ctx.w.globals.isExecCalled = !1), o.forEach(function(h, c) {
                            var d = h.w;
                            if (d.globals.shouldAnimate = a, i || (d.globals.resized = !0, d.globals.dataChanged = !0, a && h.series.getPreviousPaths()), e && U(e) === "object" && (h.config = new Le(e), e = q.extendArrayProps(h.config, e, d), h.w.globals.chartID !== t.ctx.w.globals.chartID && delete e.series, d.config = P.extend(d.config, e), r && (d.globals.lastXAxis = e.xaxis ? P.clone(e.xaxis) : [], d.globals.lastYAxis = e.yaxis ? P.clone(e.yaxis) : [], d.globals.initialConfig = P.extend({}, d.config), d.globals.initialSeries = P.clone(d.config.series), e.series))) {
                                for(var g = 0; g < d.globals.collapsedSeriesIndices.length; g++){
                                    var p = d.config.series[d.globals.collapsedSeriesIndices[g]];
                                    d.globals.collapsedSeries[g].data = d.globals.axisCharts ? p.data.slice() : p;
                                }
                                for(var f = 0; f < d.globals.ancillaryCollapsedSeriesIndices.length; f++){
                                    var b = d.config.series[d.globals.ancillaryCollapsedSeriesIndices[f]];
                                    d.globals.ancillaryCollapsedSeries[f].data = d.globals.axisCharts ? b.data.slice() : b;
                                }
                                h.series.emptyCollapsedSeries(d.config.series);
                            }
                            return h.update(e).then(function() {
                                c === o.length - 1 && n(h);
                            });
                        });
                    });
                }
            },
            {
                key: "_updateSeries",
                value: function(e, t) {
                    var i = this, a = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
                    return new Promise(function(s) {
                        var r, n = i.w;
                        return n.globals.shouldAnimate = t, n.globals.dataChanged = !0, t && i.ctx.series.getPreviousPaths(), n.globals.axisCharts ? ((r = e.map(function(o, h) {
                            return i._extendSeries(o, h);
                        })).length === 0 && (r = [
                            {
                                data: []
                            }
                        ]), n.config.series = r) : n.config.series = e.slice(), a && (n.globals.initialConfig.series = P.clone(n.config.series), n.globals.initialSeries = P.clone(n.config.series)), i.ctx.update().then(function() {
                            s(i.ctx);
                        });
                    });
                }
            },
            {
                key: "_extendSeries",
                value: function(e, t) {
                    var i = this.w, a = i.config.series[t];
                    return X(X({}, i.config.series[t]), {}, {
                        name: e.name ? e.name : a == null ? void 0 : a.name,
                        color: e.color ? e.color : a == null ? void 0 : a.color,
                        type: e.type ? e.type : a == null ? void 0 : a.type,
                        group: e.group ? e.group : a == null ? void 0 : a.group,
                        data: e.data ? e.data : a == null ? void 0 : a.data,
                        zIndex: e.zIndex !== void 0 ? e.zIndex : t
                    });
                }
            },
            {
                key: "toggleDataPointSelection",
                value: function(e, t) {
                    var i = this.w, a = null, s = ".apexcharts-series[data\\:realIndex='".concat(e, "']");
                    return i.globals.axisCharts ? a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(t, "'], ").concat(s, " circle[j='").concat(t, "'], ").concat(s, " rect[j='").concat(t, "']")).members[0] : t === void 0 && (a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(e, "']")).members[0], i.config.chart.type !== "pie" && i.config.chart.type !== "polarArea" && i.config.chart.type !== "donut" || this.ctx.pie.pieClicked(e)), a ? (new M(this.ctx).pathMouseDown(a, null), a.node ? a.node : null) : (console.warn("toggleDataPointSelection: Element not found"), null);
                }
            },
            {
                key: "forceXAxisUpdate",
                value: function(e) {
                    var t = this.w;
                    if ([
                        "min",
                        "max"
                    ].forEach(function(a) {
                        e.xaxis[a] !== void 0 && (t.config.xaxis[a] = e.xaxis[a], t.globals.lastXAxis[a] = e.xaxis[a]);
                    }), e.xaxis.categories && e.xaxis.categories.length && (t.config.xaxis.categories = e.xaxis.categories), t.config.xaxis.convertedCatToNumeric) {
                        var i = new oe(e);
                        e = i.convertCatToNumericXaxis(e, this.ctx);
                    }
                    return e;
                }
            },
            {
                key: "forceYAxisUpdate",
                value: function(e) {
                    return e.chart && e.chart.stacked && e.chart.stackType === "100%" && (Array.isArray(e.yaxis) ? e.yaxis.forEach(function(t, i) {
                        e.yaxis[i].min = 0, e.yaxis[i].max = 100;
                    }) : (e.yaxis.min = 0, e.yaxis.max = 100)), e;
                }
            },
            {
                key: "revertDefaultAxisMinMax",
                value: function(e) {
                    var t = this, i = this.w, a = i.globals.lastXAxis, s = i.globals.lastYAxis;
                    e && e.xaxis && (a = e.xaxis), e && e.yaxis && (s = e.yaxis), i.config.xaxis.min = a.min, i.config.xaxis.max = a.max;
                    var r = function(n) {
                        s[n] !== void 0 && (i.config.yaxis[n].min = s[n].min, i.config.yaxis[n].max = s[n].max);
                    };
                    i.config.yaxis.map(function(n, o) {
                        i.globals.zoomed || s[o] !== void 0 ? r(o) : t.ctx.opts.yaxis[o] !== void 0 && (n.min = t.ctx.opts.yaxis[o].min, n.max = t.ctx.opts.yaxis[o].max);
                    });
                }
            }
        ]), y;
    }();
    be = typeof window < "u" ? window : void 0, Fe = function(y, e) {
        var t = (this !== void 0 ? this : y).SVG = function(l) {
            if (t.supported) return l = new t.Doc(l), t.parser.draw || t.prepare(), l;
        };
        if (t.ns = "http://www.w3.org/2000/svg", t.xmlns = "http://www.w3.org/2000/xmlns/", t.xlink = "http://www.w3.org/1999/xlink", t.svgjs = "http://svgjs.dev", t.supported = !0, !t.supported) return !1;
        t.did = 1e3, t.eid = function(l) {
            return "Svgjs" + c(l) + t.did++;
        }, t.create = function(l) {
            var u = e.createElementNS(this.ns, l);
            return u.setAttribute("id", this.eid(l)), u;
        }, t.extend = function() {
            var l, u;
            u = (l = [].slice.call(arguments)).pop();
            for(var x = l.length - 1; x >= 0; x--)if (l[x]) for(var v in u)l[x].prototype[v] = u[v];
            t.Set && t.Set.inherit && t.Set.inherit();
        }, t.invent = function(l) {
            var u = typeof l.create == "function" ? l.create : function() {
                this.constructor.call(this, t.create(l.create));
            };
            return l.inherit && (u.prototype = new l.inherit()), l.extend && t.extend(u, l.extend), l.construct && t.extend(l.parent || t.Container, l.construct), u;
        }, t.adopt = function(l) {
            var u;
            return l ? l.instance ? l.instance : ((u = l.nodeName == "svg" ? l.parentNode instanceof y.SVGElement ? new t.Nested() : new t.Doc() : l.nodeName == "linearGradient" ? new t.Gradient("linear") : l.nodeName == "radialGradient" ? new t.Gradient("radial") : t[c(l.nodeName)] ? new t[c(l.nodeName)]() : new t.Element(l)).type = l.nodeName, u.node = l, l.instance = u, u instanceof t.Doc && u.namespace().defs(), u.setData(JSON.parse(l.getAttribute("svgjs:data")) || {}), u) : null;
        }, t.prepare = function() {
            var l = e.getElementsByTagName("body")[0], u = (l ? new t.Doc(l) : t.adopt(e.documentElement).nested()).size(2, 0);
            t.parser = {
                body: l || e.documentElement,
                draw: u.style("opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden").node,
                poly: u.polyline().node,
                path: u.path().node,
                native: t.create("svg")
            };
        }, t.parser = {
            native: t.create("svg")
        }, e.addEventListener("DOMContentLoaded", function() {
            t.parser.draw || t.prepare();
        }, !1), t.regex = {
            numberAndUnit: /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i,
            hex: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
            rgb: /rgb\((\d+),(\d+),(\d+)\)/,
            reference: /#([a-z0-9\-_]+)/i,
            transforms: /\)\s*,?\s*/,
            whitespace: /\s/g,
            isHex: /^#[a-f0-9]{3,6}$/i,
            isRgb: /^rgb\(/,
            isCss: /[^:]+:[^;]+;?/,
            isBlank: /^(\s+)?$/,
            isNumber: /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
            isPercent: /^-?[\d\.]+%$/,
            isImage: /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i,
            delimiter: /[\s,]+/,
            hyphen: /([^e])\-/gi,
            pathLetters: /[MLHVCSQTAZ]/gi,
            isPathLetter: /[MLHVCSQTAZ]/i,
            numbersWithDots: /((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi,
            dots: /\./g
        }, t.utils = {
            map: function(l, u) {
                for(var x = l.length, v = [], k = 0; k < x; k++)v.push(u(l[k]));
                return v;
            },
            filter: function(l, u) {
                for(var x = l.length, v = [], k = 0; k < x; k++)u(l[k]) && v.push(l[k]);
                return v;
            },
            filterSVGElements: function(l) {
                return this.filter(l, function(u) {
                    return u instanceof y.SVGElement;
                });
            }
        }, t.defaults = {
            attrs: {
                "fill-opacity": 1,
                "stroke-opacity": 1,
                "stroke-width": 0,
                "stroke-linejoin": "miter",
                "stroke-linecap": "butt",
                fill: "#000000",
                stroke: "#000000",
                opacity: 1,
                x: 0,
                y: 0,
                cx: 0,
                cy: 0,
                width: 0,
                height: 0,
                r: 0,
                rx: 0,
                ry: 0,
                offset: 0,
                "stop-opacity": 1,
                "stop-color": "#000000",
                "font-size": 16,
                "font-family": "Helvetica, Arial, sans-serif",
                "text-anchor": "start"
            }
        }, t.Color = function(l) {
            var u, x;
            this.r = 0, this.g = 0, this.b = 0, l && (typeof l == "string" ? t.regex.isRgb.test(l) ? (u = t.regex.rgb.exec(l.replace(t.regex.whitespace, "")), this.r = parseInt(u[1]), this.g = parseInt(u[2]), this.b = parseInt(u[3])) : t.regex.isHex.test(l) && (u = t.regex.hex.exec((x = l).length == 4 ? [
                "#",
                x.substring(1, 2),
                x.substring(1, 2),
                x.substring(2, 3),
                x.substring(2, 3),
                x.substring(3, 4),
                x.substring(3, 4)
            ].join("") : x), this.r = parseInt(u[1], 16), this.g = parseInt(u[2], 16), this.b = parseInt(u[3], 16)) : U(l) === "object" && (this.r = l.r, this.g = l.g, this.b = l.b));
        }, t.extend(t.Color, {
            toString: function() {
                return this.toHex();
            },
            toHex: function() {
                return "#" + d(this.r) + d(this.g) + d(this.b);
            },
            toRgb: function() {
                return "rgb(" + [
                    this.r,
                    this.g,
                    this.b
                ].join() + ")";
            },
            brightness: function() {
                return this.r / 255 * 0.3 + this.g / 255 * 0.59 + this.b / 255 * 0.11;
            },
            morph: function(l) {
                return this.destination = new t.Color(l), this;
            },
            at: function(l) {
                return this.destination ? (l = l < 0 ? 0 : l > 1 ? 1 : l, new t.Color({
                    r: ~~(this.r + (this.destination.r - this.r) * l),
                    g: ~~(this.g + (this.destination.g - this.g) * l),
                    b: ~~(this.b + (this.destination.b - this.b) * l)
                })) : this;
            }
        }), t.Color.test = function(l) {
            return l += "", t.regex.isHex.test(l) || t.regex.isRgb.test(l);
        }, t.Color.isRgb = function(l) {
            return l && typeof l.r == "number" && typeof l.g == "number" && typeof l.b == "number";
        }, t.Color.isColor = function(l) {
            return t.Color.isRgb(l) || t.Color.test(l);
        }, t.Array = function(l, u) {
            (l = (l || []).valueOf()).length == 0 && u && (l = u.valueOf()), this.value = this.parse(l);
        }, t.extend(t.Array, {
            toString: function() {
                return this.value.join(" ");
            },
            valueOf: function() {
                return this.value;
            },
            parse: function(l) {
                return l = l.valueOf(), Array.isArray(l) ? l : this.split(l);
            }
        }), t.PointArray = function(l, u) {
            t.Array.call(this, l, u || [
                [
                    0,
                    0
                ]
            ]);
        }, t.PointArray.prototype = new t.Array(), t.PointArray.prototype.constructor = t.PointArray;
        for(var i = {
            M: function(l, u, x) {
                return u.x = x.x = l[0], u.y = x.y = l[1], [
                    "M",
                    u.x,
                    u.y
                ];
            },
            L: function(l, u) {
                return u.x = l[0], u.y = l[1], [
                    "L",
                    l[0],
                    l[1]
                ];
            },
            H: function(l, u) {
                return u.x = l[0], [
                    "H",
                    l[0]
                ];
            },
            V: function(l, u) {
                return u.y = l[0], [
                    "V",
                    l[0]
                ];
            },
            C: function(l, u) {
                return u.x = l[4], u.y = l[5], [
                    "C",
                    l[0],
                    l[1],
                    l[2],
                    l[3],
                    l[4],
                    l[5]
                ];
            },
            Q: function(l, u) {
                return u.x = l[2], u.y = l[3], [
                    "Q",
                    l[0],
                    l[1],
                    l[2],
                    l[3]
                ];
            },
            S: function(l, u) {
                return u.x = l[2], u.y = l[3], [
                    "S",
                    l[0],
                    l[1],
                    l[2],
                    l[3]
                ];
            },
            Z: function(l, u, x) {
                return u.x = x.x, u.y = x.y, [
                    "Z"
                ];
            }
        }, a = "mlhvqtcsaz".split(""), s = 0, r = a.length; s < r; ++s)i[a[s]] = function(l) {
            return function(u, x, v) {
                if (l == "H") u[0] = u[0] + x.x;
                else if (l == "V") u[0] = u[0] + x.y;
                else if (l == "A") u[5] = u[5] + x.x, u[6] = u[6] + x.y;
                else for(var k = 0, S = u.length; k < S; ++k)u[k] = u[k] + (k % 2 ? x.y : x.x);
                if (i && typeof i[l] == "function") return i[l](u, x, v);
            };
        }(a[s].toUpperCase());
        t.PathArray = function(l, u) {
            t.Array.call(this, l, u || [
                [
                    "M",
                    0,
                    0
                ]
            ]);
        }, t.PathArray.prototype = new t.Array(), t.PathArray.prototype.constructor = t.PathArray, t.extend(t.PathArray, {
            toString: function() {
                return function(l) {
                    for(var u = 0, x = l.length, v = ""; u < x; u++)v += l[u][0], l[u][1] != null && (v += l[u][1], l[u][2] != null && (v += " ", v += l[u][2], l[u][3] != null && (v += " ", v += l[u][3], v += " ", v += l[u][4], l[u][5] != null && (v += " ", v += l[u][5], v += " ", v += l[u][6], l[u][7] != null && (v += " ", v += l[u][7])))));
                    return v + " ";
                }(this.value);
            },
            move: function(l, u) {
                var x = this.bbox();
                return x.x, x.y, this;
            },
            at: function(l) {
                if (!this.destination) return this;
                for(var u = this.value, x = this.destination.value, v = [], k = new t.PathArray(), S = 0, C = u.length; S < C; S++){
                    v[S] = [
                        u[S][0]
                    ];
                    for(var L = 1, I = u[S].length; L < I; L++)v[S][L] = u[S][L] + (x[S][L] - u[S][L]) * l;
                    v[S][0] === "A" && (v[S][4] = +(v[S][4] != 0), v[S][5] = +(v[S][5] != 0));
                }
                return k.value = v, k;
            },
            parse: function(l) {
                if (l instanceof t.PathArray) return l.valueOf();
                var u, x = {
                    M: 2,
                    L: 2,
                    H: 1,
                    V: 1,
                    C: 6,
                    S: 4,
                    Q: 4,
                    T: 2,
                    A: 7,
                    Z: 0
                };
                l = typeof l == "string" ? l.replace(t.regex.numbersWithDots, o).replace(t.regex.pathLetters, " $& ").replace(t.regex.hyphen, "$1 -").trim().split(t.regex.delimiter) : l.reduce(function(I, z) {
                    return [].concat.call(I, z);
                }, []);
                var v = [], k = new t.Point(), S = new t.Point(), C = 0, L = l.length;
                do t.regex.isPathLetter.test(l[C]) ? (u = l[C], ++C) : u == "M" ? u = "L" : u == "m" && (u = "l"), v.push(i[u].call(null, l.slice(C, C += x[u.toUpperCase()]).map(parseFloat), k, S));
                while (L > C);
                return v;
            },
            bbox: function() {
                return t.parser.draw || t.prepare(), t.parser.path.setAttribute("d", this.toString()), t.parser.path.getBBox();
            }
        }), t.Number = t.invent({
            create: function(l, u) {
                this.value = 0, this.unit = u || "", typeof l == "number" ? this.value = isNaN(l) ? 0 : isFinite(l) ? l : l < 0 ? -340000000000000000000000000000000000000 : 34e37 : typeof l == "string" ? (u = l.match(t.regex.numberAndUnit)) && (this.value = parseFloat(u[1]), u[5] == "%" ? this.value /= 100 : u[5] == "s" && (this.value *= 1e3), this.unit = u[5]) : l instanceof t.Number && (this.value = l.valueOf(), this.unit = l.unit);
            },
            extend: {
                toString: function() {
                    return (this.unit == "%" ? ~~(1e8 * this.value) / 1e6 : this.unit == "s" ? this.value / 1e3 : this.value) + this.unit;
                },
                toJSON: function() {
                    return this.toString();
                },
                valueOf: function() {
                    return this.value;
                },
                plus: function(l) {
                    return l = new t.Number(l), new t.Number(this + l, this.unit || l.unit);
                },
                minus: function(l) {
                    return l = new t.Number(l), new t.Number(this - l, this.unit || l.unit);
                },
                times: function(l) {
                    return l = new t.Number(l), new t.Number(this * l, this.unit || l.unit);
                },
                divide: function(l) {
                    return l = new t.Number(l), new t.Number(this / l, this.unit || l.unit);
                },
                to: function(l) {
                    var u = new t.Number(this);
                    return typeof l == "string" && (u.unit = l), u;
                },
                morph: function(l) {
                    return this.destination = new t.Number(l), l.relative && (this.destination.value += this.value), this;
                },
                at: function(l) {
                    return this.destination ? new t.Number(this.destination).minus(this).times(l).plus(this) : this;
                }
            }
        }), t.Element = t.invent({
            create: function(l) {
                this._stroke = t.defaults.attrs.stroke, this._event = null, this.dom = {}, (this.node = l) && (this.type = l.nodeName, this.node.instance = this, this._stroke = l.getAttribute("stroke") || this._stroke);
            },
            extend: {
                x: function(l) {
                    return this.attr("x", l);
                },
                y: function(l) {
                    return this.attr("y", l);
                },
                cx: function(l) {
                    return l == null ? this.x() + this.width() / 2 : this.x(l - this.width() / 2);
                },
                cy: function(l) {
                    return l == null ? this.y() + this.height() / 2 : this.y(l - this.height() / 2);
                },
                move: function(l, u) {
                    return this.x(l).y(u);
                },
                center: function(l, u) {
                    return this.cx(l).cy(u);
                },
                width: function(l) {
                    return this.attr("width", l);
                },
                height: function(l) {
                    return this.attr("height", l);
                },
                size: function(l, u) {
                    var x = g(this, l, u);
                    return this.width(new t.Number(x.width)).height(new t.Number(x.height));
                },
                clone: function(l) {
                    this.writeDataToDom();
                    var u = b(this.node.cloneNode(!0));
                    return l ? l.add(u) : this.after(u), u;
                },
                remove: function() {
                    return this.parent() && this.parent().removeElement(this), this;
                },
                replace: function(l) {
                    return this.after(l).remove(), l;
                },
                addTo: function(l) {
                    return l.put(this);
                },
                putIn: function(l) {
                    return l.add(this);
                },
                id: function(l) {
                    return this.attr("id", l);
                },
                show: function() {
                    return this.style("display", "");
                },
                hide: function() {
                    return this.style("display", "none");
                },
                visible: function() {
                    return this.style("display") != "none";
                },
                toString: function() {
                    return this.attr("id");
                },
                classes: function() {
                    var l = this.attr("class");
                    return l == null ? [] : l.trim().split(t.regex.delimiter);
                },
                hasClass: function(l) {
                    return this.classes().indexOf(l) != -1;
                },
                addClass: function(l) {
                    if (!this.hasClass(l)) {
                        var u = this.classes();
                        u.push(l), this.attr("class", u.join(" "));
                    }
                    return this;
                },
                removeClass: function(l) {
                    return this.hasClass(l) && this.attr("class", this.classes().filter(function(u) {
                        return u != l;
                    }).join(" ")), this;
                },
                toggleClass: function(l) {
                    return this.hasClass(l) ? this.removeClass(l) : this.addClass(l);
                },
                reference: function(l) {
                    return t.get(this.attr(l));
                },
                parent: function(l) {
                    var u = this;
                    if (!u.node.parentNode) return null;
                    if (u = t.adopt(u.node.parentNode), !l) return u;
                    for(; u && u.node instanceof y.SVGElement;){
                        if (typeof l == "string" ? u.matches(l) : u instanceof l) return u;
                        if (!u.node.parentNode || u.node.parentNode.nodeName == "#document") return null;
                        u = t.adopt(u.node.parentNode);
                    }
                },
                doc: function() {
                    return this instanceof t.Doc ? this : this.parent(t.Doc);
                },
                parents: function(l) {
                    var u = [], x = this;
                    do {
                        if (!(x = x.parent(l)) || !x.node) break;
                        u.push(x);
                    }while (x.parent);
                    return u;
                },
                matches: function(l) {
                    return function(u, x) {
                        return (u.matches || u.matchesSelector || u.msMatchesSelector || u.mozMatchesSelector || u.webkitMatchesSelector || u.oMatchesSelector).call(u, x);
                    }(this.node, l);
                },
                native: function() {
                    return this.node;
                },
                svg: function(l) {
                    var u = e.createElement("svg");
                    if (!(l && this instanceof t.Parent)) return u.appendChild(l = e.createElement("svg")), this.writeDataToDom(), l.appendChild(this.node.cloneNode(!0)), u.innerHTML.replace(/^<svg>/, "").replace(/<\/svg>$/, "");
                    u.innerHTML = "<svg>" + l.replace(/\n/, "").replace(/<([\w:-]+)([^<]+?)\/>/g, "<$1$2></$1>") + "</svg>";
                    for(var x = 0, v = u.firstChild.childNodes.length; x < v; x++)this.node.appendChild(u.firstChild.firstChild);
                    return this;
                },
                writeDataToDom: function() {
                    return (this.each || this.lines) && (this.each ? this : this.lines()).each(function() {
                        this.writeDataToDom();
                    }), this.node.removeAttribute("svgjs:data"), Object.keys(this.dom).length && this.node.setAttribute("svgjs:data", JSON.stringify(this.dom)), this;
                },
                setData: function(l) {
                    return this.dom = l, this;
                },
                is: function(l) {
                    return function(u, x) {
                        return u instanceof x;
                    }(this, l);
                }
            }
        }), t.easing = {
            "-": function(l) {
                return l;
            },
            "<>": function(l) {
                return -Math.cos(l * Math.PI) / 2 + 0.5;
            },
            ">": function(l) {
                return Math.sin(l * Math.PI / 2);
            },
            "<": function(l) {
                return 1 - Math.cos(l * Math.PI / 2);
            }
        }, t.morph = function(l) {
            return function(u, x) {
                return new t.MorphObj(u, x).at(l);
            };
        }, t.Situation = t.invent({
            create: function(l) {
                this.init = !1, this.reversed = !1, this.reversing = !1, this.duration = new t.Number(l.duration).valueOf(), this.delay = new t.Number(l.delay).valueOf(), this.start = +/* @__PURE__ */ new Date() + this.delay, this.finish = this.start + this.duration, this.ease = l.ease, this.loop = 0, this.loops = !1, this.animations = {}, this.attrs = {}, this.styles = {}, this.transforms = [], this.once = {};
            }
        }), t.FX = t.invent({
            create: function(l) {
                this._target = l, this.situations = [], this.active = !1, this.situation = null, this.paused = !1, this.lastPos = 0, this.pos = 0, this.absPos = 0, this._speed = 1;
            },
            extend: {
                animate: function(l, u, x) {
                    U(l) === "object" && (u = l.ease, x = l.delay, l = l.duration);
                    var v = new t.Situation({
                        duration: l || 1e3,
                        delay: x || 0,
                        ease: t.easing[u || "-"] || u
                    });
                    return this.queue(v), this;
                },
                target: function(l) {
                    return l && l instanceof t.Element ? (this._target = l, this) : this._target;
                },
                timeToAbsPos: function(l) {
                    return (l - this.situation.start) / (this.situation.duration / this._speed);
                },
                absPosToTime: function(l) {
                    return this.situation.duration / this._speed * l + this.situation.start;
                },
                startAnimFrame: function() {
                    this.stopAnimFrame(), this.animationFrame = y.requestAnimationFrame((function() {
                        this.step();
                    }).bind(this));
                },
                stopAnimFrame: function() {
                    y.cancelAnimationFrame(this.animationFrame);
                },
                start: function() {
                    return !this.active && this.situation && (this.active = !0, this.startCurrent()), this;
                },
                startCurrent: function() {
                    return this.situation.start = +/* @__PURE__ */ new Date() + this.situation.delay / this._speed, this.situation.finish = this.situation.start + this.situation.duration / this._speed, this.initAnimations().step();
                },
                queue: function(l) {
                    return (typeof l == "function" || l instanceof t.Situation) && this.situations.push(l), this.situation || (this.situation = this.situations.shift()), this;
                },
                dequeue: function() {
                    return this.stop(), this.situation = this.situations.shift(), this.situation && (this.situation instanceof t.Situation ? this.start() : this.situation.call(this)), this;
                },
                initAnimations: function() {
                    var l, u = this.situation;
                    if (u.init) return this;
                    for(var x in u.animations){
                        l = this.target()[x](), Array.isArray(l) || (l = [
                            l
                        ]), Array.isArray(u.animations[x]) || (u.animations[x] = [
                            u.animations[x]
                        ]);
                        for(var v = l.length; v--;)u.animations[x][v] instanceof t.Number && (l[v] = new t.Number(l[v])), u.animations[x][v] = l[v].morph(u.animations[x][v]);
                    }
                    for(var x in u.attrs)u.attrs[x] = new t.MorphObj(this.target().attr(x), u.attrs[x]);
                    for(var x in u.styles)u.styles[x] = new t.MorphObj(this.target().style(x), u.styles[x]);
                    return u.initialTransformation = this.target().matrixify(), u.init = !0, this;
                },
                clearQueue: function() {
                    return this.situations = [], this;
                },
                clearCurrent: function() {
                    return this.situation = null, this;
                },
                stop: function(l, u) {
                    var x = this.active;
                    return this.active = !1, u && this.clearQueue(), l && this.situation && (!x && this.startCurrent(), this.atEnd()), this.stopAnimFrame(), this.clearCurrent();
                },
                after: function(l) {
                    var u = this.last();
                    return this.target().on("finished.fx", function x(v) {
                        v.detail.situation == u && (l.call(this, u), this.off("finished.fx", x));
                    }), this._callStart();
                },
                during: function(l) {
                    var u = this.last(), x = function(v) {
                        v.detail.situation == u && l.call(this, v.detail.pos, t.morph(v.detail.pos), v.detail.eased, u);
                    };
                    return this.target().off("during.fx", x).on("during.fx", x), this.after(function() {
                        this.off("during.fx", x);
                    }), this._callStart();
                },
                afterAll: function(l) {
                    var u = function x(v) {
                        l.call(this), this.off("allfinished.fx", x);
                    };
                    return this.target().off("allfinished.fx", u).on("allfinished.fx", u), this._callStart();
                },
                last: function() {
                    return this.situations.length ? this.situations[this.situations.length - 1] : this.situation;
                },
                add: function(l, u, x) {
                    return this.last()[x || "animations"][l] = u, this._callStart();
                },
                step: function(l) {
                    var u, x, v;
                    l || (this.absPos = this.timeToAbsPos(+/* @__PURE__ */ new Date())), this.situation.loops !== !1 ? (u = Math.max(this.absPos, 0), x = Math.floor(u), this.situation.loops === !0 || x < this.situation.loops ? (this.pos = u - x, v = this.situation.loop, this.situation.loop = x) : (this.absPos = this.situation.loops, this.pos = 1, v = this.situation.loop - 1, this.situation.loop = this.situation.loops), this.situation.reversing && (this.situation.reversed = this.situation.reversed != !!((this.situation.loop - v) % 2))) : (this.absPos = Math.min(this.absPos, 1), this.pos = this.absPos), this.pos < 0 && (this.pos = 0), this.situation.reversed && (this.pos = 1 - this.pos);
                    var k = this.situation.ease(this.pos);
                    for(var S in this.situation.once)S > this.lastPos && S <= k && (this.situation.once[S].call(this.target(), this.pos, k), delete this.situation.once[S]);
                    return this.active && this.target().fire("during", {
                        pos: this.pos,
                        eased: k,
                        fx: this,
                        situation: this.situation
                    }), this.situation ? (this.eachAt(), this.pos == 1 && !this.situation.reversed || this.situation.reversed && this.pos == 0 ? (this.stopAnimFrame(), this.target().fire("finished", {
                        fx: this,
                        situation: this.situation
                    }), this.situations.length || (this.target().fire("allfinished"), this.situations.length || (this.target().off(".fx"), this.active = !1)), this.active ? this.dequeue() : this.clearCurrent()) : !this.paused && this.active && this.startAnimFrame(), this.lastPos = k, this) : this;
                },
                eachAt: function() {
                    var l, u = this, x = this.target(), v = this.situation;
                    for(var k in v.animations)l = [].concat(v.animations[k]).map(function(L) {
                        return typeof L != "string" && L.at ? L.at(v.ease(u.pos), u.pos) : L;
                    }), x[k].apply(x, l);
                    for(var k in v.attrs)l = [
                        k
                    ].concat(v.attrs[k]).map(function(I) {
                        return typeof I != "string" && I.at ? I.at(v.ease(u.pos), u.pos) : I;
                    }), x.attr.apply(x, l);
                    for(var k in v.styles)l = [
                        k
                    ].concat(v.styles[k]).map(function(I) {
                        return typeof I != "string" && I.at ? I.at(v.ease(u.pos), u.pos) : I;
                    }), x.style.apply(x, l);
                    if (v.transforms.length) {
                        l = v.initialTransformation, k = 0;
                        for(var S = v.transforms.length; k < S; k++){
                            var C = v.transforms[k];
                            C instanceof t.Matrix ? l = C.relative ? l.multiply(new t.Matrix().morph(C).at(v.ease(this.pos))) : l.morph(C).at(v.ease(this.pos)) : (C.relative || C.undo(l.extract()), l = l.multiply(C.at(v.ease(this.pos))));
                        }
                        x.matrix(l);
                    }
                    return this;
                },
                once: function(l, u, x) {
                    var v = this.last();
                    return x || (l = v.ease(l)), v.once[l] = u, this;
                },
                _callStart: function() {
                    return setTimeout((function() {
                        this.start();
                    }).bind(this), 0), this;
                }
            },
            parent: t.Element,
            construct: {
                animate: function(l, u, x) {
                    return (this.fx || (this.fx = new t.FX(this))).animate(l, u, x);
                },
                delay: function(l) {
                    return (this.fx || (this.fx = new t.FX(this))).delay(l);
                },
                stop: function(l, u) {
                    return this.fx && this.fx.stop(l, u), this;
                },
                finish: function() {
                    return this.fx && this.fx.finish(), this;
                }
            }
        }), t.MorphObj = t.invent({
            create: function(l, u) {
                return t.Color.isColor(u) ? new t.Color(l).morph(u) : t.regex.delimiter.test(l) ? t.regex.pathLetters.test(l) ? new t.PathArray(l).morph(u) : new t.Array(l).morph(u) : t.regex.numberAndUnit.test(u) ? new t.Number(l).morph(u) : (this.value = l, void (this.destination = u));
            },
            extend: {
                at: function(l, u) {
                    return u < 1 ? this.value : this.destination;
                },
                valueOf: function() {
                    return this.value;
                }
            }
        }), t.extend(t.FX, {
            attr: function(l, u, x) {
                if (U(l) === "object") for(var v in l)this.attr(v, l[v]);
                else this.add(l, u, "attrs");
                return this;
            },
            plot: function(l, u, x, v) {
                return arguments.length == 4 ? this.plot([
                    l,
                    u,
                    x,
                    v
                ]) : this.add("plot", new (this.target()).morphArray(l));
            }
        }), t.Box = t.invent({
            create: function(l, u, x, v) {
                if (!(U(l) !== "object" || l instanceof t.Element)) return t.Box.call(this, l.left != null ? l.left : l.x, l.top != null ? l.top : l.y, l.width, l.height);
                var k;
                arguments.length == 4 && (this.x = l, this.y = u, this.width = x, this.height = v), (k = this).x == null && (k.x = 0, k.y = 0, k.width = 0, k.height = 0), k.w = k.width, k.h = k.height, k.x2 = k.x + k.width, k.y2 = k.y + k.height, k.cx = k.x + k.width / 2, k.cy = k.y + k.height / 2;
            }
        }), t.BBox = t.invent({
            create: function(l) {
                if (t.Box.apply(this, [].slice.call(arguments)), l instanceof t.Element) {
                    var u;
                    try {
                        if (!e.documentElement.contains) {
                            for(var x = l.node; x.parentNode;)x = x.parentNode;
                            if (x != e) throw new Error("Element not in the dom");
                        }
                        u = l.node.getBBox();
                    } catch  {
                        if (l instanceof t.Shape) {
                            t.parser.draw || t.prepare();
                            var v = l.clone(t.parser.draw.instance).show();
                            v && v.node && typeof v.node.getBBox == "function" && (u = v.node.getBBox()), v && typeof v.remove == "function" && v.remove();
                        } else u = {
                            x: l.node.clientLeft,
                            y: l.node.clientTop,
                            width: l.node.clientWidth,
                            height: l.node.clientHeight
                        };
                    }
                    t.Box.call(this, u);
                }
            },
            inherit: t.Box,
            parent: t.Element,
            construct: {
                bbox: function() {
                    return new t.BBox(this);
                }
            }
        }), t.BBox.prototype.constructor = t.BBox, t.Matrix = t.invent({
            create: function(l) {
                var u = f([
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ]);
                l = l === null ? u : l instanceof t.Element ? l.matrixify() : typeof l == "string" ? f(l.split(t.regex.delimiter).map(parseFloat)) : arguments.length == 6 ? f([].slice.call(arguments)) : Array.isArray(l) ? f(l) : l && U(l) === "object" ? l : u;
                for(var x = w.length - 1; x >= 0; --x)this[w[x]] = l[w[x]] != null ? l[w[x]] : u[w[x]];
            },
            extend: {
                extract: function() {
                    var l = p(this, 0, 1);
                    p(this, 1, 0);
                    var u = 180 / Math.PI * Math.atan2(l.y, l.x) - 90;
                    return {
                        x: this.e,
                        y: this.f,
                        transformedX: (this.e * Math.cos(u * Math.PI / 180) + this.f * Math.sin(u * Math.PI / 180)) / Math.sqrt(this.a * this.a + this.b * this.b),
                        transformedY: (this.f * Math.cos(u * Math.PI / 180) + this.e * Math.sin(-u * Math.PI / 180)) / Math.sqrt(this.c * this.c + this.d * this.d),
                        rotation: u,
                        a: this.a,
                        b: this.b,
                        c: this.c,
                        d: this.d,
                        e: this.e,
                        f: this.f,
                        matrix: new t.Matrix(this)
                    };
                },
                clone: function() {
                    return new t.Matrix(this);
                },
                morph: function(l) {
                    return this.destination = new t.Matrix(l), this;
                },
                multiply: function(l) {
                    return new t.Matrix(this.native().multiply((function(u) {
                        return u instanceof t.Matrix || (u = new t.Matrix(u)), u;
                    })(l).native()));
                },
                inverse: function() {
                    return new t.Matrix(this.native().inverse());
                },
                translate: function(l, u) {
                    return new t.Matrix(this.native().translate(l || 0, u || 0));
                },
                native: function() {
                    for(var l = t.parser.native.createSVGMatrix(), u = w.length - 1; u >= 0; u--)l[w[u]] = this[w[u]];
                    return l;
                },
                toString: function() {
                    return "matrix(" + m(this.a) + "," + m(this.b) + "," + m(this.c) + "," + m(this.d) + "," + m(this.e) + "," + m(this.f) + ")";
                }
            },
            parent: t.Element,
            construct: {
                ctm: function() {
                    return new t.Matrix(this.node.getCTM());
                },
                screenCTM: function() {
                    if (this instanceof t.Nested) {
                        var l = this.rect(1, 1), u = l.node.getScreenCTM();
                        return l.remove(), new t.Matrix(u);
                    }
                    return new t.Matrix(this.node.getScreenCTM());
                }
            }
        }), t.Point = t.invent({
            create: function(l, u) {
                var x;
                x = Array.isArray(l) ? {
                    x: l[0],
                    y: l[1]
                } : U(l) === "object" ? {
                    x: l.x,
                    y: l.y
                } : l != null ? {
                    x: l,
                    y: u ?? l
                } : {
                    x: 0,
                    y: 0
                }, this.x = x.x, this.y = x.y;
            },
            extend: {
                clone: function() {
                    return new t.Point(this);
                },
                morph: function(l, u) {
                    return this.destination = new t.Point(l, u), this;
                }
            }
        }), t.extend(t.Element, {
            point: function(l, u) {
                return new t.Point(l, u).transform(this.screenCTM().inverse());
            }
        }), t.extend(t.Element, {
            attr: function(l, u, x) {
                if (l == null) {
                    for(l = {}, x = (u = this.node.attributes).length - 1; x >= 0; x--)l[u[x].nodeName] = t.regex.isNumber.test(u[x].nodeValue) ? parseFloat(u[x].nodeValue) : u[x].nodeValue;
                    return l;
                }
                if (U(l) === "object") for(var v in l)this.attr(v, l[v]);
                else if (u === null) this.node.removeAttribute(l);
                else {
                    if (u == null) return (u = this.node.getAttribute(l)) == null ? t.defaults.attrs[l] : t.regex.isNumber.test(u) ? parseFloat(u) : u;
                    l == "stroke-width" ? this.attr("stroke", parseFloat(u) > 0 ? this._stroke : null) : l == "stroke" && (this._stroke = u), l != "fill" && l != "stroke" || (t.regex.isImage.test(u) && (u = this.doc().defs().image(u, 0, 0)), u instanceof t.Image && (u = this.doc().defs().pattern(0, 0, function() {
                        this.add(u);
                    }))), typeof u == "number" ? u = new t.Number(u) : t.Color.isColor(u) ? u = new t.Color(u) : Array.isArray(u) && (u = new t.Array(u)), l == "leading" ? this.leading && this.leading(u) : typeof x == "string" ? this.node.setAttributeNS(x, l, u.toString()) : this.node.setAttribute(l, u.toString()), !this.rebuild || l != "font-size" && l != "x" || this.rebuild(l, u);
                }
                return this;
            }
        }), t.extend(t.Element, {
            transform: function(l, u) {
                var x;
                return U(l) !== "object" ? (x = new t.Matrix(this).extract(), typeof l == "string" ? x[l] : x) : (x = new t.Matrix(this), u = !!u || !!l.relative, l.a != null && (x = u ? x.multiply(new t.Matrix(l)) : new t.Matrix(l)), this.attr("transform", x));
            }
        }), t.extend(t.Element, {
            untransform: function() {
                return this.attr("transform", null);
            },
            matrixify: function() {
                return (this.attr("transform") || "").split(t.regex.transforms).slice(0, -1).map(function(l) {
                    var u = l.trim().split("(");
                    return [
                        u[0],
                        u[1].split(t.regex.delimiter).map(function(x) {
                            return parseFloat(x);
                        })
                    ];
                }).reduce(function(l, u) {
                    return u[0] == "matrix" ? l.multiply(f(u[1])) : l[u[0]].apply(l, u[1]);
                }, new t.Matrix());
            },
            toParent: function(l) {
                if (this == l) return this;
                var u = this.screenCTM(), x = l.screenCTM().inverse();
                return this.addTo(l).untransform().transform(x.multiply(u)), this;
            },
            toDoc: function() {
                return this.toParent(this.doc());
            }
        }), t.Transformation = t.invent({
            create: function(l, u) {
                if (arguments.length > 1 && typeof u != "boolean") return this.constructor.call(this, [].slice.call(arguments));
                if (Array.isArray(l)) for(var x = 0, v = this.arguments.length; x < v; ++x)this[this.arguments[x]] = l[x];
                else if (l && U(l) === "object") for(x = 0, v = this.arguments.length; x < v; ++x)this[this.arguments[x]] = l[this.arguments[x]];
                this.inversed = !1, u === !0 && (this.inversed = !0);
            }
        }), t.Translate = t.invent({
            parent: t.Matrix,
            inherit: t.Transformation,
            create: function(l, u) {
                this.constructor.apply(this, [].slice.call(arguments));
            },
            extend: {
                arguments: [
                    "transformedX",
                    "transformedY"
                ],
                method: "translate"
            }
        }), t.extend(t.Element, {
            style: function(l, u) {
                if (arguments.length == 0) return this.node.style.cssText || "";
                if (arguments.length < 2) {
                    if (U(l) === "object") for(var x in l)this.style(x, l[x]);
                    else {
                        if (!t.regex.isCss.test(l)) return this.node.style[h(l)];
                        for(l = l.split(/\s*;\s*/).filter(function(v) {
                            return !!v;
                        }).map(function(v) {
                            return v.split(/\s*:\s*/);
                        }); u = l.pop();)this.style(u[0], u[1]);
                    }
                } else this.node.style[h(l)] = u === null || t.regex.isBlank.test(u) ? "" : u;
                return this;
            }
        }), t.Parent = t.invent({
            create: function(l) {
                this.constructor.call(this, l);
            },
            inherit: t.Element,
            extend: {
                children: function() {
                    return t.utils.map(t.utils.filterSVGElements(this.node.childNodes), function(l) {
                        return t.adopt(l);
                    });
                },
                add: function(l, u) {
                    return u == null ? this.node.appendChild(l.node) : l.node != this.node.childNodes[u] && this.node.insertBefore(l.node, this.node.childNodes[u]), this;
                },
                put: function(l, u) {
                    return this.add(l, u), l;
                },
                has: function(l) {
                    return this.index(l) >= 0;
                },
                index: function(l) {
                    return [].slice.call(this.node.childNodes).indexOf(l.node);
                },
                get: function(l) {
                    return t.adopt(this.node.childNodes[l]);
                },
                first: function() {
                    return this.get(0);
                },
                last: function() {
                    return this.get(this.node.childNodes.length - 1);
                },
                each: function(l, u) {
                    for(var x = this.children(), v = 0, k = x.length; v < k; v++)x[v] instanceof t.Element && l.apply(x[v], [
                        v,
                        x
                    ]), u && x[v] instanceof t.Container && x[v].each(l, u);
                    return this;
                },
                removeElement: function(l) {
                    return this.node.removeChild(l.node), this;
                },
                clear: function() {
                    for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                    return delete this._defs, this;
                },
                defs: function() {
                    return this.doc().defs();
                }
            }
        }), t.extend(t.Parent, {
            ungroup: function(l, u) {
                return u === 0 || this instanceof t.Defs || this.node == t.parser.draw || (l = l || (this instanceof t.Doc ? this : this.parent(t.Parent)), u = u || 1 / 0, this.each(function() {
                    return this instanceof t.Defs ? this : this instanceof t.Parent ? this.ungroup(l, u - 1) : this.toParent(l);
                }), this.node.firstChild || this.remove()), this;
            },
            flatten: function(l, u) {
                return this.ungroup(l, u);
            }
        }), t.Container = t.invent({
            create: function(l) {
                this.constructor.call(this, l);
            },
            inherit: t.Parent
        }), t.ViewBox = t.invent({
            parent: t.Container,
            construct: {}
        }), [
            "click",
            "dblclick",
            "mousedown",
            "mouseup",
            "mouseover",
            "mouseout",
            "mousemove",
            "touchstart",
            "touchmove",
            "touchleave",
            "touchend",
            "touchcancel"
        ].forEach(function(l) {
            t.Element.prototype[l] = function(u) {
                return t.on(this.node, l, u), this;
            };
        }), t.listeners = [], t.handlerMap = [], t.listenerId = 0, t.on = function(l, u, x, v, k) {
            var S = x.bind(v || l.instance || l), C = (t.handlerMap.indexOf(l) + 1 || t.handlerMap.push(l)) - 1, L = u.split(".")[0], I = u.split(".")[1] || "*";
            t.listeners[C] = t.listeners[C] || {}, t.listeners[C][L] = t.listeners[C][L] || {}, t.listeners[C][L][I] = t.listeners[C][L][I] || {}, x._svgjsListenerId || (x._svgjsListenerId = ++t.listenerId), t.listeners[C][L][I][x._svgjsListenerId] = S, l.addEventListener(L, S, k || {
                passive: !0
            });
        }, t.off = function(l, u, x) {
            var v = t.handlerMap.indexOf(l), k = u && u.split(".")[0], S = u && u.split(".")[1], C = "";
            if (v != -1) {
                if (x) {
                    if (typeof x == "function" && (x = x._svgjsListenerId), !x) return;
                    t.listeners[v][k] && t.listeners[v][k][S || "*"] && (l.removeEventListener(k, t.listeners[v][k][S || "*"][x], !1), delete t.listeners[v][k][S || "*"][x]);
                } else if (S && k) {
                    if (t.listeners[v][k] && t.listeners[v][k][S]) {
                        for(var L in t.listeners[v][k][S])t.off(l, [
                            k,
                            S
                        ].join("."), L);
                        delete t.listeners[v][k][S];
                    }
                } else if (S) for(var I in t.listeners[v])for(var C in t.listeners[v][I])S === C && t.off(l, [
                    I,
                    S
                ].join("."));
                else if (k) {
                    if (t.listeners[v][k]) {
                        for(var C in t.listeners[v][k])t.off(l, [
                            k,
                            C
                        ].join("."));
                        delete t.listeners[v][k];
                    }
                } else {
                    for(var I in t.listeners[v])t.off(l, I);
                    delete t.listeners[v], delete t.handlerMap[v];
                }
            }
        }, t.extend(t.Element, {
            on: function(l, u, x, v) {
                return t.on(this.node, l, u, x, v), this;
            },
            off: function(l, u) {
                return t.off(this.node, l, u), this;
            },
            fire: function(l, u) {
                return l instanceof y.Event ? this.node.dispatchEvent(l) : this.node.dispatchEvent(l = new t.CustomEvent(l, {
                    detail: u,
                    cancelable: !0
                })), this._event = l, this;
            },
            event: function() {
                return this._event;
            }
        }), t.Defs = t.invent({
            create: "defs",
            inherit: t.Container
        }), t.G = t.invent({
            create: "g",
            inherit: t.Container,
            extend: {
                x: function(l) {
                    return l == null ? this.transform("x") : this.transform({
                        x: l - this.x()
                    }, !0);
                }
            },
            construct: {
                group: function() {
                    return this.put(new t.G());
                }
            }
        }), t.Doc = t.invent({
            create: function(l) {
                l && ((l = typeof l == "string" ? e.getElementById(l) : l).nodeName == "svg" ? this.constructor.call(this, l) : (this.constructor.call(this, t.create("svg")), l.appendChild(this.node), this.size("100%", "100%")), this.namespace().defs());
            },
            inherit: t.Container,
            extend: {
                namespace: function() {
                    return this.attr({
                        xmlns: t.ns,
                        version: "1.1"
                    }).attr("xmlns:xlink", t.xlink, t.xmlns).attr("xmlns:svgjs", t.svgjs, t.xmlns);
                },
                defs: function() {
                    var l;
                    return this._defs || ((l = this.node.getElementsByTagName("defs")[0]) ? this._defs = t.adopt(l) : this._defs = new t.Defs(), this.node.appendChild(this._defs.node)), this._defs;
                },
                parent: function() {
                    return this.node.parentNode && this.node.parentNode.nodeName != "#document" ? this.node.parentNode : null;
                },
                remove: function() {
                    return this.parent() && this.parent().removeChild(this.node), this;
                },
                clear: function() {
                    for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                    return delete this._defs, t.parser.draw && !t.parser.draw.parentNode && this.node.appendChild(t.parser.draw), this;
                },
                clone: function(l) {
                    this.writeDataToDom();
                    var u = this.node, x = b(u.cloneNode(!0));
                    return l ? (l.node || l).appendChild(x.node) : u.parentNode.insertBefore(x.node, u.nextSibling), x;
                }
            }
        }), t.extend(t.Element, {}), t.Gradient = t.invent({
            create: function(l) {
                this.constructor.call(this, t.create(l + "Gradient")), this.type = l;
            },
            inherit: t.Container,
            extend: {
                at: function(l, u, x) {
                    return this.put(new t.Stop()).update(l, u, x);
                },
                update: function(l) {
                    return this.clear(), typeof l == "function" && l.call(this, this), this;
                },
                fill: function() {
                    return "url(#" + this.id() + ")";
                },
                toString: function() {
                    return this.fill();
                },
                attr: function(l, u, x) {
                    return l == "transform" && (l = "gradientTransform"), t.Container.prototype.attr.call(this, l, u, x);
                }
            },
            construct: {
                gradient: function(l, u) {
                    return this.defs().gradient(l, u);
                }
            }
        }), t.extend(t.Gradient, t.FX, {
            from: function(l, u) {
                return (this._target || this).type == "radial" ? this.attr({
                    fx: new t.Number(l),
                    fy: new t.Number(u)
                }) : this.attr({
                    x1: new t.Number(l),
                    y1: new t.Number(u)
                });
            },
            to: function(l, u) {
                return (this._target || this).type == "radial" ? this.attr({
                    cx: new t.Number(l),
                    cy: new t.Number(u)
                }) : this.attr({
                    x2: new t.Number(l),
                    y2: new t.Number(u)
                });
            }
        }), t.extend(t.Defs, {
            gradient: function(l, u) {
                return this.put(new t.Gradient(l)).update(u);
            }
        }), t.Stop = t.invent({
            create: "stop",
            inherit: t.Element,
            extend: {
                update: function(l) {
                    return (typeof l == "number" || l instanceof t.Number) && (l = {
                        offset: arguments[0],
                        color: arguments[1],
                        opacity: arguments[2]
                    }), l.opacity != null && this.attr("stop-opacity", l.opacity), l.color != null && this.attr("stop-color", l.color), l.offset != null && this.attr("offset", new t.Number(l.offset)), this;
                }
            }
        }), t.Pattern = t.invent({
            create: "pattern",
            inherit: t.Container,
            extend: {
                fill: function() {
                    return "url(#" + this.id() + ")";
                },
                update: function(l) {
                    return this.clear(), typeof l == "function" && l.call(this, this), this;
                },
                toString: function() {
                    return this.fill();
                },
                attr: function(l, u, x) {
                    return l == "transform" && (l = "patternTransform"), t.Container.prototype.attr.call(this, l, u, x);
                }
            },
            construct: {
                pattern: function(l, u, x) {
                    return this.defs().pattern(l, u, x);
                }
            }
        }), t.extend(t.Defs, {
            pattern: function(l, u, x) {
                return this.put(new t.Pattern()).update(x).attr({
                    x: 0,
                    y: 0,
                    width: l,
                    height: u,
                    patternUnits: "userSpaceOnUse"
                });
            }
        }), t.Shape = t.invent({
            create: function(l) {
                this.constructor.call(this, l);
            },
            inherit: t.Element
        }), t.Symbol = t.invent({
            create: "symbol",
            inherit: t.Container,
            construct: {
                symbol: function() {
                    return this.put(new t.Symbol());
                }
            }
        }), t.Use = t.invent({
            create: "use",
            inherit: t.Shape,
            extend: {
                element: function(l, u) {
                    return this.attr("href", (u || "") + "#" + l, t.xlink);
                }
            },
            construct: {
                use: function(l, u) {
                    return this.put(new t.Use()).element(l, u);
                }
            }
        }), t.Rect = t.invent({
            create: "rect",
            inherit: t.Shape,
            construct: {
                rect: function(l, u) {
                    return this.put(new t.Rect()).size(l, u);
                }
            }
        }), t.Circle = t.invent({
            create: "circle",
            inherit: t.Shape,
            construct: {
                circle: function(l) {
                    return this.put(new t.Circle()).rx(new t.Number(l).divide(2)).move(0, 0);
                }
            }
        }), t.extend(t.Circle, t.FX, {
            rx: function(l) {
                return this.attr("r", l);
            },
            ry: function(l) {
                return this.rx(l);
            }
        }), t.Ellipse = t.invent({
            create: "ellipse",
            inherit: t.Shape,
            construct: {
                ellipse: function(l, u) {
                    return this.put(new t.Ellipse()).size(l, u).move(0, 0);
                }
            }
        }), t.extend(t.Ellipse, t.Rect, t.FX, {
            rx: function(l) {
                return this.attr("rx", l);
            },
            ry: function(l) {
                return this.attr("ry", l);
            }
        }), t.extend(t.Circle, t.Ellipse, {
            x: function(l) {
                return l == null ? this.cx() - this.rx() : this.cx(l + this.rx());
            },
            y: function(l) {
                return l == null ? this.cy() - this.ry() : this.cy(l + this.ry());
            },
            cx: function(l) {
                return l == null ? this.attr("cx") : this.attr("cx", l);
            },
            cy: function(l) {
                return l == null ? this.attr("cy") : this.attr("cy", l);
            },
            width: function(l) {
                return l == null ? 2 * this.rx() : this.rx(new t.Number(l).divide(2));
            },
            height: function(l) {
                return l == null ? 2 * this.ry() : this.ry(new t.Number(l).divide(2));
            },
            size: function(l, u) {
                var x = g(this, l, u);
                return this.rx(new t.Number(x.width).divide(2)).ry(new t.Number(x.height).divide(2));
            }
        }), t.Line = t.invent({
            create: "line",
            inherit: t.Shape,
            extend: {
                array: function() {
                    return new t.PointArray([
                        [
                            this.attr("x1"),
                            this.attr("y1")
                        ],
                        [
                            this.attr("x2"),
                            this.attr("y2")
                        ]
                    ]);
                },
                plot: function(l, u, x, v) {
                    return l == null ? this.array() : (l = u !== void 0 ? {
                        x1: l,
                        y1: u,
                        x2: x,
                        y2: v
                    } : new t.PointArray(l).toLine(), this.attr(l));
                },
                move: function(l, u) {
                    return this.attr(this.array().move(l, u).toLine());
                },
                size: function(l, u) {
                    var x = g(this, l, u);
                    return this.attr(this.array().size(x.width, x.height).toLine());
                }
            },
            construct: {
                line: function(l, u, x, v) {
                    return t.Line.prototype.plot.apply(this.put(new t.Line()), l != null ? [
                        l,
                        u,
                        x,
                        v
                    ] : [
                        0,
                        0,
                        0,
                        0
                    ]);
                }
            }
        }), t.Polyline = t.invent({
            create: "polyline",
            inherit: t.Shape,
            construct: {
                polyline: function(l) {
                    return this.put(new t.Polyline()).plot(l || new t.PointArray());
                }
            }
        }), t.Polygon = t.invent({
            create: "polygon",
            inherit: t.Shape,
            construct: {
                polygon: function(l) {
                    return this.put(new t.Polygon()).plot(l || new t.PointArray());
                }
            }
        }), t.extend(t.Polyline, t.Polygon, {
            array: function() {
                return this._array || (this._array = new t.PointArray(this.attr("points")));
            },
            plot: function(l) {
                return l == null ? this.array() : this.clear().attr("points", typeof l == "string" ? l : this._array = new t.PointArray(l));
            },
            clear: function() {
                return delete this._array, this;
            },
            move: function(l, u) {
                return this.attr("points", this.array().move(l, u));
            },
            size: function(l, u) {
                var x = g(this, l, u);
                return this.attr("points", this.array().size(x.width, x.height));
            }
        }), t.extend(t.Line, t.Polyline, t.Polygon, {
            morphArray: t.PointArray,
            x: function(l) {
                return l == null ? this.bbox().x : this.move(l, this.bbox().y);
            },
            y: function(l) {
                return l == null ? this.bbox().y : this.move(this.bbox().x, l);
            },
            width: function(l) {
                var u = this.bbox();
                return l == null ? u.width : this.size(l, u.height);
            },
            height: function(l) {
                var u = this.bbox();
                return l == null ? u.height : this.size(u.width, l);
            }
        }), t.Path = t.invent({
            create: "path",
            inherit: t.Shape,
            extend: {
                morphArray: t.PathArray,
                array: function() {
                    return this._array || (this._array = new t.PathArray(this.attr("d")));
                },
                plot: function(l) {
                    return l == null ? this.array() : this.clear().attr("d", typeof l == "string" ? l : this._array = new t.PathArray(l));
                },
                clear: function() {
                    return delete this._array, this;
                }
            },
            construct: {
                path: function(l) {
                    return this.put(new t.Path()).plot(l || new t.PathArray());
                }
            }
        }), t.Image = t.invent({
            create: "image",
            inherit: t.Shape,
            extend: {
                load: function(l) {
                    if (!l) return this;
                    var u = this, x = new y.Image();
                    return t.on(x, "load", function() {
                        t.off(x);
                        var v = u.parent(t.Pattern);
                        v !== null && (u.width() == 0 && u.height() == 0 && u.size(x.width, x.height), v && v.width() == 0 && v.height() == 0 && v.size(u.width(), u.height()), typeof u._loaded == "function" && u._loaded.call(u, {
                            width: x.width,
                            height: x.height,
                            ratio: x.width / x.height,
                            url: l
                        }));
                    }), t.on(x, "error", function(v) {
                        t.off(x), typeof u._error == "function" && u._error.call(u, v);
                    }), this.attr("href", x.src = this.src = l, t.xlink);
                },
                loaded: function(l) {
                    return this._loaded = l, this;
                },
                error: function(l) {
                    return this._error = l, this;
                }
            },
            construct: {
                image: function(l, u, x) {
                    return this.put(new t.Image()).load(l).size(u || 0, x || u || 0);
                }
            }
        }), t.Text = t.invent({
            create: function() {
                this.constructor.call(this, t.create("text")), this.dom.leading = new t.Number(1.3), this._rebuild = !0, this._build = !1, this.attr("font-family", t.defaults.attrs["font-family"]);
            },
            inherit: t.Shape,
            extend: {
                x: function(l) {
                    return l == null ? this.attr("x") : this.attr("x", l);
                },
                text: function(l) {
                    if (l === void 0) {
                        l = "";
                        for(var u = this.node.childNodes, x = 0, v = u.length; x < v; ++x)x != 0 && u[x].nodeType != 3 && t.adopt(u[x]).dom.newLined == 1 && (l += `
`), l += u[x].textContent;
                        return l;
                    }
                    if (this.clear().build(!0), typeof l == "function") l.call(this, this);
                    else {
                        x = 0;
                        for(var k = (l = l.split(`
`)).length; x < k; x++)this.tspan(l[x]).newLine();
                    }
                    return this.build(!1).rebuild();
                },
                size: function(l) {
                    return this.attr("font-size", l).rebuild();
                },
                leading: function(l) {
                    return l == null ? this.dom.leading : (this.dom.leading = new t.Number(l), this.rebuild());
                },
                lines: function() {
                    var l = (this.textPath && this.textPath() || this).node, u = t.utils.map(t.utils.filterSVGElements(l.childNodes), function(x) {
                        return t.adopt(x);
                    });
                    return new t.Set(u);
                },
                rebuild: function(l) {
                    if (typeof l == "boolean" && (this._rebuild = l), this._rebuild) {
                        var u = this, x = 0, v = this.dom.leading * new t.Number(this.attr("font-size"));
                        this.lines().each(function() {
                            this.dom.newLined && (u.textPath() || this.attr("x", u.attr("x")), this.text() == `
` ? x += v : (this.attr("dy", v + x), x = 0));
                        }), this.fire("rebuild");
                    }
                    return this;
                },
                build: function(l) {
                    return this._build = !!l, this;
                },
                setData: function(l) {
                    return this.dom = l, this.dom.leading = new t.Number(l.leading || 1.3), this;
                }
            },
            construct: {
                text: function(l) {
                    return this.put(new t.Text()).text(l);
                },
                plain: function(l) {
                    return this.put(new t.Text()).plain(l);
                }
            }
        }), t.Tspan = t.invent({
            create: "tspan",
            inherit: t.Shape,
            extend: {
                text: function(l) {
                    return l == null ? this.node.textContent + (this.dom.newLined ? `
` : "") : (typeof l == "function" ? l.call(this, this) : this.plain(l), this);
                },
                dx: function(l) {
                    return this.attr("dx", l);
                },
                dy: function(l) {
                    return this.attr("dy", l);
                },
                newLine: function() {
                    var l = this.parent(t.Text);
                    return this.dom.newLined = !0, this.dy(l.dom.leading * l.attr("font-size")).attr("x", l.x());
                }
            }
        }), t.extend(t.Text, t.Tspan, {
            plain: function(l) {
                return this._build === !1 && this.clear(), this.node.appendChild(e.createTextNode(l)), this;
            },
            tspan: function(l) {
                var u = (this.textPath && this.textPath() || this).node, x = new t.Tspan();
                return this._build === !1 && this.clear(), u.appendChild(x.node), x.text(l);
            },
            clear: function() {
                for(var l = (this.textPath && this.textPath() || this).node; l.hasChildNodes();)l.removeChild(l.lastChild);
                return this;
            },
            length: function() {
                return this.node.getComputedTextLength();
            }
        }), t.TextPath = t.invent({
            create: "textPath",
            inherit: t.Parent,
            parent: t.Text,
            construct: {
                morphArray: t.PathArray,
                array: function() {
                    var l = this.track();
                    return l ? l.array() : null;
                },
                plot: function(l) {
                    var u = this.track(), x = null;
                    return u && (x = u.plot(l)), l == null ? x : this;
                },
                track: function() {
                    var l = this.textPath();
                    if (l) return l.reference("href");
                },
                textPath: function() {
                    if (this.node.firstChild && this.node.firstChild.nodeName == "textPath") return t.adopt(this.node.firstChild);
                }
            }
        }), t.Nested = t.invent({
            create: function() {
                this.constructor.call(this, t.create("svg")), this.style("overflow", "visible");
            },
            inherit: t.Container,
            construct: {
                nested: function() {
                    return this.put(new t.Nested());
                }
            }
        });
        var n = {
            stroke: [
                "color",
                "width",
                "opacity",
                "linecap",
                "linejoin",
                "miterlimit",
                "dasharray",
                "dashoffset"
            ],
            fill: [
                "color",
                "opacity",
                "rule"
            ],
            prefix: function(l, u) {
                return u == "color" ? l : l + "-" + u;
            }
        };
        function o(l, u, x, v) {
            return x + v.replace(t.regex.dots, " .");
        }
        function h(l) {
            return l.toLowerCase().replace(/-(.)/g, function(u, x) {
                return x.toUpperCase();
            });
        }
        function c(l) {
            return l.charAt(0).toUpperCase() + l.slice(1);
        }
        function d(l) {
            var u = l.toString(16);
            return u.length == 1 ? "0" + u : u;
        }
        function g(l, u, x) {
            if (u == null || x == null) {
                var v = l.bbox();
                u == null ? u = v.width / v.height * x : x == null && (x = v.height / v.width * u);
            }
            return {
                width: u,
                height: x
            };
        }
        function p(l, u, x) {
            return {
                x: u * l.a + x * l.c + 0,
                y: u * l.b + x * l.d + 0
            };
        }
        function f(l) {
            return {
                a: l[0],
                b: l[1],
                c: l[2],
                d: l[3],
                e: l[4],
                f: l[5]
            };
        }
        function b(l) {
            for(var u = l.childNodes.length - 1; u >= 0; u--)l.childNodes[u] instanceof y.SVGElement && b(l.childNodes[u]);
            return t.adopt(l).id(t.eid(l.nodeName));
        }
        function m(l) {
            return Math.abs(l) > 1e-37 ? l : 0;
        }
        [
            "fill",
            "stroke"
        ].forEach(function(l) {
            var u = {};
            u[l] = function(x) {
                if (x === void 0) return this;
                if (typeof x == "string" || t.Color.isRgb(x) || x && typeof x.fill == "function") this.attr(l, x);
                else for(var v = n[l].length - 1; v >= 0; v--)x[n[l][v]] != null && this.attr(n.prefix(l, n[l][v]), x[n[l][v]]);
                return this;
            }, t.extend(t.Element, t.FX, u);
        }), t.extend(t.Element, t.FX, {
            translate: function(l, u) {
                return this.transform({
                    x: l,
                    y: u
                });
            },
            matrix: function(l) {
                return this.attr("transform", new t.Matrix(arguments.length == 6 ? [].slice.call(arguments) : l));
            },
            opacity: function(l) {
                return this.attr("opacity", l);
            },
            dx: function(l) {
                return this.x(new t.Number(l).plus(this instanceof t.FX ? 0 : this.x()), !0);
            },
            dy: function(l) {
                return this.y(new t.Number(l).plus(this instanceof t.FX ? 0 : this.y()), !0);
            }
        }), t.extend(t.Path, {
            length: function() {
                return this.node.getTotalLength();
            },
            pointAt: function(l) {
                return this.node.getPointAtLength(l);
            }
        }), t.Set = t.invent({
            create: function(l) {
                Array.isArray(l) ? this.members = l : this.clear();
            },
            extend: {
                add: function() {
                    for(var l = [].slice.call(arguments), u = 0, x = l.length; u < x; u++)this.members.push(l[u]);
                    return this;
                },
                remove: function(l) {
                    var u = this.index(l);
                    return u > -1 && this.members.splice(u, 1), this;
                },
                each: function(l) {
                    for(var u = 0, x = this.members.length; u < x; u++)l.apply(this.members[u], [
                        u,
                        this.members
                    ]);
                    return this;
                },
                clear: function() {
                    return this.members = [], this;
                },
                length: function() {
                    return this.members.length;
                },
                has: function(l) {
                    return this.index(l) >= 0;
                },
                index: function(l) {
                    return this.members.indexOf(l);
                },
                get: function(l) {
                    return this.members[l];
                },
                first: function() {
                    return this.get(0);
                },
                last: function() {
                    return this.get(this.members.length - 1);
                },
                valueOf: function() {
                    return this.members;
                }
            },
            construct: {
                set: function(l) {
                    return new t.Set(l);
                }
            }
        }), t.FX.Set = t.invent({
            create: function(l) {
                this.set = l;
            }
        }), t.Set.inherit = function() {
            var l = [];
            for(var u in t.Shape.prototype)typeof t.Shape.prototype[u] == "function" && typeof t.Set.prototype[u] != "function" && l.push(u);
            for(var u in l.forEach(function(v) {
                t.Set.prototype[v] = function() {
                    for(var k = 0, S = this.members.length; k < S; k++)this.members[k] && typeof this.members[k][v] == "function" && this.members[k][v].apply(this.members[k], arguments);
                    return v == "animate" ? this.fx || (this.fx = new t.FX.Set(this)) : this;
                };
            }), l = [], t.FX.prototype)typeof t.FX.prototype[u] == "function" && typeof t.FX.Set.prototype[u] != "function" && l.push(u);
            l.forEach(function(x) {
                t.FX.Set.prototype[x] = function() {
                    for(var v = 0, k = this.set.members.length; v < k; v++)this.set.members[v].fx[x].apply(this.set.members[v].fx, arguments);
                    return this;
                };
            });
        }, t.extend(t.Element, {}), t.extend(t.Element, {
            remember: function(l, u) {
                if (U(arguments[0]) === "object") for(var x in l)this.remember(x, l[x]);
                else {
                    if (arguments.length == 1) return this.memory()[l];
                    this.memory()[l] = u;
                }
                return this;
            },
            forget: function() {
                if (arguments.length == 0) this._memory = {};
                else for(var l = arguments.length - 1; l >= 0; l--)delete this.memory()[arguments[l]];
                return this;
            },
            memory: function() {
                return this._memory || (this._memory = {});
            }
        }), t.get = function(l) {
            var u = e.getElementById(function(x) {
                var v = (x || "").toString().match(t.regex.reference);
                if (v) return v[1];
            }(l) || l);
            return t.adopt(u);
        }, t.select = function(l, u) {
            return new t.Set(t.utils.map((u || e).querySelectorAll(l), function(x) {
                return t.adopt(x);
            }));
        }, t.extend(t.Parent, {
            select: function(l) {
                return t.select(l, this.node);
            }
        });
        var w = "abcdef".split("");
        if (typeof y.CustomEvent != "function") {
            var A = function(l, u) {
                u = u || {
                    bubbles: !1,
                    cancelable: !1,
                    detail: void 0
                };
                var x = e.createEvent("CustomEvent");
                return x.initCustomEvent(l, u.bubbles, u.cancelable, u.detail), x;
            };
            A.prototype = y.Event.prototype, t.CustomEvent = A;
        } else t.CustomEvent = y.CustomEvent;
        return t;
    }, U(Re) === "object" ? _.exports = be.document ? Fe(be, be.document) : function(y) {
        return Fe(y, y.document);
    } : be.SVG = Fe(be, be.document), /*! svg.filter.js - v2.0.2 - 2016-02-24
  * https://github.com/wout/svg.filter.js
  * Copyright (c) 2016 Wout Fierens; Licensed MIT */ (function() {
        SVG.Filter = SVG.invent({
            create: "filter",
            inherit: SVG.Parent,
            extend: {
                source: "SourceGraphic",
                sourceAlpha: "SourceAlpha",
                background: "BackgroundImage",
                backgroundAlpha: "BackgroundAlpha",
                fill: "FillPaint",
                stroke: "StrokePaint",
                autoSetIn: !0,
                put: function(r, n) {
                    return this.add(r, n), !r.attr("in") && this.autoSetIn && r.attr("in", this.source), r.attr("result") || r.attr("result", r), r;
                },
                blend: function(r, n, o) {
                    return this.put(new SVG.BlendEffect(r, n, o));
                },
                colorMatrix: function(r, n) {
                    return this.put(new SVG.ColorMatrixEffect(r, n));
                },
                convolveMatrix: function(r) {
                    return this.put(new SVG.ConvolveMatrixEffect(r));
                },
                componentTransfer: function(r) {
                    return this.put(new SVG.ComponentTransferEffect(r));
                },
                composite: function(r, n, o) {
                    return this.put(new SVG.CompositeEffect(r, n, o));
                },
                flood: function(r, n) {
                    return this.put(new SVG.FloodEffect(r, n));
                },
                offset: function(r, n) {
                    return this.put(new SVG.OffsetEffect(r, n));
                },
                image: function(r) {
                    return this.put(new SVG.ImageEffect(r));
                },
                merge: function() {
                    var r = [
                        void 0
                    ];
                    for(var n in arguments)r.push(arguments[n]);
                    return this.put(new (SVG.MergeEffect.bind.apply(SVG.MergeEffect, r))());
                },
                gaussianBlur: function(r, n) {
                    return this.put(new SVG.GaussianBlurEffect(r, n));
                },
                morphology: function(r, n) {
                    return this.put(new SVG.MorphologyEffect(r, n));
                },
                diffuseLighting: function(r, n, o) {
                    return this.put(new SVG.DiffuseLightingEffect(r, n, o));
                },
                displacementMap: function(r, n, o, h, c) {
                    return this.put(new SVG.DisplacementMapEffect(r, n, o, h, c));
                },
                specularLighting: function(r, n, o, h) {
                    return this.put(new SVG.SpecularLightingEffect(r, n, o, h));
                },
                tile: function() {
                    return this.put(new SVG.TileEffect());
                },
                turbulence: function(r, n, o, h, c) {
                    return this.put(new SVG.TurbulenceEffect(r, n, o, h, c));
                },
                toString: function() {
                    return "url(#" + this.attr("id") + ")";
                }
            }
        }), SVG.extend(SVG.Defs, {
            filter: function(r) {
                var n = this.put(new SVG.Filter());
                return typeof r == "function" && r.call(n, n), n;
            }
        }), SVG.extend(SVG.Container, {
            filter: function(r) {
                return this.defs().filter(r);
            }
        }), SVG.extend(SVG.Element, SVG.G, SVG.Nested, {
            filter: function(r) {
                return this.filterer = r instanceof SVG.Element ? r : this.doc().filter(r), this.doc() && this.filterer.doc() !== this.doc() && this.doc().defs().add(this.filterer), this.attr("filter", this.filterer), this.filterer;
            },
            unfilter: function(r) {
                return this.filterer && r === !0 && this.filterer.remove(), delete this.filterer, this.attr("filter", null);
            }
        }), SVG.Effect = SVG.invent({
            create: function() {
                this.constructor.call(this);
            },
            inherit: SVG.Element,
            extend: {
                in: function(r) {
                    return r == null ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", r);
                },
                result: function(r) {
                    return r == null ? this.attr("result") : this.attr("result", r);
                },
                toString: function() {
                    return this.result();
                }
            }
        }), SVG.ParentEffect = SVG.invent({
            create: function() {
                this.constructor.call(this);
            },
            inherit: SVG.Parent,
            extend: {
                in: function(r) {
                    return r == null ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", r);
                },
                result: function(r) {
                    return r == null ? this.attr("result") : this.attr("result", r);
                },
                toString: function() {
                    return this.result();
                }
            }
        });
        var y = {
            blend: function(r, n) {
                return this.parent() && this.parent().blend(this, r, n);
            },
            colorMatrix: function(r, n) {
                return this.parent() && this.parent().colorMatrix(r, n).in(this);
            },
            convolveMatrix: function(r) {
                return this.parent() && this.parent().convolveMatrix(r).in(this);
            },
            componentTransfer: function(r) {
                return this.parent() && this.parent().componentTransfer(r).in(this);
            },
            composite: function(r, n) {
                return this.parent() && this.parent().composite(this, r, n);
            },
            flood: function(r, n) {
                return this.parent() && this.parent().flood(r, n);
            },
            offset: function(r, n) {
                return this.parent() && this.parent().offset(r, n).in(this);
            },
            image: function(r) {
                return this.parent() && this.parent().image(r);
            },
            merge: function() {
                return this.parent() && this.parent().merge.apply(this.parent(), [
                    this
                ].concat(arguments));
            },
            gaussianBlur: function(r, n) {
                return this.parent() && this.parent().gaussianBlur(r, n).in(this);
            },
            morphology: function(r, n) {
                return this.parent() && this.parent().morphology(r, n).in(this);
            },
            diffuseLighting: function(r, n, o) {
                return this.parent() && this.parent().diffuseLighting(r, n, o).in(this);
            },
            displacementMap: function(r, n, o, h) {
                return this.parent() && this.parent().displacementMap(this, r, n, o, h);
            },
            specularLighting: function(r, n, o, h) {
                return this.parent() && this.parent().specularLighting(r, n, o, h).in(this);
            },
            tile: function() {
                return this.parent() && this.parent().tile().in(this);
            },
            turbulence: function(r, n, o, h, c) {
                return this.parent() && this.parent().turbulence(r, n, o, h, c).in(this);
            }
        };
        SVG.extend(SVG.Effect, y), SVG.extend(SVG.ParentEffect, y), SVG.ChildEffect = SVG.invent({
            create: function() {
                this.constructor.call(this);
            },
            inherit: SVG.Element,
            extend: {
                in: function(r) {
                    this.attr("in", r);
                }
            }
        });
        var e = {
            blend: function(r, n, o) {
                this.attr({
                    in: r,
                    in2: n,
                    mode: o || "normal"
                });
            },
            colorMatrix: function(r, n) {
                r == "matrix" && (n = a(n)), this.attr({
                    type: r,
                    values: n === void 0 ? null : n
                });
            },
            convolveMatrix: function(r) {
                r = a(r), this.attr({
                    order: Math.sqrt(r.split(" ").length),
                    kernelMatrix: r
                });
            },
            composite: function(r, n, o) {
                this.attr({
                    in: r,
                    in2: n,
                    operator: o
                });
            },
            flood: function(r, n) {
                this.attr("flood-color", r), n != null && this.attr("flood-opacity", n);
            },
            offset: function(r, n) {
                this.attr({
                    dx: r,
                    dy: n
                });
            },
            image: function(r) {
                this.attr("href", r, SVG.xlink);
            },
            displacementMap: function(r, n, o, h, c) {
                this.attr({
                    in: r,
                    in2: n,
                    scale: o,
                    xChannelSelector: h,
                    yChannelSelector: c
                });
            },
            gaussianBlur: function(r, n) {
                r != null || n != null ? this.attr("stdDeviation", function(o) {
                    if (!Array.isArray(o)) return o;
                    for(var h = 0, c = o.length, d = []; h < c; h++)d.push(o[h]);
                    return d.join(" ");
                }(Array.prototype.slice.call(arguments))) : this.attr("stdDeviation", "0 0");
            },
            morphology: function(r, n) {
                this.attr({
                    operator: r,
                    radius: n
                });
            },
            tile: function() {},
            turbulence: function(r, n, o, h, c) {
                this.attr({
                    numOctaves: n,
                    seed: o,
                    stitchTiles: h,
                    baseFrequency: r,
                    type: c
                });
            }
        }, t = {
            merge: function() {
                var r;
                if (arguments[0] instanceof SVG.Set) {
                    var n = this;
                    arguments[0].each(function(h) {
                        this instanceof SVG.MergeNode ? n.put(this) : (this instanceof SVG.Effect || this instanceof SVG.ParentEffect) && n.put(new SVG.MergeNode(this));
                    });
                } else {
                    r = Array.isArray(arguments[0]) ? arguments[0] : arguments;
                    for(var o = 0; o < r.length; o++)r[o] instanceof SVG.MergeNode ? this.put(r[o]) : this.put(new SVG.MergeNode(r[o]));
                }
            },
            componentTransfer: function(r) {
                if (this.rgb = new SVG.Set(), [
                    "r",
                    "g",
                    "b",
                    "a"
                ].forEach((function(o) {
                    this[o] = new SVG["Func" + o.toUpperCase()]("identity"), this.rgb.add(this[o]), this.node.appendChild(this[o].node);
                }).bind(this)), r) for(var n in r.rgb && ([
                    "r",
                    "g",
                    "b"
                ].forEach((function(o) {
                    this[o].attr(r.rgb);
                }).bind(this)), delete r.rgb), r)this[n].attr(r[n]);
            },
            diffuseLighting: function(r, n, o) {
                this.attr({
                    surfaceScale: r,
                    diffuseConstant: n,
                    kernelUnitLength: o
                });
            },
            specularLighting: function(r, n, o, h) {
                this.attr({
                    surfaceScale: r,
                    diffuseConstant: n,
                    specularExponent: o,
                    kernelUnitLength: h
                });
            }
        }, i = {
            distantLight: function(r, n) {
                this.attr({
                    azimuth: r,
                    elevation: n
                });
            },
            pointLight: function(r, n, o) {
                this.attr({
                    x: r,
                    y: n,
                    z: o
                });
            },
            spotLight: function(r, n, o, h, c, d) {
                this.attr({
                    x: r,
                    y: n,
                    z: o,
                    pointsAtX: h,
                    pointsAtY: c,
                    pointsAtZ: d
                });
            },
            mergeNode: function(r) {
                this.attr("in", r);
            }
        };
        function a(r) {
            return Array.isArray(r) && (r = new SVG.Array(r)), r.toString().replace(/^\s+/, "").replace(/\s+$/, "").replace(/\s+/g, " ");
        }
        function s() {
            var r = function() {};
            for(var n in typeof arguments[arguments.length - 1] == "function" && (r = arguments[arguments.length - 1], Array.prototype.splice.call(arguments, arguments.length - 1, 1)), arguments)for(var o in arguments[n])r(arguments[n][o], o, arguments[n]);
        }
        [
            "r",
            "g",
            "b",
            "a"
        ].forEach(function(r) {
            i["Func" + r.toUpperCase()] = function(n) {
                switch(this.attr("type", n), n){
                    case "table":
                        this.attr("tableValues", arguments[1]);
                        break;
                    case "linear":
                        this.attr("slope", arguments[1]), this.attr("intercept", arguments[2]);
                        break;
                    case "gamma":
                        this.attr("amplitude", arguments[1]), this.attr("exponent", arguments[2]), this.attr("offset", arguments[2]);
                }
            };
        }), s(e, function(r, n) {
            var o = n.charAt(0).toUpperCase() + n.slice(1);
            SVG[o + "Effect"] = SVG.invent({
                create: function() {
                    this.constructor.call(this, SVG.create("fe" + o)), r.apply(this, arguments), this.result(this.attr("id") + "Out");
                },
                inherit: SVG.Effect,
                extend: {}
            });
        }), s(t, function(r, n) {
            var o = n.charAt(0).toUpperCase() + n.slice(1);
            SVG[o + "Effect"] = SVG.invent({
                create: function() {
                    this.constructor.call(this, SVG.create("fe" + o)), r.apply(this, arguments), this.result(this.attr("id") + "Out");
                },
                inherit: SVG.ParentEffect,
                extend: {}
            });
        }), s(i, function(r, n) {
            var o = n.charAt(0).toUpperCase() + n.slice(1);
            SVG[o] = SVG.invent({
                create: function() {
                    this.constructor.call(this, SVG.create("fe" + o)), r.apply(this, arguments);
                },
                inherit: SVG.ChildEffect,
                extend: {}
            });
        }), SVG.extend(SVG.MergeEffect, {
            in: function(r) {
                return r instanceof SVG.MergeNode ? this.add(r, 0) : this.add(new SVG.MergeNode(r), 0), this;
            }
        }), SVG.extend(SVG.CompositeEffect, SVG.BlendEffect, SVG.DisplacementMapEffect, {
            in2: function(r) {
                return r == null ? this.parent() && this.parent().select('[result="' + this.attr("in2") + '"]').get(0) || this.attr("in2") : this.attr("in2", r);
            }
        }), SVG.filter = {
            sepiatone: [
                0.343,
                0.669,
                0.119,
                0,
                0,
                0.249,
                0.626,
                0.13,
                0,
                0,
                0.172,
                0.334,
                0.111,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]
        };
    }).call(void 0), function() {
        function y(s, r, n, o, h, c, d) {
            for(var g = s.slice(r, n || d), p = o.slice(h, c || d), f = 0, b = {
                pos: [
                    0,
                    0
                ],
                start: [
                    0,
                    0
                ]
            }, m = {
                pos: [
                    0,
                    0
                ],
                start: [
                    0,
                    0
                ]
            }; g[f] = e.call(b, g[f]), p[f] = e.call(m, p[f]), g[f][0] != p[f][0] || g[f][0] == "M" || g[f][0] == "A" && (g[f][4] != p[f][4] || g[f][5] != p[f][5]) ? (Array.prototype.splice.apply(g, [
                f,
                1
            ].concat(i.call(b, g[f]))), Array.prototype.splice.apply(p, [
                f,
                1
            ].concat(i.call(m, p[f])))) : (g[f] = t.call(b, g[f]), p[f] = t.call(m, p[f])), !(++f == g.length && f == p.length);)f == g.length && g.push([
                "C",
                b.pos[0],
                b.pos[1],
                b.pos[0],
                b.pos[1],
                b.pos[0],
                b.pos[1]
            ]), f == p.length && p.push([
                "C",
                m.pos[0],
                m.pos[1],
                m.pos[0],
                m.pos[1],
                m.pos[0],
                m.pos[1]
            ]);
            return {
                start: g,
                dest: p
            };
        }
        function e(s) {
            switch(s[0]){
                case "z":
                case "Z":
                    s[0] = "L", s[1] = this.start[0], s[2] = this.start[1];
                    break;
                case "H":
                    s[0] = "L", s[2] = this.pos[1];
                    break;
                case "V":
                    s[0] = "L", s[2] = s[1], s[1] = this.pos[0];
                    break;
                case "T":
                    s[0] = "Q", s[3] = s[1], s[4] = s[2], s[1] = this.reflection[1], s[2] = this.reflection[0];
                    break;
                case "S":
                    s[0] = "C", s[6] = s[4], s[5] = s[3], s[4] = s[2], s[3] = s[1], s[2] = this.reflection[1], s[1] = this.reflection[0];
            }
            return s;
        }
        function t(s) {
            var r = s.length;
            return this.pos = [
                s[r - 2],
                s[r - 1]
            ], "SCQT".indexOf(s[0]) != -1 && (this.reflection = [
                2 * this.pos[0] - s[r - 4],
                2 * this.pos[1] - s[r - 3]
            ]), s;
        }
        function i(s) {
            var r = [
                s
            ];
            switch(s[0]){
                case "M":
                    return this.pos = this.start = [
                        s[1],
                        s[2]
                    ], r;
                case "L":
                    s[5] = s[3] = s[1], s[6] = s[4] = s[2], s[1] = this.pos[0], s[2] = this.pos[1];
                    break;
                case "Q":
                    s[6] = s[4], s[5] = s[3], s[4] = 1 * s[4] / 3 + 2 * s[2] / 3, s[3] = 1 * s[3] / 3 + 2 * s[1] / 3, s[2] = 1 * this.pos[1] / 3 + 2 * s[2] / 3, s[1] = 1 * this.pos[0] / 3 + 2 * s[1] / 3;
                    break;
                case "A":
                    r = function(n, o) {
                        var h, c, d, g, p, f, b, m, w, A, l, u, x, v, k, S, C, L, I, z, T, E, R, O, D, W, N = Math.abs(o[1]), V = Math.abs(o[2]), j = o[3] % 360, se = o[4], K = o[5], le = o[6], he = o[7], $ = new SVG.Point(n), Q = new SVG.Point(le, he), dt = [];
                        if (N === 0 || V === 0 || $.x === Q.x && $.y === Q.y) return [
                            [
                                "C",
                                $.x,
                                $.y,
                                Q.x,
                                Q.y,
                                Q.x,
                                Q.y
                            ]
                        ];
                        for(h = new SVG.Point(($.x - Q.x) / 2, ($.y - Q.y) / 2).transform(new SVG.Matrix().rotate(j)), (c = h.x * h.x / (N * N) + h.y * h.y / (V * V)) > 1 && (N *= c = Math.sqrt(c), V *= c), d = new SVG.Matrix().rotate(j).scale(1 / N, 1 / V).rotate(-j), $ = $.transform(d), Q = Q.transform(d), g = [
                            Q.x - $.x,
                            Q.y - $.y
                        ], f = g[0] * g[0] + g[1] * g[1], p = Math.sqrt(f), g[0] /= p, g[1] /= p, b = f < 4 ? Math.sqrt(1 - f / 4) : 0, se === K && (b *= -1), m = new SVG.Point((Q.x + $.x) / 2 + b * -g[1], (Q.y + $.y) / 2 + b * g[0]), w = new SVG.Point($.x - m.x, $.y - m.y), A = new SVG.Point(Q.x - m.x, Q.y - m.y), l = Math.acos(w.x / Math.sqrt(w.x * w.x + w.y * w.y)), w.y < 0 && (l *= -1), u = Math.acos(A.x / Math.sqrt(A.x * A.x + A.y * A.y)), A.y < 0 && (u *= -1), K && l > u && (u += 2 * Math.PI), !K && l < u && (u -= 2 * Math.PI), v = Math.ceil(2 * Math.abs(l - u) / Math.PI), S = [], C = l, x = (u - l) / v, k = 4 * Math.tan(x / 4) / 3, T = 0; T <= v; T++)I = Math.cos(C), L = Math.sin(C), z = new SVG.Point(m.x + I, m.y + L), S[T] = [
                            new SVG.Point(z.x + k * L, z.y - k * I),
                            z,
                            new SVG.Point(z.x - k * L, z.y + k * I)
                        ], C += x;
                        for(S[0][0] = S[0][1].clone(), S[S.length - 1][2] = S[S.length - 1][1].clone(), d = new SVG.Matrix().rotate(j).scale(N, V).rotate(-j), T = 0, E = S.length; T < E; T++)S[T][0] = S[T][0].transform(d), S[T][1] = S[T][1].transform(d), S[T][2] = S[T][2].transform(d);
                        for(T = 1, E = S.length; T < E; T++)R = (z = S[T - 1][2]).x, O = z.y, D = (z = S[T][0]).x, W = z.y, le = (z = S[T][1]).x, he = z.y, dt.push([
                            "C",
                            R,
                            O,
                            D,
                            W,
                            le,
                            he
                        ]);
                        return dt;
                    }(this.pos, s), s = r[0];
            }
            return s[0] = "C", this.pos = [
                s[5],
                s[6]
            ], this.reflection = [
                2 * s[5] - s[3],
                2 * s[6] - s[4]
            ], r;
        }
        function a(s, r) {
            if (r === !1) return !1;
            for(var n = r, o = s.length; n < o; ++n)if (s[n][0] == "M") return n;
            return !1;
        }
        SVG.extend(SVG.PathArray, {
            morph: function(s) {
                for(var r = this.value, n = this.parse(s), o = 0, h = 0, c = !1, d = !1; o !== !1 || h !== !1;){
                    var g;
                    c = a(r, o !== !1 && o + 1), d = a(n, h !== !1 && h + 1), o === !1 && (o = (g = new SVG.PathArray(p.start).bbox()).height == 0 || g.width == 0 ? r.push(r[0]) - 1 : r.push([
                        "M",
                        g.x + g.width / 2,
                        g.y + g.height / 2
                    ]) - 1), h === !1 && (h = (g = new SVG.PathArray(p.dest).bbox()).height == 0 || g.width == 0 ? n.push(n[0]) - 1 : n.push([
                        "M",
                        g.x + g.width / 2,
                        g.y + g.height / 2
                    ]) - 1);
                    var p = y(r, o, c, n, h, d);
                    r = r.slice(0, o).concat(p.start, c === !1 ? [] : r.slice(c)), n = n.slice(0, h).concat(p.dest, d === !1 ? [] : n.slice(d)), o = c !== !1 && o + p.start.length, h = d !== !1 && h + p.dest.length;
                }
                return this.value = r, this.destination = new SVG.PathArray(), this.destination.value = n, this;
            }
        });
    }(), /*! svg.draggable.js - v2.2.2 - 2019-01-08
  * https://github.com/svgdotjs/svg.draggable.js
  * Copyright (c) 2019 Wout Fierens; Licensed MIT */ (function() {
        function y(e) {
            e.remember("_draggable", this), this.el = e;
        }
        y.prototype.init = function(e, t) {
            var i = this;
            this.constraint = e, this.value = t, this.el.on("mousedown.drag", function(a) {
                i.start(a);
            }), this.el.on("touchstart.drag", function(a) {
                i.start(a);
            });
        }, y.prototype.transformPoint = function(e, t) {
            var i = (e = e || window.event).changedTouches && e.changedTouches[0] || e;
            return this.p.x = i.clientX - (t || 0), this.p.y = i.clientY, this.p.matrixTransform(this.m);
        }, y.prototype.getBBox = function() {
            var e = this.el.bbox();
            return this.el instanceof SVG.Nested && (e = this.el.rbox()), (this.el instanceof SVG.G || this.el instanceof SVG.Use || this.el instanceof SVG.Nested) && (e.x = this.el.x(), e.y = this.el.y()), e;
        }, y.prototype.start = function(e) {
            if (e.type != "click" && e.type != "mousedown" && e.type != "mousemove" || (e.which || e.buttons) == 1) {
                var t = this;
                if (this.el.fire("beforedrag", {
                    event: e,
                    handler: this
                }), !this.el.event().defaultPrevented) {
                    e.preventDefault(), e.stopPropagation(), this.parent = this.parent || this.el.parent(SVG.Nested) || this.el.parent(SVG.Doc), this.p = this.parent.node.createSVGPoint(), this.m = this.el.node.getScreenCTM().inverse();
                    var i, a = this.getBBox();
                    if (this.el instanceof SVG.Text) switch(i = this.el.node.getComputedTextLength(), this.el.attr("text-anchor")){
                        case "middle":
                            i /= 2;
                            break;
                        case "start":
                            i = 0;
                    }
                    this.startPoints = {
                        point: this.transformPoint(e, i),
                        box: a,
                        transform: this.el.transform()
                    }, SVG.on(window, "mousemove.drag", function(s) {
                        t.drag(s);
                    }), SVG.on(window, "touchmove.drag", function(s) {
                        t.drag(s);
                    }), SVG.on(window, "mouseup.drag", function(s) {
                        t.end(s);
                    }), SVG.on(window, "touchend.drag", function(s) {
                        t.end(s);
                    }), this.el.fire("dragstart", {
                        event: e,
                        p: this.startPoints.point,
                        m: this.m,
                        handler: this
                    });
                }
            }
        }, y.prototype.drag = function(e) {
            var t = this.getBBox(), i = this.transformPoint(e), a = this.startPoints.box.x + i.x - this.startPoints.point.x, s = this.startPoints.box.y + i.y - this.startPoints.point.y, r = this.constraint, n = i.x - this.startPoints.point.x, o = i.y - this.startPoints.point.y;
            if (this.el.fire("dragmove", {
                event: e,
                p: i,
                m: this.m,
                handler: this
            }), this.el.event().defaultPrevented) return i;
            if (typeof r == "function") {
                var h = r.call(this.el, a, s, this.m);
                typeof h == "boolean" && (h = {
                    x: h,
                    y: h
                }), h.x === !0 ? this.el.x(a) : h.x !== !1 && this.el.x(h.x), h.y === !0 ? this.el.y(s) : h.y !== !1 && this.el.y(h.y);
            } else typeof r == "object" && (r.minX != null && a < r.minX ? n = (a = r.minX) - this.startPoints.box.x : r.maxX != null && a > r.maxX - t.width && (n = (a = r.maxX - t.width) - this.startPoints.box.x), r.minY != null && s < r.minY ? o = (s = r.minY) - this.startPoints.box.y : r.maxY != null && s > r.maxY - t.height && (o = (s = r.maxY - t.height) - this.startPoints.box.y), r.snapToGrid != null && (a -= a % r.snapToGrid, s -= s % r.snapToGrid, n -= n % r.snapToGrid, o -= o % r.snapToGrid), this.el instanceof SVG.G ? this.el.matrix(this.startPoints.transform).transform({
                x: n,
                y: o
            }, !0) : this.el.move(a, s));
            return i;
        }, y.prototype.end = function(e) {
            var t = this.drag(e);
            this.el.fire("dragend", {
                event: e,
                p: t,
                m: this.m,
                handler: this
            }), SVG.off(window, "mousemove.drag"), SVG.off(window, "touchmove.drag"), SVG.off(window, "mouseup.drag"), SVG.off(window, "touchend.drag");
        }, SVG.extend(SVG.Element, {
            draggable: function(e, t) {
                typeof e != "function" && typeof e != "object" || (t = e, e = !0);
                var i = this.remember("_draggable") || new y(this);
                return (e = e === void 0 || e) ? i.init(t || {}, e) : (this.off("mousedown.drag"), this.off("touchstart.drag")), this;
            }
        });
    }).call(void 0), function() {
        function y(e) {
            this.el = e, e.remember("_selectHandler", this), this.pointSelection = {
                isSelected: !1
            }, this.rectSelection = {
                isSelected: !1
            }, this.pointsList = {
                lt: [
                    0,
                    0
                ],
                rt: [
                    "width",
                    0
                ],
                rb: [
                    "width",
                    "height"
                ],
                lb: [
                    0,
                    "height"
                ],
                t: [
                    "width",
                    0
                ],
                r: [
                    "width",
                    "height"
                ],
                b: [
                    "width",
                    "height"
                ],
                l: [
                    0,
                    "height"
                ]
            }, this.pointCoord = function(t, i, a) {
                var s = typeof t != "string" ? t : i[t];
                return a ? s / 2 : s;
            }, this.pointCoords = function(t, i) {
                var a = this.pointsList[t];
                return {
                    x: this.pointCoord(a[0], i, t === "t" || t === "b"),
                    y: this.pointCoord(a[1], i, t === "r" || t === "l")
                };
            };
        }
        y.prototype.init = function(e, t) {
            var i = this.el.bbox();
            this.options = {};
            var a = this.el.selectize.defaults.points;
            for(var s in this.el.selectize.defaults)this.options[s] = this.el.selectize.defaults[s], t[s] !== void 0 && (this.options[s] = t[s]);
            var r = [
                "points",
                "pointsExclude"
            ];
            for(var s in r){
                var n = this.options[r[s]];
                typeof n == "string" ? n = n.length > 0 ? n.split(/\s*,\s*/i) : [] : typeof n == "boolean" && r[s] === "points" && (n = n ? a : []), this.options[r[s]] = n;
            }
            this.options.points = [
                a,
                this.options.points
            ].reduce(function(o, h) {
                return o.filter(function(c) {
                    return h.indexOf(c) > -1;
                });
            }), this.options.points = [
                this.options.points,
                this.options.pointsExclude
            ].reduce(function(o, h) {
                return o.filter(function(c) {
                    return h.indexOf(c) < 0;
                });
            }), this.parent = this.el.parent(), this.nested = this.nested || this.parent.group(), this.nested.matrix(new SVG.Matrix(this.el).translate(i.x, i.y)), this.options.deepSelect && [
                "line",
                "polyline",
                "polygon"
            ].indexOf(this.el.type) !== -1 ? this.selectPoints(e) : this.selectRect(e), this.observe(), this.cleanup();
        }, y.prototype.selectPoints = function(e) {
            return this.pointSelection.isSelected = e, this.pointSelection.set || (this.pointSelection.set = this.parent.set(), this.drawPoints()), this;
        }, y.prototype.getPointArray = function() {
            var e = this.el.bbox();
            return this.el.array().valueOf().map(function(t) {
                return [
                    t[0] - e.x,
                    t[1] - e.y
                ];
            });
        }, y.prototype.drawPoints = function() {
            for(var e = this, t = this.getPointArray(), i = 0, a = t.length; i < a; ++i){
                var s = function(n) {
                    return function(o) {
                        (o = o || window.event).preventDefault ? o.preventDefault() : o.returnValue = !1, o.stopPropagation();
                        var h = o.pageX || o.touches[0].pageX, c = o.pageY || o.touches[0].pageY;
                        e.el.fire("point", {
                            x: h,
                            y: c,
                            i: n,
                            event: o
                        });
                    };
                }(i), r = this.drawPoint(t[i][0], t[i][1]).addClass(this.options.classPoints).addClass(this.options.classPoints + "_point").on("touchstart", s).on("mousedown", s);
                this.pointSelection.set.add(r);
            }
        }, y.prototype.drawPoint = function(e, t) {
            var i = this.options.pointType;
            switch(i){
                case "circle":
                    return this.drawCircle(e, t);
                case "rect":
                    return this.drawRect(e, t);
                default:
                    if (typeof i == "function") return i.call(this, e, t);
                    throw new Error("Unknown " + i + " point type!");
            }
        }, y.prototype.drawCircle = function(e, t) {
            return this.nested.circle(this.options.pointSize).center(e, t);
        }, y.prototype.drawRect = function(e, t) {
            return this.nested.rect(this.options.pointSize, this.options.pointSize).center(e, t);
        }, y.prototype.updatePointSelection = function() {
            var e = this.getPointArray();
            this.pointSelection.set.each(function(t) {
                this.cx() === e[t][0] && this.cy() === e[t][1] || this.center(e[t][0], e[t][1]);
            });
        }, y.prototype.updateRectSelection = function() {
            var e = this, t = this.el.bbox();
            if (this.rectSelection.set.get(0).attr({
                width: t.width,
                height: t.height
            }), this.options.points.length && this.options.points.map(function(a, s) {
                var r = e.pointCoords(a, t);
                e.rectSelection.set.get(s + 1).center(r.x, r.y);
            }), this.options.rotationPoint) {
                var i = this.rectSelection.set.length();
                this.rectSelection.set.get(i - 1).center(t.width / 2, 20);
            }
        }, y.prototype.selectRect = function(e) {
            var t = this, i = this.el.bbox();
            function a(n) {
                return function(o) {
                    (o = o || window.event).preventDefault ? o.preventDefault() : o.returnValue = !1, o.stopPropagation();
                    var h = o.pageX || o.touches[0].pageX, c = o.pageY || o.touches[0].pageY;
                    t.el.fire(n, {
                        x: h,
                        y: c,
                        event: o
                    });
                };
            }
            if (this.rectSelection.isSelected = e, this.rectSelection.set = this.rectSelection.set || this.parent.set(), this.rectSelection.set.get(0) || this.rectSelection.set.add(this.nested.rect(i.width, i.height).addClass(this.options.classRect)), this.options.points.length && this.rectSelection.set.length() < 2 && (this.options.points.map(function(n, o) {
                var h = t.pointCoords(n, i), c = t.drawPoint(h.x, h.y).attr("class", t.options.classPoints + "_" + n).on("mousedown", a(n)).on("touchstart", a(n));
                t.rectSelection.set.add(c);
            }), this.rectSelection.set.each(function() {
                this.addClass(t.options.classPoints);
            })), this.options.rotationPoint && (this.options.points && !this.rectSelection.set.get(9) || !this.options.points && !this.rectSelection.set.get(1))) {
                var s = function(n) {
                    (n = n || window.event).preventDefault ? n.preventDefault() : n.returnValue = !1, n.stopPropagation();
                    var o = n.pageX || n.touches[0].pageX, h = n.pageY || n.touches[0].pageY;
                    t.el.fire("rot", {
                        x: o,
                        y: h,
                        event: n
                    });
                }, r = this.drawPoint(i.width / 2, 20).attr("class", this.options.classPoints + "_rot").on("touchstart", s).on("mousedown", s);
                this.rectSelection.set.add(r);
            }
        }, y.prototype.handler = function() {
            var e = this.el.bbox();
            this.nested.matrix(new SVG.Matrix(this.el).translate(e.x, e.y)), this.rectSelection.isSelected && this.updateRectSelection(), this.pointSelection.isSelected && this.updatePointSelection();
        }, y.prototype.observe = function() {
            var e = this;
            if (MutationObserver) {
                if (this.rectSelection.isSelected || this.pointSelection.isSelected) this.observerInst = this.observerInst || new MutationObserver(function() {
                    e.handler();
                }), this.observerInst.observe(this.el.node, {
                    attributes: !0
                });
                else try {
                    this.observerInst.disconnect(), delete this.observerInst;
                } catch  {}
            } else this.el.off("DOMAttrModified.select"), (this.rectSelection.isSelected || this.pointSelection.isSelected) && this.el.on("DOMAttrModified.select", function() {
                e.handler();
            });
        }, y.prototype.cleanup = function() {
            !this.rectSelection.isSelected && this.rectSelection.set && (this.rectSelection.set.each(function() {
                this.remove();
            }), this.rectSelection.set.clear(), delete this.rectSelection.set), !this.pointSelection.isSelected && this.pointSelection.set && (this.pointSelection.set.each(function() {
                this.remove();
            }), this.pointSelection.set.clear(), delete this.pointSelection.set), this.pointSelection.isSelected || this.rectSelection.isSelected || (this.nested.remove(), delete this.nested);
        }, SVG.extend(SVG.Element, {
            selectize: function(e, t) {
                return typeof e == "object" && (t = e, e = !0), (this.remember("_selectHandler") || new y(this)).init(e === void 0 || e, t || {}), this;
            }
        }), SVG.Element.prototype.selectize.defaults = {
            points: [
                "lt",
                "rt",
                "rb",
                "lb",
                "t",
                "r",
                "b",
                "l"
            ],
            pointsExclude: [],
            classRect: "svg_select_boundingRect",
            classPoints: "svg_select_points",
            pointSize: 7,
            rotationPoint: !0,
            deepSelect: !1,
            pointType: "circle"
        };
    }(), function() {
        (function() {
            function y(e) {
                e.remember("_resizeHandler", this), this.el = e, this.parameters = {}, this.lastUpdateCall = null, this.p = e.doc().node.createSVGPoint();
            }
            y.prototype.transformPoint = function(e, t, i) {
                return this.p.x = e - (this.offset.x - window.pageXOffset), this.p.y = t - (this.offset.y - window.pageYOffset), this.p.matrixTransform(i || this.m);
            }, y.prototype._extractPosition = function(e) {
                return {
                    x: e.clientX != null ? e.clientX : e.touches[0].clientX,
                    y: e.clientY != null ? e.clientY : e.touches[0].clientY
                };
            }, y.prototype.init = function(e) {
                var t = this;
                if (this.stop(), e !== "stop") {
                    for(var i in this.options = {}, this.el.resize.defaults)this.options[i] = this.el.resize.defaults[i], e[i] !== void 0 && (this.options[i] = e[i]);
                    this.el.on("lt.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("rt.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("rb.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("lb.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("t.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("r.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("b.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("l.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("rot.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("point.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.update();
                }
            }, y.prototype.stop = function() {
                return this.el.off("lt.resize"), this.el.off("rt.resize"), this.el.off("rb.resize"), this.el.off("lb.resize"), this.el.off("t.resize"), this.el.off("r.resize"), this.el.off("b.resize"), this.el.off("l.resize"), this.el.off("rot.resize"), this.el.off("point.resize"), this;
            }, y.prototype.resize = function(e) {
                var t = this;
                this.m = this.el.node.getScreenCTM().inverse(), this.offset = {
                    x: window.pageXOffset,
                    y: window.pageYOffset
                };
                var i = this._extractPosition(e.detail.event);
                if (this.parameters = {
                    type: this.el.type,
                    p: this.transformPoint(i.x, i.y),
                    x: e.detail.x,
                    y: e.detail.y,
                    box: this.el.bbox(),
                    rotation: this.el.transform().rotation
                }, this.el.type === "text" && (this.parameters.fontSize = this.el.attr()["font-size"]), e.detail.i !== void 0) {
                    var a = this.el.array().valueOf();
                    this.parameters.i = e.detail.i, this.parameters.pointCoords = [
                        a[e.detail.i][0],
                        a[e.detail.i][1]
                    ];
                }
                switch(e.type){
                    case "lt":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r);
                            if (this.parameters.box.width - n[0] > 0 && this.parameters.box.height - n[1] > 0) {
                                if (this.parameters.type === "text") return this.el.move(this.parameters.box.x + n[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - n[0]);
                                n = this.checkAspectRatio(n), this.el.move(this.parameters.box.x + n[0], this.parameters.box.y + n[1]).size(this.parameters.box.width - n[0], this.parameters.box.height - n[1]);
                            }
                        };
                        break;
                    case "rt":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 2);
                            if (this.parameters.box.width + n[0] > 0 && this.parameters.box.height - n[1] > 0) {
                                if (this.parameters.type === "text") return this.el.move(this.parameters.box.x - n[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + n[0]);
                                n = this.checkAspectRatio(n, !0), this.el.move(this.parameters.box.x, this.parameters.box.y + n[1]).size(this.parameters.box.width + n[0], this.parameters.box.height - n[1]);
                            }
                        };
                        break;
                    case "rb":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 0);
                            if (this.parameters.box.width + n[0] > 0 && this.parameters.box.height + n[1] > 0) {
                                if (this.parameters.type === "text") return this.el.move(this.parameters.box.x - n[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + n[0]);
                                n = this.checkAspectRatio(n), this.el.move(this.parameters.box.x, this.parameters.box.y).size(this.parameters.box.width + n[0], this.parameters.box.height + n[1]);
                            }
                        };
                        break;
                    case "lb":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 1);
                            if (this.parameters.box.width - n[0] > 0 && this.parameters.box.height + n[1] > 0) {
                                if (this.parameters.type === "text") return this.el.move(this.parameters.box.x + n[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - n[0]);
                                n = this.checkAspectRatio(n, !0), this.el.move(this.parameters.box.x + n[0], this.parameters.box.y).size(this.parameters.box.width - n[0], this.parameters.box.height + n[1]);
                            }
                        };
                        break;
                    case "t":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 2);
                            if (this.parameters.box.height - n[1] > 0) {
                                if (this.parameters.type === "text") return;
                                this.el.move(this.parameters.box.x, this.parameters.box.y + n[1]).height(this.parameters.box.height - n[1]);
                            }
                        };
                        break;
                    case "r":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 0);
                            if (this.parameters.box.width + n[0] > 0) {
                                if (this.parameters.type === "text") return;
                                this.el.move(this.parameters.box.x, this.parameters.box.y).width(this.parameters.box.width + n[0]);
                            }
                        };
                        break;
                    case "b":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 0);
                            if (this.parameters.box.height + n[1] > 0) {
                                if (this.parameters.type === "text") return;
                                this.el.move(this.parameters.box.x, this.parameters.box.y).height(this.parameters.box.height + n[1]);
                            }
                        };
                        break;
                    case "l":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 1);
                            if (this.parameters.box.width - n[0] > 0) {
                                if (this.parameters.type === "text") return;
                                this.el.move(this.parameters.box.x + n[0], this.parameters.box.y).width(this.parameters.box.width - n[0]);
                            }
                        };
                        break;
                    case "rot":
                        this.calc = function(s, r) {
                            var n = s + this.parameters.p.x, o = r + this.parameters.p.y, h = Math.atan2(this.parameters.p.y - this.parameters.box.y - this.parameters.box.height / 2, this.parameters.p.x - this.parameters.box.x - this.parameters.box.width / 2), c = Math.atan2(o - this.parameters.box.y - this.parameters.box.height / 2, n - this.parameters.box.x - this.parameters.box.width / 2), d = this.parameters.rotation + 180 * (c - h) / Math.PI + this.options.snapToAngle / 2;
                            this.el.center(this.parameters.box.cx, this.parameters.box.cy).rotate(d - d % this.options.snapToAngle, this.parameters.box.cx, this.parameters.box.cy);
                        };
                        break;
                    case "point":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, this.parameters.pointCoords[0], this.parameters.pointCoords[1]), o = this.el.array().valueOf();
                            o[this.parameters.i][0] = this.parameters.pointCoords[0] + n[0], o[this.parameters.i][1] = this.parameters.pointCoords[1] + n[1], this.el.plot(o);
                        };
                }
                this.el.fire("resizestart", {
                    dx: this.parameters.x,
                    dy: this.parameters.y,
                    event: e
                }), SVG.on(window, "touchmove.resize", function(s) {
                    t.update(s || window.event);
                }), SVG.on(window, "touchend.resize", function() {
                    t.done();
                }), SVG.on(window, "mousemove.resize", function(s) {
                    t.update(s || window.event);
                }), SVG.on(window, "mouseup.resize", function() {
                    t.done();
                });
            }, y.prototype.update = function(e) {
                if (e) {
                    var t = this._extractPosition(e), i = this.transformPoint(t.x, t.y), a = i.x - this.parameters.p.x, s = i.y - this.parameters.p.y;
                    this.lastUpdateCall = [
                        a,
                        s
                    ], this.calc(a, s), this.el.fire("resizing", {
                        dx: a,
                        dy: s,
                        event: e
                    });
                } else this.lastUpdateCall && this.calc(this.lastUpdateCall[0], this.lastUpdateCall[1]);
            }, y.prototype.done = function() {
                this.lastUpdateCall = null, SVG.off(window, "mousemove.resize"), SVG.off(window, "mouseup.resize"), SVG.off(window, "touchmove.resize"), SVG.off(window, "touchend.resize"), this.el.fire("resizedone");
            }, y.prototype.snapToGrid = function(e, t, i, a) {
                var s;
                return a !== void 0 ? s = [
                    (i + e) % this.options.snapToGrid,
                    (a + t) % this.options.snapToGrid
                ] : (i = i ?? 3, s = [
                    (this.parameters.box.x + e + (1 & i ? 0 : this.parameters.box.width)) % this.options.snapToGrid,
                    (this.parameters.box.y + t + (2 & i ? 0 : this.parameters.box.height)) % this.options.snapToGrid
                ]), e < 0 && (s[0] -= this.options.snapToGrid), t < 0 && (s[1] -= this.options.snapToGrid), e -= Math.abs(s[0]) < this.options.snapToGrid / 2 ? s[0] : s[0] - (e < 0 ? -this.options.snapToGrid : this.options.snapToGrid), t -= Math.abs(s[1]) < this.options.snapToGrid / 2 ? s[1] : s[1] - (t < 0 ? -this.options.snapToGrid : this.options.snapToGrid), this.constraintToBox(e, t, i, a);
            }, y.prototype.constraintToBox = function(e, t, i, a) {
                var s, r, n = this.options.constraint || {};
                return a !== void 0 ? (s = i, r = a) : (s = this.parameters.box.x + (1 & i ? 0 : this.parameters.box.width), r = this.parameters.box.y + (2 & i ? 0 : this.parameters.box.height)), n.minX !== void 0 && s + e < n.minX && (e = n.minX - s), n.maxX !== void 0 && s + e > n.maxX && (e = n.maxX - s), n.minY !== void 0 && r + t < n.minY && (t = n.minY - r), n.maxY !== void 0 && r + t > n.maxY && (t = n.maxY - r), [
                    e,
                    t
                ];
            }, y.prototype.checkAspectRatio = function(e, t) {
                if (!this.options.saveAspectRatio) return e;
                var i = e.slice(), a = this.parameters.box.width / this.parameters.box.height, s = this.parameters.box.width + e[0], r = this.parameters.box.height - e[1], n = s / r;
                return n < a ? (i[1] = s / a - this.parameters.box.height, t && (i[1] = -i[1])) : n > a && (i[0] = this.parameters.box.width - r * a, t && (i[0] = -i[0])), i;
            }, SVG.extend(SVG.Element, {
                resize: function(e) {
                    return (this.remember("_resizeHandler") || new y(this)).init(e || {}), this;
                }
            }), SVG.Element.prototype.resize.defaults = {
                snapToAngle: 0.1,
                snapToGrid: 1,
                constraint: {},
                saveAspectRatio: !1
            };
        }).call(this);
    }(), window.Apex === void 0 && (window.Apex = {});
    var ht = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "initModules",
                value: function() {
                    this.ctx.publicMethods = [
                        "updateOptions",
                        "updateSeries",
                        "appendData",
                        "appendSeries",
                        "isSeriesHidden",
                        "toggleSeries",
                        "showSeries",
                        "hideSeries",
                        "setLocale",
                        "resetSeries",
                        "zoomX",
                        "toggleDataPointSelection",
                        "dataURI",
                        "exportToCSV",
                        "addXaxisAnnotation",
                        "addYaxisAnnotation",
                        "addPointAnnotation",
                        "clearAnnotations",
                        "removeAnnotation",
                        "paper",
                        "destroy"
                    ], this.ctx.eventList = [
                        "click",
                        "mousedown",
                        "mousemove",
                        "mouseleave",
                        "touchstart",
                        "touchmove",
                        "touchleave",
                        "mouseup",
                        "touchend"
                    ], this.ctx.animations = new de(this.ctx), this.ctx.axes = new mt(this.ctx), this.ctx.core = new Gt(this.ctx.el, this.ctx), this.ctx.config = new Le({}), this.ctx.data = new Je(this.ctx), this.ctx.grid = new Qe(this.ctx), this.ctx.graphics = new M(this.ctx), this.ctx.coreUtils = new q(this.ctx), this.ctx.crosshairs = new We(this.ctx), this.ctx.events = new xt(this.ctx), this.ctx.exports = new Ee(this.ctx), this.ctx.localization = new bt(this.ctx), this.ctx.options = new G(), this.ctx.responsive = new vt(this.ctx), this.ctx.series = new te(this.ctx), this.ctx.theme = new yt(this.ctx), this.ctx.formatters = new re(this.ctx), this.ctx.titleSubtitle = new wt(this.ctx), this.ctx.legend = new Ke(this.ctx), this.ctx.toolbar = new et(this.ctx), this.ctx.tooltip = new at(this.ctx), this.ctx.dimensions = new Ye(this.ctx), this.ctx.updateHelpers = new Vt(this.ctx), this.ctx.zoomPanSelection = new Pt(this.ctx), this.ctx.w.globals.tooltip = new at(this.ctx);
                }
            }
        ]), y;
    }(), ct = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "clear",
                value: function(e) {
                    var t = e.isUpdating;
                    this.ctx.zoomPanSelection && this.ctx.zoomPanSelection.destroy(), this.ctx.toolbar && this.ctx.toolbar.destroy(), this.ctx.animations = null, this.ctx.axes = null, this.ctx.annotations = null, this.ctx.core = null, this.ctx.data = null, this.ctx.grid = null, this.ctx.series = null, this.ctx.responsive = null, this.ctx.theme = null, this.ctx.formatters = null, this.ctx.titleSubtitle = null, this.ctx.legend = null, this.ctx.dimensions = null, this.ctx.options = null, this.ctx.crosshairs = null, this.ctx.zoomPanSelection = null, this.ctx.updateHelpers = null, this.ctx.toolbar = null, this.ctx.localization = null, this.ctx.w.globals.tooltip = null, this.clearDomElements({
                        isUpdating: t
                    });
                }
            },
            {
                key: "killSVG",
                value: function(e) {
                    e.each(function(t, i) {
                        this.removeClass("*"), this.off(), this.stop();
                    }, !0), e.ungroup(), e.clear();
                }
            },
            {
                key: "clearDomElements",
                value: function(e) {
                    var t = this, i = e.isUpdating, a = this.w.globals.dom.Paper.node;
                    a.parentNode && a.parentNode.parentNode && !i && (a.parentNode.parentNode.style.minHeight = "unset");
                    var s = this.w.globals.dom.baseEl;
                    s && this.ctx.eventList.forEach(function(n) {
                        s.removeEventListener(n, t.ctx.events.documentEvent);
                    });
                    var r = this.w.globals.dom;
                    if (this.ctx.el !== null) for(; this.ctx.el.firstChild;)this.ctx.el.removeChild(this.ctx.el.firstChild);
                    this.killSVG(r.Paper), r.Paper.remove(), r.elWrap = null, r.elGraphical = null, r.elLegendWrap = null, r.elLegendForeign = null, r.baseEl = null, r.elGridRect = null, r.elGridRectMask = null, r.elGridRectMarkerMask = null, r.elForecastMask = null, r.elNonForecastMask = null, r.elDefs = null;
                }
            }
        ]), y;
    }(), _e = /* @__PURE__ */ new WeakMap(), jt = function() {
        function y(e, t) {
            F(this, y), this.opts = t, this.ctx = this, this.w = new ft(t).init(), this.el = e, this.w.globals.cuid = P.randomId(), this.w.globals.chartID = this.w.config.chart.id ? P.escapeString(this.w.config.chart.id) : this.w.globals.cuid, new ht(this).initModules(), this.create = P.bind(this.create, this), this.windowResizeHandler = this._windowResizeHandler.bind(this), this.parentResizeHandler = this._parentResizeCallback.bind(this);
        }
        return Y(y, [
            {
                key: "render",
                value: function() {
                    var e = this;
                    return new Promise(function(t, i) {
                        if (e.el !== null) {
                            Apex._chartInstances === void 0 && (Apex._chartInstances = []), e.w.config.chart.id && Apex._chartInstances.push({
                                id: e.w.globals.chartID,
                                group: e.w.config.chart.group,
                                chart: e
                            }), e.setLocale(e.w.config.chart.defaultLocale);
                            var a = e.w.config.chart.events.beforeMount;
                            if (typeof a == "function" && a(e, e.w), e.events.fireEvent("beforeMount", [
                                e,
                                e.w
                            ]), window.addEventListener("resize", e.windowResizeHandler), function(g, p) {
                                var f = !1;
                                if (g.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
                                    var b = g.getBoundingClientRect();
                                    g.style.display !== "none" && b.width !== 0 || (f = !0);
                                }
                                var m = new ResizeObserver(function(w) {
                                    f && p.call(g, w), f = !0;
                                });
                                g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Array.from(g.children).forEach(function(w) {
                                    return m.observe(w);
                                }) : m.observe(g), _e.set(p, m);
                            }(e.el.parentNode, e.parentResizeHandler), !e.css) {
                                var s = e.el.getRootNode && e.el.getRootNode(), r = P.is("ShadowRoot", s), n = e.el.ownerDocument, o = n.getElementById("apexcharts-css");
                                if (r || !o) {
                                    var h;
                                    e.css = document.createElement("style"), e.css.id = "apexcharts-css", e.css.textContent = `@keyframes opaque {
  0% {
      opacity: 0
  }

  to {
      opacity: 1
  }
}

@keyframes resizeanim {
  0%,to {
      opacity: 0
  }
}

.apexcharts-canvas {
  position: relative;
  user-select: none
}

.apexcharts-canvas ::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px
}

.apexcharts-canvas ::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0,0,0,.5);
  box-shadow: 0 0 1px rgba(255,255,255,.5);
  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5)
}

.apexcharts-inner {
  position: relative
}

.apexcharts-text tspan {
  font-family: inherit
}

.legend-mouseover-inactive {
  transition: .15s ease all;
  opacity: .2
}

.apexcharts-legend-text {
  padding-left: 15px;
  margin-left: -15px;
}

.apexcharts-series-collapsed {
  opacity: 0
}

.apexcharts-tooltip {
  border-radius: 5px;
  box-shadow: 2px 2px 6px -4px #999;
  cursor: default;
  font-size: 14px;
  left: 62px;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
  z-index: 12;
  transition: .15s ease all
}

.apexcharts-tooltip.apexcharts-active {
  opacity: 1;
  transition: .15s ease all
}

.apexcharts-tooltip.apexcharts-theme-light {
  border: 1px solid #e3e3e3;
  background: rgba(255,255,255,.96)
}

.apexcharts-tooltip.apexcharts-theme-dark {
  color: #fff;
  background: rgba(30,30,30,.8)
}

.apexcharts-tooltip * {
  font-family: inherit
}

.apexcharts-tooltip-title {
  padding: 6px;
  font-size: 15px;
  margin-bottom: 4px
}

.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
  background: #eceff1;
  border-bottom: 1px solid #ddd
}

.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {
  background: rgba(0,0,0,.7);
  border-bottom: 1px solid #333
}

.apexcharts-tooltip-text-goals-value,.apexcharts-tooltip-text-y-value,.apexcharts-tooltip-text-z-value {
  display: inline-block;
  margin-left: 5px;
  font-weight: 600
}

.apexcharts-tooltip-text-goals-label:empty,.apexcharts-tooltip-text-goals-value:empty,.apexcharts-tooltip-text-y-label:empty,.apexcharts-tooltip-text-y-value:empty,.apexcharts-tooltip-text-z-value:empty,.apexcharts-tooltip-title:empty {
  display: none
}

.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {
  padding: 6px 0 5px
}

.apexcharts-tooltip-goals-group,.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {
  display: flex
}

.apexcharts-tooltip-text-goals-label:not(:empty),.apexcharts-tooltip-text-goals-value:not(:empty) {
  margin-top: -6px
}

.apexcharts-tooltip-marker {
  width: 12px;
  height: 12px;
  position: relative;
  top: 0;
  margin-right: 10px;
  border-radius: 50%
}

.apexcharts-tooltip-series-group {
  padding: 0 10px;
  display: none;
  text-align: left;
  justify-content: left;
  align-items: center
}

.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {
  opacity: 1
}

.apexcharts-tooltip-series-group.apexcharts-active,.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 4px
}

.apexcharts-tooltip-series-group-hidden {
  opacity: 0;
  height: 0;
  line-height: 0;
  padding: 0!important
}

.apexcharts-tooltip-y-group {
  padding: 6px 0 5px
}

.apexcharts-custom-tooltip,.apexcharts-tooltip-box {
  padding: 4px 8px
}

.apexcharts-tooltip-boxPlot {
  display: flex;
  flex-direction: column-reverse
}

.apexcharts-tooltip-box>div {
  margin: 4px 0
}

.apexcharts-tooltip-box span.value {
  font-weight: 700
}

.apexcharts-tooltip-rangebar {
  padding: 5px 8px
}

.apexcharts-tooltip-rangebar .category {
  font-weight: 600;
  color: #777
}

.apexcharts-tooltip-rangebar .series-name {
  font-weight: 700;
  display: block;
  margin-bottom: 5px
}

.apexcharts-xaxistooltip,.apexcharts-yaxistooltip {
  opacity: 0;
  pointer-events: none;
  color: #373d3f;
  font-size: 13px;
  text-align: center;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
  background: #eceff1;
  border: 1px solid #90a4ae
}

.apexcharts-xaxistooltip {
  padding: 9px 10px;
  transition: .15s ease all
}

.apexcharts-xaxistooltip.apexcharts-theme-dark {
  background: rgba(0,0,0,.7);
  border: 1px solid rgba(0,0,0,.5);
  color: #fff
}

.apexcharts-xaxistooltip:after,.apexcharts-xaxistooltip:before {
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none
}

.apexcharts-xaxistooltip:after {
  border-color: transparent;
  border-width: 6px;
  margin-left: -6px
}

.apexcharts-xaxistooltip:before {
  border-color: transparent;
  border-width: 7px;
  margin-left: -7px
}

.apexcharts-xaxistooltip-bottom:after,.apexcharts-xaxistooltip-bottom:before {
  bottom: 100%
}

.apexcharts-xaxistooltip-top:after,.apexcharts-xaxistooltip-top:before {
  top: 100%
}

.apexcharts-xaxistooltip-bottom:after {
  border-bottom-color: #eceff1
}

.apexcharts-xaxistooltip-bottom:before {
  border-bottom-color: #90a4ae
}

.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {
  border-bottom-color: rgba(0,0,0,.5)
}

.apexcharts-xaxistooltip-top:after {
  border-top-color: #eceff1
}

.apexcharts-xaxistooltip-top:before {
  border-top-color: #90a4ae
}

.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {
  border-top-color: rgba(0,0,0,.5)
}

.apexcharts-xaxistooltip.apexcharts-active {
  opacity: 1;
  transition: .15s ease all
}

.apexcharts-yaxistooltip {
  padding: 4px 10px
}

.apexcharts-yaxistooltip.apexcharts-theme-dark {
  background: rgba(0,0,0,.7);
  border: 1px solid rgba(0,0,0,.5);
  color: #fff
}

.apexcharts-yaxistooltip:after,.apexcharts-yaxistooltip:before {
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none
}

.apexcharts-yaxistooltip:after {
  border-color: transparent;
  border-width: 6px;
  margin-top: -6px
}

.apexcharts-yaxistooltip:before {
  border-color: transparent;
  border-width: 7px;
  margin-top: -7px
}

.apexcharts-yaxistooltip-left:after,.apexcharts-yaxistooltip-left:before {
  left: 100%
}

.apexcharts-yaxistooltip-right:after,.apexcharts-yaxistooltip-right:before {
  right: 100%
}

.apexcharts-yaxistooltip-left:after {
  border-left-color: #eceff1
}

.apexcharts-yaxistooltip-left:before {
  border-left-color: #90a4ae
}

.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {
  border-left-color: rgba(0,0,0,.5)
}

.apexcharts-yaxistooltip-right:after {
  border-right-color: #eceff1
}

.apexcharts-yaxistooltip-right:before {
  border-right-color: #90a4ae
}

.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {
  border-right-color: rgba(0,0,0,.5)
}

.apexcharts-yaxistooltip.apexcharts-active {
  opacity: 1
}

.apexcharts-yaxistooltip-hidden {
  display: none
}

.apexcharts-xcrosshairs,.apexcharts-ycrosshairs {
  pointer-events: none;
  opacity: 0;
  transition: .15s ease all
}

.apexcharts-xcrosshairs.apexcharts-active,.apexcharts-ycrosshairs.apexcharts-active {
  opacity: 1;
  transition: .15s ease all
}

.apexcharts-ycrosshairs-hidden {
  opacity: 0
}

.apexcharts-selection-rect {
  cursor: move
}

.svg_select_boundingRect,.svg_select_points_rot {
  pointer-events: none;
  opacity: 0;
  visibility: hidden
}

.apexcharts-selection-rect+g .svg_select_boundingRect,.apexcharts-selection-rect+g .svg_select_points_rot {
  opacity: 0;
  visibility: hidden
}

.apexcharts-selection-rect+g .svg_select_points_l,.apexcharts-selection-rect+g .svg_select_points_r {
  cursor: ew-resize;
  opacity: 1;
  visibility: visible
}

.svg_select_points {
  fill: #efefef;
  stroke: #333;
  rx: 2
}

.apexcharts-svg.apexcharts-zoomable.hovering-zoom {
  cursor: crosshair
}

.apexcharts-svg.apexcharts-zoomable.hovering-pan {
  cursor: move
}

.apexcharts-menu-icon,.apexcharts-pan-icon,.apexcharts-reset-icon,.apexcharts-selection-icon,.apexcharts-toolbar-custom-icon,.apexcharts-zoom-icon,.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {
  cursor: pointer;
  width: 20px;
  height: 20px;
  line-height: 24px;
  color: #6e8192;
  text-align: center
}

.apexcharts-menu-icon svg,.apexcharts-reset-icon svg,.apexcharts-zoom-icon svg,.apexcharts-zoomin-icon svg,.apexcharts-zoomout-icon svg {
  fill: #6e8192
}

.apexcharts-selection-icon svg {
  fill: #444;
  transform: scale(.76)
}

.apexcharts-theme-dark .apexcharts-menu-icon svg,.apexcharts-theme-dark .apexcharts-pan-icon svg,.apexcharts-theme-dark .apexcharts-reset-icon svg,.apexcharts-theme-dark .apexcharts-selection-icon svg,.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg,.apexcharts-theme-dark .apexcharts-zoom-icon svg,.apexcharts-theme-dark .apexcharts-zoomin-icon svg,.apexcharts-theme-dark .apexcharts-zoomout-icon svg {
  fill: #f3f4f5
}

.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg {
  fill: #008ffb
}

.apexcharts-theme-light .apexcharts-menu-icon:hover svg,.apexcharts-theme-light .apexcharts-reset-icon:hover svg,.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg {
  fill: #333
}

.apexcharts-menu-icon,.apexcharts-selection-icon {
  position: relative
}

.apexcharts-reset-icon {
  margin-left: 5px
}

.apexcharts-menu-icon,.apexcharts-reset-icon,.apexcharts-zoom-icon {
  transform: scale(.85)
}

.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {
  transform: scale(.7)
}

.apexcharts-zoomout-icon {
  margin-right: 3px
}

.apexcharts-pan-icon {
  transform: scale(.62);
  position: relative;
  left: 1px;
  top: 0
}

.apexcharts-pan-icon svg {
  fill: #fff;
  stroke: #6e8192;
  stroke-width: 2
}

.apexcharts-pan-icon.apexcharts-selected svg {
  stroke: #008ffb
}

.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {
  stroke: #333
}

.apexcharts-toolbar {
  position: absolute;
  z-index: 11;
  max-width: 176px;
  text-align: right;
  border-radius: 3px;
  padding: 0 6px 2px;
  display: flex;
  justify-content: space-between;
  align-items: center
}

.apexcharts-menu {
  background: #fff;
  position: absolute;
  top: 100%;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 3px;
  right: 10px;
  opacity: 0;
  min-width: 110px;
  transition: .15s ease all;
  pointer-events: none
}

.apexcharts-menu.apexcharts-menu-open {
  opacity: 1;
  pointer-events: all;
  transition: .15s ease all
}

.apexcharts-menu-item {
  padding: 6px 7px;
  font-size: 12px;
  cursor: pointer
}

.apexcharts-theme-light .apexcharts-menu-item:hover {
  background: #eee
}

.apexcharts-theme-dark .apexcharts-menu {
  background: rgba(0,0,0,.7);
  color: #fff
}

@media screen and (min-width:768px) {
  .apexcharts-canvas:hover .apexcharts-toolbar {
      opacity: 1
  }
}

.apexcharts-canvas .apexcharts-element-hidden,.apexcharts-datalabel.apexcharts-element-hidden,.apexcharts-hide .apexcharts-series-points {
  opacity: 0
}

.apexcharts-hidden-element-shown {
  opacity: 1;
  transition: 0.25s ease all;
}
.apexcharts-datalabel,.apexcharts-datalabel-label,.apexcharts-datalabel-value,.apexcharts-datalabels,.apexcharts-pie-label {
  cursor: default;
  pointer-events: none
}

.apexcharts-pie-label-delay {
  opacity: 0;
  animation-name: opaque;
  animation-duration: .3s;
  animation-fill-mode: forwards;
  animation-timing-function: ease
}

.apexcharts-radialbar-label {
  cursor: pointer;
}

.apexcharts-annotation-rect,.apexcharts-area-series .apexcharts-area,.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-gridline,.apexcharts-line,.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-point-annotation-label,.apexcharts-radar-series path,.apexcharts-radar-series polygon,.apexcharts-toolbar svg,.apexcharts-tooltip .apexcharts-marker,.apexcharts-xaxis-annotation-label,.apexcharts-yaxis-annotation-label,.apexcharts-zoom-rect {
  pointer-events: none
}

.apexcharts-marker {
  transition: .15s ease all
}

.resize-triggers {
  animation: 1ms resizeanim;
  visibility: hidden;
  opacity: 0;
  height: 100%;
  width: 100%;
  overflow: hidden
}

.contract-trigger:before,.resize-triggers,.resize-triggers>div {
  content: " ";
  display: block;
  position: absolute;
  top: 0;
  left: 0
}

.resize-triggers>div {
  height: 100%;
  width: 100%;
  background: #eee;
  overflow: auto
}

.contract-trigger:before {
  overflow: hidden;
  width: 200%;
  height: 200%
}

.apexcharts-bar-goals-markers{
  pointer-events: none
}

.apexcharts-bar-shadows{
  pointer-events: none
}

.apexcharts-rangebar-goals-markers{
  pointer-events: none
}`;
                                    var c = ((h = e.opts.chart) === null || h === void 0 ? void 0 : h.nonce) || e.w.config.chart.nonce;
                                    c && e.css.setAttribute("nonce", c), r ? s.prepend(e.css) : n.head.appendChild(e.css);
                                }
                            }
                            var d = e.create(e.w.config.series, {});
                            if (!d) return t(e);
                            e.mount(d).then(function() {
                                typeof e.w.config.chart.events.mounted == "function" && e.w.config.chart.events.mounted(e, e.w), e.events.fireEvent("mounted", [
                                    e,
                                    e.w
                                ]), t(d);
                            }).catch(function(g) {
                                i(g);
                            });
                        } else i(new Error("Element not found"));
                    });
                }
            },
            {
                key: "create",
                value: function(e, t) {
                    var i = this.w;
                    new ht(this).initModules();
                    var a = this.w.globals;
                    if (a.noData = !1, a.animationEnded = !1, this.responsive.checkResponsiveConfig(t), i.config.xaxis.convertedCatToNumeric && new oe(i.config).convertCatToNumericXaxis(i.config, this.ctx), this.el === null || (this.core.setupElements(), i.config.chart.type === "treemap" && (i.config.grid.show = !1, i.config.yaxis[0].show = !1), a.svgWidth === 0)) return a.animationEnded = !0, null;
                    var s = q.checkComboSeries(e);
                    a.comboCharts = s.comboCharts, a.comboBarCount = s.comboBarCount;
                    var r = e.every(function(c) {
                        return c.data && c.data.length === 0;
                    });
                    (e.length === 0 || r) && this.series.handleNoData(), this.events.setupEventHandlers(), this.data.parseData(e), this.theme.init(), new Pe(this).setGlobalMarkerSize(), this.formatters.setLabelFormatters(), this.titleSubtitle.draw(), a.noData && a.collapsedSeries.length !== a.series.length && !i.config.legend.showForSingleSeries || this.legend.init(), this.series.hasAllSeriesEqualX(), a.axisCharts && (this.core.coreCalculations(), i.config.xaxis.type !== "category" && this.formatters.setLabelFormatters(), this.ctx.toolbar.minX = i.globals.minX, this.ctx.toolbar.maxX = i.globals.maxX), this.formatters.heatmapLabelFormatters(), new q(this).getLargestMarkerSize(), this.dimensions.plotCoords();
                    var n = this.core.xySettings();
                    this.grid.createGridMask();
                    var o = this.core.plotChartType(e, n), h = new ye(this);
                    return h.bringForward(), i.config.dataLabels.background.enabled && h.dataLabelsBackground(), this.core.shiftGraphPosition(), {
                        elGraph: o,
                        xyRatios: n,
                        dimensions: {
                            plot: {
                                left: i.globals.translateX,
                                top: i.globals.translateY,
                                width: i.globals.gridWidth,
                                height: i.globals.gridHeight
                            }
                        }
                    };
                }
            },
            {
                key: "mount",
                value: function() {
                    var e = this, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, i = this, a = i.w;
                    return new Promise(function(s, r) {
                        if (i.el === null) return r(new Error("Not enough data to display or target element not found"));
                        (t === null || a.globals.allSeriesCollapsed) && i.series.handleNoData(), i.grid = new Qe(i);
                        var n, o, h = i.grid.drawGrid();
                        if (i.annotations = new ie(i), i.annotations.drawImageAnnos(), i.annotations.drawTextAnnos(), a.config.grid.position === "back" && (h && a.globals.dom.elGraphical.add(h.el), h != null && (n = h.elGridBorders) !== null && n !== void 0 && n.node && a.globals.dom.elGraphical.add(h.elGridBorders)), Array.isArray(t.elGraph)) for(var c = 0; c < t.elGraph.length; c++)a.globals.dom.elGraphical.add(t.elGraph[c]);
                        else a.globals.dom.elGraphical.add(t.elGraph);
                        a.config.grid.position === "front" && (h && a.globals.dom.elGraphical.add(h.el), h != null && (o = h.elGridBorders) !== null && o !== void 0 && o.node && a.globals.dom.elGraphical.add(h.elGridBorders)), a.config.xaxis.crosshairs.position === "front" && i.crosshairs.drawXCrosshairs(), a.config.yaxis[0].crosshairs.position === "front" && i.crosshairs.drawYCrosshairs(), a.config.chart.type !== "treemap" && i.axes.drawAxis(a.config.chart.type, h);
                        var d = new Ie(e.ctx, h), g = new Ne(e.ctx, h);
                        if (h !== null && (d.xAxisLabelCorrections(h.xAxisTickWidth), g.setYAxisTextAlignments(), a.config.yaxis.map(function(f, b) {
                            a.globals.ignoreYAxisIndexes.indexOf(b) === -1 && g.yAxisTitleRotate(b, f.opposite);
                        })), i.annotations.drawAxesAnnotations(), !a.globals.noData) {
                            if (a.config.tooltip.enabled && !a.globals.noData && i.w.globals.tooltip.drawTooltip(t.xyRatios), a.globals.axisCharts && (a.globals.isXNumeric || a.config.xaxis.convertedCatToNumeric || a.globals.isRangeBar)) (a.config.chart.zoom.enabled || a.config.chart.selection && a.config.chart.selection.enabled || a.config.chart.pan && a.config.chart.pan.enabled) && i.zoomPanSelection.init({
                                xyRatios: t.xyRatios
                            });
                            else {
                                var p = a.config.chart.toolbar.tools;
                                [
                                    "zoom",
                                    "zoomin",
                                    "zoomout",
                                    "selection",
                                    "pan",
                                    "reset"
                                ].forEach(function(f) {
                                    p[f] = !1;
                                });
                            }
                            a.config.chart.toolbar.show && !a.globals.allSeriesCollapsed && i.toolbar.createToolbar();
                        }
                        a.globals.memory.methodsToExec.length > 0 && a.globals.memory.methodsToExec.forEach(function(f) {
                            f.method(f.params, !1, f.context);
                        }), a.globals.axisCharts || a.globals.noData || i.core.resizeNonAxisCharts(), s(i);
                    });
                }
            },
            {
                key: "destroy",
                value: function() {
                    var e, t;
                    window.removeEventListener("resize", this.windowResizeHandler), this.el.parentNode, e = this.parentResizeHandler, (t = _e.get(e)) && (t.disconnect(), _e.delete(e));
                    var i = this.w.config.chart.id;
                    i && Apex._chartInstances.forEach(function(a, s) {
                        a.id === P.escapeString(i) && Apex._chartInstances.splice(s, 1);
                    }), new ct(this.ctx).clear({
                        isUpdating: !1
                    });
                }
            },
            {
                key: "updateOptions",
                value: function(e) {
                    var t = this, i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], a = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], s = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], r = !(arguments.length > 4 && arguments[4] !== void 0) || arguments[4], n = this.w;
                    return n.globals.selection = void 0, e.series && (this.series.resetSeries(!1, !0, !1), e.series.length && e.series[0].data && (e.series = e.series.map(function(o, h) {
                        return t.updateHelpers._extendSeries(o, h);
                    })), this.updateHelpers.revertDefaultAxisMinMax()), e.xaxis && (e = this.updateHelpers.forceXAxisUpdate(e)), e.yaxis && (e = this.updateHelpers.forceYAxisUpdate(e)), n.globals.collapsedSeriesIndices.length > 0 && this.series.clearPreviousPaths(), e.theme && (e = this.theme.updateThemeOptions(e)), this.updateHelpers._updateOptions(e, i, a, s, r);
                }
            },
            {
                key: "updateSeries",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2];
                    return this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(e, t, i);
                }
            },
            {
                key: "appendSeries",
                value: function(e) {
                    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], a = this.w.config.series.slice();
                    return a.push(e), this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(a, t, i);
                }
            },
            {
                key: "appendData",
                value: function(e) {
                    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = this;
                    i.w.globals.dataChanged = !0, i.series.getPreviousPaths();
                    for(var a = i.w.config.series.slice(), s = 0; s < a.length; s++)if (e[s] !== null && e[s] !== void 0) for(var r = 0; r < e[s].data.length; r++)a[s].data.push(e[s].data[r]);
                    return i.w.config.series = a, t && (i.w.globals.initialSeries = P.clone(i.w.config.series)), this.update();
                }
            },
            {
                key: "update",
                value: function(e) {
                    var t = this;
                    return new Promise(function(i, a) {
                        new ct(t.ctx).clear({
                            isUpdating: !0
                        });
                        var s = t.create(t.w.config.series, e);
                        if (!s) return i(t);
                        t.mount(s).then(function() {
                            typeof t.w.config.chart.events.updated == "function" && t.w.config.chart.events.updated(t, t.w), t.events.fireEvent("updated", [
                                t,
                                t.w
                            ]), t.w.globals.isDirty = !0, i(t);
                        }).catch(function(r) {
                            a(r);
                        });
                    });
                }
            },
            {
                key: "getSyncedCharts",
                value: function() {
                    var e = this.getGroupedCharts(), t = [
                        this
                    ];
                    return e.length && (t = [], e.forEach(function(i) {
                        t.push(i);
                    })), t;
                }
            },
            {
                key: "getGroupedCharts",
                value: function() {
                    var e = this;
                    return Apex._chartInstances.filter(function(t) {
                        if (t.group) return !0;
                    }).map(function(t) {
                        return e.w.config.chart.group === t.group ? t.chart : e;
                    });
                }
            },
            {
                key: "toggleSeries",
                value: function(e) {
                    return this.series.toggleSeries(e);
                }
            },
            {
                key: "highlightSeriesOnLegendHover",
                value: function(e, t) {
                    return this.series.toggleSeriesOnHover(e, t);
                }
            },
            {
                key: "showSeries",
                value: function(e) {
                    this.series.showSeries(e);
                }
            },
            {
                key: "hideSeries",
                value: function(e) {
                    this.series.hideSeries(e);
                }
            },
            {
                key: "isSeriesHidden",
                value: function(e) {
                    this.series.isSeriesHidden(e);
                }
            },
            {
                key: "resetSeries",
                value: function() {
                    var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0], t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
                    this.series.resetSeries(e, t);
                }
            },
            {
                key: "addEventListener",
                value: function(e, t) {
                    this.events.addEventListener(e, t);
                }
            },
            {
                key: "removeEventListener",
                value: function(e, t) {
                    this.events.removeEventListener(e, t);
                }
            },
            {
                key: "addXaxisAnnotation",
                value: function(e) {
                    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, a = this;
                    i && (a = i), a.annotations.addXaxisAnnotationExternal(e, t, a);
                }
            },
            {
                key: "addYaxisAnnotation",
                value: function(e) {
                    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, a = this;
                    i && (a = i), a.annotations.addYaxisAnnotationExternal(e, t, a);
                }
            },
            {
                key: "addPointAnnotation",
                value: function(e) {
                    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, a = this;
                    i && (a = i), a.annotations.addPointAnnotationExternal(e, t, a);
                }
            },
            {
                key: "clearAnnotations",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0, t = this;
                    e && (t = e), t.annotations.clearAnnotations(t);
                }
            },
            {
                key: "removeAnnotation",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, i = this;
                    t && (i = t), i.annotations.removeAnnotation(i, e);
                }
            },
            {
                key: "getChartArea",
                value: function() {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner");
                }
            },
            {
                key: "getSeriesTotalXRange",
                value: function(e, t) {
                    return this.coreUtils.getSeriesTotalsXRange(e, t);
                }
            },
            {
                key: "getHighestValueInSeries",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                    return new De(this.ctx).getMinYMaxY(e).highestY;
                }
            },
            {
                key: "getLowestValueInSeries",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                    return new De(this.ctx).getMinYMaxY(e).lowestY;
                }
            },
            {
                key: "getSeriesTotal",
                value: function() {
                    return this.w.globals.seriesTotals;
                }
            },
            {
                key: "toggleDataPointSelection",
                value: function(e, t) {
                    return this.updateHelpers.toggleDataPointSelection(e, t);
                }
            },
            {
                key: "zoomX",
                value: function(e, t) {
                    this.ctx.toolbar.zoomUpdateOptions(e, t);
                }
            },
            {
                key: "setLocale",
                value: function(e) {
                    this.localization.setCurrentLocaleValues(e);
                }
            },
            {
                key: "dataURI",
                value: function(e) {
                    return new Ee(this.ctx).dataURI(e);
                }
            },
            {
                key: "exportToCSV",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    return new Ee(this.ctx).exportToCSV(e);
                }
            },
            {
                key: "paper",
                value: function() {
                    return this.w.globals.dom.Paper;
                }
            },
            {
                key: "_parentResizeCallback",
                value: function() {
                    this.w.globals.animationEnded && this.w.config.chart.redrawOnParentResize && this._windowResize();
                }
            },
            {
                key: "_windowResize",
                value: function() {
                    var e = this;
                    clearTimeout(this.w.globals.resizeTimer), this.w.globals.resizeTimer = window.setTimeout(function() {
                        e.w.globals.resized = !0, e.w.globals.dataChanged = !1, e.ctx.update();
                    }, 150);
                }
            },
            {
                key: "_windowResizeHandler",
                value: function() {
                    var e = this.w.config.chart.redrawOnWindowResize;
                    typeof e == "function" && (e = e()), e && this._windowResize();
                }
            }
        ], [
            {
                key: "getChartByID",
                value: function(e) {
                    var t = P.escapeString(e);
                    if (Apex._chartInstances) {
                        var i = Apex._chartInstances.filter(function(a) {
                            return a.id === t;
                        })[0];
                        return i && i.chart;
                    }
                }
            },
            {
                key: "initOnLoad",
                value: function() {
                    for(var e = document.querySelectorAll("[data-apexcharts]"), t = 0; t < e.length; t++)new y(e[t], JSON.parse(e[t].getAttribute("data-options"))).render();
                }
            },
            {
                key: "exec",
                value: function(e, t) {
                    var i = this.getChartByID(e);
                    if (i) {
                        i.w.globals.isExecCalled = !0;
                        var a = null;
                        if (i.publicMethods.indexOf(t) !== -1) {
                            for(var s = arguments.length, r = new Array(s > 2 ? s - 2 : 0), n = 2; n < s; n++)r[n - 2] = arguments[n];
                            a = i[t].apply(i, r);
                        }
                        return a;
                    }
                }
            },
            {
                key: "merge",
                value: function(e, t) {
                    return P.extend(e, t);
                }
            }
        ]), y;
    }();
    _.exports = jt;
})($a0ff767aa05ebc8a$var$Ue, $a0ff767aa05ebc8a$var$Ue.exports);
var $a0ff767aa05ebc8a$var$ti = $a0ff767aa05ebc8a$var$Ue.exports;
const $a0ff767aa05ebc8a$var$ut = /* @__PURE__ */ $a0ff767aa05ebc8a$var$ei($a0ff767aa05ebc8a$var$ti), $a0ff767aa05ebc8a$var$pt = [
    "animationEnd",
    "beforeMount",
    "mounted",
    "updated",
    "click",
    "mouseMove",
    "mouseLeave",
    "legendClick",
    "markerClick",
    "selection",
    "dataPointSelection",
    "dataPointMouseEnter",
    "dataPointMouseLeave",
    "beforeZoom",
    "beforeResetZoom",
    "zoomed",
    "scrolled",
    "brushScrolled"
], $a0ff767aa05ebc8a$export$2e2bcd8739ae039 = (0, $TusQn.defineComponent)({
    name: "apexchart",
    props: {
        options: {
            type: Object
        },
        type: {
            type: String
        },
        series: {
            type: Array,
            required: !0
        },
        width: {
            default: "100%"
        },
        height: {
            default: "auto"
        }
    },
    // events emitted by this component
    emits: $a0ff767aa05ebc8a$var$pt,
    setup (_, { emit: Re }) {
        const Ae = (0, $01W3b.ref)(null), X = (0, $01W3b.ref)(null), U = (H)=>H && typeof H == "object" && !Array.isArray(H) && H != null, F = (H, G)=>{
            typeof Object.assign != "function" && function() {
                Object.assign = function(B) {
                    if (B == null) throw new TypeError("Cannot convert undefined or null to object");
                    let re = Object(B);
                    for(let fe = 1; fe < arguments.length; fe++){
                        let ne = arguments[fe];
                        if (ne != null) for(let oe in ne)ne.hasOwnProperty(oe) && (re[oe] = ne[oe]);
                    }
                    return re;
                };
            }();
            let ie = Object.assign({}, H);
            return U(H) && U(G) && Object.keys(G).forEach((B)=>{
                U(G[B]) ? B in H ? ie[B] = F(H[B], G[B]) : Object.assign(ie, {
                    [B]: G[B]
                }) : Object.assign(ie, {
                    [B]: G[B]
                });
            }), ie;
        }, ce = async ()=>{
            if (await (0, $TusQn.nextTick)(), X.value) return;
            const H = {
                chart: {
                    type: _.type || _.options.chart.type || "line",
                    height: _.height,
                    width: _.width,
                    events: {}
                },
                series: _.series
            };
            $a0ff767aa05ebc8a$var$pt.forEach((ie)=>{
                let B = (...re)=>Re(ie, ...re);
                H.chart.events[ie] = B;
            });
            const G = F(_.options, H);
            return X.value = new $a0ff767aa05ebc8a$var$ut(Ae.value, G), X.value.render();
        }, Y = ()=>(ee(), ce()), ee = ()=>{
            X.value.destroy();
        }, ge = (H, G)=>X.value.updateSeries(H, G), me = (H, G, ie, B)=>X.value.updateOptions(H, G, ie, B), Se = (H)=>X.value.toggleSeries(H), ze = (H)=>{
            X.value.showSeries(H);
        }, ue = (H)=>{
            X.value.hideSeries(H);
        }, Me = (H, G)=>X.value.appendSeries(H, G), J = ()=>{
            X.value.resetSeries();
        }, Xe = (H, G)=>{
            X.value.toggleDataPointSelection(H, G);
        }, Ce = (H)=>X.value.appendData(H), P = (H, G)=>X.value.zoomX(H, G), de = (H)=>X.value.dataURI(H), Z = (H)=>X.value.setLocale(H), M = (H, G)=>{
            X.value.addXaxisAnnotation(H, G);
        }, q = (H, G)=>{
            X.value.addYaxisAnnotation(H, G);
        }, ve = (H, G)=>{
            X.value.addPointAnnotation(H, G);
        }, Oe = (H, G)=>{
            X.value.removeAnnotation(H, G);
        }, He = ()=>{
            X.value.clearAnnotations();
        };
        (0, $TusQn.onBeforeMount)(()=>{
            window.ApexCharts = $a0ff767aa05ebc8a$var$ut;
        }), (0, $TusQn.onMounted)(()=>{
            Ae.value = (0, $TusQn.getCurrentInstance)().proxy.$el, ce();
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            X.value && ee();
        });
        const pe = (0, $01W3b.toRefs)(_);
        return (0, $TusQn.watch)(pe.options, ()=>{
            !X.value && _.options ? ce() : X.value.updateOptions(_.options);
        }), (0, $TusQn.watch)(pe.series, ()=>{
            !X.value && _.series ? ce() : X.value.updateSeries(_.series);
        }, {
            deep: !0
        }), (0, $TusQn.watch)(pe.type, ()=>{
            Y();
        }), (0, $TusQn.watch)(pe.width, ()=>{
            Y();
        }), (0, $TusQn.watch)(pe.height, ()=>{
            Y();
        }), {
            chart: X,
            init: ce,
            refresh: Y,
            destroy: ee,
            updateOptions: me,
            updateSeries: ge,
            toggleSeries: Se,
            showSeries: ze,
            hideSeries: ue,
            resetSeries: J,
            zoomX: P,
            toggleDataPointSelection: Xe,
            appendData: Ce,
            appendSeries: Me,
            addXaxisAnnotation: M,
            addYaxisAnnotation: q,
            addPointAnnotation: ve,
            removeAnnotation: Oe,
            clearAnnotations: He,
            setLocale: Z,
            dataURI: de
        };
    },
    render () {
        return (0, $TusQn.h)("div", {
            class: "vue-apexcharts"
        });
    }
}), $a0ff767aa05ebc8a$var$ii = (_)=>{
    _.component($a0ff767aa05ebc8a$export$2e2bcd8739ae039.name, $a0ff767aa05ebc8a$export$2e2bcd8739ae039);
};
$a0ff767aa05ebc8a$export$2e2bcd8739ae039.install = $a0ff767aa05ebc8a$var$ii;



var $h8ls9 = parcelRequire("h8ls9");
var $7b4ca7aa003c0068$exports = {};
$7b4ca7aa003c0068$exports = JSON.parse('{"noAssignedModeling":"","modelings":"","pleaseSignIn":"","email":"","enterLogin":"","signIn":"","password":"","enterPassword":"","filterByName":"","settings":"","logout":"","home":"","users":"","areas":"","modelingName":"","passwordChange":"","close":"","confirm":"","userDelete":"","wannaDeleteThisUser":"","delete":"","modelingDelete":"","wannaDeleteThisModeling":"","userCreation":"","create":"","name":"","enterUserName":"","loginName":"","role":"","chooseRole":"","viewer":"","admin":"","team":"","teamName":"","group":"","groups":"","chooseGroup":"","choose":"","groupCreation":"","enterGroupName":"","groupDetail":"","save":"","userDetail":"","modelingCreation":"","modelingDetail":"","datasetList":"","assetTypeList":"","activityList":"","lifeCycleList":"","description":"","benefitList":"","forecastList":"","budgetList":"","performanceList":"","activityDelete":"","wannaDeleteThisActivity":"","lifeCycleDelete":"","wannaDeleteThisLifeCycle":"","benefitDelete":"","wannaDeleteThisBenefit":"","performanceDelete":"","wannaDeleteThisPerformance":"","unit":"","unitCost":"","rootActivity":"","activityColor":"","activityCreate":"","activityDetail":"","costFactor":"","benefitCreate":"","benefitAttributes":"","weight":"","biggerMoreBenefit":"","mandatoryActAttr":"","mandatoryActYearAttr":"","performance":"","performanceName":"","performanceDescription":"","performanceLifespan":"","performanceRanges":"","startTheoreticalAge":"","endTheoreticalAge":"","startAssetPerformance":"","endAssetPerformance":"","startIAPP":"","endIAPP":"","color":"","lifeCycleActivities":"","activityName":"","activityUnitCost":"","activityCostFactor":"","minAge":"","maxAge":"","noAct":"","significant":"","effect":"","changeToLifeCycleId":"","notFirst":"","root":"","lifeCycleFilters":"","sign":"","number":"","lifeCycleCreate":"","lifeCycleDetail":"","activity":"","datasetDetail":"","addAssetType":"","addPerformance":"","addBenefit":"","addLifeCycle":"","addDataset":"","addBudget":"","addForecast":"","addActivity":"","addCostFactor":"","inputModel":"","analysis":"","results":"","datasetCreate":"","assetTypeDetail":"","forecastCreate":"","assetTypeCreate":"","budgetCreate":"","budgetDetail":"","performanceCreate":"","performanceDetail":"","select":"","signif":"","changeToLifeCycle":"","benefitDetail":"","back":"","assetType":"","incorrectUserOrPassword":"","startYear":"","endYear":"","inflationRate":"","discountRate":"","forecastAssetTypes":"","assetTypes":"","assetAttr":"","ageAttr":"","dataset":"","lifeCycles":"","forecastAssetTypeLifeCycles":"","addAssetTypeLifeCycle":"","forecastUpdate":"","mandatoryVariants":"","forecast":"","allowBreakLifecycleVariants":"","unlimitedBudget":"","frameworkBudget":"","packageDescription":"","budgetPackages":"","predictiveYear":"","map":"","data":"","Upload":"","attribute":"","value":"","budget":"","budgetYearly":"","percentage":"","inputType":"","inputValue":"","showYearlyBudgetPackages":"","budgetDelete":"","wannaDeleteThisBudget":"","datasetDelete":"","wannaDeleteThisDataset":"","budgetAssetTypes":"","lifeCycle":"","budgetPackage":"","benefitWeight":"","none":"","leading":"","alias":"","headerName":"","infosetAttributes":"","assetAttribute":"","lifeCycleAgeAttribute":"","weightAttribute":"","selectionDetail":"","packages":"","limits":"","filterAttributeName":"","filterSign":"","filterValue":"","limitDetail":"","package":"","selectionLimitPackages":"","years":"","limit":"","totalLimitValue":"","limitValue":"","selectionInfo":"","selectionMethod":"","detail":"","addGroup":"","addPackage":"","addLimit":"","selectionDelete":"","wannaDeleteThisSelection":"","analysisSelection":"","addSelection":"","selectionAreaAssetTypes":"","groupCreate":"","packageLifeCycleViewModel":"","inputMethod":"","packageCreate":"","packageDetail":"","unlimited":"","benefit":"","custom":"","yearly":"","divided":"","limitCreate":"","selectionCreate":"","selectionPackageDelete":"","wannaDeleteThisSelectionPackage":"","selectionLimitDelete":"","wannaDeleteThisSelectionLimit":"","selectionGroupDelete":"","wannaDeleteThisSelectionGroup":"","performanceRangesChart":"","lifeCycleActivitiesChart":"","forecastName":"","selectionName":"","selectionStartYear":"","selectionEndYear":"","createdDate":"","simulation":"","wannaRunSimulation":"","runSimulation":"","export":"","selectionLimitPackageYears":"","benefitSpecification":"","testingSection1":"","testingSection2":"","copy":"","forecastCopy":"","wannaCopyThisForecast":"","validation":"","validate":"","import":"","datasets":"","upload":"","forecasts":"","selections":"","modelingImport":"","areaCreation":"","areaDetail":"","addArea":"","areaCreate":"","area":"","modelingResultDetail":"","limitName":"","conditions":"","spending":"","resultDelete":"","wannaDeleteThisResult":"","modelingResult":"","forecastDelete":"","wannaDeleteThisForecast":"","dependencies":"","cannotDeleteActivity":"","cannotDeleteBenefit":"","cannotDeletePerformance":"","cannotDeleteLifeCycle":"","cannotDeleteDataset":"","cannotDeleteAssetType":"","assetTypeDelete":"","wannaDeleteThisAssetType":"","allDataWillBeLost":"","cannotDeleteSelection":"","loading":"","assetTypeNotEmpty":"","selectionNotEmpty":"","selectionAreaDelete":"","activityUpdated":"","datasetUpdateSucessfull":"","assetTypeUpdated":"","assetTypeInfosetUpdated":"","emptyName":"","benefitUpdated":"","filesUploaded":"","errorWhileUploadingFiles":"","errorWhileUploadingFilesWrongType":"","forecastCopied":"","errorStartEndYearForecast":"","forecastUpdated":"","lifeCycleUpdated":"","missingPerformanceWarning":"","filtersWarning":"","filtersError":"","activitiesError":"","modelingUpdated":"","importSuccess":"","importError":"","lifespanError":"","performanceUpdated":"","selectionGroupCreated":"","selectionGroupError":"","selectionGroupUpdated":"","selectionGroupErrorUpdate":"","selectionLimitCreated":"","selectionLimitError":"","selectionLimitUpdated":"","selectionLimitErrorUpdate":"","limitPackagesMissingValues":"","selectionPackageCreated":"","selectionPackageError":"","selectionPackageUpdated":"","selectionPackageErrorUpdate":"","selectionCreated":"","selectionError":"","selectionUpdated":"","selectionErrorUpdate":"","groupUpdated":"","userUpdated":"","warningAttributeRemoved":"","success":"","error":"","warning":"","resultFailed":"V\xfdpo\u010Det selhal","analysisStarted":"Anal\xfdza byla \xfasp\u011B\u0161n\u011B spu\u0161t\u011Bna!","modelingResultDeleted":"","wannaDeleteThisModelingResult":"","performanceBefore":"","performanceAfter":""}');


var $a997ea418357c44d$exports = {};
$a997ea418357c44d$exports = JSON.parse('{"noAssignedModeling":"No assigned project","modelings":"projects","pleaseSignIn":"Please sign in","email":"Email","enterLogin":"Enter UserName","signIn":"Sign in","password":"Password","enterPassword":"Enter password","filterByName":"Filter by name","settings":"Settings","logout":"Logout","home":"Home","users":"Users","areas":"Areas","modelingName":"Project name","passwordChange":"Password change","close":"Close","confirm":"Confirm","userDelete":"Delete user","wannaDeleteThisUser":"Are you sure you want to delete this user?","delete":"Delete","modelingDelete":"Delete project","wannaDeleteThisModeling":"Are you sure you want to delete this project?","userCreation":"User creation","create":"Create","name":"Name","enterUserName":"Enter user name","loginName":"Login name","role":"Role","chooseRole":"Choose role","viewer":"Viewer","admin":"Admin","team":"Team","teamName":"Team name","group":"Group","groups":"Groups","chooseGroup":"Choose group","choose":"Choose","groupCreation":"Group creation","enterGroupName":"Enter group name","groupDetail":"Group detail","save":"Save","userDetail":"User detail","modelingCreation":"Project creation","modelingDetail":"Project detail","datasetList":"Datasets","assetTypeList":"Assets","activityList":"Activities","lifeCycleList":"Life Cycles","description":"Description","benefitList":"Benefits","forecastList":"Forecasts","budgetList":"Budgets","performanceList":"Performances","activityDelete":"Activity delete","wannaDeleteThisActivity":"Are you sure you want to delete this activity?","lifeCycleDelete":"Life Cycle delete","wannaDeleteThisLifeCycle":"Are you sure you want to delete this Life Cycle?","benefitDelete":"Benefit delete","wannaDeleteThisBenefit":"Are you sure you want to delete this benefit?","performanceDelete":"Performance delete","wannaDeleteThisPerformance":"Are you sure you want to delete this performance?","unit":"Unit","unitCost":"Unit cost","rootActivity":"Root activity","activityColor":"Activity color","activityCreate":"Activity create","activityDetail":"Activity detail","costFactor":"Cost factor","benefitCreate":"Benefit create","benefitAttributes":"Benefit attributes","weight":"Weight","biggerMoreBenefit":"Bigger more benefit","mandatoryActAttr":"Mandatory Act Attribute","mandatoryActYearAttr":"Mandatory Act Yearly Attribute","performance":"Performance","performanceName":"Performance name","performanceDescription":"Performance description","performanceLifespan":"Performance lifespan","performanceRanges":"Performance Ranges","startTheoreticalAge":"Start Theoretical Age","endTheoreticalAge":"End Theoretical Age","startAssetPerformance":"Start Asset Performance","endAssetPerformance":"End Asset Performance","startIAPP":"Start IAPP","endIAPP":"End IAPP","color":"Color","lifeCycleActivities":"Life Cycle Activities","activityName":"Activity name","activityUnitCost":"Activity Unit Cost","activityCostFactor":"Activity Cost Factor","minAge":"Min age","maxAge":"Max age","noAct":"No act","significant":"Significant","effect":"Effect","changeToLifeCycleId":"Change to Life Cycle Id","notFirst":"Not first","root":"Root","lifeCycleFilters":"Life Cycle filters","sign":"Sign","number":"Number","lifeCycleCreate":"Life Cycle create","lifeCycleDetail":"Life Cycle detail","activity":"Activity","datasetDetail":"Dataset detail","addAssetType":"Add Asset","addPerformance":"Add Performance","addBenefit":"Add Benefit","addLifeCycle":"Add Life Cycle","addDataset":"Add Dataset","addBudget":"Add Budget","addForecast":"Add Forecast","addActivity":"Add Activity","addCostFactor":"Add Cost Factor","inputModel":"Input model","analysis":"Analysis","results":"Results","datasetCreate":"Dataset create","assetTypeDetail":"Asset detail","forecastCreate":"Forecast create","assetTypeCreate":"Asset create","budgetCreate":"Budget create","budgetDetail":"Budget detail","performanceCreate":"Performance create","performanceDetail":"Performance detail","select":"Select","signif":"Signif.","changeToLifeCycle":"Change to Life Cycle","benefitDetail":"Benefit detail","back":"Back","assetType":"Asset Type","incorrectUserOrPassword":"Incorrect UserName Or Password","startYear":"Start Year","endYear":"End Year","inflationRate":"Inflation Rate","discountRate":"Discount Rate","forecastAssetTypes":"Asset","assetTypes":"Assets","assetAttr":"Asset Attribute","ageAttr":"Age Attribute","dataset":"Dataset","lifeCycles":"Life Cycles","forecastAssetTypeLifeCycles":"Life Cycles","addAssetTypeLifeCycle":"Add Life Cycle","forecastUpdate":"Forecast Update","mandatoryVariants":"Mandatory Variants","forecast":"Forecast","allowBreakLifecycleVariants":"Allow break Life Cycle variants","unlimitedBudget":"Unlimited budget","frameworkBudget":"Framework budget","packageDescription":"Package description","budgetPackages":"Budget Packages","predictiveYear":"Predictive Year","map":"Map","data":"Data","Upload":"Upload","attribute":"Attribute","value":"Value","budget":"Budget","budgetYearly":"Yearly budget","percentage":"Percentage","inputType":"Input type","inputValue":"Input value","showYearlyBudgetPackages":"Show yearly budget","budgetDelete":"Budget Delete","wannaDeleteThisBudget":"Are you sure you want to delete this budget?","datasetDelete":"Dataset Delete","wannaDeleteThisDataset":"Are you sure you want to delete this dataset?","budgetAssetTypes":"Budget Assets","lifeCycle":"Life Cycle","budgetPackage":"Budget Package","benefitWeight":"Benefit Weight","none":"None","leading":"Leading","alias":"Alias","headerName":"Header name","infosetAttributes":"InfoSet Attributes","assetAttribute":"Asset Attribute","lifeCycleAgeAttribute":"Life Cycle Age Attribute","weightAttribute":"Weight Attribute","selectionDetail":"Selection detail","packages":"Packages","limits":"Limits","filterAttributeName":"Filter Attribute Name","filterSign":"Filter Sign","filterValue":"Filter Value","limitDetail":"Limit Detail","package":"Package","selectionLimitPackages":"Selection Limit Packages","years":"Years","limit":"Limit","totalLimitValue":"Total Limit Value","limitValue":"Limit Value","selectionInfo":"Selection Info","selectionMethod":"Selection Method","detail":"Detail","addGroup":"Add Group","addPackage":"Add Package","addLimit":"Add Limit","selectionDelete":"Selection Delete","wannaDeleteThisSelection":"Are you sure you want to delete this selection?","analysisSelection":"Analysis Selection","addSelection":"Add Selection","selectionAreaAssetTypes":"Selection Area Assets","groupCreate":"Group Create","packageLifeCycleViewModel":"Package Life Cycles","inputMethod":"Input Method","packageCreate":"Package Create","packageDetail":"Package Detail","unlimited":"Unlimited","benefit":"Benefit","custom":"Custom","yearly":"Yearly","divided":"Divided","limitCreate":"Limit Create","selectionCreate":"Selection Create","selectionPackageDelete":"Selection Package Delete","wannaDeleteThisSelectionPackage":"Are you sure you want to delete this selection package?","selectionLimitDelete":"Selection Limit Delete","wannaDeleteThisSelectionLimit":"Are you sure you want to delete this selection limit?","selectionGroupDelete":"Selection Area Delete","wannaDeleteThisSelectionGroup":"Are you sure you want to delete this selection area?","performanceRangesChart":"Performance Ranges Chart","lifeCycleActivitiesChart":"Life Cycle Activities Chart","forecastName":"Forecast Name","selectionName":"Selection Name","selectionStartYear":"Selection Start Year","selectionEndYear":"Selection End Year","createdDate":"Created Date","simulation":"Simulation","wannaRunSimulation":"Are you sure you want to run this simulation?","runSimulation":"Run Simulation","export":"Export","selectionLimitPackageYears":"Selection Limit Package Years","benefitSpecification":"Benefit Specification","testingSection1":"Testing Section 1","testingSection2":"Testing Section 2","copy":"Copy","forecastCopy":"Forecast Copy","wannaCopyThisForecast":"Are you sure you want to copy this forecast?","validation":"Validation","validate":"Validate","import":"Import","datasets":"Datasets","upload":"Upload","forecasts":"Forecasts","selections":"Selections","modelingImport":"Project Import","areaCreation":"Area creation","areaDetail":"Area detail","addArea":"Add Area","areaCreate":"Area Create","area":"Area","modelingResultDetail":"Project Result Detail","limitName":"Limit Name","conditions":"Conditions","spending":"Spending","resultDelete":"Result Delete","wannaDeleteThisResult":"Are you sure you want to delete this project result?","modelingResult":"Modeling result","forecastDelete":"Forecast delete","wannaDeleteThisForecast":"Are you sure you want to delete this forecast?","dependencies":"Dependencies","cannotDeleteActivity":"Cannot be deleted, Activity is used in Life Cycle: ","cannotDeleteBenefit":"Cannot be deleted, Benefit is used in Selection Package: ","cannotDeletePerformance":"Cannot be deleted, Performance is used in Life Cycle: ","cannotDeleteLifeCycle":"Cannot be deleted, Life Cycle is used in Forecast: ","cannotDeleteDataset":"Cannot be deleted, Dataset contains Assets.","cannotDeleteAssetType":"Cannot be deleted, Asset is used in Forecast: ","assetTypeDelete":"Asset delete","wannaDeleteThisAssetType":"Are you sure you want to delete this Asset?","allDataWillBeLost":"All data will be lost.","cannotDeleteSelection":"Cannot be deleted, Selection is used in project result: ","loading":"Loading","assetTypeNotEmpty":"Cannot be deleted, Asset is not empty.","selectionNotEmpty":"Cannot be deleted, Selection is not empty.","selectionAreaDelete":"Selection Area delete","activityUpdated":"Activity successfully updated!","datasetUpdateSucessfull":"Dataset was successfully updated","assetTypeUpdated":"Asset succesfully updated!","assetTypeInfosetUpdated":"Asset infoset successfully updated!","emptyName":"Name must be filled in!","benefitUpdated":"Benefit successfully updated!","filesUploaded":"Files were successfully uploaded.","errorWhileUploadingFiles":"Error while uploading files","errorWhileUploadingFilesWrongType":"Error while uploading files. Wrong file type used. (required: .xlsx, .shp, .dbf, .shx)","forecastCopied":"Forecast successfully copied!","errorStartEndYearForecast":"Error when creating Forecast, start year and end year of the Forecast must be filled in!","forecastUpdated":"Forecast succesfully updated","lifeCycleUpdated":"Life Cycle successfully updated","missingPerformanceWarning":"Error when creating Life Cycle, no Performance is selected!","filtersWarning":"Life Cycle Filters contain attribute that has been removed or is not filled","filtersError":"Life Cycle Filters contain attribute that is not filled!","activitiesError":"Life Cycle Activities contain attribute that is not filled!","modelingUpdated":"Project successfully updated!","importSuccess":"Import has been successful!","importError":"Unable to import project, dependent Assets not selected!","lifespanError":"End theoretical age is bigger than lifespan!","performanceUpdated":"Performance successfully updated!","selectionGroupCreated":"Selection group successfully created!","selectionGroupError":"Error while creating selection group!","selectionGroupUpdated":"Selection group successfully updated","selectionGroupErrorUpdate":"Error while updating selection group","selectionLimitCreated":"Selection limit successfully created!","selectionLimitError":"Error while creating selection limit!","selectionLimitUpdated":"Selection limit successfully updated","selectionLimitErrorUpdate":"Error while updating selection limit","limitPackagesMissingValues":"Selection Limit Packages are missing values!","selectionPackageCreated":"Selection package successfully created!","selectionPackageError":"Error while creating selection package!","selectionPackageUpdated":"Selection package successfully updated!","selectionPackageErrorUpdate":"Error while updating selection package!","selectionCreated":"Selection successfully created!","selectionError":"Error while creating selection","selectionUpdated":"Selection successfully updated!","selectionErrorUpdate":"Error while updating selection","groupUpdated":"Group successfully updated!","userUpdated":"User successfully updated!","warningAttributeRemoved":"Form contains attribute that has been removed, please change it!","success":"Success!","error":"Error!","warning":"Warning!","wannaDeleteThisSelectionArea":"wannaDeleteThisSelectionArea","allowNotFirstVariants":"Allow not first variants","coreBenefitMethod":"Core Benefit Method","significantNumber":"Significant Number","fromStatusAsset":"From Status Asset","toStatusAsset":"To Status Asset","classificationOfAssetAttribute":"Classification of Asset Attribute","recalculateLifeCycleAge":" Recalculate Life Cycle Age","assetAttributeYear":"Asset Attribute Year","mandatoryActCostAttr":"Mandatory Act Cost Attribute","parameters":"Parameters","addParameter":"Add Parameter","addCurve":"Add Curve","parameterCreate":"Parameter create","parameterDetail":"Parameter detail","parameterAttributeYear":"Parameter Attribute Year","parameterAttribute":"Parameter Attribute","toTheResults":"To the results","startClassification":"Start Classification","endClassification":"End Classification","parameterUpdated":"Parameter updated","parameterClasses":"Parameter Classes","evaluation":"Evaluation","addEvaluation":"Add Evaluation","classTransformation":"Class Transformation","evaluationFilter":"Evaluation Filter","evaluationCreate":"Evaluation Create","evaluationDetail":"Evaluation Detail","className":"Class Name","startParameter":"Start Parameter","endParameter":"End Parameter","curveDetail":"Curve Detail","curveCreate":"Curve Create","curve":"Curve","curveRange":"Curve Range","curveFilters":"Curve Filters","curveActivityEffects":"Curve Activity Effects","startAge":"Start Age","endAge":"End Age","startValue":"Start Value","endValue":"End Value","changeToCurve":"Change to Curve","curveUpdated":"Curve updated","curveErrorUpdate":"Error while updating curve","curveCreated":"Curve created","curveError":"Error while creating curve","kpi":"KPI","addKpi":"Add KPI","kpiClassification":"KPI Classification","kpiCreate":"KPI Create","kpiDetail":"KPI Detail","evaluationMethod":"Evaluation Method","kpiUpdated":"KPI updated","evaluationParameters":"Evaluation parameters","evaluationFilters":"Evaluation filters","useAttribute":"Use attribute","parameter":"Parameter","additionalProportion":"Additional Proportion","increasingValue":"Increasing Value","recalculateWeight":"Recalculate Weight","weightAverage":"Weight Average","multiply":"Multiply","evaluationCreated":"Evaluation created","evaluationUpdated":"Evaluation updated","evaluationError":"Error while creating evaluation","evaluationErrorUpdate":"Error while updating evaluation","sumarizedCostCharts":"Sumarized Cost Charts","activityPlan":"Activity Plan","resultVisualization":"Result Visualization","weightedAverageCharts":"Weighted Average Charts","distributionCharts":"Distribution Charts","activityCharts":"Activity Charts","resultCharts":"Result Charts","weightAverageCharts":"Weight Average Charts","projectResult":"Project Result","visualization":"Visualization","dataValues":"Data values","year":"Year","currency":"Currency","curveDelete":"Curve Delete","wannaDeleteThisCurve":"Are you sure you want to delete this curve?","parameterDelete":"Parameter Delete","wannaDeleteThisParameter":"Are you sure you want to delete this parameter?","downloadZip":"Download Zip","allGroups":"All groups","totalPackageCost":"Total Package Cost","allAreas":"All areas","parameterandkpi":"Parameter and KPI","visualizationValue":"Visualization Value","coefficientAttribute":"Coefficient Attribute","coefficientForecastOnly":"Coefficient Forecast Only","curveRangeChart":"Curve Range Chart","evaluationDelete":"Evaluation Delete","wannaDeleteThisEvaluation":"Are you sure you want to delete this evaluation?","legend":"Legend","cannotDeleteKeyPerformanceIndicator":"Cannot be deleted because it is used by the following evaluations: ","kpiDelete":"KPI Delete","wannaDeleteThisKeyPerformanceIndicator":"Are you sure you want to delete this KPI?","allPackages":"All Packages","resultFailed":"Result failed","analysisStarted":"Analysis has been started successfully!","modelingResultDeleted":"Modeling result successfully deleted!","wannaDeleteThisModelingResult":"Are you sure you want to delete this modeling result?","parameterContainsCurves":"This parameter contains curves and cannot be deleted.","parameterContainsEvaluation":"This parameter contains evaluations and cannot be deleted.","performanceBefore":"Perf. before","performanceAfter":"Perf. after"}');


var $0c901ae870b60b14$exports = {};
$0c901ae870b60b14$exports = JSON.parse('{"noAssignedModeling":"Kein Projekt ausgew\xe4hlt","modelings":"Projekte","pleaseSignIn":"Bitte anmelden","email":"Email","enterLogin":"Eingabe Benutzername","signIn":"anmelden","password":"Passwort","enterPassword":"Eingabe Passwort","filterByName":"Filter nach Name","settings":"Einstellungen","logout":"Logout","home":"\xdcbersicht","users":"Nutzer","areas":"Gebiete","modelingName":"Projektname","passwordChange":"Passwort \xe4ndern","close":"Schlie\xdfen","confirm":"Best\xe4tigen","userDelete":"Nutzer l\xf6schen","wannaDeleteThisUser":"Wollen Sie den Nutzer l\xf6schen?","delete":"L\xf6schen","modelingDelete":"Projekt l\xf6schen","wannaDeleteThisModeling":"Wollen Sie das Projekt l\xf6schen?","userCreation":"Nutzer anlegen","create":"Anlegen","name":"Name","enterUserName":"Eingabe Benutzername","loginName":"Benutzername","role":"Rolle","chooseRole":"Rolle ausw\xe4hlen","viewer":"Betrachter","admin":"Admin","team":"Team","teamName":"Teambezeichnung","group":"Gruppe","groups":"Gruppen","chooseGroup":"Gruppe ausw\xe4hlen","choose":"Ausw\xe4hlen","groupCreation":"Gruppe anlegen","enterGroupName":"Eingabe Gruppenbezeichnung","groupDetail":"Gruppen Details","save":"Speichern","userDetail":"Nutzer Details","modelingCreation":"Projekt anlegen","modelingDetail":"Projekt Details","datasetList":"Dataset","assetTypeList":"Asset Liste","activityList":"Ma\xdfnahmen","lifeCycleList":"Lebenszyklen","description":"Beschreibung","benefitList":"Nutzen","forecastList":"Prognose","budgetList":"Budgets","performanceList":"Performance","activityDelete":"Ma\xdfnahme l\xf6schen","wannaDeleteThisActivity":"Wollen Sie die Ma\xdfnahme l\xf6schen?","lifeCycleDelete":"Lebenszyklus l\xf6schen","wannaDeleteThisLifeCycle":"Wollen Sie den Lebenszyklus l\xf6schen?","benefitDelete":"Nutzen l\xf6schen","wannaDeleteThisBenefit":"Wollen Sie den Nutzen l\xf6schen?","performanceDelete":"Verhaltensentwicklung l\xf6schen","wannaDeleteThisPerformance":"Wollen Sie die Verhaltensentwicklung l\xf6schen?","unit":"Einheit","unitCost":"Einheitspreis","rootActivity":"Finale Ma\xdfnahme","activityColor":"Ma\xdfnahmenfarbe","activityCreate":"Ma\xdfnahme anlegen","activityDetail":"Ma\xdfnahmen Details","costFactor":"Kostenfaktor","benefitCreate":"Nutzen anlegen","benefitAttributes":"Nutzen Attribute","weight":"Gewicht","biggerMoreBenefit":"gr\xf6\xdferer Wert, mehr Nutzen","mandatoryActAttr":"Attribut Fixe Ma\xdfnahme","mandatoryActYearAttr":"Attribut Jahr Fixe Ma\xdfnahme","performance":"Performance","performanceName":"Name","performanceDescription":"Beschreibung","performanceLifespan":"Nutzungsdauer","performanceRanges":"Zustandsklassen","startTheoreticalAge":"VON Alter theor.","endTheoreticalAge":"BIS Alter theor.","startAssetPerformance":"VON Zustand Asset","endAssetPerformance":"BIS Zustand Asset","startIAPP":"von IAPP","endIAPP":"bis IAPP","color":"Farbe","lifeCycleActivities":"Ma\xdfnahmen im Lebenzyklus","activityName":"Ma\xdfnahme Bezeichnung","activityUnitCost":"Ma\xdfnahme Einheitspreis","activityCostFactor":"Ma\xdfnahme Kostenfaktor","minAge":"VON Alter","maxAge":"BIS Alter","noAct":"Jahre keine Ma\xdfnahme","significant":"Basisnutzen","effect":"Wirkung","changeToLifeCycleId":"Wechseln zu Lebenszyklus Id","notFirst":"nicht als Erste","root":"final","lifeCycleFilters":"Lebenszyklus Filter","sign":"Bedingung","number":"Wert","lifeCycleCreate":"Lebenszyklus anlegen","lifeCycleDetail":"Lebenszyklen Details","activity":"Ma\xdfnahme","datasetDetail":"Dataset Details","addAssetType":"Asset hinzuf\xfcgen","addPerformance":"Performance hinzuf\xfcgen","addBenefit":"Nutzen hinzuf\xfcgen","addLifeCycle":"Lebenszyklus hinzuf\xfcgen","addDataset":"Dataset hinzuf\xfcgen","addBudget":"Budget hinzuf\xfcgen","addForecast":"Prognose hinzuf\xfcgen","addActivity":"Ma\xdfnahme hinzuf\xfcgen","addCostFactor":"Kostenfaktor hinzuf\xfcgen","inputModel":"Eingangsdaten","analysis":"Analyse","results":"Ergebnisse","datasetCreate":"Dataset anlegen","assetTypeDetail":"Asset Details","forecastCreate":"Prognose anlegen","assetTypeCreate":"Asset anlegen","budgetCreate":"Budget anlegen","budgetDetail":"Budgets Details","performanceCreate":"Performance anlegen","performanceDetail":"Performance Details","select":"ausw\xe4hlen","signif":"Basisnutzen","changeToLifeCycle":"Wechsel zu Lebenszyklus","benefitDetail":"Nutzen Details","back":"Zur\xfcck","assetType":"Asset","incorrectUserOrPassword":"Benutzername oder Passwort falsch","startYear":"Anfangsjahr","endYear":"Endjahr","inflationRate":"Inflationsrate","discountRate":"Diskontrate","forecastAssetTypes":"Assets","assetTypes":"Assets","assetAttr":"Asset Attribut","ageAttr":"Alter Attribut","dataset":"Dataset","lifeCycles":"Lebenszyklen","forecastAssetTypeLifeCycles":"Lebenszyklen","addAssetTypeLifeCycle":"Lebenszyklen hinzuf\xfcgen","forecastUpdate":"Prognose Details","mandatoryVariants":"Varianten fixe Ma\xdfnahmen","forecast":"Prognose","allowBreakLifecycleVariants":"unterbrochener Lebenszyklus erlaubt","unlimitedBudget":"unbegrenztes Budget","frameworkBudget":"Rahmenbudget","packageDescription":"Package Beschreibung","budgetPackages":"Budget Packages","predictiveYear":"Jahr","map":"Karte","data":"Daten","Settle":"Settle","Upload":"hochladen","attribute":"Attribut","value":"Wert","budget":"Budget","budgetYearly":"j\xe4hrliches Budget","percentage":"Anteil","inputType":"Eingabe Typ","inputValue":"Eingabe Wert","showYearlyBudgetPackages":"J\xe4hrliches Budget","budgetDelete":"Budget l\xf6schen","wannaDeleteThisBudget":"Wollen Sie dieses Budget l\xf6schen?","datasetDelete":"Datenset l\xf6schen","wannaDeleteThisDataset":"Wollen Sie dieses Datenset l\xf6schen??","budgetAssetTypes":"Budget Asset","lifeCycle":"Lebenszyklus","budgetPackage":"Budget Package","benefitWeight":"Gewicht Nutzen","none":"Leer","leading":"\xdcbernehmen","alias":"Alias","headerName":"Bezeichnung Dataset","infosetAttributes":"Dataset Attribute","assetAttribute":"Asset Attribut","lifeCycleAgeAttribute":"Lebenszyklusalter Attribut","weightAttribute":"Gewicht Attribut","selectionDetail":"Auswahl Details","packages":"Packages","limits":"Limits","filterAttributeName":"Filter Attribute","filterSign":"Bedingung","filterValue":"Wert","limitDetail":"Limits Details","package":"Package","selectionLimitPackages":"Auswahl Packages/Limits","years":"Jahre","limit":"Limit","totalLimitValue":"Gesamtlimit","limitValue":"Limit/Anteil j\xe4hrl.","selectionInfo":"Auswahl Info","selectionMethod":"Auswahlmethode","detail":"Details","addGroup":"Gruppe hinzuf\xfcgen","addPackage":"Package hinzuf\xfcgen","addLimit":"Limit hinzuf\xfcgen","selectionDelete":"Auswahl l\xf6schen","wannaDeleteThisSelection":"Wollen Sie diese Auswahl l\xf6schen?","analysisSelection":"Analyse","addSelection":"Auswahl hinzuf\xfcgen","selectionAreaAssetTypes":"Assets im Gebiet","groupCreate":"Gruppe anlegen","packageLifeCycleViewModel":"Lebenszyklen im Package","inputMethod":"Methode","packageCreate":"Package anlegen","packageDetail":"Packages Details","unlimited":"unbegrenzt","benefit":"Nutzen","custom":"ben.def.","yearly":"j\xe4hrlich","divided":"anteilig","limitCreate":"Limits anlegen","selectionCreate":"Auswahl anlegen","selectionPackageDelete":"Auswahl Package l\xf6schen","wannaDeleteThisSelectionPackage":"Wollen Sie dieses Auswahl Package l\xf6schen?","selectionLimitDelete":"Auswahl Limit l\xf6schen","wannaDeleteThisSelectionLimit":"Wollen Sie dieses Auswahl Limit l\xf6schen?","selectionGroupDelete":"Auswahl Gebiete l\xf6schen","wannaDeleteThisSelectionGroup":"Wollen Sie diese Auswahl Gebiete l\xf6schen?","performanceRangesChart":"Graphik Bereich Verhaltensentwicklung ","lifeCycleActivitiesChart":"Graphik Lebenzyklus Ma\xdfnahmen","forecastName":"Prognose","selectionName":"Auswahl","selectionStartYear":"Jahr Start","selectionEndYear":"Jahr Ende","createdDate":"Erstelldatum","simulation":"Simulation","wannaRunSimulation":"Wollen Sie die Simulation ausf\xfchren?","runSimulation":"Simulation ausf\xfchren","export":"Export","selectionLimitPackageYears":"j\xe4hrliche Limits","benefitSpecification":"Kontrollspalte Nutzen","testingSection1":"Testing Section 1","testingSection2":"Testing Section 2","copy":"Kopieren","forecastCopy":"Prognose kopieren","wannaCopyThisForecast":"Wollen Sie die Prognose kopieren?","validation":"Validierung","validate":"Validieren","import":"Import","datasets":"Dataset","upload":"Upload","forecasts":"Prognose","selections":"Auswahl","modelingImport":"Import Projekt","areaCreation":"Gebiet anlegen","areaDetail":"Gebiete Details","addArea":"Gebiet hinzuf\xfcgen","areaCreate":"Gebiet anlegen","area":"Gebiet","modelingResultDetail":"Projekt Detailergebnisse","limitName":"Bezeichnung","conditions":"Zustand","spending":"Kosten","resultDelete":"Ergebnis l\xf6schen","wannaDeleteThisResult":"Wollen Sie dieses Ergebnis l\xf6schen?","modelingResult":"Ergebnis","forecastDelete":"Prognose l\xf6schen","wannaDeleteThisForecast":"Wollen Sie diese Prognose l\xf6schen?","dependencies":"Abh\xe4ngigkeiten","cannotDeleteActivity":"L\xf6schen nicht m\xf6glich, Ma\xdfnahme verwendet in Lebenszyklus: ","cannotDeleteBenefit":"L\xf6schen nicht m\xf6glich, Nutzen verwendet in Auswahl: ","cannotDeletePerformance":"L\xf6schen nicht m\xf6glich, Verhaltensentwicklung verwendet in Lebenszyklus: ","cannotDeleteLifeCycle":"L\xf6schen nicht m\xf6glich, Lebenszyklus verwendet in Prognose: ","cannotDeleteDataset":"L\xf6schen nicht m\xf6glich, Dataset enth\xe4lt Asset.","cannotDeleteAssetType":"L\xf6schen nicht m\xf6glich, Asset verwendet in Prognose: ","assetTypeDelete":"Asset l\xf6schen","wannaDeleteThisAssetType":"Wollen Sie diesen Asset l\xf6schen?","allDataWillBeLost":"Alle Daten werden gel\xf6scht.","cannotDeleteSelection":"L\xf6schen nicht m\xf6glich, Auswahl verwendet in Projektergebnis: ","loading":"Loading","assetTypeNotEmpty":"L\xf6schen nicht m\xf6glich, Asset nicht leer.","selectionNotEmpty":"L\xf6schen nicht m\xf6glich, Auswahl nicht leer.","selectionAreaDelete":"Auswahl Gebiet gel\xf6scht","activityUpdated":"Ma\xdfnahmen erfolgreich aktualisiert!","datasetUpdateSucessfull":"Dataset erfolgreich aktualisiert!","assetTypeUpdated":"Asset erfolgreich aktualisiert!","assetTypeInfosetUpdated":"Asset Infoset erfolgreich aktualisiert!","emptyName":"Name muss gef\xfcllt sein!","benefitUpdated":"Nutzen erfolgreich aktualisiert!","filesUploaded":"Files erfolgreich hochgeladen.","errorWhileUploadingFiles":"Fehler beim Hochladen der Files","errorWhileUploadingFilesWrongType":"Fehler beim Hochladen der Files. Falscher file Type. (erforderlich: .xlsx, .shp, .dbf, .shx)","forecastCopied":"Prognose erfolgreich kopiert!","errorStartEndYearForecast":"Fehler bei Erstellung Prognose, Start- und Endjahr m\xfcssen gef\xfcllt sein!","forecastUpdated":"Prognose erfolgreich aktualisiert","lifeCycleUpdated":"Lebenszyklus erfolgreich aktualisiert","missingPerformanceWarning":"Fehler bei Erstellung Lebenszyklus, keine Verhaltensentwicklung ausgew\xe4hlt!","filtersWarning":"Lebenszyklus Filter enth\xe4lt ein Attribut, das leer oder gel\xf6scht ist","activitiesError":"Lebenszyklus Ma\xdfnahme enth\xe4lt leeres Attribut!","modelingUpdated":"Projekt erfolgreich aktualisiert!","importSuccess":"Import erfolgreich!","importError":"Import Projekt nicht m\xf6glich, Asset nicht ausgew\xe4hlt!","lifespanError":"Ende Alter theoretisch ist gr\xf6\xdfer als Nutzungsdauer!","performanceUpdated":"Verhaltensentwicklung erfolgreich aktualisiert!","selectionGroupCreated":"Auswahl erfolgreich erstellt!","selectionGroupError":"Fehler bei Erstellung Auswahl!","selectionGroupUpdated":"Auswahl erfolgreich aktualisiert","selectionGroupErrorUpdate":"Fehler bei Aktualisierung Auswahl","selectionLimitCreated":"Limits erfolgreich erstellt!","selectionLimitError":"Fehler bei Erstellung Limits!","selectionLimitUpdated":"Limits erfolgreich aktualisiert","selectionLimitErrorUpdate":"Fehler bei Aktualisierung Limits","limitPackagesMissingValues":"Packages Werte fehlen!","selectionPackageCreated":"Package erfolgreich erstellt!","selectionPackageError":"Fehler bei Erstellung Package!","selectionPackageUpdated":"Package erfolgreich aktualisiert!","selectionPackageErrorUpdate":"Fehler bei Aktualisierung Package!","selectionCreated":"Erfolgreich erstellt!","selectionError":"Fehler bei Erstellung","selectionUpdated":"Erfolgreich aktualisiert!","selectionErrorUpdate":"Fehler bei Aktualisierung","groupUpdated":"Gruppe erfolgreich aktualisiert!","userUpdated":"Nutzer erfolgreich aktualisiert!","warningAttributeRemoved":"Gel\xf6schtes Attribut enthalten, bitte anpassen!","success":"Erfolgreich durchgef\xfchrt!","error":"Fehler!","warning":"Warnung!","coreBenefitMethod":"","fromStatusAsset":"","toStatusAsset":"","classificationOfAssetAttribute":"","mandatoryActCostAttr":"","parameters":"","addParameter":"","addCurve":"","parameterCreate":"","parameterDetail":"","parameterAttributeYear":"","parameterAttribute":"","toTheResults":"","startClassification":"","endClassification":"","parameterUpdated":"","downloadZip":"","allGroups":"","totalPackageCost":"","allAreas":"","parameterandkpi":"","visualizationValue":"","coefficientAttribute":"","coefficientForecastOnly":"","curveRangeChart":"","evaluationDelete":"","wannaDeleteThisEvaluation":"","legend":"","cannotDeleteKeyPerformanceIndicator":"","kpiDelete":"","wannaDeleteThisKeyPerformanceIndicator":"","allPackages":"","analysisStarted":"","modelingResultDeleted":"","wannaDeleteThisModelingResult":"","parameterContainsCurves":"","parameterContainsEvaluation":"","wannaDeleteThisSelectionArea":"","significantNumber":"","recalculateLifeCycleAge":"","assetAttributeYear":"","parameterClasses":"","evaluation":"","addEvaluation":"","classTransformation":"","evaluationFilter":"","evaluationCreate":"","evaluationDetail":"","className":"","startParameter":"","endParameter":"","curveDetail":"","curveCreate":"","curve":"","curveRange":"","curveFilters":"","curveActivityEffects":"","startAge":"","endAge":"","startValue":"","endValue":"","changeToCurve":"","curveUpdated":"","curveErrorUpdate":"","curveCreated":"","curveError":"","kpi":"","addKpi":"","kpiClassification":"","kpiCreate":"","kpiDetail":"","evaluationMethod":"","kpiUpdated":"","evaluationParameters":"","evaluationFilters":"","useAttribute":"","parameter":"","additionalProportion":"","increasingValue":"","recalculateWeight":"","weightAverage":"","multiply":"","evaluationCreated":"","evaluationUpdated":"","evaluationError":"","evaluationErrorUpdate":"","activityPlan":"","resultVisualization":"","weightedAverageCharts":"","distributionCharts":"","activityCharts":"","resultCharts":"","weightAverageCharts":"","projectResult":"","visualization":"","dataValues":"","year":"","currency":"","curveDelete":"","wannaDeleteThisCurve":"","parameterDelete":"","wannaDeleteThisParameter":"","resultFailed":"","filtersError":"","sumarizedCostCharts":"","performanceBefore":"","performanceAfter":""}');


/*!
  * vue-i18n v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ /*!
  * shared v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ /**
 * Original Utilities
 * written by kazuya kawaguchi
 */ const $fbd1e3bc010bc8c2$export$620a268685f0ac45 = typeof window !== "undefined";
let $fbd1e3bc010bc8c2$export$bf7f2fce5c1cf636;
let $fbd1e3bc010bc8c2$export$83602b44513dc228;
var $fbd1e3bc010bc8c2$var$tag, $fbd1e3bc010bc8c2$var$name, $fbd1e3bc010bc8c2$var$startTag, $fbd1e3bc010bc8c2$var$endTag;
const $fbd1e3bc010bc8c2$var$RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */ function $fbd1e3bc010bc8c2$export$d9468344d3651243(message, ...args) {
    if (args.length === 1 && $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(args[0])) args = args[0];
    if (!args || !args.hasOwnProperty) args = {};
    return message.replace($fbd1e3bc010bc8c2$var$RE_ARGS, (match, identifier)=>{
        return args.hasOwnProperty(identifier) ? args[identifier] : "";
    });
}
const $fbd1e3bc010bc8c2$export$cd133c5e04906ece = (name, shareable = false)=>!shareable ? Symbol(name) : Symbol.for(name);
const $fbd1e3bc010bc8c2$export$5024ef1f92c9a364 = (locale, key, source)=>$fbd1e3bc010bc8c2$export$d704025436eaed65({
        l: locale,
        k: key,
        s: source
    });
const $fbd1e3bc010bc8c2$export$d704025436eaed65 = (json)=>JSON.stringify(json).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027");
const $fbd1e3bc010bc8c2$export$7e4aa119212bc614 = (val)=>typeof val === "number" && isFinite(val);
const $fbd1e3bc010bc8c2$export$871608497c498473 = (val)=>$fbd1e3bc010bc8c2$export$1dccc787cc36538b(val) === "[object Date]";
const $fbd1e3bc010bc8c2$export$49841c62b9eff15 = (val)=>$fbd1e3bc010bc8c2$export$1dccc787cc36538b(val) === "[object RegExp]";
const $fbd1e3bc010bc8c2$export$83b788b1a3698c03 = (val)=>$fbd1e3bc010bc8c2$export$53b83ca8eaab0383(val) && Object.keys(val).length === 0;
const $fbd1e3bc010bc8c2$export$e6e34fd1f2686227 = Object.assign;
let $fbd1e3bc010bc8c2$var$_globalThis;
const $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14 = ()=>{
    // prettier-ignore
    return $fbd1e3bc010bc8c2$var$_globalThis || ($fbd1e3bc010bc8c2$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
function $fbd1e3bc010bc8c2$export$4cf11838cdc2a8a8(rawText) {
    return rawText.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const $fbd1e3bc010bc8c2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3(obj, key) {
    return $fbd1e3bc010bc8c2$var$hasOwnProperty.call(obj, key);
}
/* eslint-enable */ /**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */ const $fbd1e3bc010bc8c2$export$43bee75e5e14138e = Array.isArray;
const $fbd1e3bc010bc8c2$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $fbd1e3bc010bc8c2$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238 = (val)=>typeof val === "boolean";
const $fbd1e3bc010bc8c2$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fbd1e3bc010bc8c2$export$4369c812aac99591 = (val)=>{
    return $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val) && $fbd1e3bc010bc8c2$export$f6e2535fb5126e54(val.then) && $fbd1e3bc010bc8c2$export$f6e2535fb5126e54(val.catch);
};
const $fbd1e3bc010bc8c2$export$830c053460e5ddf6 = Object.prototype.toString;
const $fbd1e3bc010bc8c2$export$1dccc787cc36538b = (value)=>$fbd1e3bc010bc8c2$export$830c053460e5ddf6.call(value);
const $fbd1e3bc010bc8c2$export$53b83ca8eaab0383 = (val)=>{
    if (!$fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val)) return false;
    const proto = Object.getPrototypeOf(val);
    return proto === null || proto.constructor === Object;
};
// for converting list and named values to displayed strings.
const $fbd1e3bc010bc8c2$export$b5b1545233b45293 = (val)=>{
    return val == null ? "" : $fbd1e3bc010bc8c2$export$43bee75e5e14138e(val) || $fbd1e3bc010bc8c2$export$53b83ca8eaab0383(val) && val.toString === $fbd1e3bc010bc8c2$export$830c053460e5ddf6 ? JSON.stringify(val, null, 2) : String(val);
};
function $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd(items, separator = "") {
    return items.reduce((str, item, index)=>index === 0 ? str + item : str + separator + item, "");
}
const $fbd1e3bc010bc8c2$var$RANGE = 2;
function $fbd1e3bc010bc8c2$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    const lines = source.split(/\r?\n/);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + 1;
        if (count >= start) {
            for(let j = i - $fbd1e3bc010bc8c2$var$RANGE; j <= i + $fbd1e3bc010bc8c2$var$RANGE || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(3 - String(line).length)}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    const pad = start - (count - lineLength) + 1;
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $fbd1e3bc010bc8c2$export$47db5deb603dfca1(code) {
    let current = code;
    return ()=>++current;
}
function $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d(msg, err) {
    if (typeof console !== "undefined") {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */ if (err) console.warn(err.stack);
    }
}
const $fbd1e3bc010bc8c2$var$hasWarned = {};
function $fbd1e3bc010bc8c2$export$5b28268982f175ba(msg) {
    if (!$fbd1e3bc010bc8c2$var$hasWarned[msg]) {
        $fbd1e3bc010bc8c2$var$hasWarned[msg] = true;
        $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d(msg);
    }
}
/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */ /**
 * Create a event emitter
 *
 * @returns An event emitter
 */ function $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1() {
    const events = new Map();
    const emitter = {
        events: events,
        on (event, handler) {
            const handlers = events.get(event);
            const added = handlers && handlers.push(handler);
            if (!added) events.set(event, [
                handler
            ]);
        },
        off (event, handler) {
            const handlers = events.get(event);
            if (handlers) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit (event, payload) {
            (events.get(event) || []).slice().map((handler)=>handler(payload));
            (events.get("*") || []).slice().map((handler)=>handler(event, payload));
        }
    };
    return emitter;
}
const $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray = (val)=>!$fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val) || $fbd1e3bc010bc8c2$export$43bee75e5e14138e(val);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $fbd1e3bc010bc8c2$export$6c40052bed430212(src, des) {
    // src and des should both be objects, and none of them can be a array
    if ($fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(src) || $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(des)) throw new Error("Invalid value");
    const stack = [
        {
            src: src,
            des: des
        }
    ];
    while(stack.length){
        const { src: src, des: des } = stack.pop();
        Object.keys(src).forEach((key)=>{
            if ($fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(src[key]) || $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(des[key])) // replace with src[key] when:
            // src[key] or des[key] is not an object, or
            // src[key] or des[key] is an array
            des[key] = src[key];
            else // src[key] and des[key] are both objects, merge them
            stack.push({
                src: src[key],
                des: des[key]
            });
        });
    }
}


/*!
  * core-base v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ 
/*!
  * message-compiler v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ 
const $b46efaa99568cb1e$export$7119efed969a17d8 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    }
};
function $b46efaa99568cb1e$export$edb4795983846c10(line, column, offset) {
    return {
        line: line,
        column: column,
        offset: offset
    };
}
function $b46efaa99568cb1e$export$90c043f1c57770b8(start, end, source) {
    const loc = {
        start: start,
        end: end
    };
    if (source != null) loc.source = source;
    return loc;
}
const $b46efaa99568cb1e$export$21499b937901db8a = {
    USE_MODULO_SYNTAX: 1,
    __EXTEND_POINT__: 2
};
/** @internal */ const $b46efaa99568cb1e$export$a9ce0120dbc716f9 = {
    [$b46efaa99568cb1e$export$21499b937901db8a.USE_MODULO_SYNTAX]: `Use modulo before '{{0}}'.`
};
function $b46efaa99568cb1e$export$b5ca1ea40a366b08(code, loc, ...args) {
    const msg = code;
    const message = {
        message: String(msg),
        code: code
    };
    if (loc) message.location = loc;
    return message;
}
const $b46efaa99568cb1e$export$77436aae039469c4 = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // generator error codes
    UNHANDLED_CODEGEN_NODE_TYPE: 15,
    // minifier error codes
    UNHANDLED_MINIFIER_NODE_TYPE: 16,
    // Special value for higher-order compilers to pick up the last code
    // to avoid collision of error codes. This should always be kept as the last
    // item.
    __EXTEND_POINT__: 17
};
/** @internal */ const $b46efaa99568cb1e$export$d8bd0967cb58683 = {
    // tokenizer error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN]: `Expected token: '{0}'`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER]: `Invalid token in placeholder: '{0}'`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: `Unterminated single quote in placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE]: `Unknown escape sequence: \\{0}`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE]: `Invalid unicode escape sequence: {0}`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE]: `Unbalanced closing brace`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE]: `Unterminated closing brace`,
    [$b46efaa99568cb1e$export$77436aae039469c4.EMPTY_PLACEHOLDER]: `Empty placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER]: `Not allowed nest placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT]: `Invalid linked format`,
    // parser error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL]: `Plural must have messages`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER]: `Unexpected empty linked modifier`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY]: `Unexpected empty linked key`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS]: `Unexpected lexical analysis in token: '{0}'`,
    // generator error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.UNHANDLED_CODEGEN_NODE_TYPE]: `unhandled codegen node type: '{0}'`,
    // minimizer error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.UNHANDLED_MINIFIER_NODE_TYPE]: `unhandled mimifier node type: '{0}'`
};
function $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, options = {}) {
    const { domain: domain, messages: messages, args: args } = options;
    const msg = code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) error.location = loc;
    error.domain = domain;
    return error;
}
/** @internal */ function $b46efaa99568cb1e$export$ad0eb2c702f03471(error) {
    throw error;
}
// eslint-disable-next-line no-useless-escape
const $b46efaa99568cb1e$var$RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
const $b46efaa99568cb1e$export$6de85467cbd6ae39 = (source)=>$b46efaa99568cb1e$var$RE_HTML_TAG.test(source);
const $b46efaa99568cb1e$var$CHAR_SP = " ";
const $b46efaa99568cb1e$var$CHAR_CR = "\r";
const $b46efaa99568cb1e$var$CHAR_LF = "\n";
const $b46efaa99568cb1e$var$CHAR_LS = String.fromCharCode(0x2028);
const $b46efaa99568cb1e$var$CHAR_PS = String.fromCharCode(0x2029);
function $b46efaa99568cb1e$var$createScanner(str) {
    const _buf = str;
    let _index = 0;
    let _line = 1;
    let _column = 1;
    let _peekOffset = 0;
    const isCRLF = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_CR && _buf[index + 1] === $b46efaa99568cb1e$var$CHAR_LF;
    const isLF = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_LF;
    const isPS = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_PS;
    const isLS = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_LS;
    const isLineEnd = (index)=>isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    const index = ()=>_index;
    const line = ()=>_line;
    const column = ()=>_column;
    const peekOffset = ()=>_peekOffset;
    const charAt = (offset)=>isCRLF(offset) || isPS(offset) || isLS(offset) ? $b46efaa99568cb1e$var$CHAR_LF : _buf[offset];
    const currentChar = ()=>charAt(_index);
    const currentPeek = ()=>charAt(_index + _peekOffset);
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) _index++;
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) _peekOffset++;
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek(offset = 0) {
        _peekOffset = offset;
    }
    function skipToPeek() {
        const target = _index + _peekOffset;
        // eslint-disable-next-line no-unmodified-loop-condition
        while(target !== _index)next();
        _peekOffset = 0;
    }
    return {
        index: index,
        line: line,
        column: column,
        peekOffset: peekOffset,
        charAt: charAt,
        currentChar: currentChar,
        currentPeek: currentPeek,
        next: next,
        peek: peek,
        reset: reset,
        resetPeek: resetPeek,
        skipToPeek: skipToPeek
    };
}
const $b46efaa99568cb1e$var$EOF = undefined;
const $b46efaa99568cb1e$var$DOT = ".";
const $b46efaa99568cb1e$var$LITERAL_DELIMITER = "'";
const $b46efaa99568cb1e$var$ERROR_DOMAIN$3 = "tokenizer";
function $b46efaa99568cb1e$var$createTokenizer(source, options = {}) {
    const location = options.location !== false;
    const _scnr = $b46efaa99568cb1e$var$createScanner(source);
    const currentOffset = ()=>_scnr.index();
    const currentPosition = ()=>$b46efaa99568cb1e$export$edb4795983846c10(_scnr.line(), _scnr.column(), _scnr.index());
    const _initLoc = currentPosition();
    const _initOffset = currentOffset();
    const _context = {
        currentType: 14 /* TokenTypes.EOF */ ,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 14 /* TokenTypes.EOF */ ,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ""
    };
    const context = ()=>_context;
    const { onError: onError } = options;
    function emitError(code, pos, offset, ...args) {
        const ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(ctx.startLoc, pos) : null;
            const err = $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, {
                domain: $b46efaa99568cb1e$var$ERROR_DOMAIN$3,
                args: args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        const token = {
            type: type
        };
        if (location) token.loc = $b46efaa99568cb1e$export$90c043f1c57770b8(context.startLoc, context.endLoc);
        if (value != null) token.value = value;
        return token;
    }
    const getEndToken = (context)=>getToken(context, 14 /* TokenTypes.EOF */ );
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        } else {
            emitError($b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return "";
        }
    }
    function peekSpaces(scnr) {
        let buf = "";
        while(scnr.currentPeek() === $b46efaa99568cb1e$var$CHAR_SP || scnr.currentPeek() === $b46efaa99568cb1e$var$CHAR_LF){
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        const buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === $b46efaa99568cb1e$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc === 95 // _
        ;
    }
    function isNumberStart(ch) {
        if (ch === $b46efaa99568cb1e$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ch = scnr.currentPeek() === "-" ? scnr.peek() : scnr.currentPeek();
        const ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === $b46efaa99568cb1e$var$LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 8 /* TokenTypes.LinkedAlias */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "." /* TokenChars.LinkedDot */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 9 /* TokenTypes.LinkedDot */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        const { currentType: currentType } = context;
        if (!(currentType === 8 /* TokenTypes.LinkedAlias */  || currentType === 12 /* TokenTypes.LinkedModifier */ )) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === ":" /* TokenChars.LinkedDelimiter */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 10 /* TokenTypes.LinkedDelimiter */ ) return false;
        const fn = ()=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return isIdentifierStart(scnr.peek());
            else if (ch === "@" /* TokenChars.LinkedAlias */  || ch === "%" /* TokenChars.Modulo */  || ch === "|" /* TokenChars.Pipe */  || ch === ":" /* TokenChars.LinkedDelimiter */  || ch === "." /* TokenChars.LinkedDot */  || ch === $b46efaa99568cb1e$var$CHAR_SP || !ch) return false;
            else if (ch === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.peek();
                return fn();
            } else // other characters
            return isTextStart(scnr, false);
        };
        const ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "|" /* TokenChars.Pipe */ ;
        scnr.resetPeek();
        return ret;
    }
    function detectModuloStart(scnr) {
        const spaces = peekSpaces(scnr);
        const ret = scnr.currentPeek() === "%" /* TokenChars.Modulo */  && scnr.peek() === "{" /* TokenChars.BraceLeft */ ;
        scnr.resetPeek();
        return {
            isModulo: ret,
            hasSpace: spaces.length > 0
        };
    }
    function isTextStart(scnr, reset = true) {
        const fn = (hasSpace = false, prev = "", detectModulo = false)=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return prev === "%" /* TokenChars.Modulo */  ? false : hasSpace;
            else if (ch === "@" /* TokenChars.LinkedAlias */  || !ch) return prev === "%" /* TokenChars.Modulo */  ? true : hasSpace;
            else if (ch === "%" /* TokenChars.Modulo */ ) {
                scnr.peek();
                return fn(hasSpace, "%" /* TokenChars.Modulo */ , true);
            } else if (ch === "|" /* TokenChars.Pipe */ ) return prev === "%" /* TokenChars.Modulo */  || detectModulo ? true : !(prev === $b46efaa99568cb1e$var$CHAR_SP || prev === $b46efaa99568cb1e$var$CHAR_LF);
            else if (ch === $b46efaa99568cb1e$var$CHAR_SP) {
                scnr.peek();
                return fn(true, $b46efaa99568cb1e$var$CHAR_SP, detectModulo);
            } else if (ch === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.peek();
                return fn(true, $b46efaa99568cb1e$var$CHAR_LF, detectModulo);
            } else return true;
        };
        const ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        const ch = scnr.currentChar();
        if (ch === $b46efaa99568cb1e$var$EOF) return $b46efaa99568cb1e$var$EOF;
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function isIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 // $
        ;
    }
    function takeIdentifierChar(scnr) {
        return takeChar(scnr, isIdentifier);
    }
    function isNamedIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 || // $
        cc === 45 // -
        ;
    }
    function takeNamedIdentifierChar(scnr) {
        return takeChar(scnr, isNamedIdentifier);
    }
    function isDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function takeDigit(scnr) {
        return takeChar(scnr, isDigit);
    }
    function isHexDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57 || // 0-9
        cc >= 65 && cc <= 70 || // A-F
        cc >= 97 && cc <= 102; // a-f
    }
    function takeHexDigit(scnr) {
        return takeChar(scnr, isHexDigit);
    }
    function getDigits(scnr) {
        let ch = "";
        let num = "";
        while(ch = takeDigit(scnr))num += ch;
        return num;
    }
    function readModulo(scnr) {
        skipSpaces(scnr);
        const ch = scnr.currentChar();
        if (ch !== "%" /* TokenChars.Modulo */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
        scnr.next();
        return "%" /* TokenChars.Modulo */ ;
    }
    function readText(scnr) {
        let buf = "";
        // eslint-disable-next-line no-constant-condition
        while(true){
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "}" /* TokenChars.BraceRight */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || !ch) break;
            else if (ch === "%" /* TokenChars.Modulo */ ) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else break;
            } else if (ch === $b46efaa99568cb1e$var$CHAR_SP || ch === $b46efaa99568cb1e$var$CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else if (isPluralStart(scnr)) break;
                else {
                    buf += ch;
                    scnr.next();
                }
            } else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = "";
        let name = "";
        while(ch = takeNamedIdentifierChar(scnr))name += ch;
        if (scnr.currentChar() === $b46efaa99568cb1e$var$EOF) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        let value = "";
        if (scnr.currentChar() === "-") {
            scnr.next();
            value += `-${getDigits(scnr)}`;
        } else value += getDigits(scnr);
        if (scnr.currentChar() === $b46efaa99568cb1e$var$EOF) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return value;
    }
    function isLiteral(ch) {
        return ch !== $b46efaa99568cb1e$var$LITERAL_DELIMITER && ch !== $b46efaa99568cb1e$var$CHAR_LF;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        let ch = "";
        let literal = "";
        while(ch = takeChar(scnr, isLiteral))if (ch === "\\") literal += readEscapeSequence(scnr);
        else literal += ch;
        const current = scnr.currentChar();
        if (current === $b46efaa99568cb1e$var$CHAR_LF || current === $b46efaa99568cb1e$var$EOF) {
            emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.next();
                // eslint-disable-next-line no-useless-escape
                eat(scnr, `\'`);
            }
            return literal;
        }
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        return literal;
    }
    function readEscapeSequence(scnr) {
        const ch = scnr.currentChar();
        switch(ch){
            case "\\":
            case `\'`:
                scnr.next();
                return `\\${ch}`;
            case "u":
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case "U":
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError($b46efaa99568cb1e$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return "";
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        let sequence = "";
        for(let i = 0; i < digits; i++){
            const ch = takeHexDigit(scnr);
            if (!ch) {
                emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
                break;
            }
            sequence += ch;
        }
        return `\\${unicode}${sequence}`;
    }
    function isInvalidIdentifier(ch) {
        return ch !== "{" /* TokenChars.BraceLeft */  && ch !== "}" /* TokenChars.BraceRight */  && ch !== $b46efaa99568cb1e$var$CHAR_SP && ch !== $b46efaa99568cb1e$var$CHAR_LF;
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = "";
        let identifiers = "";
        while(ch = takeChar(scnr, isInvalidIdentifier))identifiers += ch;
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        let ch = "";
        let name = "";
        while(ch = takeIdentifierChar(scnr))name += ch;
        return name;
    }
    function readLinkedRefer(scnr) {
        const fn = (buf)=>{
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "%" /* TokenChars.Modulo */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || ch === "(" /* TokenChars.ParenLeft */  || ch === ")" /* TokenChars.ParenRight */  || !ch) return buf;
            else if (ch === $b46efaa99568cb1e$var$CHAR_SP) return buf;
            else if (ch === $b46efaa99568cb1e$var$CHAR_LF || ch === $b46efaa99568cb1e$var$DOT) {
                buf += ch;
                scnr.next();
                return fn(buf);
            } else {
                buf += ch;
                scnr.next();
                return fn(buf);
            }
        };
        return fn("");
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        const plural = eat(scnr, "|" /* TokenChars.Pipe */ );
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        let token = null;
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                if (context.braceNest >= 1) emitError($b46efaa99568cb1e$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 2 /* TokenTypes.BraceLeft */ , "{" /* TokenChars.BraceLeft */ );
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* TokenChars.BraceRight */ :
                if (context.braceNest > 0 && context.currentType === 2 /* TokenTypes.BraceLeft */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.EMPTY_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) context.inLinked = false;
                return token;
            case "@" /* TokenChars.LinkedAlias */ :
                if (context.braceNest > 0) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default:
                {
                    let validNamedIdentifier = true;
                    let validListIdentifier = true;
                    let validLiteral = true;
                    if (isPluralStart(scnr)) {
                        if (context.braceNest > 0) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                        // reset
                        context.braceNest = 0;
                        context.inLinked = false;
                        return token;
                    }
                    if (context.braceNest > 0 && (context.currentType === 5 /* TokenTypes.Named */  || context.currentType === 6 /* TokenTypes.List */  || context.currentType === 7 /* TokenTypes.Literal */ )) {
                        emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        context.braceNest = 0;
                        return readToken(scnr, context);
                    }
                    if (validNamedIdentifier = isNamedIdentifierStart(scnr, context)) {
                        token = getToken(context, 5 /* TokenTypes.Named */ , readNamedIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validListIdentifier = isListIdentifierStart(scnr, context)) {
                        token = getToken(context, 6 /* TokenTypes.List */ , readListIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validLiteral = isLiteralStart(scnr, context)) {
                        token = getToken(context, 7 /* TokenTypes.Literal */ , readLiteral(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                        // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                        token = getToken(context, 13 /* TokenTypes.InvalidPlace */ , readInvalidIdentifier(scnr));
                        emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                        skipSpaces(scnr);
                        return token;
                    }
                    break;
                }
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        const { currentType: currentType } = context;
        let token = null;
        const ch = scnr.currentChar();
        if ((currentType === 8 /* TokenTypes.LinkedAlias */  || currentType === 9 /* TokenTypes.LinkedDot */  || currentType === 12 /* TokenTypes.LinkedModifier */  || currentType === 10 /* TokenTypes.LinkedDelimiter */ ) && (ch === $b46efaa99568cb1e$var$CHAR_LF || ch === $b46efaa99568cb1e$var$CHAR_SP)) emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
        switch(ch){
            case "@" /* TokenChars.LinkedAlias */ :
                scnr.next();
                token = getToken(context, 8 /* TokenTypes.LinkedAlias */ , "@" /* TokenChars.LinkedAlias */ );
                context.inLinked = true;
                return token;
            case "." /* TokenChars.LinkedDot */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* TokenTypes.LinkedDot */ , "." /* TokenChars.LinkedDot */ );
            case ":" /* TokenChars.LinkedDelimiter */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 10 /* TokenTypes.LinkedDelimiter */ , ":" /* TokenChars.LinkedDelimiter */ );
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) || isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 12 /* TokenTypes.LinkedModifier */ , readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* TokenChars.BraceLeft */ ) // scan the placeholder
                    return readTokenInPlaceholder(scnr, context) || token;
                    else return getToken(context, 11 /* TokenTypes.LinkedKey */ , readLinkedRefer(scnr));
                }
                if (currentType === 8 /* TokenTypes.LinkedAlias */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        let token = {
            type: 14 /* TokenTypes.EOF */ 
        };
        if (context.braceNest > 0) return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        if (context.inLinked) return readTokenInLinked(scnr, context) || getEndToken(context);
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* TokenChars.BraceRight */ :
                emitError($b46efaa99568cb1e$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
            case "@" /* TokenChars.LinkedAlias */ :
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default:
                {
                    if (isPluralStart(scnr)) {
                        token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                        // reset
                        context.braceNest = 0;
                        context.inLinked = false;
                        return token;
                    }
                    const { isModulo: isModulo, hasSpace: hasSpace } = detectModuloStart(scnr);
                    if (isModulo) return hasSpace ? getToken(context, 0 /* TokenTypes.Text */ , readText(scnr)) : getToken(context, 4 /* TokenTypes.Modulo */ , readModulo(scnr));
                    if (isTextStart(scnr)) return getToken(context, 0 /* TokenTypes.Text */ , readText(scnr));
                    break;
                }
        }
        return token;
    }
    function nextToken() {
        const { currentType: currentType, offset: offset, startLoc: startLoc, endLoc: endLoc } = _context;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === $b46efaa99568cb1e$var$EOF) return getToken(_context, 14 /* TokenTypes.EOF */ );
        return readToken(_scnr, _context);
    }
    return {
        nextToken: nextToken,
        currentOffset: currentOffset,
        currentPosition: currentPosition,
        context: context
    };
}
const $b46efaa99568cb1e$export$9838302824baa7fa = "parser";
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
const $b46efaa99568cb1e$var$KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function $b46efaa99568cb1e$var$fromEscapeSequence(match, codePoint4, codePoint6) {
    switch(match){
        case `\\\\`:
            return `\\`;
        // eslint-disable-next-line no-useless-escape
        case `\\\'`:
            // eslint-disable-next-line no-useless-escape
            return `\'`;
        default:
            {
                const codePoint = parseInt(codePoint4 || codePoint6, 16);
                if (codePoint <= 0xd7ff || codePoint >= 0xe000) return String.fromCodePoint(codePoint);
                // invalid ...
                // Replace them with U+FFFD REPLACEMENT CHARACTER.
                return "\uFFFD";
            }
    }
}
function $b46efaa99568cb1e$export$88a1156fad04455f(options = {}) {
    const location = options.location !== false;
    const { onError: onError, onWarn: onWarn } = options;
    function emitError(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(start, end) : null;
            const err = $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, {
                domain: $b46efaa99568cb1e$export$9838302824baa7fa,
                args: args
            });
            onError(err);
        }
    }
    function emitWarn(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onWarn) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(start, end) : null;
            onWarn($b46efaa99568cb1e$export$b5ca1ea40a366b08(code, loc, args));
        }
    }
    function startNode(type, offset, loc) {
        const node = {
            type: type
        };
        if (location) {
            node.start = offset;
            node.end = offset;
            node.loc = {
                start: loc,
                end: loc
            };
        }
        return node;
    }
    function endNode(node, offset, pos, type) {
        if (type) node.type = type;
        if (location) {
            node.end = offset;
            if (node.loc) node.loc.end = pos;
        }
    }
    function parseText(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(3 /* NodeTypes.Text */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(5 /* NodeTypes.List */ , offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key, modulo) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(4 /* NodeTypes.Named */ , offset, loc);
        node.key = key;
        if (modulo === true) node.modulo = true;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(9 /* NodeTypes.Literal */ , offset, loc);
        node.value = value.replace($b46efaa99568cb1e$var$KNOWN_ESCAPES, $b46efaa99568cb1e$var$fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        const token = tokenizer.nextToken();
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get linked dot loc
        const node = startNode(8 /* NodeTypes.LinkedModifier */ , offset, loc);
        if (token.type !== 12 /* TokenTypes.LinkedModifier */ ) {
            // empty modifier
            emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = "";
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node: node
            };
        }
        // check token
        if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
        node.value = token.value || "";
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(7 /* NodeTypes.LinkedKey */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        const context = tokenizer.context();
        const linkedNode = startNode(6 /* NodeTypes.Linked */ , context.offset, context.startLoc);
        let token = tokenizer.nextToken();
        if (token.type === 9 /* TokenTypes.LinkedDot */ ) {
            const parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 10 /* TokenTypes.LinkedDelimiter */ ) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* TokenTypes.BraceLeft */ ) token = tokenizer.nextToken();
        switch(token.type){
            case 11 /* TokenTypes.LinkedKey */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseLinkedKey(tokenizer, token.value || "");
                break;
            case 5 /* TokenTypes.Named */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseNamed(tokenizer, token.value || "");
                break;
            case 6 /* TokenTypes.List */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseList(tokenizer, token.value || "");
                break;
            case 7 /* TokenTypes.Literal */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseLiteral(tokenizer, token.value || "");
                break;
            default:
                {
                    // empty key
                    emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                    const nextContext = tokenizer.context();
                    const emptyLinkedKeyNode = startNode(7 /* NodeTypes.LinkedKey */ , nextContext.offset, nextContext.startLoc);
                    emptyLinkedKeyNode.value = "";
                    endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                    linkedNode.key = emptyLinkedKeyNode;
                    endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                    return {
                        nextConsumeToken: token,
                        node: linkedNode
                    };
                }
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        const context = tokenizer.context();
        const startOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? tokenizer.currentOffset() : context.offset;
        const startLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.endLoc : context.startLoc;
        const node = startNode(2 /* NodeTypes.Message */ , startOffset, startLoc);
        node.items = [];
        let nextToken = null;
        let modulo = null;
        do {
            const token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch(token.type){
                case 0 /* TokenTypes.Text */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseText(tokenizer, token.value || ""));
                    break;
                case 6 /* TokenTypes.List */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseList(tokenizer, token.value || ""));
                    break;
                case 4 /* TokenTypes.Modulo */ :
                    modulo = true;
                    break;
                case 5 /* TokenTypes.Named */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseNamed(tokenizer, token.value || "", !!modulo));
                    if (modulo) {
                        emitWarn(tokenizer, $b46efaa99568cb1e$export$21499b937901db8a.USE_MODULO_SYNTAX, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                        modulo = null;
                    }
                    break;
                case 7 /* TokenTypes.Literal */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseLiteral(tokenizer, token.value || ""));
                    break;
                case 8 /* TokenTypes.LinkedAlias */ :
                    {
                        const parsed = parseLinked(tokenizer);
                        node.items.push(parsed.node);
                        nextToken = parsed.nextConsumeToken || null;
                        break;
                    }
            }
        }while (context.currentType !== 14 /* TokenTypes.EOF */  && context.currentType !== 1 /* TokenTypes.Pipe */ );
        // adjust message node loc
        const endOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastOffset : tokenizer.currentOffset();
        const endLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastEndLoc : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        const context = tokenizer.context();
        let hasEmptyMessage = msgNode.items.length === 0;
        const node = startNode(1 /* NodeTypes.Plural */ , offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            const msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) hasEmptyMessage = msg.items.length === 0;
            node.cases.push(msg);
        }while (context.currentType !== 14 /* TokenTypes.EOF */ );
        if (hasEmptyMessage) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        const context = tokenizer.context();
        const { offset: offset, startLoc: startLoc } = context;
        const msgNode = parseMessage(tokenizer);
        if (context.currentType === 14 /* TokenTypes.EOF */ ) return msgNode;
        else return parsePlural(tokenizer, offset, startLoc, msgNode);
    }
    function parse(source) {
        const tokenizer = $b46efaa99568cb1e$var$createTokenizer(source, (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, options));
        const context = tokenizer.context();
        const node = startNode(0 /* NodeTypes.Resource */ , context.offset, context.startLoc);
        if (location && node.loc) node.loc.source = source;
        node.body = parseResource(tokenizer);
        if (options.onCacheKey) node.cacheKey = options.onCacheKey(source);
        // assert whether achieved to EOF
        if (context.currentType !== 14 /* TokenTypes.EOF */ ) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || "");
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return {
        parse: parse
    };
}
function $b46efaa99568cb1e$var$getTokenCaption(token) {
    if (token.type === 14 /* TokenTypes.EOF */ ) return "EOF";
    const name = (token.value || "").replace(/\r?\n/gu, "\\n");
    return name.length > 10 ? name.slice(0, 9) + "\u2026" : name;
}
function $b46efaa99568cb1e$var$createTransformer(ast, options = {} // eslint-disable-line
) {
    const _context = {
        ast: ast,
        helpers: new Set()
    };
    const context = ()=>_context;
    const helper = (name)=>{
        _context.helpers.add(name);
        return name;
    };
    return {
        context: context,
        helper: helper
    };
}
function $b46efaa99568cb1e$var$traverseNodes(nodes, transformer) {
    for(let i = 0; i < nodes.length; i++)$b46efaa99568cb1e$var$traverseNode(nodes[i], transformer);
}
function $b46efaa99568cb1e$var$traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch(node.type){
        case 1 /* NodeTypes.Plural */ :
            $b46efaa99568cb1e$var$traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* HelperNameMap.PLURAL */ );
            break;
        case 2 /* NodeTypes.Message */ :
            $b46efaa99568cb1e$var$traverseNodes(node.items, transformer);
            break;
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $b46efaa99568cb1e$var$traverseNode(linked.key, transformer);
                transformer.helper("linked" /* HelperNameMap.LINKED */ );
                transformer.helper("type" /* HelperNameMap.TYPE */ );
                break;
            }
        case 5 /* NodeTypes.List */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("list" /* HelperNameMap.LIST */ );
            break;
        case 4 /* NodeTypes.Named */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("named" /* HelperNameMap.NAMED */ );
            break;
    }
// TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function $b46efaa99568cb1e$var$transform(ast, options = {} // eslint-disable-line
) {
    const transformer = $b46efaa99568cb1e$var$createTransformer(ast);
    transformer.helper("normalize" /* HelperNameMap.NORMALIZE */ );
    // traverse
    ast.body && $b46efaa99568cb1e$var$traverseNode(ast.body, transformer);
    // set meta information
    const context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}
function $b46efaa99568cb1e$var$optimize(ast) {
    const body = ast.body;
    if (body.type === 2 /* NodeTypes.Message */ ) $b46efaa99568cb1e$var$optimizeMessageNode(body);
    else body.cases.forEach((c)=>$b46efaa99568cb1e$var$optimizeMessageNode(c));
    return ast;
}
function $b46efaa99568cb1e$var$optimizeMessageNode(message) {
    if (message.items.length === 1) {
        const item = message.items[0];
        if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) {
            message.static = item.value;
            delete item.value; // optimization for size
        }
    } else {
        const values = [];
        for(let i = 0; i < message.items.length; i++){
            const item = message.items[i];
            if (!(item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ )) break;
            if (item.value == null) break;
            values.push(item.value);
        }
        if (values.length === message.items.length) {
            message.static = (0, $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd)(values);
            for(let i = 0; i < message.items.length; i++){
                const item = message.items[i];
                if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) delete item.value; // optimization for size
            }
        }
    }
}
const $b46efaa99568cb1e$var$ERROR_DOMAIN$1 = "minifier";
/* eslint-disable @typescript-eslint/no-explicit-any */ function $b46efaa99568cb1e$var$minify(node) {
    node.t = node.type;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            {
                const resource = node;
                $b46efaa99568cb1e$var$minify(resource.body);
                resource.b = resource.body;
                delete resource.body;
                break;
            }
        case 1 /* NodeTypes.Plural */ :
            {
                const plural = node;
                const cases = plural.cases;
                for(let i = 0; i < cases.length; i++)$b46efaa99568cb1e$var$minify(cases[i]);
                plural.c = cases;
                delete plural.cases;
                break;
            }
        case 2 /* NodeTypes.Message */ :
            {
                const message = node;
                const items = message.items;
                for(let i = 0; i < items.length; i++)$b46efaa99568cb1e$var$minify(items[i]);
                message.i = items;
                delete message.items;
                if (message.static) {
                    message.s = message.static;
                    delete message.static;
                }
                break;
            }
        case 3 /* NodeTypes.Text */ :
        case 9 /* NodeTypes.Literal */ :
        case 8 /* NodeTypes.LinkedModifier */ :
        case 7 /* NodeTypes.LinkedKey */ :
            {
                const valueNode = node;
                if (valueNode.value) {
                    valueNode.v = valueNode.value;
                    delete valueNode.value;
                }
                break;
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $b46efaa99568cb1e$var$minify(linked.key);
                linked.k = linked.key;
                delete linked.key;
                if (linked.modifier) {
                    $b46efaa99568cb1e$var$minify(linked.modifier);
                    linked.m = linked.modifier;
                    delete linked.modifier;
                }
                break;
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                list.i = list.index;
                delete list.index;
                break;
            }
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                named.k = named.key;
                delete named.key;
                break;
            }
        default:
    }
    delete node.type;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ // eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="source-map-js" />
const $b46efaa99568cb1e$var$ERROR_DOMAIN = "parser";
function $b46efaa99568cb1e$var$createCodeGenerator(ast, options) {
    const { sourceMap: sourceMap, filename: filename, breakLineCode: breakLineCode, needIndent: _needIndent } = options;
    const location = options.location !== false;
    const _context = {
        filename: filename,
        code: "",
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode: breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    if (location && ast.loc) _context.source = ast.loc.source;
    const context = ()=>_context;
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n, withBreakLine = true) {
        const _breakLineCode = withBreakLine ? breakLineCode : "";
        push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
    }
    function indent(withNewLine = true) {
        const level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent(withNewLine = true) {
        const level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    const helper = (key)=>`_${key}`;
    const needIndent = ()=>_context.needIndent;
    return {
        context: context,
        push: push,
        indent: indent,
        deindent: deindent,
        newline: newline,
        helper: helper,
        needIndent: needIndent
    };
}
function $b46efaa99568cb1e$var$generateLinkedNode(generator, node) {
    const { helper: helper } = generator;
    generator.push(`${helper("linked" /* HelperNameMap.LINKED */ )}(`);
    $b46efaa99568cb1e$var$generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(`, `);
        $b46efaa99568cb1e$var$generateNode(generator, node.modifier);
        generator.push(`, _type`);
    } else generator.push(`, undefined, _type`);
    generator.push(`)`);
}
function $b46efaa99568cb1e$var$generateMessageNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    generator.push(`${helper("normalize" /* HelperNameMap.NORMALIZE */ )}([`);
    generator.indent(needIndent());
    const length = node.items.length;
    for(let i = 0; i < length; i++){
        $b46efaa99568cb1e$var$generateNode(generator, node.items[i]);
        if (i === length - 1) break;
        generator.push(", ");
    }
    generator.deindent(needIndent());
    generator.push("])");
}
function $b46efaa99568cb1e$var$generatePluralNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    if (node.cases.length > 1) {
        generator.push(`${helper("plural" /* HelperNameMap.PLURAL */ )}([`);
        generator.indent(needIndent());
        const length = node.cases.length;
        for(let i = 0; i < length; i++){
            $b46efaa99568cb1e$var$generateNode(generator, node.cases[i]);
            if (i === length - 1) break;
            generator.push(", ");
        }
        generator.deindent(needIndent());
        generator.push(`])`);
    }
}
function $b46efaa99568cb1e$var$generateResource(generator, node) {
    if (node.body) $b46efaa99568cb1e$var$generateNode(generator, node.body);
    else generator.push("null");
}
function $b46efaa99568cb1e$var$generateNode(generator, node) {
    const { helper: helper } = generator;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            $b46efaa99568cb1e$var$generateResource(generator, node);
            break;
        case 1 /* NodeTypes.Plural */ :
            $b46efaa99568cb1e$var$generatePluralNode(generator, node);
            break;
        case 2 /* NodeTypes.Message */ :
            $b46efaa99568cb1e$var$generateMessageNode(generator, node);
            break;
        case 6 /* NodeTypes.Linked */ :
            $b46efaa99568cb1e$var$generateLinkedNode(generator, node);
            break;
        case 8 /* NodeTypes.LinkedModifier */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* NodeTypes.LinkedKey */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* NodeTypes.List */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("list" /* HelperNameMap.LIST */ )}(${node.index}))`, node);
            break;
        case 4 /* NodeTypes.Named */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("named" /* HelperNameMap.NAMED */ )}(${JSON.stringify(node.key)}))`, node);
            break;
        case 9 /* NodeTypes.Literal */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* NodeTypes.Text */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
    }
}
// generate code from AST
const $b46efaa99568cb1e$var$generate = (ast, options = {} // eslint-disable-line
)=>{
    const mode = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.mode) ? options.mode : "normal";
    const filename = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.filename) ? options.filename : "message.intl";
    const sourceMap = !!options.sourceMap;
    // prettier-ignore
    const breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === "arrow" ? ";" : "\n";
    const needIndent = options.needIndent ? options.needIndent : mode !== "arrow";
    const helpers = ast.helpers || [];
    const generator = $b46efaa99568cb1e$var$createCodeGenerator(ast, {
        mode: mode,
        filename: filename,
        sourceMap: sourceMap,
        breakLineCode: breakLineCode,
        needIndent: needIndent
    });
    generator.push(mode === "normal" ? `function __msg__ (ctx) {` : `(ctx) => {`);
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push(`const { ${(0, $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd)(helpers.map((s)=>`${s}: _${s}`), ", ")} } = ctx`);
        generator.newline();
    }
    generator.push(`return `);
    $b46efaa99568cb1e$var$generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push(`}`);
    delete ast.helpers;
    const { code: code, map: map } = generator.context();
    return {
        ast: ast,
        code: code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};
function $b46efaa99568cb1e$export$3243579822c486a0(source, options = {}) {
    const assignedOptions = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, options);
    const jit = !!assignedOptions.jit;
    const enalbeMinify = !!assignedOptions.minify;
    const enambeOptimize = assignedOptions.optimize == null ? true : assignedOptions.optimize;
    // parse source codes
    const parser = $b46efaa99568cb1e$export$88a1156fad04455f(assignedOptions);
    const ast = parser.parse(source);
    if (!jit) {
        // transform ASTs
        $b46efaa99568cb1e$var$transform(ast, assignedOptions);
        // generate javascript codes
        return $b46efaa99568cb1e$var$generate(ast, assignedOptions);
    } else {
        // optimize ASTs
        enambeOptimize && $b46efaa99568cb1e$var$optimize(ast);
        // minimize ASTs
        enalbeMinify && $b46efaa99568cb1e$var$minify(ast);
        // In JIT mode, no ast transform, no code generation.
        return {
            ast: ast,
            code: ""
        };
    }
}


/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $a739018d680a1535$var$initFeatureFlags() {
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;
    if (typeof __INTLIFY_JIT_COMPILATION__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_JIT_COMPILATION__ = false;
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
}
const $a739018d680a1535$var$pathStateMachine = [];
$a739018d680a1535$var$pathStateMachine[0 /* States.BEFORE_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        0 /* States.BEFORE_PATH */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[1 /* States.IN_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[2 /* States.BEFORE_IDENT */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[3 /* States.IN_IDENT */ ] = {
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ ,
        1 /* Actions.PUSH */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ ,
        1 /* Actions.PUSH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[4 /* States.IN_SUB_PATH */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ['"' /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        2 /* Actions.INC_SUB_PATH_DEPTH */ 
    ],
    ["]" /* PathCharTypes.RIGHT_BRACKET */ ]: [
        1 /* States.IN_PATH */ ,
        3 /* Actions.PUSH_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[5 /* States.IN_SINGLE_QUOTE */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[6 /* States.IN_DOUBLE_QUOTE */ ] = {
    ['"' /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
/**
 * Check if an expression is a literal value.
 */ const $a739018d680a1535$var$literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function $a739018d680a1535$var$isLiteral(exp) {
    return $a739018d680a1535$var$literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */ function $a739018d680a1535$var$stripQuotes(str) {
    const a = str.charCodeAt(0);
    const b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */ function $a739018d680a1535$var$getPathCharType(ch) {
    if (ch === undefined || ch === null) return "o" /* PathCharTypes.END_OF_FAIL */ ;
    const code = ch.charCodeAt(0);
    switch(code){
        case 0x5b:
        case 0x5d:
        case 0x2e:
        case 0x22:
        case 0x27:
            return ch;
        case 0x5f:
        case 0x24:
        case 0x2d:
            return "i" /* PathCharTypes.IDENT */ ;
        case 0x09:
        case 0x0a:
        case 0x0d:
        case 0xa0:
        case 0xfeff:
        case 0x2028:
        case 0x2029:
            return "w" /* PathCharTypes.WORKSPACE */ ;
    }
    return "i" /* PathCharTypes.IDENT */ ;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */ function $a739018d680a1535$var$formatSubPath(path) {
    const trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === "0" && isNaN(parseInt(path))) return false;
    return $a739018d680a1535$var$isLiteral(trimmed) ? $a739018d680a1535$var$stripQuotes(trimmed) : "*" /* PathCharTypes.ASTARISK */  + trimmed;
}
/**
 * Parse a string path into an array of segments
 */ function $a739018d680a1535$export$98e6a39c04603d36(path) {
    const keys = [];
    let index = -1;
    let mode = 0 /* States.BEFORE_PATH */ ;
    let subPathDepth = 0;
    let c;
    let key; // eslint-disable-line
    let newChar;
    let type;
    let transition;
    let action;
    let typeMap;
    const actions = [];
    actions[0 /* Actions.APPEND */ ] = ()=>{
        if (key === undefined) key = newChar;
        else key += newChar;
    };
    actions[1 /* Actions.PUSH */ ] = ()=>{
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* Actions.INC_SUB_PATH_DEPTH */ ] = ()=>{
        actions[0 /* Actions.APPEND */ ]();
        subPathDepth++;
    };
    actions[3 /* Actions.PUSH_SUB_PATH */ ] = ()=>{
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* States.IN_SUB_PATH */ ;
            actions[0 /* Actions.APPEND */ ]();
        } else {
            subPathDepth = 0;
            if (key === undefined) return false;
            key = $a739018d680a1535$var$formatSubPath(key);
            if (key === false) return false;
            else actions[1 /* Actions.PUSH */ ]();
        }
    };
    function maybeUnescapeQuote() {
        const nextChar = path[index + 1];
        if (mode === 5 /* States.IN_SINGLE_QUOTE */  && nextChar === "'" /* PathCharTypes.SINGLE_QUOTE */  || mode === 6 /* States.IN_DOUBLE_QUOTE */  && nextChar === '"' /* PathCharTypes.DOUBLE_QUOTE */ ) {
            index++;
            newChar = "\\" + nextChar;
            actions[0 /* Actions.APPEND */ ]();
            return true;
        }
    }
    while(mode !== null){
        index++;
        c = path[index];
        if (c === "\\" && maybeUnescapeQuote()) continue;
        type = $a739018d680a1535$var$getPathCharType(c);
        typeMap = $a739018d680a1535$var$pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* PathCharTypes.ELSE */ ] || 8 /* States.ERROR */ ;
        // check parse error
        if (transition === 8 /* States.ERROR */ ) return;
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) return;
            }
        }
        // check parse finish
        if (mode === 7 /* States.AFTER_PATH */ ) return keys;
    }
}
// path token cache
const $a739018d680a1535$var$cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$b365de4c3506886c(obj, path) {
    return (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$d812c8e1906863d0(obj, path) {
    // check object
    if (!(0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(obj)) return null;
    // parse path
    let hit = $a739018d680a1535$var$cache.get(path);
    if (!hit) {
        hit = $a739018d680a1535$export$98e6a39c04603d36(path);
        if (hit) $a739018d680a1535$var$cache.set(path, hit);
    }
    // check hit
    if (!hit) return null;
    // resolve path value
    const len = hit.length;
    let last = obj;
    let i = 0;
    while(i < len){
        const val = last[hit[i]];
        if (val === undefined) return null;
        if ((0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(last)) return null;
        last = val;
        i++;
    }
    return last;
}
const $a739018d680a1535$var$DEFAULT_MODIFIER = (str)=>str;
const $a739018d680a1535$var$DEFAULT_MESSAGE = (ctx)=>""; // eslint-disable-line
const $a739018d680a1535$export$12b53af6b8529bfc = "text";
const $a739018d680a1535$var$DEFAULT_NORMALIZE = (values)=>values.length === 0 ? "" : (0, $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd)(values);
const $a739018d680a1535$var$DEFAULT_INTERPOLATE = (0, $fbd1e3bc010bc8c2$export$b5b1545233b45293);
function $a739018d680a1535$var$pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) // prettier-ignore
    return choice ? choice > 1 ? 1 : 0 : 1;
    return choice ? Math.min(choice, 2) : 0;
}
function $a739018d680a1535$var$getPluralIndex(options) {
    // prettier-ignore
    const index = (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.pluralIndex) ? options.pluralIndex : -1;
    // prettier-ignore
    return options.named && ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.named.count) || (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.named.n)) ? (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.named.count) ? options.named.count : (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.named.n) ? options.named.n : index : index;
}
function $a739018d680a1535$var$normalizeNamed(pluralIndex, props) {
    if (!props.count) props.count = pluralIndex;
    if (!props.n) props.n = pluralIndex;
}
function $a739018d680a1535$export$70de3b14beda2f5e(options = {}) {
    const locale = options.locale;
    const pluralIndex = $a739018d680a1535$var$getPluralIndex(options);
    const pluralRule = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale) && (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? options.pluralRules[locale] : $a739018d680a1535$var$pluralDefault;
    const orgPluralRule = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale) && (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? $a739018d680a1535$var$pluralDefault : undefined;
    const plural = (messages)=>{
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    const _list = options.list || [];
    const list = (index)=>_list[index];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _named = options.named || {};
    (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.pluralIndex) && $a739018d680a1535$var$normalizeNamed(pluralIndex, _named);
    const named = (key)=>_named[key];
    function message(key) {
        // prettier-ignore
        const msg = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.messages) ? options.messages(key) : (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.messages) ? options.messages[key] : false;
        return !msg ? options.parent ? options.parent.message(key) // resolve from parent messages
         : $a739018d680a1535$var$DEFAULT_MESSAGE : msg;
    }
    const _modifier = (name)=>options.modifiers ? options.modifiers[name] : $a739018d680a1535$var$DEFAULT_MODIFIER;
    const normalize = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.processor) && (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.processor.normalize) ? options.processor.normalize : $a739018d680a1535$var$DEFAULT_NORMALIZE;
    const interpolate = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.processor) && (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.processor.interpolate) ? options.processor.interpolate : $a739018d680a1535$var$DEFAULT_INTERPOLATE;
    const type = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.processor) && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.processor.type) ? options.processor.type : $a739018d680a1535$export$12b53af6b8529bfc;
    const linked = (key, ...args)=>{
        const [arg1, arg2] = args;
        let type = "text";
        let modifier = "";
        if (args.length === 1) {
            if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            } else if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1)) modifier = arg1 || modifier;
        } else if (args.length === 2) {
            if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1)) modifier = arg1 || modifier;
            if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) type = arg2 || type;
        }
        const ret = message(key)(ctx);
        const msg = // The message in vnode resolved with linked are returned as an array by processor.nomalize
        type === "vnode" && (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(ret) && modifier ? ret[0] : ret;
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    const ctx = {
        ["list" /* HelperNameMap.LIST */ ]: list,
        ["named" /* HelperNameMap.NAMED */ ]: named,
        ["plural" /* HelperNameMap.PLURAL */ ]: plural,
        ["linked" /* HelperNameMap.LINKED */ ]: linked,
        ["message" /* HelperNameMap.MESSAGE */ ]: message,
        ["type" /* HelperNameMap.TYPE */ ]: type,
        ["interpolate" /* HelperNameMap.INTERPOLATE */ ]: interpolate,
        ["normalize" /* HelperNameMap.NORMALIZE */ ]: normalize,
        ["values" /* HelperNameMap.VALUES */ ]: (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, _list, _named)
    };
    return ctx;
}
let $a739018d680a1535$var$devtools = null;
function $a739018d680a1535$export$c893d6c8966908b9(hook) {
    $a739018d680a1535$var$devtools = hook;
}
function $a739018d680a1535$export$8bd08e70642dc6f4() {
    return $a739018d680a1535$var$devtools;
}
function $a739018d680a1535$export$725afc6a300324a0(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    $a739018d680a1535$var$devtools && $a739018d680a1535$var$devtools.emit("i18n:init" /* IntlifyDevToolsHooks.I18nInit */ , {
        timestamp: Date.now(),
        i18n: i18n,
        version: version,
        meta: meta
    });
}
const $a739018d680a1535$export$190d71a47ff3f767 = /* #__PURE__*/ $a739018d680a1535$var$createDevToolsHook("function:translate" /* IntlifyDevToolsHooks.FunctionTranslate */ );
function $a739018d680a1535$var$createDevToolsHook(hook) {
    return (payloads)=>$a739018d680a1535$var$devtools && $a739018d680a1535$var$devtools.emit(hook, payloads);
}
const $a739018d680a1535$var$code$1 = (0, $b46efaa99568cb1e$export$21499b937901db8a).__EXTEND_POINT__;
const $a739018d680a1535$var$inc$1 = (0, $fbd1e3bc010bc8c2$export$47db5deb603dfca1)($a739018d680a1535$var$code$1);
const $a739018d680a1535$export$b6a676a18b27d4c8 = {
    NOT_FOUND_KEY: $a739018d680a1535$var$code$1,
    FALLBACK_TO_TRANSLATE: $a739018d680a1535$var$inc$1(),
    CANNOT_FORMAT_NUMBER: $a739018d680a1535$var$inc$1(),
    FALLBACK_TO_NUMBER_FORMAT: $a739018d680a1535$var$inc$1(),
    CANNOT_FORMAT_DATE: $a739018d680a1535$var$inc$1(),
    FALLBACK_TO_DATE_FORMAT: $a739018d680a1535$var$inc$1(),
    EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: $a739018d680a1535$var$inc$1(),
    __EXTEND_POINT__: $a739018d680a1535$var$inc$1() // 9
};
/** @internal */ const $a739018d680a1535$var$warnMessages = {
    [$a739018d680a1535$export$b6a676a18b27d4c8.NOT_FOUND_KEY]: `Not found '{key}' key in '{locale}' locale messages.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_TRANSLATE]: `Fall back to translate '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.CANNOT_FORMAT_NUMBER]: `Cannot format a number value due to not supported Intl.NumberFormat.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_NUMBER_FORMAT]: `Fall back to number format '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.CANNOT_FORMAT_DATE]: `Cannot format a date value due to not supported Intl.DateTimeFormat.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_DATE_FORMAT]: `Fall back to datetime format '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: `This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.`
};
function $a739018d680a1535$export$ae7a7631f2b2bb7(code, ...args) {
    return (0, $fbd1e3bc010bc8c2$export$d9468344d3651243)($a739018d680a1535$var$warnMessages[code], ...args);
}
const $a739018d680a1535$var$code = (0, $b46efaa99568cb1e$export$77436aae039469c4).__EXTEND_POINT__;
const $a739018d680a1535$var$inc = (0, $fbd1e3bc010bc8c2$export$47db5deb603dfca1)($a739018d680a1535$var$code);
const $a739018d680a1535$export$1d4dfd6045c40277 = {
    INVALID_ARGUMENT: $a739018d680a1535$var$code,
    INVALID_DATE_ARGUMENT: $a739018d680a1535$var$inc(),
    INVALID_ISO_DATE_ARGUMENT: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_NON_STRING_MESSAGE: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_PROMISE_VALUE: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_TYPE: $a739018d680a1535$var$inc(),
    __EXTEND_POINT__: $a739018d680a1535$var$inc() // 24
};
function $a739018d680a1535$export$3d702f7ac45b0a6b(code) {
    return (0, $b46efaa99568cb1e$export$21efa8bb37d5fecb)(code, null, undefined);
}
/** @internal */ const $a739018d680a1535$var$errorMessages = {
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT]: "Invalid arguments",
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
/** @internal */ function $a739018d680a1535$export$180605366c04f0cd(context, options) {
    return options.locale != null ? $a739018d680a1535$export$df9bcabe7f932e01(options.locale) : $a739018d680a1535$export$df9bcabe7f932e01(context.locale);
}
let $a739018d680a1535$var$_resolveLocale;
/** @internal */ function $a739018d680a1535$export$df9bcabe7f932e01(locale) {
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale)) return locale;
    else {
        if ((0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(locale)) {
            if (locale.resolvedOnce && $a739018d680a1535$var$_resolveLocale != null) return $a739018d680a1535$var$_resolveLocale;
            else if (locale.constructor.name === "Function") {
                const resolve = locale();
                if ((0, $fbd1e3bc010bc8c2$export$4369c812aac99591)(resolve)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
                return $a739018d680a1535$var$_resolveLocale = resolve;
            } else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
        } else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE);
    }
}
/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$e3330076537ef9d1(ctx, fallback, start // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    // prettier-ignore
    return [
        ...new Set([
            start,
            ...(0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(fallback) ? fallback : (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(fallback) ? Object.keys(fallback) : (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(fallback) ? [
                fallback
            ] : [
                start
            ]
        ])
    ];
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$71df9db82dc445(ctx, fallback, start) {
    const startLocale = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(start) ? start : $a739018d680a1535$export$1af4c7e47ad72f44;
    const context = ctx;
    if (!context.__localeChainCache) context.__localeChainCache = new Map();
    let chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        let block = [
            start
        ];
        // while any intervening block found
        while((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(block))block = $a739018d680a1535$var$appendBlockToChain(chain, block, fallback);
        // prettier-ignore
        // last block defined by default
        const defaults = (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(fallback) || !(0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(fallback) ? fallback : fallback["default"] ? fallback["default"] : null;
        // convert defaults to array
        block = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(defaults) ? [
            defaults
        ] : defaults;
        if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(block)) $a739018d680a1535$var$appendBlockToChain(chain, block, false);
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function $a739018d680a1535$var$appendBlockToChain(chain, block, blocks) {
    let follow = true;
    for(let i = 0; i < block.length && (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(follow); i++){
        const locale = block[i];
        if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale)) follow = $a739018d680a1535$var$appendLocaleToChain(chain, block[i], blocks);
    }
    return follow;
}
function $a739018d680a1535$var$appendLocaleToChain(chain, locale, blocks) {
    let follow;
    const tokens = locale.split("-");
    do {
        const target = tokens.join("-");
        follow = $a739018d680a1535$var$appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    }while (tokens.length && follow === true);
    return follow;
}
function $a739018d680a1535$var$appendItemToChain(chain, target, blocks) {
    let follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== "!";
            const locale = target.replace(/!/g, "");
            chain.push(locale);
            if (((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(blocks) || (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(blocks)) && blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            follow = blocks[locale];
        }
    }
    return follow;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Intlify core-base version
 * @internal
 */ const $a739018d680a1535$export$a4ad2735b021c132 = "9.13.1";
const $a739018d680a1535$export$b7f13a18d1d0f835 = -1;
const $a739018d680a1535$export$1af4c7e47ad72f44 = "en-US";
const $a739018d680a1535$export$a04371e9dbb3870b = "";
const $a739018d680a1535$var$capitalize = (str)=>`${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function $a739018d680a1535$var$getDefaultLinkedModifiers() {
    return {
        upper: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val) ? val.toUpperCase() : type === "vnode" && (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? val.children.toUpperCase() : val;
        },
        lower: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val) ? val.toLowerCase() : type === "vnode" && (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? val.children.toLowerCase() : val;
        },
        capitalize: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val) ? $a739018d680a1535$var$capitalize(val) : type === "vnode" && (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? $a739018d680a1535$var$capitalize(val.children) : val;
        }
    };
}
let $a739018d680a1535$var$_compiler;
function $a739018d680a1535$export$6ee2fbe83628b40b(compiler) {
    $a739018d680a1535$var$_compiler = compiler;
}
let $a739018d680a1535$var$_resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$45dacdc710815463(resolver) {
    $a739018d680a1535$var$_resolver = resolver;
}
let $a739018d680a1535$var$_fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$fd8ec9dd8067edec(fallbacker) {
    $a739018d680a1535$var$_fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
let $a739018d680a1535$var$_additionalMeta = null;
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$605703447dca72aa = (meta)=>{
    $a739018d680a1535$var$_additionalMeta = meta;
};
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$817795a14e5c6622 = ()=>$a739018d680a1535$var$_additionalMeta;
let $a739018d680a1535$var$_fallbackContext = null;
const $a739018d680a1535$export$e16aca6786e72a5e = (context)=>{
    $a739018d680a1535$var$_fallbackContext = context;
};
const $a739018d680a1535$export$3adddc434faa9e35 = ()=>$a739018d680a1535$var$_fallbackContext;
// ID for CoreContext
let $a739018d680a1535$var$_cid = 0;
function $a739018d680a1535$export$3599d465b05a74a5(options = {}) {
    // setup options
    const onWarn = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.onWarn) ? options.onWarn : (0, $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d);
    const version = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.version) ? options.version : $a739018d680a1535$export$a4ad2735b021c132;
    const locale = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.locale) || (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.locale) ? options.locale : $a739018d680a1535$export$1af4c7e47ad72f44;
    const _locale = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(locale) ? $a739018d680a1535$export$1af4c7e47ad72f44 : locale;
    const fallbackLocale = (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale;
    const messages = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.messages) ? options.messages : {
        [_locale]: {}
    };
    const datetimeFormats = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale]: {}
    };
    const numberFormats = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : {
        [_locale]: {}
    };
    const modifiers = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, options.modifiers || {}, $a739018d680a1535$var$getDefaultLinkedModifiers());
    const pluralRules = options.pluralRules || {};
    const missing = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    const missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    const fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    const fallbackFormat = !!options.fallbackFormat;
    const unresolving = !!options.unresolving;
    const postTranslation = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    const processor = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.processor) ? options.processor : null;
    const warnHtmlMessage = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const escapeParameter = !!options.escapeParameter;
    const messageCompiler = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.messageCompiler) ? options.messageCompiler : $a739018d680a1535$var$_compiler;
    const messageResolver = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.messageResolver) ? options.messageResolver : $a739018d680a1535$var$_resolver || $a739018d680a1535$export$b365de4c3506886c;
    const localeFallbacker = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.localeFallbacker) ? options.localeFallbacker : $a739018d680a1535$var$_fallbacker || $a739018d680a1535$export$e3330076537ef9d1;
    const fallbackContext = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.fallbackContext) ? options.fallbackContext : undefined;
    // setup internal options
    const internalOptions = options;
    const __datetimeFormatters = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : new Map();
    const __numberFormatters = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : new Map();
    const __meta = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(internalOptions.__meta) ? internalOptions.__meta : {};
    $a739018d680a1535$var$_cid++;
    const context = {
        version: version,
        cid: $a739018d680a1535$var$_cid,
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        modifiers: modifiers,
        pluralRules: pluralRules,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackFormat: fallbackFormat,
        unresolving: unresolving,
        postTranslation: postTranslation,
        processor: processor,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageCompiler: messageCompiler,
        messageResolver: messageResolver,
        localeFallbacker: localeFallbacker,
        fallbackContext: fallbackContext,
        onWarn: onWarn,
        __meta: __meta
    };
    context.datetimeFormats = datetimeFormats;
    context.numberFormats = numberFormats;
    context.__datetimeFormatters = __datetimeFormatters;
    context.__numberFormatters = __numberFormatters;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) $a739018d680a1535$export$725afc6a300324a0(context, version, __meta);
    return context;
}
/** @internal */ function $a739018d680a1535$export$d9435df38da77a63(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */ function $a739018d680a1535$export$e419d347a4a2eb71(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */ function $a739018d680a1535$export$bc779048ece0c567(context, key, locale, missingWarn, type) {
    const { missing: missing, onWarn: onWarn } = context;
    if (missing !== null) {
        const ret = missing(context, locale, key, type);
        return (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(ret) ? ret : key;
    } else return key;
}
/** @internal */ function $a739018d680a1535$export$c743ad8a3cc01530(ctx, locale, fallback) {
    const context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/** @internal */ function $a739018d680a1535$export$59f8e8904fd79a18(locale, compareLocale) {
    if (locale === compareLocale) return false;
    return locale.split("-")[0] === compareLocale.split("-")[0];
}
/** @internal */ function $a739018d680a1535$export$d783301aca6271c3(targetLocale, locales) {
    const index = locales.indexOf(targetLocale);
    if (index === -1) return false;
    for(let i = index + 1; i < locales.length; i++){
        if ($a739018d680a1535$export$59f8e8904fd79a18(targetLocale, locales[i])) return true;
    }
    return false;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ function $a739018d680a1535$var$format(ast) {
    const msg = (ctx)=>$a739018d680a1535$var$formatParts(ctx, ast);
    return msg;
}
function $a739018d680a1535$var$formatParts(ctx, ast) {
    const body = ast.b || ast.body;
    if ((body.t || body.type) === 1 /* NodeTypes.Plural */ ) {
        const plural = body;
        const cases = plural.c || plural.cases;
        return ctx.plural(cases.reduce((messages, c)=>[
                ...messages,
                $a739018d680a1535$var$formatMessageParts(ctx, c)
            ], []));
    } else return $a739018d680a1535$var$formatMessageParts(ctx, body);
}
function $a739018d680a1535$var$formatMessageParts(ctx, node) {
    const _static = node.s || node.static;
    if (_static) return ctx.type === "text" ? _static : ctx.normalize([
        _static
    ]);
    else {
        const messages = (node.i || node.items).reduce((acm, c)=>[
                ...acm,
                $a739018d680a1535$var$formatMessagePart(ctx, c)
            ], []);
        return ctx.normalize(messages);
    }
}
function $a739018d680a1535$var$formatMessagePart(ctx, node) {
    const type = node.t || node.type;
    switch(type){
        case 3 /* NodeTypes.Text */ :
            {
                const text = node;
                return text.v || text.value;
            }
        case 9 /* NodeTypes.Literal */ :
            {
                const literal = node;
                return literal.v || literal.value;
            }
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                return ctx.interpolate(ctx.named(named.k || named.key));
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                return ctx.interpolate(ctx.list(list.i != null ? list.i : list.index));
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                const modifier = linked.m || linked.modifier;
                return ctx.linked($a739018d680a1535$var$formatMessagePart(ctx, linked.k || linked.key), modifier ? $a739018d680a1535$var$formatMessagePart(ctx, modifier) : undefined, ctx.type);
            }
        case 7 /* NodeTypes.LinkedKey */ :
            {
                const linkedKey = node;
                return linkedKey.v || linkedKey.value;
            }
        case 8 /* NodeTypes.LinkedModifier */ :
            {
                const linkedModifier = node;
                return linkedModifier.v || linkedModifier.value;
            }
        default:
            throw new Error(`unhandled node type on format message part: ${type}`);
    }
}
const $a739018d680a1535$var$WARN_MESSAGE = `Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.`;
function $a739018d680a1535$var$checkHtmlMessage(source, warnHtmlMessage) {
    if (warnHtmlMessage && (0, $b46efaa99568cb1e$export$6de85467cbd6ae39)(source)) (0, $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d)((0, $fbd1e3bc010bc8c2$export$d9468344d3651243)($a739018d680a1535$var$WARN_MESSAGE, {
        source: source
    }));
}
const $a739018d680a1535$var$defaultOnCacheKey = (message)=>message;
let $a739018d680a1535$var$compileCache = Object.create(null);
function $a739018d680a1535$var$onCompileWarn(_warn) {
    if (_warn.code === (0, $b46efaa99568cb1e$export$21499b937901db8a).USE_MODULO_SYNTAX) (0, $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d)(`The use of named interpolation with modulo syntax is deprecated. ` + `It will be removed in v10.\n` + `reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format \n` + `(message compiler warning message: ${_warn.message})`);
}
function $a739018d680a1535$export$2683c80ae3fe544() {
    $a739018d680a1535$var$compileCache = Object.create(null);
}
const $a739018d680a1535$export$9ba95744594b90e0 = (val)=>(0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(val) && (val.t === 0 || val.type === 0) && ("b" in val || "body" in val);
function $a739018d680a1535$var$baseCompile(message, options = {}) {
    // error detecting on compile
    let detectError = false;
    const onError = options.onError || (0, $b46efaa99568cb1e$export$ad0eb2c702f03471);
    options.onError = (err)=>{
        detectError = true;
        onError(err);
    };
    // compile with mesasge-compiler
    return {
        ...(0, $b46efaa99568cb1e$export$3243579822c486a0)(message, options),
        detectError: detectError
    };
}
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$1ea8807c727891fc = (message, context)=>{
    if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(message)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_NON_STRING_MESSAGE);
    {
        // check HTML message
        const warnHtmlMessage = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
        // check caches
        const onCacheKey = context.onCacheKey || $a739018d680a1535$var$defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = $a739018d680a1535$var$compileCache[cacheKey];
        if (cached) return cached;
        // compile
        const { code: code, detectError: detectError } = $a739018d680a1535$var$baseCompile(message, context);
        // evaluate function
        const msg = new Function(`return ${code}`)();
        // if occurred compile error, don't cache
        return !detectError ? $a739018d680a1535$var$compileCache[cacheKey] = msg : msg;
    }
};
function $a739018d680a1535$export$ef7acd7185315e22(message, context) {
    if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(message)) {
        // check HTML message
        const warnHtmlMessage = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
        // check caches
        const onCacheKey = context.onCacheKey || $a739018d680a1535$var$defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = $a739018d680a1535$var$compileCache[cacheKey];
        if (cached) return cached;
        // compile with JIT mode
        const { ast: ast, detectError: detectError } = $a739018d680a1535$var$baseCompile(message, {
            ...context,
            location: false,
            jit: true
        });
        // compose message function from AST
        const msg = $a739018d680a1535$var$format(ast);
        // if occurred compile error, don't cache
        return !detectError ? $a739018d680a1535$var$compileCache[cacheKey] = msg : msg;
    } else {
        // AST case (passed from bundler)
        const cacheKey = message.cacheKey;
        if (cacheKey) {
            const cached = $a739018d680a1535$var$compileCache[cacheKey];
            if (cached) return cached;
            // compose message function from message (AST)
            return $a739018d680a1535$var$compileCache[cacheKey] = $a739018d680a1535$var$format(message);
        } else return $a739018d680a1535$var$format(message);
    }
}
const $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION = ()=>"";
const $a739018d680a1535$export$92c0a039cf358271 = (val)=>(0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(val);
// implementation of `translate` function
function $a739018d680a1535$export$d73ee8ef04f5226a(context, ...args) {
    const { fallbackFormat: fallbackFormat, postTranslation: postTranslation, unresolving: unresolving, messageCompiler: messageCompiler, fallbackLocale: fallbackLocale, messages: messages } = context;
    const [key, options] = $a739018d680a1535$export$8d9616744e22681a(...args);
    const missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const escapeParameter = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.escapeParameter) ? options.escapeParameter : context.escapeParameter;
    const resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    const defaultMsgOrKey = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.default) || (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.default) // default by function option
     ? !(0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.default) ? options.default : !messageCompiler ? ()=>key : key : fallbackFormat // default by `fallbackFormat` option
     ? !messageCompiler ? ()=>key : key : "";
    const enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== "";
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    // escape params
    escapeParameter && $a739018d680a1535$var$escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    let [formatScope, targetLocale, message] = !resolvedMessage ? $a739018d680a1535$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) : [
        key,
        locale,
        messages[locale] || {}
    ];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    let format = formatScope;
    // if you use default message, set it as message format!
    let cacheBaseKey = key;
    if (!resolvedMessage && !((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage && (!((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format)) || !(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(targetLocale))) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    // setup compile error detecting
    let occurred = false;
    const onError = ()=>{
        occurred = true;
    };
    // compile message format
    const msg = !$a739018d680a1535$export$92c0a039cf358271(format) ? $a739018d680a1535$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) : format;
    // if occurred compile error, return the message format
    if (occurred) return format;
    // evaluate message with context
    const ctxOptions = $a739018d680a1535$var$getMessageContextOptions(context, targetLocale, message, options);
    const msgContext = $a739018d680a1535$export$70de3b14beda2f5e(ctxOptions);
    const messaged = $a739018d680a1535$var$evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    const ret = postTranslation ? postTranslation(messaged, key) : messaged;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) {
        // prettier-ignore
        const payloads = {
            timestamp: Date.now(),
            key: (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(key) ? key : $a739018d680a1535$export$92c0a039cf358271(format) ? format.key : "",
            locale: targetLocale || ($a739018d680a1535$export$92c0a039cf358271(format) ? format.locale : ""),
            format: (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(format) ? format : $a739018d680a1535$export$92c0a039cf358271(format) ? format.source : "",
            message: ret
        };
        payloads.meta = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, context.__meta, $a739018d680a1535$export$817795a14e5c6622() || {});
        $a739018d680a1535$export$190d71a47ff3f767(payloads);
    }
    return ret;
}
function $a739018d680a1535$var$escapeParams(options) {
    if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(options.list)) options.list = options.list.map((item)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(item) ? (0, $fbd1e3bc010bc8c2$export$4cf11838cdc2a8a8)(item) : item);
    else if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.named)) Object.keys(options.named).forEach((key)=>{
        if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.named[key])) options.named[key] = (0, $fbd1e3bc010bc8c2$export$4cf11838cdc2a8a8)(options.named[key]);
    });
}
function $a739018d680a1535$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    const { messages: messages, onWarn: onWarn, messageResolver: resolveValue, localeFallbacker: localeFallbacker } = context;
    const locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    let message = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "translate";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        message = messages[targetLocale] || {};
        // for vue-devtools timeline event
        let start = null;
        let startTag;
        let endTag;
        if ((format = resolveValue(message, key)) === null) // if null, resolve with object key path
        format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format)) break;
        if (!$a739018d680a1535$export$d783301aca6271c3(targetLocale, locales)) {
            const missingRet = $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type);
            if (missingRet !== key) format = missingRet;
        }
        from = to;
    }
    return [
        format,
        targetLocale,
        message
    ];
}
function $a739018d680a1535$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) {
    const { messageCompiler: messageCompiler, warnHtmlMessage: warnHtmlMessage } = context;
    if ($a739018d680a1535$export$92c0a039cf358271(format)) {
        const msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        const msg = ()=>format;
        msg.locale = targetLocale;
        msg.key = key;
        return msg;
    }
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const msg = messageCompiler(format, $a739018d680a1535$var$getCompileContext(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, onError));
    msg.locale = targetLocale;
    msg.key = key;
    msg.source = format;
    return msg;
}
function $a739018d680a1535$var$evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const messaged = msg(msgCtx);
    return messaged;
}
/** @internal */ function $a739018d680a1535$export$8d9616744e22681a(...args) {
    const [arg1, arg2, arg3] = args;
    const options = {};
    if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1) && !(0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg1) && !$a739018d680a1535$export$92c0a039cf358271(arg1) && !$a739018d680a1535$export$9ba95744594b90e0(arg1)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    // prettier-ignore
    const key = (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg1) ? String(arg1) : $a739018d680a1535$export$92c0a039cf358271(arg1) ? arg1 : arg1;
    if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
    else if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) options.default = arg2;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg2) && !(0, $fbd1e3bc010bc8c2$export$83b788b1a3698c03)(arg2)) options.named = arg2;
    else if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(arg2)) options.list = arg2;
    if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg3)) options.plural = arg3;
    else if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg3)) options.default = arg3;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg3)) (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)(options, arg3);
    return [
        key,
        options
    ];
}
function $a739018d680a1535$var$getCompileContext(context, locale, key, source, warnHtmlMessage, onError) {
    return {
        locale: locale,
        key: key,
        warnHtmlMessage: warnHtmlMessage,
        onError: (err)=>{
            onError && onError(err);
            throw err;
        },
        onCacheKey: (source)=>(0, $fbd1e3bc010bc8c2$export$5024ef1f92c9a364)(locale, key, source)
    };
}
function $a739018d680a1535$var$getSourceForCodeFrame(source) {
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(source)) return source;
    else {
        if (source.loc && source.loc.source) return source.loc.source;
    }
}
function $a739018d680a1535$var$getMessageContextOptions(context, locale, message, options) {
    const { modifiers: modifiers, pluralRules: pluralRules, messageResolver: resolveValue, fallbackLocale: fallbackLocale, fallbackWarn: fallbackWarn, missingWarn: missingWarn, fallbackContext: fallbackContext } = context;
    const resolveMessage = (key)=>{
        let val = resolveValue(message, key);
        // fallback to root context
        if (val == null && fallbackContext) {
            const [, , message] = $a739018d680a1535$var$resolveMessageFormat(fallbackContext, key, locale, fallbackLocale, fallbackWarn, missingWarn);
            val = resolveValue(message, key);
        }
        if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val) || $a739018d680a1535$export$9ba95744594b90e0(val)) {
            let occurred = false;
            const onError = ()=>{
                occurred = true;
            };
            const msg = $a739018d680a1535$var$compileMessageFormat(context, key, locale, val, key, onError);
            return !occurred ? msg : $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION;
        } else if ($a739018d680a1535$export$92c0a039cf358271(val)) return val;
        else // TODO: should be implemented warning message
        return $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION;
    };
    const ctxOptions = {
        locale: locale,
        modifiers: modifiers,
        pluralRules: pluralRules,
        messages: resolveMessage
    };
    if (context.processor) ctxOptions.processor = context.processor;
    if (options.list) ctxOptions.list = options.list;
    if (options.named) ctxOptions.named = options.named;
    if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.plural)) ctxOptions.pluralIndex = options.plural;
    return ctxOptions;
}
const $a739018d680a1535$var$intlDefined = typeof Intl !== "undefined";
const $a739018d680a1535$var$Availabilities = {
    dateTimeFormat: $a739018d680a1535$var$intlDefined && typeof Intl.DateTimeFormat !== "undefined",
    numberFormat: $a739018d680a1535$var$intlDefined && typeof Intl.NumberFormat !== "undefined"
};
// implementation of `datetime` function
function $a739018d680a1535$export$7ba4466dbd0f07e1(context, ...args) {
    const { datetimeFormats: datetimeFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __datetimeFormatters: __datetimeFormatters } = context;
    const [key, value, options, overrides] = $a739018d680a1535$export$165524b21a0d6b5e(...args);
    const missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(key) || key === "") return new Intl.DateTimeFormat(locale, overrides).format(value);
    // resolve format
    let datetimeFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "datetime format";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        datetimeFormat = datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(format)) break;
        $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(format) || !(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(targetLocale)) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $fbd1e3bc010bc8c2$export$83b788b1a3698c03)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $a739018d680a1535$export$c77049eaf05b1508 = [
    "localeMatcher",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "formatMatcher",
    "hour12",
    "timeZone",
    "dateStyle",
    "timeStyle",
    "calendar",
    "dayPeriod",
    "numberingSystem",
    "hourCycle",
    "fractionalSecondDigits"
];
/** @internal */ function $a739018d680a1535$export$165524b21a0d6b5e(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    let value;
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        const dateTime = matches[3] ? matches[3].trim().startsWith("T") ? `${matches[1].trim()}${matches[3].trim()}` : `${matches[1].trim()}T${matches[3].trim()}` : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        } catch (e) {
            throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        }
    } else if ((0, $fbd1e3bc010bc8c2$export$871608497c498473)(arg1)) {
        if (isNaN(arg1.getTime())) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT);
        value = arg1;
    } else if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg1)) value = arg1;
    else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($a739018d680a1535$export$c77049eaf05b1508.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $a739018d680a1535$export$5bc4fc7cf15d6ccd(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__datetimeFormatters.has(id)) continue;
        context.__datetimeFormatters.delete(id);
    }
}
// implementation of `number` function
function $a739018d680a1535$export$98e628dec113755e(context, ...args) {
    const { numberFormats: numberFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __numberFormatters: __numberFormatters } = context;
    const [key, value, options, overrides] = $a739018d680a1535$export$d0e2eec8b686cf72(...args);
    const missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(key) || key === "") return new Intl.NumberFormat(locale, overrides).format(value);
    // resolve format
    let numberFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "number format";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        numberFormat = numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(format)) break;
        $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(format) || !(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(targetLocale)) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $fbd1e3bc010bc8c2$export$83b788b1a3698c03)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $a739018d680a1535$export$c39a7c3789c46ed6 = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "currencySign",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    "compactDisplay",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "roundingMode",
    "roundingPriority",
    "roundingIncrement",
    "trailingZeroDisplay"
];
/** @internal */ function $a739018d680a1535$export$d0e2eec8b686cf72(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    if (!(0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg1)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    const value = arg1;
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($a739018d680a1535$export$c39a7c3789c46ed6.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $a739018d680a1535$export$6a8717b3043a4f23(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__numberFormatters.has(id)) continue;
        context.__numberFormatters.delete(id);
    }
}
$a739018d680a1535$var$initFeatureFlags();


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */ const $409cbe3732db83c2$export$a4ad2735b021c132 = "9.13.1";
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $409cbe3732db83c2$var$initFeatureFlags() {
    if (typeof __VUE_I18N_FULL_INSTALL__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__VUE_I18N_FULL_INSTALL__ = true;
    if (typeof __VUE_I18N_LEGACY_API__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__VUE_I18N_LEGACY_API__ = true;
    if (typeof __INTLIFY_JIT_COMPILATION__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_JIT_COMPILATION__ = false;
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;
}
const $409cbe3732db83c2$var$code$1 = (0, $a739018d680a1535$export$b6a676a18b27d4c8).__EXTEND_POINT__;
const $409cbe3732db83c2$var$inc$1 = (0, $fbd1e3bc010bc8c2$export$47db5deb603dfca1)($409cbe3732db83c2$var$code$1);
const $409cbe3732db83c2$var$I18nWarnCodes = {
    FALLBACK_TO_ROOT: $409cbe3732db83c2$var$code$1,
    NOT_SUPPORTED_PRESERVE: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_FORMATTER: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_PRESERVE_DIRECTIVE: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_GET_CHOICE_INDEX: $409cbe3732db83c2$var$inc$1(),
    COMPONENT_NAME_LEGACY_COMPATIBLE: $409cbe3732db83c2$var$inc$1(),
    NOT_FOUND_PARENT_SCOPE: $409cbe3732db83c2$var$inc$1(),
    IGNORE_OBJ_FLATTEN: $409cbe3732db83c2$var$inc$1(),
    NOTICE_DROP_ALLOW_COMPOSITION: $409cbe3732db83c2$var$inc$1(),
    NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: $409cbe3732db83c2$var$inc$1() // 18
};
const $409cbe3732db83c2$var$warnMessages = {
    [$409cbe3732db83c2$var$I18nWarnCodes.FALLBACK_TO_ROOT]: `Fall back to {type} '{key}' with root locale.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE]: `Not supported 'preserve'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_FORMATTER]: `Not supported 'formatter'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: `Not supported 'preserveDirectiveContent'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX]: `Not supported 'getChoiceIndex'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE]: `Component name legacy compatible: '{name}' -> 'i18n'`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_FOUND_PARENT_SCOPE]: `Not found parent scope. use the global scope.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.IGNORE_OBJ_FLATTEN]: `Ignore object flatten: '{key}' key has an string value`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOTICE_DROP_ALLOW_COMPOSITION]: `'allowComposition' option will be dropped in the next major version. For more information, please see \u{1F449} https://tinyurl.com/2p97mcze`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: `'translateExistCompatible' option will be dropped in the next major version.`
};
function $409cbe3732db83c2$var$getWarnMessage(code, ...args) {
    return (0, $fbd1e3bc010bc8c2$export$d9468344d3651243)($409cbe3732db83c2$var$warnMessages[code], ...args);
}
const $409cbe3732db83c2$var$code = (0, $a739018d680a1535$export$1d4dfd6045c40277).__EXTEND_POINT__;
const $409cbe3732db83c2$var$inc = (0, $fbd1e3bc010bc8c2$export$47db5deb603dfca1)($409cbe3732db83c2$var$code);
const $409cbe3732db83c2$var$I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: $409cbe3732db83c2$var$code,
    // legacy module errors
    INVALID_ARGUMENT: $409cbe3732db83c2$var$inc(),
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: $409cbe3732db83c2$var$inc(),
    NOT_INSTALLED: $409cbe3732db83c2$var$inc(),
    NOT_AVAILABLE_IN_LEGACY_MODE: $409cbe3732db83c2$var$inc(),
    // directive module errors
    REQUIRED_VALUE: $409cbe3732db83c2$var$inc(),
    INVALID_VALUE: $409cbe3732db83c2$var$inc(),
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: $409cbe3732db83c2$var$inc(),
    NOT_INSTALLED_WITH_PROVIDE: $409cbe3732db83c2$var$inc(),
    // unexpected error
    UNEXPECTED_ERROR: $409cbe3732db83c2$var$inc(),
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: $409cbe3732db83c2$var$inc(),
    // bridge support vue 2.x only
    BRIDGE_SUPPORT_VUE_2_ONLY: $409cbe3732db83c2$var$inc(),
    // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
    MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: $409cbe3732db83c2$var$inc(),
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: $409cbe3732db83c2$var$inc(),
    // for enhancement
    __EXTEND_POINT__: $409cbe3732db83c2$var$inc() // 38
};
function $409cbe3732db83c2$var$createI18nError(code, ...args) {
    return (0, $b46efaa99568cb1e$export$21efa8bb37d5fecb)(code, null, undefined);
}
const $409cbe3732db83c2$var$errorMessages = {
    [$409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
    [$409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT]: "Invalid argument",
    [$409cbe3732db83c2$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED]: "Need to install with `app.use` function",
    [$409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR]: "Unexpected error",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
    [$409cbe3732db83c2$var$I18nErrorCodes.REQUIRED_VALUE]: `Required in value: {0}`,
    [$409cbe3732db83c2$var$I18nErrorCodes.INVALID_VALUE]: `Invalid value`,
    [$409cbe3732db83c2$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: `Cannot setup vue-devtools plugin`,
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
    [$409cbe3732db83c2$var$I18nErrorCodes.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
    [$409cbe3732db83c2$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define \u2018i18n\u2019 option or custom block in Composition API with using local scope in Legacy API mode",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
};
const $409cbe3732db83c2$var$TranslateVNodeSymbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__translateVNode");
const $409cbe3732db83c2$var$DatetimePartsSymbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__datetimeParts");
const $409cbe3732db83c2$var$NumberPartsSymbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__numberParts");
const $409cbe3732db83c2$var$EnableEmitter = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__enableEmitter");
const $409cbe3732db83c2$var$DisableEmitter = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__disableEmitter");
const $409cbe3732db83c2$var$SetPluralRulesSymbol = (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__setPluralRules");
(0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__intlifyMeta");
const $409cbe3732db83c2$var$InejctWithOptionSymbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__injectWithOption");
const $409cbe3732db83c2$var$DisposeSymbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__dispose");
const $409cbe3732db83c2$var$__VUE_I18N_BRIDGE__ = "__VUE_I18N_BRIDGE__";
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Transform flat json in obj to normal json in obj
 */ function $409cbe3732db83c2$var$handleFlatJson(obj) {
    // check obj
    if (!(0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(obj)) return obj;
    for(const key in obj){
        // check key
        if (!(0, $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3)(obj, key)) continue;
        // handle for normal json
        if (!key.includes(".")) // recursive process value if value is also a object
        {
            if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(obj[key])) $409cbe3732db83c2$var$handleFlatJson(obj[key]);
        } else {
            // go to the last object
            const subKeys = key.split(".");
            const lastIndex = subKeys.length - 1;
            let currentObj = obj;
            let hasStringValue = false;
            for(let i = 0; i < lastIndex; i++){
                if (!(subKeys[i] in currentObj)) currentObj[subKeys[i]] = {};
                if (!(0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(currentObj[subKeys[i]])) {
                    hasStringValue = true;
                    break;
                }
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            if (!hasStringValue) {
                currentObj[subKeys[lastIndex]] = obj[key];
                delete obj[key];
            }
            // recursive process value if value is also a object
            if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(currentObj[subKeys[lastIndex]])) $409cbe3732db83c2$var$handleFlatJson(currentObj[subKeys[lastIndex]]);
        }
    }
    return obj;
}
function $409cbe3732db83c2$var$getLocaleMessages(locale, options) {
    const { messages: messages, __i18n: __i18n, messageResolver: messageResolver, flatJson: flatJson } = options;
    // prettier-ignore
    const ret = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(messages) ? messages : (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(__i18n) ? {} : {
        [locale]: {}
    };
    // merge locale messages of i18n custom block
    if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(__i18n)) __i18n.forEach((custom)=>{
        if ("locale" in custom && "resource" in custom) {
            const { locale: locale, resource: resource } = custom;
            if (locale) {
                ret[locale] = ret[locale] || {};
                (0, $fbd1e3bc010bc8c2$export$6c40052bed430212)(resource, ret[locale]);
            } else (0, $fbd1e3bc010bc8c2$export$6c40052bed430212)(resource, ret);
        } else (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(custom) && (0, $fbd1e3bc010bc8c2$export$6c40052bed430212)(JSON.parse(custom), ret);
    });
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for(const key in ret)if ((0, $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3)(ret, key)) $409cbe3732db83c2$var$handleFlatJson(ret[key]);
    }
    return ret;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getComponentOptions(instance) {
    return instance.type;
}
function $409cbe3732db83c2$var$adjustI18nResources(gl, options, componentOptions // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    let messages = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.messages) ? options.messages : {};
    if ("__i18nGlobal" in componentOptions) messages = $409cbe3732db83c2$var$getLocaleMessages(gl.locale.value, {
        messages: messages,
        __i18n: componentOptions.__i18nGlobal
    });
    // merge locale messages
    const locales = Object.keys(messages);
    if (locales.length) locales.forEach((locale)=>{
        gl.mergeLocaleMessage(locale, messages[locale]);
    });
    // merge datetime formats
    if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.datetimeFormats)) {
        const locales = Object.keys(options.datetimeFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
        });
    }
    // merge number formats
    if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.numberFormats)) {
        const locales = Object.keys(options.numberFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeNumberFormat(locale, options.numberFormats[locale]);
        });
    }
}
function $409cbe3732db83c2$var$createTextNode(key) {
    return (0, $TusQn.createVNode)((0, $TusQn.Text), null, key, 0);
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ // extend VNode interface
const $409cbe3732db83c2$var$DEVTOOLS_META = "__INTLIFY_META__";
const $409cbe3732db83c2$var$NOOP_RETURN_ARRAY = ()=>[];
const $409cbe3732db83c2$var$NOOP_RETURN_FALSE = ()=>false;
let $409cbe3732db83c2$var$composerID = 0;
function $409cbe3732db83c2$var$defineCoreMissingHandler(missing) {
    return (ctx, locale, key, type)=>{
        return missing(locale, key, (0, $TusQn.getCurrentInstance)() || undefined, type);
    };
}
// for Intlify DevTools
/* #__NO_SIDE_EFFECTS__ */ const $409cbe3732db83c2$var$getMetaInfo = ()=>{
    const instance = (0, $TusQn.getCurrentInstance)();
    let meta = null; // eslint-disable-line @typescript-eslint/no-explicit-any
    return instance && (meta = $409cbe3732db83c2$var$getComponentOptions(instance)[$409cbe3732db83c2$var$DEVTOOLS_META]) ? {
        [$409cbe3732db83c2$var$DEVTOOLS_META]: meta
    } // eslint-disable-line @typescript-eslint/no-explicit-any
     : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$var$createComposer(options = {}, VueI18nLegacy) {
    const { __root: __root, __injectWithOption: __injectWithOption } = options;
    const _isGlobal = __root === undefined;
    const flatJson = options.flatJson;
    const _ref = (0, $fbd1e3bc010bc8c2$export$620a268685f0ac45) ? (0, $01W3b.ref) : (0, $01W3b.shallowRef);
    const translateExistCompatible = !!options.translateExistCompatible;
    let _inheritLocale = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.inheritLocale) ? options.inheritLocale : true;
    const _locale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.locale.value : (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $a739018d680a1535$export$1af4c7e47ad72f44));
    const _fallbackLocale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.fallbackLocale.value : (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = _ref($409cbe3732db83c2$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = _ref((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = _ref((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // warning suppress options
    // prettier-ignore
    let _missingWarn = __root ? __root.missingWarn : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    let _fallbackWarn = __root ? __root.fallbackWarn : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    let _fallbackRoot = __root ? __root.fallbackRoot : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    let _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    let _missing = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    let _runtimeMissing = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.missing) ? $409cbe3732db83c2$var$defineCoreMissingHandler(options.missing) : null;
    // postTranslation handler
    let _postTranslation = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    let _warnHtmlMessage = __root ? __root.warnHtmlMessage : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    let _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    const _modifiers = __root ? __root.modifiers : (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    let _pluralRules = options.pluralRules || __root && __root.pluralRules;
    // runtime context
    // eslint-disable-next-line prefer-const
    let _context;
    const getCoreContext = ()=>{
        _isGlobal && (0, $a739018d680a1535$export$e16aca6786e72a5e)(null);
        const ctxOptions = {
            version: $409cbe3732db83c2$export$a4ad2735b021c132,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            messageCompiler: options.messageCompiler,
            __meta: {
                framework: "vue"
            }
        };
        ctxOptions.datetimeFormats = _datetimeFormats.value;
        ctxOptions.numberFormats = _numberFormats.value;
        ctxOptions.__datetimeFormatters = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(_context) ? _context.__datetimeFormatters : undefined;
        ctxOptions.__numberFormatters = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(_context) ? _context.__numberFormatters : undefined;
        const ctx = (0, $a739018d680a1535$export$3599d465b05a74a5)(ctxOptions);
        _isGlobal && (0, $a739018d680a1535$export$e16aca6786e72a5e)(ctx);
        return ctx;
    };
    _context = getCoreContext();
    (0, $a739018d680a1535$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $01W3b.computed)({
        get: ()=>_locale.value,
        set: (val1)=>{
            _locale.value = val1;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $01W3b.computed)({
        get: ()=>_fallbackLocale.value,
        set: (val1)=>{
            _fallbackLocale.value = val1;
            _context.fallbackLocale = _fallbackLocale.value;
            (0, $a739018d680a1535$export$c743ad8a3cc01530)(_context, _locale.value, val1);
        }
    });
    // messages
    const messages = (0, $01W3b.computed)(()=>_messages.value);
    // datetimeFormats
    const datetimeFormats = /* #__PURE__*/ (0, $01W3b.computed)(()=>_datetimeFormats.value);
    // numberFormats
    const numberFormats = /* #__PURE__*/ (0, $01W3b.computed)(()=>_numberFormats.value);
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler1) {
        _postTranslation = handler1;
        _context.postTranslation = handler1;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler1) {
        if (handler1 !== null) _runtimeMissing = $409cbe3732db83c2$var$defineCoreMissingHandler(handler1);
        _missing = handler1;
        _context.missing = _runtimeMissing;
    }
    function isResolvedTranslateMessage(type, arg // eslint-disable-line @typescript-eslint/no-explicit-any
    ) {
        return type !== "translate" || !arg.resolvedMessage;
    }
    const wrapWithDeps = (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition)=>{
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        let ret;
        try {
            if (__INTLIFY_PROD_DEVTOOLS__) (0, $a739018d680a1535$export$605703447dca72aa)($409cbe3732db83c2$var$getMetaInfo());
            if (!_isGlobal) _context.fallbackContext = __root ? (0, $a739018d680a1535$export$3adddc434faa9e35)() : undefined;
            ret = fn(_context);
        } finally{
            if (__INTLIFY_PROD_DEVTOOLS__) (0, $a739018d680a1535$export$605703447dca72aa)(null);
            if (!_isGlobal) _context.fallbackContext = undefined;
        }
        if (warnType !== "translate exists" && // for not `te` (e.g `t`)
        (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(ret) && ret === (0, $a739018d680a1535$export$b7f13a18d1d0f835) || warnType === "translate exists" && !ret // for `te`
        ) {
            const [key, arg2] = argumentParser();
            return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
        } else if (successCondition(ret)) return ret;
        else /* istanbul ignore next */ throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    };
    // t
    function t(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $a739018d680a1535$export$d73ee8ef04f5226a), null, [
                context,
                ...args
            ]), ()=>(0, $a739018d680a1535$export$8d9616744e22681a)(...args), "translate", (root)=>Reflect.apply(root.t, root, [
                ...args
            ]), (key)=>key, (val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1));
    }
    // rt
    function rt(...args) {
        const [arg1, arg2, arg3] = args;
        if (arg3 && !(0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(arg3)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
        return t(...[
            arg1,
            arg2,
            (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({
                resolvedMessage: true
            }, arg3 || {})
        ]);
    }
    // d
    function d(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $a739018d680a1535$export$7ba4466dbd0f07e1), null, [
                context,
                ...args
            ]), ()=>(0, $a739018d680a1535$export$165524b21a0d6b5e)(...args), "datetime format", (root)=>Reflect.apply(root.d, root, [
                ...args
            ]), ()=>(0, $a739018d680a1535$export$a04371e9dbb3870b), (val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1));
    }
    // n
    function n(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $a739018d680a1535$export$98e628dec113755e), null, [
                context,
                ...args
            ]), ()=>(0, $a739018d680a1535$export$d0e2eec8b686cf72)(...args), "number format", (root)=>Reflect.apply(root.n, root, [
                ...args
            ]), ()=>(0, $a739018d680a1535$export$a04371e9dbb3870b), (val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1));
    }
    // for custom processor
    function normalize(values) {
        return values.map((val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1) || (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(val1) || (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(val1) ? $409cbe3732db83c2$var$createTextNode(String(val1)) : val1);
    }
    const interpolate = (val1)=>val1;
    const processor = {
        normalize: normalize,
        interpolate: interpolate,
        type: "vnode"
    };
    // translateVNode, using for `i18n-t` component
    function translateVNode(...args) {
        return wrapWithDeps((context)=>{
            let ret;
            const _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply((0, $a739018d680a1535$export$d73ee8ef04f5226a), null, [
                    _context,
                    ...args
                ]);
            } finally{
                _context.processor = null;
            }
            return ret;
        }, ()=>(0, $a739018d680a1535$export$8d9616744e22681a)(...args), "translate", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$TranslateVNodeSymbol](...args), (key)=>[
                $409cbe3732db83c2$var$createTextNode(key)
            ], (val1)=>(0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(val1));
    }
    // numberParts, using for `i18n-n` component
    function numberParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $a739018d680a1535$export$98e628dec113755e), null, [
                context,
                ...args
            ]), ()=>(0, $a739018d680a1535$export$d0e2eec8b686cf72)(...args), "number format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$NumberPartsSymbol](...args), $409cbe3732db83c2$var$NOOP_RETURN_ARRAY, (val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(val1));
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $a739018d680a1535$export$7ba4466dbd0f07e1), null, [
                context,
                ...args
            ]), ()=>(0, $a739018d680a1535$export$165524b21a0d6b5e)(...args), "datetime format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$DatetimePartsSymbol](...args), $409cbe3732db83c2$var$NOOP_RETURN_ARRAY, (val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(val1));
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        return wrapWithDeps(()=>{
            if (!key) return false;
            const targetLocale = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale) ? locale : _locale.value;
            const message = getLocaleMessage(targetLocale);
            const resolved = _context.messageResolver(message, key);
            return !translateExistCompatible ? (0, $a739018d680a1535$export$9ba95744594b90e0)(resolved) || (0, $a739018d680a1535$export$92c0a039cf358271)(resolved) || (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(resolved) : resolved != null;
        }, ()=>[
                key
            ], "translate exists", (root)=>{
            return Reflect.apply(root.te, root, [
                key,
                locale
            ]);
        }, $409cbe3732db83c2$var$NOOP_RETURN_FALSE, (val1)=>(0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(val1));
    }
    function resolveMessages(key) {
        let messages = null;
        const locales = (0, $a739018d680a1535$export$71df9db82dc445)(_context, _fallbackLocale.value, _locale.value);
        for(let i = 0; i < locales.length; i++){
            const targetLocaleMessages = _messages.value[locales[i]] || {};
            const messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        const messages = resolveMessages(key);
        // prettier-ignore
        return messages != null ? messages : __root ? __root.tm(key) || {} : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return _messages.value[locale] || {};
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        if (flatJson) {
            const _message = {
                [locale]: message
            };
            for(const key in _message)if ((0, $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3)(_message, key)) $409cbe3732db83c2$var$handleFlatJson(_message[key]);
            message = _message[locale];
        }
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        const _message = {
            [locale]: message
        };
        if (flatJson) {
            for(const key in _message)if ((0, $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3)(_message, key)) $409cbe3732db83c2$var$handleFlatJson(_message[key]);
        }
        message = _message[locale];
        (0, $fbd1e3bc010bc8c2$export$6c40052bed430212)(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $a739018d680a1535$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $a739018d680a1535$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        (0, $a739018d680a1535$export$6a8717b3043a4f23)(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        (0, $a739018d680a1535$export$6a8717b3043a4f23)(_context, locale, format);
    }
    // for debug
    $409cbe3732db83c2$var$composerID++;
    // watch root locale & fallbackLocale
    if (__root && (0, $fbd1e3bc010bc8c2$export$620a268685f0ac45)) {
        (0, $TusQn.watch)(__root.locale, (val1)=>{
            if (_inheritLocale) {
                _locale.value = val1;
                _context.locale = val1;
                (0, $a739018d680a1535$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
        (0, $TusQn.watch)(__root.fallbackLocale, (val1)=>{
            if (_inheritLocale) {
                _fallbackLocale.value = val1;
                _context.fallbackLocale = val1;
                (0, $a739018d680a1535$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    const composer = {
        id: $409cbe3732db83c2$var$composerID,
        locale: locale,
        fallbackLocale: fallbackLocale,
        get inheritLocale () {
            return _inheritLocale;
        },
        set inheritLocale (val){
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                (0, $a739018d680a1535$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales () {
            return Object.keys(_messages.value).sort();
        },
        messages: messages,
        get modifiers () {
            return _modifiers;
        },
        get pluralRules () {
            return _pluralRules || {};
        },
        get isGlobal () {
            return _isGlobal;
        },
        get missingWarn () {
            return _missingWarn;
        },
        set missingWarn (val){
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn () {
            return _fallbackWarn;
        },
        set fallbackWarn (val){
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot () {
            return _fallbackRoot;
        },
        set fallbackRoot (val){
            _fallbackRoot = val;
        },
        get fallbackFormat () {
            return _fallbackFormat;
        },
        set fallbackFormat (val){
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage () {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _escapeParameter;
        },
        set escapeParameter (val){
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t: t,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        [$409cbe3732db83c2$var$SetPluralRulesSymbol]: setPluralRules
    };
    composer.datetimeFormats = datetimeFormats;
    composer.numberFormats = numberFormats;
    composer.rt = rt;
    composer.te = te;
    composer.tm = tm;
    composer.d = d;
    composer.n = n;
    composer.getDateTimeFormat = getDateTimeFormat;
    composer.setDateTimeFormat = setDateTimeFormat;
    composer.mergeDateTimeFormat = mergeDateTimeFormat;
    composer.getNumberFormat = getNumberFormat;
    composer.setNumberFormat = setNumberFormat;
    composer.mergeNumberFormat = mergeNumberFormat;
    composer[$409cbe3732db83c2$var$InejctWithOptionSymbol] = __injectWithOption;
    composer[$409cbe3732db83c2$var$TranslateVNodeSymbol] = translateVNode;
    composer[$409cbe3732db83c2$var$DatetimePartsSymbol] = datetimeParts;
    composer[$409cbe3732db83c2$var$NumberPartsSymbol] = numberParts;
    var emitter;
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */ function $409cbe3732db83c2$var$convertComposerOptions(options) {
    const locale = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $a739018d680a1535$export$1af4c7e47ad72f44);
    const fallbackLocale = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    const missing = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.missing) ? options.missing : undefined;
    const missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.silentTranslationWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.silentTranslationWarn) ? !options.silentTranslationWarn : true;
    const fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.silentFallbackWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.silentFallbackWarn) ? !options.silentFallbackWarn : true;
    const fallbackRoot = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    const fallbackFormat = !!options.formatFallbackMessages;
    const modifiers = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    const pluralizationRules = options.pluralizationRules;
    const postTranslation = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : undefined;
    const warnHtmlMessage = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== "off" : true;
    const escapeParameter = !!options.escapeParameterHtml;
    const inheritLocale = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.sync) ? options.sync : true;
    let messages = options.messages;
    if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.sharedMessages)) {
        const sharedMessages = options.sharedMessages;
        const locales = Object.keys(sharedMessages);
        messages = locales.reduce((messages, locale)=>{
            const message = messages[locale] || (messages[locale] = {});
            (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)(message, sharedMessages[locale]);
            return messages;
        }, messages || {});
    }
    const { __i18n: __i18n, __root: __root, __injectWithOption: __injectWithOption } = options;
    const datetimeFormats = options.datetimeFormats;
    const numberFormats = options.numberFormats;
    const flatJson = options.flatJson;
    const translateExistCompatible = options.translateExistCompatible;
    return {
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        flatJson: flatJson,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackRoot: fallbackRoot,
        fallbackFormat: fallbackFormat,
        modifiers: modifiers,
        pluralRules: pluralizationRules,
        postTranslation: postTranslation,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale: inheritLocale,
        translateExistCompatible: translateExistCompatible,
        __i18n: __i18n,
        __root: __root,
        __injectWithOption: __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$var$createVueI18n(options = {}, VueI18nLegacy) {
    {
        const composer = $409cbe3732db83c2$var$createComposer($409cbe3732db83c2$var$convertComposerOptions(options));
        const { __extender: __extender } = options;
        // defines VueI18n
        const vueI18n = {
            // id
            id: composer.id,
            // locale
            get locale () {
                return composer.locale.value;
            },
            set locale (val){
                composer.locale.value = val;
            },
            // fallbackLocale
            get fallbackLocale () {
                return composer.fallbackLocale.value;
            },
            set fallbackLocale (val){
                composer.fallbackLocale.value = val;
            },
            // messages
            get messages () {
                return composer.messages.value;
            },
            // datetimeFormats
            get datetimeFormats () {
                return composer.datetimeFormats.value;
            },
            // numberFormats
            get numberFormats () {
                return composer.numberFormats.value;
            },
            // availableLocales
            get availableLocales () {
                return composer.availableLocales;
            },
            // formatter
            get formatter () {
                // dummy
                return {
                    interpolate () {
                        return [];
                    }
                };
            },
            set formatter (val){},
            // missing
            get missing () {
                return composer.getMissingHandler();
            },
            set missing (handler){
                composer.setMissingHandler(handler);
            },
            // silentTranslationWarn
            get silentTranslationWarn () {
                return (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
            },
            set silentTranslationWarn (val){
                composer.missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // silentFallbackWarn
            get silentFallbackWarn () {
                return (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
            },
            set silentFallbackWarn (val){
                composer.fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // modifiers
            get modifiers () {
                return composer.modifiers;
            },
            // formatFallbackMessages
            get formatFallbackMessages () {
                return composer.fallbackFormat;
            },
            set formatFallbackMessages (val){
                composer.fallbackFormat = val;
            },
            // postTranslation
            get postTranslation () {
                return composer.getPostTranslationHandler();
            },
            set postTranslation (handler){
                composer.setPostTranslationHandler(handler);
            },
            // sync
            get sync () {
                return composer.inheritLocale;
            },
            set sync (val){
                composer.inheritLocale = val;
            },
            // warnInHtmlMessage
            get warnHtmlInMessage () {
                return composer.warnHtmlMessage ? "warn" : "off";
            },
            set warnHtmlInMessage (val){
                composer.warnHtmlMessage = val !== "off";
            },
            // escapeParameterHtml
            get escapeParameterHtml () {
                return composer.escapeParameter;
            },
            set escapeParameterHtml (val){
                composer.escapeParameter = val;
            },
            // preserveDirectiveContent
            get preserveDirectiveContent () {
                return true;
            },
            set preserveDirectiveContent (val){},
            // pluralizationRules
            get pluralizationRules () {
                return composer.pluralRules || {};
            },
            // for internal
            __composer: composer,
            // t
            t (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {};
                let list = null;
                let named = null;
                if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            rt (...args) {
                return Reflect.apply(composer.rt, composer, [
                    ...args
                ]);
            },
            // tc
            tc (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {
                    plural: 1
                };
                let list = null;
                let named = null;
                if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
                else if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg3)) options.locale = arg3;
                else if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            // te
            te (key, locale) {
                return composer.te(key, locale);
            },
            // tm
            tm (key) {
                return composer.tm(key);
            },
            // getLocaleMessage
            getLocaleMessage (locale) {
                return composer.getLocaleMessage(locale);
            },
            // setLocaleMessage
            setLocaleMessage (locale, message) {
                composer.setLocaleMessage(locale, message);
            },
            // mergeLocaleMessage
            mergeLocaleMessage (locale, message) {
                composer.mergeLocaleMessage(locale, message);
            },
            // d
            d (...args) {
                return Reflect.apply(composer.d, composer, [
                    ...args
                ]);
            },
            // getDateTimeFormat
            getDateTimeFormat (locale) {
                return composer.getDateTimeFormat(locale);
            },
            // setDateTimeFormat
            setDateTimeFormat (locale, format) {
                composer.setDateTimeFormat(locale, format);
            },
            // mergeDateTimeFormat
            mergeDateTimeFormat (locale, format) {
                composer.mergeDateTimeFormat(locale, format);
            },
            // n
            n (...args) {
                return Reflect.apply(composer.n, composer, [
                    ...args
                ]);
            },
            // getNumberFormat
            getNumberFormat (locale) {
                return composer.getNumberFormat(locale);
            },
            // setNumberFormat
            setNumberFormat (locale, format) {
                composer.setNumberFormat(locale, format);
            },
            // mergeNumberFormat
            mergeNumberFormat (locale, format) {
                composer.mergeNumberFormat(locale, format);
            },
            // getChoiceIndex
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            getChoiceIndex (choice, choicesLength) {
                return -1;
            }
        };
        vueI18n.__extender = __extender;
        var emitter;
        return vueI18n;
    }
}
/* eslint-enable @typescript-eslint/no-explicit-any */ const $409cbe3732db83c2$var$baseFormatProps = {
    tag: {
        type: [
            String,
            Object
        ]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: (val1 /* ComponentI18nScope */ )=>val1 === "parent" || val1 === "global",
        default: "parent" /* ComponentI18nScope */ 
    },
    i18n: {
        type: Object
    }
};
function $409cbe3732db83c2$var$getInterpolateArg(// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ slots: slots }, keys) {
    if (keys.length === 1 && keys[0] === "default") {
        // default slot with list
        const ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce((slot, current)=>{
            return [
                ...slot,
                // prettier-ignore
                ...current.type === (0, $TusQn.Fragment) ? current.children : [
                    current
                ]
            ];
        }, []);
    } else // named slots
    return keys.reduce((arg, key)=>{
        const slot = slots[key];
        if (slot) arg[key] = slot();
        return arg;
    }, {});
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getFragmentableTag(tag) {
    return 0, $TusQn.Fragment;
}
const $409cbe3732db83c2$var$TranslationImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: "i18n-t",
    props: (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [
                Number,
                String
            ],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validator: (val1)=>(0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(val1) || !isNaN(val1)
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const { slots: slots, attrs: attrs } = context;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return ()=>{
            const keys = Object.keys(slots).filter((key)=>key !== "_");
            const options = {};
            if (props.locale) options.locale = props.locale;
            if (props.plural !== undefined) options.plural = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(props.plural) ? +props.plural : props.plural;
            const arg = $409cbe3732db83c2$var$getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = i18n[$409cbe3732db83c2$var$TranslateVNodeSymbol](props.keypath, arg, options);
            const assignedAttrs = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, attrs);
            const tag = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(props.tag) || (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : $409cbe3732db83c2$var$getFragmentableTag();
            return (0, $TusQn.h)(tag, assignedAttrs, children);
        };
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n keypath="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$b63289fbda65eed1 = $409cbe3732db83c2$var$TranslationImpl;
const $409cbe3732db83c2$export$1d08de71ac06ffd6 = $409cbe3732db83c2$export$b63289fbda65eed1;
function $409cbe3732db83c2$var$isVNode(target) {
    return (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(target) && !(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(target[0]);
}
function $409cbe3732db83c2$var$renderFormatter(props, context, slotKeys, partFormatter) {
    const { slots: slots, attrs: attrs } = context;
    return ()=>{
        const options = {
            part: true
        };
        let overrides = {};
        if (props.locale) options.locale = props.locale;
        if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(props.format)) options.key = props.format;
        else if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(props.format.key)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            options.key = props.format.key;
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce((options, prop)=>{
                return slotKeys.includes(prop) ? (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, options, {
                    [prop]: props.format[prop]
                }) // eslint-disable-line @typescript-eslint/no-explicit-any
                 : options;
            }, {});
        }
        const parts = partFormatter(...[
            props.value,
            options,
            overrides
        ]);
        let children = [
            options.key
        ];
        if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(parts)) children = parts.map((part, index)=>{
            const slot = slots[part.type];
            const node = slot ? slot({
                [part.type]: part.value,
                index: index,
                parts: parts
            }) : [
                part.value
            ];
            if ($409cbe3732db83c2$var$isVNode(node)) node[0].key = `${part.type}-${index}`;
            return node;
        });
        else if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(parts)) children = [
            parts
        ];
        const assignedAttrs = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, attrs);
        const tag = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(props.tag) || (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : $409cbe3732db83c2$var$getFragmentableTag();
        return (0, $TusQn.h)(tag, assignedAttrs, children);
    };
}
const $409cbe3732db83c2$var$NumberFormatImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: "i18n-n",
    props: (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return $409cbe3732db83c2$var$renderFormatter(props, context, (0, $a739018d680a1535$export$c39a7c3789c46ed6), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$409cbe3732db83c2$var$NumberPartsSymbol](...args));
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$27bce688931fdfcc = $409cbe3732db83c2$var$NumberFormatImpl;
const $409cbe3732db83c2$export$4665d24327644133 = $409cbe3732db83c2$export$27bce688931fdfcc;
const $409cbe3732db83c2$var$DatetimeFormatImpl = /* #__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: "i18n-d",
    props: (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({
        value: {
            type: [
                Number,
                Date
            ],
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return $409cbe3732db83c2$var$renderFormatter(props, context, (0, $a739018d680a1535$export$c77049eaf05b1508), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$409cbe3732db83c2$var$DatetimePartsSymbol](...args));
    }
});
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$64ca50867510e64e = $409cbe3732db83c2$var$DatetimeFormatImpl;
const $409cbe3732db83c2$export$c741260b89dcb234 = $409cbe3732db83c2$export$64ca50867510e64e;
function $409cbe3732db83c2$var$getComposer$2(i18n, instance) {
    const i18nInternal = i18n;
    if (i18n.mode === "composition") return i18nInternal.__getInstance(instance) || i18n.global;
    else {
        const vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null ? vueI18n.__composer : i18n.global.__composer;
    }
}
function $409cbe3732db83c2$export$8a5a05546006d0b5(i18n) {
    const _process = (binding)=>{
        const { instance: instance, modifiers: modifiers, value: value } = binding;
        /* istanbul ignore if */ if (!instance || !instance.$) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const composer = $409cbe3732db83c2$var$getComposer$2(i18n, instance.$);
        const parsedValue = $409cbe3732db83c2$var$parseValue(value);
        return [
            Reflect.apply(composer.t, composer, [
                ...$409cbe3732db83c2$var$makeParams(parsedValue)
            ]),
            composer
        ];
    };
    const register = (el, binding)=>{
        const [textContent, composer] = _process(binding);
        if ((0, $fbd1e3bc010bc8c2$export$620a268685f0ac45) && i18n.global === composer) // global scope only
        el.__i18nWatcher = (0, $TusQn.watch)(composer.locale, ()=>{
            binding.instance && binding.instance.$forceUpdate();
        });
        el.__composer = composer;
        el.textContent = textContent;
    };
    const unregister = (el)=>{
        if ((0, $fbd1e3bc010bc8c2$export$620a268685f0ac45) && el.__i18nWatcher) {
            el.__i18nWatcher();
            el.__i18nWatcher = undefined;
            delete el.__i18nWatcher;
        }
        if (el.__composer) {
            el.__composer = undefined;
            delete el.__composer;
        }
    };
    const update = (el, { value: value })=>{
        if (el.__composer) {
            const composer = el.__composer;
            const parsedValue = $409cbe3732db83c2$var$parseValue(value);
            el.textContent = Reflect.apply(composer.t, composer, [
                ...$409cbe3732db83c2$var$makeParams(parsedValue)
            ]);
        }
    };
    const getSSRProps = (binding)=>{
        const [textContent] = _process(binding);
        return {
            textContent: textContent
        };
    };
    return {
        created: register,
        unmounted: unregister,
        beforeUpdate: update,
        getSSRProps: getSSRProps
    };
}
function $409cbe3732db83c2$var$parseValue(value) {
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(value)) return {
        path: value
    };
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(value)) {
        if (!("path" in value)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.REQUIRED_VALUE, "path");
        return value;
    } else throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_VALUE);
}
function $409cbe3732db83c2$var$makeParams(value) {
    const { path: path, locale: locale, args: args, choice: choice, plural: plural } = value;
    const options = {};
    const named = args || {};
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale)) options.locale = locale;
    if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(choice)) options.plural = choice;
    if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(plural)) options.plural = plural;
    return [
        path,
        named,
        options
    ];
}
function $409cbe3732db83c2$var$apply(app, i18n, ...options) {
    const pluginOptions = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options[0]) ? options[0] : {};
    const useI18nComponentName = !!pluginOptions.useI18nComponentName;
    const globalInstall = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(pluginOptions.globalInstall) ? pluginOptions.globalInstall : true;
    if (globalInstall) {
        [
            !useI18nComponentName ? $409cbe3732db83c2$export$b63289fbda65eed1.name : "i18n",
            "I18nT"
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$b63289fbda65eed1));
        [
            $409cbe3732db83c2$export$27bce688931fdfcc.name,
            "I18nN"
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$27bce688931fdfcc));
        [
            $409cbe3732db83c2$export$64ca50867510e64e.name,
            "I18nD"
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$64ca50867510e64e));
    }
    app.directive("t", $409cbe3732db83c2$export$8a5a05546006d0b5(i18n));
}
const $409cbe3732db83c2$var$VueDevToolsLabels = {
    ["vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ]: "Vue I18n devtools",
    ["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]: "I18n Resources",
    ["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]: "Vue I18n"
};
const $409cbe3732db83c2$var$VueDevToolsPlaceholders = {
    ["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]: "Search for scopes ..."
};
const $409cbe3732db83c2$var$VueDevToolsTimelineColors = {
    ["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]: 0xffcd19
};
const $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES = "vue-i18n: composer properties";
let $409cbe3732db83c2$var$devtoolsApi;
async function $409cbe3732db83c2$var$enableDevTools(app, i18n) {
    return new Promise((resolve, reject)=>{
        try {
            (0, $de8f43bece76d38a$export$63b9a9bba9f20f3e)({
                id: "vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ,
                label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ],
                packageName: "vue-i18n",
                homepage: "https://vue-i18n.intlify.dev",
                logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
                componentStateTypes: [
                    $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES
                ],
                app: app // eslint-disable-line @typescript-eslint/no-explicit-any
            }, (api)=>{
                $409cbe3732db83c2$var$devtoolsApi = api;
                api.on.visitComponentTree(({ componentInstance: componentInstance, treeNode: treeNode })=>{
                    $409cbe3732db83c2$var$updateComponentTreeTags(componentInstance, treeNode, i18n);
                });
                api.on.inspectComponent(({ componentInstance: componentInstance, instanceData: instanceData })=>{
                    if (componentInstance.vnode.el && componentInstance.vnode.el.__VUE_I18N__ && instanceData) {
                        if (i18n.mode === "legacy") // ignore global scope on legacy mode
                        {
                            if (componentInstance.vnode.el.__VUE_I18N__ !== i18n.global.__composer) $409cbe3732db83c2$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                        } else $409cbe3732db83c2$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                    }
                });
                api.addInspector({
                    id: "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ,
                    label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ],
                    icon: "language",
                    treeFilterPlaceholder: $409cbe3732db83c2$var$VueDevToolsPlaceholders["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]
                });
                api.on.getInspectorTree((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) $409cbe3732db83c2$var$registerScope(payload, i18n);
                });
                const roots = new Map();
                api.on.getInspectorState(async (payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) {
                        api.unhighlightElement();
                        $409cbe3732db83c2$var$inspectScope(payload, i18n);
                        if (payload.nodeId === "global") {
                            if (!roots.has(payload.app)) {
                                const [root] = await api.getComponentInstances(payload.app);
                                roots.set(payload.app, root);
                            }
                            api.highlightElement(roots.get(payload.app));
                        } else {
                            const instance = $409cbe3732db83c2$var$getComponentInstance(payload.nodeId, i18n);
                            instance && api.highlightElement(instance);
                        }
                    }
                });
                api.on.editInspectorState((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) $409cbe3732db83c2$var$editScope(payload, i18n);
                });
                api.addTimelineLayer({
                    id: "vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ,
                    label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ],
                    color: $409cbe3732db83c2$var$VueDevToolsTimelineColors["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]
                });
                resolve(true);
            });
        } catch (e) {
            console.error(e);
            reject(false);
        }
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getI18nScopeLable(instance) {
    return instance.type.name || instance.type.displayName || instance.type.__file || "Anonymous";
}
function $409cbe3732db83c2$var$updateComponentTreeTags(instance, treeNode, i18n) {
    // prettier-ignore
    const global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__) // add custom tags local scope only
    {
        if (instance.vnode.el.__VUE_I18N__ !== global) {
            const tag = {
                label: `i18n (${$409cbe3732db83c2$var$getI18nScopeLable(instance)} Scope)`,
                textColor: 0x000000,
                backgroundColor: 0xffcd19
            };
            treeNode.tags.push(tag);
        }
    }
}
function $409cbe3732db83c2$var$inspectComposer(instanceData, composer) {
    const type = $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES;
    instanceData.state.push({
        type: type,
        key: "locale",
        editable: true,
        value: composer.locale.value
    });
    instanceData.state.push({
        type: type,
        key: "availableLocales",
        editable: false,
        value: composer.availableLocales
    });
    instanceData.state.push({
        type: type,
        key: "fallbackLocale",
        editable: true,
        value: composer.fallbackLocale.value
    });
    instanceData.state.push({
        type: type,
        key: "inheritLocale",
        editable: true,
        value: composer.inheritLocale
    });
    instanceData.state.push({
        type: type,
        key: "messages",
        editable: false,
        value: $409cbe3732db83c2$var$getLocaleMessageValue(composer.messages.value)
    });
    instanceData.state.push({
        type: type,
        key: "datetimeFormats",
        editable: false,
        value: composer.datetimeFormats.value
    });
    instanceData.state.push({
        type: type,
        key: "numberFormats",
        editable: false,
        value: composer.numberFormats.value
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getLocaleMessageValue(messages) {
    const value = {};
    Object.keys(messages).forEach((key)=>{
        const v = messages[key];
        if ((0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(v) && "source" in v) value[key] = $409cbe3732db83c2$var$getMessageFunctionDetails(v);
        else if ((0, $a739018d680a1535$export$9ba95744594b90e0)(v) && v.loc && v.loc.source) value[key] = v.loc.source;
        else if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(v)) value[key] = $409cbe3732db83c2$var$getLocaleMessageValue(v);
        else value[key] = v;
    });
    return value;
}
const $409cbe3732db83c2$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "&": "&amp;"
};
function $409cbe3732db83c2$var$escape(s) {
    return s.replace(/[<>"&]/g, $409cbe3732db83c2$var$escapeChar);
}
function $409cbe3732db83c2$var$escapeChar(a) {
    return $409cbe3732db83c2$var$ESC[a] || a;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getMessageFunctionDetails(func) {
    const argString = func.source ? `("${$409cbe3732db83c2$var$escape(func.source)}")` : `(?)`;
    return {
        _custom: {
            type: "function",
            display: `<span>\u{192}</span> ${argString}`
        }
    };
}
function $409cbe3732db83c2$var$registerScope(payload, i18n) {
    payload.rootNodes.push({
        id: "global",
        label: "Global Scope"
    });
    // prettier-ignore
    const global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    for (const [keyInstance, instance] of i18n.__instances){
        // prettier-ignore
        const composer = i18n.mode === "composition" ? instance : instance.__composer;
        if (global === composer) continue;
        payload.rootNodes.push({
            id: composer.id.toString(),
            label: `${$409cbe3732db83c2$var$getI18nScopeLable(keyInstance)} Scope`
        });
    }
}
function $409cbe3732db83c2$var$getComponentInstance(nodeId, i18n) {
    let instance = null;
    if (nodeId !== "global") {
        for (const [component, composer] of i18n.__instances.entries())if (composer.id.toString() === nodeId) {
            instance = component;
            break;
        }
    }
    return instance;
}
function $409cbe3732db83c2$var$getComposer$1(nodeId, i18n) {
    if (nodeId === "global") return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    else {
        const instance = Array.from(i18n.__instances.values()).find((item)=>item.id.toString() === nodeId);
        if (instance) return i18n.mode === "composition" ? instance : instance.__composer;
        else return null;
    }
}
function $409cbe3732db83c2$var$inspectScope(payload, i18n) {
    const composer = $409cbe3732db83c2$var$getComposer$1(payload.nodeId, i18n);
    if (composer) // TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload.state = $409cbe3732db83c2$var$makeScopeInspectState(composer);
    return null;
}
function $409cbe3732db83c2$var$makeScopeInspectState(composer) {
    const state = {};
    const localeType = "Locale related info";
    const localeStates = [
        {
            type: localeType,
            key: "locale",
            editable: true,
            value: composer.locale.value
        },
        {
            type: localeType,
            key: "fallbackLocale",
            editable: true,
            value: composer.fallbackLocale.value
        },
        {
            type: localeType,
            key: "availableLocales",
            editable: false,
            value: composer.availableLocales
        },
        {
            type: localeType,
            key: "inheritLocale",
            editable: true,
            value: composer.inheritLocale
        }
    ];
    state[localeType] = localeStates;
    const localeMessagesType = "Locale messages info";
    const localeMessagesStates = [
        {
            type: localeMessagesType,
            key: "messages",
            editable: false,
            value: $409cbe3732db83c2$var$getLocaleMessageValue(composer.messages.value)
        }
    ];
    state[localeMessagesType] = localeMessagesStates;
    {
        const datetimeFormatsType = "Datetime formats info";
        const datetimeFormatsStates = [
            {
                type: datetimeFormatsType,
                key: "datetimeFormats",
                editable: false,
                value: composer.datetimeFormats.value
            }
        ];
        state[datetimeFormatsType] = datetimeFormatsStates;
        const numberFormatsType = "Datetime formats info";
        const numberFormatsStates = [
            {
                type: numberFormatsType,
                key: "numberFormats",
                editable: false,
                value: composer.numberFormats.value
            }
        ];
        state[numberFormatsType] = numberFormatsStates;
    }
    return state;
}
function $409cbe3732db83c2$var$addTimelineEvent(event, payload) {
    if ($409cbe3732db83c2$var$devtoolsApi) {
        let groupId;
        if (payload && "groupId" in payload) {
            groupId = payload.groupId;
            delete payload.groupId;
        }
        $409cbe3732db83c2$var$devtoolsApi.addTimelineEvent({
            layerId: "vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ,
            event: {
                title: event,
                groupId: groupId,
                time: Date.now(),
                meta: {},
                data: payload || {},
                logType: event === "compile-error" /* VueDevToolsTimelineEvents.COMPILE_ERROR */  ? "error" : event === "fallback" /* VueDevToolsTimelineEvents.FALBACK */  || event === "missing" /* VueDevToolsTimelineEvents.MISSING */  ? "warning" : "default"
            }
        });
    }
}
function $409cbe3732db83c2$var$editScope(payload, i18n) {
    const composer = $409cbe3732db83c2$var$getComposer$1(payload.nodeId, i18n);
    if (composer) {
        const [field] = payload.path;
        if (field === "locale" && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(payload.state.value)) composer.locale.value = payload.state.value;
        else if (field === "fallbackLocale" && ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(payload.state.value) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(payload.state.value) || (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(payload.state.value))) composer.fallbackLocale.value = payload.state.value;
        else if (field === "inheritLocale" && (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(payload.state.value)) composer.inheritLocale = payload.state.value;
    }
}
/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */ function $409cbe3732db83c2$var$defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate () {
            const instance = (0, $TusQn.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const options = this.$options;
            if (options.i18n) {
                const optionsI18n = options.i18n;
                if (options.__i18n) optionsI18n.__i18n = options.__i18n;
                optionsI18n.__root = composer;
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $409cbe3732db83c2$var$mergeToGlobal(vuei18n, optionsI18n);
                else {
                    optionsI18n.__injectWithOption = true;
                    optionsI18n.__extender = i18n.__vueI18nExtend;
                    // atttach local VueI18n instance
                    this.$i18n = $409cbe3732db83c2$var$createVueI18n(optionsI18n);
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else if (options.__i18n) {
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $409cbe3732db83c2$var$mergeToGlobal(vuei18n, options);
                else {
                    // atttach local VueI18n instance
                    this.$i18n = $409cbe3732db83c2$var$createVueI18n({
                        __i18n: options.__i18n,
                        __injectWithOption: true,
                        __extender: i18n.__vueI18nExtend,
                        __root: composer
                    });
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else // attach global VueI18n instance
            this.$i18n = vuei18n;
            if (options.__i18nGlobal) $409cbe3732db83c2$var$adjustI18nResources(composer, options, options);
            // defines vue-i18n legacy APIs
            this.$t = (...args)=>this.$i18n.t(...args);
            this.$rt = (...args)=>this.$i18n.rt(...args);
            this.$tc = (...args)=>this.$i18n.tc(...args);
            this.$te = (key, locale)=>this.$i18n.te(key, locale);
            this.$d = (...args)=>this.$i18n.d(...args);
            this.$n = (...args)=>this.$i18n.n(...args);
            this.$tm = (key)=>this.$i18n.tm(key);
            i18n.__setInstance(instance, this.$i18n);
        },
        mounted () {
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$i18n) {
                const _vueI18n = this.$i18n;
                this.$el.__VUE_I18N__ = _vueI18n.__composer;
                const emitter = this.__v_emitter = (0, $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1)();
                _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                emitter.on("*", $409cbe3732db83c2$var$addTimelineEvent);
            }
        },
        unmounted () {
            const instance = (0, $TusQn.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const _vueI18n = this.$i18n;
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$el.__VUE_I18N__) {
                if (this.__v_emitter) {
                    this.__v_emitter.off("*", $409cbe3732db83c2$var$addTimelineEvent);
                    delete this.__v_emitter;
                }
                if (this.$i18n) {
                    _vueI18n.__disableEmitter && _vueI18n.__disableEmitter();
                    delete this.$el.__VUE_I18N__;
                }
            }
            delete this.$t;
            delete this.$rt;
            delete this.$tc;
            delete this.$te;
            delete this.$d;
            delete this.$n;
            delete this.$tm;
            if (_vueI18n.__disposer) {
                _vueI18n.__disposer();
                delete _vueI18n.__disposer;
                delete _vueI18n.__extender;
            }
            i18n.__deleteInstance(instance);
            delete this.$i18n;
        }
    };
}
function $409cbe3732db83c2$var$mergeToGlobal(g, options) {
    g.locale = options.locale || g.locale;
    g.fallbackLocale = options.fallbackLocale || g.fallbackLocale;
    g.missing = options.missing || g.missing;
    g.silentTranslationWarn = options.silentTranslationWarn || g.silentFallbackWarn;
    g.silentFallbackWarn = options.silentFallbackWarn || g.silentFallbackWarn;
    g.formatFallbackMessages = options.formatFallbackMessages || g.formatFallbackMessages;
    g.postTranslation = options.postTranslation || g.postTranslation;
    g.warnHtmlInMessage = options.warnHtmlInMessage || g.warnHtmlInMessage;
    g.escapeParameterHtml = options.escapeParameterHtml || g.escapeParameterHtml;
    g.sync = options.sync || g.sync;
    g.__composer[$409cbe3732db83c2$var$SetPluralRulesSymbol](options.pluralizationRules || g.pluralizationRules);
    const messages = $409cbe3732db83c2$var$getLocaleMessages(g.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach((locale)=>g.mergeLocaleMessage(locale, messages[locale]));
    if (options.datetimeFormats) Object.keys(options.datetimeFormats).forEach((locale)=>g.mergeDateTimeFormat(locale, options.datetimeFormats[locale]));
    if (options.numberFormats) Object.keys(options.numberFormats).forEach((locale)=>g.mergeNumberFormat(locale, options.numberFormats[locale]));
    return g;
}
/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */ const $409cbe3732db83c2$export$b19990ca6e622dd2 = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("global-vue-i18n");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$export$920091e3d72d80ee(options = {}, VueI18nLegacy) {
    // prettier-ignore
    const __legacyMode = __VUE_I18N_LEGACY_API__ && (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.legacy) ? options.legacy : __VUE_I18N_LEGACY_API__;
    // prettier-ignore
    const __globalInjection = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.globalInjection) ? options.globalInjection : true;
    // prettier-ignore
    const __allowComposition = __VUE_I18N_LEGACY_API__ && __legacyMode ? !!options.allowComposition : true;
    const __instances = new Map();
    const [globalScope, __global] = $409cbe3732db83c2$var$createGlobal(options, __legacyMode);
    const symbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("");
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    {
        const i18n = {
            // mode
            get mode () {
                return __VUE_I18N_LEGACY_API__ && __legacyMode ? "legacy" : "composition";
            },
            // allowComposition
            get allowComposition () {
                return __allowComposition;
            },
            // install plugin
            async install (app, ...options) {
                if (__VUE_PROD_DEVTOOLS__ && true) app.__VUE_I18N__ = i18n;
                // setup global provider
                app.__VUE_I18N_SYMBOL__ = symbol;
                app.provide(app.__VUE_I18N_SYMBOL__, i18n);
                // set composer & vuei18n extend hook options from plugin options
                if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options[0])) {
                    const opts = options[0];
                    i18n.__composerExtend = opts.__composerExtend;
                    i18n.__vueI18nExtend = opts.__vueI18nExtend;
                }
                // global method and properties injection for Composition API
                let globalReleaseHandler = null;
                if (!__legacyMode && __globalInjection) globalReleaseHandler = $409cbe3732db83c2$var$injectGlobalFields(app, i18n.global);
                // install built-in components and directive
                if (__VUE_I18N_FULL_INSTALL__) $409cbe3732db83c2$var$apply(app, i18n, ...options);
                // setup mixin for Legacy API
                if (__VUE_I18N_LEGACY_API__ && __legacyMode) app.mixin($409cbe3732db83c2$var$defineMixin(__global, __global.__composer, i18n));
                // release global scope
                const unmountApp = app.unmount;
                app.unmount = ()=>{
                    globalReleaseHandler && globalReleaseHandler();
                    i18n.dispose();
                    unmountApp();
                };
                // setup vue-devtools plugin
                if (__VUE_PROD_DEVTOOLS__ && true) {
                    const ret = await $409cbe3732db83c2$var$enableDevTools(app, i18n);
                    if (!ret) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
                    const emitter = (0, $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1)();
                    if (__legacyMode) {
                        const _vueI18n = __global;
                        _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                    } else {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const _composer = __global;
                        _composer[$409cbe3732db83c2$var$EnableEmitter] && _composer[$409cbe3732db83c2$var$EnableEmitter](emitter);
                    }
                    emitter.on("*", $409cbe3732db83c2$var$addTimelineEvent);
                }
            },
            // global accessor
            get global () {
                return __global;
            },
            dispose () {
                globalScope.stop();
            },
            __instances: // @internal
            __instances,
            __getInstance: // @internal
            __getInstance,
            __setInstance: // @internal
            __setInstance,
            __deleteInstance: // @internal
            __deleteInstance
        };
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$export$3f3caade1c12f8c9(options = {}) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (instance == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    if (!instance.isCE && instance.appContext.app != null && !instance.appContext.app.__VUE_I18N_SYMBOL__) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED);
    const i18n = $409cbe3732db83c2$var$getI18nInstance(instance);
    const gl = $409cbe3732db83c2$var$getGlobalComposer(i18n);
    const componentOptions = $409cbe3732db83c2$var$getComponentOptions(instance);
    const scope = $409cbe3732db83c2$var$getScope(options, componentOptions);
    if (__VUE_I18N_LEGACY_API__) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {
        if (i18n.mode === "legacy" && !options.__useComponent) {
            if (!i18n.allowComposition) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
            return $409cbe3732db83c2$var$useI18nForLegacy(instance, scope, gl, options);
        }
    }
    if (scope === "global") {
        $409cbe3732db83c2$var$adjustI18nResources(gl, options, componentOptions);
        return gl;
    }
    if (scope === "parent") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let composer = $409cbe3732db83c2$var$getComposer(i18n, instance, options.__useComponent);
        if (composer == null) composer = gl;
        return composer;
    }
    const i18nInternal = i18n;
    let composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        const composerOptions = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, options);
        if ("__i18n" in componentOptions) composerOptions.__i18n = componentOptions.__i18n;
        if (gl) composerOptions.__root = gl;
        composer = $409cbe3732db83c2$var$createComposer(composerOptions);
        if (i18nInternal.__composerExtend) composer[$409cbe3732db83c2$var$DisposeSymbol] = i18nInternal.__composerExtend(composer);
        $409cbe3732db83c2$var$setupLifeCycle(i18nInternal, instance, composer);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
/**
 * Cast to VueI18n legacy compatible type
 *
 * @remarks
 * This API is provided only with [vue-i18n-bridge](https://vue-i18n.intlify.dev/guide/migration/ways.html#what-is-vue-i18n-bridge).
 *
 * The purpose of this function is to convert an {@link I18n} instance created with {@link createI18n | createI18n(legacy: true)} into a `vue-i18n@v8.x` compatible instance of `new VueI18n` in a TypeScript environment.
 *
 * @param i18n - An instance of {@link I18n}
 * @returns A i18n instance which is casted to {@link VueI18n} type
 *
 * @VueI18nTip
 * :new: provided by **vue-i18n-bridge only**
 *
 * @VueI18nGeneral
 */ /* #__NO_SIDE_EFFECTS__ */ const $409cbe3732db83c2$export$ec8a89fa64fbfb0 = (i18n)=>{
    if (!($409cbe3732db83c2$var$__VUE_I18N_BRIDGE__ in i18n)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N);
    return i18n;
};
function $409cbe3732db83c2$var$createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const scope = (0, $01W3b.effectScope)();
    {
        const obj = __VUE_I18N_LEGACY_API__ && legacyMode ? scope.run(()=>$409cbe3732db83c2$var$createVueI18n(options)) : scope.run(()=>$409cbe3732db83c2$var$createComposer(options));
        if (obj == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        return [
            scope,
            obj
        ];
    }
}
function $409cbe3732db83c2$var$getI18nInstance(instance) {
    {
        const i18n = (0, $TusQn.inject)(!instance.isCE ? instance.appContext.app.__VUE_I18N_SYMBOL__ : $409cbe3732db83c2$export$b19990ca6e622dd2);
        /* istanbul ignore if */ if (!i18n) throw $409cbe3732db83c2$var$createI18nError(!instance.isCE ? $409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR : $409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getScope(options, componentOptions) {
    // prettier-ignore
    return (0, $fbd1e3bc010bc8c2$export$83b788b1a3698c03)(options) ? "__i18n" in componentOptions ? "local" : "global" : !options.useScope ? "local" : options.useScope;
}
function $409cbe3732db83c2$var$getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
}
function $409cbe3732db83c2$var$getComposer(i18n, target, useComponent = false) {
    let composer = null;
    const root = target.root;
    let current = $409cbe3732db83c2$var$getParentComponentInstance(target, useComponent);
    while(current != null){
        const i18nInternal = i18n;
        if (i18n.mode === "composition") composer = i18nInternal.__getInstance(current);
        else if (__VUE_I18N_LEGACY_API__) {
            const vueI18n = i18nInternal.__getInstance(current);
            if (vueI18n != null) {
                composer = vueI18n.__composer;
                if (useComponent && composer && !composer[$409cbe3732db83c2$var$InejctWithOptionSymbol] // eslint-disable-line @typescript-eslint/no-explicit-any
                ) composer = null;
            }
        }
        if (composer != null) break;
        if (root === current) break;
        current = current.parent;
    }
    return composer;
}
function $409cbe3732db83c2$var$getParentComponentInstance(target, useComponent = false) {
    if (target == null) return null;
    // if `useComponent: true` will be specified, we get lexical scope owner instance for use-case slots
    return !useComponent ? target.parent : target.vnode.ctx || target.parent; // eslint-disable-line @typescript-eslint/no-explicit-any
}
function $409cbe3732db83c2$var$setupLifeCycle(i18n, target, composer) {
    let emitter = null;
    (0, $TusQn.onMounted)(()=>{
        // inject composer instance to DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el) {
            target.vnode.el.__VUE_I18N__ = composer;
            emitter = (0, $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1)();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const _composer = composer;
            _composer[$409cbe3732db83c2$var$EnableEmitter] && _composer[$409cbe3732db83c2$var$EnableEmitter](emitter);
            emitter.on("*", $409cbe3732db83c2$var$addTimelineEvent);
        }
    }, target);
    (0, $TusQn.onUnmounted)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _composer = composer;
        // remove composer instance from DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el && target.vnode.el.__VUE_I18N__) {
            emitter && emitter.off("*", $409cbe3732db83c2$var$addTimelineEvent);
            _composer[$409cbe3732db83c2$var$DisableEmitter] && _composer[$409cbe3732db83c2$var$DisableEmitter]();
            delete target.vnode.el.__VUE_I18N__;
        }
        i18n.__deleteInstance(target);
        // dispose extended resources
        const dispose = _composer[$409cbe3732db83c2$var$DisposeSymbol];
        if (dispose) {
            dispose();
            delete _composer[$409cbe3732db83c2$var$DisposeSymbol];
        }
    }, target);
}
function $409cbe3732db83c2$var$useI18nForLegacy(instance, scope, root, options = {} // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const isLocalScope = scope === "local";
    const _composer = (0, $01W3b.shallowRef)(null);
    if (isLocalScope && instance.proxy && !(instance.proxy.$options.i18n || instance.proxy.$options.__i18n)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
    const _inheritLocale = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.inheritLocale) ? options.inheritLocale : !(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.locale);
    const _locale = (0, $01W3b.ref)(// prettier-ignore
    !isLocalScope || _inheritLocale ? root.locale.value : (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $a739018d680a1535$export$1af4c7e47ad72f44));
    const _fallbackLocale = (0, $01W3b.ref)(// prettier-ignore
    !isLocalScope || _inheritLocale ? root.fallbackLocale.value : (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = (0, $01W3b.ref)($409cbe3732db83c2$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = (0, $01W3b.ref)((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = (0, $01W3b.ref)((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _missingWarn = isLocalScope ? root.missingWarn : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    const _fallbackWarn = isLocalScope ? root.fallbackWarn : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    const _fallbackRoot = isLocalScope ? root.fallbackRoot : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    const _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    const _missing = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    // postTranslation handler
    const _postTranslation = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    const _warnHtmlMessage = isLocalScope ? root.warnHtmlMessage : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const _escapeParameter = !!options.escapeParameter;
    // prettier-ignore
    const _modifiers = isLocalScope ? root.modifiers : (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    const _pluralRules = options.pluralRules || isLocalScope && root.pluralRules;
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $01W3b.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.locale.value : _locale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.locale.value = val1;
            _locale.value = val1;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $01W3b.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.fallbackLocale.value : _fallbackLocale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.fallbackLocale.value = val1;
            _fallbackLocale.value = val1;
        }
    });
    // messages
    const messages = (0, $01W3b.computed)(()=>{
        if (_composer.value) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _composer.value.messages.value;
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _messages.value;
    });
    const datetimeFormats = (0, $01W3b.computed)(()=>_datetimeFormats.value);
    const numberFormats = (0, $01W3b.computed)(()=>_numberFormats.value);
    function getPostTranslationHandler() {
        return _composer.value ? _composer.value.getPostTranslationHandler() : _postTranslation;
    }
    function setPostTranslationHandler(handler1) {
        if (_composer.value) _composer.value.setPostTranslationHandler(handler1);
    }
    function getMissingHandler() {
        return _composer.value ? _composer.value.getMissingHandler() : _missing;
    }
    function setMissingHandler(handler1) {
        if (_composer.value) _composer.value.setMissingHandler(handler1);
    }
    function warpWithDeps(fn) {
        trackReactivityValues();
        return fn();
    }
    function t(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.t, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function rt(...args) {
        return _composer.value ? Reflect.apply(_composer.value.rt, null, [
            ...args
        ]) : "";
    }
    function d(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.d, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function n(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.n, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function tm(key) {
        return _composer.value ? _composer.value.tm(key) : {};
    }
    function te(key, locale) {
        return _composer.value ? _composer.value.te(key, locale) : false;
    }
    function getLocaleMessage(locale) {
        return _composer.value ? _composer.value.getLocaleMessage(locale) : {};
    }
    function setLocaleMessage(locale, message) {
        if (_composer.value) {
            _composer.value.setLocaleMessage(locale, message);
            _messages.value[locale] = message;
        }
    }
    function mergeLocaleMessage(locale, message) {
        if (_composer.value) _composer.value.mergeLocaleMessage(locale, message);
    }
    function getDateTimeFormat(locale) {
        return _composer.value ? _composer.value.getDateTimeFormat(locale) : {};
    }
    function setDateTimeFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setDateTimeFormat(locale, format);
            _datetimeFormats.value[locale] = format;
        }
    }
    function mergeDateTimeFormat(locale, format) {
        if (_composer.value) _composer.value.mergeDateTimeFormat(locale, format);
    }
    function getNumberFormat(locale) {
        return _composer.value ? _composer.value.getNumberFormat(locale) : {};
    }
    function setNumberFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setNumberFormat(locale, format);
            _numberFormats.value[locale] = format;
        }
    }
    function mergeNumberFormat(locale, format) {
        if (_composer.value) _composer.value.mergeNumberFormat(locale, format);
    }
    const wrapper = {
        get id () {
            return _composer.value ? _composer.value.id : -1;
        },
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        get inheritLocale () {
            return _composer.value ? _composer.value.inheritLocale : _inheritLocale;
        },
        set inheritLocale (val){
            if (_composer.value) _composer.value.inheritLocale = val;
        },
        get availableLocales () {
            return _composer.value ? _composer.value.availableLocales : Object.keys(_messages.value);
        },
        get modifiers () {
            return _composer.value ? _composer.value.modifiers : _modifiers;
        },
        get pluralRules () {
            return _composer.value ? _composer.value.pluralRules : _pluralRules;
        },
        get isGlobal () {
            return _composer.value ? _composer.value.isGlobal : false;
        },
        get missingWarn () {
            return _composer.value ? _composer.value.missingWarn : _missingWarn;
        },
        set missingWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackWarn () {
            return _composer.value ? _composer.value.fallbackWarn : _fallbackWarn;
        },
        set fallbackWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackRoot () {
            return _composer.value ? _composer.value.fallbackRoot : _fallbackRoot;
        },
        set fallbackRoot (val){
            if (_composer.value) _composer.value.fallbackRoot = val;
        },
        get fallbackFormat () {
            return _composer.value ? _composer.value.fallbackFormat : _fallbackFormat;
        },
        set fallbackFormat (val){
            if (_composer.value) _composer.value.fallbackFormat = val;
        },
        get warnHtmlMessage () {
            return _composer.value ? _composer.value.warnHtmlMessage : _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            if (_composer.value) _composer.value.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _composer.value ? _composer.value.escapeParameter : _escapeParameter;
        },
        set escapeParameter (val){
            if (_composer.value) _composer.value.escapeParameter = val;
        },
        t: t,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        rt: rt,
        d: d,
        n: n,
        tm: tm,
        te: te,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getDateTimeFormat: getDateTimeFormat,
        setDateTimeFormat: setDateTimeFormat,
        mergeDateTimeFormat: mergeDateTimeFormat,
        getNumberFormat: getNumberFormat,
        setNumberFormat: setNumberFormat,
        mergeNumberFormat: mergeNumberFormat
    };
    function sync(composer) {
        composer.locale.value = _locale.value;
        composer.fallbackLocale.value = _fallbackLocale.value;
        Object.keys(_messages.value).forEach((locale)=>{
            composer.mergeLocaleMessage(locale, _messages.value[locale]);
        });
        Object.keys(_datetimeFormats.value).forEach((locale)=>{
            composer.mergeDateTimeFormat(locale, _datetimeFormats.value[locale]);
        });
        Object.keys(_numberFormats.value).forEach((locale)=>{
            composer.mergeNumberFormat(locale, _numberFormats.value[locale]);
        });
        composer.escapeParameter = _escapeParameter;
        composer.fallbackFormat = _fallbackFormat;
        composer.fallbackRoot = _fallbackRoot;
        composer.fallbackWarn = _fallbackWarn;
        composer.missingWarn = _missingWarn;
        composer.warnHtmlMessage = _warnHtmlMessage;
    }
    (0, $TusQn.onBeforeMount)(()=>{
        if (instance.proxy == null || instance.proxy.$i18n == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const composer = _composer.value = instance.proxy.$i18n.__composer;
        if (scope === "global") {
            _locale.value = composer.locale.value;
            _fallbackLocale.value = composer.fallbackLocale.value;
            _messages.value = composer.messages.value;
            _datetimeFormats.value = composer.datetimeFormats.value;
            _numberFormats.value = composer.numberFormats.value;
        } else if (isLocalScope) sync(composer);
    });
    return wrapper;
}
const $409cbe3732db83c2$var$globalExportProps = [
    "locale",
    "fallbackLocale",
    "availableLocales"
];
const $409cbe3732db83c2$var$globalExportMethods = [
    "t",
    "rt",
    "d",
    "n",
    "tm",
    "te"
];
function $409cbe3732db83c2$var$injectGlobalFields(app, composer) {
    const i18n = Object.create(null);
    $409cbe3732db83c2$var$globalExportProps.forEach((prop)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const wrap = (0, $01W3b.isRef)(desc.value) // check computed props
         ? {
            get () {
                return desc.value.value;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set (val1) {
                desc.value.value = val1;
            }
        } : {
            get () {
                return desc.get && desc.get();
            }
        };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    $409cbe3732db83c2$var$globalExportMethods.forEach((method)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
    });
    const dispose = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete app.config.globalProperties.$i18n;
        $409cbe3732db83c2$var$globalExportMethods.forEach((method)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            delete app.config.globalProperties[`$${method}`];
        });
    };
    return dispose;
}
$409cbe3732db83c2$var$initFeatureFlags();
// register message compiler at vue-i18n
if (__INTLIFY_JIT_COMPILATION__) (0, $a739018d680a1535$export$6ee2fbe83628b40b)((0, $a739018d680a1535$export$ef7acd7185315e22));
else (0, $a739018d680a1535$export$6ee2fbe83628b40b)((0, $a739018d680a1535$export$1ea8807c727891fc));
// register message resolver at vue-i18n
(0, $a739018d680a1535$export$45dacdc710815463)((0, $a739018d680a1535$export$d812c8e1906863d0));
// register fallback locale at vue-i18n
(0, $a739018d680a1535$export$fd8ec9dd8067edec)((0, $a739018d680a1535$export$71df9db82dc445));
// NOTE: experimental !!
if (__INTLIFY_PROD_DEVTOOLS__) {
    const target = (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)();
    target.__INTLIFY__ = true;
    (0, $a739018d680a1535$export$c893d6c8966908b9)(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}


parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");
const $0c8b5991b63d9a06$var$messages = {
    cz: (0, (/*@__PURE__*/$parcel$interopDefault($7b4ca7aa003c0068$exports))),
    en: (0, (/*@__PURE__*/$parcel$interopDefault($a997ea418357c44d$exports))),
    de: (0, (/*@__PURE__*/$parcel$interopDefault($0c901ae870b60b14$exports)))
};
const $0c8b5991b63d9a06$var$i18n = (0, $409cbe3732db83c2$export$920091e3d72d80ee)({
    locale: document.documentElement.lang,
    fallbackLocale: "en",
    messages: $0c8b5991b63d9a06$var$messages
});
const $0c8b5991b63d9a06$var$toastTypes = {
    success: "success",
    error: "error",
    info: "info",
    warn: "warn"
};
(0, $h8ls9.default).init({
    types: $0c8b5991b63d9a06$var$toastTypes
});
function $0c8b5991b63d9a06$var$toast({ title: title, message: message, type: type, timeout: timeout, cb: cb }) {
    return (0, $h8ls9.default)[type]($0c8b5991b63d9a06$var$i18n.global.t(message), $0c8b5991b63d9a06$var$i18n.global.t(title), timeout, cb);
}
const $0c8b5991b63d9a06$var$options = {
    success: $0c8b5991b63d9a06$var$toast,
    error: $0c8b5991b63d9a06$var$toast,
    info: $0c8b5991b63d9a06$var$toast,
    warn: $0c8b5991b63d9a06$var$toast
};
const $0c8b5991b63d9a06$var$app = (0, $eeJ70.createApp)((0, $65b882e90cc2c305$export$2e2bcd8739ae039));
$0c8b5991b63d9a06$var$app.use($0c8b5991b63d9a06$var$i18n).use((0, $0dc597825647b4a5$export$2e2bcd8739ae039)).use((0, $0b901d553092e5c6$export$2e2bcd8739ae039), $0c8b5991b63d9a06$var$options).use((0, $a0ff767aa05ebc8a$export$2e2bcd8739ae039));
$0c8b5991b63d9a06$var$app.mount("#app");


//# sourceMappingURL=index.c263bdd1.js.map
